(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './compose-multiplatform-core-compose-ui-ui-graphics.js', './kotlin-kotlin-stdlib.js', './compose-multiplatform-core-compose-ui-ui.js', './compose-multiplatform-core-compose-ui-ui-geometry.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './compose-multiplatform-core-compose-foundation-foundation-layout.js', './androidx-compose-runtime-runtime.js', './kotlinx-coroutines-core.js', './androidx-collection-collection.js', './androidx-compose-runtime-runtime-saveable.js', './compose-multiplatform-core-compose-ui-ui-text.js', './compose-multiplatform-core-compose-animation-animation-core.js', './compose-multiplatform-core-compose-animation-animation.js', './compose-multiplatform-core-compose-ui-ui-util.js', './kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.js', './kotlinx-atomicfu.js', './skiko-kjs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./compose-multiplatform-core-compose-ui-ui-graphics.js'), require('./kotlin-kotlin-stdlib.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./compose-multiplatform-core-compose-ui-ui-geometry.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./compose-multiplatform-core-compose-foundation-foundation-layout.js'), require('./androidx-compose-runtime-runtime.js'), require('./kotlinx-coroutines-core.js'), require('./androidx-collection-collection.js'), require('./androidx-compose-runtime-runtime-saveable.js'), require('./compose-multiplatform-core-compose-ui-ui-text.js'), require('./compose-multiplatform-core-compose-animation-animation-core.js'), require('./compose-multiplatform-core-compose-animation-animation.js'), require('./compose-multiplatform-core-compose-ui-ui-util.js'), require('./kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.js'), require('./kotlinx-atomicfu.js'), require('./skiko-kjs.js'));
  else {
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-geometry'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'compose-multiplatform-core-compose-ui-ui-geometry' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-geometry' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-foundation-foundation-layout'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'compose-multiplatform-core-compose-foundation-foundation-layout' was not found. Please, check whether 'compose-multiplatform-core-compose-foundation-foundation-layout' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime-saveable'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'androidx-compose-runtime-runtime-saveable' was not found. Please, check whether 'androidx-compose-runtime-runtime-saveable' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-text'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'compose-multiplatform-core-compose-ui-ui-text' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-text' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-animation-animation-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'compose-multiplatform-core-compose-animation-animation-core' was not found. Please, check whether 'compose-multiplatform-core-compose-animation-animation-core' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-animation-animation'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'compose-multiplatform-core-compose-animation-animation' was not found. Please, check whether 'compose-multiplatform-core-compose-animation-animation' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-util'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'compose-multiplatform-core-compose-ui-ui-util' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-util' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat' was not found. Please, check whether 'kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    if (typeof globalThis['skiko-kjs'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation'. Its dependency 'skiko-kjs' was not found. Please, check whether 'skiko-kjs' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation'.");
    }
    globalThis['compose-multiplatform-core-compose-foundation-foundation'] = factory(typeof globalThis['compose-multiplatform-core-compose-foundation-foundation'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-foundation-foundation'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['kotlin-kotlin-stdlib'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['compose-multiplatform-core-compose-ui-ui-geometry'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['compose-multiplatform-core-compose-foundation-foundation-layout'], globalThis['androidx-compose-runtime-runtime'], globalThis['kotlinx-coroutines-core'], globalThis['androidx-collection-collection'], globalThis['androidx-compose-runtime-runtime-saveable'], globalThis['compose-multiplatform-core-compose-ui-ui-text'], globalThis['compose-multiplatform-core-compose-animation-animation-core'], globalThis['compose-multiplatform-core-compose-animation-animation'], globalThis['compose-multiplatform-core-compose-ui-ui-util'], kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat, globalThis['kotlinx-atomicfu'], globalThis['skiko-kjs']);
  }
}(function (_, kotlin_org_jetbrains_compose_ui_ui_graphics, kotlin_kotlin, kotlin_org_jetbrains_compose_ui_ui, kotlin_org_jetbrains_compose_ui_ui_geometry, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_compose_foundation_foundation_layout, kotlin_androidx_compose_runtime_runtime, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_androidx_collection_collection, kotlin_androidx_compose_runtime_runtime_saveable, kotlin_org_jetbrains_compose_ui_ui_text, kotlin_org_jetbrains_compose_animation_animation_core, kotlin_org_jetbrains_compose_animation_animation, kotlin_org_jetbrains_compose_ui_ui_util, kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat, kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_org_jetbrains_skiko_skiko) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var sign = Math.sign;
  var get_RectangleShape = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.l1;
  var VOID = kotlin_kotlin.$_$.d;
  var get_NoInspectorInfo = kotlin_org_jetbrains_compose_ui_ui.$_$.i7;
  var get_isDebugInspectorInfoEnabled = kotlin_org_jetbrains_compose_ui_ui.$_$.o7;
  var ModifierNodeElement = kotlin_org_jetbrains_compose_ui_ui.$_$.m5;
  var Companion_getInstance = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.g4;
  var protoOf = kotlin_kotlin.$_$.eh;
  var invalidateSemantics = kotlin_org_jetbrains_compose_ui_ui.$_$.h6;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var equals = kotlin_kotlin.$_$.sf;
  var invalidateDraw = kotlin_org_jetbrains_compose_ui_ui.$_$.d6;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var Color__hashCode_impl_vjyivj = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a3;
  var hashCode = kotlin_kotlin.$_$.bg;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var drawOutline = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c2;
  var drawOutline_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d2;
  var observeReads = kotlin_org_jetbrains_compose_ui_ui.$_$.i6;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var Node = kotlin_org_jetbrains_compose_ui_ui.$_$.qa;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.n1;
  var set_shape = kotlin_org_jetbrains_compose_ui_ui.$_$.x9;
  var onMeasureResultChanged = kotlin_org_jetbrains_compose_ui_ui.$_$.a5;
  var get_shouldClearDescendantSemantics = kotlin_org_jetbrains_compose_ui_ui.$_$.v5;
  var get_shouldMergeDescendantSemantics = kotlin_org_jetbrains_compose_ui_ui.$_$.w5;
  var DrawModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.b5;
  var DelegatableNode = kotlin_org_jetbrains_compose_ui_ui.$_$.x4;
  var SemanticsModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.x5;
  var Color = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.y;
  var Dp__toString_impl_kcddez = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k2;
  var toString = kotlin_kotlin.$_$.hh;
  var Dp__hashCode_impl_sxkrra = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j2;
  var Companion_getInstance_1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.j4;
  var Companion_instance = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.h4;
  var Color__copy$default_impl_ectz3s = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.x3;
  var SolidColor = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q1;
  var Companion_getInstance_2 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.n4;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var fromInt = kotlin_kotlin.$_$.pe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var Long = kotlin_kotlin.$_$.kn;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var _IntSize___init__impl__emcjft = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d3;
  var ImageBitmapConfig = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.z;
  var _Size___get_packedValue__impl__7rlt1o = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.g1;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var convertToInt = kotlin_kotlin.$_$.le;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var floatFromBits = kotlin_kotlin.$_$.uf;
  var _IntSize___get_packedValue__impl__uho7jf = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f3;
  var ImageBitmap = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a1;
  var Canvas = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.s;
  var CanvasDrawScope = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a;
  var toSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t1;
  var Companion_getInstance_3 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d4;
  var Stroke = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c;
  var get_isSimple = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.l;
  var _Size___get_minDimension__impl__4iso0r = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.f1;
  var Companion_getInstance_4 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b4;
  var toRawBits = kotlin_kotlin.$_$.fp;
  var _Offset___init__impl__c168vi = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.r;
  var _Size___init__impl__aywn0g = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c1;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var Rectangle = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.f1;
  var Rounded = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.g1;
  var Generic = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.e1;
  var _CornerRadius___get_packedValue__impl__okv4jq = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.q;
  var Companion_getInstance_5 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.f4;
  var DelegatingNode = kotlin_org_jetbrains_compose_ui_ui.$_$.y4;
  var CacheDrawModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.d;
  var Path = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.k1;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var Companion_getInstance_6 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.l1;
  var Fill_getInstance = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.b4;
  var _CornerRadius___init__impl__ojmabe = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.p;
  var RoundRect = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.i;
  var drawBehind = kotlin_org_jetbrains_compose_ui_ui.$_$.i;
  var Spacer = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.f;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var _Constraints___get_maxWidth__impl__uuyqc = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c2;
  var _Constraints___get_maxHeight__impl__dt3e8z = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b2;
  var Companion_instance_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.ec;
  var composed = kotlin_org_jetbrains_compose_ui_ui.$_$.va;
  var isInterface = kotlin_kotlin.$_$.rg;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var Role = kotlin_org_jetbrains_compose_ui_ui.$_$.v7;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var Role__hashCode_impl_ucjza4 = kotlin_org_jetbrains_compose_ui_ui.$_$.eb;
  var isOutOfBounds = kotlin_org_jetbrains_compose_ui_ui.$_$.o2;
  var PointerEventPass_Final_getInstance = kotlin_org_jetbrains_compose_ui_ui.$_$.gc;
  var changedToUp = kotlin_org_jetbrains_compose_ui_ui.$_$.n2;
  var PointerEventPass_Main_getInstance = kotlin_org_jetbrains_compose_ui_ui.$_$.ic;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var invert = kotlin_kotlin.$_$.qe;
  var compare = kotlin_kotlin.$_$.je;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var currentValueOf = kotlin_org_jetbrains_compose_ui_ui.$_$.z5;
  var cancelAndJoin = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v;
  var coroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var Companion_getInstance_7 = kotlin_org_jetbrains_compose_ui_ui.$_$.jb;
  var mutableLongObjectMapOf = kotlin_androidx_collection_collection.$_$.d1;
  var get_LocalViewConfiguration = kotlin_org_jetbrains_compose_ui_ui.$_$.g7;
  var requireDensity = kotlin_org_jetbrains_compose_ui_ui.$_$.l6;
  var Size = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.j;
  var get_center = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.z;
  var _IntOffset___get_x__impl__qiqr5o = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b3;
  var _IntOffset___get_y__impl__2avpwj = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c3;
  var Companion_getInstance_8 = kotlin_org_jetbrains_compose_ui_ui.$_$.pb;
  var get_key = kotlin_org_jetbrains_compose_ui_ui.$_$.r1;
  var _Key___get_keyCode__impl__ymzu5v = kotlin_org_jetbrains_compose_ui_ui.$_$.cb;
  var set_role = kotlin_org_jetbrains_compose_ui_ui.$_$.m9;
  var onClick = kotlin_org_jetbrains_compose_ui_ui.$_$.z8;
  var disabled = kotlin_org_jetbrains_compose_ui_ui.$_$.h8;
  var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var onDensityChange = kotlin_org_jetbrains_compose_ui_ui.$_$.p5;
  var interceptOutOfBoundsChildEvents = kotlin_org_jetbrains_compose_ui_ui.$_$.o5;
  var sharePointerInputWithSiblings = kotlin_org_jetbrains_compose_ui_ui.$_$.r5;
  var onViewConfigurationChange = kotlin_org_jetbrains_compose_ui_ui.$_$.q5;
  var get_touchBoundsExpansion = kotlin_org_jetbrains_compose_ui_ui.$_$.s5;
  var get_isImportantForBounds = kotlin_org_jetbrains_compose_ui_ui.$_$.u5;
  var PointerInputModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.t5;
  var KeyInputModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.m1;
  var TraversableNode = kotlin_org_jetbrains_compose_ui_ui.$_$.y5;
  var CompositionLocalConsumerModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.w4;
  var IndirectPointerInputModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.l1;
  var requestFocus = kotlin_org_jetbrains_compose_ui_ui.$_$.v;
  var get_type = kotlin_org_jetbrains_compose_ui_ui.$_$.u1;
  var Companion_getInstance_9 = kotlin_org_jetbrains_compose_ui_ui.$_$.nb;
  var traverseAncestors = kotlin_org_jetbrains_compose_ui_ui.$_$.o6;
  var Companion_getInstance_10 = kotlin_org_jetbrains_compose_ui_ui.$_$.mb;
  var get_LocalHapticFeedback = kotlin_org_jetbrains_compose_ui_ui.$_$.x6;
  var Companion_instance_1 = kotlin_org_jetbrains_compose_ui_ui.$_$.lb;
  var Offset = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c;
  var subtract = kotlin_kotlin.$_$.af;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var PointerInputEventHandler = kotlin_org_jetbrains_compose_ui_ui.$_$.g2;
  var PointerInputScope = kotlin_org_jetbrains_compose_ui_ui.$_$.h2;
  var SuspendingPointerInputModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.j2;
  var changedToUpIgnoreConsumed = kotlin_org_jetbrains_compose_ui_ui.$_$.m2;
  var onLongClick = kotlin_org_jetbrains_compose_ui_ui.$_$.c9;
  var Companion_getInstance_11 = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var clip = kotlin_org_jetbrains_compose_ui_ui.$_$.h;
  var Rect = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.f;
  var Shape = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.o1;
  var _Dp___init__impl__ms3zkb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h2;
  var findNearestAncestor = kotlin_org_jetbrains_compose_ui_ui.$_$.b6;
  var bringIntoView = kotlin_org_jetbrains_compose_ui_ui.$_$.qc;
  var get_LocalPinnableContainer = kotlin_org_jetbrains_compose_ui_ui.$_$.m3;
  var funFocusTargetModifierNode2 = kotlin_org_jetbrains_compose_ui_ui.$_$.r;
  var set_focused = kotlin_org_jetbrains_compose_ui_ui.$_$.n8;
  var requestFocus_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.l9;
  var GlobalPositionAwareModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.c5;
  var findNearestAncestor_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.c6;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var Companion_getInstance_12 = kotlin_org_jetbrains_compose_ui_ui.$_$.dc;
  var Companion_getInstance_13 = kotlin_org_jetbrains_compose_ui_ui.$_$.ub;
  var semantics = kotlin_org_jetbrains_compose_ui_ui.$_$.s9;
  var clipToBounds = kotlin_org_jetbrains_compose_ui_ui.$_$.g;
  var paint = kotlin_org_jetbrains_compose_ui_ui.$_$.l;
  var get_currentCompositeKeyHashCode = kotlin_androidx_compose_runtime_runtime.$_$.l1;
  var materialize = kotlin_org_jetbrains_compose_ui_ui.$_$.wa;
  var Companion_getInstance_14 = kotlin_org_jetbrains_compose_ui_ui.$_$.vb;
  var invalidApplier = kotlin_androidx_compose_runtime_runtime.$_$.r1;
  var Applier = kotlin_androidx_compose_runtime_runtime.$_$.h;
  var _Updater___init__impl__rbfxm8 = kotlin_androidx_compose_runtime_runtime.$_$.r2;
  var Updater__set_impl_v7kwss = kotlin_androidx_compose_runtime_runtime.$_$.t2;
  var Updater__reconcile_impl_1mfi6g = kotlin_androidx_compose_runtime_runtime.$_$.s2;
  var Companion_getInstance_15 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a4;
  var BitmapPainter = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.f;
  var androidx_compose_ui_graphics_painter_BitmapPainter$stableprop_getter = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.i;
  var Constraints = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b;
  var MeasurePolicy = kotlin_org_jetbrains_compose_ui_ui.$_$.r3;
  var minIntrinsicWidth = kotlin_org_jetbrains_compose_ui_ui.$_$.q3;
  var minIntrinsicHeight = kotlin_org_jetbrains_compose_ui_ui.$_$.p3;
  var maxIntrinsicWidth = kotlin_org_jetbrains_compose_ui_ui.$_$.o3;
  var maxIntrinsicHeight = kotlin_org_jetbrains_compose_ui_ui.$_$.n3;
  var set_contentDescription = kotlin_org_jetbrains_compose_ui_ui.$_$.d8;
  var Companion_getInstance_16 = kotlin_org_jetbrains_compose_ui_ui.$_$.ac;
  var _Constraints___get_minWidth__impl__hi9lfi = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e2;
  var _Constraints___get_minHeight__impl__ev4bgx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d2;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p1;
  var foldIn = kotlin_org_jetbrains_compose_ui_ui.$_$.pa;
  var all = kotlin_org_jetbrains_compose_ui_ui.$_$.oa;
  var then = kotlin_org_jetbrains_compose_ui_ui.$_$.ra;
  var DrawModifier = kotlin_org_jetbrains_compose_ui_ui.$_$.e;
  var compositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.i1;
  var CancellationException_init_$Create$ = kotlin_kotlin.$_$.q4;
  var Mutex = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o2;
  var Enum = kotlin_kotlin.$_$.en;
  var captureStack = kotlin_kotlin.$_$.gf;
  var compositionLocalWithComputedDefaultOf = kotlin_androidx_compose_runtime_runtime.$_$.j1;
  var rangeTo = kotlin_kotlin.$_$.ji;
  var Companion_getInstance_17 = kotlin_org_jetbrains_compose_ui_ui.$_$.zb;
  var set_progressBarRangeInfo = kotlin_org_jetbrains_compose_ui_ui.$_$.k9;
  var coerceIn = kotlin_kotlin.$_$.gi;
  var ProgressBarRangeInfo = kotlin_org_jetbrains_compose_ui_ui.$_$.u7;
  var KMutableProperty1 = kotlin_kotlin.$_$.wi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var Saver = kotlin_androidx_compose_runtime_runtime_saveable.$_$.d;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var coerceIn_0 = kotlin_kotlin.$_$.di;
  var roundToInt = kotlin_kotlin.$_$.kh;
  var isNaN_0 = kotlin_kotlin.$_$.qo;
  var mutableIntStateOf = kotlin_androidx_compose_runtime_runtime.$_$.w1;
  var derivedStateOf = kotlin_androidx_compose_runtime_runtime.$_$.p1;
  var Companion_instance_2 = kotlin_androidx_compose_runtime_runtime.$_$.u2;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var rememberSaveable = kotlin_androidx_compose_runtime_runtime_saveable.$_$.j;
  var Constraints__copy$default_impl_f452rp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.w3;
  var coerceAtMost = kotlin_kotlin.$_$.bi;
  var set_isTraversalGroup = kotlin_org_jetbrains_compose_ui_ui.$_$.x8;
  var ScrollAxisRange = kotlin_org_jetbrains_compose_ui_ui.$_$.w7;
  var set_horizontalScrollAxisRange = kotlin_org_jetbrains_compose_ui_ui.$_$.q8;
  var set_verticalScrollAxisRange = kotlin_org_jetbrains_compose_ui_ui.$_$.fa;
  var LayoutModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.k5;
  var LayoutDirection_Ltr_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k4;
  var requireLayoutDirection = kotlin_org_jetbrains_compose_ui_ui.$_$.n6;
  var maybeCachedBoxMeasurePolicy = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.v;
  var BoxScopeInstance_instance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.b2;
  var round = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.n1;
  var pointerInput = kotlin_org_jetbrains_compose_ui_ui.$_$.u2;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var IntOffset = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.r;
  var _IntOffset___init__impl__rq8h7b = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.v2;
  var IntRect = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.s;
  var _Offset___get_packedValue__impl__xh2k8q = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.y;
  var Offset__toString_impl_4ffbou = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.b1;
  var Offset__hashCode_impl_hbql41 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.w;
  var mutableStateOf = kotlin_androidx_compose_runtime_runtime.$_$.b2;
  var Color__toString_impl_hpzmaq = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c3;
  var isBlank = kotlin_kotlin.$_$.dk;
  var mutableStateListOf = kotlin_androidx_compose_runtime_runtime.$_$.z1;
  var composableLambdaInstance = kotlin_androidx_compose_runtime_runtime.$_$.b;
  var padding = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.d1;
  var fillMaxWidth = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.r;
  var height = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.t;
  var Box = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.b;
  var Arrangement_getInstance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.a2;
  var sizeIn = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.l1;
  var rowMeasurePolicy = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.j1;
  var RowScopeInstance_instance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.d2;
  var requiredSizeIn = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.f1;
  var _TextOverflow___init__impl__obguoe = kotlin_org_jetbrains_compose_ui_ui_text.$_$.n2;
  var Companion_getInstance_18 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.q3;
  var get_sp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.q1;
  var Companion_getInstance_19 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.b3;
  var get_sp_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.o1;
  var TextStyle_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.j4;
  var rememberComposableLambda = kotlin_androidx_compose_runtime_runtime.$_$.c;
  var Popup = kotlin_org_jetbrains_compose_ui_ui.$_$.ma;
  var shadow = kotlin_org_jetbrains_compose_ui_ui.$_$.o;
  var IntrinsicSize_Max_getInstance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.g2;
  var width = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.s1;
  var columnMeasurePolicy = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.l;
  var ColumnScopeInstance_instance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.c2;
  var PopupProperties_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui.$_$.zc;
  var MutableVector = kotlin_androidx_compose_runtime_runtime.$_$.a;
  var Companion_instance_3 = kotlin_kotlin.$_$.j3;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var until = kotlin_kotlin.$_$.mi;
  var spring = kotlin_org_jetbrains_compose_animation_animation_core.$_$.y1;
  var println = kotlin_kotlin.$_$.de;
  var Companion_getInstance_20 = kotlin_org_jetbrains_compose_ui_ui.$_$.ob;
  var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l3;
  var Companion_getInstance_21 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e4;
  var CoroutineStart_UNDISPATCHED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
  var IntSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t;
  var isArray = kotlin_kotlin.$_$.jg;
  var bitwiseXor = kotlin_kotlin.$_$.ie;
  var compareTo = kotlin_kotlin.$_$.nf;
  var Key_instance_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g;
  var toString_1 = kotlin_kotlin.$_$.cm;
  var get_job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p3;
  var CancellationException = kotlin_kotlin.$_$.fd;
  var printStackTrace = kotlin_kotlin.$_$.wo;
  var intercepted = kotlin_kotlin.$_$.jd;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q2;
  var returnIfSuspended = kotlin_kotlin.$_$.w3;
  var Companion_getInstance_22 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g4;
  var IntSize__toString_impl_54w9zl = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g3;
  var MeasuredSizeAwareModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.l5;
  var VelocityTracker1D_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui.$_$.tc;
  var Velocity = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.x;
  var Offset__getDistance_impl_pclvxn = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.v;
  var Offset__div_impl_eaxtg1 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.t;
  var Offset__times_impl_jz1mli = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.a1;
  var Offset__minus_impl_hoj2c0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.x;
  var Offset__plus_impl_c78cg0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.z;
  var Companion_getInstance_23 = kotlin_org_jetbrains_compose_ui_ui.$_$.rb;
  var AwaitPointerEventScope = kotlin_org_jetbrains_compose_ui_ui.$_$.e2;
  var PointerEventPass_Initial_getInstance = kotlin_org_jetbrains_compose_ui_ui.$_$.hc;
  var positionChangeIgnoreConsumed = kotlin_org_jetbrains_compose_ui_ui.$_$.w2;
  var firstOrNull = kotlin_kotlin.$_$.k9;
  var positionChange = kotlin_org_jetbrains_compose_ui_ui.$_$.z2;
  var PointerEventTimeoutCancellationException = kotlin_org_jetbrains_compose_ui_ui.$_$.f2;
  var positionChangedIgnoreConsumed = kotlin_org_jetbrains_compose_ui_ui.$_$.x2;
  var _Dp___get_value__impl__geb1vb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l2;
  var rememberUpdatedState = kotlin_androidx_compose_runtime_runtime.$_$.g2;
  var Velocity__times_impl_yav0ik = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.s3;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var Channel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
  var first = kotlin_kotlin.$_$.o9;
  var VelocityTracker = kotlin_org_jetbrains_compose_ui_ui.$_$.b2;
  var addPointerInputChange = kotlin_org_jetbrains_compose_ui_ui.$_$.c2;
  var requireLayoutCoordinates = kotlin_org_jetbrains_compose_ui_ui.$_$.m6;
  var positionOnScreen = kotlin_org_jetbrains_compose_ui_ui.$_$.u4;
  var PointerType = kotlin_org_jetbrains_compose_ui_ui.$_$.i2;
  var addPointerInputChange_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.d2;
  var get_isActive = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o3;
  var Companion_getInstance_24 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j4;
  var changedToDownIgnoreConsumed = kotlin_org_jetbrains_compose_ui_ui.$_$.k2;
  var _Velocity___get_x__impl__qqcikv = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.u3;
  var _Velocity___get_y__impl__239yhc = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.v3;
  var _PointerId___init__impl__w2urwh = kotlin_org_jetbrains_compose_ui_ui.$_$.db;
  var get_isActive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.n3;
  var _ChannelResult___get_isSuccess__impl__odq1z9 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c;
  var get_LinearEasing = kotlin_org_jetbrains_compose_animation_animation_core.$_$.m;
  var tween = kotlin_org_jetbrains_compose_animation_animation_core.$_$.z1;
  var animateTo = kotlin_org_jetbrains_compose_animation_animation_core.$_$.d2;
  var ChannelResult__getOrNull_impl_f5e07h = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a;
  var copy = kotlin_org_jetbrains_compose_animation_animation_core.$_$.n1;
  var AnimationState = kotlin_org_jetbrains_compose_animation_animation_core.$_$.d;
  var Velocity_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.y;
  var withTimeoutOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b1;
  var supervisorScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.z;
  var sequence = kotlin_kotlin.$_$.hj;
  var SequenceScope = kotlin_kotlin.$_$.aj;
  var withFrameNanos = kotlin_androidx_compose_runtime_runtime.$_$.z2;
  var LayoutDirection_Rtl_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l4;
  var getFocusedRect = kotlin_org_jetbrains_compose_ui_ui.$_$.t;
  var KFunctionImpl = kotlin_kotlin.$_$.ni;
  var initMetadataForFunctionReference = kotlin_kotlin.$_$.fg;
  var NestedScrollDispatcher = kotlin_org_jetbrains_compose_ui_ui.$_$.y1;
  var nestedScrollModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.z1;
  var dispatchOnScrollChanged = kotlin_org_jetbrains_compose_ui_ui.$_$.a6;
  var get_isCtrlPressed = kotlin_org_jetbrains_compose_ui_ui.$_$.o1;
  var scrollBy = kotlin_org_jetbrains_compose_ui_ui.$_$.o9;
  var scrollByOffset = kotlin_org_jetbrains_compose_ui_ui.$_$.n9;
  var Velocity__copy$default_impl_eql69u = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.z3;
  var Velocity__minus_impl_w0cg92 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.q3;
  var Offset__copy$default_impl_bmwjg8 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.j1;
  var onPreScroll = kotlin_org_jetbrains_compose_ui_ui.$_$.w1;
  var onPreFling = kotlin_org_jetbrains_compose_ui_ui.$_$.oc;
  var NestedScrollConnection = kotlin_org_jetbrains_compose_ui_ui.$_$.x1;
  var animateDecay = kotlin_org_jetbrains_compose_animation_animation_core.$_$.c2;
  var withContext = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a1;
  var splineBasedDecay = kotlin_org_jetbrains_compose_animation_animation.$_$.t;
  var get_key_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.sa;
  var get = kotlin_kotlin.$_$.td;
  var fold = kotlin_kotlin.$_$.sd;
  var minusKey = kotlin_kotlin.$_$.ud;
  var plus = kotlin_kotlin.$_$.wd;
  var MotionDurationScale = kotlin_org_jetbrains_compose_ui_ui.$_$.ta;
  var toPx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h;
  var toPx_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.i;
  var roundToPx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c;
  var roundToPx_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d;
  var toDp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g;
  var toDp_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f;
  var toDp_1 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.q;
  var toSize_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j;
  var toDpSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e;
  var Density = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l;
  var animate = kotlin_org_jetbrains_compose_animation_animation_core.$_$.e2;
  var get_isPrimaryPressed = kotlin_org_jetbrains_compose_ui_ui.$_$.p2;
  var changedToDown = kotlin_org_jetbrains_compose_ui_ui.$_$.l2;
  var add = kotlin_kotlin.$_$.fe;
  var positionChanged = kotlin_org_jetbrains_compose_ui_ui.$_$.y2;
  var AnimationVector1D = kotlin_org_jetbrains_compose_animation_animation_core.$_$.f;
  var toNumber = kotlin_kotlin.$_$.bf;
  var roundToLong = kotlin_kotlin.$_$.lh;
  var Key_instance_1 = kotlin_org_jetbrains_compose_ui_ui.$_$.fc;
  var get_VectorConverter = kotlin_org_jetbrains_compose_animation_animation_core.$_$.y;
  var coerceAtLeast = kotlin_kotlin.$_$.xh;
  var to = kotlin_kotlin.$_$.ip;
  var coerceIn_1 = kotlin_kotlin.$_$.ei;
  var abs = kotlin_kotlin.$_$.ih;
  var coerceAtLeast_0 = kotlin_kotlin.$_$.wh;
  var calculateTargetValue = kotlin_org_jetbrains_compose_animation_animation_core.$_$.m1;
  var coerceAtMost_0 = kotlin_kotlin.$_$.zh;
  var LaunchedEffect = kotlin_androidx_compose_runtime_runtime.$_$.r;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var BufferOverflow_DROP_OLDEST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
  var MutableSharedFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r1;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.a6;
  var PaddingValues = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.d;
  var Constraints_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a;
  var minIntrinsicWidth_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.j5;
  var minIntrinsicHeight_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.i5;
  var maxIntrinsicWidth_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.h5;
  var maxIntrinsicHeight_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.g5;
  var CollectionInfo = kotlin_org_jetbrains_compose_ui_ui.$_$.t7;
  var createCompositionCoroutineScope = kotlin_androidx_compose_runtime_runtime.$_$.k1;
  var get_LocalGraphicsContext = kotlin_org_jetbrains_compose_ui_ui.$_$.w6;
  var get_LocalScrollCaptureInProgress = kotlin_org_jetbrains_compose_ui_ui.$_$.c7;
  var last = kotlin_kotlin.$_$.na;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var constrainWidth = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c1;
  var constrainHeight = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b1;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var calculateStartPadding = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.k;
  var calculateEndPadding = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.j;
  var offset = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j1;
  var emptyIntList = kotlin_androidx_collection_collection.$_$.r;
  var referentialEqualityPolicy = kotlin_androidx_compose_runtime_runtime.$_$.e2;
  var derivedStateOf_0 = kotlin_androidx_compose_runtime_runtime.$_$.o1;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var ArrayDeque_init_$Create$ = kotlin_kotlin.$_$.x3;
  var get_sign = kotlin_kotlin.$_$.oh;
  var get_lastIndex = kotlin_kotlin.$_$.fa;
  var lastOrNull = kotlin_kotlin.$_$.ka;
  var emptyList = kotlin_kotlin.$_$.c9;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.z3;
  var get_indices = kotlin_kotlin.$_$.x9;
  var reversed = kotlin_kotlin.$_$.ki;
  var MeasureResult = kotlin_org_jetbrains_compose_ui_ui.$_$.t3;
  var IntOffset__plus_impl_nqoa9b = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.z2;
  var listOf = kotlin_kotlin.$_$.ta;
  var traceValue = kotlin_org_jetbrains_compose_ui_ui_util.$_$.g;
  var listSaver = kotlin_androidx_compose_runtime_runtime_saveable.$_$.f;
  var RemeasurementModifier = kotlin_org_jetbrains_compose_ui_ui.$_$.c4;
  var neverEqualPolicy = kotlin_androidx_compose_runtime_runtime.$_$.c2;
  var get_rulers = kotlin_org_jetbrains_compose_ui_ui.$_$.s3;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x2;
  var Density_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k;
  var toIntArray = kotlin_kotlin.$_$.ic;
  var last_0 = kotlin_kotlin.$_$.qa;
  var firstOrNull_0 = kotlin_kotlin.$_$.n9;
  var lastOrNull_0 = kotlin_kotlin.$_$.la;
  var plus_0 = kotlin_kotlin.$_$.ib;
  var _Constraints___get_hasFixedHeight__impl__y56fxx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.y1;
  var _Constraints___get_hasFixedWidth__impl__4p17wc = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.z1;
  var Companion_instance_4 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a4;
  var binarySearch = kotlin_kotlin.$_$.x7;
  var registerOnLayoutRectChanged = kotlin_org_jetbrains_compose_ui_ui.$_$.v4;
  var CompletableDeferred = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s2;
  var mutableIntObjectMapOf = kotlin_androidx_collection_collection.$_$.b1;
  var mutableIntSetOf = kotlin_androidx_collection_collection.$_$.c1;
  var mutableIntIntMapOf = kotlin_androidx_collection_collection.$_$.y;
  var mutableObjectIntMapOf = kotlin_androidx_collection_collection.$_$.f1;
  var SubcomposeLayoutState = kotlin_org_jetbrains_compose_ui_ui.$_$.d4;
  var DisposableEffect = kotlin_androidx_compose_runtime_runtime.$_$.o;
  var androidx_compose_ui_layout_SubcomposeLayoutState$stableprop_getter = kotlin_org_jetbrains_compose_ui_ui.$_$.h4;
  var SubcomposeLayout = kotlin_org_jetbrains_compose_ui_ui.$_$.f4;
  var Companion_getInstance_25 = kotlin_org_jetbrains_compose_ui_ui.$_$.tb;
  var remeasureSync = kotlin_org_jetbrains_compose_ui_ui.$_$.j6;
  var BeyondBoundsLayoutProviderModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.c3;
  var Companion_getInstance_26 = kotlin_kotlin.$_$.a3;
  var numberRangeToNumber = kotlin_kotlin.$_$.yg;
  var IntOffset__minus_impl_4m69hb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.x2;
  var SpringSpec = kotlin_org_jetbrains_compose_animation_animation_core.$_$.p;
  var get_VectorConverter_0 = kotlin_org_jetbrains_compose_animation_animation_core.$_$.u;
  var Animatable = kotlin_org_jetbrains_compose_animation_animation_core.$_$.b;
  var ParentDataModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.n5;
  var get_VisibilityThreshold = kotlin_org_jetbrains_compose_animation_animation_core.$_$.b1;
  var IntOffset__copy$default_impl_1y5pbb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.y3;
  var copyOf = kotlin_kotlin.$_$.v8;
  var drawLayer = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d;
  var Comparator = kotlin_kotlin.$_$.bn;
  var compareValues = kotlin_kotlin.$_$.ad;
  var mutableScatterMapOf = kotlin_androidx_collection_collection.$_$.j1;
  var mutableScatterSetOf = kotlin_androidx_collection_collection.$_$.l1;
  var sortWith = kotlin_kotlin.$_$.wb;
  var fill = kotlin_kotlin.$_$.f9;
  var reverse = kotlin_kotlin.$_$.qb;
  var DisposableEffect_0 = kotlin_androidx_compose_runtime_runtime.$_$.q;
  var MutableObjectIntMap = kotlin_androidx_collection_collection.$_$.l;
  var emptyObjectIntMap = kotlin_androidx_collection_collection.$_$.s;
  var Dp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.p;
  var DpSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.o;
  var layout$default = kotlin_org_jetbrains_compose_ui_ui.$_$.rc;
  var layout$default_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.sc;
  var MeasureScope = kotlin_org_jetbrains_compose_ui_ui.$_$.u3;
  var toMutableList = kotlin_kotlin.$_$.pc;
  var structuralEqualityPolicy = kotlin_androidx_compose_runtime_runtime.$_$.m2;
  var SnapshotStateList_init_$Create$ = kotlin_androidx_compose_runtime_runtime.$_$.a3;
  var KtList = kotlin_kotlin.$_$.e7;
  var androidx_compose_runtime_ProvidedValue$stableprop_getter = kotlin_androidx_compose_runtime_runtime.$_$.f1;
  var CompositionLocalProvider = kotlin_androidx_compose_runtime_runtime.$_$.l;
  var Monotonic_instance = kotlin_kotlin.$_$.f3;
  var AnimationState_0 = kotlin_org_jetbrains_compose_animation_animation_core.$_$.c;
  var AnimationState_1 = kotlin_org_jetbrains_compose_animation_animation_core.$_$.e;
  var CancellationException_init_$Init$ = kotlin_kotlin.$_$.o4;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ce;
  var indexForKey = kotlin_org_jetbrains_compose_ui_ui.$_$.r8;
  var scrollToIndex = kotlin_org_jetbrains_compose_ui_ui.$_$.p9;
  var getScrollViewportLength = kotlin_org_jetbrains_compose_ui_ui.$_$.o8;
  var set_collectionInfo = kotlin_org_jetbrains_compose_ui_ui.$_$.b8;
  var intListOf = kotlin_androidx_collection_collection.$_$.w;
  var get_LocalSaveableStateRegistry = kotlin_androidx_compose_runtime_runtime_saveable.$_$.a;
  var rememberSaveableStateHolder = kotlin_androidx_compose_runtime_runtime_saveable.$_$.g;
  var SaveableStateRegistry = kotlin_androidx_compose_runtime_runtime_saveable.$_$.b;
  var SaveableStateRegistry_0 = kotlin_androidx_compose_runtime_runtime_saveable.$_$.c;
  var get_LocalLayoutDirection = kotlin_org_jetbrains_compose_ui_ui.$_$.a7;
  var nestedScroll = kotlin_org_jetbrains_compose_ui_ui.$_$.a2;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.w2;
  var get_VisibilityThreshold_0 = kotlin_org_jetbrains_compose_animation_animation_core.$_$.a1;
  var rememberSplineBasedDecay = kotlin_org_jetbrains_compose_animation_animation.$_$.m;
  var get_LocalDensity = kotlin_org_jetbrains_compose_ui_ui.$_$.t6;
  var Offset__copy_impl_9gtypn = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.s;
  var pageLeft = kotlin_org_jetbrains_compose_ui_ui.$_$.e9;
  var pageRight = kotlin_org_jetbrains_compose_ui_ui.$_$.f9;
  var pageUp = kotlin_org_jetbrains_compose_ui_ui.$_$.g9;
  var pageDown = kotlin_org_jetbrains_compose_ui_ui.$_$.d9;
  var coerceAtLeast_1 = kotlin_kotlin.$_$.vh;
  var numberToLong = kotlin_kotlin.$_$.we;
  var coerceAtMost_1 = kotlin_kotlin.$_$.ai;
  var listOf_0 = kotlin_kotlin.$_$.sa;
  var Absolute_getInstance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.z1;
  var mutableFloatStateOf = kotlin_androidx_compose_runtime_runtime.$_$.v1;
  var multiply = kotlin_kotlin.$_$.ue;
  var coerceIn_2 = kotlin_kotlin.$_$.fi;
  var abs_0 = kotlin_kotlin.$_$.jh;
  var numberToDouble = kotlin_kotlin.$_$.bh;
  var onRemeasured = kotlin_org_jetbrains_compose_ui_ui.$_$.e5;
  var BringIntoViewModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.s7;
  var LayoutAwareModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.f5;
  var set_selected = kotlin_org_jetbrains_compose_ui_ui.$_$.r9;
  var selectableGroup = kotlin_org_jetbrains_compose_ui_ui.$_$.q9;
  var ToggleableState = kotlin_org_jetbrains_compose_ui_ui.$_$.ga;
  var set_toggleableState = kotlin_org_jetbrains_compose_ui_ui.$_$.da;
  var Companion_getInstance_27 = kotlin_org_jetbrains_compose_ui_ui.$_$.fb;
  var set_contentDataType = kotlin_org_jetbrains_compose_ui_ui.$_$.c8;
  var Companion_instance_5 = kotlin_org_jetbrains_compose_ui_ui.$_$.hb;
  var ToggleableState_Indeterminate_getInstance = kotlin_org_jetbrains_compose_ui_ui.$_$.lc;
  var createFromBoolean = kotlin_org_jetbrains_compose_ui_ui.$_$.a;
  var set_fillableData = kotlin_org_jetbrains_compose_ui_ui.$_$.m8;
  var onFillData = kotlin_org_jetbrains_compose_ui_ui.$_$.a9;
  var Interpolatable = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c1;
  var toRect = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.o;
  var RoundRect_0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.g;
  var lerp = kotlin_org_jetbrains_compose_ui_ui_util.$_$.d;
  var Companion_getInstance_28 = kotlin_org_jetbrains_compose_ui_ui.$_$.kb;
  var Companion_getInstance_29 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h4;
  var Companion_getInstance_30 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.l3;
  var Companion_getInstance_31 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.n3;
  var _Color___get_value__impl__1pls5m = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d3;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.w1;
  var _TextUnit___get_rawType__impl__tu8yq5 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.m3;
  var _BaselineShift___get_multiplier__impl__qhmjek = kotlin_org_jetbrains_compose_ui_ui_text.$_$.l2;
  var Companion_getInstance_32 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.y2;
  var Companion_getInstance_33 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.s3;
  var Companion_getInstance_34 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.m3;
  var FontWeight = kotlin_org_jetbrains_compose_ui_ui_text.$_$.d;
  var Companion_getInstance_35 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.z2;
  var Companion_getInstance_36 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.r3;
  var _FontStyle___get_value__impl__gx8aaz = kotlin_org_jetbrains_compose_ui_ui_text.$_$.d2;
  var _FontSynthesis___get_value__impl__xrueqg = kotlin_org_jetbrains_compose_ui_ui_text.$_$.e2;
  var lerp_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.i2;
  var _TransformOrigin___get_pivotFractionX__impl__a9pmci = kotlin_org_jetbrains_compose_ui_ui.$_$.za;
  var _TransformOrigin___get_pivotFractionY__impl__ijwupp = kotlin_org_jetbrains_compose_ui_ui.$_$.ab;
  var TransformOrigin = kotlin_org_jetbrains_compose_ui_ui.$_$.f1;
  var lerp_1 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g1;
  var lerp_2 = kotlin_org_jetbrains_compose_ui_ui_util.$_$.e;
  var Companion_instance_6 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.k4;
  var Brush = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.r;
  var Shadow = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.k;
  var lerp_3 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.l;
  var getOrNull = kotlin_kotlin.$_$.s9;
  var Companion_getInstance_37 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.x2;
  var MutableObjectList = kotlin_androidx_collection_collection.$_$.m;
  var Range_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.g4;
  var Pair = kotlin_kotlin.$_$.pn;
  var TextOverflow = kotlin_org_jetbrains_compose_ui_ui_text.$_$.f1;
  var _TextOverflow___get_value__impl__vugm5i = kotlin_org_jetbrains_compose_ui_ui_text.$_$.p2;
  var Companion_getInstance_38 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.w3;
  var Companion_getInstance_39 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.t3;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.x1;
  var get_LocalFontFamilyResolver = kotlin_org_jetbrains_compose_ui_ui.$_$.v6;
  var AnnotatedString_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.e4;
  var KMutableProperty0 = kotlin_kotlin.$_$.vi;
  var getLocalDelegateReference = kotlin_kotlin.$_$.wf;
  var Companion_getInstance_40 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.i3;
  var TextFieldValue_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.b4;
  var SideEffect = kotlin_androidx_compose_runtime_runtime.$_$.d1;
  var TextRange = kotlin_org_jetbrains_compose_ui_ui_text.$_$.w1;
  var DpSize_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.n;
  var Companion_getInstance_41 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.d3;
  var FocusRequester = kotlin_org_jetbrains_compose_ui_ui.$_$.q;
  var TextInputService = kotlin_org_jetbrains_compose_ui_ui_text.$_$.w;
  var get_LocalFocusManager = kotlin_org_jetbrains_compose_ui_ui.$_$.u6;
  var get_LocalWindowInfo = kotlin_org_jetbrains_compose_ui_ui.$_$.h7;
  var get_LocalSoftwareKeyboardController = kotlin_org_jetbrains_compose_ui_ui.$_$.d7;
  var get_currentRecomposeScope = kotlin_androidx_compose_runtime_runtime.$_$.n1;
  var get_LocalClipboard = kotlin_org_jetbrains_compose_ui_ui.$_$.r6;
  var get_LocalTextToolbar = kotlin_org_jetbrains_compose_ui_ui.$_$.e7;
  var get_LocalActiveClipEventsTarget = kotlin_org_jetbrains_compose_ui_ui.$_$.ka;
  var onGloballyPositioned = kotlin_org_jetbrains_compose_ui_ui.$_$.q4;
  var PasswordVisualTransformation = kotlin_org_jetbrains_compose_ui_ui_text.$_$.p;
  var Companion_getInstance_42 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.f3;
  var drawWithContent = kotlin_org_jetbrains_compose_ui_ui.$_$.k;
  var Companion_getInstance_43 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.v3;
  var EditProcessor = kotlin_org_jetbrains_compose_ui_ui_text.$_$.j;
  var Paint = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.h1;
  var _TextRange___get_collapsed__impl__cilesp = kotlin_org_jetbrains_compose_ui_ui_text.$_$.q2;
  var _TextRange___get_max__impl__owm8m = kotlin_org_jetbrains_compose_ui_ui_text.$_$.t2;
  var onPreviewKeyEvent = kotlin_org_jetbrains_compose_ui_ui.$_$.t1;
  var _TextRange___get_start__impl__ww4t90 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.w2;
  var _TextRange___get_end__impl__gcdxpp = kotlin_org_jetbrains_compose_ui_ui_text.$_$.r2;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var _DpSize___init__impl__t4mur0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.r2;
  var EventListener = kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.$_$.a;
  var snapshotFlow = kotlin_androidx_compose_runtime_runtime.$_$.h2;
  var get_FirstBaseline = kotlin_org_jetbrains_compose_ui_ui.$_$.d3;
  var get_LastBaseline = kotlin_org_jetbrains_compose_ui_ui.$_$.f3;
  var mapOf = kotlin_kotlin.$_$.wa;
  var heightIn = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.s;
  var invalidateMeasurement = kotlin_org_jetbrains_compose_ui_ui.$_$.f6;
  var resolveDefaults = kotlin_org_jetbrains_compose_ui_ui_text.$_$.a2;
  var FontStyle = kotlin_org_jetbrains_compose_ui_ui_text.$_$.b;
  var FontSynthesis = kotlin_org_jetbrains_compose_ui_ui_text.$_$.c;
  var get_isAltPressed = kotlin_org_jetbrains_compose_ui_ui.$_$.n1;
  var get_isMetaPressed = kotlin_org_jetbrains_compose_ui_ui.$_$.p1;
  var get_isShiftPressed = kotlin_org_jetbrains_compose_ui_ui.$_$.q1;
  var Companion_getInstance_44 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.c3;
  var Companion_getInstance_45 = kotlin_org_jetbrains_compose_ui_ui.$_$.ib;
  var KeyboardCapitalization = kotlin_org_jetbrains_compose_ui_ui_text.$_$.n;
  var Companion_getInstance_46 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.e3;
  var KeyboardType = kotlin_org_jetbrains_compose_ui_ui_text.$_$.o;
  var Companion_getInstance_47 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.k3;
  var ImeAction = kotlin_org_jetbrains_compose_ui_ui_text.$_$.l;
  var ImeOptions = kotlin_org_jetbrains_compose_ui_ui_text.$_$.m;
  var KeyboardCapitalization__hashCode_impl_6ibuz5 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.h2;
  var KeyboardType__hashCode_impl_mw6m33 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.j2;
  var ImeAction__hashCode_impl_m1mrob = kotlin_org_jetbrains_compose_ui_ui_text.$_$.f2;
  var KeyboardCapitalization__toString_impl_f8u1tq = kotlin_org_jetbrains_compose_ui_ui_text.$_$.i2;
  var KeyboardType__toString_impl_150pa8 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.k2;
  var ImeAction__toString_impl_r8bdhy = kotlin_org_jetbrains_compose_ui_ui_text.$_$.g2;
  var charSequenceGet = kotlin_kotlin.$_$.kf;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var TextRange_0 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.v1;
  var _Constraints___get_hasBoundedWidth__impl__7hd0wr = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.x1;
  var MultiParagraph = kotlin_org_jetbrains_compose_ui_ui_text.$_$.m1;
  var MultiParagraphIntrinsics = kotlin_org_jetbrains_compose_ui_ui_text.$_$.l1;
  var TextLayoutInput_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.i4;
  var constrain = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e1;
  var TextLayoutResult = kotlin_org_jetbrains_compose_ui_ui_text.$_$.r1;
  var round_0 = kotlin_kotlin.$_$.mh;
  var get_LocalCursorBlinkEnabled = kotlin_org_jetbrains_compose_ui_ui.$_$.s6;
  var LaunchedEffect_0 = kotlin_androidx_compose_runtime_runtime.$_$.s;
  var _TextRange___get_min__impl__uu95c4 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.u2;
  var findRootCoordinates = kotlin_org_jetbrains_compose_ui_ui.$_$.m4;
  var Triple = kotlin_kotlin.$_$.tn;
  var _Color___get_alpha__impl__wcfyv1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.v2;
  var TextPainter_instance = kotlin_org_jetbrains_compose_ui_ui_text.$_$.u3;
  var TextRange_1 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.u1;
  var Builder_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.f4;
  var SpanStyle_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.h4;
  var TransformedText = kotlin_org_jetbrains_compose_ui_ui_text.$_$.x;
  var Paragraph = kotlin_org_jetbrains_compose_ui_ui_text.$_$.p1;
  var Rect_0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.e;
  var repeat = kotlin_kotlin.$_$.uk;
  var focusRequester = kotlin_org_jetbrains_compose_ui_ui.$_$.s;
  var onFocusChanged = kotlin_org_jetbrains_compose_ui_ui.$_$.u;
  var FinishComposingTextCommand = kotlin_org_jetbrains_compose_ui_ui_text.$_$.k;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var CommitTextCommand_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.z3;
  var DeleteSurroundingTextCommand = kotlin_org_jetbrains_compose_ui_ui_text.$_$.i;
  var Companion_getInstance_48 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.g3;
  var onKeyEvent = kotlin_org_jetbrains_compose_ui_ui.$_$.s1;
  var pointerInput_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.v2;
  var Companion_getInstance_49 = kotlin_org_jetbrains_compose_ui_ui.$_$.qb;
  var pointerHoverIcon = kotlin_org_jetbrains_compose_ui_ui.$_$.t2;
  var Companion_getInstance_50 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.m1;
  var minIntrinsicWidth_1 = kotlin_org_jetbrains_compose_ui_ui.$_$.k3;
  var minIntrinsicHeight_1 = kotlin_org_jetbrains_compose_ui_ui.$_$.j3;
  var maxIntrinsicWidth_1 = kotlin_org_jetbrains_compose_ui_ui.$_$.i3;
  var maxIntrinsicHeight_1 = kotlin_org_jetbrains_compose_ui_ui.$_$.h3;
  var LayoutModifier = kotlin_org_jetbrains_compose_ui_ui.$_$.l3;
  var constrain_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d1;
  var layout = kotlin_org_jetbrains_compose_ui_ui.$_$.p4;
  var graphicsLayer = kotlin_org_jetbrains_compose_ui_ui.$_$.h1;
  var Clickable = kotlin_org_jetbrains_compose_ui_ui_text.$_$.i1;
  var IllegalArgumentException = kotlin_kotlin.$_$.hn;
  var Url = kotlin_org_jetbrains_compose_ui_ui_text.$_$.j1;
  var arrayConcat = kotlin_kotlin.$_$.a;
  var LinkAnnotation = kotlin_org_jetbrains_compose_ui_ui_text.$_$.k1;
  var arrayListOf = kotlin_kotlin.$_$.r7;
  var roundToIntRect = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.m1;
  var SemanticsProperties_getInstance = kotlin_org_jetbrains_compose_ui_ui.$_$.bc;
  var get_LocalUriHandler = kotlin_org_jetbrains_compose_ui_ui.$_$.f7;
  var ParentDataModifier = kotlin_org_jetbrains_compose_ui_ui.$_$.a4;
  var SpanStyle = kotlin_org_jetbrains_compose_ui_ui_text.$_$.q1;
  var fastJoinToString = kotlin_org_jetbrains_compose_ui_ui_util.$_$.c;
  var get_isSecondaryPressed = kotlin_org_jetbrains_compose_ui_ui.$_$.q2;
  var stylusHoverIcon = kotlin_org_jetbrains_compose_ui_ui.$_$.a3;
  var FocusEventModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.p;
  var DpTouchBoundsExpansion = kotlin_org_jetbrains_compose_ui_ui.$_$.z4;
  var DeleteAllCommand = kotlin_org_jetbrains_compose_ui_ui_text.$_$.h;
  var requestAutofill = kotlin_org_jetbrains_compose_ui_ui.$_$.k6;
  var CommitTextCommand = kotlin_org_jetbrains_compose_ui_ui_text.$_$.g;
  var isCharSequence = kotlin_kotlin.$_$.ng;
  var replaceRange = kotlin_kotlin.$_$.wk;
  var TextFieldValue = kotlin_org_jetbrains_compose_ui_ui_text.$_$.v;
  var set_inputText = kotlin_org_jetbrains_compose_ui_ui.$_$.s8;
  var set_editableText = kotlin_org_jetbrains_compose_ui_ui.$_$.j8;
  var set_textSelectionRange = kotlin_org_jetbrains_compose_ui_ui.$_$.ba;
  var createFromText = kotlin_org_jetbrains_compose_ui_ui.$_$.b;
  var Companion_getInstance_51 = kotlin_org_jetbrains_compose_ui_ui.$_$.gb;
  var set_contentType = kotlin_org_jetbrains_compose_ui_ui.$_$.e8;
  var password = kotlin_org_jetbrains_compose_ui_ui.$_$.i9;
  var set_isEditable = kotlin_org_jetbrains_compose_ui_ui.$_$.v8;
  var getTextLayoutResult = kotlin_org_jetbrains_compose_ui_ui.$_$.p8;
  var setText = kotlin_org_jetbrains_compose_ui_ui.$_$.w9;
  var insertTextAtCursor = kotlin_org_jetbrains_compose_ui_ui.$_$.t8;
  var setSelection = kotlin_org_jetbrains_compose_ui_ui.$_$.u9;
  var onImeAction = kotlin_org_jetbrains_compose_ui_ui.$_$.b9;
  var copyText = kotlin_org_jetbrains_compose_ui_ui.$_$.f8;
  var cutText = kotlin_org_jetbrains_compose_ui_ui.$_$.g8;
  var pasteText = kotlin_org_jetbrains_compose_ui_ui.$_$.j9;
  var awaitCancellation = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.t;
  var throwKotlinNothingValueException = kotlin_kotlin.$_$.bp;
  var establishTextInputSession = kotlin_org_jetbrains_compose_ui_ui.$_$.pc;
  var startInput = kotlin_org_jetbrains_compose_ui_ui_text.$_$.r;
  var notifyFocusedRect = kotlin_org_jetbrains_compose_ui_ui_text.$_$.q;
  var updateTextLayoutResult = kotlin_org_jetbrains_compose_ui_ui_text.$_$.s;
  var PlatformTextInputService = kotlin_org_jetbrains_compose_ui_ui_text.$_$.t;
  var _TextUnit___get_isEm__impl__esrmtl = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j3;
  var _TextUnit___get_value__impl__hpbx0k = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.p3;
  var TextUnit = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.w;
  var TextUnit__toString_impl_51ghw0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.n3;
  var checkArithmetic = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a1;
  var pack = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k1;
  var ParagraphIntrinsics = kotlin_org_jetbrains_compose_ui_ui_text.$_$.n1;
  var Paragraph_0 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.o1;
  var _Constraints___get_value__impl__3ah2ax = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g2;
  var _Constraints___init__impl__v8ud31 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.u1;
  var TextOverflow__hashCode_impl_kqdwgt = kotlin_org_jetbrains_compose_ui_ui_text.$_$.o2;
  var RememberObserver = kotlin_androidx_compose_runtime_runtime.$_$.a1;
  var set_text = kotlin_org_jetbrains_compose_ui_ui.$_$.aa;
  var set_textSubstitution = kotlin_org_jetbrains_compose_ui_ui.$_$.ca;
  var set_isShowingTextSubstitution = kotlin_org_jetbrains_compose_ui_ui.$_$.w8;
  var setTextSubstitution = kotlin_org_jetbrains_compose_ui_ui.$_$.v9;
  var showTextSubstitution = kotlin_org_jetbrains_compose_ui_ui.$_$.y9;
  var clearTextSubstitution = kotlin_org_jetbrains_compose_ui_ui.$_$.z7;
  var invalidateLayer = kotlin_org_jetbrains_compose_ui_ui.$_$.e6;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.i4;
  var Companion_getInstance_52 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.o4;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.c4;
  var LazyThreadSafetyMode_NONE_getInstance = kotlin_kotlin.$_$.u3;
  var lazy = kotlin_kotlin.$_$.so;
  var get_isShiftPressed_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.r2;
  var ResolvedTextDirection_Ltr_getInstance = kotlin_org_jetbrains_compose_ui_ui_text.$_$.x3;
  var ResolvedTextDirection_Rtl_getInstance = kotlin_org_jetbrains_compose_ui_ui_text.$_$.y3;
  var SemanticsPropertyKey = kotlin_org_jetbrains_compose_ui_ui.$_$.x7;
  var _TextRange___get_reversed__impl__emhnbm = kotlin_org_jetbrains_compose_ui_ui_text.$_$.v2;
  var androidx_compose_ui_text_TextLayoutResult$stableprop_getter = kotlin_org_jetbrains_compose_ui_ui_text.$_$.x1;
  var boundsInWindow = kotlin_org_jetbrains_compose_ui_ui.$_$.i4;
  var Rect_1 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.d;
  var HapticFeedbackType = kotlin_org_jetbrains_compose_ui_ui.$_$.k1;
  var _TextRange___get_length__impl__7qes3a = kotlin_org_jetbrains_compose_ui_ui_text.$_$.s2;
  var getSelectedText = kotlin_org_jetbrains_compose_ui_ui_text.$_$.z;
  var getTextBeforeSelection = kotlin_org_jetbrains_compose_ui_ui_text.$_$.b1;
  var getTextAfterSelection = kotlin_org_jetbrains_compose_ui_ui_text.$_$.a1;
  var TextToolbarStatus_Shown_getInstance = kotlin_org_jetbrains_compose_ui_ui.$_$.kc;
  var SetSelectionCommand = kotlin_org_jetbrains_compose_ui_ui_text.$_$.u;
  var Companion_instance_7 = kotlin_org_jetbrains_compose_ui_ui.$_$.wb;
  var await_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  var CancellationException_init_$Init$_0 = kotlin_kotlin.$_$.p4;
  var Popup_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.la;
  var PaddingValues_0 = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.c;
  var padding_0 = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.b1;
  var Companion_getInstance_53 = kotlin_org_jetbrains_compose_ui_ui.$_$.sb;
  var get_LocalInputModeManager = kotlin_org_jetbrains_compose_ui_ui.$_$.y6;
  var get_LocalSystemTheme = kotlin_org_jetbrains_compose_ui_ui.$_$.na;
  var SystemTheme_Dark_getInstance = kotlin_org_jetbrains_compose_ui_ui.$_$.nc;
  var InputMode = kotlin_org_jetbrains_compose_ui_ui.$_$.b3;
  var flow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d2;
  var staticCompositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.l2;
  var Companion_instance_8 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.j3;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.d6;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.j4;
  var get_utf16CodePoint = kotlin_org_jetbrains_compose_ui_ui.$_$.v1;
  var Companion_getInstance_54 = kotlin_org_jetbrains_skiko_skiko.$_$.e;
  var substring = kotlin_kotlin.$_$.pl;
  var Char__plus_impl_qi7pgj = kotlin_kotlin.$_$.v;
  var numberToChar = kotlin_kotlin.$_$.ah;
  var CharProperties_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.c;
  var isHighSurrogate = kotlin_kotlin.$_$.fk;
  var isLowSurrogate = kotlin_kotlin.$_$.hk;
  var Companion_getInstance_55 = kotlin_kotlin.$_$.h3;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.t;
  var PlatformTextInputSession = kotlin_org_jetbrains_compose_ui_ui.$_$.j7;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var CharSequence = kotlin_kotlin.$_$.xm;
  var _Matrix___init__impl__q3kp4w = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.i3;
  var Matrix = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d1;
  var Matrix__map_impl_7meu7m = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.m3;
  var size = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.m1;
  var drawWithCache = kotlin_org_jetbrains_compose_ui_ui.$_$.j;
  var SplineBasedFloatDecayAnimationSpec = kotlin_org_jetbrains_compose_animation_animation.$_$.f;
  var generateDecayAnimationSpec = kotlin_org_jetbrains_compose_animation_animation_core.$_$.s1;
  var get_hostOs = kotlin_org_jetbrains_skiko_skiko.$_$.j6;
  var Companion_getInstance_56 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d4;
  var get_domEventOrNull = kotlin_org_jetbrains_compose_ui_ui.$_$.c;
  var firstOrNull_1 = kotlin_kotlin.$_$.yj;
  var toString_2 = kotlin_kotlin.$_$.y;
  var Char = kotlin_kotlin.$_$.ym;
  var WebTextToolbar = kotlin_org_jetbrains_compose_ui_ui.$_$.l7;
  var Companion_getInstance_57 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f4;
  var positionInWindow = kotlin_org_jetbrains_compose_ui_ui.$_$.t4;
  var CompositionLocalProvider_0 = kotlin_androidx_compose_runtime_runtime.$_$.k;
  var Color_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.x;
  var _DpSize___get_packedValue__impl__jx4au8 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t2;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(BackgroundElement, 'BackgroundElement', VOID, ModifierNodeElement);
  initMetadataForClass(BackgroundNode, 'BackgroundNode', VOID, Node, [DrawModifierNode, DelegatableNode, SemanticsModifierNode]);
  initMetadataForClass(BorderModifierNodeElement, 'BorderModifierNodeElement', VOID, ModifierNodeElement);
  initMetadataForClass(BorderModifierNode, 'BorderModifierNode', VOID, DelegatingNode, [SemanticsModifierNode]);
  initMetadataForClass(BorderCache, 'BorderCache', BorderCache);
  initMetadataForClass(BorderStroke, 'BorderStroke');
  initMetadataForClass(ClickableElement, 'ClickableElement', VOID, ModifierNodeElement);
  function isInterested(event) {
    return false;
  }
  initMetadataForInterface(GestureConnection, 'GestureConnection');
  initMetadataForClass(AbstractClickableNode, 'AbstractClickableNode', VOID, DelegatingNode, [PointerInputModifierNode, KeyInputModifierNode, DelegatableNode, SemanticsModifierNode, TraversableNode, CompositionLocalConsumerModifierNode, IndirectPointerInputModifierNode, GestureConnection], [2]);
  initMetadataForClass(ClickableNode, 'ClickableNode', VOID, AbstractClickableNode, VOID, [2]);
  initMetadataForLambda(AbstractClickableNode$handlePressInteraction$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(TraverseKey, 'TraverseKey');
  initMetadataForLambda(AbstractClickableNode$onFocusChange$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$onFocusChange$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$onPointerEvent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$onPointerEvent$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$onKeyEvent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$onKeyEvent$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$handlePressInteractionStart$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$handlePressInteractionStart$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$handlePressInteractionStart$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$handlePressInteractionStart$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$handlePressInteractionRelease$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$handlePressInteractionRelease$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$handlePressInteractionCancel$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$handlePressInteraction$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$emitHoverEnter$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractClickableNode$emitHoverExit$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handlePressInteractionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(CombinedClickableElement, 'CombinedClickableElement', VOID, ModifierNodeElement);
  initMetadataForLambda(CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(DoubleKeyClickState, 'DoubleKeyClickState');
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(CombinedClickableNode$createPointerInputNodeIfNeeded$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CombinedClickableNode$handleDownEvent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CombinedClickableNode$handleUpEvent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CombinedClickableNode$onClickKeyDownEvent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CombinedClickableNode$onClickKeyUpEvent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CombinedClickableNode, 'CombinedClickableNode', VOID, AbstractClickableNode, [CompositionLocalConsumerModifierNode], [2]);
  initMetadataForObject(VerticalScrollableClipShape, 'VerticalScrollableClipShape', VOID, VOID, [Shape]);
  initMetadataForObject(HorizontalScrollableClipShape, 'HorizontalScrollableClipShape', VOID, VOID, [Shape]);
  initMetadataForObject(ComposeFoundationFlags, 'ComposeFoundationFlags');
  initMetadataForObject(TraverseKey_0, 'TraverseKey');
  initMetadataForLambda(FocusableNode$onFocusStateChange$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(FocusableNode$emitWithFallback$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(FocusableNode, 'FocusableNode', VOID, DelegatingNode, [SemanticsModifierNode, GlobalPositionAwareModifierNode, CompositionLocalConsumerModifierNode, DelegatableNode, TraversableNode]);
  initMetadataForClass(FocusableElement, 'FocusableElement', VOID, ModifierNodeElement);
  initMetadataForObject(TraverseKey_1, 'TraverseKey');
  initMetadataForClass(FocusedBoundsObserverNode, 'FocusedBoundsObserverNode', VOID, Node, [TraversableNode]);
  initMetadataForObject(TraverseKey_2, 'TraverseKey');
  initMetadataForClass(GestureNode, 'GestureNode', VOID, Node, [TraversableNode, DelegatableNode]);
  initMetadataForClass(HoverableElement, 'HoverableElement', VOID, ModifierNodeElement);
  initMetadataForLambda(HoverableNode$onPointerEvent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HoverableNode$onPointerEvent$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($emitEnterCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($emitExitCOROUTINE$, CoroutineImpl);
  initMetadataForClass(HoverableNode, 'HoverableNode', VOID, Node, [PointerInputModifierNode], [0]);
  initMetadataForClass(sam$androidx_compose_ui_layout_MeasurePolicy$0, 'sam$androidx_compose_ui_layout_MeasurePolicy$0', VOID, VOID, [MeasurePolicy, FunctionAdapter]);
  function rememberUpdatedInstance(interactionSource, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(1257603829);
    $composer_0.n30();
    return NoIndicationInstance_instance;
  }
  initMetadataForInterface(Indication, 'Indication');
  initMetadataForInterface(IndicationNodeFactory, 'IndicationNodeFactory', VOID, VOID, [Indication]);
  initMetadataForLambda(DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DefaultDebugIndicationInstance, 'DefaultDebugIndicationInstance', VOID, Node, [DrawModifierNode]);
  initMetadataForObject(DefaultDebugIndication, 'DefaultDebugIndication', VOID, VOID, [IndicationNodeFactory]);
  initMetadataForObject(NoIndicationInstance, 'NoIndicationInstance');
  initMetadataForClass(IndicationModifierElement, 'IndicationModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(IndicationModifier, 'IndicationModifier', VOID, VOID, [DrawModifier]);
  initMetadataForClass(IndicationModifierNode, 'IndicationModifierNode', VOID, DelegatingNode);
  initMetadataForClass(Mutator, 'Mutator');
  initMetadataForLambda(MutatorMutex$mutate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(MutatorMutex$mutateWith$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(MutatorMutex, 'MutatorMutex', MutatorMutex, VOID, VOID, [2, 3]);
  initMetadataForClass(MutatePriority, 'MutatePriority', VOID, Enum);
  initMetadataForClass(PlatformOptimizedCancellationException, 'PlatformOptimizedCancellationException', VOID, CancellationException);
  initMetadataForClass(MutationInterruptedException, 'MutationInterruptedException', MutationInterruptedException, PlatformOptimizedCancellationException);
  initMetadataForClass(OverscrollEffect$node$1, VOID, VOID, Node);
  function get_effectModifier() {
    return Companion_instance_0;
  }
  function get_node() {
    return new OverscrollEffect$node$1();
  }
  initMetadataForInterface(OverscrollEffect, 'OverscrollEffect', VOID, VOID, VOID, [2]);
  initMetadataForClass(OverscrollModifierElement, 'OverscrollModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(OverscrollModifierNode, 'OverscrollModifierNode', VOID, DelegatingNode);
  initMetadataForCompanion(Companion);
  initMetadataForClass(ScrollState$_scrollIndicatorState$1);
  function scroll$default(scrollPriority, block, $completion, $super) {
    scrollPriority = scrollPriority === VOID ? MutatePriority_Default_getInstance() : scrollPriority;
    return $super === VOID ? this.pg7(scrollPriority, block, $completion) : $super.pg7.call(this, scrollPriority, block, $completion);
  }
  function get_canScrollForward() {
    return true;
  }
  function get_canScrollBackward() {
    return true;
  }
  initMetadataForInterface(ScrollableState, 'ScrollableState', VOID, VOID, VOID, [2]);
  initMetadataForClass(ScrollState, 'ScrollState', VOID, VOID, [ScrollableState], [2, 1]);
  initMetadataForClass(ScrollingLayoutElement, 'ScrollingLayoutElement', VOID, ModifierNodeElement);
  initMetadataForClass(ScrollNode, 'ScrollNode', VOID, Node, [LayoutModifierNode, SemanticsModifierNode]);
  initMetadataForClass(ScrollableAreaElement, 'ScrollableAreaElement', VOID, ModifierNodeElement);
  initMetadataForClass(ScrollableAreaNode, 'ScrollableAreaNode', VOID, DelegatingNode, [CompositionLocalConsumerModifierNode, DelegatableNode]);
  initMetadataForObject(ContextMenuKey, 'ContextMenuKey');
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(contextMenuGestures$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ContextMenuPopupPositionProvider, 'ContextMenuPopupPositionProvider');
  initMetadataForClass(Status, 'Status');
  initMetadataForClass(Open, 'Open', VOID, Status);
  initMetadataForObject(Closed, 'Closed', VOID, Status);
  initMetadataForClass(ContextMenuState, 'ContextMenuState');
  initMetadataForClass(ContextMenuColors, 'ContextMenuColors');
  initMetadataForClass(ContextMenuScope, 'ContextMenuScope');
  initMetadataForObject(ComposableSingletons$ContextMenuUiKt, 'ComposableSingletons$ContextMenuUiKt');
  initMetadataForObject(ContextMenuSpec, 'ContextMenuSpec');
  initMetadataForClass(BringIntoViewRequestPriorityQueue, 'BringIntoViewRequestPriorityQueue', BringIntoViewRequestPriorityQueue);
  function get_scrollAnimationSpec() {
    return Companion_getInstance_59().lge_1;
  }
  function calculateScrollDistance(offset, size, containerSize) {
    return Companion_getInstance_59().nge(offset, size, containerSize);
  }
  initMetadataForInterface(BringIntoViewSpec, 'BringIntoViewSpec');
  initMetadataForClass(BringIntoViewSpec$Companion$DefaultBringIntoViewSpec$1, VOID, VOID, VOID, [BringIntoViewSpec]);
  initMetadataForCompanion(Companion_0);
  initMetadataForLambda(ContentInViewNode$launchAnimation$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(Request, 'Request');
  initMetadataForLambda(ContentInViewNode$launchAnimation$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($bringChildIntoViewCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ContentInViewNode, 'ContentInViewNode', VOID, Node, [CompositionLocalConsumerModifierNode, MeasuredSizeAwareModifierNode], [1]);
  initMetadataForClass(DifferentialVelocityTracker, 'DifferentialVelocityTracker', DifferentialVelocityTracker);
  initMetadataForClass(TouchSlopDetector, 'TouchSlopDetector', TouchSlopDetector);
  initMetadataForLambda(detectDragGestures$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(awaitLongPressOrCancellation$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($processDragGestureCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($dragCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($awaitLongPressOrCancellationCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($awaitTouchSlopOrCancellationCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($awaitDragOrCancellationCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(DragScope, 'DragScope');
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(DraggableElement, 'DraggableElement', VOID, ModifierNodeElement);
  initMetadataForClass(DefaultDraggableState$dragScope$1, VOID, VOID, VOID, [DragScope]);
  initMetadataForLambda(DefaultDraggableState$drag$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DefaultDraggableState, 'DefaultDraggableState', VOID, VOID, VOID, [2]);
  initMetadataForLambda(DraggableNode$drag$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DraggableNode$onDragStarted$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DraggableNode$onDragStopped$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DragGestureNode, 'DragGestureNode', VOID, DelegatingNode, [PointerInputModifierNode, IndirectPointerInputModifierNode, CompositionLocalConsumerModifierNode, GestureConnection], [1, 0]);
  initMetadataForClass(DraggableNode, 'DraggableNode', VOID, DragGestureNode, VOID, [1]);
  initMetadataForLambda(DragGestureNode$startListeningForEvents$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DragGestureNode$startListeningForEvents$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($processDragStartCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($processDragStopCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($processDragCancelCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DragEvent, 'DragEvent');
  initMetadataForClass(DragStarted, 'DragStarted', VOID, DragEvent);
  initMetadataForClass(DragStopped, 'DragStopped', VOID, DragEvent);
  initMetadataForObject(DragCancelled, 'DragCancelled', VOID, DragEvent);
  initMetadataForClass(DragDelta, 'DragDelta', VOID, DragEvent);
  initMetadataForClass(AwaitTouchSlop, 'AwaitTouchSlop', VOID, Enum);
  initMetadataForClass(DragDetectionState, 'DragDetectionState');
  initMetadataForClass(AwaitDown, 'AwaitDown', AwaitDown, DragDetectionState);
  initMetadataForClass(AwaitTouchSlop_0, 'AwaitTouchSlop', AwaitTouchSlop_0, DragDetectionState);
  initMetadataForClass(AwaitGesturePickup, 'AwaitGesturePickup', AwaitGesturePickup, DragDetectionState);
  initMetadataForClass(Dragging, 'Dragging', Dragging, DragDetectionState);
  initMetadataForLambda(NoOpOnDragStarted$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(NoOpOnDragStopped$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(awaitEachGesture$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($awaitAllPointersUpCOROUTINE$, CoroutineImpl);
  initMetadataForClass(AwaitTouchSlop_1, 'AwaitTouchSlop', VOID, Enum);
  initMetadataForClass(DragDetectionState_0, 'DragDetectionState');
  initMetadataForClass(AwaitDown_0, 'AwaitDown', AwaitDown_0, DragDetectionState_0);
  initMetadataForClass(MouseWheelScrollDelta, 'MouseWheelScrollDelta');
  initMetadataForLambda(MouseWheelScrollingLogic$startReceivingEvents$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(MouseWheelScrollingLogic$dispatchMouseWheelScroll$waitNextScrollDelta$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($dispatchMouseWheelScrollCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($dispatchMouseWheelScroll$waitNextScrollDeltaCOROUTINE$, CoroutineImpl);
  initMetadataForClass(NonTouchScrollingLogic, 'NonTouchScrollingLogic', VOID, VOID, VOID, [1]);
  initMetadataForClass(MouseWheelScrollingLogic, 'MouseWheelScrollingLogic', VOID, NonTouchScrollingLogic, VOID, [4, 5, 1, 6]);
  initMetadataForLambda(NonTouchScrollingLogic$userScroll$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($userScrollCOROUTINE$, CoroutineImpl);
  initMetadataForLambda(untilNull$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(busyReceive$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(busyReceive$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(Orientation, 'Orientation', VOID, Enum);
  initMetadataForLambda(scrollBy$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(stopScroll$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($scrollByCOROUTINE$, CoroutineImpl);
  initMetadataForObject(TraverseKey_3, 'TraverseKey');
  initMetadataForClass(ScrollableContainerNode, 'ScrollableContainerNode', VOID, Node, [TraversableNode]);
  initMetadataForObject(ScrollableDefaults, 'ScrollableDefaults');
  initMetadataForClass(ScrollableElement, 'ScrollableElement', VOID, ModifierNodeElement);
  initMetadataForLambda(ScrollableNode$onKeyEvent$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ScrollableNode$drag$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ScrollableNode$onDragStopped$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ScrollableNode$onWheelScrollStopped$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ScrollableNode$onTrackpadScrollStopped$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForFunctionReference(ScrollableNode$onWheelScrollStopped$ref, KFunctionImpl, VOID, [1]);
  initMetadataForFunctionReference(ScrollableNode$onTrackpadScrollStopped$ref, KFunctionImpl, VOID, [1]);
  initMetadataForLambda(ScrollableNode$onKeyEvent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ScrollableNode$setScrollSemanticsActions$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ScrollableNode$setScrollSemanticsActions$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($dragCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(ScrollableNode, 'ScrollableNode', VOID, DragGestureNode, [KeyInputModifierNode, SemanticsModifierNode], [1]);
  function updateDensity(density) {
    return Unit_instance;
  }
  initMetadataForInterface(ScrollableDefaultFlingBehavior, 'ScrollableDefaultFlingBehavior', VOID, VOID, VOID, [2]);
  initMetadataForInterface(ScrollScope, 'ScrollScope');
  initMetadataForClass(ScrollingLogic$doFlingAnimation$2$reverseScope$1, VOID, VOID, VOID, [ScrollScope]);
  initMetadataForInterface(NestedScrollScope, 'NestedScrollScope');
  initMetadataForClass(ScrollingLogic$nestedScrollScope$1, VOID, VOID, VOID, [NestedScrollScope]);
  initMetadataForLambda(ScrollingLogic$onScrollStopped$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ScrollingLogic$doFlingAnimation$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ScrollingLogic$scroll$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($onScrollStoppedCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($doFlingAnimationCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ScrollingLogic, 'ScrollingLogic', VOID, VOID, VOID, [2, 1]);
  initMetadataForCoroutine($onPostFlingCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ScrollableNestedScrollConnection, 'ScrollableNestedScrollConnection', VOID, VOID, [NestedScrollConnection], [2, 1]);
  function get_isSmoothScrollingEnabled() {
    return true;
  }
  function isPreciseWheelScroll(event) {
    return false;
  }
  initMetadataForInterface(ScrollConfig, 'ScrollConfig');
  initMetadataForClass(FlingCancellationException, 'FlingCancellationException', FlingCancellationException, PlatformOptimizedCancellationException);
  initMetadataForLambda(DefaultFlingBehavior$performFling$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DefaultFlingBehavior, 'DefaultFlingBehavior', VOID, VOID, [ScrollableDefaultFlingBehavior], [2]);
  initMetadataForClass(NoOpScrollScope$1, VOID, VOID, VOID, [ScrollScope]);
  initMetadataForClass(DefaultScrollMotionDurationScale$1, VOID, VOID, VOID, [MotionDurationScale]);
  initMetadataForClass(UnityDensity$1, VOID, VOID, VOID, [Density]);
  initMetadataForLambda(semanticsScrollBy$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($semanticsScrollByCOROUTINE$, CoroutineImpl);
  initMetadataForLambda(DefaultScrollableState$scroll$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DefaultScrollableState$scrollScope$1, VOID, VOID, VOID, [ScrollScope]);
  initMetadataForLambda(DefaultScrollableState$scroll$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DefaultScrollableState, 'DefaultScrollableState', VOID, VOID, [ScrollableState], [2]);
  initMetadataForInterface(PressGestureScope, 'PressGestureScope', VOID, VOID, [Density], [0]);
  initMetadataForCoroutine($resetCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($tryAwaitReleaseCOROUTINE$, CoroutineImpl);
  initMetadataForClass(PressGestureScopeImpl, 'PressGestureScopeImpl', VOID, VOID, [PressGestureScope, Density], [0]);
  initMetadataForClass(LongPressResult, 'LongPressResult');
  initMetadataForObject(Success, 'Success', VOID, LongPressResult);
  initMetadataForClass(Released, 'Released', VOID, LongPressResult);
  initMetadataForObject(Canceled, 'Canceled', VOID, LongPressResult);
  initMetadataForLambda(NoPressGesture$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(detectTapGestures$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(detectTapGestures$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(processTapGesture$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(processTapGesture$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(processTapGesture$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(processTapGesture$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(processTapGesture$slambda_7, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(processTapGesture$slambda_9, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(processTapGesture$slambda_11, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(processTapGesture$slambda_13, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(processTapGesture$slambda_15, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(processTapGesture$slambda_17, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(launchAwaitingReset$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(waitForLongPress$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(awaitSecondDown$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(detectTapAndPress$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(detectTapAndPress$slambda$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(detectTapAndPress$slambda$slambda$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(detectTapAndPress$slambda$slambda$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(detectTapAndPress$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(detectTapAndPress$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($processTapGestureCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($awaitFirstDownCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($waitForUpOrCancellationCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($waitForLongPressCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($consumeUntilUpCOROUTINE$, CoroutineImpl);
  function performFling(_this__u8e3s4, initialVelocity, $completion) {
    return this.qhv(_this__u8e3s4, initialVelocity, get_NoOnReport(), $completion);
  }
  initMetadataForInterface(TargetedFlingBehavior, 'TargetedFlingBehavior', VOID, VOID, VOID, [3, 2]);
  initMetadataForClass(TrackpadScrollDelta, 'TrackpadScrollDelta');
  initMetadataForLambda(TrackpadScrollingLogic$startReceivingEvents$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TrackpadScrollingLogic$dispatchTrackpadScroll$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($dispatchTrackpadScrollCOROUTINE$, CoroutineImpl);
  initMetadataForClass(TrackpadScrollingLogic, 'TrackpadScrollingLogic', VOID, NonTouchScrollingLogic, VOID, [2, 1]);
  initMetadataForLambda(detectTransformGestures$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_2);
  initMetadataForCoroutine($animateToZeroCOROUTINE$, CoroutineImpl);
  initMetadataForClass(UpdatableAnimationState, 'UpdatableAnimationState', VOID, VOID, VOID, [2]);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(FinalSnappingItem, 'FinalSnappingItem');
  function calculateApproachOffset(velocity, decayOffset) {
    return decayOffset;
  }
  initMetadataForInterface(SnapLayoutInfoProvider_1, 'SnapLayoutInfoProvider');
  initMetadataForClass(SnapLayoutInfoProvider$1, VOID, VOID, VOID, [SnapLayoutInfoProvider_1]);
  initMetadataForClass(SnapLayoutInfoProvider$1_0, VOID, VOID, VOID, [SnapLayoutInfoProvider_1]);
  initMetadataForLambda(SnapFlingBehavior$fling$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($performFlingCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($flingCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($tryApproachCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SnapFlingBehavior, 'SnapFlingBehavior', VOID, VOID, [TargetedFlingBehavior], [3, 4, 2]);
  initMetadataForClass(AnimationResult, 'AnimationResult');
  initMetadataForCoroutine($approachAnimationCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DecayApproachAnimation, 'DecayApproachAnimation', VOID, VOID, VOID, [4]);
  initMetadataForCoroutine($approachAnimationCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(TargetApproachAnimation, 'TargetApproachAnimation', VOID, VOID, VOID, [4]);
  initMetadataForCoroutine($animateWithTargetCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($animateDecayCOROUTINE$, CoroutineImpl);
  initMetadataForObject(Center, 'Center');
  initMetadataForObject(Start, 'Start');
  initMetadataForInterface(Interaction, 'Interaction');
  initMetadataForClass(Start_0, 'Start', Start_0, VOID, [Interaction]);
  initMetadataForClass(Stop, 'Stop', VOID, VOID, [Interaction]);
  initMetadataForClass(Cancel, 'Cancel', VOID, VOID, [Interaction]);
  initMetadataForInterface(FocusInteraction, 'FocusInteraction', VOID, VOID, [Interaction]);
  initMetadataForClass(Focus, 'Focus', Focus, VOID, [FocusInteraction]);
  initMetadataForClass(Unfocus, 'Unfocus', VOID, VOID, [FocusInteraction]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(collectIsFocusedAsState$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(collectIsFocusedAsState$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(Enter, 'Enter', Enter, VOID, [Interaction]);
  initMetadataForClass(Exit, 'Exit', VOID, VOID, [Interaction]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_1, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(collectIsHoveredAsState$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(collectIsHoveredAsState$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(MutableInteractionSourceImpl, 'MutableInteractionSourceImpl', MutableInteractionSourceImpl, VOID, VOID, [1]);
  initMetadataForInterface(PressInteraction, 'PressInteraction', VOID, VOID, [Interaction]);
  initMetadataForClass(Press, 'Press', VOID, VOID, [PressInteraction]);
  initMetadataForClass(Release, 'Release', VOID, VOID, [PressInteraction]);
  initMetadataForClass(Cancel_0, 'Cancel', VOID, VOID, [PressInteraction]);
  function item(key, contentType, content) {
    // Inline function 'kotlin.error' call
    var message = 'The method is not implemented';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function item$default(key, contentType, content, $super) {
    key = key === VOID ? null : key;
    contentType = contentType === VOID ? null : contentType;
    var tmp;
    if ($super === VOID) {
      this.bi9(key, contentType, content);
      tmp = Unit_instance;
    } else {
      item(key, contentType, content);
      tmp = Unit_instance;
    }
    return tmp;
  }
  function items(count, key, contentType, itemContent) {
    // Inline function 'kotlin.error' call
    var message = 'The method is not implemented';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function items$default(count, key, contentType, itemContent, $super) {
    key = key === VOID ? null : key;
    var tmp;
    if (contentType === VOID) {
      tmp = LazyListScope$items$lambda;
    } else {
      tmp = contentType;
    }
    contentType = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.di9(count, key, contentType, itemContent);
      tmp_0 = Unit_instance;
    } else {
      items(count, key, contentType, itemContent);
      tmp_0 = Unit_instance;
    }
    return tmp_0;
  }
  initMetadataForInterface(LazyListScope, 'LazyListScope');
  function fillParentMaxWidth$default(_this__u8e3s4, fraction, $super) {
    fraction = fraction === VOID ? 1.0 : fraction;
    return $super === VOID ? this.fi9(_this__u8e3s4, fraction) : $super.fi9.call(this, _this__u8e3s4, fraction);
  }
  initMetadataForInterface(LazyItemScope, 'LazyItemScope');
  initMetadataForClass(LazyItemScopeImpl, 'LazyItemScopeImpl', LazyItemScopeImpl, VOID, [LazyItemScope]);
  initMetadataForClass(ParentSizeElement, 'ParentSizeElement', VOID, ModifierNodeElement);
  initMetadataForClass(ParentSizeNode, 'ParentSizeNode', VOID, Node, [LayoutModifierNode]);
  initMetadataForClass(LazyLayoutSemanticState$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForInterface(LazyLayoutMeasurePolicy, 'LazyLayoutMeasurePolicy');
  initMetadataForClass(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0, 'sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0', VOID, VOID, [LazyLayoutMeasurePolicy, FunctionAdapter]);
  initMetadataForClass(LazyLayoutMeasuredItemProvider, 'LazyLayoutMeasuredItemProvider');
  initMetadataForClass(LazyListMeasuredItemProvider, 'LazyListMeasuredItemProvider', VOID, LazyLayoutMeasuredItemProvider);
  initMetadataForClass(rememberLazyListMeasurePolicy$1, VOID, VOID, LazyListMeasuredItemProvider);
  initMetadataForClass(LazyListBeyondBoundsState, 'LazyListBeyondBoundsState');
  initMetadataForClass(LazyLayoutIntervalContent, 'LazyLayoutIntervalContent');
  initMetadataForClass(LazyListIntervalContent, 'LazyListIntervalContent', VOID, LazyLayoutIntervalContent, [LazyListScope]);
  function get_key_1() {
    return null;
  }
  function get_type_0() {
    return LazyLayoutIntervalContent$Interval$_get_type_$lambda_1wu10p;
  }
  initMetadataForInterface(Interval_1, 'Interval');
  initMetadataForClass(LazyListInterval, 'LazyListInterval', VOID, VOID, [Interval_1]);
  function getContentType(index) {
    return null;
  }
  function getKey(index) {
    return getDefaultLazyLayoutKey(index);
  }
  function getIndex(key) {
    return -1;
  }
  initMetadataForInterface(LazyLayoutItemProvider, 'LazyLayoutItemProvider');
  initMetadataForClass(LazyListItemProviderImpl, 'LazyListItemProviderImpl', VOID, VOID, [LazyLayoutItemProvider]);
  function get_viewportSize() {
    return Companion_getInstance_22().n5g_1;
  }
  function get_orientation() {
    return Orientation_Vertical_getInstance();
  }
  function get_beforeContentPadding() {
    return 0;
  }
  function get_afterContentPadding() {
    return 0;
  }
  function get_mainAxisItemSpacing() {
    return 0;
  }
  initMetadataForInterface(LazyListLayoutInfo, 'LazyListLayoutInfo');
  initMetadataForClass(LazyListMeasureResult, 'LazyListMeasureResult', VOID, VOID, [LazyListLayoutInfo, MeasureResult]);
  initMetadataForInterface(LazyLayoutMeasuredItem, 'LazyLayoutMeasuredItem');
  initMetadataForClass(LazyListMeasuredItem, 'LazyListMeasuredItem', VOID, VOID, [LazyLayoutMeasuredItem]);
  function get_prefetchScheduler() {
    return null;
  }
  initMetadataForInterface(LazyListPrefetchStrategy, 'LazyListPrefetchStrategy');
  function schedulePrefetch$default(index, onPrefetchFinished, $super) {
    onPrefetchFinished = onPrefetchFinished === VOID ? null : onPrefetchFinished;
    return $super === VOID ? this.sih(index, onPrefetchFinished) : $super.sih.call(this, index, onPrefetchFinished);
  }
  initMetadataForInterface(LazyListPrefetchScope, 'LazyListPrefetchScope');
  initMetadataForClass(LazyListPrefetchResultScopeImpl, 'LazyListPrefetchResultScopeImpl');
  initMetadataForClass(DefaultLazyListPrefetchStrategy, 'DefaultLazyListPrefetchStrategy', DefaultLazyListPrefetchStrategy, VOID, [LazyListPrefetchStrategy]);
  initMetadataForClass(LazyListScrollPosition, 'LazyListScrollPosition', LazyListScrollPosition);
  function calculateDistanceTo$default(targetIndex, targetOffset, $super) {
    targetOffset = targetOffset === VOID ? 0 : targetOffset;
    return $super === VOID ? this.zii(targetIndex, targetOffset) : $super.zii.call(this, targetIndex, targetOffset);
  }
  initMetadataForInterface(LazyLayoutScrollScope_0, 'LazyLayoutScrollScope', VOID, VOID, [ScrollScope]);
  initMetadataForClass(LazyLayoutScrollScope$1, VOID, VOID, VOID, [LazyLayoutScrollScope_0, ScrollScope]);
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(LazyListState$remeasurementModifier$1, VOID, VOID, VOID, [RemeasurementModifier]);
  initMetadataForClass(LazyListState$prefetchScope$1, VOID, VOID, VOID, [LazyListPrefetchScope]);
  initMetadataForClass(LazyListState$_scrollIndicatorState$1);
  initMetadataForLambda(LazyListState$scrollToItem$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LazyListState$animateScrollToItem$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($scrollCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($animateScrollToItemCOROUTINE$, CoroutineImpl);
  initMetadataForClass(LazyListState, 'LazyListState', VOID, VOID, [ScrollableState], [2]);
  initMetadataForClass(EmptyLazyListMeasureResult$1, VOID, VOID, VOID, [MeasureResult]);
  initMetadataForClass(LazyGridSlots, 'LazyGridSlots');
  initMetadataForClass(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_0, 'sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0', VOID, VOID, [LazyLayoutMeasurePolicy, FunctionAdapter]);
  initMetadataForClass(LazyGridMeasuredItemProvider, 'LazyGridMeasuredItemProvider', VOID, LazyLayoutMeasuredItemProvider);
  initMetadataForClass(rememberLazyGridMeasurePolicy$1, VOID, VOID, LazyGridMeasuredItemProvider);
  initMetadataForClass(LazyGridMeasuredLineProvider, 'LazyGridMeasuredLineProvider');
  initMetadataForClass(rememberLazyGridMeasurePolicy$2, VOID, VOID, LazyGridMeasuredLineProvider);
  initMetadataForClass(LazyGridBeyondBoundsState, 'LazyGridBeyondBoundsState');
  initMetadataForClass(Fixed, 'Fixed');
  function item$default_0(key, span, contentType, content, $super) {
    key = key === VOID ? null : key;
    span = span === VOID ? null : span;
    contentType = contentType === VOID ? null : contentType;
    var tmp;
    if ($super === VOID) {
      this.diq(key, span, contentType, content);
      tmp = Unit_instance;
    } else {
      tmp = $super.diq.call(this, key, span, contentType, content);
    }
    return tmp;
  }
  function items$default_0(count, key, span, contentType, itemContent, $super) {
    key = key === VOID ? null : key;
    span = span === VOID ? null : span;
    var tmp;
    if (contentType === VOID) {
      tmp = LazyGridScope$items$lambda;
    } else {
      tmp = contentType;
    }
    contentType = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.fiq(count, key, span, contentType, itemContent);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.fiq.call(this, count, key, span, contentType, itemContent);
    }
    return tmp_0;
  }
  initMetadataForInterface(LazyGridScope, 'LazyGridScope');
  initMetadataForClass(GridSlotCache, 'GridSlotCache');
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(LazyGridIntervalContent, 'LazyGridIntervalContent', VOID, LazyLayoutIntervalContent, [LazyGridScope]);
  initMetadataForClass(LazyGridInterval, 'LazyGridInterval', VOID, VOID, [Interval_1]);
  initMetadataForClass(LazyGridItemProviderImpl, 'LazyGridItemProviderImpl', VOID, VOID, [LazyLayoutItemProvider]);
  initMetadataForObject(LazyGridItemScopeImpl, 'LazyGridItemScopeImpl');
  initMetadataForClass(LazyGridMeasureResult, 'LazyGridMeasureResult', VOID, VOID, [MeasureResult]);
  initMetadataForClass(LazyGridMeasuredItem, 'LazyGridMeasuredItem', VOID, VOID, [LazyLayoutMeasuredItem]);
  initMetadataForClass(LazyGridMeasuredLine, 'LazyGridMeasuredLine');
  function get_prefetchScheduler_0() {
    return null;
  }
  initMetadataForInterface(LazyGridPrefetchStrategy, 'LazyGridPrefetchStrategy');
  initMetadataForClass(LazyGridPrefetchResultScopeImpl, 'LazyGridPrefetchResultScopeImpl');
  initMetadataForClass(DefaultLazyGridPrefetchStrategy, 'DefaultLazyGridPrefetchStrategy', DefaultLazyGridPrefetchStrategy, VOID, [LazyGridPrefetchStrategy]);
  initMetadataForClass(LazyGridScrollPosition, 'LazyGridScrollPosition', LazyGridScrollPosition);
  initMetadataForClass(GridItemSpan, 'GridItemSpan');
  initMetadataForClass(LineConfiguration, 'LineConfiguration');
  initMetadataForClass(Bucket, 'Bucket');
  initMetadataForObject(LazyGridItemSpanScopeImpl, 'LazyGridItemSpanScopeImpl');
  initMetadataForClass(LazyGridSpanLayoutProvider, 'LazyGridSpanLayoutProvider');
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(LazyGridState$remeasurementModifier$1, VOID, VOID, VOID, [RemeasurementModifier]);
  initMetadataForClass(LazyGridState$prefetchScope$1);
  initMetadataForClass(LazyGridState$_scrollIndicatorState$1);
  initMetadataForLambda(LazyGridState$scrollToItem$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($scrollCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(LazyGridState, 'LazyGridState', VOID, VOID, [ScrollableState], [2]);
  initMetadataForClass(EmptyLazyGridLayoutInfo$1, VOID, VOID, VOID, [MeasureResult]);
  initMetadataForClass(rememberLazyGridSemanticState$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(Node_0, 'Node', VOID, Node);
  initMetadataForClass(AwaitFirstLayoutModifier, 'AwaitFirstLayoutModifier', AwaitFirstLayoutModifier, ModifierNodeElement, VOID, [0]);
  initMetadataForClass(CacheWindowLogic, 'CacheWindowLogic');
  initMetadataForObject(NoKey, 'NoKey');
  initMetadataForClass(CachedItem, 'CachedItem');
  initMetadataForClass(MutableIntervalList, 'MutableIntervalList', MutableIntervalList);
  initMetadataForClass(Interval, 'Interval');
  initMetadataForClass(LazyLayoutItemReusePolicy, 'LazyLayoutItemReusePolicy');
  initMetadataForClass(LazyLayout$$inlined$run$1$2$1);
  initMetadataForClass(Interval_0, 'Interval');
  initMetadataForClass(LazyLayoutBeyondBoundsInfo, 'LazyLayoutBeyondBoundsInfo', LazyLayoutBeyondBoundsInfo);
  initMetadataForClass(LazyLayoutBeyondBoundsModifierElement, 'LazyLayoutBeyondBoundsModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(LazyLayoutBeyondBoundsProviderModifierNode$Companion$emptyBeyondBoundsScope$1);
  initMetadataForCompanion(Companion_7);
  initMetadataForClass(LazyLayoutBeyondBoundsProviderModifierNode$layout$1);
  initMetadataForClass(LazyLayoutBeyondBoundsProviderModifierNode, 'LazyLayoutBeyondBoundsProviderModifierNode', VOID, Node, [LayoutModifierNode, BeyondBoundsLayoutProviderModifierNode]);
  function calculateAheadWindow(_this__u8e3s4, viewport) {
    return 0;
  }
  function calculateBehindWindow(_this__u8e3s4, viewport) {
    return 0;
  }
  initMetadataForInterface(LazyLayoutCacheWindow, 'LazyLayoutCacheWindow');
  initMetadataForCompanion(Companion_8);
  initMetadataForLambda(LazyLayoutItemAnimation$cancelPlacementAnimation$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LazyLayoutItemAnimation$animatePlacementDelta$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LazyLayoutItemAnimation$animateAppearance$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LazyLayoutItemAnimation$animateAppearance$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LazyLayoutItemAnimation$animateDisappearance$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LazyLayoutItemAnimation$release$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LazyLayoutItemAnimation$release$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LazyLayoutItemAnimation$release$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LazyLayoutItemAnimation, 'LazyLayoutItemAnimation');
  initMetadataForClass(LazyLayoutAnimationSpecsNode, 'LazyLayoutAnimationSpecsNode', VOID, Node, [ParentDataModifierNode]);
  initMetadataForClass(ItemInfo, 'ItemInfo');
  initMetadataForClass(DisplayingDisappearingItemsElement, 'DisplayingDisappearingItemsElement', VOID, ModifierNodeElement);
  initMetadataForClass(DisplayingDisappearingItemsNode, 'DisplayingDisappearingItemsNode', VOID, Node, [DrawModifierNode]);
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(LazyLayoutItemAnimator, 'LazyLayoutItemAnimator', LazyLayoutItemAnimator);
  initMetadataForClass(LazyLayoutItemContentFactory$CachedItemContent$createContentLambda$1$1$$inlined$cache$1$1);
  initMetadataForClass(CachedItemContent, 'CachedItemContent');
  initMetadataForClass(LazyLayoutItemContentFactory, 'LazyLayoutItemContentFactory');
  initMetadataForClass(NearestRangeKeyIndexMap, 'NearestRangeKeyIndexMap');
  initMetadataForClass(LazyLayoutMeasureScopeImpl, 'LazyLayoutMeasureScopeImpl', VOID, VOID, [MeasureScope]);
  initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(LazyLayoutNearestRangeState, 'LazyLayoutNearestRangeState');
  initMetadataForInterface(PinnedItem, 'PinnedItem');
  initMetadataForClass(LazyLayoutPinnedItemList, 'LazyLayoutPinnedItemList', LazyLayoutPinnedItemList_init_$Create$, VOID, [KtList]);
  initMetadataForClass(LazyLayoutPinnableItem_0, 'LazyLayoutPinnableItem', VOID, VOID, [PinnedItem]);
  initMetadataForClass(LazyLayoutPinnableItem$$inlined$cache$1$1);
  initMetadataForClass(LazyLayoutPrefetchState, 'LazyLayoutPrefetchState');
  function get_nestedPrefetchItemCount() {
    return -1;
  }
  initMetadataForInterface(NestedPrefetchScope, 'NestedPrefetchScope');
  initMetadataForClass(PrefetchMetrics, 'PrefetchMetrics', PrefetchMetrics);
  initMetadataForClass(HandleAndRequestImpl, 'HandleAndRequestImpl');
  initMetadataForClass(PrefetchHandleProvider, 'PrefetchHandleProvider');
  initMetadataForObject(DummyHandle, 'DummyHandle');
  initMetadataForClass(TraversablePrefetchStateNode, 'TraversablePrefetchStateNode', VOID, Node, [TraversableNode]);
  initMetadataForClass(TraversablePrefetchStateModifierElement, 'TraversablePrefetchStateModifierElement', VOID, ModifierNodeElement);
  initMetadataForLambda(LazyLayoutScrollDeltaBetweenPasses$updateScrollDeltaForApproach$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LazyLayoutScrollDeltaBetweenPasses, 'LazyLayoutScrollDeltaBetweenPasses', LazyLayoutScrollDeltaBetweenPasses);
  initMetadataForClass(ItemFoundInScroll, 'ItemFoundInScroll', VOID, CancellationException);
  initMetadataForCoroutine($animateScrollToItemCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(LazyLayoutSemanticsModifier, 'LazyLayoutSemanticsModifier', VOID, ModifierNodeElement);
  initMetadataForLambda(LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LazyLayoutSemanticsModifierNode, 'LazyLayoutSemanticsModifierNode', VOID, Node, [SemanticsModifierNode]);
  initMetadataForClass(StickyItemsPlacement$Companion$StickToTopPlacement$1);
  initMetadataForCompanion(Companion_10);
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(LazySaveableStateHolder$SaveableStateProvider$$inlined$cache$1$1);
  initMetadataForClass(LazySaveableStateHolder, 'LazySaveableStateHolder', VOID, VOID, [SaveableStateRegistry_0]);
  initMetadataForInterface(PriorityPrefetchScheduler, 'PriorityPrefetchScheduler');
  initMetadataForClass(PagerLazyLayoutItemProvider, 'PagerLazyLayoutItemProvider', VOID, VOID, [LazyLayoutItemProvider]);
  initMetadataForClass(PagerIntervalContent, 'PagerIntervalContent', VOID, VOID, [Interval_1]);
  initMetadataForCoroutine($performFlingCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(PagerWrapperFlingBehavior, 'PagerWrapperFlingBehavior', VOID, VOID, VOID, [2]);
  initMetadataForClass(PagerBringIntoViewSpec, 'PagerBringIntoViewSpec', VOID, VOID, [BringIntoViewSpec]);
  initMetadataForClass(LegacyPagerBringIntoViewSpec, 'LegacyPagerBringIntoViewSpec', VOID, VOID, [BringIntoViewSpec]);
  initMetadataForClass(PagerLayoutIntervalContent, 'PagerLayoutIntervalContent', VOID, LazyLayoutIntervalContent);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(dragDirectionDetector$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(dragDirectionDetector$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(dragDirectionDetector$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LazyLayoutSemanticState$1_0, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(MeasuredPage, 'MeasuredPage');
  initMetadataForObject(Fill, 'Fill');
  initMetadataForObject(PagerDefaults, 'PagerDefaults');
  initMetadataForClass(DefaultPagerNestedScrollConnection, 'DefaultPagerNestedScrollConnection', VOID, VOID, [NestedScrollConnection], [2, 1]);
  initMetadataForLambda(pagerSemantics$performForwardPaging$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(pagerSemantics$performBackwardPaging$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(PagerBeyondBoundsState, 'PagerBeyondBoundsState');
  initMetadataForClass(PagerCacheWindowLogic, 'PagerCacheWindowLogic', VOID, CacheWindowLogic);
  initMetadataForClass(PagerCacheWindowScope, 'PagerCacheWindowScope');
  initMetadataForClass(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_1, 'sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0', VOID, VOID, [LazyLayoutMeasurePolicy, FunctionAdapter]);
  initMetadataForClass(PagerMeasureResult, 'PagerMeasureResult', VOID, VOID, [MeasureResult]);
  initMetadataForObject(PagerScopeImpl, 'PagerScopeImpl');
  initMetadataForClass(PagerScrollPosition, 'PagerScrollPosition');
  initMetadataForClass(LazyLayoutScrollScope$1_0, VOID, VOID, VOID, [LazyLayoutScrollScope_0, ScrollScope]);
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(PagerSnapDistanceMaxPages, 'PagerSnapDistanceMaxPages');
  initMetadataForClass(PagerState$pagerCacheWindow$1, VOID, VOID, VOID, [LazyLayoutCacheWindow]);
  initMetadataForClass(PagerState$_scrollIndicatorState$1);
  initMetadataForClass(PagerState$remeasurementModifier$1, VOID, VOID, VOID, [RemeasurementModifier]);
  initMetadataForLambda(PagerState$scrollToPage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(PagerState$requestScrollToPage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(PagerState$animateScrollToPage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($animateScrollToPageCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($awaitScrollDependenciesCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($scrollCOROUTINE$_1, CoroutineImpl);
  initMetadataForClass(PagerState, 'PagerState', VOID, VOID, [ScrollableState], [2, 3, 0]);
  initMetadataForCompanion(Companion_13);
  initMetadataForClass(DefaultPagerState, 'DefaultPagerState', VOID, PagerState, VOID, [2, 3]);
  initMetadataForClass(UnitDensity$1, VOID, VOID, VOID, [Density]);
  initMetadataForClass(EmptyLayoutInfo$1, VOID, VOID, VOID, [MeasureResult]);
  initMetadataForCoroutine($animateToNextPageCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($animateToPreviousPageCOROUTINE$, CoroutineImpl);
  initMetadataForClass(BringIntoViewRequesterNode, 'BringIntoViewRequesterNode', VOID, Node);
  initMetadataForCoroutine($bringIntoViewCOROUTINE$, CoroutineImpl);
  initMetadataForClass(BringIntoViewRequesterImpl, 'BringIntoViewRequesterImpl', BringIntoViewRequesterImpl, VOID, VOID, [1]);
  initMetadataForClass(BringIntoViewRequesterElement, 'BringIntoViewRequesterElement', VOID, ModifierNodeElement);
  initMetadataForLambda(BringIntoViewResponderNode$bringIntoView$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BringIntoViewResponderNode$bringIntoView$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BringIntoViewResponderNode$bringIntoView$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($bringIntoViewCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(BringIntoViewResponderNode, 'BringIntoViewResponderNode', VOID, Node, [BringIntoViewModifierNode, LayoutAwareModifierNode], [2]);
  initMetadataForClass(SelectableElement, 'SelectableElement', VOID, ModifierNodeElement);
  initMetadataForClass(SelectableNode, 'SelectableNode', VOID, ClickableNode, VOID, [2]);
  initMetadataForClass(TriStateToggleableElement, 'TriStateToggleableElement', VOID, ModifierNodeElement);
  initMetadataForClass(TriStateToggleableNode, 'TriStateToggleableNode', VOID, ClickableNode, VOID, [2]);
  initMetadataForClass(CornerBasedShape, 'CornerBasedShape', VOID, VOID, [Shape, Interpolatable]);
  initMetadataForClass(PercentCornerSize, 'PercentCornerSize');
  initMetadataForClass(DpCornerSize, 'DpCornerSize');
  initMetadataForClass(PxCornerSize, 'PxCornerSize');
  initMetadataForClass(ZeroCornerSize$1);
  initMetadataForClass(RoundedCornerShape, 'RoundedCornerShape', VOID, CornerBasedShape);
  initMetadataForClass(lerp$1);
  initMetadataForClass(ResolvedStyle, 'ResolvedStyle', VOID, VOID, [Density]);
  initMetadataForInterface(Style, 'Style');
  initMetadataForClass(sam$androidx_compose_foundation_style_Style$0, 'sam$androidx_compose_foundation_style_Style$0', VOID, VOID, [Style, FunctionAdapter]);
  initMetadataForClass(StyleOuterNode, 'StyleOuterNode', VOID, DelegatingNode, [LayoutModifierNode, DrawModifierNode, TraversableNode, CompositionLocalConsumerModifierNode, DelegatableNode]);
  initMetadataForClass(sam$androidx_compose_ui_layout_MeasurePolicy$0_0, 'sam$androidx_compose_ui_layout_MeasurePolicy$0', VOID, VOID, [MeasurePolicy, FunctionAdapter]);
  initMetadataForObject(EmptyMeasurePolicy, 'EmptyMeasurePolicy', VOID, VOID, [MeasurePolicy]);
  initMetadataForClass(LinksTextMeasurePolicy, 'LinksTextMeasurePolicy', VOID, VOID, [MeasurePolicy]);
  initMetadataForClass(TextMeasurePolicy, 'TextMeasurePolicy', VOID, VOID, [MeasurePolicy]);
  initMetadataForObject(ComposableSingletons$BasicTextFieldKt, 'ComposableSingletons$BasicTextFieldKt');
  initMetadataForInterface(TextFieldDecorator, 'TextFieldDecorator');
  initMetadataForClass(sam$androidx_compose_foundation_text_input_TextFieldDecorator$0, 'sam$androidx_compose_foundation_text_input_TextFieldDecorator$0', VOID, VOID, [TextFieldDecorator, FunctionAdapter]);
  initMetadataForClass(TextContextMenuItems, 'TextContextMenuItems', VOID, Enum);
  initMetadataForCompanion(Companion_14);
  initMetadataForClass(MenuItemsAvailability, 'MenuItemsAvailability');
  initMetadataForLambda(CommonContextMenuArea$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($getContextMenuItemsAvailabilityCOROUTINE$, CoroutineImpl);
  initMetadataForObject(ComposableSingletons$CoreTextFieldKt, 'ComposableSingletons$CoreTextFieldKt');
  initMetadataForClass(LegacyTextFieldState, 'LegacyTextFieldState');
  initMetadataForClass(HandleState, 'HandleState', VOID, Enum);
  initMetadataForClass(Handle, 'Handle', VOID, Enum);
  initMetadataForInterface(OffsetProvider, 'OffsetProvider');
  initMetadataForClass(sam$androidx_compose_foundation_text_selection_OffsetProvider$0, 'sam$androidx_compose_foundation_text_selection_OffsetProvider$0', VOID, VOID, [OffsetProvider, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForClass(CoreTextField$$inlined$rememberClipboardEventsHandler$4$4);
  initMetadataForLambda(CoreTextField$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_2, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(CoreTextField$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CoreTextField$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CoreTextField$$inlined$cache$6$1);
  initMetadataForClass(CoreTextField$$inlined$cache$7$1);
  initMetadataForClass(CoreTextField$4, VOID, VOID, VOID, [MeasurePolicy]);
  initMetadataForLambda(TextFieldCursorHandle$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TextFieldCursorHandle$slambda$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TextFieldCursorHandle$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TextFieldCursorHandle$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(HeightInLinesElement, 'HeightInLinesElement', VOID, ModifierNodeElement);
  initMetadataForClass(HeightInLinesNode, 'HeightInLinesNode', VOID, Node, [CompositionLocalConsumerModifierNode, LayoutModifierNode, DelegatableNode]);
  initMetadataForClass(KeyCommand, 'KeyCommand', VOID, Enum);
  initMetadataForClass(defaultKeyMapping$1);
  initMetadataForClass(commonKeyMapping$1);
  initMetadataForCompanion(Companion_15);
  initMetadataForClass(KeyboardActionRunner, 'KeyboardActionRunner');
  initMetadataForCompanion(Companion_16);
  initMetadataForClass(KeyboardActions, 'KeyboardActions', KeyboardActions);
  initMetadataForCompanion(Companion_17);
  initMetadataForClass(KeyboardOptions, 'KeyboardOptions');
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_3, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(LinkStateInteractionSourceObserver$collectInteractionsForLinks$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LinkStateInteractionSourceObserver, 'LinkStateInteractionSourceObserver', VOID, VOID, VOID, [0]);
  initMetadataForLambda(detectDownAndDragGesturesWithObserver$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(detectDownAndDragGesturesWithObserver$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(detectDownAndDragGesturesWithObserver$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(detectPreDragGesturesWithObserver$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($detectDownAndDragGesturesWithObserverCOROUTINE$, CoroutineImpl);
  initMetadataForCompanion(Companion_18);
  initMetadataForClass(TextDelegate, 'TextDelegate');
  initMetadataForLambda(cursor$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_19);
  initMetadataForClass(TextFieldKeyInput, 'TextFieldKeyInput');
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(defaultTextFieldPointer$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForClass(tapPressTextFieldModifier$1$$inlined$cache$1$1);
  initMetadataForLambda(tapPressTextFieldModifier$lambda$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(tapPressTextFieldModifier$lambda$slambda$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(tapPressTextFieldModifier$lambda$slambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(tapPressTextFieldModifier$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_20);
  initMetadataForClass(TextFieldScrollerPosition, 'TextFieldScrollerPosition', TextFieldScrollerPosition_init_$Create$);
  initMetadataForClass(VerticalScrollLayoutModifier, 'VerticalScrollLayoutModifier', VOID, VOID, [LayoutModifier]);
  initMetadataForClass(HorizontalScrollLayoutModifier, 'HorizontalScrollLayoutModifier', VOID, VOID, [LayoutModifier]);
  initMetadataForClass(textFieldScrollable$1$wrappedScrollableState$1, VOID, VOID, VOID, [ScrollableState], [2]);
  initMetadataForClass(TextFieldSizeElement, 'TextFieldSizeElement', VOID, ModifierNodeElement);
  initMetadataForClass(TextFieldSizeNode, 'TextFieldSizeNode', VOID, Node, [CompositionLocalConsumerModifierNode, LayoutModifierNode]);
  initMetadataForClass(LegacyTextFieldSize, 'LegacyTextFieldSize');
  initMetadataForClass(TextFieldSize, 'TextFieldSize');
  initMetadataForClass(TextLayoutResultProxy, 'TextLayoutResultProxy');
  initMetadataForInterface(TextRangeScopeMeasurePolicy, 'TextRangeScopeMeasurePolicy');
  initMetadataForClass(sam$androidx_compose_foundation_text_TextRangeScopeMeasurePolicy$0, 'sam$androidx_compose_foundation_text_TextRangeScopeMeasurePolicy$0', VOID, VOID, [TextRangeScopeMeasurePolicy, FunctionAdapter]);
  initMetadataForClass(TextLinkScope$shapeForRange$1, VOID, VOID, VOID, [Shape]);
  initMetadataForLambda(TextLinkScope$LinksComposables$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TextLinkScope$StyleAnnotation$$inlined$cache$1$1);
  initMetadataForClass(TextLinkScope, 'TextLinkScope');
  initMetadataForClass(TextRangeLayoutModifier, 'TextRangeLayoutModifier', VOID, VOID, [ParentDataModifier]);
  initMetadataForClass(TextRangeLayoutMeasureScope, 'TextRangeLayoutMeasureScope', TextRangeLayoutMeasureScope);
  initMetadataForClass(TextRangeLayoutMeasureResult, 'TextRangeLayoutMeasureResult');
  initMetadataForClass(TextAnnotatorScope, 'TextAnnotatorScope');
  initMetadataForClass(Entry, 'Entry');
  initMetadataForClass(UndoManager, 'UndoManager', UndoManager);
  initMetadataForClass(ValidatingOffsetMapping, 'ValidatingOffsetMapping');
  initMetadataForClass(TextContextMenuBuilderScope, 'TextContextMenuBuilderScope');
  initMetadataForCompanion(Companion_21);
  initMetadataForClass(TextContextMenuData, 'TextContextMenuData');
  initMetadataForClass(TextContextMenuComponent, 'TextContextMenuComponent');
  initMetadataForObject(TextContextMenuKeys, 'TextContextMenuKeys');
  initMetadataForObject(TextContextMenuSeparator, 'TextContextMenuSeparator', VOID, TextContextMenuComponent);
  initMetadataForLambda(onRightClickDown$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($awaitFirstRightClickDownCOROUTINE$, CoroutineImpl);
  initMetadataForClass(TextContextMenuGestureElement, 'TextContextMenuGestureElement', VOID, ModifierNodeElement);
  initMetadataForCompanion(Companion_22);
  initMetadataForClass(ClickTextContextMenuDataProvider, 'ClickTextContextMenuDataProvider');
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(TextContextMenuGestureNode$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TextContextMenuGestureNode$tryShowContextMenu$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TextContextMenuGestureNode, 'TextContextMenuGestureNode', VOID, DelegatingNode, [CompositionLocalConsumerModifierNode, GlobalPositionAwareModifierNode]);
  initMetadataForClass(AddTextContextMenuDataComponentsElement, 'AddTextContextMenuDataComponentsElement', VOID, ModifierNodeElement);
  initMetadataForObject(TextContextMenuDataTraverseKey, 'TextContextMenuDataTraverseKey');
  initMetadataForClass(AddTextContextMenuDataComponentsNode, 'AddTextContextMenuDataComponentsNode', VOID, Node, [TraversableNode]);
  initMetadataForClass(FilterTextContextMenuDataComponentsNode, 'FilterTextContextMenuDataComponentsNode', VOID, Node, [TraversableNode]);
  initMetadataForClass(ToolbarRequester, 'ToolbarRequester');
  initMetadataForClass(ToolbarRequesterImpl, 'ToolbarRequesterImpl', ToolbarRequesterImpl, ToolbarRequester);
  initMetadataForLambda(TextContextMenuToolbarHandlerNode$show$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TextContextMenuToolbarHandlerNode, 'TextContextMenuToolbarHandlerNode', VOID, DelegatingNode, [CompositionLocalConsumerModifierNode]);
  initMetadataForClass(ToolbarHandlerState, 'ToolbarHandlerState', VOID, Enum);
  initMetadataForClass(TextContextMenuToolbarHandlerElement, 'TextContextMenuToolbarHandlerElement', VOID, ModifierNodeElement);
  initMetadataForClass(SessionImpl, 'SessionImpl', VOID, VOID, VOID, [0]);
  initMetadataForLambda(BasicTextContextMenuProvider$showTextContextMenu$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(BasicTextContextMenuProvider, 'BasicTextContextMenuProvider', VOID, VOID, VOID, [1]);
  initMetadataForClass(basicTextContextMenuProvider$$inlined$cache$1$1);
  initMetadataForClass(StylusHandwritingElement, 'StylusHandwritingElement', VOID, ModifierNodeElement);
  initMetadataForLambda(StylusHandwritingNode$suspendingPointerInputModifierNode$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(StylusHandwritingNode$suspendingPointerInputModifierNode$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(StylusHandwritingNode, 'StylusHandwritingNode', VOID, DelegatingNode, [PointerInputModifierNode, FocusEventModifierNode, DelegatableNode]);
  initMetadataForClass(CoreTextFieldSemanticsModifier, 'CoreTextFieldSemanticsModifier', VOID, ModifierNodeElement);
  initMetadataForClass(CoreTextFieldSemanticsModifierNode, 'CoreTextFieldSemanticsModifierNode', VOID, DelegatingNode, [SemanticsModifierNode]);
  initMetadataForLambda(CursorAnimationState$snapToVisibleAndAnimate$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CursorAnimationState$snapToVisibleAndAnimate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($snapToVisibleAndAnimateCOROUTINE$, CoroutineImpl);
  initMetadataForClass(CursorAnimationState, 'CursorAnimationState', VOID, VOID, VOID, [0]);
  initMetadataForClass(LegacyAdaptingPlatformTextInputModifier, 'LegacyAdaptingPlatformTextInputModifier', VOID, ModifierNodeElement);
  initMetadataForLambda(LegacyAdaptingPlatformTextInputModifierNode$launchTextInputSession$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LegacyAdaptingPlatformTextInputModifierNode, 'LegacyAdaptingPlatformTextInputModifierNode', VOID, Node, [DelegatableNode, CompositionLocalConsumerModifierNode, GlobalPositionAwareModifierNode]);
  initMetadataForClass(LegacyPlatformTextInputServiceAdapter, 'LegacyPlatformTextInputServiceAdapter', VOID, VOID, [PlatformTextInputService]);
  initMetadataForCompanion(Companion_23);
  initMetadataForClass(InlineDensity, 'InlineDensity');
  initMetadataForCompanion(Companion_24);
  initMetadataForClass(MinLinesConstrainer, 'MinLinesConstrainer');
  initMetadataForClass(TextAutoSizeLayoutScopeImpl, 'TextAutoSizeLayoutScopeImpl', VOID, VOID, [Density]);
  initMetadataForClass(MultiParagraphLayoutCache, 'MultiParagraphLayoutCache');
  initMetadataForClass(ParagraphLayoutCache, 'ParagraphLayoutCache');
  initMetadataForCompanion(Companion_25);
  initMetadataForClass(SelectableTextAnnotatedStringElement, 'SelectableTextAnnotatedStringElement', VOID, ModifierNodeElement);
  initMetadataForClass(SelectableTextAnnotatedStringNode, 'SelectableTextAnnotatedStringNode', VOID, DelegatingNode, [LayoutModifierNode, DrawModifierNode, GlobalPositionAwareModifierNode]);
  initMetadataForClass(SelectionController, 'SelectionController', VOID, VOID, [RememberObserver]);
  initMetadataForCompanion(Companion_26);
  initMetadataForClass(StaticTextSelectionParams, 'StaticTextSelectionParams');
  initMetadataForClass(TextAnnotatedStringElement, 'TextAnnotatedStringElement', VOID, ModifierNodeElement);
  initMetadataForClass(TextSubstitutionValue, 'TextSubstitutionValue');
  initMetadataForClass(TextAnnotatedStringNode, 'TextAnnotatedStringNode', VOID, Node, [LayoutModifierNode, DrawModifierNode, SemanticsModifierNode]);
  initMetadataForClass(TextStringSimpleElement, 'TextStringSimpleElement', VOID, ModifierNodeElement);
  initMetadataForClass(TextSubstitutionValue_0, 'TextSubstitutionValue');
  initMetadataForClass(TextStringSimpleNode, 'TextStringSimpleNode', VOID, Node, [LayoutModifierNode, DrawModifierNode, SemanticsModifierNode]);
  initMetadataForCompanion(Companion_27);
  initMetadataForClass(MultiWidgetSelectionDelegate, 'MultiWidgetSelectionDelegate');
  initMetadataForClass(SelectedTextType, 'SelectedTextType', VOID, Enum);
  initMetadataForClass(AnchorInfo, 'AnchorInfo');
  initMetadataForClass(Selection, 'Selection');
  initMetadataForInterface(SelectionAdjustment, 'SelectionAdjustment');
  initMetadataForClass(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0, 'sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0', VOID, VOID, [SelectionAdjustment, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_0, 'sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0', VOID, VOID, [SelectionAdjustment, FunctionAdapter]);
  initMetadataForInterface(BoundaryFunction, 'BoundaryFunction');
  initMetadataForClass(sam$androidx_compose_foundation_text_selection_BoundaryFunction$0, 'sam$androidx_compose_foundation_text_selection_BoundaryFunction$0', VOID, VOID, [BoundaryFunction, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_1, 'sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0', VOID, VOID, [SelectionAdjustment, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_foundation_text_selection_BoundaryFunction$0_0, 'sam$androidx_compose_foundation_text_selection_BoundaryFunction$0', VOID, VOID, [BoundaryFunction, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_2, 'sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0', VOID, VOID, [SelectionAdjustment, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_3, 'sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0', VOID, VOID, [SelectionAdjustment, FunctionAdapter]);
  initMetadataForCompanion(Companion_28);
  initMetadataForClass(ClicksCounter, 'ClicksCounter');
  initMetadataForClass(DownResolution, 'DownResolution', VOID, Enum);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_7, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(awaitSelectionGestures$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(updateSelectionTouchMode$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(updateSelectionTouchMode$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(touchSelectionSubsequentPress$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($awaitDownCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($mouseSelectionCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($touchSelectionFirstPressCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($touchSelectionSubsequentPressCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SelectionHandleInfo, 'SelectionHandleInfo');
  initMetadataForClass(SelectionHandleAnchor, 'SelectionHandleAnchor', VOID, Enum);
  initMetadataForClass(HandlePositionProvider, 'HandlePositionProvider');
  initMetadataForClass(SelectableInfo, 'SelectableInfo');
  initMetadataForClass(CrossStatus, 'CrossStatus', VOID, Enum);
  initMetadataForCompanion(Companion_29);
  initMetadataForClass(SingleSelectionLayout, 'SingleSelectionLayout');
  initMetadataForClass(sam$androidx_compose_ui_layout_MeasurePolicy$0_1, 'sam$androidx_compose_ui_layout_MeasurePolicy$0', VOID, VOID, [MeasurePolicy, FunctionAdapter]);
  initMetadataForLambda(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_1, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_3, CoroutineImpl, VOID, [0]);
  initMetadataForClass(TextFieldSelectionManager$touchSelectionObserver$1);
  initMetadataForClass(TextFieldSelectionManager$mouseSelectionObserver$1);
  initMetadataForLambda(TextFieldSelectionManager$maybeSuggestSelection$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TextFieldSelectionManager$handleDragObserver$1);
  initMetadataForClass(TextFieldSelectionManager$cursorDragObserver$1);
  initMetadataForLambda(TextFieldSelectionManager$copy$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TextFieldSelectionManager$paste$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TextFieldSelectionManager$cut$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($updateClipboardEntryCOROUTINE$, CoroutineImpl);
  initMetadataForClass(TextFieldSelectionManager, 'TextFieldSelectionManager', TextFieldSelectionManager, VOID, VOID, [0]);
  initMetadataForClass(sam$androidx_compose_foundation_text_selection_OffsetProvider$0_0, 'sam$androidx_compose_foundation_text_selection_OffsetProvider$0', VOID, VOID, [OffsetProvider, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_8, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(TextFieldSelectionHandle$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TextPreparedSelectionState, 'TextPreparedSelectionState', TextPreparedSelectionState);
  initMetadataForClass(BaseTextPreparedSelection, 'BaseTextPreparedSelection');
  initMetadataForClass(TextFieldPreparedSelection, 'TextFieldPreparedSelection', VOID, BaseTextPreparedSelection);
  initMetadataForCompanion(Companion_30);
  initMetadataForClass(TextSelectionColors, 'TextSelectionColors');
  initMetadataForCoroutine($readTextCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readAnnotatedStringCOROUTINE$, CoroutineImpl);
  initMetadataForClass(AtomicReference, 'AtomicReference');
  initMetadataForClass(ContextMenuColors_0, 'ContextMenuColors');
  initMetadataForClass(InputModeFilterIndicationNodeFactory$create$1, VOID, VOID, DelegatingNode, [CompositionLocalConsumerModifierNode]);
  initMetadataForClass(InputModeFilterIndicationNodeFactory, 'InputModeFilterIndicationNodeFactory', VOID, VOID, [IndicationNodeFactory]);
  initMetadataForClass(InputModeFilterIndication, 'InputModeFilterIndication', VOID, VOID, [Indication]);
  initMetadataForLambda(InputModeFilterInteractionSource$interactions$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_4, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(InputModeFilterInteractionSource$interactions$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(InputModeFilterInteractionSource, 'InputModeFilterInteractionSource');
  initMetadataForClass(rememberDefaultPrefetchScheduler$1);
  initMetadataForClass(SynchronizedObject, 'SynchronizedObject', SynchronizedObject);
  initMetadataForCompanion(Companion_31);
  initMetadataForCompanion(Companion_32);
  initMetadataForClass(ContextMenuStrings, 'ContextMenuStrings');
  initMetadataForObject(Translations, 'Translations');
  initMetadataForLambda(localeTagChain$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DeadKeyCombiner, 'DeadKeyCombiner', DeadKeyCombiner);
  initMetadataForObject(DefaultSkikoKeyMapping, 'DefaultSkikoKeyMapping');
  initMetadataForClass(createMacOsDefaultKeyMapping$1);
  initMetadataForClass(createWindowsDefaultKeyMapping$1);
  initMetadataForLambda(codePointsAt$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TextContextMenuItemWithComposableLeadingIcon, 'TextContextMenuItemWithComposableLeadingIcon', VOID, TextContextMenuComponent);
  initMetadataForObject(ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt, 'ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt');
  initMetadataForClass(MaintainWindowPositionPopupPositionProvider, 'MaintainWindowPositionPopupPositionProvider');
  initMetadataForLambda(createLegacyPlatformTextInputServiceAdapter$o$startInput$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(createLegacyPlatformTextInputServiceAdapter$1$makeRequest$textEditorState$1, VOID, VOID, VOID, [CharSequence]);
  initMetadataForClass(createLegacyPlatformTextInputServiceAdapter$1, VOID, VOID, LegacyPlatformTextInputServiceAdapter);
  initMetadataForClass(TextEditingScope$1);
  initMetadataForClass(SkikoPlatformTextInputMethodRequest, 'SkikoPlatformTextInputMethodRequest');
  initMetadataForClass(SkikoSelectionModifierElement, 'SkikoSelectionModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_9, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(SkikoSelectionModifierNode$pointerInputNode$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(SkikoSelectionModifierNode$longPressDragObserver$1);
  initMetadataForLambda(SkikoSelectionModifierNode$bringIntoView$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(SkikoSelectionModifierNode, 'SkikoSelectionModifierNode', VOID, DelegatingNode);
  initMetadataForClass(skikoMouseSelectionObserver$1);
  initMetadataForClass(SkikoSelectionHandle$1, VOID, VOID, VOID, [OffsetProvider]);
  initMetadataForObject(JsConfig, 'JsConfig', VOID, VOID, [ScrollConfig]);
  initMetadataForClass(DefaultLazyKey, 'DefaultLazyKey');
  initMetadataForClass(createPlatformDefaultKeyMapping$1);
  initMetadataForObject(WebContextMenuToolbarSpec, 'WebContextMenuToolbarSpec');
  initMetadataForObject(ComposableSingletons$WebContextMenuToolbarUi_webKt, 'ComposableSingletons$WebContextMenuToolbarUi_webKt');
  initMetadataForClass(sam$androidx_compose_ui_layout_MeasurePolicy$0_2, 'sam$androidx_compose_ui_layout_MeasurePolicy$0', VOID, VOID, [MeasurePolicy, FunctionAdapter]);
  initMetadataForObject(ComposableSingletons$WebTextContextMenuToolbarProvider_webKt, 'ComposableSingletons$WebTextContextMenuToolbarProvider_webKt');
  initMetadataForLambda(addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(addBasicTextFieldTextContextMenuComponents$lambda$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(addBasicTextFieldTextContextMenuComponents$lambda$slambda_1, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(addBasicTextFieldTextContextMenuComponents$lambda$slambda_3, CoroutineImpl, VOID, [0]);
  //endregion
  function background(_this__u8e3s4, color, shape) {
    shape = shape === VOID ? get_RectangleShape() : shape;
    var alpha = 1.0;
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = background$lambda(color, shape);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp0_inspectorInfo = tmp;
    return _this__u8e3s4.d8v(new BackgroundElement(color, VOID, alpha, shape, tmp0_inspectorInfo));
  }
  function BackgroundElement(color, brush, alpha, shape, inspectorInfo) {
    color = color === VOID ? Companion_getInstance().u6b_1 : color;
    brush = brush === VOID ? null : brush;
    ModifierNodeElement.call(this);
    this.dfa_1 = color;
    this.efa_1 = brush;
    this.ffa_1 = alpha;
    this.gfa_1 = shape;
    this.hfa_1 = inspectorInfo;
  }
  protoOf(BackgroundElement).r3d = function () {
    return new BackgroundNode(this.dfa_1, this.efa_1, this.ffa_1, this.gfa_1);
  };
  protoOf(BackgroundElement).ifa = function (node) {
    node.xfa_1 = this.dfa_1;
    node.yfa_1 = this.efa_1;
    node.zfa_1 = this.ffa_1;
    if (!equals(node.afb_1, this.gfa_1)) {
      node.afb_1 = this.gfa_1;
      invalidateSemantics(node);
    }
    invalidateDraw(node);
  };
  protoOf(BackgroundElement).d8y = function (node) {
    return this.ifa(node instanceof BackgroundNode ? node : THROW_CCE());
  };
  protoOf(BackgroundElement).hashCode = function () {
    var result = Color__hashCode_impl_vjyivj(this.dfa_1);
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.efa_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + getNumberHashCode(this.ffa_1) | 0;
    result = imul(31, result) + hashCode(this.gfa_1) | 0;
    return result;
  };
  protoOf(BackgroundElement).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof BackgroundElement ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otherModifier = tmp;
    return equals(this.dfa_1, otherModifier.dfa_1) && equals(this.efa_1, otherModifier.efa_1) && this.ffa_1 === otherModifier.ffa_1 && equals(this.gfa_1, otherModifier.gfa_1);
  };
  function drawRect($this, $receiver) {
    if (!equals($this.xfa_1, Companion_getInstance().u6b_1)) {
      $receiver.b6q($this.xfa_1);
    }
    var tmp0_safe_receiver = $this.yfa_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $receiver.a6q(tmp0_safe_receiver, VOID, VOID, $this.zfa_1);
    }
  }
  function drawOutline_1($this, $receiver) {
    var outline = getOutline($this, $receiver);
    if (!equals($this.xfa_1, Companion_getInstance().u6b_1)) {
      drawOutline($receiver, outline, $this.xfa_1);
    }
    var tmp0_safe_receiver = $this.yfa_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      drawOutline_0($receiver, outline, tmp0_safe_receiver, $this.zfa_1);
    }
  }
  function getOutline($this, $receiver) {
    var outline;
    if (equals($receiver.o5d(), $this.dfb_1) && $receiver.r6p().equals($this.efb_1) && equals($this.gfb_1, $this.afb_1)) {
      outline = ensureNotNull($this.ffb_1);
    } else {
      observeReads($this, BackgroundNode$getOutline$lambda($this, $receiver));
      outline = $this.hfb_1;
      $this.hfb_1 = null;
    }
    $this.ffb_1 = outline;
    $this.dfb_1 = $receiver.o5d();
    $this.efb_1 = $receiver.r6p();
    $this.gfb_1 = $this.afb_1;
    return ensureNotNull(outline);
  }
  function BackgroundNode$getOutline$lambda(this$0, $this_getOutline) {
    return function () {
      this$0.hfb_1 = this$0.afb_1.l6j($this_getOutline.o5d(), $this_getOutline.r6p(), $this_getOutline);
      return Unit_instance;
    };
  }
  function BackgroundNode(color, brush, alpha, shape) {
    Node.call(this);
    this.xfa_1 = color;
    this.yfa_1 = brush;
    this.zfa_1 = alpha;
    this.afb_1 = shape;
    this.bfb_1 = false;
    this.cfb_1 = false;
    this.dfb_1 = Companion_getInstance_0().k5e_1;
    this.efb_1 = null;
    this.ffb_1 = null;
    this.gfb_1 = null;
    this.hfb_1 = null;
  }
  protoOf(BackgroundNode).b8w = function () {
    return this.bfb_1;
  };
  protoOf(BackgroundNode).k9i = function () {
    return this.cfb_1;
  };
  protoOf(BackgroundNode).h92 = function (_this__u8e3s4) {
    if (this.afb_1 === get_RectangleShape()) {
      drawRect(this, _this__u8e3s4);
    } else {
      drawOutline_1(this, _this__u8e3s4);
    }
    _this__u8e3s4.z91();
  };
  protoOf(BackgroundNode).w95 = function () {
    this.dfb_1 = Companion_getInstance_0().k5e_1;
    this.efb_1 = null;
    this.ffb_1 = null;
    this.gfb_1 = null;
    invalidateDraw(this);
  };
  protoOf(BackgroundNode).l9i = function (_this__u8e3s4) {
    set_shape(_this__u8e3s4, this.afb_1);
  };
  function background_0(_this__u8e3s4, brush, shape, alpha) {
    shape = shape === VOID ? get_RectangleShape() : shape;
    alpha = alpha === VOID ? 1.0 : alpha;
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = background$lambda_0(alpha, brush, shape);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new BackgroundElement(VOID, brush, alpha, shape, tmp$ret$0));
  }
  function background$lambda($color, $shape) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'background';
      _this__u8e3s4.ldp_1 = new Color($color);
      _this__u8e3s4.mdp_1.odp('color', new Color($color));
      _this__u8e3s4.mdp_1.odp('shape', $shape);
      return Unit_instance;
    };
  }
  function background$lambda_0($alpha, $brush, $shape) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'background';
      _this__u8e3s4.mdp_1.odp('alpha', $alpha);
      _this__u8e3s4.mdp_1.odp('brush', $brush);
      _this__u8e3s4.mdp_1.odp('shape', $shape);
      return Unit_instance;
    };
  }
  var androidx_compose_foundation_MarqueeDefaults$stable;
  var androidx_compose_foundation_BasicTooltipDefaults$stable;
  var androidx_compose_foundation_BorderModifierNodeElement$stable;
  var androidx_compose_foundation_BorderModifierNode$stable;
  function border(_this__u8e3s4, border, shape) {
    shape = shape === VOID ? get_RectangleShape() : shape;
    return border_0(_this__u8e3s4, border.ifb_1, border.jfb_1, shape);
  }
  function border_0(_this__u8e3s4, width, brush, shape) {
    return _this__u8e3s4.d8v(new BorderModifierNodeElement(width, brush, shape));
  }
  function BorderModifierNodeElement(width, brush, shape) {
    ModifierNodeElement.call(this);
    this.lfb_1 = width;
    this.mfb_1 = brush;
    this.nfb_1 = shape;
  }
  protoOf(BorderModifierNodeElement).r3d = function () {
    return new BorderModifierNode(this.lfb_1, this.mfb_1, this.nfb_1);
  };
  protoOf(BorderModifierNodeElement).ofb = function (node) {
    node.mfc(this.lfb_1);
    node.nfc(this.mfb_1);
    node.l98(this.nfb_1);
  };
  protoOf(BorderModifierNodeElement).d8y = function (node) {
    return this.ofb(node instanceof BorderModifierNode ? node : THROW_CCE());
  };
  protoOf(BorderModifierNodeElement).toString = function () {
    return 'BorderModifierNodeElement(width=' + Dp__toString_impl_kcddez(this.lfb_1) + ', brush=' + toString(this.mfb_1) + ', shape=' + toString(this.nfb_1) + ')';
  };
  protoOf(BorderModifierNodeElement).hashCode = function () {
    var result = Dp__hashCode_impl_sxkrra(this.lfb_1);
    result = imul(result, 31) + hashCode(this.mfb_1) | 0;
    result = imul(result, 31) + hashCode(this.nfb_1) | 0;
    return result;
  };
  protoOf(BorderModifierNodeElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BorderModifierNodeElement))
      return false;
    if (!equals(this.lfb_1, other.lfb_1))
      return false;
    if (!equals(this.mfb_1, other.mfb_1))
      return false;
    if (!equals(this.nfb_1, other.nfb_1))
      return false;
    return true;
  };
  function drawGenericBorder($this, $receiver, brush, outline, fillArea, strokeWidth) {
    var tmp;
    if (fillArea) {
      tmp = $receiver.f92(BorderModifierNode$drawGenericBorder$lambda(outline, brush));
    } else {
      var config;
      var colorFilter;
      if (brush instanceof SolidColor) {
        config = Companion_getInstance_1().y6g_1;
        colorFilter = Companion_instance.i6g(Color__copy$default_impl_ectz3s(brush.d6b_1, 1.0));
      } else {
        config = Companion_getInstance_1().x6g_1;
        colorFilter = null;
      }
      var pathBounds = outline.w6h_1.a6j();
      if ($this.hfc_1 == null) {
        $this.hfc_1 = new BorderCache();
      }
      // Inline function 'kotlin.apply' call
      var this_0 = ensureNotNull($this.hfc_1).sfc();
      this_0.u4c();
      this_0.d6i(pathBounds);
      this_0.b6j(this_0, outline.w6h_1, Companion_getInstance_2().d6j_1);
      var maskPath = this_0;
      var cacheImageBitmap;
      // Inline function 'androidx.compose.ui.geometry.Rect.width' call
      // Inline function 'kotlin.math.ceil' call
      var x = pathBounds.m5d_1 - pathBounds.k5d_1;
      var tmp$ret$3 = Math.ceil(x);
      var tmp0 = numberToInt(tmp$ret$3);
      // Inline function 'androidx.compose.ui.geometry.Rect.height' call
      // Inline function 'kotlin.math.ceil' call
      var x_0 = pathBounds.n5d_1 - pathBounds.l5d_1;
      var tmp$ret$5 = Math.ceil(x_0);
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = numberToInt(tmp$ret$5);
      var tmp$ret$7 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var pathBoundsSize = _IntSize___init__impl__emcjft(tmp$ret$7);
      // Inline function 'kotlin.with' call
      var tmp0_0 = ensureNotNull($this.hfc_1);
      // Inline function 'androidx.compose.foundation.BorderCache.drawBorderCache' call
      var config_0 = config;
      var targetImageBitmap = tmp0_0.ofc_1;
      var targetCanvas = tmp0_0.pfc_1;
      var tmp_0;
      var tmp0_safe_receiver = targetImageBitmap;
      var tmp_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v6g();
      if (equals(tmp_1 == null ? null : new ImageBitmapConfig(tmp_1), new ImageBitmapConfig(Companion_getInstance_1().x6g_1))) {
        tmp_0 = true;
      } else {
        var tmp1_safe_receiver = targetImageBitmap;
        var tmp_2 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.v6g();
        tmp_0 = equals(new ImageBitmapConfig(config_0), tmp_2 == null ? null : new ImageBitmapConfig(tmp_2));
      }
      var compatibleConfig = tmp_0;
      var tmp_3;
      var tmp_4;
      var tmp_5;
      if (targetImageBitmap == null || targetCanvas == null) {
        tmp_5 = true;
      } else {
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        var this_1 = $receiver.o5d();
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value = _Size___get_packedValue__impl__7rlt1o(this_1);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value, 32));
        tmp_5 = floatFromBits(bits) > targetImageBitmap.h5e();
      }
      if (tmp_5) {
        tmp_4 = true;
      } else {
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        var this_2 = $receiver.o5d();
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_0 = _Size___get_packedValue__impl__7rlt1o(this_2);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        tmp_4 = floatFromBits(bits_0) > targetImageBitmap.i5e();
      }
      if (tmp_4) {
        tmp_3 = true;
      } else {
        tmp_3 = !compatibleConfig;
      }
      if (tmp_3) {
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call
        // Inline function 'androidx.compose.ui.util.unpackInt1' call
        var value_1 = _IntSize___get_packedValue__impl__uho7jf(pathBoundsSize);
        var tmp_6 = convertToInt(shiftRight(value_1, 32));
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_2 = _IntSize___get_packedValue__impl__uho7jf(pathBoundsSize);
        var tmp$ret$21 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
        // Inline function 'kotlin.also' call
        var this_3 = ImageBitmap(tmp_6, tmp$ret$21, config_0);
        tmp0_0.ofc_1 = this_3;
        targetImageBitmap = this_3;
        // Inline function 'kotlin.also' call
        var this_4 = Canvas(targetImageBitmap);
        tmp0_0.pfc_1 = this_4;
        targetCanvas = this_4;
      }
      var tmp2_elvis_lhs = tmp0_0.qfc_1;
      var tmp_7;
      if (tmp2_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_5 = new CanvasDrawScope();
        tmp0_0.qfc_1 = this_5;
        tmp_7 = this_5;
      } else {
        tmp_7 = tmp2_elvis_lhs;
      }
      var targetDrawScope = tmp_7;
      var drawSize = toSize(pathBoundsSize);
      var tmp4 = $receiver.r6p();
      // Inline function 'androidx.compose.ui.graphics.drawscope.CanvasDrawScope.draw' call
      var canvas = targetCanvas;
      var _destruct__k2r9zo = targetDrawScope.h6o_1;
      var prevDensity = _destruct__k2r9zo.zh();
      var prevLayoutDirection = _destruct__k2r9zo.ai();
      var prevCanvas = _destruct__k2r9zo.hr();
      var prevSize = _destruct__k2r9zo.j6p();
      // Inline function 'kotlin.apply' call
      var this_6 = targetDrawScope.h6o_1;
      this_6.f6p_1 = $receiver;
      this_6.g6p_1 = tmp4;
      this_6.h6p_1 = canvas;
      this_6.i6p_1 = drawSize;
      canvas.t6d();
      targetDrawScope.b6q(Companion_getInstance().i6b_1, VOID, drawSize, VOID, VOID, VOID, Companion_getInstance_3().y69_1);
      var tmp2 = -pathBounds.k5d_1;
      // Inline function 'androidx.compose.ui.graphics.drawscope.translate' call
      var top = -pathBounds.l5d_1;
      targetDrawScope.v6p().p6p().b5d(tmp2, top);
      try {
        targetDrawScope.l6q(outline.w6h_1, brush, VOID, new Stroke(strokeWidth * 2));
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        var this_7 = targetDrawScope.o5d();
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value_3 = _Size___get_packedValue__impl__7rlt1o(this_7);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_1 = convertToInt(shiftRight(value_3, 32));
        var tmp_8 = floatFromBits(bits_1) + 1;
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        var this_8 = targetDrawScope.o5d();
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value_4 = _Size___get_packedValue__impl__7rlt1o(this_8);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_2 = convertToInt(shiftRight(value_4, 32));
        var tmp2_0 = tmp_8 / floatFromBits(bits_2);
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        var this_9 = targetDrawScope.o5d();
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_5 = _Size___get_packedValue__impl__7rlt1o(this_9);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_3 = convertToInt(bitwiseAnd(value_5, new Long(-1, 0)));
        var tmp_9 = floatFromBits(bits_3) + 1;
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        var this_10 = targetDrawScope.o5d();
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_6 = _Size___get_packedValue__impl__7rlt1o(this_10);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_4 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
        // Inline function 'androidx.compose.ui.graphics.drawscope.scale' call
        var scaleY = tmp_9 / floatFromBits(bits_4);
        var pivot = targetDrawScope.m6q();
        // Inline function 'androidx.compose.ui.graphics.drawscope.withTransform' call
        // Inline function 'kotlin.with' call
        var $this$with = targetDrawScope.v6p();
        var previousSize = $this$with.o5d();
        $this$with.x5u().t6d();
        try {
          $this$with.p6p().u6q(tmp2_0, scaleY, pivot);
          targetDrawScope.l6q(maskPath, brush, VOID, VOID, VOID, Companion_getInstance_3().y69_1);
        }finally {
          $this$with.x5u().u6d();
          $this$with.o6p(previousSize);
        }
      }finally {
        targetDrawScope.v6p().p6p().b5d(-tmp2, -top);
      }
      canvas.u6d();
      // Inline function 'kotlin.apply' call
      var this_11 = targetDrawScope.h6o_1;
      this_11.f6p_1 = prevDensity;
      this_11.g6p_1 = prevLayoutDirection;
      this_11.h6p_1 = prevCanvas;
      this_11.i6p_1 = prevSize;
      targetImageBitmap.w6g();
      cacheImageBitmap = targetImageBitmap;
      tmp = $receiver.f92(BorderModifierNode$drawGenericBorder$lambda_0(pathBounds, cacheImageBitmap, pathBoundsSize, colorFilter));
    }
    return tmp;
  }
  function drawRoundRectBorder($this, $receiver, brush, outline, topLeft, borderSize, fillArea, strokeWidth) {
    var tmp;
    if (get_isSimple(outline.t6h_1)) {
      var cornerRadius = outline.t6h_1.b5e_1;
      var halfStroke = strokeWidth / 2;
      var borderStroke = new Stroke(strokeWidth);
      tmp = $receiver.f92(BorderModifierNode$drawRoundRectBorder$lambda(fillArea, brush, cornerRadius, halfStroke, strokeWidth, topLeft, borderSize, borderStroke));
    } else {
      if ($this.hfc_1 == null) {
        $this.hfc_1 = new BorderCache();
      }
      var path = ensureNotNull($this.hfc_1).sfc();
      var roundedRectPath = createRoundRectPath(path, outline.t6h_1, strokeWidth, fillArea);
      tmp = $receiver.f92(BorderModifierNode$drawRoundRectBorder$lambda_0(roundedRectPath, brush));
    }
    return tmp;
  }
  function BorderModifierNode$drawWithCacheModifierNode$lambda(this$0) {
    return function ($this$CacheDrawModifierNode) {
      var hasValidBorderParams = $this$CacheDrawModifierNode.v5e(this$0.ifc_1) >= 0.0 && _Size___get_minDimension__impl__4iso0r($this$CacheDrawModifierNode.o5d()) > 0.0;
      var tmp;
      if (!hasValidBorderParams) {
        tmp = drawContentWithoutBorder($this$CacheDrawModifierNode);
      } else {
        var tmp_0;
        if (equals(this$0.ifc_1, Companion_getInstance_4().n5f_1)) {
          tmp_0 = 1.0;
        } else {
          // Inline function 'kotlin.math.ceil' call
          var x = $this$CacheDrawModifierNode.v5e(this$0.ifc_1);
          tmp_0 = Math.ceil(x);
        }
        var tmp0 = tmp_0;
        // Inline function 'kotlin.math.ceil' call
        var x_0 = _Size___get_minDimension__impl__4iso0r($this$CacheDrawModifierNode.o5d()) / 2;
        // Inline function 'kotlin.math.min' call
        var b = Math.ceil(x_0);
        var strokeWidthPx = Math.min(tmp0, b);
        var halfStroke = strokeWidthPx / 2;
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var v1 = fromInt(toRawBits(halfStroke));
        var v2 = fromInt(toRawBits(halfStroke));
        var tmp$ret$4 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        var topLeft = _Offset___init__impl__c168vi(tmp$ret$4);
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        var this_0 = $this$CacheDrawModifierNode.o5d();
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value = _Size___get_packedValue__impl__7rlt1o(this_0);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value, 32));
        var tmp0_0 = floatFromBits(bits) - strokeWidthPx;
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        var this_1 = $this$CacheDrawModifierNode.o5d();
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        // Inline function 'androidx.compose.ui.geometry.Size' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var val2 = floatFromBits(bits_0) - strokeWidthPx;
        var v1_0 = fromInt(toRawBits(tmp0_0));
        var v2_0 = fromInt(toRawBits(val2));
        var tmp$ret$14 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
        var borderSize = _Size___init__impl__aywn0g(tmp$ret$14);
        var fillArea = strokeWidthPx * 2 > _Size___get_minDimension__impl__4iso0r($this$CacheDrawModifierNode.o5d());
        var outline = this$0.kfc_1.l6j($this$CacheDrawModifierNode.o5d(), $this$CacheDrawModifierNode.r6p(), $this$CacheDrawModifierNode);
        var tmp_1;
        if (outline instanceof Generic) {
          tmp_1 = drawGenericBorder(this$0, $this$CacheDrawModifierNode, this$0.jfc_1, outline, fillArea, strokeWidthPx);
        } else {
          if (outline instanceof Rounded) {
            tmp_1 = drawRoundRectBorder(this$0, $this$CacheDrawModifierNode, this$0.jfc_1, outline, topLeft, borderSize, fillArea, strokeWidthPx);
          } else {
            if (outline instanceof Rectangle) {
              tmp_1 = drawRectBorder($this$CacheDrawModifierNode, this$0.jfc_1, topLeft, borderSize, fillArea, strokeWidthPx);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
        tmp = tmp_1;
      }
      return tmp;
    };
  }
  function BorderModifierNode$drawGenericBorder$lambda($outline, $brush) {
    return function ($this$onDrawWithContent) {
      $this$onDrawWithContent.z91();
      $this$onDrawWithContent.l6q($outline.w6h_1, $brush);
      return Unit_instance;
    };
  }
  function BorderModifierNode$drawGenericBorder$lambda_0($pathBounds, $cacheImageBitmap, $pathBoundsSize, $colorFilter) {
    return function ($this$onDrawWithContent) {
      $this$onDrawWithContent.z91();
      var tmp2 = $pathBounds.k5d_1;
      // Inline function 'androidx.compose.ui.graphics.drawscope.translate' call
      var top = $pathBounds.l5d_1;
      $this$onDrawWithContent.v6p().p6p().b5d(tmp2, top);
      try {
        $this$onDrawWithContent.d6q($cacheImageBitmap, VOID, $pathBoundsSize, VOID, VOID, VOID, VOID, $colorFilter);
      }finally {
        $this$onDrawWithContent.v6p().p6p().b5d(-tmp2, -top);
      }
      return Unit_instance;
    };
  }
  function BorderModifierNode$drawRoundRectBorder$lambda($fillArea, $brush, $cornerRadius, $halfStroke, $strokeWidth, $topLeft, $borderSize, $borderStroke) {
    return function ($this$onDrawWithContent) {
      $this$onDrawWithContent.z91();
      var tmp;
      if ($fillArea) {
        $this$onDrawWithContent.e6q($brush, VOID, VOID, $cornerRadius);
        tmp = Unit_instance;
      } else {
        // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
        var this_0 = $cornerRadius;
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value = _CornerRadius___get_packedValue__impl__okv4jq(this_0);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value, 32));
        if (floatFromBits(bits) < $halfStroke) {
          var tmp2 = $strokeWidth;
          var tmp4 = $strokeWidth;
          // Inline function 'androidx.compose.ui.geometry.Size.width' call
          var this_1 = $this$onDrawWithContent.o5d();
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_0 = convertToInt(shiftRight(value_0, 32));
          var tmp6 = floatFromBits(bits_0) - $strokeWidth;
          // Inline function 'androidx.compose.ui.geometry.Size.height' call
          var this_2 = $this$onDrawWithContent.o5d();
          // Inline function 'androidx.compose.ui.util.unpackFloat2' call
          var value_1 = _Size___get_packedValue__impl__7rlt1o(this_2);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
          var tmp8 = floatFromBits(bits_1) - $strokeWidth;
          // Inline function 'androidx.compose.ui.graphics.drawscope.clipRect' call
          var clipOp = Companion_getInstance_5().c6e_1;
          // Inline function 'androidx.compose.ui.graphics.drawscope.withTransform' call
          // Inline function 'kotlin.with' call
          var $this$with = $this$onDrawWithContent.v6p();
          var previousSize = $this$with.o5d();
          $this$with.x5u().t6d();
          try {
            $this$with.p6p().a6e(tmp2, tmp4, tmp6, tmp8, clipOp);
            $this$onDrawWithContent.e6q($brush, VOID, VOID, $cornerRadius);
          }finally {
            $this$with.x5u().u6d();
            $this$with.o6p(previousSize);
          }
          tmp = Unit_instance;
        } else {
          $this$onDrawWithContent.e6q($brush, $topLeft, $borderSize, shrink($cornerRadius, $halfStroke), VOID, $borderStroke);
          tmp = Unit_instance;
        }
      }
      return Unit_instance;
    };
  }
  function BorderModifierNode$drawRoundRectBorder$lambda_0($roundedRectPath, $brush) {
    return function ($this$onDrawWithContent) {
      $this$onDrawWithContent.z91();
      $this$onDrawWithContent.l6q($roundedRectPath, $brush);
      return Unit_instance;
    };
  }
  function BorderModifierNode(widthParameter, brushParameter, shapeParameter) {
    DelegatingNode.call(this);
    this.ffc_1 = false;
    this.gfc_1 = false;
    this.hfc_1 = null;
    this.ifc_1 = widthParameter;
    this.jfc_1 = brushParameter;
    this.kfc_1 = shapeParameter;
    var tmp = this;
    tmp.lfc_1 = this.tb1(CacheDrawModifierNode(BorderModifierNode$drawWithCacheModifierNode$lambda(this)));
  }
  protoOf(BorderModifierNode).b8w = function () {
    return this.ffc_1;
  };
  protoOf(BorderModifierNode).k9i = function () {
    return this.gfc_1;
  };
  protoOf(BorderModifierNode).mfc = function (value) {
    if (!equals(this.ifc_1, value)) {
      this.ifc_1 = value;
      this.lfc_1.a94();
    }
  };
  protoOf(BorderModifierNode).nfc = function (value) {
    if (!equals(this.jfc_1, value)) {
      this.jfc_1 = value;
      this.lfc_1.a94();
    }
  };
  protoOf(BorderModifierNode).l98 = function (value) {
    if (!equals(this.kfc_1, value)) {
      this.kfc_1 = value;
      this.lfc_1.a94();
      invalidateSemantics(this);
    }
  };
  protoOf(BorderModifierNode).l9i = function (_this__u8e3s4) {
    set_shape(_this__u8e3s4, this.kfc_1);
  };
  function BorderCache(imageBitmap, canvas, canvasDrawScope, borderPath) {
    imageBitmap = imageBitmap === VOID ? null : imageBitmap;
    canvas = canvas === VOID ? null : canvas;
    canvasDrawScope = canvasDrawScope === VOID ? null : canvasDrawScope;
    borderPath = borderPath === VOID ? null : borderPath;
    this.ofc_1 = imageBitmap;
    this.pfc_1 = canvas;
    this.qfc_1 = canvasDrawScope;
    this.rfc_1 = borderPath;
  }
  protoOf(BorderCache).sfc = function () {
    var tmp0_elvis_lhs = this.rfc_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = Path();
      this.rfc_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(BorderCache).toString = function () {
    return 'BorderCache(imageBitmap=' + toString_0(this.ofc_1) + ', canvas=' + toString_0(this.pfc_1) + ', canvasDrawScope=' + toString_0(this.qfc_1) + ', borderPath=' + toString_0(this.rfc_1) + ')';
  };
  protoOf(BorderCache).hashCode = function () {
    var result = this.ofc_1 == null ? 0 : hashCode(this.ofc_1);
    result = imul(result, 31) + (this.pfc_1 == null ? 0 : hashCode(this.pfc_1)) | 0;
    result = imul(result, 31) + (this.qfc_1 == null ? 0 : hashCode(this.qfc_1)) | 0;
    result = imul(result, 31) + (this.rfc_1 == null ? 0 : hashCode(this.rfc_1)) | 0;
    return result;
  };
  protoOf(BorderCache).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BorderCache))
      return false;
    if (!equals(this.ofc_1, other.ofc_1))
      return false;
    if (!equals(this.pfc_1, other.pfc_1))
      return false;
    if (!equals(this.qfc_1, other.qfc_1))
      return false;
    if (!equals(this.rfc_1, other.rfc_1))
      return false;
    return true;
  };
  function drawContentWithoutBorder(_this__u8e3s4) {
    return _this__u8e3s4.f92(drawContentWithoutBorder$lambda);
  }
  function drawRectBorder(_this__u8e3s4, brush, topLeft, borderSize, fillArea, strokeWidthPx) {
    var rectTopLeft = fillArea ? Companion_getInstance_6().g5d_1 : topLeft;
    var size = fillArea ? _this__u8e3s4.o5d() : borderSize;
    var style = fillArea ? Fill_getInstance() : new Stroke(strokeWidthPx);
    return _this__u8e3s4.f92(drawRectBorder$lambda(brush, rectTopLeft, size, style));
  }
  function shrink(_this__u8e3s4, value) {
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _CornerRadius___get_packedValue__impl__okv4jq(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value_0, 32));
    // Inline function 'kotlin.math.max' call
    var b = floatFromBits(bits) - value;
    var tmp0 = Math.max(0.0, b);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _CornerRadius___get_packedValue__impl__okv4jq(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    // Inline function 'kotlin.math.max' call
    var b_0 = floatFromBits(bits_0) - value;
    // Inline function 'androidx.compose.ui.geometry.CornerRadius' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = Math.max(0.0, b_0);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$11 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _CornerRadius___init__impl__ojmabe(tmp$ret$11);
  }
  function createRoundRectPath(targetPath, roundedRect, strokeWidth, fillArea) {
    // Inline function 'kotlin.apply' call
    targetPath.u4c();
    targetPath.v6h(roundedRect);
    if (!fillArea) {
      // Inline function 'kotlin.apply' call
      var this_0 = Path();
      this_0.v6h(createInsetRoundedRect(strokeWidth, roundedRect));
      var insetPath = this_0;
      targetPath.b6j(targetPath, insetPath, Companion_getInstance_2().d6j_1);
    }
    return targetPath;
  }
  function createInsetRoundedRect(widthPx, roundedRect) {
    var tmp0_right = roundedRect.h5e() - widthPx;
    var tmp1_bottom = roundedRect.i5e() - widthPx;
    var tmp2_topLeftCornerRadius = shrink(roundedRect.b5e_1, widthPx);
    var tmp3_topRightCornerRadius = shrink(roundedRect.c5e_1, widthPx);
    var tmp4_bottomLeftCornerRadius = shrink(roundedRect.e5e_1, widthPx);
    var tmp5_bottomRightCornerRadius = shrink(roundedRect.d5e_1, widthPx);
    return new RoundRect(widthPx, widthPx, tmp0_right, tmp1_bottom, tmp2_topLeftCornerRadius, tmp3_topRightCornerRadius, tmp5_bottomRightCornerRadius, tmp4_bottomLeftCornerRadius);
  }
  function border_1(_this__u8e3s4, width, color, shape) {
    shape = shape === VOID ? get_RectangleShape() : shape;
    return border_0(_this__u8e3s4, width, new SolidColor(color), shape);
  }
  function drawContentWithoutBorder$lambda($this$onDrawWithContent) {
    $this$onDrawWithContent.z91();
    return Unit_instance;
  }
  function drawRectBorder$lambda($brush, $rectTopLeft, $size, $style) {
    return function ($this$onDrawWithContent) {
      $this$onDrawWithContent.z91();
      $this$onDrawWithContent.a6q($brush, $rectTopLeft, $size, VOID, $style);
      return Unit_instance;
    };
  }
  var androidx_compose_foundation_BorderStroke$stable;
  function BorderStroke(width, brush) {
    this.ifb_1 = width;
    this.jfb_1 = brush;
  }
  protoOf(BorderStroke).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BorderStroke))
      return false;
    if (!equals(this.ifb_1, other.ifb_1))
      return false;
    if (!equals(this.jfb_1, other.jfb_1))
      return false;
    return true;
  };
  protoOf(BorderStroke).hashCode = function () {
    var result = Dp__hashCode_impl_sxkrra(this.ifb_1);
    result = imul(31, result) + hashCode(this.jfb_1) | 0;
    return result;
  };
  protoOf(BorderStroke).toString = function () {
    return 'BorderStroke(width=' + Dp__toString_impl_kcddez(this.ifb_1) + ', brush=' + toString(this.jfb_1) + ')';
  };
  function BorderStroke_0(width, color) {
    return new BorderStroke(width, new SolidColor(color));
  }
  function Canvas_0(modifier, onDraw, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-932836462);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDraw) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      Spacer(drawBehind(modifier, onDraw), $composer_0, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(Canvas$lambda(modifier, onDraw, $changed));
    }
  }
  function Canvas$lambda($modifier, $onDraw, $$changed) {
    return function ($composer, $force) {
      Canvas_0($modifier, $onDraw, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function checkScrollableContainerConstraints(constraints, orientation) {
    if (orientation.equals(Orientation_Vertical_getInstance())) {
      // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
      if (!!(_Constraints___get_maxHeight__impl__dt3e8z(constraints) === 2147483647)) {
        var tmp$ret$1 = 'Vertically scrollable component was measured with an infinity maximum height constraints, which is disallowed. One of the common reasons is nesting layouts like LazyColumn and Column(Modifier.verticalScroll()). If you want to add a header before the list of items please add a header as a separate item() before the main items() inside the LazyColumn scope. There could be other reasons for this to happen: your ComposeView was added into a LinearLayout with some weight, you applied Modifier.wrapContentSize(unbounded = true) or wrote a custom layout. Please try to remove the source of infinite constraints in the hierarchy above the scrolling container.';
        throwIllegalStateException(tmp$ret$1);
      }
    } else {
      // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
      if (!!(_Constraints___get_maxWidth__impl__uuyqc(constraints) === 2147483647)) {
        var tmp$ret$3 = 'Horizontally scrollable component was measured with an infinity maximum width constraints, which is disallowed. One of the common reasons is nesting layouts like LazyRow and Row(Modifier.horizontalScroll()). If you want to add a header before the list of items please add a header as a separate item() before the main items() inside the LazyRow scope. There could be other reasons for this to happen: your ComposeView was added into a LinearLayout with some weight, you applied Modifier.wrapContentSize(unbounded = true) or wrote a custom layout. Please try to remove the source of infinite constraints in the hierarchy above the scrolling container.';
        throwIllegalStateException(tmp$ret$3);
      }
    }
  }
  var androidx_compose_foundation_ClickableNode$stable;
  var androidx_compose_foundation_CombinedClickableNode_DoubleKeyClickState$stable;
  var androidx_compose_foundation_AbstractClickableNode$stable;
  function clickable(_this__u8e3s4, enabled, onClickLabel, role, interactionSource, onClick) {
    enabled = enabled === VOID ? true : enabled;
    onClickLabel = onClickLabel === VOID ? null : onClickLabel;
    role = role === VOID ? null : role;
    interactionSource = interactionSource === VOID ? null : interactionSource;
    return _this__u8e3s4.d8v(new ClickableElement(interactionSource, null, true, enabled, onClickLabel, role, onClick));
  }
  function clickable_0(_this__u8e3s4, interactionSource, indication_0, enabled, onClickLabel, role, onClick) {
    enabled = enabled === VOID ? true : enabled;
    onClickLabel = onClickLabel === VOID ? null : onClickLabel;
    role = role === VOID ? null : role;
    // Inline function 'androidx.compose.foundation.clickableWithIndicationIfNeeded' call
    var tmp;
    if (!(indication_0 == null) ? isInterface(indication_0, IndicationNodeFactory) : false) {
      tmp = new ClickableElement(interactionSource, indication_0, false, enabled, onClickLabel, role, onClick);
    } else {
      if (indication_0 == null) {
        tmp = new ClickableElement(interactionSource, null, false, enabled, onClickLabel, role, onClick);
      } else {
        if (!(interactionSource == null)) {
          var tmp_0 = indication(Companion_instance_0, interactionSource, indication_0);
          var tmp$ret$3 = new ClickableElement(interactionSource, null, false, enabled, onClickLabel, role, onClick);
          tmp = tmp_0.d8v(tmp$ret$3);
        } else {
          var tmp_1 = Companion_instance_0;
          tmp = composed(tmp_1, VOID, clickable$lambda(indication_0, enabled, onClickLabel, role, onClick));
        }
      }
    }
    return _this__u8e3s4.d8v(tmp);
  }
  function ClickableElement(interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role, onClick) {
    ModifierNodeElement.call(this);
    this.ufc_1 = interactionSource;
    this.vfc_1 = indicationNodeFactory;
    this.wfc_1 = useLocalIndication;
    this.xfc_1 = enabled;
    this.yfc_1 = onClickLabel;
    this.zfc_1 = role;
    this.afd_1 = onClick;
  }
  protoOf(ClickableElement).r3d = function () {
    return new ClickableNode(this.ufc_1, this.vfc_1, this.wfc_1, this.xfc_1, this.yfc_1, this.zfc_1, this.afd_1);
  };
  protoOf(ClickableElement).bfd = function (node) {
    node.rfe(this.ufc_1, this.vfc_1, this.wfc_1, this.xfc_1, this.yfc_1, this.zfc_1, this.afd_1);
  };
  protoOf(ClickableElement).d8y = function (node) {
    return this.bfd(node instanceof ClickableNode ? node : THROW_CCE());
  };
  protoOf(ClickableElement).equals = function (other) {
    if (this === other)
      return true;
    if (other === null)
      return false;
    if (!getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ClickableElement))
      THROW_CCE();
    if (!equals(this.ufc_1, other.ufc_1))
      return false;
    if (!equals(this.vfc_1, other.vfc_1))
      return false;
    if (!(this.wfc_1 === other.wfc_1))
      return false;
    if (!(this.xfc_1 === other.xfc_1))
      return false;
    if (!(this.yfc_1 == other.yfc_1))
      return false;
    var tmp = this.zfc_1;
    var tmp_0 = tmp == null ? null : new Role(tmp);
    var tmp_1 = other.zfc_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new Role(tmp_1)))
      return false;
    if (!(this.afd_1 === other.afd_1))
      return false;
    return true;
  };
  protoOf(ClickableElement).hashCode = function () {
    var tmp0_safe_receiver = this.ufc_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.vfc_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    result = imul(31, result) + getBooleanHashCode(this.wfc_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.xfc_1) | 0;
    var tmp_0 = imul(31, result);
    var tmp4_safe_receiver = this.yfc_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : getStringHashCode(tmp4_safe_receiver);
    result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    var tmp_1 = imul(31, result);
    var tmp6_safe_receiver = this.zfc_1;
    var tmp_2;
    var tmp_3 = tmp6_safe_receiver;
    if ((tmp_3 == null ? null : new Role(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      tmp_2 = Role__hashCode_impl_ucjza4(tmp6_safe_receiver);
    }
    var tmp7_elvis_lhs = tmp_2;
    result = tmp_1 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0;
    result = imul(31, result) + hashCode(this.afd_1) | 0;
    return result;
  };
  function handleDownEvent($this, down) {
    down.ra2();
    $this.pfe_1 = down;
    if ($this.nff_1) {
      requestFocusWhenInMouseInputMode($this);
      if (ComposeFoundationFlags_instance.pfg_1) {
        $this.gfg(down);
      } else {
        $this.ffg(down.ka0_1, false);
      }
    }
  }
  function handleUpEvent($this, up) {
    up.ra2();
    if ($this.nff_1) {
      $this.xfg(ensureNotNull($this.pfe_1).ka0_1, false);
      $this.off_1();
    }
    $this.pfe_1 = null;
  }
  function handleNonUpEventIfNeeded($this, pointerEvent, bounds) {
    var touchPadding = $this.yfg(bounds);
    var tmp0 = pointerEvent.ca0_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (item.qa2() || isOutOfBounds(item, bounds, touchPadding)) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      cancelInput($this, false);
    }
  }
  function checkForCancellation($this, pointerEvent) {
    if (!($this.pfe_1 == null)) {
      var tmp0 = pointerEvent.ca0_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastAny' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = tmp0.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = tmp0.l1(index);
            if (item.qa2() && !equals(item, $this.pfe_1)) {
              tmp$ret$0 = true;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$0 = false;
      }
      if (tmp$ret$0) {
        cancelInput($this, false);
      }
    }
  }
  function cancelInput($this, indirectPointer) {
    if (indirectPointer) {
      $this.qfe_1 = null;
    } else {
      $this.pfe_1 = null;
    }
    $this.zfg(indirectPointer);
  }
  function ClickableNode(interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role, onClick) {
    AbstractClickableNode.call(this, interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role, onClick);
    this.pfe_1 = null;
    this.qfe_1 = null;
  }
  protoOf(ClickableNode).aa1 = function (pointerEvent, pass, bounds) {
    protoOf(AbstractClickableNode).aa1.call(this, pointerEvent, pass, bounds);
    if (pass.equals(PointerEventPass_Main_getInstance())) {
      if (this.pfe_1 == null) {
        if (isChangedToDown(pointerEvent, true)) {
          handleDownEvent(this, pointerEvent.ca0_1.l1(0));
        }
      } else {
        var tmp0 = pointerEvent.ca0_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'androidx.compose.ui.util.fastAll' call
          // Inline function 'androidx.compose.ui.util.fastForEach' call
          var inductionVariable = 0;
          var last = tmp0.n1() - 1 | 0;
          if (inductionVariable <= last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var item = tmp0.l1(index);
              if (!changedToUp(item)) {
                tmp$ret$0 = false;
                break $l$block;
              }
            }
             while (inductionVariable <= last);
          tmp$ret$0 = true;
        }
        if (tmp$ret$0) {
          handleUpEvent(this, pointerEvent.ca0_1.l1(0));
        } else {
          handleNonUpEventIfNeeded(this, pointerEvent, bounds);
        }
      }
    } else if (pass.equals(PointerEventPass_Final_getInstance())) {
      checkForCancellation(this, pointerEvent);
    }
  };
  protoOf(ClickableNode).xa1 = function () {
    protoOf(AbstractClickableNode).xa1.call(this);
    cancelInput(this, false);
  };
  protoOf(ClickableNode).d9u = function () {
    cancelInput(this, true);
  };
  protoOf(ClickableNode).rfe = function (interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role, onClick) {
    this.afh(interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role, onClick);
  };
  protoOf(ClickableNode).bfh = function (event) {
    return false;
  };
  protoOf(ClickableNode).cfh = function (event) {
    this.off_1();
    return true;
  };
  function AbstractClickableNode$handlePressInteraction$slambda$slambda(this$0, $offset, $interactionSource, resultContinuation) {
    this.qfh_1 = this$0;
    this.rfh_1 = $offset;
    this.sfh_1 = $interactionSource;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$handlePressInteraction$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$handlePressInteraction$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$handlePressInteraction$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp_0;
            if (ComposeFoundationFlags_instance.pfg_1) {
              tmp_0 = delayPressInteraction_0(this.qfh_1, null);
            } else {
              tmp_0 = delayPressInteraction(this.qfh_1);
            }

            var shouldDelayPress = tmp_0;
            if (shouldDelayPress) {
              this.n9_1 = 1;
              suspendResult = delay(get_TapIndicationDelay(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.ufh_1 = new Press(this.rfh_1);
            this.n9_1 = 3;
            suspendResult = this.sfh_1.vfh(this.ufh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.qfh_1.vff_1 = this.ufh_1;
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$handlePressInteraction$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$handlePressInteraction$slambda$slambda(this.qfh_1, this.rfh_1, this.sfh_1, completion);
    i.tfh_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$handlePressInteraction$slambda$slambda_0(this$0, $offset, $interactionSource, resultContinuation) {
    var i = new AbstractClickableNode$handlePressInteraction$slambda$slambda(this$0, $offset, $interactionSource, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function shouldLazilyCreateIndication($this) {
    return $this.bfg_1 == null;
  }
  function onFocusChange($this, isFocused) {
    if (isFocused) {
      initializeIndicationAndInteractionSourceIfNeeded($this);
    } else {
      if (!($this.iff_1 == null)) {
        // Inline function 'androidx.collection.LongObjectMap.forEachValue' call
        var this_0 = $this.xff_1;
        var v = this_0.ax_1;
        $l$block: {
          // Inline function 'androidx.collection.LongObjectMap.forEachIndexed' call
          var m = this_0.yw_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_1 = slot;
              var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value, new Long(128, 0)) < 0) {
                      var index = (i << 3) + j | 0;
                      var it = v[index];
                      var tmp = $this.a8w();
                      launch(tmp, VOID, VOID, AbstractClickableNode$onFocusChange$slambda_0($this, it, null));
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block;
                }
              }
            }
             while (!(i === lastIndex));
        }
        var tmp0_safe_receiver = $this.zff_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp_0 = $this.a8w();
          launch(tmp_0, VOID, VOID, AbstractClickableNode$onFocusChange$slambda_2($this, tmp0_safe_receiver, null));
        }
      }
      $this.xff_1.c3();
      $this.zff_1 = null;
      $this.gfh();
    }
  }
  function recreateIndicationIfNeeded($this) {
    if (!($this.uff_1 == null) || !$this.cfg_1) {
      var tmp0_safe_receiver = $this.uff_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $this.vb1(tmp0_safe_receiver);
      }
      $this.uff_1 = null;
      initializeIndicationAndInteractionSourceIfNeeded($this);
    }
  }
  function initializeIndicationAndInteractionSourceIfNeeded($this) {
    if (!($this.uff_1 == null))
      return Unit_instance;
    var indicationFactory = $this.kff_1 ? $this.rff_1 : $this.jff_1;
    if (indicationFactory == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp = platformIndication(indicationFactory);
      var platformFactory = (!(tmp == null) ? isInterface(tmp, IndicationNodeFactory) : false) ? tmp : THROW_CCE();
      if ($this.iff_1 == null) {
        $this.iff_1 = funMutableInteractionSource();
      }
      $this.qff_1.tfi($this.iff_1);
      var node = platformFactory.ufi(ensureNotNull($this.iff_1));
      $this.tb1(node);
      $this.uff_1 = node;
    }
  }
  function initializeGestureCoordination($this) {
    if (!ComposeFoundationFlags_instance.pfg_1)
      return Unit_instance;
    if ($this.tff_1 == null) {
      $this.tff_1 = $this.tb1(gestureNode($this));
    }
  }
  function delayPressInteraction($this) {
    return hasScrollableContainer($this) || isComposeRootInScrollableContainer($this);
  }
  function delayPressInteraction_0($this, event) {
    var tmp;
    if (event == null) {
      tmp = !(get_parentGestureConnection($this) == null);
    } else {
      tmp = hasInterestedParent($this, event);
    }
    var hasInterestedParent_0 = tmp;
    return hasInterestedParent_0 || isComposeRootInScrollableContainer($this);
  }
  function emitHoverEnter($this) {
    if ($this.wff_1 == null) {
      var interaction = new Enter();
      var tmp0_safe_receiver = $this.iff_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp = $this.a8w();
        launch(tmp, VOID, VOID, AbstractClickableNode$emitHoverEnter$slambda_0(tmp0_safe_receiver, interaction, null));
      }
      $this.wff_1 = interaction;
    }
  }
  function emitHoverExit($this) {
    var tmp0_safe_receiver = $this.wff_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var interaction = new Exit(tmp0_safe_receiver);
      var tmp0_safe_receiver_0 = $this.iff_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp = $this.a8w();
        launch(tmp, VOID, VOID, AbstractClickableNode$emitHoverExit$slambda_0(tmp0_safe_receiver_0, interaction, null));
      }
      $this.wff_1 = null;
    }
  }
  function TraverseKey() {
  }
  var TraverseKey_instance;
  function TraverseKey_getInstance() {
    return TraverseKey_instance;
  }
  function AbstractClickableNode$onFocusChange$ref(p0) {
    return constructCallableReference(function (p0_0) {
      var tmp0 = p0;
      onFocusChange(tmp0, p0_0);
      return Unit_instance;
    }, 1, 0, 238, 'onFocusChange', [p0]);
  }
  function AbstractClickableNode$onObservedReadsChanged$lambda(this$0) {
    return function () {
      var indication = currentValueOf(this$0, get_LocalIndication());
      // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
      if (!isInterface(indication, IndicationNodeFactory)) {
        var tmp$ret$1 = unsupportedIndicationExceptionMessage(indication);
        throwIllegalArgumentException(tmp$ret$1);
      }
      var previousFactory = this$0.rff_1;
      this$0.rff_1 = indication;
      var tmp;
      if (!(previousFactory == null) && !equals(this$0.rff_1, previousFactory)) {
        recreateIndicationIfNeeded(this$0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AbstractClickableNode$onFocusChange$slambda(this$0, $it, resultContinuation) {
    this.dfj_1 = this$0;
    this.efj_1 = $it;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$onFocusChange$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$onFocusChange$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$onFocusChange$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.dfj_1.iff_1;
            if (tmp0_safe_receiver == null) {
              this.gfj_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = tmp0_safe_receiver.vfh(new Cancel_0(this.efj_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            tmp_0.gfj_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$onFocusChange$slambda).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$onFocusChange$slambda(this.dfj_1, this.efj_1, completion);
    i.ffj_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$onFocusChange$slambda_0(this$0, $it, resultContinuation) {
    var i = new AbstractClickableNode$onFocusChange$slambda(this$0, $it, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$onFocusChange$slambda_1(this$0, $it, resultContinuation) {
    this.pfj_1 = this$0;
    this.qfj_1 = $it;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$onFocusChange$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$onFocusChange$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$onFocusChange$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.pfj_1.iff_1;
            if (tmp0_safe_receiver == null) {
              this.sfj_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = tmp0_safe_receiver.vfh(new Cancel_0(this.qfj_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            tmp_0.sfj_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$onFocusChange$slambda_1).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$onFocusChange$slambda_1(this.pfj_1, this.qfj_1, completion);
    i.rfj_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$onFocusChange$slambda_2(this$0, $it, resultContinuation) {
    var i = new AbstractClickableNode$onFocusChange$slambda_1(this$0, $it, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$onPointerEvent$slambda(this$0, resultContinuation) {
    this.bfk_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$onPointerEvent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$onPointerEvent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$onPointerEvent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          emitHoverEnter(this.bfk_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(AbstractClickableNode$onPointerEvent$slambda).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$onPointerEvent$slambda(this.bfk_1, completion);
    i.cfk_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$onPointerEvent$slambda_0(this$0, resultContinuation) {
    var i = new AbstractClickableNode$onPointerEvent$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$onPointerEvent$slambda_1(this$0, resultContinuation) {
    this.lfk_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$onPointerEvent$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$onPointerEvent$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$onPointerEvent$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          emitHoverExit(this.lfk_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(AbstractClickableNode$onPointerEvent$slambda_1).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$onPointerEvent$slambda_1(this.lfk_1, completion);
    i.mfk_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$onPointerEvent$slambda_2(this$0, resultContinuation) {
    var i = new AbstractClickableNode$onPointerEvent$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$onKeyEvent$slambda(this$0, $press, resultContinuation) {
    this.vfk_1 = this$0;
    this.wfk_1 = $press;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$onKeyEvent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$onKeyEvent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$onKeyEvent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.vfk_1.iff_1;
            if (tmp0_safe_receiver == null) {
              this.yfk_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = tmp0_safe_receiver.vfh(this.wfk_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            tmp_0.yfk_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$onKeyEvent$slambda).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$onKeyEvent$slambda(this.vfk_1, this.wfk_1, completion);
    i.xfk_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$onKeyEvent$slambda_0(this$0, $press, resultContinuation) {
    var i = new AbstractClickableNode$onKeyEvent$slambda(this$0, $press, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$onKeyEvent$slambda_1(this$0, $press, resultContinuation) {
    this.hfl_1 = this$0;
    this.ifl_1 = $press;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$onKeyEvent$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$onKeyEvent$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$onKeyEvent$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.hfl_1.iff_1;
            if (tmp0_safe_receiver == null) {
              this.kfl_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = tmp0_safe_receiver.vfh(new Release(this.ifl_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            tmp_0.kfl_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$onKeyEvent$slambda_1).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$onKeyEvent$slambda_1(this.hfl_1, this.ifl_1, completion);
    i.jfl_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$onKeyEvent$slambda_2(this$0, $press, resultContinuation) {
    var i = new AbstractClickableNode$onKeyEvent$slambda_1(this$0, $press, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$applySemantics$lambda(this$0) {
    return function () {
      this$0.off_1();
      return true;
    };
  }
  function AbstractClickableNode$handlePressInteractionStart$slambda($interactionSource, $press, this$0, resultContinuation) {
    this.tfl_1 = $interactionSource;
    this.ufl_1 = $press;
    this.vfl_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = delay(get_TapIndicationDelay(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.tfl_1.vfh(this.ufl_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.vfl_1.vff_1 = this.ufl_1;
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$handlePressInteractionStart$slambda(this.tfl_1, this.ufl_1, this.vfl_1, completion);
    i.wfl_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$handlePressInteractionStart$slambda_0($interactionSource, $press, this$0, resultContinuation) {
    var i = new AbstractClickableNode$handlePressInteractionStart$slambda($interactionSource, $press, this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$handlePressInteractionStart$slambda_1($interactionSource, $press, resultContinuation) {
    this.ffm_1 = $interactionSource;
    this.gfm_1 = $press;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.ffm_1.vfh(this.gfm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_1).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$handlePressInteractionStart$slambda_1(this.ffm_1, this.gfm_1, completion);
    i.hfm_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$handlePressInteractionStart$slambda_2($interactionSource, $press, resultContinuation) {
    var i = new AbstractClickableNode$handlePressInteractionStart$slambda_1($interactionSource, $press, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$handlePressInteractionStart$slambda_3($interactionSource, $press, $indirectPointer, this$0, resultContinuation) {
    this.qfm_1 = $interactionSource;
    this.rfm_1 = $press;
    this.sfm_1 = $indirectPointer;
    this.tfm_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_3).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = delay(get_TapIndicationDelay(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.qfm_1.vfh(this.rfm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (this.sfm_1) {
              this.tfm_1.zff_1 = this.rfm_1;
            } else {
              this.tfm_1.vff_1 = this.rfm_1;
            }

            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_3).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$handlePressInteractionStart$slambda_3(this.qfm_1, this.rfm_1, this.sfm_1, this.tfm_1, completion);
    i.ufm_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$handlePressInteractionStart$slambda_4($interactionSource, $press, $indirectPointer, this$0, resultContinuation) {
    var i = new AbstractClickableNode$handlePressInteractionStart$slambda_3($interactionSource, $press, $indirectPointer, this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$handlePressInteractionStart$slambda_5($interactionSource, $press, resultContinuation) {
    this.dfn_1 = $interactionSource;
    this.efn_1 = $press;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_5).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.dfn_1.vfh(this.efn_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$handlePressInteractionStart$slambda_5).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$handlePressInteractionStart$slambda_5(this.dfn_1, this.efn_1, completion);
    i.ffn_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$handlePressInteractionStart$slambda_6($interactionSource, $press, resultContinuation) {
    var i = new AbstractClickableNode$handlePressInteractionStart$slambda_5($interactionSource, $press, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$handlePressInteractionRelease$slambda($job, $offset, $interactionSource, resultContinuation) {
    this.ofn_1 = $job;
    this.pfn_1 = $offset;
    this.qfn_1 = $interactionSource;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$handlePressInteractionRelease$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$handlePressInteractionRelease$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$handlePressInteractionRelease$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = this.ofn_1.x1a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var press = new Press(this.pfn_1);
            this.sfn_1 = new Release(press);
            this.n9_1 = 2;
            suspendResult = this.qfn_1.vfh(press, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.qfn_1.vfh(this.sfn_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$handlePressInteractionRelease$slambda).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$handlePressInteractionRelease$slambda(this.ofn_1, this.pfn_1, this.qfn_1, completion);
    i.rfn_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$handlePressInteractionRelease$slambda_0($job, $offset, $interactionSource, resultContinuation) {
    var i = new AbstractClickableNode$handlePressInteractionRelease$slambda($job, $offset, $interactionSource, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$handlePressInteractionRelease$slambda_1($it, $interactionSource, resultContinuation) {
    this.bfo_1 = $it;
    this.cfo_1 = $interactionSource;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$handlePressInteractionRelease$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$handlePressInteractionRelease$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$handlePressInteractionRelease$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var endInteraction = new Release(this.bfo_1);
            this.n9_1 = 1;
            suspendResult = this.cfo_1.vfh(endInteraction, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$handlePressInteractionRelease$slambda_1).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$handlePressInteractionRelease$slambda_1(this.bfo_1, this.cfo_1, completion);
    i.dfo_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$handlePressInteractionRelease$slambda_2($it, $interactionSource, resultContinuation) {
    var i = new AbstractClickableNode$handlePressInteractionRelease$slambda_1($it, $interactionSource, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$handlePressInteractionCancel$lambda($interactionSource, $endInteraction) {
    return function (it) {
      $interactionSource.efo($endInteraction);
      return Unit_instance;
    };
  }
  function AbstractClickableNode$handlePressInteractionCancel$slambda($interactionSource, $endInteraction, $handler, resultContinuation) {
    this.nfo_1 = $interactionSource;
    this.ofo_1 = $endInteraction;
    this.pfo_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$handlePressInteractionCancel$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$handlePressInteractionCancel$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$handlePressInteractionCancel$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.nfo_1.vfh(this.ofo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = this.pfo_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.s1d();
            }

            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$handlePressInteractionCancel$slambda).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$handlePressInteractionCancel$slambda(this.nfo_1, this.ofo_1, this.pfo_1, completion);
    i.qfo_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$handlePressInteractionCancel$slambda_0($interactionSource, $endInteraction, $handler, resultContinuation) {
    var i = new AbstractClickableNode$handlePressInteractionCancel$slambda($interactionSource, $endInteraction, $handler, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$handlePressInteraction$slambda($this_handlePressInteraction, $offset, $interactionSource, this$0, resultContinuation) {
    this.zfo_1 = $this_handlePressInteraction;
    this.afp_1 = $offset;
    this.bfp_1 = $interactionSource;
    this.cfp_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$handlePressInteraction$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$handlePressInteraction$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$handlePressInteraction$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            var tmp_0 = this;
            tmp_0.ifp_1 = launch(this.dfp_1, VOID, VOID, AbstractClickableNode$handlePressInteraction$slambda$slambda_0(this.cfp_1, this.afp_1, this.bfp_1, null));
            this.n9_1 = 1;
            suspendResult = this.zfo_1.jfp(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.gfp_1 = suspendResult;
            if (this.ifp_1.r19()) {
              this.n9_1 = 4;
              suspendResult = cancelAndJoin(this.ifp_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp0_safe_receiver = this.cfp_1.vff_1;
              if (tmp0_safe_receiver == null) {
                this.hfp_1 = null;
                this.n9_1 = 3;
                continue $sm;
              } else {
                var tmp_1;
                if (this.gfp_1) {
                  tmp_1 = new Release(tmp0_safe_receiver);
                } else {
                  tmp_1 = new Cancel_0(tmp0_safe_receiver);
                }
                var endInteraction = tmp_1;
                this.n9_1 = 2;
                suspendResult = this.bfp_1.vfh(endInteraction, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 2:
            var tmp_2 = this;
            tmp_2.hfp_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.efp_1 = this.hfp_1;
            this.n9_1 = 8;
            continue $sm;
          case 4:
            if (this.gfp_1) {
              var press = new Press(this.afp_1);
              this.ffp_1 = new Release(press);
              this.n9_1 = 5;
              suspendResult = this.bfp_1.vfh(press, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 5:
            this.n9_1 = 6;
            suspendResult = this.bfp_1.vfh(this.ffp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.efp_1 = Unit_instance;
            this.n9_1 = 8;
            continue $sm;
          case 8:
            this.cfp_1.vff_1 = null;
            return Unit_instance;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$handlePressInteraction$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new AbstractClickableNode$handlePressInteraction$slambda(this.zfo_1, this.afp_1, this.bfp_1, this.cfp_1, completion);
    i.dfp_1 = $this$coroutineScope;
    return i;
  };
  function AbstractClickableNode$handlePressInteraction$slambda_0($this_handlePressInteraction, $offset, $interactionSource, this$0, resultContinuation) {
    var i = new AbstractClickableNode$handlePressInteraction$slambda($this_handlePressInteraction, $offset, $interactionSource, this$0, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function AbstractClickableNode$emitHoverEnter$slambda($interactionSource, $interaction, resultContinuation) {
    this.sfp_1 = $interactionSource;
    this.tfp_1 = $interaction;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$emitHoverEnter$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$emitHoverEnter$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$emitHoverEnter$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.sfp_1.vfh(this.tfp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$emitHoverEnter$slambda).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$emitHoverEnter$slambda(this.sfp_1, this.tfp_1, completion);
    i.ufp_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$emitHoverEnter$slambda_0($interactionSource, $interaction, resultContinuation) {
    var i = new AbstractClickableNode$emitHoverEnter$slambda($interactionSource, $interaction, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AbstractClickableNode$emitHoverExit$slambda($interactionSource, $interaction, resultContinuation) {
    this.dfq_1 = $interactionSource;
    this.efq_1 = $interaction;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractClickableNode$emitHoverExit$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode$emitHoverExit$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractClickableNode$emitHoverExit$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.dfq_1.vfh(this.efq_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractClickableNode$emitHoverExit$slambda).q24 = function ($this$launch, completion) {
    var i = new AbstractClickableNode$emitHoverExit$slambda(this.dfq_1, this.efq_1, completion);
    i.ffq_1 = $this$launch;
    return i;
  };
  function AbstractClickableNode$emitHoverExit$slambda_0($interactionSource, $interaction, resultContinuation) {
    var i = new AbstractClickableNode$emitHoverExit$slambda($interactionSource, $interaction, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function $handlePressInteractionCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, offset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ofq_1 = _this__u8e3s4;
    this.pfq_1 = _this__u8e3s4_0;
    this.qfq_1 = offset;
  }
  protoOf($handlePressInteractionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.ofq_1.iff_1;
            if (tmp0_safe_receiver == null) {
              this.rfq_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = coroutineScope(AbstractClickableNode$handlePressInteraction$slambda_0(this.pfq_1, this.qfq_1, tmp0_safe_receiver, this.ofq_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            tmp_0.rfq_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function AbstractClickableNode(interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role, onClick) {
    DelegatingNode.call(this);
    this.iff_1 = interactionSource;
    this.jff_1 = indicationNodeFactory;
    this.kff_1 = useLocalIndication;
    this.lff_1 = onClickLabel;
    this.mff_1 = role;
    this.nff_1 = enabled;
    this.off_1 = onClick;
    this.pff_1 = false;
    var tmp = this;
    var tmp_0 = this.iff_1;
    var tmp_1 = Companion_getInstance_7().k9e_1;
    tmp.qff_1 = new FocusableNode(tmp_0, tmp_1, AbstractClickableNode$onFocusChange$ref(this));
    this.rff_1 = null;
    this.sff_1 = null;
    this.tff_1 = null;
    this.uff_1 = null;
    this.vff_1 = null;
    this.wff_1 = null;
    this.xff_1 = mutableLongObjectMapOf();
    this.yff_1 = Companion_getInstance_6().g5d_1;
    this.zff_1 = null;
    this.afg_1 = null;
    this.bfg_1 = this.iff_1;
    this.cfg_1 = shouldLazilyCreateIndication(this);
    this.dfg_1 = null;
    this.efg_1 = TraverseKey_instance;
  }
  protoOf(AbstractClickableNode).b8w = function () {
    return this.pff_1;
  };
  protoOf(AbstractClickableNode).dfh = function () {
    return null;
  };
  protoOf(AbstractClickableNode).efh = function (_this__u8e3s4) {
  };
  protoOf(AbstractClickableNode).afh = function (interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role, onClick) {
    var isIndicationNodeDirty = false;
    if (!equals(this.bfg_1, interactionSource)) {
      this.ffh();
      this.bfg_1 = interactionSource;
      this.iff_1 = interactionSource;
      isIndicationNodeDirty = true;
    }
    if (!equals(this.jff_1, indicationNodeFactory)) {
      this.jff_1 = indicationNodeFactory;
      isIndicationNodeDirty = true;
    }
    if (!(this.kff_1 === useLocalIndication)) {
      this.kff_1 = useLocalIndication;
      if (useLocalIndication) {
        this.w95();
      }
      isIndicationNodeDirty = true;
    }
    if (!(this.nff_1 === enabled)) {
      if (enabled) {
        this.tb1(this.qff_1);
      } else {
        this.vb1(this.qff_1);
        this.ffh();
      }
      invalidateSemantics(this);
      this.nff_1 = enabled;
    }
    if (!(this.lff_1 == onClickLabel)) {
      this.lff_1 = onClickLabel;
      invalidateSemantics(this);
    }
    var tmp = this.mff_1;
    var tmp_0 = tmp == null ? null : new Role(tmp);
    var tmp_1 = role;
    if (!equals(tmp_0, tmp_1 == null ? null : new Role(tmp_1))) {
      this.mff_1 = role;
      invalidateSemantics(this);
    }
    this.off_1 = onClick;
    if (!(this.cfg_1 === shouldLazilyCreateIndication(this))) {
      this.cfg_1 = shouldLazilyCreateIndication(this);
      if (!this.cfg_1 && this.uff_1 == null)
        isIndicationNodeDirty = true;
    }
    if (isIndicationNodeDirty) {
      recreateIndicationIfNeeded(this);
    }
    this.qff_1.tfi(this.iff_1);
  };
  protoOf(AbstractClickableNode).yfg = function (size) {
    var minimumTouchTargetSizeDp = currentValueOf(this, get_LocalViewConfiguration()).eab();
    // Inline function 'kotlin.with' call
    var minimumTouchTargetSize = requireDensity(this).f5f(minimumTouchTargetSizeDp);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(minimumTouchTargetSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(size);
    // Inline function 'kotlin.math.max' call
    var b = tmp - convertToInt(shiftRight(value_0, 32));
    var horizontal = Math.max(0.0, b) / 2.0;
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(minimumTouchTargetSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    var tmp_0 = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(size);
    // Inline function 'kotlin.math.max' call
    var b_0 = tmp_0 - convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var vertical = Math.max(0.0, b_0) / 2.0;
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(horizontal));
    var v2 = fromInt(toRawBits(vertical));
    var tmp$ret$17 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Size___init__impl__aywn0g(tmp$ret$17);
  };
  protoOf(AbstractClickableNode).f8w = function () {
    this.w95();
    if (!this.cfg_1) {
      initializeIndicationAndInteractionSourceIfNeeded(this);
    }
    if (this.nff_1) {
      this.tb1(this.qff_1);
    }
  };
  protoOf(AbstractClickableNode).w95 = function () {
    if (this.kff_1) {
      observeReads(this, AbstractClickableNode$onObservedReadsChanged$lambda(this));
    }
  };
  protoOf(AbstractClickableNode).h8w = function () {
    this.ffh();
    if (this.bfg_1 == null) {
      this.iff_1 = null;
    }
    var tmp0_safe_receiver = this.uff_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.vb1(tmp0_safe_receiver);
    }
    this.uff_1 = null;
    var tmp1_safe_receiver = this.tff_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.vb1(tmp1_safe_receiver);
    }
    this.tff_1 = null;
  };
  protoOf(AbstractClickableNode).ffh = function () {
    var tmp0_safe_receiver = this.iff_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = this.vff_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var interaction = new Cancel_0(tmp0_safe_receiver_0);
        tmp0_safe_receiver.efo(interaction);
      }
      var tmp1_safe_receiver = this.zff_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var interaction_0 = new Cancel_0(tmp1_safe_receiver);
        tmp0_safe_receiver.efo(interaction_0);
      }
      var tmp2_safe_receiver = this.wff_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var interaction_1 = new Exit(tmp2_safe_receiver);
        tmp0_safe_receiver.efo(interaction_1);
      }
      // Inline function 'androidx.collection.LongObjectMap.forEachValue' call
      var this_0 = this.xff_1;
      var v = this_0.ax_1;
      $l$block: {
        // Inline function 'androidx.collection.LongObjectMap.forEachIndexed' call
        var m = this_0.yw_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$10 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$10, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var it = v[index];
                    tmp0_safe_receiver.efo(new Cancel_0(it));
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    }
    this.vff_1 = null;
    this.zff_1 = null;
    this.afg_1 = null;
    this.wff_1 = null;
    this.xff_1.c3();
  };
  protoOf(AbstractClickableNode).aa1 = function (pointerEvent, pass, bounds) {
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.toOffset' call
    var this_0 = get_center(bounds);
    var tmp0 = _IntOffset___get_x__impl__qiqr5o(this_0);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = _IntOffset___get_y__impl__2avpwj(this_0);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$2 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    tmp.yff_1 = _Offset___init__impl__c168vi(tmp$ret$2);
    initializeIndicationAndInteractionSourceIfNeeded(this);
    if (this.nff_1) {
      initializeGestureCoordination(this);
      if (pass.equals(PointerEventPass_Main_getInstance())) {
        var tmp0_subject = pointerEvent.ha0_1;
        if (tmp0_subject === Companion_getInstance_8().oa1_1) {
          var tmp_0 = this.a8w();
          launch(tmp_0, VOID, VOID, AbstractClickableNode$onPointerEvent$slambda_0(this, null));
        } else if (tmp0_subject === Companion_getInstance_8().pa1_1) {
          var tmp_1 = this.a8w();
          launch(tmp_1, VOID, VOID, AbstractClickableNode$onPointerEvent$slambda_2(this, null));
        }
      }
    }
    if (this.sff_1 == null) {
      var node = this.dfh();
      if (!(node == null)) {
        this.sff_1 = this.tb1(node);
      }
    }
    var tmp1_safe_receiver = this.sff_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.aa1(pointerEvent, pass, bounds);
    }
  };
  protoOf(AbstractClickableNode).xa1 = function () {
    var tmp0_safe_receiver = this.iff_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = this.wff_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var interaction = new Exit(tmp0_safe_receiver_0);
        tmp = tmp0_safe_receiver.efo(interaction);
      }
    }
    this.wff_1 = null;
    var tmp1_safe_receiver = this.sff_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.xa1();
    }
  };
  protoOf(AbstractClickableNode).w9e = function (event) {
    initializeIndicationAndInteractionSourceIfNeeded(this);
    var keyCode = _Key___get_keyCode__impl__ymzu5v(get_key(event));
    var tmp;
    if (this.nff_1 && get_isPress(event)) {
      var wasInteractionHandled = false;
      if (!this.xff_1.mx(keyCode)) {
        var press = new Press(this.yff_1);
        this.xff_1.jx(keyCode, press);
        if (!(this.iff_1 == null)) {
          var tmp_0 = this.a8w();
          launch(tmp_0, VOID, VOID, AbstractClickableNode$onKeyEvent$slambda_0(this, press, null));
        }
        wasInteractionHandled = true;
      }
      tmp = this.bfh(event) || wasInteractionHandled;
    } else if (this.nff_1 && get_isClick(event)) {
      var press_0 = this.xff_1.kx(keyCode);
      if (!(press_0 == null)) {
        if (!(this.iff_1 == null)) {
          var tmp_1 = this.a8w();
          launch(tmp_1, VOID, VOID, AbstractClickableNode$onKeyEvent$slambda_2(this, press_0, null));
        }
        this.cfh(event);
      }
      tmp = !(press_0 == null);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(AbstractClickableNode).gfh = function () {
  };
  protoOf(AbstractClickableNode).v9e = function (event) {
    return false;
  };
  protoOf(AbstractClickableNode).l9j = function () {
    return true;
  };
  protoOf(AbstractClickableNode).l9i = function (_this__u8e3s4) {
    var tmp = this.mff_1;
    if (!((tmp == null ? null : new Role(tmp)) == null)) {
      var tmp_0 = this.mff_1;
      set_role(_this__u8e3s4, ensureNotNull(tmp_0 == null ? null : new Role(tmp_0)).jbw_1);
    }
    var tmp0_label = this.lff_1;
    onClick(_this__u8e3s4, tmp0_label, AbstractClickableNode$applySemantics$lambda(this));
    if (this.nff_1) {
      // Inline function 'kotlin.with' call
      this.qff_1.l9i(_this__u8e3s4);
    } else {
      disabled(_this__u8e3s4);
    }
    this.efh(_this__u8e3s4);
  };
  protoOf(AbstractClickableNode).sfq = function () {
    var tmp0_safe_receiver = this.sff_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp0_safe_receiver.fab();
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(AbstractClickableNode).gfg = function (event) {
    var tmp0_safe_receiver = this.iff_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var press = new Press(event.ka0_1);
      var tmp;
      if (delayPressInteraction_0(this, event)) {
        var tmp_0 = this;
        var tmp_1 = this.a8w();
        tmp_0.dfg_1 = launch(tmp_1, VOID, VOID, AbstractClickableNode$handlePressInteractionStart$slambda_0(tmp0_safe_receiver, press, this, null));
        tmp = Unit_instance;
      } else {
        this.vff_1 = press;
        var tmp_2 = this.a8w();
        tmp = launch(tmp_2, VOID, VOID, AbstractClickableNode$handlePressInteractionStart$slambda_2(tmp0_safe_receiver, press, null));
      }
    }
  };
  protoOf(AbstractClickableNode).ffg = function (offset, indirectPointer) {
    var tmp0_safe_receiver = this.iff_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var press = new Press(offset);
      var tmp;
      if (ComposeFoundationFlags_instance.pfg_1) {
        tmp = delayPressInteraction_0(this, null);
      } else {
        tmp = delayPressInteraction(this);
      }
      var shouldDelayPress = tmp;
      var tmp_0;
      if (shouldDelayPress) {
        var tmp_1 = this;
        var tmp_2 = this.a8w();
        tmp_1.dfg_1 = launch(tmp_2, VOID, VOID, AbstractClickableNode$handlePressInteractionStart$slambda_4(tmp0_safe_receiver, press, indirectPointer, this, null));
        tmp_0 = Unit_instance;
      } else {
        if (indirectPointer) {
          this.zff_1 = press;
        } else {
          this.vff_1 = press;
        }
        var tmp_3 = this.a8w();
        tmp_0 = launch(tmp_3, VOID, VOID, AbstractClickableNode$handlePressInteractionStart$slambda_6(tmp0_safe_receiver, press, null));
      }
    }
  };
  protoOf(AbstractClickableNode).xfg = function (offset, indirectPointer) {
    var tmp0_safe_receiver = this.iff_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var job = this.dfg_1;
      if ((job == null ? null : job.r19()) === true) {
        job.b1b();
        var tmp = this.a8w();
        launch(tmp, VOID, VOID, AbstractClickableNode$handlePressInteractionRelease$slambda_0(job, offset, tmp0_safe_receiver, null));
      } else {
        var interaction = indirectPointer ? this.zff_1 : this.vff_1;
        if (interaction == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp_0 = this.a8w();
          launch(tmp_0, VOID, VOID, AbstractClickableNode$handlePressInteractionRelease$slambda_2(interaction, tmp0_safe_receiver, null));
        }
      }
      if (indirectPointer) {
        this.zff_1 = null;
      } else {
        this.vff_1 = null;
      }
    }
  };
  protoOf(AbstractClickableNode).zfg = function (indirectPointer) {
    var tmp0_safe_receiver = this.iff_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp1_safe_receiver = this.dfg_1;
      if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r19()) === true) {
        var tmp0_safe_receiver_0 = this.dfg_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.b1b();
        }
      } else {
        var interaction = indirectPointer ? this.zff_1 : this.vff_1;
        if (interaction == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var endInteraction = new Cancel_0(interaction);
          var tmp0_safe_receiver_1 = this.a8w().q19().aa(Key_instance);
          var tmp;
          if (tmp0_safe_receiver_1 == null) {
            tmp = null;
          } else {
            tmp = tmp0_safe_receiver_1.t1a(AbstractClickableNode$handlePressInteractionCancel$lambda(tmp0_safe_receiver, endInteraction));
          }
          var handler = tmp;
          var tmp_0 = this.a8w();
          launch(tmp_0, VOID, VOID, AbstractClickableNode$handlePressInteractionCancel$slambda_0(tmp0_safe_receiver, endInteraction, handler, null));
        }
      }
      if (indirectPointer) {
        this.zff_1 = null;
      } else {
        this.vff_1 = null;
      }
    }
  };
  protoOf(AbstractClickableNode).tfq = function (_this__u8e3s4, offset, $completion) {
    var tmp = new $handlePressInteractionCOROUTINE$(this, _this__u8e3s4, offset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AbstractClickableNode).t91 = function () {
    return this.efg_1;
  };
  function requestFocusWhenInMouseInputMode(_this__u8e3s4) {
    if (isRequestFocusOnClickEnabled()) {
      requestFocus(_this__u8e3s4);
    }
  }
  function unsupportedIndicationExceptionMessage(indication) {
    return 'clickable only supports IndicationNodeFactory instances provided to LocalIndication, but Indication was provided instead. Either migrate the Indication implementation to implement IndicationNodeFactory, or use the other clickable overload that takes an Indication parameter, and explicitly pass LocalIndication.current there. The Indication' + (' instance provided here was: ' + toString(indication));
  }
  function get_isPress(_this__u8e3s4) {
    return get_type(_this__u8e3s4) === Companion_getInstance_9().e9e_1 && get_isEnter(_this__u8e3s4);
  }
  function get_isClick(_this__u8e3s4) {
    return get_type(_this__u8e3s4) === Companion_getInstance_9().d9e_1 && get_isEnter(_this__u8e3s4);
  }
  function hasScrollableContainer(_this__u8e3s4) {
    var hasScrollable = {_v: false};
    var tmp = TraverseKey_instance_3;
    traverseAncestors(_this__u8e3s4, tmp, hasScrollableContainer$lambda(hasScrollable));
    return hasScrollable._v;
  }
  function hasInterestedParent(_this__u8e3s4, event) {
    var hasInterestedParent = {_v: false};
    traverseAncestorGestureConnections(_this__u8e3s4, hasInterestedParent$lambda(event, hasInterestedParent));
    return hasInterestedParent._v;
  }
  function get_isEnter(_this__u8e3s4) {
    var tmp0_subject = get_key(_this__u8e3s4);
    return equals(tmp0_subject, Companion_getInstance_10().mcd_1) || equals(tmp0_subject, Companion_getInstance_10().acb_1) || (equals(tmp0_subject, Companion_getInstance_10().vcc_1) || equals(tmp0_subject, Companion_getInstance_10().zca_1)) ? true : false;
  }
  function combinedClickable(_this__u8e3s4, interactionSource, indication_0, enabled, onClickLabel, role, onLongClickLabel, onLongClick, onDoubleClick, hapticFeedbackEnabled, onClick) {
    enabled = enabled === VOID ? true : enabled;
    onClickLabel = onClickLabel === VOID ? null : onClickLabel;
    role = role === VOID ? null : role;
    onLongClickLabel = onLongClickLabel === VOID ? null : onLongClickLabel;
    onLongClick = onLongClick === VOID ? null : onLongClick;
    onDoubleClick = onDoubleClick === VOID ? null : onDoubleClick;
    hapticFeedbackEnabled = hapticFeedbackEnabled === VOID ? true : hapticFeedbackEnabled;
    // Inline function 'androidx.compose.foundation.clickableWithIndicationIfNeeded' call
    var tmp;
    if (!(indication_0 == null) ? isInterface(indication_0, IndicationNodeFactory) : false) {
      tmp = new CombinedClickableElement(interactionSource, indication_0, false, enabled, onClickLabel, role, onClick, onLongClickLabel, onLongClick, onDoubleClick, hapticFeedbackEnabled);
    } else {
      if (indication_0 == null) {
        tmp = new CombinedClickableElement(interactionSource, null, false, enabled, onClickLabel, role, onClick, onLongClickLabel, onLongClick, onDoubleClick, hapticFeedbackEnabled);
      } else {
        if (!(interactionSource == null)) {
          var tmp_0 = indication(Companion_instance_0, interactionSource, indication_0);
          var tmp$ret$3 = new CombinedClickableElement(interactionSource, null, false, enabled, onClickLabel, role, onClick, onLongClickLabel, onLongClick, onDoubleClick, hapticFeedbackEnabled);
          tmp = tmp_0.d8v(tmp$ret$3);
        } else {
          var tmp_1 = Companion_instance_0;
          tmp = composed(tmp_1, VOID, combinedClickable$lambda(indication_0, enabled, onClickLabel, role, onClick, onLongClickLabel, onLongClick, onDoubleClick, hapticFeedbackEnabled));
        }
      }
    }
    return _this__u8e3s4.d8v(tmp);
  }
  function CombinedClickableElement(interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role, onClick, onLongClickLabel, onLongClick, onDoubleClick, hapticFeedbackEnabled) {
    ModifierNodeElement.call(this);
    this.vfq_1 = interactionSource;
    this.wfq_1 = indicationNodeFactory;
    this.xfq_1 = useLocalIndication;
    this.yfq_1 = enabled;
    this.zfq_1 = onClickLabel;
    this.afr_1 = role;
    this.bfr_1 = onClick;
    this.cfr_1 = onLongClickLabel;
    this.dfr_1 = onLongClick;
    this.efr_1 = onDoubleClick;
    this.ffr_1 = hapticFeedbackEnabled;
  }
  protoOf(CombinedClickableElement).r3d = function () {
    return new CombinedClickableNode(this.bfr_1, this.cfr_1, this.dfr_1, this.efr_1, this.ffr_1, this.vfq_1, this.wfq_1, this.xfq_1, this.yfq_1, this.zfq_1, this.afr_1);
  };
  protoOf(CombinedClickableElement).gfr = function (node) {
    node.xfs_1 = this.ffr_1;
    node.pft(this.bfr_1, this.cfr_1, this.dfr_1, this.efr_1, this.vfq_1, this.wfq_1, this.xfq_1, this.yfq_1, this.zfq_1, this.afr_1);
  };
  protoOf(CombinedClickableElement).d8y = function (node) {
    return this.gfr(node instanceof CombinedClickableNode ? node : THROW_CCE());
  };
  protoOf(CombinedClickableElement).equals = function (other) {
    if (this === other)
      return true;
    if (other === null)
      return false;
    if (!getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof CombinedClickableElement))
      THROW_CCE();
    if (!equals(this.vfq_1, other.vfq_1))
      return false;
    if (!equals(this.wfq_1, other.wfq_1))
      return false;
    if (!(this.xfq_1 === other.xfq_1))
      return false;
    if (!(this.yfq_1 === other.yfq_1))
      return false;
    if (!(this.zfq_1 == other.zfq_1))
      return false;
    var tmp = this.afr_1;
    var tmp_0 = tmp == null ? null : new Role(tmp);
    var tmp_1 = other.afr_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new Role(tmp_1)))
      return false;
    if (!(this.bfr_1 === other.bfr_1))
      return false;
    if (!(this.cfr_1 == other.cfr_1))
      return false;
    if (!(this.dfr_1 === other.dfr_1))
      return false;
    if (!(this.efr_1 === other.efr_1))
      return false;
    if (!(this.ffr_1 === other.ffr_1))
      return false;
    return true;
  };
  protoOf(CombinedClickableElement).hashCode = function () {
    var tmp0_safe_receiver = this.vfq_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.wfq_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    result = imul(31, result) + getBooleanHashCode(this.xfq_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.yfq_1) | 0;
    var tmp_0 = imul(31, result);
    var tmp4_safe_receiver = this.zfq_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : getStringHashCode(tmp4_safe_receiver);
    result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    var tmp_1 = imul(31, result);
    var tmp6_safe_receiver = this.afr_1;
    var tmp_2;
    var tmp_3 = tmp6_safe_receiver;
    if ((tmp_3 == null ? null : new Role(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      tmp_2 = Role__hashCode_impl_ucjza4(tmp6_safe_receiver);
    }
    var tmp7_elvis_lhs = tmp_2;
    result = tmp_1 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0;
    result = imul(31, result) + hashCode(this.bfr_1) | 0;
    var tmp_4 = imul(31, result);
    var tmp8_safe_receiver = this.cfr_1;
    var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : getStringHashCode(tmp8_safe_receiver);
    result = tmp_4 + (tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs) | 0;
    var tmp_5 = imul(31, result);
    var tmp10_safe_receiver = this.dfr_1;
    var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : hashCode(tmp10_safe_receiver);
    result = tmp_5 + (tmp11_elvis_lhs == null ? 0 : tmp11_elvis_lhs) | 0;
    var tmp_6 = imul(31, result);
    var tmp12_safe_receiver = this.efr_1;
    var tmp13_elvis_lhs = tmp12_safe_receiver == null ? null : hashCode(tmp12_safe_receiver);
    result = tmp_6 + (tmp13_elvis_lhs == null ? 0 : tmp13_elvis_lhs) | 0;
    result = imul(31, result) + getBooleanHashCode(this.ffr_1) | 0;
    return result;
  };
  function CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$lambda(this$0) {
    return function (it) {
      requestFocusWhenInMouseInputMode(this$0);
      var tmp0_safe_receiver = this$0.wfs_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver();
      return Unit_instance;
    };
  }
  function CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$lambda_0(this$0) {
    return function (it) {
      requestFocusWhenInMouseInputMode(this$0);
      var tmp0_safe_receiver = this$0.vfs_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver();
      var tmp;
      if (this$0.xfs_1) {
        currentValueOf(this$0, get_LocalHapticFeedback()).hcu(Companion_instance_1.g9t());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$slambda(this$0, resultContinuation) {
    this.yft_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$slambda).bfu = function ($this$detectTapGestures, offset, $completion) {
    var tmp = this.cfu($this$detectTapGestures, offset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, PressGestureScope) : false) ? p1 : THROW_CCE();
    return this.bfu(tmp, p2 instanceof Offset ? p2.e5d_1 : THROW_CCE(), $completion);
  };
  protoOf(CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.yft_1.nff_1) {
              requestFocusWhenInMouseInputMode(this.yft_1);
              this.n9_1 = 1;
              suspendResult = this.yft_1.tfq(this.zft_1, this.afu_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$slambda).cfu = function ($this$detectTapGestures, offset, completion) {
    var i = new CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$slambda(this.yft_1, completion);
    i.zft_1 = $this$detectTapGestures;
    i.afu_1 = offset;
    return i;
  };
  function CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$detectTapGestures, offset, $completion) {
      return i.bfu($this$detectTapGestures, offset.e5d_1, $completion);
    }, 2);
  }
  function CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$lambda_1(this$0) {
    return function (it) {
      var tmp;
      if (this$0.nff_1) {
        tmp = this$0.off_1();
      }
      return Unit_instance;
    };
  }
  function DoubleKeyClickState(job) {
    this.dfu_1 = job;
    this.efu_1 = false;
  }
  function handleDownEvent_0($this, down) {
    down.ra2();
    $this.bft_1 = down;
    if ($this.nff_1) {
      var tmp1_safe_receiver = $this.dft_1;
      if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r19()) === true) {
        var minTime = currentValueOf($this, get_LocalViewConfiguration()).tb9();
        if (compare(subtract(down.ja0_1, $this.gft_1), minTime) < 0) {
          $this.hft_1 = true;
          return Unit_instance;
        } else {
          $this.eft_1 = true;
          var tmp0_safe_receiver = $this.dft_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.b1b();
          }
          $this.dft_1 = null;
        }
      }
      $this.fft_1 = false;
      if (ComposeFoundationFlags_instance.pfg_1) {
        $this.gfg(down);
      } else {
        $this.ffg(down.ka0_1, false);
      }
      if (!($this.vfs_1 == null)) {
        var tmp = $this;
        var tmp_0 = $this.a8w();
        tmp.cft_1 = launch(tmp_0, VOID, VOID, CombinedClickableNode$handleDownEvent$slambda_0($this, null));
      }
    }
  }
  function handleUpEvent_0($this, uptimeMillis, downChange) {
    if ($this.nff_1 && !$this.hft_1) {
      $this.xfg(downChange.ka0_1, false);
      $this.gft_1 = uptimeMillis;
      if (!$this.fft_1) {
        if ($this.eft_1) {
          var tmp0_safe_receiver = $this.wfs_1;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver();
        } else {
          if (!($this.wfs_1 == null)) {
            var tmp = $this;
            var tmp_0 = $this.a8w();
            tmp.dft_1 = launch(tmp_0, VOID, VOID, CombinedClickableNode$handleUpEvent$slambda_0($this, null));
          } else {
            $this.off_1();
          }
        }
      }
    }
    $this.bft_1 = null;
    $this.hft_1 = false;
    $this.eft_1 = false;
    var tmp1_safe_receiver = $this.cft_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.b1b();
    }
    $this.cft_1 = null;
    $this.fft_1 = false;
  }
  function handleNonUpEventIfNeeded_0($this, pointerEvent, bounds) {
    var touchPadding = $this.yfg(bounds);
    var tmp0 = pointerEvent.ca0_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (item.qa2() || isOutOfBounds(item, bounds, touchPadding)) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      cancelInput_0($this, false);
    }
  }
  function handleDeepPress($this) {
    if (!$this.fft_1 && $this.nff_1 && !($this.vfs_1 == null)) {
      var tmp0_safe_receiver = $this.cft_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.b1b();
      }
      $this.cft_1 = null;
      var tmp1_safe_receiver = $this.vfs_1;
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver();
      if ($this.xfs_1) {
        currentValueOf($this, get_LocalHapticFeedback()).hcu(Companion_instance_1.g9t());
      }
      $this.fft_1 = true;
    }
  }
  function checkForCancellation_0($this, pointerEvent) {
    if (!($this.bft_1 == null) && !$this.fft_1) {
      var tmp0 = pointerEvent.ca0_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastAny' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = tmp0.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = tmp0.l1(index);
            if (item.qa2() && !equals(item, $this.bft_1)) {
              tmp$ret$0 = true;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$0 = false;
      }
      if (tmp$ret$0) {
        cancelInput_0($this, false);
      }
    }
  }
  function cancelInput_0($this, indirectPointer) {
    if (indirectPointer) {
      $this.ift_1 = null;
      var tmp0_safe_receiver = $this.jft_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.b1b();
      }
      $this.jft_1 = null;
      var tmp1_safe_receiver = $this.kft_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.b1b();
      }
      $this.kft_1 = null;
      $this.lft_1 = false;
      $this.mft_1 = false;
      $this.nft_1 = new Long(-1, -1);
      $this.oft_1 = false;
    } else {
      $this.bft_1 = null;
      var tmp2_safe_receiver = $this.cft_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.b1b();
      }
      $this.cft_1 = null;
      var tmp3_safe_receiver = $this.dft_1;
      if (tmp3_safe_receiver == null)
        null;
      else {
        tmp3_safe_receiver.b1b();
      }
      $this.dft_1 = null;
      $this.eft_1 = false;
      $this.fft_1 = false;
      $this.gft_1 = new Long(-1, -1);
      $this.hft_1 = false;
    }
    $this.zfg(indirectPointer);
  }
  function resetKeyPressState($this) {
    // Inline function 'kotlin.apply' call
    var this_0 = $this.yfs_1;
    // Inline function 'androidx.collection.LongObjectMap.forEachValue' call
    var v = this_0.ax_1;
    $l$block: {
      // Inline function 'androidx.collection.LongObjectMap.forEachIndexed' call
      var m = this_0.yw_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  v[index].b1b();
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    this_0.c3();
    // Inline function 'kotlin.apply' call
    var this_2 = $this.zfs_1;
    // Inline function 'androidx.collection.LongObjectMap.forEachValue' call
    var v_0 = this_2.ax_1;
    $l$block_0: {
      // Inline function 'androidx.collection.LongObjectMap.forEachIndexed' call
      var m_0 = this_2.yw_1;
      var lastIndex_0 = m_0.length - 2 | 0;
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= lastIndex_0)
        do {
          var i_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var slot_0 = m_0[i_0];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_3 = slot_0;
          var tmp$ret$12 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$12, new Long(-2139062144, -2139062144))) {
            var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < bitCount_0)
              do {
                var j_0 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                if (compare(value_0, new Long(128, 0)) < 0) {
                  var index_0 = (i_0 << 3) + j_0 | 0;
                  v_0[index_0].dfu_1.b1b();
                }
                slot_0 = shiftRight(slot_0, 8);
              }
               while (inductionVariable_2 < bitCount_0);
            if (!(bitCount_0 === 8)) {
              break $l$block_0;
            }
          }
        }
         while (!(i_0 === lastIndex_0));
    }
    this_2.c3();
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0(function_0) {
    this.ffu_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).ka7 = function (_this__u8e3s4, $completion) {
    return this.ffu_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).q3 = function () {
    return this.ffu_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function CombinedClickableNode$createPointerInputNodeIfNeeded$slambda(this$0, resultContinuation) {
    this.ofu_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CombinedClickableNode$createPointerInputNodeIfNeeded$slambda).vc6 = function ($this$SuspendingPointerInputModifierNode, $completion) {
    var tmp = this.wc6($this$SuspendingPointerInputModifierNode, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CombinedClickableNode$createPointerInputNodeIfNeeded$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CombinedClickableNode$createPointerInputNodeIfNeeded$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0;
            if (this.ofu_1.nff_1 && !(this.ofu_1.wfs_1 == null)) {
              tmp_0 = CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$lambda(this.ofu_1);
            } else {
              tmp_0 = null;
            }

            var tmp_1 = tmp_0;
            var tmp_2;
            if (this.ofu_1.nff_1 && !(this.ofu_1.vfs_1 == null)) {
              tmp_2 = CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$lambda_0(this.ofu_1);
            } else {
              tmp_2 = null;
            }

            var tmp_3 = tmp_2;
            var tmp_4 = CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$slambda_0(this.ofu_1, null);
            suspendResult = detectTapGestures(this.pfu_1, tmp_1, tmp_3, tmp_4, CombinedClickableNode$createPointerInputNodeIfNeeded$slambda$lambda_1(this.ofu_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CombinedClickableNode$createPointerInputNodeIfNeeded$slambda).wc6 = function ($this$SuspendingPointerInputModifierNode, completion) {
    var i = new CombinedClickableNode$createPointerInputNodeIfNeeded$slambda(this.ofu_1, completion);
    i.pfu_1 = $this$SuspendingPointerInputModifierNode;
    return i;
  };
  function CombinedClickableNode$createPointerInputNodeIfNeeded$slambda_0(this$0, resultContinuation) {
    var i = new CombinedClickableNode$createPointerInputNodeIfNeeded$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$SuspendingPointerInputModifierNode, $completion) {
      return i.vc6($this$SuspendingPointerInputModifierNode, $completion);
    }, 1);
  }
  function CombinedClickableNode$handleDownEvent$slambda(this$0, resultContinuation) {
    this.yfu_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CombinedClickableNode$handleDownEvent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CombinedClickableNode$handleDownEvent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CombinedClickableNode$handleDownEvent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(currentValueOf(this.yfu_1, get_LocalViewConfiguration()).rb9(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = this.yfu_1.vfs_1;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver();
            if (this.yfu_1.xfs_1) {
              currentValueOf(this.yfu_1, get_LocalHapticFeedback()).hcu(Companion_instance_1.g9t());
            }

            this.yfu_1.fft_1 = true;
            var tmp1_safe_receiver = this.yfu_1.dft_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.b1b();
            }

            this.yfu_1.dft_1 = null;
            this.yfu_1.cft_1 = null;
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CombinedClickableNode$handleDownEvent$slambda).q24 = function ($this$launch, completion) {
    var i = new CombinedClickableNode$handleDownEvent$slambda(this.yfu_1, completion);
    i.zfu_1 = $this$launch;
    return i;
  };
  function CombinedClickableNode$handleDownEvent$slambda_0(this$0, resultContinuation) {
    var i = new CombinedClickableNode$handleDownEvent$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CombinedClickableNode$handleUpEvent$slambda(this$0, resultContinuation) {
    this.ifv_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CombinedClickableNode$handleUpEvent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CombinedClickableNode$handleUpEvent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CombinedClickableNode$handleUpEvent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(currentValueOf(this.ifv_1, get_LocalViewConfiguration()).sb9(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ifv_1.off_1();
            this.ifv_1.dft_1 = null;
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CombinedClickableNode$handleUpEvent$slambda).q24 = function ($this$launch, completion) {
    var i = new CombinedClickableNode$handleUpEvent$slambda(this.ifv_1, completion);
    i.jfv_1 = $this$launch;
    return i;
  };
  function CombinedClickableNode$handleUpEvent$slambda_0(this$0, resultContinuation) {
    var i = new CombinedClickableNode$handleUpEvent$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CombinedClickableNode$applyAdditionalSemantics$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.vfs_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver();
      return true;
    };
  }
  function CombinedClickableNode$onClickKeyDownEvent$slambda(this$0, resultContinuation) {
    this.sfv_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CombinedClickableNode$onClickKeyDownEvent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CombinedClickableNode$onClickKeyDownEvent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CombinedClickableNode$onClickKeyDownEvent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(currentValueOf(this.sfv_1, get_LocalViewConfiguration()).rb9(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = this.sfv_1.vfs_1;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver();
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CombinedClickableNode$onClickKeyDownEvent$slambda).q24 = function ($this$launch, completion) {
    var i = new CombinedClickableNode$onClickKeyDownEvent$slambda(this.sfv_1, completion);
    i.tfv_1 = $this$launch;
    return i;
  };
  function CombinedClickableNode$onClickKeyDownEvent$slambda_0(this$0, resultContinuation) {
    var i = new CombinedClickableNode$onClickKeyDownEvent$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CombinedClickableNode$onClickKeyUpEvent$slambda(this$0, $keyCode, resultContinuation) {
    this.cfw_1 = this$0;
    this.dfw_1 = $keyCode;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CombinedClickableNode$onClickKeyUpEvent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CombinedClickableNode$onClickKeyUpEvent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CombinedClickableNode$onClickKeyUpEvent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var configuration = currentValueOf(this.cfw_1, get_LocalViewConfiguration());
            this.ffw_1 = configuration.tb9();
            this.gfw_1 = configuration.sb9();
            this.n9_1 = 1;
            suspendResult = delay(this.ffw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = this.cfw_1.zfs_1.lx(this.dfw_1);
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.efu_1 = true;
            }

            this.n9_1 = 2;
            suspendResult = delay(subtract(this.gfw_1, this.ffw_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.cfw_1.off_1();
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CombinedClickableNode$onClickKeyUpEvent$slambda).q24 = function ($this$launch, completion) {
    var i = new CombinedClickableNode$onClickKeyUpEvent$slambda(this.cfw_1, this.dfw_1, completion);
    i.efw_1 = $this$launch;
    return i;
  };
  function CombinedClickableNode$onClickKeyUpEvent$slambda_0(this$0, $keyCode, resultContinuation) {
    var i = new CombinedClickableNode$onClickKeyUpEvent$slambda(this$0, $keyCode, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CombinedClickableNode(onClick, onLongClickLabel, onLongClick, onDoubleClick, hapticFeedbackEnabled, interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role) {
    AbstractClickableNode.call(this, interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role, onClick);
    this.ufs_1 = onLongClickLabel;
    this.vfs_1 = onLongClick;
    this.wfs_1 = onDoubleClick;
    this.xfs_1 = hapticFeedbackEnabled;
    this.yfs_1 = mutableLongObjectMapOf();
    this.zfs_1 = mutableLongObjectMapOf();
    this.aft_1 = !ComposeFoundationFlags_instance.sfg_1;
    this.bft_1 = null;
    this.cft_1 = null;
    this.dft_1 = null;
    this.eft_1 = false;
    this.fft_1 = false;
    this.gft_1 = new Long(-1, -1);
    this.hft_1 = false;
    this.ift_1 = null;
    this.jft_1 = null;
    this.kft_1 = null;
    this.lft_1 = false;
    this.mft_1 = false;
    this.nft_1 = new Long(-1, -1);
    this.oft_1 = false;
  }
  protoOf(CombinedClickableNode).dfh = function () {
    if (this.aft_1) {
      var tmp = CombinedClickableNode$createPointerInputNodeIfNeeded$slambda_0(this, null);
      return SuspendingPointerInputModifierNode(new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0(tmp));
    }
    return null;
  };
  protoOf(CombinedClickableNode).aa1 = function (pointerEvent, pass, bounds) {
    protoOf(AbstractClickableNode).aa1.call(this, pointerEvent, pass, bounds);
    if (this.aft_1)
      return Unit_instance;
    if (pass.equals(PointerEventPass_Main_getInstance())) {
      if (this.bft_1 == null) {
        if (isChangedToDown(pointerEvent, true)) {
          handleDownEvent_0(this, pointerEvent.ca0_1.l1(0));
        }
      } else {
        if (get_isDeepPress(pointerEvent)) {
          handleDeepPress(this);
        }
        if (this.fft_1) {
          var tmp0 = pointerEvent.ca0_1;
          var tmp$ret$0;
          $l$block: {
            // Inline function 'androidx.compose.ui.util.fastAll' call
            // Inline function 'androidx.compose.ui.util.fastForEach' call
            var inductionVariable = 0;
            var last = tmp0.n1() - 1 | 0;
            if (inductionVariable <= last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var item = tmp0.l1(index);
                if (!changedToUpIgnoreConsumed(item)) {
                  tmp$ret$0 = false;
                  break $l$block;
                }
              }
               while (inductionVariable <= last);
            tmp$ret$0 = true;
          }
          if (tmp$ret$0) {
            var up = pointerEvent.ca0_1.l1(0);
            up.ra2();
            handleUpEvent_0(this, up.ja0_1, ensureNotNull(this.bft_1));
          } else {
            // Inline function 'androidx.compose.ui.util.fastForEach' call
            var this_0 = pointerEvent.ca0_1;
            var inductionVariable_0 = 0;
            var last_0 = this_0.n1() - 1 | 0;
            if (inductionVariable_0 <= last_0)
              do {
                var index_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var item_0 = this_0.l1(index_0);
                item_0.ra2();
              }
               while (inductionVariable_0 <= last_0);
          }
          return Unit_instance;
        }
        var tmp0_0 = pointerEvent.ca0_1;
        var tmp$ret$6;
        $l$block_0: {
          // Inline function 'androidx.compose.ui.util.fastAll' call
          // Inline function 'androidx.compose.ui.util.fastForEach' call
          var inductionVariable_1 = 0;
          var last_1 = tmp0_0.n1() - 1 | 0;
          if (inductionVariable_1 <= last_1)
            do {
              var index_1 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var item_1 = tmp0_0.l1(index_1);
              if (!changedToUp(item_1)) {
                tmp$ret$6 = false;
                break $l$block_0;
              }
            }
             while (inductionVariable_1 <= last_1);
          tmp$ret$6 = true;
        }
        if (tmp$ret$6) {
          var up_0 = pointerEvent.ca0_1.l1(0);
          up_0.ra2();
          handleUpEvent_0(this, up_0.ja0_1, ensureNotNull(this.bft_1));
        } else {
          handleNonUpEventIfNeeded_0(this, pointerEvent, bounds);
        }
      }
    } else if (pass.equals(PointerEventPass_Final_getInstance())) {
      checkForCancellation_0(this, pointerEvent);
    }
  };
  protoOf(CombinedClickableNode).xa1 = function () {
    protoOf(AbstractClickableNode).xa1.call(this);
    cancelInput_0(this, false);
  };
  protoOf(CombinedClickableNode).d9u = function () {
    cancelInput_0(this, true);
  };
  protoOf(CombinedClickableNode).pft = function (onClick, onLongClickLabel, onLongClick, onDoubleClick, interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role) {
    var resetPointerInputHandling = false;
    if (!(this.ufs_1 == onLongClickLabel)) {
      this.ufs_1 = onLongClickLabel;
      invalidateSemantics(this);
    }
    if (!(this.vfs_1 == null === (onLongClick == null))) {
      this.ffh();
      invalidateSemantics(this);
      resetPointerInputHandling = true;
    }
    this.vfs_1 = onLongClick;
    if (!(this.wfs_1 == null === (onDoubleClick == null))) {
      resetPointerInputHandling = true;
    }
    this.wfs_1 = onDoubleClick;
    if (!(this.nff_1 === enabled)) {
      resetPointerInputHandling = true;
    }
    this.afh(interactionSource, indicationNodeFactory, useLocalIndication, enabled, onClickLabel, role, onClick);
    if (resetPointerInputHandling) {
      this.sfq();
      cancelInput_0(this, false);
      cancelInput_0(this, true);
    }
  };
  protoOf(CombinedClickableNode).efh = function (_this__u8e3s4) {
    if (!(this.vfs_1 == null)) {
      var tmp0_label = this.ufs_1;
      onLongClick(_this__u8e3s4, tmp0_label, CombinedClickableNode$applyAdditionalSemantics$lambda(this));
    }
  };
  protoOf(CombinedClickableNode).bfh = function (event) {
    var keyCode = _Key___get_keyCode__impl__ymzu5v(get_key(event));
    var handledByLongClick = false;
    if (!(this.vfs_1 == null)) {
      if (this.yfs_1.lx(keyCode) == null) {
        var tmp = this.a8w();
        this.yfs_1.jx(keyCode, launch(tmp, VOID, VOID, CombinedClickableNode$onClickKeyDownEvent$slambda_0(this, null)));
        handledByLongClick = true;
      }
    }
    var doubleClickState = this.zfs_1.lx(keyCode);
    if (!(doubleClickState == null)) {
      if (doubleClickState.dfu_1.r19()) {
        doubleClickState.dfu_1.b1b();
        if (!doubleClickState.efu_1) {
          this.off_1();
          this.zfs_1.kx(keyCode);
        }
      } else {
        this.zfs_1.kx(keyCode);
      }
    }
    return handledByLongClick;
  };
  protoOf(CombinedClickableNode).cfh = function (event) {
    var keyCode = _Key___get_keyCode__impl__ymzu5v(get_key(event));
    var longClickInvoked = false;
    if (!(this.yfs_1.lx(keyCode) == null)) {
      var tmp0_safe_receiver = this.yfs_1.lx(keyCode);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        if (tmp0_safe_receiver.r19()) {
          tmp0_safe_receiver.b1b();
        } else {
          longClickInvoked = true;
        }
      }
      this.yfs_1.kx(keyCode);
    }
    if (!(this.wfs_1 == null)) {
      if (this.zfs_1.lx(keyCode) == null) {
        if (!longClickInvoked) {
          var tmp = this.a8w();
          this.zfs_1.jx(keyCode, new DoubleKeyClickState(launch(tmp, VOID, VOID, CombinedClickableNode$onClickKeyUpEvent$slambda_0(this, keyCode, null))));
        }
      } else {
        if (!longClickInvoked) {
          var tmp1_safe_receiver = this.wfs_1;
          if (tmp1_safe_receiver == null)
            null;
          else
            tmp1_safe_receiver();
        }
        this.zfs_1.kx(keyCode);
      }
    } else {
      if (!longClickInvoked) {
        this.off_1();
      }
    }
    return true;
  };
  protoOf(CombinedClickableNode).gfh = function () {
    resetKeyPressState(this);
  };
  protoOf(CombinedClickableNode).k8w = function () {
    protoOf(AbstractClickableNode).k8w.call(this);
    resetKeyPressState(this);
  };
  function clickable$lambda($indication, $enabled, $onClickLabel, $role, $onClick) {
    return function ($this$composed, $composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(-1525724089);
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = funMutableInteractionSource();
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var newInteractionSource = tmp;
      var tmp_0 = indication(Companion_instance_0, newInteractionSource, $indication);
      var tmp$ret$4 = new ClickableElement(newInteractionSource, null, false, $enabled, $onClickLabel, $role, $onClick);
      var tmp0 = tmp_0.d8v(tmp$ret$4);
      $composer_0.n30();
      return tmp0;
    };
  }
  function hasScrollableContainer$lambda($hasScrollable) {
    return function (node) {
      var tmp;
      if ($hasScrollable._v) {
        tmp = true;
      } else {
        tmp = (node instanceof ScrollableContainerNode ? node : THROW_CCE()).wfw_1;
      }
      $hasScrollable._v = tmp;
      return !$hasScrollable._v;
    };
  }
  function hasInterestedParent$lambda($event, $hasInterestedParent) {
    return function (coordinator) {
      var isCoordinatorInterested = coordinator.hfh($event);
      $hasInterestedParent._v = $hasInterestedParent._v || isCoordinatorInterested;
      return !$hasInterestedParent._v;
    };
  }
  function combinedClickable$lambda($indication, $enabled, $onClickLabel, $role, $onClick, $onLongClickLabel, $onLongClick, $onDoubleClick, $hapticFeedbackEnabled) {
    return function ($this$composed, $composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(-1525724089);
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = funMutableInteractionSource();
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var newInteractionSource = tmp;
      var tmp_0 = indication(Companion_instance_0, newInteractionSource, $indication);
      var tmp$ret$4 = new CombinedClickableElement(newInteractionSource, null, false, $enabled, $onClickLabel, $role, $onClick, $onLongClickLabel, $onLongClick, $onDoubleClick, $hapticFeedbackEnabled);
      var tmp0 = tmp_0.d8v(tmp$ret$4);
      $composer_0.n30();
      return tmp0;
    };
  }
  function get_MaxSupportedElevation() {
    _init_properties_ClipScrollableContainer_kt__60yb60();
    return MaxSupportedElevation;
  }
  var MaxSupportedElevation;
  function clipScrollableContainer(_this__u8e3s4, orientation) {
    _init_properties_ClipScrollableContainer_kt__60yb60();
    var tmp;
    if (orientation.equals(Orientation_Vertical_getInstance())) {
      tmp = clip(Companion_instance_0, VerticalScrollableClipShape_instance);
    } else {
      tmp = clip(Companion_instance_0, HorizontalScrollableClipShape_instance);
    }
    return _this__u8e3s4.d8v(tmp);
  }
  function VerticalScrollableClipShape() {
  }
  protoOf(VerticalScrollableClipShape).l6j = function (size, layoutDirection, density) {
    // Inline function 'kotlin.with' call
    var inflateSize = density.w5e(get_MaxSupportedElevation());
    var tmp = -inflateSize;
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits) + inflateSize;
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$6 = floatFromBits(bits_0);
    return new Rectangle(new Rect(tmp, 0.0, tmp_0, tmp$ret$6));
  };
  var VerticalScrollableClipShape_instance;
  function VerticalScrollableClipShape_getInstance() {
    return VerticalScrollableClipShape_instance;
  }
  function HorizontalScrollableClipShape() {
  }
  protoOf(HorizontalScrollableClipShape).l6j = function (size, layoutDirection, density) {
    // Inline function 'kotlin.with' call
    var inflateSize = density.w5e(get_MaxSupportedElevation());
    var tmp = -inflateSize;
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$6 = floatFromBits(bits_0);
    return new Rectangle(new Rect(0.0, tmp, tmp_0, tmp$ret$6 + inflateSize));
  };
  var HorizontalScrollableClipShape_instance;
  function HorizontalScrollableClipShape_getInstance() {
    return HorizontalScrollableClipShape_instance;
  }
  var properties_initialized_ClipScrollableContainer_kt_l2hne;
  function _init_properties_ClipScrollableContainer_kt__60yb60() {
    if (!properties_initialized_ClipScrollableContainer_kt_l2hne) {
      properties_initialized_ClipScrollableContainer_kt_l2hne = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      MaxSupportedElevation = _Dp___init__impl__ms3zkb(30);
    }
  }
  var androidx_compose_foundation_ComposeFoundationFlags$stable;
  function ComposeFoundationFlags() {
    this.hfg_1 = false;
    this.ifg_1 = true;
    this.jfg_1 = true;
    this.kfg_1 = true;
    this.lfg_1 = true;
    this.mfg_1 = true;
    this.nfg_1 = true;
    this.ofg_1 = true;
    this.pfg_1 = true;
    this.qfg_1 = true;
    this.rfg_1 = true;
    this.sfg_1 = true;
    this.tfg_1 = true;
    this.ufg_1 = true;
    this.vfg_1 = true;
    this.wfg_1 = true;
  }
  var ComposeFoundationFlags_instance;
  function ComposeFoundationFlags_getInstance() {
    return ComposeFoundationFlags_instance;
  }
  function isSystemInDarkTheme($composer, $changed) {
    var $composer_0 = $composer;
    return _isSystemInDarkTheme($composer_0, 0);
  }
  var androidx_compose_foundation_FocusableNode$stable;
  function TraverseKey_0() {
  }
  var TraverseKey_instance_0;
  function TraverseKey_getInstance_0() {
    return TraverseKey_instance_0;
  }
  function _get_focusedBoundsObserver__j1jje9($this) {
    var tmp;
    if ($this.z8v_1) {
      var tmp_0 = findNearestAncestor($this, TraverseKey_instance_1);
      tmp = tmp_0 instanceof FocusedBoundsObserverNode ? tmp_0 : null;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function onFocusStateChange($this, previousState, currentState) {
    if (!$this.z8v_1)
      return Unit_instance;
    var isFocused = currentState.s9h();
    var wasFocused = previousState.s9h();
    if (isFocused === wasFocused)
      return Unit_instance;
    var tmp0_safe_receiver = $this.nfi_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(isFocused);
    if (isFocused) {
      var tmp = $this.a8w();
      launch(tmp, VOID, VOID, FocusableNode$onFocusStateChange$slambda_0($this, null));
      var pinnableContainer = retrievePinnableContainer($this);
      var tmp_0 = $this;
      tmp_0.qfi_1 = pinnableContainer == null ? null : pinnableContainer.nfx();
      notifyObserverWhenAttached($this);
    } else {
      var tmp2_safe_receiver = $this.qfi_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.r2v();
      }
      $this.qfi_1 = null;
      var tmp3_safe_receiver = _get_focusedBoundsObserver__j1jje9($this);
      if (tmp3_safe_receiver == null)
        null;
      else {
        tmp3_safe_receiver.mfx(null);
      }
    }
    invalidateSemantics($this);
    emitInteraction($this, isFocused);
  }
  function retrievePinnableContainer($this) {
    var container = {_v: null};
    observeReads($this, FocusableNode$retrievePinnableContainer$lambda(container, $this));
    return container._v;
  }
  function notifyObserverWhenAttached($this) {
    if (!($this.rfi_1 == null) && ensureNotNull($this.rfi_1).y91()) {
      var tmp0_safe_receiver = _get_focusedBoundsObserver__j1jje9($this);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.mfx($this.rfi_1);
      }
    }
  }
  function emitInteraction($this, isFocused) {
    var tmp0_safe_receiver = $this.mfi_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp;
      if (isFocused) {
        var tmp0_safe_receiver_0 = $this.pfi_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var interaction = new Unfocus(tmp0_safe_receiver_0);
          emitWithFallback($this, tmp0_safe_receiver, interaction);
          $this.pfi_1 = null;
        }
        var interaction_0 = new Focus();
        emitWithFallback($this, tmp0_safe_receiver, interaction_0);
        $this.pfi_1 = interaction_0;
        tmp = Unit_instance;
      } else {
        var tmp1_safe_receiver = $this.pfi_1;
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var interaction_1 = new Unfocus(tmp1_safe_receiver);
          emitWithFallback($this, tmp0_safe_receiver, interaction_1);
          $this.pfi_1 = null;
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
    }
  }
  function disposeInteractionSource($this) {
    var tmp0_safe_receiver = $this.mfi_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = $this.pfi_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var interaction = new Unfocus(tmp0_safe_receiver_0);
        tmp = tmp0_safe_receiver.efo(interaction);
      }
    }
    $this.pfi_1 = null;
  }
  function emitWithFallback($this, $receiver, interaction) {
    if ($this.z8v_1) {
      var tmp0_safe_receiver = $this.a8w().q19().aa(Key_instance);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp0_safe_receiver.t1a(FocusableNode$emitWithFallback$lambda($receiver, interaction));
      }
      var handler = tmp;
      var tmp_0 = $this.a8w();
      launch(tmp_0, VOID, VOID, FocusableNode$emitWithFallback$slambda_0($receiver, interaction, handler, null));
    } else {
      $receiver.efo(interaction);
    }
  }
  function FocusableNode$onFocusStateChange$ref(p0) {
    return constructCallableReference(function (p0_0, p1) {
      var tmp0 = p0;
      onFocusStateChange(tmp0, p0_0, p1);
      return Unit_instance;
    }, 2, 0, 239, 'onFocusStateChange', [p0]);
  }
  function FocusableNode$onFocusStateChange$slambda(this$0, resultContinuation) {
    this.wfx_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FocusableNode$onFocusStateChange$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FocusableNode$onFocusStateChange$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FocusableNode$onFocusStateChange$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = bringIntoView(this.wfx_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FocusableNode$onFocusStateChange$slambda).q24 = function ($this$launch, completion) {
    var i = new FocusableNode$onFocusStateChange$slambda(this.wfx_1, completion);
    i.xfx_1 = $this$launch;
    return i;
  };
  function FocusableNode$onFocusStateChange$slambda_0(this$0, resultContinuation) {
    var i = new FocusableNode$onFocusStateChange$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function FocusableNode$requestFocus$ref(p0) {
    return constructCallableReference(function () {
      return p0.pco();
    }, 0, 0, 240, 'requestFocus', [p0]);
  }
  function FocusableNode$retrievePinnableContainer$lambda($container, this$0) {
    return function () {
      $container._v = currentValueOf(this$0, get_LocalPinnableContainer());
      return Unit_instance;
    };
  }
  function FocusableNode$emitWithFallback$lambda($this_emitWithFallback, $interaction) {
    return function (it) {
      $this_emitWithFallback.efo($interaction);
      return Unit_instance;
    };
  }
  function FocusableNode$emitWithFallback$slambda($this_emitWithFallback, $interaction, $handler, resultContinuation) {
    this.gfy_1 = $this_emitWithFallback;
    this.hfy_1 = $interaction;
    this.ify_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FocusableNode$emitWithFallback$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FocusableNode$emitWithFallback$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FocusableNode$emitWithFallback$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.gfy_1.vfh(this.hfy_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = this.ify_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.s1d();
            }

            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FocusableNode$emitWithFallback$slambda).q24 = function ($this$launch, completion) {
    var i = new FocusableNode$emitWithFallback$slambda(this.gfy_1, this.hfy_1, this.ify_1, completion);
    i.jfy_1 = $this$launch;
    return i;
  };
  function FocusableNode$emitWithFallback$slambda_0($this_emitWithFallback, $interaction, $handler, resultContinuation) {
    var i = new FocusableNode$emitWithFallback$slambda($this_emitWithFallback, $interaction, $handler, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function FocusableNode(interactionSource, focusability, onFocusChange) {
    focusability = focusability === VOID ? Companion_getInstance_7().j9e_1 : focusability;
    onFocusChange = onFocusChange === VOID ? null : onFocusChange;
    DelegatingNode.call(this);
    this.mfi_1 = interactionSource;
    this.nfi_1 = onFocusChange;
    this.ofi_1 = false;
    this.pfi_1 = null;
    this.qfi_1 = null;
    this.rfi_1 = null;
    var tmp = this;
    tmp.sfi_1 = this.tb1(funFocusTargetModifierNode2(focusability, FocusableNode$onFocusStateChange$ref(this)));
  }
  protoOf(FocusableNode).b8w = function () {
    return this.ofi_1;
  };
  protoOf(FocusableNode).t91 = function () {
    return TraverseKey_instance_0;
  };
  protoOf(FocusableNode).pco = function () {
    return this.sfi_1.o9h();
  };
  protoOf(FocusableNode).tfi = function (interactionSource) {
    if (!equals(this.mfi_1, interactionSource)) {
      disposeInteractionSource(this);
      this.mfi_1 = interactionSource;
    }
  };
  protoOf(FocusableNode).l9i = function (_this__u8e3s4) {
    set_focused(_this__u8e3s4, this.sfi_1.x9c().s9h());
    requestFocus_0(_this__u8e3s4, VOID, FocusableNode$requestFocus$ref(this));
  };
  protoOf(FocusableNode).k8w = function () {
    var tmp0_safe_receiver = this.qfi_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.r2v();
    }
    this.qfi_1 = null;
  };
  protoOf(FocusableNode).w95 = function () {
    var pinnableContainer = retrievePinnableContainer(this);
    if (this.sfi_1.x9c().s9h()) {
      var tmp0_safe_receiver = this.qfi_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.r2v();
      }
      var tmp = this;
      tmp.qfi_1 = pinnableContainer == null ? null : pinnableContainer.nfx();
    }
  };
  protoOf(FocusableNode).eam = function (coordinates) {
    this.rfi_1 = coordinates;
    if (!this.sfi_1.x9c().s9h())
      return Unit_instance;
    if (coordinates.y91()) {
      notifyObserverWhenAttached(this);
    } else {
      var tmp0_safe_receiver = _get_focusedBoundsObserver__j1jje9(this);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.mfx(null);
      }
    }
  };
  function focusable(_this__u8e3s4, enabled, interactionSource) {
    enabled = enabled === VOID ? true : enabled;
    interactionSource = interactionSource === VOID ? null : interactionSource;
    var tmp;
    if (enabled) {
      tmp = new FocusableElement(interactionSource);
    } else {
      tmp = Companion_instance_0;
    }
    return _this__u8e3s4.d8v(tmp);
  }
  function FocusableElement(interactionSource) {
    ModifierNodeElement.call(this);
    this.lfy_1 = interactionSource;
  }
  protoOf(FocusableElement).r3d = function () {
    return new FocusableNode(this.lfy_1);
  };
  protoOf(FocusableElement).mfy = function (node) {
    node.tfi(this.lfy_1);
  };
  protoOf(FocusableElement).d8y = function (node) {
    return this.mfy(node instanceof FocusableNode ? node : THROW_CCE());
  };
  protoOf(FocusableElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FocusableElement))
      return false;
    if (!equals(this.lfy_1, other.lfy_1))
      return false;
    return true;
  };
  protoOf(FocusableElement).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.lfy_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  var androidx_compose_foundation_FocusedBoundsObserverNode$stable;
  function TraverseKey_1() {
  }
  var TraverseKey_instance_1;
  function TraverseKey_getInstance_1() {
    return TraverseKey_instance_1;
  }
  function FocusedBoundsObserverNode() {
  }
  protoOf(FocusedBoundsObserverNode).mfx = function (focusedBounds) {
    this.lfx_1(focusedBounds);
    var tmp0_safe_receiver = findNearestAncestor_0(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.mfx(focusedBounds);
    }
  };
  function GestureConnection() {
  }
  function gestureNode(gestureConnection) {
    return new GestureNode(gestureConnection);
  }
  function get_parentGestureConnection(_this__u8e3s4) {
    var tmp = findNearestAncestor(_this__u8e3s4, TraverseKey_instance_2);
    var tmp0_safe_receiver = tmp instanceof GestureNode ? tmp : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bfz_1;
  }
  function traverseAncestorGestureConnections(_this__u8e3s4, block) {
    var tmp = TraverseKey_instance_2;
    traverseAncestors(_this__u8e3s4, tmp, traverseAncestorGestureConnections$lambda(block));
  }
  function TraverseKey_2() {
  }
  var TraverseKey_instance_2;
  function TraverseKey_getInstance_2() {
    return TraverseKey_instance_2;
  }
  function GestureNode(gestureConnection) {
    Node.call(this);
    this.bfz_1 = gestureConnection;
  }
  protoOf(GestureNode).t91 = function () {
    return TraverseKey_instance_2;
  };
  function traverseAncestorGestureConnections$lambda($block) {
    return function (node) {
      // Inline function 'kotlin.check' call
      if (!(node instanceof GestureNode)) {
        var message = 'Node is not a GestureNode instance';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      return $block(node.bfz_1);
    };
  }
  function hoverable(_this__u8e3s4, interactionSource, enabled) {
    enabled = enabled === VOID ? true : enabled;
    return _this__u8e3s4.d8v(enabled ? new HoverableElement(interactionSource) : Companion_instance_0);
  }
  function HoverableElement(interactionSource) {
    ModifierNodeElement.call(this);
    this.dfz_1 = interactionSource;
  }
  protoOf(HoverableElement).r3d = function () {
    return new HoverableNode(this.dfz_1);
  };
  protoOf(HoverableElement).efz = function (node) {
    node.vfz(this.dfz_1);
  };
  protoOf(HoverableElement).d8y = function (node) {
    return this.efz(node instanceof HoverableNode ? node : THROW_CCE());
  };
  protoOf(HoverableElement).hashCode = function () {
    return imul(31, hashCode(this.dfz_1));
  };
  protoOf(HoverableElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HoverableElement))
      return false;
    if (!equals(other.dfz_1, this.dfz_1))
      return false;
    return true;
  };
  function emitEnter($this, $completion) {
    var tmp = new $emitEnterCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function emitExit($this, $completion) {
    var tmp = new $emitExitCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function tryEmitExit($this) {
    var tmp0_safe_receiver = $this.ufz_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var interaction = new Exit(tmp0_safe_receiver);
      $this.tfz_1.efo(interaction);
      $this.ufz_1 = null;
    }
  }
  function HoverableNode$onPointerEvent$slambda(this$0, resultContinuation) {
    this.yg0_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HoverableNode$onPointerEvent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HoverableNode$onPointerEvent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HoverableNode$onPointerEvent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = emitEnter(this.yg0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HoverableNode$onPointerEvent$slambda).q24 = function ($this$launch, completion) {
    var i = new HoverableNode$onPointerEvent$slambda(this.yg0_1, completion);
    i.zg0_1 = $this$launch;
    return i;
  };
  function HoverableNode$onPointerEvent$slambda_0(this$0, resultContinuation) {
    var i = new HoverableNode$onPointerEvent$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function HoverableNode$onPointerEvent$slambda_1(this$0, resultContinuation) {
    this.ig1_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HoverableNode$onPointerEvent$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HoverableNode$onPointerEvent$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HoverableNode$onPointerEvent$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = emitExit(this.ig1_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HoverableNode$onPointerEvent$slambda_1).q24 = function ($this$launch, completion) {
    var i = new HoverableNode$onPointerEvent$slambda_1(this.ig1_1, completion);
    i.jg1_1 = $this$launch;
    return i;
  };
  function HoverableNode$onPointerEvent$slambda_2(this$0, resultContinuation) {
    var i = new HoverableNode$onPointerEvent$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function $emitEnterCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.eg0_1 = _this__u8e3s4;
  }
  protoOf($emitEnterCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.eg0_1.ufz_1 == null) {
              this.fg0_1 = new Enter();
              this.n9_1 = 1;
              suspendResult = this.eg0_1.tfz_1.vfh(this.fg0_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.eg0_1.ufz_1 = this.fg0_1;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $emitExitCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.og0_1 = _this__u8e3s4;
  }
  protoOf($emitExitCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.og0_1.ufz_1;
            if (tmp0_safe_receiver == null) {
              this.pg0_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              var interaction = new Exit(tmp0_safe_receiver);
              this.n9_1 = 1;
              suspendResult = this.og0_1.tfz_1.vfh(interaction, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.og0_1.ufz_1 = null;
            var tmp_0 = this;
            tmp_0.pg0_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function HoverableNode(interactionSource) {
    Node.call(this);
    this.tfz_1 = interactionSource;
    this.ufz_1 = null;
  }
  protoOf(HoverableNode).vfz = function (interactionSource) {
    if (!equals(this.tfz_1, interactionSource)) {
      tryEmitExit(this);
      this.tfz_1 = interactionSource;
    }
  };
  protoOf(HoverableNode).aa1 = function (pointerEvent, pass, bounds) {
    if (pass.equals(PointerEventPass_Main_getInstance())) {
      var tmp0_subject = pointerEvent.ha0_1;
      if (tmp0_subject === Companion_getInstance_8().oa1_1) {
        var tmp = this.a8w();
        launch(tmp, VOID, VOID, HoverableNode$onPointerEvent$slambda_0(this, null));
      } else if (tmp0_subject === Companion_getInstance_8().pa1_1) {
        var tmp_0 = this.a8w();
        launch(tmp_0, VOID, VOID, HoverableNode$onPointerEvent$slambda_2(this, null));
      }
    }
  };
  protoOf(HoverableNode).xa1 = function () {
    tryEmitExit(this);
  };
  protoOf(HoverableNode).h8w = function () {
    tryEmitExit(this);
  };
  function Image(painter, contentDescription, modifier, alignment, contentScale, alpha, colorFilter, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var alignment_0 = {_v: alignment};
    var contentScale_0 = {_v: contentScale};
    var alpha_0 = {_v: alpha};
    var colorFilter_0 = {_v: colorFilter};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1142754848);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(painter) : $composer_0.q31(painter)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(contentDescription) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(alignment_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(contentScale_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.n31(alpha_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(colorFilter_0._v) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      if (!(($default & 8) === 0)) {
        alignment_0._v = Companion_getInstance_12().o8t_1;
      }
      if (!(($default & 16) === 0)) {
        contentScale_0._v = Companion_getInstance_13().r96_1;
      }
      if (!(($default & 32) === 0)) {
        alpha_0._v = 1.0;
      }
      if (!(($default & 64) === 0)) {
        colorFilter_0._v = null;
      }
      var tmp;
      if (!(contentDescription == null)) {
        $composer_0.m30(1899222916);
        var tmp_0 = Companion_instance_0;
        var tmp0 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it = tmp0.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance_11().f30_1) {
          var value = Image$lambda(contentDescription);
          tmp0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$0 = tmp_1;
        var tmp0_group = semantics(tmp_0, VOID, tmp$ret$0);
        $composer_0.n30();
        tmp = tmp0_group;
      } else {
        $composer_0.m30(1899381698);
        $composer_0.n30();
        tmp = Companion_instance_0;
      }
      var semantics_0 = tmp;
      var tmp0_0 = paint(clipToBounds(modifier_0._v.d8v(semantics_0)), painter, VOID, alignment_0._v, contentScale_0._v, alpha_0._v, colorFilter_0._v);
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_0.i31();
      var tmp_2;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var tmp_3 = Image$lambda_0;
        var value_0 = new sam$androidx_compose_ui_layout_MeasurePolicy$0(tmp_3);
        this_0.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp2 = tmp_2;
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_1 = tmp0_0;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier_1 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
      var materialized = materialize($composer_1, modifier_1);
      var localMap = $composer_1.t31();
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var factory = Companion_getInstance_14().oah_1;
      var $composer_2 = $composer_1;
      var tmp_4 = $composer_2.g30();
      if (!isInterface(tmp_4, Applier)) {
        invalidApplier();
      }
      $composer_2.b31();
      if ($composer_2.h30()) {
        $composer_2.c31(factory);
      } else {
        $composer_2.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp2, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      $composer_2.e31();
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(Image$lambda_1(painter, contentDescription, modifier_0, alignment_0, contentScale_0, alpha_0, colorFilter_0, $changed, $default));
    }
  }
  function Image_0(bitmap, contentDescription, modifier, alignment, contentScale, alpha, colorFilter, filterQuality, $composer, $changed, $default) {
    var modifier_0 = modifier;
    var alignment_0 = alignment;
    var contentScale_0 = contentScale;
    var alpha_0 = alpha;
    var colorFilter_0 = colorFilter;
    var filterQuality_0 = filterQuality;
    var $composer_0 = $composer;
    if (!(($default & 4) === 0))
      modifier_0 = Companion_instance_0;
    if (!(($default & 8) === 0))
      alignment_0 = Companion_getInstance_12().o8t_1;
    if (!(($default & 16) === 0))
      contentScale_0 = Companion_getInstance_13().r96_1;
    if (!(($default & 32) === 0))
      alpha_0 = 1.0;
    if (!(($default & 64) === 0))
      colorFilter_0 = null;
    if (!(($default & 128) === 0))
      filterQuality_0 = Companion_getInstance_15().y6h_1;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.k31(bitmap);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = BitmapPainter(bitmap, VOID, VOID, filterQuality_0);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var bitmapPainter = tmp;
    Image(bitmapPainter, contentDescription, modifier_0, alignment_0, contentScale_0, alpha_0, colorFilter_0, $composer_0, androidx_compose_ui_graphics_painter_BitmapPainter$stableprop_getter() | 112 & $changed | 896 & $changed | 7168 & $changed | 57344 & $changed | 458752 & $changed | 3670016 & $changed, 0);
  }
  function sam$androidx_compose_ui_layout_MeasurePolicy$0(function_0) {
    this.kg1_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).mak = function (_this__u8e3s4, measurables, constraints) {
    return this.kg1_1(_this__u8e3s4, measurables, new Constraints(constraints));
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).q3 = function () {
    return this.kg1_1;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function Image$lambda($contentDescription) {
    return function ($this$semantics) {
      set_contentDescription($this$semantics, $contentDescription);
      set_role($this$semantics, Companion_getInstance_16().ybx_1);
      return Unit_instance;
    };
  }
  function Image$lambda_0($this$Layout, _unused_var__etf5q3, constraints) {
    var tmp = _Constraints___get_minWidth__impl__hi9lfi(constraints.m5e_1);
    var tmp_0 = _Constraints___get_minHeight__impl__ev4bgx(constraints.m5e_1);
    return $this$Layout.n8y(tmp, tmp_0, VOID, Image$lambda$lambda);
  }
  function Image$lambda$lambda($this$layout) {
    return Unit_instance;
  }
  function Image$lambda_1($painter, $contentDescription, $modifier, $alignment, $contentScale, $alpha, $colorFilter, $$changed, $$default) {
    return function ($composer, $force) {
      Image($painter, $contentDescription, $modifier._v, $alignment._v, $contentScale._v, $alpha._v, $colorFilter._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function get_LocalIndication() {
    _init_properties_Indication_kt__w3ndj0();
    return LocalIndication;
  }
  var LocalIndication;
  function IndicationNodeFactory() {
  }
  function Indication() {
  }
  function indication(_this__u8e3s4, interactionSource, indication) {
    _init_properties_Indication_kt__w3ndj0();
    return indicationImpl(_this__u8e3s4, interactionSource, platformIndication(indication));
  }
  function DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda$slambda($pressCount, $hoverCount, $focusCount, this$0, resultContinuation) {
    this.ug1_1 = $pressCount;
    this.vg1_1 = $hoverCount;
    this.wg1_1 = $focusCount;
    this.xg1_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda$slambda).zg1 = function (interaction, $completion) {
    var tmp = this.ag2(interaction, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda$slambda).ja = function (p1, $completion) {
    return this.zg1((!(p1 == null) ? isInterface(p1, Interaction) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_subject = this.yg1_1;
          if (tmp0_subject instanceof Press) {
            var _unary__edvuaz = this.ug1_1._v;
            this.ug1_1._v = _unary__edvuaz + 1 | 0;
          } else {
            if (tmp0_subject instanceof Release) {
              var _unary__edvuaz_0 = this.ug1_1._v;
              this.ug1_1._v = _unary__edvuaz_0 - 1 | 0;
            } else {
              if (tmp0_subject instanceof Cancel_0) {
                var _unary__edvuaz_1 = this.ug1_1._v;
                this.ug1_1._v = _unary__edvuaz_1 - 1 | 0;
              } else {
                if (tmp0_subject instanceof Enter) {
                  var _unary__edvuaz_2 = this.vg1_1._v;
                  this.vg1_1._v = _unary__edvuaz_2 + 1 | 0;
                } else {
                  if (tmp0_subject instanceof Exit) {
                    var _unary__edvuaz_3 = this.vg1_1._v;
                    this.vg1_1._v = _unary__edvuaz_3 - 1 | 0;
                  } else {
                    if (tmp0_subject instanceof Focus) {
                      var _unary__edvuaz_4 = this.wg1_1._v;
                      this.wg1_1._v = _unary__edvuaz_4 + 1 | 0;
                    } else {
                      if (tmp0_subject instanceof Unfocus) {
                        var _unary__edvuaz_5 = this.wg1_1._v;
                        this.wg1_1._v = _unary__edvuaz_5 - 1 | 0;
                      }
                    }
                  }
                }
              }
            }
          }
          var pressed = this.ug1_1._v > 0;
          var hovered = this.vg1_1._v > 0;
          var focused = this.wg1_1._v > 0;
          var invalidateNeeded = false;
          if (!(this.xg1_1.qg2_1 === pressed)) {
            this.xg1_1.qg2_1 = pressed;
            invalidateNeeded = true;
          }
          if (!(this.xg1_1.rg2_1 === hovered)) {
            this.xg1_1.rg2_1 = hovered;
            invalidateNeeded = true;
          }
          if (!(this.xg1_1.sg2_1 === focused)) {
            this.xg1_1.sg2_1 = focused;
            invalidateNeeded = true;
          }
          if (invalidateNeeded) {
            invalidateDraw(this.xg1_1);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda$slambda).ag2 = function (interaction, completion) {
    var i = new DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda$slambda(this.ug1_1, this.vg1_1, this.wg1_1, this.xg1_1, completion);
    i.yg1_1 = interaction;
    return i;
  };
  function DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda$slambda_0($pressCount, $hoverCount, $focusCount, this$0, resultContinuation) {
    var i = new DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda$slambda($pressCount, $hoverCount, $focusCount, this$0, resultContinuation);
    return constructCallableReference(function (interaction, $completion) {
      return i.zg1(interaction, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.tg2_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.tg2_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.tg2_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda(this$0, resultContinuation) {
    this.cg3_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var pressCount = {_v: 0};
            var hoverCount = {_v: 0};
            var focusCount = {_v: 0};
            this.n9_1 = 1;
            var tmp_0 = this.cg3_1.pg2_1.eg3();
            var tmp_1 = DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda$slambda_0(pressCount, hoverCount, focusCount, this.cg3_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda).q24 = function ($this$launch, completion) {
    var i = new DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda(this.cg3_1, completion);
    i.dg3_1 = $this$launch;
    return i;
  };
  function DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda_0(this$0, resultContinuation) {
    var i = new DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function DefaultDebugIndicationInstance(interactionSource) {
    Node.call(this);
    this.pg2_1 = interactionSource;
    this.qg2_1 = false;
    this.rg2_1 = false;
    this.sg2_1 = false;
  }
  protoOf(DefaultDebugIndicationInstance).f8w = function () {
    var tmp = this.a8w();
    launch(tmp, VOID, VOID, DefaultDebugIndication$DefaultDebugIndicationInstance$onAttach$slambda_0(this, null));
  };
  protoOf(DefaultDebugIndicationInstance).h92 = function (_this__u8e3s4) {
    _this__u8e3s4.z91();
    if (this.qg2_1) {
      _this__u8e3s4.b6q(Color__copy$default_impl_ectz3s(Companion_getInstance().i6b_1, 0.3), VOID, _this__u8e3s4.o5d());
    } else if (this.rg2_1 || this.sg2_1) {
      _this__u8e3s4.b6q(Color__copy$default_impl_ectz3s(Companion_getInstance().i6b_1, 0.1), VOID, _this__u8e3s4.o5d());
    }
  };
  function DefaultDebugIndication() {
  }
  protoOf(DefaultDebugIndication).ufi = function (interactionSource) {
    return new DefaultDebugIndicationInstance(interactionSource);
  };
  protoOf(DefaultDebugIndication).hashCode = function () {
    return -1;
  };
  protoOf(DefaultDebugIndication).equals = function (other) {
    return other === this;
  };
  var DefaultDebugIndication_instance;
  function DefaultDebugIndication_getInstance() {
    return DefaultDebugIndication_instance;
  }
  function NoIndicationInstance() {
  }
  protoOf(NoIndicationInstance).fg3 = function (_this__u8e3s4) {
    _this__u8e3s4.z91();
  };
  var NoIndicationInstance_instance;
  function NoIndicationInstance_getInstance() {
    return NoIndicationInstance_instance;
  }
  function indicationImpl(_this__u8e3s4, interactionSource, indication) {
    _init_properties_Indication_kt__w3ndj0();
    if (indication == null)
      return _this__u8e3s4;
    if (isInterface(indication, IndicationNodeFactory)) {
      return _this__u8e3s4.d8v(new IndicationModifierElement(interactionSource, indication));
    }
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = indicationImpl$lambda(interactionSource, indication);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp0_inspectorInfo = tmp;
    return composed(_this__u8e3s4, tmp0_inspectorInfo, indicationImpl$lambda_0(indication, interactionSource));
  }
  function IndicationModifierElement(interactionSource, indication) {
    ModifierNodeElement.call(this);
    this.hg3_1 = interactionSource;
    this.ig3_1 = indication;
  }
  protoOf(IndicationModifierElement).r3d = function () {
    return new IndicationModifierNode(this.ig3_1.ufi(this.hg3_1));
  };
  protoOf(IndicationModifierElement).jg3 = function (node) {
    node.bg4(this.ig3_1.ufi(this.hg3_1));
  };
  protoOf(IndicationModifierElement).d8y = function (node) {
    return this.jg3(node instanceof IndicationModifierNode ? node : THROW_CCE());
  };
  protoOf(IndicationModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IndicationModifierElement))
      return false;
    if (!equals(this.hg3_1, other.hg3_1))
      return false;
    if (!this.ig3_1.equals(other.ig3_1))
      return false;
    return true;
  };
  protoOf(IndicationModifierElement).hashCode = function () {
    var result = hashCode(this.hg3_1);
    result = imul(31, result) + this.ig3_1.hashCode() | 0;
    return result;
  };
  function IndicationModifier(indicationInstance) {
    this.cg4_1 = indicationInstance;
  }
  protoOf(IndicationModifier).h92 = function (_this__u8e3s4) {
    // Inline function 'kotlin.with' call
    this.cg4_1.fg3(_this__u8e3s4);
  };
  function IndicationModifierNode(indicationNode) {
    DelegatingNode.call(this);
    this.ag4_1 = indicationNode;
    this.tb1(this.ag4_1);
  }
  protoOf(IndicationModifierNode).bg4 = function (indicationNode) {
    this.vb1(this.ag4_1);
    this.ag4_1 = indicationNode;
    this.tb1(indicationNode);
  };
  function LocalIndication$lambda() {
    _init_properties_Indication_kt__w3ndj0();
    return DefaultDebugIndication_instance;
  }
  function indicationImpl$lambda($interactionSource, $indication) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'indication';
      _this__u8e3s4.mdp_1.odp('interactionSource', $interactionSource);
      _this__u8e3s4.mdp_1.odp('indication', $indication);
      return Unit_instance;
    };
  }
  function indicationImpl$lambda_0($indication, $interactionSource) {
    return function ($this$composed, $composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(-51460101);
      var instance = $indication.lg1($interactionSource, $composer_0, 0);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.k31(instance);
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = new IndicationModifier(instance);
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0 = tmp;
      $composer_0.n30();
      return tmp0;
    };
  }
  var properties_initialized_Indication_kt_w71gpq;
  function _init_properties_Indication_kt__w3ndj0() {
    if (!properties_initialized_Indication_kt_w71gpq) {
      properties_initialized_Indication_kt_w71gpq = true;
      LocalIndication = compositionLocalOf(VOID, LocalIndication$lambda);
    }
  }
  var androidx_compose_foundation_MutationInterruptedException$stable;
  var androidx_compose_foundation_MutatorMutex$stable;
  function Mutator(priority, job) {
    this.dg4_1 = priority;
    this.eg4_1 = job;
  }
  protoOf(Mutator).fg4 = function (other) {
    return this.dg4_1.i3(other.dg4_1) >= 0;
  };
  protoOf(Mutator).e2z = function () {
    return this.eg4_1.a1b(new MutationInterruptedException());
  };
  function tryMutateOrCancel($this, mutator) {
    $l$loop: while (true) {
      var oldMutator = $this.gg4_1.f1i();
      if (oldMutator == null || mutator.fg4(oldMutator)) {
        if ($this.gg4_1.w21(oldMutator, mutator)) {
          if (oldMutator == null)
            null;
          else {
            oldMutator.e2z();
          }
          break $l$loop;
        }
      } else
        throw CancellationException_init_$Create$('Current mutation had a higher priority');
    }
  }
  function MutatorMutex$mutate$slambda($priority, this$0, $block, resultContinuation) {
    this.rg4_1 = $priority;
    this.sg4_1 = this$0;
    this.tg4_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MutatorMutex$mutate$slambda).j8x = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MutatorMutex$mutate$slambda).ja = function (p1, $completion) {
    return this.j8x((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(MutatorMutex$mutate$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.xg4_1 = new Mutator(this.rg4_1, ensureNotNull(this.ug4_1.q19().aa(Key_instance)));
            tryMutateOrCancel(this.sg4_1, this.xg4_1);
            this.wg4_1 = this.sg4_1.hg4_1;
            this.vg4_1 = null;
            this.n9_1 = 1;
            suspendResult = this.wg4_1.o2u(this.vg4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.yg4_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 8;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 7;
            this.n9_1 = 4;
            suspendResult = this.tg4_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.zg4_1 = suspendResult;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            var tmp_0 = this.zg4_1;
            this.o9_1 = 8;
            this.sg4_1.gg4_1.w21(this.xg4_1, null);
            this.yg4_1 = tmp_0;
            this.o9_1 = 9;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var tmp_1 = this.yg4_1;
            this.o9_1 = 9;
            this.wg4_1.q2u(this.vg4_1);
            return tmp_1;
          case 7:
            this.o9_1 = 8;
            var t = this.q9_1;
            this.sg4_1.gg4_1.w21(this.xg4_1, null);
            throw t;
          case 8:
            this.o9_1 = 9;
            var t_0 = this.q9_1;
            this.wg4_1.q2u(this.vg4_1);
            throw t_0;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(MutatorMutex$mutate$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new MutatorMutex$mutate$slambda(this.rg4_1, this.sg4_1, this.tg4_1, completion);
    i.ug4_1 = $this$coroutineScope;
    return i;
  };
  function MutatorMutex$mutate$slambda_0($priority, this$0, $block, resultContinuation) {
    var i = new MutatorMutex$mutate$slambda($priority, this$0, $block, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.j8x($this$coroutineScope, $completion);
    }, 1);
  }
  function MutatorMutex$mutateWith$slambda($priority, this$0, $block, $receiver, resultContinuation) {
    this.ig5_1 = $priority;
    this.jg5_1 = this$0;
    this.kg5_1 = $block;
    this.lg5_1 = $receiver;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MutatorMutex$mutateWith$slambda).j8x = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MutatorMutex$mutateWith$slambda).ja = function (p1, $completion) {
    return this.j8x((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(MutatorMutex$mutateWith$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.pg5_1 = new Mutator(this.ig5_1, ensureNotNull(this.mg5_1.q19().aa(Key_instance)));
            tryMutateOrCancel(this.jg5_1, this.pg5_1);
            this.og5_1 = this.jg5_1.hg4_1;
            this.ng5_1 = null;
            this.n9_1 = 1;
            suspendResult = this.og5_1.o2u(this.ng5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.qg5_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 8;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 7;
            this.n9_1 = 4;
            suspendResult = this.kg5_1(this.lg5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.rg5_1 = suspendResult;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            var tmp_0 = this.rg5_1;
            this.o9_1 = 8;
            this.jg5_1.gg4_1.w21(this.pg5_1, null);
            this.qg5_1 = tmp_0;
            this.o9_1 = 9;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var tmp_1 = this.qg5_1;
            this.o9_1 = 9;
            this.og5_1.q2u(this.ng5_1);
            return tmp_1;
          case 7:
            this.o9_1 = 8;
            var t = this.q9_1;
            this.jg5_1.gg4_1.w21(this.pg5_1, null);
            throw t;
          case 8:
            this.o9_1 = 9;
            var t_0 = this.q9_1;
            this.og5_1.q2u(this.ng5_1);
            throw t_0;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(MutatorMutex$mutateWith$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new MutatorMutex$mutateWith$slambda(this.ig5_1, this.jg5_1, this.kg5_1, this.lg5_1, completion);
    i.mg5_1 = $this$coroutineScope;
    return i;
  };
  function MutatorMutex$mutateWith$slambda_0($priority, this$0, $block, $receiver, resultContinuation) {
    var i = new MutatorMutex$mutateWith$slambda($priority, this$0, $block, $receiver, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.j8x($this$coroutineScope, $completion);
    }, 1);
  }
  function MutatorMutex() {
    this.gg4_1 = new AtomicReference(null);
    this.hg4_1 = Mutex();
  }
  protoOf(MutatorMutex).sg5 = function (priority, block, $completion) {
    return coroutineScope(MutatorMutex$mutate$slambda_0(priority, this, block, null), $completion);
  };
  protoOf(MutatorMutex).tg5 = function (priority, block, $completion, $super) {
    priority = priority === VOID ? MutatePriority_Default_getInstance() : priority;
    return $super === VOID ? this.sg5(priority, block, $completion) : $super.sg5.call(this, priority, block, $completion);
  };
  protoOf(MutatorMutex).ug5 = function (receiver, priority, block, $completion) {
    return coroutineScope(MutatorMutex$mutateWith$slambda_0(priority, this, block, receiver, null), $completion);
  };
  var MutatePriority_Default_instance;
  var MutatePriority_UserInput_instance;
  var MutatePriority_PreventUserInput_instance;
  var MutatePriority_entriesInitialized;
  function MutatePriority_initEntries() {
    if (MutatePriority_entriesInitialized)
      return Unit_instance;
    MutatePriority_entriesInitialized = true;
    MutatePriority_Default_instance = new MutatePriority('Default', 0);
    MutatePriority_UserInput_instance = new MutatePriority('UserInput', 1);
    MutatePriority_PreventUserInput_instance = new MutatePriority('PreventUserInput', 2);
  }
  function MutatePriority(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MutationInterruptedException() {
    PlatformOptimizedCancellationException.call(this, 'Mutation interrupted');
    captureStack(this, MutationInterruptedException);
  }
  function MutatePriority_Default_getInstance() {
    MutatePriority_initEntries();
    return MutatePriority_Default_instance;
  }
  function MutatePriority_UserInput_getInstance() {
    MutatePriority_initEntries();
    return MutatePriority_UserInput_instance;
  }
  function MutatePriority_PreventUserInput_getInstance() {
    MutatePriority_initEntries();
    return MutatePriority_PreventUserInput_instance;
  }
  function get_LocalOverscrollFactory() {
    _init_properties_Overscroll_kt__l5on41();
    return LocalOverscrollFactory;
  }
  var LocalOverscrollFactory;
  function OverscrollEffect$node$1() {
    Node.call(this);
  }
  function OverscrollEffect() {
  }
  function overscroll(_this__u8e3s4, overscrollEffect) {
    _init_properties_Overscroll_kt__l5on41();
    var tmp1_elvis_lhs = overscrollEffect == null ? null : overscrollEffect.yg5();
    var effectModifier = tmp1_elvis_lhs == null ? Companion_instance_0 : tmp1_elvis_lhs;
    var modifier = !(effectModifier === Companion_instance_0) ? effectModifier : new OverscrollModifierElement(overscrollEffect);
    return _this__u8e3s4.d8v(modifier);
  }
  function OverscrollModifierElement(overscrollEffect) {
    ModifierNodeElement.call(this);
    this.ag6_1 = overscrollEffect;
  }
  protoOf(OverscrollModifierElement).r3d = function () {
    var tmp0_safe_receiver = this.ag6_1;
    return new OverscrollModifierNode(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f4n());
  };
  protoOf(OverscrollModifierElement).bg6 = function (node) {
    var tmp0_safe_receiver = this.ag6_1;
    node.tg6(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f4n());
  };
  protoOf(OverscrollModifierElement).d8y = function (node) {
    return this.bg6(node instanceof OverscrollModifierNode ? node : THROW_CCE());
  };
  protoOf(OverscrollModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OverscrollModifierElement))
      return false;
    if (!equals(this.ag6_1, other.ag6_1))
      return false;
    return true;
  };
  protoOf(OverscrollModifierElement).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.ag6_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  function attachIfNeeded($this) {
    var tmp = $this;
    var tmp_0;
    var tmp0_safe_receiver = $this.sg6_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f4n();
    if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.z8v_1) === false) {
      tmp_0 = $this.tb1(ensureNotNull($this.sg6_1));
    } else {
      tmp_0 = null;
    }
    tmp.sg6_1 = tmp_0;
  }
  function OverscrollModifierNode(overscrollNode) {
    DelegatingNode.call(this);
    this.sg6_1 = overscrollNode;
  }
  protoOf(OverscrollModifierNode).f8w = function () {
    attachIfNeeded(this);
  };
  protoOf(OverscrollModifierNode).h8w = function () {
    var tmp0_safe_receiver = this.sg6_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.vb1(tmp0_safe_receiver);
    }
  };
  protoOf(OverscrollModifierNode).tg6 = function (overscrollNode) {
    var tmp0_safe_receiver = this.sg6_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.vb1(tmp0_safe_receiver);
    }
    this.sg6_1 = overscrollNode;
    attachIfNeeded(this);
  };
  function rememberOverscrollEffect($composer, $changed) {
    _init_properties_Overscroll_kt__l5on41();
    var $composer_0 = $composer;
    $composer_0.m30(282942128);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalOverscrollFactory();
    var $composer_1 = $composer_0;
    var tmp0_elvis_lhs = $composer_1.u31(this_0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      $composer_0.n30();
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var overscrollFactory = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.k31(overscrollFactory);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp_0;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = overscrollFactory.ug6();
      $composer_0.j31(value);
      tmp_0 = value;
    } else {
      tmp_0 = it;
    }
    var tmp0 = tmp_0;
    $composer_0.n30();
    return tmp0;
  }
  function LocalOverscrollFactory$lambda($this$compositionLocalWithComputedDefaultOf) {
    _init_properties_Overscroll_kt__l5on41();
    return defaultOverscrollFactory($this$compositionLocalWithComputedDefaultOf);
  }
  var properties_initialized_Overscroll_kt_huz4ql;
  function _init_properties_Overscroll_kt__l5on41() {
    if (!properties_initialized_Overscroll_kt_huz4ql) {
      properties_initialized_Overscroll_kt_huz4ql = true;
      LocalOverscrollFactory = compositionLocalWithComputedDefaultOf(LocalOverscrollFactory$lambda);
    }
  }
  function progressSemantics(_this__u8e3s4) {
    return semantics(_this__u8e3s4, true, progressSemantics$lambda);
  }
  function progressSemantics_0(_this__u8e3s4, value, valueRange, steps) {
    valueRange = valueRange === VOID ? rangeTo(0.0, 1.0) : valueRange;
    steps = steps === VOID ? 0 : steps;
    return semantics(_this__u8e3s4, true, progressSemantics$lambda_0(value, valueRange, steps));
  }
  function progressSemantics$lambda($this$semantics) {
    set_progressBarRangeInfo($this$semantics, Companion_getInstance_17().fby_1);
    return Unit_instance;
  }
  function progressSemantics$lambda_0($value, $valueRange, $steps) {
    return function ($this$semantics) {
      set_progressBarRangeInfo($this$semantics, new ProgressBarRangeInfo(coerceIn($value, $valueRange), $valueRange, $steps));
      return Unit_instance;
    };
  }
  var androidx_compose_foundation_ScrollState$stable;
  var androidx_compose_foundation_ScrollingLayoutElement$stable;
  var androidx_compose_foundation_ScrollNode$stable;
  function ScrollState$Companion$Saver$lambda($this$Saver, it) {
    return it.u1();
  }
  function ScrollState$Companion$Saver$lambda_0(it) {
    return new ScrollState(it);
  }
  function _set_value__lx0xdg($this, _set____db54di) {
    var tmp0 = $this.vg6_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ScrollState$_get_value_$ref_glv4vj();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, ScrollState$_set_value_$ref_cozbj1());
    tmp0.a49(_set____db54di);
    return Unit_instance;
  }
  function Companion() {
    Companion_instance_9 = this;
    var tmp = this;
    var tmp_0 = ScrollState$Companion$Saver$lambda;
    tmp.fg7_1 = Saver(tmp_0, ScrollState$Companion$Saver$lambda_0);
  }
  var Companion_instance_9;
  function Companion_getInstance_58() {
    if (Companion_instance_9 == null)
      new Companion();
    return Companion_instance_9;
  }
  function ScrollState$_get_value_$ref_glv4vj() {
    return constructCallableReference(function (p0) {
      return p0.u1();
    }, 1, 0, 241);
  }
  function ScrollState$_set_value_$ref_cozbj1() {
    return constructCallableReference(function (p0, p1) {
      _set_value__lx0xdg(p0, p1);
      return Unit_instance;
    }, 2, 0, 242);
  }
  function ScrollState$_get_viewportSize_$ref_wh2h7x() {
    return constructCallableReference(function (p0) {
      return p0.gg7();
    }, 1, 0, 243);
  }
  function ScrollState$_set_viewportSize_$ref_9gxbof() {
    return constructCallableReference(function (p0, p1) {
      p0.hg7(p1);
      return Unit_instance;
    }, 2, 0, 244);
  }
  function ScrollState$_get_contentSize_$ref_8o8206() {
    return constructCallableReference(function (p0) {
      return p0.ig7();
    }, 1, 0, 245);
  }
  function ScrollState$_set_contentSize_$ref_1fi5ie() {
    return constructCallableReference(function (p0, p1) {
      p0.jg7(p1);
      return Unit_instance;
    }, 2, 0, 246);
  }
  function ScrollState$scrollableState$lambda(this$0) {
    return function (it) {
      var absolute = this$0.u1() + it + this$0.ag7_1;
      var newValue = coerceIn_0(absolute, 0.0, this$0.kg7());
      var changed = !(absolute === newValue);
      var consumed = newValue - this$0.u1();
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var tmp;
      if (isNaN_0(consumed)) {
        tmp = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp = roundToInt(consumed);
      }
      var consumedInt = tmp;
      _set_value__lx0xdg(this$0, this$0.u1() + consumedInt | 0);
      this$0.ag7_1 = consumed - consumedInt;
      return changed ? consumed : it;
    };
  }
  function ScrollState$_scrollIndicatorState$1(this$0) {
    this.lg7_1 = this$0;
  }
  function ScrollState$canScrollForward$delegate$lambda(this$0) {
    return function () {
      return this$0.u1() < this$0.kg7();
    };
  }
  function ScrollState$_get_canScrollForward_$ref_sobksu() {
    return constructCallableReference(function (p0) {
      return p0.mg7();
    }, 1, 0, 247);
  }
  function ScrollState$canScrollBackward$delegate$lambda(this$0) {
    return function () {
      return this$0.u1() > 0;
    };
  }
  function ScrollState$_get_canScrollBackward_$ref_b5ydxc() {
    return constructCallableReference(function (p0) {
      return p0.ng7();
    }, 1, 0, 248);
  }
  function ScrollState(initial) {
    Companion_getInstance_58();
    this.vg6_1 = mutableIntStateOf(initial);
    this.wg6_1 = mutableIntStateOf(0);
    this.xg6_1 = mutableIntStateOf(0);
    this.yg6_1 = funMutableInteractionSource();
    this.zg6_1 = mutableIntStateOf(2147483647);
    this.ag7_1 = 0.0;
    var tmp = this;
    tmp.bg7_1 = ScrollableState_0(ScrollState$scrollableState$lambda(this));
    var tmp_0 = this;
    tmp_0.cg7_1 = new ScrollState$_scrollIndicatorState$1(this);
    var tmp_1 = this;
    tmp_1.dg7_1 = derivedStateOf(ScrollState$canScrollForward$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.eg7_1 = derivedStateOf(ScrollState$canScrollBackward$delegate$lambda(this));
  }
  protoOf(ScrollState).u1 = function () {
    var tmp0 = this.vg6_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ScrollState$_get_value_$ref_glv4vj();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, ScrollState$_set_value_$ref_cozbj1());
    return tmp0.b49();
  };
  protoOf(ScrollState).og7 = function (newMax) {
    this.zg6_1.a49(newMax);
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
      var previousSnapshot = Companion_instance_2.p52();
      var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
      var newSnapshot = Companion_instance_2.q52(previousSnapshot);
      try {
        if (this.u1() > newMax) {
          _set_value__lx0xdg(this, newMax);
        }
        break $l$block;
      }finally {
        Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
      }
    }
  };
  protoOf(ScrollState).kg7 = function () {
    return this.zg6_1.b49();
  };
  protoOf(ScrollState).hg7 = function (_set____db54di) {
    var tmp0 = this.wg6_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ScrollState$_get_viewportSize_$ref_wh2h7x();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('viewportSize', 1, tmp, tmp_0, ScrollState$_set_viewportSize_$ref_9gxbof());
    tmp0.a49(_set____db54di);
    return Unit_instance;
  };
  protoOf(ScrollState).gg7 = function () {
    var tmp0 = this.wg6_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ScrollState$_get_viewportSize_$ref_wh2h7x();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('viewportSize', 1, tmp, tmp_0, ScrollState$_set_viewportSize_$ref_9gxbof());
    return tmp0.b49();
  };
  protoOf(ScrollState).jg7 = function (_set____db54di) {
    var tmp0 = this.xg6_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ScrollState$_get_contentSize_$ref_8o8206();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('contentSize', 1, tmp, tmp_0, ScrollState$_set_contentSize_$ref_1fi5ie());
    tmp0.a49(_set____db54di);
    return Unit_instance;
  };
  protoOf(ScrollState).ig7 = function () {
    var tmp0 = this.xg6_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ScrollState$_get_contentSize_$ref_8o8206();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('contentSize', 1, tmp, tmp_0, ScrollState$_set_contentSize_$ref_1fi5ie());
    return tmp0.b49();
  };
  protoOf(ScrollState).pg7 = function (scrollPriority, block, $completion) {
    return this.bg7_1.pg7(scrollPriority, block, $completion);
  };
  protoOf(ScrollState).rg7 = function (delta) {
    return this.bg7_1.rg7(delta);
  };
  protoOf(ScrollState).sg7 = function () {
    return this.bg7_1.sg7();
  };
  protoOf(ScrollState).mg7 = function () {
    var tmp0 = this.dg7_1;
    var tmp = KProperty1;
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('canScrollForward', 1, tmp, ScrollState$_get_canScrollForward_$ref_sobksu(), null);
    return tmp0.u1();
  };
  protoOf(ScrollState).ng7 = function () {
    var tmp0 = this.eg7_1;
    var tmp = KProperty1;
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('canScrollBackward', 1, tmp, ScrollState$_get_canScrollBackward_$ref_b5ydxc(), null);
    return tmp0.u1();
  };
  protoOf(ScrollState).tg7 = function (value, $completion) {
    return scrollBy_0(this, value - this.u1() | 0, $completion);
  };
  function rememberScrollState(initial, $composer, $changed, $default) {
    var initial_0 = {_v: initial};
    var $composer_0 = $composer;
    if (!(($default & 1) === 0)) {
      initial_0._v = 0;
    }
    var tmp = Companion_getInstance_58().fg7_1;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.m31(initial_0._v) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp_0;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = rememberScrollState$lambda(initial_0);
      $composer_0.j31(value);
      tmp_0 = value;
    } else {
      tmp_0 = it;
    }
    var tmp$ret$0 = tmp_0;
    return rememberSaveable([], tmp, tmp$ret$0, $composer_0, 0);
  }
  function horizontalScroll(_this__u8e3s4, state, enabled, flingBehavior, reverseScrolling) {
    enabled = enabled === VOID ? true : enabled;
    flingBehavior = flingBehavior === VOID ? null : flingBehavior;
    reverseScrolling = reverseScrolling === VOID ? false : reverseScrolling;
    return scroll(_this__u8e3s4, state, reverseScrolling, flingBehavior, enabled, false, true);
  }
  function scroll(_this__u8e3s4, state, reverseScrolling, flingBehavior, isScrollable, isVertical, useLocalOverscrollFactory, overscrollEffect) {
    overscrollEffect = overscrollEffect === VOID ? null : overscrollEffect;
    var orientation = isVertical ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance();
    var tmp;
    if (useLocalOverscrollFactory) {
      var tmp0_interactionSource = state.yg6_1;
      tmp = scrollableArea(_this__u8e3s4, state, orientation, isScrollable, reverseScrolling, flingBehavior, tmp0_interactionSource);
    } else {
      var tmp1_interactionSource = state.yg6_1;
      tmp = scrollableArea_0(_this__u8e3s4, state, orientation, overscrollEffect, isScrollable, reverseScrolling, flingBehavior, tmp1_interactionSource);
    }
    var scrollableArea_1 = tmp;
    return scrollableArea_1.d8v(new ScrollingLayoutElement(state, reverseScrolling, isVertical));
  }
  function ScrollingLayoutElement(scrollState, reverseScrolling, isVertical) {
    ModifierNodeElement.call(this);
    this.vg7_1 = scrollState;
    this.wg7_1 = reverseScrolling;
    this.xg7_1 = isVertical;
  }
  protoOf(ScrollingLayoutElement).r3d = function () {
    return new ScrollNode(this.vg7_1, this.wg7_1, this.xg7_1);
  };
  protoOf(ScrollingLayoutElement).yg7 = function (node) {
    node.ng8_1 = this.vg7_1;
    node.og8_1 = this.wg7_1;
    node.pg8_1 = this.xg7_1;
  };
  protoOf(ScrollingLayoutElement).d8y = function (node) {
    return this.yg7(node instanceof ScrollNode ? node : THROW_CCE());
  };
  protoOf(ScrollingLayoutElement).hashCode = function () {
    var result = hashCode(this.vg7_1);
    result = imul(31, result) + getBooleanHashCode(this.wg7_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.xg7_1) | 0;
    return result;
  };
  protoOf(ScrollingLayoutElement).equals = function (other) {
    if (!(other instanceof ScrollingLayoutElement))
      return false;
    return equals(this.vg7_1, other.vg7_1) && this.wg7_1 === other.wg7_1 && this.xg7_1 === other.xg7_1;
  };
  function ScrollNode$measure$lambda$lambda($placeable, $xOffset, $yOffset) {
    return function ($this$withMotionFrameOfReferencePlacement) {
      $this$withMotionFrameOfReferencePlacement.pal($placeable, $xOffset, $yOffset);
      return Unit_instance;
    };
  }
  function ScrollNode$measure$lambda(this$0, $side, $placeable) {
    return function ($this$layout) {
      var tmp0 = this$0.ng8_1.u1();
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      var maximumValue = $side;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_0 = tmp0 < 0 ? 0 : tmp0;
      var scroll = this_0 > maximumValue ? maximumValue : this_0;
      var absScroll = this$0.og8_1 ? scroll - $side | 0 : -scroll | 0;
      var xOffset = this$0.pg8_1 ? 0 : absScroll;
      var yOffset = this$0.pg8_1 ? absScroll : 0;
      $this$layout.xal(ScrollNode$measure$lambda$lambda($placeable, xOffset, yOffset));
      return Unit_instance;
    };
  }
  function ScrollNode$applySemantics$lambda(this$0) {
    return function () {
      return this$0.ng8_1.u1();
    };
  }
  function ScrollNode$applySemantics$lambda_0(this$0) {
    return function () {
      return this$0.ng8_1.kg7();
    };
  }
  function ScrollNode(state, reverseScrolling, isVertical) {
    Node.call(this);
    this.ng8_1 = state;
    this.og8_1 = reverseScrolling;
    this.pg8_1 = isVertical;
  }
  protoOf(ScrollNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    checkScrollableContainerConstraints(constraints, this.pg8_1 ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance());
    var tmp0_maxHeight = this.pg8_1 ? 2147483647 : _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    var tmp1_maxWidth = this.pg8_1 ? _Constraints___get_maxWidth__impl__uuyqc(constraints) : 2147483647;
    var childConstraints = Constraints__copy$default_impl_f452rp(constraints, VOID, tmp1_maxWidth, VOID, tmp0_maxHeight);
    var placeable = measurable.h8y(childConstraints);
    var width = coerceAtMost(placeable.i8y_1, _Constraints___get_maxWidth__impl__uuyqc(constraints));
    var height = coerceAtMost(placeable.j8y_1, _Constraints___get_maxHeight__impl__dt3e8z(constraints));
    var scrollHeight = placeable.j8y_1 - height | 0;
    var scrollWidth = placeable.i8y_1 - width | 0;
    var side = this.pg8_1 ? scrollHeight : scrollWidth;
    this.ng8_1.og7(side);
    this.ng8_1.hg7(this.pg8_1 ? height : width);
    this.ng8_1.jg7(this.pg8_1 ? placeable.j8y_1 : placeable.i8y_1);
    return _this__u8e3s4.n8y(width, height, VOID, ScrollNode$measure$lambda(this, side, placeable));
  };
  protoOf(ScrollNode).o8y = function (_this__u8e3s4, measurable, height) {
    return measurable.b98(this.pg8_1 ? 2147483647 : height);
  };
  protoOf(ScrollNode).p8y = function (_this__u8e3s4, measurable, width) {
    return measurable.d98(this.pg8_1 ? width : 2147483647);
  };
  protoOf(ScrollNode).q8y = function (_this__u8e3s4, measurable, height) {
    return measurable.c98(this.pg8_1 ? 2147483647 : height);
  };
  protoOf(ScrollNode).r8y = function (_this__u8e3s4, measurable, width) {
    return measurable.e98(this.pg8_1 ? width : 2147483647);
  };
  protoOf(ScrollNode).l9i = function (_this__u8e3s4) {
    set_isTraversalGroup(_this__u8e3s4, true);
    var tmp = ScrollNode$applySemantics$lambda(this);
    var accessibilityScrollState = new ScrollAxisRange(tmp, ScrollNode$applySemantics$lambda_0(this), this.og8_1);
    if (this.pg8_1) {
      set_verticalScrollAxisRange(_this__u8e3s4, accessibilityScrollState);
    } else {
      set_horizontalScrollAxisRange(_this__u8e3s4, accessibilityScrollState);
    }
  };
  function verticalScroll(_this__u8e3s4, state, enabled, flingBehavior, reverseScrolling) {
    enabled = enabled === VOID ? true : enabled;
    flingBehavior = flingBehavior === VOID ? null : flingBehavior;
    reverseScrolling = reverseScrolling === VOID ? false : reverseScrolling;
    return scroll(_this__u8e3s4, state, reverseScrolling, flingBehavior, enabled, true, true);
  }
  function rememberScrollState$lambda($initial) {
    return function () {
      return new ScrollState($initial._v);
    };
  }
  function scrollableArea(_this__u8e3s4, state, orientation, enabled, reverseScrolling, flingBehavior, interactionSource, bringIntoViewSpec) {
    enabled = enabled === VOID ? true : enabled;
    reverseScrolling = reverseScrolling === VOID ? false : reverseScrolling;
    flingBehavior = flingBehavior === VOID ? null : flingBehavior;
    interactionSource = interactionSource === VOID ? null : interactionSource;
    bringIntoViewSpec = bringIntoViewSpec === VOID ? null : bringIntoViewSpec;
    return clipScrollableContainer(_this__u8e3s4, orientation).d8v(new ScrollableAreaElement(state, orientation, enabled, reverseScrolling, flingBehavior, interactionSource, bringIntoViewSpec, true, null));
  }
  function scrollableArea_0(_this__u8e3s4, state, orientation, overscrollEffect, enabled, reverseScrolling, flingBehavior, interactionSource, bringIntoViewSpec) {
    enabled = enabled === VOID ? true : enabled;
    reverseScrolling = reverseScrolling === VOID ? false : reverseScrolling;
    flingBehavior = flingBehavior === VOID ? null : flingBehavior;
    interactionSource = interactionSource === VOID ? null : interactionSource;
    bringIntoViewSpec = bringIntoViewSpec === VOID ? null : bringIntoViewSpec;
    return clipScrollableContainer(_this__u8e3s4, orientation).d8v(new ScrollableAreaElement(state, orientation, enabled, reverseScrolling, flingBehavior, interactionSource, bringIntoViewSpec, false, overscrollEffect));
  }
  function ScrollableAreaElement(state, orientation, enabled, reverseScrolling, flingBehavior, interactionSource, bringIntoViewSpec, useLocalOverscrollFactory, overscrollEffect) {
    ModifierNodeElement.call(this);
    this.rg8_1 = state;
    this.sg8_1 = orientation;
    this.tg8_1 = enabled;
    this.ug8_1 = reverseScrolling;
    this.vg8_1 = flingBehavior;
    this.wg8_1 = interactionSource;
    this.xg8_1 = bringIntoViewSpec;
    this.yg8_1 = useLocalOverscrollFactory;
    this.zg8_1 = overscrollEffect;
  }
  protoOf(ScrollableAreaElement).r3d = function () {
    return new ScrollableAreaNode(this.rg8_1, this.sg8_1, this.tg8_1, this.ug8_1, this.vg8_1, this.wg8_1, this.xg8_1, this.yg8_1, this.zg8_1);
  };
  protoOf(ScrollableAreaElement).ag9 = function (node) {
    node.gga(this.rg8_1, this.sg8_1, this.yg8_1, this.zg8_1, this.tg8_1, this.ug8_1, this.vg8_1, this.wg8_1, this.xg8_1);
  };
  protoOf(ScrollableAreaElement).d8y = function (node) {
    return this.ag9(node instanceof ScrollableAreaNode ? node : THROW_CCE());
  };
  protoOf(ScrollableAreaElement).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ScrollableAreaElement))
      THROW_CCE();
    if (!equals(this.rg8_1, other.rg8_1))
      return false;
    if (!this.sg8_1.equals(other.sg8_1))
      return false;
    if (!(this.tg8_1 === other.tg8_1))
      return false;
    if (!(this.ug8_1 === other.ug8_1))
      return false;
    if (!equals(this.vg8_1, other.vg8_1))
      return false;
    if (!equals(this.wg8_1, other.wg8_1))
      return false;
    if (!equals(this.xg8_1, other.xg8_1))
      return false;
    if (!(this.yg8_1 === other.yg8_1))
      return false;
    if (!equals(this.zg8_1, other.zg8_1))
      return false;
    return true;
  };
  protoOf(ScrollableAreaElement).hashCode = function () {
    var result = hashCode(this.rg8_1);
    result = imul(31, result) + this.sg8_1.hashCode() | 0;
    result = imul(31, result) + getBooleanHashCode(this.tg8_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.ug8_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.vg8_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.wg8_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : hashCode(tmp2_safe_receiver);
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_1 = imul(31, result);
    var tmp4_safe_receiver = this.xg8_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : hashCode(tmp4_safe_receiver);
    result = tmp_1 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    result = imul(31, result) + getBooleanHashCode(this.yg8_1) | 0;
    var tmp_2 = imul(31, result);
    var tmp6_safe_receiver = this.zg8_1;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : hashCode(tmp6_safe_receiver);
    result = tmp_2 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0;
    return result;
  };
  function attachOverscrollNodeIfNeeded($this) {
    if ($this.cga_1 == null) {
      if ($this.yg9_1) {
        observeReads($this, ScrollableAreaNode$attachOverscrollNodeIfNeeded$lambda($this));
      }
      var effect = $this.hga();
      if (!(effect == null)) {
        var node = effect.f4n();
        if (!node.f4n().z8v_1) {
          $this.cga_1 = $this.tb1(node);
        }
      }
    } else {
      var tmp0_safe_receiver = $this.cga_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        if (!tmp0_safe_receiver.f4n().z8v_1) {
          $this.tb1(tmp0_safe_receiver);
        }
      }
    }
  }
  function ScrollableAreaNode$attachOverscrollNodeIfNeeded$lambda(this$0) {
    return function () {
      this$0.dga_1 = currentValueOf(this$0, get_LocalOverscrollFactory());
      var tmp = this$0;
      var tmp0_safe_receiver = this$0.dga_1;
      tmp.ega_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ug6();
      return Unit_instance;
    };
  }
  function ScrollableAreaNode(state, orientation, enabled, reverseScrolling, flingBehavior, interactionSource, bringIntoViewSpec, useLocalOverscrollFactory, userProvidedOverscrollEffect) {
    DelegatingNode.call(this);
    this.rg9_1 = state;
    this.sg9_1 = orientation;
    this.tg9_1 = enabled;
    this.ug9_1 = reverseScrolling;
    this.vg9_1 = flingBehavior;
    this.wg9_1 = interactionSource;
    this.xg9_1 = bringIntoViewSpec;
    this.yg9_1 = useLocalOverscrollFactory;
    this.zg9_1 = userProvidedOverscrollEffect;
    this.aga_1 = false;
    this.bga_1 = null;
    this.cga_1 = null;
    this.dga_1 = null;
    this.ega_1 = null;
    this.fga_1 = false;
  }
  protoOf(ScrollableAreaNode).b8w = function () {
    return this.aga_1;
  };
  protoOf(ScrollableAreaNode).hga = function () {
    var tmp;
    if (this.yg9_1) {
      tmp = this.ega_1;
    } else {
      tmp = this.zg9_1;
    }
    return tmp;
  };
  protoOf(ScrollableAreaNode).f8w = function () {
    this.fga_1 = this.iga();
    attachOverscrollNodeIfNeeded(this);
    if (this.bga_1 == null) {
      this.bga_1 = this.tb1(new ScrollableNode(this.rg9_1, this.hga(), this.vg9_1, this.sg9_1, this.tg9_1, this.fga_1, this.wg9_1, this.xg9_1));
    }
  };
  protoOf(ScrollableAreaNode).h8w = function () {
    var tmp0_safe_receiver = this.cga_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.vb1(tmp0_safe_receiver);
    }
  };
  protoOf(ScrollableAreaNode).o8w = function () {
    var reverseDirection = this.iga();
    if (!(this.fga_1 === reverseDirection)) {
      this.fga_1 = reverseDirection;
      this.gga(this.rg9_1, this.sg9_1, this.yg9_1, this.hga(), this.tg9_1, this.ug9_1, this.vg9_1, this.wg9_1, this.xg9_1);
    }
  };
  protoOf(ScrollableAreaNode).gga = function (state, orientation, useLocalOverscrollFactory, overscrollEffect, enabled, reverseScrolling, flingBehavior, interactionSource, bringIntoViewSpec) {
    this.rg9_1 = state;
    this.sg9_1 = orientation;
    var useLocalOverscrollFactoryChanged = false;
    if (!(this.yg9_1 === useLocalOverscrollFactory)) {
      useLocalOverscrollFactoryChanged = true;
      this.yg9_1 = useLocalOverscrollFactory;
    }
    var overscrollEffectChanged = false;
    if (!equals(this.zg9_1, overscrollEffect)) {
      overscrollEffectChanged = true;
      this.zg9_1 = overscrollEffect;
    }
    if (useLocalOverscrollFactoryChanged || (overscrollEffectChanged && !useLocalOverscrollFactory)) {
      var tmp0_safe_receiver = this.cga_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.vb1(tmp0_safe_receiver);
      }
      this.cga_1 = null;
      attachOverscrollNodeIfNeeded(this);
    }
    this.tg9_1 = enabled;
    this.ug9_1 = reverseScrolling;
    this.vg9_1 = flingBehavior;
    this.wg9_1 = interactionSource;
    this.xg9_1 = bringIntoViewSpec;
    this.fga_1 = this.iga();
    var tmp1_safe_receiver = this.bga_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.hgc(state, orientation, this.hga(), enabled, this.fga_1, flingBehavior, interactionSource, bringIntoViewSpec);
    }
  };
  protoOf(ScrollableAreaNode).iga = function () {
    var layoutDirection = LayoutDirection_Ltr_getInstance();
    if (this.z8v_1) {
      layoutDirection = requireLayoutDirection(this);
    }
    return ScrollableDefaults_instance.igc(layoutDirection, this.sg9_1, this.ug9_1);
  };
  protoOf(ScrollableAreaNode).w95 = function () {
    var factory = currentValueOf(this, get_LocalOverscrollFactory());
    if (!equals(factory, this.dga_1)) {
      this.dga_1 = factory;
      this.ega_1 = null;
      var tmp0_safe_receiver = this.cga_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.vb1(tmp0_safe_receiver);
      }
      this.cga_1 = null;
      attachOverscrollNodeIfNeeded(this);
      var tmp1_safe_receiver = this.bga_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.hgc(this.rg9_1, this.sg9_1, this.hga(), this.tg9_1, this.fga_1, this.vg9_1, this.wg9_1, this.xg9_1);
      }
    }
  };
  var androidx_compose_foundation_border_BorderLogic$stable;
  var androidx_compose_foundation_content_ReceiveContentElement$stable;
  var androidx_compose_foundation_content_ReceiveContentNode$stable;
  function ContextMenuArea(state, onDismiss, contextMenuBuilderBlock, modifier, enabled, onOpenGesture, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var enabled_0 = {_v: enabled};
    var onOpenGesture_0 = {_v: onOpenGesture};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1195420540);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(state) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(contextMenuBuilderBlock) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onOpenGesture_0._v) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      if (!(($default & 16) === 0)) {
        enabled_0._v = true;
      }
      if (!(($default & 32) === 0)) {
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance_11().f30_1) {
          var value = ContextMenuArea$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        onOpenGesture_0._v = tmp;
      }
      var tmp_0;
      if (enabled_0._v) {
        $composer_0.m30(-1095188022);
        var tmp_1 = modifier_0._v;
        var tmp0 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(($dirty & 458752) === 131072 | ($dirty & 14) === 4);
        // Inline function 'kotlin.let' call
        var it_0 = tmp0.i31();
        var tmp_2;
        if (invalid || it_0 === Companion_getInstance_11().f30_1) {
          var value_0 = ContextMenuArea$lambda_0(onOpenGesture_0, state);
          tmp0.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_0;
        }
        var tmp$ret$4 = tmp_2;
        var tmp0_group = contextMenuGestures(tmp_1, tmp$ret$4);
        $composer_0.n30();
        tmp_0 = tmp0_group;
      } else {
        $composer_0.m30(-1095031162);
        $composer_0.n30();
        tmp_0 = modifier_0._v;
      }
      var finalModifier = tmp_0;
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = finalModifier;
      var contentAlignment = null;
      var propagateMinConstraints = true;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier_1 = Companion_instance_0;
      if (!((2 & 2) === 0))
        contentAlignment = Companion_getInstance_12().k8t_1;
      if (!((2 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0_0 = Companion_getInstance_14().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_3 = $composer_3.g30();
      if (!isInterface(tmp_3, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      content($composer_5, 14 & $dirty >> 18);
      ContextMenu(state, onDismiss, null, contextMenuBuilderBlock, $composer_5, 14 & $dirty | 112 & $dirty | 7168 & $dirty << 3, 4);
      $composer_3.e31();
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(ContextMenuArea$lambda_1(state, onDismiss, contextMenuBuilderBlock, modifier_0, enabled_0, onOpenGesture_0, content, $changed, $default));
    }
  }
  function ContextMenu(state, onDismiss, modifier, contextMenuBuilderBlock, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-195055274);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(state) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(contextMenuBuilderBlock) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      var status = state.zbq();
      if (!(status instanceof Open)) {
        var tmp1_safe_receiver = $composer_0.t30();
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.p3c(ContextMenu$lambda(state, onDismiss, modifier_0, contextMenuBuilderBlock, $changed, $default));
        }
        return Unit_instance;
      }
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.k31(status);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ContextMenuPopupPositionProvider_init_$Create$(round(status.kgc_1));
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var popupPositionProvider = tmp;
      ContextMenuPopup(popupPositionProvider, onDismiss, modifier_0._v, contextMenuBuilderBlock, $composer_0, 112 & $dirty | 896 & $dirty | 7168 & $dirty, 0);
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(ContextMenu$lambda_0(state, onDismiss, modifier_0, contextMenuBuilderBlock, $changed, $default));
    }
  }
  function ContextMenuArea$lambda() {
    return Unit_instance;
  }
  function ContextMenuArea$lambda_0($onOpenGesture, $state) {
    return function (it) {
      $onOpenGesture._v();
      $state.lgc(new Open(it.e5d_1));
      return Unit_instance;
    };
  }
  function ContextMenuArea$lambda_1($state, $onDismiss, $contextMenuBuilderBlock, $modifier, $enabled, $onOpenGesture, $content, $$changed, $$default) {
    return function ($composer, $force) {
      ContextMenuArea($state, $onDismiss, $contextMenuBuilderBlock, $modifier._v, $enabled._v, $onOpenGesture._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ContextMenu$lambda($state, $onDismiss, $modifier, $contextMenuBuilderBlock, $$changed, $$default) {
    return function ($composer, $force) {
      ContextMenu($state, $onDismiss, $modifier._v, $contextMenuBuilderBlock, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ContextMenu$lambda_0($state, $onDismiss, $modifier, $contextMenuBuilderBlock, $$changed, $$default) {
    return function ($composer, $force) {
      ContextMenu($state, $onDismiss, $modifier._v, $contextMenuBuilderBlock, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function contextMenuGestures(_this__u8e3s4, onOpenGesture) {
    var tmp = ContextMenuKey_instance;
    var tmp_0 = contextMenuGestures$slambda_0(onOpenGesture, null);
    return pointerInput(_this__u8e3s4, tmp, new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0(tmp_0));
  }
  function ContextMenuKey() {
  }
  var ContextMenuKey_instance;
  function ContextMenuKey_getInstance() {
    return ContextMenuKey_instance;
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0(function_0) {
    this.mgc_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0).ka7 = function (_this__u8e3s4, $completion) {
    return this.mgc_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0).q3 = function () {
    return this.mgc_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function contextMenuGestures$slambda($onOpenGesture, resultContinuation) {
    this.vgc_1 = $onOpenGesture;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(contextMenuGestures$slambda).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(contextMenuGestures$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(contextMenuGestures$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = onRightClickDown(this.wgc_1, this.vgc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(contextMenuGestures$slambda).wc6 = function ($this$pointerInput, completion) {
    var i = new contextMenuGestures$slambda(this.vgc_1, completion);
    i.wgc_1 = $this$pointerInput;
    return i;
  };
  function contextMenuGestures$slambda_0($onOpenGesture, resultContinuation) {
    var i = new contextMenuGestures$slambda($onOpenGesture, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  var androidx_compose_foundation_contextmenu_ContextMenuPopupPositionProvider$stable;
  function ContextMenuPopupPositionProvider_init_$Init$(anchorPosition, onPositionCalculated, $this) {
    onPositionCalculated = onPositionCalculated === VOID ? null : onPositionCalculated;
    ContextMenuPopupPositionProvider.call($this, ContextMenuPopupPositionProvider$_init_$lambda_rw8evn(anchorPosition), onPositionCalculated);
    return $this;
  }
  function ContextMenuPopupPositionProvider_init_$Create$(anchorPosition, onPositionCalculated) {
    return ContextMenuPopupPositionProvider_init_$Init$(anchorPosition, onPositionCalculated, objectCreate(protoOf(ContextMenuPopupPositionProvider)));
  }
  function ContextMenuPopupPositionProvider$_init_$lambda_rw8evn($anchorPosition) {
    return function () {
      return new IntOffset($anchorPosition);
    };
  }
  function ContextMenuPopupPositionProvider(anchorPositionBlock, onPositionCalculated) {
    onPositionCalculated = onPositionCalculated === VOID ? null : onPositionCalculated;
    this.xgc_1 = anchorPositionBlock;
    this.ygc_1 = onPositionCalculated;
  }
  protoOf(ContextMenuPopupPositionProvider).ldb = function (anchorBounds, windowSize, layoutDirection, popupContentSize) {
    var anchorPosition = this.xgc_1().a5g_1;
    var tmp = anchorBounds.f5g_1 + _IntOffset___get_x__impl__qiqr5o(anchorPosition) | 0;
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(popupContentSize);
    var tmp_0 = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(windowSize);
    var tmp$ret$2 = convertToInt(shiftRight(value_0, 32));
    var tmp0 = alignPopupAxis(tmp, tmp_0, tmp$ret$2, layoutDirection.equals(LayoutDirection_Ltr_getInstance()));
    var tmp_1 = anchorBounds.g5g_1 + _IntOffset___get_y__impl__2avpwj(anchorPosition) | 0;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_1 = _IntSize___get_packedValue__impl__uho7jf(popupContentSize);
    var tmp_2 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(windowSize);
    var tmp$ret$6 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = alignPopupAxis(tmp_1, tmp_2, tmp$ret$6);
    var tmp$ret$9 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    var resultPosition = _IntOffset___init__impl__rq8h7b(tmp$ret$9);
    var tmp0_safe_receiver = this.ygc_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(new IntOffset(anchorPosition), IntRect(resultPosition, popupContentSize));
    return resultPosition;
  };
  function alignPopupAxis(position, popupLength, windowLength, closeAffinity) {
    closeAffinity = closeAffinity === VOID ? true : closeAffinity;
    return popupLength >= windowLength ? alignStartEdges(popupLength, windowLength, closeAffinity) : popupFitsBetweenPositionAndEndEdge(position, popupLength, windowLength, closeAffinity) ? alignPopupStartEdgeToPosition(position, popupLength, closeAffinity) : popupFitsBetweenPositionAndStartEdge(position, popupLength, windowLength, closeAffinity) ? alignPopupEndEdgeToPosition(position, popupLength, closeAffinity) : alignEndEdges(popupLength, windowLength, closeAffinity);
  }
  function alignStartEdges(popupLength, windowLength, closeAffinity) {
    return closeAffinity ? 0 : windowLength - popupLength | 0;
  }
  function popupFitsBetweenPositionAndEndEdge(position, popupLength, windowLength, closeAffinity) {
    return popupFitsBetweenPositionAndStartEdge(position, popupLength, windowLength, !closeAffinity);
  }
  function alignPopupStartEdgeToPosition(position, popupLength, closeAffinity) {
    return closeAffinity ? position : position - popupLength | 0;
  }
  function popupFitsBetweenPositionAndStartEdge(position, popupLength, windowLength, closeAffinity) {
    var tmp;
    if (closeAffinity) {
      tmp = popupLength <= position;
    } else {
      tmp = (windowLength - popupLength | 0) > position;
    }
    return tmp;
  }
  function alignPopupEndEdgeToPosition(position, popupLength, closeAffinity) {
    return alignPopupStartEdgeToPosition(position, popupLength, !closeAffinity);
  }
  function alignEndEdges(popupLength, windowLength, closeAffinity) {
    return alignStartEdges(popupLength, windowLength, !closeAffinity);
  }
  var androidx_compose_foundation_contextmenu_ContextMenuState_Status_Open$stable;
  var androidx_compose_foundation_contextmenu_ContextMenuState_Status_Closed$stable;
  var androidx_compose_foundation_contextmenu_ContextMenuState_Status$stable;
  var androidx_compose_foundation_contextmenu_ContextMenuState$stable;
  function Open(offset) {
    Status.call(this);
    this.kgc_1 = offset;
    // Inline function 'androidx.compose.ui.geometry.isSpecified' call
    var this_0 = this.kgc_1;
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!!equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
      var tmp$ret$2 = 'ContextMenuState.Status should never be open with an unspecified offset. Use ContextMenuState.Status.Closed instead.';
      throwIllegalStateException(tmp$ret$2);
    }
  }
  protoOf(Open).toString = function () {
    return 'Open(offset=' + Offset__toString_impl_4ffbou(this.kgc_1) + ')';
  };
  protoOf(Open).hashCode = function () {
    return Offset__hashCode_impl_hbql41(this.kgc_1);
  };
  protoOf(Open).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Open))
      return false;
    return equals(this.kgc_1, other.kgc_1);
  };
  function Closed() {
    Closed_instance = this;
    Status.call(this);
  }
  protoOf(Closed).toString = function () {
    return 'Closed';
  };
  var Closed_instance;
  function Closed_getInstance() {
    if (Closed_instance == null)
      new Closed();
    return Closed_instance;
  }
  function Status() {
  }
  function ContextMenuState$_get_status_$ref_abw1uf() {
    return constructCallableReference(function (p0) {
      return p0.zbq();
    }, 1, 0, 249);
  }
  function ContextMenuState$_set_status_$ref_4qcjat() {
    return constructCallableReference(function (p0, p1) {
      p0.lgc(p1);
      return Unit_instance;
    }, 2, 0, 250);
  }
  function ContextMenuState(initialStatus) {
    initialStatus = initialStatus === VOID ? Closed_getInstance() : initialStatus;
    this.jgc_1 = mutableStateOf(initialStatus);
  }
  protoOf(ContextMenuState).lgc = function (_set____db54di) {
    var tmp0 = this.jgc_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ContextMenuState$_get_status_$ref_abw1uf();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('status', 1, tmp, tmp_0, ContextMenuState$_set_status_$ref_4qcjat());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(ContextMenuState).zbq = function () {
    var tmp0 = this.jgc_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ContextMenuState$_get_status_$ref_abw1uf();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('status', 1, tmp, tmp_0, ContextMenuState$_set_status_$ref_4qcjat());
    return tmp0.u1();
  };
  protoOf(ContextMenuState).toString = function () {
    return 'ContextMenuState(status=' + toString(this.zbq()) + ')';
  };
  protoOf(ContextMenuState).hashCode = function () {
    return hashCode(this.zbq());
  };
  protoOf(ContextMenuState).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof ContextMenuState))
      return false;
    return equals(other.zbq(), this.zbq());
  };
  function close(_this__u8e3s4) {
    _this__u8e3s4.lgc(Closed_getInstance());
  }
  function get_DefaultPopupProperties() {
    _init_properties_ContextMenuUi_kt__qmv7g0();
    return DefaultPopupProperties;
  }
  var DefaultPopupProperties;
  function get_DefaultContextMenuColors() {
    _init_properties_ContextMenuUi_kt__qmv7g0();
    return DefaultContextMenuColors;
  }
  var DefaultContextMenuColors;
  var androidx_compose_foundation_contextmenu_ContextMenuSpec$stable;
  var androidx_compose_foundation_contextmenu_ContextMenuScope$stable;
  var androidx_compose_foundation_contextmenu_ContextMenuColors$stable;
  function ContextMenuColors(backgroundColor, textColor, iconColor, disabledTextColor, disabledIconColor) {
    this.zgc_1 = backgroundColor;
    this.agd_1 = textColor;
    this.bgd_1 = iconColor;
    this.cgd_1 = disabledTextColor;
    this.dgd_1 = disabledIconColor;
  }
  protoOf(ContextMenuColors).equals = function (other) {
    if (this === other)
      return true;
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(other instanceof ContextMenuColors);
    }
    if (tmp)
      return false;
    if (!equals(this.zgc_1, other.zgc_1))
      return false;
    if (!equals(this.agd_1, other.agd_1))
      return false;
    if (!equals(this.bgd_1, other.bgd_1))
      return false;
    if (!equals(this.cgd_1, other.cgd_1))
      return false;
    if (!equals(this.dgd_1, other.dgd_1))
      return false;
    return true;
  };
  protoOf(ContextMenuColors).hashCode = function () {
    var result = Color__hashCode_impl_vjyivj(this.zgc_1);
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.agd_1) | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.bgd_1) | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.cgd_1) | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.dgd_1) | 0;
    return result;
  };
  protoOf(ContextMenuColors).toString = function () {
    return 'ContextMenuColors(' + ('backgroundColor=' + Color__toString_impl_hpzmaq(this.zgc_1) + ', ') + ('textColor=' + Color__toString_impl_hpzmaq(this.agd_1) + ', ') + ('iconColor=' + Color__toString_impl_hpzmaq(this.bgd_1) + ', ') + ('disabledTextColor=' + Color__toString_impl_hpzmaq(this.cgd_1) + ', ') + ('disabledIconColor=' + Color__toString_impl_hpzmaq(this.dgd_1)) + ')';
  };
  function ContextMenuScope$Content$lambda($tmp0_rcvr, $colors, $$changed) {
    return function ($composer, $force) {
      $tmp0_rcvr.ggd($colors, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function ContextMenuScope$item$lambda($label, this$0, $modifier, $enabled, $leadingIcon, $onClick) {
    return function (colors, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31(colors) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        var resolvedLabel = $label($composer_0, 0);
        // Inline function 'kotlin.text.isNotBlank' call
        // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
        if (!!isBlank(resolvedLabel)) {
          var tmp$ret$2 = 'Label must not be blank';
          throwIllegalStateException(tmp$ret$2);
        }
        tmp_0 = this$0.egd_1($modifier, resolvedLabel, $enabled, colors, $leadingIcon, $onClick, $composer_0, 7168 & $dirty << 9);
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ContextMenuScope(itemUi) {
    this.egd_1 = itemUi;
    this.fgd_1 = mutableStateListOf();
  }
  protoOf(ContextMenuScope).ggd = function (colors, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-798501095);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(this) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = this.fgd_1;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item(colors, $composer_0, 14 & $dirty);
        }
         while (inductionVariable <= last);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(ContextMenuScope$Content$lambda(this, colors, $changed));
    }
  };
  protoOf(ContextMenuScope).hgd = function () {
    this.fgd_1.c3();
  };
  protoOf(ContextMenuScope).igd = function (label, modifier, enabled, leadingIcon, onClick) {
    var tmp0 = this.fgd_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = ComposableLambda$invoke$ref(composableLambdaInstance(-1789283891, true, ContextMenuScope$item$lambda(label, this, modifier, enabled, leadingIcon, onClick)));
    tmp0.j1(element);
  };
  protoOf(ContextMenuScope).jgd = function (label, modifier, enabled, leadingIcon, onClick, $super) {
    modifier = modifier === VOID ? Companion_instance_0 : modifier;
    enabled = enabled === VOID ? true : enabled;
    leadingIcon = leadingIcon === VOID ? null : leadingIcon;
    var tmp;
    if ($super === VOID) {
      this.igd(label, modifier, enabled, leadingIcon, onClick);
      tmp = Unit_instance;
    } else {
      tmp = $super.igd.call(this, label, modifier, enabled, leadingIcon, onClick);
    }
    return tmp;
  };
  function ComposableLambda$invoke$ref_0(p0) {
    return constructCallableReference(function (p0_0, p1, p2, p3, p4, p5, p6, p7) {
      p0.x50(p0_0, p1, p2, p3, p4, p5, p6, p7);
      return Unit_instance;
    }, 8, 0, 251, VOID, [p0]);
  }
  function ComposableSingletons$ContextMenuUiKt$lambda$_1571120048$lambda_q32sog(modifier, label, enabled, colors, leadingIcon, onClick, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(leadingIcon) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      ContextMenuItem(label, enabled, colors, modifier, leadingIcon, onClick, $composer_0, 14 & $dirty >> 3 | 112 & $dirty >> 3 | 896 & $dirty >> 3 | 7168 & $dirty << 9 | 57344 & $dirty | 458752 & $dirty, 0);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ContextMenuUiKt$lambda$_1455401925$lambda_b73i9j(colors, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      Box(background(height(fillMaxWidth(padding(Companion_instance_0, VOID, ContextMenuSpec_getInstance().vgd_1)), ContextMenuSpec_getInstance().ugd_1), colors.bgd_1), $composer_0, 0);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ContextMenuUiKt() {
    ComposableSingletons$ContextMenuUiKt_instance = this;
    var tmp = this;
    tmp.age_1 = ComposableLambda$invoke$ref_0(composableLambdaInstance(-1571120048, false, ComposableSingletons$ContextMenuUiKt$lambda$_1571120048$lambda_q32sog));
    var tmp_0 = this;
    tmp_0.bge_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1455401925, false, ComposableSingletons$ContextMenuUiKt$lambda$_1455401925$lambda_b73i9j));
  }
  var ComposableSingletons$ContextMenuUiKt_instance;
  function ComposableSingletons$ContextMenuUiKt_getInstance() {
    if (ComposableSingletons$ContextMenuUiKt_instance == null)
      new ComposableSingletons$ContextMenuUiKt();
    return ComposableSingletons$ContextMenuUiKt_instance;
  }
  function ContextMenuItem(label, enabled, colors, modifier, leadingIcon, onClick, $composer, $changed, $default) {
    _init_properties_ContextMenuUi_kt__qmv7g0();
    var modifier_0 = {_v: modifier};
    var leadingIcon_0 = {_v: leadingIcon};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-2001167027);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(leadingIcon_0._v) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74899) === 74898), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      if (!(($default & 16) === 0)) {
        leadingIcon_0._v = null;
      }
      var tmp5_verticalAlignment = ContextMenuSpec_getInstance().pgd_1;
      var tmp6_horizontalArrangement = Arrangement_getInstance().mdq(ContextMenuSpec_getInstance().rgd_1);
      var tmp = modifier_0._v;
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 112) === 32 | ($dirty & 458752) === 131072);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ContextMenuItem$lambda(enabled, onClick);
        tmp0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp$ret$0 = tmp_0;
      var tmp0_$receiver = fillMaxWidth(clickable(tmp, enabled, label, VOID, VOID, tmp$ret$0));
      var tmp1_minWidth = ContextMenuSpec_getInstance().kgd_1;
      var tmp2_maxWidth = ContextMenuSpec_getInstance().lgd_1;
      var tmp3_minHeight = ContextMenuSpec_getInstance().mgd_1;
      var tmp4_maxHeight = ContextMenuSpec_getInstance().mgd_1;
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_1 = padding(sizeIn(tmp0_$receiver, tmp1_minWidth, tmp3_minHeight, tmp2_maxWidth, tmp4_maxHeight), ContextMenuSpec_getInstance().rgd_1);
      var horizontalArrangement = tmp6_horizontalArrangement;
      var verticalAlignment = tmp5_verticalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier_1 = Companion_instance_0;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_12().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0_0 = Companion_getInstance_14().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      var tmp0_safe_receiver = leadingIcon_0._v;
      if (tmp0_safe_receiver == null) {
        $composer_5.m30(-1597947094);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1597947093);
        // Inline function 'kotlin.let' call
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = requiredSizeIn(Companion_instance_0, ContextMenuSpec_getInstance().tgd_1, VOID, ContextMenuSpec_getInstance().tgd_1, ContextMenuSpec_getInstance().tgd_1);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance_0;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_12().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance_0;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_4);
        var tmp0_1 = Companion_getInstance_14().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_2 = $composer_8.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_1);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_14().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_14().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_14().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_14().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_14().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        tmp0_safe_receiver(new Color(enabled ? colors.bgd_1 : colors.dgd_1), $composer_10, 0);
        $composer_8.e31();
        $composer_5.n30();
      }
      var tmp1_style = ContextMenuSpec_getInstance().cge(enabled ? colors.agd_1 : colors.cgd_1);
      var tmp2_modifier = RowScopeInstance_instance.xds(Companion_instance_0, 1.0, true);
      var tmp_3 = _TextOverflow___init__impl__obguoe(0);
      BasicText(label, tmp2_modifier, tmp1_style, null, tmp_3, false, 1, 0, null, null, $composer_5, 1572864 | 14 & $dirty, 952);
      $composer_3.e31();
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver_0 = $composer_0.t30();
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      tmp0_safe_receiver_0.p3c(ContextMenuItem$lambda_0(label, enabled, colors, modifier_0, leadingIcon_0, onClick, $changed, $default));
    }
  }
  function ContextMenuSpec() {
    ContextMenuSpec_instance = this;
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp.kgd_1 = _Dp___init__impl__ms3zkb(112);
    var tmp_0 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_0.lgd_1 = _Dp___init__impl__ms3zkb(280);
    var tmp_1 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_1.mgd_1 = _Dp___init__impl__ms3zkb(48);
    var tmp_2 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_2.ngd_1 = _Dp___init__impl__ms3zkb(3);
    var tmp_3 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_3.ogd_1 = _Dp___init__impl__ms3zkb(4);
    this.pgd_1 = Companion_getInstance_12().u8t_1;
    this.qgd_1 = Companion_getInstance_18().f7v_1;
    var tmp_4 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_4.rgd_1 = _Dp___init__impl__ms3zkb(12);
    var tmp_5 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_5.sgd_1 = _Dp___init__impl__ms3zkb(8);
    var tmp_6 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_6.tgd_1 = _Dp___init__impl__ms3zkb(24);
    var tmp_7 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_7.ugd_1 = _Dp___init__impl__ms3zkb(1);
    var tmp_8 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_8.vgd_1 = _Dp___init__impl__ms3zkb(8);
    this.wgd_1 = get_sp(14);
    this.xgd_1 = Companion_getInstance_19().c7z_1;
    this.ygd_1 = get_sp(20);
    this.zgd_1 = get_sp_0(0.1);
  }
  protoOf(ContextMenuSpec).cge = function (color) {
    var tmp0_textAlign = this.qgd_1;
    var tmp1_fontSize = this.wgd_1;
    var tmp2_fontWeight = this.xgd_1;
    var tmp3_lineHeight = this.ygd_1;
    var tmp4_letterSpacing = this.zgd_1;
    return TextStyle_init_$Create$(color, tmp1_fontSize, tmp2_fontWeight, VOID, VOID, VOID, VOID, tmp4_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_textAlign, VOID, tmp3_lineHeight);
  };
  var ContextMenuSpec_instance;
  function ContextMenuSpec_getInstance() {
    if (ContextMenuSpec_instance == null)
      new ContextMenuSpec();
    return ContextMenuSpec_instance;
  }
  function ContextMenuPopup(popupPositionProvider, onDismiss, modifier, contextMenuBuilderBlock, $composer, $changed, $default) {
    _init_properties_ContextMenuUi_kt__qmv7g0();
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(307841774);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(popupPositionProvider) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(contextMenuBuilderBlock) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      ContextMenuPopup_0(popupPositionProvider, onDismiss, modifier_0._v, computeContextMenuColors($composer_0, 0), contextMenuBuilderBlock, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty | 57344 & $dirty << 3, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ContextMenuPopup$lambda(popupPositionProvider, onDismiss, modifier_0, contextMenuBuilderBlock, $changed, $default));
    }
  }
  function ContextMenuPopup_0(popupPositionProvider, onDismiss, modifier, colors, contextMenuBuilderBlock, $composer, $changed, $default) {
    _init_properties_ContextMenuUi_kt__qmv7g0();
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-305401220);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(popupPositionProvider) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(contextMenuBuilderBlock) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      var tmp = get_DefaultPopupProperties();
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1271367778, true, ContextMenuPopup$lambda_0(modifier_0, colors, contextMenuBuilderBlock), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp$ret$0 = tmp_0;
      Popup(popupPositionProvider, onDismiss, tmp, tmp$ret$0, $composer_0, 3456 | 14 & $dirty | 112 & $dirty, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ContextMenuPopup$lambda_1(popupPositionProvider, onDismiss, modifier_0, colors, contextMenuBuilderBlock, $changed, $default));
    }
  }
  function ContextMenuColumnBuilder(modifier, colors, contextMenuBuilderBlock, $composer, $changed, $default) {
    _init_properties_ContextMenuUi_kt__qmv7g0();
    var modifier_0 = {_v: modifier};
    var colors_0 = {_v: colors};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-625529233);
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(colors_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(contextMenuBuilderBlock) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      if (!(($default & 2) === 0)) {
        colors_0._v = get_DefaultContextMenuColors();
      }
      var tmp = colors_0._v;
      var tmp_0 = modifier_0._v;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-250345048, true, ContextMenuColumnBuilder$lambda(contextMenuBuilderBlock, colors_0), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_1;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ComposableLambda$invoke$ref_2(dispatchReceiver);
        $composer_1.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp$ret$0 = tmp_1;
      ContextMenuColumn(tmp, tmp_0, tmp$ret$0, $composer_0, 384 | 14 & $dirty >> 3 | 112 & $dirty << 3, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ContextMenuColumnBuilder$lambda_0(modifier_0, colors_0, contextMenuBuilderBlock, $changed, $default));
    }
  }
  function ContextMenuColumn(colors, modifier, content, $composer, $changed, $default) {
    _init_properties_ContextMenuUi_kt__qmv7g0();
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-527864079);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      var tmp = padding(width(background(shadow(modifier_0._v, ContextMenuSpec_getInstance().ngd_1, RoundedCornerShape_0(ContextMenuSpec_getInstance().ogd_1)), colors.zgc_1), IntrinsicSize_Max_getInstance()), VOID, ContextMenuSpec_getInstance().sgd_1);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var $changed_0 = 7168 & $dirty << 3;
      var modifier_1 = verticalScroll(tmp, rememberScrollState(0, $composer_0, 0, 1));
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance_0;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_12().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & $changed_0 >> 3 | 112 & $changed_0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0 = Companion_getInstance_14().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      var $composer_4 = $composer_3;
      content(ColumnScopeInstance_instance, $composer_4, 6 | 112 & $changed_0 >> 6);
      $composer_3.e31();
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ContextMenuColumn$lambda(colors, modifier_0, content, $changed, $default));
    }
  }
  function ContextMenuItem$lambda($enabled, $onClick) {
    return function () {
      if ($enabled)
        $onClick();
      return Unit_instance;
    };
  }
  function ContextMenuItem$lambda_0($label, $enabled, $colors, $modifier, $leadingIcon, $onClick, $$changed, $$default) {
    return function ($composer, $force) {
      ContextMenuItem($label, $enabled, $colors, $modifier._v, $leadingIcon._v, $onClick, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ContextMenuPopup$lambda($popupPositionProvider, $onDismiss, $modifier, $contextMenuBuilderBlock, $$changed, $$default) {
    return function ($composer, $force) {
      ContextMenuPopup($popupPositionProvider, $onDismiss, $modifier._v, $contextMenuBuilderBlock, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ContextMenuPopup$lambda_0($modifier, $colors, $contextMenuBuilderBlock) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        ContextMenuColumnBuilder($modifier._v, $colors, $contextMenuBuilderBlock, $composer_0, 0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_1(p0) {
    return constructCallableReference(function (p0_0, p1) {
      p0.t50(p0_0, p1);
      return Unit_instance;
    }, 2, 0, 17, VOID, [p0]);
  }
  function ContextMenuPopup$lambda_1($popupPositionProvider, $onDismiss, $modifier, $colors, $contextMenuBuilderBlock, $$changed, $$default) {
    return function ($composer, $force) {
      ContextMenuPopup_0($popupPositionProvider, $onDismiss, $modifier._v, $colors, $contextMenuBuilderBlock, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ContextMenuColumnBuilder$lambda($contextMenuBuilderBlock, $colors) {
    return function ($this$ContextMenuColumn, $composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance_11().f30_1) {
          var value = new ContextMenuScope(ComposableSingletons$ContextMenuUiKt_getInstance().age_1);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var scope = tmp_0;
        // Inline function 'kotlin.with' call
        scope.hgd();
        $contextMenuBuilderBlock(scope);
        scope.ggd($colors._v, $composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_2(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function ContextMenuColumnBuilder$lambda_0($modifier, $colors, $contextMenuBuilderBlock, $$changed, $$default) {
    return function ($composer, $force) {
      ContextMenuColumnBuilder($modifier._v, $colors._v, $contextMenuBuilderBlock, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ContextMenuColumn$lambda($colors, $modifier, $content, $$changed, $$default) {
    return function ($composer, $force) {
      ContextMenuColumn($colors, $modifier._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var properties_initialized_ContextMenuUi_kt_ol07rm;
  function _init_properties_ContextMenuUi_kt__qmv7g0() {
    if (!properties_initialized_ContextMenuUi_kt_ol07rm) {
      properties_initialized_ContextMenuUi_kt_ol07rm = true;
      DefaultPopupProperties = PopupProperties_init_$Create$(true);
      DefaultContextMenuColors = new ContextMenuColors(Companion_getInstance().m6b_1, Companion_getInstance().i6b_1, Companion_getInstance().i6b_1, Color__copy$default_impl_ectz3s(Companion_getInstance().i6b_1, 0.38), Color__copy$default_impl_ectz3s(Companion_getInstance().i6b_1, 0.38));
      androidx_compose_foundation_contextmenu_ContextMenuSpec$stable = 0;
      androidx_compose_foundation_contextmenu_ContextMenuScope$stable = 0;
      androidx_compose_foundation_contextmenu_ContextMenuColors$stable = 0;
    }
  }
  var androidx_compose_foundation_draganddrop_DragAndDropSourceNode$stable;
  function access$_get_requests__ad7flz($this) {
    return $this.dge_1;
  }
  function BringIntoViewRequestPriorityQueue$enqueue$lambda(this$0, $request) {
    return function (it) {
      this$0.dge_1.g10($request);
      return Unit_instance;
    };
  }
  function BringIntoViewRequestPriorityQueue() {
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.dge_1 = new MutableVector(tmp$ret$2, 0);
  }
  protoOf(BringIntoViewRequestPriorityQueue).n1 = function () {
    return this.dge_1.d3e_1;
  };
  protoOf(BringIntoViewRequestPriorityQueue).ege = function (request) {
    var tmp0_elvis_lhs = request.fge_1();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = request.gge_1;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
      this_0.y9(tmp$ret$3);
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var requestBounds = tmp;
    request.gge_1.f1d(BringIntoViewRequestPriorityQueue$enqueue$lambda(this, request));
    // Inline function 'androidx.compose.runtime.collection.MutableVector.indices' call
    var this_1 = this.dge_1;
    var progression = until(0, this_1.d3e_1);
    var last = progression.x1_1;
    var inductionVariable = progression.y1_1;
    if (last <= inductionVariable)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = this.dge_1;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var index = i;
        var r = tmp0.b3e_1[index];
        var tmp1_elvis_lhs = r.fge_1();
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var rBounds = tmp_0;
        var intersection = requestBounds.r5d(rBounds);
        if (intersection.equals(requestBounds)) {
          this.dge_1.ni(i + 1 | 0, request);
          return true;
        } else if (!intersection.equals(rBounds)) {
          var cause = CancellationException_init_$Create$('bringIntoView call interrupted by a newer, non-overlapping call');
          var inductionVariable_0 = this.dge_1.d3e_1 - 1 | 0;
          if (inductionVariable_0 <= i)
            do {
              var j = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var tmp0_0 = this.dge_1;
              // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
              var index_0 = i;
              tmp0_0.b3e_1[index_0].gge_1.d1d(cause);
            }
             while (!(j === i));
        }
      }
       while (!(i === last));
    this.dge_1.ni(0, request);
    return true;
  };
  protoOf(BringIntoViewRequestPriorityQueue).hge = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.indices' call
    var this_0 = this.dge_1;
    var progression = until(0, this_0.d3e_1);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0 = this.dge_1;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var index = i;
        // Inline function 'kotlin.coroutines.resume' call
        var this_1 = tmp0.b3e_1[index].gge_1;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
        this_1.y9(tmp$ret$3);
      }
       while (!(i === last));
    this.dge_1.c3();
  };
  protoOf(BringIntoViewRequestPriorityQueue).ige = function (cause) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.map' call
    var this_0 = this.dge_1;
    var tmp = 0;
    var tmp_0 = this_0.d3e_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
      tmp_1[tmp_2] = this_0.b3e_1[tmp_2].gge_1;
      tmp = tmp + 1 | 0;
    }
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp_1.length;
    while (inductionVariable < last) {
      var element = tmp_1[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      element.d1d(cause);
    }
    // Inline function 'androidx.compose.runtime.collection.MutableVector.isEmpty' call
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(this.dge_1.d3e_1 === 0)) {
      var tmp$ret$9 = 'uncancelled requests present';
      throwIllegalStateException(tmp$ret$9);
    }
  };
  function BringIntoViewSpec$Companion$DefaultBringIntoViewSpec$1() {
  }
  function Companion_0() {
    Companion_instance_10 = this;
    this.lge_1 = spring();
    var tmp = this;
    tmp.mge_1 = new BringIntoViewSpec$Companion$DefaultBringIntoViewSpec$1();
  }
  protoOf(Companion_0).nge = function (offset, size, containerSize) {
    var trailingEdge = offset + size;
    var leadingEdge = offset;
    var tmp;
    if (leadingEdge >= 0 && trailingEdge <= containerSize) {
      tmp = 0.0;
    } else {
      if (leadingEdge < 0 && trailingEdge > containerSize) {
        tmp = 0.0;
      } else {
        // Inline function 'kotlin.math.abs' call
        var tmp_0 = Math.abs(leadingEdge);
        // Inline function 'kotlin.math.abs' call
        var x = trailingEdge - containerSize;
        if (tmp_0 < Math.abs(x)) {
          tmp = leadingEdge;
        } else {
          tmp = trailingEdge - containerSize;
        }
      }
    }
    return tmp;
  };
  var Companion_instance_10;
  function Companion_getInstance_59() {
    if (Companion_instance_10 == null)
      new Companion_0();
    return Companion_instance_10;
  }
  function BringIntoViewSpec() {
  }
  function get_UnspecifiedIntSize() {
    _init_properties_ContentInViewNode_kt__ricsr1();
    return UnspecifiedIntSize;
  }
  var UnspecifiedIntSize;
  var androidx_compose_foundation_gestures_ContentInViewNode_Request$stable;
  var androidx_compose_foundation_gestures_ContentInViewNode$stable;
  function ContentInViewNode$launchAnimation$slambda$slambda$lambda(this$0, $animationState, $this_scroll, $animationJob) {
    return function (delta) {
      var scrollMultiplier = this$0.egf_1 ? 1.0 : -1.0;
      var adjustedDelta = scrollMultiplier * delta;
      var tmp;
      if (false) {
        println('[ContentInViewModifier] Scroll target changed by \u0394' + delta + ' to ' + ('' + $animationState.qgf_1 + ', scrolling by ' + adjustedDelta + ' ') + ('(reverseDirection=' + this$0.egf_1 + ')'));
        tmp = Unit_instance;
      }
      // Inline function 'kotlin.with' call
      var $this$with = this$0.dgf_1;
      var consumedScroll = scrollMultiplier * $this$with.hgg($this$with.fgg($this_scroll.ggg($this$with.fgg($this$with.egg(adjustedDelta)), Companion_getInstance_20().d9v_1)));
      var tmp_0;
      if (false) {
        println('[ContentInViewModifier] Consumed ' + consumedScroll + ' of scroll');
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp_2 = Math.abs(consumedScroll);
      // Inline function 'kotlin.math.absoluteValue' call
      if (tmp_2 < Math.abs(delta)) {
        // Inline function 'kotlin.math.abs' call
        var tmp_3 = Math.abs(consumedScroll);
        // Inline function 'kotlin.math.abs' call
        var tmp$ret$5 = Math.abs(delta);
        cancel($animationJob, 'Scroll animation cancelled because scroll was not consumed ' + ('(' + tmp_3 + ' < ' + tmp$ret$5 + ')'));
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ContentInViewNode$launchAnimation$slambda$slambda$lambda_0(this$0, $animationState, $bringIntoViewSpec) {
    return function () {
      var tmp;
      if (false) {
        println('[ContentInViewModifier] afterFrame');
        tmp = Unit_instance;
      }
      var tmp0 = this$0.igf_1;
      $l$block_0: {
        // Inline function 'androidx.compose.foundation.gestures.BringIntoViewRequestPriorityQueue.resumeAndRemoveWhile' call
        $l$loop: while (true) {
          // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
          if (!!(access$_get_requests__ad7flz(tmp0).d3e_1 === 0)) {
            break $l$loop;
          }
          var tmp0_0 = access$_get_requests__ad7flz(tmp0).xg().fge_1();
          var tmp$ret$2;
          $l$block: {
            if (tmp0_0 == null) {
              tmp$ret$2 = true;
              break $l$block;
            }
            // Inline function 'kotlin.also' call
            var this_0 = isMaxVisible(this$0, tmp0_0);
            if (false && this_0) {
              println('[ContentInViewModifier] Completed BIV request with bounds ' + tmp0_0.toString());
            }
            tmp$ret$2 = this_0;
          }
          if (tmp$ret$2) {
            var tmp_0 = access$_get_requests__ad7flz(tmp0);
            // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
            var tmp$ret$5 = access$_get_requests__ad7flz(tmp0).d3e_1 - 1 | 0;
            // Inline function 'kotlin.coroutines.resume' call
            var this_1 = tmp_0.h3(tmp$ret$5).gge_1;
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
            this_1.y9(tmp$ret$7);
          } else {
            break $l$block_0;
          }
        }
      }
      var tmp_1;
      var tmp_2;
      if (this$0.jgf_1) {
        var tmp0_safe_receiver = this$0.ggf_1();
        tmp_2 = (tmp0_safe_receiver == null ? null : isMaxVisible(this$0, tmp0_safe_receiver)) === true;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        if (false) {
          println('[ContentInViewModifier] Completed tracking focused child request');
        }
        this$0.jgf_1 = false;
        tmp_1 = Unit_instance;
      }
      $animationState.qgf_1 = calculateScrollDelta(this$0, $bringIntoViewSpec, Companion_getInstance_21().c5g_1);
      var tmp_3;
      if (false) {
        println('[ContentInViewModifier] scroll target after frame: ' + $animationState.qgf_1);
        tmp_3 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ContentInViewNode$launchAnimation$slambda$slambda($animationState, this$0, $bringIntoViewSpec, $viewportAdjustmentForReverseScroll, $animationJob, resultContinuation) {
    this.qgg_1 = $animationState;
    this.rgg_1 = this$0;
    this.sgg_1 = $bringIntoViewSpec;
    this.tgg_1 = $viewportAdjustmentForReverseScroll;
    this.ugg_1 = $animationJob;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentInViewNode$launchAnimation$slambda$slambda).wgg = function ($this$scroll, $completion) {
    var tmp = this.xgg($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ContentInViewNode$launchAnimation$slambda$slambda).ja = function (p1, $completion) {
    return this.wgg((!(p1 == null) ? isInterface(p1, NestedScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ContentInViewNode$launchAnimation$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.qgg_1.qgf_1 = calculateScrollDelta(this.rgg_1, this.sgg_1, this.tgg_1);
            if (false) {
              println('[ContentInViewModifier] Starting scroll animation down from ' + this.qgg_1.qgf_1 + '\u2026');
            }

            this.n9_1 = 1;
            var tmp_0 = ContentInViewNode$launchAnimation$slambda$slambda$lambda(this.rgg_1, this.qgg_1, this.vgg_1, this.ugg_1);
            suspendResult = this.qgg_1.ygg(tmp_0, ContentInViewNode$launchAnimation$slambda$slambda$lambda_0(this.rgg_1, this.qgg_1, this.sgg_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentInViewNode$launchAnimation$slambda$slambda).xgg = function ($this$scroll, completion) {
    var i = new ContentInViewNode$launchAnimation$slambda$slambda(this.qgg_1, this.rgg_1, this.sgg_1, this.tgg_1, this.ugg_1, completion);
    i.vgg_1 = $this$scroll;
    return i;
  };
  function ContentInViewNode$launchAnimation$slambda$slambda_0($animationState, this$0, $bringIntoViewSpec, $viewportAdjustmentForReverseScroll, $animationJob, resultContinuation) {
    var i = new ContentInViewNode$launchAnimation$slambda$slambda($animationState, this$0, $bringIntoViewSpec, $viewportAdjustmentForReverseScroll, $animationJob, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.wgg($this$scroll, $completion);
    }, 1);
  }
  function requireBringIntoViewSpec($this) {
    var tmp0_elvis_lhs = $this.fgf_1;
    return tmp0_elvis_lhs == null ? currentValueOf($this, get_LocalBringIntoViewSpec()) : tmp0_elvis_lhs;
  }
  function launchAnimation($this, viewportAdjustmentForReverseScroll) {
    viewportAdjustmentForReverseScroll = viewportAdjustmentForReverseScroll === VOID ? Companion_getInstance_21().c5g_1 : viewportAdjustmentForReverseScroll;
    var bringIntoViewSpec = requireBringIntoViewSpec($this);
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!!$this.lgf_1) {
      var tmp$ret$1 = 'launchAnimation called when previous animation was running';
      throwIllegalStateException(tmp$ret$1);
    }
    if (false) {
      println('[ContentInViewModifier] launchAnimation');
    }
    var animationState = new UpdatableAnimationState(requireBringIntoViewSpec($this).jge());
    var tmp = $this.a8w();
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    launch(tmp, VOID, tmp_0, ContentInViewNode$launchAnimation$slambda_0($this, animationState, bringIntoViewSpec, viewportAdjustmentForReverseScroll, null));
  }
  function calculateScrollDelta($this, bringIntoViewSpec, viewportAdjustmentForReverseScroll) {
    var tmp0_elvis_lhs = $this.kgf_1;
    var tmp;
    if (new IntSize(tmp0_elvis_lhs) == null) {
      return 0.0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var viewportSize = tmp;
    var tmp1_elvis_lhs = findBringIntoViewRequest($this);
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? $this.jgf_1 ? $this.ggf_1() : null : tmp1_elvis_lhs;
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      return 0.0;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var rectangleToMakeVisible = tmp_0;
    var size = toSize(viewportSize);
    var tmp_1;
    switch ($this.cgf_1.a1_1) {
      case 0:
        var tmp_2 = rectangleToMakeVisible.l5d_1 - _IntOffset___get_y__impl__2avpwj(viewportAdjustmentForReverseScroll);
        var tmp_3 = rectangleToMakeVisible.n5d_1 - rectangleToMakeVisible.l5d_1;
        // Inline function 'androidx.compose.ui.geometry.Size.height' call

        // Inline function 'androidx.compose.ui.util.unpackFloat2' call

        var value = _Size___get_packedValue__impl__7rlt1o(size);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call

        // Inline function 'kotlin.fromBits' call

        var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
        var tmp$ret$0 = floatFromBits(bits);
        tmp_1 = bringIntoViewSpec.kge(tmp_2, tmp_3, tmp$ret$0);
        break;
      case 1:
        var tmp_4 = rectangleToMakeVisible.k5d_1 - _IntOffset___get_x__impl__qiqr5o(viewportAdjustmentForReverseScroll);
        var tmp_5 = rectangleToMakeVisible.m5d_1 - rectangleToMakeVisible.k5d_1;
        // Inline function 'androidx.compose.ui.geometry.Size.width' call

        // Inline function 'androidx.compose.ui.util.unpackFloat1' call

        var value_0 = _Size___get_packedValue__impl__7rlt1o(size);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call

        // Inline function 'kotlin.fromBits' call

        var bits_0 = convertToInt(shiftRight(value_0, 32));
        var tmp$ret$4 = floatFromBits(bits_0);
        tmp_1 = bringIntoViewSpec.kge(tmp_4, tmp_5, tmp$ret$4);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp_1;
  }
  function findBringIntoViewRequest($this) {
    var rectangleToMakeVisible = null;
    // Inline function 'androidx.compose.foundation.gestures.BringIntoViewRequestPriorityQueue.forEachFromSmallest' call
    var this_0 = $this.igf_1;
    var tmp0 = access$_get_requests__ad7flz(this_0);
    $l$block: {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEachReversed' call
      var i = tmp0.d3e_1 - 1 | 0;
      var tmp = tmp0.b3e_1;
      var content = isArray(tmp) ? tmp : THROW_CCE();
      if (i >= content.length) {
        break $l$block;
      }
      while (i >= 0) {
        var tmp0_0 = content[i].fge_1();
        $l$block_0: {
          if (tmp0_0 == null) {
            break $l$block_0;
          }
          if (compareTo_1($this, tmp0_0.o5d(), toSize($this.zgg())) <= 0) {
            rectangleToMakeVisible = tmp0_0;
          } else {
            var tmp0_elvis_lhs = rectangleToMakeVisible;
            return tmp0_elvis_lhs == null ? tmp0_0 : tmp0_elvis_lhs;
          }
        }
        i = i - 1 | 0;
      }
    }
    return rectangleToMakeVisible;
  }
  function computeDestination($this, childBounds) {
    // Inline function 'androidx.compose.ui.geometry.Offset.unaryMinus' call
    var this_0 = relocationOffset($this, childBounds, $this.zgg(), Companion_getInstance_21().c5g_1);
    var tmp$ret$0 = _Offset___init__impl__c168vi(bitwiseXor(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(-2147483648, -2147483648)));
    return childBounds.p5d(tmp$ret$0);
  }
  function isMaxVisible($this, $receiver, size, containerOffset) {
    size = size === VOID ? $this.zgg() : size;
    containerOffset = containerOffset === VOID ? Companion_getInstance_21().c5g_1 : containerOffset;
    var relocationOffset_0 = relocationOffset($this, $receiver, size, containerOffset);
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(relocationOffset_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    // Inline function 'kotlin.math.abs' call
    var x = floatFromBits(bits);
    if (Math.abs(x) <= 0.5) {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(relocationOffset_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      // Inline function 'kotlin.math.abs' call
      var x_0 = floatFromBits(bits_0);
      tmp = Math.abs(x_0) <= 0.5;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function relocationOffset($this, childBounds, containerSize, containerOffset) {
    var size = toSize(containerSize);
    var tmp;
    switch ($this.cgf_1.a1_1) {
      case 0:
        var tmp_0 = requireBringIntoViewSpec($this);
        var tmp_1 = childBounds.l5d_1 - _IntOffset___get_y__impl__2avpwj(containerOffset);
        var tmp_2 = childBounds.n5d_1 - childBounds.l5d_1;
        // Inline function 'androidx.compose.ui.geometry.Size.height' call

        // Inline function 'androidx.compose.ui.util.unpackFloat2' call

        var value = _Size___get_packedValue__impl__7rlt1o(size);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call

        // Inline function 'kotlin.fromBits' call

        var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
        var tmp$ret$0 = floatFromBits(bits);
        // Inline function 'androidx.compose.ui.geometry.Offset' call

        // Inline function 'androidx.compose.ui.util.packFloats' call

        var val2 = tmp_0.kge(tmp_1, tmp_2, tmp$ret$0);
        var v1 = fromInt(toRawBits(0.0));
        var v2 = fromInt(toRawBits(val2));
        var tmp$ret$5 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        tmp = _Offset___init__impl__c168vi(tmp$ret$5);
        break;
      case 1:
        var tmp_3 = requireBringIntoViewSpec($this);
        var tmp_4 = childBounds.k5d_1 - _IntOffset___get_x__impl__qiqr5o(containerOffset);
        var tmp_5 = childBounds.m5d_1 - childBounds.k5d_1;
        // Inline function 'androidx.compose.ui.geometry.Size.width' call

        // Inline function 'androidx.compose.ui.util.unpackFloat1' call

        var value_0 = _Size___get_packedValue__impl__7rlt1o(size);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call

        // Inline function 'kotlin.fromBits' call

        var bits_0 = convertToInt(shiftRight(value_0, 32));
        var tmp$ret$6 = floatFromBits(bits_0);
        // Inline function 'androidx.compose.ui.geometry.Offset' call

        // Inline function 'androidx.compose.ui.util.packFloats' call

        var val1 = tmp_3.kge(tmp_4, tmp_5, tmp$ret$6);
        var v1_0 = fromInt(toRawBits(val1));
        var v2_0 = fromInt(toRawBits(0.0));
        var tmp$ret$11 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
        tmp = _Offset___init__impl__c168vi(tmp$ret$11);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function compareTo_0($this, $receiver, other) {
    var tmp;
    switch ($this.cgf_1.a1_1) {
      case 1:
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call

        // Inline function 'androidx.compose.ui.util.unpackInt1' call

        var value = _IntSize___get_packedValue__impl__uho7jf($receiver);
        var tmp_0 = convertToInt(shiftRight(value, 32));
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call

        // Inline function 'androidx.compose.ui.util.unpackInt1' call

        var value_0 = _IntSize___get_packedValue__impl__uho7jf(other);
        var tmp$ret$2 = convertToInt(shiftRight(value_0, 32));
        tmp = compareTo(tmp_0, tmp$ret$2);
        break;
      case 0:
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call

        // Inline function 'androidx.compose.ui.util.unpackInt2' call

        var value_1 = _IntSize___get_packedValue__impl__uho7jf($receiver);
        var tmp_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call

        // Inline function 'androidx.compose.ui.util.unpackInt2' call

        var value_2 = _IntSize___get_packedValue__impl__uho7jf(other);
        var tmp$ret$6 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
        tmp = compareTo(tmp_1, tmp$ret$6);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function compareTo_1($this, $receiver, other) {
    var tmp;
    switch ($this.cgf_1.a1_1) {
      case 1:
        // Inline function 'androidx.compose.ui.geometry.Size.width' call

        // Inline function 'androidx.compose.ui.util.unpackFloat1' call

        var value = _Size___get_packedValue__impl__7rlt1o($receiver);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call

        // Inline function 'kotlin.fromBits' call

        var bits = convertToInt(shiftRight(value, 32));
        var tmp_0 = floatFromBits(bits);
        // Inline function 'androidx.compose.ui.geometry.Size.width' call

        // Inline function 'androidx.compose.ui.util.unpackFloat1' call

        var value_0 = _Size___get_packedValue__impl__7rlt1o(other);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call

        // Inline function 'kotlin.fromBits' call

        var bits_0 = convertToInt(shiftRight(value_0, 32));
        var tmp$ret$4 = floatFromBits(bits_0);
        tmp = compareTo(tmp_0, tmp$ret$4);
        break;
      case 0:
        // Inline function 'androidx.compose.ui.geometry.Size.height' call

        // Inline function 'androidx.compose.ui.util.unpackFloat2' call

        var value_1 = _Size___get_packedValue__impl__7rlt1o($receiver);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call

        // Inline function 'kotlin.fromBits' call

        var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
        var tmp_1 = floatFromBits(bits_1);
        // Inline function 'androidx.compose.ui.geometry.Size.height' call

        // Inline function 'androidx.compose.ui.util.unpackFloat2' call

        var value_2 = _Size___get_packedValue__impl__7rlt1o(other);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call

        // Inline function 'kotlin.fromBits' call

        var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
        var tmp$ret$12 = floatFromBits(bits_2);
        tmp = compareTo(tmp_1, tmp$ret$12);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function Request(currentBounds, continuation) {
    this.fge_1 = currentBounds;
    this.gge_1 = continuation;
  }
  protoOf(Request).toString = function () {
    var tmp0_safe_receiver = this.gge_1.t9().aa(Key_instance_0);
    var name = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h1h_1;
    var tmp = 'Request@' + toString_1(hashCode(this), 16);
    var tmp_0;
    if (name == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = '[' + name + '](';
    }
    var tmp2_elvis_lhs = tmp_0;
    return tmp + (tmp2_elvis_lhs == null ? '(' : tmp2_elvis_lhs) + ('currentBounds()=' + toString_0(this.fge_1()) + ', ') + ('continuation=' + toString(this.gge_1) + ')');
  };
  function ContentInViewNode$launchAnimation$slambda(this$0, $animationState, $bringIntoViewSpec, $viewportAdjustmentForReverseScroll, resultContinuation) {
    this.igh_1 = this$0;
    this.jgh_1 = $animationState;
    this.kgh_1 = $bringIntoViewSpec;
    this.lgh_1 = $viewportAdjustmentForReverseScroll;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentInViewNode$launchAnimation$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ContentInViewNode$launchAnimation$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ContentInViewNode$launchAnimation$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.ngh_1 = null;
            this.ogh_1 = get_job(this.mgh_1.q19());
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.o9_1 = 3;
            this.igh_1.lgf_1 = true;
            this.n9_1 = 2;
            var tmp_0 = MutatePriority_Default_getInstance();
            suspendResult = this.igh_1.dgf_1.pgh(tmp_0, ContentInViewNode$launchAnimation$slambda$slambda_0(this.jgh_1, this.igh_1, this.kgh_1, this.lgh_1, this.ogh_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (false) {
              println('[ContentInViewModifier] animation completed successfully, resuming' + (' ' + this.igh_1.igf_1.n1() + ' remaining BIV requests\u2026'));
            }

            this.igh_1.igf_1.hge();
            this.o9_1 = 5;
            this.n9_1 = 6;
            continue $sm;
          case 3:
            this.o9_1 = 4;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof CancellationException) {
              var e = this.q9_1;
              this.ngh_1 = e;
              throw e;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            if (false) {
              println('[ContentInViewModifier] animation completed with ' + this.igh_1.igf_1.n1() + ' ' + 'unsatisfied BIV requests');
              var tmp0_safe_receiver = this.ngh_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                printStackTrace(tmp0_safe_receiver);
              }
            }

            this.igh_1.lgf_1 = false;
            this.igh_1.igf_1.ige(this.ngh_1);
            this.igh_1.jgf_1 = false;
            throw t;
          case 5:
            throw this.q9_1;
          case 6:
            this.o9_1 = 5;
            if (false) {
              println('[ContentInViewModifier] animation completed with ' + this.igh_1.igf_1.n1() + ' ' + 'unsatisfied BIV requests');
              var tmp0_safe_receiver_0 = this.ngh_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                printStackTrace(tmp0_safe_receiver_0);
              }
            }

            this.igh_1.lgf_1 = false;
            this.igh_1.igf_1.ige(this.ngh_1);
            this.igh_1.jgf_1 = false;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 5) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(ContentInViewNode$launchAnimation$slambda).q24 = function ($this$launch, completion) {
    var i = new ContentInViewNode$launchAnimation$slambda(this.igh_1, this.jgh_1, this.kgh_1, this.lgh_1, completion);
    i.mgh_1 = $this$launch;
    return i;
  };
  function ContentInViewNode$launchAnimation$slambda_0(this$0, $animationState, $bringIntoViewSpec, $viewportAdjustmentForReverseScroll, resultContinuation) {
    var i = new ContentInViewNode$launchAnimation$slambda(this$0, $animationState, $bringIntoViewSpec, $viewportAdjustmentForReverseScroll, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function $bringChildIntoViewCOROUTINE$(_this__u8e3s4, localRect, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ygh_1 = _this__u8e3s4;
    this.zgh_1 = localRect;
  }
  protoOf($bringChildIntoViewCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0_safe_receiver = this.zgh_1();
            if (!((tmp0_safe_receiver == null ? null : isMaxVisible(this.ygh_1, tmp0_safe_receiver)) === false))
              return Unit_instance;
            this.n9_1 = 1;
            var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
            cancellable.v1e();
            var request = new Request(this.zgh_1, cancellable);
            if (false) {
              println('[ContentInViewModifier] Registering bringChildIntoView request: ' + request.toString());
            }

            if (this.ygh_1.igf_1.ege(request) && !this.ygh_1.lgf_1) {
              launchAnimation(this.ygh_1);
            }

            suspendResult = returnIfSuspended(cancellable.x1b(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ContentInViewNode(orientation, scrollingLogic, reverseDirection, bringIntoViewSpec, getFocusedRect) {
    Node.call(this);
    this.cgf_1 = orientation;
    this.dgf_1 = scrollingLogic;
    this.egf_1 = reverseDirection;
    this.fgf_1 = bringIntoViewSpec;
    this.ggf_1 = getFocusedRect;
    this.hgf_1 = false;
    this.igf_1 = new BringIntoViewRequestPriorityQueue();
    this.jgf_1 = false;
    this.kgf_1 = get_UnspecifiedIntSize();
    this.lgf_1 = false;
  }
  protoOf(ContentInViewNode).b8w = function () {
    return this.hgf_1;
  };
  protoOf(ContentInViewNode).zgg = function () {
    // Inline function 'androidx.compose.foundation.gestures.takeOrElse' call
    var this_0 = this.kgf_1;
    var tmp;
    if (equals(this_0, get_UnspecifiedIntSize())) {
      tmp = Companion_getInstance_22().n5g_1;
    } else {
      tmp = this_0;
    }
    return tmp;
  };
  protoOf(ContentInViewNode).agi = function (localRect) {
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!!equals(this.kgf_1, get_UnspecifiedIntSize())) {
      var tmp$ret$1 = 'Expected BringIntoViewRequester to not be used before parents are placed.';
      throwIllegalStateException(tmp$ret$1);
    }
    return computeDestination(this, localRect);
  };
  protoOf(ContentInViewNode).bgi = function (localRect, $completion) {
    var tmp = new $bringChildIntoViewCOROUTINE$(this, localRect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ContentInViewNode).u91 = function (size) {
    var previousViewportSize = this.zgg();
    this.kgf_1 = size;
    if (compareTo_0(this, size, previousViewportSize) >= 0)
      return Unit_instance;
    if (false) {
      println('[ContentInViewModifier] viewport shrunk: ' + IntSize__toString_impl_54w9zl(previousViewportSize) + ' -> ' + IntSize__toString_impl_54w9zl(size));
    }
    var tmp;
    if (!this.egf_1) {
      var tmp_0;
      if (this.cgf_1.equals(Orientation_Vertical_getInstance())) {
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value = _IntSize___get_packedValue__impl__uho7jf(previousViewportSize);
        var tmp_1 = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_0 = _IntSize___get_packedValue__impl__uho7jf(size);
        // Inline function 'androidx.compose.ui.unit.IntOffset' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2 = tmp_1 - convertToInt(bitwiseAnd(value_0, new Long(-1, 0))) | 0;
        var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
        tmp_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$5);
      } else {
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call
        // Inline function 'androidx.compose.ui.util.unpackInt1' call
        var value_1 = _IntSize___get_packedValue__impl__uho7jf(previousViewportSize);
        var tmp_2 = convertToInt(shiftRight(value_1, 32));
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call
        // Inline function 'androidx.compose.ui.util.unpackInt1' call
        var value_2 = _IntSize___get_packedValue__impl__uho7jf(size);
        // Inline function 'androidx.compose.ui.unit.IntOffset' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val1 = tmp_2 - convertToInt(shiftRight(value_2, 32)) | 0;
        var tmp$ret$11 = bitwiseOr(shiftLeft(fromInt(val1), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
        tmp_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$11);
      }
      tmp = tmp_0;
    } else {
      tmp = Companion_getInstance_21().c5g_1;
    }
    var viewportAdjustmentForReverseScroll = tmp;
    var tmp0_safe_receiver = this.ggf_1();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (false) {
        println('[ContentInViewModifier] focused child bounds: ' + tmp0_safe_receiver.toString());
      }
      if (!this.lgf_1 && !this.jgf_1 && isMaxVisible(this, tmp0_safe_receiver, previousViewportSize) && !isMaxVisible(this, tmp0_safe_receiver, VOID, viewportAdjustmentForReverseScroll)) {
        if (false) {
          println('[ContentInViewModifier] focused child was clipped by viewport shrink: ' + tmp0_safe_receiver.toString());
        }
        this.jgf_1 = true;
        launchAnimation(this, viewportAdjustmentForReverseScroll);
      }
    }
  };
  protoOf(ContentInViewNode).cgi = function (orientation, reverseDirection, bringIntoViewSpec) {
    this.cgf_1 = orientation;
    this.egf_1 = reverseDirection;
    this.fgf_1 = bringIntoViewSpec;
  };
  var properties_initialized_ContentInViewNode_kt_w0e6a3;
  function _init_properties_ContentInViewNode_kt__ricsr1() {
    if (!properties_initialized_ContentInViewNode_kt_w0e6a3) {
      properties_initialized_ContentInViewNode_kt_w0e6a3 = true;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(-1), 32), bitwiseAnd(fromInt(-1), new Long(-1, 0)));
      UnspecifiedIntSize = _IntSize___init__impl__emcjft(tmp$ret$1);
      androidx_compose_foundation_gestures_ContentInViewNode_Request$stable = 8;
      androidx_compose_foundation_gestures_ContentInViewNode$stable = 8;
    }
  }
  function DifferentialVelocityTracker() {
    this.dgi_1 = VelocityTracker1D_init_$Create$(true);
    this.egi_1 = VelocityTracker1D_init_$Create$(true);
  }
  protoOf(DifferentialVelocityTracker).fgi = function (timeMillis, delta) {
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(delta);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp$ret$0 = floatFromBits(bits);
    this.dgi_1.tab(timeMillis, tmp$ret$0);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(delta);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$4 = floatFromBits(bits_0);
    this.egi_1.tab(timeMillis, tmp$ret$4);
  };
  protoOf(DifferentialVelocityTracker).ggi = function () {
    var velocityX = this.dgi_1.xab(3.4028235E38);
    var velocityY = this.egi_1.xab(3.4028235E38);
    return Velocity(velocityX, velocityY);
  };
  function get_mouseSlop() {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return mouseSlop;
  }
  var mouseSlop;
  function get_defaultTouchSlop() {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return defaultTouchSlop;
  }
  var defaultTouchSlop;
  function get_mouseToTouchSlopRatio() {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return mouseToTouchSlopRatio;
  }
  var mouseToTouchSlopRatio;
  var androidx_compose_foundation_gestures_TouchSlopDetector$stable;
  function calculatePostSlopOffset($this, touchSlop) {
    var tmp;
    if ($this.hgi_1 == null) {
      var touchSlopOffset = Offset__times_impl_jz1mli(Offset__div_impl_eaxtg1($this.igi_1, Offset__getDistance_impl_pclvxn($this.igi_1)), touchSlop);
      tmp = Offset__minus_impl_hoj2c0($this.igi_1, touchSlopOffset);
    } else {
      var tmp_0 = $this.jgi($this.igi_1);
      // Inline function 'kotlin.math.sign' call
      var x = $this.jgi($this.igi_1);
      var finalMainAxisChange = tmp_0 - sign(x) * touchSlop;
      var finalCrossAxisChange = $this.kgi($this.igi_1);
      var tmp_1;
      if (equals($this.hgi_1, Orientation_Horizontal_getInstance())) {
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var v1 = fromInt(toRawBits(finalMainAxisChange));
        var v2 = fromInt(toRawBits(finalCrossAxisChange));
        var tmp$ret$2 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        tmp_1 = _Offset___init__impl__c168vi(tmp$ret$2);
      } else {
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var v1_0 = fromInt(toRawBits(finalCrossAxisChange));
        var v2_0 = fromInt(toRawBits(finalMainAxisChange));
        var tmp$ret$4 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
        tmp_1 = _Offset___init__impl__c168vi(tmp$ret$4);
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function TouchSlopDetector(orientation, initialPositionChange) {
    orientation = orientation === VOID ? null : orientation;
    initialPositionChange = initialPositionChange === VOID ? Companion_getInstance_6().g5d_1 : initialPositionChange;
    this.hgi_1 = orientation;
    this.igi_1 = initialPositionChange;
  }
  protoOf(TouchSlopDetector).jgi = function (_this__u8e3s4) {
    var tmp;
    if (equals(this.hgi_1, Orientation_Horizontal_getInstance())) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      tmp = floatFromBits(bits);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp = floatFromBits(bits_0);
    }
    return tmp;
  };
  protoOf(TouchSlopDetector).kgi = function (_this__u8e3s4) {
    var tmp;
    if (equals(this.hgi_1, Orientation_Horizontal_getInstance())) {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
      tmp = floatFromBits(bits);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(shiftRight(value_0, 32));
      tmp = floatFromBits(bits_0);
    }
    return tmp;
  };
  protoOf(TouchSlopDetector).lgi = function (positionChange, touchSlop, shouldCommit) {
    var tmp;
    if (shouldCommit) {
      this.igi_1 = Offset__plus_impl_c78cg0(this.igi_1, positionChange);
      tmp = this.igi_1;
    } else {
      tmp = Offset__plus_impl_c78cg0(this.igi_1, positionChange);
    }
    var finalChange = tmp;
    var tmp_0;
    if (this.hgi_1 == null) {
      tmp_0 = Offset__getDistance_impl_pclvxn(finalChange);
    } else {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = this.jgi(finalChange);
      tmp_0 = Math.abs(this_0);
    }
    var inDirection = tmp_0;
    var hasCrossedSlop = inDirection >= touchSlop;
    var tmp_1;
    if (hasCrossedSlop) {
      tmp_1 = calculatePostSlopOffset(this, touchSlop);
    } else {
      tmp_1 = Companion_getInstance_6().i5d_1;
    }
    return tmp_1;
  };
  protoOf(TouchSlopDetector).mgi = function (positionChange, touchSlop, shouldCommit, $super) {
    shouldCommit = shouldCommit === VOID ? true : shouldCommit;
    return $super === VOID ? this.lgi(positionChange, touchSlop, shouldCommit) : $super.lgi.call(this, new Offset(positionChange), touchSlop, shouldCommit).e5d_1;
  };
  protoOf(TouchSlopDetector).ngi = function (initialPositionAccumulator) {
    this.igi_1 = initialPositionAccumulator;
  };
  protoOf(TouchSlopDetector).ogi = function (initialPositionAccumulator, $super) {
    initialPositionAccumulator = initialPositionAccumulator === VOID ? Companion_getInstance_6().g5d_1 : initialPositionAccumulator;
    var tmp;
    if ($super === VOID) {
      this.ngi(initialPositionAccumulator);
      tmp = Unit_instance;
    } else {
      tmp = $super.ngi.call(this, new Offset(initialPositionAccumulator));
    }
    return tmp;
  };
  protoOf(TouchSlopDetector).pgi = function (delta) {
    var projectedPositionChange = Offset__plus_impl_c78cg0(this.igi_1, delta);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(projectedPositionChange);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = floatFromBits(bits);
    var tmp0_x = Math.abs(this_0);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(projectedPositionChange);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    // Inline function 'kotlin.math.absoluteValue' call
    var this_1 = floatFromBits(bits_0);
    // Inline function 'kotlin.math.atan2' call
    var y = Math.abs(this_1);
    var angle = Math.atan2(y, tmp0_x) * 180 / 3.141592653589793;
    var tmp2_subject = this.hgi_1;
    var tmp;
    switch (tmp2_subject == null ? -1 : tmp2_subject.a1_1) {
      case 1:
        tmp = angle < 30;
        break;
      case 0:
        tmp = angle > 30;
        break;
      default:
        tmp = false;
        break;
    }
    return tmp;
  };
  function pointerSlop(_this__u8e3s4, pointerType) {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return pointerType === Companion_getInstance_23().na2_1 ? _this__u8e3s4.ub9() * get_mouseToTouchSlopRatio() : _this__u8e3s4.ub9();
  }
  function detectDragGestures(_this__u8e3s4, onDragStart, onDragEnd, onDragCancel, onDrag, $completion) {
    var tmp;
    if (onDragStart === VOID) {
      tmp = detectDragGestures$lambda;
    } else {
      tmp = onDragStart;
    }
    onDragStart = tmp;
    var tmp_0;
    if (onDragEnd === VOID) {
      tmp_0 = detectDragGestures$lambda_0;
    } else {
      tmp_0 = onDragEnd;
    }
    onDragEnd = tmp_0;
    var tmp_1;
    if (onDragCancel === VOID) {
      tmp_1 = detectDragGestures$lambda_1;
    } else {
      tmp_1 = onDragCancel;
    }
    onDragCancel = tmp_1;
    var tmp_2 = detectDragGestures$lambda_2(onDragStart);
    var tmp_3 = detectDragGestures$lambda_3(onDragEnd);
    return detectDragGestures_0(_this__u8e3s4, null, tmp_2, tmp_3, onDragCancel, detectDragGestures$lambda_4, onDrag, $completion);
  }
  function detectDragGestures_0(_this__u8e3s4, orientationLock, onDragStart, onDragEnd, onDragCancel, shouldAwaitTouchSlop, onDrag, $completion) {
    var tmp;
    if (onDragStart === VOID) {
      tmp = detectDragGestures$lambda_5;
    } else {
      tmp = onDragStart;
    }
    onDragStart = tmp;
    var tmp_0;
    if (onDragEnd === VOID) {
      tmp_0 = detectDragGestures$lambda_6;
    } else {
      tmp_0 = onDragEnd;
    }
    onDragEnd = tmp_0;
    var tmp_1;
    if (onDragCancel === VOID) {
      tmp_1 = detectDragGestures$lambda_7;
    } else {
      tmp_1 = onDragCancel;
    }
    onDragCancel = tmp_1;
    var tmp_2;
    if (shouldAwaitTouchSlop === VOID) {
      tmp_2 = detectDragGestures$lambda_8;
    } else {
      tmp_2 = shouldAwaitTouchSlop;
    }
    shouldAwaitTouchSlop = tmp_2;
    return awaitEachGesture(_this__u8e3s4, detectDragGestures$slambda_0(shouldAwaitTouchSlop, orientationLock, onDragStart, onDrag, onDragCancel, onDragEnd, null), $completion);
  }
  function processDragGesture(_this__u8e3s4, initialDown, shouldAwaitTouchSlop, orientationLock, onDragStart, onDrag, onDragCancel, onDragEnd, $completion) {
    var tmp = new $processDragGestureCOROUTINE$(_this__u8e3s4, initialDown, shouldAwaitTouchSlop, orientationLock, onDragStart, onDrag, onDragCancel, onDragEnd, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function isPointerUp(_this__u8e3s4, pointerId) {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    var tmp0 = _this__u8e3s4.ca0_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (equals(item.ia0_1, pointerId)) {
            tmp$ret$0 = item;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = null;
    }
    var tmp0_safe_receiver = tmp$ret$0;
    return !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.la0_1) === true);
  }
  function drag(_this__u8e3s4, pointerId, onDrag, $completion) {
    var tmp = new $dragCOROUTINE$(_this__u8e3s4, pointerId, onDrag, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function awaitLongPressOrCancellation(_this__u8e3s4, pointerId, $completion) {
    var tmp = new $awaitLongPressOrCancellationCOROUTINE$(_this__u8e3s4, pointerId, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function awaitTouchSlopOrCancellation(_this__u8e3s4, pointerId, onTouchSlopReached, $completion) {
    var tmp = new $awaitTouchSlopOrCancellationCOROUTINE$(_this__u8e3s4, pointerId, onTouchSlopReached, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function awaitDragOrCancellation(_this__u8e3s4, pointerId, $completion) {
    var tmp = new $awaitDragOrCancellationCOROUTINE$(_this__u8e3s4, pointerId, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function access$isPointerUp$tDragGestureDetectorKt($receiver, pointerId) {
    return isPointerUp($receiver, pointerId);
  }
  function detectDragGestures$lambda(it) {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return Unit_instance;
  }
  function detectDragGestures$lambda_0() {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return Unit_instance;
  }
  function detectDragGestures$lambda_1() {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return Unit_instance;
  }
  function detectDragGestures$lambda_2($onDragStart) {
    return function (_unused_var__etf5q3, slopTriggerChange, _unused_var__etf5q3_0) {
      $onDragStart(new Offset(slopTriggerChange.ka0_1));
      return Unit_instance;
    };
  }
  function detectDragGestures$lambda_3($onDragEnd) {
    return function (it) {
      $onDragEnd();
      return Unit_instance;
    };
  }
  function detectDragGestures$lambda_4() {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return true;
  }
  function detectDragGestures$lambda_5(_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return Unit_instance;
  }
  function detectDragGestures$lambda_6(it) {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return Unit_instance;
  }
  function detectDragGestures$lambda_7() {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return Unit_instance;
  }
  function detectDragGestures$lambda_8() {
    _init_properties_DragGestureDetector_kt__sw7hnt();
    return true;
  }
  function detectDragGestures$slambda($shouldAwaitTouchSlop, $orientationLock, $onDragStart, $onDrag, $onDragCancel, $onDragEnd, resultContinuation) {
    this.lgo_1 = $shouldAwaitTouchSlop;
    this.mgo_1 = $orientationLock;
    this.ngo_1 = $onDragStart;
    this.ogo_1 = $onDrag;
    this.pgo_1 = $onDragCancel;
    this.qgo_1 = $onDragEnd;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectDragGestures$slambda).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectDragGestures$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectDragGestures$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = awaitFirstDown(this.rgo_1, false, PointerEventPass_Initial_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var initialDown = suspendResult;
            this.n9_1 = 2;
            suspendResult = processDragGesture(this.rgo_1, initialDown, this.lgo_1, this.mgo_1, this.ngo_1, this.ogo_1, this.pgo_1, this.qgo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(detectDragGestures$slambda).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new detectDragGestures$slambda(this.lgo_1, this.mgo_1, this.ngo_1, this.ogo_1, this.pgo_1, this.qgo_1, completion);
    i.rgo_1 = $this$awaitEachGesture;
    return i;
  };
  function detectDragGestures$slambda_0($shouldAwaitTouchSlop, $orientationLock, $onDragStart, $onDrag, $onDragCancel, $onDragEnd, resultContinuation) {
    var i = new detectDragGestures$slambda($shouldAwaitTouchSlop, $orientationLock, $onDragStart, $onDrag, $onDragCancel, $onDragEnd, resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  function awaitLongPressOrCancellation$slambda($deepPress, $currentDown, $longPress, resultContinuation) {
    this.agp_1 = $deepPress;
    this.bgp_1 = $currentDown;
    this.cgp_1 = $longPress;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(awaitLongPressOrCancellation$slambda).ic6 = function ($this$withTimeout, $completion) {
    var tmp = this.jc6($this$withTimeout, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(awaitLongPressOrCancellation$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(awaitLongPressOrCancellation$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.fgp_1 = false;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!!this.fgp_1) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = this.dgp_1.pa7(PointerEventPass_Main_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.egp_1 = suspendResult;
            var tmp0 = this.egp_1.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (!changedToUpIgnoreConsumed(item)) {
                    tmp$ret$0 = false;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$0 = true;
            }
             while (false);
            if (tmp$ret$0) {
              this.fgp_1 = true;
            }

            var tmp0_0 = this.egp_1.ca0_1;
            var tmp$ret$2;
            l$ret$3: do {
              var inductionVariable_0 = 0;
              var last_0 = tmp0_0.n1() - 1 | 0;
              if (inductionVariable_0 <= last_0)
                do {
                  var index_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var item_0 = tmp0_0.l1(index_0);
                  if (item_0.qa2() || isOutOfBounds(item_0, this.dgp_1.q95(), this.dgp_1.na7())) {
                    tmp$ret$2 = true;
                    break l$ret$3;
                  }
                }
                 while (inductionVariable_0 <= last_0);
              tmp$ret$2 = false;
            }
             while (false);
            if (tmp$ret$2) {
              this.fgp_1 = true;
            }

            if (get_isDeepPress(this.egp_1)) {
              this.agp_1._v = true;
              this.fgp_1 = true;
            }

            this.n9_1 = 3;
            suspendResult = this.dgp_1.pa7(PointerEventPass_Final_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var consumeCheck = suspendResult;
            var tmp0_1 = consumeCheck.ca0_1;
            var tmp$ret$4;
            l$ret$5: do {
              var inductionVariable_1 = 0;
              var last_1 = tmp0_1.n1() - 1 | 0;
              if (inductionVariable_1 <= last_1)
                do {
                  var index_1 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  var item_1 = tmp0_1.l1(index_1);
                  if (item_1.qa2()) {
                    tmp$ret$4 = true;
                    break l$ret$5;
                  }
                }
                 while (inductionVariable_1 <= last_1);
              tmp$ret$4 = false;
            }
             while (false);
            if (tmp$ret$4) {
              this.fgp_1 = true;
            }

            if (isPointerUp(this.egp_1, this.bgp_1._v.ia0_1)) {
              var tmp0_2 = this.egp_1.ca0_1;
              var tmp$ret$6;
              l$ret$7: do {
                var inductionVariable_2 = 0;
                var last_2 = tmp0_2.n1() - 1 | 0;
                if (inductionVariable_2 <= last_2)
                  do {
                    var index_2 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    var item_2 = tmp0_2.l1(index_2);
                    if (item_2.la0_1) {
                      tmp$ret$6 = item_2;
                      break l$ret$7;
                    }
                  }
                   while (inductionVariable_2 <= last_2);
                tmp$ret$6 = null;
              }
               while (false);
              var newPressed = tmp$ret$6;
              if (!(newPressed == null)) {
                this.bgp_1._v = newPressed;
                this.cgp_1._v = this.bgp_1._v;
              } else {
                this.fgp_1 = true;
              }
            } else {
              var tmp0_3 = this.egp_1.ca0_1;
              var tmp$ret$8;
              l$ret$9: do {
                var inductionVariable_3 = 0;
                var last_3 = tmp0_3.n1() - 1 | 0;
                if (inductionVariable_3 <= last_3)
                  do {
                    var index_3 = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var item_3 = tmp0_3.l1(index_3);
                    if (equals(item_3.ia0_1, this.bgp_1._v.ia0_1)) {
                      tmp$ret$8 = item_3;
                      break l$ret$9;
                    }
                  }
                   while (inductionVariable_3 <= last_3);
                tmp$ret$8 = null;
              }
               while (false);
              this.cgp_1._v = tmp$ret$8;
            }

            this.n9_1 = 1;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(awaitLongPressOrCancellation$slambda).jc6 = function ($this$withTimeout, completion) {
    var i = new awaitLongPressOrCancellation$slambda(this.agp_1, this.bgp_1, this.cgp_1, completion);
    i.dgp_1 = $this$withTimeout;
    return i;
  };
  function awaitLongPressOrCancellation$slambda_0($deepPress, $currentDown, $longPress, resultContinuation) {
    var i = new awaitLongPressOrCancellation$slambda($deepPress, $currentDown, $longPress, resultContinuation);
    return constructCallableReference(function ($this$withTimeout, $completion) {
      return i.ic6($this$withTimeout, $completion);
    }, 1);
  }
  function $processDragGestureCOROUTINE$(_this__u8e3s4, initialDown, shouldAwaitTouchSlop, orientationLock, onDragStart, onDrag, onDragCancel, onDragEnd, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ygi_1 = _this__u8e3s4;
    this.zgi_1 = initialDown;
    this.agj_1 = shouldAwaitTouchSlop;
    this.bgj_1 = orientationLock;
    this.cgj_1 = onDragStart;
    this.dgj_1 = onDrag;
    this.egj_1 = onDragCancel;
    this.fgj_1 = onDragEnd;
  }
  protoOf($processDragGestureCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 54;
            this.igl_1 = this.agj_1();
            if (!this.igl_1) {
              this.zgi_1.ra2();
            }

            this.n9_1 = 1;
            suspendResult = awaitFirstDown(this.ygi_1, false, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.zgj_1 = suspendResult;
            this.ygj_1 = Companion_getInstance_6().g5d_1;
            if (this.igl_1) {
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.xgj_1 = this.zgi_1;
              this.n9_1 = 17;
              continue $sm;
            }

          case 2:
            this.hgl_1 = this.ygi_1;
            this.ggl_1 = this.zgj_1.ia0_1;
            this.fgl_1 = this.zgj_1.qa0_1;
            this.egl_1 = this.bgj_1;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.ugk_1 = this.hgl_1;
            this.cgl_1 = this.ggl_1;
            this.dgl_1 = this.fgl_1;
            this.bgl_1 = this.egl_1;
            this.agl_1 = Companion_getInstance_6().g5d_1;
            if (access$isPointerUp$tDragGestureDetectorKt(this.ugk_1.oa7(), this.cgl_1)) {
              this.sgk_1 = null;
              this.n9_1 = 15;
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            this.wgk_1 = pointerSlop(this.ugk_1.la7(), this.dgl_1);
            this.xgk_1 = this.cgl_1;
            this.vgk_1 = new TouchSlopDetector(this.bgl_1, this.agl_1);
            this.n9_1 = 5;
            continue $sm;
          case 5:
            if (!true) {
              this.n9_1 = 14;
              continue $sm;
            }

            this.n9_1 = 6;
            suspendResult = this.ugk_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.ygk_1 = suspendResult;
            var tmp0 = this.ygk_1.ca0_1;
            var tmp$ret$2;
            l$ret$3: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (equals(item.ia0_1, this.xgk_1)) {
                    tmp$ret$2 = item;
                    break l$ret$3;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$2 = null;
            }
             while (false);
            var tmp0_elvis_lhs = tmp$ret$2;
            if (tmp0_elvis_lhs == null) {
              this.sgk_1 = null;
              this.n9_1 = 15;
              var tmp_0 = this;
              continue $sm;
            } else {
              this.zgk_1 = tmp0_elvis_lhs;
              this.n9_1 = 7;
              continue $sm;
            }

          case 7:
            this.tgk_1 = this.zgk_1;
            if (this.tgk_1.qa2()) {
              this.sgk_1 = null;
              this.n9_1 = 15;
              continue $sm;
            } else {
              if (changedToUpIgnoreConsumed(this.tgk_1)) {
                var tmp0_0 = this.ygk_1.ca0_1;
                var tmp$ret$4;
                l$ret$5: do {
                  var inductionVariable_0 = 0;
                  var last_0 = tmp0_0.n1() - 1 | 0;
                  if (inductionVariable_0 <= last_0)
                    do {
                      var index_0 = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      var item_0 = tmp0_0.l1(index_0);
                      if (item_0.la0_1) {
                        tmp$ret$4 = item_0;
                        break l$ret$5;
                      }
                    }
                     while (inductionVariable_0 <= last_0);
                  tmp$ret$4 = null;
                }
                 while (false);
                var otherDown = tmp$ret$4;
                if (otherDown == null) {
                  this.sgk_1 = null;
                  this.n9_1 = 15;
                  continue $sm;
                } else {
                  this.xgk_1 = otherDown.ia0_1;
                  this.n9_1 = 12;
                  continue $sm;
                }
              } else {
                var postSlopOffset = this.vgk_1.mgi(positionChangeIgnoreConsumed(this.tgk_1), this.wgk_1);
                if (!equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(postSlopOffset), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
                  this.tgk_1.ra2();
                  this.ygj_1 = postSlopOffset;
                  if (this.tgk_1.qa2()) {
                    this.sgk_1 = this.tgk_1;
                    this.n9_1 = 15;
                    continue $sm;
                  } else {
                    this.vgk_1.ogi();
                    this.n9_1 = 10;
                    continue $sm;
                  }
                } else {
                  this.n9_1 = 8;
                  suspendResult = this.ugk_1.pa7(PointerEventPass_Final_getInstance(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              }
            }

          case 8:
            if (this.tgk_1.qa2()) {
              this.sgk_1 = null;
              this.n9_1 = 15;
              continue $sm;
            } else {
              this.n9_1 = 9;
              continue $sm;
            }

          case 9:
            this.n9_1 = 11;
            continue $sm;
          case 10:
            this.n9_1 = 11;
            continue $sm;
          case 11:
            this.n9_1 = 13;
            continue $sm;
          case 12:
            this.n9_1 = 13;
            continue $sm;
          case 13:
            this.n9_1 = 5;
            continue $sm;
          case 14:
            if (false) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.n9_1 = 15;
            continue $sm;
          case 15:
            this.xgj_1 = this.sgk_1;
            if (!(this.xgj_1 == null) && !this.xgj_1.qa2()) {
              this.n9_1 = 2;
              continue $sm;
            }

            this.n9_1 = 16;
            continue $sm;
          case 16:
            this.n9_1 = 17;
            continue $sm;
          case 17:
            this.n9_1 = 18;
            continue $sm;
          case 18:
            var tmp_1;
            if (this.xgj_1 == null) {
              var tmp0_1 = this.ygi_1.oa7().ca0_1;
              var tmp$ret$6;
              l$ret$7: do {
                var inductionVariable_1 = 0;
                var last_1 = tmp0_1.n1() - 1 | 0;
                if (inductionVariable_1 <= last_1)
                  do {
                    var index_1 = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var item_1 = tmp0_1.l1(index_1);
                    if (item_1.la0_1) {
                      tmp$ret$6 = true;
                      break l$ret$7;
                    }
                  }
                   while (inductionVariable_1 <= last_1);
                tmp$ret$6 = false;
              }
               while (false);
              tmp_1 = tmp$ret$6;
            } else {
              tmp_1 = false;
            }

            if (!tmp_1) {
              this.n9_1 = 36;
              continue $sm;
            }

            this.n9_1 = 19;
            continue $sm;
          case 19:
            this.n9_1 = 20;
            suspendResult = this.ygi_1.pa7(PointerEventPass_Final_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 20:
            this.rgk_1 = suspendResult;
            var tmp_2;
            var tmp0_2 = this.rgk_1.ca0_1;
            var tmp$ret$8;
            l$ret$9: do {
              var inductionVariable_2 = 0;
              var last_2 = tmp0_2.n1() - 1 | 0;
              if (inductionVariable_2 <= last_2)
                do {
                  var index_2 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var item_2 = tmp0_2.l1(index_2);
                  if (item_2.qa2()) {
                    tmp$ret$8 = true;
                    break l$ret$9;
                  }
                }
                 while (inductionVariable_2 <= last_2);
              tmp$ret$8 = false;
            }
             while (false);
            if (tmp$ret$8) {
              var tmp0_3 = this.rgk_1.ca0_1;
              var tmp$ret$10;
              l$ret$11: do {
                var inductionVariable_3 = 0;
                var last_3 = tmp0_3.n1() - 1 | 0;
                if (inductionVariable_3 <= last_3)
                  do {
                    var index_3 = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var item_3 = tmp0_3.l1(index_3);
                    if (item_3.la0_1) {
                      tmp$ret$10 = true;
                      break l$ret$11;
                    }
                  }
                   while (inductionVariable_3 <= last_3);
                tmp$ret$10 = false;
              }
               while (false);
              tmp_2 = tmp$ret$10;
            } else {
              tmp_2 = false;
            }

            if (tmp_2) {
              this.n9_1 = 19;
              continue $sm;
            }

            this.n9_1 = 21;
            continue $sm;
          case 21:
            var tmp0_4 = this.rgk_1.ca0_1;
            var tmp$ret$12;
            l$ret$13: do {
              var inductionVariable_4 = 0;
              var last_4 = tmp0_4.n1() - 1 | 0;
              if (inductionVariable_4 <= last_4)
                do {
                  var index_4 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var item_4 = tmp0_4.l1(index_4);
                  if (item_4.la0_1) {
                    tmp$ret$12 = true;
                    break l$ret$13;
                  }
                }
                 while (inductionVariable_4 <= last_4);
              tmp$ret$12 = false;
            }
             while (false);
            if (tmp$ret$12) {
              var tmp0_safe_receiver = firstOrNull(this.rgk_1.ca0_1);
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ka0_1;
              var tmp_3;
              var tmp_4 = tmp1_elvis_lhs;
              if ((tmp_4 == null ? null : new Offset(tmp_4)) == null) {
                tmp_3 = Companion_getInstance_6().g5d_1;
              } else {
                tmp_3 = tmp1_elvis_lhs;
              }
              var initialPositionChange = Offset__minus_impl_hoj2c0(tmp_3, this.zgj_1.ka0_1);
              this.qgk_1 = this.ygi_1;
              this.pgk_1 = this.zgj_1.ia0_1;
              this.ogk_1 = this.zgj_1.qa0_1;
              this.ngk_1 = this.bgj_1;
              this.mgk_1 = initialPositionChange;
              this.n9_1 = 22;
              continue $sm;
            } else {
              this.n9_1 = 35;
              continue $sm;
            }

          case 22:
            this.cgk_1 = this.qgk_1;
            this.kgk_1 = this.pgk_1;
            this.lgk_1 = this.ogk_1;
            this.jgk_1 = this.ngk_1;
            this.igk_1 = this.mgk_1;
            if (access$isPointerUp$tDragGestureDetectorKt(this.cgk_1.oa7(), this.kgk_1)) {
              this.agk_1 = null;
              this.n9_1 = 34;
              continue $sm;
            } else {
              this.n9_1 = 23;
              continue $sm;
            }

          case 23:
            this.egk_1 = pointerSlop(this.cgk_1.la7(), this.lgk_1);
            this.fgk_1 = this.kgk_1;
            this.dgk_1 = new TouchSlopDetector(this.jgk_1, this.igk_1);
            this.n9_1 = 24;
            continue $sm;
          case 24:
            if (!true) {
              this.n9_1 = 33;
              continue $sm;
            }

            this.n9_1 = 25;
            suspendResult = this.cgk_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 25:
            this.ggk_1 = suspendResult;
            var tmp0_5 = this.ggk_1.ca0_1;
            var tmp$ret$16;
            l$ret$17: do {
              var inductionVariable_5 = 0;
              var last_5 = tmp0_5.n1() - 1 | 0;
              if (inductionVariable_5 <= last_5)
                do {
                  var index_5 = inductionVariable_5;
                  inductionVariable_5 = inductionVariable_5 + 1 | 0;
                  var item_5 = tmp0_5.l1(index_5);
                  if (equals(item_5.ia0_1, this.fgk_1)) {
                    tmp$ret$16 = item_5;
                    break l$ret$17;
                  }
                }
                 while (inductionVariable_5 <= last_5);
              tmp$ret$16 = null;
            }
             while (false);
            var tmp0_elvis_lhs_0 = tmp$ret$16;
            if (tmp0_elvis_lhs_0 == null) {
              this.agk_1 = null;
              this.n9_1 = 34;
              var tmp_5 = this;
              continue $sm;
            } else {
              this.hgk_1 = tmp0_elvis_lhs_0;
              this.n9_1 = 26;
              continue $sm;
            }

          case 26:
            this.bgk_1 = this.hgk_1;
            if (this.bgk_1.qa2()) {
              this.agk_1 = null;
              this.n9_1 = 34;
              continue $sm;
            } else {
              if (changedToUpIgnoreConsumed(this.bgk_1)) {
                var tmp0_6 = this.ggk_1.ca0_1;
                var tmp$ret$18;
                l$ret$19: do {
                  var inductionVariable_6 = 0;
                  var last_6 = tmp0_6.n1() - 1 | 0;
                  if (inductionVariable_6 <= last_6)
                    do {
                      var index_6 = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      var item_6 = tmp0_6.l1(index_6);
                      if (item_6.la0_1) {
                        tmp$ret$18 = item_6;
                        break l$ret$19;
                      }
                    }
                     while (inductionVariable_6 <= last_6);
                  tmp$ret$18 = null;
                }
                 while (false);
                var otherDown_0 = tmp$ret$18;
                if (otherDown_0 == null) {
                  this.agk_1 = null;
                  this.n9_1 = 34;
                  continue $sm;
                } else {
                  this.fgk_1 = otherDown_0.ia0_1;
                  this.n9_1 = 31;
                  continue $sm;
                }
              } else {
                var postSlopOffset_0 = this.dgk_1.mgi(positionChangeIgnoreConsumed(this.bgk_1), this.egk_1);
                if (!equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(postSlopOffset_0), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
                  var change = this.bgk_1;
                  change.ra2();
                  this.ygj_1 = positionChange(change);
                  if (this.bgk_1.qa2()) {
                    this.agk_1 = this.bgk_1;
                    this.n9_1 = 34;
                    continue $sm;
                  } else {
                    this.dgk_1.ogi();
                    this.n9_1 = 29;
                    continue $sm;
                  }
                } else {
                  this.n9_1 = 27;
                  suspendResult = this.cgk_1.pa7(PointerEventPass_Final_getInstance(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              }
            }

          case 27:
            if (this.bgk_1.qa2()) {
              this.agk_1 = null;
              this.n9_1 = 34;
              continue $sm;
            } else {
              this.n9_1 = 28;
              continue $sm;
            }

          case 28:
            this.n9_1 = 30;
            continue $sm;
          case 29:
            this.n9_1 = 30;
            continue $sm;
          case 30:
            this.n9_1 = 32;
            continue $sm;
          case 31:
            this.n9_1 = 32;
            continue $sm;
          case 32:
            this.n9_1 = 24;
            continue $sm;
          case 33:
            if (false) {
              this.n9_1 = 22;
              continue $sm;
            }

            this.n9_1 = 34;
            continue $sm;
          case 34:
            this.xgj_1 = this.agk_1;
            this.n9_1 = 35;
            continue $sm;
          case 35:
            this.n9_1 = 18;
            continue $sm;
          case 36:
            if (!(this.xgj_1 == null)) {
              this.cgj_1(this.zgj_1, this.xgj_1, new Offset(this.ygj_1));
              this.dgj_1(this.xgj_1, new Offset(this.ygj_1));
              this.wgj_1 = this.ygi_1;
              this.vgj_1 = this.xgj_1.ia0_1;
              this.ugj_1 = null;
              this.n9_1 = 37;
              continue $sm;
            } else {
              this.n9_1 = 53;
              continue $sm;
            }

          case 37:
            this.sgj_1 = this.wgj_1;
            this.tgj_1 = this.vgj_1;
            this.lgj_1 = this.ugj_1;
            if (access$isPointerUp$tDragGestureDetectorKt(this.sgj_1.oa7(), this.tgj_1)) {
              this.ggj_1 = null;
              this.n9_1 = 52;
              continue $sm;
            } else {
              this.n9_1 = 38;
              continue $sm;
            }

          case 38:
            this.hgj_1 = this.tgj_1;
            this.n9_1 = 39;
            continue $sm;
          case 39:
            if (!true) {
              this.n9_1 = 51;
              continue $sm;
            }

            this.rgj_1 = this.sgj_1;
            this.qgj_1 = this.hgj_1;
            this.n9_1 = 40;
            continue $sm;
          case 40:
            this.pgj_1 = this.rgj_1;
            this.mgj_1 = this.qgj_1;
            this.n9_1 = 41;
            continue $sm;
          case 41:
            if (!true) {
              this.n9_1 = 46;
              continue $sm;
            }

            this.n9_1 = 42;
            suspendResult = this.pgj_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 42:
            this.ngj_1 = suspendResult;
            var tmp0_7 = this.ngj_1.ca0_1;
            var tmp$ret$22;
            l$ret$23: do {
              var inductionVariable_7 = 0;
              var last_7 = tmp0_7.n1() - 1 | 0;
              if (inductionVariable_7 <= last_7)
                do {
                  var index_7 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  var item_7 = tmp0_7.l1(index_7);
                  if (equals(item_7.ia0_1, this.mgj_1)) {
                    tmp$ret$22 = item_7;
                    break l$ret$23;
                  }
                }
                 while (inductionVariable_7 <= last_7);
              tmp$ret$22 = null;
            }
             while (false);
            var tmp0_elvis_lhs_1 = tmp$ret$22;
            if (tmp0_elvis_lhs_1 == null) {
              this.kgj_1 = null;
              this.n9_1 = 47;
              var tmp_6 = this;
              continue $sm;
            } else {
              this.ogj_1 = tmp0_elvis_lhs_1;
              this.n9_1 = 43;
              continue $sm;
            }

          case 43:
            var dragEvent = this.ogj_1;
            if (changedToUpIgnoreConsumed(dragEvent)) {
              var tmp0_8 = this.ngj_1.ca0_1;
              var tmp$ret$26;
              l$ret$27: do {
                var inductionVariable_8 = 0;
                var last_8 = tmp0_8.n1() - 1 | 0;
                if (inductionVariable_8 <= last_8)
                  do {
                    var index_8 = inductionVariable_8;
                    inductionVariable_8 = inductionVariable_8 + 1 | 0;
                    var item_8 = tmp0_8.l1(index_8);
                    if (item_8.la0_1) {
                      tmp$ret$26 = item_8;
                      break l$ret$27;
                    }
                  }
                   while (inductionVariable_8 <= last_8);
                tmp$ret$26 = null;
              }
               while (false);
              var otherDown_1 = tmp$ret$26;
              if (otherDown_1 == null) {
                this.kgj_1 = dragEvent;
                this.n9_1 = 47;
                continue $sm;
              } else {
                this.mgj_1 = otherDown_1.ia0_1;
                this.n9_1 = 44;
                continue $sm;
              }
            } else {
              var positionChange_0 = positionChangeIgnoreConsumed(dragEvent);
              var tmp_7;
              if (this.lgj_1 == null) {
                tmp_7 = Offset__getDistance_impl_pclvxn(positionChange_0);
              } else {
                var tmp_8;
                if (equals(this.lgj_1, Orientation_Vertical_getInstance())) {
                  var value = _Offset___get_packedValue__impl__xh2k8q(positionChange_0);
                  var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
                  tmp_8 = floatFromBits(bits);
                } else {
                  var value_0 = _Offset___get_packedValue__impl__xh2k8q(positionChange_0);
                  var bits_0 = convertToInt(shiftRight(value_0, 32));
                  tmp_8 = floatFromBits(bits_0);
                }
                tmp_7 = tmp_8;
              }
              var motionChange = tmp_7;
              if (!(motionChange === 0.0)) {
                this.kgj_1 = dragEvent;
                this.n9_1 = 47;
                continue $sm;
              } else {
                this.n9_1 = 45;
                continue $sm;
              }
            }

          case 44:
            this.n9_1 = 45;
            continue $sm;
          case 45:
            this.n9_1 = 41;
            continue $sm;
          case 46:
            if (false) {
              this.n9_1 = 40;
              continue $sm;
            }

            this.n9_1 = 47;
            continue $sm;
          case 47:
            var tmp0_elvis_lhs_2 = this.kgj_1;
            if (tmp0_elvis_lhs_2 == null) {
              this.ggj_1 = null;
              this.n9_1 = 52;
              var tmp_9 = this;
              continue $sm;
            } else {
              this.jgj_1 = tmp0_elvis_lhs_2;
              this.n9_1 = 48;
              continue $sm;
            }

          case 48:
            this.igj_1 = this.jgj_1;
            if (this.igj_1.qa2()) {
              this.ggj_1 = null;
              this.n9_1 = 52;
              continue $sm;
            } else {
              this.n9_1 = 49;
              continue $sm;
            }

          case 49:
            if (changedToUpIgnoreConsumed(this.igj_1)) {
              this.ggj_1 = this.igj_1;
              this.n9_1 = 52;
              continue $sm;
            } else {
              this.n9_1 = 50;
              continue $sm;
            }

          case 50:
            var it = this.igj_1;
            this.dgj_1(it, new Offset(positionChange(it)));
            it.ra2();
            this.hgj_1 = this.igj_1.ia0_1;
            this.n9_1 = 39;
            continue $sm;
          case 51:
            if (false) {
              this.n9_1 = 37;
              continue $sm;
            }

            this.n9_1 = 52;
            continue $sm;
          case 52:
            var upEvent = this.ggj_1;
            if (upEvent == null) {
              this.egj_1();
            } else {
              this.fgj_1(upEvent);
            }

            this.n9_1 = 53;
            continue $sm;
          case 53:
            return Unit_instance;
          case 54:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 54) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $dragCOROUTINE$(_this__u8e3s4, pointerId, onDrag, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rgl_1 = _this__u8e3s4;
    this.sgl_1 = pointerId;
    this.tgl_1 = onDrag;
  }
  protoOf($dragCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.ugl_1 = this.sgl_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = awaitDragOrCancellation(this.rgl_1, this.ugl_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return false;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var change = tmp_0;
            if (changedToUpIgnoreConsumed(change)) {
              return true;
            }

            this.tgl_1(change);
            this.ugl_1 = change.ia0_1;
            this.n9_1 = 1;
            continue $sm;
          case 3:
            throw this.q9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $awaitLongPressOrCancellationCOROUTINE$(_this__u8e3s4, pointerId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dgm_1 = _this__u8e3s4;
    this.egm_1 = pointerId;
  }
  protoOf($awaitLongPressOrCancellationCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (isPointerUp(this.dgm_1.oa7(), this.egm_1)) {
              return null;
            }

            var tmp_0 = this;
            var tmp0 = this.dgm_1.oa7().ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (equals(item.ia0_1, this.egm_1)) {
                    tmp$ret$0 = item;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$0 = null;
            }
             while (false);
            var tmp0_elvis_lhs = tmp$ret$0;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.ggm_1 = tmp_1;
            this.hgm_1 = {_v: null};
            var currentDown = {_v: this.ggm_1};
            var longPressTimeout = this.dgm_1.la7().rb9();
            this.o9_1 = 2;
            this.igm_1 = {_v: false};
            this.n9_1 = 1;
            suspendResult = this.dgm_1.sa7(longPressTimeout, awaitLongPressOrCancellation$slambda_0(this.igm_1, currentDown, this.hgm_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_2 = this;
            var tmp_3;
            if (this.igm_1._v) {
              var tmp1_elvis_lhs = this.hgm_1._v;
              tmp_3 = tmp1_elvis_lhs == null ? this.ggm_1 : tmp1_elvis_lhs;
            } else {
              tmp_3 = null;
            }

            tmp_2.fgm_1 = tmp_3;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_4 = this.q9_1;
            if (tmp_4 instanceof PointerEventTimeoutCancellationException) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_5 = this;
              var tmp2_elvis_lhs = this.hgm_1._v;
              tmp_5.fgm_1 = tmp2_elvis_lhs == null ? this.ggm_1 : tmp2_elvis_lhs;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.fgm_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $awaitTouchSlopOrCancellationCOROUTINE$(_this__u8e3s4, pointerId, onTouchSlopReached, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rgm_1 = _this__u8e3s4;
    this.sgm_1 = pointerId;
    this.tgm_1 = onTouchSlopReached;
  }
  protoOf($awaitTouchSlopOrCancellationCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 14;
            var tmp0_pointerType = Companion_getInstance_23().ma2_1;
            this.lgn_1 = this.rgm_1;
            this.kgn_1 = this.sgm_1;
            this.jgn_1 = tmp0_pointerType;
            this.ign_1 = null;
            this.hgn_1 = this.tgm_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.wgm_1 = this.lgn_1;
            this.fgn_1 = this.kgn_1;
            this.ggn_1 = this.jgn_1;
            this.egn_1 = this.ign_1;
            this.dgn_1 = Companion_getInstance_6().g5d_1;
            this.ygm_1 = this.hgn_1;
            if (access$isPointerUp$tDragGestureDetectorKt(this.wgm_1.oa7(), this.fgn_1)) {
              this.ugm_1 = null;
              this.n9_1 = 13;
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            this.zgm_1 = pointerSlop(this.wgm_1.la7(), this.ggn_1);
            this.agn_1 = this.fgn_1;
            this.xgm_1 = new TouchSlopDetector(this.egn_1, this.dgn_1);
            this.n9_1 = 3;
            continue $sm;
          case 3:
            if (!true) {
              this.n9_1 = 12;
              continue $sm;
            }

            this.n9_1 = 4;
            suspendResult = this.wgm_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.bgn_1 = suspendResult;
            var tmp0 = this.bgn_1.ca0_1;
            var tmp$ret$2;
            l$ret$3: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (equals(item.ia0_1, this.agn_1)) {
                    tmp$ret$2 = item;
                    break l$ret$3;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$2 = null;
            }
             while (false);
            var tmp0_elvis_lhs = tmp$ret$2;
            if (tmp0_elvis_lhs == null) {
              this.ugm_1 = null;
              this.n9_1 = 13;
              var tmp_0 = this;
              continue $sm;
            } else {
              this.cgn_1 = tmp0_elvis_lhs;
              this.n9_1 = 5;
              continue $sm;
            }

          case 5:
            this.vgm_1 = this.cgn_1;
            if (this.vgm_1.qa2()) {
              this.ugm_1 = null;
              this.n9_1 = 13;
              continue $sm;
            } else {
              if (changedToUpIgnoreConsumed(this.vgm_1)) {
                var tmp0_0 = this.bgn_1.ca0_1;
                var tmp$ret$4;
                l$ret$5: do {
                  var inductionVariable_0 = 0;
                  var last_0 = tmp0_0.n1() - 1 | 0;
                  if (inductionVariable_0 <= last_0)
                    do {
                      var index_0 = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      var item_0 = tmp0_0.l1(index_0);
                      if (item_0.la0_1) {
                        tmp$ret$4 = item_0;
                        break l$ret$5;
                      }
                    }
                     while (inductionVariable_0 <= last_0);
                  tmp$ret$4 = null;
                }
                 while (false);
                var otherDown = tmp$ret$4;
                if (otherDown == null) {
                  this.ugm_1 = null;
                  this.n9_1 = 13;
                  continue $sm;
                } else {
                  this.agn_1 = otherDown.ia0_1;
                  this.n9_1 = 10;
                  continue $sm;
                }
              } else {
                var postSlopOffset = this.xgm_1.mgi(positionChangeIgnoreConsumed(this.vgm_1), this.zgm_1);
                if (!equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(postSlopOffset), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
                  this.ygm_1(this.vgm_1, new Offset(postSlopOffset));
                  if (this.vgm_1.qa2()) {
                    this.ugm_1 = this.vgm_1;
                    this.n9_1 = 13;
                    continue $sm;
                  } else {
                    this.xgm_1.ogi();
                    this.n9_1 = 8;
                    continue $sm;
                  }
                } else {
                  this.n9_1 = 6;
                  suspendResult = this.wgm_1.pa7(PointerEventPass_Final_getInstance(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              }
            }

          case 6:
            if (this.vgm_1.qa2()) {
              this.ugm_1 = null;
              this.n9_1 = 13;
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 7:
            this.n9_1 = 9;
            continue $sm;
          case 8:
            this.n9_1 = 9;
            continue $sm;
          case 9:
            this.n9_1 = 11;
            continue $sm;
          case 10:
            this.n9_1 = 11;
            continue $sm;
          case 11:
            this.n9_1 = 3;
            continue $sm;
          case 12:
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 13;
            continue $sm;
          case 13:
            return this.ugm_1;
          case 14:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 14) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $awaitDragOrCancellationCOROUTINE$(_this__u8e3s4, pointerId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ugn_1 = _this__u8e3s4;
    this.vgn_1 = pointerId;
  }
  protoOf($awaitDragOrCancellationCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            if (isPointerUp(this.ugn_1.oa7(), this.vgn_1)) {
              return null;
            }

            this.cgo_1 = this.ugn_1;
            this.bgo_1 = this.vgn_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.ago_1 = this.cgo_1;
            this.xgn_1 = this.bgo_1;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.n9_1 = 8;
              continue $sm;
            }

            this.n9_1 = 3;
            suspendResult = this.ago_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.ygn_1 = suspendResult;
            var tmp0 = this.ygn_1.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (equals(item.ia0_1, this.xgn_1)) {
                    tmp$ret$0 = item;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$0 = null;
            }
             while (false);
            var tmp0_elvis_lhs = tmp$ret$0;
            if (tmp0_elvis_lhs == null) {
              this.wgn_1 = null;
              this.n9_1 = 9;
              var tmp_0 = this;
              continue $sm;
            } else {
              this.zgn_1 = tmp0_elvis_lhs;
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            var dragEvent = this.zgn_1;
            if (changedToUpIgnoreConsumed(dragEvent)) {
              var tmp0_0 = this.ygn_1.ca0_1;
              var tmp$ret$4;
              l$ret$5: do {
                var inductionVariable_0 = 0;
                var last_0 = tmp0_0.n1() - 1 | 0;
                if (inductionVariable_0 <= last_0)
                  do {
                    var index_0 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var item_0 = tmp0_0.l1(index_0);
                    if (item_0.la0_1) {
                      tmp$ret$4 = item_0;
                      break l$ret$5;
                    }
                  }
                   while (inductionVariable_0 <= last_0);
                tmp$ret$4 = null;
              }
               while (false);
              var otherDown = tmp$ret$4;
              if (otherDown == null) {
                this.wgn_1 = dragEvent;
                this.n9_1 = 9;
                continue $sm;
              } else {
                this.xgn_1 = otherDown.ia0_1;
                this.n9_1 = 5;
                continue $sm;
              }
            } else {
              if (positionChangedIgnoreConsumed(dragEvent)) {
                this.wgn_1 = dragEvent;
                this.n9_1 = 9;
                continue $sm;
              } else {
                this.n9_1 = 6;
                continue $sm;
              }
            }

          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.n9_1 = 2;
            continue $sm;
          case 7:
            throw this.q9_1;
          case 8:
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 9;
            continue $sm;
          case 9:
            var change = this.wgn_1;
            var tmp_1;
            if ((change == null ? null : change.qa2()) === false) {
              tmp_1 = change;
            } else {
              tmp_1 = null;
            }

            return tmp_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_DragGestureDetector_kt_xqxw6j;
  function _init_properties_DragGestureDetector_kt__sw7hnt() {
    if (!properties_initialized_DragGestureDetector_kt_xqxw6j) {
      properties_initialized_DragGestureDetector_kt_xqxw6j = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      mouseSlop = _Dp___init__impl__ms3zkb(0.125);
      // Inline function 'androidx.compose.ui.unit.dp' call
      defaultTouchSlop = _Dp___init__impl__ms3zkb(18);
      var tmp0 = get_mouseSlop();
      // Inline function 'androidx.compose.ui.unit.Dp.div' call
      var other = get_defaultTouchSlop();
      mouseToTouchSlopRatio = _Dp___get_value__impl__geb1vb(tmp0) / _Dp___get_value__impl__geb1vb(other);
      androidx_compose_foundation_gestures_TouchSlopDetector$stable = 8;
    }
  }
  function get_NoOpOnDragStarted() {
    _init_properties_Draggable_kt__eqnzl1();
    return NoOpOnDragStarted;
  }
  var NoOpOnDragStarted;
  function get_NoOpOnDragStopped() {
    _init_properties_Draggable_kt__eqnzl1();
    return NoOpOnDragStopped;
  }
  var NoOpOnDragStopped;
  var androidx_compose_foundation_gestures_DraggableElement$stable;
  var androidx_compose_foundation_gestures_DraggableNode$stable;
  var androidx_compose_foundation_gestures_DragGestureNode$stable;
  var androidx_compose_foundation_gestures_DragEvent_DragStarted$stable;
  var androidx_compose_foundation_gestures_DragEvent_DragStopped$stable;
  var androidx_compose_foundation_gestures_DragEvent_DragCancelled$stable;
  var androidx_compose_foundation_gestures_DragEvent_DragDelta$stable;
  var androidx_compose_foundation_gestures_DragEvent$stable;
  var androidx_compose_foundation_gestures_DragDetectionState_AwaitDown$stable;
  var androidx_compose_foundation_gestures_DragDetectionState_AwaitTouchSlop$stable;
  var androidx_compose_foundation_gestures_DragDetectionState_AwaitGesturePickup$stable;
  var androidx_compose_foundation_gestures_DragDetectionState_Dragging$stable;
  function DragScope() {
  }
  function draggable(_this__u8e3s4, state, orientation, enabled, interactionSource, startDragImmediately, onDragStarted, onDragStopped, reverseDirection) {
    enabled = enabled === VOID ? true : enabled;
    interactionSource = interactionSource === VOID ? null : interactionSource;
    startDragImmediately = startDragImmediately === VOID ? false : startDragImmediately;
    onDragStarted = onDragStarted === VOID ? get_NoOpOnDragStarted() : onDragStarted;
    onDragStopped = onDragStopped === VOID ? get_NoOpOnDragStopped() : onDragStopped;
    reverseDirection = reverseDirection === VOID ? false : reverseDirection;
    _init_properties_Draggable_kt__eqnzl1();
    return _this__u8e3s4.d8v(new DraggableElement(state, orientation, enabled, interactionSource, startDragImmediately, onDragStarted, onDragStopped, reverseDirection));
  }
  function rememberDraggableState(onDelta, $composer, $changed) {
    _init_properties_Draggable_kt__eqnzl1();
    var $composer_0 = $composer;
    var onDeltaState = rememberUpdatedState(onDelta, $composer_0, 14 & $changed);
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance_11().f30_1) {
      var value = DraggableState(rememberDraggableState$lambda(onDeltaState));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function DraggableState(onDelta) {
    _init_properties_Draggable_kt__eqnzl1();
    return new DefaultDraggableState(onDelta);
  }
  function DraggableElement$Companion$CanDrag$lambda(it) {
    return true;
  }
  function Companion_1() {
    Companion_instance_11 = this;
    var tmp = this;
    tmp.hgp_1 = DraggableElement$Companion$CanDrag$lambda;
  }
  var Companion_instance_11;
  function Companion_getInstance_60() {
    if (Companion_instance_11 == null)
      new Companion_1();
    return Companion_instance_11;
  }
  function DraggableElement(state, orientation, enabled, interactionSource, startDragImmediately, onDragStarted, onDragStopped, reverseDirection) {
    Companion_getInstance_60();
    ModifierNodeElement.call(this);
    this.jgp_1 = state;
    this.kgp_1 = orientation;
    this.lgp_1 = enabled;
    this.mgp_1 = interactionSource;
    this.ngp_1 = startDragImmediately;
    this.ogp_1 = onDragStarted;
    this.pgp_1 = onDragStopped;
    this.qgp_1 = reverseDirection;
  }
  protoOf(DraggableElement).r3d = function () {
    return new DraggableNode(this.jgp_1, Companion_getInstance_60().hgp_1, this.kgp_1, this.lgp_1, this.mgp_1, this.ngp_1, this.ogp_1, this.pgp_1, this.qgp_1);
  };
  protoOf(DraggableElement).rgp = function (node) {
    node.igr(this.jgp_1, Companion_getInstance_60().hgp_1, this.kgp_1, this.lgp_1, this.mgp_1, this.ngp_1, this.ogp_1, this.pgp_1, this.qgp_1);
  };
  protoOf(DraggableElement).d8y = function (node) {
    return this.rgp(node instanceof DraggableNode ? node : THROW_CCE());
  };
  protoOf(DraggableElement).equals = function (other) {
    if (this === other)
      return true;
    if (other === null)
      return false;
    if (!getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof DraggableElement))
      THROW_CCE();
    if (!equals(this.jgp_1, other.jgp_1))
      return false;
    if (!this.kgp_1.equals(other.kgp_1))
      return false;
    if (!(this.lgp_1 === other.lgp_1))
      return false;
    if (!equals(this.mgp_1, other.mgp_1))
      return false;
    if (!(this.ngp_1 === other.ngp_1))
      return false;
    if (!equals(this.ogp_1, other.ogp_1))
      return false;
    if (!equals(this.pgp_1, other.pgp_1))
      return false;
    if (!(this.qgp_1 === other.qgp_1))
      return false;
    return true;
  };
  protoOf(DraggableElement).hashCode = function () {
    var result = hashCode(this.jgp_1);
    result = imul(31, result) + this.kgp_1.hashCode() | 0;
    result = imul(31, result) + getBooleanHashCode(this.lgp_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.mgp_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + getBooleanHashCode(this.ngp_1) | 0;
    result = imul(31, result) + hashCode(this.ogp_1) | 0;
    result = imul(31, result) + hashCode(this.pgp_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.qgp_1) | 0;
    return result;
  };
  function DefaultDraggableState$dragScope$1(this$0) {
    this.jgr_1 = this$0;
  }
  protoOf(DefaultDraggableState$dragScope$1).ggp = function (pixels) {
    return this.jgr_1.kgr_1(pixels);
  };
  function DefaultDraggableState$drag$slambda(this$0, $dragPriority, $block, resultContinuation) {
    this.vgr_1 = this$0;
    this.wgr_1 = $dragPriority;
    this.xgr_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultDraggableState$drag$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultDraggableState$drag$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultDraggableState$drag$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.vgr_1.mgr_1.ug5(this.vgr_1.lgr_1, this.wgr_1, this.xgr_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultDraggableState$drag$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new DefaultDraggableState$drag$slambda(this.vgr_1, this.wgr_1, this.xgr_1, completion);
    i.ygr_1 = $this$coroutineScope;
    return i;
  };
  function DefaultDraggableState$drag$slambda_0(this$0, $dragPriority, $block, resultContinuation) {
    var i = new DefaultDraggableState$drag$slambda(this$0, $dragPriority, $block, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function DefaultDraggableState(onDelta) {
    this.kgr_1 = onDelta;
    var tmp = this;
    tmp.lgr_1 = new DefaultDraggableState$dragScope$1(this);
    this.mgr_1 = new MutatorMutex();
  }
  protoOf(DefaultDraggableState).zgr = function (dragPriority, block, $completion) {
    return coroutineScope(DefaultDraggableState$drag$slambda_0(this, dragPriority, block, null), $completion);
  };
  function DraggableNode$drag$slambda$lambda($this_drag, this$0) {
    return function (dragDelta) {
      $this_drag.ggp(toFloat(reverseIfNeeded_0(this$0, dragDelta.ags_1), this$0.dgr_1));
      return Unit_instance;
    };
  }
  function reverseIfNeeded($this, $receiver) {
    return $this.hgr_1 ? Velocity__times_impl_yav0ik($receiver, -1.0) : Velocity__times_impl_yav0ik($receiver, 1.0);
  }
  function reverseIfNeeded_0($this, $receiver) {
    return $this.hgr_1 ? Offset__times_impl_jz1mli($receiver, -1.0) : Offset__times_impl_jz1mli($receiver, 1.0);
  }
  function DraggableNode$drag$slambda($forEachDelta, this$0, resultContinuation) {
    this.kgs_1 = $forEachDelta;
    this.lgs_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DraggableNode$drag$slambda).ngs = function ($this$drag, $completion) {
    var tmp = this.ogs($this$drag, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DraggableNode$drag$slambda).ja = function (p1, $completion) {
    return this.ngs((!(p1 == null) ? isInterface(p1, DragScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DraggableNode$drag$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.kgs_1(DraggableNode$drag$slambda$lambda(this.mgs_1, this.lgs_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DraggableNode$drag$slambda).ogs = function ($this$drag, completion) {
    var i = new DraggableNode$drag$slambda(this.kgs_1, this.lgs_1, completion);
    i.mgs_1 = $this$drag;
    return i;
  };
  function DraggableNode$drag$slambda_0($forEachDelta, this$0, resultContinuation) {
    var i = new DraggableNode$drag$slambda($forEachDelta, this$0, resultContinuation);
    return constructCallableReference(function ($this$drag, $completion) {
      return i.ngs($this$drag, $completion);
    }, 1);
  }
  function DraggableNode$onDragStarted$slambda(this$0, $startedPosition, resultContinuation) {
    this.xgs_1 = this$0;
    this.ygs_1 = $startedPosition;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DraggableNode$onDragStarted$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DraggableNode$onDragStarted$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DraggableNode$onDragStarted$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.xgs_1.fgr_1(this.zgs_1, new Offset(this.ygs_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DraggableNode$onDragStarted$slambda).q24 = function ($this$launch, completion) {
    var i = new DraggableNode$onDragStarted$slambda(this.xgs_1, this.ygs_1, completion);
    i.zgs_1 = $this$launch;
    return i;
  };
  function DraggableNode$onDragStarted$slambda_0(this$0, $startedPosition, resultContinuation) {
    var i = new DraggableNode$onDragStarted$slambda(this$0, $startedPosition, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function DraggableNode$onDragStopped$slambda(this$0, $event, resultContinuation) {
    this.igt_1 = this$0;
    this.jgt_1 = $event;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DraggableNode$onDragStopped$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DraggableNode$onDragStopped$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DraggableNode$onDragStopped$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.igt_1.ggr_1(this.kgt_1, toFloat_0(reverseIfNeeded(this.igt_1, this.jgt_1.lgt_1), this.igt_1.dgr_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DraggableNode$onDragStopped$slambda).q24 = function ($this$launch, completion) {
    var i = new DraggableNode$onDragStopped$slambda(this.igt_1, this.jgt_1, completion);
    i.kgt_1 = $this$launch;
    return i;
  };
  function DraggableNode$onDragStopped$slambda_0(this$0, $event, resultContinuation) {
    var i = new DraggableNode$onDragStopped$slambda(this$0, $event, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function DraggableNode(state, canDrag, orientation, enabled, interactionSource, startDragImmediately, onDragStarted, onDragStopped, reverseDirection) {
    DragGestureNode.call(this, canDrag, enabled, interactionSource, orientation);
    this.cgr_1 = state;
    this.dgr_1 = orientation;
    this.egr_1 = startDragImmediately;
    this.fgr_1 = onDragStarted;
    this.ggr_1 = onDragStopped;
    this.hgr_1 = reverseDirection;
  }
  protoOf(DraggableNode).ngt = function (forEachDelta, $completion) {
    var tmp = this.cgr_1;
    var tmp_0 = MutatePriority_UserInput_getInstance();
    return tmp.zgr(tmp_0, DraggableNode$drag$slambda_0(forEachDelta, this, null), $completion);
  };
  protoOf(DraggableNode).ogt = function (startedPosition) {
    if (!this.z8v_1 || equals(this.fgr_1, get_NoOpOnDragStarted()))
      return Unit_instance;
    var tmp = this.a8w();
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    launch(tmp, VOID, tmp_0, DraggableNode$onDragStarted$slambda_0(this, startedPosition, null));
  };
  protoOf(DraggableNode).pgt = function (event) {
    if (!this.z8v_1 || equals(this.ggr_1, get_NoOpOnDragStopped()))
      return Unit_instance;
    var tmp = this.a8w();
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    launch(tmp, VOID, tmp_0, DraggableNode$onDragStopped$slambda_0(this, event, null));
  };
  protoOf(DraggableNode).qgt = function () {
    return this.egr_1;
  };
  protoOf(DraggableNode).igr = function (state, canDrag, orientation, enabled, interactionSource, startDragImmediately, onDragStarted, onDragStopped, reverseDirection) {
    var resetPointerInputHandling = false;
    if (!equals(this.cgr_1, state)) {
      this.cgr_1 = state;
      resetPointerInputHandling = true;
    }
    if (!this.dgr_1.equals(orientation)) {
      this.dgr_1 = orientation;
      resetPointerInputHandling = true;
    }
    if (!(this.hgr_1 === reverseDirection)) {
      this.hgr_1 = reverseDirection;
      resetPointerInputHandling = true;
    }
    this.fgr_1 = onDragStarted;
    this.ggr_1 = onDragStopped;
    this.egr_1 = startDragImmediately;
    this.bgv(canDrag, enabled, interactionSource, orientation, resetPointerInputHandling);
  };
  function DragGestureNode$startListeningForEvents$slambda$slambda($event, this$0, resultContinuation) {
    this.ngv_1 = $event;
    this.ogv_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DragGestureNode$startListeningForEvents$slambda$slambda).rgv = function (processDelta, $completion) {
    var tmp = this.sgv(processDelta, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DragGestureNode$startListeningForEvents$slambda$slambda).ja = function (p1, $completion) {
    return this.rgv((!(p1 == null) ? typeof p1 === 'function' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DragGestureNode$startListeningForEvents$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            var tmp_0;
            var tmp_1 = this.ngv_1._v;
            if (!(tmp_1 instanceof DragStopped)) {
              var tmp_2 = this.ngv_1._v;
              tmp_0 = !(tmp_2 instanceof DragCancelled);
            } else {
              tmp_0 = false;
            }

            if (!tmp_0) {
              this.n9_1 = 5;
              continue $sm;
            }

            var tmp_3 = this.ngv_1._v;
            var tmp0_safe_receiver = tmp_3 instanceof DragDelta ? tmp_3 : null;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.pgv_1(tmp0_safe_receiver);
            }

            var tmp1_safe_receiver = this.ogv_1.ngu_1;
            if (tmp1_safe_receiver == null) {
              this.qgv_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = tmp1_safe_receiver.u1s(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.qgv_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var ARGUMENT = this.qgv_1;
            this.ngv_1._v = ARGUMENT;
            this.n9_1 = 1;
            continue $sm;
          case 4:
            throw this.q9_1;
          case 5:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DragGestureNode$startListeningForEvents$slambda$slambda).sgv = function (processDelta, completion) {
    var i = new DragGestureNode$startListeningForEvents$slambda$slambda(this.ngv_1, this.ogv_1, completion);
    i.pgv_1 = processDelta;
    return i;
  };
  function DragGestureNode$startListeningForEvents$slambda$slambda_0($event, this$0, resultContinuation) {
    var i = new DragGestureNode$startListeningForEvents$slambda$slambda($event, this$0, resultContinuation);
    return constructCallableReference(function (processDelta, $completion) {
      return i.rgv(processDelta, $completion);
    }, 1);
  }
  function _get_awaitDownState__saur72($this) {
    var tmp0_elvis_lhs = $this.rgu_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new AwaitDown();
      $this.rgu_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_draggingState__15pugh($this) {
    var tmp0_elvis_lhs = $this.sgu_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new Dragging();
      $this.sgu_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_awaitTouchSlopState__q7iazn($this) {
    var tmp0_elvis_lhs = $this.tgu_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new AwaitTouchSlop_0();
      $this.tgu_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_awaitGesturePickupState__gq0mb3($this) {
    var tmp0_elvis_lhs = $this.ugu_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new AwaitGesturePickup();
      $this.ugu_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function requireVelocityTracker($this) {
    var tmp0 = $this.wgu_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Velocity Tracker not initialized.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$0;
  }
  function requireChannel($this) {
    var tmp0 = $this.ngu_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Events channel not initialized.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$0;
  }
  function requireTouchSlopDetector($this) {
    var tmp0 = $this.ygu_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Touch slop detector not initialized.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$0;
  }
  function startListeningForEvents($this) {
    $this.pgu_1 = true;
    if ($this.ngu_1 == null) {
      $this.ngu_1 = Channel(2147483647);
    }
    var tmp = $this.a8w();
    launch(tmp, VOID, VOID, DragGestureNode$startListeningForEvents$slambda_0($this, null));
  }
  function processDragStart($this, event, $completion) {
    var tmp = new $processDragStartCOROUTINE$($this, event, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function processDragStop($this, event, $completion) {
    var tmp = new $processDragStopCOROUTINE$($this, event, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function processDragCancel($this, $completion) {
    var tmp = new $processDragCancelCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function processRawPointerEvent($this, pointerEvent, pass) {
    var tmp0 = $this.vgu_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'currentDragState should not be null';
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    var state = tmp$ret$0;
    if (state instanceof AwaitDown) {
      processInitialDownState($this, pointerEvent, pass, state);
    } else {
      if (state instanceof AwaitTouchSlop_0) {
        processAwaitTouchSlop($this, pointerEvent, pass, state);
      } else {
        if (state instanceof AwaitGesturePickup) {
          processAwaitGesturePickup($this, pointerEvent, pass, state);
        } else {
          if (state instanceof Dragging) {
            processDraggingState($this, pointerEvent, pass, state);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
  }
  function resetDragDetectionState($this) {
    moveToAwaitDownState($this);
    if ($this.pgu_1) {
      sendDragCancelled($this);
    }
    $this.wgu_1 = null;
  }
  function moveToAwaitTouchSlopState($this, initialDown, pointerId, initialTouchSlopPositionChange, verifyConsumptionInFinalPass) {
    initialTouchSlopPositionChange = initialTouchSlopPositionChange === VOID ? Companion_getInstance_6().g5d_1 : initialTouchSlopPositionChange;
    verifyConsumptionInFinalPass = verifyConsumptionInFinalPass === VOID ? false : verifyConsumptionInFinalPass;
    var tmp = $this;
    // Inline function 'kotlin.apply' call
    var this_0 = _get_awaitTouchSlopState__q7iazn($this);
    this_0.egx_1 = initialDown;
    this_0.fgx_1 = pointerId;
    if ($this.ygu_1 == null) {
      $this.ygu_1 = new TouchSlopDetector($this.hgu_1);
    } else {
      var tmp0_safe_receiver = $this.ygu_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.hgi_1 = $this.hgu_1;
      }
      var tmp1_safe_receiver = $this.ygu_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.ngi(initialTouchSlopPositionChange);
      }
    }
    this_0.ggx_1 = verifyConsumptionInFinalPass;
    tmp.vgu_1 = this_0;
  }
  function moveToDraggingState($this, pointerId) {
    var tmp = $this;
    // Inline function 'kotlin.apply' call
    var this_0 = _get_draggingState__15pugh($this);
    this_0.hgx_1 = pointerId;
    tmp.vgu_1 = this_0;
  }
  function moveToAwaitDownState($this) {
    var tmp = $this;
    // Inline function 'kotlin.apply' call
    var this_0 = _get_awaitDownState__saur72($this);
    this_0.igx_1 = AwaitTouchSlop_NotInitialized_getInstance();
    this_0.jgx_1 = false;
    tmp.vgu_1 = this_0;
  }
  function moveToAwaitGesturePickupState($this, initialDown, pointerId, touchSlopDetector) {
    var tmp = $this;
    // Inline function 'kotlin.apply' call
    var this_0 = _get_awaitGesturePickupState__gq0mb3($this);
    this_0.kgx_1 = initialDown;
    this_0.lgx_1 = pointerId;
    var tmp_0 = this_0;
    // Inline function 'kotlin.also' call
    touchSlopDetector.ogi();
    tmp_0.mgx_1 = touchSlopDetector;
    tmp.vgu_1 = this_0;
  }
  function processInitialDownState($this, pointerEvent, pass, state) {
    if (pointerEvent.ca0_1.r())
      return Unit_instance;
    if (!isChangedToDown(pointerEvent, false))
      return Unit_instance;
    var firstDown = first(pointerEvent.ca0_1);
    var tmp;
    if (state.igx_1.a1_1 === 2) {
      var tmp_0;
      if (!$this.qgt()) {
        tmp_0 = AwaitTouchSlop_Yes_getInstance();
      } else {
        tmp_0 = AwaitTouchSlop_No_getInstance();
      }
      tmp = tmp_0;
    } else {
      tmp = state.igx_1;
    }
    var awaitTouchSlop = tmp;
    state.igx_1 = awaitTouchSlop;
    if (pass.equals(PointerEventPass_Initial_getInstance())) {
      if (awaitTouchSlop.equals(AwaitTouchSlop_No_getInstance())) {
        firstDown.ra2();
        state.jgx_1 = true;
      }
    }
    if (pass.equals(PointerEventPass_Main_getInstance())) {
      if (awaitTouchSlop.equals(AwaitTouchSlop_Yes_getInstance())) {
        moveToAwaitTouchSlopState($this, firstDown, firstDown.ia0_1);
      } else if (state.jgx_1) {
        sendDragStart($this, firstDown, firstDown, Companion_getInstance_6().g5d_1);
        sendDragEvent($this, firstDown, Companion_getInstance_6().g5d_1);
        moveToDraggingState($this, firstDown.ia0_1);
      }
    }
  }
  function processAwaitTouchSlop($this, pointerEvent, pass, state) {
    if (pass.equals(PointerEventPass_Initial_getInstance()))
      return Unit_instance;
    var tmp0 = pointerEvent.ca0_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (equals(item.ia0_1, state.fgx_1)) {
            tmp$ret$0 = item;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = null;
    }
    var eventFromPointerId = tmp$ret$0;
    var tmp;
    if (eventFromPointerId == null) {
      var tmp0_0 = pointerEvent.ca0_1;
      var tmp$ret$4;
      $l$block_0: {
        // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp0_0.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = tmp0_0.l1(index_0);
            if (item_0.la0_1) {
              tmp$ret$4 = item_0;
              break $l$block_0;
            }
          }
           while (inductionVariable_0 <= last_0);
        tmp$ret$4 = null;
      }
      var otherDown = tmp$ret$4;
      if (otherDown == null) {
        moveToAwaitDownState($this);
        return Unit_instance;
      } else {
        state.fgx_1 = otherDown.ia0_1;
      }
      tmp = otherDown;
    } else {
      tmp = eventFromPointerId;
    }
    var dragEvent = tmp;
    if (pass.equals(PointerEventPass_Main_getInstance())) {
      if (!dragEvent.qa2()) {
        if (changedToUpIgnoreConsumed(dragEvent)) {
          var tmp0_1 = pointerEvent.ca0_1;
          var tmp$ret$8;
          $l$block_1: {
            // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
            // Inline function 'androidx.compose.ui.util.fastForEach' call
            var inductionVariable_1 = 0;
            var last_1 = tmp0_1.n1() - 1 | 0;
            if (inductionVariable_1 <= last_1)
              do {
                var index_1 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var item_1 = tmp0_1.l1(index_1);
                if (item_1.la0_1) {
                  tmp$ret$8 = item_1;
                  break $l$block_1;
                }
              }
               while (inductionVariable_1 <= last_1);
            tmp$ret$8 = null;
          }
          var otherDown_0 = tmp$ret$8;
          if (otherDown_0 == null) {
            moveToAwaitDownState($this);
          } else {
            state.fgx_1 = otherDown_0.ia0_1;
          }
        } else {
          var touchSlop = pointerSlop(currentValueOf($this, get_LocalViewConfiguration()), dragEvent.qa0_1);
          var postSlopOffset = requireTouchSlopDetector($this).mgi(positionChangeIgnoreConsumed(dragEvent), touchSlop);
          if (ComposeFoundationFlags_instance.rfg_1) {
            // Inline function 'androidx.compose.ui.geometry.isSpecified' call
            if (!equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(postSlopOffset), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
              var isSelfInterested = $this.hfh(dragEvent);
              var tmp0_safe_receiver = get_parentGestureConnection($this);
              var isParentInterested = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hfh(dragEvent)) === true;
              if (!isSelfInterested && isParentInterested) {
                state.ggx_1 = true;
              } else {
                dragEvent.ra2();
                sendDragStart($this, ensureNotNull(state.egx_1), dragEvent, postSlopOffset);
                sendDragEvent($this, dragEvent, postSlopOffset);
                moveToDraggingState($this, dragEvent.ia0_1);
              }
            } else {
              state.ggx_1 = true;
            }
          } else {
            // Inline function 'androidx.compose.ui.geometry.isSpecified' call
            if (!equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(postSlopOffset), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
              dragEvent.ra2();
              sendDragStart($this, ensureNotNull(state.egx_1), dragEvent, postSlopOffset);
              sendDragEvent($this, dragEvent, postSlopOffset);
              moveToDraggingState($this, dragEvent.ia0_1);
            } else {
              state.ggx_1 = true;
            }
          }
        }
      } else {
        var tmp0_2 = state.egx_1;
        var tmp$ret$14;
        $l$block_2: {
          // Inline function 'kotlin.requireNotNull' call
          if (tmp0_2 == null) {
            var message = 'AwaitTouchSlop.initialDown was not initialized';
            throw IllegalArgumentException_init_$Create$(toString(message));
          } else {
            tmp$ret$14 = tmp0_2;
            break $l$block_2;
          }
        }
        var tmp_0 = tmp$ret$14;
        var tmp_1 = state.fgx_1;
        var tmp0_3 = $this.ygu_1;
        var tmp$ret$16;
        $l$block_3: {
          // Inline function 'kotlin.requireNotNull' call
          if (tmp0_3 == null) {
            var message_0 = 'AwaitTouchSlop.touchSlopDetector was not initialized';
            throw IllegalArgumentException_init_$Create$(toString(message_0));
          } else {
            tmp$ret$16 = tmp0_3;
            break $l$block_3;
          }
        }
        moveToAwaitGesturePickupState($this, tmp_0, tmp_1, tmp$ret$16);
      }
    }
    if (pass.equals(PointerEventPass_Final_getInstance()) && state.ggx_1) {
      if (dragEvent.qa2()) {
        var tmp0_4 = state.egx_1;
        var tmp$ret$18;
        $l$block_4: {
          // Inline function 'kotlin.requireNotNull' call
          if (tmp0_4 == null) {
            var message_1 = 'AwaitTouchSlop.initialDown was not initialized';
            throw IllegalArgumentException_init_$Create$(toString(message_1));
          } else {
            tmp$ret$18 = tmp0_4;
            break $l$block_4;
          }
        }
        var tmp_2 = tmp$ret$18;
        var tmp_3 = state.fgx_1;
        var tmp0_5 = $this.ygu_1;
        var tmp$ret$20;
        $l$block_5: {
          // Inline function 'kotlin.requireNotNull' call
          if (tmp0_5 == null) {
            var message_2 = 'AwaitTouchSlop.touchSlopDetector was not initialized';
            throw IllegalArgumentException_init_$Create$(toString(message_2));
          } else {
            tmp$ret$20 = tmp0_5;
            break $l$block_5;
          }
        }
        moveToAwaitGesturePickupState($this, tmp_2, tmp_3, tmp$ret$20);
      } else {
        state.ggx_1 = false;
      }
    }
  }
  function processAwaitGesturePickup($this, pointerEvent, pass, state) {
    if (!pass.equals(PointerEventPass_Final_getInstance()))
      return Unit_instance;
    var tmp0 = pointerEvent.ca0_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAll' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (!!item.qa2()) {
            tmp$ret$0 = false;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = true;
    }
    var hasUnconsumedDrag = tmp$ret$0;
    var tmp0_0 = pointerEvent.ca0_1;
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_0 = tmp0_0.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = tmp0_0.l1(index_0);
          if (item_0.la0_1) {
            tmp$ret$4 = true;
            break $l$block_0;
          }
        }
         while (inductionVariable_0 <= last_0);
      tmp$ret$4 = false;
    }
    var hasDownPointers = tmp$ret$4;
    if (!hasDownPointers || pointerEvent.ca0_1.r()) {
      moveToAwaitDownState($this);
    } else if (hasUnconsumedDrag) {
      var initialPositionChange = Offset__minus_impl_hoj2c0(first(pointerEvent.ca0_1).ka0_1, ensureNotNull(state.kgx_1).ka0_1);
      var tmp0_1 = state.kgx_1;
      var tmp$ret$8;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0_1 == null) {
          var message = 'AwaitGesturePickup.initialDown was not initialized.';
          throw IllegalArgumentException_init_$Create$(toString(message));
        } else {
          tmp$ret$8 = tmp0_1;
          break $l$block_1;
        }
      }
      moveToAwaitTouchSlopState($this, tmp$ret$8, state.lgx_1, initialPositionChange);
    }
  }
  function processDraggingState($this, pointerEvent, pass, state) {
    if (!pass.equals(PointerEventPass_Main_getInstance()))
      return Unit_instance;
    var pointer = state.hgx_1;
    var tmp0 = pointerEvent.ca0_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (equals(item.ia0_1, pointer)) {
            tmp$ret$0 = item;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var dragEvent = tmp;
    if (changedToUpIgnoreConsumed(dragEvent)) {
      var tmp0_0 = pointerEvent.ca0_1;
      var tmp$ret$4;
      $l$block_0: {
        // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp0_0.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = tmp0_0.l1(index_0);
            if (item_0.la0_1) {
              tmp$ret$4 = item_0;
              break $l$block_0;
            }
          }
           while (inductionVariable_0 <= last_0);
        tmp$ret$4 = null;
      }
      var otherDown = tmp$ret$4;
      if (otherDown == null) {
        if (!dragEvent.qa2() && changedToUpIgnoreConsumed(dragEvent)) {
          sendDragStopped($this, dragEvent);
        } else {
          sendDragCancelled($this);
        }
        moveToAwaitDownState($this);
      } else {
        state.hgx_1 = otherDown.ia0_1;
      }
    } else {
      if (dragEvent.qa2()) {
        sendDragCancelled($this);
      } else {
        var positionChange_0 = positionChangeIgnoreConsumed(dragEvent);
        var motionChange = Offset__getDistance_impl_pclvxn(positionChange_0);
        if (!(motionChange === 0.0)) {
          var positionChange_1 = positionChange(dragEvent);
          sendDragEvent($this, dragEvent, positionChange_1);
          dragEvent.ra2();
        }
      }
    }
  }
  function sendDragStart($this, down, slopTriggerChange, overSlopOffset) {
    if ($this.wgu_1 == null)
      $this.wgu_1 = new VelocityTracker();
    addPointerInputChange(requireVelocityTracker($this), down);
    var dragStartedOffset = Offset__minus_impl_hoj2c0(slopTriggerChange.ka0_1, overSlopOffset);
    $this.agv_1 = Companion_getInstance_6().g5d_1;
    if ($this.igu_1(new PointerType(down.qa0_1))) {
      if (!$this.pgu_1) {
        if ($this.ngu_1 == null) {
          $this.ngu_1 = Channel(2147483647);
        }
        startListeningForEvents($this);
      }
      $this.xgu_1 = positionOnScreen(requireLayoutCoordinates($this));
      requireChannel($this).s1s(new DragStarted(dragStartedOffset));
    }
  }
  function sendDragEvent($this, change, dragAmount) {
    var currentPositionOnScreen = positionOnScreen(requireLayoutCoordinates($this.m8v_1));
    if (!equals($this.xgu_1, Companion_getInstance_6().i5d_1) && !equals(currentPositionOnScreen, $this.xgu_1)) {
      var delta = Offset__minus_impl_hoj2c0(currentPositionOnScreen, $this.xgu_1);
      $this.agv_1 = Offset__plus_impl_c78cg0($this.agv_1, delta);
    }
    $this.xgu_1 = currentPositionOnScreen;
    addPointerInputChange_0(requireVelocityTracker($this), change, $this.agv_1);
    requireChannel($this).s1s(new DragDelta(dragAmount, false));
  }
  function sendDragStopped($this, change) {
    addPointerInputChange(requireVelocityTracker($this), change);
    var maximumVelocity = currentValueOf($this, get_LocalViewConfiguration()).wb9();
    var velocity = requireVelocityTracker($this).iab(Velocity(maximumVelocity, maximumVelocity));
    requireVelocityTracker($this).jab();
    requireChannel($this).s1s(new DragStopped(toValidVelocity(velocity), false));
    $this.qgu_1 = false;
  }
  function sendDragCancelled($this) {
    requireChannel($this).s1s(DragCancelled_getInstance());
  }
  function DragGestureNode$_canDrag$lambda(this$0) {
    return function (it) {
      return this$0.igu_1(it);
    };
  }
  function DragGestureNode$startListeningForEvents$slambda(this$0, resultContinuation) {
    this.vgx_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DragGestureNode$startListeningForEvents$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DragGestureNode$startListeningForEvents$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DragGestureNode$startListeningForEvents$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 14;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!get_isActive(this.wgx_1)) {
              this.n9_1 = 13;
              continue $sm;
            }

            var tmp0_safe_receiver = this.vgx_1.ngu_1;
            if (tmp0_safe_receiver == null) {
              this.ygx_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = tmp0_safe_receiver.u1s(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.ygx_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.xgx_1 = {_v: this.ygx_1};
            var tmp_0 = this.xgx_1._v;
            if (!(tmp_0 instanceof DragStarted)) {
              this.n9_1 = 1;
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            this.n9_1 = 5;
            suspendResult = processDragStart(this.vgx_1, this.xgx_1._v, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.o9_1 = 10;
            this.n9_1 = 6;
            suspendResult = this.vgx_1.ngt(DragGestureNode$startListeningForEvents$slambda$slambda_0(this.xgx_1, this.vgx_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp_1 = this.xgx_1._v;
            if (tmp_1 instanceof DragStopped) {
              this.n9_1 = 8;
              var tmp_2 = this.xgx_1._v;
              suspendResult = processDragStop(this.vgx_1, tmp_2 instanceof DragStopped ? tmp_2 : THROW_CCE(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_3 = this.xgx_1._v;
              if (tmp_3 instanceof DragCancelled) {
                this.n9_1 = 7;
                suspendResult = processDragCancel(this.vgx_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 9;
                continue $sm;
              }
            }

          case 7:
            this.n9_1 = 9;
            continue $sm;
          case 8:
            this.n9_1 = 9;
            continue $sm;
          case 9:
            this.o9_1 = 14;
            this.n9_1 = 12;
            continue $sm;
          case 10:
            this.o9_1 = 14;
            var tmp_4 = this.q9_1;
            if (tmp_4 instanceof CancellationException) {
              var c = this.q9_1;
              this.n9_1 = 11;
              suspendResult = processDragCancel(this.vgx_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 11:
            this.n9_1 = 12;
            continue $sm;
          case 12:
            this.o9_1 = 14;
            this.n9_1 = 1;
            continue $sm;
          case 13:
            return Unit_instance;
          case 14:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 14) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DragGestureNode$startListeningForEvents$slambda).q24 = function ($this$launch, completion) {
    var i = new DragGestureNode$startListeningForEvents$slambda(this.vgx_1, completion);
    i.wgx_1 = $this$launch;
    return i;
  };
  function DragGestureNode$startListeningForEvents$slambda_0(this$0, resultContinuation) {
    var i = new DragGestureNode$startListeningForEvents$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function $processDragStartCOROUTINE$(_this__u8e3s4, event, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bgw_1 = _this__u8e3s4;
    this.cgw_1 = event;
  }
  protoOf($processDragStartCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            var tmp0_safe_receiver = this.bgw_1.ogu_1;
            if (tmp0_safe_receiver == null) {
              this.fgw_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              var tmp0_safe_receiver_0 = this.bgw_1.kgu_1;
              if (tmp0_safe_receiver_0 == null) {
                this.ggw_1 = null;
                this.n9_1 = 2;
                continue $sm;
              } else {
                this.n9_1 = 1;
                suspendResult = tmp0_safe_receiver_0.vfh(new Cancel(tmp0_safe_receiver), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 1:
            var tmp_0 = this;
            tmp_0.ggw_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.fgw_1 = this.ggw_1;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.dgw_1 = new Start_0();
            var tmp1_safe_receiver = this.bgw_1.kgu_1;
            if (tmp1_safe_receiver == null) {
              this.egw_1 = null;
              this.n9_1 = 5;
              continue $sm;
            } else {
              this.n9_1 = 4;
              suspendResult = tmp1_safe_receiver.vfh(this.dgw_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 4:
            var tmp_1 = this;
            tmp_1.egw_1 = Unit_instance;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.bgw_1.ogu_1 = this.dgw_1;
            this.bgw_1.ogt(this.cgw_1.zgx_1);
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $processDragStopCOROUTINE$(_this__u8e3s4, event, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pgw_1 = _this__u8e3s4;
    this.qgw_1 = event;
  }
  protoOf($processDragStopCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0_safe_receiver = this.pgw_1.ogu_1;
            if (tmp0_safe_receiver == null) {
              this.rgw_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              var tmp0_safe_receiver_0 = this.pgw_1.kgu_1;
              if (tmp0_safe_receiver_0 == null) {
                this.sgw_1 = null;
                this.n9_1 = 2;
                continue $sm;
              } else {
                this.n9_1 = 1;
                suspendResult = tmp0_safe_receiver_0.vfh(new Stop(tmp0_safe_receiver), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 1:
            var tmp_0 = this;
            tmp_0.sgw_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.pgw_1.ogu_1 = null;
            var tmp_1 = this;
            tmp_1.rgw_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.pgw_1.pgt(this.qgw_1);
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $processDragCancelCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bgx_1 = _this__u8e3s4;
  }
  protoOf($processDragCancelCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0_safe_receiver = this.bgx_1.ogu_1;
            if (tmp0_safe_receiver == null) {
              this.cgx_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              var tmp0_safe_receiver_0 = this.bgx_1.kgu_1;
              if (tmp0_safe_receiver_0 == null) {
                this.dgx_1 = null;
                this.n9_1 = 2;
                continue $sm;
              } else {
                this.n9_1 = 1;
                suspendResult = tmp0_safe_receiver_0.vfh(new Cancel(tmp0_safe_receiver), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 1:
            var tmp_0 = this;
            tmp_0.dgx_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.bgx_1.ogu_1 = null;
            var tmp_1 = this;
            tmp_1.cgx_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.bgx_1.pgt(new DragStopped(Companion_getInstance_24().v5g_1, false));
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function DragGestureNode(canDrag, enabled, interactionSource, orientationLock) {
    DelegatingNode.call(this);
    this.hgu_1 = orientationLock;
    this.igu_1 = canDrag;
    this.jgu_1 = enabled;
    this.kgu_1 = interactionSource;
    this.lgu_1 = null;
    var tmp = this;
    tmp.mgu_1 = DragGestureNode$_canDrag$lambda(this);
    this.ngu_1 = null;
    this.ogu_1 = null;
    this.pgu_1 = false;
    this.qgu_1 = false;
    this.rgu_1 = null;
    this.sgu_1 = null;
    this.tgu_1 = null;
    this.ugu_1 = null;
    this.vgu_1 = null;
    this.wgu_1 = null;
    this.xgu_1 = Companion_getInstance_6().i5d_1;
    this.ygu_1 = null;
    this.zgu_1 = null;
    this.agv_1 = Companion_getInstance_6().g5d_1;
  }
  protoOf(DragGestureNode).h8w = function () {
    this.pgu_1 = false;
    this.dgv();
    this.agv_1 = Companion_getInstance_6().g5d_1;
    var tmp0_safe_receiver = this.lgu_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.vb1(tmp0_safe_receiver);
    }
    this.lgu_1 = null;
  };
  protoOf(DragGestureNode).cgv = function () {
    if (!ComposeFoundationFlags_instance.pfg_1)
      return Unit_instance;
    if (this.lgu_1 == null) {
      this.lgu_1 = this.tb1(gestureNode(this));
    }
  };
  protoOf(DragGestureNode).aa1 = function (pointerEvent, pass, bounds) {
    this.qgu_1 = true;
    this.cgv();
    if (this.jgu_1) {
      if (this.vgu_1 == null)
        this.vgu_1 = _get_awaitDownState__saur72(this);
      processRawPointerEvent(this, pointerEvent, pass);
    }
  };
  protoOf(DragGestureNode).d9u = function () {
    var tmp0_safe_receiver = this.zgu_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.mgy();
    }
  };
  protoOf(DragGestureNode).hfh = function (event) {
    if (changedToDownIgnoreConsumed(event))
      return this.jgu_1;
    if (!ComposeFoundationFlags_instance.rfg_1)
      return false;
    if (changedToUpIgnoreConsumed(event))
      return false;
    if (this.ygu_1 == null) {
      this.ygu_1 = new TouchSlopDetector(this.hgu_1);
    }
    var touchSlop = currentValueOf(this, get_LocalViewConfiguration()).ub9();
    var positionChange_0 = positionChange(event);
    // Inline function 'kotlin.with' call
    var $this$with = requireTouchSlopDetector(this);
    return !equals($this$with.lgi(positionChange_0, touchSlop, false), Companion_getInstance_6().i5d_1) && $this$with.pgi(positionChange_0);
  };
  protoOf(DragGestureNode).xa1 = function () {
    if (this.qgu_1) {
      resetDragDetectionState(this);
    }
    this.qgu_1 = false;
  };
  protoOf(DragGestureNode).dgv = function () {
    var tmp0_safe_receiver = this.ogu_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = this.kgu_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else
        tmp0_safe_receiver_0.efo(new Cancel(tmp0_safe_receiver));
      this.ogu_1 = null;
    }
  };
  protoOf(DragGestureNode).bgv = function (canDrag, enabled, interactionSource, orientationLock, shouldResetPointerInputHandling) {
    var resetPointerInputHandling = shouldResetPointerInputHandling;
    this.igu_1 = canDrag;
    if (!(this.jgu_1 === enabled)) {
      this.jgu_1 = enabled;
      if (!enabled) {
        this.dgv();
        this.zgu_1 = null;
      }
      resetPointerInputHandling = true;
    }
    if (!equals(this.kgu_1, interactionSource)) {
      this.dgv();
      this.kgu_1 = interactionSource;
    }
    if (!equals(this.hgu_1, orientationLock)) {
      this.hgu_1 = orientationLock;
      resetPointerInputHandling = true;
    }
    if (resetPointerInputHandling) {
      if (this.qgu_1) {
        resetDragDetectionState(this);
      }
      var tmp0_safe_receiver = this.zgu_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.mgy();
      }
    }
  };
  protoOf(DragGestureNode).egv = function (event) {
    var tmp;
    if (event instanceof DragStarted) {
      tmp = !this.pgu_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      this.pgu_1 = true;
      startListeningForEvents(this);
    }
    requireChannel(this).s1s(event);
  };
  function DragStarted(startPoint) {
    DragEvent.call(this);
    this.zgx_1 = startPoint;
  }
  function DragStopped(velocity, isIndirectPointerEvent) {
    DragEvent.call(this);
    this.lgt_1 = velocity;
    this.mgt_1 = isIndirectPointerEvent;
  }
  function DragCancelled() {
    DragCancelled_instance = this;
    DragEvent.call(this);
  }
  var DragCancelled_instance;
  function DragCancelled_getInstance() {
    if (DragCancelled_instance == null)
      new DragCancelled();
    return DragCancelled_instance;
  }
  function DragDelta(delta, isIndirectPointerEvent) {
    DragEvent.call(this);
    this.ags_1 = delta;
    this.bgs_1 = isIndirectPointerEvent;
  }
  function DragEvent() {
  }
  function toFloat(_this__u8e3s4, orientation) {
    _init_properties_Draggable_kt__eqnzl1();
    var tmp;
    if (orientation.equals(Orientation_Vertical_getInstance())) {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
      tmp = floatFromBits(bits);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(shiftRight(value_0, 32));
      tmp = floatFromBits(bits_0);
    }
    return tmp;
  }
  function toFloat_0(_this__u8e3s4, orientation) {
    _init_properties_Draggable_kt__eqnzl1();
    return orientation.equals(Orientation_Vertical_getInstance()) ? _Velocity___get_y__impl__239yhc(_this__u8e3s4) : _Velocity___get_x__impl__qqcikv(_this__u8e3s4);
  }
  var AwaitTouchSlop_Yes_instance;
  var AwaitTouchSlop_No_instance;
  var AwaitTouchSlop_NotInitialized_instance;
  var AwaitTouchSlop_entriesInitialized;
  function AwaitTouchSlop_initEntries() {
    if (AwaitTouchSlop_entriesInitialized)
      return Unit_instance;
    AwaitTouchSlop_entriesInitialized = true;
    AwaitTouchSlop_Yes_instance = new AwaitTouchSlop('Yes', 0);
    AwaitTouchSlop_No_instance = new AwaitTouchSlop('No', 1);
    AwaitTouchSlop_NotInitialized_instance = new AwaitTouchSlop('NotInitialized', 2);
  }
  function AwaitTouchSlop(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function AwaitTouchSlop_Yes_getInstance() {
    AwaitTouchSlop_initEntries();
    return AwaitTouchSlop_Yes_instance;
  }
  function AwaitTouchSlop_No_getInstance() {
    AwaitTouchSlop_initEntries();
    return AwaitTouchSlop_No_instance;
  }
  function AwaitTouchSlop_NotInitialized_getInstance() {
    AwaitTouchSlop_initEntries();
    return AwaitTouchSlop_NotInitialized_instance;
  }
  function AwaitDown(awaitTouchSlop, consumedOnInitial) {
    awaitTouchSlop = awaitTouchSlop === VOID ? AwaitTouchSlop_NotInitialized_getInstance() : awaitTouchSlop;
    consumedOnInitial = consumedOnInitial === VOID ? false : consumedOnInitial;
    DragDetectionState.call(this);
    this.igx_1 = awaitTouchSlop;
    this.jgx_1 = consumedOnInitial;
  }
  function AwaitTouchSlop_0(initialDown, pointerId, verifyConsumptionInFinalPass) {
    initialDown = initialDown === VOID ? null : initialDown;
    pointerId = pointerId === VOID ? _PointerId___init__impl__w2urwh(new Long(-1, 2147483647)) : pointerId;
    verifyConsumptionInFinalPass = verifyConsumptionInFinalPass === VOID ? false : verifyConsumptionInFinalPass;
    DragDetectionState.call(this);
    this.egx_1 = initialDown;
    this.fgx_1 = pointerId;
    this.ggx_1 = verifyConsumptionInFinalPass;
  }
  function AwaitGesturePickup(initialDown, pointerId, touchSlopDetector) {
    initialDown = initialDown === VOID ? null : initialDown;
    pointerId = pointerId === VOID ? _PointerId___init__impl__w2urwh(new Long(-1, 2147483647)) : pointerId;
    touchSlopDetector = touchSlopDetector === VOID ? null : touchSlopDetector;
    DragDetectionState.call(this);
    this.kgx_1 = initialDown;
    this.lgx_1 = pointerId;
    this.mgx_1 = touchSlopDetector;
  }
  function Dragging(pointerId) {
    pointerId = pointerId === VOID ? _PointerId___init__impl__w2urwh(new Long(-1, 2147483647)) : pointerId;
    DragDetectionState.call(this);
    this.hgx_1 = pointerId;
  }
  function DragDetectionState() {
  }
  function toValidVelocity(_this__u8e3s4) {
    _init_properties_Draggable_kt__eqnzl1();
    return Velocity(isNaN_0(_Velocity___get_x__impl__qqcikv(_this__u8e3s4)) ? 0.0 : _Velocity___get_x__impl__qqcikv(_this__u8e3s4), isNaN_0(_Velocity___get_y__impl__239yhc(_this__u8e3s4)) ? 0.0 : _Velocity___get_y__impl__239yhc(_this__u8e3s4));
  }
  function NoOpOnDragStarted$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NoOpOnDragStarted$slambda).xgy = function (_this__u8e3s4, it, $completion) {
    var tmp = this.ygy(_this__u8e3s4, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NoOpOnDragStarted$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE();
    return this.xgy(tmp, p2 instanceof Offset ? p2.e5d_1 : THROW_CCE(), $completion);
  };
  protoOf(NoOpOnDragStarted$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(NoOpOnDragStarted$slambda).ygy = function (_this__u8e3s4, it, completion) {
    var i = new NoOpOnDragStarted$slambda(completion);
    i.vgy_1 = _this__u8e3s4;
    i.wgy_1 = it;
    return i;
  };
  function NoOpOnDragStarted$slambda_0(resultContinuation) {
    var i = new NoOpOnDragStarted$slambda(resultContinuation);
    return constructCallableReference(function (_this__u8e3s4, it, $completion) {
      return i.xgy(_this__u8e3s4, it.e5d_1, $completion);
    }, 2);
  }
  function NoOpOnDragStopped$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NoOpOnDragStopped$slambda).jgz = function (_this__u8e3s4, it, $completion) {
    var tmp = this.kgz(_this__u8e3s4, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NoOpOnDragStopped$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE();
    return this.jgz(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(NoOpOnDragStopped$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(NoOpOnDragStopped$slambda).kgz = function (_this__u8e3s4, it, completion) {
    var i = new NoOpOnDragStopped$slambda(completion);
    i.hgz_1 = _this__u8e3s4;
    i.igz_1 = it;
    return i;
  };
  function NoOpOnDragStopped$slambda_0(resultContinuation) {
    var i = new NoOpOnDragStopped$slambda(resultContinuation);
    return constructCallableReference(function (_this__u8e3s4, it, $completion) {
      return i.jgz(_this__u8e3s4, it, $completion);
    }, 2);
  }
  function rememberDraggableState$lambda($onDeltaState) {
    return function (it) {
      $onDeltaState.u1()(it);
      return Unit_instance;
    };
  }
  var properties_initialized_Draggable_kt_yfsy1p;
  function _init_properties_Draggable_kt__eqnzl1() {
    if (!properties_initialized_Draggable_kt_yfsy1p) {
      properties_initialized_Draggable_kt_yfsy1p = true;
      NoOpOnDragStarted = NoOpOnDragStarted$slambda_0(null);
      NoOpOnDragStopped = NoOpOnDragStopped$slambda_0(null);
      androidx_compose_foundation_gestures_DraggableElement$stable = 0;
      androidx_compose_foundation_gestures_DraggableNode$stable = 8;
      androidx_compose_foundation_gestures_DragGestureNode$stable = 8;
      androidx_compose_foundation_gestures_DragEvent_DragStarted$stable = 0;
      androidx_compose_foundation_gestures_DragEvent_DragStopped$stable = 0;
      androidx_compose_foundation_gestures_DragEvent_DragCancelled$stable = 0;
      androidx_compose_foundation_gestures_DragEvent_DragDelta$stable = 0;
      androidx_compose_foundation_gestures_DragEvent$stable = 0;
      androidx_compose_foundation_gestures_DragDetectionState_AwaitDown$stable = 8;
      androidx_compose_foundation_gestures_DragDetectionState_AwaitTouchSlop$stable = 8;
      androidx_compose_foundation_gestures_DragDetectionState_AwaitGesturePickup$stable = 8;
      androidx_compose_foundation_gestures_DragDetectionState_Dragging$stable = 8;
    }
  }
  var androidx_compose_foundation_gestures_GestureCancellationException$stable;
  function awaitEachGesture(_this__u8e3s4, block, $completion) {
    // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
    // Inline function 'kotlin.js.getCoroutineContext' call
    var currentContext = $completion.t9();
    return _this__u8e3s4.ma7(awaitEachGesture$slambda_0(currentContext, block, null), $completion);
  }
  function awaitAllPointersUp(_this__u8e3s4, pass, $completion) {
    pass = pass === VOID ? PointerEventPass_Final_getInstance() : pass;
    var tmp = new $awaitAllPointersUpCOROUTINE$(_this__u8e3s4, pass, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function allPointersUp(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.oa7().ca0_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (item.la0_1) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = false;
    }
    return !tmp$ret$0;
  }
  function awaitEachGesture$slambda($currentContext, $block, resultContinuation) {
    this.dh0_1 = $currentContext;
    this.eh0_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(awaitEachGesture$slambda).ic6 = function ($this$awaitPointerEventScope, $completion) {
    var tmp = this.jc6($this$awaitPointerEventScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(awaitEachGesture$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(awaitEachGesture$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!get_isActive_0(this.dh0_1)) {
              this.n9_1 = 8;
              continue $sm;
            }

            this.o9_1 = 4;
            this.n9_1 = 2;
            suspendResult = this.eh0_1(this.fh0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = awaitAllPointersUp(this.fh0_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.o9_1 = 9;
            this.n9_1 = 7;
            continue $sm;
          case 4:
            this.o9_1 = 9;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof CancellationException) {
              var e = this.q9_1;
              if (get_isActive_0(this.dh0_1)) {
                this.n9_1 = 5;
                suspendResult = awaitAllPointersUp(this.fh0_1, VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                throw e;
              }
            } else {
              throw this.q9_1;
            }

          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.o9_1 = 9;
            this.n9_1 = 1;
            continue $sm;
          case 8:
            return Unit_instance;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 9) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(awaitEachGesture$slambda).jc6 = function ($this$awaitPointerEventScope, completion) {
    var i = new awaitEachGesture$slambda(this.dh0_1, this.eh0_1, completion);
    i.fh0_1 = $this$awaitPointerEventScope;
    return i;
  };
  function awaitEachGesture$slambda_0($currentContext, $block, resultContinuation) {
    var i = new awaitEachGesture$slambda($currentContext, $block, resultContinuation);
    return constructCallableReference(function ($this$awaitPointerEventScope, $completion) {
      return i.ic6($this$awaitPointerEventScope, $completion);
    }, 1);
  }
  function $awaitAllPointersUpCOROUTINE$(_this__u8e3s4, pass, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tgz_1 = _this__u8e3s4;
    this.ugz_1 = pass;
  }
  protoOf($awaitAllPointersUpCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            if (!allPointersUp(this.tgz_1)) {
              this.n9_1 = 1;
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            suspendResult = this.tgz_1.pa7(this.ugz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var events = suspendResult;
            var tmp0 = events.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (item.la0_1) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$0 = false;
            }
             while (false);
            if (tmp$ret$0) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector_DragDetectionState_AwaitDown$stable;
  var androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector_DragDetectionState_AwaitTouchSlop$stable;
  var androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector_DragDetectionState_AwaitGesturePickup$stable;
  var androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector_DragDetectionState_Dragging$stable;
  var androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector_DragDetectionState$stable;
  var androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector$stable;
  var androidx_compose_foundation_gestures_IndirectPointerInputEventSmoother$stable;
  var androidx_compose_foundation_gestures_OffsetSmoother$stable;
  var AwaitTouchSlop_Yes_instance_0;
  var AwaitTouchSlop_No_instance_0;
  var AwaitTouchSlop_NotInitialized_instance_0;
  var AwaitTouchSlop_entriesInitialized_0;
  function AwaitTouchSlop_initEntries_0() {
    if (AwaitTouchSlop_entriesInitialized_0)
      return Unit_instance;
    AwaitTouchSlop_entriesInitialized_0 = true;
    AwaitTouchSlop_Yes_instance_0 = new AwaitTouchSlop_1('Yes', 0);
    AwaitTouchSlop_No_instance_0 = new AwaitTouchSlop_1('No', 1);
    AwaitTouchSlop_NotInitialized_instance_0 = new AwaitTouchSlop_1('NotInitialized', 2);
  }
  function AwaitTouchSlop_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function AwaitTouchSlop_NotInitialized_getInstance_0() {
    AwaitTouchSlop_initEntries_0();
    return AwaitTouchSlop_NotInitialized_instance_0;
  }
  function AwaitDown_0(awaitTouchSlop, consumedOnInitial) {
    awaitTouchSlop = awaitTouchSlop === VOID ? AwaitTouchSlop_NotInitialized_getInstance_0() : awaitTouchSlop;
    consumedOnInitial = consumedOnInitial === VOID ? false : consumedOnInitial;
    DragDetectionState_0.call(this);
    this.gh0_1 = awaitTouchSlop;
    this.hh0_1 = consumedOnInitial;
  }
  function _get_awaitDownState__saur72_0($this) {
    var tmp0_elvis_lhs = $this.bgy_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new AwaitDown_0();
      $this.bgy_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function moveToAwaitDownState_0($this) {
    var tmp = $this;
    // Inline function 'kotlin.apply' call
    var this_0 = _get_awaitDownState__saur72_0($this);
    this_0.gh0_1 = AwaitTouchSlop_NotInitialized_getInstance_0();
    this_0.hh0_1 = false;
    tmp.fgy_1 = this_0;
  }
  function sendDragCancelled_0($this) {
    $this.agy_1.egv(DragCancelled_getInstance());
  }
  function DragDetectionState_0() {
  }
  function get_AnimationThreshold() {
    _init_properties_MouseWheelScrollingLogic_kt__38b1wf();
    return AnimationThreshold;
  }
  var AnimationThreshold;
  function get_AnimationSpeed() {
    _init_properties_MouseWheelScrollingLogic_kt__38b1wf();
    return AnimationSpeed;
  }
  var AnimationSpeed;
  var androidx_compose_foundation_gestures_MouseWheelScrollingLogic$stable;
  function MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda$lambda(this$0, $targetScrollDelta, $targetValue, $this_dispatchMouseWheelScroll, $requiredAnimation) {
    return function (lastValue) {
      var nextScrollDelta = sumOrNull(this$0, this$0.oh0_1);
      var tmp;
      if (!(nextScrollDelta == null)) {
        trackVelocity(this$0, nextScrollDelta);
        $targetScrollDelta._v = $targetScrollDelta._v.th0(nextScrollDelta);
        $targetValue._v = $this_dispatchMouseWheelScroll.uh0($this_dispatchMouseWheelScroll.fgg($targetScrollDelta._v.qh0_1));
        $requiredAnimation._v = !isLowScrollingDelta($targetValue._v - lastValue);
        tmp = Unit_instance;
      }
      return !(nextScrollDelta == null);
    };
  }
  function MouseWheelScrollDelta(value, timeMillis, shouldApplyImmediately) {
    this.qh0_1 = value;
    this.rh0_1 = timeMillis;
    this.sh0_1 = shouldApplyImmediately;
  }
  protoOf(MouseWheelScrollDelta).th0 = function (other) {
    var tmp = Offset__plus_impl_c78cg0(this.qh0_1, other.qh0_1);
    var tmp0 = this.rh0_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = other.rh0_1;
    var tmp$ret$0 = compare(tmp0, b) >= 0 ? tmp0 : b;
    return new MouseWheelScrollDelta(tmp, tmp$ret$0, this.sh0_1);
  };
  protoOf(MouseWheelScrollDelta).vh0 = function (value, timeMillis, shouldApplyImmediately) {
    return new MouseWheelScrollDelta(value, timeMillis, shouldApplyImmediately);
  };
  protoOf(MouseWheelScrollDelta).wh0 = function (value, timeMillis, shouldApplyImmediately, $super) {
    value = value === VOID ? this.qh0_1 : value;
    timeMillis = timeMillis === VOID ? this.rh0_1 : timeMillis;
    shouldApplyImmediately = shouldApplyImmediately === VOID ? this.sh0_1 : shouldApplyImmediately;
    return $super === VOID ? this.vh0(value, timeMillis, shouldApplyImmediately) : $super.vh0.call(this, new Offset(value), timeMillis, shouldApplyImmediately);
  };
  protoOf(MouseWheelScrollDelta).toString = function () {
    return 'MouseWheelScrollDelta(value=' + Offset__toString_impl_4ffbou(this.qh0_1) + ', timeMillis=' + this.rh0_1.toString() + ', shouldApplyImmediately=' + this.sh0_1 + ')';
  };
  protoOf(MouseWheelScrollDelta).hashCode = function () {
    var result = Offset__hashCode_impl_hbql41(this.qh0_1);
    result = imul(result, 31) + this.rh0_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.sh0_1) | 0;
    return result;
  };
  protoOf(MouseWheelScrollDelta).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseWheelScrollDelta))
      return false;
    if (!equals(this.qh0_1, other.qh0_1))
      return false;
    if (!equalsLong(this.rh0_1, other.rh0_1))
      return false;
    if (!(this.sh0_1 === other.sh0_1))
      return false;
    return true;
  };
  function onMouseWheel($this, pointerEvent, bounds) {
    // Inline function 'kotlin.with' call
    var $this$with = $this.nh0_1;
    // Inline function 'kotlin.with' call
    var $this$with_0 = $this.zh0_1;
    var scrollDelta = $this$with.ch1($this$with_0, pointerEvent, bounds);
    var tmp;
    if (canConsumeDelta($this, $this.xh0_1, scrollDelta)) {
      tmp = _ChannelResult___get_isSuccess__impl__odq1z9($this.oh0_1.s1s(new MouseWheelScrollDelta(scrollDelta, first(pointerEvent.ca0_1).ja0_1, !$this.nh0_1.dh1() || $this.nh0_1.eh1(pointerEvent))));
    } else {
      tmp = $this.ah1_1;
    }
    return tmp;
  }
  function sumOrNull($this, $receiver) {
    var sum = null;
    var _iterator__ex2g4s = untilNull(MouseWheelScrollingLogic$sumOrNull$lambda($receiver)).t();
    while (_iterator__ex2g4s.u()) {
      var i = _iterator__ex2g4s.v();
      sum = sum == null ? i : sum.th0(i);
    }
    return sum;
  }
  function canConsumeDelta($this, $receiver, scrollDelta) {
    var delta = $receiver.uh0($receiver.fgg(scrollDelta));
    var tmp;
    if (delta === 0.0) {
      tmp = false;
    } else if (delta > 0.0) {
      tmp = $receiver.rgf_1.mg7();
    } else {
      tmp = $receiver.rgf_1.ng7();
    }
    return tmp;
  }
  function trackVelocity($this, scrollDelta) {
    $this.bh1_1.fgi(scrollDelta.rh0_1, scrollDelta.qh0_1);
  }
  function dispatchMouseWheelScroll($this, $receiver, scrollDelta, threshold, speed, $completion) {
    var tmp = new $dispatchMouseWheelScrollCOROUTINE$($this, $receiver, scrollDelta, threshold, speed, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function animateMouseWheelScroll($this, $receiver, animationState, targetValue, durationMillis, shouldCancelAnimation, $completion) {
    var lastValue = {_v: animationState.u1()};
    var tmp = tween(durationMillis, VOID, get_LinearEasing());
    return animateTo(animationState, targetValue, tmp, true, MouseWheelScrollingLogic$animateMouseWheelScroll$lambda(lastValue, $this, $receiver, shouldCancelAnimation), $completion);
  }
  function dispatchMouseWheelScroll_0($this, $receiver, delta) {
    // Inline function 'kotlin.with' call
    var $this$with = $this.xh0_1;
    var offset = $this$with.egg($this$with.th1(delta));
    var consumed = $receiver.ggg(offset, Companion_getInstance_20().d9v_1);
    return $this$with.hgg($this$with.fgg(consumed));
  }
  function MouseWheelScrollingLogic$startReceivingEvents$slambda(this$0, resultContinuation) {
    this.ch2_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MouseWheelScrollingLogic$startReceivingEvents$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MouseWheelScrollingLogic$startReceivingEvents$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(MouseWheelScrollingLogic$startReceivingEvents$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 7;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!get_isActive_0(this.dh2_1.q19())) {
              this.n9_1 = 5;
              continue $sm;
            }

            this.n9_1 = 3;
            suspendResult = this.ch2_1.oh0_1.u1s(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var scrollDelta = suspendResult;
            var threshold = this.ch2_1.zh0_1.v5e(get_AnimationThreshold());
            var speed = this.ch2_1.zh0_1.v5e(get_AnimationSpeed());
            this.n9_1 = 4;
            suspendResult = dispatchMouseWheelScroll(this.ch2_1, this.ch2_1.xh0_1, scrollDelta, threshold, speed, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 2;
            continue $sm;
          case 5:
            this.o9_1 = 8;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.o9_1 = 8;
            this.ch2_1.ph0_1 = null;
            return Unit_instance;
          case 7:
            this.o9_1 = 8;
            var t = this.q9_1;
            this.ch2_1.ph0_1 = null;
            throw t;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(MouseWheelScrollingLogic$startReceivingEvents$slambda).q24 = function ($this$launch, completion) {
    var i = new MouseWheelScrollingLogic$startReceivingEvents$slambda(this.ch2_1, completion);
    i.dh2_1 = $this$launch;
    return i;
  };
  function MouseWheelScrollingLogic$startReceivingEvents$slambda_0(this$0, resultContinuation) {
    var i = new MouseWheelScrollingLogic$startReceivingEvents$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function MouseWheelScrollingLogic$sumOrNull$lambda($this_sumOrNull) {
    return function () {
      return ChannelResult__getOrNull_impl_f5e07h($this_sumOrNull.w1s());
    };
  }
  function MouseWheelScrollingLogic$dispatchMouseWheelScroll$waitNextScrollDelta$slambda(this$0, resultContinuation) {
    this.mh2_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MouseWheelScrollingLogic$dispatchMouseWheelScroll$waitNextScrollDelta$slambda).oh2 = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.q24($this$withTimeoutOrNull, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MouseWheelScrollingLogic$dispatchMouseWheelScroll$waitNextScrollDelta$slambda).ja = function (p1, $completion) {
    return this.oh2((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(MouseWheelScrollingLogic$dispatchMouseWheelScroll$waitNextScrollDelta$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = busyReceive(this.mh2_1.oh0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(MouseWheelScrollingLogic$dispatchMouseWheelScroll$waitNextScrollDelta$slambda).q24 = function ($this$withTimeoutOrNull, completion) {
    var i = new MouseWheelScrollingLogic$dispatchMouseWheelScroll$waitNextScrollDelta$slambda(this.mh2_1, completion);
    i.nh2_1 = $this$withTimeoutOrNull;
    return i;
  };
  function MouseWheelScrollingLogic$dispatchMouseWheelScroll$waitNextScrollDelta$slambda_0(this$0, resultContinuation) {
    var i = new MouseWheelScrollingLogic$dispatchMouseWheelScroll$waitNextScrollDelta$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$withTimeoutOrNull, $completion) {
      return i.oh2($this$withTimeoutOrNull, $completion);
    }, 1);
  }
  function dispatchMouseWheelScroll$waitNextScrollDelta(targetScrollDelta, targetValue, $this_dispatchMouseWheelScroll, animationState, this$0, timeoutMillis, $completion) {
    var tmp = new $dispatchMouseWheelScroll$waitNextScrollDeltaCOROUTINE$(targetScrollDelta, targetValue, $this_dispatchMouseWheelScroll, animationState, this$0, timeoutMillis, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda($targetValue, $animationState, $targetScrollDelta, $threshold, this$0, $speed, $this_dispatchMouseWheelScroll, resultContinuation) {
    this.lh3_1 = $targetValue;
    this.mh3_1 = $animationState;
    this.nh3_1 = $targetScrollDelta;
    this.oh3_1 = $threshold;
    this.ph3_1 = this$0;
    this.qh3_1 = $speed;
    this.rh3_1 = $this_dispatchMouseWheelScroll;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda).wgg = function ($this$userScroll, $completion) {
    var tmp = this.xgg($this$userScroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda).ja = function (p1, $completion) {
    return this.wgg((!(p1 == null) ? isInterface(p1, NestedScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.th3_1 = {_v: true};
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.th3_1._v) {
              this.n9_1 = 7;
              continue $sm;
            }

            this.th3_1._v = false;
            var targetValueLeftover = this.lh3_1._v - this.mh3_1._v.u1();
            var tmp_0;
            if (this.nh3_1._v.sh0_1) {
              tmp_0 = true;
            } else {
              tmp_0 = Math.abs(targetValueLeftover) < this.oh3_1;
            }

            if (tmp_0) {
              dispatchMouseWheelScroll_0(this.ph3_1, this.sh3_1, targetValueLeftover);
              this.n9_1 = 5;
              suspendResult = dispatchMouseWheelScroll$waitNextScrollDelta(this.nh3_1, this.lh3_1, this.rh3_1, this.mh3_1, this.ph3_1, new Long(50, 0), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var instantDelta = sign(targetValueLeftover) * this.oh3_1;
              dispatchMouseWheelScroll_0(this.ph3_1, this.sh3_1, instantDelta);
              this.mh3_1._v = copy(this.mh3_1._v, this.mh3_1._v.u1() + instantDelta);
              var tmp_1 = this;
              var x = this.lh3_1._v - this.mh3_1._v.u1();
              var this_0 = Math.abs(x) / this.qh3_1;
              tmp_1.uh3_1 = coerceAtMost(roundToInt(this_0), 100);
              this.n9_1 = 2;
              var tmp_2 = this.mh3_1._v;
              var tmp_3 = this.lh3_1._v;
              suspendResult = animateMouseWheelScroll(this.ph3_1, this.sh3_1, tmp_2, tmp_3, this.uh3_1, MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda$lambda(this.ph3_1, this.nh3_1, this.lh3_1, this.rh3_1, this.th3_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            if (!this.th3_1._v) {
              this.n9_1 = 3;
              var tmp0 = new Long(50, 0);
              var other = this.uh3_1;
              suspendResult = dispatchMouseWheelScroll$waitNextScrollDelta(this.nh3_1, this.lh3_1, this.rh3_1, this.mh3_1, this.ph3_1, subtract(tmp0, fromInt(other)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            var ARGUMENT = suspendResult;
            this.th3_1._v = ARGUMENT;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 6;
            continue $sm;
          case 5:
            var ARGUMENT_0 = suspendResult;
            this.th3_1._v = ARGUMENT_0;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.n9_1 = 1;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda).xgg = function ($this$userScroll, completion) {
    var i = new MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda(this.lh3_1, this.mh3_1, this.nh3_1, this.oh3_1, this.ph3_1, this.qh3_1, this.rh3_1, completion);
    i.sh3_1 = $this$userScroll;
    return i;
  };
  function MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda_0($targetValue, $animationState, $targetScrollDelta, $threshold, this$0, $speed, $this_dispatchMouseWheelScroll, resultContinuation) {
    var i = new MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda($targetValue, $animationState, $targetScrollDelta, $threshold, this$0, $speed, $this_dispatchMouseWheelScroll, resultContinuation);
    return constructCallableReference(function ($this$userScroll, $completion) {
      return i.wgg($this$userScroll, $completion);
    }, 1);
  }
  function MouseWheelScrollingLogic$animateMouseWheelScroll$lambda($lastValue, this$0, $this_animateMouseWheelScroll, $shouldCancelAnimation) {
    return function ($this$animateTo) {
      var delta = $this$animateTo.u1() - $lastValue._v;
      var tmp;
      if (!isLowScrollingDelta(delta)) {
        var consumedDelta = dispatchMouseWheelScroll_0(this$0, $this_animateMouseWheelScroll, delta);
        if (!isLowScrollingDelta(delta - consumedDelta)) {
          $this$animateTo.hea();
          return Unit_instance;
        }
        $lastValue._v = $lastValue._v + delta;
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($shouldCancelAnimation($lastValue._v)) {
        $this$animateTo.hea();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function $dispatchMouseWheelScrollCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, scrollDelta, threshold, speed, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nh1_1 = _this__u8e3s4;
    this.oh1_1 = _this__u8e3s4_0;
    this.ph1_1 = scrollDelta;
    this.qh1_1 = threshold;
    this.rh1_1 = speed;
  }
  protoOf($dispatchMouseWheelScrollCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var targetScrollDelta = {_v: this.ph1_1};
            trackVelocity(this.nh1_1, this.ph1_1);
            var tmp0_safe_receiver = sumOrNull(this.nh1_1, this.nh1_1.oh0_1);
            if (tmp0_safe_receiver == null)
              null;
            else {
              trackVelocity(this.nh1_1, tmp0_safe_receiver);
              targetScrollDelta._v = targetScrollDelta._v.th0(tmp0_safe_receiver);
            }

            this.sh1_1 = {_v: this.oh1_1.hgg(this.oh1_1.fgg(targetScrollDelta._v.qh0_1))};
            if (isLowScrollingDelta(this.sh1_1._v)) {
              return Unit_instance;
            }

            var animationState = {_v: AnimationState(0.0)};
            this.n9_1 = 1;
            suspendResult = this.nh1_1.vh3(MouseWheelScrollingLogic$dispatchMouseWheelScroll$slambda_0(this.sh1_1, animationState, targetScrollDelta, this.qh1_1, this.nh1_1, this.rh1_1, this.oh1_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var velocity = this.nh1_1.bh1_1.ggi();
            if (equals(velocity, Companion_getInstance_24().v5g_1)) {
              var x = this.sh1_1._v;
              var tmp0 = Math.abs(x) / 100;
              var b = this.rh1_1;
              var velocityPxInMs = Math.min(tmp0, b);
              var x_0 = this.sh1_1._v;
              velocity = this.oh1_1.wh3(this.oh1_1.th1(sign(x_0)) * velocityPxInMs * 1000);
            }

            this.n9_1 = 2;
            suspendResult = this.nh1_1.yh0_1(new Velocity_0(velocity), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $dispatchMouseWheelScroll$waitNextScrollDeltaCOROUTINE$(targetScrollDelta, targetValue, $this_dispatchMouseWheelScroll, animationState, this$0, timeoutMillis, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xh2_1 = targetScrollDelta;
    this.yh2_1 = targetValue;
    this.zh2_1 = $this_dispatchMouseWheelScroll;
    this.ah3_1 = animationState;
    this.bh3_1 = this$0;
    this.ch3_1 = timeoutMillis;
  }
  protoOf($dispatchMouseWheelScroll$waitNextScrollDeltaCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            if (compare(this.ch3_1, new Long(0, 0)) < 0)
              return false;
            this.n9_1 = 1;
            suspendResult = withTimeoutOrNull(this.ch3_1, MouseWheelScrollingLogic$dispatchMouseWheelScroll$waitNextScrollDelta$slambda_0(this.bh3_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              var previousDeltaShouldApplyImmediately = this.xh2_1._v.sh0_1;
              this.xh2_1._v = tmp0_safe_receiver.wh0(VOID, VOID, previousDeltaShouldApplyImmediately);
              this.yh2_1._v = this.zh2_1.uh0(this.zh2_1.fgg(this.xh2_1._v.qh0_1));
              this.ah3_1._v = AnimationState(0.0);
              trackVelocity(this.bh3_1, tmp0_safe_receiver);
              tmp_0 = !isLowScrollingDelta(this.yh2_1._v);
            }

            var tmp1_elvis_lhs = tmp_0;
            return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function MouseWheelScrollingLogic(scrollingLogic, mouseWheelScrollConfig, onScrollStopped, density) {
    NonTouchScrollingLogic.call(this, scrollingLogic, onScrollStopped, density);
    this.nh0_1 = mouseWheelScrollConfig;
    this.oh0_1 = Channel(2147483647);
    this.ph0_1 = null;
  }
  protoOf(MouseWheelScrollingLogic).aa1 = function (pointerEvent, pass, bounds) {
    if (!(pointerEvent.ha0_1 === Companion_getInstance_8().qa1_1))
      return Unit_instance;
    // Inline function 'androidx.compose.foundation.gestures.NonTouchScrollingLogic.isConsumed' call
    var tmp0 = pointerEvent.ca0_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (item.qa2()) {
            tmp$ret$1 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = false;
    }
    if (tmp$ret$1)
      return Unit_instance;
    if (pass.equals(PointerEventPass_Initial_getInstance()) && this.ah1_1) {
      onMouseWheel(this, pointerEvent, bounds);
      this.xh3(pointerEvent);
    }
    if (pass.equals(PointerEventPass_Main_getInstance()) && !this.ah1_1) {
      var consumed = onMouseWheel(this, pointerEvent, bounds);
      if (consumed) {
        this.xh3(pointerEvent);
      }
    }
  };
  protoOf(MouseWheelScrollingLogic).yh3 = function (coroutineScope) {
    if (this.ph0_1 == null) {
      var tmp = this;
      tmp.ph0_1 = launch(coroutineScope, VOID, VOID, MouseWheelScrollingLogic$startReceivingEvents$slambda_0(this, null));
    }
  };
  function isLowScrollingDelta(_this__u8e3s4) {
    _init_properties_MouseWheelScrollingLogic_kt__38b1wf();
    var tmp;
    if (isNaN_0(_this__u8e3s4)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      tmp = Math.abs(_this__u8e3s4) < 0.5;
    }
    return tmp;
  }
  var properties_initialized_MouseWheelScrollingLogic_kt_l6e0rl;
  function _init_properties_MouseWheelScrollingLogic_kt__38b1wf() {
    if (!properties_initialized_MouseWheelScrollingLogic_kt_l6e0rl) {
      properties_initialized_MouseWheelScrollingLogic_kt_l6e0rl = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      AnimationThreshold = _Dp___init__impl__ms3zkb(6);
      // Inline function 'androidx.compose.ui.unit.dp' call
      AnimationSpeed = _Dp___init__impl__ms3zkb(1);
      androidx_compose_foundation_gestures_MouseWheelScrollingLogic$stable = 8;
    }
  }
  var androidx_compose_foundation_gestures_NonTouchScrollingLogic$stable;
  function NonTouchScrollingLogic$userScroll$slambda(this$0, $block, resultContinuation) {
    this.ih4_1 = this$0;
    this.jh4_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NonTouchScrollingLogic$userScroll$slambda).p24 = function ($this$supervisorScope, $completion) {
    var tmp = this.q24($this$supervisorScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NonTouchScrollingLogic$userScroll$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NonTouchScrollingLogic$userScroll$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.ih4_1.xh0_1.pgh(MutatePriority_UserInput_getInstance(), this.jh4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NonTouchScrollingLogic$userScroll$slambda).q24 = function ($this$supervisorScope, completion) {
    var i = new NonTouchScrollingLogic$userScroll$slambda(this.ih4_1, this.jh4_1, completion);
    i.kh4_1 = $this$supervisorScope;
    return i;
  };
  function NonTouchScrollingLogic$userScroll$slambda_0(this$0, $block, resultContinuation) {
    var i = new NonTouchScrollingLogic$userScroll$slambda(this$0, $block, resultContinuation);
    return constructCallableReference(function ($this$supervisorScope, $completion) {
      return i.p24($this$supervisorScope, $completion);
    }, 1);
  }
  function $userScrollCOROUTINE$(_this__u8e3s4, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.th4_1 = _this__u8e3s4;
    this.uh4_1 = block;
  }
  protoOf($userScrollCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.th4_1.ah1_1 = true;
            this.n9_1 = 1;
            suspendResult = supervisorScope(NonTouchScrollingLogic$userScroll$slambda_0(this.th4_1, this.uh4_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.th4_1.ah1_1 = false;
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function NonTouchScrollingLogic(scrollingLogic, onScrollStopped, density) {
    this.xh0_1 = scrollingLogic;
    this.yh0_1 = onScrollStopped;
    this.zh0_1 = density;
    this.ah1_1 = false;
    this.bh1_1 = new DifferentialVelocityTracker();
  }
  protoOf(NonTouchScrollingLogic).zh3 = function (density) {
    this.zh0_1 = density;
  };
  protoOf(NonTouchScrollingLogic).xh3 = function (_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = _this__u8e3s4.ca0_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        item.ra2();
      }
       while (inductionVariable <= last);
    return Unit_instance;
  };
  protoOf(NonTouchScrollingLogic).vh3 = function (block, $completion) {
    var tmp = new $userScrollCOROUTINE$(this, block, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function untilNull(builderAction) {
    return sequence(untilNull$slambda_0(builderAction, null));
  }
  function busyReceive(_this__u8e3s4, $completion) {
    return coroutineScope(busyReceive$slambda_0(_this__u8e3s4, null), $completion);
  }
  function untilNull$slambda($builderAction, resultContinuation) {
    this.dh5_1 = $builderAction;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(untilNull$slambda).a12 = function ($this$sequence, $completion) {
    var tmp = this.b12($this$sequence, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(untilNull$slambda).ja = function (p1, $completion) {
    return this.a12(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(untilNull$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            var tmp0_safe_receiver = this.dh5_1();
            if (tmp0_safe_receiver == null) {
              this.fh5_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.gh5_1 = tmp0_safe_receiver;
              var it = this.gh5_1;
              this.n9_1 = 2;
              suspendResult = this.eh5_1.oi(it, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.fh5_1 = this.gh5_1;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var element = this.fh5_1;
            if (!(element == null)) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(untilNull$slambda).b12 = function ($this$sequence, completion) {
    var i = new untilNull$slambda(this.dh5_1, completion);
    i.eh5_1 = $this$sequence;
    return i;
  };
  function untilNull$slambda_0($builderAction, resultContinuation) {
    var i = new untilNull$slambda($builderAction, resultContinuation);
    return constructCallableReference(function ($this$sequence, $completion) {
      return i.a12($this$sequence, $completion);
    }, 1);
  }
  function busyReceive$slambda$slambda$lambda(it) {
    return Unit_instance;
  }
  function busyReceive$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(busyReceive$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(busyReceive$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(busyReceive$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!get_isActive_0(this.ph5_1.q19())) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = withFrameNanos(busyReceive$slambda$slambda$lambda, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(busyReceive$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new busyReceive$slambda$slambda(completion);
    i.ph5_1 = $this$launch;
    return i;
  };
  function busyReceive$slambda$slambda_0(resultContinuation) {
    var i = new busyReceive$slambda$slambda(resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function busyReceive$slambda($this_busyReceive, resultContinuation) {
    this.yh5_1 = $this_busyReceive;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(busyReceive$slambda).ch6 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(busyReceive$slambda).ja = function (p1, $completion) {
    return this.ch6((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(busyReceive$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp_0 = this;
            tmp_0.ah6_1 = launch(this.zh5_1, VOID, VOID, busyReceive$slambda$slambda_0(null));
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            suspendResult = this.yh5_1.u1s(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.bh6_1 = suspendResult;
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp_1 = this.bh6_1;
            this.o9_1 = 5;
            this.ah6_1.b1b();
            return tmp_1;
          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            this.ah6_1.b1b();
            throw t;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(busyReceive$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new busyReceive$slambda(this.yh5_1, completion);
    i.zh5_1 = $this$coroutineScope;
    return i;
  };
  function busyReceive$slambda_0($this_busyReceive, resultContinuation) {
    var i = new busyReceive$slambda($this_busyReceive, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.ch6($this$coroutineScope, $completion);
    }, 1);
  }
  var Orientation_Vertical_instance;
  var Orientation_Horizontal_instance;
  var Orientation_entriesInitialized;
  function Orientation_initEntries() {
    if (Orientation_entriesInitialized)
      return Unit_instance;
    Orientation_entriesInitialized = true;
    Orientation_Vertical_instance = new Orientation('Vertical', 0);
    Orientation_Horizontal_instance = new Orientation('Horizontal', 1);
  }
  function Orientation(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Orientation_Vertical_getInstance() {
    Orientation_initEntries();
    return Orientation_Vertical_instance;
  }
  function Orientation_Horizontal_getInstance() {
    Orientation_initEntries();
    return Orientation_Horizontal_instance;
  }
  function scrollBy_0(_this__u8e3s4, value, $completion) {
    var tmp = new $scrollByCOROUTINE$(_this__u8e3s4, value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function stopScroll(_this__u8e3s4, scrollPriority, $completion) {
    scrollPriority = scrollPriority === VOID ? MutatePriority_Default_getInstance() : scrollPriority;
    return _this__u8e3s4.pg7(scrollPriority, stopScroll$slambda_0(null), $completion);
  }
  function scrollBy$slambda($consumed, $value, resultContinuation) {
    this.wh6_1 = $consumed;
    this.xh6_1 = $value;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(scrollBy$slambda).zh6 = function ($this$scroll, $completion) {
    var tmp = this.ah7($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(scrollBy$slambda).ja = function (p1, $completion) {
    return this.zh6((!(p1 == null) ? isInterface(p1, ScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(scrollBy$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.wh6_1._v = this.yh6_1.bh7(this.xh6_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(scrollBy$slambda).ah7 = function ($this$scroll, completion) {
    var i = new scrollBy$slambda(this.wh6_1, this.xh6_1, completion);
    i.yh6_1 = $this$scroll;
    return i;
  };
  function scrollBy$slambda_0($consumed, $value, resultContinuation) {
    var i = new scrollBy$slambda($consumed, $value, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.zh6($this$scroll, $completion);
    }, 1);
  }
  function stopScroll$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(stopScroll$slambda).zh6 = function ($this$scroll, $completion) {
    var tmp = this.ah7($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(stopScroll$slambda).ja = function (p1, $completion) {
    return this.zh6((!(p1 == null) ? isInterface(p1, ScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(stopScroll$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(stopScroll$slambda).ah7 = function ($this$scroll, completion) {
    var i = new stopScroll$slambda(completion);
    i.kh7_1 = $this$scroll;
    return i;
  };
  function stopScroll$slambda_0(resultContinuation) {
    var i = new stopScroll$slambda(resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.zh6($this$scroll, $completion);
    }, 1);
  }
  function $scrollByCOROUTINE$(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lh6_1 = _this__u8e3s4;
    this.mh6_1 = value;
  }
  protoOf($scrollByCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.nh6_1 = {_v: 0.0};
            this.n9_1 = 1;
            suspendResult = this.lh6_1.qg7(VOID, scrollBy$slambda_0(this.nh6_1, this.mh6_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.nh6_1._v;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function get_CanDragCalculation() {
    _init_properties_Scrollable_kt__k2543d();
    return CanDragCalculation;
  }
  var CanDragCalculation;
  function get_NoOpScrollScope() {
    _init_properties_Scrollable_kt__k2543d();
    return NoOpScrollScope;
  }
  var NoOpScrollScope;
  function get_DefaultScrollMotionDurationScale() {
    _init_properties_Scrollable_kt__k2543d();
    return DefaultScrollMotionDurationScale;
  }
  var DefaultScrollMotionDurationScale;
  function get_UnityDensity() {
    _init_properties_Scrollable_kt__k2543d();
    return UnityDensity;
  }
  var UnityDensity;
  var androidx_compose_foundation_gestures_ScrollableNode$stable;
  var androidx_compose_foundation_gestures_ScrollableDefaults_NoOpOverscrollEffect$stable;
  var androidx_compose_foundation_gestures_ScrollableDefaults$stable;
  var androidx_compose_foundation_gestures_ScrollingLogic$stable;
  var androidx_compose_foundation_gestures_ScrollableNestedScrollConnection$stable;
  var androidx_compose_foundation_gestures_DefaultFlingBehavior$stable;
  var androidx_compose_foundation_gestures_ScrollableContainerNode$stable;
  var androidx_compose_foundation_gestures_FlingCancellationException$stable;
  function TraverseKey_3() {
  }
  var TraverseKey_instance_3;
  function TraverseKey_getInstance_3() {
    return TraverseKey_instance_3;
  }
  function ScrollableContainerNode(enabled) {
    Node.call(this);
    this.vfw_1 = TraverseKey_instance_3;
    this.wfw_1 = enabled;
  }
  protoOf(ScrollableContainerNode).t91 = function () {
    return this.vfw_1;
  };
  protoOf(ScrollableContainerNode).lh7 = function (enabled) {
    this.wfw_1 = enabled;
  };
  function ScrollableDefaults() {
  }
  protoOf(ScrollableDefaults).mh7 = function ($composer, $changed) {
    var $composer_0 = $composer;
    return rememberPlatformDefaultFlingBehavior($composer_0, 0);
  };
  protoOf(ScrollableDefaults).igc = function (layoutDirection, orientation, reverseScrolling) {
    var reverseDirection = !reverseScrolling;
    var isRtl = layoutDirection.equals(LayoutDirection_Rtl_getInstance());
    if (isRtl && !orientation.equals(Orientation_Vertical_getInstance())) {
      reverseDirection = !reverseDirection;
    }
    return reverseDirection;
  };
  var ScrollableDefaults_instance;
  function ScrollableDefaults_getInstance() {
    return ScrollableDefaults_instance;
  }
  function scrollable(_this__u8e3s4, state, orientation, overscrollEffect, enabled, reverseDirection, flingBehavior, interactionSource, bringIntoViewSpec) {
    enabled = enabled === VOID ? true : enabled;
    reverseDirection = reverseDirection === VOID ? false : reverseDirection;
    flingBehavior = flingBehavior === VOID ? null : flingBehavior;
    interactionSource = interactionSource === VOID ? null : interactionSource;
    bringIntoViewSpec = bringIntoViewSpec === VOID ? null : bringIntoViewSpec;
    _init_properties_Scrollable_kt__k2543d();
    return _this__u8e3s4.d8v(new ScrollableElement(state, orientation, overscrollEffect, enabled, reverseDirection, flingBehavior, interactionSource, bringIntoViewSpec));
  }
  function ScrollableElement(state, orientation, overscrollEffect, enabled, reverseDirection, flingBehavior, interactionSource, bringIntoViewSpec) {
    ModifierNodeElement.call(this);
    this.oh7_1 = state;
    this.ph7_1 = orientation;
    this.qh7_1 = overscrollEffect;
    this.rh7_1 = enabled;
    this.sh7_1 = reverseDirection;
    this.th7_1 = flingBehavior;
    this.uh7_1 = interactionSource;
    this.vh7_1 = bringIntoViewSpec;
  }
  protoOf(ScrollableElement).r3d = function () {
    return new ScrollableNode(this.oh7_1, this.qh7_1, this.th7_1, this.ph7_1, this.rh7_1, this.sh7_1, this.uh7_1, this.vh7_1);
  };
  protoOf(ScrollableElement).wh7 = function (node) {
    node.hgc(this.oh7_1, this.ph7_1, this.qh7_1, this.rh7_1, this.sh7_1, this.th7_1, this.uh7_1, this.vh7_1);
  };
  protoOf(ScrollableElement).d8y = function (node) {
    return this.wh7(node instanceof ScrollableNode ? node : THROW_CCE());
  };
  protoOf(ScrollableElement).hashCode = function () {
    var result = hashCode(this.oh7_1);
    result = imul(31, result) + this.ph7_1.hashCode() | 0;
    var tmp = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.qh7_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + getBooleanHashCode(this.rh7_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.sh7_1) | 0;
    var tmp_0 = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.th7_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    result = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    var tmp_1 = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_1 = this.uh7_1;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
    result = tmp_1 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
    var tmp_2 = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_2 = this.vh7_1;
    var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    result = tmp_2 + (tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2) | 0;
    return result;
  };
  protoOf(ScrollableElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScrollableElement))
      return false;
    if (!equals(this.oh7_1, other.oh7_1))
      return false;
    if (!this.ph7_1.equals(other.ph7_1))
      return false;
    if (!equals(this.qh7_1, other.qh7_1))
      return false;
    if (!(this.rh7_1 === other.rh7_1))
      return false;
    if (!(this.sh7_1 === other.sh7_1))
      return false;
    if (!equals(this.th7_1, other.th7_1))
      return false;
    if (!equals(this.uh7_1, other.uh7_1))
      return false;
    if (!equals(this.vh7_1, other.vh7_1))
      return false;
    return true;
  };
  function ScrollableNode$drag$slambda$lambda($this_scroll, $$this$with) {
    return function (it) {
      var invertIndirectPointer = it.bgs_1 ? -1.0 : 1.0;
      $this_scroll.yh7(Offset__times_impl_jz1mli($$this$with.xh7(it.ags_1), invertIndirectPointer), Companion_getInstance_20().d9v_1);
      return Unit_instance;
    };
  }
  function ScrollableNode$onKeyEvent$slambda$slambda($scrollAmount, resultContinuation) {
    this.hh8_1 = $scrollAmount;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScrollableNode$onKeyEvent$slambda$slambda).wgg = function ($this$scroll, $completion) {
    var tmp = this.xgg($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScrollableNode$onKeyEvent$slambda$slambda).ja = function (p1, $completion) {
    return this.wgg((!(p1 == null) ? isInterface(p1, NestedScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScrollableNode$onKeyEvent$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.ih8_1.ggg(this.hh8_1, Companion_getInstance_20().d9v_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ScrollableNode$onKeyEvent$slambda$slambda).xgg = function ($this$scroll, completion) {
    var i = new ScrollableNode$onKeyEvent$slambda$slambda(this.hh8_1, completion);
    i.ih8_1 = $this$scroll;
    return i;
  };
  function ScrollableNode$onKeyEvent$slambda$slambda_0($scrollAmount, resultContinuation) {
    var i = new ScrollableNode$onKeyEvent$slambda$slambda($scrollAmount, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.wgg($this$scroll, $completion);
    }, 1);
  }
  function onWheelScrollStopped($this, velocity) {
    var tmp = $this.wgb_1.a8w();
    launch(tmp, VOID, VOID, ScrollableNode$onWheelScrollStopped$slambda_0($this, velocity, null));
  }
  function onTrackpadScrollStopped($this, velocity) {
    var tmp = $this.wgb_1.a8w();
    launch(tmp, VOID, VOID, ScrollableNode$onTrackpadScrollStopped$slambda_0($this, velocity, null));
  }
  function ensureMouseWheelScrollingLogicInitialized($this) {
    if ($this.egc_1 == null) {
      var tmp = $this;
      var tmp_0 = platformScrollConfig($this);
      tmp.egc_1 = new MouseWheelScrollingLogic($this.ygb_1, tmp_0, ScrollableNode$onWheelScrollStopped$ref_0($this), requireDensity($this));
    }
    var tmp0_safe_receiver = $this.egc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.yh3($this.a8w());
    }
  }
  function ensureTrackpadScrollingLogicInitialized($this) {
    if ($this.fgc_1 == null) {
      var tmp = $this;
      tmp.fgc_1 = new TrackpadScrollingLogic($this.ygb_1, ScrollableNode$onTrackpadScrollStopped$ref_0($this), requireDensity($this));
    }
    var tmp0_safe_receiver = $this.fgc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.yh3($this.a8w());
    }
  }
  function updateDefaultFlingBehavior($this) {
    if (!$this.z8v_1)
      return Unit_instance;
    var density = requireDensity($this);
    $this.xgb_1.zh3(density);
  }
  function setScrollSemanticsActions($this) {
    var tmp = $this;
    tmp.cgc_1 = ScrollableNode$setScrollSemanticsActions$lambda($this);
    var tmp_0 = $this;
    tmp_0.dgc_1 = ScrollableNode$setScrollSemanticsActions$slambda_0($this, null);
  }
  function clearScrollSemanticsActions($this) {
    $this.cgc_1 = null;
    $this.dgc_1 = null;
  }
  function ScrollableNode$scrollingLogic$lambda(this$0) {
    return function () {
      return this$0.z8v_1;
    };
  }
  function ScrollableNode$contentInViewNode$lambda(this$0) {
    return function () {
      return getFocusedRect(this$0.agc_1);
    };
  }
  function ScrollableNode$drag$slambda($forEachDelta, $$this$with, resultContinuation) {
    this.yh8_1 = $forEachDelta;
    this.zh8_1 = $$this$with;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScrollableNode$drag$slambda).wgg = function ($this$scroll, $completion) {
    var tmp = this.xgg($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScrollableNode$drag$slambda).ja = function (p1, $completion) {
    return this.wgg((!(p1 == null) ? isInterface(p1, NestedScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScrollableNode$drag$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.yh8_1(ScrollableNode$drag$slambda$lambda(this.ah9_1, this.zh8_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScrollableNode$drag$slambda).xgg = function ($this$scroll, completion) {
    var i = new ScrollableNode$drag$slambda(this.yh8_1, this.zh8_1, completion);
    i.ah9_1 = $this$scroll;
    return i;
  };
  function ScrollableNode$drag$slambda_0($forEachDelta, $$this$with, resultContinuation) {
    var i = new ScrollableNode$drag$slambda($forEachDelta, $$this$with, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.wgg($this$scroll, $completion);
    }, 1);
  }
  function ScrollableNode$onDragStopped$slambda($event, this$0, resultContinuation) {
    this.jh9_1 = $event;
    this.kh9_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScrollableNode$onDragStopped$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScrollableNode$onDragStopped$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScrollableNode$onDragStopped$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var invertIndirectPointer = this.jh9_1.mgt_1 ? -1.0 : 1.0;
            this.n9_1 = 1;
            suspendResult = this.kh9_1.ygb_1.mh9(Velocity__times_impl_yav0ik(this.jh9_1.lgt_1, invertIndirectPointer), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScrollableNode$onDragStopped$slambda).q24 = function ($this$launch, completion) {
    var i = new ScrollableNode$onDragStopped$slambda(this.jh9_1, this.kh9_1, completion);
    i.lh9_1 = $this$launch;
    return i;
  };
  function ScrollableNode$onDragStopped$slambda_0($event, this$0, resultContinuation) {
    var i = new ScrollableNode$onDragStopped$slambda($event, this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ScrollableNode$onWheelScrollStopped$slambda(this$0, $velocity, resultContinuation) {
    this.vh9_1 = this$0;
    this.wh9_1 = $velocity;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScrollableNode$onWheelScrollStopped$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScrollableNode$onWheelScrollStopped$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScrollableNode$onWheelScrollStopped$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.vh9_1.ygb_1.mh9(this.wh9_1, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScrollableNode$onWheelScrollStopped$slambda).q24 = function ($this$launch, completion) {
    var i = new ScrollableNode$onWheelScrollStopped$slambda(this.vh9_1, this.wh9_1, completion);
    i.xh9_1 = $this$launch;
    return i;
  };
  function ScrollableNode$onWheelScrollStopped$slambda_0(this$0, $velocity, resultContinuation) {
    var i = new ScrollableNode$onWheelScrollStopped$slambda(this$0, $velocity, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ScrollableNode$onTrackpadScrollStopped$slambda(this$0, $velocity, resultContinuation) {
    this.gha_1 = this$0;
    this.hha_1 = $velocity;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScrollableNode$onTrackpadScrollStopped$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScrollableNode$onTrackpadScrollStopped$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScrollableNode$onTrackpadScrollStopped$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.gha_1.ygb_1.mh9(this.hha_1, false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScrollableNode$onTrackpadScrollStopped$slambda).q24 = function ($this$launch, completion) {
    var i = new ScrollableNode$onTrackpadScrollStopped$slambda(this.gha_1, this.hha_1, completion);
    i.iha_1 = $this$launch;
    return i;
  };
  function ScrollableNode$onTrackpadScrollStopped$slambda_0(this$0, $velocity, resultContinuation) {
    var i = new ScrollableNode$onTrackpadScrollStopped$slambda(this$0, $velocity, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ScrollableNode$onWheelScrollStopped$ref(p0) {
    KFunctionImpl.call(this, 5, 2, 252);
    this.mha_1 = p0;
  }
  protoOf(ScrollableNode$onWheelScrollStopped$ref).nha = function (p0, $completion) {
    var tmp0 = this.mha_1;
    onWheelScrollStopped(tmp0, p0);
    return Unit_instance;
  };
  protoOf(ScrollableNode$onWheelScrollStopped$ref).ja = function (p1, $completion) {
    return this.nha(p1 instanceof Velocity_0 ? p1.t5g_1 : THROW_CCE(), $completion);
  };
  function ScrollableNode$onWheelScrollStopped$ref_0(p0) {
    var i = new ScrollableNode$onWheelScrollStopped$ref(p0);
    return constructCallableReference(function (p0, $completion) {
      return i.nha(p0.t5g_1, $completion);
    }, 1, 5, 252, VOID, [p0]);
  }
  function ScrollableNode$onTrackpadScrollStopped$ref(p0) {
    KFunctionImpl.call(this, 5, 2, 253);
    this.rha_1 = p0;
  }
  protoOf(ScrollableNode$onTrackpadScrollStopped$ref).nha = function (p0, $completion) {
    var tmp0 = this.rha_1;
    onTrackpadScrollStopped(tmp0, p0);
    return Unit_instance;
  };
  protoOf(ScrollableNode$onTrackpadScrollStopped$ref).ja = function (p1, $completion) {
    return this.nha(p1 instanceof Velocity_0 ? p1.t5g_1 : THROW_CCE(), $completion);
  };
  function ScrollableNode$onTrackpadScrollStopped$ref_0(p0) {
    var i = new ScrollableNode$onTrackpadScrollStopped$ref(p0);
    return constructCallableReference(function (p0, $completion) {
      return i.nha(p0.t5g_1, $completion);
    }, 1, 5, 253, VOID, [p0]);
  }
  function ScrollableNode$onKeyEvent$slambda(this$0, $scrollAmount, resultContinuation) {
    this.ahb_1 = this$0;
    this.bhb_1 = $scrollAmount;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScrollableNode$onKeyEvent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScrollableNode$onKeyEvent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScrollableNode$onKeyEvent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = MutatePriority_UserInput_getInstance();
            suspendResult = this.ahb_1.ygb_1.pgh(tmp_0, ScrollableNode$onKeyEvent$slambda$slambda_0(this.bhb_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScrollableNode$onKeyEvent$slambda).q24 = function ($this$launch, completion) {
    var i = new ScrollableNode$onKeyEvent$slambda(this.ahb_1, this.bhb_1, completion);
    i.chb_1 = $this$launch;
    return i;
  };
  function ScrollableNode$onKeyEvent$slambda_0(this$0, $scrollAmount, resultContinuation) {
    var i = new ScrollableNode$onKeyEvent$slambda(this$0, $scrollAmount, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ScrollableNode$setScrollSemanticsActions$lambda$slambda(this$0, $x, $y, resultContinuation) {
    this.lhb_1 = this$0;
    this.mhb_1 = $x;
    this.nhb_1 = $y;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScrollableNode$setScrollSemanticsActions$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScrollableNode$setScrollSemanticsActions$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScrollableNode$setScrollSemanticsActions$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            var tmp0 = this.mhb_1;
            var val2 = this.nhb_1;
            var v1 = fromInt(toRawBits(tmp0));
            var v2 = fromInt(toRawBits(val2));
            suspendResult = semanticsScrollBy(this.lhb_1.ygb_1, _Offset___init__impl__c168vi(bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)))), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.n9_1 = 2;
            continue $sm;
          case 1:
            var unboxed = suspendResult.e5d_1;
            suspendResult = new Offset(unboxed);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScrollableNode$setScrollSemanticsActions$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new ScrollableNode$setScrollSemanticsActions$lambda$slambda(this.lhb_1, this.mhb_1, this.nhb_1, completion);
    i.ohb_1 = $this$launch;
    return i;
  };
  function ScrollableNode$setScrollSemanticsActions$lambda$slambda_0(this$0, $x, $y, resultContinuation) {
    var i = new ScrollableNode$setScrollSemanticsActions$lambda$slambda(this$0, $x, $y, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ScrollableNode$setScrollSemanticsActions$lambda(this$0) {
    return function (x, y) {
      var tmp = this$0.a8w();
      launch(tmp, VOID, VOID, ScrollableNode$setScrollSemanticsActions$lambda$slambda_0(this$0, x, y, null));
      return true;
    };
  }
  function ScrollableNode$setScrollSemanticsActions$slambda(this$0, resultContinuation) {
    this.xhb_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScrollableNode$setScrollSemanticsActions$slambda).zhb = function (offset, $completion) {
    var tmp = this.ahc(offset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    var tmp_0 = tmp.v9();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  protoOf(ScrollableNode$setScrollSemanticsActions$slambda).ja = function (p1, $completion) {
    return this.zhb(p1 instanceof Offset ? p1.e5d_1 : THROW_CCE(), $completion);
  };
  protoOf(ScrollableNode$setScrollSemanticsActions$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = semanticsScrollBy(this.xhb_1.ygb_1, this.yhb_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.n9_1 = 2;
            continue $sm;
          case 1:
            var unboxed = suspendResult.e5d_1;
            suspendResult = new Offset(unboxed);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScrollableNode$setScrollSemanticsActions$slambda).ahc = function (offset, completion) {
    var i = new ScrollableNode$setScrollSemanticsActions$slambda(this.xhb_1, completion);
    i.yhb_1 = offset;
    return i;
  };
  function ScrollableNode$setScrollSemanticsActions$slambda_0(this$0, resultContinuation) {
    var i = new ScrollableNode$setScrollSemanticsActions$slambda(this$0, resultContinuation);
    return constructCallableReference(function (offset, $completion) {
      return i.zhb(offset.e5d_1, $completion);
    }, 1);
  }
  function $dragCOROUTINE$_0(_this__u8e3s4, forEachDelta, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jhc_1 = _this__u8e3s4;
    this.khc_1 = forEachDelta;
  }
  protoOf($dragCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$with = this.jhc_1.ygb_1;
            this.n9_1 = 1;
            var tmp_0 = MutatePriority_UserInput_getInstance();
            suspendResult = $this$with.pgh(tmp_0, ScrollableNode$drag$slambda_0(this.khc_1, $this$with, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ScrollableNode(state, overscrollEffect, flingBehavior, orientation, enabled, reverseDirection, interactionSource, bringIntoViewSpec) {
    DragGestureNode.call(this, get_CanDragCalculation(), enabled, interactionSource, orientation);
    this.tgb_1 = overscrollEffect;
    this.ugb_1 = flingBehavior;
    this.vgb_1 = false;
    this.wgb_1 = new NestedScrollDispatcher();
    this.xgb_1 = platformScrollableDefaultFlingBehavior();
    var tmp = this;
    var tmp1_overscrollEffect = this.tgb_1;
    var tmp0_elvis_lhs = this.ugb_1;
    var tmp2_flingBehavior = tmp0_elvis_lhs == null ? this.xgb_1 : tmp0_elvis_lhs;
    var tmp3_nestedScrollDispatcher = this.wgb_1;
    tmp.ygb_1 = new ScrollingLogic(state, tmp1_overscrollEffect, tmp2_flingBehavior, orientation, reverseDirection, tmp3_nestedScrollDispatcher, this, ScrollableNode$scrollingLogic$lambda(this));
    var tmp_0 = this;
    var tmp0_scrollingLogic = this.ygb_1;
    tmp_0.zgb_1 = new ScrollableNestedScrollConnection(tmp0_scrollingLogic, enabled);
    this.agc_1 = this.tb1(funFocusTargetModifierNode2(Companion_getInstance_7().l9e_1));
    var tmp_1 = this;
    tmp_1.bgc_1 = this.tb1(new ContentInViewNode(orientation, this.ygb_1, reverseDirection, bringIntoViewSpec, ScrollableNode$contentInViewNode$lambda(this)));
    this.cgc_1 = null;
    this.dgc_1 = null;
    this.egc_1 = null;
    this.fgc_1 = null;
    this.ggc_1 = null;
    this.tb1(nestedScrollModifierNode(this.zgb_1, this.wgb_1));
    this.tb1(new BringIntoViewResponderNode(this.bgc_1));
    if (!ComposeFoundationFlags_instance.pfg_1) {
      this.ggc_1 = this.tb1(new ScrollableContainerNode(enabled));
    }
  }
  protoOf(ScrollableNode).b8w = function () {
    return this.vgb_1;
  };
  protoOf(ScrollableNode).lhc = function (delta) {
    if (!this.z8v_1)
      return Unit_instance;
    dispatchOnScrollChanged(this, delta);
  };
  protoOf(ScrollableNode).ngt = function (forEachDelta, $completion) {
    var tmp = new $dragCOROUTINE$_0(this, forEachDelta, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScrollableNode).ogt = function (startedPosition) {
  };
  protoOf(ScrollableNode).pgt = function (event) {
    var tmp = this.wgb_1.a8w();
    launch(tmp, VOID, VOID, ScrollableNode$onDragStopped$slambda_0(event, this, null));
  };
  protoOf(ScrollableNode).qgt = function () {
    return this.ygb_1.mhc();
  };
  protoOf(ScrollableNode).hgc = function (state, orientation, overscrollEffect, enabled, reverseDirection, flingBehavior, interactionSource, bringIntoViewSpec) {
    var shouldInvalidateSemantics = false;
    if (!(this.jgu_1 === enabled)) {
      this.zgb_1.ohc_1 = enabled;
      var tmp0_safe_receiver = this.ggc_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.lh7(enabled);
      }
      shouldInvalidateSemantics = true;
    }
    var resolvedFlingBehavior = flingBehavior == null ? this.xgb_1 : flingBehavior;
    var resetPointerInputHandling = this.ygb_1.phc(state, orientation, overscrollEffect, reverseDirection, resolvedFlingBehavior, this.wgb_1);
    this.bgc_1.cgi(orientation, reverseDirection, bringIntoViewSpec);
    this.tgb_1 = overscrollEffect;
    this.ugb_1 = flingBehavior;
    this.bgv(get_CanDragCalculation(), enabled, interactionSource, this.ygb_1.qhc() ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance(), resetPointerInputHandling);
    if (shouldInvalidateSemantics) {
      clearScrollSemanticsActions(this);
      invalidateSemantics(this);
    }
  };
  protoOf(ScrollableNode).f8w = function () {
    updateDefaultFlingBehavior(this);
    var tmp0_safe_receiver = this.egc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zh3(requireDensity(this));
    }
    var tmp1_safe_receiver = this.fgc_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.zh3(requireDensity(this));
    }
  };
  protoOf(ScrollableNode).n8w = function () {
    this.xa1();
    updateDefaultFlingBehavior(this);
    var tmp0_safe_receiver = this.egc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zh3(requireDensity(this));
    }
    var tmp1_safe_receiver = this.fgc_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.zh3(requireDensity(this));
    }
  };
  protoOf(ScrollableNode).w9e = function (event) {
    var tmp;
    if (this.jgu_1 && (equals(get_key(event), Companion_getInstance_10().tcb_1) || equals(get_key(event), Companion_getInstance_10().scb_1)) && get_type(event) === Companion_getInstance_9().e9e_1 && !get_isCtrlPressed(event)) {
      var tmp_0;
      if (this.ygb_1.qhc()) {
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        var this_0 = this.bgc_1.zgg();
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
        var viewportHeight = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
        var tmp_1;
        if (equals(get_key(event), Companion_getInstance_10().scb_1)) {
          tmp_1 = viewportHeight;
        } else {
          tmp_1 = -viewportHeight;
        }
        var yAmount = tmp_1;
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var v1 = fromInt(toRawBits(0.0));
        var v2 = fromInt(toRawBits(yAmount));
        var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        tmp_0 = _Offset___init__impl__c168vi(tmp$ret$3);
      } else {
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call
        var this_1 = this.bgc_1.zgg();
        // Inline function 'androidx.compose.ui.util.unpackInt1' call
        var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
        var viewportWidth = convertToInt(shiftRight(value_0, 32));
        var tmp_2;
        if (equals(get_key(event), Companion_getInstance_10().scb_1)) {
          tmp_2 = viewportWidth;
        } else {
          tmp_2 = -viewportWidth;
        }
        var xAmount = tmp_2;
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var v1_0 = fromInt(toRawBits(xAmount));
        var v2_0 = fromInt(toRawBits(0.0));
        var tmp$ret$7 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
        tmp_0 = _Offset___init__impl__c168vi(tmp$ret$7);
      }
      var scrollAmount = tmp_0;
      var tmp_3 = this.a8w();
      launch(tmp_3, VOID, VOID, ScrollableNode$onKeyEvent$slambda_0(this, scrollAmount, null));
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ScrollableNode).v9e = function (event) {
    return false;
  };
  protoOf(ScrollableNode).aa1 = function (pointerEvent, pass, bounds) {
    var tmp0 = pointerEvent.ca0_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (this.igu_1(new PointerType(item.qa0_1))) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      protoOf(DragGestureNode).aa1.call(this, pointerEvent, pass, bounds);
    }
    this.cgv();
    if (this.jgu_1) {
      if (pass.equals(PointerEventPass_Initial_getInstance()) && pointerEvent.ha0_1 === Companion_getInstance_8().qa1_1) {
        ensureMouseWheelScrollingLogicInitialized(this);
      }
      var tmp0_safe_receiver = this.egc_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.aa1(pointerEvent, pass, bounds);
      }
      if (pass.equals(PointerEventPass_Initial_getInstance()) && (pointerEvent.ha0_1 === Companion_getInstance_8().ua1_1 || pointerEvent.ha0_1 === Companion_getInstance_8().va1_1 || pointerEvent.ha0_1 === Companion_getInstance_8().wa1_1)) {
        ensureTrackpadScrollingLogicInitialized(this);
      }
      var tmp1_safe_receiver = this.fgc_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.aa1(pointerEvent, pass, bounds);
      }
    }
  };
  protoOf(ScrollableNode).l9i = function (_this__u8e3s4) {
    if (this.jgu_1 && (this.cgc_1 == null || this.dgc_1 == null)) {
      setScrollSemanticsActions(this);
    }
    var tmp0_safe_receiver = this.cgc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      scrollBy(_this__u8e3s4, VOID, tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = this.dgc_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      scrollByOffset(_this__u8e3s4, tmp1_safe_receiver);
    }
  };
  function ScrollableDefaultFlingBehavior() {
  }
  function ScrollingLogic$doFlingAnimation$2$reverseScope$1(this$0, $nestedScrollScope) {
    this.rhc_1 = this$0;
    this.shc_1 = $nestedScrollScope;
  }
  protoOf(ScrollingLogic$doFlingAnimation$2$reverseScope$1).bh7 = function (pixels) {
    var tmp;
    // Inline function 'kotlin.math.absoluteValue' call
    if (!(Math.abs(pixels) === 0.0)) {
      tmp = !this.rhc_1.ygf_1();
    } else {
      tmp = false;
    }
    if (tmp) {
      throw new FlingCancellationException();
    }
    return this.rhc_1.th1(this.rhc_1.hgg(this.shc_1.yh7(this.rhc_1.fgg(this.rhc_1.egg(pixels)), Companion_getInstance_20().e9v_1)));
  };
  function toFloat_1($this, $receiver) {
    return $this.ugf_1.equals(Orientation_Horizontal_getInstance()) ? _Velocity___get_x__impl__qqcikv($receiver) : _Velocity___get_y__impl__239yhc($receiver);
  }
  function singleAxisVelocity($this, $receiver) {
    return $this.ugf_1.equals(Orientation_Horizontal_getInstance()) ? Velocity__copy$default_impl_eql69u($receiver, VOID, 0.0) : Velocity__copy$default_impl_eql69u($receiver, 0.0);
  }
  function update($this, $receiver, newValue) {
    return $this.ugf_1.equals(Orientation_Horizontal_getInstance()) ? Velocity__copy$default_impl_eql69u($receiver, newValue) : Velocity__copy$default_impl_eql69u($receiver, VOID, newValue);
  }
  function performScroll($this, $receiver, delta, source) {
    var consumedByPreScroll = $this.wgf_1.f9x(delta, source);
    var scrollAvailableAfterPreScroll = Offset__minus_impl_hoj2c0(delta, consumedByPreScroll);
    var singleAxisDeltaForSelfScroll = $this.hgg($this.fgg($this.xh7(scrollAvailableAfterPreScroll)));
    var consumedBySelfScroll = $this.fgg($this.egg($receiver.bh7(singleAxisDeltaForSelfScroll)));
    $this.xgf_1.lhc(consumedBySelfScroll);
    var deltaAvailableAfterScroll = Offset__minus_impl_hoj2c0(scrollAvailableAfterPreScroll, consumedBySelfScroll);
    var consumedByPostScroll = $this.wgf_1.g9x(consumedBySelfScroll, deltaAvailableAfterScroll, source);
    return Offset__plus_impl_c78cg0(Offset__plus_impl_c78cg0(consumedByPreScroll, consumedBySelfScroll), consumedByPostScroll);
  }
  function _get_shouldDispatchOverscroll__1og37n($this) {
    return $this.rgf_1.mg7() || $this.rgf_1.ng7();
  }
  function dispatchRawDelta($this, scroll) {
    return $this.egg($this.th1($this.rgf_1.rg7($this.th1($this.hgg(scroll)))));
  }
  function ScrollingLogic$nestedScrollScope$1(this$0) {
    this.thc_1 = this$0;
  }
  protoOf(ScrollingLogic$nestedScrollScope$1).ggg = function (offset, source) {
    // Inline function 'kotlin.with' call
    var $this$with = this.thc_1.bgg_1;
    return performScroll(this.thc_1, $this$with, offset, source);
  };
  protoOf(ScrollingLogic$nestedScrollScope$1).yh7 = function (offset, source) {
    this.thc_1.agg_1 = source;
    var overscroll = this.thc_1.sgf_1;
    var tmp;
    if (!(overscroll == null) && _get_shouldDispatchOverscroll__1og37n(this.thc_1)) {
      tmp = overscroll.vg5(offset, this.thc_1.agg_1, this.thc_1.dgg_1);
    } else {
      // Inline function 'kotlin.with' call
      var $this$with = this.thc_1.bgg_1;
      tmp = performScroll(this.thc_1, $this$with, offset, source);
    }
    return tmp;
  };
  function ScrollingLogic$performScrollForOverscroll$lambda(this$0) {
    return function (delta) {
      // Inline function 'kotlin.with' call
      var $this$with = this$0.bgg_1;
      var tmp$ret$0 = performScroll(this$0, $this$with, delta.e5d_1, this$0.agg_1);
      return new Offset(tmp$ret$0);
    };
  }
  function ScrollingLogic$onScrollStopped$slambda(this$0, resultContinuation) {
    this.chd_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScrollingLogic$onScrollStopped$slambda).ghd = function (velocity, $completion) {
    var tmp = this.hhd(velocity, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    var tmp_0 = tmp.v9();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  protoOf(ScrollingLogic$onScrollStopped$slambda).ja = function (p1, $completion) {
    return this.ghd(p1 instanceof Velocity_0 ? p1.t5g_1 : THROW_CCE(), $completion);
  };
  protoOf(ScrollingLogic$onScrollStopped$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            this.n9_1 = 1;
            suspendResult = this.chd_1.wgf_1.h9x(this.dhd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.n9_1 = 2;
            continue $sm;
          case 1:
            var unboxed = suspendResult.t5g_1;
            suspendResult = new Velocity_0(unboxed);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var preConsumedByParent = suspendResult.t5g_1;
            this.fhd_1 = Velocity__minus_impl_w0cg92(this.dhd_1, preConsumedByParent);
            this.n9_1 = 3;
            suspendResult = this.chd_1.ihd(this.fhd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.n9_1 = 4;
            continue $sm;
          case 3:
            var unboxed_0 = suspendResult.t5g_1;
            suspendResult = new Velocity_0(unboxed_0);
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.ehd_1 = suspendResult.t5g_1;
            this.n9_1 = 5;
            suspendResult = this.chd_1.wgf_1.i9x(Velocity__minus_impl_w0cg92(this.fhd_1, this.ehd_1), this.ehd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.n9_1 = 6;
            continue $sm;
          case 5:
            var unboxed_1 = suspendResult.t5g_1;
            suspendResult = new Velocity_0(unboxed_1);
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var consumedPost = suspendResult.t5g_1;
            var totalLeft = Velocity__minus_impl_w0cg92(this.ehd_1, consumedPost);
            return new Velocity_0(Velocity__minus_impl_w0cg92(this.dhd_1, totalLeft));
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScrollingLogic$onScrollStopped$slambda).hhd = function (velocity, completion) {
    var i = new ScrollingLogic$onScrollStopped$slambda(this.chd_1, completion);
    i.dhd_1 = velocity;
    return i;
  };
  function ScrollingLogic$onScrollStopped$slambda_0(this$0, resultContinuation) {
    var i = new ScrollingLogic$onScrollStopped$slambda(this$0, resultContinuation);
    return constructCallableReference(function (velocity, $completion) {
      return i.ghd(velocity.t5g_1, $completion);
    }, 1);
  }
  function ScrollingLogic$doFlingAnimation$slambda(this$0, $result, $available, resultContinuation) {
    this.rhd_1 = this$0;
    this.shd_1 = $result;
    this.thd_1 = $available;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScrollingLogic$doFlingAnimation$slambda).wgg = function ($this$scroll, $completion) {
    var tmp = this.xgg($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScrollingLogic$doFlingAnimation$slambda).ja = function (p1, $completion) {
    return this.wgg((!(p1 == null) ? isInterface(p1, NestedScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScrollingLogic$doFlingAnimation$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var nestedScrollScope = this.uhd_1;
            var reverseScope = new ScrollingLogic$doFlingAnimation$2$reverseScope$1(this.rhd_1, nestedScrollScope);
            var $this$with = this.rhd_1.tgf_1;
            this.vhd_1 = this.shd_1._v.t5g_1;
            this.n9_1 = 1;
            suspendResult = $this$with.whd(reverseScope, this.rhd_1.th1(toFloat_1(this.rhd_1, this.thd_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = this.rhd_1.th1(ARGUMENT);
            var ARGUMENT_1 = update(this.rhd_1, this.vhd_1, ARGUMENT_0);
            this.shd_1._v = new Velocity_0(ARGUMENT_1);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScrollingLogic$doFlingAnimation$slambda).xgg = function ($this$scroll, completion) {
    var i = new ScrollingLogic$doFlingAnimation$slambda(this.rhd_1, this.shd_1, this.thd_1, completion);
    i.uhd_1 = $this$scroll;
    return i;
  };
  function ScrollingLogic$doFlingAnimation$slambda_0(this$0, $result, $available, resultContinuation) {
    var i = new ScrollingLogic$doFlingAnimation$slambda(this$0, $result, $available, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.wgg($this$scroll, $completion);
    }, 1);
  }
  function ScrollingLogic$scroll$slambda(this$0, $block, resultContinuation) {
    this.fhe_1 = this$0;
    this.ghe_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScrollingLogic$scroll$slambda).zh6 = function ($this$scroll, $completion) {
    var tmp = this.ah7($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScrollingLogic$scroll$slambda).ja = function (p1, $completion) {
    return this.zh6((!(p1 == null) ? isInterface(p1, ScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScrollingLogic$scroll$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.fhe_1.bgg_1 = this.hhe_1;
            this.n9_1 = 1;
            suspendResult = this.ghe_1(this.fhe_1.cgg_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScrollingLogic$scroll$slambda).ah7 = function ($this$scroll, completion) {
    var i = new ScrollingLogic$scroll$slambda(this.fhe_1, this.ghe_1, completion);
    i.hhe_1 = $this$scroll;
    return i;
  };
  function ScrollingLogic$scroll$slambda_0(this$0, $block, resultContinuation) {
    var i = new ScrollingLogic$scroll$slambda(this$0, $block, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.zh6($this$scroll, $completion);
    }, 1);
  }
  function $onScrollStoppedCOROUTINE$(_this__u8e3s4, initialVelocity, isMouseWheel, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qhe_1 = _this__u8e3s4;
    this.rhe_1 = initialVelocity;
    this.she_1 = isMouseWheel;
  }
  protoOf($onScrollStoppedCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (this.she_1 && !get_shouldBeTriggeredByMouseWheel(this.qhe_1.tgf_1)) {
              return Unit_instance;
            }

            var availableVelocity = singleAxisVelocity(this.qhe_1, this.rhe_1);
            var performFling = ScrollingLogic$onScrollStopped$slambda_0(this.qhe_1, null);
            var overscroll = this.qhe_1.sgf_1;
            if (!(overscroll == null) && _get_shouldDispatchOverscroll__1og37n(this.qhe_1)) {
              this.n9_1 = 2;
              suspendResult = overscroll.wg5(availableVelocity, performFling, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = performFling(new Velocity_0(availableVelocity), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.the_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            var tmp_0 = this;
            tmp_0.the_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $doFlingAnimationCOROUTINE$(_this__u8e3s4, available, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.chf_1 = _this__u8e3s4;
    this.dhf_1 = available;
  }
  protoOf($doFlingAnimationCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.ehf_1 = {_v: new Velocity_0(this.dhf_1)};
            this.chf_1.zgf_1 = true;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            var tmp_0 = MutatePriority_Default_getInstance();
            suspendResult = this.chf_1.pgh(tmp_0, ScrollingLogic$doFlingAnimation$slambda_0(this.chf_1, this.ehf_1, this.dhf_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            this.chf_1.zgf_1 = false;
            return this.ehf_1._v;
          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            this.chf_1.zgf_1 = false;
            throw t;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ScrollingLogic(scrollableState, overscrollEffect, flingBehavior, orientation, reverseDirection, nestedScrollDispatcher, onScrollChangedDispatcher, isScrollableNodeAttached) {
    this.rgf_1 = scrollableState;
    this.sgf_1 = overscrollEffect;
    this.tgf_1 = flingBehavior;
    this.ugf_1 = orientation;
    this.vgf_1 = reverseDirection;
    this.wgf_1 = nestedScrollDispatcher;
    this.xgf_1 = onScrollChangedDispatcher;
    this.ygf_1 = isScrollableNodeAttached;
    this.zgf_1 = false;
    this.agg_1 = Companion_getInstance_20().d9v_1;
    this.bgg_1 = get_NoOpScrollScope();
    var tmp = this;
    tmp.cgg_1 = new ScrollingLogic$nestedScrollScope$1(this);
    var tmp_0 = this;
    tmp_0.dgg_1 = ScrollingLogic$performScrollForOverscroll$lambda(this);
  }
  protoOf(ScrollingLogic).fhf = function () {
    return this.zgf_1;
  };
  protoOf(ScrollingLogic).egg = function (_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === 0.0) {
      tmp = Companion_getInstance_6().g5d_1;
    } else if (this.ugf_1.equals(Orientation_Horizontal_getInstance())) {
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1 = fromInt(toRawBits(_this__u8e3s4));
      var v2 = fromInt(toRawBits(0.0));
      var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      tmp = _Offset___init__impl__c168vi(tmp$ret$1);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1_0 = fromInt(toRawBits(0.0));
      var v2_0 = fromInt(toRawBits(_this__u8e3s4));
      var tmp$ret$3 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
      tmp = _Offset___init__impl__c168vi(tmp$ret$3);
    }
    return tmp;
  };
  protoOf(ScrollingLogic).xh7 = function (_this__u8e3s4) {
    return this.ugf_1.equals(Orientation_Horizontal_getInstance()) ? Offset__copy$default_impl_bmwjg8(_this__u8e3s4, VOID, 0.0) : Offset__copy$default_impl_bmwjg8(_this__u8e3s4, 0.0);
  };
  protoOf(ScrollingLogic).hgg = function (_this__u8e3s4) {
    var tmp;
    if (this.ugf_1.equals(Orientation_Horizontal_getInstance())) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      tmp = floatFromBits(bits);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp = floatFromBits(bits_0);
    }
    return tmp;
  };
  protoOf(ScrollingLogic).uh0 = function (_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = floatFromBits(bits);
    var tmp0 = Math.abs(this_0);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_0, 32));
    // Inline function 'kotlin.math.absoluteValue' call
    var this_1 = floatFromBits(bits_0);
    // Inline function 'kotlin.math.atan2' call
    var x = Math.abs(this_1);
    var angle = Math.atan2(tmp0, x);
    var tmp;
    if (angle >= 0.7853981633974483) {
      var tmp_0;
      if (this.ugf_1.equals(Orientation_Vertical_getInstance())) {
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_1 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
        tmp_0 = floatFromBits(bits_1);
      } else {
        tmp_0 = 0.0;
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if (this.ugf_1.equals(Orientation_Horizontal_getInstance())) {
        // Inline function 'androidx.compose.ui.geometry.Offset.x' call
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value_2 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_2 = convertToInt(shiftRight(value_2, 32));
        tmp_1 = floatFromBits(bits_2);
      } else {
        tmp_1 = 0.0;
      }
      tmp = tmp_1;
    }
    return tmp;
  };
  protoOf(ScrollingLogic).wh3 = function (_this__u8e3s4) {
    return _this__u8e3s4 === 0.0 ? Companion_getInstance_24().v5g_1 : this.ugf_1.equals(Orientation_Horizontal_getInstance()) ? Velocity(_this__u8e3s4, 0.0) : Velocity(0.0, _this__u8e3s4);
  };
  protoOf(ScrollingLogic).th1 = function (_this__u8e3s4) {
    return this.vgf_1 ? _this__u8e3s4 * -1 : _this__u8e3s4;
  };
  protoOf(ScrollingLogic).fgg = function (_this__u8e3s4) {
    return this.vgf_1 ? Offset__times_impl_jz1mli(_this__u8e3s4, -1.0) : _this__u8e3s4;
  };
  protoOf(ScrollingLogic).ghf = function (scroll) {
    var tmp;
    if (this.rgf_1.sg7()) {
      tmp = Companion_getInstance_6().g5d_1;
    } else {
      tmp = dispatchRawDelta(this, scroll);
    }
    return tmp;
  };
  protoOf(ScrollingLogic).mh9 = function (initialVelocity, isMouseWheel, $completion) {
    var tmp = new $onScrollStoppedCOROUTINE$(this, initialVelocity, isMouseWheel, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScrollingLogic).ihd = function (available, $completion) {
    var tmp = new $doFlingAnimationCOROUTINE$(this, available, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    var tmp_0 = tmp.v9();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  protoOf(ScrollingLogic).mhc = function () {
    var tmp;
    if (this.rgf_1.sg7()) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = this.sgf_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xg5();
      tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ScrollingLogic).pgh = function (scrollPriority, block, $completion) {
    var tmp = this.rgf_1;
    return tmp.pg7(scrollPriority, ScrollingLogic$scroll$slambda_0(this, block, null), $completion);
  };
  protoOf(ScrollingLogic).phc = function (scrollableState, orientation, overscrollEffect, reverseDirection, flingBehavior, nestedScrollDispatcher) {
    var resetPointerInputHandling = false;
    if (!equals(this.rgf_1, scrollableState)) {
      this.rgf_1 = scrollableState;
      resetPointerInputHandling = true;
    }
    this.sgf_1 = overscrollEffect;
    if (!this.ugf_1.equals(orientation)) {
      this.ugf_1 = orientation;
      resetPointerInputHandling = true;
    }
    if (!(this.vgf_1 === reverseDirection)) {
      this.vgf_1 = reverseDirection;
      resetPointerInputHandling = true;
    }
    this.tgf_1 = flingBehavior;
    this.wgf_1 = nestedScrollDispatcher;
    return resetPointerInputHandling;
  };
  protoOf(ScrollingLogic).qhc = function () {
    return this.ugf_1.equals(Orientation_Vertical_getInstance());
  };
  function $onPostFlingCOROUTINE$(_this__u8e3s4, consumed, available, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.phf_1 = _this__u8e3s4;
    this.qhf_1 = consumed;
    this.rhf_1 = available;
  }
  protoOf($onPostFlingCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            if (this.phf_1.ohc_1) {
              if (this.phf_1.nhc_1.fhf()) {
                var tmp_0 = this;
                tmp_0.thf_1 = Companion_getInstance_24().v5g_1;
                this.n9_1 = 3;
                continue $sm;
              } else {
                this.n9_1 = 1;
                suspendResult = this.phf_1.nhc_1.ihd(this.rhf_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                this.n9_1 = 2;
                continue $sm;
              }
            } else {
              var tmp_1 = this;
              tmp_1.shf_1 = Companion_getInstance_24().v5g_1;
              this.n9_1 = 4;
              continue $sm;
            }

          case 1:
            var unboxed = suspendResult.t5g_1;
            suspendResult = new Velocity_0(unboxed);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.thf_1 = suspendResult.t5g_1;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var velocityLeft = this.thf_1;
            this.shf_1 = Velocity__minus_impl_w0cg92(this.rhf_1, velocityLeft);
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return new Velocity_0(this.shf_1);
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ScrollableNestedScrollConnection(scrollingLogic, enabled) {
    this.nhc_1 = scrollingLogic;
    this.ohc_1 = enabled;
  }
  protoOf(ScrollableNestedScrollConnection).a9v = function (consumed, available, source) {
    var tmp;
    if (this.ohc_1) {
      tmp = this.nhc_1.ghf(available);
    } else {
      tmp = Companion_getInstance_6().g5d_1;
    }
    return tmp;
  };
  protoOf(ScrollableNestedScrollConnection).c9v = function (consumed, available, $completion) {
    var tmp = new $onPostFlingCOROUTINE$(this, consumed, available, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    var tmp_0 = tmp.v9();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  function NestedScrollScope() {
  }
  function ScrollConfig() {
  }
  function semanticsScrollBy(_this__u8e3s4, offset, $completion) {
    var tmp = new $semanticsScrollByCOROUTINE$(_this__u8e3s4, offset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    var tmp_0 = tmp.v9();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  }
  function get_shouldBeTriggeredByMouseWheel(_this__u8e3s4) {
    _init_properties_Scrollable_kt__k2543d();
    return !isInterface(_this__u8e3s4, ScrollableDefaultFlingBehavior);
  }
  function FlingCancellationException() {
    PlatformOptimizedCancellationException.call(this, 'The fling animation was cancelled');
    captureStack(this, FlingCancellationException);
  }
  function DefaultFlingBehavior$performFling$slambda$lambda($lastValue, $this_performFling, $velocityLeft, this$0) {
    return function ($this$animateDecay) {
      var delta = $this$animateDecay.u1() - $lastValue._v;
      var consumed = $this_performFling.bh7(delta);
      $lastValue._v = $this$animateDecay.u1();
      $velocityLeft._v = $this$animateDecay.eec();
      var tmp;
      // Inline function 'kotlin.math.abs' call
      var x = delta - consumed;
      if (Math.abs(x) > 0.5) {
        $this$animateDecay.hea();
        tmp = Unit_instance;
      }
      var _unary__edvuaz = this$0.hhg_1;
      this$0.hhg_1 = _unary__edvuaz + 1 | 0;
      return Unit_instance;
    };
  }
  function DefaultFlingBehavior$performFling$slambda($initialVelocity, this$0, $this_performFling, resultContinuation) {
    this.qhg_1 = $initialVelocity;
    this.rhg_1 = this$0;
    this.shg_1 = $this_performFling;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultFlingBehavior$performFling$slambda).xhg = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultFlingBehavior$performFling$slambda).ja = function (p1, $completion) {
    return this.xhg((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultFlingBehavior$performFling$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var x = this.qhg_1;
            if (Math.abs(x) > 1.0) {
              this.vhg_1 = {_v: this.qhg_1};
              var lastValue = {_v: 0.0};
              this.whg_1 = AnimationState(0.0, this.qhg_1);
              this.o9_1 = 2;
              this.n9_1 = 1;
              var tmp_0 = this.rhg_1.fhg_1;
              suspendResult = animateDecay(this.whg_1, tmp_0, VOID, DefaultFlingBehavior$performFling$slambda$lambda(lastValue, this.shg_1, this.vhg_1, this.rhg_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.uhg_1 = this.qhg_1;
              this.n9_1 = 4;
              continue $sm;
            }

          case 1:
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 5;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof CancellationException) {
              var exception = this.q9_1;
              this.vhg_1._v = this.whg_1.eec();
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 5;
            this.uhg_1 = this.vhg_1._v;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return this.uhg_1;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultFlingBehavior$performFling$slambda).q24 = function ($this$withContext, completion) {
    var i = new DefaultFlingBehavior$performFling$slambda(this.qhg_1, this.rhg_1, this.shg_1, completion);
    i.thg_1 = $this$withContext;
    return i;
  };
  function DefaultFlingBehavior$performFling$slambda_0($initialVelocity, this$0, $this_performFling, resultContinuation) {
    var i = new DefaultFlingBehavior$performFling$slambda($initialVelocity, this$0, $this_performFling, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.xhg($this$withContext, $completion);
    }, 1);
  }
  function DefaultFlingBehavior(flingDecay, motionDurationScale) {
    motionDurationScale = motionDurationScale === VOID ? get_DefaultScrollMotionDurationScale() : motionDurationScale;
    this.fhg_1 = flingDecay;
    this.ghg_1 = motionDurationScale;
    this.hhg_1 = 0;
  }
  protoOf(DefaultFlingBehavior).whd = function (_this__u8e3s4, initialVelocity, $completion) {
    this.hhg_1 = 0;
    return withContext(this.ghg_1, DefaultFlingBehavior$performFling$slambda_0(initialVelocity, this, _this__u8e3s4, null), $completion);
  };
  protoOf(DefaultFlingBehavior).zh3 = function (density) {
    this.fhg_1 = splineBasedDecay(density);
  };
  function CanDragCalculation$lambda(type) {
    _init_properties_Scrollable_kt__k2543d();
    return !equals(type, new PointerType(Companion_getInstance_23().na2_1));
  }
  function NoOpScrollScope$1() {
  }
  protoOf(NoOpScrollScope$1).bh7 = function (pixels) {
    return pixels;
  };
  function DefaultScrollMotionDurationScale$1() {
  }
  protoOf(DefaultScrollMotionDurationScale$1).r8w = function () {
    return 1.0;
  };
  function UnityDensity$1() {
  }
  protoOf(UnityDensity$1).u5e = function () {
    return 1.0;
  };
  protoOf(UnityDensity$1).j5f = function () {
    return 1.0;
  };
  function semanticsScrollBy$slambda$lambda($previousValue, $this_semanticsScrollBy, $this_scroll) {
    return function (currentValue, _unused_var__etf5q3) {
      var delta = currentValue - $previousValue._v;
      var consumed = $this_semanticsScrollBy.th1($this_semanticsScrollBy.hgg($this_scroll.ggg($this_semanticsScrollBy.egg($this_semanticsScrollBy.th1(delta)), Companion_getInstance_20().d9v_1)));
      $previousValue._v = $previousValue._v + consumed;
      return Unit_instance;
    };
  }
  function semanticsScrollBy$slambda($this_semanticsScrollBy, $offset, $previousValue, resultContinuation) {
    this.ghh_1 = $this_semanticsScrollBy;
    this.hhh_1 = $offset;
    this.ihh_1 = $previousValue;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(semanticsScrollBy$slambda).wgg = function ($this$scroll, $completion) {
    var tmp = this.xgg($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(semanticsScrollBy$slambda).ja = function (p1, $completion) {
    return this.wgg((!(p1 == null) ? isInterface(p1, NestedScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(semanticsScrollBy$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.ghh_1.hgg(this.hhh_1);
            suspendResult = animate(0.0, tmp_0, VOID, VOID, semanticsScrollBy$slambda$lambda(this.ihh_1, this.ghh_1, this.jhh_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(semanticsScrollBy$slambda).xgg = function ($this$scroll, completion) {
    var i = new semanticsScrollBy$slambda(this.ghh_1, this.hhh_1, this.ihh_1, completion);
    i.jhh_1 = $this$scroll;
    return i;
  };
  function semanticsScrollBy$slambda_0($this_semanticsScrollBy, $offset, $previousValue, resultContinuation) {
    var i = new semanticsScrollBy$slambda($this_semanticsScrollBy, $offset, $previousValue, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.wgg($this$scroll, $completion);
    }, 1);
  }
  function $semanticsScrollByCOROUTINE$(_this__u8e3s4, offset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.chg_1 = _this__u8e3s4;
    this.dhg_1 = offset;
  }
  protoOf($semanticsScrollByCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.ehg_1 = {_v: 0.0};
            this.n9_1 = 1;
            var tmp_0 = MutatePriority_Default_getInstance();
            suspendResult = this.chg_1.pgh(tmp_0, semanticsScrollBy$slambda_0(this.chg_1, this.dhg_1, this.ehg_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return new Offset(this.chg_1.egg(this.ehg_1._v));
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_Scrollable_kt_7d5rzr;
  function _init_properties_Scrollable_kt__k2543d() {
    if (!properties_initialized_Scrollable_kt_7d5rzr) {
      properties_initialized_Scrollable_kt_7d5rzr = true;
      CanDragCalculation = CanDragCalculation$lambda;
      NoOpScrollScope = new NoOpScrollScope$1();
      DefaultScrollMotionDurationScale = new DefaultScrollMotionDurationScale$1();
      UnityDensity = new UnityDensity$1();
      androidx_compose_foundation_gestures_ScrollableNode$stable = 8;
      androidx_compose_foundation_gestures_ScrollableDefaults_NoOpOverscrollEffect$stable = 0;
      androidx_compose_foundation_gestures_ScrollableDefaults$stable = 0;
      androidx_compose_foundation_gestures_ScrollingLogic$stable = 8;
      androidx_compose_foundation_gestures_ScrollableNestedScrollConnection$stable = 8;
      androidx_compose_foundation_gestures_DefaultFlingBehavior$stable = 0;
      androidx_compose_foundation_gestures_ScrollableContainerNode$stable = 8;
      androidx_compose_foundation_gestures_FlingCancellationException$stable = 8;
    }
  }
  function ScrollScope() {
  }
  function ScrollableState() {
  }
  function ScrollableState_0(consumeScrollDelta) {
    return new DefaultScrollableState(consumeScrollDelta);
  }
  function DefaultScrollableState$scroll$slambda$slambda(this$0, $block, resultContinuation) {
    this.shh_1 = this$0;
    this.thh_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultScrollableState$scroll$slambda$slambda).zh6 = function ($this$mutateWith, $completion) {
    var tmp = this.ah7($this$mutateWith, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultScrollableState$scroll$slambda$slambda).ja = function (p1, $completion) {
    return this.zh6((!(p1 == null) ? isInterface(p1, ScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultScrollableState$scroll$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.shh_1.yhh_1.s21(true);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            suspendResult = this.thh_1(this.uhh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            this.shh_1.yhh_1.s21(false);
            return Unit_instance;
          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            this.shh_1.yhh_1.s21(false);
            throw t;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultScrollableState$scroll$slambda$slambda).ah7 = function ($this$mutateWith, completion) {
    var i = new DefaultScrollableState$scroll$slambda$slambda(this.shh_1, this.thh_1, completion);
    i.uhh_1 = $this$mutateWith;
    return i;
  };
  function DefaultScrollableState$scroll$slambda$slambda_0(this$0, $block, resultContinuation) {
    var i = new DefaultScrollableState$scroll$slambda$slambda(this$0, $block, resultContinuation);
    return constructCallableReference(function ($this$mutateWith, $completion) {
      return i.zh6($this$mutateWith, $completion);
    }, 1);
  }
  function DefaultScrollableState$scrollScope$1(this$0) {
    this.bhi_1 = this$0;
  }
  protoOf(DefaultScrollableState$scrollScope$1).bh7 = function (pixels) {
    if (isNaN_0(pixels))
      return 0.0;
    var delta = this.bhi_1.vhh_1(pixels);
    this.bhi_1.zhh_1.s21(delta > 0);
    this.bhi_1.ahi_1.s21(delta < 0);
    return delta;
  };
  function DefaultScrollableState$scroll$slambda(this$0, $scrollPriority, $block, resultContinuation) {
    this.khi_1 = this$0;
    this.lhi_1 = $scrollPriority;
    this.mhi_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultScrollableState$scroll$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultScrollableState$scroll$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultScrollableState$scroll$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.khi_1.xhh_1.ug5(this.khi_1.whh_1, this.lhi_1, DefaultScrollableState$scroll$slambda$slambda_0(this.khi_1, this.mhi_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultScrollableState$scroll$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new DefaultScrollableState$scroll$slambda(this.khi_1, this.lhi_1, this.mhi_1, completion);
    i.nhi_1 = $this$coroutineScope;
    return i;
  };
  function DefaultScrollableState$scroll$slambda_0(this$0, $scrollPriority, $block, resultContinuation) {
    var i = new DefaultScrollableState$scroll$slambda(this$0, $scrollPriority, $block, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function DefaultScrollableState(onDelta) {
    this.vhh_1 = onDelta;
    var tmp = this;
    tmp.whh_1 = new DefaultScrollableState$scrollScope$1(this);
    this.xhh_1 = new MutatorMutex();
    this.yhh_1 = mutableStateOf(false);
    this.zhh_1 = mutableStateOf(false);
    this.ahi_1 = mutableStateOf(false);
  }
  protoOf(DefaultScrollableState).pg7 = function (scrollPriority, block, $completion) {
    return coroutineScope(DefaultScrollableState$scroll$slambda_0(this, scrollPriority, block, null), $completion);
  };
  protoOf(DefaultScrollableState).rg7 = function (delta) {
    return this.vhh_1(delta);
  };
  protoOf(DefaultScrollableState).sg7 = function () {
    return this.yhh_1.u1();
  };
  function rememberScrollableState(consumeScrollDelta, $composer, $changed) {
    var $composer_0 = $composer;
    var lambdaState = rememberUpdatedState(consumeScrollDelta, $composer_0, 14 & $changed);
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance_11().f30_1) {
      var value = ScrollableState_0(rememberScrollableState$lambda(lambdaState));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function rememberScrollableState$lambda($lambdaState) {
    return function (it) {
      return $lambdaState.u1()(it);
    };
  }
  function get_NoPressGesture() {
    _init_properties_TapGestureDetector_kt__k4yygc();
    return NoPressGesture;
  }
  var NoPressGesture;
  var androidx_compose_foundation_gestures_LongPressResult_Success$stable;
  var androidx_compose_foundation_gestures_LongPressResult_Released$stable;
  var androidx_compose_foundation_gestures_LongPressResult_Canceled$stable;
  var androidx_compose_foundation_gestures_LongPressResult$stable;
  var androidx_compose_foundation_gestures_PressGestureScopeImpl$stable;
  function detectTapGestures(_this__u8e3s4, onDoubleTap, onLongPress, onPress, onTap, $completion) {
    onDoubleTap = onDoubleTap === VOID ? null : onDoubleTap;
    onLongPress = onLongPress === VOID ? null : onLongPress;
    onPress = onPress === VOID ? get_NoPressGesture() : onPress;
    onTap = onTap === VOID ? null : onTap;
    return coroutineScope(detectTapGestures$slambda_0(_this__u8e3s4, onDoubleTap, onLongPress, onPress, onTap, null), $completion);
  }
  function isChangedToDown(_this__u8e3s4, requireUnconsumed) {
    _init_properties_TapGestureDetector_kt__k4yygc();
    var tmp;
    if (firstDownRefersToPrimaryMouseButtonOnly()) {
      var tmp0 = _this__u8e3s4.ca0_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastAll' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = tmp0.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = tmp0.l1(index);
            if (!(item.qa0_1 === Companion_getInstance_23().na2_1)) {
              tmp$ret$0 = false;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$0 = true;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    var onlyPrimaryButtonCausesDown = tmp;
    if (onlyPrimaryButtonCausesDown && !get_isPrimaryPressed(_this__u8e3s4.da0_1))
      return false;
    var tmp0_0 = _this__u8e3s4.ca0_1;
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.util.fastAll' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_0 = tmp0_0.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = tmp0_0.l1(index_0);
          if (!(requireUnconsumed ? changedToDown(item_0) : changedToDownIgnoreConsumed(item_0))) {
            tmp$ret$4 = false;
            break $l$block_0;
          }
        }
         while (inductionVariable_0 <= last_0);
      tmp$ret$4 = true;
    }
    return tmp$ret$4;
  }
  function PressGestureScope() {
  }
  function $resetCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.whi_1 = _this__u8e3s4;
  }
  protoOf($resetCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.whi_1.ahj_1.p2u(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.whi_1.yhi_1 = false;
            this.whi_1.zhi_1 = false;
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $tryAwaitReleaseCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jhj_1 = _this__u8e3s4;
  }
  protoOf($tryAwaitReleaseCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (!this.jhj_1.yhi_1 && !this.jhj_1.zhi_1) {
              this.n9_1 = 1;
              suspendResult = this.jhj_1.ahj_1.p2u(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.jhj_1.ahj_1.r2u();
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return this.jhj_1.yhi_1;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function PressGestureScopeImpl(density) {
    this.xhi_1 = density;
    this.yhi_1 = false;
    this.zhi_1 = false;
    this.ahj_1 = Mutex(false);
  }
  protoOf(PressGestureScopeImpl).e2z = function () {
    this.zhi_1 = true;
    if (this.ahj_1.l2u()) {
      this.ahj_1.r2u();
    }
  };
  protoOf(PressGestureScopeImpl).r2v = function () {
    this.yhi_1 = true;
    if (this.ahj_1.l2u()) {
      this.ahj_1.r2u();
    }
  };
  protoOf(PressGestureScopeImpl).khj = function ($completion) {
    var tmp = new $resetCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(PressGestureScopeImpl).jfp = function ($completion) {
    var tmp = new $tryAwaitReleaseCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(PressGestureScopeImpl).v5e = function (_this__u8e3s4) {
    return this.xhi_1.v5e(_this__u8e3s4);
  };
  protoOf(PressGestureScopeImpl).x5e = function (_this__u8e3s4) {
    return this.xhi_1.x5e(_this__u8e3s4);
  };
  protoOf(PressGestureScopeImpl).w5e = function (_this__u8e3s4) {
    return this.xhi_1.w5e(_this__u8e3s4);
  };
  protoOf(PressGestureScopeImpl).c5f = function (_this__u8e3s4) {
    return this.xhi_1.c5f(_this__u8e3s4);
  };
  protoOf(PressGestureScopeImpl).d5f = function (_this__u8e3s4) {
    return this.xhi_1.d5f(_this__u8e3s4);
  };
  protoOf(PressGestureScopeImpl).e5f = function (_this__u8e3s4) {
    return this.xhi_1.e5f(_this__u8e3s4);
  };
  protoOf(PressGestureScopeImpl).b5f = function (_this__u8e3s4) {
    return this.xhi_1.b5f(_this__u8e3s4);
  };
  protoOf(PressGestureScopeImpl).f5f = function (_this__u8e3s4) {
    return this.xhi_1.f5f(_this__u8e3s4);
  };
  protoOf(PressGestureScopeImpl).g5f = function (_this__u8e3s4) {
    return this.xhi_1.g5f(_this__u8e3s4);
  };
  protoOf(PressGestureScopeImpl).u5e = function () {
    return this.xhi_1.u5e();
  };
  protoOf(PressGestureScopeImpl).j5f = function () {
    return this.xhi_1.j5f();
  };
  function processTapGesture(_this__u8e3s4, scope, pressScope, onDoubleTap, onLongPress, onPress, onTap, $completion) {
    var tmp = new $processTapGestureCOROUTINE$(_this__u8e3s4, scope, pressScope, onDoubleTap, onLongPress, onPress, onTap, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function awaitFirstDown(_this__u8e3s4, requireUnconsumed, pass, $completion) {
    requireUnconsumed = requireUnconsumed === VOID ? true : requireUnconsumed;
    pass = pass === VOID ? PointerEventPass_Main_getInstance() : pass;
    var tmp = new $awaitFirstDownCOROUTINE$(_this__u8e3s4, requireUnconsumed, pass, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function launchAwaitingReset(_this__u8e3s4, resetJob, start, block) {
    start = start === VOID ? CoroutineStart_UNDISPATCHED_getInstance() : start;
    _init_properties_TapGestureDetector_kt__k4yygc();
    return launch(_this__u8e3s4, VOID, start, launchAwaitingReset$slambda_0(resetJob, block, null));
  }
  function waitForUpOrCancellation(_this__u8e3s4, pass, $completion) {
    pass = pass === VOID ? PointerEventPass_Main_getInstance() : pass;
    var tmp = new $waitForUpOrCancellationCOROUTINE$(_this__u8e3s4, pass, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function Success() {
    Success_instance = this;
    LongPressResult.call(this);
  }
  var Success_instance;
  function Success_getInstance() {
    if (Success_instance == null)
      new Success();
    return Success_instance;
  }
  function Released(finalUpChange) {
    LongPressResult.call(this);
    this.ghl_1 = finalUpChange;
  }
  function Canceled() {
    Canceled_instance = this;
    LongPressResult.call(this);
  }
  var Canceled_instance;
  function Canceled_getInstance() {
    if (Canceled_instance == null)
      new Canceled();
    return Canceled_instance;
  }
  function LongPressResult() {
  }
  function waitForLongPress(_this__u8e3s4, pass, $completion) {
    pass = pass === VOID ? PointerEventPass_Main_getInstance() : pass;
    var tmp = new $waitForLongPressCOROUTINE$(_this__u8e3s4, pass, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function consumeUntilUp(_this__u8e3s4, $completion) {
    var tmp = new $consumeUntilUpCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function awaitSecondDown(_this__u8e3s4, firstUp, $completion) {
    var tmp = _this__u8e3s4.la7().sb9();
    return _this__u8e3s4.ra7(tmp, awaitSecondDown$slambda_0(firstUp, null), $completion);
  }
  function detectTapAndPress(_this__u8e3s4, onPress, onTap, $completion) {
    onPress = onPress === VOID ? get_NoPressGesture() : onPress;
    onTap = onTap === VOID ? null : onTap;
    var pressScope = new PressGestureScopeImpl(_this__u8e3s4);
    return coroutineScope(detectTapAndPress$slambda_0(_this__u8e3s4, onPress, onTap, pressScope, null), $completion);
  }
  function NoPressGesture$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NoPressGesture$slambda).bfu = function (_this__u8e3s4, it, $completion) {
    var tmp = this.cfu(_this__u8e3s4, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NoPressGesture$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, PressGestureScope) : false) ? p1 : THROW_CCE();
    return this.bfu(tmp, p2 instanceof Offset ? p2.e5d_1 : THROW_CCE(), $completion);
  };
  protoOf(NoPressGesture$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(NoPressGesture$slambda).cfu = function (_this__u8e3s4, it, completion) {
    var i = new NoPressGesture$slambda(completion);
    i.jhm_1 = _this__u8e3s4;
    i.khm_1 = it;
    return i;
  };
  function NoPressGesture$slambda_0(resultContinuation) {
    var i = new NoPressGesture$slambda(resultContinuation);
    return constructCallableReference(function (_this__u8e3s4, it, $completion) {
      return i.bfu(_this__u8e3s4, it.e5d_1, $completion);
    }, 2);
  }
  function detectTapGestures$slambda$slambda($this_coroutineScope, $pressScope, $onDoubleTap, $onLongPress, $onPress, $onTap, resultContinuation) {
    this.thm_1 = $this_coroutineScope;
    this.uhm_1 = $pressScope;
    this.vhm_1 = $onDoubleTap;
    this.whm_1 = $onLongPress;
    this.xhm_1 = $onPress;
    this.yhm_1 = $onTap;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectTapGestures$slambda$slambda).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectTapGestures$slambda$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectTapGestures$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = processTapGesture(this.zhm_1, this.thm_1, this.uhm_1, this.vhm_1, this.whm_1, this.xhm_1, this.yhm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(detectTapGestures$slambda$slambda).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new detectTapGestures$slambda$slambda(this.thm_1, this.uhm_1, this.vhm_1, this.whm_1, this.xhm_1, this.yhm_1, completion);
    i.zhm_1 = $this$awaitEachGesture;
    return i;
  };
  function detectTapGestures$slambda$slambda_0($this_coroutineScope, $pressScope, $onDoubleTap, $onLongPress, $onPress, $onTap, resultContinuation) {
    var i = new detectTapGestures$slambda$slambda($this_coroutineScope, $pressScope, $onDoubleTap, $onLongPress, $onPress, $onTap, resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  function detectTapGestures$slambda($this_detectTapGestures, $onDoubleTap, $onLongPress, $onPress, $onTap, resultContinuation) {
    this.ihn_1 = $this_detectTapGestures;
    this.jhn_1 = $onDoubleTap;
    this.khn_1 = $onLongPress;
    this.lhn_1 = $onPress;
    this.mhn_1 = $onTap;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectTapGestures$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectTapGestures$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectTapGestures$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var pressScope = new PressGestureScopeImpl(this.ihn_1);
            this.n9_1 = 1;
            suspendResult = awaitEachGesture(this.ihn_1, detectTapGestures$slambda$slambda_0(this.nhn_1, pressScope, this.jhn_1, this.khn_1, this.lhn_1, this.mhn_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(detectTapGestures$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new detectTapGestures$slambda(this.ihn_1, this.jhn_1, this.khn_1, this.lhn_1, this.mhn_1, completion);
    i.nhn_1 = $this$coroutineScope;
    return i;
  };
  function detectTapGestures$slambda_0($this_detectTapGestures, $onDoubleTap, $onLongPress, $onPress, $onTap, resultContinuation) {
    var i = new detectTapGestures$slambda($this_detectTapGestures, $onDoubleTap, $onLongPress, $onPress, $onTap, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function processTapGesture$slambda($pressScope, resultContinuation) {
    this.whn_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(processTapGesture$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(processTapGesture$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(processTapGesture$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.whn_1.khj(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(processTapGesture$slambda).q24 = function ($this$launch, completion) {
    var i = new processTapGesture$slambda(this.whn_1, completion);
    i.xhn_1 = $this$launch;
    return i;
  };
  function processTapGesture$slambda_0($pressScope, resultContinuation) {
    var i = new processTapGesture$slambda($pressScope, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function processTapGesture$slambda_1($onPress, $pressScope, $down, resultContinuation) {
    this.gho_1 = $onPress;
    this.hho_1 = $pressScope;
    this.iho_1 = $down;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(processTapGesture$slambda_1).p24 = function ($this$launchAwaitingReset, $completion) {
    var tmp = this.q24($this$launchAwaitingReset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(processTapGesture$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(processTapGesture$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.gho_1(this.hho_1, new Offset(this.iho_1.ka0_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(processTapGesture$slambda_1).q24 = function ($this$launchAwaitingReset, completion) {
    var i = new processTapGesture$slambda_1(this.gho_1, this.hho_1, this.iho_1, completion);
    i.jho_1 = $this$launchAwaitingReset;
    return i;
  };
  function processTapGesture$slambda_2($onPress, $pressScope, $down, resultContinuation) {
    var i = new processTapGesture$slambda_1($onPress, $pressScope, $down, resultContinuation);
    return constructCallableReference(function ($this$launchAwaitingReset, $completion) {
      return i.p24($this$launchAwaitingReset, $completion);
    }, 1);
  }
  function processTapGesture$slambda_3($pressScope, resultContinuation) {
    this.sho_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(processTapGesture$slambda_3).p24 = function ($this$launchAwaitingReset, $completion) {
    var tmp = this.q24($this$launchAwaitingReset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(processTapGesture$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(processTapGesture$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.sho_1.r2v();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(processTapGesture$slambda_3).q24 = function ($this$launchAwaitingReset, completion) {
    var i = new processTapGesture$slambda_3(this.sho_1, completion);
    i.tho_1 = $this$launchAwaitingReset;
    return i;
  };
  function processTapGesture$slambda_4($pressScope, resultContinuation) {
    var i = new processTapGesture$slambda_3($pressScope, resultContinuation);
    return constructCallableReference(function ($this$launchAwaitingReset, $completion) {
      return i.p24($this$launchAwaitingReset, $completion);
    }, 1);
  }
  function processTapGesture$slambda_5($pressScope, resultContinuation) {
    this.chp_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(processTapGesture$slambda_5).p24 = function ($this$launchAwaitingReset, $completion) {
    var tmp = this.q24($this$launchAwaitingReset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(processTapGesture$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(processTapGesture$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.chp_1.e2z();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(processTapGesture$slambda_5).q24 = function ($this$launchAwaitingReset, completion) {
    var i = new processTapGesture$slambda_5(this.chp_1, completion);
    i.dhp_1 = $this$launchAwaitingReset;
    return i;
  };
  function processTapGesture$slambda_6($pressScope, resultContinuation) {
    var i = new processTapGesture$slambda_5($pressScope, resultContinuation);
    return constructCallableReference(function ($this$launchAwaitingReset, $completion) {
      return i.p24($this$launchAwaitingReset, $completion);
    }, 1);
  }
  function processTapGesture$slambda_7($pressScope, resultContinuation) {
    this.mhp_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(processTapGesture$slambda_7).p24 = function ($this$launchAwaitingReset, $completion) {
    var tmp = this.q24($this$launchAwaitingReset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(processTapGesture$slambda_7).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(processTapGesture$slambda_7).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.mhp_1.r2v();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(processTapGesture$slambda_7).q24 = function ($this$launchAwaitingReset, completion) {
    var i = new processTapGesture$slambda_7(this.mhp_1, completion);
    i.nhp_1 = $this$launchAwaitingReset;
    return i;
  };
  function processTapGesture$slambda_8($pressScope, resultContinuation) {
    var i = new processTapGesture$slambda_7($pressScope, resultContinuation);
    return constructCallableReference(function ($this$launchAwaitingReset, $completion) {
      return i.p24($this$launchAwaitingReset, $completion);
    }, 1);
  }
  function processTapGesture$slambda_9($cancelOrReleaseJob, $pressScope, resultContinuation) {
    this.whp_1 = $cancelOrReleaseJob;
    this.xhp_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(processTapGesture$slambda_9).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(processTapGesture$slambda_9).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(processTapGesture$slambda_9).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.whp_1.x1a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.xhp_1.khj(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(processTapGesture$slambda_9).q24 = function ($this$launch, completion) {
    var i = new processTapGesture$slambda_9(this.whp_1, this.xhp_1, completion);
    i.yhp_1 = $this$launch;
    return i;
  };
  function processTapGesture$slambda_10($cancelOrReleaseJob, $pressScope, resultContinuation) {
    var i = new processTapGesture$slambda_9($cancelOrReleaseJob, $pressScope, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function processTapGesture$slambda_11($onPress, $pressScope, $secondDown, resultContinuation) {
    this.hhq_1 = $onPress;
    this.ihq_1 = $pressScope;
    this.jhq_1 = $secondDown;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(processTapGesture$slambda_11).p24 = function ($this$launchAwaitingReset, $completion) {
    var tmp = this.q24($this$launchAwaitingReset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(processTapGesture$slambda_11).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(processTapGesture$slambda_11).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.hhq_1(this.ihq_1, new Offset(this.jhq_1.ka0_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(processTapGesture$slambda_11).q24 = function ($this$launchAwaitingReset, completion) {
    var i = new processTapGesture$slambda_11(this.hhq_1, this.ihq_1, this.jhq_1, completion);
    i.khq_1 = $this$launchAwaitingReset;
    return i;
  };
  function processTapGesture$slambda_12($onPress, $pressScope, $secondDown, resultContinuation) {
    var i = new processTapGesture$slambda_11($onPress, $pressScope, $secondDown, resultContinuation);
    return constructCallableReference(function ($this$launchAwaitingReset, $completion) {
      return i.p24($this$launchAwaitingReset, $completion);
    }, 1);
  }
  function processTapGesture$slambda_13($pressScope, resultContinuation) {
    this.thq_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(processTapGesture$slambda_13).p24 = function ($this$launchAwaitingReset, $completion) {
    var tmp = this.q24($this$launchAwaitingReset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(processTapGesture$slambda_13).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(processTapGesture$slambda_13).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.thq_1.r2v();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(processTapGesture$slambda_13).q24 = function ($this$launchAwaitingReset, completion) {
    var i = new processTapGesture$slambda_13(this.thq_1, completion);
    i.uhq_1 = $this$launchAwaitingReset;
    return i;
  };
  function processTapGesture$slambda_14($pressScope, resultContinuation) {
    var i = new processTapGesture$slambda_13($pressScope, resultContinuation);
    return constructCallableReference(function ($this$launchAwaitingReset, $completion) {
      return i.p24($this$launchAwaitingReset, $completion);
    }, 1);
  }
  function processTapGesture$slambda_15($pressScope, resultContinuation) {
    this.dhr_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(processTapGesture$slambda_15).p24 = function ($this$launchAwaitingReset, $completion) {
    var tmp = this.q24($this$launchAwaitingReset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(processTapGesture$slambda_15).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(processTapGesture$slambda_15).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.dhr_1.r2v();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(processTapGesture$slambda_15).q24 = function ($this$launchAwaitingReset, completion) {
    var i = new processTapGesture$slambda_15(this.dhr_1, completion);
    i.ehr_1 = $this$launchAwaitingReset;
    return i;
  };
  function processTapGesture$slambda_16($pressScope, resultContinuation) {
    var i = new processTapGesture$slambda_15($pressScope, resultContinuation);
    return constructCallableReference(function ($this$launchAwaitingReset, $completion) {
      return i.p24($this$launchAwaitingReset, $completion);
    }, 1);
  }
  function processTapGesture$slambda_17($pressScope, resultContinuation) {
    this.nhr_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(processTapGesture$slambda_17).p24 = function ($this$launchAwaitingReset, $completion) {
    var tmp = this.q24($this$launchAwaitingReset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(processTapGesture$slambda_17).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(processTapGesture$slambda_17).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.nhr_1.e2z();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(processTapGesture$slambda_17).q24 = function ($this$launchAwaitingReset, completion) {
    var i = new processTapGesture$slambda_17(this.nhr_1, completion);
    i.ohr_1 = $this$launchAwaitingReset;
    return i;
  };
  function processTapGesture$slambda_18($pressScope, resultContinuation) {
    var i = new processTapGesture$slambda_17($pressScope, resultContinuation);
    return constructCallableReference(function ($this$launchAwaitingReset, $completion) {
      return i.p24($this$launchAwaitingReset, $completion);
    }, 1);
  }
  function launchAwaitingReset$slambda($resetJob, $block, resultContinuation) {
    this.xhr_1 = $resetJob;
    this.yhr_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchAwaitingReset$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(launchAwaitingReset$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchAwaitingReset$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.xhr_1.x1a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.yhr_1(this.zhr_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(launchAwaitingReset$slambda).q24 = function ($this$launch, completion) {
    var i = new launchAwaitingReset$slambda(this.xhr_1, this.yhr_1, completion);
    i.zhr_1 = $this$launch;
    return i;
  };
  function launchAwaitingReset$slambda_0($resetJob, $block, resultContinuation) {
    var i = new launchAwaitingReset$slambda($resetJob, $block, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function waitForLongPress$slambda($pass, $result, resultContinuation) {
    this.ihs_1 = $pass;
    this.jhs_1 = $result;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(waitForLongPress$slambda).ic6 = function ($this$withTimeout, $completion) {
    var tmp = this.jc6($this$withTimeout, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(waitForLongPress$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(waitForLongPress$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 9;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = this.khs_1.pa7(this.ihs_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.lhs_1 = suspendResult;
            var tmp0 = this.lhs_1.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (!changedToUp(item)) {
                    tmp$ret$0 = false;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$0 = true;
            }
             while (false);
            if (tmp$ret$0) {
              this.jhs_1._v = new Released(this.lhs_1.ca0_1.l1(0));
              this.n9_1 = 9;
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            if (get_isDeepPress(this.lhs_1)) {
              this.jhs_1._v = Success_getInstance();
              this.n9_1 = 9;
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            var tmp0_0 = this.lhs_1.ca0_1;
            var tmp$ret$2;
            l$ret$3: do {
              var inductionVariable_0 = 0;
              var last_0 = tmp0_0.n1() - 1 | 0;
              if (inductionVariable_0 <= last_0)
                do {
                  var index_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var item_0 = tmp0_0.l1(index_0);
                  if (item_0.qa2() || isOutOfBounds(item_0, this.khs_1.q95(), this.khs_1.na7())) {
                    tmp$ret$2 = true;
                    break l$ret$3;
                  }
                }
                 while (inductionVariable_0 <= last_0);
              tmp$ret$2 = false;
            }
             while (false);
            if (tmp$ret$2) {
              this.jhs_1._v = Canceled_getInstance();
              this.n9_1 = 9;
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 5:
            this.n9_1 = 6;
            suspendResult = this.khs_1.pa7(PointerEventPass_Final_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var consumeCheck = suspendResult;
            var tmp0_1 = consumeCheck.ca0_1;
            var tmp$ret$4;
            l$ret$5: do {
              var inductionVariable_1 = 0;
              var last_1 = tmp0_1.n1() - 1 | 0;
              if (inductionVariable_1 <= last_1)
                do {
                  var index_1 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  var item_1 = tmp0_1.l1(index_1);
                  if (item_1.qa2()) {
                    tmp$ret$4 = true;
                    break l$ret$5;
                  }
                }
                 while (inductionVariable_1 <= last_1);
              tmp$ret$4 = false;
            }
             while (false);
            if (tmp$ret$4) {
              this.jhs_1._v = Canceled_getInstance();
              this.n9_1 = 9;
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 7:
            this.n9_1 = 1;
            continue $sm;
          case 8:
            throw this.q9_1;
          case 9:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(waitForLongPress$slambda).jc6 = function ($this$withTimeout, completion) {
    var i = new waitForLongPress$slambda(this.ihs_1, this.jhs_1, completion);
    i.khs_1 = $this$withTimeout;
    return i;
  };
  function waitForLongPress$slambda_0($pass, $result, resultContinuation) {
    var i = new waitForLongPress$slambda($pass, $result, resultContinuation);
    return constructCallableReference(function ($this$withTimeout, $completion) {
      return i.ic6($this$withTimeout, $completion);
    }, 1);
  }
  function awaitSecondDown$slambda($firstUp, resultContinuation) {
    this.uhs_1 = $firstUp;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(awaitSecondDown$slambda).yhs = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.jc6($this$withTimeoutOrNull, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(awaitSecondDown$slambda).ja = function (p1, $completion) {
    return this.yhs((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(awaitSecondDown$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.xhs_1 = add(this.uhs_1.ja0_1, this.vhs_1.la7().tb9());
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = awaitFirstDown(this.vhs_1, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.whs_1 = suspendResult;
            if (compare(this.whs_1.ja0_1, this.xhs_1) < 0) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 3;
            continue $sm;
          case 3:
            return this.whs_1;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(awaitSecondDown$slambda).jc6 = function ($this$withTimeoutOrNull, completion) {
    var i = new awaitSecondDown$slambda(this.uhs_1, completion);
    i.vhs_1 = $this$withTimeoutOrNull;
    return i;
  };
  function awaitSecondDown$slambda_0($firstUp, resultContinuation) {
    var i = new awaitSecondDown$slambda($firstUp, resultContinuation);
    return constructCallableReference(function ($this$withTimeoutOrNull, $completion) {
      return i.yhs($this$withTimeoutOrNull, $completion);
    }, 1);
  }
  function detectTapAndPress$slambda$slambda$slambda($pressScope, resultContinuation) {
    this.hht_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectTapAndPress$slambda$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.hht_1.khj(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new detectTapAndPress$slambda$slambda$slambda(this.hht_1, completion);
    i.iht_1 = $this$launch;
    return i;
  };
  function detectTapAndPress$slambda$slambda$slambda_0($pressScope, resultContinuation) {
    var i = new detectTapAndPress$slambda$slambda$slambda($pressScope, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function detectTapAndPress$slambda$slambda$slambda_1($onPress, $pressScope, $down, resultContinuation) {
    this.rht_1 = $onPress;
    this.sht_1 = $pressScope;
    this.tht_1 = $down;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectTapAndPress$slambda$slambda$slambda_1).p24 = function ($this$launchAwaitingReset, $completion) {
    var tmp = this.q24($this$launchAwaitingReset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.rht_1(this.sht_1, new Offset(this.tht_1.ka0_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda_1).q24 = function ($this$launchAwaitingReset, completion) {
    var i = new detectTapAndPress$slambda$slambda$slambda_1(this.rht_1, this.sht_1, this.tht_1, completion);
    i.uht_1 = $this$launchAwaitingReset;
    return i;
  };
  function detectTapAndPress$slambda$slambda$slambda_2($onPress, $pressScope, $down, resultContinuation) {
    var i = new detectTapAndPress$slambda$slambda$slambda_1($onPress, $pressScope, $down, resultContinuation);
    return constructCallableReference(function ($this$launchAwaitingReset, $completion) {
      return i.p24($this$launchAwaitingReset, $completion);
    }, 1);
  }
  function detectTapAndPress$slambda$slambda$slambda_3($pressScope, resultContinuation) {
    this.dhu_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectTapAndPress$slambda$slambda$slambda_3).p24 = function ($this$launchAwaitingReset, $completion) {
    var tmp = this.q24($this$launchAwaitingReset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.dhu_1.e2z();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda_3).q24 = function ($this$launchAwaitingReset, completion) {
    var i = new detectTapAndPress$slambda$slambda$slambda_3(this.dhu_1, completion);
    i.ehu_1 = $this$launchAwaitingReset;
    return i;
  };
  function detectTapAndPress$slambda$slambda$slambda_4($pressScope, resultContinuation) {
    var i = new detectTapAndPress$slambda$slambda$slambda_3($pressScope, resultContinuation);
    return constructCallableReference(function ($this$launchAwaitingReset, $completion) {
      return i.p24($this$launchAwaitingReset, $completion);
    }, 1);
  }
  function detectTapAndPress$slambda$slambda$slambda_5($pressScope, resultContinuation) {
    this.nhu_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectTapAndPress$slambda$slambda$slambda_5).p24 = function ($this$launchAwaitingReset, $completion) {
    var tmp = this.q24($this$launchAwaitingReset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.nhu_1.r2v();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(detectTapAndPress$slambda$slambda$slambda_5).q24 = function ($this$launchAwaitingReset, completion) {
    var i = new detectTapAndPress$slambda$slambda$slambda_5(this.nhu_1, completion);
    i.ohu_1 = $this$launchAwaitingReset;
    return i;
  };
  function detectTapAndPress$slambda$slambda$slambda_6($pressScope, resultContinuation) {
    var i = new detectTapAndPress$slambda$slambda$slambda_5($pressScope, resultContinuation);
    return constructCallableReference(function ($this$launchAwaitingReset, $completion) {
      return i.p24($this$launchAwaitingReset, $completion);
    }, 1);
  }
  function detectTapAndPress$slambda$slambda($this_coroutineScope, $onPress, $onTap, $pressScope, resultContinuation) {
    this.xhu_1 = $this_coroutineScope;
    this.yhu_1 = $onPress;
    this.zhu_1 = $onTap;
    this.ahv_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectTapAndPress$slambda$slambda).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectTapAndPress$slambda$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectTapAndPress$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp_0 = this;
            var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
            tmp_0.chv_1 = launch(this.xhu_1, VOID, tmp_1, detectTapAndPress$slambda$slambda$slambda_0(this.ahv_1, null));
            this.n9_1 = 1;
            suspendResult = awaitFirstDown(this.bhv_1, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            this_0.ra2();
            var down = this_0;
            if (!(this.yhu_1 === get_NoPressGesture())) {
              launchAwaitingReset(this.xhu_1, this.chv_1, VOID, detectTapAndPress$slambda$slambda$slambda_2(this.yhu_1, this.ahv_1, down, null));
            }

            this.n9_1 = 2;
            suspendResult = waitForUpOrCancellation(this.bhv_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var up = suspendResult;
            if (up == null) {
              launchAwaitingReset(this.xhu_1, this.chv_1, VOID, detectTapAndPress$slambda$slambda$slambda_4(this.ahv_1, null));
            } else {
              up.ra2();
              launchAwaitingReset(this.xhu_1, this.chv_1, VOID, detectTapAndPress$slambda$slambda$slambda_6(this.ahv_1, null));
              var tmp0_safe_receiver = this.zhu_1;
              if (tmp0_safe_receiver == null)
                null;
              else
                tmp0_safe_receiver(new Offset(up.ka0_1));
            }

            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(detectTapAndPress$slambda$slambda).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new detectTapAndPress$slambda$slambda(this.xhu_1, this.yhu_1, this.zhu_1, this.ahv_1, completion);
    i.bhv_1 = $this$awaitEachGesture;
    return i;
  };
  function detectTapAndPress$slambda$slambda_0($this_coroutineScope, $onPress, $onTap, $pressScope, resultContinuation) {
    var i = new detectTapAndPress$slambda$slambda($this_coroutineScope, $onPress, $onTap, $pressScope, resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  function detectTapAndPress$slambda($this_detectTapAndPress, $onPress, $onTap, $pressScope, resultContinuation) {
    this.lhv_1 = $this_detectTapAndPress;
    this.mhv_1 = $onPress;
    this.nhv_1 = $onTap;
    this.ohv_1 = $pressScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectTapAndPress$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectTapAndPress$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectTapAndPress$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = awaitEachGesture(this.lhv_1, detectTapAndPress$slambda$slambda_0(this.phv_1, this.mhv_1, this.nhv_1, this.ohv_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(detectTapAndPress$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new detectTapAndPress$slambda(this.lhv_1, this.mhv_1, this.nhv_1, this.ohv_1, completion);
    i.phv_1 = $this$coroutineScope;
    return i;
  };
  function detectTapAndPress$slambda_0($this_detectTapAndPress, $onPress, $onTap, $pressScope, resultContinuation) {
    var i = new detectTapAndPress$slambda($this_detectTapAndPress, $onPress, $onTap, $pressScope, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function $processTapGestureCOROUTINE$(_this__u8e3s4, scope, pressScope, onDoubleTap, onLongPress, onPress, onTap, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.thj_1 = _this__u8e3s4;
    this.uhj_1 = scope;
    this.vhj_1 = pressScope;
    this.whj_1 = onDoubleTap;
    this.xhj_1 = onLongPress;
    this.yhj_1 = onPress;
    this.zhj_1 = onTap;
  }
  protoOf($processTapGestureCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 16;
            this.n9_1 = 1;
            suspendResult = awaitFirstDown(this.thj_1, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.jhk_1 = suspendResult;
            this.jhk_1.ra2();
            var tmp_0 = this;
            var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
            tmp_0.dhk_1 = launch(this.uhj_1, VOID, tmp_1, processTapGesture$slambda_0(this.vhj_1, null));
            if (!(this.yhj_1 === get_NoPressGesture())) {
              var tmp_2 = this.dhk_1;
              launchAwaitingReset(this.uhj_1, tmp_2, VOID, processTapGesture$slambda_2(this.yhj_1, this.vhj_1, this.jhk_1, null));
            }

            if (this.xhj_1 == null) {
              this.n9_1 = 5;
              suspendResult = waitForUpOrCancellation(this.thj_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = waitForLongPress(this.thj_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var longPressResult = suspendResult;
            if (equals(longPressResult, Success_getInstance())) {
              this.xhj_1(new Offset(this.jhk_1.ka0_1));
              this.n9_1 = 3;
              suspendResult = consumeUntilUp(this.thj_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (longPressResult instanceof Released) {
                this.ihk_1 = longPressResult.ghl_1;
                this.n9_1 = 4;
                continue $sm;
              } else {
                if (longPressResult instanceof Canceled) {
                  this.ihk_1 = null;
                  this.n9_1 = 4;
                  continue $sm;
                } else {
                  var tmp_3 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            var tmp_4 = this.dhk_1;
            launchAwaitingReset(this.uhj_1, tmp_4, VOID, processTapGesture$slambda_4(this.vhj_1, null));
            var tmp_5 = this;
            return Unit_instance;
          case 4:
            this.chk_1 = this.ihk_1;
            this.n9_1 = 6;
            continue $sm;
          case 5:
            this.chk_1 = suspendResult;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            if (this.chk_1 == null) {
              var tmp_6 = this;
              var tmp_7 = this.dhk_1;
              tmp_6.hhk_1 = launchAwaitingReset(this.uhj_1, tmp_7, VOID, processTapGesture$slambda_6(this.vhj_1, null));
            } else {
              this.chk_1.ra2();
              var tmp_8 = this;
              var tmp_9 = this.dhk_1;
              tmp_8.hhk_1 = launchAwaitingReset(this.uhj_1, tmp_9, VOID, processTapGesture$slambda_8(this.vhj_1, null));
            }

            if (!(this.chk_1 == null)) {
              if (this.whj_1 == null) {
                var tmp_10 = this;
                var tmp0_safe_receiver = this.zhj_1;
                tmp_10.ahk_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(new Offset(this.chk_1.ka0_1));
                this.n9_1 = 14;
                continue $sm;
              } else {
                this.n9_1 = 7;
                suspendResult = awaitSecondDown(this.thj_1, this.chk_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              this.n9_1 = 15;
              continue $sm;
            }

          case 7:
            this.ghk_1 = suspendResult;
            if (this.ghk_1 == null) {
              var tmp_11 = this;
              var tmp1_safe_receiver = this.zhj_1;
              tmp_11.bhk_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver(new Offset(this.chk_1.ka0_1));
              this.n9_1 = 13;
              continue $sm;
            } else {
              var tmp_12 = this;
              var tmp_13 = CoroutineStart_UNDISPATCHED_getInstance();
              tmp_12.dhk_1 = launch(this.uhj_1, VOID, tmp_13, processTapGesture$slambda_10(this.hhk_1, this.vhj_1, null));
              if (!(this.yhj_1 === get_NoPressGesture())) {
                var tmp_14 = this.dhk_1;
                launchAwaitingReset(this.uhj_1, tmp_14, VOID, processTapGesture$slambda_12(this.yhj_1, this.vhj_1, this.ghk_1, null));
              }
              if (this.xhj_1 == null) {
                this.n9_1 = 11;
                suspendResult = waitForUpOrCancellation(this.thj_1, VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 8;
                suspendResult = waitForLongPress(this.thj_1, VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 8:
            var longPressResult_0 = suspendResult;
            if (equals(longPressResult_0, Success_getInstance())) {
              this.xhj_1(new Offset(this.ghk_1.ka0_1));
              this.n9_1 = 9;
              suspendResult = consumeUntilUp(this.thj_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (longPressResult_0 instanceof Released) {
                this.fhk_1 = longPressResult_0.ghl_1;
                this.n9_1 = 10;
                continue $sm;
              } else {
                if (longPressResult_0 instanceof Canceled) {
                  this.fhk_1 = null;
                  this.n9_1 = 10;
                  continue $sm;
                } else {
                  var tmp_15 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 9:
            var tmp_16 = this.dhk_1;
            launchAwaitingReset(this.uhj_1, tmp_16, VOID, processTapGesture$slambda_14(this.vhj_1, null));
            var tmp_17 = this;
            return Unit_instance;
          case 10:
            this.ehk_1 = this.fhk_1;
            this.n9_1 = 12;
            continue $sm;
          case 11:
            this.ehk_1 = suspendResult;
            this.n9_1 = 12;
            continue $sm;
          case 12:
            var secondUp = this.ehk_1;
            var tmp_18 = this;
            var tmp_19;
            if (!(secondUp == null)) {
              secondUp.ra2();
              var tmp_20 = this.dhk_1;
              launchAwaitingReset(this.uhj_1, tmp_20, VOID, processTapGesture$slambda_16(this.vhj_1, null));
              this.whj_1(new Offset(secondUp.ka0_1));
              tmp_19 = Unit_instance;
            } else {
              var tmp_21 = this.dhk_1;
              launchAwaitingReset(this.uhj_1, tmp_21, VOID, processTapGesture$slambda_18(this.vhj_1, null));
              var tmp2_safe_receiver = this.zhj_1;
              tmp_19 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver(new Offset(this.chk_1.ka0_1));
            }

            tmp_18.bhk_1 = tmp_19;
            this.n9_1 = 13;
            continue $sm;
          case 13:
            this.ahk_1 = this.bhk_1;
            this.n9_1 = 14;
            continue $sm;
          case 14:
            this.n9_1 = 15;
            continue $sm;
          case 15:
            return Unit_instance;
          case 16:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 16) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $awaitFirstDownCOROUTINE$(_this__u8e3s4, requireUnconsumed, pass, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.shk_1 = _this__u8e3s4;
    this.thk_1 = requireUnconsumed;
    this.uhk_1 = pass;
  }
  protoOf($awaitFirstDownCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.shk_1.pa7(this.uhk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.vhk_1 = suspendResult;
            if (!isChangedToDown(this.vhk_1, this.thk_1)) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 3;
            continue $sm;
          case 3:
            return this.vhk_1.ca0_1.l1(0);
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $waitForUpOrCancellationCOROUTINE$(_this__u8e3s4, pass, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ehl_1 = _this__u8e3s4;
    this.fhl_1 = pass;
  }
  protoOf($waitForUpOrCancellationCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 5;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = this.ehl_1.pa7(this.fhl_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var event = suspendResult;
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (!changedToUp(item)) {
                    tmp$ret$0 = false;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$0 = true;
            }
             while (false);
            if (tmp$ret$0) {
              return event.ca0_1.l1(0);
            }

            var tmp0_0 = event.ca0_1;
            var tmp$ret$2;
            l$ret$3: do {
              var inductionVariable_0 = 0;
              var last_0 = tmp0_0.n1() - 1 | 0;
              if (inductionVariable_0 <= last_0)
                do {
                  var index_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var item_0 = tmp0_0.l1(index_0);
                  if (item_0.qa2() || isOutOfBounds(item_0, this.ehl_1.q95(), this.ehl_1.na7())) {
                    tmp$ret$2 = true;
                    break l$ret$3;
                  }
                }
                 while (inductionVariable_0 <= last_0);
              tmp$ret$2 = false;
            }
             while (false);
            if (tmp$ret$2) {
              return null;
            }

            this.n9_1 = 3;
            suspendResult = this.ehl_1.pa7(PointerEventPass_Final_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var consumeCheck = suspendResult;
            var tmp0_1 = consumeCheck.ca0_1;
            var tmp$ret$4;
            l$ret$5: do {
              var inductionVariable_1 = 0;
              var last_1 = tmp0_1.n1() - 1 | 0;
              if (inductionVariable_1 <= last_1)
                do {
                  var index_1 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  var item_1 = tmp0_1.l1(index_1);
                  if (item_1.qa2()) {
                    tmp$ret$4 = true;
                    break l$ret$5;
                  }
                }
                 while (inductionVariable_1 <= last_1);
              tmp$ret$4 = false;
            }
             while (false);
            if (tmp$ret$4) {
              return null;
            }

            this.n9_1 = 1;
            continue $sm;
          case 4:
            throw this.q9_1;
          case 5:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $waitForLongPressCOROUTINE$(_this__u8e3s4, pass, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.phl_1 = _this__u8e3s4;
    this.qhl_1 = pass;
  }
  protoOf($waitForLongPressCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.rhl_1 = {_v: Canceled_getInstance()};
            this.o9_1 = 3;
            this.n9_1 = 1;
            var tmp_0 = this.phl_1.la7().rb9();
            suspendResult = this.phl_1.sa7(tmp_0, waitForLongPress$slambda_0(this.qhl_1, this.rhl_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            return this.rhl_1._v;
          case 3:
            this.o9_1 = 4;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof PointerEventTimeoutCancellationException) {
              var _unused_var__etf5q3 = this.q9_1;
              return Success_getInstance();
            } else {
              throw this.q9_1;
            }

          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $consumeUntilUpCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ahm_1 = _this__u8e3s4;
  }
  protoOf($consumeUntilUpCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.ahm_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var event = suspendResult;
            var this_0 = event.ca0_1;
            var inductionVariable = 0;
            var last = this_0.n1() - 1 | 0;
            if (inductionVariable <= last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var item = this_0.l1(index);
                item.ra2();
              }
               while (inductionVariable <= last);
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable_0 = 0;
              var last_0 = tmp0.n1() - 1 | 0;
              if (inductionVariable_0 <= last_0)
                do {
                  var index_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var item_0 = tmp0.l1(index_0);
                  if (item_0.la0_1) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable_0 <= last_0);
              tmp$ret$0 = false;
            }
             while (false);
            if (tmp$ret$0) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_TapGestureDetector_kt_lhe8oi;
  function _init_properties_TapGestureDetector_kt__k4yygc() {
    if (!properties_initialized_TapGestureDetector_kt_lhe8oi) {
      properties_initialized_TapGestureDetector_kt_lhe8oi = true;
      NoPressGesture = NoPressGesture$slambda_0(null);
      androidx_compose_foundation_gestures_LongPressResult_Success$stable = 0;
      androidx_compose_foundation_gestures_LongPressResult_Released$stable = 0;
      androidx_compose_foundation_gestures_LongPressResult_Canceled$stable = 0;
      androidx_compose_foundation_gestures_LongPressResult$stable = 0;
      androidx_compose_foundation_gestures_PressGestureScopeImpl$stable = 0;
    }
  }
  function get_NoOnReport() {
    _init_properties_TargetedFlingBehavior_kt__e3jgs4();
    return NoOnReport;
  }
  var NoOnReport;
  function TargetedFlingBehavior() {
  }
  function NoOnReport$lambda(it) {
    _init_properties_TargetedFlingBehavior_kt__e3jgs4();
    return Unit_instance;
  }
  var properties_initialized_TargetedFlingBehavior_kt_jhjcr6;
  function _init_properties_TargetedFlingBehavior_kt__e3jgs4() {
    if (!properties_initialized_TargetedFlingBehavior_kt_jhjcr6) {
      properties_initialized_TargetedFlingBehavior_kt_jhjcr6 = true;
      NoOnReport = NoOnReport$lambda;
    }
  }
  var androidx_compose_foundation_gestures_TrackpadScrollingLogic$stable;
  function TrackpadScrollDelta(value, timeMillis, isEnd) {
    this.rhv_1 = value;
    this.shv_1 = timeMillis;
    this.thv_1 = isEnd;
  }
  protoOf(TrackpadScrollDelta).uhv = function (other) {
    var tmp = Offset__plus_impl_c78cg0(this.rhv_1, other.rhv_1);
    var tmp0 = this.shv_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = other.shv_1;
    var tmp$ret$0 = compare(tmp0, b) >= 0 ? tmp0 : b;
    return new TrackpadScrollDelta(tmp, tmp$ret$0, this.thv_1 || other.thv_1);
  };
  function onPan($this, pointerEvent) {
    if (!ComposeFoundationFlags_instance.qfg_1)
      return false;
    var sent = false;
    var tmp0_safe_receiver = firstOrNull(pointerEvent.ca0_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = tmp0_safe_receiver.ba1();
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          // Inline function 'androidx.compose.ui.geometry.Offset.unaryMinus' call
          var this_1 = item.fa1_1;
          var delta = _Offset___init__impl__c168vi(bitwiseXor(_Offset___get_packedValue__impl__xh2k8q(this_1), new Long(-2147483648, -2147483648)));
          if (canConsumeDelta_0($this, $this.xh0_1, delta)) {
            sent = _ChannelResult___get_isSuccess__impl__odq1z9($this.oh8_1.s1s(new TrackpadScrollDelta(delta, item.ca1_1, false))) || sent;
          }
        }
         while (inductionVariable <= last);
      // Inline function 'androidx.compose.ui.geometry.Offset.unaryMinus' call
      var this_2 = tmp0_safe_receiver.ta0_1;
      var delta_0 = _Offset___init__impl__c168vi(bitwiseXor(_Offset___get_packedValue__impl__xh2k8q(this_2), new Long(-2147483648, -2147483648)));
      var isPanEnd = pointerEvent.ha0_1 === Companion_getInstance_8().wa1_1;
      if (canConsumeDelta_0($this, $this.xh0_1, delta_0) || isPanEnd) {
        sent = _ChannelResult___get_isSuccess__impl__odq1z9($this.oh8_1.s1s(new TrackpadScrollDelta(delta_0, tmp0_safe_receiver.ja0_1, isPanEnd))) || sent;
      }
    }
    return sent || $this.ah1_1;
  }
  function sumOrNull_0($this, $receiver) {
    var sum = null;
    var _iterator__ex2g4s = untilNull(TrackpadScrollingLogic$sumOrNull$lambda($receiver)).t();
    while (_iterator__ex2g4s.u()) {
      var i = _iterator__ex2g4s.v();
      sum = sum == null ? i : sum.uhv(i);
    }
    return sum;
  }
  function canConsumeDelta_0($this, $receiver, scrollDelta) {
    return !($receiver.uh0($receiver.fgg(scrollDelta)) === 0.0);
  }
  function trackVelocity_0($this, scrollDelta) {
    $this.bh1_1.fgi(scrollDelta.shv_1, scrollDelta.rhv_1);
  }
  function dispatchTrackpadScroll($this, $receiver, scrollDelta, $completion) {
    var tmp = new $dispatchTrackpadScrollCOROUTINE$($this, $receiver, scrollDelta, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function dispatchTrackpadScroll_0($this, $receiver, delta) {
    // Inline function 'kotlin.with' call
    var $this$with = $this.xh0_1;
    var offset = $this$with.egg($this$with.th1(delta));
    var consumed = $receiver.yh7(offset, Companion_getInstance_20().d9v_1);
    return $this$with.hgg($this$with.fgg(consumed));
  }
  function TrackpadScrollingLogic$startReceivingEvents$slambda(this$0, resultContinuation) {
    this.ohw_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TrackpadScrollingLogic$startReceivingEvents$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TrackpadScrollingLogic$startReceivingEvents$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TrackpadScrollingLogic$startReceivingEvents$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 7;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!get_isActive_0(this.phw_1.q19())) {
              this.n9_1 = 5;
              continue $sm;
            }

            this.qhw_1 = this.ohw_1.xh0_1;
            this.n9_1 = 3;
            suspendResult = this.ohw_1.oh8_1.u1s(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            this.n9_1 = 4;
            suspendResult = dispatchTrackpadScroll(this.ohw_1, this.qhw_1, ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 2;
            continue $sm;
          case 5:
            this.o9_1 = 8;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.o9_1 = 8;
            this.ohw_1.ph8_1 = null;
            return Unit_instance;
          case 7:
            this.o9_1 = 8;
            var t = this.q9_1;
            this.ohw_1.ph8_1 = null;
            throw t;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TrackpadScrollingLogic$startReceivingEvents$slambda).q24 = function ($this$launch, completion) {
    var i = new TrackpadScrollingLogic$startReceivingEvents$slambda(this.ohw_1, completion);
    i.phw_1 = $this$launch;
    return i;
  };
  function TrackpadScrollingLogic$startReceivingEvents$slambda_0(this$0, resultContinuation) {
    var i = new TrackpadScrollingLogic$startReceivingEvents$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TrackpadScrollingLogic$sumOrNull$lambda($this_sumOrNull) {
    return function () {
      return ChannelResult__getOrNull_impl_f5e07h($this_sumOrNull.w1s());
    };
  }
  function TrackpadScrollingLogic$dispatchTrackpadScroll$slambda(this$0, $this_dispatchTrackpadScroll, $targetScrollDelta, resultContinuation) {
    this.zhw_1 = this$0;
    this.ahx_1 = $this_dispatchTrackpadScroll;
    this.bhx_1 = $targetScrollDelta;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TrackpadScrollingLogic$dispatchTrackpadScroll$slambda).wgg = function ($this$userScroll, $completion) {
    var tmp = this.xgg($this$userScroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TrackpadScrollingLogic$dispatchTrackpadScroll$slambda).ja = function (p1, $completion) {
    return this.wgg((!(p1 == null) ? isInterface(p1, NestedScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TrackpadScrollingLogic$dispatchTrackpadScroll$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            dispatchTrackpadScroll_0(this.zhw_1, this.chx_1, this.ahx_1.uh0(this.ahx_1.fgg(this.bhx_1._v.rhv_1)));
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!!this.bhx_1._v.thv_1) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = busyReceive(this.zhw_1.oh8_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.bhx_1._v = ARGUMENT;
            trackVelocity_0(this.zhw_1, this.bhx_1._v);
            var tmp0_safe_receiver = sumOrNull_0(this.zhw_1, this.zhw_1.oh8_1);
            if (tmp0_safe_receiver == null)
              null;
            else {
              trackVelocity_0(this.zhw_1, tmp0_safe_receiver);
              this.bhx_1._v = this.bhx_1._v.uhv(tmp0_safe_receiver);
            }

            dispatchTrackpadScroll_0(this.zhw_1, this.chx_1, this.ahx_1.uh0(this.ahx_1.fgg(this.bhx_1._v.rhv_1)));
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TrackpadScrollingLogic$dispatchTrackpadScroll$slambda).xgg = function ($this$userScroll, completion) {
    var i = new TrackpadScrollingLogic$dispatchTrackpadScroll$slambda(this.zhw_1, this.ahx_1, this.bhx_1, completion);
    i.chx_1 = $this$userScroll;
    return i;
  };
  function TrackpadScrollingLogic$dispatchTrackpadScroll$slambda_0(this$0, $this_dispatchTrackpadScroll, $targetScrollDelta, resultContinuation) {
    var i = new TrackpadScrollingLogic$dispatchTrackpadScroll$slambda(this$0, $this_dispatchTrackpadScroll, $targetScrollDelta, resultContinuation);
    return constructCallableReference(function ($this$userScroll, $completion) {
      return i.wgg($this$userScroll, $completion);
    }, 1);
  }
  function $dispatchTrackpadScrollCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, scrollDelta, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dhw_1 = _this__u8e3s4;
    this.ehw_1 = _this__u8e3s4_0;
    this.fhw_1 = scrollDelta;
  }
  protoOf($dispatchTrackpadScrollCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var targetScrollDelta = {_v: this.fhw_1};
            trackVelocity_0(this.dhw_1, this.fhw_1);
            var tmp0_safe_receiver = sumOrNull_0(this.dhw_1, this.dhw_1.oh8_1);
            if (tmp0_safe_receiver == null)
              null;
            else {
              trackVelocity_0(this.dhw_1, tmp0_safe_receiver);
              targetScrollDelta._v = targetScrollDelta._v.uhv(tmp0_safe_receiver);
            }

            this.n9_1 = 1;
            suspendResult = this.dhw_1.vh3(TrackpadScrollingLogic$dispatchTrackpadScroll$slambda_0(this.dhw_1, this.ehw_1, targetScrollDelta, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.dhw_1.yh0_1(new Velocity_0(this.dhw_1.bh1_1.ggi()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function TrackpadScrollingLogic(scrollingLogic, onScrollStopped, density) {
    NonTouchScrollingLogic.call(this, scrollingLogic, onScrollStopped, density);
    this.oh8_1 = Channel(2147483647);
    this.ph8_1 = null;
  }
  protoOf(TrackpadScrollingLogic).aa1 = function (pointerEvent, pass, bounds) {
    if (!ComposeFoundationFlags_instance.qfg_1 || (!(pointerEvent.ha0_1 === Companion_getInstance_8().ua1_1) && !(pointerEvent.ha0_1 === Companion_getInstance_8().va1_1) && !(pointerEvent.ha0_1 === Companion_getInstance_8().wa1_1)))
      return Unit_instance;
    // Inline function 'androidx.compose.foundation.gestures.NonTouchScrollingLogic.isConsumed' call
    var tmp0 = pointerEvent.ca0_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (item.qa2()) {
            tmp$ret$1 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = false;
    }
    if (tmp$ret$1)
      return Unit_instance;
    if (pass.equals(PointerEventPass_Initial_getInstance()) && this.ah1_1) {
      onPan(this, pointerEvent);
      this.xh3(pointerEvent);
    }
    if (pass.equals(PointerEventPass_Main_getInstance()) && !this.ah1_1) {
      var consumed = onPan(this, pointerEvent);
      if (consumed) {
        this.xh3(pointerEvent);
      }
    }
  };
  protoOf(TrackpadScrollingLogic).yh3 = function (coroutineScope) {
    if (this.ph8_1 == null) {
      var tmp = this;
      tmp.ph8_1 = launch(coroutineScope, VOID, VOID, TrackpadScrollingLogic$startReceivingEvents$slambda_0(this, null));
    }
  };
  function calculateZoom(_this__u8e3s4) {
    var currentCentroidSize = calculateCentroidSize(_this__u8e3s4, true);
    var previousCentroidSize = calculateCentroidSize(_this__u8e3s4, false);
    if (currentCentroidSize === 0.0 || previousCentroidSize === 0.0) {
      return 1.0;
    }
    return currentCentroidSize / previousCentroidSize;
  }
  function calculatePan(_this__u8e3s4) {
    var currentCentroid = calculateCentroid(_this__u8e3s4, true);
    if (equals(currentCentroid, Companion_getInstance_6().i5d_1)) {
      return Companion_getInstance_6().g5d_1;
    }
    var previousCentroid = calculateCentroid(_this__u8e3s4, false);
    return Offset__minus_impl_hoj2c0(currentCentroid, previousCentroid);
  }
  function calculateCentroid(_this__u8e3s4, useCurrent) {
    useCurrent = useCurrent === VOID ? true : useCurrent;
    return calculateCentroid_0(_this__u8e3s4, useCurrent, calculateCentroid$lambda);
  }
  function detectTransformGestures(_this__u8e3s4, panZoomLock, onGesture, $completion) {
    panZoomLock = panZoomLock === VOID ? false : panZoomLock;
    return awaitEachGesture(_this__u8e3s4, detectTransformGestures$slambda_0(panZoomLock, onGesture, null), $completion);
  }
  function calculateCentroidSize(_this__u8e3s4, useCurrent) {
    useCurrent = useCurrent === VOID ? true : useCurrent;
    var centroid = calculateCentroid(_this__u8e3s4, useCurrent);
    if (equals(centroid, Companion_getInstance_6().i5d_1)) {
      return 0.0;
    }
    var distanceToCentroid = 0.0;
    var distanceWeight = 0;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = _this__u8e3s4.ca0_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        if (item.la0_1 && item.pa0_1) {
          var position = useCurrent ? item.ka0_1 : item.oa0_1;
          distanceToCentroid = distanceToCentroid + Offset__getDistance_impl_pclvxn(Offset__minus_impl_hoj2c0(position, centroid));
          distanceWeight = distanceWeight + 1 | 0;
        }
      }
       while (inductionVariable <= last);
    return distanceToCentroid / distanceWeight;
  }
  function calculateCentroid_0(_this__u8e3s4, useCurrent, pointerInputChangeMatcher) {
    useCurrent = useCurrent === VOID ? true : useCurrent;
    var centroid = Companion_getInstance_6().g5d_1;
    var centroidWeight = 0;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = _this__u8e3s4.ca0_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        if (pointerInputChangeMatcher(item)) {
          var position = useCurrent ? item.ka0_1 : item.oa0_1;
          centroid = Offset__plus_impl_c78cg0(centroid, position);
          centroidWeight = centroidWeight + 1 | 0;
        }
      }
       while (inductionVariable <= last);
    var tmp;
    if (centroidWeight === 0) {
      tmp = Companion_getInstance_6().i5d_1;
    } else {
      tmp = Offset__div_impl_eaxtg1(centroid, centroidWeight);
    }
    return tmp;
  }
  function calculateRotation(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.util.fastSumBy' call
    var sum = 0;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = _this__u8e3s4.ca0_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        var tmp = sum;
        sum = tmp + (item.pa0_1 && item.la0_1 ? 1 : 0) | 0;
      }
       while (inductionVariable <= last);
    var pointerCount = sum;
    if (pointerCount < 2) {
      return 0.0;
    }
    var currentCentroid = calculateCentroid(_this__u8e3s4, true);
    var previousCentroid = calculateCentroid(_this__u8e3s4, false);
    var rotation = 0.0;
    var rotationWeight = 0.0;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_1 = _this__u8e3s4.ca0_1;
    var inductionVariable_0 = 0;
    var last_0 = this_1.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = this_1.l1(index_0);
        if (item_0.la0_1 && item_0.pa0_1) {
          var currentPosition = item_0.ka0_1;
          var previousPosition = item_0.oa0_1;
          var previousOffset = Offset__minus_impl_hoj2c0(previousPosition, previousCentroid);
          var currentOffset = Offset__minus_impl_hoj2c0(currentPosition, currentCentroid);
          var previousAngle = angle(previousOffset);
          var currentAngle = angle(currentOffset);
          var angleDiff = currentAngle - previousAngle;
          var weight = Offset__getDistance_impl_pclvxn(Offset__plus_impl_c78cg0(currentOffset, previousOffset)) / 2.0;
          rotation = rotation + (angleDiff > 180.0 ? angleDiff - 360.0 : angleDiff < -180.0 ? angleDiff + 360.0 : angleDiff) * weight;
          rotationWeight = rotationWeight + weight;
        }
      }
       while (inductionVariable_0 <= last_0);
    return rotationWeight === 0.0 ? 0.0 : rotation / rotationWeight;
  }
  function angle(_this__u8e3s4) {
    var tmp;
    var tmp_0;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    if (floatFromBits(bits) === 0.0) {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp_0 = floatFromBits(bits_0) === 0.0;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = 0.0;
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_1 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(shiftRight(value_1, 32));
      var tmp0 = floatFromBits(bits_1);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_2 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      // Inline function 'kotlin.math.atan2' call
      var x = floatFromBits(bits_2);
      tmp = -Math.atan2(tmp0, x) * 180.0 / 3.141592653589793;
    }
    return tmp;
  }
  function calculateCentroid$lambda(change) {
    return change.la0_1 && change.pa0_1;
  }
  function detectTransformGestures$slambda($panZoomLock, $onGesture, resultContinuation) {
    this.lhx_1 = $panZoomLock;
    this.mhx_1 = $onGesture;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectTransformGestures$slambda).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectTransformGestures$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectTransformGestures$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.shx_1 = 0.0;
            this.thx_1 = 1.0;
            this.rhx_1 = Companion_getInstance_6().g5d_1;
            this.phx_1 = false;
            this.qhx_1 = this.nhx_1.la7().ub9();
            this.ohx_1 = false;
            this.n9_1 = 1;
            suspendResult = awaitFirstDown(this.nhx_1, false, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.nhx_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var event = suspendResult;
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (item.qa2()) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$0 = false;
            }
             while (false);
            var canceled = tmp$ret$0;
            if (!canceled) {
              var zoomChange = calculateZoom(event);
              var rotationChange = calculateRotation(event);
              var panChange = calculatePan(event);
              if (!this.phx_1) {
                this.thx_1 = this.thx_1 * zoomChange;
                this.shx_1 = this.shx_1 + rotationChange;
                this.rhx_1 = Offset__plus_impl_c78cg0(this.rhx_1, panChange);
                var centroidSize = calculateCentroidSize(event, false);
                var x = 1 - this.thx_1;
                var zoomMotion = Math.abs(x) * centroidSize;
                var x_0 = this.shx_1 * 3.141592653589793 * centroidSize / 180.0;
                var rotationMotion = Math.abs(x_0);
                var panMotion = Offset__getDistance_impl_pclvxn(this.rhx_1);
                if (zoomMotion > this.qhx_1 || rotationMotion > this.qhx_1 || panMotion > this.qhx_1) {
                  this.phx_1 = true;
                  this.ohx_1 = (this.lhx_1 && rotationMotion < this.qhx_1);
                }
              }
              if (this.phx_1) {
                var centroid = calculateCentroid(event, false);
                var effectiveRotation = this.ohx_1 ? 0.0 : rotationChange;
                if (!(effectiveRotation === 0.0) || !(zoomChange === 1.0) || !equals(panChange, Companion_getInstance_6().g5d_1)) {
                  this.mhx_1(new Offset(centroid), new Offset(panChange), zoomChange, effectiveRotation);
                }
                var this_0 = event.ca0_1;
                var inductionVariable_0 = 0;
                var last_0 = this_0.n1() - 1 | 0;
                if (inductionVariable_0 <= last_0)
                  do {
                    var index_0 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var item_0 = this_0.l1(index_0);
                    if (positionChanged(item_0)) {
                      item_0.ra2();
                    }
                  }
                   while (inductionVariable_0 <= last_0);
              }
            }

            var tmp_0;
            if (!canceled) {
              var tmp0_0 = event.ca0_1;
              var tmp$ret$2;
              l$ret$3: do {
                var inductionVariable_1 = 0;
                var last_1 = tmp0_0.n1() - 1 | 0;
                if (inductionVariable_1 <= last_1)
                  do {
                    var index_1 = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var item_1 = tmp0_0.l1(index_1);
                    if (item_1.la0_1) {
                      tmp$ret$2 = true;
                      break l$ret$3;
                    }
                  }
                   while (inductionVariable_1 <= last_1);
                tmp$ret$2 = false;
              }
               while (false);
              tmp_0 = tmp$ret$2;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this.n9_1 = 2;
              continue $sm;
            }

            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(detectTransformGestures$slambda).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new detectTransformGestures$slambda(this.lhx_1, this.mhx_1, completion);
    i.nhx_1 = $this$awaitEachGesture;
    return i;
  };
  function detectTransformGestures$slambda_0($panZoomLock, $onGesture, resultContinuation) {
    var i = new detectTransformGestures$slambda($panZoomLock, $onGesture, resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  var androidx_compose_foundation_gestures_TransformEvent_TransformStarted$stable;
  var androidx_compose_foundation_gestures_TransformEvent_TransformStopped$stable;
  var androidx_compose_foundation_gestures_TransformEvent_TransformDelta$stable;
  var androidx_compose_foundation_gestures_UpdatableAnimationState$stable;
  function Companion_2() {
    Companion_instance_12 = this;
    this.uhx_1 = 0.01;
    this.vhx_1 = new AnimationVector1D(0.0);
  }
  protoOf(Companion_2).whx = function (_this__u8e3s4) {
    // Inline function 'kotlin.math.absoluteValue' call
    return Math.abs(_this__u8e3s4) < 0.01;
  };
  var Companion_instance_12;
  function Companion_getInstance_61() {
    if (Companion_instance_12 == null)
      new Companion_2();
    return Companion_instance_12;
  }
  function UpdatableAnimationState$animateToZero$lambda(this$0, $durationScale, $beforeFrame) {
    return function (frameTime) {
      var tmp;
      if (equalsLong(this$0.ngf_1, new Long(0, -2147483648))) {
        this$0.ngf_1 = frameTime;
        tmp = Unit_instance;
      }
      var vectorizedCurrentValue = new AnimationVector1D(this$0.qgf_1);
      var tmp_0;
      if ($durationScale === 0.0) {
        tmp_0 = this$0.mgf_1.kee(new AnimationVector1D(this$0.qgf_1), Companion_getInstance_61().vhx_1, this$0.ogf_1);
      } else {
        var tmp0 = subtract(frameTime, this$0.ngf_1);
        // Inline function 'kotlin.Long.div' call
        var other = $durationScale;
        // Inline function 'kotlin.math.roundToLong' call
        var this_0 = toNumber(tmp0) / other;
        tmp_0 = roundToLong(this_0);
      }
      var playTime = tmp_0;
      var newValue = this$0.mgf_1.hee(playTime, vectorizedCurrentValue, Companion_getInstance_61().vhx_1, this$0.ogf_1).jeg_1;
      this$0.ogf_1 = this$0.mgf_1.mee(playTime, vectorizedCurrentValue, Companion_getInstance_61().vhx_1, this$0.ogf_1);
      this$0.ngf_1 = frameTime;
      var delta = this$0.qgf_1 - newValue;
      this$0.qgf_1 = newValue;
      $beforeFrame(delta);
      return Unit_instance;
    };
  }
  function UpdatableAnimationState$animateToZero$lambda_0(this$0, $beforeFrame) {
    return function (it) {
      var delta = this$0.qgf_1;
      this$0.qgf_1 = 0.0;
      $beforeFrame(delta);
      return Unit_instance;
    };
  }
  function $animateToZeroCOROUTINE$(_this__u8e3s4, beforeFrame, afterFrame, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fhy_1 = _this__u8e3s4;
    this.ghy_1 = beforeFrame;
    this.hhy_1 = afterFrame;
  }
  protoOf($animateToZeroCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 10;
            if (!!this.fhy_1.pgf_1) {
              throwIllegalStateException('animateToZero called while previous animation is running');
            }

            var tmp_0 = this;
            var tmp0_safe_receiver = this.t9().aa(Key_instance_1);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r8w();
            tmp_0.ihy_1 = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
            this.fhy_1.pgf_1 = true;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 9;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!!Companion_getInstance_61().whx(this.fhy_1.qgf_1)) {
              this.n9_1 = 5;
              continue $sm;
            }

            this.n9_1 = 3;
            suspendResult = withFrameNanos(UpdatableAnimationState$animateToZero$lambda(this.fhy_1, this.ihy_1, this.ghy_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.hhy_1();
            if (this.ihy_1 === 0.0) {
              this.n9_1 = 5;
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            this.n9_1 = 2;
            continue $sm;
          case 5:
            var this_0 = this.fhy_1.qgf_1;
            if (!(Math.abs(this_0) === 0.0)) {
              this.n9_1 = 6;
              suspendResult = withFrameNanos(UpdatableAnimationState$animateToZero$lambda_0(this.fhy_1, this.ghy_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 6:
            this.hhy_1();
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.o9_1 = 10;
            this.n9_1 = 8;
            continue $sm;
          case 8:
            this.o9_1 = 10;
            this.fhy_1.ngf_1 = new Long(0, -2147483648);
            this.fhy_1.ogf_1 = Companion_getInstance_61().vhx_1;
            this.fhy_1.pgf_1 = false;
            return Unit_instance;
          case 9:
            this.o9_1 = 10;
            var t = this.q9_1;
            this.fhy_1.ngf_1 = new Long(0, -2147483648);
            this.fhy_1.ogf_1 = Companion_getInstance_61().vhx_1;
            this.fhy_1.pgf_1 = false;
            throw t;
          case 10:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 10) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function UpdatableAnimationState(animationSpec) {
    Companion_getInstance_61();
    this.mgf_1 = animationSpec.qed(get_VectorConverter(FloatCompanionObject_instance));
    this.ngf_1 = new Long(0, -2147483648);
    this.ogf_1 = Companion_getInstance_61().vhx_1;
    this.pgf_1 = false;
    this.qgf_1 = 0.0;
  }
  protoOf(UpdatableAnimationState).ygg = function (beforeFrame, afterFrame, $completion) {
    var tmp = new $animateToZeroCOROUTINE$(this, beforeFrame, afterFrame, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function offsetOnMainAxis(_this__u8e3s4, orientation) {
    var tmp;
    if (orientation.equals(Orientation_Vertical_getInstance())) {
      tmp = _IntOffset___get_y__impl__2avpwj(_this__u8e3s4.jhy());
    } else {
      tmp = _IntOffset___get_x__impl__qiqr5o(_this__u8e3s4.jhy());
    }
    return tmp;
  }
  function sizeOnMainAxis(_this__u8e3s4, orientation) {
    var tmp;
    if (orientation.equals(Orientation_Vertical_getInstance())) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_0 = _this__u8e3s4.q95();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      tmp = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = _this__u8e3s4.q95();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      tmp = convertToInt(shiftRight(value_0, 32));
    }
    return tmp;
  }
  function get_singleAxisViewportSize(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.lhy().equals(Orientation_Vertical_getInstance())) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_0 = _this__u8e3s4.khy();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      tmp = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = _this__u8e3s4.khy();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      tmp = convertToInt(shiftRight(value_0, 32));
    }
    return tmp;
  }
  function SnapLayoutInfoProvider(lazyListState, snapPosition) {
    snapPosition = snapPosition === VOID ? Center_instance : snapPosition;
    return new SnapLayoutInfoProvider$1(lazyListState, snapPosition);
  }
  function get_singleAxisViewportSize_0(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.lhy().equals(Orientation_Vertical_getInstance())) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_0 = _this__u8e3s4.khy();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      tmp = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = _this__u8e3s4.khy();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      tmp = convertToInt(shiftRight(value_0, 32));
    }
    return tmp;
  }
  function _FinalSnappingItem___init__impl__fowkhg(value) {
    return value;
  }
  function Companion_3() {
    Companion_instance_13 = this;
    this.mhy_1 = _FinalSnappingItem___init__impl__fowkhg(0);
    this.nhy_1 = _FinalSnappingItem___init__impl__fowkhg(1);
    this.ohy_1 = _FinalSnappingItem___init__impl__fowkhg(2);
  }
  var Companion_instance_13;
  function Companion_getInstance_62() {
    if (Companion_instance_13 == null)
      new Companion_3();
    return Companion_instance_13;
  }
  function FinalSnappingItem__toString_impl_zhonzw($this) {
    return 'FinalSnappingItem(value=' + $this + ')';
  }
  function FinalSnappingItem__hashCode_impl_dqir71($this) {
    return $this;
  }
  function FinalSnappingItem__equals_impl_clfmq1($this, other) {
    if (!(other instanceof FinalSnappingItem))
      return false;
    if (!($this === other.phy_1))
      return false;
    return true;
  }
  function FinalSnappingItem(value) {
    Companion_getInstance_62();
    this.phy_1 = value;
  }
  protoOf(FinalSnappingItem).toString = function () {
    return FinalSnappingItem__toString_impl_zhonzw(this.phy_1);
  };
  protoOf(FinalSnappingItem).hashCode = function () {
    return FinalSnappingItem__hashCode_impl_dqir71(this.phy_1);
  };
  protoOf(FinalSnappingItem).equals = function (other) {
    return FinalSnappingItem__equals_impl_clfmq1(this.phy_1, other);
  };
  function calculateFinalSnappingItem(_this__u8e3s4, velocity) {
    var tmp;
    // Inline function 'kotlin.math.absoluteValue' call
    if (Math.abs(velocity) < _this__u8e3s4.v5e(get_MinFlingVelocityDp())) {
      tmp = Companion_getInstance_62().mhy_1;
    } else {
      tmp = velocity > 0 ? Companion_getInstance_62().nhy_1 : Companion_getInstance_62().ohy_1;
    }
    return tmp;
  }
  function _get_layoutInfo__1qe26r($this) {
    return $this.qhy_1.thz();
  }
  function _get_averageItemSize__5v9sqo($this) {
    var layoutInfo = _get_layoutInfo__1qe26r($this);
    var tmp;
    if (layoutInfo.uhz().r()) {
      tmp = 0;
    } else {
      var numberOfItems = layoutInfo.uhz().n1();
      // Inline function 'androidx.compose.ui.util.fastSumBy' call
      var sum = 0;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = layoutInfo.uhz();
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          var tmp_0 = sum;
          sum = tmp_0 + item.n1() | 0;
        }
         while (inductionVariable <= last);
      tmp = sum / numberOfItems | 0;
    }
    return tmp;
  }
  function SnapLayoutInfoProvider$1($lazyListState, $snapPosition) {
    this.qhy_1 = $lazyListState;
    this.rhy_1 = $snapPosition;
  }
  protoOf(SnapLayoutInfoProvider$1).vhz = function (velocity, decayOffset) {
    // Inline function 'kotlin.math.absoluteValue' call
    var tmp$ret$0 = Math.abs(decayOffset);
    var tmp = coerceAtLeast(tmp$ret$0 - _get_averageItemSize__5v9sqo(this), 0.0);
    // Inline function 'kotlin.math.sign' call
    return tmp * sign(decayOffset);
  };
  protoOf(SnapLayoutInfoProvider$1).whz = function (velocity) {
    var lowerBoundOffset = -Infinity;
    var upperBoundOffset = Infinity;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = _get_layoutInfo__1qe26r(this).uhz();
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        $l$block: {
          var tmp0_safe_receiver = isInterface(item, LazyLayoutMeasuredItem) ? item : null;
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xhz()) === true) {
            break $l$block;
          }
          var offset = calculateDistanceToDesiredSnapPosition(get_singleAxisViewportSize_0(_get_layoutInfo__1qe26r(this)), _get_layoutInfo__1qe26r(this).yhz(), _get_layoutInfo__1qe26r(this).zhz(), item.n1(), item.ai0(), item.bi0(), this.rhy_1, _get_layoutInfo__1qe26r(this).ci0());
          if (offset <= 0 && offset > lowerBoundOffset) {
            lowerBoundOffset = offset;
          }
          if (offset >= 0 && offset < upperBoundOffset) {
            upperBoundOffset = offset;
          }
        }
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.with' call
    var $this$with = this.qhy_1.di0();
    var tmp$ret$2 = calculateFinalSnappingItem($this$with, velocity);
    return calculateFinalOffset(tmp$ret$2, lowerBoundOffset, upperBoundOffset);
  };
  function SnapLayoutInfoProvider_0(pagerState, pagerSnapDistance, calculateFinalSnappingBound) {
    return new SnapLayoutInfoProvider$1_0(pagerState, calculateFinalSnappingBound, pagerSnapDistance);
  }
  function calculateFinalSnappingBound(pagerState, layoutDirection, snapPositionalThreshold, flingVelocity, lowerBoundOffset, upperBoundOffset) {
    var isScrollingForward_0 = isScrollingForward(pagerState, flingVelocity);
    var tmp;
    if (pagerState.thz().lhy().equals(Orientation_Vertical_getInstance())) {
      tmp = isScrollingForward_0;
    } else {
      var tmp_0;
      if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
        tmp_0 = isScrollingForward_0;
      } else {
        tmp_0 = !isScrollingForward_0;
      }
      tmp = tmp_0;
    }
    var isForward = tmp;
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$1 = 'isScrollingForward=' + isScrollingForward_0 + ' ' + ('isForward=' + isForward + ' ') + ('layoutDirection=' + layoutDirection.toString());
      println('PagerSnapLayoutInfoProvider: ' + tmp$ret$1);
    }
    var pageSize = pagerState.thz().ui1();
    var tmp_1;
    if (pageSize === 0) {
      tmp_1 = 0.0;
    } else {
      tmp_1 = dragGestureDelta(pagerState) / pageSize;
    }
    var offsetFromSnappedPosition = tmp_1;
    var offsetFromSnappedPositionOverflow = offsetFromSnappedPosition - numberToInt(offsetFromSnappedPosition);
    // Inline function 'kotlin.with' call
    var $this$with = pagerState.wi0_1;
    var finalSnappingItem = calculateFinalSnappingItem($this$with, flingVelocity);
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$5 = '\nfinalSnappingItem=' + FinalSnappingItem__toString_impl_zhonzw(finalSnappingItem) + ('\nlower=' + lowerBoundOffset) + ('\nupper=' + upperBoundOffset);
      println('PagerSnapLayoutInfoProvider: ' + tmp$ret$5);
    }
    var tmp_2;
    if (finalSnappingItem === Companion_getInstance_62().mhy_1) {
      var tmp_3;
      // Inline function 'kotlin.math.absoluteValue' call
      if (Math.abs(offsetFromSnappedPositionOverflow) > snapPositionalThreshold) {
        // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
        if (false) {
          var tmp$ret$8 = 'Crossed Snap Positional Threshold';
          println('PagerSnapLayoutInfoProvider: ' + tmp$ret$8);
        }
        tmp_3 = isForward ? upperBoundOffset : lowerBoundOffset;
      } else {
        var tmp_4;
        // Inline function 'kotlin.math.abs' call
        var tmp_5 = Math.abs(offsetFromSnappedPosition);
        // Inline function 'kotlin.math.abs' call
        var x = pagerState.vi1();
        if (tmp_5 >= Math.abs(x)) {
          // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
          if (false) {
            var tmp$ret$12 = 'Crossed Positional Threshold Fraction';
            println('PagerSnapLayoutInfoProvider: ' + tmp$ret$12);
          }
          tmp_4 = isForward ? lowerBoundOffset : upperBoundOffset;
        } else {
          // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
          if (false) {
            var tmp$ret$14 = 'Snap To Closest';
            println('PagerSnapLayoutInfoProvider: ' + tmp$ret$14);
          }
          var tmp_6;
          // Inline function 'kotlin.math.absoluteValue' call
          var tmp_7 = Math.abs(lowerBoundOffset);
          // Inline function 'kotlin.math.absoluteValue' call
          if (tmp_7 < Math.abs(upperBoundOffset)) {
            tmp_6 = lowerBoundOffset;
          } else {
            tmp_6 = upperBoundOffset;
          }
          tmp_4 = tmp_6;
        }
        tmp_3 = tmp_4;
      }
      tmp_2 = tmp_3;
    } else if (finalSnappingItem === Companion_getInstance_62().nhy_1) {
      tmp_2 = upperBoundOffset;
    } else if (finalSnappingItem === Companion_getInstance_62().ohy_1) {
      tmp_2 = lowerBoundOffset;
    } else {
      tmp_2 = 0.0;
    }
    return tmp_2;
  }
  function isScrollingForward(_this__u8e3s4, velocity) {
    var reverseScrollDirection = _this__u8e3s4.thz().wi1();
    var tmp;
    if (_this__u8e3s4.xi1()) {
      tmp = -velocity;
    } else {
      tmp = dragGestureDelta(_this__u8e3s4);
    }
    var isForward = tmp > 0;
    return isForward && reverseScrollDirection || (!isForward && !reverseScrollDirection);
  }
  function dragGestureDelta(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.thz().lhy().equals(Orientation_Horizontal_getInstance())) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_0 = _this__u8e3s4.yi1();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      tmp = floatFromBits(bits);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_1 = _this__u8e3s4.yi1();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp = floatFromBits(bits_0);
    }
    return tmp;
  }
  function searchForSnappingBounds($this, snapPosition, velocity) {
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$1 = 'Calculating Snapping Bounds';
      println('PagerSnapLayoutInfoProvider: ' + tmp$ret$1);
    }
    var lowerBoundOffset = -Infinity;
    var upperBoundOffset = Infinity;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = $this.thz().ci2();
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        var offset = calculateDistanceToDesiredSnapPosition(get_mainAxisViewportSize($this.thz()), $this.thz().yhz(), $this.thz().zhz(), $this.thz().ui1(), item.ai0(), item.bi0(), snapPosition, $this.zi1_1.di2());
        if (offset <= 0 && offset > lowerBoundOffset) {
          lowerBoundOffset = offset;
        }
        if (offset >= 0 && offset < upperBoundOffset) {
          upperBoundOffset = offset;
        }
      }
       while (inductionVariable <= last);
    if (lowerBoundOffset === -Infinity) {
      lowerBoundOffset = upperBoundOffset;
    }
    if (upperBoundOffset === Infinity) {
      upperBoundOffset = lowerBoundOffset;
    }
    if (!$this.zi1_1.mg7()) {
      upperBoundOffset = 0.0;
      if (isScrollingForward($this.zi1_1, velocity)) {
        lowerBoundOffset = 0.0;
      }
    }
    if (!$this.zi1_1.ng7()) {
      lowerBoundOffset = 0.0;
      if (!isScrollingForward($this.zi1_1, velocity)) {
        upperBoundOffset = 0.0;
      }
    }
    return to(lowerBoundOffset, upperBoundOffset);
  }
  function SnapLayoutInfoProvider$1_0($pagerState, $calculateFinalSnappingBound, $pagerSnapDistance) {
    this.zi1_1 = $pagerState;
    this.ai2_1 = $calculateFinalSnappingBound;
    this.bi2_1 = $pagerSnapDistance;
  }
  protoOf(SnapLayoutInfoProvider$1_0).thz = function () {
    return this.zi1_1.thz();
  };
  protoOf(SnapLayoutInfoProvider$1_0).ei2 = function (_this__u8e3s4) {
    return !(_this__u8e3s4 === Infinity) && !(_this__u8e3s4 === -Infinity);
  };
  protoOf(SnapLayoutInfoProvider$1_0).whz = function (velocity) {
    var snapPosition = this.zi1_1.thz().fi2();
    var _destruct__k2r9zo = searchForSnappingBounds(this, snapPosition, velocity);
    var lowerBoundOffset = _destruct__k2r9zo.zh();
    var upperBoundOffset = _destruct__k2r9zo.ai();
    var finalDistance = this.ai2_1(velocity, lowerBoundOffset, upperBoundOffset);
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(finalDistance === lowerBoundOffset || finalDistance === upperBoundOffset || finalDistance === 0.0)) {
      var tmp$ret$1 = 'Final Snapping Offset Should Be one of ' + lowerBoundOffset + ', ' + upperBoundOffset + ' or 0.0';
      throwIllegalStateException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$3 = 'Snapping to=' + finalDistance;
      println('PagerSnapLayoutInfoProvider: ' + tmp$ret$3);
    }
    var tmp;
    if (this.ei2(finalDistance)) {
      tmp = finalDistance;
    } else {
      tmp = 0.0;
    }
    return tmp;
  };
  protoOf(SnapLayoutInfoProvider$1_0).vhz = function (velocity, decayOffset) {
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$1 = 'Approach Velocity=' + velocity;
      println('PagerSnapLayoutInfoProvider: ' + tmp$ret$1);
    }
    var effectivePageSizePx = this.zi1_1.gi2() + this.zi1_1.hi2() | 0;
    if (effectivePageSizePx === 0)
      return 0.0;
    var animationOffsetPx = decayOffset;
    var tmp;
    if (velocity < 0) {
      tmp = this.zi1_1.ii0_1 + 1 | 0;
    } else {
      tmp = this.zi1_1.ii0_1;
    }
    var startPage = tmp;
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$3 = '\nAnimation Offset=' + animationOffsetPx + ' ' + ('\nFling Start Page=' + startPage + ' ') + ('\nEffective Page Size=' + effectivePageSizePx);
      println('PagerSnapLayoutInfoProvider: ' + tmp$ret$3);
    }
    var pagesInAnimationOffset = animationOffsetPx / effectivePageSizePx;
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$5 = 'Pages in Animation Offset=' + pagesInAnimationOffset;
      println('PagerSnapLayoutInfoProvider: ' + tmp$ret$5);
    }
    var targetPage = coerceIn_1(startPage + numberToInt(pagesInAnimationOffset) | 0, 0, this.zi1_1.di2());
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$7 = 'Fling Target Page=' + targetPage;
      println('PagerSnapLayoutInfoProvider: ' + tmp$ret$7);
    }
    var correctedTargetPage = coerceIn_1(this.bi2_1.ii2(startPage, targetPage, velocity, this.zi1_1.gi2(), this.zi1_1.hi2()), 0, this.zi1_1.di2());
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$9 = 'Fling Corrected Target Page=' + correctedTargetPage;
      println('PagerSnapLayoutInfoProvider: ' + tmp$ret$9);
    }
    var proposedFlingOffset = imul(correctedTargetPage - startPage | 0, effectivePageSizePx);
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$11 = 'Proposed Fling Approach Offset=' + proposedFlingOffset;
      println('PagerSnapLayoutInfoProvider: ' + tmp$ret$11);
    }
    var flingApproachOffsetPx = coerceAtLeast_0(abs(proposedFlingOffset) - effectivePageSizePx | 0, 0);
    var tmp_0;
    if (flingApproachOffsetPx === 0) {
      tmp_0 = flingApproachOffsetPx;
    } else {
      // Inline function 'kotlin.math.sign' call
      tmp_0 = flingApproachOffsetPx * sign(velocity);
    }
    // Inline function 'kotlin.also' call
    var this_0 = tmp_0;
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$16 = 'Fling Approach Offset=' + this_0;
      println('PagerSnapLayoutInfoProvider: ' + tmp$ret$16);
    }
    return this_0;
  };
  function get_MinFlingVelocityDp() {
    _init_properties_SnapFlingBehavior_kt__1y2evi();
    return MinFlingVelocityDp;
  }
  var MinFlingVelocityDp;
  var androidx_compose_foundation_gestures_snapping_SnapFlingBehavior$stable;
  function snapFlingBehavior(snapLayoutInfoProvider, decayAnimationSpec, snapAnimationSpec) {
    _init_properties_SnapFlingBehavior_kt__1y2evi();
    return new SnapFlingBehavior(snapLayoutInfoProvider, decayAnimationSpec, snapAnimationSpec);
  }
  function calculateFinalOffset(snappingOffset, lowerBound, upperBound) {
    _init_properties_SnapFlingBehavior_kt__1y2evi();
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$1 = 'Proposed Bounds: Lower=' + lowerBound + ' Upper=' + upperBound;
      println('SnapFlingBehavior: ' + tmp$ret$1);
    }
    var tmp;
    if (snappingOffset === Companion_getInstance_62().mhy_1) {
      var tmp_0;
      // Inline function 'kotlin.math.abs' call
      var tmp_1 = Math.abs(upperBound);
      // Inline function 'kotlin.math.abs' call
      if (tmp_1 <= Math.abs(lowerBound)) {
        tmp_0 = upperBound;
      } else {
        tmp_0 = lowerBound;
      }
      tmp = tmp_0;
    } else if (snappingOffset === Companion_getInstance_62().nhy_1) {
      tmp = upperBound;
    } else if (snappingOffset === Companion_getInstance_62().ohy_1) {
      tmp = lowerBound;
    } else {
      tmp = 0.0;
    }
    var finalDistance = tmp;
    var tmp_2;
    if (calculateFinalOffset$isValidDistance(finalDistance)) {
      tmp_2 = finalDistance;
    } else {
      tmp_2 = 0.0;
    }
    return tmp_2;
  }
  function SnapFlingBehavior$fling$slambda$lambda($remainingScrollOffset, $onRemainingScrollOffsetUpdate) {
    return function (delta) {
      $remainingScrollOffset._v = $remainingScrollOffset._v - delta;
      $onRemainingScrollOffsetUpdate($remainingScrollOffset._v);
      return Unit_instance;
    };
  }
  function SnapFlingBehavior$fling$slambda$lambda_0($remainingScrollOffset, $onRemainingScrollOffsetUpdate) {
    return function (delta) {
      $remainingScrollOffset._v = $remainingScrollOffset._v - delta;
      $onRemainingScrollOffsetUpdate($remainingScrollOffset._v);
      return Unit_instance;
    };
  }
  function fling($this, $receiver, initialVelocity, onRemainingScrollOffsetUpdate, $completion) {
    var tmp = new $flingCOROUTINE$($this, $receiver, initialVelocity, onRemainingScrollOffsetUpdate, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function tryApproach($this, $receiver, offset, velocity, updateRemainingScrollOffset, $completion) {
    var tmp = new $tryApproachCOROUTINE$($this, $receiver, offset, velocity, updateRemainingScrollOffset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function runApproach($this, $receiver, initialTargetOffset, initialVelocity, onAnimationStep, $completion) {
    var tmp;
    if (isDecayApproachPossible($this, initialTargetOffset, initialVelocity)) {
      // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
      if (false) {
        var tmp$ret$1 = 'High Velocity Approach';
        println('SnapFlingBehavior: ' + tmp$ret$1);
      }
      tmp = new DecayApproachAnimation($this.ki3_1);
    } else {
      // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
      if (false) {
        var tmp$ret$3 = 'Low Velocity Approach';
        println('SnapFlingBehavior: ' + tmp$ret$3);
      }
      tmp = new TargetApproachAnimation($this.li3_1);
    }
    var animation = tmp;
    return approach($receiver, initialTargetOffset, initialVelocity, animation, onAnimationStep, $completion);
  }
  function isDecayApproachPossible($this, offset, velocity) {
    var decayOffset = calculateTargetValue($this.ki3_1, 0.0, velocity);
    // Inline function 'androidx.compose.foundation.gestures.snapping.debugLog' call
    if (false) {
      var tmp$ret$1 = 'Evaluating decay possibility with ' + ('decayOffset=' + decayOffset + ' and proposed approach=' + offset);
      println('SnapFlingBehavior: ' + tmp$ret$1);
    }
    // Inline function 'kotlin.math.absoluteValue' call
    var tmp = Math.abs(decayOffset);
    // Inline function 'kotlin.math.absoluteValue' call
    return tmp >= Math.abs(offset);
  }
  function SnapFlingBehavior$fling$slambda(this$0, $initialVelocity, $onRemainingScrollOffsetUpdate, $this_fling, resultContinuation) {
    this.vi3_1 = this$0;
    this.wi3_1 = $initialVelocity;
    this.xi3_1 = $onRemainingScrollOffsetUpdate;
    this.yi3_1 = $this_fling;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SnapFlingBehavior$fling$slambda).bi4 = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SnapFlingBehavior$fling$slambda).ja = function (p1, $completion) {
    return this.bi4((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SnapFlingBehavior$fling$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var decayOffset = calculateTargetValue(this.vi3_1.ki3_1, 0.0, this.wi3_1);
            var initialOffset = this.vi3_1.ji3_1.vhz(this.wi3_1, decayOffset);
            if (!!isNaN_0(initialOffset)) {
              throwIllegalStateException('calculateApproachOffset returned NaN. Please use a valid value.');
            }

            var tmp_0 = this;
            var tmp_1 = Math.abs(initialOffset);
            var x = this.wi3_1;
            tmp_0.ai4_1 = {_v: tmp_1 * sign(x)};
            this.xi3_1(this.ai4_1._v);
            this.n9_1 = 1;
            var tmp_2 = this.ai4_1._v;
            suspendResult = tryApproach(this.vi3_1, this.yi3_1, tmp_2, this.wi3_1, SnapFlingBehavior$fling$slambda$lambda(this.ai4_1, this.xi3_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var animationState = suspendResult;
            var finalSnapOffset = this.vi3_1.ji3_1.whz(animationState.eec());
            if (!!isNaN_0(finalSnapOffset)) {
              throwIllegalStateException('calculateSnapOffset returned NaN. Please use a valid value.');
            }

            this.ai4_1._v = finalSnapOffset;
            if (false) {
              println('SnapFlingBehavior: ' + ('Settling Final Bound=' + this.ai4_1._v));
            }

            this.n9_1 = 2;
            var tmp_3 = this.ai4_1._v;
            var tmp_4 = this.ai4_1._v;
            var tmp_5 = copy(animationState, 0.0);
            suspendResult = animateWithTarget(this.yi3_1, tmp_3, tmp_4, tmp_5, this.vi3_1.li3_1, SnapFlingBehavior$fling$slambda$lambda_0(this.ai4_1, this.xi3_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SnapFlingBehavior$fling$slambda).q24 = function ($this$withContext, completion) {
    var i = new SnapFlingBehavior$fling$slambda(this.vi3_1, this.wi3_1, this.xi3_1, this.yi3_1, completion);
    i.zi3_1 = $this$withContext;
    return i;
  };
  function SnapFlingBehavior$fling$slambda_0(this$0, $initialVelocity, $onRemainingScrollOffsetUpdate, $this_fling, resultContinuation) {
    var i = new SnapFlingBehavior$fling$slambda(this$0, $initialVelocity, $onRemainingScrollOffsetUpdate, $this_fling, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.bi4($this$withContext, $completion);
    }, 1);
  }
  function $performFlingCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, initialVelocity, onRemainingDistanceUpdated, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ki4_1 = _this__u8e3s4;
    this.li4_1 = _this__u8e3s4_0;
    this.mi4_1 = initialVelocity;
    this.ni4_1 = onRemainingDistanceUpdated;
  }
  protoOf($performFlingCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = fling(this.ki4_1, this.li4_1, this.mi4_1, this.ni4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var _destruct__k2r9zo = suspendResult;
            var remainingOffset = _destruct__k2r9zo.zh();
            var remainingState = _destruct__k2r9zo.ai();
            if (false) {
              println('SnapFlingBehavior: ' + ('Post Settling Offset=' + remainingOffset));
            }

            return remainingOffset === 0.0 ? 0.0 : remainingState.eec();
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $flingCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, initialVelocity, onRemainingScrollOffsetUpdate, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ri2_1 = _this__u8e3s4;
    this.si2_1 = _this__u8e3s4_0;
    this.ti2_1 = initialVelocity;
    this.ui2_1 = onRemainingScrollOffsetUpdate;
  }
  protoOf($flingCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.ri2_1.mi3_1;
            suspendResult = withContext(tmp_0, SnapFlingBehavior$fling$slambda_0(this.ri2_1, this.ti2_1, this.ui2_1, this.si2_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            this.ui2_1(0.0);
            return result;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $tryApproachCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, offset, velocity, updateRemainingScrollOffset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.di3_1 = _this__u8e3s4;
    this.ei3_1 = _this__u8e3s4_0;
    this.fi3_1 = offset;
    this.gi3_1 = velocity;
    this.hi3_1 = updateRemainingScrollOffset;
  }
  protoOf($tryApproachCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp_0;
            var this_0 = this.fi3_1;
            if (Math.abs(this_0) === 0.0) {
              tmp_0 = true;
            } else {
              var this_1 = this.gi3_1;
              tmp_0 = Math.abs(this_1) === 0.0;
            }

            if (tmp_0) {
              var tmp_1 = this;
              tmp_1.ii3_1 = AnimationState(this.fi3_1, this.gi3_1);
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = runApproach(this.di3_1, this.ei3_1, this.fi3_1, this.gi3_1, this.hi3_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.ii3_1 = suspendResult.pi4_1;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            throw this.q9_1;
          case 3:
            return this.ii3_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function SnapFlingBehavior(snapLayoutInfoProvider, decayAnimationSpec, snapAnimationSpec) {
    this.ji3_1 = snapLayoutInfoProvider;
    this.ki3_1 = decayAnimationSpec;
    this.li3_1 = snapAnimationSpec;
    this.mi3_1 = get_DefaultScrollMotionDurationScale();
  }
  protoOf(SnapFlingBehavior).qhv = function (_this__u8e3s4, initialVelocity, onRemainingDistanceUpdated, $completion) {
    var tmp = new $performFlingCOROUTINE$(this, _this__u8e3s4, initialVelocity, onRemainingDistanceUpdated, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SnapFlingBehavior).equals = function (other) {
    var tmp;
    if (other instanceof SnapFlingBehavior) {
      tmp = (equals(other.li3_1, this.li3_1) && equals(other.ki3_1, this.ki3_1) && equals(other.ji3_1, this.ji3_1));
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SnapFlingBehavior).hashCode = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.let' call
    var it = imul(31, 0) + hashCode(this.li3_1) | 0;
    // Inline function 'kotlin.let' call
    var it_0 = imul(31, it) + hashCode(this.ki3_1) | 0;
    return imul(31, it_0) + hashCode(this.ji3_1) | 0;
  };
  function AnimationResult(remainingOffset, currentAnimationState) {
    this.oi4_1 = remainingOffset;
    this.pi4_1 = currentAnimationState;
  }
  protoOf(AnimationResult).zh = function () {
    return this.oi4_1;
  };
  protoOf(AnimationResult).ai = function () {
    return this.pi4_1;
  };
  function animateWithTarget(_this__u8e3s4, targetOffset, cancelOffset, animationState, animationSpec, onAnimationStep, $completion) {
    var tmp = new $animateWithTargetCOROUTINE$(_this__u8e3s4, targetOffset, cancelOffset, animationState, animationSpec, onAnimationStep, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function $approachAnimationCOROUTINE$(_this__u8e3s4, scope, offset, velocity, onAnimationStep, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.oi5_1 = _this__u8e3s4;
    this.pi5_1 = scope;
    this.qi5_1 = offset;
    this.ri5_1 = velocity;
    this.si5_1 = onAnimationStep;
  }
  protoOf($approachAnimationCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var animationState = AnimationState(0.0, this.ri5_1);
            var $this$with = this.pi5_1;
            this.n9_1 = 1;
            suspendResult = animateDecay_0($this$with, this.qi5_1, animationState, this.oi5_1.ti5_1, this.si5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function DecayApproachAnimation(decayAnimationSpec) {
    this.ti5_1 = decayAnimationSpec;
  }
  protoOf(DecayApproachAnimation).ui5 = function (scope, offset, velocity, onAnimationStep, $completion) {
    var tmp = new $approachAnimationCOROUTINE$(this, scope, offset, velocity, onAnimationStep, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DecayApproachAnimation).vi5 = function (scope, offset, velocity, onAnimationStep, $completion) {
    var tmp = (!(offset == null) ? typeof offset === 'number' : false) ? offset : THROW_CCE();
    return this.ui5(scope, tmp, (!(velocity == null) ? typeof velocity === 'number' : false) ? velocity : THROW_CCE(), onAnimationStep, $completion);
  };
  function $approachAnimationCOROUTINE$_0(_this__u8e3s4, scope, offset, velocity, onAnimationStep, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ei6_1 = _this__u8e3s4;
    this.fi6_1 = scope;
    this.gi6_1 = offset;
    this.hi6_1 = velocity;
    this.ii6_1 = onAnimationStep;
  }
  protoOf($approachAnimationCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var animationState = AnimationState(0.0, this.hi6_1);
            var this_0 = this.gi6_1;
            var tmp_0 = Math.abs(this_0);
            var x = this.hi6_1;
            var targetOffset = tmp_0 * sign(x);
            var $this$with = this.fi6_1;
            this.n9_1 = 1;
            suspendResult = animateWithTarget($this$with, targetOffset, this.gi6_1, animationState, this.ei6_1.ji6_1, this.ii6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function TargetApproachAnimation(animationSpec) {
    this.ji6_1 = animationSpec;
  }
  protoOf(TargetApproachAnimation).ui5 = function (scope, offset, velocity, onAnimationStep, $completion) {
    var tmp = new $approachAnimationCOROUTINE$_0(this, scope, offset, velocity, onAnimationStep, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TargetApproachAnimation).vi5 = function (scope, offset, velocity, onAnimationStep, $completion) {
    var tmp = (!(offset == null) ? typeof offset === 'number' : false) ? offset : THROW_CCE();
    return this.ui5(scope, tmp, (!(velocity == null) ? typeof velocity === 'number' : false) ? velocity : THROW_CCE(), onAnimationStep, $completion);
  };
  function approach(_this__u8e3s4, initialTargetOffset, initialVelocity, animation, onAnimationStep, $completion) {
    return animation.vi5(_this__u8e3s4, initialTargetOffset, initialVelocity, onAnimationStep, $completion);
  }
  function coerceToTarget(_this__u8e3s4, target) {
    _init_properties_SnapFlingBehavior_kt__1y2evi();
    if (target === 0.0)
      return 0.0;
    return target > 0 ? coerceAtMost_0(_this__u8e3s4, target) : coerceAtLeast(_this__u8e3s4, target);
  }
  function animateDecay_0(_this__u8e3s4, targetOffset, animationState, decayAnimationSpec, onAnimationStep, $completion) {
    var tmp = new $animateDecayCOROUTINE$(_this__u8e3s4, targetOffset, animationState, decayAnimationSpec, onAnimationStep, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function calculateFinalOffset$isValidDistance(_this__u8e3s4) {
    return !(_this__u8e3s4 === Infinity) && !(_this__u8e3s4 === -Infinity);
  }
  function animateWithTarget$lambda($cancelOffset, $consumedUpToNow, $this_animateWithTarget, $onAnimationStep) {
    return function ($this$animateTo) {
      var realValue = coerceToTarget($this$animateTo.u1(), $cancelOffset);
      var delta = realValue - $consumedUpToNow._v;
      var consumed = 0.0;
      var tmp;
      try {
        consumed = $this_animateWithTarget.bh7(delta);
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof CancellationException) {
          var _unused_var__etf5q3 = $p;
          $this$animateTo.hea();
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      $onAnimationStep(consumed);
      var tmp_1;
      var tmp_2;
      // Inline function 'kotlin.math.abs' call
      var x = delta - consumed;
      if (Math.abs(x) > 0.5) {
        tmp_2 = true;
      } else {
        tmp_2 = !(realValue === $this$animateTo.u1());
      }
      if (tmp_2) {
        $this$animateTo.hea();
        tmp_1 = Unit_instance;
      }
      $consumedUpToNow._v = $consumedUpToNow._v + consumed;
      return Unit_instance;
    };
  }
  function animateDecay$consumeDelta(_this__u8e3s4, $this_animateDecay, $onAnimationStep, delta) {
    var consumed = 0.0;
    try {
      consumed = $this_animateDecay.bh7(delta);
    } catch ($p) {
      if ($p instanceof CancellationException) {
        var _unused_var__etf5q3 = $p;
        _this__u8e3s4.hea();
      } else {
        throw $p;
      }
    }
    $onAnimationStep(consumed);
    // Inline function 'kotlin.math.abs' call
    var x = delta - consumed;
    if (Math.abs(x) > 0.5) {
      _this__u8e3s4.hea();
    }
  }
  function animateDecay$lambda($targetOffset, $previousValue, $this_animateDecay, $onAnimationStep) {
    return function ($this$animateDecay) {
      var tmp;
      // Inline function 'kotlin.math.abs' call
      var x = $this$animateDecay.u1();
      var tmp_0 = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = $targetOffset;
      if (tmp_0 >= Math.abs(x_0)) {
        var finalValue = coerceToTarget($this$animateDecay.u1(), $targetOffset);
        var finalDelta = finalValue - $previousValue._v;
        animateDecay$consumeDelta($this$animateDecay, $this_animateDecay, $onAnimationStep, finalDelta);
        $this$animateDecay.hea();
        $previousValue._v = finalValue;
        tmp = Unit_instance;
      } else {
        var delta = $this$animateDecay.u1() - $previousValue._v;
        animateDecay$consumeDelta($this$animateDecay, $this_animateDecay, $onAnimationStep, delta);
        $previousValue._v = $this$animateDecay.u1();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function $animateWithTargetCOROUTINE$(_this__u8e3s4, targetOffset, cancelOffset, animationState, animationSpec, onAnimationStep, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yi4_1 = _this__u8e3s4;
    this.zi4_1 = targetOffset;
    this.ai5_1 = cancelOffset;
    this.bi5_1 = animationState;
    this.ci5_1 = animationSpec;
    this.di5_1 = onAnimationStep;
  }
  protoOf($animateWithTargetCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.ei5_1 = {_v: 0.0};
            this.fi5_1 = this.bi5_1.eec();
            this.n9_1 = 1;
            var tmp_0 = !(this.bi5_1.eec() === 0.0);
            suspendResult = animateTo(this.bi5_1, this.zi4_1, this.ci5_1, tmp_0, animateWithTarget$lambda(this.ai5_1, this.ei5_1, this.yi4_1, this.di5_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (false) {
              println('SnapFlingBehavior: ' + ('Snap Animation: Proposed Offset=' + this.zi4_1 + ' Achieved Offset=' + this.ei5_1._v));
            }

            var finalVelocity = coerceToTarget(this.bi5_1.eec(), this.fi5_1);
            return new AnimationResult(this.zi4_1 - this.ei5_1._v, copy(this.bi5_1, VOID, finalVelocity));
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $animateDecayCOROUTINE$(_this__u8e3s4, targetOffset, animationState, decayAnimationSpec, onAnimationStep, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.si6_1 = _this__u8e3s4;
    this.ti6_1 = targetOffset;
    this.ui6_1 = animationState;
    this.vi6_1 = decayAnimationSpec;
    this.wi6_1 = onAnimationStep;
  }
  protoOf($animateDecayCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.xi6_1 = {_v: 0.0};
            this.n9_1 = 1;
            var tmp_0 = !(this.ui6_1.eec() === 0.0);
            suspendResult = animateDecay(this.ui6_1, this.vi6_1, tmp_0, animateDecay$lambda(this.ti6_1, this.xi6_1, this.si6_1, this.wi6_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (false) {
              println('SnapFlingBehavior: ' + ('Decay Animation: Proposed Offset=' + this.ti6_1 + ' Achieved Offset=' + this.xi6_1._v));
            }

            return new AnimationResult(this.ti6_1 - this.xi6_1._v, this.ui6_1);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_SnapFlingBehavior_kt_r96zw;
  function _init_properties_SnapFlingBehavior_kt__1y2evi() {
    if (!properties_initialized_SnapFlingBehavior_kt_r96zw) {
      properties_initialized_SnapFlingBehavior_kt_r96zw = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      MinFlingVelocityDp = _Dp___init__impl__ms3zkb(400);
      androidx_compose_foundation_gestures_snapping_SnapFlingBehavior$stable = 0;
    }
  }
  function SnapLayoutInfoProvider_1() {
  }
  var androidx_compose_foundation_gestures_snapping_SnapPosition_Center$stable;
  var androidx_compose_foundation_gestures_snapping_SnapPosition_Start$stable;
  var androidx_compose_foundation_gestures_snapping_SnapPosition_End$stable;
  function Center() {
  }
  protoOf(Center).yi6 = function (layoutSize, itemSize, beforeContentPadding, afterContentPadding, itemIndex, itemCount) {
    var availableLayoutSpace = (layoutSize - beforeContentPadding | 0) - afterContentPadding | 0;
    return (availableLayoutSpace / 2 | 0) - (itemSize / 2 | 0) | 0;
  };
  protoOf(Center).toString = function () {
    return 'Center';
  };
  var Center_instance;
  function Center_getInstance() {
    return Center_instance;
  }
  function Start() {
  }
  protoOf(Start).yi6 = function (layoutSize, itemSize, beforeContentPadding, afterContentPadding, itemIndex, itemCount) {
    return 0;
  };
  protoOf(Start).toString = function () {
    return 'Start';
  };
  var Start_instance;
  function Start_getInstance() {
    return Start_instance;
  }
  function calculateDistanceToDesiredSnapPosition(mainAxisViewPortSize, beforeContentPadding, afterContentPadding, itemSize, itemOffset, itemIndex, snapPosition, itemCount) {
    // Inline function 'kotlin.with' call
    var desiredDistance = snapPosition.yi6(mainAxisViewPortSize, itemSize, beforeContentPadding, afterContentPadding, itemIndex, itemCount);
    return itemOffset - desiredDistance;
  }
  var androidx_compose_foundation_interaction_DragInteraction_Start$stable;
  var androidx_compose_foundation_interaction_DragInteraction_Stop$stable;
  var androidx_compose_foundation_interaction_DragInteraction_Cancel$stable;
  function Start_0() {
  }
  function Stop(start) {
    this.zi6_1 = start;
  }
  function Cancel(start) {
    this.ai7_1 = start;
  }
  var androidx_compose_foundation_interaction_FocusInteraction_Focus$stable;
  var androidx_compose_foundation_interaction_FocusInteraction_Unfocus$stable;
  function collectIsFocusedAsState(_this__u8e3s4, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance_11().f30_1) {
      var value = mutableStateOf(false);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var isFocused = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(_this__u8e3s4) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid || it_0 === Companion_getInstance_11().f30_1) {
      var value_0 = collectIsFocusedAsState$slambda_0(_this__u8e3s4, isFocused, null);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp$ret$4 = tmp_0;
    LaunchedEffect(_this__u8e3s4, tmp$ret$4, $composer_0, 14 & $changed);
    return isFocused;
  }
  function Focus() {
  }
  function Unfocus(focus) {
    this.bi7_1 = focus;
  }
  function FocusInteraction() {
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_0(function_0) {
    this.ci7_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).a1v = function (value, $completion) {
    return this.ci7_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).q3 = function () {
    return this.ci7_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function collectIsFocusedAsState$slambda$slambda($focusInteractions, $isFocused, resultContinuation) {
    this.li7_1 = $focusInteractions;
    this.mi7_1 = $isFocused;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(collectIsFocusedAsState$slambda$slambda).zg1 = function (interaction, $completion) {
    var tmp = this.ag2(interaction, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(collectIsFocusedAsState$slambda$slambda).ja = function (p1, $completion) {
    return this.zg1((!(p1 == null) ? isInterface(p1, Interaction) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(collectIsFocusedAsState$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_subject = this.ni7_1;
          if (tmp0_subject instanceof Focus) {
            this.li7_1.j1(this.ni7_1);
          } else {
            if (tmp0_subject instanceof Unfocus) {
              this.li7_1.d3(this.ni7_1.bi7_1);
            }
          }
          var this_0 = this.li7_1;
          this.mi7_1.s21(!this_0.r());
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(collectIsFocusedAsState$slambda$slambda).ag2 = function (interaction, completion) {
    var i = new collectIsFocusedAsState$slambda$slambda(this.li7_1, this.mi7_1, completion);
    i.ni7_1 = interaction;
    return i;
  };
  function collectIsFocusedAsState$slambda$slambda_0($focusInteractions, $isFocused, resultContinuation) {
    var i = new collectIsFocusedAsState$slambda$slambda($focusInteractions, $isFocused, resultContinuation);
    return constructCallableReference(function (interaction, $completion) {
      return i.zg1(interaction, $completion);
    }, 1);
  }
  function collectIsFocusedAsState$slambda($this_collectIsFocusedAsState, $isFocused, resultContinuation) {
    this.wi7_1 = $this_collectIsFocusedAsState;
    this.xi7_1 = $isFocused;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(collectIsFocusedAsState$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(collectIsFocusedAsState$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(collectIsFocusedAsState$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var focusInteractions = ArrayList_init_$Create$();
            this.n9_1 = 1;
            var tmp_0 = this.wi7_1.eg3();
            var tmp_1 = collectIsFocusedAsState$slambda$slambda_0(focusInteractions, this.xi7_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(collectIsFocusedAsState$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new collectIsFocusedAsState$slambda(this.wi7_1, this.xi7_1, completion);
    i.yi7_1 = $this$LaunchedEffect;
    return i;
  };
  function collectIsFocusedAsState$slambda_0($this_collectIsFocusedAsState, $isFocused, resultContinuation) {
    var i = new collectIsFocusedAsState$slambda($this_collectIsFocusedAsState, $isFocused, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  var androidx_compose_foundation_interaction_HoverInteraction_Enter$stable;
  var androidx_compose_foundation_interaction_HoverInteraction_Exit$stable;
  function Enter() {
  }
  function Exit(enter) {
    this.zi7_1 = enter;
  }
  function collectIsHoveredAsState(_this__u8e3s4, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance_11().f30_1) {
      var value = mutableStateOf(false);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var isHovered = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(_this__u8e3s4) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid || it_0 === Companion_getInstance_11().f30_1) {
      var value_0 = collectIsHoveredAsState$slambda_0(_this__u8e3s4, isHovered, null);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp$ret$4 = tmp_0;
    LaunchedEffect(_this__u8e3s4, tmp$ret$4, $composer_0, 14 & $changed);
    return isHovered;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_1(function_0) {
    this.ai8_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).a1v = function (value, $completion) {
    return this.ai8_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).q3 = function () {
    return this.ai8_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function collectIsHoveredAsState$slambda$slambda($hoverInteractions, $isHovered, resultContinuation) {
    this.ji8_1 = $hoverInteractions;
    this.ki8_1 = $isHovered;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(collectIsHoveredAsState$slambda$slambda).zg1 = function (interaction, $completion) {
    var tmp = this.ag2(interaction, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(collectIsHoveredAsState$slambda$slambda).ja = function (p1, $completion) {
    return this.zg1((!(p1 == null) ? isInterface(p1, Interaction) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(collectIsHoveredAsState$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_subject = this.li8_1;
          if (tmp0_subject instanceof Enter) {
            this.ji8_1.j1(this.li8_1);
          } else {
            if (tmp0_subject instanceof Exit) {
              this.ji8_1.d3(this.li8_1.zi7_1);
            }
          }
          var this_0 = this.ji8_1;
          this.ki8_1.s21(!this_0.r());
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(collectIsHoveredAsState$slambda$slambda).ag2 = function (interaction, completion) {
    var i = new collectIsHoveredAsState$slambda$slambda(this.ji8_1, this.ki8_1, completion);
    i.li8_1 = interaction;
    return i;
  };
  function collectIsHoveredAsState$slambda$slambda_0($hoverInteractions, $isHovered, resultContinuation) {
    var i = new collectIsHoveredAsState$slambda$slambda($hoverInteractions, $isHovered, resultContinuation);
    return constructCallableReference(function (interaction, $completion) {
      return i.zg1(interaction, $completion);
    }, 1);
  }
  function collectIsHoveredAsState$slambda($this_collectIsHoveredAsState, $isHovered, resultContinuation) {
    this.ui8_1 = $this_collectIsHoveredAsState;
    this.vi8_1 = $isHovered;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(collectIsHoveredAsState$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(collectIsHoveredAsState$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(collectIsHoveredAsState$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var hoverInteractions = ArrayList_init_$Create$();
            this.n9_1 = 1;
            var tmp_0 = this.ui8_1.eg3();
            var tmp_1 = collectIsHoveredAsState$slambda$slambda_0(hoverInteractions, this.vi8_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_1(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(collectIsHoveredAsState$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new collectIsHoveredAsState$slambda(this.ui8_1, this.vi8_1, completion);
    i.wi8_1 = $this$LaunchedEffect;
    return i;
  };
  function collectIsHoveredAsState$slambda_0($this_collectIsHoveredAsState, $isHovered, resultContinuation) {
    var i = new collectIsHoveredAsState$slambda($this_collectIsHoveredAsState, $isHovered, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function Interaction() {
  }
  function funMutableInteractionSource() {
    return new MutableInteractionSourceImpl();
  }
  function MutableInteractionSourceImpl() {
    this.xi8_1 = MutableSharedFlow(VOID, 16, BufferOverflow_DROP_OLDEST_getInstance());
  }
  protoOf(MutableInteractionSourceImpl).eg3 = function () {
    return this.xi8_1;
  };
  protoOf(MutableInteractionSourceImpl).vfh = function (interaction, $completion) {
    return this.xi8_1.a1v(interaction, $completion);
  };
  protoOf(MutableInteractionSourceImpl).efo = function (interaction) {
    return this.xi8_1.i1z(interaction);
  };
  var androidx_compose_foundation_interaction_PressInteraction_Press$stable;
  var androidx_compose_foundation_interaction_PressInteraction_Release$stable;
  var androidx_compose_foundation_interaction_PressInteraction_Cancel$stable;
  function Press(pressPosition) {
    this.yi8_1 = pressPosition;
  }
  function Release(press) {
    this.zi8_1 = press;
  }
  function Cancel_0(press) {
    this.ai9_1 = press;
  }
  function PressInteraction() {
  }
  function throwIllegalArgumentException(message) {
    throw IllegalArgumentException_init_$Create$(message);
  }
  function throwIndexOutOfBoundsException(message) {
    throw IndexOutOfBoundsException_init_$Create$(message);
  }
  function throwIllegalArgumentExceptionForNullCheck(message) {
    throw IllegalArgumentException_init_$Create$(message);
  }
  function throwIllegalStateException(message) {
    throw IllegalStateException_init_$Create$(message);
  }
  function throwIllegalStateExceptionForNullCheck(message) {
    throw IllegalStateException_init_$Create$(message);
  }
  function LazyRow(modifier, state, contentPadding, reverseLayout, horizontalArrangement, verticalAlignment, flingBehavior, userScrollEnabled, overscrollEffect, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var state_0 = {_v: state};
    var contentPadding_0 = {_v: contentPadding};
    var reverseLayout_0 = {_v: reverseLayout};
    var horizontalArrangement_0 = {_v: horizontalArrangement};
    var verticalAlignment_0 = {_v: verticalAlignment};
    var flingBehavior_0 = {_v: flingBehavior};
    var userScrollEnabled_0 = {_v: userScrollEnabled};
    var overscrollEffect_0 = {_v: overscrollEffect};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1884325601);
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | (($default & 2) === 0 && $composer_0.k31(state_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(contentPadding_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(reverseLayout_0._v) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | (($default & 16) === 0 && $composer_0.k31(horizontalArrangement_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.k31(verticalAlignment_0._v) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | (($default & 64) === 0 && $composer_0.k31(flingBehavior_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.l31(userScrollEnabled_0._v) ? 8388608 : 4194304);
    if (($changed & 100663296) === 0)
      $dirty = $dirty | (($default & 256) === 0 && $composer_0.k31(overscrollEffect_0._v) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 536870912 : 268435456);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 1) === 0)) {
          modifier_0._v = Companion_instance_0;
        }
        if (!(($default & 2) === 0)) {
          state_0._v = rememberLazyListState(0, 0, $composer_0, 0, 3);
          $dirty = $dirty & -113;
        }
        if (!(($default & 4) === 0)) {
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
          contentPadding_0._v = PaddingValues(tmp$ret$0);
        }
        if (!(($default & 8) === 0)) {
          reverseLayout_0._v = false;
        }
        if (!(($default & 16) === 0)) {
          horizontalArrangement_0._v = !reverseLayout_0._v ? Arrangement_getInstance().qdp_1 : Arrangement_getInstance().rdp_1;
          $dirty = $dirty & -57345;
        }
        if (!(($default & 32) === 0)) {
          verticalAlignment_0._v = Companion_getInstance_12().t8t_1;
        }
        if (!(($default & 64) === 0)) {
          flingBehavior_0._v = ScrollableDefaults_instance.mh7($composer_0, 6);
          $dirty = $dirty & -3670017;
        }
        if (!(($default & 128) === 0)) {
          userScrollEnabled_0._v = true;
        }
        if (!(($default & 256) === 0)) {
          overscrollEffect_0._v = rememberOverscrollEffect($composer_0, 0);
          $dirty = $dirty & -234881025;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 2) === 0))
          $dirty = $dirty & -113;
        if (!(($default & 16) === 0))
          $dirty = $dirty & -57345;
        if (!(($default & 64) === 0))
          $dirty = $dirty & -3670017;
        if (!(($default & 256) === 0))
          $dirty = $dirty & -234881025;
      }
      $composer_0.r30();
      var tmp = modifier_0._v;
      var tmp_0 = state_0._v;
      var tmp_1 = contentPadding_0._v;
      var tmp_2 = reverseLayout_0._v;
      var tmp_3 = flingBehavior_0._v;
      var tmp_4 = userScrollEnabled_0._v;
      var tmp_5 = overscrollEffect_0._v;
      LazyList(tmp, tmp_0, tmp_1, tmp_2, false, tmp_3, tmp_4, tmp_5, 0, null, null, verticalAlignment_0._v, horizontalArrangement_0._v, content, $composer_0, 24576 | 14 & $dirty | 112 & $dirty | 896 & $dirty | 7168 & $dirty | 458752 & $dirty >> 3 | 3670016 & $dirty >> 3 | 29360128 & $dirty >> 3, 112 & $dirty >> 12 | 896 & $dirty >> 6 | 7168 & $dirty >> 18, 1792);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(LazyRow$lambda(modifier_0, state_0, contentPadding_0, reverseLayout_0, horizontalArrangement_0, verticalAlignment_0, flingBehavior_0, userScrollEnabled_0, overscrollEffect_0, content, $changed, $default));
    }
  }
  function LazyListScope$items$lambda(it) {
    return null;
  }
  function LazyListScope() {
  }
  function LazyColumn(modifier, state, contentPadding, reverseLayout, verticalArrangement, horizontalAlignment, flingBehavior, userScrollEnabled, overscrollEffect, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var state_0 = {_v: state};
    var contentPadding_0 = {_v: contentPadding};
    var reverseLayout_0 = {_v: reverseLayout};
    var verticalArrangement_0 = {_v: verticalArrangement};
    var horizontalAlignment_0 = {_v: horizontalAlignment};
    var flingBehavior_0 = {_v: flingBehavior};
    var userScrollEnabled_0 = {_v: userScrollEnabled};
    var overscrollEffect_0 = {_v: overscrollEffect};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(53695811);
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | (($default & 2) === 0 && $composer_0.k31(state_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(contentPadding_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(reverseLayout_0._v) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | (($default & 16) === 0 && $composer_0.k31(verticalArrangement_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.k31(horizontalAlignment_0._v) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | (($default & 64) === 0 && $composer_0.k31(flingBehavior_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.l31(userScrollEnabled_0._v) ? 8388608 : 4194304);
    if (($changed & 100663296) === 0)
      $dirty = $dirty | (($default & 256) === 0 && $composer_0.k31(overscrollEffect_0._v) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 536870912 : 268435456);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 1) === 0)) {
          modifier_0._v = Companion_instance_0;
        }
        if (!(($default & 2) === 0)) {
          state_0._v = rememberLazyListState(0, 0, $composer_0, 0, 3);
          $dirty = $dirty & -113;
        }
        if (!(($default & 4) === 0)) {
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
          contentPadding_0._v = PaddingValues(tmp$ret$0);
        }
        if (!(($default & 8) === 0)) {
          reverseLayout_0._v = false;
        }
        if (!(($default & 16) === 0)) {
          verticalArrangement_0._v = !reverseLayout_0._v ? Arrangement_getInstance().sdp_1 : Arrangement_getInstance().tdp_1;
          $dirty = $dirty & -57345;
        }
        if (!(($default & 32) === 0)) {
          horizontalAlignment_0._v = Companion_getInstance_12().w8t_1;
        }
        if (!(($default & 64) === 0)) {
          flingBehavior_0._v = ScrollableDefaults_instance.mh7($composer_0, 6);
          $dirty = $dirty & -3670017;
        }
        if (!(($default & 128) === 0)) {
          userScrollEnabled_0._v = true;
        }
        if (!(($default & 256) === 0)) {
          overscrollEffect_0._v = rememberOverscrollEffect($composer_0, 0);
          $dirty = $dirty & -234881025;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 2) === 0))
          $dirty = $dirty & -113;
        if (!(($default & 16) === 0))
          $dirty = $dirty & -57345;
        if (!(($default & 64) === 0))
          $dirty = $dirty & -3670017;
        if (!(($default & 256) === 0))
          $dirty = $dirty & -234881025;
      }
      $composer_0.r30();
      var tmp = modifier_0._v;
      var tmp_0 = state_0._v;
      var tmp_1 = contentPadding_0._v;
      var tmp_2 = reverseLayout_0._v;
      var tmp_3 = flingBehavior_0._v;
      var tmp_4 = userScrollEnabled_0._v;
      var tmp_5 = overscrollEffect_0._v;
      var tmp_6 = horizontalAlignment_0._v;
      var tmp_7 = verticalArrangement_0._v;
      LazyList(tmp, tmp_0, tmp_1, tmp_2, true, tmp_3, tmp_4, tmp_5, 0, tmp_6, tmp_7, null, null, content, $composer_0, 24576 | 14 & $dirty | 112 & $dirty | 896 & $dirty | 7168 & $dirty | 458752 & $dirty >> 3 | 3670016 & $dirty >> 3 | 29360128 & $dirty >> 3 | 1879048192 & $dirty << 12, 14 & $dirty >> 12 | 7168 & $dirty >> 18, 6400);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(LazyColumn$lambda(modifier_0, state_0, contentPadding_0, reverseLayout_0, verticalArrangement_0, horizontalAlignment_0, flingBehavior_0, userScrollEnabled_0, overscrollEffect_0, content, $changed, $default));
    }
  }
  function LazyRow$lambda($modifier, $state, $contentPadding, $reverseLayout, $horizontalArrangement, $verticalAlignment, $flingBehavior, $userScrollEnabled, $overscrollEffect, $content, $$changed, $$default) {
    return function ($composer, $force) {
      LazyRow($modifier._v, $state._v, $contentPadding._v, $reverseLayout._v, $horizontalArrangement._v, $verticalAlignment._v, $flingBehavior._v, $userScrollEnabled._v, $overscrollEffect._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function LazyColumn$lambda($modifier, $state, $contentPadding, $reverseLayout, $verticalArrangement, $horizontalAlignment, $flingBehavior, $userScrollEnabled, $overscrollEffect, $content, $$changed, $$default) {
    return function ($composer, $force) {
      LazyColumn($modifier._v, $state._v, $contentPadding._v, $reverseLayout._v, $verticalArrangement._v, $horizontalAlignment._v, $flingBehavior._v, $userScrollEnabled._v, $overscrollEffect._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function LazyItemScope() {
  }
  var androidx_compose_foundation_lazy_LazyItemScopeImpl$stable;
  function LazyItemScopeImpl() {
    this.hi9_1 = mutableIntStateOf(2147483647);
    this.ii9_1 = mutableIntStateOf(2147483647);
  }
  protoOf(LazyItemScopeImpl).ji9 = function (width, height) {
    this.hi9_1.a49(width);
    this.ii9_1.a49(height);
  };
  protoOf(LazyItemScopeImpl).fi9 = function (_this__u8e3s4, fraction) {
    var tmp0_widthState = this.hi9_1;
    return _this__u8e3s4.d8v(new ParentSizeElement(fraction, tmp0_widthState, VOID, 'fillParentMaxWidth'));
  };
  function ParentSizeElement(fraction, widthState, heightState, inspectorName) {
    widthState = widthState === VOID ? null : widthState;
    heightState = heightState === VOID ? null : heightState;
    ModifierNodeElement.call(this);
    this.li9_1 = fraction;
    this.mi9_1 = widthState;
    this.ni9_1 = heightState;
    this.oi9_1 = inspectorName;
  }
  protoOf(ParentSizeElement).r3d = function () {
    return new ParentSizeNode(this.li9_1, this.mi9_1, this.ni9_1);
  };
  protoOf(ParentSizeElement).pi9 = function (node) {
    node.eia_1 = this.li9_1;
    node.fia_1 = this.mi9_1;
    node.gia_1 = this.ni9_1;
  };
  protoOf(ParentSizeElement).d8y = function (node) {
    return this.pi9(node instanceof ParentSizeNode ? node : THROW_CCE());
  };
  protoOf(ParentSizeElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ParentSizeElement))
      return false;
    return this.li9_1 === other.li9_1 && equals(this.mi9_1, other.mi9_1) && equals(this.ni9_1, other.ni9_1);
  };
  protoOf(ParentSizeElement).hashCode = function () {
    var tmp0_safe_receiver = this.mi9_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.ni9_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : hashCode(tmp2_safe_receiver);
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    result = imul(31, result) + getNumberHashCode(this.li9_1) | 0;
    return result;
  };
  function ParentSizeNode$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.jal($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function ParentSizeNode(fraction, widthState, heightState) {
    widthState = widthState === VOID ? null : widthState;
    heightState = heightState === VOID ? null : heightState;
    Node.call(this);
    this.eia_1 = fraction;
    this.fia_1 = widthState;
    this.gia_1 = heightState;
  }
  protoOf(ParentSizeNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var tmp0_safe_receiver = this.fia_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0;
      if (!(tmp0_safe_receiver.u1() === 2147483647)) {
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var this_0 = tmp0_safe_receiver.u1() * this.eia_1;
        var tmp_1;
        if (isNaN_0(this_0)) {
          tmp_1 = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp_1 = roundToInt(this_0);
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = 2147483647;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var width = tmp1_elvis_lhs == null ? 2147483647 : tmp1_elvis_lhs;
    var tmp2_safe_receiver = this.gia_1;
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_3;
      if (!(tmp2_safe_receiver.u1() === 2147483647)) {
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var this_1 = tmp2_safe_receiver.u1() * this.eia_1;
        var tmp_4;
        if (isNaN_0(this_1)) {
          tmp_4 = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp_4 = roundToInt(this_1);
        }
        tmp_3 = tmp_4;
      } else {
        tmp_3 = 2147483647;
      }
      tmp_2 = tmp_3;
    }
    var tmp3_elvis_lhs = tmp_2;
    var height = tmp3_elvis_lhs == null ? 2147483647 : tmp3_elvis_lhs;
    var tmp4_minWidth = !(width === 2147483647) ? width : _Constraints___get_minWidth__impl__hi9lfi(constraints);
    var tmp5_minHeight = !(height === 2147483647) ? height : _Constraints___get_minHeight__impl__ev4bgx(constraints);
    var tmp6_maxWidth = !(width === 2147483647) ? width : _Constraints___get_maxWidth__impl__uuyqc(constraints);
    var tmp7_maxHeight = !(height === 2147483647) ? height : _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    var childConstraints = Constraints_0(tmp4_minWidth, tmp6_maxWidth, tmp5_minHeight, tmp7_maxHeight);
    var placeable = measurable.h8y(childConstraints);
    var tmp_5 = placeable.i8y_1;
    var tmp_6 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp_5, tmp_6, VOID, ParentSizeNode$measure$lambda(placeable));
  };
  function LazyLayoutSemanticState(state, isVertical) {
    return new LazyLayoutSemanticState$1(state, isVertical);
  }
  function _get_totalItemsCount__f088iq($this) {
    var tmp0 = $this.hia_1;
    var tmp = KProperty1;
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('totalItemsCount', 1, tmp, LazyLayoutSemanticState$o$_get_totalItemsCount_$ref_c2v8wx(), null);
    return tmp0.u1();
  }
  function LazyLayoutSemanticState$o$totalItemsCount$delegate$lambda($state) {
    return function () {
      return $state.thz().ci0();
    };
  }
  function LazyLayoutSemanticState$o$_get_totalItemsCount_$ref_c2v8wx() {
    return constructCallableReference(function (p0) {
      return _get_totalItemsCount__f088iq(p0);
    }, 1, 0, 254);
  }
  function LazyLayoutSemanticState$1($state, $isVertical) {
    this.iia_1 = $state;
    this.jia_1 = $isVertical;
    var tmp = this;
    tmp.hia_1 = derivedStateOf(LazyLayoutSemanticState$o$totalItemsCount$delegate$lambda($state));
  }
  protoOf(LazyLayoutSemanticState$1).kia = function () {
    return estimatedLazyScrollOffset(this.iia_1.lia(), this.iia_1.mia());
  };
  protoOf(LazyLayoutSemanticState$1).nia = function () {
    return estimatedLazyMaxScrollOffset(this.iia_1.lia(), this.iia_1.mia(), this.iia_1.mg7());
  };
  protoOf(LazyLayoutSemanticState$1).oia = function (index, $completion) {
    return this.iia_1.pia(index, VOID, $completion);
  };
  protoOf(LazyLayoutSemanticState$1).qia = function () {
    var tmp;
    if (this.jia_1) {
      tmp = new CollectionInfo(_get_totalItemsCount__f088iq(this), 1);
    } else {
      tmp = new CollectionInfo(1, _get_totalItemsCount__f088iq(this));
    }
    return tmp;
  };
  protoOf(LazyLayoutSemanticState$1).ria = function () {
    var tmp;
    if (this.iia_1.thz().lhy().equals(Orientation_Vertical_getInstance())) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_0 = this.iia_1.thz().khy();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      tmp = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = this.iia_1.thz().khy();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      tmp = convertToInt(shiftRight(value_0, 32));
    }
    return tmp;
  };
  protoOf(LazyLayoutSemanticState$1).sia = function () {
    return this.iia_1.thz().yhz() + this.iia_1.thz().zhz() | 0;
  };
  function LazyList(modifier, state, contentPadding, reverseLayout, isVertical, flingBehavior, userScrollEnabled, overscrollEffect, beyondBoundsItemCount, horizontalAlignment, verticalArrangement, verticalAlignment, horizontalArrangement, content, $composer, $changed, $changed1, $default) {
    var beyondBoundsItemCount_0 = {_v: beyondBoundsItemCount};
    var horizontalAlignment_0 = {_v: horizontalAlignment};
    var verticalArrangement_0 = {_v: verticalArrangement};
    var verticalAlignment_0 = {_v: verticalAlignment};
    var horizontalArrangement_0 = {_v: horizontalArrangement};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(924924659);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(state) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(contentPadding) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(reverseLayout) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(isVertical) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.k31(flingBehavior) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.l31(userScrollEnabled) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.k31(overscrollEffect) ? 8388608 : 4194304);
    if (($changed & 100663296) === 0)
      $dirty = $dirty | (($default & 256) === 0 && $composer_0.m31(beyondBoundsItemCount_0._v) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.k31(horizontalAlignment_0._v) ? 536870912 : 268435456);
    if (!(($default & 1024) === 0))
      $dirty1 = $dirty1 | 6;
    else if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(verticalArrangement_0._v) ? 4 : 2);
    if (!(($default & 2048) === 0))
      $dirty1 = $dirty1 | 48;
    else if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(verticalAlignment_0._v) ? 32 : 16);
    if (!(($default & 4096) === 0))
      $dirty1 = $dirty1 | 384;
    else if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(horizontalArrangement_0._v) ? 256 : 128);
    if (($changed1 & 3072) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(content) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 1171) === 1170), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 256) === 0)) {
          beyondBoundsItemCount_0._v = defaultLazyListBeyondBoundsItemCount($composer_0, 0);
          $dirty = $dirty & -234881025;
        }
        if (!(($default & 512) === 0)) {
          horizontalAlignment_0._v = null;
        }
        if (!(($default & 1024) === 0)) {
          verticalArrangement_0._v = null;
        }
        if (!(($default & 2048) === 0)) {
          verticalAlignment_0._v = null;
        }
        if (!(($default & 4096) === 0)) {
          horizontalArrangement_0._v = null;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 256) === 0))
          $dirty = $dirty & -234881025;
      }
      $composer_0.r30();
      var itemProviderLambda = rememberLazyListItemProviderLambda(state, content, $composer_0, 14 & $dirty >> 3 | 112 & $dirty1 >> 6);
      var semanticState = rememberLazyListSemanticState(state, isVertical, $composer_0, 14 & $dirty >> 3 | 112 & $dirty >> 9);
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_1 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = LazyList$lambda;
      }
      var composer = $composer_1;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = createCompositionCoroutineScope(getContext(), composer);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var coroutineScope = tmp;
      var tmp0 = get_LocalGraphicsContext();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_2 = $composer_0;
      var graphicsContext = $composer_2.u31(tmp0);
      var tmp0_0 = get_LocalScrollCaptureInProgress();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_3 = $composer_0;
      var stickyHeadersEnabled = !$composer_3.u31(tmp0_0);
      var measurePolicy = rememberLazyListMeasurePolicy(itemProviderLambda, state, contentPadding, reverseLayout, isVertical, beyondBoundsItemCount_0._v, horizontalAlignment_0._v, verticalAlignment_0._v, horizontalArrangement_0._v, verticalArrangement_0._v, coroutineScope, graphicsContext, stickyHeadersEnabled ? Companion_getInstance_69().tia_1 : null, $composer_0, 112 & $dirty | 896 & $dirty | 7168 & $dirty | 57344 & $dirty | 458752 & $dirty >> 9 | 3670016 & $dirty >> 9 | 29360128 & $dirty1 << 18 | 234881024 & $dirty1 << 18 | 1879048192 & $dirty1 << 27, 0);
      var orientation = isVertical ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance();
      var tmp_0;
      if (userScrollEnabled) {
        $composer_0.m30(-2077147368);
        var tmp0_group = lazyLayoutBeyondBoundsModifier(Companion_instance_0, rememberLazyListBeyondBoundsState(state, beyondBoundsItemCount_0._v, $composer_0, 14 & $dirty >> 3 | 112 & $dirty >> 21), state.ihz_1, reverseLayout, orientation);
        $composer_0.n30();
        tmp_0 = tmp0_group;
      } else {
        $composer_0.m30(-2076718545);
        $composer_0.n30();
        tmp_0 = Companion_instance_0;
      }
      var beyondBoundsModifier = tmp_0;
      var tmp0_$receiver = lazyLayoutSemantics(modifier.d8v(state.fhz_1).d8v(state.ghz_1), itemProviderLambda, semanticState, orientation, userScrollEnabled, reverseLayout, $composer_0, 57344 & $dirty >> 6 | 458752 & $dirty << 6).d8v(beyondBoundsModifier).d8v(state.hhz_1.eib_1);
      var tmp1_interactionSource = state.yhy_1;
      var tmp2_modifier = scrollableArea_0(tmp0_$receiver, state, orientation, overscrollEffect, userScrollEnabled, reverseLayout, flingBehavior, tmp1_interactionSource);
      var tmp3_prefetchState = state.jhz_1;
      LazyLayout(itemProviderLambda, tmp2_modifier, tmp3_prefetchState, measurePolicy, $composer_0, 0, 0);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(LazyList$lambda_0(modifier, state, contentPadding, reverseLayout, isVertical, flingBehavior, userScrollEnabled, overscrollEffect, beyondBoundsItemCount_0, horizontalAlignment_0, verticalArrangement_0, verticalAlignment_0, horizontalArrangement_0, content, $changed, $changed1, $default));
    }
  }
  function rememberLazyListMeasurePolicy(itemProviderLambda, state, contentPadding, reverseLayout, isVertical, beyondBoundsItemCount, horizontalAlignment, verticalAlignment, horizontalArrangement, verticalArrangement, coroutineScope, graphicsContext, stickyItemsPlacement, $composer, $changed, $changed1) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!(!!(!!(!!(!!(!!(!!(!!((($changed & 112 ^ 48) > 32 && $composer_0.k31(state) || ($changed & 48) === 32) | (($changed & 896 ^ 384) > 256 && $composer_0.k31(contentPadding) || ($changed & 384) === 256)) | (($changed & 7168 ^ 3072) > 2048 && $composer_0.l31(reverseLayout) || ($changed & 3072) === 2048)) | (($changed & 57344 ^ 24576) > 16384 && $composer_0.l31(isVertical) || ($changed & 24576) === 16384)) | (($changed & 458752 ^ 196608) > 131072 && $composer_0.m31(beyondBoundsItemCount) || ($changed & 196608) === 131072)) | (($changed & 3670016 ^ 1572864) > 1048576 && $composer_0.k31(horizontalAlignment) || ($changed & 1572864) === 1048576)) | (($changed & 29360128 ^ 12582912) > 8388608 && $composer_0.k31(verticalAlignment) || ($changed & 12582912) === 8388608)) | (($changed & 234881024 ^ 100663296) > 67108864 && $composer_0.k31(horizontalArrangement) || ($changed & 100663296) === 67108864)) | (($changed & 1879048192 ^ 805306368) > 536870912 && $composer_0.k31(verticalArrangement) || ($changed & 805306368) === 536870912)) | $composer_0.k31(graphicsContext)) | (($changed1 & 896 ^ 384) > 256 && $composer_0.k31(stickyItemsPlacement) || ($changed1 & 384) === 256));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var tmp_0 = rememberLazyListMeasurePolicy$lambda(state, isVertical, contentPadding, reverseLayout, itemProviderLambda, verticalArrangement, horizontalArrangement, beyondBoundsItemCount, coroutineScope, graphicsContext, stickyItemsPlacement, horizontalAlignment, verticalAlignment);
      var value = new sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0(tmp_0);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function keepAroundItems(_this__u8e3s4, visibleItemsList, measuredItemProvider) {
    // Inline function 'androidx.compose.ui.util.trace' call
    var tmp;
    if (_this__u8e3s4.uib()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !visibleItemsList.r();
    } else {
      tmp = false;
    }
    if (tmp) {
      var firstVisibleItemIndex = first(visibleItemsList).vib_1;
      var lastVisibleItemIndex = last(visibleItemsList).vib_1;
      var inductionVariable = _this__u8e3s4.oib_1;
      if (inductionVariable < firstVisibleItemIndex)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          measuredItemProvider.zic(item);
        }
         while (inductionVariable < firstVisibleItemIndex);
      var inductionVariable_0 = lastVisibleItemIndex + 1 | 0;
      var last_0 = _this__u8e3s4.pib_1;
      if (inductionVariable_0 <= last_0)
        do {
          var item_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          measuredItemProvider.zic(item_0);
        }
         while (!(item_0 === last_0));
    }
  }
  function sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0(function_0) {
    this.aid_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0).bid = function (_this__u8e3s4, constraints) {
    return this.aid_1(_this__u8e3s4, new Constraints(constraints));
  };
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0).q3 = function () {
    return this.aid_1;
  };
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, LazyLayoutMeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function LazyList$lambda() {
    return EmptyCoroutineContext_getInstance();
  }
  function LazyList$lambda_0($modifier, $state, $contentPadding, $reverseLayout, $isVertical, $flingBehavior, $userScrollEnabled, $overscrollEffect, $beyondBoundsItemCount, $horizontalAlignment, $verticalArrangement, $verticalAlignment, $horizontalArrangement, $content, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      LazyList($modifier, $state, $contentPadding, $reverseLayout, $isVertical, $flingBehavior, $userScrollEnabled, $overscrollEffect, $beyondBoundsItemCount._v, $horizontalAlignment._v, $verticalArrangement._v, $verticalAlignment._v, $horizontalArrangement._v, $content, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function rememberLazyListMeasurePolicy$1($isVertical, $horizontalAlignment, $verticalAlignment, $reverseLayout, $state, $contentConstraints, $itemProvider, $this_LazyLayoutMeasurePolicy, $itemsCount, $spaceBetweenItems, $beforeContentPadding, $afterContentPadding, $visualItemOffset) {
    this.mid_1 = $isVertical;
    this.nid_1 = $horizontalAlignment;
    this.oid_1 = $verticalAlignment;
    this.pid_1 = $reverseLayout;
    this.qid_1 = $state;
    this.gid_1 = $this_LazyLayoutMeasurePolicy;
    this.hid_1 = $itemsCount;
    this.iid_1 = $spaceBetweenItems;
    this.jid_1 = $beforeContentPadding;
    this.kid_1 = $afterContentPadding;
    this.lid_1 = $visualItemOffset;
    LazyListMeasuredItemProvider.call(this, $contentConstraints, $isVertical, $itemProvider, $this_LazyLayoutMeasurePolicy);
  }
  protoOf(rememberLazyListMeasurePolicy$1).rid = function (index, key, contentType, placeables, constraints) {
    var spacing = index === (this.hid_1 - 1 | 0) ? 0 : this.iid_1;
    return new LazyListMeasuredItem(index, placeables, this.mid_1, this.nid_1, this.oid_1, this.gid_1.r6p(), this.pid_1, this.jid_1, this.kid_1, spacing, this.lid_1, key, contentType, this.qid_1.hhz_1, constraints);
  };
  function rememberLazyListMeasurePolicy$lambda$lambda($this_LazyLayoutMeasurePolicy, $containerConstraints, $totalHorizontalPadding, $totalVerticalPadding) {
    return function (width, height, placement) {
      return $this_LazyLayoutMeasurePolicy.kag(constrainWidth($containerConstraints, width + $totalHorizontalPadding | 0), constrainHeight($containerConstraints, height + $totalVerticalPadding | 0), emptyMap(), placement);
    };
  }
  function rememberLazyListMeasurePolicy$lambda($state, $isVertical, $contentPadding, $reverseLayout, $itemProviderLambda, $verticalArrangement, $horizontalArrangement, $beyondBoundsItemCount, $coroutineScope, $graphicsContext, $stickyItemsPlacement, $horizontalAlignment, $verticalAlignment) {
    return function ($this$LazyLayoutMeasurePolicy, containerConstraints) {
      ObservableScopeInvalidator__attachToScope_impl_wvvw97($state.ohz_1);
      var hasLookaheadOccurred = $state.thy_1 || $this$LazyLayoutMeasurePolicy.jag();
      checkScrollableContainerConstraints(containerConstraints.m5e_1, $isVertical ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance());
      var tmp;
      if ($isVertical) {
        tmp = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.adw($this$LazyLayoutMeasurePolicy.r6p()));
      } else {
        tmp = $this$LazyLayoutMeasurePolicy.w5e(calculateStartPadding($contentPadding, $this$LazyLayoutMeasurePolicy.r6p()));
      }
      var startPadding = tmp;
      var tmp_0;
      if ($isVertical) {
        tmp_0 = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.zdv($this$LazyLayoutMeasurePolicy.r6p()));
      } else {
        tmp_0 = $this$LazyLayoutMeasurePolicy.w5e(calculateEndPadding($contentPadding, $this$LazyLayoutMeasurePolicy.r6p()));
      }
      var endPadding = tmp_0;
      var topPadding = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.fdw());
      var bottomPadding = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.gdw());
      var totalVerticalPadding = topPadding + bottomPadding | 0;
      var totalHorizontalPadding = startPadding + endPadding | 0;
      var totalMainAxisPadding = $isVertical ? totalVerticalPadding : totalHorizontalPadding;
      var beforeContentPadding = $isVertical && !$reverseLayout ? topPadding : $isVertical && $reverseLayout ? bottomPadding : !$isVertical && !$reverseLayout ? startPadding : endPadding;
      var afterContentPadding = totalMainAxisPadding - beforeContentPadding | 0;
      var contentConstraints = offset(containerConstraints.m5e_1, -totalHorizontalPadding | 0, -totalVerticalPadding | 0);
      var itemProvider = $itemProviderLambda();
      itemProvider.zid().ji9(_Constraints___get_maxWidth__impl__uuyqc(contentConstraints), _Constraints___get_maxHeight__impl__dt3e8z(contentConstraints));
      var tmp_1;
      if ($isVertical) {
        // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
        var value = $verticalArrangement;
        if (value == null) {
          var tmp$ret$1 = 'null verticalArrangement when isVertical == true';
          throwIllegalArgumentExceptionForNullCheck(tmp$ret$1);
        }
        tmp_1 = value.zdp();
      } else {
        // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
        var value_0 = $horizontalArrangement;
        if (value_0 == null) {
          var tmp$ret$3 = 'null horizontalAlignment when isVertical == false';
          throwIllegalArgumentExceptionForNullCheck(tmp$ret$3);
        }
        tmp_1 = value_0.zdp();
      }
      var spaceBetweenItemsDp = tmp_1;
      var spaceBetweenItems = $this$LazyLayoutMeasurePolicy.w5e(spaceBetweenItemsDp);
      var itemsCount = itemProvider.aie();
      var tmp_2;
      if ($isVertical) {
        tmp_2 = _Constraints___get_maxHeight__impl__dt3e8z(containerConstraints.m5e_1) - totalVerticalPadding | 0;
      } else {
        tmp_2 = _Constraints___get_maxWidth__impl__uuyqc(containerConstraints.m5e_1) - totalHorizontalPadding | 0;
      }
      var mainAxisAvailableSize = tmp_2;
      var tmp_3;
      if (!$reverseLayout || mainAxisAvailableSize > 0) {
        // Inline function 'androidx.compose.ui.unit.IntOffset' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(startPadding), 32), bitwiseAnd(fromInt(topPadding), new Long(-1, 0)));
        tmp_3 = _IntOffset___init__impl__rq8h7b(tmp$ret$5);
      } else {
        var tmp0 = $isVertical ? startPadding : startPadding + mainAxisAvailableSize | 0;
        // Inline function 'androidx.compose.ui.unit.IntOffset' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2 = $isVertical ? topPadding + mainAxisAvailableSize | 0 : topPadding;
        var tmp$ret$7 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
        tmp_3 = _IntOffset___init__impl__rq8h7b(tmp$ret$7);
      }
      var visualItemOffset = tmp_3;
      var measuredItemProvider = new rememberLazyListMeasurePolicy$1($isVertical, $horizontalAlignment, $verticalAlignment, $reverseLayout, $state, contentConstraints, itemProvider, $this$LazyLayoutMeasurePolicy, itemsCount, spaceBetweenItems, beforeContentPadding, afterContentPadding, visualItemOffset);
      var firstVisibleItemIndex;
      var firstVisibleScrollOffset;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance_2.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance_2.q52(previousSnapshot);
        try {
          firstVisibleItemIndex = $state.bie(itemProvider, $state.lia());
          firstVisibleScrollOffset = $state.mia();
          break $l$block;
        }finally {
          Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
        }
      }
      var pinnedItems = calculateLazyLayoutPinnedIndices(itemProvider, $state.mhz_1, $state.ihz_1);
      var tmp_4;
      if ($this$LazyLayoutMeasurePolicy.jag() || !hasLookaheadOccurred) {
        tmp_4 = $state.zhy_1;
      } else {
        tmp_4 = $state.cie();
      }
      var scrollToBeConsumed = tmp_4;
      var tmp_5 = $this$LazyLayoutMeasurePolicy.jag();
      var tmp_6 = !$state.ahz_1;
      var measureResult = measureLazyList(itemsCount, measuredItemProvider, mainAxisAvailableSize, beforeContentPadding, afterContentPadding, spaceBetweenItems, firstVisibleItemIndex, firstVisibleScrollOffset, scrollToBeConsumed, contentConstraints, $isVertical, $verticalArrangement, $horizontalArrangement, $reverseLayout, $this$LazyLayoutMeasurePolicy, $state.hhz_1, $beyondBoundsItemCount, pinnedItems, hasLookaheadOccurred, tmp_5, $coroutineScope, $state.rhz_1, $graphicsContext, $stickyItemsPlacement, tmp_6, rememberLazyListMeasurePolicy$lambda$lambda($this$LazyLayoutMeasurePolicy, containerConstraints.m5e_1, totalHorizontalPadding, totalVerticalPadding));
      $state.die(measureResult, $this$LazyLayoutMeasurePolicy.jag());
      var tmp_7 = $state.shy_1;
      var tmp0_safe_receiver = tmp_7 instanceof CacheWindowLogic ? tmp_7 : null;
      if (tmp0_safe_receiver == null)
        null;
      else {
        keepAroundItems(tmp0_safe_receiver, measureResult.oie_1, measuredItemProvider);
      }
      return measureResult;
    };
  }
  var androidx_compose_foundation_lazy_LazyListBeyondBoundsState$stable;
  function rememberLazyListBeyondBoundsState(state, beyondBoundsItemCount, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(state) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.m31(beyondBoundsItemCount) || ($changed & 48) === 32));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = new LazyListBeyondBoundsState(state, beyondBoundsItemCount);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function LazyListBeyondBoundsState(state, beyondBoundsItemCount) {
    this.wie_1 = state;
    this.xie_1 = beyondBoundsItemCount;
  }
  protoOf(LazyListBeyondBoundsState).aie = function () {
    return this.wie_1.thz().ci0();
  };
  protoOf(LazyListBeyondBoundsState).yie = function () {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.wie_1.thz().uhz().r();
  };
  protoOf(LazyListBeyondBoundsState).zie = function () {
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = this.wie_1.lia() - this.xie_1 | 0;
    return Math.max(0, b);
  };
  protoOf(LazyListBeyondBoundsState).aif = function () {
    var tmp0 = this.aie() - 1 | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = last(this.wie_1.thz().uhz()).bi0() + this.xie_1 | 0;
    return Math.min(tmp0, b);
  };
  protoOf(LazyListBeyondBoundsState).bif = function () {
    if (this.wie_1.thz().uhz().r())
      return 0;
    var viewportSize = get_singleAxisViewportSize_0(this.wie_1.thz());
    var averageItemSize = visibleItemsAverageSize(this.wie_1.thz());
    if (averageItemSize === 0)
      return 1;
    return coerceAtLeast_0(viewportSize / averageItemSize | 0, 1);
  };
  var androidx_compose_foundation_lazy_LazyListCacheWindowStrategy$stable;
  var androidx_compose_foundation_lazy_LazyListCacheWindowScope$stable;
  var androidx_compose_foundation_lazy_LazyListIntervalContent$stable;
  var androidx_compose_foundation_lazy_LazyListInterval$stable;
  function LazyListIntervalContent$item$lambda($key) {
    return function (_unused_var__etf5q3) {
      return $key;
    };
  }
  function LazyListIntervalContent$item$lambda_0($contentType) {
    return function (it) {
      return $contentType;
    };
  }
  function ComposableLambda$invoke$ref_3(p0) {
    return constructCallableReference(function (p0_0, p1, p2, p3) {
      p0.v50(p0_0, p1, p2, p3);
      return Unit_instance;
    }, 4, 0, 255, VOID, [p0]);
  }
  function LazyListIntervalContent$item$lambda_1($content) {
    return function ($this$LazyListInterval, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$LazyListInterval) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 131) === 130), $dirty & 1)) {
        tmp_0 = $content($this$LazyListInterval, $composer_0, 14 & $dirty);
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function LazyListIntervalContent(content) {
    LazyLayoutIntervalContent.call(this);
    this.cif_1 = new MutableIntervalList();
    this.dif_1 = null;
    // Inline function 'kotlin.apply' call
    content(this);
  }
  protoOf(LazyListIntervalContent).eif = function () {
    return this.cif_1;
  };
  protoOf(LazyListIntervalContent).wid = function () {
    var tmp0_elvis_lhs = this.dif_1;
    return tmp0_elvis_lhs == null ? emptyIntList() : tmp0_elvis_lhs;
  };
  protoOf(LazyListIntervalContent).di9 = function (count, key, contentType, itemContent) {
    this.cif_1.iif(count, new LazyListInterval(key, contentType, itemContent));
  };
  protoOf(LazyListIntervalContent).bi9 = function (key, contentType, content) {
    var tmp;
    if (!(key == null)) {
      tmp = LazyListIntervalContent$item$lambda(key);
    } else {
      tmp = null;
    }
    var tmp_0 = tmp;
    var tmp_1 = LazyListIntervalContent$item$lambda_0(contentType);
    this.cif_1.iif(1, new LazyListInterval(tmp_0, tmp_1, ComposableLambda$invoke$ref_3(composableLambdaInstance(-857469575, true, LazyListIntervalContent$item$lambda_1(content)))));
  };
  function LazyListInterval(key, type, item) {
    this.lif_1 = key;
    this.mif_1 = type;
    this.nif_1 = item;
  }
  protoOf(LazyListInterval).t1 = function () {
    return this.lif_1;
  };
  protoOf(LazyListInterval).oif = function () {
    return this.mif_1;
  };
  function rememberLazyListItemProviderLambda(state, content, $composer, $changed) {
    var $composer_0 = $composer;
    var latestContent = rememberUpdatedState(content, $composer_0, 14 & $changed >> 3);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(state) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var scope = new LazyItemScopeImpl();
      var tmp_0 = referentialEqualityPolicy();
      var intervalContentState = derivedStateOf_0(tmp_0, rememberLazyListItemProviderLambda$lambda(latestContent));
      var tmp_1 = referentialEqualityPolicy();
      var itemProviderState = derivedStateOf_0(tmp_1, rememberLazyListItemProviderLambda$lambda_0(intervalContentState, state, scope));
      var tmp_2 = KProperty0;
      var value = getPropertyCallableRef('value', 0, tmp_2, State$_get_value_$ref_hr9f44(itemProviderState), null);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function LazyListItemProviderImpl$Item$lambda(this$0, $index) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var tmp0 = this$0.qif_1;
        // Inline function 'androidx.compose.foundation.lazy.layout.LazyLayoutIntervalContent.withInterval' call
        var globalIndex = $index;
        var interval = tmp0.eif().l1(globalIndex);
        var localIntervalIndex = globalIndex - interval.tif_1 | 0;
        interval.vif_1.nif_1(this$0.rif_1, localIntervalIndex, $composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function LazyListItemProviderImpl$Item$lambda_0($tmp0_rcvr, $index, $key, $$changed) {
    return function ($composer, $force) {
      $tmp0_rcvr.wif($index, $key, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function LazyListItemProviderImpl(state, intervalContent, itemScope, keyIndexMap) {
    this.pif_1 = state;
    this.qif_1 = intervalContent;
    this.rif_1 = itemScope;
    this.sif_1 = keyIndexMap;
  }
  protoOf(LazyListItemProviderImpl).zid = function () {
    return this.rif_1;
  };
  protoOf(LazyListItemProviderImpl).vid = function () {
    return this.sif_1;
  };
  protoOf(LazyListItemProviderImpl).aie = function () {
    return this.qif_1.aie();
  };
  protoOf(LazyListItemProviderImpl).wif = function (index, key, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-462424778);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.m31(index) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(key) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(this) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-824725566, true, LazyListItemProviderImpl$Item$lambda(this, index), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      LazyLayoutPinnableItem(key, index, this.pif_1.mhz_1, tmp$ret$0, $composer_0, 3072 | 14 & $dirty >> 3 | 112 & $dirty << 3);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(LazyListItemProviderImpl$Item$lambda_0(this, index, key, $changed));
    }
  };
  protoOf(LazyListItemProviderImpl).jif = function (index) {
    var tmp0_elvis_lhs = this.sif_1.jif(index);
    return tmp0_elvis_lhs == null ? this.qif_1.jif(index) : tmp0_elvis_lhs;
  };
  protoOf(LazyListItemProviderImpl).kif = function (index) {
    return this.qif_1.kif(index);
  };
  protoOf(LazyListItemProviderImpl).wid = function () {
    return this.qif_1.wid();
  };
  protoOf(LazyListItemProviderImpl).xif = function (key) {
    return this.sif_1.xif(key);
  };
  protoOf(LazyListItemProviderImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LazyListItemProviderImpl))
      return false;
    return equals(this.qif_1, other.qif_1);
  };
  protoOf(LazyListItemProviderImpl).hashCode = function () {
    return hashCode(this.qif_1);
  };
  function rememberLazyListItemProviderLambda$lambda($latestContent) {
    return function () {
      return new LazyListIntervalContent($latestContent.u1());
    };
  }
  function rememberLazyListItemProviderLambda$lambda_0($intervalContentState, $state, $scope) {
    return function () {
      var intervalContent = $intervalContentState.u1();
      var map = new NearestRangeKeyIndexMap($state.yif(), intervalContent);
      return new LazyListItemProviderImpl($state, intervalContent, $scope, map);
    };
  }
  function State$_get_value_$ref_hr9f44(p0) {
    return constructCallableReference(function () {
      return p0.u1();
    }, 0, 0, 256, VOID, [p0]);
  }
  function LazyListLayoutInfo() {
  }
  function visibleItemsAverageSize(_this__u8e3s4) {
    var visibleItems = _this__u8e3s4.uhz();
    if (visibleItems.r())
      return 0;
    // Inline function 'androidx.compose.ui.util.fastSumBy' call
    var sum = 0;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = visibleItems.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = visibleItems.l1(index);
        var tmp = sum;
        sum = tmp + item.n1() | 0;
      }
       while (inductionVariable <= last);
    var itemsSum = sum;
    return (itemsSum / visibleItems.n1() | 0) + _this__u8e3s4.big() | 0;
  }
  function measureLazyList(itemsCount, measuredItemProvider, mainAxisAvailableSize, beforeContentPadding, afterContentPadding, spaceBetweenItems, firstVisibleItemIndex, firstVisibleItemScrollOffset, scrollToBeConsumed, constraints, isVertical, verticalArrangement, horizontalArrangement, reverseLayout, density, itemAnimator, beyondBoundsItemCount, pinnedItems, hasLookaheadOccurred, isLookingAhead, coroutineScope, placementScopeInvalidator, graphicsContext, stickyItemsPlacement, shouldRunItemAnimation, layout) {
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(beforeContentPadding >= 0)) {
      var tmp$ret$1 = 'invalid beforeContentPadding';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(afterContentPadding >= 0)) {
      var tmp$ret$3 = 'invalid afterContentPadding';
      throwIllegalArgumentException(tmp$ret$3);
    }
    if (itemsCount <= 0) {
      var layoutWidth = _Constraints___get_minWidth__impl__hi9lfi(constraints);
      var layoutHeight = _Constraints___get_minHeight__impl__ev4bgx(constraints);
      var tmp0_layoutWidth = layoutWidth;
      var tmp1_layoutHeight = layoutHeight;
      // Inline function 'kotlin.collections.mutableListOf' call
      var tmp2_positionedItems = ArrayList_init_$Create$();
      var tmp3_keyIndexMap = measuredItemProvider.vid();
      itemAnimator.cig(0, tmp0_layoutWidth, tmp1_layoutHeight, tmp2_positionedItems, tmp3_keyIndexMap, measuredItemProvider, isVertical, isLookingAhead, 1, hasLookaheadOccurred, 0, 0, coroutineScope, graphicsContext);
      if (!isLookingAhead) {
        var disappearingItemsSize = itemAnimator.dig();
        if (!equals(disappearingItemsSize, Companion_getInstance_22().n5g_1)) {
          // Inline function 'androidx.compose.ui.unit.IntSize.width' call
          // Inline function 'androidx.compose.ui.util.unpackInt1' call
          var value = _IntSize___get_packedValue__impl__uho7jf(disappearingItemsSize);
          var tmp$ret$5 = convertToInt(shiftRight(value, 32));
          layoutWidth = constrainWidth(constraints, tmp$ret$5);
          // Inline function 'androidx.compose.ui.unit.IntSize.height' call
          // Inline function 'androidx.compose.ui.util.unpackInt2' call
          var value_0 = _IntSize___get_packedValue__impl__uho7jf(disappearingItemsSize);
          var tmp$ret$7 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
          layoutHeight = constrainHeight(constraints, tmp$ret$7);
        }
      }
      var tmp = layoutWidth;
      var tmp_0 = layoutHeight;
      var tmp4_measureResult = layout(tmp, tmp_0, measureLazyList$lambda);
      var tmp5_visibleItemsInfo = emptyList();
      var tmp6_viewportStartOffset = -beforeContentPadding | 0;
      var tmp7_viewportEndOffset = mainAxisAvailableSize + afterContentPadding | 0;
      var tmp8_orientation = isVertical ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance();
      var tmp9_childConstraints = measuredItemProvider.yic_1;
      return new LazyListMeasureResult(null, 0, false, 0.0, tmp4_measureResult, 0.0, false, coroutineScope, density, tmp9_childConstraints, tmp5_visibleItemsInfo, tmp6_viewportStartOffset, tmp7_viewportEndOffset, 0, reverseLayout, tmp8_orientation, afterContentPadding, spaceBetweenItems);
    } else {
      var currentFirstItemIndex = firstVisibleItemIndex;
      var currentFirstItemScrollOffset = firstVisibleItemScrollOffset;
      if (currentFirstItemIndex >= itemsCount) {
        currentFirstItemIndex = itemsCount - 1 | 0;
        currentFirstItemScrollOffset = 0;
      }
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var tmp_1;
      if (isNaN_0(scrollToBeConsumed)) {
        tmp_1 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_1 = roundToInt(scrollToBeConsumed);
      }
      var scrollDelta = tmp_1;
      currentFirstItemScrollOffset = currentFirstItemScrollOffset - scrollDelta | 0;
      if (currentFirstItemIndex === 0 && currentFirstItemScrollOffset < 0) {
        scrollDelta = scrollDelta + currentFirstItemScrollOffset | 0;
        currentFirstItemScrollOffset = 0;
      }
      var visibleItems = ArrayDeque_init_$Create$();
      var minOffset = (-beforeContentPadding | 0) + (spaceBetweenItems < 0 ? spaceBetweenItems : 0) | 0;
      var maxOffset = mainAxisAvailableSize;
      currentFirstItemScrollOffset = currentFirstItemScrollOffset + minOffset | 0;
      var maxCrossAxis = 0;
      var remeasureNeeded = false;
      while (currentFirstItemScrollOffset < 0 && currentFirstItemIndex > 0) {
        var previous = currentFirstItemIndex - 1 | 0;
        var measuredItem = measuredItemProvider.uid(previous);
        visibleItems.g3(0, measuredItem);
        var tmp0 = maxCrossAxis;
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = measuredItem.pic_1;
        maxCrossAxis = Math.max(tmp0, b);
        currentFirstItemScrollOffset = currentFirstItemScrollOffset + measuredItem.oic_1 | 0;
        currentFirstItemIndex = previous;
      }
      if (currentFirstItemScrollOffset < minOffset) {
        var notConsumedScrollDelta = minOffset - currentFirstItemScrollOffset | 0;
        currentFirstItemScrollOffset = minOffset;
        scrollDelta = scrollDelta - notConsumedScrollDelta | 0;
      }
      currentFirstItemScrollOffset = currentFirstItemScrollOffset - minOffset | 0;
      var index = currentFirstItemIndex;
      var maxMainAxis = coerceAtLeast_0(maxOffset + afterContentPadding | 0, 0);
      var currentMainAxisOffset = -currentFirstItemScrollOffset | 0;
      var indexInVisibleItems = 0;
      while (indexInVisibleItems < visibleItems.sg_1) {
        if (currentMainAxisOffset >= maxMainAxis) {
          visibleItems.h3(indexInVisibleItems);
          remeasureNeeded = true;
        } else {
          index = index + 1 | 0;
          currentMainAxisOffset = currentMainAxisOffset + visibleItems.l1(indexInVisibleItems).oic_1 | 0;
          indexInVisibleItems = indexInVisibleItems + 1 | 0;
        }
      }
      while (index < itemsCount && (currentMainAxisOffset < maxMainAxis || currentMainAxisOffset <= 0 || visibleItems.r())) {
        var measuredItem_0 = measuredItemProvider.uid(index);
        currentMainAxisOffset = currentMainAxisOffset + measuredItem_0.oic_1 | 0;
        if (currentMainAxisOffset <= minOffset && !(index === (itemsCount - 1 | 0))) {
          currentFirstItemIndex = index + 1 | 0;
          currentFirstItemScrollOffset = currentFirstItemScrollOffset - measuredItem_0.oic_1 | 0;
          remeasureNeeded = true;
        } else {
          var tmp0_0 = maxCrossAxis;
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_0 = measuredItem_0.pic_1;
          maxCrossAxis = Math.max(tmp0_0, b_0);
          visibleItems.j1(measuredItem_0);
        }
        index = index + 1 | 0;
      }
      var preScrollBackScrollDelta = scrollDelta;
      if (currentMainAxisOffset < maxOffset) {
        var toScrollBack = maxOffset - currentMainAxisOffset | 0;
        currentFirstItemScrollOffset = currentFirstItemScrollOffset - toScrollBack | 0;
        currentMainAxisOffset = currentMainAxisOffset + toScrollBack | 0;
        while (currentFirstItemScrollOffset < beforeContentPadding && currentFirstItemIndex > 0) {
          var previousIndex = currentFirstItemIndex - 1 | 0;
          var measuredItem_1 = measuredItemProvider.uid(previousIndex);
          visibleItems.g3(0, measuredItem_1);
          var tmp0_1 = maxCrossAxis;
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_1 = measuredItem_1.pic_1;
          maxCrossAxis = Math.max(tmp0_1, b_1);
          currentFirstItemScrollOffset = currentFirstItemScrollOffset + measuredItem_1.oic_1 | 0;
          currentFirstItemIndex = previousIndex;
        }
        scrollDelta = scrollDelta + toScrollBack | 0;
        if (currentFirstItemScrollOffset < 0) {
          scrollDelta = scrollDelta + currentFirstItemScrollOffset | 0;
          currentMainAxisOffset = currentMainAxisOffset + currentFirstItemScrollOffset | 0;
          currentFirstItemScrollOffset = 0;
        }
      }
      var tmp_2;
      var tmp_3;
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var tmp_4;
      if (isNaN_0(scrollToBeConsumed)) {
        tmp_4 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_4 = roundToInt(scrollToBeConsumed);
      }
      var tmp$ret$14 = tmp_4;
      if (get_sign(tmp$ret$14) === get_sign(scrollDelta)) {
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var tmp_5;
        if (isNaN_0(scrollToBeConsumed)) {
          tmp_5 = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp_5 = roundToInt(scrollToBeConsumed);
        }
        var tmp$ret$16 = tmp_5;
        tmp_3 = abs(tmp$ret$16) >= abs(scrollDelta);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = scrollDelta;
      } else {
        tmp_2 = scrollToBeConsumed;
      }
      var consumedScroll = tmp_2;
      var unconsumedScroll = scrollToBeConsumed - consumedScroll;
      var tmp_6;
      if (isLookingAhead && scrollDelta > preScrollBackScrollDelta && unconsumedScroll <= 0) {
        tmp_6 = (scrollDelta - preScrollBackScrollDelta | 0) + unconsumedScroll;
      } else {
        tmp_6 = 0.0;
      }
      var scrollBackAmount = tmp_6;
      // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
      if (!(currentFirstItemScrollOffset >= 0)) {
        var tmp$ret$19 = 'negative currentFirstItemScrollOffset';
        throwIllegalArgumentException(tmp$ret$19);
      }
      var visibleItemsScrollOffset = -currentFirstItemScrollOffset | 0;
      var firstItem = visibleItems.vg();
      if (beforeContentPadding > 0 || spaceBetweenItems < 0) {
        var inductionVariable = 0;
        var last = visibleItems.n1() - 1 | 0;
        if (inductionVariable <= last)
          $l$loop: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var size = visibleItems.l1(i).oic_1;
            if (!(currentFirstItemScrollOffset === 0) && size <= currentFirstItemScrollOffset && !(i === get_lastIndex(visibleItems))) {
              currentFirstItemScrollOffset = currentFirstItemScrollOffset - size | 0;
              firstItem = visibleItems.l1(i + 1 | 0);
            } else {
              break $l$loop;
            }
          }
           while (inductionVariable <= last);
      }
      var extraItemsBefore = createItemsBeforeList(currentFirstItemIndex, measuredItemProvider, beyondBoundsItemCount, pinnedItems);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_0 = extraItemsBefore.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item = extraItemsBefore.l1(index_0);
          var tmp0_2 = maxCrossAxis;
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_2 = item.pic_1;
          maxCrossAxis = Math.max(tmp0_2, b_2);
        }
         while (inductionVariable_0 <= last_0);
      var extraItemsAfter = createItemsAfterList(visibleItems, measuredItemProvider, itemsCount, beyondBoundsItemCount, pinnedItems);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_1 = 0;
      var last_1 = extraItemsAfter.n1() - 1 | 0;
      if (inductionVariable_1 <= last_1)
        do {
          var index_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var item_0 = extraItemsAfter.l1(index_1);
          var tmp0_3 = maxCrossAxis;
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_3 = item_0.pic_1;
          maxCrossAxis = Math.max(tmp0_3, b_3);
        }
         while (inductionVariable_1 <= last_1);
      var noExtraItems = equals(firstItem, visibleItems.vg()) && extraItemsBefore.r() && extraItemsAfter.r();
      var layoutWidth_0 = constrainWidth(constraints, isVertical ? maxCrossAxis : currentMainAxisOffset);
      var layoutHeight_0 = constrainHeight(constraints, isVertical ? currentMainAxisOffset : maxCrossAxis);
      var positionedItems = calculateItemsOffsets(visibleItems, extraItemsBefore, extraItemsAfter, layoutWidth_0, layoutHeight_0, currentMainAxisOffset, maxOffset, visibleItemsScrollOffset, isVertical, verticalArrangement, horizontalArrangement, reverseLayout, density);
      if (!ComposeFoundationFlags_instance.ufg_1 || shouldRunItemAnimation) {
        var tmp10_consumedScroll = numberToInt(consumedScroll);
        var tmp11_layoutWidth = layoutWidth_0;
        var tmp12_layoutHeight = layoutHeight_0;
        var tmp13_keyIndexMap = measuredItemProvider.vid();
        var tmp14_layoutMinOffset = currentFirstItemScrollOffset;
        var tmp15_layoutMaxOffset = currentMainAxisOffset;
        itemAnimator.cig(tmp10_consumedScroll, tmp11_layoutWidth, tmp12_layoutHeight, positionedItems, tmp13_keyIndexMap, measuredItemProvider, isVertical, isLookingAhead, 1, hasLookaheadOccurred, tmp14_layoutMinOffset, tmp15_layoutMaxOffset, coroutineScope, graphicsContext);
      }
      if (!isLookingAhead) {
        var disappearingItemsSize_0 = itemAnimator.dig();
        if (!equals(disappearingItemsSize_0, Companion_getInstance_22().n5g_1)) {
          var oldMainAxisSize = isVertical ? layoutHeight_0 : layoutWidth_0;
          var tmp0_4 = layoutWidth_0;
          // Inline function 'androidx.compose.ui.unit.IntSize.width' call
          // Inline function 'androidx.compose.ui.util.unpackInt1' call
          var value_1 = _IntSize___get_packedValue__impl__uho7jf(disappearingItemsSize_0);
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_4 = convertToInt(shiftRight(value_1, 32));
          var tmp$ret$28 = Math.max(tmp0_4, b_4);
          layoutWidth_0 = constrainWidth(constraints, tmp$ret$28);
          var tmp0_5 = layoutHeight_0;
          // Inline function 'androidx.compose.ui.unit.IntSize.height' call
          // Inline function 'androidx.compose.ui.util.unpackInt2' call
          var value_2 = _IntSize___get_packedValue__impl__uho7jf(disappearingItemsSize_0);
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_5 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
          var tmp$ret$31 = Math.max(tmp0_5, b_5);
          layoutHeight_0 = constrainHeight(constraints, tmp$ret$31);
          var newMainAxisSize = isVertical ? layoutHeight_0 : layoutWidth_0;
          if (!(newMainAxisSize === oldMainAxisSize)) {
            // Inline function 'androidx.compose.ui.util.fastForEach' call
            var inductionVariable_2 = 0;
            var last_2 = positionedItems.n1() - 1 | 0;
            if (inductionVariable_2 <= last_2)
              do {
                var index_2 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var item_1 = positionedItems.l1(index_2);
                item_1.eig(newMainAxisSize);
              }
               while (inductionVariable_2 <= last_2);
          }
        }
      }
      var tmp16_safe_receiver = visibleItems.wg();
      var tmp17_elvis_lhs = tmp16_safe_receiver == null ? null : tmp16_safe_receiver.vib_1;
      var tmp_7 = tmp17_elvis_lhs == null ? 0 : tmp17_elvis_lhs;
      var tmp18_safe_receiver = visibleItems.yg();
      var tmp19_elvis_lhs = tmp18_safe_receiver == null ? null : tmp18_safe_receiver.vib_1;
      var tmp_8 = tmp19_elvis_lhs == null ? 0 : tmp19_elvis_lhs;
      var tmp_9 = measuredItemProvider.wid();
      var tmp_10 = layoutWidth_0;
      var tmp_11 = layoutHeight_0;
      var stickingItems = applyStickyItems(stickyItemsPlacement, tmp_7, tmp_8, positionedItems, tmp_9, beforeContentPadding, afterContentPadding, tmp_10, tmp_11, measureLazyList$lambda_0(measuredItemProvider));
      var tmp_12;
      if (noExtraItems) {
        var tmp20_safe_receiver = firstOrNull(positionedItems);
        tmp_12 = tmp20_safe_receiver == null ? null : tmp20_safe_receiver.vib_1;
      } else {
        var tmp21_safe_receiver = visibleItems.wg();
        tmp_12 = tmp21_safe_receiver == null ? null : tmp21_safe_receiver.vib_1;
      }
      var firstVisibleIndex = tmp_12;
      var tmp_13;
      if (noExtraItems) {
        var tmp22_safe_receiver = lastOrNull(positionedItems);
        tmp_13 = tmp22_safe_receiver == null ? null : tmp22_safe_receiver.vib_1;
      } else {
        var tmp23_safe_receiver = visibleItems.yg();
        tmp_13 = tmp23_safe_receiver == null ? null : tmp23_safe_receiver.vib_1;
      }
      var lastVisibleIndex = tmp_13;
      var tmp26_firstVisibleItem = firstItem;
      var tmp27_firstVisibleItemScrollOffset = currentFirstItemScrollOffset;
      var tmp28_canScrollForward = index < itemsCount || currentMainAxisOffset > maxOffset;
      var tmp_14 = layoutWidth_0;
      var tmp_15 = layoutHeight_0;
      var tmp29_measureResult = layout(tmp_14, tmp_15, measureLazyList$lambda_1(placementScopeInvalidator, positionedItems, isLookingAhead, stickingItems));
      var tmp_16 = firstVisibleIndex == null ? 0 : firstVisibleIndex;
      var tmp30_visibleItemsInfo = updatedVisibleItems(tmp_16, lastVisibleIndex == null ? 0 : lastVisibleIndex, positionedItems, stickingItems);
      var tmp31_viewportStartOffset = -beforeContentPadding | 0;
      var tmp32_viewportEndOffset = maxOffset + afterContentPadding | 0;
      var tmp33_orientation = isVertical ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance();
      var tmp34_remeasureNeeded = remeasureNeeded;
      var tmp35_childConstraints = measuredItemProvider.yic_1;
      return new LazyListMeasureResult(tmp26_firstVisibleItem, tmp27_firstVisibleItemScrollOffset, tmp28_canScrollForward, consumedScroll, tmp29_measureResult, scrollBackAmount, tmp34_remeasureNeeded, coroutineScope, density, tmp35_childConstraints, tmp30_visibleItemsInfo, tmp31_viewportStartOffset, tmp32_viewportEndOffset, itemsCount, reverseLayout, tmp33_orientation, afterContentPadding, spaceBetweenItems);
    }
  }
  function createItemsBeforeList(currentFirstItemIndex, measuredItemProvider, beyondBoundsItemCount, pinnedItems) {
    var list = null;
    var start = currentFirstItemIndex;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = start - beyondBoundsItemCount | 0;
    start = Math.max(0, b);
    var inductionVariable = currentFirstItemIndex - 1 | 0;
    var last = start;
    if (last <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (list == null) {
          // Inline function 'kotlin.collections.mutableListOf' call
          list = ArrayList_init_$Create$();
        }
        list.j1(measuredItemProvider.uid(i));
      }
       while (!(i === last));
    // Inline function 'androidx.compose.ui.util.fastForEachReversed' call
    var inductionVariable_0 = pinnedItems.n1() - 1 | 0;
    if (0 <= inductionVariable_0)
      do {
        var index = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + -1 | 0;
        var item = pinnedItems.l1(index);
        if (item < start) {
          if (list == null) {
            // Inline function 'kotlin.collections.mutableListOf' call
            list = ArrayList_init_$Create$();
          }
          var tmp0_safe_receiver = list;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver.j1(measuredItemProvider.uid(item));
        }
      }
       while (0 <= inductionVariable_0);
    var tmp0_elvis_lhs = list;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  function createItemsAfterList(visibleItems, measuredItemProvider, itemsCount, beyondBoundsItemCount, pinnedItems) {
    var list = null;
    var end = last(visibleItems).vib_1;
    var tmp0 = end + beyondBoundsItemCount | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = itemsCount - 1 | 0;
    end = Math.min(tmp0, b);
    var inductionVariable = last(visibleItems).vib_1 + 1 | 0;
    var last_0 = end;
    if (inductionVariable <= last_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (list == null) {
          // Inline function 'kotlin.collections.mutableListOf' call
          list = ArrayList_init_$Create$();
        }
        list.j1(measuredItemProvider.uid(i));
      }
       while (!(i === last_0));
    var tmp0_safe_receiver = list;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (last(tmp0_safe_receiver).vib_1 > end) {
        end = last(tmp0_safe_receiver).vib_1;
      }
    }
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable_0 = 0;
    var last_1 = pinnedItems.n1() - 1 | 0;
    if (inductionVariable_0 <= last_1)
      do {
        var index = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item = pinnedItems.l1(index);
        if (item > end) {
          if (list == null) {
            // Inline function 'kotlin.collections.mutableListOf' call
            list = ArrayList_init_$Create$();
          }
          var tmp0_safe_receiver_0 = list;
          if (tmp0_safe_receiver_0 == null)
            null;
          else
            tmp0_safe_receiver_0.j1(measuredItemProvider.uid(item));
        }
      }
       while (inductionVariable_0 <= last_1);
    var tmp1_elvis_lhs = list;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function calculateItemsOffsets(items, extraItemsBefore, extraItemsAfter, layoutWidth, layoutHeight, finalMainAxisOffset, maxOffset, itemsScrollOffset, isVertical, verticalArrangement, horizontalArrangement, reverseLayout, density) {
    var mainAxisLayoutSize = isVertical ? layoutHeight : layoutWidth;
    // Inline function 'kotlin.comparisons.minOf' call
    var hasSpareSpace = finalMainAxisOffset < Math.min(mainAxisLayoutSize, maxOffset);
    if (hasSpareSpace) {
      // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
      if (!(itemsScrollOffset === 0)) {
        var tmp$ret$2 = 'non-zero itemsScrollOffset';
        throwIllegalStateException(tmp$ret$2);
      }
    }
    var positionedItems = ArrayList_init_$Create$_0((items.n1() + extraItemsBefore.n1() | 0) + extraItemsAfter.n1() | 0);
    if (hasSpareSpace) {
      // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
      if (!(extraItemsBefore.r() && extraItemsAfter.r())) {
        var tmp$ret$4 = 'no extra items';
        throwIllegalArgumentException(tmp$ret$4);
      }
      var itemsCount = items.n1();
      var tmp = 0;
      var tmp_0 = new Int32Array(itemsCount);
      while (tmp < itemsCount) {
        var tmp_1 = tmp;
        tmp_0[tmp_1] = items.l1(calculateItemsOffsets$reverseAware(tmp_1, reverseLayout, itemsCount)).lic_1;
        tmp = tmp + 1 | 0;
      }
      var sizes = tmp_0;
      var offsets = new Int32Array(itemsCount);
      if (isVertical) {
        // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
        if (verticalArrangement == null) {
          var tmp$ret$7 = 'null verticalArrangement when isVertical == true';
          throwIllegalArgumentExceptionForNullCheck(tmp$ret$7);
        }
        // Inline function 'kotlin.with' call
        verticalArrangement.fdq(density, mainAxisLayoutSize, sizes, offsets);
      } else {
        // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
        if (horizontalArrangement == null) {
          var tmp$ret$11 = 'null horizontalArrangement when isVertical == false';
          throwIllegalArgumentExceptionForNullCheck(tmp$ret$11);
        }
        // Inline function 'kotlin.with' call
        horizontalArrangement.pdp(density, mainAxisLayoutSize, sizes, LayoutDirection_Ltr_getInstance(), offsets);
      }
      var reverseAwareOffsetIndices = !reverseLayout ? get_indices(offsets) : reversed(get_indices(offsets));
      var inductionVariable = reverseAwareOffsetIndices.x1_1;
      var last = reverseAwareOffsetIndices.y1_1;
      var step = reverseAwareOffsetIndices.z1_1;
      if (step > 0 && inductionVariable <= last || (step < 0 && last <= inductionVariable))
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          var absoluteOffset = offsets[index];
          var item = items.l1(calculateItemsOffsets$reverseAware(index, reverseLayout, itemsCount));
          var tmp_2;
          if (reverseLayout) {
            tmp_2 = (mainAxisLayoutSize - absoluteOffset | 0) - item.lic_1 | 0;
          } else {
            tmp_2 = absoluteOffset;
          }
          var relativeOffset = tmp_2;
          item.fig(relativeOffset, layoutWidth, layoutHeight);
          positionedItems.j1(item);
        }
         while (!(index === last));
    } else {
      var currentMainAxis = itemsScrollOffset;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_0 = extraItemsBefore.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = extraItemsBefore.l1(index_0);
          currentMainAxis = currentMainAxis - item_0.oic_1 | 0;
          item_0.fig(currentMainAxis, layoutWidth, layoutHeight);
          positionedItems.j1(item_0);
        }
         while (inductionVariable_0 <= last_0);
      currentMainAxis = itemsScrollOffset;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_1 = 0;
      var last_1 = items.n1() - 1 | 0;
      if (inductionVariable_1 <= last_1)
        do {
          var index_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var item_1 = items.l1(index_1);
          item_1.fig(currentMainAxis, layoutWidth, layoutHeight);
          positionedItems.j1(item_1);
          currentMainAxis = currentMainAxis + item_1.oic_1 | 0;
        }
         while (inductionVariable_1 <= last_1);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_2 = 0;
      var last_2 = extraItemsAfter.n1() - 1 | 0;
      if (inductionVariable_2 <= last_2)
        do {
          var index_2 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var item_2 = extraItemsAfter.l1(index_2);
          item_2.fig(currentMainAxis, layoutWidth, layoutHeight);
          positionedItems.j1(item_2);
          currentMainAxis = currentMainAxis + item_2.oic_1 | 0;
        }
         while (inductionVariable_2 <= last_2);
    }
    return positionedItems;
  }
  function measureLazyList$lambda($this$layout) {
    return Unit_instance;
  }
  function measureLazyList$lambda_0($measuredItemProvider) {
    return function (it) {
      return $measuredItemProvider.uid(it);
    };
  }
  function measureLazyList$lambda$lambda($positionedItems, $isLookingAhead, $stickingItems) {
    return function ($this$withMotionFrameOfReferencePlacement) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = $positionedItems;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item.gig($this$withMotionFrameOfReferencePlacement, $isLookingAhead);
        }
         while (inductionVariable <= last);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_1 = $stickingItems;
      var inductionVariable_0 = 0;
      var last_0 = this_1.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = this_1.l1(index_0);
          item_0.gig($this$withMotionFrameOfReferencePlacement, $isLookingAhead);
        }
         while (inductionVariable_0 <= last_0);
      return Unit_instance;
    };
  }
  function measureLazyList$lambda_1($placementScopeInvalidator, $positionedItems, $isLookingAhead, $stickingItems) {
    return function ($this$layout) {
      $this$layout.xal(measureLazyList$lambda$lambda($positionedItems, $isLookingAhead, $stickingItems));
      ObservableScopeInvalidator__attachToScope_impl_wvvw97($placementScopeInvalidator);
      return Unit_instance;
    };
  }
  function calculateItemsOffsets$reverseAware(_this__u8e3s4, $reverseLayout, itemsCount) {
    return !$reverseLayout ? _this__u8e3s4 : (itemsCount - _this__u8e3s4 | 0) - 1 | 0;
  }
  var androidx_compose_foundation_lazy_LazyListMeasureResult$stable;
  function LazyListMeasureResult(firstVisibleItem, firstVisibleItemScrollOffset, canScrollForward, consumedScroll, measureResult, scrollBackAmount, remeasureNeeded, coroutineScope, density, childConstraints, visibleItemsInfo, viewportStartOffset, viewportEndOffset, totalItemsCount, reverseLayout, orientation, afterContentPadding, mainAxisItemSpacing) {
    this.eie_1 = firstVisibleItem;
    this.fie_1 = firstVisibleItemScrollOffset;
    this.gie_1 = canScrollForward;
    this.hie_1 = consumedScroll;
    this.iie_1 = measureResult;
    this.jie_1 = scrollBackAmount;
    this.kie_1 = remeasureNeeded;
    this.lie_1 = coroutineScope;
    this.mie_1 = density;
    this.nie_1 = childConstraints;
    this.oie_1 = visibleItemsInfo;
    this.pie_1 = viewportStartOffset;
    this.qie_1 = viewportEndOffset;
    this.rie_1 = totalItemsCount;
    this.sie_1 = reverseLayout;
    this.tie_1 = orientation;
    this.uie_1 = afterContentPadding;
    this.vie_1 = mainAxisItemSpacing;
  }
  protoOf(LazyListMeasureResult).uhz = function () {
    return this.oie_1;
  };
  protoOf(LazyListMeasureResult).zif = function () {
    return this.pie_1;
  };
  protoOf(LazyListMeasureResult).aig = function () {
    return this.qie_1;
  };
  protoOf(LazyListMeasureResult).ci0 = function () {
    return this.rie_1;
  };
  protoOf(LazyListMeasureResult).lhy = function () {
    return this.tie_1;
  };
  protoOf(LazyListMeasureResult).zhz = function () {
    return this.uie_1;
  };
  protoOf(LazyListMeasureResult).big = function () {
    return this.vie_1;
  };
  protoOf(LazyListMeasureResult).ng7 = function () {
    var tmp;
    var tmp0_safe_receiver = this.eie_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vib_1;
    if (!((tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) === 0)) {
      tmp = true;
    } else {
      tmp = !(this.fie_1 === 0);
    }
    return tmp;
  };
  protoOf(LazyListMeasureResult).khy = function () {
    var tmp0 = this.h5e();
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = this.i5e();
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntSize___init__impl__emcjft(tmp$ret$1);
  };
  protoOf(LazyListMeasureResult).yhz = function () {
    return -this.pie_1 | 0;
  };
  protoOf(LazyListMeasureResult).hig = function (delta, updateAnimations) {
    var tmp;
    if (this.kie_1 || this.oie_1.r() || this.eie_1 == null) {
      tmp = true;
    } else {
      var containsUpper = this.eie_1.oic_1;
      var containsArg = this.fie_1 - delta | 0;
      tmp = !(0 <= containsArg ? containsArg < containsUpper : false);
    }
    if (tmp) {
      return null;
    }
    var first_0 = first(this.oie_1);
    var last_0 = last(this.oie_1);
    if (first_0.qic_1 || last_0.qic_1) {
      return null;
    }
    var tmp_0;
    if (delta < 0) {
      var deltaToFirstItemChange = (first_0.kic_1 + first_0.oic_1 | 0) - this.pie_1 | 0;
      var deltaToLastItemChange = (last_0.kic_1 + last_0.oic_1 | 0) - this.qie_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      tmp_0 = Math.min(deltaToFirstItemChange, deltaToLastItemChange) > (-delta | 0);
    } else {
      var deltaToFirstItemChange_0 = this.pie_1 - first_0.kic_1 | 0;
      var deltaToLastItemChange_0 = this.qie_1 - last_0.kic_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      tmp_0 = Math.min(deltaToFirstItemChange_0, deltaToLastItemChange_0) > delta;
    }
    var canApply = tmp_0;
    var tmp_1;
    if (canApply) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = this.oie_1;
      var inductionVariable = 0;
      var last_1 = this_0.n1() - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item.iig(delta, updateAnimations);
        }
         while (inductionVariable <= last_1);
      tmp_1 = new LazyListMeasureResult(this.eie_1, this.fie_1 - delta | 0, this.gie_1 || delta > 0, delta, this.iie_1, this.jie_1, this.kie_1, this.lie_1, this.mie_1, this.nie_1, this.oie_1, this.pie_1, this.qie_1, this.rie_1, this.sie_1, this.tie_1, this.uie_1, this.vie_1);
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  };
  protoOf(LazyListMeasureResult).uad = function () {
    this.iie_1.uad();
  };
  protoOf(LazyListMeasureResult).h5e = function () {
    return this.iie_1.h5e();
  };
  protoOf(LazyListMeasureResult).i5e = function () {
    return this.iie_1.i5e();
  };
  protoOf(LazyListMeasureResult).sad = function () {
    return this.iie_1.sad();
  };
  protoOf(LazyListMeasureResult).tad = function () {
    return this.iie_1.tad();
  };
  var androidx_compose_foundation_lazy_LazyListMeasuredItem$stable;
  function _get_mainAxis__jwdafl($this, $receiver) {
    return $this.xib_1 ? _IntOffset___get_y__impl__2avpwj($receiver) : _IntOffset___get_x__impl__qiqr5o($receiver);
  }
  function _get_mainAxisSize__iyci34($this, $receiver) {
    return $this.xib_1 ? $receiver.j8y_1 : $receiver.i8y_1;
  }
  function LazyListMeasuredItem(index, placeables, isVertical, horizontalAlignment, verticalAlignment, layoutDirection, reverseLayout, beforeContentPadding, afterContentPadding, spacing, visualOffset, key, contentType, animator, constraints) {
    this.vib_1 = index;
    this.wib_1 = placeables;
    this.xib_1 = isVertical;
    this.yib_1 = horizontalAlignment;
    this.zib_1 = verticalAlignment;
    this.aic_1 = layoutDirection;
    this.bic_1 = reverseLayout;
    this.cic_1 = beforeContentPadding;
    this.dic_1 = afterContentPadding;
    this.eic_1 = spacing;
    this.fic_1 = visualOffset;
    this.gic_1 = key;
    this.hic_1 = contentType;
    this.iic_1 = animator;
    this.jic_1 = constraints;
    this.kic_1 = 0;
    this.mic_1 = 0;
    this.nic_1 = 1;
    this.qic_1 = false;
    this.ric_1 = -2147483648;
    this.sic_1 = 0;
    this.tic_1 = 0;
    var mainAxisSize = 0;
    var maxCrossAxis = 0;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.wib_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index_0);
        mainAxisSize = mainAxisSize + (this.xib_1 ? item.j8y_1 : item.i8y_1) | 0;
        var tmp0 = maxCrossAxis;
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = !this.xib_1 ? item.j8y_1 : item.i8y_1;
        maxCrossAxis = Math.max(tmp0, b);
      }
       while (inductionVariable <= last);
    this.lic_1 = mainAxisSize;
    this.oic_1 = coerceAtLeast_0(this.lic_1 + this.eic_1 | 0, 0);
    this.pic_1 = maxCrossAxis;
    this.uic_1 = new Int32Array(imul(this.wib_1.n1(), 2));
  }
  protoOf(LazyListMeasuredItem).bi0 = function () {
    return this.vib_1;
  };
  protoOf(LazyListMeasuredItem).jig = function () {
    return this.xib_1;
  };
  protoOf(LazyListMeasuredItem).t1 = function () {
    return this.gic_1;
  };
  protoOf(LazyListMeasuredItem).vds = function () {
    return this.jic_1;
  };
  protoOf(LazyListMeasuredItem).ai0 = function () {
    return this.kic_1;
  };
  protoOf(LazyListMeasuredItem).n1 = function () {
    return this.lic_1;
  };
  protoOf(LazyListMeasuredItem).kig = function () {
    return this.mic_1;
  };
  protoOf(LazyListMeasuredItem).lig = function () {
    return this.nic_1;
  };
  protoOf(LazyListMeasuredItem).mig = function () {
    return this.oic_1;
  };
  protoOf(LazyListMeasuredItem).nig = function (_set____db54di) {
    this.qic_1 = _set____db54di;
  };
  protoOf(LazyListMeasuredItem).xhz = function () {
    return this.qic_1;
  };
  protoOf(LazyListMeasuredItem).law = function () {
    return this.wib_1.n1();
  };
  protoOf(LazyListMeasuredItem).oig = function (index) {
    return this.wib_1.l1(index).xag();
  };
  protoOf(LazyListMeasuredItem).pig = function (mainAxisOffset, crossAxisOffset, layoutWidth, layoutHeight) {
    this.fig(mainAxisOffset, layoutWidth, layoutHeight);
  };
  protoOf(LazyListMeasuredItem).fig = function (mainAxisOffset, layoutWidth, layoutHeight) {
    this.kic_1 = mainAxisOffset;
    this.ric_1 = this.xib_1 ? layoutHeight : layoutWidth;
    var mainAxisOffset_0 = mainAxisOffset;
    // Inline function 'androidx.compose.ui.util.fastForEachIndexed' call
    var this_0 = this.wib_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        var indexInArray = imul(index, 2);
        if (this.xib_1) {
          // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
          var value = this.yib_1;
          if (value == null) {
            var tmp$ret$3 = 'null horizontalAlignment when isVertical == true';
            throwIllegalArgumentExceptionForNullCheck(tmp$ret$3);
          }
          this.uic_1[indexInArray] = value.a8u(item.i8y_1, layoutWidth, this.aic_1);
          this.uic_1[indexInArray + 1 | 0] = mainAxisOffset_0;
          mainAxisOffset_0 = mainAxisOffset_0 + item.j8y_1 | 0;
        } else {
          this.uic_1[indexInArray] = mainAxisOffset_0;
          var tmp = indexInArray + 1 | 0;
          // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
          var value_0 = this.zib_1;
          if (value_0 == null) {
            var tmp$ret$5 = 'null verticalAlignment when isVertical == false';
            throwIllegalArgumentExceptionForNullCheck(tmp$ret$5);
          }
          this.uic_1[tmp] = value_0.c8u(item.j8y_1, layoutHeight);
          mainAxisOffset_0 = mainAxisOffset_0 + item.i8y_1 | 0;
        }
      }
       while (inductionVariable <= last);
    this.sic_1 = -this.cic_1 | 0;
    this.tic_1 = this.ric_1 + this.dic_1 | 0;
  };
  protoOf(LazyListMeasuredItem).eig = function (mainAxisLayoutSize) {
    this.ric_1 = mainAxisLayoutSize;
    this.tic_1 = mainAxisLayoutSize + this.dic_1 | 0;
  };
  protoOf(LazyListMeasuredItem).qig = function (index) {
    var tmp;
    if (index === 0 && this.law() === 0) {
      var tmp_0;
      if (this.xib_1) {
        // Inline function 'androidx.compose.ui.unit.IntOffset' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2 = this.kic_1;
        var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
        tmp_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$1);
      } else {
        // Inline function 'androidx.compose.ui.unit.IntOffset' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val1 = this.kic_1;
        var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(val1), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
        tmp_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
      }
      tmp = tmp_0;
    } else {
      var tmp0 = this.uic_1[imul(index, 2)];
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2_0 = this.uic_1[imul(index, 2) + 1 | 0];
      var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
      tmp = _IntOffset___init__impl__rq8h7b(tmp$ret$5);
    }
    return tmp;
  };
  protoOf(LazyListMeasuredItem).iig = function (delta, updateAnimations) {
    if (this.qic_1) {
      return Unit_instance;
    }
    this.kic_1 = this.kic_1 + delta | 0;
    // Inline function 'kotlin.repeat' call
    var times = this.uic_1.length;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var oddEven = index & 1;
        if (this.xib_1 && !(oddEven === 0) || (!this.xib_1 && oddEven === 0)) {
          var _array__4zh2yp = this.uic_1;
          _array__4zh2yp[index] = _array__4zh2yp[index] + delta | 0;
        }
      }
       while (inductionVariable < times);
    if (updateAnimations) {
      // Inline function 'kotlin.repeat' call
      var times_0 = this.law();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < times_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var animation = this.iic_1.rig(this.gic_1, index_0);
          if (!(animation == null)) {
            var tmp = animation;
            // Inline function 'androidx.compose.foundation.lazy.LazyListMeasuredItem.copy' call
            var this_0 = animation.dih_1;
            var tmp_0;
            if (this.xib_1) {
              var tmp0 = _IntOffset___get_x__impl__qiqr5o(this_0);
              // Inline function 'androidx.compose.ui.unit.IntOffset' call
              // Inline function 'androidx.compose.ui.util.packInts' call
              var val2 = _IntOffset___get_y__impl__2avpwj(this_0) + delta | 0;
              var tmp$ret$7 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
              tmp_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$7);
            } else {
              var tmp0_0 = _IntOffset___get_x__impl__qiqr5o(this_0) + delta | 0;
              // Inline function 'androidx.compose.ui.unit.IntOffset' call
              // Inline function 'androidx.compose.ui.util.packInts' call
              var val2_0 = _IntOffset___get_y__impl__2avpwj(this_0);
              var tmp$ret$10 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
              tmp_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$10);
            }
            tmp.dih_1 = tmp_0;
          }
        }
         while (inductionVariable_0 < times_0);
    }
  };
  protoOf(LazyListMeasuredItem).gig = function (scope, isLookingAhead) {
    // Inline function 'kotlin.with' call
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!!(this.ric_1 === -2147483648)) {
      var tmp$ret$3 = 'position() should be called first';
      throwIllegalArgumentException(tmp$ret$3);
    }
    // Inline function 'kotlin.repeat' call
    var times = this.law();
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var placeable = this.wib_1.l1(index);
        var minOffset = this.sic_1 - _get_mainAxisSize__iyci34(this, placeable) | 0;
        var maxOffset = this.tic_1;
        var offset = this.qig(index);
        var animation = this.iic_1.rig(this.gic_1, index);
        var layer;
        if (!(animation == null)) {
          if (isLookingAhead) {
            animation.jih_1 = offset;
          } else {
            var tmp;
            if (!equals(animation.jih_1, Companion_getInstance_67().kih_1)) {
              tmp = animation.jih_1;
            } else {
              tmp = offset;
            }
            var targetOffset = tmp;
            var animatedOffset = IntOffset__plus_impl_nqoa9b(targetOffset, animation.lih());
            if (_get_mainAxis__jwdafl(this, targetOffset) <= minOffset && _get_mainAxis__jwdafl(this, animatedOffset) <= minOffset || (_get_mainAxis__jwdafl(this, targetOffset) >= maxOffset && _get_mainAxis__jwdafl(this, animatedOffset) >= maxOffset)) {
              animation.mih();
            }
            offset = animatedOffset;
          }
          layer = animation.fih_1;
        } else {
          layer = null;
        }
        if (this.bic_1) {
          // Inline function 'androidx.compose.foundation.lazy.LazyListMeasuredItem.copy' call
          var this_0 = offset;
          var tmp_0;
          if (this.xib_1) {
            var tmp0 = _IntOffset___get_x__impl__qiqr5o(this_0);
            var mainAxisOffset = _IntOffset___get_y__impl__2avpwj(this_0);
            // Inline function 'androidx.compose.ui.unit.IntOffset' call
            // Inline function 'androidx.compose.ui.util.packInts' call
            var val2 = (this.ric_1 - mainAxisOffset | 0) - _get_mainAxisSize__iyci34(this, placeable) | 0;
            var tmp$ret$9 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
            tmp_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$9);
          } else {
            var mainAxisOffset_0 = _IntOffset___get_x__impl__qiqr5o(this_0);
            var tmp0_0 = (this.ric_1 - mainAxisOffset_0 | 0) - _get_mainAxisSize__iyci34(this, placeable) | 0;
            // Inline function 'androidx.compose.ui.unit.IntOffset' call
            // Inline function 'androidx.compose.ui.util.packInts' call
            var val2_0 = _IntOffset___get_y__impl__2avpwj(this_0);
            var tmp$ret$12 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
            tmp_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$12);
          }
          offset = tmp_0;
        }
        offset = IntOffset__plus_impl_nqoa9b(offset, this.fic_1);
        if (!isLookingAhead) {
          if (animation == null)
            null;
          else {
            animation.eih_1 = offset;
          }
        }
        if (this.xib_1) {
          if (!(layer == null)) {
            scope.wal(placeable, offset, layer);
          } else {
            scope.ual(placeable, offset);
          }
        } else {
          if (!(layer == null)) {
            scope.ral(placeable, offset, layer);
          } else {
            scope.nal(placeable, offset);
          }
        }
      }
       while (inductionVariable < times);
    return Unit_instance;
  };
  var androidx_compose_foundation_lazy_LazyListMeasuredItemProvider$stable;
  function LazyListMeasuredItemProvider(constraints, isVertical, itemProvider, measureScope) {
    LazyLayoutMeasuredItemProvider.call(this);
    this.wic_1 = itemProvider;
    this.xic_1 = measureScope;
    this.yic_1 = Constraints_0(VOID, isVertical ? _Constraints___get_maxWidth__impl__uuyqc(constraints) : 2147483647, VOID, !isVertical ? _Constraints___get_maxHeight__impl__dt3e8z(constraints) : 2147483647);
  }
  protoOf(LazyListMeasuredItemProvider).sid = function (index, lane, span, constraints) {
    return this.tid(index, constraints);
  };
  protoOf(LazyListMeasuredItemProvider).tid = function (index, constraints) {
    var key = this.wic_1.jif(index);
    var contentType = this.wic_1.kif(index);
    var placeables = this.yid(this.xic_1, index, constraints);
    return this.rid(index, key, contentType, placeables, constraints);
  };
  protoOf(LazyListMeasuredItemProvider).uid = function (index, constraints, $super) {
    constraints = constraints === VOID ? this.yic_1 : constraints;
    return $super === VOID ? this.tid(index, constraints) : $super.tid.call(this, index, new Constraints(constraints));
  };
  protoOf(LazyListMeasuredItemProvider).zic = function (index) {
    if (0 <= index ? index < this.wic_1.aie() : false) {
      this.xic_1.nih(index);
    }
  };
  protoOf(LazyListMeasuredItemProvider).vid = function () {
    return this.wic_1.vid();
  };
  protoOf(LazyListMeasuredItemProvider).wid = function () {
    return this.wic_1.wid();
  };
  var androidx_compose_foundation_lazy_LazyListPrefetchResultScopeImpl$stable;
  function LazyListPrefetchStrategy() {
  }
  function LazyListPrefetchStrategy_0(nestedPrefetchItemCount) {
    nestedPrefetchItemCount = nestedPrefetchItemCount === VOID ? 2 : nestedPrefetchItemCount;
    return new DefaultLazyListPrefetchStrategy(nestedPrefetchItemCount);
  }
  function LazyListPrefetchScope() {
  }
  function LazyListPrefetchResultScopeImpl(index, mainAxisSize) {
    this.uih_1 = index;
    this.vih_1 = mainAxisSize;
  }
  function resetPrefetchState($this) {
    $this.xih_1 = -1;
    var tmp0_safe_receiver = $this.yih_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.e2z();
    }
    $this.yih_1 = null;
  }
  function calculateIndexToPrefetch($this, $receiver, scrollingForward) {
    var tmp;
    if (scrollingForward) {
      tmp = last($receiver.uhz()).bi0() + 1 | 0;
    } else {
      tmp = first($receiver.uhz()).bi0() - 1 | 0;
    }
    return tmp;
  }
  function evaluatePrefetchForCancellation($this, $receiver, currentPrefetchingIndex, scrollingForward) {
    var tmp;
    if (!(currentPrefetchingIndex === -1)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$receiver.uhz().r();
    } else {
      tmp = false;
    }
    if (tmp) {
      var expectedPrefetchIndex = calculateIndexToPrefetch($this, $receiver, scrollingForward);
      if (!(currentPrefetchingIndex === expectedPrefetchIndex)) {
        resetPrefetchState($this);
      }
    }
  }
  function DefaultLazyListPrefetchStrategy(initialNestedPrefetchItemCount) {
    initialNestedPrefetchItemCount = initialNestedPrefetchItemCount === VOID ? 2 : initialNestedPrefetchItemCount;
    this.wih_1 = initialNestedPrefetchItemCount;
    this.xih_1 = -1;
    this.yih_1 = null;
    this.zih_1 = false;
    this.aii_1 = -1;
    this.bii_1 = 0.0;
  }
  protoOf(DefaultLazyListPrefetchStrategy).pih = function (_this__u8e3s4, delta, layoutInfo) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!layoutInfo.uhz().r()) {
      var scrollingForward = delta < 0;
      var indexToPrefetch = calculateIndexToPrefetch(this, layoutInfo, scrollingForward);
      if (0 <= indexToPrefetch ? indexToPrefetch < layoutInfo.ci0() : false) {
        if (!(indexToPrefetch === this.xih_1)) {
          if (!(this.zih_1 === scrollingForward)) {
            resetPrefetchState(this);
          }
          this.zih_1 = scrollingForward;
          this.xih_1 = indexToPrefetch;
          this.yih_1 = _this__u8e3s4.tih(indexToPrefetch);
        }
        if (scrollingForward) {
          var lastItem = last(layoutInfo.uhz());
          var spacing = layoutInfo.big();
          var distanceToPrefetchItem = ((lastItem.ai0() + lastItem.n1() | 0) + spacing | 0) - layoutInfo.aig() | 0;
          if (distanceToPrefetchItem < -delta) {
            var tmp0_safe_receiver = this.yih_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.cii();
            }
          }
        } else {
          var firstItem = first(layoutInfo.uhz());
          var distanceToPrefetchItem_0 = layoutInfo.zif() - firstItem.ai0() | 0;
          if (distanceToPrefetchItem_0 < delta) {
            var tmp1_safe_receiver = this.yih_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.cii();
            }
          }
        }
      }
    }
    this.bii_1 = delta;
  };
  protoOf(DefaultLazyListPrefetchStrategy).qih = function (_this__u8e3s4, layoutInfo) {
    evaluatePrefetchForCancellation(this, layoutInfo, this.xih_1, this.zih_1);
    var currentPassItemCount = layoutInfo.ci0();
    var tmp;
    if (!(this.aii_1 === -1) && !(this.bii_1 === 0.0) && !(this.aii_1 === currentPassItemCount)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !layoutInfo.uhz().r();
    } else {
      tmp = false;
    }
    if (tmp) {
      var indexToPrefetch = calculateIndexToPrefetch(this, layoutInfo, this.bii_1 < 0);
      if (0 <= indexToPrefetch ? indexToPrefetch < currentPassItemCount : false) {
        this.xih_1 = indexToPrefetch;
        this.yih_1 = _this__u8e3s4.tih(indexToPrefetch);
      }
    }
    this.aii_1 = currentPassItemCount;
  };
  protoOf(DefaultLazyListPrefetchStrategy).rih = function (_this__u8e3s4, firstVisibleItemIndex) {
    var tmp;
    if (_this__u8e3s4.dii() === -1) {
      tmp = this.wih_1;
    } else {
      tmp = _this__u8e3s4.dii();
    }
    var resolvedNestedPrefetchItemCount = tmp;
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < resolvedNestedPrefetchItemCount)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _this__u8e3s4.eii(firstVisibleItemIndex + index | 0);
      }
       while (inductionVariable < resolvedNestedPrefetchItemCount);
  };
  var androidx_compose_foundation_lazy_LazyListScrollPosition$stable;
  function _set_scrollOffset__x5lxuf($this, _set____db54di) {
    var tmp0 = $this.gii_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyListScrollPosition$_get_scrollOffset_$ref_c90jyu();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('scrollOffset', 1, tmp, tmp_0, LazyListScrollPosition$_set_scrollOffset_$ref_gu3p3y());
    tmp0.a49(_set____db54di);
    return Unit_instance;
  }
  function update_0($this, index, scrollOffset) {
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(index >= 0.0)) {
      var tmp$ret$1 = 'Index should be non-negative (' + index + ')';
      throwIllegalArgumentException(tmp$ret$1);
    }
    $this.kii(index);
    $this.jii_1.pii(index);
    _set_scrollOffset__x5lxuf($this, scrollOffset);
  }
  function LazyListScrollPosition$_get_index_$ref_6uddda() {
    return constructCallableReference(function (p0) {
      return p0.bi0();
    }, 1, 0, 257);
  }
  function LazyListScrollPosition$_set_index_$ref_yvw87a() {
    return constructCallableReference(function (p0, p1) {
      p0.kii(p1);
      return Unit_instance;
    }, 2, 0, 258);
  }
  function LazyListScrollPosition$_get_scrollOffset_$ref_c90jyu() {
    return constructCallableReference(function (p0) {
      return p0.kia();
    }, 1, 0, 259);
  }
  function LazyListScrollPosition$_set_scrollOffset_$ref_gu3p3y() {
    return constructCallableReference(function (p0, p1) {
      _set_scrollOffset__x5lxuf(p0, p1);
      return Unit_instance;
    }, 2, 0, 260);
  }
  function LazyListScrollPosition(initialIndex, initialScrollOffset) {
    initialIndex = initialIndex === VOID ? 0 : initialIndex;
    initialScrollOffset = initialScrollOffset === VOID ? 0 : initialScrollOffset;
    this.fii_1 = mutableIntStateOf(initialIndex);
    this.gii_1 = mutableIntStateOf(initialScrollOffset);
    this.hii_1 = false;
    this.iii_1 = null;
    this.jii_1 = new LazyLayoutNearestRangeState(initialIndex, 30, 100);
  }
  protoOf(LazyListScrollPosition).kii = function (_set____db54di) {
    var tmp0 = this.fii_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyListScrollPosition$_get_index_$ref_6uddda();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('index', 1, tmp, tmp_0, LazyListScrollPosition$_set_index_$ref_yvw87a());
    tmp0.a49(_set____db54di);
    return Unit_instance;
  };
  protoOf(LazyListScrollPosition).bi0 = function () {
    var tmp0 = this.fii_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyListScrollPosition$_get_index_$ref_6uddda();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('index', 1, tmp, tmp_0, LazyListScrollPosition$_set_index_$ref_yvw87a());
    return tmp0.b49();
  };
  protoOf(LazyListScrollPosition).kia = function () {
    var tmp0 = this.gii_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyListScrollPosition$_get_scrollOffset_$ref_c90jyu();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('scrollOffset', 1, tmp, tmp_0, LazyListScrollPosition$_set_scrollOffset_$ref_gu3p3y());
    return tmp0.b49();
  };
  protoOf(LazyListScrollPosition).qii = function (measureResult) {
    var tmp = this;
    var tmp0_safe_receiver = measureResult.eie_1;
    tmp.iii_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gic_1;
    if (this.hii_1 || measureResult.rie_1 > 0) {
      this.hii_1 = true;
      var scrollOffset = measureResult.fie_1;
      // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
      if (!(scrollOffset >= 0.0)) {
        var tmp$ret$1 = 'scrollOffset should be non-negative';
        throwIllegalStateException(tmp$ret$1);
      }
      var tmp1_safe_receiver = measureResult.eie_1;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.vib_1;
      var firstIndex = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
      update_0(this, firstIndex, scrollOffset);
    }
  };
  protoOf(LazyListScrollPosition).rii = function (scrollOffset) {
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(scrollOffset >= 0.0)) {
      var tmp$ret$1 = 'scrollOffset should be non-negative';
      throwIllegalStateException(tmp$ret$1);
    }
    _set_scrollOffset__x5lxuf(this, scrollOffset);
  };
  protoOf(LazyListScrollPosition).sii = function (index, scrollOffset) {
    update_0(this, index, scrollOffset);
    this.iii_1 = null;
  };
  protoOf(LazyListScrollPosition).tii = function (itemProvider, index) {
    var newIndex = findIndexByKey(itemProvider, this.iii_1, index);
    if (!(index === newIndex)) {
      this.kii(newIndex);
      this.jii_1.pii(index);
    }
    return newIndex;
  };
  function LazyLayoutScrollScope(state, scrollScope) {
    return new LazyLayoutScrollScope$1(scrollScope, state);
  }
  function LazyLayoutScrollScope$1($scrollScope, $state) {
    this.vii_1 = $state;
    this.uii_1 = $scrollScope;
  }
  protoOf(LazyLayoutScrollScope$1).lia = function () {
    return this.vii_1.lia();
  };
  protoOf(LazyLayoutScrollScope$1).mia = function () {
    return this.vii_1.mia();
  };
  protoOf(LazyLayoutScrollScope$1).wii = function () {
    var tmp0_safe_receiver = lastOrNull(this.vii_1.thz().uhz());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bi0();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(LazyLayoutScrollScope$1).aie = function () {
    return this.vii_1.thz().ci0();
  };
  protoOf(LazyLayoutScrollScope$1).xii = function (index, offset) {
    this.vii_1.yii(index, offset, true);
  };
  protoOf(LazyLayoutScrollScope$1).zii = function (targetIndex, targetOffset) {
    var layoutInfo = this.vii_1.thz();
    if (layoutInfo.uhz().r())
      return 0;
    var tmp;
    var containsLower = this.lia();
    if (!(targetIndex <= this.wii() ? containsLower <= targetIndex : false)) {
      var averageSize = visibleItemsAverageSize(layoutInfo);
      var indexesDiff = targetIndex - this.lia() | 0;
      tmp = imul(averageSize, indexesDiff) - this.mia() | 0;
    } else {
      var tmp0 = layoutInfo.uhz();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = tmp0.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = tmp0.l1(index);
            if (item.bi0() === targetIndex) {
              tmp$ret$0 = item;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$0 = null;
      }
      var visibleItem = tmp$ret$0;
      var tmp1_elvis_lhs = visibleItem == null ? null : visibleItem.ai0();
      tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    }
    return tmp + targetOffset | 0;
  };
  protoOf(LazyLayoutScrollScope$1).bh7 = function (pixels) {
    return this.uii_1.bh7(pixels);
  };
  function rememberLazyListSemanticState(state, isVertical, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(state) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.l31(isVertical) || ($changed & 48) === 32));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = LazyLayoutSemanticState(state, isVertical);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function get_EmptyLazyListMeasureResult() {
    _init_properties_LazyListState_kt__xj6vt9();
    return EmptyLazyListMeasureResult;
  }
  var EmptyLazyListMeasureResult;
  var androidx_compose_foundation_lazy_LazyListState$stable;
  function LazyListState$Companion$Saver$lambda($this$listSaver, it) {
    return listOf([it.lia(), it.mia()]);
  }
  function LazyListState$Companion$Saver$lambda_0(it) {
    return LazyListState_init_$Create$(it.l1(0), it.l1(1));
  }
  function LazyListState$prefetchScope$o$schedulePrefetch$lambda($onPrefetchFinished, $lastMeasureResult, $index) {
    return function ($this$schedulePrecompositionAndPremeasure) {
      var tmp;
      if (!($onPrefetchFinished == null)) {
        var mainAxisItemSize = 0;
        // Inline function 'kotlin.repeat' call
        var times = $this$schedulePrecompositionAndPremeasure.law();
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp_0 = mainAxisItemSize;
            var tmp_1;
            if ($lastMeasureResult.tie_1.equals(Orientation_Vertical_getInstance())) {
              // Inline function 'androidx.compose.ui.unit.IntSize.height' call
              var this_0 = $this$schedulePrecompositionAndPremeasure.maw(index);
              // Inline function 'androidx.compose.ui.util.unpackInt2' call
              var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
              tmp_1 = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
            } else {
              // Inline function 'androidx.compose.ui.unit.IntSize.width' call
              var this_1 = $this$schedulePrecompositionAndPremeasure.maw(index);
              // Inline function 'androidx.compose.ui.util.unpackInt1' call
              var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
              tmp_1 = convertToInt(shiftRight(value_0, 32));
            }
            mainAxisItemSize = tmp_0 + tmp_1 | 0;
          }
           while (inductionVariable < times);
        tmp = $onPrefetchFinished(new LazyListPrefetchResultScopeImpl($index, mainAxisItemSize));
      }
      return Unit_instance;
    };
  }
  function LazyListState_init_$Init$(firstVisibleItemIndex, firstVisibleItemScrollOffset, $this) {
    firstVisibleItemIndex = firstVisibleItemIndex === VOID ? 0 : firstVisibleItemIndex;
    firstVisibleItemScrollOffset = firstVisibleItemScrollOffset === VOID ? 0 : firstVisibleItemScrollOffset;
    LazyListState.call($this, firstVisibleItemIndex, firstVisibleItemScrollOffset, LazyListPrefetchStrategy_0());
    return $this;
  }
  function LazyListState_init_$Create$(firstVisibleItemIndex, firstVisibleItemScrollOffset) {
    return LazyListState_init_$Init$(firstVisibleItemIndex, firstVisibleItemScrollOffset, objectCreate(protoOf(LazyListState)));
  }
  function _set_canScrollForward__ffth81($this, _set____db54di) {
    var tmp0 = $this.phz_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyListState$_get_canScrollForward_$ref_5adtnb();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('canScrollForward', 1, tmp, tmp_0, LazyListState$_set_canScrollForward_$ref_j8ghnn());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _set_canScrollBackward__6c7ll1($this, _set____db54di) {
    var tmp0 = $this.qhz_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyListState$_get_canScrollBackward_$ref_1euzt1();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('canScrollBackward', 1, tmp, tmp_0, LazyListState$_set_canScrollBackward_$ref_4qrcmn());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function notifyPrefetchOnScroll($this, delta, layoutInfo) {
    if ($this.dhz_1) {
      // Inline function 'kotlin.with' call
      $this.shy_1.pih($this.khz_1, delta, layoutInfo);
    }
  }
  function traceVisibleItems($this, measureResult) {
    var firstVisibleItem = firstOrNull(measureResult.oie_1);
    var lastVisibleItem = lastOrNull(measureResult.oie_1);
    var tmp1_safe_receiver = firstVisibleItem == null ? null : firstVisibleItem.vib_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : fromInt(tmp1_safe_receiver);
    traceValue('firstVisibleItem:index', tmp2_elvis_lhs == null ? new Long(-1, -1) : tmp2_elvis_lhs);
    var tmp4_safe_receiver = lastVisibleItem == null ? null : lastVisibleItem.vib_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : fromInt(tmp4_safe_receiver);
    traceValue('lastVisibleItem:index', tmp5_elvis_lhs == null ? new Long(-1, -1) : tmp5_elvis_lhs);
  }
  function Companion_4() {
    Companion_instance_14 = this;
    var tmp = this;
    var tmp_0 = LazyListState$Companion$Saver$lambda;
    tmp.bij_1 = listSaver(tmp_0, LazyListState$Companion$Saver$lambda_0);
  }
  var Companion_instance_14;
  function Companion_getInstance_63() {
    if (Companion_instance_14 == null)
      new Companion_4();
    return Companion_instance_14;
  }
  function LazyListState$scrollableState$lambda(this$0) {
    return function (it) {
      return -this$0.cij(-it);
    };
  }
  function LazyListState$remeasurementModifier$1(this$0) {
    this.dij_1 = this$0;
  }
  protoOf(LazyListState$remeasurementModifier$1).xap = function (remeasurement) {
    this.dij_1.ehz_1 = remeasurement;
  };
  function LazyListState$prefetchState$lambda(this$0, $firstVisibleItemIndex) {
    return function ($this$LazyLayoutPrefetchState) {
      // Inline function 'kotlin.with' call
      var $this$with = this$0.shy_1;
      var tmp$ret$2;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance_2.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance_2.q52(previousSnapshot);
        try {
          tmp$ret$2 = $firstVisibleItemIndex;
          break $l$block;
        }finally {
          Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
        }
      }
      $this$with.rih($this$LazyLayoutPrefetchState, tmp$ret$2);
      return Unit_instance;
    };
  }
  function LazyListState$prefetchScope$1(this$0) {
    this.eij_1 = this$0;
  }
  protoOf(LazyListState$prefetchScope$1).sih = function (index, onPrefetchFinished) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
      var previousSnapshot = Companion_instance_2.p52();
      var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
      var newSnapshot = Companion_instance_2.q52(previousSnapshot);
      try {
        tmp$ret$0 = this.eij_1.xhy_1.u1();
        break $l$block;
      }finally {
        Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
      }
    }
    var lastMeasureResult = tmp$ret$0;
    var tmp = this.eij_1.vhy_1;
    return this.eij_1.jhz_1.mij(index, lastMeasureResult.nie_1, tmp, LazyListState$prefetchScope$o$schedulePrefetch$lambda(onPrefetchFinished, lastMeasureResult, index));
  };
  function LazyListState$_scrollIndicatorState$1(this$0) {
    this.nij_1 = this$0;
  }
  function LazyListState$_get_nearestRange_$ref_lpwyv4() {
    return constructCallableReference(function (p0) {
      return p0.yif();
    }, 1, 0, 261);
  }
  function LazyListState$scrollToItem$slambda(this$0, $index, $scrollOffset, resultContinuation) {
    this.wij_1 = this$0;
    this.xij_1 = $index;
    this.yij_1 = $scrollOffset;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyListState$scrollToItem$slambda).zh6 = function ($this$scroll, $completion) {
    var tmp = this.ah7($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyListState$scrollToItem$slambda).ja = function (p1, $completion) {
    return this.zh6((!(p1 == null) ? isInterface(p1, ScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyListState$scrollToItem$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.wij_1.yii(this.xij_1, this.yij_1, true);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(LazyListState$scrollToItem$slambda).ah7 = function ($this$scroll, completion) {
    var i = new LazyListState$scrollToItem$slambda(this.wij_1, this.xij_1, this.yij_1, completion);
    i.zij_1 = $this$scroll;
    return i;
  };
  function LazyListState$scrollToItem$slambda_0(this$0, $index, $scrollOffset, resultContinuation) {
    var i = new LazyListState$scrollToItem$slambda(this$0, $index, $scrollOffset, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.zh6($this$scroll, $completion);
    }, 1);
  }
  function LazyListState$_get_canScrollForward_$ref_5adtnb() {
    return constructCallableReference(function (p0) {
      return p0.mg7();
    }, 1, 0, 262);
  }
  function LazyListState$_set_canScrollForward_$ref_j8ghnn() {
    return constructCallableReference(function (p0, p1) {
      _set_canScrollForward__ffth81(p0, p1);
      return Unit_instance;
    }, 2, 0, 263);
  }
  function LazyListState$_get_canScrollBackward_$ref_1euzt1() {
    return constructCallableReference(function (p0) {
      return p0.ng7();
    }, 1, 0, 264);
  }
  function LazyListState$_set_canScrollBackward_$ref_4qrcmn() {
    return constructCallableReference(function (p0, p1) {
      _set_canScrollBackward__6c7ll1(p0, p1);
      return Unit_instance;
    }, 2, 0, 265);
  }
  function LazyListState$animateScrollToItem$slambda(this$0, $index, $scrollOffset, resultContinuation) {
    this.iik_1 = this$0;
    this.jik_1 = $index;
    this.kik_1 = $scrollOffset;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyListState$animateScrollToItem$slambda).zh6 = function ($this$scroll, $completion) {
    var tmp = this.ah7($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyListState$animateScrollToItem$slambda).ja = function (p1, $completion) {
    return this.zh6((!(p1 == null) ? isInterface(p1, ScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyListState$animateScrollToItem$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = animateScrollToItem(LazyLayoutScrollScope(this.iik_1, this.lik_1), this.jik_1, this.kik_1, 100, this.iik_1.di0(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LazyListState$animateScrollToItem$slambda).ah7 = function ($this$scroll, completion) {
    var i = new LazyListState$animateScrollToItem$slambda(this.iik_1, this.jik_1, this.kik_1, completion);
    i.lik_1 = $this$scroll;
    return i;
  };
  function LazyListState$animateScrollToItem$slambda_0(this$0, $index, $scrollOffset, resultContinuation) {
    var i = new LazyListState$animateScrollToItem$slambda(this$0, $index, $scrollOffset, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.zh6($this$scroll, $completion);
    }, 1);
  }
  function $scrollCOROUTINE$(_this__u8e3s4, scrollPriority, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uik_1 = _this__u8e3s4;
    this.vik_1 = scrollPriority;
    this.wik_1 = block;
  }
  protoOf($scrollCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (this.uik_1.xhy_1.u1() === get_EmptyLazyListMeasureResult()) {
              this.n9_1 = 1;
              suspendResult = this.uik_1.ghz_1.ail(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.uik_1.bhz_1.pg7(this.vik_1, this.wik_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $animateScrollToItemCOROUTINE$(_this__u8e3s4, index, scrollOffset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jil_1 = _this__u8e3s4;
    this.kil_1 = index;
    this.lil_1 = scrollOffset;
  }
  protoOf($animateScrollToItemCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.jil_1.ahz_1 = true;
            this.n9_1 = 2;
            suspendResult = this.jil_1.qg7(VOID, LazyListState$animateScrollToItem$slambda_0(this.jil_1, this.kil_1, this.lil_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            this.jil_1.ahz_1 = false;
            return Unit_instance;
          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            this.jil_1.ahz_1 = false;
            throw t;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function LazyListState(firstVisibleItemIndex, firstVisibleItemScrollOffset, prefetchStrategy) {
    Companion_getInstance_63();
    firstVisibleItemIndex = firstVisibleItemIndex === VOID ? 0 : firstVisibleItemIndex;
    firstVisibleItemScrollOffset = firstVisibleItemScrollOffset === VOID ? 0 : firstVisibleItemScrollOffset;
    prefetchStrategy = prefetchStrategy === VOID ? LazyListPrefetchStrategy_0() : prefetchStrategy;
    this.shy_1 = prefetchStrategy;
    this.thy_1 = false;
    this.uhy_1 = null;
    this.vhy_1 = false;
    this.why_1 = new LazyListScrollPosition(firstVisibleItemIndex, firstVisibleItemScrollOffset);
    this.xhy_1 = mutableStateOf(get_EmptyLazyListMeasureResult(), neverEqualPolicy());
    this.yhy_1 = funMutableInteractionSource();
    this.zhy_1 = 0.0;
    this.ahz_1 = false;
    var tmp = this;
    tmp.bhz_1 = ScrollableState_0(LazyListState$scrollableState$lambda(this));
    this.chz_1 = 0;
    this.dhz_1 = true;
    this.ehz_1 = null;
    var tmp_0 = this;
    tmp_0.fhz_1 = new LazyListState$remeasurementModifier$1(this);
    this.ghz_1 = new AwaitFirstLayoutModifier();
    this.hhz_1 = new LazyLayoutItemAnimator();
    this.ihz_1 = new LazyLayoutBeyondBoundsInfo();
    var tmp_1 = this;
    var tmp_2 = this.shy_1.oih();
    tmp_1.jhz_1 = LazyLayoutPrefetchState_init_$Create$(tmp_2, LazyListState$prefetchState$lambda(this, firstVisibleItemIndex));
    var tmp_3 = this;
    tmp_3.khz_1 = new LazyListState$prefetchScope$1(this);
    var tmp_4 = this;
    tmp_4.lhz_1 = new LazyListState$_scrollIndicatorState$1(this);
    this.mhz_1 = LazyLayoutPinnedItemList_init_$Create$();
    this.nhz_1 = this.why_1.jii_1;
    this.ohz_1 = _ObservableScopeInvalidator___init__impl__ism0sl();
    this.phz_1 = mutableStateOf(false);
    this.qhz_1 = mutableStateOf(false);
    this.rhz_1 = _ObservableScopeInvalidator___init__impl__ism0sl();
    this.shz_1 = new LazyLayoutScrollDeltaBetweenPasses();
  }
  protoOf(LazyListState).lia = function () {
    return this.why_1.bi0();
  };
  protoOf(LazyListState).mia = function () {
    return this.why_1.kia();
  };
  protoOf(LazyListState).thz = function () {
    return this.xhy_1.u1();
  };
  protoOf(LazyListState).di0 = function () {
    return this.xhy_1.u1().mie_1;
  };
  protoOf(LazyListState).yif = function () {
    var tmp0 = this.nhz_1;
    var tmp = KProperty1;
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('nearestRange', 1, tmp, LazyListState$_get_nearestRange_$ref_lpwyv4(), null);
    return tmp0.u1();
  };
  protoOf(LazyListState).mil = function (index, scrollOffset, $completion) {
    return this.qg7(VOID, LazyListState$scrollToItem$slambda_0(this, index, scrollOffset, null), $completion);
  };
  protoOf(LazyListState).pia = function (index, scrollOffset, $completion, $super) {
    scrollOffset = scrollOffset === VOID ? 0 : scrollOffset;
    return $super === VOID ? this.mil(index, scrollOffset, $completion) : $super.mil.call(this, index, scrollOffset, $completion);
  };
  protoOf(LazyListState).yii = function (index, scrollOffset, forceRemeasure) {
    var positionChanged = !(this.why_1.bi0() === index) || !(this.why_1.kia() === scrollOffset);
    if (positionChanged) {
      this.hhz_1.u4c();
      var tmp = this.shy_1;
      var tmp0_safe_receiver = tmp instanceof CacheWindowLogic ? tmp : null;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.nil();
      }
    }
    this.why_1.sii(index, scrollOffset);
    if (forceRemeasure) {
      var tmp1_safe_receiver = this.ehz_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.ob8();
      }
    } else {
      ObservableScopeInvalidator__invalidateScope_impl_b202xc(this.ohz_1);
    }
  };
  protoOf(LazyListState).pg7 = function (scrollPriority, block, $completion) {
    var tmp = new $scrollCOROUTINE$(this, scrollPriority, block, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyListState).rg7 = function (delta) {
    return this.bhz_1.rg7(delta);
  };
  protoOf(LazyListState).sg7 = function () {
    return this.bhz_1.sg7();
  };
  protoOf(LazyListState).mg7 = function () {
    var tmp0 = this.phz_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyListState$_get_canScrollForward_$ref_5adtnb();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('canScrollForward', 1, tmp, tmp_0, LazyListState$_set_canScrollForward_$ref_j8ghnn());
    return tmp0.u1();
  };
  protoOf(LazyListState).ng7 = function () {
    var tmp0 = this.qhz_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyListState$_get_canScrollBackward_$ref_1euzt1();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('canScrollBackward', 1, tmp, tmp_0, LazyListState$_set_canScrollBackward_$ref_4qrcmn());
    return tmp0.u1();
  };
  protoOf(LazyListState).cij = function (distance) {
    if (distance < 0 && !this.mg7() || (distance > 0 && !this.ng7())) {
      return 0.0;
    }
    // Inline function 'kotlin.math.abs' call
    var x = this.zhy_1;
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(Math.abs(x) <= 0.5)) {
      var tmp$ret$2 = 'entered drag with non-zero pending scroll';
      throwIllegalStateException(tmp$ret$2);
    }
    this.vhy_1 = true;
    this.zhy_1 = this.zhy_1 + distance;
    // Inline function 'kotlin.math.abs' call
    var x_0 = this.zhy_1;
    if (Math.abs(x_0) > 0.5) {
      var preScrollToBeConsumed = this.zhy_1;
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = this.zhy_1;
      var tmp;
      if (isNaN_0(this_0)) {
        tmp = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp = roundToInt(this_0);
      }
      var intDelta = tmp;
      var scrolledLayoutInfo = this.xhy_1.u1().hig(intDelta, !this.thy_1);
      if (!(scrolledLayoutInfo == null) && !(this.uhy_1 == null)) {
        var tmp0_safe_receiver = this.uhy_1;
        var scrolledApproachLayoutInfo = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hig(intDelta, true);
        if (!(scrolledApproachLayoutInfo == null)) {
          this.uhy_1 = scrolledApproachLayoutInfo;
        } else {
          scrolledLayoutInfo = null;
        }
      }
      if (!(scrolledLayoutInfo == null)) {
        this.oil(scrolledLayoutInfo, this.thy_1, true);
        ObservableScopeInvalidator__invalidateScope_impl_b202xc(this.rhz_1);
        notifyPrefetchOnScroll(this, preScrollToBeConsumed - this.zhy_1, scrolledLayoutInfo);
      } else {
        var tmp1_safe_receiver = this.ehz_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ob8();
        }
        notifyPrefetchOnScroll(this, preScrollToBeConsumed - this.zhy_1, this.thz());
      }
    }
    // Inline function 'kotlin.math.abs' call
    var x_1 = this.zhy_1;
    if (Math.abs(x_1) <= 0.5) {
      return distance;
    } else {
      var scrollConsumed = distance - this.zhy_1;
      this.zhy_1 = 0.0;
      return scrollConsumed;
    }
  };
  protoOf(LazyListState).pil = function (index, scrollOffset, $completion) {
    var tmp = new $animateScrollToItemCOROUTINE$(this, index, scrollOffset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyListState).qil = function (index, scrollOffset, $completion, $super) {
    scrollOffset = scrollOffset === VOID ? 0 : scrollOffset;
    return $super === VOID ? this.pil(index, scrollOffset, $completion) : $super.pil.call(this, index, scrollOffset, $completion);
  };
  protoOf(LazyListState).oil = function (result, isLookingAhead, visibleItemsStayedTheSame) {
    this.jhz_1.kij_1 = result.oie_1.n1();
    if (!isLookingAhead && this.thy_1) {
      this.uhy_1 = result;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance_2.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance_2.q52(previousSnapshot);
        try {
          var tmp;
          var tmp_0;
          if (this.shz_1.uil()) {
            var tmp0_safe_receiver = result.eie_1;
            tmp_0 = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vib_1) === this.why_1.bi0();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp = result.fie_1 === this.why_1.kia();
          } else {
            tmp = false;
          }
          if (tmp) {
            this.shz_1.vil();
          }
          break $l$block;
        }finally {
          Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
        }
      }
    } else {
      if (isLookingAhead) {
        this.thy_1 = true;
      }
      _set_canScrollBackward__6c7ll1(this, result.ng7());
      _set_canScrollForward__ffth81(this, result.gie_1);
      this.zhy_1 = this.zhy_1 - result.hie_1;
      this.xhy_1.s21(result);
      if (visibleItemsStayedTheSame) {
        this.why_1.rii(result.fie_1);
      } else {
        traceVisibleItems(this, result);
        this.why_1.qii(result);
        if (this.dhz_1) {
          // Inline function 'kotlin.with' call
          this.shy_1.qih(this.khz_1, result);
        }
      }
      if (isLookingAhead) {
        this.shz_1.til(result.jie_1, result.mie_1, result.lie_1);
      }
      this.chz_1 = this.chz_1 + 1 | 0;
    }
  };
  protoOf(LazyListState).die = function (result, isLookingAhead, visibleItemsStayedTheSame, $super) {
    visibleItemsStayedTheSame = visibleItemsStayedTheSame === VOID ? false : visibleItemsStayedTheSame;
    var tmp;
    if ($super === VOID) {
      this.oil(result, isLookingAhead, visibleItemsStayedTheSame);
      tmp = Unit_instance;
    } else {
      tmp = $super.oil.call(this, result, isLookingAhead, visibleItemsStayedTheSame);
    }
    return tmp;
  };
  protoOf(LazyListState).cie = function () {
    return this.shz_1.cie();
  };
  protoOf(LazyListState).bie = function (itemProvider, firstItemIndex) {
    return this.why_1.tii(itemProvider, firstItemIndex);
  };
  function rememberLazyListState(initialFirstVisibleItemIndex, initialFirstVisibleItemScrollOffset, $composer, $changed, $default) {
    _init_properties_LazyListState_kt__xj6vt9();
    var initialFirstVisibleItemIndex_0 = {_v: initialFirstVisibleItemIndex};
    var initialFirstVisibleItemScrollOffset_0 = {_v: initialFirstVisibleItemScrollOffset};
    var $composer_0 = $composer;
    if (!(($default & 1) === 0)) {
      initialFirstVisibleItemIndex_0._v = 0;
    }
    if (!(($default & 2) === 0)) {
      initialFirstVisibleItemScrollOffset_0._v = 0;
    }
    var tmp = Companion_getInstance_63().bij_1;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.m31(initialFirstVisibleItemIndex_0._v) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.m31(initialFirstVisibleItemScrollOffset_0._v) || ($changed & 48) === 32));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp_0;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = rememberLazyListState$lambda(initialFirstVisibleItemIndex_0, initialFirstVisibleItemScrollOffset_0);
      $composer_0.j31(value);
      tmp_0 = value;
    } else {
      tmp_0 = it;
    }
    var tmp$ret$0 = tmp_0;
    return rememberSaveable([], tmp, tmp$ret$0, $composer_0, 0);
  }
  function EmptyLazyListMeasureResult$1() {
    this.wil_1 = 0;
    this.xil_1 = 0;
    this.yil_1 = emptyMap();
  }
  protoOf(EmptyLazyListMeasureResult$1).h5e = function () {
    return this.wil_1;
  };
  protoOf(EmptyLazyListMeasureResult$1).i5e = function () {
    return this.xil_1;
  };
  protoOf(EmptyLazyListMeasureResult$1).sad = function () {
    return this.yil_1;
  };
  protoOf(EmptyLazyListMeasureResult$1).uad = function () {
  };
  function rememberLazyListState$lambda($initialFirstVisibleItemIndex, $initialFirstVisibleItemScrollOffset) {
    return function () {
      return LazyListState_init_$Create$($initialFirstVisibleItemIndex._v, $initialFirstVisibleItemScrollOffset._v);
    };
  }
  var properties_initialized_LazyListState_kt_8bkzkf;
  function _init_properties_LazyListState_kt__xj6vt9() {
    if (!properties_initialized_LazyListState_kt_8bkzkf) {
      properties_initialized_LazyListState_kt_8bkzkf = true;
      var tmp0_measureResult = new EmptyLazyListMeasureResult$1();
      var tmp1_visibleItemsInfo = emptyList();
      var tmp2_orientation = Orientation_Vertical_getInstance();
      var tmp3_coroutineScope = CoroutineScope_0(EmptyCoroutineContext_getInstance());
      var tmp4_density = Density_0(1.0);
      var tmp5_childConstraints = Constraints_0();
      EmptyLazyListMeasureResult = new LazyListMeasureResult(null, 0, false, 0.0, tmp0_measureResult, 0.0, false, tmp3_coroutineScope, tmp4_density, tmp5_childConstraints, tmp1_visibleItemsInfo, 0, 0, 0, false, tmp2_orientation, 0, 0);
      androidx_compose_foundation_lazy_LazyListState$stable = 0;
    }
  }
  var androidx_compose_foundation_lazy_grid_LazyGridSlots$stable;
  function LazyGridSlots(sizes, positions) {
    this.zil_1 = sizes;
    this.aim_1 = positions;
  }
  function LazyGrid(modifier, state, slots, contentPadding, reverseLayout, isVertical, flingBehavior, userScrollEnabled, overscrollEffect, verticalArrangement, horizontalArrangement, content, $composer, $changed, $changed1, $default) {
    var modifier_0 = {_v: modifier};
    var contentPadding_0 = {_v: contentPadding};
    var reverseLayout_0 = {_v: reverseLayout};
    var flingBehavior_0 = {_v: flingBehavior};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(708740370);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(state) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ((($changed & 512) === 0 ? $composer_0.k31(slots) : $composer_0.q31(slots)) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(contentPadding_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(reverseLayout_0._v) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.l31(isVertical) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | (($default & 64) === 0 && $composer_0.k31(flingBehavior_0._v) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.l31(userScrollEnabled) ? 8388608 : 4194304);
    if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.k31(overscrollEffect) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.k31(verticalArrangement) ? 536870912 : 268435456);
    if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(horizontalArrangement) ? 4 : 2);
    if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 19) === 18), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 1) === 0)) {
          modifier_0._v = Companion_instance_0;
        }
        if (!(($default & 8) === 0)) {
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
          contentPadding_0._v = PaddingValues(tmp$ret$0);
        }
        if (!(($default & 16) === 0)) {
          reverseLayout_0._v = false;
        }
        if (!(($default & 64) === 0)) {
          flingBehavior_0._v = ScrollableDefaults_instance.mh7($composer_0, 6);
          $dirty = $dirty & -3670017;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 64) === 0))
          $dirty = $dirty & -3670017;
      }
      $composer_0.r30();
      var itemProviderLambda = rememberLazyGridItemProviderLambda(state, content, $composer_0, 14 & $dirty >> 3 | 112 & $dirty1);
      var semanticState = rememberLazyGridSemanticState(state, reverseLayout_0._v, $composer_0, 14 & $dirty >> 3 | 112 & $dirty >> 9);
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_1 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = LazyGrid$lambda;
      }
      var composer = $composer_1;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = createCompositionCoroutineScope(getContext(), composer);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var coroutineScope = tmp;
      var tmp0 = get_LocalGraphicsContext();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_2 = $composer_0;
      var graphicsContext = $composer_2.u31(tmp0);
      var tmp0_0 = get_LocalScrollCaptureInProgress();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_3 = $composer_0;
      var stickyHeadersEnabled = !$composer_3.u31(tmp0_0);
      var measurePolicy = rememberLazyGridMeasurePolicy(itemProviderLambda, state, slots, contentPadding_0._v, reverseLayout_0._v, isVertical, horizontalArrangement, verticalArrangement, coroutineScope, graphicsContext, stickyHeadersEnabled ? Companion_getInstance_69().tia_1 : null, $composer_0, 112 & $dirty | 896 & $dirty | 7168 & $dirty | 57344 & $dirty | 458752 & $dirty | 3670016 & $dirty1 << 18 | 29360128 & $dirty >> 6, 0);
      var orientation = isVertical ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance();
      var tmp_0;
      if (userScrollEnabled) {
        $composer_0.m30(27281635);
        var tmp0_group = lazyLayoutBeyondBoundsModifier(Companion_instance_0, rememberLazyGridBeyondBoundsState(state, $composer_0, 14 & $dirty >> 3), state.qim_1, reverseLayout_0._v, orientation);
        $composer_0.n30();
        tmp_0 = tmp0_group;
      } else {
        $composer_0.m30(27577840);
        $composer_0.n30();
        tmp_0 = Companion_instance_0;
      }
      var beyondBoundsModifier = tmp_0;
      var tmp0_$receiver = lazyLayoutSemantics(modifier_0._v.d8v(state.nim_1).d8v(state.oim_1), itemProviderLambda, semanticState, orientation, userScrollEnabled, reverseLayout_0._v, $composer_0, 57344 & $dirty >> 9 | 458752 & $dirty << 3).d8v(beyondBoundsModifier).d8v(state.pim_1.eib_1);
      var tmp1_interactionSource = state.him_1;
      var tmp2_modifier = scrollableArea_0(tmp0_$receiver, state, orientation, overscrollEffect, userScrollEnabled, reverseLayout_0._v, flingBehavior_0._v, tmp1_interactionSource);
      var tmp3_prefetchState = state.rim_1;
      LazyLayout(itemProviderLambda, tmp2_modifier, tmp3_prefetchState, measurePolicy, $composer_0, 0, 0);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(LazyGrid$lambda_0(modifier_0, state, slots, contentPadding_0, reverseLayout_0, isVertical, flingBehavior_0, userScrollEnabled, overscrollEffect, verticalArrangement, horizontalArrangement, content, $changed, $changed1, $default));
    }
  }
  function rememberLazyGridMeasurePolicy(itemProviderLambda, state, slots, contentPadding, reverseLayout, isVertical, horizontalArrangement, verticalArrangement, coroutineScope, graphicsContext, stickyItemsScrollBehavior, $composer, $changed, $changed1) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!(!!(!!(!!(!!((($changed & 112 ^ 48) > 32 && $composer_0.k31(state) || ($changed & 48) === 32) | (($changed & 896 ^ 384) > 256 && $composer_0.k31(slots) || ($changed & 384) === 256)) | (($changed & 7168 ^ 3072) > 2048 && $composer_0.k31(contentPadding) || ($changed & 3072) === 2048)) | (($changed & 57344 ^ 24576) > 16384 && $composer_0.l31(reverseLayout) || ($changed & 24576) === 16384)) | (($changed & 458752 ^ 196608) > 131072 && $composer_0.l31(isVertical) || ($changed & 196608) === 131072)) | (($changed & 3670016 ^ 1572864) > 1048576 && $composer_0.k31(horizontalArrangement) || ($changed & 1572864) === 1048576)) | (($changed & 29360128 ^ 12582912) > 8388608 && $composer_0.k31(verticalArrangement) || ($changed & 12582912) === 8388608)) | $composer_0.k31(graphicsContext));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var tmp_0 = rememberLazyGridMeasurePolicy$lambda(state, isVertical, contentPadding, reverseLayout, itemProviderLambda, slots, verticalArrangement, horizontalArrangement, coroutineScope, graphicsContext, stickyItemsScrollBehavior);
      var value = new sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_0(tmp_0);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function keepAroundItems_0(_this__u8e3s4, orientation, visibleItemsList, measuredLineProvider) {
    // Inline function 'androidx.compose.ui.util.trace' call
    var tmp;
    if (_this__u8e3s4.uib()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !visibleItemsList.r();
    } else {
      tmp = false;
    }
    if (tmp) {
      var firstVisibleItemIndex = lineIndex(first(visibleItemsList), orientation);
      var lastVisibleItemIndex = lineIndex(last(visibleItemsList), orientation);
      var inductionVariable = _this__u8e3s4.oib_1;
      if (inductionVariable < firstVisibleItemIndex)
        do {
          var line = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          measuredLineProvider.hin(line);
        }
         while (inductionVariable < firstVisibleItemIndex);
      var inductionVariable_0 = lastVisibleItemIndex + 1 | 0;
      var last_0 = _this__u8e3s4.pib_1;
      if (inductionVariable_0 <= last_0)
        do {
          var line_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          measuredLineProvider.hin(line_0);
        }
         while (!(line_0 === last_0));
    }
  }
  function sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_0(function_0) {
    this.iin_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_0).bid = function (_this__u8e3s4, constraints) {
    return this.iin_1(_this__u8e3s4, new Constraints(constraints));
  };
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_0).q3 = function () {
    return this.iin_1;
  };
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, LazyLayoutMeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function LazyGrid$lambda() {
    return EmptyCoroutineContext_getInstance();
  }
  function LazyGrid$lambda_0($modifier, $state, $slots, $contentPadding, $reverseLayout, $isVertical, $flingBehavior, $userScrollEnabled, $overscrollEffect, $verticalArrangement, $horizontalArrangement, $content, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      LazyGrid($modifier._v, $state, $slots, $contentPadding._v, $reverseLayout._v, $isVertical, $flingBehavior._v, $userScrollEnabled, $overscrollEffect, $verticalArrangement, $horizontalArrangement, $content, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function rememberLazyGridMeasurePolicy$1($state, $isVertical, $reverseLayout, $itemProvider, $this_LazyLayoutMeasurePolicy, $spaceBetweenLines, $beforeContentPadding, $afterContentPadding, $visualItemOffset) {
    this.rin_1 = $state;
    this.sin_1 = $isVertical;
    this.tin_1 = $reverseLayout;
    this.nin_1 = $this_LazyLayoutMeasurePolicy;
    this.oin_1 = $beforeContentPadding;
    this.pin_1 = $afterContentPadding;
    this.qin_1 = $visualItemOffset;
    LazyGridMeasuredItemProvider.call(this, $itemProvider, $this_LazyLayoutMeasurePolicy, $spaceBetweenLines);
  }
  protoOf(rememberLazyGridMeasurePolicy$1).uin = function (index, key, contentType, crossAxisSize, mainAxisSpacing, placeables, constraints, lane, span) {
    var tmp0_layoutDirection = this.nin_1.r6p();
    var tmp1_animator = this.rin_1.pim_1;
    return new LazyGridMeasuredItem(index, key, this.sin_1, crossAxisSize, mainAxisSpacing, this.tin_1, tmp0_layoutDirection, this.oin_1, this.pin_1, placeables, this.qin_1, contentType, tmp1_animator, constraints, lane, span);
  };
  function rememberLazyGridMeasurePolicy$2($isVertical, $resolvedSlots, $itemsCount, $spaceBetweenLines, $measuredItemProvider, $spanLayoutProvider) {
    this.iio_1 = $isVertical;
    this.hio_1 = $resolvedSlots;
    LazyGridMeasuredLineProvider.call(this, $isVertical, $resolvedSlots, $itemsCount, $spaceBetweenLines, $measuredItemProvider, $spanLayoutProvider);
  }
  protoOf(rememberLazyGridMeasurePolicy$2).jio = function (index, items, spans, mainAxisSpacing) {
    return new LazyGridMeasuredLine(index, items, this.hio_1, spans, this.iio_1, mainAxisSpacing);
  };
  function rememberLazyGridMeasurePolicy$lambda$lambda($spanLayoutProvider, $measuredLineProvider) {
    return function (line) {
      var lineConfiguration = $spanLayoutProvider.wio(line);
      var index = lineConfiguration.xio_1;
      var slot = 0;
      var result = ArrayList_init_$Create$_0(lineConfiguration.yio_1.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = lineConfiguration.yio_1;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index_0);
          var it = item.zio_1;
          var span = _GridItemSpan___get_currentLineSpan__impl__sg7kqc(it);
          result.j1(to(index, new Constraints($measuredLineProvider.kio(slot, span))));
          index = index + 1 | 0;
          slot = slot + span | 0;
        }
         while (inductionVariable <= last);
      return result;
    };
  }
  function rememberLazyGridMeasurePolicy$lambda$lambda_0($spanLayoutProvider) {
    return function (itemIndex) {
      return $spanLayoutProvider.aip(itemIndex);
    };
  }
  function rememberLazyGridMeasurePolicy$lambda$lambda_1($this_LazyLayoutMeasurePolicy, $containerConstraints, $totalHorizontalPadding, $totalVerticalPadding) {
    return function (width, height, placement) {
      return $this_LazyLayoutMeasurePolicy.kag(constrainWidth($containerConstraints, width + $totalHorizontalPadding | 0), constrainHeight($containerConstraints, height + $totalVerticalPadding | 0), emptyMap(), placement);
    };
  }
  function rememberLazyGridMeasurePolicy$lambda($state, $isVertical, $contentPadding, $reverseLayout, $itemProviderLambda, $slots, $verticalArrangement, $horizontalArrangement, $coroutineScope, $graphicsContext, $stickyItemsScrollBehavior) {
    return function ($this$LazyLayoutMeasurePolicy, containerConstraints) {
      ObservableScopeInvalidator__attachToScope_impl_wvvw97($state.xim_1);
      var isInLookaheadScope = $state.cim_1 || $this$LazyLayoutMeasurePolicy.jag();
      checkScrollableContainerConstraints(containerConstraints.m5e_1, $isVertical ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance());
      var tmp;
      if ($isVertical) {
        tmp = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.adw($this$LazyLayoutMeasurePolicy.r6p()));
      } else {
        tmp = $this$LazyLayoutMeasurePolicy.w5e(calculateStartPadding($contentPadding, $this$LazyLayoutMeasurePolicy.r6p()));
      }
      var startPadding = tmp;
      var tmp_0;
      if ($isVertical) {
        tmp_0 = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.zdv($this$LazyLayoutMeasurePolicy.r6p()));
      } else {
        tmp_0 = $this$LazyLayoutMeasurePolicy.w5e(calculateEndPadding($contentPadding, $this$LazyLayoutMeasurePolicy.r6p()));
      }
      var endPadding = tmp_0;
      var topPadding = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.fdw());
      var bottomPadding = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.gdw());
      var totalVerticalPadding = topPadding + bottomPadding | 0;
      var totalHorizontalPadding = startPadding + endPadding | 0;
      var totalMainAxisPadding = $isVertical ? totalVerticalPadding : totalHorizontalPadding;
      var beforeContentPadding = $isVertical && !$reverseLayout ? topPadding : $isVertical && $reverseLayout ? bottomPadding : !$isVertical && !$reverseLayout ? startPadding : endPadding;
      var afterContentPadding = totalMainAxisPadding - beforeContentPadding | 0;
      var contentConstraints = offset(containerConstraints.m5e_1, -totalHorizontalPadding | 0, -totalVerticalPadding | 0);
      var itemProvider = $itemProviderLambda();
      var spanLayoutProvider = itemProvider.bip();
      var resolvedSlots = $slots.cip($this$LazyLayoutMeasurePolicy, contentConstraints);
      var slotsPerLine = resolvedSlots.zil_1.length;
      spanLayoutProvider.dip(slotsPerLine);
      var tmp_1;
      if ($isVertical) {
        // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
        var value = $verticalArrangement;
        if (value == null) {
          var tmp$ret$1 = 'null verticalArrangement when isVertical == true';
          throwIllegalArgumentExceptionForNullCheck(tmp$ret$1);
        }
        tmp_1 = value.zdp();
      } else {
        // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
        var value_0 = $horizontalArrangement;
        if (value_0 == null) {
          var tmp$ret$3 = 'null horizontalArrangement when isVertical == false';
          throwIllegalArgumentExceptionForNullCheck(tmp$ret$3);
        }
        tmp_1 = value_0.zdp();
      }
      var spaceBetweenLinesDp = tmp_1;
      var spaceBetweenLines = $this$LazyLayoutMeasurePolicy.w5e(spaceBetweenLinesDp);
      var itemsCount = itemProvider.aie();
      var tmp_2;
      if ($isVertical) {
        tmp_2 = _Constraints___get_maxHeight__impl__dt3e8z(containerConstraints.m5e_1) - totalVerticalPadding | 0;
      } else {
        tmp_2 = _Constraints___get_maxWidth__impl__uuyqc(containerConstraints.m5e_1) - totalHorizontalPadding | 0;
      }
      var mainAxisAvailableSize = tmp_2;
      var tmp_3;
      if (!$reverseLayout || mainAxisAvailableSize > 0) {
        // Inline function 'androidx.compose.ui.unit.IntOffset' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(startPadding), 32), bitwiseAnd(fromInt(topPadding), new Long(-1, 0)));
        tmp_3 = _IntOffset___init__impl__rq8h7b(tmp$ret$5);
      } else {
        var tmp0 = $isVertical ? startPadding : startPadding + mainAxisAvailableSize | 0;
        // Inline function 'androidx.compose.ui.unit.IntOffset' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2 = $isVertical ? topPadding + mainAxisAvailableSize | 0 : topPadding;
        var tmp$ret$7 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
        tmp_3 = _IntOffset___init__impl__rq8h7b(tmp$ret$7);
      }
      var visualItemOffset = tmp_3;
      var measuredItemProvider = new rememberLazyGridMeasurePolicy$1($state, $isVertical, $reverseLayout, itemProvider, $this$LazyLayoutMeasurePolicy, spaceBetweenLines, beforeContentPadding, afterContentPadding, visualItemOffset);
      var measuredLineProvider = new rememberLazyGridMeasurePolicy$2($isVertical, resolvedSlots, itemsCount, spaceBetweenLines, measuredItemProvider, spanLayoutProvider);
      var prefetchInfoRetriever = rememberLazyGridMeasurePolicy$lambda$lambda(spanLayoutProvider, measuredLineProvider);
      var lineIndexProvider = rememberLazyGridMeasurePolicy$lambda$lambda_0(spanLayoutProvider);
      var firstVisibleLineIndex;
      var firstVisibleLineScrollOffset;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance_2.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance_2.q52(previousSnapshot);
        try {
          var index = $state.eip(itemProvider, $state.lia());
          if (index < itemsCount || itemsCount <= 0) {
            firstVisibleLineIndex = spanLayoutProvider.aip(index);
            firstVisibleLineScrollOffset = $state.mia();
          } else {
            firstVisibleLineIndex = spanLayoutProvider.aip(itemsCount - 1 | 0);
            firstVisibleLineScrollOffset = 0;
          }
          break $l$block;
        }finally {
          Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
        }
      }
      var pinnedItems = calculateLazyLayoutPinnedIndices(itemProvider, $state.uim_1, $state.qim_1);
      var tmp_4;
      if ($this$LazyLayoutMeasurePolicy.jag() || !isInLookaheadScope) {
        tmp_4 = $state.iim_1;
      } else {
        tmp_4 = $state.cie();
      }
      var scrollToBeConsumed = tmp_4;
      var tmp0_itemAnimator = $state.pim_1;
      var tmp1_isLookingAhead = $this$LazyLayoutMeasurePolicy.jag();
      var tmp2_approachLayoutInfo = $state.dim_1;
      var tmp3_placementScopeInvalidator = $state.wim_1;
      var measureResult = measureLazyGrid(itemsCount, measuredLineProvider, measuredItemProvider, mainAxisAvailableSize, beforeContentPadding, afterContentPadding, spaceBetweenLines, firstVisibleLineIndex, firstVisibleLineScrollOffset, scrollToBeConsumed, contentConstraints, $isVertical, $verticalArrangement, $horizontalArrangement, $reverseLayout, $this$LazyLayoutMeasurePolicy, tmp0_itemAnimator, slotsPerLine, pinnedItems, isInLookaheadScope, tmp1_isLookingAhead, tmp2_approachLayoutInfo, $coroutineScope, tmp3_placementScopeInvalidator, $graphicsContext, prefetchInfoRetriever, lineIndexProvider, $stickyItemsScrollBehavior, rememberLazyGridMeasurePolicy$lambda$lambda_1($this$LazyLayoutMeasurePolicy, containerConstraints.m5e_1, totalHorizontalPadding, totalVerticalPadding));
      $state.fip(measureResult, $this$LazyLayoutMeasurePolicy.jag());
      var tmp_5 = $state.bim_1;
      var tmp4_safe_receiver = tmp_5 instanceof CacheWindowLogic ? tmp_5 : null;
      if (tmp4_safe_receiver == null)
        null;
      else {
        keepAroundItems_0(tmp4_safe_receiver, measureResult.xip_1, measureResult.sip_1, measuredLineProvider);
      }
      return measureResult;
    };
  }
  var androidx_compose_foundation_lazy_grid_LazyGridBeyondBoundsState$stable;
  function rememberLazyGridBeyondBoundsState(state, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(state) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = new LazyGridBeyondBoundsState(state);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function LazyGridBeyondBoundsState(state) {
    this.aiq_1 = state;
  }
  protoOf(LazyGridBeyondBoundsState).aie = function () {
    return this.aiq_1.thz().ci0();
  };
  protoOf(LazyGridBeyondBoundsState).yie = function () {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.aiq_1.thz().uhz().r();
  };
  protoOf(LazyGridBeyondBoundsState).zie = function () {
    return this.aiq_1.lia();
  };
  protoOf(LazyGridBeyondBoundsState).aif = function () {
    return last(this.aiq_1.thz().uhz()).bi0();
  };
  protoOf(LazyGridBeyondBoundsState).bif = function () {
    if (this.aiq_1.thz().uhz().r())
      return 0;
    var viewportSize = get_singleAxisViewportSize(this.aiq_1.thz());
    var lineAverageSize = visibleLinesAverageMainAxisSize(this.aiq_1.thz());
    if (lineAverageSize === 0)
      return 1;
    return coerceAtLeast_0(viewportSize / lineAverageSize | 0, 1);
  };
  var androidx_compose_foundation_lazy_grid_LazyGridCacheWindowPrefetchStrategy$stable;
  var androidx_compose_foundation_lazy_grid_GridCells_Fixed$stable;
  var androidx_compose_foundation_lazy_grid_GridCells_Adaptive$stable;
  var androidx_compose_foundation_lazy_grid_GridCells_FixedSize$stable;
  function Fixed(count) {
    this.biq_1 = count;
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(this.biq_1 > 0)) {
      var tmp$ret$1 = 'Provided count should be larger than zero';
      throwIllegalArgumentException(tmp$ret$1);
    }
  }
  protoOf(Fixed).ciq = function (_this__u8e3s4, availableSize, spacing) {
    return calculateCellsCrossAxisSizeImpl(availableSize, this.biq_1, spacing);
  };
  protoOf(Fixed).hashCode = function () {
    return -this.biq_1 | 0;
  };
  protoOf(Fixed).equals = function (other) {
    var tmp;
    if (other instanceof Fixed) {
      tmp = this.biq_1 === other.biq_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function LazyVerticalGrid(columns, modifier, state, contentPadding, reverseLayout, verticalArrangement, horizontalArrangement, flingBehavior, userScrollEnabled, overscrollEffect, content, $composer, $changed, $changed1, $default) {
    var modifier_0 = {_v: modifier};
    var state_0 = {_v: state};
    var contentPadding_0 = {_v: contentPadding};
    var reverseLayout_0 = {_v: reverseLayout};
    var verticalArrangement_0 = {_v: verticalArrangement};
    var horizontalArrangement_0 = {_v: horizontalArrangement};
    var flingBehavior_0 = {_v: flingBehavior};
    var userScrollEnabled_0 = {_v: userScrollEnabled};
    var overscrollEffect_0 = {_v: overscrollEffect};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-2072102870);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(columns) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | (($default & 4) === 0 && $composer_0.k31(state_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(contentPadding_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(reverseLayout_0._v) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | (($default & 32) === 0 && $composer_0.k31(verticalArrangement_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(horizontalArrangement_0._v) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | (($default & 128) === 0 && $composer_0.k31(flingBehavior_0._v) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.l31(userScrollEnabled_0._v) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | (($default & 512) === 0 && $composer_0.k31(overscrollEffect_0._v) ? 536870912 : 268435456);
    if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(content) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 3) === 2), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 2) === 0)) {
          modifier_0._v = Companion_instance_0;
        }
        if (!(($default & 4) === 0)) {
          state_0._v = rememberLazyGridState(0, 0, $composer_0, 0, 3);
          $dirty = $dirty & -897;
        }
        if (!(($default & 8) === 0)) {
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
          contentPadding_0._v = PaddingValues(tmp$ret$0);
        }
        if (!(($default & 16) === 0)) {
          reverseLayout_0._v = false;
        }
        if (!(($default & 32) === 0)) {
          verticalArrangement_0._v = !reverseLayout_0._v ? Arrangement_getInstance().sdp_1 : Arrangement_getInstance().tdp_1;
          $dirty = $dirty & -458753;
        }
        if (!(($default & 64) === 0)) {
          horizontalArrangement_0._v = Arrangement_getInstance().qdp_1;
        }
        if (!(($default & 128) === 0)) {
          flingBehavior_0._v = ScrollableDefaults_instance.mh7($composer_0, 6);
          $dirty = $dirty & -29360129;
        }
        if (!(($default & 256) === 0)) {
          userScrollEnabled_0._v = true;
        }
        if (!(($default & 512) === 0)) {
          overscrollEffect_0._v = rememberOverscrollEffect($composer_0, 0);
          $dirty = $dirty & -1879048193;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
        if (!(($default & 32) === 0))
          $dirty = $dirty & -458753;
        if (!(($default & 128) === 0))
          $dirty = $dirty & -29360129;
        if (!(($default & 512) === 0))
          $dirty = $dirty & -1879048193;
      }
      $composer_0.r30();
      var tmp0_slots = rememberColumnWidthSums(columns, horizontalArrangement_0._v, $composer_0, 14 & $dirty | 112 & $dirty >> 15);
      LazyGrid(modifier_0._v, state_0._v, tmp0_slots, contentPadding_0._v, reverseLayout_0._v, true, flingBehavior_0._v, userScrollEnabled_0._v, overscrollEffect_0._v, verticalArrangement_0._v, horizontalArrangement_0._v, content, $composer_0, 196608 | 14 & $dirty >> 3 | 112 & $dirty >> 3 | 7168 & $dirty | 57344 & $dirty | 3670016 & $dirty >> 3 | 29360128 & $dirty >> 3 | 234881024 & $dirty >> 3 | 1879048192 & $dirty << 12, 14 & $dirty >> 18 | 112 & $dirty1 << 3, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(LazyVerticalGrid$lambda(columns, modifier_0, state_0, contentPadding_0, reverseLayout_0, verticalArrangement_0, horizontalArrangement_0, flingBehavior_0, userScrollEnabled_0, overscrollEffect_0, content, $changed, $changed1, $default));
    }
  }
  function LazyGridScope$items$lambda(it) {
    return null;
  }
  function LazyGridScope() {
  }
  function calculateCellsCrossAxisSizeImpl(gridSize, slotCount, spacing) {
    var gridSizeWithoutSpacing = gridSize - imul(spacing, slotCount - 1 | 0) | 0;
    var slotSize = gridSizeWithoutSpacing / slotCount | 0;
    var remainingPixels = gridSizeWithoutSpacing % slotCount | 0;
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var list = ArrayList_init_$Create$_0(slotCount);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < slotCount)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$4 = slotSize + (index < remainingPixels ? 1 : 0) | 0;
        list.j1(tmp$ret$4);
      }
       while (inductionVariable < slotCount);
    return list;
  }
  function rememberColumnWidthSums(columns, horizontalArrangement, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(columns) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.k31(horizontalArrangement) || ($changed & 48) === 32));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = new GridSlotCache(rememberColumnWidthSums$lambda(columns, horizontalArrangement));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function GridSlotCache(calculation) {
    this.hiq_1 = calculation;
    this.iiq_1 = Constraints_0();
    this.jiq_1 = 0.0;
    this.kiq_1 = null;
  }
  protoOf(GridSlotCache).cip = function (density, constraints) {
    // Inline function 'kotlin.with' call
    if (!(this.kiq_1 == null) && equals(this.iiq_1, constraints) && this.jiq_1 === density.u5e()) {
      return ensureNotNull(this.kiq_1);
    }
    this.iiq_1 = constraints;
    this.jiq_1 = density.u5e();
    // Inline function 'kotlin.also' call
    var this_0 = this.hiq_1(density, new Constraints(constraints));
    this.kiq_1 = this_0;
    return this_0;
  };
  function LazyVerticalGrid$lambda($columns, $modifier, $state, $contentPadding, $reverseLayout, $verticalArrangement, $horizontalArrangement, $flingBehavior, $userScrollEnabled, $overscrollEffect, $content, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      LazyVerticalGrid($columns, $modifier._v, $state._v, $contentPadding._v, $reverseLayout._v, $verticalArrangement._v, $horizontalArrangement._v, $flingBehavior._v, $userScrollEnabled._v, $overscrollEffect._v, $content, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function rememberColumnWidthSums$lambda($columns, $horizontalArrangement) {
    return function ($this$GridSlotCache, constraints) {
      // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
      if (!!(_Constraints___get_maxWidth__impl__uuyqc(constraints.m5e_1) === 2147483647)) {
        var tmp$ret$1 = "LazyVerticalGrid's width should be bound by parent.";
        throwIllegalArgumentException(tmp$ret$1);
      }
      var gridWidth = _Constraints___get_maxWidth__impl__uuyqc(constraints.m5e_1);
      // Inline function 'kotlin.with' call
      var $this$with = $columns;
      // Inline function 'kotlin.let' call
      var sizes = toIntArray($this$with.ciq($this$GridSlotCache, gridWidth, $this$GridSlotCache.w5e($horizontalArrangement.zdp())));
      var positions = new Int32Array(sizes.length);
      // Inline function 'kotlin.with' call
      $horizontalArrangement.pdp($this$GridSlotCache, gridWidth, sizes, LayoutDirection_Ltr_getInstance(), positions);
      return new LazyGridSlots(sizes, positions);
    };
  }
  var androidx_compose_foundation_lazy_grid_LazyGridIntervalContent$stable;
  var androidx_compose_foundation_lazy_grid_LazyGridInterval$stable;
  function LazyGridIntervalContent$Companion$DefaultSpan$lambda(_this__u8e3s4, it) {
    return new GridItemSpan(GridItemSpan_0(1));
  }
  function Companion_5() {
    Companion_instance_15 = this;
    var tmp = this;
    tmp.liq_1 = LazyGridIntervalContent$Companion$DefaultSpan$lambda;
  }
  var Companion_instance_15;
  function Companion_getInstance_64() {
    if (Companion_instance_15 == null)
      new Companion_5();
    return Companion_instance_15;
  }
  function LazyGridIntervalContent$item$lambda($key) {
    return function (it) {
      return $key;
    };
  }
  function LazyGridIntervalContent$item$lambda_0($span) {
    return function ($this$let, it) {
      return $span($this$let);
    };
  }
  function LazyGridIntervalContent$item$lambda_1($contentType) {
    return function (it) {
      return $contentType;
    };
  }
  function ComposableLambda$invoke$ref_4(p0) {
    return constructCallableReference(function (p0_0, p1, p2, p3) {
      p0.v50(p0_0, p1, p2, p3);
      return Unit_instance;
    }, 4, 0, 255, VOID, [p0]);
  }
  function LazyGridIntervalContent$item$lambda_2($content) {
    return function ($this$LazyGridInterval, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$LazyGridInterval) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 131) === 130), $dirty & 1)) {
        tmp_0 = $content($this$LazyGridInterval, $composer_0, 14 & $dirty);
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function LazyGridIntervalContent(content) {
    Companion_getInstance_64();
    LazyLayoutIntervalContent.call(this);
    this.miq_1 = new LazyGridSpanLayoutProvider(this);
    this.niq_1 = new MutableIntervalList();
    this.oiq_1 = false;
    this.piq_1 = null;
    // Inline function 'kotlin.apply' call
    content(this);
  }
  protoOf(LazyGridIntervalContent).eif = function () {
    return this.niq_1;
  };
  protoOf(LazyGridIntervalContent).wid = function () {
    var tmp0_elvis_lhs = this.piq_1;
    return tmp0_elvis_lhs == null ? emptyIntList() : tmp0_elvis_lhs;
  };
  protoOf(LazyGridIntervalContent).diq = function (key, span, contentType, content) {
    var tmp;
    if (key == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = LazyGridIntervalContent$item$lambda(key);
    }
    var tmp_0 = tmp;
    var tmp_1;
    if (span == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = LazyGridIntervalContent$item$lambda_0(span);
    }
    var tmp2_elvis_lhs = tmp_1;
    var tmp_2 = tmp2_elvis_lhs == null ? Companion_getInstance_64().liq_1 : tmp2_elvis_lhs;
    var tmp_3 = LazyGridIntervalContent$item$lambda_1(contentType);
    this.niq_1.iif(1, new LazyGridInterval(tmp_0, tmp_2, tmp_3, ComposableLambda$invoke$ref_4(composableLambdaInstance(-291643851, true, LazyGridIntervalContent$item$lambda_2(content)))));
    if (!(span == null))
      this.oiq_1 = true;
  };
  protoOf(LazyGridIntervalContent).fiq = function (count, key, span, contentType, itemContent) {
    this.niq_1.iif(count, new LazyGridInterval(key, span == null ? Companion_getInstance_64().liq_1 : span, contentType, itemContent));
    if (!(span == null))
      this.oiq_1 = true;
  };
  function LazyGridInterval(key, span, type, item) {
    this.qiq_1 = key;
    this.riq_1 = span;
    this.siq_1 = type;
    this.tiq_1 = item;
  }
  protoOf(LazyGridInterval).t1 = function () {
    return this.qiq_1;
  };
  protoOf(LazyGridInterval).oif = function () {
    return this.siq_1;
  };
  function lineIndex(_this__u8e3s4, orientation) {
    var tmp;
    if (orientation.equals(Orientation_Vertical_getInstance())) {
      tmp = _this__u8e3s4.viq();
    } else {
      tmp = _this__u8e3s4.uiq();
    }
    return tmp;
  }
  function rememberLazyGridItemProviderLambda(state, content, $composer, $changed) {
    var $composer_0 = $composer;
    var latestContent = rememberUpdatedState(content, $composer_0, 14 & $changed >> 3);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(state) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var tmp_0 = referentialEqualityPolicy();
      var intervalContentState = derivedStateOf_0(tmp_0, rememberLazyGridItemProviderLambda$lambda(latestContent));
      var tmp_1 = referentialEqualityPolicy();
      var itemProviderState = derivedStateOf_0(tmp_1, rememberLazyGridItemProviderLambda$lambda_0(intervalContentState, state));
      var tmp_2 = KProperty0;
      var value = getPropertyCallableRef('value', 0, tmp_2, State$_get_value_$ref_hr9f44_0(itemProviderState), null);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function LazyGridItemProviderImpl$Item$lambda(this$0, $index) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var tmp0 = this$0.xiq_1;
        // Inline function 'androidx.compose.foundation.lazy.layout.LazyLayoutIntervalContent.withInterval' call
        var globalIndex = $index;
        var interval = tmp0.eif().l1(globalIndex);
        var localIntervalIndex = globalIndex - interval.tif_1 | 0;
        interval.vif_1.tiq_1(LazyGridItemScopeImpl_instance, localIntervalIndex, $composer_0, 6);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function LazyGridItemProviderImpl$Item$lambda_0($tmp0_rcvr, $index, $key, $$changed) {
    return function ($composer, $force) {
      $tmp0_rcvr.wif($index, $key, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function LazyGridItemProviderImpl(state, intervalContent, keyIndexMap) {
    this.wiq_1 = state;
    this.xiq_1 = intervalContent;
    this.yiq_1 = keyIndexMap;
  }
  protoOf(LazyGridItemProviderImpl).vid = function () {
    return this.yiq_1;
  };
  protoOf(LazyGridItemProviderImpl).aie = function () {
    return this.xiq_1.aie();
  };
  protoOf(LazyGridItemProviderImpl).jif = function (index) {
    var tmp0_elvis_lhs = this.yiq_1.jif(index);
    return tmp0_elvis_lhs == null ? this.xiq_1.jif(index) : tmp0_elvis_lhs;
  };
  protoOf(LazyGridItemProviderImpl).kif = function (index) {
    return this.xiq_1.kif(index);
  };
  protoOf(LazyGridItemProviderImpl).wid = function () {
    return this.xiq_1.wid();
  };
  protoOf(LazyGridItemProviderImpl).wif = function (index, key, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1493551140);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.m31(index) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(key) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(this) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(726189336, true, LazyGridItemProviderImpl$Item$lambda(this, index), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      LazyLayoutPinnableItem(key, index, this.wiq_1.uim_1, tmp$ret$0, $composer_0, 3072 | 14 & $dirty >> 3 | 112 & $dirty << 3);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(LazyGridItemProviderImpl$Item$lambda_0(this, index, key, $changed));
    }
  };
  protoOf(LazyGridItemProviderImpl).bip = function () {
    return this.xiq_1.miq_1;
  };
  protoOf(LazyGridItemProviderImpl).xif = function (key) {
    return this.yiq_1.xif(key);
  };
  protoOf(LazyGridItemProviderImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LazyGridItemProviderImpl))
      return false;
    return equals(this.xiq_1, other.xiq_1);
  };
  protoOf(LazyGridItemProviderImpl).hashCode = function () {
    return hashCode(this.xiq_1);
  };
  function rememberLazyGridItemProviderLambda$lambda($latestContent) {
    return function () {
      return new LazyGridIntervalContent($latestContent.u1());
    };
  }
  function rememberLazyGridItemProviderLambda$lambda_0($intervalContentState, $state) {
    return function () {
      var intervalContent = $intervalContentState.u1();
      var map = new NearestRangeKeyIndexMap($state.yif(), intervalContent);
      return new LazyGridItemProviderImpl($state, intervalContent, map);
    };
  }
  function State$_get_value_$ref_hr9f44_0(p0) {
    return constructCallableReference(function () {
      return p0.u1();
    }, 0, 0, 256, VOID, [p0]);
  }
  var androidx_compose_foundation_lazy_grid_LazyGridItemScopeImpl$stable;
  function LazyGridItemScopeImpl() {
  }
  var LazyGridItemScopeImpl_instance;
  function LazyGridItemScopeImpl_getInstance() {
    return LazyGridItemScopeImpl_instance;
  }
  function visibleLinesAverageMainAxisSize(_this__u8e3s4) {
    var isVertical = _this__u8e3s4.lhy().equals(Orientation_Vertical_getInstance());
    var visibleItems = _this__u8e3s4.uhz();
    if (visibleItems.r())
      return 0;
    var totalLinesMainAxisSize = 0;
    var linesCount = 0;
    var lineStartIndex = 0;
    $l$loop: while (lineStartIndex < visibleItems.n1()) {
      var currentLine = visibleLinesAverageMainAxisSize$lineOf(isVertical, _this__u8e3s4, lineStartIndex);
      if (currentLine === -1) {
        lineStartIndex = lineStartIndex + 1 | 0;
        continue $l$loop;
      }
      var lineMainAxisSize = 0;
      var lineEndIndex = lineStartIndex;
      while (lineEndIndex < visibleItems.n1() && visibleLinesAverageMainAxisSize$lineOf(isVertical, _this__u8e3s4, lineEndIndex) === currentLine) {
        var tmp0 = lineMainAxisSize;
        var tmp;
        if (isVertical) {
          // Inline function 'androidx.compose.ui.unit.IntSize.height' call
          var this_0 = visibleItems.l1(lineEndIndex).q95();
          // Inline function 'androidx.compose.ui.util.unpackInt2' call
          var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
          tmp = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
        } else {
          // Inline function 'androidx.compose.ui.unit.IntSize.width' call
          var this_1 = visibleItems.l1(lineEndIndex).q95();
          // Inline function 'androidx.compose.ui.util.unpackInt1' call
          var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
          tmp = convertToInt(shiftRight(value_0, 32));
        }
        // Inline function 'kotlin.math.max' call
        var b = tmp;
        lineMainAxisSize = Math.max(tmp0, b);
        lineEndIndex = lineEndIndex + 1 | 0;
      }
      totalLinesMainAxisSize = totalLinesMainAxisSize + lineMainAxisSize | 0;
      linesCount = linesCount + 1 | 0;
      lineStartIndex = lineEndIndex;
    }
    return (totalLinesMainAxisSize / linesCount | 0) + _this__u8e3s4.big() | 0;
  }
  function visibleLinesAverageMainAxisSize$lineOf(isVertical, $this_visibleLinesAverageMainAxisSize, index) {
    return isVertical ? $this_visibleLinesAverageMainAxisSize.uhz().l1(index).viq() : $this_visibleLinesAverageMainAxisSize.uhz().l1(index).uiq();
  }
  function measureLazyGrid(itemsCount, measuredLineProvider, measuredItemProvider, mainAxisAvailableSize, beforeContentPadding, afterContentPadding, spaceBetweenLines, firstVisibleLineIndex, firstVisibleLineScrollOffset, scrollToBeConsumed, constraints, isVertical, verticalArrangement, horizontalArrangement, reverseLayout, density, itemAnimator, slotsPerLine, pinnedItems, isInLookaheadScope, isLookingAhead, approachLayoutInfo, coroutineScope, placementScopeInvalidator, graphicsContext, prefetchInfoRetriever, lineIndexProvider, stickyItemsScrollBehavior, layout) {
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(beforeContentPadding >= 0)) {
      var tmp$ret$1 = 'negative beforeContentPadding';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(afterContentPadding >= 0)) {
      var tmp$ret$3 = 'negative afterContentPadding';
      throwIllegalArgumentException(tmp$ret$3);
    }
    if (itemsCount <= 0) {
      var layoutWidth = _Constraints___get_minWidth__impl__hi9lfi(constraints);
      var layoutHeight = _Constraints___get_minHeight__impl__ev4bgx(constraints);
      var tmp0_layoutWidth = layoutWidth;
      var tmp1_layoutHeight = layoutHeight;
      // Inline function 'kotlin.collections.mutableListOf' call
      var tmp2_positionedItems = ArrayList_init_$Create$();
      var tmp3_keyIndexMap = measuredItemProvider.vid();
      itemAnimator.cig(0, tmp0_layoutWidth, tmp1_layoutHeight, tmp2_positionedItems, tmp3_keyIndexMap, measuredItemProvider, isVertical, isLookingAhead, slotsPerLine, isInLookaheadScope, 0, 0, coroutineScope, graphicsContext);
      if (!isLookingAhead) {
        var disappearingItemsSize = itemAnimator.dig();
        if (!equals(disappearingItemsSize, Companion_getInstance_22().n5g_1)) {
          // Inline function 'androidx.compose.ui.unit.IntSize.width' call
          // Inline function 'androidx.compose.ui.util.unpackInt1' call
          var value = _IntSize___get_packedValue__impl__uho7jf(disappearingItemsSize);
          var tmp$ret$5 = convertToInt(shiftRight(value, 32));
          layoutWidth = constrainWidth(constraints, tmp$ret$5);
          // Inline function 'androidx.compose.ui.unit.IntSize.height' call
          // Inline function 'androidx.compose.ui.util.unpackInt2' call
          var value_0 = _IntSize___get_packedValue__impl__uho7jf(disappearingItemsSize);
          var tmp$ret$7 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
          layoutHeight = constrainHeight(constraints, tmp$ret$7);
        }
      }
      var tmp = layoutWidth;
      var tmp_0 = layoutHeight;
      var tmp4_measureResult = layout(tmp, tmp_0, measureLazyGrid$lambda);
      var tmp5_visibleItemsInfo = emptyList();
      var tmp6_viewportStartOffset = -beforeContentPadding | 0;
      var tmp7_viewportEndOffset = mainAxisAvailableSize + afterContentPadding | 0;
      var tmp8_orientation = isVertical ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance();
      return new LazyGridMeasureResult(null, 0, false, 0.0, tmp4_measureResult, 0.0, false, coroutineScope, density, slotsPerLine, prefetchInfoRetriever, lineIndexProvider, tmp5_visibleItemsInfo, tmp6_viewportStartOffset, tmp7_viewportEndOffset, 0, reverseLayout, tmp8_orientation, afterContentPadding, spaceBetweenLines);
    } else {
      var currentFirstLineIndex = firstVisibleLineIndex;
      var currentFirstLineScrollOffset = firstVisibleLineScrollOffset;
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var tmp_1;
      if (isNaN_0(scrollToBeConsumed)) {
        tmp_1 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_1 = roundToInt(scrollToBeConsumed);
      }
      var scrollDelta = tmp_1;
      currentFirstLineScrollOffset = currentFirstLineScrollOffset - scrollDelta | 0;
      if (currentFirstLineIndex === 0 && currentFirstLineScrollOffset < 0) {
        scrollDelta = scrollDelta + currentFirstLineScrollOffset | 0;
        currentFirstLineScrollOffset = 0;
      }
      var visibleLines = ArrayDeque_init_$Create$();
      var minOffset = (-beforeContentPadding | 0) + (spaceBetweenLines < 0 ? spaceBetweenLines : 0) | 0;
      var maxOffset = mainAxisAvailableSize;
      currentFirstLineScrollOffset = currentFirstLineScrollOffset + minOffset | 0;
      while (currentFirstLineScrollOffset < 0 && currentFirstLineIndex > 0) {
        var previous = currentFirstLineIndex - 1 | 0;
        var measuredLine = measuredLineProvider.mio(previous);
        visibleLines.g3(0, measuredLine);
        currentFirstLineScrollOffset = currentFirstLineScrollOffset + measuredLine.gir_1 | 0;
        currentFirstLineIndex = previous;
      }
      if (currentFirstLineScrollOffset < minOffset) {
        var notConsumedScrollDelta = minOffset - currentFirstLineScrollOffset | 0;
        currentFirstLineScrollOffset = minOffset;
        scrollDelta = scrollDelta - notConsumedScrollDelta | 0;
      }
      currentFirstLineScrollOffset = currentFirstLineScrollOffset - minOffset | 0;
      var index = currentFirstLineIndex;
      var maxMainAxis = coerceAtLeast_0(maxOffset + afterContentPadding | 0, 0);
      var currentMainAxisOffset = -currentFirstLineScrollOffset | 0;
      var remeasureNeeded = false;
      var indexInVisibleLines = 0;
      while (indexInVisibleLines < visibleLines.sg_1) {
        if (currentMainAxisOffset >= maxMainAxis) {
          visibleLines.h3(indexInVisibleLines);
          remeasureNeeded = true;
        } else {
          index = index + 1 | 0;
          currentMainAxisOffset = currentMainAxisOffset + visibleLines.l1(indexInVisibleLines).gir_1 | 0;
          indexInVisibleLines = indexInVisibleLines + 1 | 0;
        }
      }
      $l$loop: while (index < itemsCount && (currentMainAxisOffset < maxMainAxis || currentMainAxisOffset <= 0 || visibleLines.r())) {
        var measuredLine_0 = measuredLineProvider.mio(index);
        if (measuredLine_0.r()) {
          break $l$loop;
        }
        currentMainAxisOffset = currentMainAxisOffset + measuredLine_0.gir_1 | 0;
        if (currentMainAxisOffset <= minOffset && !(last_0(measuredLine_0.air_1).hir_1 === (itemsCount - 1 | 0))) {
          currentFirstLineIndex = index + 1 | 0;
          currentFirstLineScrollOffset = currentFirstLineScrollOffset - measuredLine_0.gir_1 | 0;
          remeasureNeeded = true;
        } else {
          visibleLines.j1(measuredLine_0);
        }
        index = index + 1 | 0;
      }
      var preScrollBackScrollDelta = scrollDelta;
      if (currentMainAxisOffset < maxOffset) {
        var toScrollBack = maxOffset - currentMainAxisOffset | 0;
        currentFirstLineScrollOffset = currentFirstLineScrollOffset - toScrollBack | 0;
        currentMainAxisOffset = currentMainAxisOffset + toScrollBack | 0;
        while (currentFirstLineScrollOffset < beforeContentPadding && currentFirstLineIndex > 0) {
          var previousIndex = currentFirstLineIndex - 1 | 0;
          var measuredLine_1 = measuredLineProvider.mio(previousIndex);
          visibleLines.g3(0, measuredLine_1);
          currentFirstLineScrollOffset = currentFirstLineScrollOffset + measuredLine_1.gir_1 | 0;
          currentFirstLineIndex = previousIndex;
        }
        scrollDelta = scrollDelta + toScrollBack | 0;
        if (currentFirstLineScrollOffset < 0) {
          scrollDelta = scrollDelta + currentFirstLineScrollOffset | 0;
          currentMainAxisOffset = currentMainAxisOffset + currentFirstLineScrollOffset | 0;
          currentFirstLineScrollOffset = 0;
        }
      }
      var tmp_2;
      var tmp_3;
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var tmp_4;
      if (isNaN_0(scrollToBeConsumed)) {
        tmp_4 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_4 = roundToInt(scrollToBeConsumed);
      }
      var tmp$ret$11 = tmp_4;
      if (get_sign(tmp$ret$11) === get_sign(scrollDelta)) {
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var tmp_5;
        if (isNaN_0(scrollToBeConsumed)) {
          tmp_5 = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp_5 = roundToInt(scrollToBeConsumed);
        }
        var tmp$ret$13 = tmp_5;
        tmp_3 = abs(tmp$ret$13) >= abs(scrollDelta);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = scrollDelta;
      } else {
        tmp_2 = scrollToBeConsumed;
      }
      var consumedScroll = tmp_2;
      var unconsumedScroll = scrollToBeConsumed - consumedScroll;
      var tmp_6;
      if (isLookingAhead && scrollDelta > preScrollBackScrollDelta && unconsumedScroll <= 0) {
        tmp_6 = (scrollDelta - preScrollBackScrollDelta | 0) + unconsumedScroll;
      } else {
        tmp_6 = 0.0;
      }
      var scrollBackAmount = tmp_6;
      // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
      if (!(currentFirstLineScrollOffset >= 0)) {
        var tmp$ret$16 = 'negative initial offset';
        throwIllegalArgumentException(tmp$ret$16);
      }
      var visibleLinesScrollOffset = -currentFirstLineScrollOffset | 0;
      var firstLine = visibleLines.wg();
      var tmp9_safe_receiver = firstLine;
      var tmp10_safe_receiver = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.air_1;
      var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : firstOrNull_0(tmp10_safe_receiver);
      var tmp12_elvis_lhs = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.hir_1;
      var firstItemIndex = tmp12_elvis_lhs == null ? 0 : tmp12_elvis_lhs;
      var tmp13_safe_receiver = visibleLines.yg();
      var tmp14_safe_receiver = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.air_1;
      var tmp15_safe_receiver = tmp14_safe_receiver == null ? null : lastOrNull_0(tmp14_safe_receiver);
      var tmp16_elvis_lhs = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.hir_1;
      var lastItemIndex = tmp16_elvis_lhs == null ? 0 : tmp16_elvis_lhs;
      // Inline function 'androidx.compose.foundation.lazy.grid.calculateExtraItems' call
      var items = null;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = pinnedItems.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = pinnedItems.l1(index_0);
          if (0 <= item ? item < firstItemIndex : false) {
            var span = measuredLineProvider.lio(item);
            var constraints_0 = measuredLineProvider.kio(0, span);
            var measuredItem = measuredItemProvider.sid(item, 0, span, constraints_0);
            if (items == null) {
              // Inline function 'kotlin.collections.mutableListOf' call
              items = ArrayList_init_$Create$();
            }
            var tmp0_safe_receiver = items;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver.j1(measuredItem);
          }
        }
         while (inductionVariable <= last);
      var tmp0_elvis_lhs = items;
      var extraItemsBefore = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      var linesRetainedForLookahead_0 = linesRetainedForLookahead(lastItemIndex, itemsCount, measuredLineProvider, isLookingAhead, visibleLines, approachLayoutInfo);
      // Inline function 'androidx.compose.foundation.lazy.grid.calculateExtraItems' call
      var items_0 = null;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_1 = pinnedItems.n1() - 1 | 0;
      if (inductionVariable_0 <= last_1)
        do {
          var index_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = pinnedItems.l1(index_1);
          var tmp_7;
          if ((lastItemIndex + 1 | 0) <= item_0 ? item_0 < itemsCount : false) {
            var tmp_8;
            if (!isLookingAhead) {
              tmp_8 = true;
            } else {
              var tmp$ret$26;
              $l$block_0: {
                // Inline function 'androidx.compose.ui.util.fastAny' call
                // Inline function 'androidx.compose.ui.util.fastForEach' call
                var inductionVariable_1 = 0;
                var last_2 = linesRetainedForLookahead_0.n1() - 1 | 0;
                if (inductionVariable_1 <= last_2)
                  do {
                    var index_2 = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var item_1 = linesRetainedForLookahead_0.l1(index_2);
                    var tmp0 = item_1.air_1;
                    var tmp$ret$30;
                    $l$block: {
                      // Inline function 'kotlin.collections.any' call
                      var inductionVariable_2 = 0;
                      var last_3 = tmp0.length;
                      while (inductionVariable_2 < last_3) {
                        var element = tmp0[inductionVariable_2];
                        inductionVariable_2 = inductionVariable_2 + 1 | 0;
                        if (element.hir_1 === item_0) {
                          tmp$ret$30 = true;
                          break $l$block;
                        }
                      }
                      tmp$ret$30 = false;
                    }
                    if (tmp$ret$30) {
                      tmp$ret$26 = true;
                      break $l$block_0;
                    }
                  }
                   while (inductionVariable_1 <= last_2);
                tmp$ret$26 = false;
              }
              tmp_8 = !tmp$ret$26;
            }
            tmp_7 = tmp_8;
          } else {
            tmp_7 = false;
          }
          if (tmp_7) {
            var span_0 = measuredLineProvider.lio(item_0);
            var constraints_1 = measuredLineProvider.kio(0, span_0);
            var measuredItem_0 = measuredItemProvider.sid(item_0, 0, span_0, constraints_1);
            if (items_0 == null) {
              // Inline function 'kotlin.collections.mutableListOf' call
              items_0 = ArrayList_init_$Create$();
            }
            var tmp0_safe_receiver_0 = items_0;
            if (tmp0_safe_receiver_0 == null)
              null;
            else
              tmp0_safe_receiver_0.j1(measuredItem_0);
          }
        }
         while (inductionVariable_0 <= last_1);
      var tmp0_elvis_lhs_0 = items_0;
      var extraItemsAfter = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
      if (beforeContentPadding > 0 || spaceBetweenLines < 0) {
        var inductionVariable_3 = 0;
        var last_4 = visibleLines.n1() - 1 | 0;
        if (inductionVariable_3 <= last_4)
          $l$loop_0: do {
            var i = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var size = visibleLines.l1(i).gir_1;
            if (!(currentFirstLineScrollOffset === 0) && size <= currentFirstLineScrollOffset && !(i === get_lastIndex(visibleLines))) {
              currentFirstLineScrollOffset = currentFirstLineScrollOffset - size | 0;
              firstLine = visibleLines.l1(i + 1 | 0);
            } else {
              break $l$loop_0;
            }
          }
           while (inductionVariable_3 <= last_4);
      }
      var tmp_9;
      if (isVertical) {
        tmp_9 = _Constraints___get_maxWidth__impl__uuyqc(constraints);
      } else {
        tmp_9 = constrainWidth(constraints, currentMainAxisOffset);
      }
      var layoutWidth_0 = tmp_9;
      var tmp_10;
      if (isVertical) {
        tmp_10 = constrainHeight(constraints, currentMainAxisOffset);
      } else {
        tmp_10 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
      }
      var layoutHeight_0 = tmp_10;
      var positionedItems = calculateItemsOffsets_0(linesRetainedForLookahead_0.r() ? visibleLines : plus_0(visibleLines, linesRetainedForLookahead_0), extraItemsBefore, extraItemsAfter, layoutWidth_0, layoutHeight_0, currentMainAxisOffset, maxOffset, visibleLinesScrollOffset, isVertical, verticalArrangement, horizontalArrangement, reverseLayout, density);
      var tmp17_consumedScroll = numberToInt(consumedScroll);
      var tmp18_layoutWidth = layoutWidth_0;
      var tmp19_layoutHeight = layoutHeight_0;
      var tmp20_keyIndexMap = measuredItemProvider.vid();
      var tmp21_layoutMinOffset = currentFirstLineScrollOffset;
      var tmp22_layoutMaxOffset = currentMainAxisOffset;
      itemAnimator.cig(tmp17_consumedScroll, tmp18_layoutWidth, tmp19_layoutHeight, positionedItems, tmp20_keyIndexMap, measuredItemProvider, isVertical, isLookingAhead, slotsPerLine, isInLookaheadScope, tmp21_layoutMinOffset, tmp22_layoutMaxOffset, coroutineScope, graphicsContext);
      if (!isLookingAhead) {
        var disappearingItemsSize_0 = itemAnimator.dig();
        if (!equals(disappearingItemsSize_0, Companion_getInstance_22().n5g_1)) {
          var oldMainAxisSize = isVertical ? layoutHeight_0 : layoutWidth_0;
          var tmp0_0 = layoutWidth_0;
          // Inline function 'androidx.compose.ui.unit.IntSize.width' call
          // Inline function 'androidx.compose.ui.util.unpackInt1' call
          var value_1 = _IntSize___get_packedValue__impl__uho7jf(disappearingItemsSize_0);
          // Inline function 'kotlin.comparisons.maxOf' call
          var b = convertToInt(shiftRight(value_1, 32));
          var tmp$ret$35 = Math.max(tmp0_0, b);
          layoutWidth_0 = constrainWidth(constraints, tmp$ret$35);
          var tmp0_1 = layoutHeight_0;
          // Inline function 'androidx.compose.ui.unit.IntSize.height' call
          // Inline function 'androidx.compose.ui.util.unpackInt2' call
          var value_2 = _IntSize___get_packedValue__impl__uho7jf(disappearingItemsSize_0);
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_0 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
          var tmp$ret$38 = Math.max(tmp0_1, b_0);
          layoutHeight_0 = constrainHeight(constraints, tmp$ret$38);
          var newMainAxisSize = isVertical ? layoutHeight_0 : layoutWidth_0;
          if (!(newMainAxisSize === oldMainAxisSize)) {
            // Inline function 'androidx.compose.ui.util.fastForEach' call
            var inductionVariable_4 = 0;
            var last_5 = positionedItems.n1() - 1 | 0;
            if (inductionVariable_4 <= last_5)
              do {
                var index_3 = inductionVariable_4;
                inductionVariable_4 = inductionVariable_4 + 1 | 0;
                var item_2 = positionedItems.l1(index_3);
                item_2.eig(newMainAxisSize);
              }
               while (inductionVariable_4 <= last_5);
          }
        }
      }
      var tmp_11 = measuredItemProvider.aio();
      var tmp_12 = layoutWidth_0;
      var tmp_13 = layoutHeight_0;
      var stickingItems = applyStickyItems(stickyItemsScrollBehavior, firstItemIndex, lastItemIndex, positionedItems, tmp_11, beforeContentPadding, afterContentPadding, tmp_12, tmp_13, measureLazyGrid$lambda_0(measuredLineProvider, measuredItemProvider));
      var tmp23_firstVisibleLine = firstLine;
      var tmp24_firstVisibleLineScrollOffset = currentFirstLineScrollOffset;
      var tmp25_canScrollForward = !(lastItemIndex === (itemsCount - 1 | 0)) || currentMainAxisOffset > maxOffset;
      var tmp_14 = layoutWidth_0;
      var tmp_15 = layoutHeight_0;
      var tmp26_measureResult = layout(tmp_14, tmp_15, measureLazyGrid$lambda_1(placementScopeInvalidator, positionedItems, isLookingAhead, stickingItems));
      var tmp27_viewportStartOffset = -beforeContentPadding | 0;
      var tmp28_viewportEndOffset = mainAxisAvailableSize + afterContentPadding | 0;
      var tmp29_visibleItemsInfo = updatedVisibleItems(firstItemIndex, lastItemIndex, positionedItems, stickingItems);
      var tmp30_orientation = isVertical ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance();
      var tmp31_remeasureNeeded = remeasureNeeded;
      return new LazyGridMeasureResult(tmp23_firstVisibleLine, tmp24_firstVisibleLineScrollOffset, tmp25_canScrollForward, consumedScroll, tmp26_measureResult, scrollBackAmount, tmp31_remeasureNeeded, coroutineScope, density, slotsPerLine, prefetchInfoRetriever, lineIndexProvider, tmp29_visibleItemsInfo, tmp27_viewportStartOffset, tmp28_viewportEndOffset, itemsCount, reverseLayout, tmp30_orientation, afterContentPadding, spaceBetweenLines);
    }
  }
  function linesRetainedForLookahead(lastVisibleItemIndex, itemsCount, measuredLineProvider, isLookingAhead, visibleLines, lastApproachLayoutInfo) {
    var list = null;
    if (isLookingAhead) {
      var tmp;
      if (!(lastApproachLayoutInfo == null)) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp = !lastApproachLayoutInfo.uhz().r();
      } else {
        tmp = false;
      }
      if (tmp) {
        // Inline function 'kotlin.run' call
        var $this$run = lastApproachLayoutInfo.uhz();
        var found = null;
        var inductionVariable = $this$run.n1() - 1 | 0;
        if (0 <= inductionVariable)
          $l$loop: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            if ($this$run.l1(i).bi0() > lastVisibleItemIndex && (i === 0 || $this$run.l1(i - 1 | 0).bi0() <= lastVisibleItemIndex)) {
              found = $this$run.l1(i);
              break $l$loop;
            }
          }
           while (0 <= inductionVariable);
        var firstItem = found;
        var lastVisibleItem = last(lastApproachLayoutInfo.uhz());
        var tmp0_safe_receiver = lastOrNull(visibleLines);
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = tmp0_safe_receiver.ziq_1 + 1 | 0;
        }
        var tmp1_elvis_lhs = tmp_0;
        var lineIndex = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        if (!(firstItem == null)) {
          var inductionVariable_0 = firstItem.bi0();
          var tmp0 = lastVisibleItem.bi0();
          // Inline function 'kotlin.math.min' call
          var b = itemsCount - 1 | 0;
          var last_0 = Math.min(tmp0, b);
          if (inductionVariable_0 <= last_0)
            do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var tmp2_safe_receiver = list;
              var tmp_1;
              if (tmp2_safe_receiver == null) {
                tmp_1 = null;
              } else {
                var tmp$ret$6;
                $l$block_0: {
                  // Inline function 'androidx.compose.ui.util.fastAny' call
                  // Inline function 'androidx.compose.ui.util.fastForEach' call
                  var inductionVariable_1 = 0;
                  var last_1 = tmp2_safe_receiver.n1() - 1 | 0;
                  if (inductionVariable_1 <= last_1)
                    do {
                      var index = inductionVariable_1;
                      inductionVariable_1 = inductionVariable_1 + 1 | 0;
                      var item = tmp2_safe_receiver.l1(index);
                      var tmp0_0 = item.air_1;
                      var tmp$ret$10;
                      $l$block: {
                        // Inline function 'kotlin.collections.any' call
                        var inductionVariable_2 = 0;
                        var last_2 = tmp0_0.length;
                        while (inductionVariable_2 < last_2) {
                          var element = tmp0_0[inductionVariable_2];
                          inductionVariable_2 = inductionVariable_2 + 1 | 0;
                          if (element.hir_1 === i_0) {
                            tmp$ret$10 = true;
                            break $l$block;
                          }
                        }
                        tmp$ret$10 = false;
                      }
                      if (tmp$ret$10) {
                        tmp$ret$6 = true;
                        break $l$block_0;
                      }
                    }
                     while (inductionVariable_1 <= last_1);
                  tmp$ret$6 = false;
                }
                tmp_1 = tmp$ret$6;
              }
              if (!(tmp_1 === true)) {
                if (list == null) {
                  // Inline function 'kotlin.collections.mutableListOf' call
                  list = ArrayList_init_$Create$();
                }
                var measuredLine = measuredLineProvider.mio(lineIndex);
                lineIndex = lineIndex + 1 | 0;
                list.j1(measuredLine);
              }
            }
             while (!(i_0 === last_0));
        }
      }
    }
    var tmp3_elvis_lhs = list;
    return tmp3_elvis_lhs == null ? emptyList() : tmp3_elvis_lhs;
  }
  function calculateItemsOffsets_0(lines, itemsBefore, itemsAfter, layoutWidth, layoutHeight, finalMainAxisOffset, maxOffset, firstLineScrollOffset, isVertical, verticalArrangement, horizontalArrangement, reverseLayout, density) {
    var mainAxisLayoutSize = isVertical ? layoutHeight : layoutWidth;
    // Inline function 'kotlin.math.min' call
    var hasSpareSpace = finalMainAxisOffset < Math.min(mainAxisLayoutSize, maxOffset);
    if (hasSpareSpace) {
      // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
      if (!(firstLineScrollOffset === 0)) {
        var tmp$ret$2 = 'non-zero firstLineScrollOffset';
        throwIllegalStateException(tmp$ret$2);
      }
    }
    // Inline function 'androidx.compose.ui.util.fastSumBy' call
    var sum = 0;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = lines.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = lines.l1(index);
        var tmp = sum;
        sum = tmp + item.air_1.length | 0;
      }
       while (inductionVariable <= last);
    var tmp$ret$3 = sum;
    var positionedItems = ArrayList_init_$Create$_0(tmp$ret$3);
    if (hasSpareSpace) {
      // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
      if (!(itemsBefore.r() && itemsAfter.r())) {
        var tmp$ret$8 = 'no items';
        throwIllegalArgumentException(tmp$ret$8);
      }
      var linesCount = lines.n1();
      var tmp_0 = 0;
      var tmp_1 = new Int32Array(linesCount);
      while (tmp_0 < linesCount) {
        var tmp_2 = tmp_0;
        tmp_1[tmp_2] = lines.l1(calculateItemsOffsets$reverseAware_0(tmp_2, reverseLayout, linesCount)).fir_1;
        tmp_0 = tmp_0 + 1 | 0;
      }
      var sizes = tmp_1;
      var offsets = new Int32Array(linesCount);
      if (isVertical) {
        // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
        if (verticalArrangement == null) {
          var tmp$ret$11 = 'null verticalArrangement';
          throwIllegalArgumentExceptionForNullCheck(tmp$ret$11);
        }
        // Inline function 'kotlin.with' call
        verticalArrangement.fdq(density, mainAxisLayoutSize, sizes, offsets);
      } else {
        // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
        if (horizontalArrangement == null) {
          var tmp$ret$15 = 'null horizontalArrangement';
          throwIllegalArgumentExceptionForNullCheck(tmp$ret$15);
        }
        // Inline function 'kotlin.with' call
        horizontalArrangement.pdp(density, mainAxisLayoutSize, sizes, LayoutDirection_Ltr_getInstance(), offsets);
      }
      var reverseAwareOffsetIndices = reverseLayout ? reversed(get_indices(offsets)) : get_indices(offsets);
      var inductionVariable_0 = reverseAwareOffsetIndices.x1_1;
      var last_0 = reverseAwareOffsetIndices.y1_1;
      var step = reverseAwareOffsetIndices.z1_1;
      if (step > 0 && inductionVariable_0 <= last_0 || (step < 0 && last_0 <= inductionVariable_0))
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step | 0;
          var absoluteOffset = offsets[index_0];
          var line = lines.l1(calculateItemsOffsets$reverseAware_0(index_0, reverseLayout, linesCount));
          var tmp_3;
          if (reverseLayout) {
            tmp_3 = (mainAxisLayoutSize - absoluteOffset | 0) - line.fir_1 | 0;
          } else {
            tmp_3 = absoluteOffset;
          }
          var relativeOffset = tmp_3;
          addAllFromArray(positionedItems, line.gis(relativeOffset, layoutWidth, layoutHeight));
        }
         while (!(index_0 === last_0));
    } else {
      var currentMainAxis = firstLineScrollOffset;
      // Inline function 'androidx.compose.ui.util.fastForEachReversed' call
      var inductionVariable_1 = itemsBefore.n1() - 1 | 0;
      if (0 <= inductionVariable_1)
        do {
          var index_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + -1 | 0;
          var item_0 = itemsBefore.l1(index_1);
          currentMainAxis = currentMainAxis - item_0.xir_1 | 0;
          item_0.pig(currentMainAxis, 0, layoutWidth, layoutHeight);
          positionedItems.j1(item_0);
        }
         while (0 <= inductionVariable_1);
      currentMainAxis = firstLineScrollOffset;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_2 = 0;
      var last_1 = lines.n1() - 1 | 0;
      if (inductionVariable_2 <= last_1)
        do {
          var index_2 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var item_1 = lines.l1(index_2);
          addAllFromArray(positionedItems, item_1.gis(currentMainAxis, layoutWidth, layoutHeight));
          currentMainAxis = currentMainAxis + item_1.gir_1 | 0;
        }
         while (inductionVariable_2 <= last_1);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_3 = 0;
      var last_2 = itemsAfter.n1() - 1 | 0;
      if (inductionVariable_3 <= last_2)
        do {
          var index_3 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var item_2 = itemsAfter.l1(index_3);
          item_2.pig(currentMainAxis, 0, layoutWidth, layoutHeight);
          positionedItems.j1(item_2);
          currentMainAxis = currentMainAxis + item_2.xir_1 | 0;
        }
         while (inductionVariable_3 <= last_2);
    }
    return positionedItems;
  }
  function addAllFromArray(_this__u8e3s4, arr) {
    var inductionVariable = 0;
    var last = arr.length;
    while (inductionVariable < last) {
      var item = arr[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      _this__u8e3s4.j1(item);
    }
  }
  function measureLazyGrid$lambda($this$layout) {
    return Unit_instance;
  }
  function measureLazyGrid$lambda_0($measuredLineProvider, $measuredItemProvider) {
    return function (it) {
      var span = $measuredLineProvider.lio(it);
      var childConstraints = $measuredLineProvider.kio(0, span);
      return $measuredItemProvider.sid(it, 0, span, childConstraints);
    };
  }
  function measureLazyGrid$lambda$lambda($positionedItems, $isLookingAhead, $stickingItems) {
    return function ($this$withMotionFrameOfReferencePlacement) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = $positionedItems;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item.gig($this$withMotionFrameOfReferencePlacement, $isLookingAhead);
        }
         while (inductionVariable <= last);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_1 = $stickingItems;
      var inductionVariable_0 = 0;
      var last_0 = this_1.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = this_1.l1(index_0);
          item_0.gig($this$withMotionFrameOfReferencePlacement, $isLookingAhead);
        }
         while (inductionVariable_0 <= last_0);
      return Unit_instance;
    };
  }
  function measureLazyGrid$lambda_1($placementScopeInvalidator, $positionedItems, $isLookingAhead, $stickingItems) {
    return function ($this$layout) {
      $this$layout.xal(measureLazyGrid$lambda$lambda($positionedItems, $isLookingAhead, $stickingItems));
      ObservableScopeInvalidator__attachToScope_impl_wvvw97($placementScopeInvalidator);
      return Unit_instance;
    };
  }
  function calculateItemsOffsets$reverseAware_0(_this__u8e3s4, $reverseLayout, linesCount) {
    return !$reverseLayout ? _this__u8e3s4 : (linesCount - _this__u8e3s4 | 0) - 1 | 0;
  }
  var androidx_compose_foundation_lazy_grid_LazyGridMeasureResult$stable;
  function LazyGridMeasureResult(firstVisibleLine, firstVisibleLineScrollOffset, canScrollForward, consumedScroll, measureResult, scrollBackAmount, remeasureNeeded, coroutineScope, density, slotsPerLine, prefetchInfoRetriever, lineIndexProvider, visibleItemsInfo, viewportStartOffset, viewportEndOffset, totalItemsCount, reverseLayout, orientation, afterContentPadding, mainAxisItemSpacing) {
    this.gip_1 = firstVisibleLine;
    this.hip_1 = firstVisibleLineScrollOffset;
    this.iip_1 = canScrollForward;
    this.jip_1 = consumedScroll;
    this.kip_1 = measureResult;
    this.lip_1 = scrollBackAmount;
    this.mip_1 = remeasureNeeded;
    this.nip_1 = coroutineScope;
    this.oip_1 = density;
    this.pip_1 = slotsPerLine;
    this.qip_1 = prefetchInfoRetriever;
    this.rip_1 = lineIndexProvider;
    this.sip_1 = visibleItemsInfo;
    this.tip_1 = viewportStartOffset;
    this.uip_1 = viewportEndOffset;
    this.vip_1 = totalItemsCount;
    this.wip_1 = reverseLayout;
    this.xip_1 = orientation;
    this.yip_1 = afterContentPadding;
    this.zip_1 = mainAxisItemSpacing;
  }
  protoOf(LazyGridMeasureResult).uhz = function () {
    return this.sip_1;
  };
  protoOf(LazyGridMeasureResult).zif = function () {
    return this.tip_1;
  };
  protoOf(LazyGridMeasureResult).aig = function () {
    return this.uip_1;
  };
  protoOf(LazyGridMeasureResult).ci0 = function () {
    return this.vip_1;
  };
  protoOf(LazyGridMeasureResult).lhy = function () {
    return this.xip_1;
  };
  protoOf(LazyGridMeasureResult).zhz = function () {
    return this.yip_1;
  };
  protoOf(LazyGridMeasureResult).big = function () {
    return this.zip_1;
  };
  protoOf(LazyGridMeasureResult).ng7 = function () {
    var tmp;
    var tmp0_safe_receiver = this.gip_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ziq_1;
    if (!((tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) === 0)) {
      tmp = true;
    } else {
      tmp = !(this.hip_1 === 0);
    }
    return tmp;
  };
  protoOf(LazyGridMeasureResult).khy = function () {
    var tmp0 = this.h5e();
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = this.i5e();
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntSize___init__impl__emcjft(tmp$ret$1);
  };
  protoOf(LazyGridMeasureResult).yhz = function () {
    return -this.tip_1 | 0;
  };
  protoOf(LazyGridMeasureResult).hig = function (delta, updateAnimations) {
    var tmp;
    if (this.mip_1 || this.sip_1.r() || this.gip_1 == null) {
      tmp = true;
    } else {
      var containsUpper = this.gip_1.gir_1;
      var containsArg = this.hip_1 - delta | 0;
      tmp = !(0 <= containsArg ? containsArg < containsUpper : false);
    }
    if (tmp) {
      return null;
    }
    var first_0 = first(this.sip_1);
    var last_0 = last(this.sip_1);
    if (first_0.fis_1 || last_0.fis_1) {
      return null;
    }
    var tmp_0;
    if (delta < 0) {
      var deltaToFirstItemChange = (offsetOnMainAxis(first_0, this.xip_1) + first_0.xir_1 | 0) - this.tip_1 | 0;
      var deltaToLastItemChange = (offsetOnMainAxis(last_0, this.xip_1) + last_0.xir_1 | 0) - this.uip_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      tmp_0 = Math.min(deltaToFirstItemChange, deltaToLastItemChange) > (-delta | 0);
    } else {
      var deltaToFirstItemChange_0 = this.tip_1 - offsetOnMainAxis(first_0, this.xip_1) | 0;
      var deltaToLastItemChange_0 = this.uip_1 - offsetOnMainAxis(last_0, this.xip_1) | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      tmp_0 = Math.min(deltaToFirstItemChange_0, deltaToLastItemChange_0) > delta;
    }
    var canApply = tmp_0;
    var tmp_1;
    if (canApply) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = this.sip_1;
      var inductionVariable = 0;
      var last_1 = this_0.n1() - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item.iig(delta, updateAnimations);
        }
         while (inductionVariable <= last_1);
      var tmp0_firstVisibleLine = this.gip_1;
      var tmp1_firstVisibleLineScrollOffset = this.hip_1 - delta | 0;
      var tmp2_canScrollForward = this.iip_1 || delta > 0;
      var tmp4_scrollBackAmount = this.lip_1;
      var tmp5_measureResult = this.kip_1;
      var tmp6_remeasureNeeded = this.mip_1;
      var tmp7_coroutineScope = this.nip_1;
      var tmp8_density = this.oip_1;
      var tmp9_slotsPerLine = this.pip_1;
      var tmp10_prefetchInfoRetriever = this.qip_1;
      var tmp11_lineIndexProvider = this.rip_1;
      var tmp12_visibleItemsInfo = this.sip_1;
      var tmp13_viewportStartOffset = this.tip_1;
      var tmp14_viewportEndOffset = this.uip_1;
      var tmp15_totalItemsCount = this.vip_1;
      var tmp16_reverseLayout = this.wip_1;
      var tmp17_orientation = this.xip_1;
      var tmp18_afterContentPadding = this.yip_1;
      var tmp19_mainAxisItemSpacing = this.zip_1;
      tmp_1 = new LazyGridMeasureResult(tmp0_firstVisibleLine, tmp1_firstVisibleLineScrollOffset, tmp2_canScrollForward, delta, tmp5_measureResult, tmp4_scrollBackAmount, tmp6_remeasureNeeded, tmp7_coroutineScope, tmp8_density, tmp9_slotsPerLine, tmp10_prefetchInfoRetriever, tmp11_lineIndexProvider, tmp12_visibleItemsInfo, tmp13_viewportStartOffset, tmp14_viewportEndOffset, tmp15_totalItemsCount, tmp16_reverseLayout, tmp17_orientation, tmp18_afterContentPadding, tmp19_mainAxisItemSpacing);
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  };
  protoOf(LazyGridMeasureResult).uad = function () {
    this.kip_1.uad();
  };
  protoOf(LazyGridMeasureResult).h5e = function () {
    return this.kip_1.h5e();
  };
  protoOf(LazyGridMeasureResult).i5e = function () {
    return this.kip_1.i5e();
  };
  protoOf(LazyGridMeasureResult).sad = function () {
    return this.kip_1.sad();
  };
  protoOf(LazyGridMeasureResult).tad = function () {
    return this.kip_1.tad();
  };
  var androidx_compose_foundation_lazy_grid_LazyGridMeasuredItem$stable;
  function _get_mainAxis__jwdafl_0($this, $receiver) {
    return $this.jir_1 ? _IntOffset___get_y__impl__2avpwj($receiver) : _IntOffset___get_x__impl__qiqr5o($receiver);
  }
  function _get_mainAxisSize__iyci34_0($this, $receiver) {
    return $this.jir_1 ? $receiver.j8y_1 : $receiver.i8y_1;
  }
  function LazyGridMeasuredItem(index, key, isVertical, crossAxisSize, mainAxisSpacing, reverseLayout, layoutDirection, beforeContentPadding, afterContentPadding, placeables, visualOffset, contentType, animator, constraints, lane, span) {
    this.hir_1 = index;
    this.iir_1 = key;
    this.jir_1 = isVertical;
    this.kir_1 = crossAxisSize;
    this.lir_1 = reverseLayout;
    this.mir_1 = layoutDirection;
    this.nir_1 = beforeContentPadding;
    this.oir_1 = afterContentPadding;
    this.pir_1 = placeables;
    this.qir_1 = visualOffset;
    this.rir_1 = contentType;
    this.sir_1 = animator;
    this.tir_1 = constraints;
    this.uir_1 = lane;
    this.vir_1 = span;
    this.yir_1 = -2147483648;
    this.zir_1 = 0;
    this.ais_1 = 0;
    var maxMainAxis = 0;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.pir_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index_0);
        var tmp0 = maxMainAxis;
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = this.jir_1 ? item.j8y_1 : item.i8y_1;
        maxMainAxis = Math.max(tmp0, b);
      }
       while (inductionVariable <= last);
    this.wir_1 = maxMainAxis;
    this.xir_1 = coerceAtLeast_0(maxMainAxis + mainAxisSpacing | 0, 0);
    var tmp = this;
    var tmp_0;
    if (this.jir_1) {
      var tmp0_0 = this.kir_1;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = this.wir_1;
      var tmp$ret$4 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      tmp_0 = _IntSize___init__impl__emcjft(tmp$ret$4);
    } else {
      var tmp0_1 = this.wir_1;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2_0 = this.kir_1;
      var tmp$ret$6 = bitwiseOr(shiftLeft(fromInt(tmp0_1), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
      tmp_0 = _IntSize___init__impl__emcjft(tmp$ret$6);
    }
    tmp.bis_1 = tmp_0;
    this.cis_1 = Companion_getInstance_21().c5g_1;
    this.dis_1 = -1;
    this.eis_1 = -1;
    this.fis_1 = false;
  }
  protoOf(LazyGridMeasuredItem).bi0 = function () {
    return this.hir_1;
  };
  protoOf(LazyGridMeasuredItem).t1 = function () {
    return this.iir_1;
  };
  protoOf(LazyGridMeasuredItem).jig = function () {
    return this.jir_1;
  };
  protoOf(LazyGridMeasuredItem).vds = function () {
    return this.tir_1;
  };
  protoOf(LazyGridMeasuredItem).kig = function () {
    return this.uir_1;
  };
  protoOf(LazyGridMeasuredItem).lig = function () {
    return this.vir_1;
  };
  protoOf(LazyGridMeasuredItem).mig = function () {
    return this.xir_1;
  };
  protoOf(LazyGridMeasuredItem).law = function () {
    return this.pir_1.n1();
  };
  protoOf(LazyGridMeasuredItem).oig = function (index) {
    return this.pir_1.l1(index).xag();
  };
  protoOf(LazyGridMeasuredItem).q95 = function () {
    return this.bis_1;
  };
  protoOf(LazyGridMeasuredItem).jhy = function () {
    return this.cis_1;
  };
  protoOf(LazyGridMeasuredItem).viq = function () {
    return this.dis_1;
  };
  protoOf(LazyGridMeasuredItem).uiq = function () {
    return this.eis_1;
  };
  protoOf(LazyGridMeasuredItem).qig = function (index) {
    return this.cis_1;
  };
  protoOf(LazyGridMeasuredItem).nig = function (_set____db54di) {
    this.fis_1 = _set____db54di;
  };
  protoOf(LazyGridMeasuredItem).xhz = function () {
    return this.fis_1;
  };
  protoOf(LazyGridMeasuredItem).pig = function (mainAxisOffset, crossAxisOffset, layoutWidth, layoutHeight) {
    this.his(mainAxisOffset, crossAxisOffset, layoutWidth, layoutHeight, -1, -1);
  };
  protoOf(LazyGridMeasuredItem).his = function (mainAxisOffset, crossAxisOffset, layoutWidth, layoutHeight, row, column) {
    this.yir_1 = this.jir_1 ? layoutHeight : layoutWidth;
    var crossAxisLayoutSize = this.jir_1 ? layoutWidth : layoutHeight;
    var tmp;
    if (this.jir_1 && this.mir_1.equals(LayoutDirection_Rtl_getInstance())) {
      tmp = (crossAxisLayoutSize - crossAxisOffset | 0) - this.kir_1 | 0;
    } else {
      tmp = crossAxisOffset;
    }
    var crossAxisOffset_0 = tmp;
    var tmp_0 = this;
    var tmp_1;
    if (this.jir_1) {
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(crossAxisOffset_0), 32), bitwiseAnd(fromInt(mainAxisOffset), new Long(-1, 0)));
      tmp_1 = _IntOffset___init__impl__rq8h7b(tmp$ret$1);
    } else {
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(mainAxisOffset), 32), bitwiseAnd(fromInt(crossAxisOffset_0), new Long(-1, 0)));
      tmp_1 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
    }
    tmp_0.cis_1 = tmp_1;
    this.dis_1 = row;
    this.eis_1 = column;
    this.zir_1 = -this.nir_1 | 0;
    this.ais_1 = this.yir_1 + this.oir_1 | 0;
  };
  protoOf(LazyGridMeasuredItem).eig = function (mainAxisLayoutSize) {
    this.yir_1 = mainAxisLayoutSize;
    this.ais_1 = mainAxisLayoutSize + this.oir_1 | 0;
  };
  protoOf(LazyGridMeasuredItem).iig = function (delta, updateAnimations) {
    if (this.fis_1) {
      return Unit_instance;
    }
    var tmp = this;
    // Inline function 'androidx.compose.foundation.lazy.grid.LazyGridMeasuredItem.copy' call
    var this_0 = this.cis_1;
    var tmp_0;
    if (this.jir_1) {
      tmp_0 = _IntOffset___get_x__impl__qiqr5o(this_0);
    } else {
      tmp_0 = _IntOffset___get_x__impl__qiqr5o(this_0) + delta | 0;
    }
    var tmp0 = tmp_0;
    var tmp_1;
    if (this.jir_1) {
      tmp_1 = _IntOffset___get_y__impl__2avpwj(this_0) + delta | 0;
    } else {
      tmp_1 = _IntOffset___get_y__impl__2avpwj(this_0);
    }
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = tmp_1;
    var tmp$ret$4 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    tmp.cis_1 = _IntOffset___init__impl__rq8h7b(tmp$ret$4);
    if (updateAnimations) {
      // Inline function 'kotlin.repeat' call
      var times = this.law();
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var animation = this.sir_1.rig(this.iir_1, index);
          if (!(animation == null)) {
            var tmp_2 = animation;
            // Inline function 'androidx.compose.foundation.lazy.grid.LazyGridMeasuredItem.copy' call
            var this_1 = animation.dih_1;
            var tmp_3;
            if (this.jir_1) {
              tmp_3 = _IntOffset___get_x__impl__qiqr5o(this_1);
            } else {
              tmp_3 = _IntOffset___get_x__impl__qiqr5o(this_1) + delta | 0;
            }
            var tmp0_0 = tmp_3;
            var tmp_4;
            if (this.jir_1) {
              tmp_4 = _IntOffset___get_y__impl__2avpwj(this_1) + delta | 0;
            } else {
              tmp_4 = _IntOffset___get_y__impl__2avpwj(this_1);
            }
            // Inline function 'androidx.compose.ui.unit.IntOffset' call
            // Inline function 'androidx.compose.ui.util.packInts' call
            var val2_0 = tmp_4;
            var tmp$ret$11 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
            tmp_2.dih_1 = _IntOffset___init__impl__rq8h7b(tmp$ret$11);
          }
        }
         while (inductionVariable < times);
    }
  };
  protoOf(LazyGridMeasuredItem).gig = function (scope, isLookingAhead) {
    // Inline function 'kotlin.with' call
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!!(this.yir_1 === -2147483648)) {
      var tmp$ret$3 = 'position() should be called first';
      throwIllegalArgumentException(tmp$ret$3);
    }
    // Inline function 'kotlin.repeat' call
    var times = this.law();
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var placeable = this.pir_1.l1(index);
        var minOffset = this.zir_1 - _get_mainAxisSize__iyci34_0(this, placeable) | 0;
        var maxOffset = this.ais_1;
        var offset = this.cis_1;
        var animation = this.sir_1.rig(this.iir_1, index);
        var layer;
        if (!(animation == null)) {
          if (isLookingAhead) {
            animation.jih_1 = offset;
          } else {
            var tmp;
            if (!equals(animation.jih_1, Companion_getInstance_67().kih_1)) {
              tmp = animation.jih_1;
            } else {
              tmp = offset;
            }
            var targetOffset = tmp;
            var animatedOffset = IntOffset__plus_impl_nqoa9b(targetOffset, animation.lih());
            if (_get_mainAxis__jwdafl_0(this, offset) <= minOffset && _get_mainAxis__jwdafl_0(this, animatedOffset) <= minOffset || (_get_mainAxis__jwdafl_0(this, offset) >= maxOffset && _get_mainAxis__jwdafl_0(this, animatedOffset) >= maxOffset)) {
              animation.mih();
            }
            offset = animatedOffset;
          }
          layer = animation.fih_1;
        } else {
          layer = null;
        }
        if (this.lir_1) {
          // Inline function 'androidx.compose.foundation.lazy.grid.LazyGridMeasuredItem.copy' call
          var this_0 = offset;
          var tmp_0;
          if (this.jir_1) {
            tmp_0 = _IntOffset___get_x__impl__qiqr5o(this_0);
          } else {
            var mainAxisOffset = _IntOffset___get_x__impl__qiqr5o(this_0);
            tmp_0 = (this.yir_1 - mainAxisOffset | 0) - _get_mainAxisSize__iyci34_0(this, placeable) | 0;
          }
          var tmp0 = tmp_0;
          var tmp_1;
          if (this.jir_1) {
            var mainAxisOffset_0 = _IntOffset___get_y__impl__2avpwj(this_0);
            tmp_1 = (this.yir_1 - mainAxisOffset_0 | 0) - _get_mainAxisSize__iyci34_0(this, placeable) | 0;
          } else {
            tmp_1 = _IntOffset___get_y__impl__2avpwj(this_0);
          }
          // Inline function 'androidx.compose.ui.unit.IntOffset' call
          // Inline function 'androidx.compose.ui.util.packInts' call
          var val2 = tmp_1;
          var tmp$ret$10 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
          offset = _IntOffset___init__impl__rq8h7b(tmp$ret$10);
        }
        offset = IntOffset__plus_impl_nqoa9b(offset, this.qir_1);
        if (!isLookingAhead) {
          if (animation == null)
            null;
          else {
            animation.eih_1 = offset;
          }
        }
        if (this.jir_1) {
          if (!(layer == null)) {
            scope.wal(placeable, offset, layer);
          } else {
            scope.ual(placeable, offset);
          }
        } else {
          if (!(layer == null)) {
            scope.ral(placeable, offset, layer);
          } else {
            scope.nal(placeable, offset);
          }
        }
      }
       while (inductionVariable < times);
    return Unit_instance;
  };
  var androidx_compose_foundation_lazy_grid_LazyGridMeasuredItemProvider$stable;
  function LazyGridMeasuredItemProvider(itemProvider, measureScope, defaultMainAxisSpacing) {
    LazyLayoutMeasuredItemProvider.call(this);
    this.win_1 = itemProvider;
    this.xin_1 = measureScope;
    this.yin_1 = defaultMainAxisSpacing;
  }
  protoOf(LazyGridMeasuredItemProvider).sid = function (index, lane, span, constraints) {
    return this.zin(index, constraints, lane, span, this.yin_1);
  };
  protoOf(LazyGridMeasuredItemProvider).zin = function (index, constraints, lane, span, mainAxisSpacing) {
    var key = this.win_1.jif(index);
    var contentType = this.win_1.kif(index);
    var placeables = this.yid(this.xin_1, index, constraints);
    var tmp;
    if (_Constraints___get_hasFixedWidth__impl__4p17wc(constraints)) {
      tmp = _Constraints___get_minWidth__impl__hi9lfi(constraints);
    } else {
      // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
      if (!_Constraints___get_hasFixedHeight__impl__y56fxx(constraints)) {
        var tmp$ret$1 = 'does not have fixed height';
        throwIllegalArgumentException(tmp$ret$1);
      }
      tmp = _Constraints___get_minHeight__impl__ev4bgx(constraints);
    }
    var crossAxisSize = tmp;
    return this.uin(index, key, contentType, crossAxisSize, mainAxisSpacing, placeables, constraints, lane, span);
  };
  protoOf(LazyGridMeasuredItemProvider).vid = function () {
    return this.win_1.vid();
  };
  protoOf(LazyGridMeasuredItemProvider).aio = function () {
    return this.win_1.wid();
  };
  var androidx_compose_foundation_lazy_grid_LazyGridMeasuredLine$stable;
  function LazyGridMeasuredLine(index, items, slots, spans, isVertical, mainAxisSpacing) {
    this.ziq_1 = index;
    this.air_1 = items;
    this.bir_1 = slots;
    this.cir_1 = spans;
    this.dir_1 = isVertical;
    this.eir_1 = mainAxisSpacing;
    var maxMainAxis = 0;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.air_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = maxMainAxis;
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = element.wir_1;
      maxMainAxis = Math.max(tmp0, b);
    }
    this.fir_1 = maxMainAxis;
    this.gir_1 = coerceAtLeast_0(maxMainAxis + this.eir_1 | 0, 0);
  }
  protoOf(LazyGridMeasuredLine).r = function () {
    // Inline function 'kotlin.collections.isEmpty' call
    return this.air_1.length === 0;
  };
  protoOf(LazyGridMeasuredLine).gis = function (offset, layoutWidth, layoutHeight) {
    var usedSpan = 0;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = this.air_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var span = _GridItemSpan___get_currentLineSpan__impl__sg7kqc(this.cir_1.l1(_unary__edvuaz).zio_1);
      var startSlot = usedSpan;
      item.his(offset, this.bir_1.aim_1[startSlot], layoutWidth, layoutHeight, this.dir_1 ? this.ziq_1 : startSlot, this.dir_1 ? startSlot : this.ziq_1);
      // Inline function 'kotlin.also' call
      usedSpan = usedSpan + span | 0;
    }
    return this.air_1;
  };
  var androidx_compose_foundation_lazy_grid_LazyGridMeasuredLineProvider$stable;
  function LazyGridMeasuredLineProvider(isVertical, slots, gridItemsCount, spaceBetweenLines, measuredItemProvider, spanLayoutProvider) {
    this.bin_1 = isVertical;
    this.cin_1 = slots;
    this.din_1 = gridItemsCount;
    this.ein_1 = spaceBetweenLines;
    this.fin_1 = measuredItemProvider;
    this.gin_1 = spanLayoutProvider;
  }
  protoOf(LazyGridMeasuredLineProvider).kio = function (startSlot, span) {
    var tmp;
    if (span === 1) {
      tmp = this.cin_1.zil_1[startSlot];
    } else {
      var endSlot = (startSlot + span | 0) - 1 | 0;
      tmp = (this.cin_1.aim_1[endSlot] + this.cin_1.zil_1[endSlot] | 0) - this.cin_1.aim_1[startSlot] | 0;
    }
    var crossAxisSize = coerceAtLeast_0(tmp, 0);
    var tmp_0;
    if (this.bin_1) {
      tmp_0 = Companion_instance_4.q5e(crossAxisSize);
    } else {
      tmp_0 = Companion_instance_4.r5e(crossAxisSize);
    }
    return tmp_0;
  };
  protoOf(LazyGridMeasuredLineProvider).lio = function (index) {
    return this.gin_1.iis(index, this.gin_1.vio_1);
  };
  protoOf(LazyGridMeasuredLineProvider).mio = function (lineIndex) {
    var lineConfiguration = this.gin_1.wio(lineIndex);
    var lineItemsCount = lineConfiguration.yio_1.n1();
    var tmp;
    if (lineItemsCount === 0 || (lineConfiguration.xio_1 + lineItemsCount | 0) === this.din_1) {
      tmp = 0;
    } else {
      tmp = this.ein_1;
    }
    var mainAxisSpacing = tmp;
    var startSlot = {_v: 0};
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(lineItemsCount);
    while (tmp_0 < lineItemsCount) {
      var tmp_2 = tmp_0;
      var span = _GridItemSpan___get_currentLineSpan__impl__sg7kqc(lineConfiguration.yio_1.l1(tmp_2).zio_1);
      var constraints = this.kio(startSlot._v, span);
      // Inline function 'kotlin.also' call
      var this_0 = this.fin_1.zin(lineConfiguration.xio_1 + tmp_2 | 0, constraints, startSlot._v, span, mainAxisSpacing);
      startSlot._v = startSlot._v + span | 0;
      tmp_1[tmp_2] = this_0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    var items = tmp_1;
    return this.jio(lineIndex, items, lineConfiguration.yio_1, mainAxisSpacing);
  };
  protoOf(LazyGridMeasuredLineProvider).hin = function (lineIndex) {
    return this.mio(lineIndex);
  };
  var androidx_compose_foundation_lazy_grid_LazyGridPrefetchResultScopeImpl$stable;
  function LazyGridPrefetchStrategy() {
  }
  function LazyGridPrefetchStrategy_0(nestedPrefetchItemCount) {
    nestedPrefetchItemCount = nestedPrefetchItemCount === VOID ? 2 : nestedPrefetchItemCount;
    return new DefaultLazyGridPrefetchStrategy(nestedPrefetchItemCount);
  }
  function LazyGridPrefetchResultScopeImpl(lineIndex, mainAxisSizes) {
    this.lis_1 = lineIndex;
    this.mis_1 = mainAxisSizes;
  }
  function evaluatePrefetchForCancellation_0($this, $receiver, currentPrefetchingLineIndex, scrollingForward) {
    var tmp;
    if (!(currentPrefetchingLineIndex === -1)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$receiver.uhz().r();
    } else {
      tmp = false;
    }
    if (tmp) {
      var expectedLineToPrefetch = calculateLineIndexToPrefetch($this, $receiver, scrollingForward);
      if (!(currentPrefetchingLineIndex === expectedLineToPrefetch)) {
        resetPrefetchState_0($this);
      }
    }
  }
  function calculateLineIndexToPrefetch($this, $receiver, scrollingForward) {
    var tmp;
    if (scrollingForward) {
      // Inline function 'kotlin.let' call
      var it = last($receiver.uhz());
      tmp = ($receiver.lhy().equals(Orientation_Vertical_getInstance()) ? it.viq() : it.uiq()) + 1 | 0;
    } else {
      // Inline function 'kotlin.let' call
      var it_0 = first($receiver.uhz());
      tmp = ($receiver.lhy().equals(Orientation_Vertical_getInstance()) ? it_0.viq() : it_0.uiq()) - 1 | 0;
    }
    return tmp;
  }
  function calculateClosestNextItemToPrefetch($this, $receiver, scrollingForward) {
    var tmp;
    if (scrollingForward) {
      tmp = last($receiver.uhz()).bi0() + 1 | 0;
    } else {
      tmp = first($receiver.uhz()).bi0() - 1 | 0;
    }
    return tmp;
  }
  function resetPrefetchState_0($this) {
    $this.ois_1 = -1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = $this.pis_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      content[i].e2z();
      i = i + 1 | 0;
    }
    $this.pis_1.c3();
  }
  function DefaultLazyGridPrefetchStrategy(initialNestedPrefetchItemCount) {
    initialNestedPrefetchItemCount = initialNestedPrefetchItemCount === VOID ? 2 : initialNestedPrefetchItemCount;
    this.nis_1 = initialNestedPrefetchItemCount;
    this.ois_1 = -1;
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.pis_1 = new MutableVector(tmp$ret$2, 0);
    this.qis_1 = false;
    this.ris_1 = -1;
    this.sis_1 = 0.0;
  }
  protoOf(DefaultLazyGridPrefetchStrategy).jis = function (_this__u8e3s4, delta, layoutInfo) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!layoutInfo.uhz().r()) {
      var scrollingForward = delta < 0;
      var lineToPrefetch = calculateLineIndexToPrefetch(this, layoutInfo, scrollingForward);
      var closestNextItemToPrefetch = calculateClosestNextItemToPrefetch(this, layoutInfo, scrollingForward);
      if (0 <= closestNextItemToPrefetch ? closestNextItemToPrefetch < layoutInfo.ci0() : false) {
        if (!(lineToPrefetch === this.ois_1) && lineToPrefetch >= 0) {
          if (!(this.qis_1 === scrollingForward)) {
            // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
            var this_0 = this.pis_1;
            var i = 0;
            var tmp = this_0.b3e_1;
            var content = isArray(tmp) ? tmp : THROW_CCE();
            var size = this_0.d3e_1;
            while (i < size) {
              content[i].e2z();
              i = i + 1 | 0;
            }
          }
          this.qis_1 = scrollingForward;
          this.ois_1 = lineToPrefetch;
          this.pis_1.c3();
          var tmp0 = this.pis_1;
          // Inline function 'androidx.compose.runtime.collection.MutableVector.addAll' call
          var elements = _this__u8e3s4.tis(lineToPrefetch);
          tmp0.l4a(tmp0.d3e_1, elements);
        }
        if (scrollingForward) {
          var lastItem = last(layoutInfo.uhz());
          var itemSize = sizeOnMainAxis(lastItem, layoutInfo.lhy());
          var itemSpacing = layoutInfo.big();
          var distanceToPrefetchItem = ((offsetOnMainAxis(lastItem, layoutInfo.lhy()) + itemSize | 0) + itemSpacing | 0) - layoutInfo.aig() | 0;
          if (distanceToPrefetchItem < -delta) {
            // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
            var this_1 = this.pis_1;
            var i_0 = 0;
            var tmp_0 = this_1.b3e_1;
            var content_0 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
            var size_0 = this_1.d3e_1;
            while (i_0 < size_0) {
              content_0[i_0].cii();
              i_0 = i_0 + 1 | 0;
            }
          }
        } else {
          var firstItem = first(layoutInfo.uhz());
          var distanceToPrefetchItem_0 = layoutInfo.zif() - offsetOnMainAxis(firstItem, layoutInfo.lhy()) | 0;
          if (distanceToPrefetchItem_0 < delta) {
            // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
            var this_2 = this.pis_1;
            var i_1 = 0;
            var tmp_1 = this_2.b3e_1;
            var content_1 = isArray(tmp_1) ? tmp_1 : THROW_CCE();
            var size_1 = this_2.d3e_1;
            while (i_1 < size_1) {
              content_1[i_1].cii();
              i_1 = i_1 + 1 | 0;
            }
          }
        }
      }
    }
    this.sis_1 = delta;
  };
  protoOf(DefaultLazyGridPrefetchStrategy).kis = function (_this__u8e3s4, layoutInfo) {
    evaluatePrefetchForCancellation_0(this, layoutInfo, this.ois_1, this.qis_1);
    var currentPassItemCount = layoutInfo.ci0();
    var tmp;
    if (!(this.ris_1 === -1) && !(this.sis_1 === 0.0) && !(this.ris_1 === currentPassItemCount)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !layoutInfo.uhz().r();
    } else {
      tmp = false;
    }
    if (tmp) {
      var lineToPrefetch = calculateLineIndexToPrefetch(this, layoutInfo, this.sis_1 < 0);
      var closestNextItemToPrefetch = calculateClosestNextItemToPrefetch(this, layoutInfo, this.sis_1 < 0);
      if (0 <= closestNextItemToPrefetch ? closestNextItemToPrefetch < layoutInfo.ci0() : false) {
        if (!(lineToPrefetch === this.ois_1) && lineToPrefetch >= 0) {
          this.ois_1 = lineToPrefetch;
          this.pis_1.c3();
          var tmp0 = this.pis_1;
          // Inline function 'androidx.compose.runtime.collection.MutableVector.addAll' call
          var elements = _this__u8e3s4.tis(lineToPrefetch);
          tmp0.l4a(tmp0.d3e_1, elements);
        }
      }
    }
    this.ris_1 = currentPassItemCount;
  };
  protoOf(DefaultLazyGridPrefetchStrategy).rih = function (_this__u8e3s4, firstVisibleItemIndex) {
    var tmp;
    if (_this__u8e3s4.dii() === -1) {
      tmp = this.nis_1;
    } else {
      tmp = _this__u8e3s4.dii();
    }
    var resolvedNestedPrefetchItemCount = tmp;
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < resolvedNestedPrefetchItemCount)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _this__u8e3s4.eii(firstVisibleItemIndex + index | 0);
      }
       while (inductionVariable < resolvedNestedPrefetchItemCount);
  };
  var androidx_compose_foundation_lazy_grid_LazyGridScrollPosition$stable;
  function _set_index__fyfqnn($this, _set____db54di) {
    var tmp0 = $this.uis_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyGridScrollPosition$_get_index_$ref_yzx8w6();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('index', 1, tmp, tmp_0, LazyGridScrollPosition$_set_index_$ref_6qccoe());
    tmp0.a49(_set____db54di);
    return Unit_instance;
  }
  function _set_scrollOffset__x5lxuf_0($this, _set____db54di) {
    var tmp0 = $this.vis_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyGridScrollPosition$_get_scrollOffset_$ref_vnyro2();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('scrollOffset', 1, tmp, tmp_0, LazyGridScrollPosition$_set_scrollOffset_$ref_aa118a());
    tmp0.a49(_set____db54di);
    return Unit_instance;
  }
  function update_1($this, index, scrollOffset) {
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(index >= 0.0)) {
      var tmp$ret$1 = 'Index should be non-negative';
      throwIllegalArgumentException(tmp$ret$1);
    }
    _set_index__fyfqnn($this, index);
    $this.yis_1.pii(index);
    _set_scrollOffset__x5lxuf_0($this, scrollOffset);
  }
  function LazyGridScrollPosition$_get_index_$ref_yzx8w6() {
    return constructCallableReference(function (p0) {
      return p0.bi0();
    }, 1, 0, 266);
  }
  function LazyGridScrollPosition$_set_index_$ref_6qccoe() {
    return constructCallableReference(function (p0, p1) {
      _set_index__fyfqnn(p0, p1);
      return Unit_instance;
    }, 2, 0, 267);
  }
  function LazyGridScrollPosition$_get_scrollOffset_$ref_vnyro2() {
    return constructCallableReference(function (p0) {
      return p0.kia();
    }, 1, 0, 268);
  }
  function LazyGridScrollPosition$_set_scrollOffset_$ref_aa118a() {
    return constructCallableReference(function (p0, p1) {
      _set_scrollOffset__x5lxuf_0(p0, p1);
      return Unit_instance;
    }, 2, 0, 269);
  }
  function LazyGridScrollPosition(initialIndex, initialScrollOffset) {
    initialIndex = initialIndex === VOID ? 0 : initialIndex;
    initialScrollOffset = initialScrollOffset === VOID ? 0 : initialScrollOffset;
    this.uis_1 = mutableIntStateOf(initialIndex);
    this.vis_1 = mutableIntStateOf(initialScrollOffset);
    this.wis_1 = false;
    this.xis_1 = null;
    this.yis_1 = new LazyLayoutNearestRangeState(initialIndex, 90, 200);
  }
  protoOf(LazyGridScrollPosition).bi0 = function () {
    var tmp0 = this.uis_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyGridScrollPosition$_get_index_$ref_yzx8w6();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('index', 1, tmp, tmp_0, LazyGridScrollPosition$_set_index_$ref_6qccoe());
    return tmp0.b49();
  };
  protoOf(LazyGridScrollPosition).kia = function () {
    var tmp0 = this.vis_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyGridScrollPosition$_get_scrollOffset_$ref_vnyro2();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('scrollOffset', 1, tmp, tmp_0, LazyGridScrollPosition$_set_scrollOffset_$ref_aa118a());
    return tmp0.b49();
  };
  protoOf(LazyGridScrollPosition).zis = function (measureResult) {
    var tmp = this;
    var tmp0_safe_receiver = measureResult.gip_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.air_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : firstOrNull_0(tmp1_safe_receiver);
    tmp.xis_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.iir_1;
    if (this.wis_1 || measureResult.vip_1 > 0) {
      this.wis_1 = true;
      var scrollOffset = measureResult.hip_1;
      // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
      if (!(scrollOffset >= 0.0)) {
        var tmp$ret$1 = 'scrollOffset should be non-negative (' + scrollOffset + ')';
        throwIllegalStateException(tmp$ret$1);
      }
      var tmp3_safe_receiver = measureResult.gip_1;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.air_1;
      var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : firstOrNull_0(tmp4_safe_receiver);
      var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.hir_1;
      var firstIndex = tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs;
      update_1(this, firstIndex, scrollOffset);
    }
  };
  protoOf(LazyGridScrollPosition).rii = function (scrollOffset) {
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(scrollOffset >= 0.0)) {
      var tmp$ret$1 = 'scrollOffset should be non-negative';
      throwIllegalStateException(tmp$ret$1);
    }
    _set_scrollOffset__x5lxuf_0(this, scrollOffset);
  };
  protoOf(LazyGridScrollPosition).sii = function (index, scrollOffset) {
    update_1(this, index, scrollOffset);
    this.xis_1 = null;
  };
  protoOf(LazyGridScrollPosition).ait = function (itemProvider, index) {
    var newIndex = findIndexByKey(itemProvider, this.xis_1, index);
    if (!(index === newIndex)) {
      _set_index__fyfqnn(this, newIndex);
      this.yis_1.pii(index);
    }
    return newIndex;
  };
  function _GridItemSpan___init__impl__x45lr6(packedValue) {
    return packedValue;
  }
  function _get_packedValue__aj623s($this) {
    return $this;
  }
  function _GridItemSpan___get_currentLineSpan__impl__sg7kqc($this) {
    return convertToInt(_get_packedValue__aj623s($this));
  }
  function GridItemSpan__toString_impl_aecw6a($this) {
    return 'GridItemSpan(packedValue=' + $this.toString() + ')';
  }
  function GridItemSpan__hashCode_impl_w5isz5($this) {
    return $this.hashCode();
  }
  function GridItemSpan__equals_impl_og48vf($this, other) {
    if (!(other instanceof GridItemSpan))
      return false;
    var tmp0_other_with_cast = other.zio_1;
    if (!equalsLong($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function GridItemSpan(packedValue) {
    this.zio_1 = packedValue;
  }
  protoOf(GridItemSpan).toString = function () {
    return GridItemSpan__toString_impl_aecw6a(this.zio_1);
  };
  protoOf(GridItemSpan).hashCode = function () {
    return GridItemSpan__hashCode_impl_w5isz5(this.zio_1);
  };
  protoOf(GridItemSpan).equals = function (other) {
    return GridItemSpan__equals_impl_og48vf(this.zio_1, other);
  };
  function GridItemSpan_0(currentLineSpan) {
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(currentLineSpan > 0)) {
      var tmp$ret$1 = 'The span value should be higher than 0';
      throwIllegalArgumentException(tmp$ret$1);
    }
    return _GridItemSpan___init__impl__x45lr6(fromInt(currentLineSpan));
  }
  var androidx_compose_foundation_lazy_grid_LazyGridSpanLayoutProvider_LineConfiguration$stable;
  var androidx_compose_foundation_lazy_grid_LazyGridSpanLayoutProvider$stable;
  function LineConfiguration(firstItemIndex, spans) {
    this.xio_1 = firstItemIndex;
    this.yio_1 = spans;
  }
  function _get_bucketSize__qovgv4($this) {
    // Inline function 'kotlin.math.sqrt' call
    var x = 1.0 * $this.bit() / $this.vio_1;
    var tmp$ret$0 = Math.sqrt(x);
    return numberToInt(tmp$ret$0) + 1 | 0;
  }
  function getDefaultSpans($this, currentSlotsPerLine) {
    var tmp;
    if (currentSlotsPerLine === $this.uio_1.n1()) {
      tmp = $this.uio_1;
    } else {
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var list = ArrayList_init_$Create$_0(currentSlotsPerLine);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < currentSlotsPerLine)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4 = new GridItemSpan(GridItemSpan_0(1));
          list.j1(tmp$ret$4);
        }
         while (inductionVariable < currentSlotsPerLine);
      // Inline function 'kotlin.also' call
      $this.uio_1 = list;
      tmp = list;
    }
    return tmp;
  }
  function invalidateCache($this) {
    $this.oio_1.c3();
    $this.oio_1.j1(new Bucket(0));
    $this.pio_1 = 0;
    $this.qio_1 = 0;
    $this.rio_1 = 0;
    $this.sio_1 = -1;
    $this.tio_1.c3();
  }
  function Bucket(firstItemIndex, firstItemKnownSpan) {
    firstItemKnownSpan = firstItemKnownSpan === VOID ? 0 : firstItemKnownSpan;
    this.cit_1 = firstItemIndex;
    this.dit_1 = firstItemKnownSpan;
  }
  function LazyGridItemSpanScopeImpl() {
    this.eit_1 = 0;
    this.fit_1 = 0;
  }
  protoOf(LazyGridItemSpanScopeImpl).git = function () {
    return this.fit_1;
  };
  var LazyGridItemSpanScopeImpl_instance;
  function LazyGridItemSpanScopeImpl_getInstance() {
    return LazyGridItemSpanScopeImpl_instance;
  }
  function LazyGridSpanLayoutProvider$getLineIndexOfItem$lambda($itemIndex) {
    return function (it) {
      return it.cit_1 - $itemIndex | 0;
    };
  }
  function LazyGridSpanLayoutProvider(gridContent) {
    this.nio_1 = gridContent;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    this_0.j1(new Bucket(0));
    tmp.oio_1 = this_0;
    this.pio_1 = 0;
    this.qio_1 = 0;
    this.rio_1 = 0;
    this.sio_1 = -1;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.tio_1 = ArrayList_init_$Create$();
    this.uio_1 = emptyList();
    this.vio_1 = 0;
  }
  protoOf(LazyGridSpanLayoutProvider).bit = function () {
    return this.nio_1.niq_1.gif_1;
  };
  protoOf(LazyGridSpanLayoutProvider).dip = function (value) {
    if (!(value === this.vio_1)) {
      this.vio_1 = value;
      invalidateCache(this);
    }
  };
  protoOf(LazyGridSpanLayoutProvider).wio = function (lineIndex) {
    if (!this.nio_1.oiq_1) {
      var firstItemIndex = imul(lineIndex, this.vio_1);
      return new LineConfiguration(firstItemIndex, getDefaultSpans(this, coerceAtLeast_0(coerceAtMost(this.vio_1, this.bit() - firstItemIndex | 0), 0)));
    }
    var tmp0 = lineIndex / _get_bucketSize__qovgv4(this) | 0;
    // Inline function 'kotlin.math.min' call
    var b = this.oio_1.n1() - 1 | 0;
    var bucketIndex = Math.min(tmp0, b);
    var currentLine = imul(bucketIndex, _get_bucketSize__qovgv4(this));
    var currentItemIndex = this.oio_1.l1(bucketIndex).cit_1;
    var knownCurrentItemSpan = this.oio_1.l1(bucketIndex).dit_1;
    var containsArg = this.pio_1;
    if (currentLine <= containsArg ? containsArg <= lineIndex : false) {
      currentLine = this.pio_1;
      currentItemIndex = this.qio_1;
      knownCurrentItemSpan = this.rio_1;
    } else {
      if (bucketIndex === this.sio_1 && (lineIndex - currentLine | 0) < this.tio_1.n1()) {
        currentItemIndex = this.tio_1.l1(lineIndex - currentLine | 0);
        currentLine = lineIndex;
        knownCurrentItemSpan = 0;
      }
    }
    var tmp;
    if ((currentLine % _get_bucketSize__qovgv4(this) | 0) === 0) {
      var containsUpper = _get_bucketSize__qovgv4(this);
      var containsArg_0 = lineIndex - currentLine | 0;
      tmp = 2 <= containsArg_0 ? containsArg_0 < containsUpper : false;
    } else {
      tmp = false;
    }
    var cacheThisBucket = tmp;
    if (cacheThisBucket) {
      this.sio_1 = bucketIndex;
      this.tio_1.c3();
    }
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(currentLine <= lineIndex)) {
      var tmp$ret$2 = 'currentLine (' + currentLine + ') > lineIndex (' + lineIndex + ')';
      throwIllegalStateException(tmp$ret$2);
    }
    while (currentLine < lineIndex && currentItemIndex < this.bit()) {
      if (cacheThisBucket) {
        this.tio_1.j1(currentItemIndex);
      }
      var spansUsed = 0;
      $l$loop: while (spansUsed < this.vio_1 && currentItemIndex < this.bit()) {
        var tmp_0;
        if (knownCurrentItemSpan === 0) {
          tmp_0 = this.iis(currentItemIndex, this.vio_1 - spansUsed | 0);
        } else {
          // Inline function 'kotlin.also' call
          var this_0 = knownCurrentItemSpan;
          knownCurrentItemSpan = 0;
          tmp_0 = this_0;
        }
        var span = tmp_0;
        if ((spansUsed + span | 0) > this.vio_1) {
          knownCurrentItemSpan = span;
          break $l$loop;
        }
        currentItemIndex = currentItemIndex + 1 | 0;
        spansUsed = spansUsed + span | 0;
      }
      currentLine = currentLine + 1 | 0;
      if ((currentLine % _get_bucketSize__qovgv4(this) | 0) === 0 && currentItemIndex < this.bit()) {
        var currentLineBucket = currentLine / _get_bucketSize__qovgv4(this) | 0;
        // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
        if (!(this.oio_1.n1() === currentLineBucket)) {
          var tmp$ret$6 = 'invalid starting point';
          throwIllegalStateException(tmp$ret$6);
        }
        this.oio_1.j1(new Bucket(currentItemIndex, knownCurrentItemSpan));
      }
    }
    this.pio_1 = lineIndex;
    this.qio_1 = currentItemIndex;
    this.rio_1 = knownCurrentItemSpan;
    var firstItemIndex_0 = currentItemIndex;
    // Inline function 'kotlin.collections.mutableListOf' call
    var spans = ArrayList_init_$Create$();
    var spansUsed_0 = 0;
    $l$loop_0: while (spansUsed_0 < this.vio_1 && currentItemIndex < this.bit()) {
      var tmp_1;
      if (knownCurrentItemSpan === 0) {
        tmp_1 = this.iis(currentItemIndex, this.vio_1 - spansUsed_0 | 0);
      } else {
        // Inline function 'kotlin.also' call
        var this_1 = knownCurrentItemSpan;
        knownCurrentItemSpan = 0;
        tmp_1 = this_1;
      }
      var span_0 = tmp_1;
      if ((spansUsed_0 + span_0 | 0) > this.vio_1)
        break $l$loop_0;
      currentItemIndex = currentItemIndex + 1 | 0;
      spans.j1(new GridItemSpan(GridItemSpan_0(span_0)));
      spansUsed_0 = spansUsed_0 + span_0 | 0;
    }
    return new LineConfiguration(firstItemIndex_0, spans);
  };
  protoOf(LazyGridSpanLayoutProvider).aip = function (itemIndex) {
    if (this.bit() <= 0) {
      return 0;
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(itemIndex < this.bit())) {
      var tmp$ret$1 = 'ItemIndex > total count';
      throwIllegalArgumentException(tmp$ret$1);
    }
    if (!this.nio_1.oiq_1) {
      return itemIndex / this.vio_1 | 0;
    }
    // Inline function 'kotlin.let' call
    var it = binarySearch(this.oio_1, VOID, VOID, LazyGridSpanLayoutProvider$getLineIndexOfItem$lambda(itemIndex));
    var lowerBoundBucket = it >= 0 ? it : (-it | 0) - 2 | 0;
    var currentLine = imul(lowerBoundBucket, _get_bucketSize__qovgv4(this));
    var currentItemIndex = this.oio_1.l1(lowerBoundBucket).cit_1;
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(currentItemIndex <= itemIndex)) {
      var tmp$ret$5 = 'currentItemIndex > itemIndex';
      throwIllegalArgumentException(tmp$ret$5);
    }
    var spansUsed = 0;
    while (currentItemIndex < itemIndex) {
      var _unary__edvuaz = currentItemIndex;
      currentItemIndex = _unary__edvuaz + 1 | 0;
      var span = this.iis(_unary__edvuaz, this.vio_1 - spansUsed | 0);
      if ((spansUsed + span | 0) < this.vio_1) {
        spansUsed = spansUsed + span | 0;
      } else if ((spansUsed + span | 0) === this.vio_1) {
        currentLine = currentLine + 1 | 0;
        spansUsed = 0;
      } else {
        currentLine = currentLine + 1 | 0;
        spansUsed = span;
      }
      if ((currentLine % _get_bucketSize__qovgv4(this) | 0) === 0) {
        var currentLineBucket = currentLine / _get_bucketSize__qovgv4(this) | 0;
        if (currentLineBucket >= this.oio_1.n1()) {
          this.oio_1.j1(new Bucket(currentItemIndex - (spansUsed > 0 ? 1 : 0) | 0));
        }
      }
    }
    if ((spansUsed + this.iis(itemIndex, this.vio_1 - spansUsed | 0) | 0) > this.vio_1) {
      currentLine = currentLine + 1 | 0;
    }
    return currentLine;
  };
  protoOf(LazyGridSpanLayoutProvider).iis = function (itemIndex, maxSpan) {
    // Inline function 'kotlin.with' call
    LazyGridItemSpanScopeImpl_instance.eit_1 = maxSpan;
    LazyGridItemSpanScopeImpl_instance.fit_1 = this.vio_1;
    var interval = this.nio_1.niq_1.l1(itemIndex);
    var localIntervalIndex = itemIndex - interval.tif_1 | 0;
    var span = interval.vif_1.riq_1(LazyGridItemSpanScopeImpl_instance, localIntervalIndex).zio_1;
    return _GridItemSpan___get_currentLineSpan__impl__sg7kqc(span);
  };
  function get_EmptyLazyGridLayoutInfo() {
    _init_properties_LazyGridState_kt__6hut();
    return EmptyLazyGridLayoutInfo;
  }
  var EmptyLazyGridLayoutInfo;
  var androidx_compose_foundation_lazy_grid_LazyGridState$stable;
  function LazyGridState$Companion$Saver$lambda($this$listSaver, it) {
    return listOf([it.lia(), it.mia()]);
  }
  function LazyGridState$Companion$Saver$lambda_0(it) {
    return LazyGridState_init_$Create$(it.l1(0), it.l1(1));
  }
  function LazyGridState$prefetchScope$o$scheduleLinePrefetch$lambda($measureResult, $itemSizes, $completedCount, $itemsInLineInfo, $onPrefetchFinished, $lineIndex) {
    return function ($this$schedulePrecompositionAndPremeasure) {
      var itemMainAxisItemSize = 0;
      // Inline function 'kotlin.repeat' call
      var times = $this$schedulePrecompositionAndPremeasure.law();
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp = itemMainAxisItemSize;
          var tmp_0;
          if ($measureResult.xip_1.equals(Orientation_Vertical_getInstance())) {
            // Inline function 'androidx.compose.ui.unit.IntSize.height' call
            var this_0 = $this$schedulePrecompositionAndPremeasure.maw(index);
            // Inline function 'androidx.compose.ui.util.unpackInt2' call
            var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
            tmp_0 = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
          } else {
            // Inline function 'androidx.compose.ui.unit.IntSize.width' call
            var this_1 = $this$schedulePrecompositionAndPremeasure.maw(index);
            // Inline function 'androidx.compose.ui.util.unpackInt1' call
            var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
            tmp_0 = convertToInt(shiftRight(value_0, 32));
          }
          itemMainAxisItemSize = tmp + tmp_0 | 0;
        }
         while (inductionVariable < times);
      var tmp0_safe_receiver = $itemSizes;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.j1(itemMainAxisItemSize);
      if ($completedCount._v === $itemsInLineInfo.n1()) {
        if (!($onPrefetchFinished == null) && !($itemSizes == null)) {
          $onPrefetchFinished(new LazyGridPrefetchResultScopeImpl($lineIndex, $itemSizes));
        }
      } else {
        var _unary__edvuaz = $completedCount._v;
        $completedCount._v = _unary__edvuaz + 1 | 0;
      }
      return Unit_instance;
    };
  }
  function LazyGridState_init_$Init$(firstVisibleItemIndex, firstVisibleItemScrollOffset, $this) {
    firstVisibleItemIndex = firstVisibleItemIndex === VOID ? 0 : firstVisibleItemIndex;
    firstVisibleItemScrollOffset = firstVisibleItemScrollOffset === VOID ? 0 : firstVisibleItemScrollOffset;
    LazyGridState.call($this, firstVisibleItemIndex, firstVisibleItemScrollOffset, LazyGridPrefetchStrategy_0());
    return $this;
  }
  function LazyGridState_init_$Create$(firstVisibleItemIndex, firstVisibleItemScrollOffset) {
    return LazyGridState_init_$Init$(firstVisibleItemIndex, firstVisibleItemScrollOffset, objectCreate(protoOf(LazyGridState)));
  }
  function _set_canScrollForward__ffth81_0($this, _set____db54di) {
    var tmp0 = $this.yim_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyGridState$_get_canScrollForward_$ref_buq70f();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('canScrollForward', 1, tmp, tmp_0, LazyGridState$_set_canScrollForward_$ref_pssv0r());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _set_canScrollBackward__6c7ll1_0($this, _set____db54di) {
    var tmp0 = $this.zim_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyGridState$_get_canScrollBackward_$ref_azjnfx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('canScrollBackward', 1, tmp, tmp_0, LazyGridState$_set_canScrollBackward_$ref_4txb09());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function notifyPrefetchOnScroll_0($this, delta, layoutInfo) {
    if ($this.lim_1) {
      // Inline function 'kotlin.with' call
      $this.bim_1.jis($this.sim_1, delta, layoutInfo);
    }
  }
  function Companion_6() {
    Companion_instance_16 = this;
    var tmp = this;
    var tmp_0 = LazyGridState$Companion$Saver$lambda;
    tmp.hit_1 = listSaver(tmp_0, LazyGridState$Companion$Saver$lambda_0);
  }
  var Companion_instance_16;
  function Companion_getInstance_65() {
    if (Companion_instance_16 == null)
      new Companion_6();
    return Companion_instance_16;
  }
  function LazyGridState$scrollableState$lambda(this$0) {
    return function (it) {
      return -this$0.cij(-it);
    };
  }
  function LazyGridState$remeasurementModifier$1(this$0) {
    this.iit_1 = this$0;
  }
  protoOf(LazyGridState$remeasurementModifier$1).xap = function (remeasurement) {
    this.iit_1.mim_1 = remeasurement;
  };
  function LazyGridState$prefetchState$lambda(this$0, $firstVisibleItemIndex) {
    return function ($this$LazyLayoutPrefetchState) {
      // Inline function 'kotlin.with' call
      var $this$with = this$0.bim_1;
      var tmp$ret$2;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance_2.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance_2.q52(previousSnapshot);
        try {
          tmp$ret$2 = $firstVisibleItemIndex;
          break $l$block;
        }finally {
          Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
        }
      }
      $this$with.rih($this$LazyLayoutPrefetchState, tmp$ret$2);
      return Unit_instance;
    };
  }
  function LazyGridState$prefetchScope$1(this$0) {
    this.jit_1 = this$0;
  }
  protoOf(LazyGridState$prefetchScope$1).tis = function (lineIndex) {
    return this.kit(lineIndex, null);
  };
  protoOf(LazyGridState$prefetchScope$1).kit = function (lineIndex, onPrefetchFinished) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var prefetchHandles = ArrayList_init_$Create$();
    var tmp;
    if (onPrefetchFinished == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    }
    var itemSizes = tmp;
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
      var previousSnapshot = Companion_instance_2.p52();
      var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
      var newSnapshot = Companion_instance_2.q52(previousSnapshot);
      try {
        var tmp_0;
        if (this.jit_1.cim_1) {
          tmp_0 = this.jit_1.dim_1;
        } else {
          tmp_0 = this.jit_1.gim_1.u1();
        }
        var layoutInfo = tmp_0;
        var tmp_1;
        if (layoutInfo == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          var completedCount = {_v: 1};
          var itemsInLineInfo = layoutInfo.qip_1(lineIndex);
          // Inline function 'androidx.compose.ui.util.fastForEach' call
          var inductionVariable = 0;
          var last = itemsInLineInfo.n1() - 1 | 0;
          if (inductionVariable <= last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var item = itemsInLineInfo.l1(index);
              var tmp_2 = this.jit_1.eim_1;
              prefetchHandles.j1(this.jit_1.rim_1.mij(item.xh_1, item.yh_1.m5e_1, tmp_2, LazyGridState$prefetchScope$o$scheduleLinePrefetch$lambda(layoutInfo, itemSizes, completedCount, itemsInLineInfo, onPrefetchFinished, lineIndex)));
            }
             while (inductionVariable <= last);
          tmp_1 = Unit_instance;
        }
        break $l$block;
      }finally {
        Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
      }
    }
    return prefetchHandles;
  };
  function LazyGridState$_scrollIndicatorState$1(this$0) {
    this.lit_1 = this$0;
  }
  function LazyGridState$_get_nearestRange_$ref_bfrn6w() {
    return constructCallableReference(function (p0) {
      return p0.yif();
    }, 1, 0, 270);
  }
  function LazyGridState$scrollToItem$slambda(this$0, $index, $scrollOffset, resultContinuation) {
    this.uit_1 = this$0;
    this.vit_1 = $index;
    this.wit_1 = $scrollOffset;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyGridState$scrollToItem$slambda).zh6 = function ($this$scroll, $completion) {
    var tmp = this.ah7($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyGridState$scrollToItem$slambda).ja = function (p1, $completion) {
    return this.zh6((!(p1 == null) ? isInterface(p1, ScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyGridState$scrollToItem$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.uit_1.yii(this.vit_1, this.wit_1, true);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(LazyGridState$scrollToItem$slambda).ah7 = function ($this$scroll, completion) {
    var i = new LazyGridState$scrollToItem$slambda(this.uit_1, this.vit_1, this.wit_1, completion);
    i.xit_1 = $this$scroll;
    return i;
  };
  function LazyGridState$scrollToItem$slambda_0(this$0, $index, $scrollOffset, resultContinuation) {
    var i = new LazyGridState$scrollToItem$slambda(this$0, $index, $scrollOffset, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.zh6($this$scroll, $completion);
    }, 1);
  }
  function LazyGridState$_get_canScrollForward_$ref_buq70f() {
    return constructCallableReference(function (p0) {
      return p0.mg7();
    }, 1, 0, 271);
  }
  function LazyGridState$_set_canScrollForward_$ref_pssv0r() {
    return constructCallableReference(function (p0, p1) {
      _set_canScrollForward__ffth81_0(p0, p1);
      return Unit_instance;
    }, 2, 0, 272);
  }
  function LazyGridState$_get_canScrollBackward_$ref_azjnfx() {
    return constructCallableReference(function (p0) {
      return p0.ng7();
    }, 1, 0, 273);
  }
  function LazyGridState$_set_canScrollBackward_$ref_4txb09() {
    return constructCallableReference(function (p0, p1) {
      _set_canScrollBackward__6c7ll1_0(p0, p1);
      return Unit_instance;
    }, 2, 0, 274);
  }
  function $scrollCOROUTINE$_0(_this__u8e3s4, scrollPriority, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.giu_1 = _this__u8e3s4;
    this.hiu_1 = scrollPriority;
    this.iiu_1 = block;
  }
  protoOf($scrollCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (this.giu_1.gim_1.u1() === get_EmptyLazyGridLayoutInfo()) {
              this.n9_1 = 1;
              suspendResult = this.giu_1.oim_1.ail(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.giu_1.jim_1.pg7(this.hiu_1, this.iiu_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function LazyGridState(firstVisibleItemIndex, firstVisibleItemScrollOffset, prefetchStrategy) {
    Companion_getInstance_65();
    firstVisibleItemIndex = firstVisibleItemIndex === VOID ? 0 : firstVisibleItemIndex;
    firstVisibleItemScrollOffset = firstVisibleItemScrollOffset === VOID ? 0 : firstVisibleItemScrollOffset;
    prefetchStrategy = prefetchStrategy === VOID ? LazyGridPrefetchStrategy_0() : prefetchStrategy;
    this.bim_1 = prefetchStrategy;
    this.cim_1 = false;
    this.dim_1 = null;
    this.eim_1 = false;
    this.fim_1 = new LazyGridScrollPosition(firstVisibleItemIndex, firstVisibleItemScrollOffset);
    this.gim_1 = mutableStateOf(get_EmptyLazyGridLayoutInfo(), neverEqualPolicy());
    this.him_1 = funMutableInteractionSource();
    this.iim_1 = 0.0;
    var tmp = this;
    tmp.jim_1 = ScrollableState_0(LazyGridState$scrollableState$lambda(this));
    this.kim_1 = 0;
    this.lim_1 = true;
    this.mim_1 = null;
    var tmp_0 = this;
    tmp_0.nim_1 = new LazyGridState$remeasurementModifier$1(this);
    this.oim_1 = new AwaitFirstLayoutModifier();
    this.pim_1 = new LazyLayoutItemAnimator();
    this.qim_1 = new LazyLayoutBeyondBoundsInfo();
    var tmp_1 = this;
    var tmp_2 = this.bim_1.oih();
    tmp_1.rim_1 = LazyLayoutPrefetchState_init_$Create$(tmp_2, LazyGridState$prefetchState$lambda(this, firstVisibleItemIndex));
    var tmp_3 = this;
    tmp_3.sim_1 = new LazyGridState$prefetchScope$1(this);
    var tmp_4 = this;
    tmp_4.tim_1 = new LazyGridState$_scrollIndicatorState$1(this);
    this.uim_1 = LazyLayoutPinnedItemList_init_$Create$();
    this.vim_1 = this.fim_1.yis_1;
    this.wim_1 = _ObservableScopeInvalidator___init__impl__ism0sl();
    this.xim_1 = _ObservableScopeInvalidator___init__impl__ism0sl();
    this.yim_1 = mutableStateOf(false);
    this.zim_1 = mutableStateOf(false);
    this.ain_1 = new LazyLayoutScrollDeltaBetweenPasses();
  }
  protoOf(LazyGridState).lia = function () {
    return this.fim_1.bi0();
  };
  protoOf(LazyGridState).mia = function () {
    return this.fim_1.kia();
  };
  protoOf(LazyGridState).thz = function () {
    return this.gim_1.u1();
  };
  protoOf(LazyGridState).yif = function () {
    var tmp0 = this.vim_1;
    var tmp = KProperty1;
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('nearestRange', 1, tmp, LazyGridState$_get_nearestRange_$ref_bfrn6w(), null);
    return tmp0.u1();
  };
  protoOf(LazyGridState).mil = function (index, scrollOffset, $completion) {
    return this.qg7(VOID, LazyGridState$scrollToItem$slambda_0(this, index, scrollOffset, null), $completion);
  };
  protoOf(LazyGridState).jiu = function (index, scrollOffset, $completion, $super) {
    scrollOffset = scrollOffset === VOID ? 0 : scrollOffset;
    return $super === VOID ? this.mil(index, scrollOffset, $completion) : $super.mil.call(this, index, scrollOffset, $completion);
  };
  protoOf(LazyGridState).yii = function (index, scrollOffset, forceRemeasure) {
    var positionChanged = !(this.fim_1.bi0() === index) || !(this.fim_1.kia() === scrollOffset);
    if (positionChanged) {
      this.pim_1.u4c();
      var tmp = this.bim_1;
      var tmp0_safe_receiver = tmp instanceof CacheWindowLogic ? tmp : null;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.nil();
      }
    }
    this.fim_1.sii(index, scrollOffset);
    if (forceRemeasure) {
      var tmp1_safe_receiver = this.mim_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.ob8();
      }
    } else {
      ObservableScopeInvalidator__invalidateScope_impl_b202xc(this.xim_1);
    }
  };
  protoOf(LazyGridState).pg7 = function (scrollPriority, block, $completion) {
    var tmp = new $scrollCOROUTINE$_0(this, scrollPriority, block, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyGridState).rg7 = function (delta) {
    return this.jim_1.rg7(delta);
  };
  protoOf(LazyGridState).sg7 = function () {
    return this.jim_1.sg7();
  };
  protoOf(LazyGridState).mg7 = function () {
    var tmp0 = this.yim_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyGridState$_get_canScrollForward_$ref_buq70f();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('canScrollForward', 1, tmp, tmp_0, LazyGridState$_set_canScrollForward_$ref_pssv0r());
    return tmp0.u1();
  };
  protoOf(LazyGridState).ng7 = function () {
    var tmp0 = this.zim_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyGridState$_get_canScrollBackward_$ref_azjnfx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('canScrollBackward', 1, tmp, tmp_0, LazyGridState$_set_canScrollBackward_$ref_4txb09());
    return tmp0.u1();
  };
  protoOf(LazyGridState).cij = function (distance) {
    if (distance < 0 && !this.mg7() || (distance > 0 && !this.ng7())) {
      return 0.0;
    }
    // Inline function 'kotlin.math.abs' call
    var x = this.iim_1;
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(Math.abs(x) <= 0.5)) {
      var tmp$ret$2 = 'entered drag with non-zero pending scroll';
      throwIllegalStateException(tmp$ret$2);
    }
    this.iim_1 = this.iim_1 + distance;
    // Inline function 'kotlin.math.abs' call
    var x_0 = this.iim_1;
    if (Math.abs(x_0) > 0.5) {
      var preScrollToBeConsumed = this.iim_1;
      // Inline function 'kotlin.math.roundToInt' call
      var this_0 = this.iim_1;
      var intDelta = roundToInt(this_0);
      var scrolledLayoutInfo = this.gim_1.u1().hig(intDelta, !this.cim_1);
      if (!(scrolledLayoutInfo == null) && !(this.dim_1 == null)) {
        var tmp0_safe_receiver = this.dim_1;
        var scrolledApproachLayoutInfo = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hig(intDelta, true);
        if (!(scrolledApproachLayoutInfo == null)) {
          this.dim_1 = scrolledApproachLayoutInfo;
        } else {
          scrolledLayoutInfo = null;
        }
      }
      if (!(scrolledLayoutInfo == null)) {
        this.kiu(scrolledLayoutInfo, this.cim_1, true);
        ObservableScopeInvalidator__invalidateScope_impl_b202xc(this.wim_1);
        notifyPrefetchOnScroll_0(this, preScrollToBeConsumed - this.iim_1, scrolledLayoutInfo);
      } else {
        var tmp1_safe_receiver = this.mim_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ob8();
        }
        notifyPrefetchOnScroll_0(this, preScrollToBeConsumed - this.iim_1, this.thz());
      }
    }
    // Inline function 'kotlin.math.abs' call
    var x_1 = this.iim_1;
    if (Math.abs(x_1) <= 0.5) {
      return distance;
    } else {
      var scrollConsumed = distance - this.iim_1;
      this.iim_1 = 0.0;
      return scrollConsumed;
    }
  };
  protoOf(LazyGridState).kiu = function (result, isLookingAhead, visibleItemsStayedTheSame) {
    this.rim_1.kij_1 = result.sip_1.n1();
    if (!isLookingAhead && this.cim_1) {
      this.dim_1 = result;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance_2.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance_2.q52(previousSnapshot);
        try {
          var tmp;
          if (this.ain_1.uil() && result.hip_1 === this.fim_1.kia()) {
            var tmp0_safe_receiver = result.gip_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.air_1;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : firstOrNull_0(tmp1_safe_receiver);
            tmp = (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hir_1) === this.fim_1.bi0();
          } else {
            tmp = false;
          }
          if (tmp) {
            this.ain_1.vil();
          }
          break $l$block;
        }finally {
          Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
        }
      }
    } else {
      if (isLookingAhead) {
        this.cim_1 = true;
      }
      this.iim_1 = this.iim_1 - result.jip_1;
      this.gim_1.s21(result);
      _set_canScrollBackward__6c7ll1_0(this, result.ng7());
      _set_canScrollForward__ffth81_0(this, result.iip_1);
      if (visibleItemsStayedTheSame) {
        this.fim_1.rii(result.hip_1);
      } else {
        this.fim_1.zis(result);
        if (this.lim_1) {
          // Inline function 'kotlin.with' call
          this.bim_1.kis(this.sim_1, result);
        }
      }
      if (isLookingAhead) {
        this.ain_1.til(result.lip_1, result.oip_1, result.nip_1);
      }
      this.kim_1 = this.kim_1 + 1 | 0;
    }
  };
  protoOf(LazyGridState).fip = function (result, isLookingAhead, visibleItemsStayedTheSame, $super) {
    visibleItemsStayedTheSame = visibleItemsStayedTheSame === VOID ? false : visibleItemsStayedTheSame;
    var tmp;
    if ($super === VOID) {
      this.kiu(result, isLookingAhead, visibleItemsStayedTheSame);
      tmp = Unit_instance;
    } else {
      tmp = $super.kiu.call(this, result, isLookingAhead, visibleItemsStayedTheSame);
    }
    return tmp;
  };
  protoOf(LazyGridState).cie = function () {
    return this.ain_1.cie();
  };
  protoOf(LazyGridState).eip = function (itemProvider, firstItemIndex) {
    return this.fim_1.ait(itemProvider, firstItemIndex);
  };
  function rememberLazyGridState(initialFirstVisibleItemIndex, initialFirstVisibleItemScrollOffset, $composer, $changed, $default) {
    _init_properties_LazyGridState_kt__6hut();
    var initialFirstVisibleItemIndex_0 = {_v: initialFirstVisibleItemIndex};
    var initialFirstVisibleItemScrollOffset_0 = {_v: initialFirstVisibleItemScrollOffset};
    var $composer_0 = $composer;
    if (!(($default & 1) === 0)) {
      initialFirstVisibleItemIndex_0._v = 0;
    }
    if (!(($default & 2) === 0)) {
      initialFirstVisibleItemScrollOffset_0._v = 0;
    }
    var tmp = Companion_getInstance_65().hit_1;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.m31(initialFirstVisibleItemIndex_0._v) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.m31(initialFirstVisibleItemScrollOffset_0._v) || ($changed & 48) === 32));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp_0;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = rememberLazyGridState$lambda(initialFirstVisibleItemIndex_0, initialFirstVisibleItemScrollOffset_0);
      $composer_0.j31(value);
      tmp_0 = value;
    } else {
      tmp_0 = it;
    }
    var tmp$ret$0 = tmp_0;
    return rememberSaveable([], tmp, tmp$ret$0, $composer_0, 0);
  }
  function EmptyLazyGridLayoutInfo$1() {
    this.liu_1 = 0;
    this.miu_1 = 0;
    this.niu_1 = emptyMap();
  }
  protoOf(EmptyLazyGridLayoutInfo$1).h5e = function () {
    return this.liu_1;
  };
  protoOf(EmptyLazyGridLayoutInfo$1).i5e = function () {
    return this.miu_1;
  };
  protoOf(EmptyLazyGridLayoutInfo$1).sad = function () {
    return this.niu_1;
  };
  protoOf(EmptyLazyGridLayoutInfo$1).uad = function () {
  };
  function EmptyLazyGridLayoutInfo$lambda(it) {
    _init_properties_LazyGridState_kt__6hut();
    return emptyList();
  }
  function EmptyLazyGridLayoutInfo$lambda_0(it) {
    _init_properties_LazyGridState_kt__6hut();
    return -1;
  }
  function rememberLazyGridState$lambda($initialFirstVisibleItemIndex, $initialFirstVisibleItemScrollOffset) {
    return function () {
      return LazyGridState_init_$Create$($initialFirstVisibleItemIndex._v, $initialFirstVisibleItemScrollOffset._v);
    };
  }
  var properties_initialized_LazyGridState_kt_b7v9uh;
  function _init_properties_LazyGridState_kt__6hut() {
    if (!properties_initialized_LazyGridState_kt_b7v9uh) {
      properties_initialized_LazyGridState_kt_b7v9uh = true;
      var tmp0_measureResult = new EmptyLazyGridLayoutInfo$1();
      var tmp1_visibleItemsInfo = emptyList();
      var tmp2_orientation = Orientation_Vertical_getInstance();
      var tmp3_density = Density_0(1.0);
      var tmp4_coroutineScope = CoroutineScope_0(EmptyCoroutineContext_getInstance());
      var tmp = EmptyLazyGridLayoutInfo$lambda;
      EmptyLazyGridLayoutInfo = new LazyGridMeasureResult(null, 0, false, 0.0, tmp0_measureResult, 0.0, false, tmp4_coroutineScope, tmp3_density, 0, tmp, EmptyLazyGridLayoutInfo$lambda_0, tmp1_visibleItemsInfo, 0, 0, 0, false, tmp2_orientation, 0, 0);
      androidx_compose_foundation_lazy_grid_LazyGridState$stable = 0;
    }
  }
  function rememberLazyGridSemanticState(state, reverseScrolling, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(state) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.l31(reverseScrolling) || ($changed & 48) === 32));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = new rememberLazyGridSemanticState$1(state);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function rememberLazyGridSemanticState$1($state) {
    this.oiu_1 = $state;
  }
  protoOf(rememberLazyGridSemanticState$1).kia = function () {
    return estimatedLazyScrollOffset(this.oiu_1.lia(), this.oiu_1.mia());
  };
  protoOf(rememberLazyGridSemanticState$1).nia = function () {
    return estimatedLazyMaxScrollOffset(this.oiu_1.lia(), this.oiu_1.mia(), this.oiu_1.mg7());
  };
  protoOf(rememberLazyGridSemanticState$1).oia = function (index, $completion) {
    return this.oiu_1.jiu(index, VOID, $completion);
  };
  protoOf(rememberLazyGridSemanticState$1).qia = function () {
    return new CollectionInfo(-1, -1);
  };
  protoOf(rememberLazyGridSemanticState$1).ria = function () {
    var tmp;
    if (this.oiu_1.thz().lhy().equals(Orientation_Vertical_getInstance())) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_0 = this.oiu_1.thz().khy();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      tmp = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = this.oiu_1.thz().khy();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      tmp = convertToInt(shiftRight(value_0, 32));
    }
    return tmp;
  };
  protoOf(rememberLazyGridSemanticState$1).sia = function () {
    return this.oiu_1.thz().yhz() + this.oiu_1.thz().zhz() | 0;
  };
  var androidx_compose_foundation_lazy_layout_AwaitFirstLayoutModifier$stable;
  function AwaitFirstLayoutModifier$Node$requestOnAfterLayoutCallback$lambda(this$0, this$1) {
    return function (it) {
      var tmp0_safe_receiver = this$0.div_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.n7o();
      }
      this$0.div_1 = null;
      var tmp1_safe_receiver = this$1.zik_1;
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver.u1g(Unit_instance);
      this$1.zik_1 = null;
      return Unit_instance;
    };
  }
  function Node_0($outer) {
    this.eiv_1 = $outer;
    Node.call(this);
    this.div_1 = null;
  }
  protoOf(Node_0).f8w = function () {
    this.eiv_1.yik_1 = this;
    if (!(this.eiv_1.zik_1 == null)) {
      this.fiv();
    }
  };
  protoOf(Node_0).fiv = function () {
    var tmp = this;
    var tmp_0 = new Long(0, 0);
    var tmp_1 = new Long(0, 0);
    tmp.div_1 = registerOnLayoutRectChanged(this, tmp_0, tmp_1, AwaitFirstLayoutModifier$Node$requestOnAfterLayoutCallback$lambda(this, this.eiv_1));
  };
  protoOf(Node_0).h8w = function () {
    if (this.eiv_1.yik_1 === this) {
      this.eiv_1.yik_1 = null;
    }
    var tmp0_safe_receiver = this.div_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.n7o();
    }
    this.div_1 = null;
  };
  function AwaitFirstLayoutModifier() {
    ModifierNodeElement.call(this);
    this.yik_1 = null;
    this.zik_1 = null;
  }
  protoOf(AwaitFirstLayoutModifier).ail = function ($completion) {
    var tmp0_elvis_lhs = this.zik_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = CompletableDeferred();
      this.zik_1 = this_0;
      var node = this.yik_1;
      if (!(node == null) && node.z8v_1) {
        node.fiv();
      }
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var lock = tmp;
    return lock.r1c($completion);
  };
  protoOf(AwaitFirstLayoutModifier).r3d = function () {
    return new Node_0(this);
  };
  protoOf(AwaitFirstLayoutModifier).giv = function (node) {
  };
  protoOf(AwaitFirstLayoutModifier).d8y = function (node) {
    return this.giv(node instanceof Node_0 ? node : THROW_CCE());
  };
  protoOf(AwaitFirstLayoutModifier).hashCode = function () {
    return 234;
  };
  protoOf(AwaitFirstLayoutModifier).equals = function (other) {
    return other === this;
  };
  var androidx_compose_foundation_lazy_layout_CacheWindowLogic$stable;
  var androidx_compose_foundation_lazy_layout_CachedItem$stable;
  function traceWindowInfo($this) {
    traceValue('prefetchWindowStartExtraSpace', fromInt($this.qib_1));
    traceValue('prefetchWindowEndExtraSpace', fromInt($this.rib_1));
    traceValue('prefetchWindowStartIndex', fromInt($this.oib_1));
    traceValue('prefetchWindowEndIndex', fromInt($this.pib_1));
  }
  function onDatasetChanged($this, $receiver) {
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$1 = 'Total Items Changed';
      println('CacheWindowLogic: ' + tmp$ret$1);
    }
    $this.sib_1 = true;
    if ($receiver.yie()) {
      $this.oib_1 = coerceAtLeast_0($this.oib_1, 0);
      var lastLineIndex = $receiver.hiv();
      if (!(lastLineIndex === -1)) {
        $this.pib_1 = coerceAtMost($this.pib_1, lastLineIndex);
      }
      if ($this.lib_1 <= 0.0) {
        removeOutOfBoundsItems($this, $receiver.jiv(), $this.tib_1 - 1 | 0);
      } else {
        removeOutOfBoundsItems($this, 0, $receiver.iiv());
      }
    }
  }
  function onDatasetChangedWithoutFix($this, $receiver) {
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$1 = 'Total Items Changed';
      println('CacheWindowLogic: ' + tmp$ret$1);
    }
    $this.sib_1 = true;
    $this.oib_1 = coerceAtLeast_0($this.oib_1, 0);
    var lastLineIndex = $receiver.hiv();
    if (!(lastLineIndex === -1)) {
      $this.pib_1 = coerceAtMost($this.pib_1, lastLineIndex);
    }
    removeOutOfBoundsItems($this, $this.pib_1, $this.tib_1 - 1 | 0);
  }
  function fillCacheWindowBackward($this, $receiver, delta) {
    if ($receiver.yie()) {
      var viewport = $receiver.kiv();
      // Inline function 'kotlin.with' call
      var $this$with = $this.fib_1;
      var tmp0_safe_receiver = $receiver.u5e();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : $this$with.liv(tmp0_safe_receiver, viewport);
      var keepAroundWindow = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      $this.tib_1 = $receiver.ci0();
      // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
      if (false) {
        var tmp$ret$3 = 'fillCacheWindowBackward visibleWindowStart=' + $receiver.iiv() + ' \n' + ('visibleWindowEnd=' + $receiver.jiv() + ' \n') + ('keepAroundWindow=' + keepAroundWindow + ' \n') + ('mainAxisExtraSpaceStart=' + $receiver.miv() + ' \n') + ('mainAxisExtraSpaceEnd=' + $receiver.niv() + ' \n');
        println('CacheWindowLogic: ' + tmp$ret$3);
      }
      var tmp0_visibleWindowStart = $receiver.iiv();
      var tmp1_visibleWindowEnd = $receiver.jiv();
      var tmp2_itemsCount = $receiver.ci0();
      var tmp3_mainAxisExtraSpaceStart = $receiver.miv();
      var tmp4_mainAxisExtraSpaceEnd = $receiver.niv();
      onKeepAround($this, tmp0_visibleWindowStart, tmp1_visibleWindowEnd, tmp4_mainAxisExtraSpaceEnd, tmp3_mainAxisExtraSpaceStart, keepAroundWindow, delta, tmp2_itemsCount);
    }
  }
  function fillCacheWindowForward($this, $receiver, delta) {
    if ($receiver.yie()) {
      var viewport = $receiver.kiv();
      // Inline function 'kotlin.with' call
      var $this$with = $this.fib_1;
      var tmp0_safe_receiver = $receiver.u5e();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : $this$with.oiv(tmp0_safe_receiver, viewport);
      var prefetchForwardWindow = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
      if (false) {
        var tmp$ret$3 = 'fillCacheWindowForward visibleWindowStart=' + $receiver.iiv() + ' \n' + ('visibleWindowEnd=' + $receiver.jiv() + ' \n') + ('prefetchForwardWindow=' + prefetchForwardWindow + ' \n') + ('mainAxisExtraSpaceStart=' + $receiver.miv() + ' \n') + ('mainAxisExtraSpaceEnd=' + $receiver.niv() + ' \n');
        println('CacheWindowLogic: ' + tmp$ret$3);
      }
      var tmp0_visibleWindowStart = $receiver.iiv();
      var tmp1_visibleWindowEnd = $receiver.jiv();
      var tmp2_mainAxisExtraSpaceStart = $receiver.miv();
      var tmp3_mainAxisExtraSpaceEnd = $receiver.niv();
      var tmp4_applyForwardPrefetch = delta <= 0.0;
      onPrefetchForward($this, $receiver, tmp0_visibleWindowStart, tmp1_visibleWindowEnd, prefetchForwardWindow, tmp3_mainAxisExtraSpaceEnd, tmp2_mainAxisExtraSpaceStart, delta, tmp4_applyForwardPrefetch);
    }
  }
  function refillWindow($this, $receiver, refillForward) {
    if ($receiver.yie()) {
      var viewport = $receiver.kiv();
      // Inline function 'kotlin.with' call
      var $this$with = $this.fib_1;
      var tmp0_safe_receiver = $receiver.u5e();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : $this$with.oiv(tmp0_safe_receiver, viewport);
      var prefetchForwardWindow = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp0_visibleWindowStart = $receiver.iiv();
      var tmp1_visibleWindowEnd = $receiver.jiv();
      var tmp2_mainAxisExtraSpaceStart = $receiver.miv();
      var tmp3_mainAxisExtraSpaceEnd = $receiver.niv();
      onPrefetchForward($this, $receiver, tmp0_visibleWindowStart, tmp1_visibleWindowEnd, prefetchForwardWindow, tmp3_mainAxisExtraSpaceEnd, tmp2_mainAxisExtraSpaceStart, 0.0, refillForward);
    }
  }
  function onPrefetchForward($this, $receiver, visibleWindowStart, visibleWindowEnd, prefetchForwardWindow, mainAxisExtraSpaceEnd, mainAxisExtraSpaceStart, scrollDelta, applyForwardPrefetch) {
    // Inline function 'kotlin.math.sign' call
    var tmp = sign(scrollDelta);
    // Inline function 'kotlin.math.sign' call
    var this_0 = $this.lib_1;
    var changedScrollDirection = !(tmp === sign(this_0));
    if (applyForwardPrefetch) {
      if (changedScrollDirection || $this.sib_1) {
        $this.rib_1 = prefetchForwardWindow - mainAxisExtraSpaceEnd | 0;
        $this.pib_1 = visibleWindowEnd;
      } else {
        var tmp_0 = $this;
        var tmp_1 = $this.rib_1;
        // Inline function 'kotlin.math.absoluteValue' call
        // Inline function 'kotlin.math.roundToInt' call
        var this_1 = Math.abs(scrollDelta);
        var tmp$ret$3 = roundToInt(this_1);
        tmp_0.rib_1 = coerceAtMost(tmp_1 + tmp$ret$3 | 0, prefetchForwardWindow - mainAxisExtraSpaceEnd | 0);
      }
      $l$loop: while ($this.rib_1 > 0 && !($receiver.piv($this.pib_1) === -1) && $receiver.piv($this.pib_1) < ($this.tib_1 - 1 | 0)) {
        var tmp_2;
        if (ComposeFoundationFlags_instance.nfg_1) {
          tmp_2 = !(scrollDelta === 0.0);
        } else {
          tmp_2 = true;
        }
        var scrollDeltaCheck = tmp_2;
        var tmp_3;
        if (($this.pib_1 + 1 | 0) === (visibleWindowEnd + 1 | 0) && scrollDeltaCheck) {
          // Inline function 'kotlin.math.absoluteValue' call
          tmp_3 = Math.abs(scrollDelta) >= mainAxisExtraSpaceEnd;
        } else {
          tmp_3 = false;
        }
        var isUrgent = tmp_3;
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$6 = 'getItemSizeOrPrefetch item=' + ($this.pib_1 + 1 | 0) + ' isUrgent=' + isUrgent;
          println('CacheWindowLogic: ' + tmp$ret$6);
        }
        var itemSize = getItemSizeOrPrefetch($this, $receiver, $this.pib_1 + 1 | 0, isUrgent);
        if (itemSize === -1)
          break $l$loop;
        $this.pib_1 = $this.pib_1 + 1 | 0;
        $this.rib_1 = $this.rib_1 - itemSize | 0;
      }
    } else {
      if (changedScrollDirection || $this.sib_1) {
        $this.qib_1 = prefetchForwardWindow - mainAxisExtraSpaceStart | 0;
        $this.oib_1 = visibleWindowStart;
      } else {
        var tmp_4 = $this;
        var tmp_5 = $this.qib_1;
        // Inline function 'kotlin.math.absoluteValue' call
        // Inline function 'kotlin.math.roundToInt' call
        var this_2 = Math.abs(scrollDelta);
        var tmp$ret$8 = roundToInt(this_2);
        tmp_4.qib_1 = coerceAtMost(tmp_5 + tmp$ret$8 | 0, prefetchForwardWindow - mainAxisExtraSpaceStart | 0);
      }
      $l$loop_0: while ($this.qib_1 > 0 && $this.oib_1 > 0) {
        var tmp_6;
        if (ComposeFoundationFlags_instance.nfg_1) {
          tmp_6 = !(scrollDelta === 0.0);
        } else {
          tmp_6 = true;
        }
        var scrollDeltaCheck_0 = tmp_6;
        var tmp_7;
        if (($this.oib_1 - 1 | 0) === (visibleWindowStart - 1 | 0) && scrollDeltaCheck_0) {
          // Inline function 'kotlin.math.absoluteValue' call
          tmp_7 = Math.abs(scrollDelta) >= mainAxisExtraSpaceStart;
        } else {
          tmp_7 = false;
        }
        var isUrgent_0 = tmp_7;
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$11 = 'getItemSizeOrPrefetch item=' + ($this.pib_1 + 1 | 0) + ' isUrgent=' + isUrgent_0;
          println('CacheWindowLogic: ' + tmp$ret$11);
        }
        var itemSize_0 = getItemSizeOrPrefetch($this, $receiver, $this.oib_1 - 1 | 0, isUrgent_0);
        if (itemSize_0 === -1)
          break $l$loop_0;
        $this.oib_1 = $this.oib_1 - 1 | 0;
        $this.qib_1 = $this.qib_1 - itemSize_0 | 0;
      }
    }
  }
  function onKeepAround($this, visibleWindowStart, visibleWindowEnd, mainAxisExtraSpaceEnd, mainAxisExtraSpaceStart, keepAroundWindow, scrollDelta, itemsCount) {
    if (scrollDelta <= 0.0) {
      $this.qib_1 = keepAroundWindow - mainAxisExtraSpaceStart | 0;
      $this.oib_1 = visibleWindowStart;
      $l$loop_0: while ($this.qib_1 > 0 && $this.oib_1 > 0) {
        var tmp;
        if (ComposeFoundationFlags_instance.nfg_1) {
          var tmp_0;
          if ($this.kib_1.hv($this.oib_1 - 1 | 0)) {
            tmp_0 = ensureNotNull($this.kib_1.l1($this.oib_1 - 1 | 0)).riv_1;
          } else {
            break $l$loop_0;
          }
          tmp = tmp_0;
        } else {
          var tmp_1;
          if ($this.jib_1.hv($this.oib_1 - 1 | 0)) {
            tmp_1 = $this.jib_1.l1($this.oib_1 - 1 | 0);
          } else {
            break $l$loop_0;
          }
          tmp = tmp_1;
        }
        var item = tmp;
        $this.oib_1 = $this.oib_1 - 1 | 0;
        $this.qib_1 = $this.qib_1 - item | 0;
      }
      removeOutOfBoundsItems($this, 0, $this.oib_1 - 1 | 0);
    } else {
      $this.rib_1 = keepAroundWindow - mainAxisExtraSpaceEnd | 0;
      $this.pib_1 = visibleWindowEnd;
      $l$loop_2: while ($this.rib_1 > 0 && $this.pib_1 < (itemsCount - 1 | 0)) {
        var tmp_2;
        if (ComposeFoundationFlags_instance.nfg_1) {
          var tmp_3;
          if ($this.kib_1.hv($this.pib_1 + 1 | 0)) {
            tmp_3 = ensureNotNull($this.kib_1.l1($this.pib_1 + 1 | 0)).riv_1;
          } else {
            break $l$loop_2;
          }
          tmp_2 = tmp_3;
        } else {
          var tmp_4;
          if ($this.jib_1.hv($this.pib_1 + 1 | 0)) {
            tmp_4 = $this.jib_1.l1($this.pib_1 + 1 | 0);
          } else {
            break $l$loop_2;
          }
          tmp_2 = tmp_4;
        }
        var item_0 = tmp_2;
        $this.pib_1 = $this.pib_1 + 1 | 0;
        $this.rib_1 = $this.rib_1 - item_0 | 0;
      }
      removeOutOfBoundsItems($this, $this.pib_1 + 1 | 0, itemsCount - 1 | 0);
    }
  }
  function getItemSizeOrPrefetch($this, $receiver, index, isUrgent) {
    var tmp;
    if (ComposeFoundationFlags_instance.nfg_1) {
      var tmp_0;
      if ($this.kib_1.hv(index)) {
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$1 = 'Item ' + index + ' is Cached!';
          println('CacheWindowLogic: ' + tmp$ret$1);
        }
        tmp_0 = ensureNotNull($this.kib_1.l1(index)).riv_1;
      } else if ($this.hib_1.hv(index)) {
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$3 = 'Item=' + index + ' is already scheduled. isUrgent=' + isUrgent;
          println('CacheWindowLogic: ' + tmp$ret$3);
        }
        if (isUrgent) {
          var tmp0_safe_receiver = $this.hib_1.l1(index);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'androidx.compose.ui.util.fastForEach' call
            var inductionVariable = 0;
            var last = tmp0_safe_receiver.n1() - 1 | 0;
            if (inductionVariable <= last)
              do {
                var index_0 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var item = tmp0_safe_receiver.l1(index_0);
                item.cii();
              }
               while (inductionVariable <= last);
          }
        }
        tmp_0 = -1;
      } else {
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$7 = 'Scheduling Prefetching for Item=' + index + '. isUrgent=' + isUrgent;
          println('CacheWindowLogic: ' + tmp$ret$7);
        }
        $this.hib_1.ew(index, $receiver.siv(index, CacheWindowLogic$getItemSizeOrPrefetch$lambda($this, $receiver)));
        if (isUrgent) {
          var tmp1_safe_receiver = $this.hib_1.l1(index);
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'androidx.compose.ui.util.fastForEach' call
            var inductionVariable_0 = 0;
            var last_0 = tmp1_safe_receiver.n1() - 1 | 0;
            if (inductionVariable_0 <= last_0)
              do {
                var index_1 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var item_0 = tmp1_safe_receiver.l1(index_1);
                item_0.cii();
              }
               while (inductionVariable_0 <= last_0);
          }
        }
        tmp_0 = -1;
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if ($this.jib_1.hv(index)) {
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$11 = 'Item ' + index + ' is Cached!';
          println('CacheWindowLogic: ' + tmp$ret$11);
        }
        tmp_1 = $this.jib_1.l1(index);
      } else if ($this.hib_1.hv(index)) {
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$13 = 'Item=' + index + ' is already scheduled. isUrgent=' + isUrgent;
          println('CacheWindowLogic: ' + tmp$ret$13);
        }
        if (isUrgent) {
          var tmp2_safe_receiver = $this.hib_1.l1(index);
          if (tmp2_safe_receiver == null)
            null;
          else {
            // Inline function 'androidx.compose.ui.util.fastForEach' call
            var inductionVariable_1 = 0;
            var last_1 = tmp2_safe_receiver.n1() - 1 | 0;
            if (inductionVariable_1 <= last_1)
              do {
                var index_2 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var item_1 = tmp2_safe_receiver.l1(index_2);
                item_1.cii();
              }
               while (inductionVariable_1 <= last_1);
          }
        }
        tmp_1 = -1;
      } else {
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$17 = 'Scheduling Prefetching for Item=' + index + '. isUrgent=' + isUrgent;
          println('CacheWindowLogic: ' + tmp$ret$17);
        }
        $this.hib_1.ew(index, $receiver.siv(index, CacheWindowLogic$getItemSizeOrPrefetch$lambda_0($this, $receiver)));
        if (isUrgent) {
          var tmp3_safe_receiver = $this.hib_1.l1(index);
          if (tmp3_safe_receiver == null)
            null;
          else {
            // Inline function 'androidx.compose.ui.util.fastForEach' call
            var inductionVariable_2 = 0;
            var last_2 = tmp3_safe_receiver.n1() - 1 | 0;
            if (inductionVariable_2 <= last_2)
              do {
                var index_3 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var item_2 = tmp3_safe_receiver.l1(index_3);
                item_2.cii();
              }
               while (inductionVariable_2 <= last_2);
          }
        }
        tmp_1 = -1;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function cachePrefetchedItem($this, index, size) {
    if (ComposeFoundationFlags_instance.nfg_1) {
      $this.kib_1.ew(index, updateOrCreateCachedItem($this, index, size, NoKey_instance));
    } else {
      $this.jib_1.zu(index, size);
    }
    if (index > $this.pib_1) {
      $this.pib_1 = index;
      $this.rib_1 = $this.rib_1 - size | 0;
    } else if (index < $this.oib_1) {
      $this.oib_1 = index;
      $this.qib_1 = $this.qib_1 - size | 0;
    }
  }
  function updateOrCreateCachedItem($this, index, size, key) {
    var cachedItem = $this.kib_1.l1(index);
    var tmp;
    if (!(cachedItem == null)) {
      cachedItem.riv_1 = size;
      cachedItem.qiv_1 = key;
      tmp = cachedItem;
    } else {
      tmp = new CachedItem(key, size);
    }
    return tmp;
  }
  function cacheVisibleItemsInfo($this, index, key, size) {
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$1 = 'cacheVisibleItemsInfo item=' + index + ' size=' + size + ' key=' + toString(key);
      println('CacheWindowLogic: ' + tmp$ret$1);
    }
    if ($this.kib_1.hv(index)) {
      var cachedSize = ensureNotNull($this.kib_1.l1(index)).riv_1;
      var cachedKey = ensureNotNull($this.kib_1.l1(index)).qiv_1;
      if (!(cachedSize === size) || !equals(cachedKey, key)) {
        $this.sib_1 = true;
      }
    }
    $this.kib_1.ew(index, updateOrCreateCachedItem($this, index, size, key));
    var tmp = $this;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = $this.oib_1;
    tmp.oib_1 = Math.min(a, index);
    var tmp_0 = $this;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.pib_1;
    tmp_0.pib_1 = Math.max(a_0, index);
    var tmp0_safe_receiver = $this.hib_1.gw(index);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0_safe_receiver.l1(index_0);
          item.e2z();
        }
         while (inductionVariable <= last);
    }
  }
  function cacheVisibleItemsInfoWithoutFix($this, index, size) {
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$1 = 'cacheVisibleItemsInfo item=' + index + ' size=' + size;
      println('CacheWindowLogic: ' + tmp$ret$1);
    }
    if ($this.jib_1.hv(index) && !($this.jib_1.l1(index) === size)) {
      $this.sib_1 = true;
    }
    $this.jib_1.zu(index, size);
    var tmp = $this;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = $this.oib_1;
    tmp.oib_1 = Math.min(a, index);
    var tmp_0 = $this;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.pib_1;
    tmp_0.pib_1 = Math.max(a_0, index);
    var tmp0_safe_receiver = $this.hib_1.gw(index);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0_safe_receiver.l1(index_0);
          item.e2z();
        }
         while (inductionVariable <= last);
    }
  }
  function removeOutOfBoundsItems($this, startLine, endLine) {
    $this.iib_1.c3();
    // Inline function 'androidx.collection.IntObjectMap.forEachKey' call
    var this_0 = $this.hib_1;
    var k = this_0.uv_1;
    $l$block: {
      // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
      var m = this_0.tv_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var it = k[index];
                  if (startLine <= it ? it <= endLine : false) {
                    $this.iib_1.pv(it);
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    // Inline function 'androidx.collection.IntIntMap.forEachKey' call
    var this_2 = $this.jib_1;
    var k_0 = this_2.ou_1;
    $l$block_0: {
      // Inline function 'androidx.collection.IntIntMap.forEachIndexed' call
      var m_0 = this_2.nu_1;
      var lastIndex_0 = m_0.length - 2 | 0;
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= lastIndex_0)
        do {
          var i_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var slot_0 = m_0[i_0];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_3 = slot_0;
          var tmp$ret$8 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$8, new Long(-2139062144, -2139062144))) {
            var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < bitCount_0)
              do {
                var j_0 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                if (compare(value_0, new Long(128, 0)) < 0) {
                  var index_0 = (i_0 << 3) + j_0 | 0;
                  var it_0 = k_0[index_0];
                  if (startLine <= it_0 ? it_0 <= endLine : false) {
                    $this.iib_1.pv(it_0);
                  }
                }
                slot_0 = shiftRight(slot_0, 8);
              }
               while (inductionVariable_2 < bitCount_0);
            if (!(bitCount_0 === 8)) {
              break $l$block_0;
            }
          }
        }
         while (!(i_0 === lastIndex_0));
    }
    // Inline function 'androidx.collection.IntObjectMap.forEachKey' call
    var this_4 = $this.kib_1;
    var k_1 = this_4.uv_1;
    $l$block_1: {
      // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
      var m_1 = this_4.tv_1;
      var lastIndex_1 = m_1.length - 2 | 0;
      var inductionVariable_3 = 0;
      if (inductionVariable_3 <= lastIndex_1)
        do {
          var i_1 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var slot_1 = m_1[i_1];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_5 = slot_1;
          var tmp$ret$14 = bitwiseAnd(bitwiseAnd(this_5, shiftLeft(invert(this_5), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$14, new Long(-2139062144, -2139062144))) {
            var bitCount_1 = 8 - (~(i_1 - lastIndex_1 | 0) >>> 31 | 0) | 0;
            var inductionVariable_4 = 0;
            if (inductionVariable_4 < bitCount_1)
              do {
                var j_1 = inductionVariable_4;
                inductionVariable_4 = inductionVariable_4 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value_1 = bitwiseAnd(slot_1, new Long(255, 0));
                if (compare(value_1, new Long(128, 0)) < 0) {
                  var index_1 = (i_1 << 3) + j_1 | 0;
                  var it_1 = k_1[index_1];
                  if (startLine <= it_1 ? it_1 <= endLine : false) {
                    $this.iib_1.pv(it_1);
                  }
                }
                slot_1 = shiftRight(slot_1, 8);
              }
               while (inductionVariable_4 < bitCount_1);
            if (!(bitCount_1 === 8)) {
              break $l$block_1;
            }
          }
        }
         while (!(i_1 === lastIndex_1));
    }
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$19 = 'Indices to remove=' + $this.iib_1.toString();
      println('CacheWindowLogic: ' + tmp$ret$19);
    }
    // Inline function 'androidx.collection.IntSet.forEach' call
    var this_6 = $this.iib_1;
    // Inline function 'kotlin.contracts.contract' call
    var k_2 = this_6.jw_1;
    $l$block_2: {
      // Inline function 'androidx.collection.IntSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m_2 = this_6.iw_1;
      var lastIndex_2 = m_2.length - 2 | 0;
      var inductionVariable_5 = 0;
      if (inductionVariable_5 <= lastIndex_2)
        do {
          var i_2 = inductionVariable_5;
          inductionVariable_5 = inductionVariable_5 + 1 | 0;
          var slot_2 = m_2[i_2];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_7 = slot_2;
          var tmp$ret$24 = bitwiseAnd(bitwiseAnd(this_7, shiftLeft(invert(this_7), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$24, new Long(-2139062144, -2139062144))) {
            var bitCount_2 = 8 - (~(i_2 - lastIndex_2 | 0) >>> 31 | 0) | 0;
            var inductionVariable_6 = 0;
            if (inductionVariable_6 < bitCount_2)
              do {
                var j_2 = inductionVariable_6;
                inductionVariable_6 = inductionVariable_6 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value_2 = bitwiseAnd(slot_2, new Long(255, 0));
                if (compare(value_2, new Long(128, 0)) < 0) {
                  var index_2 = (i_2 << 3) + j_2 | 0;
                  var it_2 = k_2[index_2];
                  var tmp0_safe_receiver = $this.hib_1.gw(it_2);
                  if (tmp0_safe_receiver == null)
                    null;
                  else {
                    // Inline function 'androidx.compose.ui.util.fastForEach' call
                    var inductionVariable_7 = 0;
                    var last = tmp0_safe_receiver.n1() - 1 | 0;
                    if (inductionVariable_7 <= last)
                      do {
                        var index_3 = inductionVariable_7;
                        inductionVariable_7 = inductionVariable_7 + 1 | 0;
                        var item = tmp0_safe_receiver.l1(index_3);
                        item.e2z();
                      }
                       while (inductionVariable_7 <= last);
                  }
                  $this.jib_1.av(it_2);
                  $this.kib_1.gw(it_2);
                }
                slot_2 = shiftRight(slot_2, 8);
              }
               while (inductionVariable_6 < bitCount_2);
            if (!(bitCount_2 === 8)) {
              break $l$block_2;
            }
          }
        }
         while (!(i_2 === lastIndex_2));
    }
  }
  function onItemPrefetched($this, $receiver, index, itemSize) {
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$1 = 'onItemPrefetched item=' + index + ' size=' + itemSize;
      println('CacheWindowLogic: ' + tmp$ret$1);
    }
    cachePrefetchedItem($this, index, itemSize);
    scheduleNextItemIfNeeded($this, $receiver);
    traceWindowInfo($this);
  }
  function scheduleNextItemIfNeeded($this, $receiver) {
    var nextPrefetchableLineIndex = -1;
    // Inline function 'kotlin.math.sign' call
    var this_0 = $this.lib_1;
    if (sign(this_0) <= 0) {
      if ($this.rib_1 > 0)
        nextPrefetchableLineIndex = $this.pib_1 + 1 | 0;
    } else {
      // Inline function 'kotlin.math.sign' call
      var this_1 = $this.lib_1;
      if (sign(this_1) > 0) {
        if ($this.qib_1 > 0)
          nextPrefetchableLineIndex = $this.oib_1 - 1 | 0;
      }
    }
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$3 = 'nextPrefetchableLineIndex=' + nextPrefetchableLineIndex;
      println('CacheWindowLogic: ' + tmp$ret$3);
    }
    if (nextPrefetchableLineIndex > 0 && !($receiver.piv(nextPrefetchableLineIndex) === -1) && $receiver.piv(nextPrefetchableLineIndex) < $this.tib_1) {
      var tmp = nextPrefetchableLineIndex;
      var tmp_0 = nextPrefetchableLineIndex;
      $this.hib_1.ew(tmp, $receiver.siv(tmp_0, CacheWindowLogic$scheduleNextItemIfNeeded$lambda($this, $receiver)));
    }
  }
  function CacheWindowLogic$getItemSizeOrPrefetch$lambda(this$0, $this_getItemSizeOrPrefetch) {
    return function (prefetchedIndex, size) {
      onItemPrefetched(this$0, $this_getItemSizeOrPrefetch, prefetchedIndex, size);
      return Unit_instance;
    };
  }
  function CacheWindowLogic$getItemSizeOrPrefetch$lambda_0(this$0, $this_getItemSizeOrPrefetch) {
    return function (prefetchedIndex, size) {
      onItemPrefetched(this$0, $this_getItemSizeOrPrefetch, prefetchedIndex, size);
      return Unit_instance;
    };
  }
  function CacheWindowLogic$scheduleNextItemIfNeeded$lambda(this$0, $this_scheduleNextItemIfNeeded) {
    return function (index, mainAxisSize) {
      onItemPrefetched(this$0, $this_scheduleNextItemIfNeeded, index, mainAxisSize);
      return Unit_instance;
    };
  }
  function CacheWindowLogic(cacheWindow, enableInitialPrefetch) {
    enableInitialPrefetch = enableInitialPrefetch === VOID ? true : enableInitialPrefetch;
    this.fib_1 = cacheWindow;
    this.gib_1 = enableInitialPrefetch;
    this.hib_1 = mutableIntObjectMapOf();
    this.iib_1 = mutableIntSetOf();
    this.jib_1 = mutableIntIntMapOf();
    this.kib_1 = mutableIntObjectMapOf();
    this.lib_1 = 0.0;
    this.mib_1 = -1;
    this.nib_1 = false;
    this.oib_1 = 2147483647;
    this.pib_1 = -2147483648;
    this.qib_1 = 0;
    this.rib_1 = 0;
    this.sib_1 = false;
    this.tib_1 = 0;
  }
  protoOf(CacheWindowLogic).tiv = function (_this__u8e3s4, delta) {
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$1 = 'delta=' + delta;
      println('CacheWindowLogic: ' + tmp$ret$1);
    }
    traceWindowInfo(this);
    fillCacheWindowBackward(this, _this__u8e3s4, delta);
    fillCacheWindowForward(this, _this__u8e3s4, delta);
    this.lib_1 = delta;
    traceWindowInfo(this);
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$3 = 'prefetchWindowStartExtraSpace=' + this.qib_1 + '\n' + ('prefetchWindowEndExtraSpace=' + this.rib_1 + '\n') + ('prefetchWindowStartIndex=' + this.oib_1 + '\n') + ('prefetchWindowEndIndex=' + this.pib_1);
      println('CacheWindowLogic: ' + tmp$ret$3);
    }
  };
  protoOf(CacheWindowLogic).uiv = function (_this__u8e3s4) {
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$1 = 'hasUpdatedVisibleItemsOnce=' + this.nib_1;
      println('CacheWindowLogic: ' + tmp$ret$1);
    }
    if (!this.nib_1 && this.gib_1) {
      // Inline function 'kotlin.with' call
      var $this$with = this.fib_1;
      var tmp0_safe_receiver = _this__u8e3s4.u5e();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : $this$with.oiv(tmp0_safe_receiver, _this__u8e3s4.kiv());
      var prefetchForwardWindow = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      if (!(prefetchForwardWindow === 0))
        this.sib_1 = true;
      this.nib_1 = true;
    }
    if (!(this.mib_1 === -1) && !(this.mib_1 === _this__u8e3s4.ci0())) {
      if (ComposeFoundationFlags_instance.nfg_1) {
        onDatasetChanged(this, _this__u8e3s4);
      } else {
        onDatasetChangedWithoutFix(this, _this__u8e3s4);
      }
    }
    this.tib_1 = _this__u8e3s4.ci0();
    if (_this__u8e3s4.yie()) {
      // Inline function 'androidx.compose.foundation.lazy.layout.forEachVisibleItem' call
      // Inline function 'kotlin.repeat' call
      var times = _this__u8e3s4.viv();
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0 = _this__u8e3s4.wiv(index);
          var tmp2 = _this__u8e3s4.xiv(index);
          var mainAxisSize = _this__u8e3s4.yiv(index);
          if (ComposeFoundationFlags_instance.nfg_1) {
            if (!(tmp0 === -1)) {
              cacheVisibleItemsInfo(this, tmp0, tmp2, mainAxisSize);
            }
          } else {
            if (!(tmp0 === -1)) {
              cacheVisibleItemsInfoWithoutFix(this, tmp0, mainAxisSize);
            }
          }
        }
         while (inductionVariable < times);
      if (this.sib_1) {
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$9 = 'Refill Window Forward=' + (this.lib_1 <= 0.0);
          println('CacheWindowLogic: ' + tmp$ret$9);
        }
        refillWindow(this, _this__u8e3s4, this.lib_1 <= 0.0);
        this.sib_1 = false;
      }
    } else {
      this.nil();
    }
    this.mib_1 = _this__u8e3s4.ci0();
  };
  protoOf(CacheWindowLogic).uib = function () {
    return !(this.oib_1 === 2147483647) && !(this.pib_1 === -2147483648);
  };
  protoOf(CacheWindowLogic).nil = function () {
    this.oib_1 = 2147483647;
    this.pib_1 = -2147483648;
    this.qib_1 = 0;
    this.rib_1 = 0;
    this.sib_1 = false;
    this.jib_1.c3();
    this.kib_1.c3();
    // Inline function 'androidx.collection.MutableIntObjectMap.removeIf' call
    var this_0 = this.hib_1;
    $l$block: {
      // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
      var m = this_0.tv_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  this_0.uv_1[index];
                  // Inline function 'androidx.compose.ui.util.fastForEach' call
                  var this_2 = this_0.vv_1[index];
                  var inductionVariable_1 = 0;
                  var last = this_2.n1() - 1 | 0;
                  if (inductionVariable_1 <= last)
                    do {
                      var index_0 = inductionVariable_1;
                      inductionVariable_1 = inductionVariable_1 + 1 | 0;
                      var item = this_2.l1(index_0);
                      item.e2z();
                    }
                     while (inductionVariable_1 <= last);
                  if (true) {
                    this_0.hw(index);
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
  };
  function NoKey() {
  }
  var NoKey_instance;
  function NoKey_getInstance() {
    return NoKey_instance;
  }
  function CachedItem(key, mainAxisSize) {
    this.qiv_1 = key;
    this.riv_1 = mainAxisSize;
  }
  protoOf(CachedItem).toString = function () {
    return 'CachedItem(key=' + toString(this.qiv_1) + ', mainAxisSize=' + this.riv_1 + ')';
  };
  var androidx_compose_foundation_lazy_layout_IntervalList_Interval$stable;
  var androidx_compose_foundation_lazy_layout_MutableIntervalList$stable;
  function getIntervalForIndex($this, itemIndex) {
    var lastInterval = $this.hif_1;
    var tmp;
    if (!(lastInterval == null) && contains($this, lastInterval, itemIndex)) {
      tmp = lastInterval;
    } else {
      var tmp0 = $this.fif_1;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
      var index = binarySearch_0($this.fif_1, itemIndex);
      // Inline function 'kotlin.also' call
      var this_0 = tmp0.b3e_1[index];
      $this.hif_1 = this_0;
      tmp = this_0;
    }
    return tmp;
  }
  function contains($this, $receiver, index) {
    var containsLower = $receiver.tif_1;
    return index < ($receiver.tif_1 + $receiver.uif_1 | 0) ? containsLower <= index : false;
  }
  function MutableIntervalList() {
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.fif_1 = new MutableVector(tmp$ret$2, 0);
    this.gif_1 = 0;
    this.hif_1 = null;
  }
  protoOf(MutableIntervalList).n1 = function () {
    return this.gif_1;
  };
  protoOf(MutableIntervalList).iif = function (size, value) {
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(size >= 0)) {
      var tmp$ret$1 = 'size should be >=0';
      throwIllegalArgumentException(tmp$ret$1);
    }
    if (size === 0) {
      return Unit_instance;
    }
    var interval = new Interval(this.gif_1, size, value);
    this.gif_1 = this.gif_1 + size | 0;
    this.fif_1.zz(interval);
  };
  protoOf(MutableIntervalList).ziv = function (fromIndex, toIndex, block) {
    // Inline function 'androidx.compose.foundation.lazy.layout.MutableIntervalList.checkIndexBounds' call
    if (!(0 <= fromIndex ? fromIndex < this.gif_1 : false)) {
      throwIndexOutOfBoundsException('Index ' + fromIndex + ', size ' + this.gif_1);
    }
    // Inline function 'androidx.compose.foundation.lazy.layout.MutableIntervalList.checkIndexBounds' call
    if (!(0 <= toIndex ? toIndex < this.gif_1 : false)) {
      throwIndexOutOfBoundsException('Index ' + toIndex + ', size ' + this.gif_1);
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(toIndex >= fromIndex)) {
      var tmp$ret$3 = 'toIndex (' + toIndex + ') should be not smaller than fromIndex (' + fromIndex + ')';
      throwIllegalArgumentException(tmp$ret$3);
    }
    var intervalIndex = binarySearch_0(this.fif_1, fromIndex);
    var tmp0 = this.fif_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
    var index = intervalIndex;
    var itemIndex = tmp0.b3e_1[index].tif_1;
    while (itemIndex <= toIndex) {
      var tmp0_0 = this.fif_1;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
      var index_0 = intervalIndex;
      var interval = tmp0_0.b3e_1[index_0];
      block(interval);
      itemIndex = itemIndex + interval.uif_1 | 0;
      intervalIndex = intervalIndex + 1 | 0;
    }
  };
  protoOf(MutableIntervalList).l1 = function (index) {
    // Inline function 'androidx.compose.foundation.lazy.layout.MutableIntervalList.checkIndexBounds' call
    if (!(0 <= index ? index < this.gif_1 : false)) {
      throwIndexOutOfBoundsException('Index ' + index + ', size ' + this.gif_1);
    }
    return getIntervalForIndex(this, index);
  };
  function Interval(startIndex, size, value) {
    this.tif_1 = startIndex;
    this.uif_1 = size;
    this.vif_1 = value;
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(this.tif_1 >= 0)) {
      var tmp$ret$1 = 'startIndex should be >= 0';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(this.uif_1 > 0)) {
      var tmp$ret$3 = 'size should be > 0';
      throwIllegalArgumentException(tmp$ret$3);
    }
  }
  function binarySearch_0(_this__u8e3s4, itemIndex) {
    var left = 0;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
    var right = _this__u8e3s4.d3e_1 - 1 | 0;
    while (left < right) {
      var middle = left + ((right - left | 0) / 2 | 0) | 0;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
      var middleValue = _this__u8e3s4.b3e_1[middle].tif_1;
      if (middleValue === itemIndex) {
        return middle;
      }
      if (middleValue < itemIndex) {
        left = middle + 1 | 0;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var index = left;
        if (itemIndex < _this__u8e3s4.b3e_1[index].tif_1) {
          return middle;
        }
      } else {
        right = middle - 1 | 0;
      }
    }
    return left;
  }
  function LazyLayout(itemProvider, modifier, prefetchState, measurePolicy, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var prefetchState_0 = {_v: prefetchState};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1055276397);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(itemProvider) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(prefetchState_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ((($changed & 4096) === 0 ? $composer_0.k31(measurePolicy) : $composer_0.q31(measurePolicy)) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      if (!(($default & 4) === 0)) {
        prefetchState_0._v = null;
      }
      var currentItemProvider = rememberUpdatedState(itemProvider, $composer_0, 14 & $dirty);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-933153643, true, LazyLayout$lambda(prefetchState_0, modifier_0, measurePolicy, currentItemProvider), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ComposableLambda$invoke$ref_5(dispatchReceiver);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      LazySaveableStateHolderProvider(tmp$ret$0, $composer_0, 6);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(LazyLayout$lambda_0(itemProvider, modifier_0, prefetchState_0, measurePolicy, $changed, $default));
    }
  }
  function LazyLayoutItemReusePolicy(factory) {
    this.aiw_1 = factory;
    this.biw_1 = mutableObjectIntMapOf();
  }
  protoOf(LazyLayoutItemReusePolicy).vaw = function (slotIds) {
    this.biw_1.c3();
    // Inline function 'androidx.compose.ui.layout.SlotIdsSet.fastForEach' call
    // Inline function 'androidx.collection.OrderedScatterSet.forEach' call
    var this_0 = slotIds.taw_1;
    // Inline function 'kotlin.contracts.contract' call
    var elements = this_0.u10_1;
    var nodes = this_0.v10_1;
    var candidate = this_0.x10_1;
    while (!(candidate === 2147483647)) {
      // Inline function 'androidx.collection.previousNode' call
      var this_1 = nodes[candidate];
      var previousNode = convertToInt(bitwiseAnd(shiftRight(this_1, 31), new Long(2147483647, 0)));
      var slotId = elements[candidate];
      var type = this.aiw_1.fiw(slotId);
      var currentCount = this.biw_1.rz(type, 0);
      if (currentCount === 7) {
        slotIds.eax(slotId);
      } else {
        this.biw_1.oz(type, currentCount + 1 | 0);
      }
      candidate = previousNode;
    }
  };
  protoOf(LazyLayoutItemReusePolicy).uav = function (slotId, reusableSlotId) {
    return equals(this.aiw_1.fiw(slotId), this.aiw_1.fiw(reusableSlotId));
  };
  function LazyLayout$lambda$lambda($currentItemProvider) {
    return function () {
      return $currentItemProvider.u1()();
    };
  }
  function LazyLayout$$inlined$run$1$2$1($prefetchState) {
    this.giw_1 = $prefetchState;
  }
  protoOf(LazyLayout$$inlined$run$1$2$1).s1d = function () {
    var tmp0_safe_receiver = this.giw_1._v.iij_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.miw();
    }
    this.giw_1._v.iij_1 = null;
  };
  function LazyLayout$lambda$lambda_0($prefetchState, $itemContentFactory, $subcomposeLayoutState, $executor) {
    return function ($this$DisposableEffect) {
      $prefetchState._v.iij_1 = new PrefetchHandleProvider($itemContentFactory, $subcomposeLayoutState, $executor);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new LazyLayout$$inlined$run$1$2$1($prefetchState);
    };
  }
  function LazyLayout$lambda$lambda_1($itemContentFactory, $measurePolicy) {
    return function ($this$remember, constraints) {
      var scope = new LazyLayoutMeasureScopeImpl($itemContentFactory, $this$remember);
      // Inline function 'kotlin.with' call
      return $measurePolicy.bid(scope, constraints.m5e_1);
    };
  }
  function LazyLayout$lambda($prefetchState, $modifier, $measurePolicy, $currentItemProvider) {
    return function (saveableStateHolder, $composer, $changed) {
      var $composer_0 = $composer;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = new LazyLayoutItemContentFactory(saveableStateHolder, LazyLayout$lambda$lambda($currentItemProvider));
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var itemContentFactory = tmp;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_0 = $composer_0.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = new SubcomposeLayoutState(new LazyLayoutItemReusePolicy(itemContentFactory));
        $composer_0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var subcomposeLayoutState = tmp_0;
      if (!($prefetchState._v == null)) {
        $composer_0.m30(1743490539);
        var tmp0_elvis_lhs = $prefetchState._v.fij_1;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          $composer_0.m30(887527095);
          var tmp0_group = rememberDefaultPrefetchScheduler($composer_0, 0);
          $composer_0.n30();
          tmp_1 = tmp0_group;
        } else {
          $composer_0.m30(887526010);
          $composer_0.n30();
          tmp_1 = tmp0_elvis_lhs;
        }
        var executor = tmp_1;
        var tmp_2 = [$prefetchState._v, itemContentFactory, subcomposeLayoutState, executor];
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!(!!($composer_0.k31($prefetchState._v) | $composer_0.q31(itemContentFactory)) | $composer_0.q31(subcomposeLayoutState)) | $composer_0.q31(executor));
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_3;
        if (invalid || it_1 === Companion_getInstance_11().f30_1) {
          var value_1 = LazyLayout$lambda$lambda_0($prefetchState, itemContentFactory, subcomposeLayoutState, executor);
          $composer_0.j31(value_1);
          tmp_3 = value_1;
        } else {
          tmp_3 = it_1;
        }
        var tmp$ret$8 = tmp_3;
        DisposableEffect(tmp_2, tmp$ret$8, $composer_0, 0);
        $composer_0.n30();
      } else {
        $composer_0.m30(1744076749);
        $composer_0.n30();
      }
      var tmp_4 = traversablePrefetchState($modifier._v, $prefetchState._v);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.k31(itemContentFactory) | $composer_0.k31($measurePolicy));
      // Inline function 'kotlin.let' call
      var it_2 = $composer_0.i31();
      var tmp_5;
      if (invalid_0 || it_2 === Companion_getInstance_11().f30_1) {
        var value_2 = LazyLayout$lambda$lambda_1(itemContentFactory, $measurePolicy);
        $composer_0.j31(value_2);
        tmp_5 = value_2;
      } else {
        tmp_5 = it_2;
      }
      var tmp$ret$12 = tmp_5;
      SubcomposeLayout(subcomposeLayoutState, tmp_4, tmp$ret$12, $composer_0, androidx_compose_ui_layout_SubcomposeLayoutState$stableprop_getter(), 0);
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_5(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function LazyLayout$lambda_0($itemProvider, $modifier, $prefetchState, $measurePolicy, $$changed, $$default) {
    return function ($composer, $force) {
      LazyLayout($itemProvider, $modifier._v, $prefetchState._v, $measurePolicy, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function Interval_0(start, end) {
    this.niw_1 = start;
    this.oiw_1 = end;
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(this.niw_1 >= 0)) {
      var tmp$ret$1 = 'negative start index';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(this.oiw_1 >= this.niw_1)) {
      var tmp$ret$3 = 'end index greater than start';
      throwIllegalArgumentException(tmp$ret$3);
    }
  }
  protoOf(Interval_0).toString = function () {
    return 'Interval(start=' + this.niw_1 + ', end=' + this.oiw_1 + ')';
  };
  protoOf(Interval_0).hashCode = function () {
    var result = this.niw_1;
    result = imul(result, 31) + this.oiw_1 | 0;
    return result;
  };
  protoOf(Interval_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Interval_0))
      return false;
    if (!(this.niw_1 === other.niw_1))
      return false;
    if (!(this.oiw_1 === other.oiw_1))
      return false;
    return true;
  };
  function LazyLayoutBeyondBoundsInfo() {
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.piw_1 = new MutableVector(tmp$ret$2, 0);
  }
  protoOf(LazyLayoutBeyondBoundsInfo).qiw = function (start, end) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Interval_0(start, end);
    this.piw_1.zz(this_0);
    return this_0;
  };
  protoOf(LazyLayoutBeyondBoundsInfo).riw = function (interval) {
    this.piw_1.g10(interval);
  };
  protoOf(LazyLayoutBeyondBoundsInfo).siw = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
    return !(this.piw_1.d3e_1 === 0);
  };
  protoOf(LazyLayoutBeyondBoundsInfo).e1 = function () {
    var minIndex = this.piw_1.vg().niw_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.piw_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      if (it.niw_1 < minIndex) {
        minIndex = it.niw_1;
      }
      i = i + 1 | 0;
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(minIndex >= 0)) {
      var tmp$ret$3 = 'negative minIndex';
      throwIllegalArgumentException(tmp$ret$3);
    }
    return minIndex;
  };
  protoOf(LazyLayoutBeyondBoundsInfo).f9f = function () {
    var maxIndex = this.piw_1.vg().oiw_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.piw_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      if (it.oiw_1 > maxIndex) {
        maxIndex = it.oiw_1;
      }
      i = i + 1 | 0;
    }
    return maxIndex;
  };
  var androidx_compose_foundation_lazy_layout_LazyLayoutBeyondBoundsProviderModifierNode$stable;
  function lazyLayoutBeyondBoundsModifier(_this__u8e3s4, state, beyondBoundsInfo, reverseLayout, orientation) {
    return _this__u8e3s4.d8v(new LazyLayoutBeyondBoundsModifierElement(state, beyondBoundsInfo, reverseLayout, orientation));
  }
  function LazyLayoutBeyondBoundsModifierElement(state, beyondBoundsInfo, reverseLayout, orientation) {
    ModifierNodeElement.call(this);
    this.uiw_1 = state;
    this.viw_1 = beyondBoundsInfo;
    this.wiw_1 = reverseLayout;
    this.xiw_1 = orientation;
  }
  protoOf(LazyLayoutBeyondBoundsModifierElement).r3d = function () {
    return new LazyLayoutBeyondBoundsProviderModifierNode(this.uiw_1, this.viw_1, this.wiw_1, this.xiw_1);
  };
  protoOf(LazyLayoutBeyondBoundsModifierElement).yiw = function (node) {
    node.rix(this.uiw_1, this.viw_1, this.wiw_1, this.xiw_1);
  };
  protoOf(LazyLayoutBeyondBoundsModifierElement).d8y = function (node) {
    return this.yiw(node instanceof LazyLayoutBeyondBoundsProviderModifierNode ? node : THROW_CCE());
  };
  protoOf(LazyLayoutBeyondBoundsModifierElement).hashCode = function () {
    var result = hashCode(this.uiw_1);
    result = imul(31, result) + hashCode(this.viw_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.wiw_1) | 0;
    result = imul(31, result) + this.xiw_1.hashCode() | 0;
    return result;
  };
  protoOf(LazyLayoutBeyondBoundsModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LazyLayoutBeyondBoundsModifierElement))
      return false;
    if (!equals(this.uiw_1, other.uiw_1))
      return false;
    if (!equals(this.viw_1, other.viw_1))
      return false;
    if (!(this.wiw_1 === other.wiw_1))
      return false;
    if (!this.xiw_1.equals(other.xiw_1))
      return false;
    return true;
  };
  function LazyLayoutBeyondBoundsProviderModifierNode$Companion$emptyBeyondBoundsScope$1() {
    this.six_1 = false;
  }
  protoOf(LazyLayoutBeyondBoundsProviderModifierNode$Companion$emptyBeyondBoundsScope$1).e9i = function () {
    return this.six_1;
  };
  function Companion_7() {
    Companion_instance_17 = this;
    var tmp = this;
    tmp.tix_1 = new LazyLayoutBeyondBoundsProviderModifierNode$Companion$emptyBeyondBoundsScope$1();
  }
  var Companion_instance_17;
  function Companion_getInstance_66() {
    if (Companion_instance_17 == null)
      new Companion_7();
    return Companion_instance_17;
  }
  function isForward($this, $receiver) {
    var tmp;
    if ($receiver === Companion_getInstance_25().e9b_1) {
      tmp = false;
    } else if ($receiver === Companion_getInstance_25().f9b_1) {
      tmp = true;
    } else if ($receiver === Companion_getInstance_25().i9b_1) {
      tmp = $this.pix_1;
    } else if ($receiver === Companion_getInstance_25().j9b_1) {
      tmp = !$this.pix_1;
    } else if ($receiver === Companion_getInstance_25().g9b_1) {
      var tmp_0;
      switch (requireLayoutDirection($this).a1_1) {
        case 0:
          tmp_0 = $this.pix_1;
          break;
        case 1:
          tmp_0 = !$this.pix_1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else if ($receiver === Companion_getInstance_25().h9b_1) {
      var tmp_1;
      switch (requireLayoutDirection($this).a1_1) {
        case 0:
          tmp_1 = !$this.pix_1;
          break;
        case 1:
          tmp_1 = $this.pix_1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_1;
    } else {
      unsupportedDirection();
    }
    return tmp;
  }
  function addNextInterval($this, currentInterval, direction) {
    var start = currentInterval.niw_1;
    var end = currentInterval.oiw_1;
    if (isForward($this, direction)) {
      end = end + 1 | 0;
    } else {
      start = start - 1 | 0;
    }
    return $this.oix_1.qiw(start, end);
  }
  function hasMoreContent($this, $receiver, direction) {
    if (isOppositeToOrientation($this, direction))
      return false;
    return isForward($this, direction) ? $receiver.oiw_1 < ($this.nix_1.aie() - 1 | 0) : $receiver.niw_1 > 0;
  }
  function isOppositeToOrientation($this, $receiver) {
    var tmp;
    if ($receiver === Companion_getInstance_25().i9b_1 || $receiver === Companion_getInstance_25().j9b_1) {
      tmp = $this.qix_1.equals(Orientation_Horizontal_getInstance());
    } else if ($receiver === Companion_getInstance_25().g9b_1 || $receiver === Companion_getInstance_25().h9b_1) {
      tmp = $this.qix_1.equals(Orientation_Vertical_getInstance());
    } else if ($receiver === Companion_getInstance_25().e9b_1 || $receiver === Companion_getInstance_25().f9b_1) {
      tmp = false;
    } else {
      unsupportedDirection();
    }
    return tmp;
  }
  function LazyLayoutBeyondBoundsProviderModifierNode$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.jal($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function LazyLayoutBeyondBoundsProviderModifierNode$layout$1(this$0, $interval, $direction) {
    this.uix_1 = this$0;
    this.vix_1 = $interval;
    this.wix_1 = $direction;
  }
  protoOf(LazyLayoutBeyondBoundsProviderModifierNode$layout$1).e9i = function () {
    return hasMoreContent(this.uix_1, this.vix_1._v, this.wix_1);
  };
  function LazyLayoutBeyondBoundsProviderModifierNode(state, beyondBoundsInfo, reverseLayout, orientation) {
    Companion_getInstance_66();
    Node.call(this);
    this.nix_1 = state;
    this.oix_1 = beyondBoundsInfo;
    this.pix_1 = reverseLayout;
    this.qix_1 = orientation;
  }
  protoOf(LazyLayoutBeyondBoundsProviderModifierNode).lag = function () {
    return this;
  };
  protoOf(LazyLayoutBeyondBoundsProviderModifierNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var placeable = measurable.h8y(constraints);
    var tmp = placeable.i8y_1;
    var tmp_0 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp, tmp_0, VOID, LazyLayoutBeyondBoundsProviderModifierNode$measure$lambda(placeable));
  };
  protoOf(LazyLayoutBeyondBoundsProviderModifierNode).s9b = function (direction, block) {
    if (this.nix_1.aie() <= 0 || !this.nix_1.yie() || !this.z8v_1) {
      return block(Companion_getInstance_66().tix_1);
    }
    var tmp;
    if (isForward(this, direction)) {
      tmp = this.nix_1.aif();
    } else {
      tmp = this.nix_1.zie();
    }
    var startIndex = tmp;
    var interval = {_v: this.oix_1.qiw(startIndex, startIndex)};
    var found = null;
    var maxItemsToLayout = coerceAtMost(imul(2, this.nix_1.bif()), this.nix_1.aie());
    var itemsCreatedSoFar = 0;
    while (found == null && hasMoreContent(this, interval._v, direction) && itemsCreatedSoFar < maxItemsToLayout) {
      // Inline function 'kotlin.also' call
      var this_0 = addNextInterval(this, interval._v, direction);
      this.oix_1.riw(interval._v);
      interval._v = this_0;
      itemsCreatedSoFar = itemsCreatedSoFar + 1 | 0;
      remeasureSync(this);
      found = block(new LazyLayoutBeyondBoundsProviderModifierNode$layout$1(this, interval, direction));
    }
    this.oix_1.riw(interval._v);
    remeasureSync(this);
    return found;
  };
  protoOf(LazyLayoutBeyondBoundsProviderModifierNode).rix = function (state, beyondBoundsInfo, reverseLayout, orientation) {
    this.nix_1 = state;
    this.oix_1 = beyondBoundsInfo;
    this.pix_1 = reverseLayout;
    this.qix_1 = orientation;
  };
  function unsupportedDirection() {
    // Inline function 'kotlin.error' call
    var message = 'Lazy list does not support beyond bounds layout for the specified direction';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function calculateLazyLayoutPinnedIndices(_this__u8e3s4, pinnedItemList, beyondBoundsInfo) {
    if (!beyondBoundsInfo.siw() && pinnedItemList.r()) {
      return emptyList();
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      var pinnedItems = ArrayList_init_$Create$();
      var tmp;
      if (beyondBoundsInfo.siw()) {
        var tmp_0 = beyondBoundsInfo.e1();
        var tmp0 = beyondBoundsInfo.f9f();
        // Inline function 'kotlin.math.min' call
        var b = _this__u8e3s4.aie() - 1 | 0;
        var tmp$ret$1 = Math.min(tmp0, b);
        tmp = numberRangeToNumber(tmp_0, tmp$ret$1);
      } else {
        tmp = Companion_getInstance_26().v1_1;
      }
      var beyondBoundsRange = tmp;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = pinnedItemList.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = pinnedItemList.l1(index);
          $l$block_0: {
            var index_0 = findIndexByKey(_this__u8e3s4, item.t1(), item.bi0());
            var containsLower = beyondBoundsRange.x1_1;
            if (index_0 <= beyondBoundsRange.y1_1 ? containsLower <= index_0 : false) {
              break $l$block_0;
            }
            if (!(0 <= index_0 ? index_0 < _this__u8e3s4.aie() : false)) {
              break $l$block_0;
            }
            pinnedItems.j1(index_0);
          }
        }
         while (inductionVariable <= last);
      var inductionVariable_0 = beyondBoundsRange.x1_1;
      var last_0 = beyondBoundsRange.y1_1;
      if (inductionVariable_0 <= last_0)
        do {
          var i = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          pinnedItems.j1(i);
        }
         while (!(i === last_0));
      return pinnedItems;
    }
  }
  function LazyLayoutCacheWindow() {
  }
  var androidx_compose_foundation_lazy_layout_LazyLayoutIntervalContent$stable;
  function LazyLayoutIntervalContent$Interval$_get_type_$lambda_1wu10p(it) {
    return null;
  }
  function Interval_1() {
  }
  function LazyLayoutIntervalContent() {
  }
  protoOf(LazyLayoutIntervalContent).aie = function () {
    return this.eif().n1();
  };
  protoOf(LazyLayoutIntervalContent).jif = function (index) {
    // Inline function 'androidx.compose.foundation.lazy.layout.LazyLayoutIntervalContent.withInterval' call
    var interval = this.eif().l1(index);
    var localIntervalIndex = index - interval.tif_1 | 0;
    var tmp0_safe_receiver = interval.vif_1.t1();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(localIntervalIndex);
    return tmp1_elvis_lhs == null ? getDefaultLazyLayoutKey(index) : tmp1_elvis_lhs;
  };
  protoOf(LazyLayoutIntervalContent).kif = function (index) {
    // Inline function 'androidx.compose.foundation.lazy.layout.LazyLayoutIntervalContent.withInterval' call
    var interval = this.eif().l1(index);
    var localIntervalIndex = index - interval.tif_1 | 0;
    return interval.vif_1.oif()(localIntervalIndex);
  };
  function get_InterruptionSpec() {
    _init_properties_LazyLayoutItemAnimation_kt__2wnm5d();
    return InterruptionSpec;
  }
  var InterruptionSpec;
  var androidx_compose_foundation_lazy_layout_LazyLayoutItemAnimation$stable;
  var androidx_compose_foundation_lazy_layout_LazyLayoutAnimateItemElement$stable;
  var androidx_compose_foundation_lazy_layout_LazyLayoutAnimationSpecsNode$stable;
  function LazyLayoutItemAnimation$animatePlacementDelta$slambda$lambda(this$0, $animationTarget) {
    return function ($this$animateTo) {
      _set_placementDelta__ka0zmk(this$0, IntOffset__minus_impl_4m69hb($this$animateTo.u1().a5g_1, $animationTarget));
      this$0.uig_1();
      return Unit_instance;
    };
  }
  function LazyLayoutItemAnimation$animateAppearance$slambda$lambda($layer, this$0) {
    return function ($this$animateTo) {
      $layer.v66($this$animateTo.u1());
      this$0.uig_1();
      return Unit_instance;
    };
  }
  function LazyLayoutItemAnimation$animateDisappearance$slambda$lambda($layer, this$0) {
    return function ($this$animateTo) {
      $layer.v66($this$animateTo.u1());
      this$0.uig_1();
      return Unit_instance;
    };
  }
  function _set_isPlacementAnimationInProgress__3yokhw($this, _set____db54di) {
    var tmp0 = $this.zig_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutItemAnimation$_get_isPlacementAnimationInProgress_$ref_sbqptc();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isPlacementAnimationInProgress', 1, tmp, tmp_0, LazyLayoutItemAnimation$_set_isPlacementAnimationInProgress_$ref_cq4wqs());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _set_isAppearanceAnimationInProgress__16qsn7($this, _set____db54di) {
    var tmp0 = $this.aih_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutItemAnimation$_get_isAppearanceAnimationInProgress_$ref_h8oolj();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isAppearanceAnimationInProgress', 1, tmp, tmp_0, LazyLayoutItemAnimation$_set_isAppearanceAnimationInProgress_$ref_n6h8u3());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _set_isDisappearanceAnimationInProgress__px4w5l($this, _set____db54di) {
    var tmp0 = $this.bih_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutItemAnimation$_get_isDisappearanceAnimationInProgress_$ref_ex294t();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isDisappearanceAnimationInProgress', 1, tmp, tmp_0, LazyLayoutItemAnimation$_set_isDisappearanceAnimationInProgress_$ref_33j7ef());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _set_isDisappearanceAnimationFinished__gvr3m1($this, _set____db54di) {
    var tmp0 = $this.cih_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutItemAnimation$_get_isDisappearanceAnimationFinished_$ref_8x5n7n();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isDisappearanceAnimationFinished', 1, tmp, tmp_0, LazyLayoutItemAnimation$_set_isDisappearanceAnimationFinished_$ref_x47o7d());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _set_placementDelta__ka0zmk($this, _set____db54di) {
    var tmp0 = $this.iih_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutItemAnimation$_get_placementDelta_$ref_o6k9lk();
    getPropertyCallableRef('placementDelta', 1, tmp, tmp_0, LazyLayoutItemAnimation$_set_placementDelta_$ref_cwoh98());
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new IntOffset(_set____db54di);
    tmp0.s21(value);
    return Unit_instance;
  }
  function Companion_8() {
    Companion_instance_18 = this;
    var tmp = this;
    var tmp0 = 2147483647;
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = 2147483647;
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    tmp.kih_1 = _IntOffset___init__impl__rq8h7b(tmp$ret$1);
  }
  var Companion_instance_18;
  function Companion_getInstance_67() {
    if (Companion_instance_18 == null)
      new Companion_8();
    return Companion_instance_18;
  }
  function LazyLayoutItemAnimation$_init_$lambda_d5bd4() {
    return Unit_instance;
  }
  function LazyLayoutItemAnimation$_get_isPlacementAnimationInProgress_$ref_sbqptc() {
    return constructCallableReference(function (p0) {
      return p0.yix();
    }, 1, 0, 275);
  }
  function LazyLayoutItemAnimation$_set_isPlacementAnimationInProgress_$ref_cq4wqs() {
    return constructCallableReference(function (p0, p1) {
      _set_isPlacementAnimationInProgress__3yokhw(p0, p1);
      return Unit_instance;
    }, 2, 0, 276);
  }
  function LazyLayoutItemAnimation$_get_isAppearanceAnimationInProgress_$ref_h8oolj() {
    return constructCallableReference(function (p0) {
      return p0.zix();
    }, 1, 0, 277);
  }
  function LazyLayoutItemAnimation$_set_isAppearanceAnimationInProgress_$ref_n6h8u3() {
    return constructCallableReference(function (p0, p1) {
      _set_isAppearanceAnimationInProgress__16qsn7(p0, p1);
      return Unit_instance;
    }, 2, 0, 278);
  }
  function LazyLayoutItemAnimation$_get_isDisappearanceAnimationInProgress_$ref_ex294t() {
    return constructCallableReference(function (p0) {
      return p0.aiy();
    }, 1, 0, 279);
  }
  function LazyLayoutItemAnimation$_set_isDisappearanceAnimationInProgress_$ref_33j7ef() {
    return constructCallableReference(function (p0, p1) {
      _set_isDisappearanceAnimationInProgress__px4w5l(p0, p1);
      return Unit_instance;
    }, 2, 0, 280);
  }
  function LazyLayoutItemAnimation$_get_isDisappearanceAnimationFinished_$ref_8x5n7n() {
    return constructCallableReference(function (p0) {
      return p0.biy();
    }, 1, 0, 281);
  }
  function LazyLayoutItemAnimation$_set_isDisappearanceAnimationFinished_$ref_x47o7d() {
    return constructCallableReference(function (p0, p1) {
      _set_isDisappearanceAnimationFinished__gvr3m1(p0, p1);
      return Unit_instance;
    }, 2, 0, 282);
  }
  function LazyLayoutItemAnimation$_get_placementDelta_$ref_o6k9lk() {
    return constructCallableReference(function (p0) {
      return new IntOffset(p0.lih());
    }, 1, 0, 283);
  }
  function LazyLayoutItemAnimation$_set_placementDelta_$ref_cwoh98() {
    return constructCallableReference(function (p0, p1) {
      _set_placementDelta__ka0zmk(p0, p1.a5g_1);
      return Unit_instance;
    }, 2, 0, 284);
  }
  function LazyLayoutItemAnimation$cancelPlacementAnimation$slambda(this$0, resultContinuation) {
    this.kiy_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyLayoutItemAnimation$cancelPlacementAnimation$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyLayoutItemAnimation$cancelPlacementAnimation$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyLayoutItemAnimation$cancelPlacementAnimation$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.kiy_1.gih_1.hec(new IntOffset(Companion_getInstance_21().c5g_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            _set_placementDelta__ka0zmk(this.kiy_1, Companion_getInstance_21().c5g_1);
            _set_isPlacementAnimationInProgress__3yokhw(this.kiy_1, false);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LazyLayoutItemAnimation$cancelPlacementAnimation$slambda).q24 = function ($this$launch, completion) {
    var i = new LazyLayoutItemAnimation$cancelPlacementAnimation$slambda(this.kiy_1, completion);
    i.liy_1 = $this$launch;
    return i;
  };
  function LazyLayoutItemAnimation$cancelPlacementAnimation$slambda_0(this$0, resultContinuation) {
    var i = new LazyLayoutItemAnimation$cancelPlacementAnimation$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function LazyLayoutItemAnimation$animatePlacementDelta$slambda(this$0, $spec, $totalDelta, resultContinuation) {
    this.uiy_1 = this$0;
    this.viy_1 = $spec;
    this.wiy_1 = $totalDelta;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyLayoutItemAnimation$animatePlacementDelta$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyLayoutItemAnimation$animatePlacementDelta$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyLayoutItemAnimation$animatePlacementDelta$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.o9_1 = 4;
            var tmp_0 = this;
            var tmp_1;
            if (this.uiy_1.gih_1.rea()) {
              var tmp_2;
              var tmp_3 = this.viy_1;
              if (tmp_3 instanceof SpringSpec) {
                tmp_2 = this.viy_1;
              } else {
                tmp_2 = get_InterruptionSpec();
              }
              tmp_1 = tmp_2;
            } else {
              tmp_1 = this.viy_1;
            }

            tmp_0.yiy_1 = tmp_1;
            if (!this.uiy_1.gih_1.rea()) {
              this.n9_1 = 1;
              suspendResult = this.uiy_1.gih_1.hec(new IntOffset(this.wiy_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.uiy_1.uig_1();
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var animationTarget = IntOffset__minus_impl_4m69hb(this.uiy_1.gih_1.u1().a5g_1, this.wiy_1);
            this.n9_1 = 3;
            suspendResult = this.uiy_1.gih_1.gec(new IntOffset(animationTarget), this.yiy_1, VOID, LazyLayoutItemAnimation$animatePlacementDelta$slambda$lambda(this.uiy_1, animationTarget), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            _set_isPlacementAnimationInProgress__3yokhw(this.uiy_1, false);
            this.uiy_1.yig_1 = false;
            this.o9_1 = 5;
            this.n9_1 = 6;
            continue $sm;
          case 4:
            this.o9_1 = 5;
            var tmp_4 = this.q9_1;
            if (tmp_4 instanceof CancellationException) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 6;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            throw this.q9_1;
          case 6:
            this.o9_1 = 5;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LazyLayoutItemAnimation$animatePlacementDelta$slambda).q24 = function ($this$launch, completion) {
    var i = new LazyLayoutItemAnimation$animatePlacementDelta$slambda(this.uiy_1, this.viy_1, this.wiy_1, completion);
    i.xiy_1 = $this$launch;
    return i;
  };
  function LazyLayoutItemAnimation$animatePlacementDelta$slambda_0(this$0, $spec, $totalDelta, resultContinuation) {
    var i = new LazyLayoutItemAnimation$animatePlacementDelta$slambda(this$0, $spec, $totalDelta, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function LazyLayoutItemAnimation$animateAppearance$slambda(this$0, resultContinuation) {
    this.hiz_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyLayoutItemAnimation$animateAppearance$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyLayoutItemAnimation$animateAppearance$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyLayoutItemAnimation$animateAppearance$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.hiz_1.hih_1.hec(1.0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LazyLayoutItemAnimation$animateAppearance$slambda).q24 = function ($this$launch, completion) {
    var i = new LazyLayoutItemAnimation$animateAppearance$slambda(this.hiz_1, completion);
    i.iiz_1 = $this$launch;
    return i;
  };
  function LazyLayoutItemAnimation$animateAppearance$slambda_0(this$0, resultContinuation) {
    var i = new LazyLayoutItemAnimation$animateAppearance$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function LazyLayoutItemAnimation$animateAppearance$slambda_1($shouldResetValue, this$0, $spec, $layer, resultContinuation) {
    this.riz_1 = $shouldResetValue;
    this.siz_1 = this$0;
    this.tiz_1 = $spec;
    this.uiz_1 = $layer;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyLayoutItemAnimation$animateAppearance$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyLayoutItemAnimation$animateAppearance$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyLayoutItemAnimation$animateAppearance$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 6;
            if (this.riz_1) {
              this.n9_1 = 2;
              suspendResult = this.siz_1.hih_1.hec(0.0, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            suspendResult = this.siz_1.hih_1.gec(1.0, this.tiz_1, VOID, LazyLayoutItemAnimation$animateAppearance$slambda$lambda(this.uiz_1, this.siz_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.wiz_1 = suspendResult;
            this.o9_1 = 7;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.wiz_1;
            this.o9_1 = 7;
            _set_isAppearanceAnimationInProgress__16qsn7(this.siz_1, false);
            return Unit_instance;
          case 6:
            this.o9_1 = 7;
            var t = this.q9_1;
            _set_isAppearanceAnimationInProgress__16qsn7(this.siz_1, false);
            throw t;
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LazyLayoutItemAnimation$animateAppearance$slambda_1).q24 = function ($this$launch, completion) {
    var i = new LazyLayoutItemAnimation$animateAppearance$slambda_1(this.riz_1, this.siz_1, this.tiz_1, this.uiz_1, completion);
    i.viz_1 = $this$launch;
    return i;
  };
  function LazyLayoutItemAnimation$animateAppearance$slambda_2($shouldResetValue, this$0, $spec, $layer, resultContinuation) {
    var i = new LazyLayoutItemAnimation$animateAppearance$slambda_1($shouldResetValue, this$0, $spec, $layer, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function LazyLayoutItemAnimation$animateDisappearance$slambda(this$0, $spec, $layer, resultContinuation) {
    this.fj0_1 = this$0;
    this.gj0_1 = $spec;
    this.hj0_1 = $layer;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyLayoutItemAnimation$animateDisappearance$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyLayoutItemAnimation$animateDisappearance$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyLayoutItemAnimation$animateDisappearance$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            suspendResult = this.fj0_1.hih_1.gec(0.0, this.gj0_1, VOID, LazyLayoutItemAnimation$animateDisappearance$slambda$lambda(this.hj0_1, this.fj0_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            _set_isDisappearanceAnimationFinished__gvr3m1(this.fj0_1, true);
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            _set_isDisappearanceAnimationInProgress__px4w5l(this.fj0_1, false);
            return Unit_instance;
          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            _set_isDisappearanceAnimationInProgress__px4w5l(this.fj0_1, false);
            throw t;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LazyLayoutItemAnimation$animateDisappearance$slambda).q24 = function ($this$launch, completion) {
    var i = new LazyLayoutItemAnimation$animateDisappearance$slambda(this.fj0_1, this.gj0_1, this.hj0_1, completion);
    i.ij0_1 = $this$launch;
    return i;
  };
  function LazyLayoutItemAnimation$animateDisappearance$slambda_0(this$0, $spec, $layer, resultContinuation) {
    var i = new LazyLayoutItemAnimation$animateDisappearance$slambda(this$0, $spec, $layer, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function LazyLayoutItemAnimation$release$slambda(this$0, resultContinuation) {
    this.rj0_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyLayoutItemAnimation$release$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyLayoutItemAnimation$release$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyLayoutItemAnimation$release$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.rj0_1.gih_1.iec(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LazyLayoutItemAnimation$release$slambda).q24 = function ($this$launch, completion) {
    var i = new LazyLayoutItemAnimation$release$slambda(this.rj0_1, completion);
    i.sj0_1 = $this$launch;
    return i;
  };
  function LazyLayoutItemAnimation$release$slambda_0(this$0, resultContinuation) {
    var i = new LazyLayoutItemAnimation$release$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function LazyLayoutItemAnimation$release$slambda_1(this$0, resultContinuation) {
    this.bj1_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyLayoutItemAnimation$release$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyLayoutItemAnimation$release$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyLayoutItemAnimation$release$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.bj1_1.hih_1.iec(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LazyLayoutItemAnimation$release$slambda_1).q24 = function ($this$launch, completion) {
    var i = new LazyLayoutItemAnimation$release$slambda_1(this.bj1_1, completion);
    i.cj1_1 = $this$launch;
    return i;
  };
  function LazyLayoutItemAnimation$release$slambda_2(this$0, resultContinuation) {
    var i = new LazyLayoutItemAnimation$release$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function LazyLayoutItemAnimation$release$slambda_3(this$0, resultContinuation) {
    this.lj1_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyLayoutItemAnimation$release$slambda_3).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyLayoutItemAnimation$release$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyLayoutItemAnimation$release$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.lj1_1.hih_1.iec(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LazyLayoutItemAnimation$release$slambda_3).q24 = function ($this$launch, completion) {
    var i = new LazyLayoutItemAnimation$release$slambda_3(this.lj1_1, completion);
    i.mj1_1 = $this$launch;
    return i;
  };
  function LazyLayoutItemAnimation$release$slambda_4(this$0, resultContinuation) {
    var i = new LazyLayoutItemAnimation$release$slambda_3(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function LazyLayoutItemAnimation(coroutineScope, graphicsContext, onLayerPropertyChanged) {
    Companion_getInstance_67();
    graphicsContext = graphicsContext === VOID ? null : graphicsContext;
    var tmp;
    if (onLayerPropertyChanged === VOID) {
      tmp = LazyLayoutItemAnimation$_init_$lambda_d5bd4;
    } else {
      tmp = onLayerPropertyChanged;
    }
    onLayerPropertyChanged = tmp;
    this.sig_1 = coroutineScope;
    this.tig_1 = graphicsContext;
    this.uig_1 = onLayerPropertyChanged;
    this.vig_1 = null;
    this.wig_1 = null;
    this.xig_1 = null;
    this.yig_1 = false;
    this.zig_1 = mutableStateOf(false);
    this.aih_1 = mutableStateOf(false);
    this.bih_1 = mutableStateOf(false);
    this.cih_1 = mutableStateOf(false);
    this.dih_1 = Companion_getInstance_67().kih_1;
    this.eih_1 = Companion_getInstance_21().c5g_1;
    var tmp_0 = this;
    var tmp0_safe_receiver = this.tig_1;
    tmp_0.fih_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m6z();
    this.gih_1 = new Animatable(new IntOffset(Companion_getInstance_21().c5g_1), get_VectorConverter_0(Companion_getInstance_21()));
    this.hih_1 = new Animatable(1.0, get_VectorConverter(FloatCompanionObject_instance));
    this.iih_1 = mutableStateOf(new IntOffset(Companion_getInstance_21().c5g_1));
    this.jih_1 = Companion_getInstance_67().kih_1;
  }
  protoOf(LazyLayoutItemAnimation).yix = function () {
    var tmp0 = this.zig_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutItemAnimation$_get_isPlacementAnimationInProgress_$ref_sbqptc();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isPlacementAnimationInProgress', 1, tmp, tmp_0, LazyLayoutItemAnimation$_set_isPlacementAnimationInProgress_$ref_cq4wqs());
    return tmp0.u1();
  };
  protoOf(LazyLayoutItemAnimation).zix = function () {
    var tmp0 = this.aih_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutItemAnimation$_get_isAppearanceAnimationInProgress_$ref_h8oolj();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isAppearanceAnimationInProgress', 1, tmp, tmp_0, LazyLayoutItemAnimation$_set_isAppearanceAnimationInProgress_$ref_n6h8u3());
    return tmp0.u1();
  };
  protoOf(LazyLayoutItemAnimation).aiy = function () {
    var tmp0 = this.bih_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutItemAnimation$_get_isDisappearanceAnimationInProgress_$ref_ex294t();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isDisappearanceAnimationInProgress', 1, tmp, tmp_0, LazyLayoutItemAnimation$_set_isDisappearanceAnimationInProgress_$ref_33j7ef());
    return tmp0.u1();
  };
  protoOf(LazyLayoutItemAnimation).biy = function () {
    var tmp0 = this.cih_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutItemAnimation$_get_isDisappearanceAnimationFinished_$ref_8x5n7n();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isDisappearanceAnimationFinished', 1, tmp, tmp_0, LazyLayoutItemAnimation$_set_isDisappearanceAnimationFinished_$ref_x47o7d());
    return tmp0.u1();
  };
  protoOf(LazyLayoutItemAnimation).lih = function () {
    var tmp0 = this.iih_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutItemAnimation$_get_placementDelta_$ref_o6k9lk();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('placementDelta', 1, tmp, tmp_0, LazyLayoutItemAnimation$_set_placementDelta_$ref_cwoh98());
    return tmp0.u1().a5g_1;
  };
  protoOf(LazyLayoutItemAnimation).mih = function () {
    if (this.yix()) {
      launch(this.sig_1, VOID, VOID, LazyLayoutItemAnimation$cancelPlacementAnimation$slambda_0(this, null));
    }
  };
  protoOf(LazyLayoutItemAnimation).nj1 = function (delta, isMovingAway) {
    var tmp0_elvis_lhs = this.wig_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var spec = tmp;
    var totalDelta = IntOffset__minus_impl_4m69hb(this.lih(), delta);
    _set_placementDelta__ka0zmk(this, totalDelta);
    _set_isPlacementAnimationInProgress__3yokhw(this, true);
    this.yig_1 = isMovingAway;
    launch(this.sig_1, VOID, VOID, LazyLayoutItemAnimation$animatePlacementDelta$slambda_0(this, spec, totalDelta, null));
  };
  protoOf(LazyLayoutItemAnimation).oj1 = function () {
    var layer = this.fih_1;
    var spec = this.vig_1;
    if (this.zix() || spec == null || layer == null) {
      if (this.aiy()) {
        if (layer == null)
          null;
        else {
          layer.v66(1.0);
        }
        launch(this.sig_1, VOID, VOID, LazyLayoutItemAnimation$animateAppearance$slambda_0(this, null));
      }
      return Unit_instance;
    }
    _set_isAppearanceAnimationInProgress__16qsn7(this, true);
    var shouldResetValue = !this.aiy();
    if (shouldResetValue) {
      layer.v66(0.0);
    }
    launch(this.sig_1, VOID, VOID, LazyLayoutItemAnimation$animateAppearance$slambda_2(shouldResetValue, this, spec, layer, null));
  };
  protoOf(LazyLayoutItemAnimation).pj1 = function () {
    var layer = this.fih_1;
    var spec = this.xig_1;
    if (layer == null || this.aiy() || spec == null) {
      return Unit_instance;
    }
    _set_isDisappearanceAnimationInProgress__px4w5l(this, true);
    launch(this.sig_1, VOID, VOID, LazyLayoutItemAnimation$animateDisappearance$slambda_0(this, spec, layer, null));
  };
  protoOf(LazyLayoutItemAnimation).r2v = function () {
    if (this.yix()) {
      _set_isPlacementAnimationInProgress__3yokhw(this, false);
      launch(this.sig_1, VOID, VOID, LazyLayoutItemAnimation$release$slambda_0(this, null));
    }
    if (this.zix()) {
      _set_isAppearanceAnimationInProgress__16qsn7(this, false);
      launch(this.sig_1, VOID, VOID, LazyLayoutItemAnimation$release$slambda_2(this, null));
    }
    if (this.aiy()) {
      _set_isDisappearanceAnimationInProgress__px4w5l(this, false);
      launch(this.sig_1, VOID, VOID, LazyLayoutItemAnimation$release$slambda_4(this, null));
    }
    this.yig_1 = false;
    _set_placementDelta__ka0zmk(this, Companion_getInstance_21().c5g_1);
    this.dih_1 = Companion_getInstance_67().kih_1;
    var tmp0_safe_receiver = this.fih_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = this.tig_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.n6z(tmp0_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.fih_1 = null;
    this.vig_1 = null;
    this.xig_1 = null;
    this.wig_1 = null;
  };
  function LazyLayoutAnimationSpecsNode() {
  }
  var properties_initialized_LazyLayoutItemAnimation_kt_4vo3xf;
  function _init_properties_LazyLayoutItemAnimation_kt__2wnm5d() {
    if (!properties_initialized_LazyLayoutItemAnimation_kt_4vo3xf) {
      properties_initialized_LazyLayoutItemAnimation_kt_4vo3xf = true;
      InterruptionSpec = spring(VOID, 400.0, new IntOffset(get_VisibilityThreshold(Companion_getInstance_21())));
      androidx_compose_foundation_lazy_layout_LazyLayoutItemAnimation$stable = 8;
      androidx_compose_foundation_lazy_layout_LazyLayoutAnimateItemElement$stable = 0;
      androidx_compose_foundation_lazy_layout_LazyLayoutAnimationSpecsNode$stable = 8;
    }
  }
  function get_EmptyArray() {
    _init_properties_LazyLayoutItemAnimator_kt__c458wo();
    return EmptyArray;
  }
  var EmptyArray;
  var androidx_compose_foundation_lazy_layout_LazyLayoutItemAnimator$stable;
  function _get_isRunningPlacement__7osn6j($this) {
    var tmp0 = $this.qj1_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if ((element == null ? null : element.yig_1) === true) {
          tmp$ret$0 = true;
          break $l$block;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function LazyLayoutItemAnimator$ItemInfo$updateAnimation$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.dib_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        invalidateDraw(tmp0_safe_receiver);
      }
      return Unit_instance;
    };
  }
  function removeInfoForKey($this, key) {
    var tmp0_safe_receiver = $this.uia_1.a3(key);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qj1_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element == null)
          null;
        else {
          element.r2v();
        }
      }
    }
  }
  function releaseAnimations($this) {
    if ($this.uia_1.fv()) {
      // Inline function 'androidx.collection.ScatterMap.forEachValue' call
      var this_0 = $this.uia_1;
      var v = this_0.y12_1;
      $l$block: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m = this_0.w12_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    // Inline function 'kotlin.collections.forEach' call
                    var indexedObject = v[index].qj1_1;
                    var inductionVariable_1 = 0;
                    var last = indexedObject.length;
                    while (inductionVariable_1 < last) {
                      var element = indexedObject[inductionVariable_1];
                      inductionVariable_1 = inductionVariable_1 + 1 | 0;
                      if (element == null)
                        null;
                      else {
                        element.r2v();
                      }
                    }
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
      $this.uia_1.c3();
    }
  }
  function initializeAnimation($this, item, mainAxisOffset, itemInfo) {
    itemInfo = itemInfo === VOID ? ensureNotNull($this.uia_1.w2(item.t1())) : itemInfo;
    var firstPlaceableOffset = item.qig(0);
    var tmp;
    if (item.jig()) {
      tmp = IntOffset__copy$default_impl_1y5pbb(firstPlaceableOffset, VOID, mainAxisOffset);
    } else {
      tmp = IntOffset__copy$default_impl_1y5pbb(firstPlaceableOffset, mainAxisOffset);
    }
    var targetFirstPlaceableOffset = tmp;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = itemInfo.qj1_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item_0 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      if (!(item_0 == null)) {
        var diffToFirstPlaceableOffset = IntOffset__minus_impl_4m69hb(item.qig(_unary__edvuaz), firstPlaceableOffset);
        item_0.dih_1 = IntOffset__plus_impl_nqoa9b(targetFirstPlaceableOffset, diffToFirstPlaceableOffset);
      }
    }
  }
  function startPlacementAnimationsIfNeeded($this, item, isMovingAway) {
    isMovingAway = isMovingAway === VOID ? false : isMovingAway;
    var itemInfo = ensureNotNull($this.uia_1.w2(item.t1()));
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = itemInfo.qj1_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item_0 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      if (!(item_0 == null)) {
        var newTarget = item.qig(_unary__edvuaz);
        var currentTarget = item_0.dih_1;
        if (!equals(currentTarget, Companion_getInstance_67().kih_1) && !equals(currentTarget, newTarget)) {
          item_0.nj1(IntOffset__minus_impl_4m69hb(newTarget, currentTarget), isMovingAway);
        }
        item_0.dih_1 = newTarget;
      }
    }
  }
  function updateAndReturnOffsetFor($this, $receiver, item) {
    var lane = item.kig();
    var span = item.lig();
    var maxOffset = 0;
    var inductionVariable = lane;
    var last = lane + span | 0;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $receiver[i] = $receiver[i] + item.mig() | 0;
        var tmp0 = maxOffset;
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = $receiver[i];
        maxOffset = Math.max(tmp0, b);
      }
       while (inductionVariable < last);
    return maxOffset;
  }
  function _get_hasAnimations__pyw8qw($this, $receiver) {
    // Inline function 'kotlin.repeat' call
    var times = $receiver.law();
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (get_specs($receiver.oig(index)) == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return true;
        }
      }
       while (inductionVariable < times);
    return false;
  }
  function _get_mainAxisOffset__tgjb0i($this, $receiver) {
    // Inline function 'kotlin.let' call
    var it = $receiver.qig(0);
    return $receiver.jig() ? _IntOffset___get_y__impl__2avpwj(it) : _IntOffset___get_x__impl__qiqr5o(it);
  }
  function _get_crossAxisOffset__9wyil9($this, $receiver) {
    // Inline function 'kotlin.let' call
    var it = $receiver.qig(0);
    return !$receiver.jig() ? _IntOffset___get_y__impl__2avpwj(it) : _IntOffset___get_x__impl__qiqr5o(it);
  }
  function ItemInfo($outer) {
    this.xj1_1 = $outer;
    this.qj1_1 = get_EmptyArray();
    this.rj1_1 = null;
    this.sj1_1 = 0;
    this.tj1_1 = 0;
    this.uj1_1 = 1;
    this.vj1_1 = 0;
    this.wj1_1 = 0;
  }
  protoOf(ItemInfo).yj1 = function (positionedItem, coroutineScope, graphicsContext, layoutMinOffset, layoutMaxOffset, crossAxisOffset) {
    if (!_get_isRunningPlacement__7osn6j(this)) {
      this.vj1_1 = layoutMinOffset;
      this.wj1_1 = layoutMaxOffset;
    }
    var inductionVariable = positionedItem.law();
    var last = this.qj1_1.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver = this.qj1_1[i];
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.r2v();
        }
      }
       while (inductionVariable < last);
    if (!(this.qj1_1.length === positionedItem.law())) {
      this.qj1_1 = copyOf(this.qj1_1, positionedItem.law());
    }
    this.rj1_1 = positionedItem.vds();
    this.sj1_1 = crossAxisOffset;
    this.tj1_1 = positionedItem.kig();
    this.uj1_1 = positionedItem.lig();
    // Inline function 'kotlin.repeat' call
    var times = positionedItem.law();
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < times)
      do {
        var index = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var specs = get_specs(positionedItem.oig(index));
        if (specs == null) {
          var tmp0_safe_receiver_0 = this.qj1_1[index];
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.r2v();
          }
          this.qj1_1[index] = null;
        } else {
          var tmp1_elvis_lhs = this.qj1_1[index];
          var tmp;
          if (tmp1_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = new LazyLayoutItemAnimation(coroutineScope, graphicsContext, LazyLayoutItemAnimator$ItemInfo$updateAnimation$lambda(this.xj1_1));
            this.qj1_1[index] = this_0;
            tmp = this_0;
          } else {
            tmp = tmp1_elvis_lhs;
          }
          var animation = tmp;
          animation.vig_1 = specs.nj2_1;
          animation.wig_1 = specs.oj2_1;
          animation.xig_1 = specs.pj2_1;
        }
      }
       while (inductionVariable_0 < times);
  };
  protoOf(ItemInfo).qj2 = function (positionedItem, coroutineScope, graphicsContext, layoutMinOffset, layoutMaxOffset, crossAxisOffset, $super) {
    crossAxisOffset = crossAxisOffset === VOID ? _get_crossAxisOffset__9wyil9(this.xj1_1, positionedItem) : crossAxisOffset;
    var tmp;
    if ($super === VOID) {
      this.yj1(positionedItem, coroutineScope, graphicsContext, layoutMinOffset, layoutMaxOffset, crossAxisOffset);
      tmp = Unit_instance;
    } else {
      tmp = $super.yj1.call(this, positionedItem, coroutineScope, graphicsContext, layoutMinOffset, layoutMaxOffset, crossAxisOffset);
    }
    return tmp;
  };
  function DisplayingDisappearingItemsElement(animator) {
    ModifierNodeElement.call(this);
    this.sj2_1 = animator;
  }
  protoOf(DisplayingDisappearingItemsElement).r3d = function () {
    return new DisplayingDisappearingItemsNode(this.sj2_1);
  };
  protoOf(DisplayingDisappearingItemsElement).tj2 = function (node) {
    node.jj3(this.sj2_1);
  };
  protoOf(DisplayingDisappearingItemsElement).d8y = function (node) {
    return this.tj2(node instanceof DisplayingDisappearingItemsNode ? node : THROW_CCE());
  };
  protoOf(DisplayingDisappearingItemsElement).toString = function () {
    return 'DisplayingDisappearingItemsElement(animator=' + toString(this.sj2_1) + ')';
  };
  protoOf(DisplayingDisappearingItemsElement).hashCode = function () {
    return hashCode(this.sj2_1);
  };
  protoOf(DisplayingDisappearingItemsElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DisplayingDisappearingItemsElement))
      return false;
    if (!equals(this.sj2_1, other.sj2_1))
      return false;
    return true;
  };
  function DisplayingDisappearingItemsNode(animator) {
    Node.call(this);
    this.ij3_1 = animator;
  }
  protoOf(DisplayingDisappearingItemsNode).h92 = function (_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.ij3_1.cib_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        $l$block: {
          var tmp0_elvis_lhs = item.fih_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            break $l$block;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var layer = tmp;
          var x = _IntOffset___get_x__impl__qiqr5o(item.eih_1);
          var y = _IntOffset___get_y__impl__2avpwj(item.eih_1);
          var tmp2 = x - _IntOffset___get_x__impl__qiqr5o(layer.k6r_1);
          // Inline function 'androidx.compose.ui.graphics.drawscope.translate' call
          var top = y - _IntOffset___get_y__impl__2avpwj(layer.k6r_1);
          _this__u8e3s4.v6p().p6p().b5d(tmp2, top);
          try {
            drawLayer(_this__u8e3s4, layer);
          }finally {
            _this__u8e3s4.v6p().p6p().b5d(-tmp2, -top);
          }
        }
      }
       while (inductionVariable <= last);
    _this__u8e3s4.z91();
  };
  protoOf(DisplayingDisappearingItemsNode).f8w = function () {
    this.ij3_1.dib_1 = this;
  };
  protoOf(DisplayingDisappearingItemsNode).h8w = function () {
    this.ij3_1.u4c();
  };
  protoOf(DisplayingDisappearingItemsNode).jj3 = function (animator) {
    if (!equals(this.ij3_1, animator)) {
      if (this.m8v_1.z8v_1) {
        this.ij3_1.u4c();
        animator.dib_1 = this;
        this.ij3_1 = animator;
      }
    }
  };
  protoOf(DisplayingDisappearingItemsNode).toString = function () {
    return 'DisplayingDisappearingItemsNode(animator=' + toString(this.ij3_1) + ')';
  };
  protoOf(DisplayingDisappearingItemsNode).hashCode = function () {
    return hashCode(this.ij3_1);
  };
  protoOf(DisplayingDisappearingItemsNode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DisplayingDisappearingItemsNode))
      return false;
    if (!equals(this.ij3_1, other.ij3_1))
      return false;
    return true;
  };
  function sam$kotlin_Comparator$0(function_0) {
    this.kj3_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).ze = function (a, b) {
    return this.kj3_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).q3 = function () {
    return this.kj3_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function LazyLayoutItemAnimator$onMeasured$lambda($previousKeyToIndexMap) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp = $previousKeyToIndexMap.xif(b.t1());
      var tmp$ret$2 = $previousKeyToIndexMap.xif(a.t1());
      return compareValues(tmp, tmp$ret$2);
    };
  }
  function LazyLayoutItemAnimator$onMeasured$lambda_0($previousKeyToIndexMap) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp = $previousKeyToIndexMap.xif(a.t1());
      var tmp$ret$2 = $previousKeyToIndexMap.xif(b.t1());
      return compareValues(tmp, tmp$ret$2);
    };
  }
  function LazyLayoutItemAnimator$onMeasured$lambda_1($keyIndexMap) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp = $keyIndexMap.xif(b.t1());
      var tmp$ret$2 = $keyIndexMap.xif(a.t1());
      return compareValues(tmp, tmp$ret$2);
    };
  }
  function LazyLayoutItemAnimator$onMeasured$lambda_2($keyIndexMap) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp = $keyIndexMap.xif(a.t1());
      var tmp$ret$2 = $keyIndexMap.xif(b.t1());
      return compareValues(tmp, tmp$ret$2);
    };
  }
  function LazyLayoutItemAnimator() {
    this.uia_1 = mutableScatterMapOf();
    this.via_1 = null;
    this.wia_1 = 0;
    this.xia_1 = mutableScatterSetOf();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.yia_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.zia_1 = ArrayList_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_1.aib_1 = ArrayList_init_$Create$();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_2.bib_1 = ArrayList_init_$Create$();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_3.cib_1 = ArrayList_init_$Create$();
    this.dib_1 = null;
    this.eib_1 = new DisplayingDisappearingItemsElement(this);
  }
  protoOf(LazyLayoutItemAnimator).cig = function (consumedScroll, layoutWidth, layoutHeight, positionedItems, keyIndexMap, itemProvider, isVertical, isLookingAhead, laneCount, hasLookaheadOccurred, layoutMinOffset, layoutMaxOffset, coroutineScope, graphicsContext) {
    var previousKeyToIndexMap = this.via_1;
    this.via_1 = keyIndexMap;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = positionedItems.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = positionedItems.l1(index);
          if (_get_hasAnimations__pyw8qw(this, item)) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = false;
    }
    var hasAnimations = tmp$ret$0;
    if (!hasAnimations && this.uia_1.r()) {
      releaseAnimations(this);
      return Unit_instance;
    }
    var previousFirstVisibleIndex = this.wia_1;
    var tmp = this;
    var tmp0_safe_receiver = firstOrNull(positionedItems);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bi0();
    tmp.wia_1 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp_0;
    if (isVertical) {
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(consumedScroll), new Long(-1, 0)));
      tmp_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$5);
    } else {
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var tmp$ret$7 = bitwiseOr(shiftLeft(fromInt(consumedScroll), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
      tmp_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$7);
    }
    var scrollOffset = tmp_0;
    var shouldSetupAnimation = isLookingAhead || !hasLookaheadOccurred;
    // Inline function 'androidx.collection.ScatterMap.forEachKey' call
    var this_0 = this.uia_1;
    var k = this_0.x12_1;
    $l$block_0: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= lastIndex)
        do {
          var i = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$10 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$10, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < bitCount)
              do {
                var j = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index_0 = (i << 3) + j | 0;
                  var it = k[index_0];
                  this.xia_1.j1(it);
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_1 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block_0;
            }
          }
        }
         while (!(i === lastIndex));
    }
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable_2 = 0;
    var last_0 = positionedItems.n1() - 1 | 0;
    if (inductionVariable_2 <= last_0)
      do {
        var index_1 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        var item_0 = positionedItems.l1(index_1);
        this.xia_1.d3(item_0.t1());
        if (_get_hasAnimations__pyw8qw(this, item_0)) {
          var itemInfo = this.uia_1.w2(item_0.t1());
          var tmp1_elvis_lhs_0 = previousKeyToIndexMap == null ? null : previousKeyToIndexMap.xif(item_0.t1());
          var previousIndex = tmp1_elvis_lhs_0 == null ? -1 : tmp1_elvis_lhs_0;
          var shouldAnimateAppearance = previousIndex === -1 && !(previousKeyToIndexMap == null);
          if (itemInfo == null) {
            var newItemInfo = new ItemInfo(this);
            newItemInfo.qj2(item_0, coroutineScope, graphicsContext, layoutMinOffset, layoutMaxOffset);
            this.uia_1.h13(item_0.t1(), newItemInfo);
            if (!(item_0.bi0() === previousIndex) && !(previousIndex === -1)) {
              if (previousIndex < previousFirstVisibleIndex) {
                this.yia_1.j1(item_0);
              } else {
                this.zia_1.j1(item_0);
              }
            } else {
              // Inline function 'kotlin.let' call
              var it_0 = item_0.qig(0);
              var tmp$ret$16 = item_0.jig() ? _IntOffset___get_y__impl__2avpwj(it_0) : _IntOffset___get_x__impl__qiqr5o(it_0);
              initializeAnimation(this, item_0, tmp$ret$16, newItemInfo);
              if (shouldAnimateAppearance) {
                // Inline function 'kotlin.collections.forEach' call
                var indexedObject = newItemInfo.qj1_1;
                var inductionVariable_3 = 0;
                var last_1 = indexedObject.length;
                while (inductionVariable_3 < last_1) {
                  var element = indexedObject[inductionVariable_3];
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  if (element == null)
                    null;
                  else {
                    element.oj1();
                  }
                }
              }
            }
          } else {
            if (shouldSetupAnimation) {
              itemInfo.qj2(item_0, coroutineScope, graphicsContext, layoutMinOffset, layoutMaxOffset);
              // Inline function 'kotlin.collections.forEach' call
              var indexedObject_0 = itemInfo.qj1_1;
              var inductionVariable_4 = 0;
              var last_2 = indexedObject_0.length;
              while (inductionVariable_4 < last_2) {
                var element_0 = indexedObject_0[inductionVariable_4];
                inductionVariable_4 = inductionVariable_4 + 1 | 0;
                if (!(element_0 == null) && !equals(element_0.dih_1, Companion_getInstance_67().kih_1)) {
                  element_0.dih_1 = IntOffset__plus_impl_nqoa9b(element_0.dih_1, scrollOffset);
                }
              }
              if (shouldAnimateAppearance) {
                // Inline function 'kotlin.collections.forEach' call
                var indexedObject_1 = itemInfo.qj1_1;
                var inductionVariable_5 = 0;
                var last_3 = indexedObject_1.length;
                while (inductionVariable_5 < last_3) {
                  var element_1 = indexedObject_1[inductionVariable_5];
                  inductionVariable_5 = inductionVariable_5 + 1 | 0;
                  if (!(element_1 == null)) {
                    if (element_1.aiy()) {
                      this.cib_1.d3(element_1);
                      var tmp0_safe_receiver_0 = this.dib_1;
                      if (tmp0_safe_receiver_0 == null)
                        null;
                      else {
                        invalidateDraw(tmp0_safe_receiver_0);
                      }
                    }
                    element_1.oj1();
                  }
                }
              }
              startPlacementAnimationsIfNeeded(this, item_0);
            }
          }
        } else {
          removeInfoForKey(this, item_0.t1());
        }
      }
       while (inductionVariable_2 <= last_0);
    var accumulatedOffsetPerLane = new Int32Array(laneCount);
    if (shouldSetupAnimation && !(previousKeyToIndexMap == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.yia_1.r()) {
        // Inline function 'kotlin.collections.sortByDescending' call
        var this_2 = this.yia_1;
        if (this_2.n1() > 1) {
          // Inline function 'kotlin.comparisons.compareByDescending' call
          var tmp_1 = LazyLayoutItemAnimator$onMeasured$lambda(previousKeyToIndexMap);
          var tmp$ret$26 = new sam$kotlin_Comparator$0(tmp_1);
          sortWith(this_2, tmp$ret$26);
        }
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var this_3 = this.yia_1;
        var inductionVariable_6 = 0;
        var last_4 = this_3.n1() - 1 | 0;
        if (inductionVariable_6 <= last_4)
          do {
            var index_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + 1 | 0;
            var item_1 = this_3.l1(index_2);
            var accumulatedOffset = updateAndReturnOffsetFor(this, accumulatedOffsetPerLane, item_1);
            var mainAxisOffset = layoutMinOffset - accumulatedOffset | 0;
            initializeAnimation(this, item_1, mainAxisOffset);
            startPlacementAnimationsIfNeeded(this, item_1);
          }
           while (inductionVariable_6 <= last_4);
        fill(accumulatedOffsetPerLane, 0);
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.zia_1.r()) {
        // Inline function 'kotlin.collections.sortBy' call
        var this_4 = this.zia_1;
        if (this_4.n1() > 1) {
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp_2 = LazyLayoutItemAnimator$onMeasured$lambda_0(previousKeyToIndexMap);
          var tmp$ret$31 = new sam$kotlin_Comparator$0(tmp_2);
          sortWith(this_4, tmp$ret$31);
        }
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var this_5 = this.zia_1;
        var inductionVariable_7 = 0;
        var last_5 = this_5.n1() - 1 | 0;
        if (inductionVariable_7 <= last_5)
          do {
            var index_3 = inductionVariable_7;
            inductionVariable_7 = inductionVariable_7 + 1 | 0;
            var item_2 = this_5.l1(index_3);
            var accumulatedOffset_0 = updateAndReturnOffsetFor(this, accumulatedOffsetPerLane, item_2);
            var mainAxisOffset_0 = (layoutMaxOffset + accumulatedOffset_0 | 0) - item_2.mig() | 0;
            initializeAnimation(this, item_2, mainAxisOffset_0);
            startPlacementAnimationsIfNeeded(this, item_2);
          }
           while (inductionVariable_7 <= last_5);
        fill(accumulatedOffsetPerLane, 0);
      }
    }
    // Inline function 'androidx.collection.ScatterSet.forEach' call
    var this_6 = this.xia_1;
    // Inline function 'kotlin.contracts.contract' call
    var elements = this_6.k16_1;
    $l$block_3: {
      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m_0 = this_6.j16_1;
      var lastIndex_0 = m_0.length - 2 | 0;
      var inductionVariable_8 = 0;
      if (inductionVariable_8 <= lastIndex_0)
        do {
          var i_0 = inductionVariable_8;
          inductionVariable_8 = inductionVariable_8 + 1 | 0;
          var slot_0 = m_0[i_0];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_7 = slot_0;
          var tmp$ret$38 = bitwiseAnd(bitwiseAnd(this_7, shiftLeft(invert(this_7), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$38, new Long(-2139062144, -2139062144))) {
            var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
            var inductionVariable_9 = 0;
            if (inductionVariable_9 < bitCount_0)
              do {
                var j_0 = inductionVariable_9;
                inductionVariable_9 = inductionVariable_9 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                if (compare(value_0, new Long(128, 0)) < 0) {
                  var index_4 = (i_0 << 3) + j_0 | 0;
                  var tmp0 = elements[index_4];
                  $l$block_1: {
                    var tmp0_elvis_lhs = this.uia_1.w2(tmp0);
                    var tmp_3;
                    if (tmp0_elvis_lhs == null) {
                      break $l$block_1;
                    } else {
                      tmp_3 = tmp0_elvis_lhs;
                    }
                    var info = tmp_3;
                    var newIndex = keyIndexMap.xif(tmp0);
                    var tmp_4 = info;
                    // Inline function 'kotlin.comparisons.minOf' call
                    var b = info.uj1_1;
                    tmp_4.uj1_1 = Math.min(laneCount, b);
                    var tmp_5 = info;
                    var tmp0_0 = laneCount - info.uj1_1 | 0;
                    // Inline function 'kotlin.comparisons.minOf' call
                    var b_0 = info.tj1_1;
                    tmp_5.tj1_1 = Math.min(tmp0_0, b_0);
                    if (newIndex === -1) {
                      var isProgress = false;
                      // Inline function 'kotlin.collections.forEachIndexed' call
                      var index_5 = 0;
                      var indexedObject_2 = info.qj1_1;
                      var inductionVariable_10 = 0;
                      var last_6 = indexedObject_2.length;
                      while (inductionVariable_10 < last_6) {
                        var item_3 = indexedObject_2[inductionVariable_10];
                        inductionVariable_10 = inductionVariable_10 + 1 | 0;
                        var _unary__edvuaz = index_5;
                        index_5 = _unary__edvuaz + 1 | 0;
                        if (!(item_3 == null)) {
                          if (item_3.aiy()) {
                            isProgress = true;
                          } else if (item_3.biy()) {
                            item_3.r2v();
                            info.qj1_1[_unary__edvuaz] = null;
                            this.cib_1.d3(item_3);
                            var tmp0_safe_receiver_1 = this.dib_1;
                            if (tmp0_safe_receiver_1 == null)
                              null;
                            else {
                              invalidateDraw(tmp0_safe_receiver_1);
                            }
                          } else {
                            if (!(item_3.fih_1 == null)) {
                              item_3.pj1();
                            }
                            if (item_3.aiy()) {
                              this.cib_1.j1(item_3);
                              var tmp1_safe_receiver = this.dib_1;
                              if (tmp1_safe_receiver == null)
                                null;
                              else {
                                invalidateDraw(tmp1_safe_receiver);
                              }
                              isProgress = true;
                            } else {
                              item_3.r2v();
                              info.qj1_1[_unary__edvuaz] = null;
                            }
                          }
                        }
                      }
                      if (!isProgress) {
                        removeInfoForKey(this, tmp0);
                      }
                    } else {
                      var tmp_6 = info.rj1_1;
                      var tmp1_constraints = ensureNotNull(tmp_6 == null ? null : new Constraints(tmp_6)).m5e_1;
                      var tmp2_lane = info.tj1_1;
                      var tmp3_span = info.uj1_1;
                      var item_4 = itemProvider.sid(newIndex, tmp2_lane, tmp3_span, tmp1_constraints);
                      item_4.nig(true);
                      var tmp0_1 = info.qj1_1;
                      var tmp$ret$46;
                      $l$block_2: {
                        // Inline function 'kotlin.collections.any' call
                        var inductionVariable_11 = 0;
                        var last_7 = tmp0_1.length;
                        while (inductionVariable_11 < last_7) {
                          var element_2 = tmp0_1[inductionVariable_11];
                          inductionVariable_11 = inductionVariable_11 + 1 | 0;
                          if ((element_2 == null ? null : element_2.yix()) === true) {
                            tmp$ret$46 = true;
                            break $l$block_2;
                          }
                        }
                        tmp$ret$46 = false;
                      }
                      var inProgress = tmp$ret$46;
                      var tmp_7;
                      if (!inProgress) {
                        tmp_7 = newIndex === (previousKeyToIndexMap == null ? null : previousKeyToIndexMap.xif(tmp0));
                      } else {
                        tmp_7 = false;
                      }
                      if (tmp_7) {
                        removeInfoForKey(this, tmp0);
                      } else {
                        info.yj1(item_4, coroutineScope, graphicsContext, layoutMinOffset, layoutMaxOffset, info.sj1_1);
                        if (newIndex < this.wia_1) {
                          this.aib_1.j1(item_4);
                        } else {
                          this.bib_1.j1(item_4);
                        }
                      }
                    }
                  }
                }
                slot_0 = shiftRight(slot_0, 8);
              }
               while (inductionVariable_9 < bitCount_0);
            if (!(bitCount_0 === 8)) {
              break $l$block_3;
            }
          }
        }
         while (!(i_0 === lastIndex_0));
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.aib_1.r()) {
      // Inline function 'kotlin.collections.sortByDescending' call
      var this_8 = this.aib_1;
      if (this_8.n1() > 1) {
        // Inline function 'kotlin.comparisons.compareByDescending' call
        var tmp_8 = LazyLayoutItemAnimator$onMeasured$lambda_1(keyIndexMap);
        var tmp$ret$50 = new sam$kotlin_Comparator$0(tmp_8);
        sortWith(this_8, tmp$ret$50);
      }
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_9 = this.aib_1;
      var inductionVariable_12 = 0;
      var last_8 = this_9.n1() - 1 | 0;
      if (inductionVariable_12 <= last_8)
        do {
          var index_6 = inductionVariable_12;
          inductionVariable_12 = inductionVariable_12 + 1 | 0;
          var item_5 = this_9.l1(index_6);
          var itemInfo_0 = ensureNotNull(this.uia_1.w2(item_5.t1()));
          var accumulatedOffset_1 = updateAndReturnOffsetFor(this, accumulatedOffsetPerLane, item_5);
          var tmp_9;
          if (isLookingAhead) {
            tmp_9 = _get_mainAxisOffset__tgjb0i(this, first(positionedItems));
          } else {
            tmp_9 = itemInfo_0.vj1_1;
          }
          var mainAxisOffset_1 = tmp_9 - accumulatedOffset_1 | 0;
          item_5.pig(mainAxisOffset_1, itemInfo_0.sj1_1, layoutWidth, layoutHeight);
          if (shouldSetupAnimation) {
            startPlacementAnimationsIfNeeded(this, item_5, true);
          }
        }
         while (inductionVariable_12 <= last_8);
      fill(accumulatedOffsetPerLane, 0);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.bib_1.r()) {
      // Inline function 'kotlin.collections.sortBy' call
      var this_10 = this.bib_1;
      if (this_10.n1() > 1) {
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_10 = LazyLayoutItemAnimator$onMeasured$lambda_2(keyIndexMap);
        var tmp$ret$55 = new sam$kotlin_Comparator$0(tmp_10);
        sortWith(this_10, tmp$ret$55);
      }
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_11 = this.bib_1;
      var inductionVariable_13 = 0;
      var last_9 = this_11.n1() - 1 | 0;
      if (inductionVariable_13 <= last_9)
        do {
          var index_7 = inductionVariable_13;
          inductionVariable_13 = inductionVariable_13 + 1 | 0;
          var item_6 = this_11.l1(index_7);
          var itemInfo_1 = ensureNotNull(this.uia_1.w2(item_6.t1()));
          var accumulatedOffset_2 = updateAndReturnOffsetFor(this, accumulatedOffsetPerLane, item_6);
          var mainAxisOffset_2 = (itemInfo_1.wj1_1 - item_6.mig() | 0) + accumulatedOffset_2 | 0;
          item_6.pig(mainAxisOffset_2, itemInfo_1.sj1_1, layoutWidth, layoutHeight);
          if (shouldSetupAnimation) {
            startPlacementAnimationsIfNeeded(this, item_6, true);
          }
        }
         while (inductionVariable_13 <= last_9);
    }
    // Inline function 'kotlin.apply' call
    var this_12 = this.aib_1;
    reverse(this_12);
    positionedItems.e3(0, this_12);
    positionedItems.o1(this.bib_1);
    this.yia_1.c3();
    this.zia_1.c3();
    this.aib_1.c3();
    this.bib_1.c3();
    this.xia_1.c3();
  };
  protoOf(LazyLayoutItemAnimator).u4c = function () {
    releaseAnimations(this);
    this.via_1 = null;
    this.wia_1 = -1;
  };
  protoOf(LazyLayoutItemAnimator).rig = function (key, placeableIndex) {
    var tmp0_safe_receiver = this.uia_1.w2(key);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qj1_1;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver[placeableIndex];
  };
  protoOf(LazyLayoutItemAnimator).dig = function () {
    var size = Companion_getInstance_22().n5g_1;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.cib_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        var layer = item.fih_1;
        if (!(layer == null)) {
          // Inline function 'androidx.compose.ui.unit.IntSize.width' call
          var this_1 = size;
          // Inline function 'androidx.compose.ui.util.unpackInt1' call
          var value = _IntSize___get_packedValue__impl__uho7jf(this_1);
          var tmp0 = convertToInt(shiftRight(value, 32));
          var tmp = _IntOffset___get_x__impl__qiqr5o(item.dih_1);
          // Inline function 'androidx.compose.ui.unit.IntSize.width' call
          var this_2 = layer.l6r_1;
          // Inline function 'androidx.compose.ui.util.unpackInt1' call
          var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_2);
          // Inline function 'kotlin.comparisons.maxOf' call
          var b = tmp + convertToInt(shiftRight(value_0, 32)) | 0;
          var tmp0_0 = Math.max(tmp0, b);
          // Inline function 'androidx.compose.ui.unit.IntSize.height' call
          var this_3 = size;
          // Inline function 'androidx.compose.ui.util.unpackInt2' call
          var value_1 = _IntSize___get_packedValue__impl__uho7jf(this_3);
          var tmp0_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
          var tmp_0 = _IntOffset___get_y__impl__2avpwj(item.dih_1);
          // Inline function 'androidx.compose.ui.unit.IntSize.height' call
          var this_4 = layer.l6r_1;
          // Inline function 'androidx.compose.ui.util.unpackInt2' call
          var value_2 = _IntSize___get_packedValue__impl__uho7jf(this_4);
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_0 = tmp_0 + convertToInt(bitwiseAnd(value_2, new Long(-1, 0))) | 0;
          // Inline function 'androidx.compose.ui.unit.IntSize' call
          // Inline function 'androidx.compose.ui.util.packInts' call
          var val2 = Math.max(tmp0_1, b_0);
          var tmp$ret$13 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
          size = _IntSize___init__impl__emcjft(tmp$ret$13);
        }
      }
       while (inductionVariable <= last);
    return size;
  };
  function get_specs(_this__u8e3s4) {
    _init_properties_LazyLayoutItemAnimator_kt__c458wo();
    return _this__u8e3s4 instanceof LazyLayoutAnimationSpecsNode ? _this__u8e3s4 : null;
  }
  var properties_initialized_LazyLayoutItemAnimator_kt_ie901m;
  function _init_properties_LazyLayoutItemAnimator_kt__c458wo() {
    if (!properties_initialized_LazyLayoutItemAnimator_kt_ie901m) {
      properties_initialized_LazyLayoutItemAnimator_kt_ie901m = true;
      // Inline function 'kotlin.emptyArray' call
      EmptyArray = [];
      androidx_compose_foundation_lazy_layout_LazyLayoutItemAnimator$stable = 8;
    }
  }
  var androidx_compose_foundation_lazy_layout_LazyLayoutItemContentFactory$stable;
  function createContentLambda($this) {
    return ComposableLambda$invoke$ref_1(composableLambdaInstance(818252804, true, LazyLayoutItemContentFactory$CachedItemContent$createContentLambda$lambda($this.pj3_1, $this)));
  }
  function LazyLayoutItemContentFactory$CachedItemContent$createContentLambda$1$1$$inlined$cache$1$1(this$0) {
    this.qj3_1 = this$0;
  }
  protoOf(LazyLayoutItemContentFactory$CachedItemContent$createContentLambda$1$1$$inlined$cache$1$1).s1d = function () {
    this.qj3_1.oj3_1 = null;
  };
  function LazyLayoutItemContentFactory$CachedItemContent$createContentLambda$lambda$lambda(this$0) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new LazyLayoutItemContentFactory$CachedItemContent$createContentLambda$1$1$$inlined$cache$1$1(this$0);
    };
  }
  function LazyLayoutItemContentFactory$CachedItemContent$createContentLambda$lambda(this$0, this$1) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var itemProvider = this$0.diw_1();
        var index = this$1.nj3_1;
        if (index >= itemProvider.aie() || !equals(itemProvider.jif(index), this$1.lj3_1)) {
          index = itemProvider.xif(this$1.lj3_1);
          if (!(index === -1))
            this$1.nj3_1 = index;
        }
        if (!(index === -1)) {
          $composer_0.m30(-1664741271);
          SkippableItem(itemProvider, _StableValue___init__impl__8rwrjx(this$0.ciw_1), index, _StableValue___init__impl__8rwrjx(this$1.lj3_1), $composer_0, 0);
          $composer_0.n30();
        } else {
          $composer_0.m30(-1664505826);
          $composer_0.n30();
        }
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31(this$1);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance_11().f30_1) {
          var value = LazyLayoutItemContentFactory$CachedItemContent$createContentLambda$lambda$lambda(this$1);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$0 = tmp_0;
        DisposableEffect_0(this$1.lj3_1, tmp$ret$0, $composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CachedItemContent($outer, index, key, contentType) {
    this.pj3_1 = $outer;
    this.lj3_1 = key;
    this.mj3_1 = contentType;
    this.nj3_1 = index;
    this.oj3_1 = null;
  }
  protoOf(CachedItemContent).rj3 = function () {
    var tmp0_elvis_lhs = this.oj3_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = createContentLambda(this);
      this.oj3_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  function LazyLayoutItemContentFactory(saveableStateHolder, itemProvider) {
    this.ciw_1 = saveableStateHolder;
    this.diw_1 = itemProvider;
    this.eiw_1 = mutableScatterMapOf();
  }
  protoOf(LazyLayoutItemContentFactory).fiw = function (key) {
    if (key == null)
      return null;
    var cachedContent = this.eiw_1.w2(key);
    var tmp;
    if (!(cachedContent == null)) {
      tmp = cachedContent.mj3_1;
    } else {
      var itemProvider = this.diw_1();
      var index = itemProvider.xif(key);
      var tmp_0;
      if (!(index === -1)) {
        tmp_0 = itemProvider.kif(index);
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(LazyLayoutItemContentFactory).sj3 = function (index, key, contentType) {
    var cached = this.eiw_1.w2(key);
    var tmp;
    if (!(cached == null) && cached.nj3_1 === index && equals(cached.mj3_1, contentType)) {
      tmp = cached.rj3();
    } else {
      var newContent = new CachedItemContent(this, index, key, contentType);
      this.eiw_1.h13(key, newContent);
      tmp = newContent.rj3();
    }
    return tmp;
  };
  function SkippableItem(itemProvider, saveableStateHolder, index, key, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1439843069);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(itemProvider) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(_StableValue___get_value__impl__cutoif(saveableStateHolder)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.m31(index) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(_StableValue___get_value__impl__cutoif(key)) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      var tmp = _StableValue___get_value__impl__cutoif(saveableStateHolder);
      var tmp_0 = _StableValue___get_value__impl__cutoif(key);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(980966366, true, SkippableItem$lambda(itemProvider, index, key), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_1;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp$ret$0 = tmp_1;
      tmp.x7o(tmp_0, tmp$ret$0, $composer_0, 48);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(SkippableItem$lambda_0(itemProvider, saveableStateHolder, index, key, $changed));
    }
  }
  function _StableValue___init__impl__8rwrjx(value) {
    return value;
  }
  function _StableValue___get_value__impl__cutoif($this) {
    return $this;
  }
  function SkippableItem$lambda($itemProvider, $index, $key) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        $itemProvider.wif($index, _StableValue___get_value__impl__cutoif($key), $composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SkippableItem$lambda_0($itemProvider, $saveableStateHolder, $index, $key, $$changed) {
    return function ($composer, $force) {
      SkippableItem($itemProvider, $saveableStateHolder, $index, $key, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function findIndexByKey(_this__u8e3s4, key, lastKnownIndex) {
    if (key == null || _this__u8e3s4.aie() === 0) {
      return lastKnownIndex;
    }
    if (lastKnownIndex < _this__u8e3s4.aie() && equals(key, _this__u8e3s4.jif(lastKnownIndex))) {
      return lastKnownIndex;
    }
    var newIndex = _this__u8e3s4.xif(key);
    if (!(newIndex === -1)) {
      return newIndex;
    }
    return lastKnownIndex;
  }
  function LazyLayoutItemProvider() {
  }
  var androidx_compose_foundation_lazy_layout_NearestRangeKeyIndexMap$stable;
  function NearestRangeKeyIndexMap$lambda($first, $last, $map, this$0) {
    return function (it) {
      var keyFactory = it.vif_1.t1();
      var tmp0 = $first;
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = it.tif_1;
      var start = Math.max(tmp0, b);
      var tmp0_0 = $last;
      // Inline function 'kotlin.comparisons.minOf' call
      var b_0 = (it.tif_1 + it.uif_1 | 0) - 1 | 0;
      var end = Math.min(tmp0_0, b_0);
      var inductionVariable = start;
      var tmp;
      if (inductionVariable <= end) {
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1_elvis_lhs = keyFactory == null ? null : keyFactory(i - it.tif_1 | 0);
          var key = tmp1_elvis_lhs == null ? getDefaultLazyLayoutKey(i) : tmp1_elvis_lhs;
          $map.oz(key, i);
          this$0.uj3_1[i - this$0.vj3_1 | 0] = key;
        }
         while (!(i === end));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NearestRangeKeyIndexMap(nearestRange, intervalContent) {
    var list = intervalContent.eif();
    var first = nearestRange.x1_1;
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(first >= 0)) {
      var tmp$ret$1 = 'negative nearestRange.first';
      throwIllegalStateException(tmp$ret$1);
    }
    var tmp0 = nearestRange.y1_1;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = list.n1() - 1 | 0;
    var last = Math.min(tmp0, b);
    if (last < first) {
      this.tj3_1 = emptyObjectIntMap();
      var tmp = this;
      // Inline function 'kotlin.emptyArray' call
      tmp.uj3_1 = [];
      this.vj3_1 = 0;
    } else {
      var size = (last - first | 0) + 1 | 0;
      var tmp_0 = this;
      // Inline function 'kotlin.arrayOfNulls' call
      tmp_0.uj3_1 = Array(size);
      this.vj3_1 = first;
      var tmp_1 = this;
      // Inline function 'kotlin.also' call
      var this_0 = new MutableObjectIntMap(size);
      list.ziv(first, last, NearestRangeKeyIndexMap$lambda(first, last, this_0, this));
      tmp_1.tj3_1 = this_0;
    }
  }
  protoOf(NearestRangeKeyIndexMap).xif = function (key) {
    var tmp0 = this.tj3_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.collection.ObjectIntMap.getOrElse' call
      var index = tmp0.cz(key);
      if (index >= 0) {
        tmp$ret$0 = tmp0.fz_1[index];
        break $l$block;
      }
      tmp$ret$0 = -1;
    }
    return tmp$ret$0;
  };
  protoOf(NearestRangeKeyIndexMap).jif = function (index) {
    var tmp0 = this.uj3_1;
    // Inline function 'kotlin.collections.getOrElse' call
    var index_0 = index - this.vj3_1 | 0;
    var tmp;
    if (0 <= index_0 ? index_0 <= (tmp0.length - 1 | 0) : false) {
      tmp = tmp0[index_0];
    } else {
      tmp = null;
    }
    return tmp;
  };
  function LazyLayoutMeasurePolicy() {
  }
  var androidx_compose_foundation_lazy_layout_LazyLayoutMeasureScopeImpl$stable;
  function LazyLayoutMeasureScopeImpl(itemContentFactory, subcomposeMeasureScope) {
    this.wj3_1 = itemContentFactory;
    this.xj3_1 = subcomposeMeasureScope;
    this.yj3_1 = this.wj3_1.diw_1();
    this.zj3_1 = mutableIntObjectMapOf();
    this.aj4_1 = mutableIntObjectMapOf();
  }
  protoOf(LazyLayoutMeasureScopeImpl).nih = function (index) {
    var cachedMeasurable = this.aj4_1.l1(index);
    if (!(cachedMeasurable == null)) {
      return cachedMeasurable;
    } else {
      var key = this.yj3_1.jif(index);
      var contentType = this.yj3_1.kif(index);
      var itemContent = this.wj3_1.sj3(index, key, contentType);
      // Inline function 'kotlin.also' call
      var this_0 = this.xj3_1.aaw(key, itemContent);
      this.aj4_1.ew(index, this_0);
      return this_0;
    }
  };
  protoOf(LazyLayoutMeasureScopeImpl).b5f = function (_this__u8e3s4) {
    // Inline function 'kotlin.with' call
    return this.xj3_1.b5f(_this__u8e3s4);
  };
  protoOf(LazyLayoutMeasureScopeImpl).d5f = function (_this__u8e3s4) {
    // Inline function 'kotlin.with' call
    return this.xj3_1.d5f(_this__u8e3s4);
  };
  protoOf(LazyLayoutMeasureScopeImpl).e5f = function (_this__u8e3s4) {
    // Inline function 'kotlin.with' call
    return this.xj3_1.e5f(_this__u8e3s4);
  };
  protoOf(LazyLayoutMeasureScopeImpl).f5f = function (_this__u8e3s4) {
    // Inline function 'kotlin.with' call
    return this.xj3_1.f5f(_this__u8e3s4);
  };
  protoOf(LazyLayoutMeasureScopeImpl).g5f = function (_this__u8e3s4) {
    // Inline function 'kotlin.with' call
    return this.xj3_1.g5f(_this__u8e3s4);
  };
  protoOf(LazyLayoutMeasureScopeImpl).kag = function (width, height, alignmentLines, placementBlock) {
    return this.xj3_1.kag(width, height, alignmentLines, placementBlock);
  };
  protoOf(LazyLayoutMeasureScopeImpl).hag = function (width, height, alignmentLines, rulers, placementBlock) {
    return this.xj3_1.hag(width, height, alignmentLines, rulers, placementBlock);
  };
  protoOf(LazyLayoutMeasureScopeImpl).r6p = function () {
    return this.xj3_1.r6p();
  };
  protoOf(LazyLayoutMeasureScopeImpl).jag = function () {
    return this.xj3_1.jag();
  };
  protoOf(LazyLayoutMeasureScopeImpl).v5e = function (_this__u8e3s4) {
    return this.xj3_1.v5e(_this__u8e3s4);
  };
  protoOf(LazyLayoutMeasureScopeImpl).x5e = function (_this__u8e3s4) {
    return this.xj3_1.x5e(_this__u8e3s4);
  };
  protoOf(LazyLayoutMeasureScopeImpl).w5e = function (_this__u8e3s4) {
    return this.xj3_1.w5e(_this__u8e3s4);
  };
  protoOf(LazyLayoutMeasureScopeImpl).c5f = function (_this__u8e3s4) {
    return this.xj3_1.c5f(_this__u8e3s4);
  };
  protoOf(LazyLayoutMeasureScopeImpl).u5e = function () {
    return this.xj3_1.u5e();
  };
  protoOf(LazyLayoutMeasureScopeImpl).j5f = function () {
    return this.xj3_1.j5f();
  };
  function get_LazyLayoutMeasuredItemIndexComparator() {
    _init_properties_LazyLayoutMeasuredItem_kt__wd7sy1();
    return LazyLayoutMeasuredItemIndexComparator;
  }
  var LazyLayoutMeasuredItemIndexComparator;
  var androidx_compose_foundation_lazy_layout_LazyLayoutMeasuredItemProvider$stable;
  function LazyLayoutMeasuredItem() {
  }
  function LazyLayoutMeasuredItemProvider() {
    this.xid_1 = mutableIntObjectMapOf();
  }
  protoOf(LazyLayoutMeasuredItemProvider).yid = function (_this__u8e3s4, index, constraints) {
    var cachedPlaceable = this.xid_1.l1(index);
    var tmp;
    if (!(cachedPlaceable == null)) {
      tmp = cachedPlaceable;
    } else {
      var measurables = _this__u8e3s4.nih(index);
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = measurables.n1();
      var list = ArrayList_init_$Create$_0(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4 = measurables.l1(index_0).h8y(constraints);
          list.j1(tmp$ret$4);
        }
         while (inductionVariable < size);
      // Inline function 'kotlin.also' call
      this.xid_1.ew(index, list);
      tmp = list;
    }
    return tmp;
  };
  function updatedVisibleItems(firstVisibleIndex, lastVisibleIndex, positionedItems, stickingItems) {
    _init_properties_LazyLayoutMeasuredItem_kt__wd7sy1();
    if (positionedItems.r())
      return emptyList();
    var finalVisibleItems = toMutableList(stickingItems);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = positionedItems.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = positionedItems.l1(index);
        var containsArg = item.bi0();
        if (firstVisibleIndex <= containsArg ? containsArg <= lastVisibleIndex : false) {
          finalVisibleItems.j1(item);
        }
      }
       while (inductionVariable <= last);
    sortWith(finalVisibleItems, get_LazyLayoutMeasuredItemIndexComparator());
    return finalVisibleItems;
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.bj4_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).ze = function (a, b) {
    return this.bj4_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).q3 = function () {
    return this.bj4_1;
  };
  protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function LazyLayoutMeasuredItemIndexComparator$lambda(a, b) {
    _init_properties_LazyLayoutMeasuredItem_kt__wd7sy1();
    return compareTo(a.bi0(), b.bi0());
  }
  var properties_initialized_LazyLayoutMeasuredItem_kt_z5sk07;
  function _init_properties_LazyLayoutMeasuredItem_kt__wd7sy1() {
    if (!properties_initialized_LazyLayoutMeasuredItem_kt_z5sk07) {
      properties_initialized_LazyLayoutMeasuredItem_kt_z5sk07 = true;
      var tmp = LazyLayoutMeasuredItemIndexComparator$lambda;
      LazyLayoutMeasuredItemIndexComparator = new sam$kotlin_Comparator$0_0(tmp);
      androidx_compose_foundation_lazy_layout_LazyLayoutMeasuredItemProvider$stable = 8;
    }
  }
  var androidx_compose_foundation_lazy_layout_LazyLayoutNearestRangeState$stable;
  function calculateNearestItemsRange($this, firstVisibleItem, slidingWindowSize, extraItemCount) {
    var slidingWindowStart = imul(slidingWindowSize, firstVisibleItem / slidingWindowSize | 0);
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = slidingWindowStart - extraItemCount | 0;
    var start = Math.max(a, 0);
    var end = (slidingWindowStart + slidingWindowSize | 0) + extraItemCount | 0;
    return until(start, end);
  }
  function _set_value__lx0xdg_0($this, _set____db54di) {
    var tmp0 = $this.nii_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutNearestRangeState$_get_value_$ref_raeacf();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, LazyLayoutNearestRangeState$_set_value_$ref_20g625());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function Companion_9() {
  }
  var Companion_instance_19;
  function Companion_getInstance_68() {
    return Companion_instance_19;
  }
  function LazyLayoutNearestRangeState$_get_value_$ref_raeacf() {
    return constructCallableReference(function (p0) {
      return p0.u1();
    }, 1, 0, 285);
  }
  function LazyLayoutNearestRangeState$_set_value_$ref_20g625() {
    return constructCallableReference(function (p0, p1) {
      _set_value__lx0xdg_0(p0, p1);
      return Unit_instance;
    }, 2, 0, 286);
  }
  function LazyLayoutNearestRangeState(firstVisibleItem, slidingWindowSize, extraItemCount) {
    this.lii_1 = slidingWindowSize;
    this.mii_1 = extraItemCount;
    this.nii_1 = mutableStateOf(calculateNearestItemsRange(Companion_instance_19, firstVisibleItem, this.lii_1, this.mii_1), structuralEqualityPolicy());
    this.oii_1 = firstVisibleItem;
  }
  protoOf(LazyLayoutNearestRangeState).u1 = function () {
    var tmp0 = this.nii_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutNearestRangeState$_get_value_$ref_raeacf();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, LazyLayoutNearestRangeState$_set_value_$ref_20g625());
    return tmp0.u1();
  };
  protoOf(LazyLayoutNearestRangeState).pii = function (firstVisibleItem) {
    if (!(firstVisibleItem === this.oii_1)) {
      this.oii_1 = firstVisibleItem;
      _set_value__lx0xdg_0(this, calculateNearestItemsRange(Companion_instance_19, firstVisibleItem, this.lii_1, this.mii_1));
    }
  };
  var androidx_compose_foundation_lazy_layout_LazyLayoutPinnedItemList$stable;
  function LazyLayoutPinnedItemList_init_$Init$($this) {
    LazyLayoutPinnedItemList.call($this, SnapshotStateList_init_$Create$());
    return $this;
  }
  function LazyLayoutPinnedItemList_init_$Create$() {
    return LazyLayoutPinnedItemList_init_$Init$(objectCreate(protoOf(LazyLayoutPinnedItemList)));
  }
  function PinnedItem() {
  }
  function LazyLayoutPinnedItemList(items) {
    this.xix_1 = items;
  }
  protoOf(LazyLayoutPinnedItemList).cj4 = function (item) {
    this.xix_1.j1(item);
  };
  protoOf(LazyLayoutPinnedItemList).dj4 = function (item) {
    this.xix_1.d3(item);
  };
  protoOf(LazyLayoutPinnedItemList).r = function () {
    return this.xix_1.r();
  };
  protoOf(LazyLayoutPinnedItemList).ej4 = function (element) {
    return this.xix_1.m1(element);
  };
  protoOf(LazyLayoutPinnedItemList).m1 = function (element) {
    if (!(!(element == null) ? isInterface(element, PinnedItem) : false))
      return false;
    return this.ej4((!(element == null) ? isInterface(element, PinnedItem) : false) ? element : THROW_CCE());
  };
  protoOf(LazyLayoutPinnedItemList).t = function () {
    return this.xix_1.t();
  };
  protoOf(LazyLayoutPinnedItemList).fj4 = function (elements) {
    return this.xix_1.r2(elements);
  };
  protoOf(LazyLayoutPinnedItemList).r2 = function (elements) {
    return this.fj4(elements);
  };
  protoOf(LazyLayoutPinnedItemList).l1 = function (index) {
    return this.xix_1.l1(index);
  };
  protoOf(LazyLayoutPinnedItemList).gj4 = function (element) {
    return this.xix_1.q1(element);
  };
  protoOf(LazyLayoutPinnedItemList).q1 = function (element) {
    if (!(!(element == null) ? isInterface(element, PinnedItem) : false))
      return -1;
    return this.gj4((!(element == null) ? isInterface(element, PinnedItem) : false) ? element : THROW_CCE());
  };
  protoOf(LazyLayoutPinnedItemList).p1 = function (index) {
    return this.xix_1.p1(index);
  };
  protoOf(LazyLayoutPinnedItemList).t2 = function (fromIndex, toIndex) {
    return this.xix_1.t2(fromIndex, toIndex);
  };
  protoOf(LazyLayoutPinnedItemList).n1 = function () {
    return this.xix_1.n1();
  };
  function LazyLayoutPinnableItem(key, index, pinnedItemList, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(872548579);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(key) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.m31(index) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(pinnedItemList) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.k31(key) | $composer_0.k31(pinnedItemList));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = new LazyLayoutPinnableItem_0(key, pinnedItemList);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var pinnableItem = tmp;
      pinnableItem.jj4_1 = index;
      var tmp0_0 = get_LocalPinnableContainer();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var tmp$ret$4 = $composer_1.u31(tmp0_0);
      pinnableItem.oj4(tmp$ret$4);
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_0.k31(pinnableItem);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_1.i31();
      var tmp_0;
      if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = LazyLayoutPinnableItem$lambda(pinnableItem);
        tmp0_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp$ret$5 = tmp_0;
      DisposableEffect_0(pinnableItem, tmp$ret$5, $composer_0, 0);
      CompositionLocalProvider(get_LocalPinnableContainer().h3c(pinnableItem), content, $composer_0, androidx_compose_runtime_ProvidedValue$stableprop_getter() | 112 & $dirty >> 6);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(LazyLayoutPinnableItem$lambda_0(key, index, pinnedItemList, content, $changed));
    }
  }
  function _set__parentPinnableContainer__wpbnbm($this, _set____db54di) {
    var tmp0 = $this.nj4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutPinnableItem$_get__parentPinnableContainer_$ref_i8s623();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('_parentPinnableContainer', 1, tmp, tmp_0, LazyLayoutPinnableItem$_set__parentPinnableContainer_$ref_pfd50f());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get__parentPinnableContainer__xtf70a($this) {
    var tmp0 = $this.nj4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LazyLayoutPinnableItem$_get__parentPinnableContainer_$ref_i8s623();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('_parentPinnableContainer', 1, tmp, tmp_0, LazyLayoutPinnableItem$_set__parentPinnableContainer_$ref_pfd50f());
    return tmp0.u1();
  }
  function LazyLayoutPinnableItem$_get__parentPinnableContainer_$ref_i8s623() {
    return constructCallableReference(function (p0) {
      return _get__parentPinnableContainer__xtf70a(p0);
    }, 1, 0, 287);
  }
  function LazyLayoutPinnableItem$_set__parentPinnableContainer_$ref_pfd50f() {
    return constructCallableReference(function (p0, p1) {
      _set__parentPinnableContainer__wpbnbm(p0, p1);
      return Unit_instance;
    }, 2, 0, 288);
  }
  function LazyLayoutPinnableItem_0(key, pinnedItemList) {
    this.hj4_1 = key;
    this.ij4_1 = pinnedItemList;
    this.jj4_1 = -1;
    this.kj4_1 = 0;
    this.lj4_1 = null;
    this.mj4_1 = false;
    this.nj4_1 = mutableStateOf(null);
  }
  protoOf(LazyLayoutPinnableItem_0).t1 = function () {
    return this.hj4_1;
  };
  protoOf(LazyLayoutPinnableItem_0).bi0 = function () {
    return this.jj4_1;
  };
  protoOf(LazyLayoutPinnableItem_0).oj4 = function (value) {
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
      var previousSnapshot = Companion_instance_2.p52();
      var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
      var newSnapshot = Companion_instance_2.q52(previousSnapshot);
      try {
        var previous = _get__parentPinnableContainer__xtf70a(this);
        if (!(value === previous)) {
          _set__parentPinnableContainer__wpbnbm(this, value);
          if (this.kj4_1 > 0) {
            var tmp0_safe_receiver = this.lj4_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.r2v();
            }
            var tmp = this;
            tmp.lj4_1 = value == null ? null : value.nfx();
          }
        }
        break $l$block;
      }finally {
        Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
      }
    }
  };
  protoOf(LazyLayoutPinnableItem_0).pj4 = function () {
    return _get__parentPinnableContainer__xtf70a(this);
  };
  protoOf(LazyLayoutPinnableItem_0).nfx = function () {
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!!this.mj4_1) {
      var tmp$ret$1 = 'Pin should not be called on an already disposed item ';
      throwIllegalStateException(tmp$ret$1);
    }
    if (this.kj4_1 === 0) {
      this.ij4_1.cj4(this);
      var tmp = this;
      var tmp0_safe_receiver = this.pj4();
      tmp.lj4_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.nfx();
    }
    this.kj4_1 = this.kj4_1 + 1 | 0;
    return this;
  };
  protoOf(LazyLayoutPinnableItem_0).r2v = function () {
    if (this.mj4_1)
      return Unit_instance;
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(this.kj4_1 > 0)) {
      var tmp$ret$1 = 'Release should only be called once';
      throwIllegalStateException(tmp$ret$1);
    }
    this.kj4_1 = this.kj4_1 - 1 | 0;
    if (this.kj4_1 === 0) {
      this.ij4_1.dj4(this);
      var tmp0_safe_receiver = this.lj4_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.r2v();
      }
      this.lj4_1 = null;
    }
  };
  protoOf(LazyLayoutPinnableItem_0).miw = function () {
    this.mj4_1 = true;
  };
  function LazyLayoutPinnableItem$$inlined$cache$1$1($pinnableItem) {
    this.qj4_1 = $pinnableItem;
  }
  protoOf(LazyLayoutPinnableItem$$inlined$cache$1$1).s1d = function () {
    this.qj4_1.miw();
  };
  function LazyLayoutPinnableItem$lambda($pinnableItem) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new LazyLayoutPinnableItem$$inlined$cache$1$1($pinnableItem);
    };
  }
  function LazyLayoutPinnableItem$lambda_0($key, $index, $pinnedItemList, $content, $$changed) {
    return function ($composer, $force) {
      LazyLayoutPinnableItem($key, $index, $pinnedItemList, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var ZeroConstraints;
  var androidx_compose_foundation_lazy_layout_LazyLayoutPrefetchState$stable;
  var androidx_compose_foundation_lazy_layout_PrefetchMetrics$stable;
  var androidx_compose_foundation_lazy_layout_Averages$stable;
  var androidx_compose_foundation_lazy_layout_PrefetchHandleProvider$stable;
  function LazyLayoutPrefetchState_init_$Init$(prefetchScheduler, onNestedPrefetch, $this) {
    prefetchScheduler = prefetchScheduler === VOID ? null : prefetchScheduler;
    onNestedPrefetch = onNestedPrefetch === VOID ? null : onNestedPrefetch;
    LazyLayoutPrefetchState.call($this);
    $this.fij_1 = prefetchScheduler;
    $this.gij_1 = onNestedPrefetch;
    return $this;
  }
  function LazyLayoutPrefetchState_init_$Create$(prefetchScheduler, onNestedPrefetch) {
    return LazyLayoutPrefetchState_init_$Init$(prefetchScheduler, onNestedPrefetch, objectCreate(protoOf(LazyLayoutPrefetchState)));
  }
  function LazyLayoutPrefetchState() {
    this.fij_1 = null;
    this.gij_1 = null;
    this.hij_1 = new PrefetchMetrics();
    this.iij_1 = null;
    this.jij_1 = -1;
    this.kij_1 = -1;
    this.lij_1 = 0;
  }
  protoOf(LazyLayoutPrefetchState).rj4 = function (index, constraints, onItemPremeasured) {
    return this.mij(index, constraints, true, onItemPremeasured);
  };
  protoOf(LazyLayoutPrefetchState).sj4 = function (index, constraints, onItemPremeasured, $super) {
    onItemPremeasured = onItemPremeasured === VOID ? null : onItemPremeasured;
    return $super === VOID ? this.rj4(index, constraints, onItemPremeasured) : $super.rj4.call(this, index, new Constraints(constraints), onItemPremeasured);
  };
  protoOf(LazyLayoutPrefetchState).mij = function (index, constraints, isHighPriority, onItemPremeasured) {
    var tmp0_safe_receiver = this.iij_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tj4(index, constraints, this.hij_1, isHighPriority, onItemPremeasured);
    return tmp1_elvis_lhs == null ? DummyHandle_instance : tmp1_elvis_lhs;
  };
  function NestedPrefetchScope() {
  }
  function PrefetchMetrics() {
    this.uj4_1 = mutableScatterMapOf();
    this.vj4_1 = null;
    this.wj4_1 = null;
  }
  function HandleAndRequestImpl_init_$Init$($outer, index, constraints, prefetchMetrics, priorityPrefetchScheduler, onItemPremeasured, $this) {
    HandleAndRequestImpl.call($this, $outer, index, prefetchMetrics, priorityPrefetchScheduler, onItemPremeasured);
    $this.bj5_1 = constraints;
    return $this;
  }
  function HandleAndRequestImpl_init_$Create$($outer, index, constraints, prefetchMetrics, priorityPrefetchScheduler, onItemPremeasured) {
    return HandleAndRequestImpl_init_$Init$($outer, index, constraints, prefetchMetrics, priorityPrefetchScheduler, onItemPremeasured, objectCreate(protoOf(HandleAndRequestImpl)));
  }
  function _get_isComposed__yuu24x($this) {
    var tmp;
    if ($this.gj5_1) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = $this.dj5_1;
      tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g3y()) === true;
    }
    return tmp;
  }
  function cleanUp($this) {
    var tmp0_safe_receiver = $this.dj5_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.e2z();
    }
    $this.dj5_1 = null;
    var tmp1_safe_receiver = $this.cj5_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.s1d();
    }
    $this.cj5_1 = null;
    $this.jj5_1 = null;
  }
  function HandleAndRequestImpl($outer, index, prefetchMetrics, priorityPrefetchScheduler, onItemPremeasured) {
    this.pj5_1 = $outer;
    this.xj4_1 = index;
    this.yj4_1 = prefetchMetrics;
    this.zj4_1 = priorityPrefetchScheduler;
    this.aj5_1 = onItemPremeasured;
    this.bj5_1 = null;
    this.cj5_1 = null;
    this.dj5_1 = null;
    this.ej5_1 = false;
    this.fj5_1 = false;
    this.gj5_1 = false;
    this.hj5_1 = null;
    this.ij5_1 = false;
    this.jj5_1 = null;
    this.kj5_1 = false;
    this.lj5_1 = new Long(0, 0);
    this.mj5_1 = new Long(0, 0);
    this.nj5_1 = Monotonic_instance.mf();
    this.oj5_1 = false;
  }
  protoOf(HandleAndRequestImpl).bi0 = function () {
    return this.xj4_1;
  };
  protoOf(HandleAndRequestImpl).e2z = function () {
    if (!this.fj5_1) {
      this.fj5_1 = true;
      cleanUp(this);
    }
  };
  protoOf(HandleAndRequestImpl).cii = function () {
    this.kj5_1 = true;
  };
  protoOf(HandleAndRequestImpl).law = function () {
    var tmp0_safe_receiver = this.cj5_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.law();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(HandleAndRequestImpl).maw = function (placeableIndex) {
    var tmp0_safe_receiver = this.cj5_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.maw(placeableIndex);
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new IntSize(tmp_0)) == null) {
      tmp = Companion_getInstance_22().n5g_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(HandleAndRequestImpl).toString = function () {
    var tmp = this.bj5_1;
    return 'HandleAndRequestImpl { index = ' + this.xj4_1 + ', constraints = ' + toString_0(tmp == null ? null : new Constraints(tmp)) + ', ' + ('isComposed = ' + _get_isComposed__yuu24x(this) + ', isMeasured = ' + this.ej5_1 + ', isCanceled = ' + this.fj5_1 + ' }');
  };
  function PrefetchHandleProvider(itemContentFactory, subcomposeLayoutState, executor) {
    this.hiw_1 = itemContentFactory;
    this.iiw_1 = subcomposeLayoutState;
    this.jiw_1 = executor;
    this.kiw_1 = true;
    this.liw_1 = false;
  }
  protoOf(PrefetchHandleProvider).miw = function () {
    this.kiw_1 = false;
  };
  protoOf(PrefetchHandleProvider).tj4 = function (index, constraints, prefetchMetrics, isHighPriority, onItemPremeasured) {
    var tmp = this.jiw_1;
    // Inline function 'kotlin.also' call
    var this_0 = HandleAndRequestImpl_init_$Create$(this, index, constraints, prefetchMetrics, isInterface(tmp, PriorityPrefetchScheduler) ? tmp : null, onItemPremeasured);
    this.qj5(this.jiw_1, this_0, isHighPriority);
    traceValue('compose:lazy:schedule_prefetch:index', fromInt(index));
    return this_0;
  };
  protoOf(PrefetchHandleProvider).qj5 = function (_this__u8e3s4, request, isHighPriority) {
    if (isInterface(_this__u8e3s4, PriorityPrefetchScheduler)) {
      if (isHighPriority) {
        _this__u8e3s4.tj5(request);
      } else {
        _this__u8e3s4.sj5(request);
      }
    } else {
      _this__u8e3s4.rj5(request);
    }
  };
  function DummyHandle() {
  }
  protoOf(DummyHandle).e2z = function () {
  };
  protoOf(DummyHandle).cii = function () {
  };
  var DummyHandle_instance;
  function DummyHandle_getInstance() {
    return DummyHandle_instance;
  }
  function TraversablePrefetchStateNode(prefetchState) {
    Node.call(this);
    this.ij6_1 = prefetchState;
    this.jj6_1 = 'androidx.compose.foundation.lazy.layout.TraversablePrefetchStateNode';
  }
  protoOf(TraversablePrefetchStateNode).t91 = function () {
    return this.jj6_1;
  };
  function traversablePrefetchState(_this__u8e3s4, lazyLayoutPrefetchState) {
    _init_properties_LazyLayoutPrefetchState_kt__2q0ebu();
    var tmp;
    if (lazyLayoutPrefetchState == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = _this__u8e3s4.d8v(new TraversablePrefetchStateModifierElement(lazyLayoutPrefetchState));
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  }
  function TraversablePrefetchStateModifierElement(prefetchState) {
    ModifierNodeElement.call(this);
    this.lj6_1 = prefetchState;
  }
  protoOf(TraversablePrefetchStateModifierElement).r3d = function () {
    return new TraversablePrefetchStateNode(this.lj6_1);
  };
  protoOf(TraversablePrefetchStateModifierElement).mj6 = function (node) {
    node.ij6_1 = this.lj6_1;
  };
  protoOf(TraversablePrefetchStateModifierElement).d8y = function (node) {
    return this.mj6(node instanceof TraversablePrefetchStateNode ? node : THROW_CCE());
  };
  protoOf(TraversablePrefetchStateModifierElement).toString = function () {
    return 'TraversablePrefetchStateModifierElement(prefetchState=' + toString(this.lj6_1) + ')';
  };
  protoOf(TraversablePrefetchStateModifierElement).hashCode = function () {
    return hashCode(this.lj6_1);
  };
  protoOf(TraversablePrefetchStateModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TraversablePrefetchStateModifierElement))
      return false;
    if (!equals(this.lj6_1, other.lj6_1))
      return false;
    return true;
  };
  var properties_initialized_LazyLayoutPrefetchState_kt_6kjxas;
  function _init_properties_LazyLayoutPrefetchState_kt__2q0ebu() {
    if (!properties_initialized_LazyLayoutPrefetchState_kt_6kjxas) {
      properties_initialized_LazyLayoutPrefetchState_kt_6kjxas = true;
      ZeroConstraints = Constraints_0(VOID, 0, VOID, 0);
      androidx_compose_foundation_lazy_layout_LazyLayoutPrefetchState$stable = 0;
      androidx_compose_foundation_lazy_layout_PrefetchMetrics$stable = 8;
      androidx_compose_foundation_lazy_layout_Averages$stable = 8;
      androidx_compose_foundation_lazy_layout_PrefetchHandleProvider$stable = 8;
    }
  }
  function get_DeltaThresholdForScrollAnimation() {
    _init_properties_LazyLayoutScrollDeltaBetweenPasses_kt__ghjlxi();
    return DeltaThresholdForScrollAnimation;
  }
  var DeltaThresholdForScrollAnimation;
  var androidx_compose_foundation_lazy_layout_LazyLayoutScrollDeltaBetweenPasses$stable;
  function LazyLayoutScrollDeltaBetweenPasses$updateScrollDeltaForApproach$slambda(this$0, resultContinuation) {
    this.vj6_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyLayoutScrollDeltaBetweenPasses$updateScrollDeltaForApproach$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyLayoutScrollDeltaBetweenPasses$updateScrollDeltaForApproach$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyLayoutScrollDeltaBetweenPasses$updateScrollDeltaForApproach$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = animateTo(this.vj6_1.sil_1, 0.0, spring(VOID, 400.0, 0.5), true, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LazyLayoutScrollDeltaBetweenPasses$updateScrollDeltaForApproach$slambda).q24 = function ($this$launch, completion) {
    var i = new LazyLayoutScrollDeltaBetweenPasses$updateScrollDeltaForApproach$slambda(this.vj6_1, completion);
    i.wj6_1 = $this$launch;
    return i;
  };
  function LazyLayoutScrollDeltaBetweenPasses$updateScrollDeltaForApproach$slambda_0(this$0, resultContinuation) {
    var i = new LazyLayoutScrollDeltaBetweenPasses$updateScrollDeltaForApproach$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function LazyLayoutScrollDeltaBetweenPasses() {
    this.ril_1 = null;
    this.sil_1 = AnimationState_0(get_VectorConverter(FloatCompanionObject_instance), 0.0, 0.0);
  }
  protoOf(LazyLayoutScrollDeltaBetweenPasses).cie = function () {
    return this.sil_1.u1();
  };
  protoOf(LazyLayoutScrollDeltaBetweenPasses).uil = function () {
    return !(this.sil_1.u1() === 0.0);
  };
  protoOf(LazyLayoutScrollDeltaBetweenPasses).til = function (delta, density, coroutineScope) {
    // Inline function 'kotlin.with' call
    if (delta <= density.v5e(get_DeltaThresholdForScrollAnimation())) {
      return Unit_instance;
    }
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
      var previousSnapshot = Companion_instance_2.p52();
      var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
      var newSnapshot = Companion_instance_2.q52(previousSnapshot);
      try {
        var currentDelta = this.sil_1.u1();
        var tmp0_safe_receiver = this.ril_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.b1b();
        }
        if (this.sil_1.fea_1) {
          this.sil_1 = copy(this.sil_1, currentDelta - delta);
        } else {
          this.sil_1 = new AnimationState_1(get_VectorConverter(FloatCompanionObject_instance), -delta);
        }
        var tmp = this;
        tmp.ril_1 = launch(coroutineScope, VOID, VOID, LazyLayoutScrollDeltaBetweenPasses$updateScrollDeltaForApproach$slambda_0(this, null));
        break $l$block;
      }finally {
        Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
      }
    }
  };
  protoOf(LazyLayoutScrollDeltaBetweenPasses).vil = function () {
    var tmp0_safe_receiver = this.ril_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.b1b();
    }
    this.sil_1 = new AnimationState_1(get_VectorConverter(FloatCompanionObject_instance), 0.0);
  };
  var properties_initialized_LazyLayoutScrollDeltaBetweenPasses_kt_f8kdb8;
  function _init_properties_LazyLayoutScrollDeltaBetweenPasses_kt__ghjlxi() {
    if (!properties_initialized_LazyLayoutScrollDeltaBetweenPasses_kt_f8kdb8) {
      properties_initialized_LazyLayoutScrollDeltaBetweenPasses_kt_f8kdb8 = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      DeltaThresholdForScrollAnimation = _Dp___init__impl__ms3zkb(1);
      androidx_compose_foundation_lazy_layout_LazyLayoutScrollDeltaBetweenPasses$stable = 8;
    }
  }
  function get_TargetDistance() {
    _init_properties_LazyLayoutScrollScope_kt__83jxft();
    return TargetDistance;
  }
  var TargetDistance;
  function get_BoundDistance() {
    _init_properties_LazyLayoutScrollScope_kt__83jxft();
    return BoundDistance;
  }
  var BoundDistance;
  function get_MinimumDistance() {
    _init_properties_LazyLayoutScrollScope_kt__83jxft();
    return MinimumDistance;
  }
  var MinimumDistance;
  function LazyLayoutScrollScope_0() {
  }
  function animateScrollToItem(_this__u8e3s4, index, scrollOffset, numOfItemsForTeleport, density, $completion) {
    var tmp = new $animateScrollToItemCOROUTINE$_0(_this__u8e3s4, index, scrollOffset, numOfItemsForTeleport, density, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function isItemVisible(_this__u8e3s4, index) {
    _init_properties_LazyLayoutScrollScope_kt__83jxft();
    var containsLower = _this__u8e3s4.lia();
    return index <= _this__u8e3s4.wii() ? containsLower <= index : false;
  }
  function ItemFoundInScroll(itemOffset, previousAnimation) {
    CancellationException_init_$Init$(this);
    captureStack(this, ItemFoundInScroll);
    this.rj7_1 = itemOffset;
    this.sj7_1 = previousAnimation;
  }
  function animateScrollToItem$isOvershot(forward, $this_animateScrollToItem, $index, $scrollOffset) {
    var tmp;
    if (forward) {
      var tmp_0;
      if ($this_animateScrollToItem.lia() > $index) {
        tmp_0 = true;
      } else if ($this_animateScrollToItem.lia() === $index && $this_animateScrollToItem.mia() > $scrollOffset) {
        tmp_0 = true;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if ($this_animateScrollToItem.lia() < $index) {
        tmp_1 = true;
      } else if ($this_animateScrollToItem.lia() === $index && $this_animateScrollToItem.mia() < $scrollOffset) {
        tmp_1 = true;
      } else {
        tmp_1 = false;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function animateScrollToItem$lambda($this_animateScrollToItem, $index, $target, $prevValue, $loop, $forward, $boundDistancePx, $loops, $numOfItemsForTeleport, $scrollOffset, $anim) {
    return function ($this$animateTo) {
      // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
      if (false) {
        var tmp$ret$1 = 'firstVisibleItemIndex=' + $this_animateScrollToItem.lia();
        println('LazyScrolling: ' + tmp$ret$1);
      }
      var tmp;
      if (!isItemVisible($this_animateScrollToItem, $index)) {
        var tmp_0;
        if ($target > 0) {
          tmp_0 = coerceAtMost_0($this$animateTo.u1(), $target);
        } else {
          tmp_0 = coerceAtLeast($this$animateTo.u1(), $target);
        }
        var coercedValue = tmp_0;
        var delta = coercedValue - $prevValue._v;
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$3 = 'Scrolling by ' + delta + ' (target: ' + $target + ', coercedValue: ' + coercedValue + ')';
          println('LazyScrolling: ' + tmp$ret$3);
        }
        var consumed = $this_animateScrollToItem.bh7(delta);
        var tmp_1;
        if (isItemVisible($this_animateScrollToItem, $index)) {
          // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
          if (false) {
            var tmp$ret$5 = 'Found the item after performing scrollBy()';
            println('LazyScrolling: ' + tmp$ret$5);
          }
          tmp_1 = Unit_instance;
        } else if (!animateScrollToItem$isOvershot($forward, $this_animateScrollToItem, $index, $scrollOffset)) {
          if (!(delta === consumed)) {
            // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
            if (false) {
              var tmp$ret$7 = 'Hit end without finding the item';
              println('LazyScrolling: ' + tmp$ret$7);
            }
            $this$animateTo.hea();
            $loop._v = false;
            return Unit_instance;
          }
          $prevValue._v = $prevValue._v + delta;
          if ($forward) {
            if ($this$animateTo.u1() > $boundDistancePx) {
              // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
              if (false) {
                var tmp$ret$9 = 'Struck bound going forward';
                println('LazyScrolling: ' + tmp$ret$9);
              }
              $this$animateTo.hea();
            }
          } else {
            if ($this$animateTo.u1() < -$boundDistancePx) {
              // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
              if (false) {
                var tmp$ret$11 = 'Struck bound going backward';
                println('LazyScrolling: ' + tmp$ret$11);
              }
              $this$animateTo.hea();
            }
          }
          var tmp_2;
          if ($forward) {
            var tmp_3;
            if ($loops._v >= 2 && ($index - $this_animateScrollToItem.wii() | 0) > $numOfItemsForTeleport) {
              // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
              if (false) {
                var tmp$ret$13 = 'Teleport forward';
                println('LazyScrolling: ' + tmp$ret$13);
              }
              $this_animateScrollToItem.xii($index - $numOfItemsForTeleport | 0, 0);
              tmp_3 = Unit_instance;
            }
            tmp_2 = tmp_3;
          } else {
            var tmp_4;
            if ($loops._v >= 2 && ($this_animateScrollToItem.lia() - $index | 0) > $numOfItemsForTeleport) {
              // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
              if (false) {
                var tmp$ret$15 = 'Teleport backward';
                println('LazyScrolling: ' + tmp$ret$15);
              }
              $this_animateScrollToItem.xii($index + $numOfItemsForTeleport | 0, 0);
              tmp_4 = Unit_instance;
            }
            tmp_2 = tmp_4;
          }
          tmp_1 = tmp_2;
        }
        tmp = tmp_1;
      }
      var tmp_5;
      if (animateScrollToItem$isOvershot($forward, $this_animateScrollToItem, $index, $scrollOffset)) {
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$17 = 'Overshot, ' + ('item ' + $this_animateScrollToItem.lia() + ' at  ' + $this_animateScrollToItem.mia() + ',') + (' target is ' + $scrollOffset);
          println('LazyScrolling: ' + tmp$ret$17);
        }
        $this_animateScrollToItem.xii($index, $scrollOffset);
        $loop._v = false;
        $this$animateTo.hea();
        return Unit_instance;
      } else if (isItemVisible($this_animateScrollToItem, $index)) {
        var targetItemOffset = $this_animateScrollToItem.aij($index);
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$19 = 'Found item';
          println('LazyScrolling: ' + tmp$ret$19);
        }
        throw new ItemFoundInScroll(targetItemOffset, $anim._v);
      }
      return Unit_instance;
    };
  }
  function animateScrollToItem$lambda_0($target, $prevValue, $this_animateScrollToItem) {
    return function ($this$animateTo) {
      var tmp;
      if ($target > 0) {
        tmp = coerceAtMost_0($this$animateTo.u1(), $target);
      } else if ($target < 0) {
        tmp = coerceAtLeast($this$animateTo.u1(), $target);
      } else {
        // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
        if (false) {
          var tmp$ret$1 = "WARNING: somehow ended up seeking 0px, this shouldn't happen";
          println('LazyScrolling: ' + tmp$ret$1);
        }
        tmp = 0.0;
      }
      var coercedValue = tmp;
      var delta = coercedValue - $prevValue._v;
      // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
      if (false) {
        var tmp$ret$3 = 'Seeking by ' + delta + ' (coercedValue = ' + coercedValue + ')';
        println('LazyScrolling: ' + tmp$ret$3);
      }
      var consumed = $this_animateScrollToItem.bh7(delta);
      var tmp_0;
      if (!(delta === consumed) || !(coercedValue === $this$animateTo.u1())) {
        $this$animateTo.hea();
        tmp_0 = Unit_instance;
      }
      $prevValue._v = $prevValue._v + delta;
      return Unit_instance;
    };
  }
  function $animateScrollToItemCOROUTINE$_0(_this__u8e3s4, index, scrollOffset, numOfItemsForTeleport, density, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fj7_1 = _this__u8e3s4;
    this.gj7_1 = index;
    this.hj7_1 = scrollOffset;
    this.ij7_1 = numOfItemsForTeleport;
    this.jj7_1 = density;
  }
  protoOf($animateScrollToItemCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            if (!(this.gj7_1 >= 0.0)) {
              throwIllegalArgumentException('Index should be non-negative');
            }

            this.o9_1 = 4;
            var tmp_0 = this;
            tmp_0.pj7_1 = this.jj7_1.v5e(get_TargetDistance());
            var tmp_1 = this;
            tmp_1.mj7_1 = this.jj7_1.v5e(get_BoundDistance());
            var tmp_2 = this;
            tmp_2.qj7_1 = this.jj7_1.v5e(get_MinimumDistance());
            this.oj7_1 = {_v: true};
            this.lj7_1 = {_v: AnimationState(0.0)};
            if (isItemVisible(this.fj7_1, this.gj7_1)) {
              var targetItemInitialOffset = this.fj7_1.aij(this.gj7_1);
              throw new ItemFoundInScroll(targetItemInitialOffset, this.lj7_1._v);
            }

            this.nj7_1 = this.gj7_1 > this.fj7_1.lia();
            this.kj7_1 = {_v: 1};
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.oj7_1._v && this.fj7_1.aie() > 0)) {
              this.n9_1 = 3;
              continue $sm;
            }

            var expectedDistance = this.fj7_1.aij(this.gj7_1) + this.hj7_1 | 0;
            var tmp_3;
            if (abs(expectedDistance) < this.pj7_1) {
              var tmp0 = Math.abs(expectedDistance);
              var b = this.qj7_1;
              var absTargetPx = Math.max(tmp0, b);
              tmp_3 = this.nj7_1 ? absTargetPx : -absTargetPx;
            } else {
              tmp_3 = this.nj7_1 ? this.pj7_1 : -this.pj7_1;
            }

            var target = tmp_3;
            if (false) {
              println('LazyScrolling: ' + ('Scrolling to index=' + this.gj7_1 + ' offset=' + this.hj7_1 + ' from ' + ('index=' + this.fj7_1.lia() + ' offset=' + this.fj7_1.mia() + ' with ') + ('calculated target=' + target)));
            }

            this.lj7_1._v = copy(this.lj7_1._v, 0.0);
            var prevValue = {_v: 0.0};
            this.n9_1 = 2;
            var tmp_4 = this.lj7_1._v;
            var tmp_5 = !(this.lj7_1._v.eec() === 0.0);
            suspendResult = animateTo(tmp_4, target, VOID, tmp_5, animateScrollToItem$lambda(this.fj7_1, this.gj7_1, target, prevValue, this.oj7_1, this.nj7_1, this.mj7_1, this.kj7_1, this.ij7_1, this.hj7_1, this.lj7_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var _unary__edvuaz = this.kj7_1._v;
            this.kj7_1._v = _unary__edvuaz + 1 | 0;
            this.n9_1 = 1;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            this.n9_1 = 7;
            continue $sm;
          case 4:
            this.o9_1 = 6;
            var tmp_6 = this.q9_1;
            if (tmp_6 instanceof ItemFoundInScroll) {
              var itemFound = this.q9_1;
              var anim = copy(itemFound.sj7_1, 0.0);
              var target_0 = itemFound.rj7_1 + this.hj7_1 | 0;
              var prevValue_0 = {_v: 0.0};
              if (false) {
                println('LazyScrolling: ' + ('Seeking by ' + target_0 + ' at velocity ' + itemFound.sj7_1.eec()));
              }
              this.n9_1 = 5;
              var tmp_7 = !(anim.eec() === 0.0);
              suspendResult = animateTo(anim, target_0, VOID, tmp_7, animateScrollToItem$lambda_0(target_0, prevValue_0, this.fj7_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            this.fj7_1.xii(this.gj7_1, this.hj7_1);
            this.n9_1 = 7;
            continue $sm;
          case 6:
            throw this.q9_1;
          case 7:
            this.o9_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_LazyLayoutScrollScope_kt_5iuvg9;
  function _init_properties_LazyLayoutScrollScope_kt__83jxft() {
    if (!properties_initialized_LazyLayoutScrollScope_kt_5iuvg9) {
      properties_initialized_LazyLayoutScrollScope_kt_5iuvg9 = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      TargetDistance = _Dp___init__impl__ms3zkb(2500);
      // Inline function 'androidx.compose.ui.unit.dp' call
      BoundDistance = _Dp___init__impl__ms3zkb(1500);
      // Inline function 'androidx.compose.ui.unit.dp' call
      MinimumDistance = _Dp___init__impl__ms3zkb(50);
    }
  }
  function lazyLayoutSemantics(_this__u8e3s4, itemProviderLambda, state, orientation, userScrollEnabled, reverseScrolling, $composer, $changed) {
    var $composer_0 = $composer;
    return _this__u8e3s4.d8v(new LazyLayoutSemanticsModifier(itemProviderLambda, state, orientation, userScrollEnabled, reverseScrolling));
  }
  function LazyLayoutSemanticsModifier(itemProviderLambda, state, orientation, userScrollEnabled, reverseScrolling) {
    ModifierNodeElement.call(this);
    this.uj7_1 = itemProviderLambda;
    this.vj7_1 = state;
    this.wj7_1 = orientation;
    this.xj7_1 = userScrollEnabled;
    this.yj7_1 = reverseScrolling;
  }
  protoOf(LazyLayoutSemanticsModifier).r3d = function () {
    return new LazyLayoutSemanticsModifierNode(this.uj7_1, this.vj7_1, this.wj7_1, this.xj7_1, this.yj7_1);
  };
  protoOf(LazyLayoutSemanticsModifier).zj7 = function (node) {
    node.wj8(this.uj7_1, this.vj7_1, this.wj7_1, this.xj7_1, this.yj7_1);
  };
  protoOf(LazyLayoutSemanticsModifier).d8y = function (node) {
    return this.zj7(node instanceof LazyLayoutSemanticsModifierNode ? node : THROW_CCE());
  };
  protoOf(LazyLayoutSemanticsModifier).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LazyLayoutSemanticsModifier))
      return false;
    if (!(this.uj7_1 === other.uj7_1))
      return false;
    if (!equals(this.vj7_1, other.vj7_1))
      return false;
    if (!this.wj7_1.equals(other.wj7_1))
      return false;
    if (!(this.xj7_1 === other.xj7_1))
      return false;
    if (!(this.yj7_1 === other.yj7_1))
      return false;
    return true;
  };
  protoOf(LazyLayoutSemanticsModifier).hashCode = function () {
    var result = hashCode(this.uj7_1);
    result = imul(31, result) + hashCode(this.vj7_1) | 0;
    result = imul(31, result) + this.wj7_1.hashCode() | 0;
    result = imul(31, result) + getBooleanHashCode(this.xj7_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.yj7_1) | 0;
    return result;
  };
  function _get_isVertical__yidrg5($this) {
    return $this.qj8_1.equals(Orientation_Vertical_getInstance());
  }
  function _get_collectionInfo__2ea9zz($this) {
    return $this.pj8_1.qia();
  }
  function _get_scrollAxisRange__a4mluq($this) {
    var tmp = $this.tj8_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('scrollAxisRange');
    }
  }
  function updateCachedSemanticsValues($this) {
    var tmp = $this;
    var tmp_0 = LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda($this);
    tmp.tj8_1 = new ScrollAxisRange(tmp_0, LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda_0($this), $this.sj8_1);
    var tmp_1 = $this;
    var tmp_2;
    if ($this.rj8_1) {
      tmp_2 = LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda_1($this);
    } else {
      tmp_2 = null;
    }
    tmp_1.vj8_1 = tmp_2;
  }
  function LazyLayoutSemanticsModifierNode$indexForKeyMapping$lambda(this$0) {
    return function (needle) {
      var itemProvider = this$0.oj8_1();
      var result = -1;
      var inductionVariable = 0;
      var last = itemProvider.aie();
      var tmp;
      if (inductionVariable < last) {
        $l$loop: do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (equals(itemProvider.jif(index), needle)) {
            result = index;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
        tmp = Unit_instance;
      }
      return result;
    };
  }
  function LazyLayoutSemanticsModifierNode$applySemantics$lambda(this$0) {
    return function () {
      return this$0.pj8_1.ria() - this$0.pj8_1.sia() | 0;
    };
  }
  function LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda(this$0) {
    return function () {
      return this$0.pj8_1.kia();
    };
  }
  function LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda_0(this$0) {
    return function () {
      return this$0.pj8_1.nia();
    };
  }
  function LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda$slambda(this$0, $index, resultContinuation) {
    this.fj9_1 = this$0;
    this.gj9_1 = $index;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.fj9_1.pj8_1.oia(this.gj9_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda$slambda(this.fj9_1, this.gj9_1, completion);
    i.hj9_1 = $this$launch;
    return i;
  };
  function LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda$slambda_0(this$0, $index, resultContinuation) {
    var i = new LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda$slambda(this$0, $index, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda_1(this$0) {
    return function (index) {
      var itemProvider = this$0.oj8_1();
      // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
      if (!(index >= 0 && index < itemProvider.aie())) {
        var tmp$ret$1 = "Can't scroll to index " + index + ', it is out of ' + ('bounds [0, ' + itemProvider.aie() + ')');
        throwIllegalArgumentException(tmp$ret$1);
      }
      var tmp = this$0.a8w();
      launch(tmp, VOID, VOID, LazyLayoutSemanticsModifierNode$updateCachedSemanticsValues$lambda$slambda_0(this$0, index, null));
      return true;
    };
  }
  function LazyLayoutSemanticsModifierNode(itemProviderLambda, state, orientation, userScrollEnabled, reverseScrolling) {
    Node.call(this);
    this.oj8_1 = itemProviderLambda;
    this.pj8_1 = state;
    this.qj8_1 = orientation;
    this.rj8_1 = userScrollEnabled;
    this.sj8_1 = reverseScrolling;
    var tmp = this;
    tmp.uj8_1 = LazyLayoutSemanticsModifierNode$indexForKeyMapping$lambda(this);
    this.vj8_1 = null;
    updateCachedSemanticsValues(this);
  }
  protoOf(LazyLayoutSemanticsModifierNode).b8w = function () {
    return false;
  };
  protoOf(LazyLayoutSemanticsModifierNode).wj8 = function (itemProviderLambda, state, orientation, userScrollEnabled, reverseScrolling) {
    this.oj8_1 = itemProviderLambda;
    this.pj8_1 = state;
    if (!this.qj8_1.equals(orientation)) {
      this.qj8_1 = orientation;
      invalidateSemantics(this);
    }
    if (!(this.rj8_1 === userScrollEnabled) || !(this.sj8_1 === reverseScrolling)) {
      this.rj8_1 = userScrollEnabled;
      this.sj8_1 = reverseScrolling;
      updateCachedSemanticsValues(this);
      invalidateSemantics(this);
    }
  };
  protoOf(LazyLayoutSemanticsModifierNode).l9i = function (_this__u8e3s4) {
    set_isTraversalGroup(_this__u8e3s4, true);
    indexForKey(_this__u8e3s4, this.uj8_1);
    if (_get_isVertical__yidrg5(this)) {
      set_verticalScrollAxisRange(_this__u8e3s4, _get_scrollAxisRange__a4mluq(this));
    } else {
      set_horizontalScrollAxisRange(_this__u8e3s4, _get_scrollAxisRange__a4mluq(this));
    }
    var tmp0_safe_receiver = this.vj8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      scrollToIndex(_this__u8e3s4, VOID, tmp0_safe_receiver);
    }
    getScrollViewportLength(_this__u8e3s4, VOID, LazyLayoutSemanticsModifierNode$applySemantics$lambda(this));
    set_collectionInfo(_this__u8e3s4, _get_collectionInfo__2ea9zz(this));
  };
  function estimatedLazyScrollOffset(firstVisibleItemIndex, firstVisibleItemScrollOffset) {
    return firstVisibleItemScrollOffset + imul(firstVisibleItemIndex, 500) | 0;
  }
  function estimatedLazyMaxScrollOffset(firstVisibleItemIndex, firstVisibleItemScrollOffset, canScrollForward) {
    var tmp;
    if (canScrollForward) {
      tmp = estimatedLazyScrollOffset(firstVisibleItemIndex, firstVisibleItemScrollOffset) + 100;
    } else {
      tmp = estimatedLazyScrollOffset(firstVisibleItemIndex, firstVisibleItemScrollOffset);
    }
    return tmp;
  }
  function StickyItemsPlacement$Companion$StickToTopPlacement$1() {
  }
  protoOf(StickyItemsPlacement$Companion$StickToTopPlacement$1).ij9 = function (visibleStickyItems, itemIndex, itemSize, itemOffset, beforeContentPadding, afterContentPadding, layoutWidth, layoutHeight) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = visibleStickyItems.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = visibleStickyItems.l1(index);
          if (!(item.bi0() === itemIndex)) {
            tmp$ret$0 = item;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = null;
    }
    var tmp0_safe_receiver = tmp$ret$0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_mainAxisOffset(tmp0_safe_receiver);
    var nextStickyItemOffset = tmp1_elvis_lhs == null ? -2147483648 : tmp1_elvis_lhs;
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$5 = 'Next Item Offset=' + nextStickyItemOffset;
      println('StickToTopBehavior: ' + tmp$ret$5);
    }
    var tmp;
    if (itemOffset === -2147483648) {
      tmp = -beforeContentPadding | 0;
    } else {
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = -beforeContentPadding | 0;
      tmp = Math.max(a, itemOffset);
    }
    var updatedItemOffset = tmp;
    if (!(nextStickyItemOffset === -2147483648)) {
      var tmp0 = updatedItemOffset;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = nextStickyItemOffset - itemSize | 0;
      updatedItemOffset = Math.min(tmp0, b);
    }
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$9 = 'Item=' + itemIndex + ' Initial_Offset=' + itemOffset + ' ' + ('Final_Offset=' + updatedItemOffset);
      println('StickToTopBehavior: ' + tmp$ret$9);
    }
    return updatedItemOffset;
  };
  protoOf(StickyItemsPlacement$Companion$StickToTopPlacement$1).jj9 = function (firstVisibleItemIndex, lastVisibleItemIndex, stickyItems) {
    var tmp;
    if ((lastVisibleItemIndex - firstVisibleItemIndex | 0) < 0) {
      tmp = true;
    } else {
      // Inline function 'androidx.collection.IntList.isEmpty' call
      tmp = stickyItems.jv_1 === 0;
    }
    if (tmp)
      return emptyIntList();
    var firstVisible = firstVisibleItemIndex;
    // Inline function 'androidx.compose.foundation.lazy.layout.debugLog' call
    if (false) {
      var tmp$ret$2 = 'First Visible Item Index=' + firstVisible;
      println('StickToTopBehavior: ' + tmp$ret$2);
    }
    var currentHeaderIndex = -1;
    // Inline function 'androidx.collection.IntList.indices' call
    var progression = until(0, stickyItems.jv_1);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    if (inductionVariable <= last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (stickyItems.l1(index) <= firstVisible) {
          currentHeaderIndex = stickyItems.l1(index);
        } else {
          break $l$loop;
        }
      }
       while (!(index === last));
    var tmp_0;
    if (currentHeaderIndex === -1) {
      tmp_0 = emptyIntList();
    } else {
      tmp_0 = intListOf(currentHeaderIndex);
    }
    return tmp_0;
  };
  function Companion_10() {
    Companion_instance_20 = this;
    var tmp = this;
    tmp.tia_1 = new StickyItemsPlacement$Companion$StickToTopPlacement$1();
  }
  var Companion_instance_20;
  function Companion_getInstance_69() {
    if (Companion_instance_20 == null)
      new Companion_10();
    return Companion_instance_20;
  }
  function get_mainAxisOffset(_this__u8e3s4) {
    // Inline function 'kotlin.let' call
    var it = _this__u8e3s4.qig(0);
    return _this__u8e3s4.jig() ? _IntOffset___get_y__impl__2avpwj(it) : _IntOffset___get_x__impl__qiqr5o(it);
  }
  function applyStickyItems(_this__u8e3s4, firstVisibleItemIndex, lastVisibleItemIndex, positionedItems, stickyItems, beforeContentPadding, afterContentPadding, layoutWidth, layoutHeight, getAndMeasure) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (!(_this__u8e3s4 == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_1 = !positionedItems.r();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'androidx.collection.IntList.isNotEmpty' call
      tmp_0 = !(stickyItems.jv_1 === 0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var stickingItems = _this__u8e3s4.jj9(firstVisibleItemIndex, lastVisibleItemIndex, stickyItems);
      // Inline function 'kotlin.collections.mutableListOf' call
      var positionedStickingItems = ArrayList_init_$Create$();
      // Inline function 'androidx.compose.ui.util.fastFilter' call
      var target = ArrayList_init_$Create$_0(positionedItems.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = positionedItems.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = positionedItems.l1(index);
          if (stickyItems.dm(item.bi0())) {
            // Inline function 'kotlin.collections.plusAssign' call
            target.j1(item);
          }
        }
         while (inductionVariable <= last);
      var visibleStickyItems = target;
      // Inline function 'androidx.collection.IntList.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var content = stickingItems.iv_1;
      var inductionVariable_0 = 0;
      var last_0 = stickingItems.jv_1;
      if (inductionVariable_0 < last_0)
        do {
          var i = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var stickingIndex = content[i];
          var tmp$ret$11;
          $l$block: {
            // Inline function 'kotlin.collections.indexOfFirst' call
            var index_0 = 0;
            var _iterator__ex2g4s = positionedItems.t();
            while (_iterator__ex2g4s.u()) {
              var item_0 = _iterator__ex2g4s.v();
              if (item_0.bi0() === stickingIndex) {
                tmp$ret$11 = index_0;
                break $l$block;
              }
              index_0 = index_0 + 1 | 0;
            }
            tmp$ret$11 = -1;
          }
          var itemIndex = tmp$ret$11;
          var tmp_2;
          if (itemIndex === -1) {
            tmp_2 = getAndMeasure(stickingIndex);
          } else {
            tmp_2 = positionedItems.h3(itemIndex);
          }
          var item_1 = tmp_2;
          var offset = _this__u8e3s4.ij9(visibleStickyItems, stickingIndex, item_1.mig(), itemIndex === -1 ? -2147483648 : get_mainAxisOffset(item_1), beforeContentPadding, afterContentPadding, layoutWidth, layoutHeight);
          item_1.nig(true);
          item_1.pig(offset, 0, layoutWidth, layoutHeight);
          positionedStickingItems.j1(item_1);
        }
         while (inductionVariable_0 < last_0);
      tmp = positionedStickingItems;
    } else {
      tmp = emptyList();
    }
    return tmp;
  }
  function LazySaveableStateHolderProvider(content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-709502251);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      var tmp0 = get_LocalSaveableStateRegistry();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var currentRegistry = $composer_1.u31(tmp0);
      var wrappedHolder = rememberSaveableStateHolder($composer_0, 0);
      var tmp = Companion_instance_21.kj9(currentRegistry, wrappedHolder);
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.q31(currentRegistry) | $composer_0.q31(wrappedHolder));
      // Inline function 'kotlin.let' call
      var it = tmp0_0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = LazySaveableStateHolderProvider$lambda(currentRegistry, wrappedHolder);
        tmp0_0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp$ret$1 = tmp_0;
      var holder = rememberSaveable([currentRegistry], tmp, tmp$ret$1, $composer_0, 0);
      var tmp_1 = get_LocalSaveableStateRegistry().h3c(holder);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-412824043, true, LazySaveableStateHolderProvider$lambda_0(content, holder), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_2.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_2.i31();
      var tmp_2;
      if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_2.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp$ret$5 = tmp_2;
      CompositionLocalProvider(tmp_1, tmp$ret$5, $composer_0, 48 | androidx_compose_runtime_ProvidedValue$stableprop_getter());
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(LazySaveableStateHolderProvider$lambda_1(content, $changed));
    }
  }
  function LazySaveableStateHolder$Companion$saver$lambda($this$Saver, it) {
    // Inline function 'kotlin.collections.ifEmpty' call
    var this_0 = it.t7o();
    var tmp;
    if (this_0.r()) {
      tmp = null;
    } else {
      tmp = this_0;
    }
    return tmp;
  }
  function LazySaveableStateHolder$Companion$saver$lambda_0($parentRegistry, $wrappedHolder) {
    return function (restored) {
      return LazySaveableStateHolder_init_$Create$($parentRegistry, restored, $wrappedHolder);
    };
  }
  function LazySaveableStateHolder_init_$Init$(parentRegistry, restoredValues, wrappedHolder, $this) {
    LazySaveableStateHolder.call($this, SaveableStateRegistry(restoredValues, LazySaveableStateHolder$_init_$lambda_f4mmxz(parentRegistry)), wrappedHolder);
    return $this;
  }
  function LazySaveableStateHolder_init_$Create$(parentRegistry, restoredValues, wrappedHolder) {
    return LazySaveableStateHolder_init_$Init$(parentRegistry, restoredValues, wrappedHolder, objectCreate(protoOf(LazySaveableStateHolder)));
  }
  function Companion_11() {
  }
  protoOf(Companion_11).kj9 = function (parentRegistry, wrappedHolder) {
    var tmp = LazySaveableStateHolder$Companion$saver$lambda;
    return Saver(tmp, LazySaveableStateHolder$Companion$saver$lambda_0(parentRegistry, wrappedHolder));
  };
  var Companion_instance_21;
  function Companion_getInstance_70() {
    return Companion_instance_21;
  }
  function LazySaveableStateHolder$_init_$lambda_f4mmxz($parentRegistry) {
    return function (it) {
      var tmp0_safe_receiver = $parentRegistry;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z7n(it);
      return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
    };
  }
  function LazySaveableStateHolder$SaveableStateProvider$$inlined$cache$1$1(this$0, $key) {
    this.oj9_1 = this$0;
    this.pj9_1 = $key;
  }
  protoOf(LazySaveableStateHolder$SaveableStateProvider$$inlined$cache$1$1).s1d = function () {
    this.oj9_1.nj9_1.i11(this.pj9_1);
  };
  function LazySaveableStateHolder$SaveableStateProvider$lambda(this$0, $key) {
    return function ($this$DisposableEffect) {
      this$0.nj9_1.u16($key);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new LazySaveableStateHolder$SaveableStateProvider$$inlined$cache$1$1(this$0, $key);
    };
  }
  function LazySaveableStateHolder$SaveableStateProvider$lambda_0($tmp0_rcvr, $key, $content, $$changed) {
    return function ($composer, $force) {
      $tmp0_rcvr.x7o($key, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function LazySaveableStateHolder(wrappedRegistry, wrappedHolder) {
    this.lj9_1 = wrappedRegistry;
    this.mj9_1 = wrappedHolder;
    this.nj9_1 = mutableScatterSetOf();
  }
  protoOf(LazySaveableStateHolder).t7o = function () {
    // Inline function 'androidx.collection.ScatterSet.forEach' call
    var this_0 = this.nj9_1;
    // Inline function 'kotlin.contracts.contract' call
    var elements = this_0.k16_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m = this_0.j16_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var it = elements[index];
                  this.mj9_1.y7o(it);
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    return this.lj9_1.t7o();
  };
  protoOf(LazySaveableStateHolder).x7o = function (key, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-858296452);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(key) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(this) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      this.mj9_1.x7o(key, content, $composer_0, 14 & $dirty | 112 & $dirty);
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.q31(this) | $composer_0.q31(key));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = LazySaveableStateHolder$SaveableStateProvider$lambda(this, key);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      DisposableEffect_0(key, tmp$ret$0, $composer_0, 14 & $dirty);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(LazySaveableStateHolder$SaveableStateProvider$lambda_0(this, key, content, $changed));
    }
  };
  protoOf(LazySaveableStateHolder).y7o = function (key) {
    this.mj9_1.y7o(key);
  };
  protoOf(LazySaveableStateHolder).a7o = function (key) {
    return this.lj9_1.a7o(key);
  };
  protoOf(LazySaveableStateHolder).k7o = function (key, valueProvider) {
    return this.lj9_1.k7o(key, valueProvider);
  };
  protoOf(LazySaveableStateHolder).z7n = function (value) {
    return this.lj9_1.z7n(value);
  };
  function LazySaveableStateHolderProvider$lambda($currentRegistry, $wrappedHolder) {
    return function () {
      return LazySaveableStateHolder_init_$Create$($currentRegistry, emptyMap(), $wrappedHolder);
    };
  }
  function LazySaveableStateHolderProvider$lambda_0($content, $holder) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        tmp = $content($holder, $composer_0, 0);
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function LazySaveableStateHolderProvider$lambda_1($content, $$changed) {
    return function ($composer, $force) {
      LazySaveableStateHolderProvider($content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function _ObservableScopeInvalidator___init__impl__ism0sl(state) {
    state = state === VOID ? mutableStateOf(Unit_instance, neverEqualPolicy()) : state;
    return state;
  }
  function _get_state__b8zcm8($this) {
    return $this;
  }
  function ObservableScopeInvalidator__attachToScope_impl_wvvw97($this) {
    _get_state__b8zcm8($this).u1();
  }
  function ObservableScopeInvalidator__invalidateScope_impl_b202xc($this) {
    _get_state__b8zcm8($this).s21(Unit_instance);
  }
  function PriorityPrefetchScheduler() {
  }
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridSlots$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridBeyondBoundsState$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_StaggeredGridCells_Fixed$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_StaggeredGridCells_Adaptive$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_StaggeredGridCells_FixedSize$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridIntervalContent$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridInterval$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridItemScopeImpl$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridLaneInfo$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridMeasureContext$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridMeasureProvider$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridMeasuredItem$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridScrollPosition$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_StaggeredGridItemSpan$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridSpanProvider$stable;
  var androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridState$stable;
  var androidx_compose_foundation_pager_PagerLazyLayoutItemProvider$stable;
  var androidx_compose_foundation_pager_PagerIntervalContent$stable;
  function PagerLazyLayoutItemProvider$Item$lambda(this$0, $index) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var tmp0 = this$0.rj9_1;
        // Inline function 'androidx.compose.foundation.lazy.layout.LazyLayoutIntervalContent.withInterval' call
        var globalIndex = $index;
        var interval = tmp0.eif().l1(globalIndex);
        var localIntervalIndex = globalIndex - interval.tif_1 | 0;
        interval.vif_1.vj9_1(this$0.tj9_1, localIntervalIndex, $composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function PagerLazyLayoutItemProvider$Item$lambda_0($tmp0_rcvr, $index, $key, $$changed) {
    return function ($composer, $force) {
      $tmp0_rcvr.wif($index, $key, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function PagerLazyLayoutItemProvider(state, intervalContent, keyIndexMap) {
    this.qj9_1 = state;
    this.rj9_1 = intervalContent;
    this.sj9_1 = keyIndexMap;
    this.tj9_1 = PagerScopeImpl_instance;
  }
  protoOf(PagerLazyLayoutItemProvider).aie = function () {
    return this.rj9_1.aie();
  };
  protoOf(PagerLazyLayoutItemProvider).wif = function (index, key, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1201380429);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.m31(index) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(key) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(this) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1142237095, true, PagerLazyLayoutItemProvider$Item$lambda(this, index), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      LazyLayoutPinnableItem(key, index, this.qj9_1.mi1_1, tmp$ret$0, $composer_0, 3072 | 14 & $dirty >> 3 | 112 & $dirty << 3);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(PagerLazyLayoutItemProvider$Item$lambda_0(this, index, key, $changed));
    }
  };
  protoOf(PagerLazyLayoutItemProvider).jif = function (index) {
    var tmp0_elvis_lhs = this.sj9_1.jif(index);
    return tmp0_elvis_lhs == null ? this.rj9_1.jif(index) : tmp0_elvis_lhs;
  };
  protoOf(PagerLazyLayoutItemProvider).xif = function (key) {
    return this.sj9_1.xif(key);
  };
  protoOf(PagerLazyLayoutItemProvider).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PagerLazyLayoutItemProvider))
      return false;
    return equals(this.rj9_1, other.rj9_1);
  };
  protoOf(PagerLazyLayoutItemProvider).hashCode = function () {
    return hashCode(this.rj9_1);
  };
  function Pager(modifier, state, contentPadding, reverseLayout, orientation, flingBehavior, userScrollEnabled, overscrollEffect, beyondViewportPageCount, pageSpacing, pageSize, pageNestedScrollConnection, key, horizontalAlignment, verticalAlignment, snapPosition, pageContent, $composer, $changed, $changed1, $default) {
    var beyondViewportPageCount_0 = {_v: beyondViewportPageCount};
    var pageSpacing_0 = {_v: new Dp(pageSpacing)};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-572816025);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(state) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(contentPadding) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(reverseLayout) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.m31(orientation.a1_1) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.k31(flingBehavior) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.l31(userScrollEnabled) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.k31(overscrollEffect) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.m31(beyondViewportPageCount_0._v) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.n31(_Dp___get_value__impl__geb1vb(pageSpacing_0._v.m5f_1)) ? 536870912 : 268435456);
    if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(pageSize) ? 4 : 2);
    if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(pageNestedScrollConnection) ? 32 : 16);
    if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(key) ? 256 : 128);
    if (($changed1 & 3072) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(horizontalAlignment) ? 2048 : 1024);
    if (($changed1 & 24576) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(verticalAlignment) ? 16384 : 8192);
    if (($changed1 & 196608) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(snapPosition) ? 131072 : 65536);
    if (($changed1 & 1572864) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(pageContent) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 599187) === 599186), $dirty & 1)) {
      if (!(($default & 256) === 0)) {
        beyondViewportPageCount_0._v = 0;
      }
      if (!(($default & 512) === 0)) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
        pageSpacing_0._v = new Dp(tmp$ret$0);
      }
      // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
      if (!(beyondViewportPageCount_0._v >= 0)) {
        var tmp$ret$2 = 'beyondViewportPageCount should be greater than or equal to 0, ' + ('you selected ' + beyondViewportPageCount_0._v);
        throwIllegalArgumentException(tmp$ret$2);
      }
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 112) === 32;
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = Pager$lambda(state);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$3 = tmp;
      var pagerItemProvider = rememberPagerItemProviderLambda(state, pageContent, key, tmp$ret$3, $composer_0, 14 & $dirty >> 3 | 112 & $dirty1 >> 15 | 896 & $dirty1);
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_1 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = Pager$lambda_0;
      }
      var composer = $composer_1;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_0 = $composer_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = createCompositionCoroutineScope(getContext(), composer);
        $composer_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var coroutineScope = tmp_0;
      var tmp_1 = beyondViewportPageCount_0._v;
      var tmp_2 = pageSpacing_0._v;
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = ($dirty & 112) === 32;
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_0.i31();
      var tmp_3;
      if (invalid_0 || it_1 === Companion_getInstance_11().f30_1) {
        var value_1 = Pager$lambda_1(state);
        tmp0_0.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp$ret$12 = tmp_3;
      var measurePolicy = rememberPagerMeasurePolicy(pagerItemProvider, state, contentPadding, reverseLayout, orientation, tmp_1, tmp_2.m5f_1, pageSize, horizontalAlignment, verticalAlignment, snapPosition, coroutineScope, tmp$ret$12, $composer_0, 112 & $dirty | 896 & $dirty | 7168 & $dirty | 57344 & $dirty | 458752 & $dirty >> 9 | 3670016 & $dirty >> 9 | 29360128 & $dirty1 << 21 | 234881024 & $dirty1 << 15 | 1879048192 & $dirty1 << 15, 14 & $dirty1 >> 15);
      var semanticState = rememberPagerSemanticState(state, orientation.equals(Orientation_Vertical_getInstance()), $composer_0, 14 & $dirty >> 3);
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(($dirty & 112) === 32 | ($dirty & 458752) === 131072);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_1.i31();
      var tmp_4;
      if (invalid_1 || it_2 === Companion_getInstance_11().f30_1) {
        var value_2 = new PagerWrapperFlingBehavior(flingBehavior, state);
        tmp0_1.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var resolvedFlingBehavior = tmp_4;
      var tmp0_2 = get_LocalBringIntoViewSpec();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_2 = $composer_0;
      var defaultBringIntoViewSpec = $composer_2.u31(tmp0_2);
      var tmp0_3 = get_LocalLayoutDirection();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_3 = $composer_0;
      var layoutDirection = $composer_3.u31(tmp0_3);
      var tmp_5;
      if (ComposeFoundationFlags_instance.mfg_1) {
        $composer_0.m30(-853904960);
        var tmp0_4 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = !!(!!(($dirty & 112) === 32 | $composer_0.k31(defaultBringIntoViewSpec)) | $composer_0.m31(layoutDirection.a1_1));
        // Inline function 'kotlin.let' call
        var it_3 = tmp0_4.i31();
        var tmp_6;
        if (invalid_2 || it_3 === Companion_getInstance_11().f30_1) {
          var value_3 = new PagerBringIntoViewSpec(state, defaultBringIntoViewSpec, layoutDirection);
          tmp0_4.j31(value_3);
          tmp_6 = value_3;
        } else {
          tmp_6 = it_3;
        }
        var tmp0_group = tmp_6;
        $composer_0.n30();
        tmp_5 = tmp0_group;
      } else {
        $composer_0.m30(-853714372);
        var tmp0_5 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = !!(($dirty & 112) === 32 | $composer_0.k31(defaultBringIntoViewSpec));
        // Inline function 'kotlin.let' call
        var it_4 = tmp0_5.i31();
        var tmp_7;
        if (invalid_3 || it_4 === Companion_getInstance_11().f30_1) {
          var value_4 = new LegacyPagerBringIntoViewSpec(state, defaultBringIntoViewSpec);
          tmp0_5.j31(value_4);
          tmp_7 = value_4;
        } else {
          tmp_7 = it_4;
        }
        var tmp1_group = tmp_7;
        $composer_0.n30();
        tmp_5 = tmp1_group;
      }
      var pagerBringIntoViewSpec = tmp_5;
      var tmp_8;
      if (userScrollEnabled) {
        $composer_0.m30(-853484445);
        var tmp2_group = lazyLayoutBeyondBoundsModifier(Companion_instance_0, rememberPagerBeyondBoundsState(state, beyondViewportPageCount_0._v, $composer_0, 14 & $dirty >> 3 | 112 & $dirty >> 21), state.hi1_1, reverseLayout, orientation);
        $composer_0.n30();
        tmp_8 = tmp2_group;
      } else {
        $composer_0.m30(-853054661);
        $composer_0.n30();
        tmp_8 = Companion_instance_0;
      }
      var beyondBoundsModifier = tmp_8;
      var tmp0_$receiver = pagerSemantics(lazyLayoutSemantics(modifier.d8v(state.ki1_1).d8v(state.ii1_1), pagerItemProvider, semanticState, orientation, userScrollEnabled, reverseLayout, $composer_0, 7168 & $dirty >> 3 | 57344 & $dirty >> 6 | 458752 & $dirty << 6), state, orientation.equals(Orientation_Vertical_getInstance()), coroutineScope, userScrollEnabled).d8v(beyondBoundsModifier);
      var tmp1_interactionSource = state.yi0_1;
      var tmp2_modifier = nestedScroll(dragDirectionDetector(scrollableArea_0(tmp0_$receiver, state, orientation, overscrollEffect, userScrollEnabled, reverseLayout, resolvedFlingBehavior, tmp1_interactionSource, pagerBringIntoViewSpec), state), pageNestedScrollConnection);
      var tmp3_prefetchState = state.di1_1;
      LazyLayout(pagerItemProvider, tmp2_modifier, tmp3_prefetchState, measurePolicy, $composer_0, 0, 0);
    } else {
      $composer_0.z30();
    }
    var tmp3_safe_receiver = $composer_0.t30();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.p3c(Pager$lambda_2(modifier, state, contentPadding, reverseLayout, orientation, flingBehavior, userScrollEnabled, overscrollEffect, beyondViewportPageCount_0, pageSpacing_0, pageSize, pageNestedScrollConnection, key, horizontalAlignment, verticalAlignment, snapPosition, pageContent, $changed, $changed1, $default));
    }
  }
  function PagerIntervalContent(key, item) {
    this.uj9_1 = key;
    this.vj9_1 = item;
  }
  protoOf(PagerIntervalContent).t1 = function () {
    return this.uj9_1;
  };
  function rememberPagerItemProviderLambda(state, pageContent, key, pageCount, $composer, $changed) {
    var $composer_0 = $composer;
    var latestContent = rememberUpdatedState(pageContent, $composer_0, 14 & $changed >> 3);
    var latestKey = rememberUpdatedState(key, $composer_0, 14 & $changed >> 6);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!((($changed & 14 ^ 6) > 4 && $composer_0.k31(state) || ($changed & 6) === 4) | $composer_0.k31(latestContent)) | $composer_0.k31(latestKey)) | (($changed & 7168 ^ 3072) > 2048 && $composer_0.k31(pageCount) || ($changed & 3072) === 2048));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var tmp_0 = referentialEqualityPolicy();
      var intervalContentState = derivedStateOf_0(tmp_0, rememberPagerItemProviderLambda$lambda(latestContent, latestKey, pageCount));
      var tmp_1 = referentialEqualityPolicy();
      var itemProviderState = derivedStateOf_0(tmp_1, rememberPagerItemProviderLambda$lambda_0(intervalContentState, state));
      var tmp_2 = KProperty0;
      var value = getPropertyCallableRef('value', 0, tmp_2, State$_get_value_$ref_hr9f44_1(itemProviderState), null);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function PagerWrapperFlingBehavior$performFling$lambda(this$0, $scope) {
    return function (remainingScrollOffset) {
      var tmp;
      if (!(this$0.xj9_1.yj9() === 0)) {
        tmp = remainingScrollOffset / this$0.xj9_1.yj9();
      } else {
        tmp = 0.0;
      }
      var flingPageDisplacement = tmp;
      // Inline function 'kotlin.math.roundToInt' call
      var targetPage = roundToInt(flingPageDisplacement) + this$0.xj9_1.zj9() | 0;
      // Inline function 'kotlin.with' call
      this$0.xj9_1.aja($scope, targetPage);
      return Unit_instance;
    };
  }
  function $performFlingCOROUTINE$_0(_this__u8e3s4, _this__u8e3s4_0, initialVelocity, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jja_1 = _this__u8e3s4;
    this.kja_1 = _this__u8e3s4_0;
    this.lja_1 = initialVelocity;
  }
  protoOf($performFlingCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var scope = this.kja_1;
            var $this$with = this.jja_1.wj9_1;
            this.n9_1 = 1;
            suspendResult = $this$with.qhv(this.kja_1, this.lja_1, PagerWrapperFlingBehavior$performFling$lambda(this.jja_1, scope), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var resultVelocity = suspendResult;
            var tmp_0;
            if (!(this.jja_1.xj9_1.mja() === 0.0)) {
              var this_0 = this.jja_1.xj9_1.mja();
              tmp_0 = Math.abs(this_0) < 0.001;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this.jja_1.xj9_1.nja(this.jja_1.xj9_1.zj9());
            } else {
              this.jja_1.xj9_1.mja();
            }

            return resultVelocity;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function PagerWrapperFlingBehavior(originalFlingBehavior, pagerState) {
    this.wj9_1 = originalFlingBehavior;
    this.xj9_1 = pagerState;
  }
  protoOf(PagerWrapperFlingBehavior).whd = function (_this__u8e3s4, initialVelocity, $completion) {
    var tmp = new $performFlingCOROUTINE$_0(this, _this__u8e3s4, initialVelocity, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function settlingScrollDistance($this, containerSize) {
    var reversedFirstPageScroll = $this.rja($this.oja_1) * -1.0;
    var tmp;
    if (_get_shouldChangeScrollDirection__5tr9xa($this, $this.oja_1)) {
      var tmp_0;
      if ($this.oja_1.sja()) {
        tmp_0 = reversedFirstPageScroll;
      } else {
        tmp_0 = reversedFirstPageScroll + $this.oja_1.yj9();
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if ($this.oja_1.sja()) {
        tmp_1 = reversedFirstPageScroll + $this.oja_1.yj9();
      } else {
        tmp_1 = reversedFirstPageScroll;
      }
      tmp = tmp_1;
    }
    return coerceIn_0(tmp, -containerSize, containerSize);
  }
  function overrideProposedOffsetMove($this, proposedOffsetMove) {
    var correctedOffset = $this.rja($this.oja_1) * -1;
    while (proposedOffsetMove > 0.0 && correctedOffset < proposedOffsetMove) {
      correctedOffset = correctedOffset + $this.oja_1.yj9();
    }
    while (proposedOffsetMove < 0.0 && correctedOffset > proposedOffsetMove) {
      correctedOffset = correctedOffset - $this.oja_1.yj9();
    }
    return correctedOffset;
  }
  function _get_shouldChangeScrollDirection__5tr9xa($this, $receiver) {
    return $this.qja_1.equals(LayoutDirection_Rtl_getInstance()) && $receiver.thz().lhy().equals(Orientation_Horizontal_getInstance());
  }
  function PagerBringIntoViewSpec(pagerState, defaultBringIntoViewSpec, layoutDirection) {
    this.oja_1 = pagerState;
    this.pja_1 = defaultBringIntoViewSpec;
    this.qja_1 = layoutDirection;
  }
  protoOf(PagerBringIntoViewSpec).kge = function (offset, size, containerSize) {
    var proposedOffsetMove = this.pja_1.kge(offset, size, containerSize);
    var tmp;
    if (offset > 0) {
      tmp = offset + size > containerSize;
    } else {
      tmp = offset + size <= get_VisibilityThreshold_0(IntCompanionObject_instance);
    }
    var isItemOutView = tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'kotlin.math.absoluteValue' call
    if (!(Math.abs(proposedOffsetMove) === 0.0)) {
      tmp_1 = isItemOutView;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = overrideProposedOffsetMove(this, proposedOffsetMove);
    } else {
      var tmp_2;
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = this.oja_1.ji0_1;
      if (abs(this_0) < 1.0E-6) {
        tmp_2 = 0.0;
      } else {
        tmp_2 = settlingScrollDistance(this, containerSize);
      }
      tmp_0 = tmp_2;
    }
    var finalOffset = tmp_0;
    return finalOffset;
  };
  protoOf(PagerBringIntoViewSpec).rja = function (_this__u8e3s4) {
    var tmp;
    if (_get_shouldChangeScrollDirection__5tr9xa(this, _this__u8e3s4)) {
      tmp = (-_this__u8e3s4.ji0_1 | 0) + _this__u8e3s4.yj9() | 0;
    } else {
      tmp = _this__u8e3s4.ji0_1;
    }
    return tmp;
  };
  function overrideProposedOffsetMove_0($this, proposedOffsetMove) {
    var correctedOffset = $this.tja_1.ji0_1 * -1;
    while (proposedOffsetMove > 0.0 && correctedOffset < proposedOffsetMove) {
      correctedOffset = correctedOffset + $this.tja_1.yj9();
    }
    while (proposedOffsetMove < 0.0 && correctedOffset > proposedOffsetMove) {
      correctedOffset = correctedOffset - $this.tja_1.yj9();
    }
    return correctedOffset;
  }
  function LegacyPagerBringIntoViewSpec(pagerState, defaultBringIntoViewSpec) {
    this.tja_1 = pagerState;
    this.uja_1 = defaultBringIntoViewSpec;
  }
  protoOf(LegacyPagerBringIntoViewSpec).kge = function (offset, size, containerSize) {
    var proposedOffsetMove = this.uja_1.kge(offset, size, containerSize);
    var tmp;
    if (offset > 0) {
      tmp = offset + size > containerSize;
    } else {
      tmp = offset + size <= 0;
    }
    var isItemOutView = tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'kotlin.math.absoluteValue' call
    if (!(Math.abs(proposedOffsetMove) === 0.0)) {
      tmp_1 = isItemOutView;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = overrideProposedOffsetMove_0(this, proposedOffsetMove);
    } else {
      var tmp_2;
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = this.tja_1.ji0_1;
      if (abs(this_0) < 1.0E-6) {
        tmp_2 = 0.0;
      } else {
        var reversedFirstPageScroll = this.tja_1.ji0_1 * -1.0;
        var tmp_3;
        if (this.tja_1.sja()) {
          tmp_3 = reversedFirstPageScroll + this.tja_1.yj9();
        } else {
          tmp_3 = reversedFirstPageScroll;
        }
        tmp_2 = coerceIn_0(tmp_3, -containerSize, containerSize);
      }
      tmp_0 = tmp_2;
    }
    var finalOffset = tmp_0;
    return finalOffset;
  };
  function dragDirectionDetector(_this__u8e3s4, state) {
    var tmp = Companion_instance_0;
    var tmp_0 = dragDirectionDetector$slambda_0(state, null);
    return _this__u8e3s4.d8v(pointerInput(tmp, state, new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1(tmp_0)));
  }
  function PagerLayoutIntervalContent(pageContent, key, pageCount) {
    LazyLayoutIntervalContent.call(this);
    this.vja_1 = pageContent;
    this.wja_1 = key;
    this.xja_1 = pageCount;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new MutableIntervalList();
    this_0.iif(this.xja_1, new PagerIntervalContent(this.wja_1, this.vja_1));
    tmp.yja_1 = this_0;
  }
  protoOf(PagerLayoutIntervalContent).eif = function () {
    return this.yja_1;
  };
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1(function_0) {
    this.zja_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1).ka7 = function (_this__u8e3s4, $completion) {
    return this.zja_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1).q3 = function () {
    return this.zja_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function Pager$lambda($state) {
    return function () {
      return $state.di2();
    };
  }
  function Pager$lambda_0() {
    return EmptyCoroutineContext_getInstance();
  }
  function Pager$lambda_1($state) {
    return function () {
      return $state.di2();
    };
  }
  function Pager$lambda_2($modifier, $state, $contentPadding, $reverseLayout, $orientation, $flingBehavior, $userScrollEnabled, $overscrollEffect, $beyondViewportPageCount, $pageSpacing, $pageSize, $pageNestedScrollConnection, $key, $horizontalAlignment, $verticalAlignment, $snapPosition, $pageContent, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      Pager($modifier, $state, $contentPadding, $reverseLayout, $orientation, $flingBehavior, $userScrollEnabled, $overscrollEffect, $beyondViewportPageCount._v, $pageSpacing._v.m5f_1, $pageSize, $pageNestedScrollConnection, $key, $horizontalAlignment, $verticalAlignment, $snapPosition, $pageContent, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function rememberPagerItemProviderLambda$lambda($latestContent, $latestKey, $pageCount) {
    return function () {
      return new PagerLayoutIntervalContent($latestContent.u1(), $latestKey.u1(), $pageCount());
    };
  }
  function rememberPagerItemProviderLambda$lambda_0($intervalContentState, $state) {
    return function () {
      var intervalContent = $intervalContentState.u1();
      var map = new NearestRangeKeyIndexMap($state.yif(), intervalContent);
      return new PagerLazyLayoutItemProvider($state, intervalContent, map);
    };
  }
  function State$_get_value_$ref_hr9f44_1(p0) {
    return constructCallableReference(function () {
      return p0.u1();
    }, 0, 0, 256, VOID, [p0]);
  }
  function dragDirectionDetector$slambda$slambda$slambda($state, resultContinuation) {
    this.ijb_1 = $state;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(dragDirectionDetector$slambda$slambda$slambda).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(dragDirectionDetector$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(dragDirectionDetector$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            suspendResult = awaitFirstDown(this.jjb_1, false, PointerEventPass_Initial_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.kjb_1 = suspendResult;
            this.ljb_1 = null;
            this.ijb_1.mjb(Companion_getInstance_6().g5d_1);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!(this.ljb_1 == null)) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 3;
            suspendResult = this.jjb_1.pa7(PointerEventPass_Initial_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var event = suspendResult;
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (!changedToUp(item)) {
                    tmp$ret$0 = false;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$0 = true;
            }
             while (false);
            if (tmp$ret$0) {
              this.ljb_1 = event.ca0_1.l1(0);
            }

            this.n9_1 = 2;
            continue $sm;
          case 4:
            this.ijb_1.mjb(Offset__minus_impl_hoj2c0(this.ljb_1.ka0_1, this.kjb_1.ka0_1));
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(dragDirectionDetector$slambda$slambda$slambda).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new dragDirectionDetector$slambda$slambda$slambda(this.ijb_1, completion);
    i.jjb_1 = $this$awaitEachGesture;
    return i;
  };
  function dragDirectionDetector$slambda$slambda$slambda_0($state, resultContinuation) {
    var i = new dragDirectionDetector$slambda$slambda$slambda($state, resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  function dragDirectionDetector$slambda$slambda($this_pointerInput, $state, resultContinuation) {
    this.vjb_1 = $this_pointerInput;
    this.wjb_1 = $state;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(dragDirectionDetector$slambda$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(dragDirectionDetector$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(dragDirectionDetector$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = awaitEachGesture(this.vjb_1, dragDirectionDetector$slambda$slambda$slambda_0(this.wjb_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(dragDirectionDetector$slambda$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new dragDirectionDetector$slambda$slambda(this.vjb_1, this.wjb_1, completion);
    i.xjb_1 = $this$coroutineScope;
    return i;
  };
  function dragDirectionDetector$slambda$slambda_0($this_pointerInput, $state, resultContinuation) {
    var i = new dragDirectionDetector$slambda$slambda($this_pointerInput, $state, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function dragDirectionDetector$slambda($state, resultContinuation) {
    this.gjc_1 = $state;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(dragDirectionDetector$slambda).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(dragDirectionDetector$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(dragDirectionDetector$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = coroutineScope(dragDirectionDetector$slambda$slambda_0(this.hjc_1, this.gjc_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(dragDirectionDetector$slambda).wc6 = function ($this$pointerInput, completion) {
    var i = new dragDirectionDetector$slambda(this.gjc_1, completion);
    i.hjc_1 = $this$pointerInput;
    return i;
  };
  function dragDirectionDetector$slambda_0($state, resultContinuation) {
    var i = new dragDirectionDetector$slambda($state, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function LazyLayoutSemanticState_0(state, isVertical) {
    return new LazyLayoutSemanticState$1_0(state, isVertical);
  }
  function LazyLayoutSemanticState$1_0($state, $isVertical) {
    this.ijc_1 = $state;
    this.jjc_1 = $isVertical;
  }
  protoOf(LazyLayoutSemanticState$1_0).kia = function () {
    return toNumber(currentAbsoluteScrollOffset(this.ijc_1));
  };
  protoOf(LazyLayoutSemanticState$1_0).nia = function () {
    return toNumber(calculateNewMaxScrollOffset(this.ijc_1.thz(), this.ijc_1.di2()));
  };
  protoOf(LazyLayoutSemanticState$1_0).oia = function (index, $completion) {
    return this.ijc_1.kjc(index, VOID, $completion);
  };
  protoOf(LazyLayoutSemanticState$1_0).qia = function () {
    var tmp;
    if (this.jjc_1) {
      tmp = new CollectionInfo(this.ijc_1.di2(), 1);
    } else {
      tmp = new CollectionInfo(1, this.ijc_1.di2());
    }
    return tmp;
  };
  protoOf(LazyLayoutSemanticState$1_0).ria = function () {
    var tmp;
    if (this.ijc_1.thz().lhy().equals(Orientation_Vertical_getInstance())) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_0 = this.ijc_1.thz().khy();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      tmp = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = this.ijc_1.thz().khy();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      tmp = convertToInt(shiftRight(value_0, 32));
    }
    return tmp;
  };
  protoOf(LazyLayoutSemanticState$1_0).sia = function () {
    return this.ijc_1.thz().yhz() + this.ijc_1.thz().zhz() | 0;
  };
  var androidx_compose_foundation_pager_MeasuredPage$stable;
  function getOffset($this, index) {
    var tmp0 = $this.wjc_1[imul(index, 2)];
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = $this.wjc_1[imul(index, 2) + 1 | 0];
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntOffset___init__impl__rq8h7b(tmp$ret$1);
  }
  function _get_mainAxisSize__iyci34_1($this, $receiver) {
    return $this.ujc_1 ? $receiver.j8y_1 : $receiver.i8y_1;
  }
  function MeasuredPage(index, size, placeables, visualOffset, key, orientation, horizontalAlignment, verticalAlignment, layoutDirection, reverseLayout) {
    this.ljc_1 = index;
    this.mjc_1 = size;
    this.njc_1 = placeables;
    this.ojc_1 = visualOffset;
    this.pjc_1 = key;
    this.qjc_1 = horizontalAlignment;
    this.rjc_1 = verticalAlignment;
    this.sjc_1 = layoutDirection;
    this.tjc_1 = reverseLayout;
    this.ujc_1 = orientation.equals(Orientation_Vertical_getInstance());
    var maxCrossAxis = 0;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.njc_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index_0);
        var tmp0 = maxCrossAxis;
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = !this.ujc_1 ? item.j8y_1 : item.i8y_1;
        maxCrossAxis = Math.max(tmp0, b);
      }
       while (inductionVariable <= last);
    this.vjc_1 = maxCrossAxis;
    this.wjc_1 = new Int32Array(imul(this.njc_1.n1(), 2));
    this.xjc_1 = 0;
    this.yjc_1 = -2147483648;
  }
  protoOf(MeasuredPage).bi0 = function () {
    return this.ljc_1;
  };
  protoOf(MeasuredPage).ai0 = function () {
    return this.xjc_1;
  };
  protoOf(MeasuredPage).fig = function (offset, layoutWidth, layoutHeight) {
    this.xjc_1 = offset;
    this.yjc_1 = this.ujc_1 ? layoutHeight : layoutWidth;
    var mainAxisOffset = offset;
    // Inline function 'androidx.compose.ui.util.fastForEachIndexed' call
    var this_0 = this.njc_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        var indexInArray = imul(index, 2);
        if (this.ujc_1) {
          // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
          var value = this.qjc_1;
          if (value == null) {
            var tmp$ret$3 = 'null horizontalAlignment';
            throwIllegalArgumentExceptionForNullCheck(tmp$ret$3);
          }
          this.wjc_1[indexInArray] = value.a8u(item.i8y_1, layoutWidth, this.sjc_1);
          this.wjc_1[indexInArray + 1 | 0] = mainAxisOffset;
          mainAxisOffset = mainAxisOffset + item.j8y_1 | 0;
        } else {
          this.wjc_1[indexInArray] = mainAxisOffset;
          var tmp = indexInArray + 1 | 0;
          // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
          var value_0 = this.rjc_1;
          if (value_0 == null) {
            var tmp$ret$5 = 'null verticalAlignment';
            throwIllegalArgumentExceptionForNullCheck(tmp$ret$5);
          }
          this.wjc_1[tmp] = value_0.c8u(item.j8y_1, layoutHeight);
          mainAxisOffset = mainAxisOffset + item.i8y_1 | 0;
        }
      }
       while (inductionVariable <= last);
  };
  protoOf(MeasuredPage).zjc = function (scope) {
    // Inline function 'kotlin.with' call
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!!(this.yjc_1 === -2147483648)) {
      var tmp$ret$3 = 'position() should be called first';
      throwIllegalArgumentException(tmp$ret$3);
    }
    // Inline function 'kotlin.repeat' call
    var times = this.njc_1.n1();
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var placeable = this.njc_1.l1(index);
        var offset = getOffset(this, index);
        if (this.tjc_1) {
          // Inline function 'androidx.compose.foundation.pager.MeasuredPage.copy' call
          var this_0 = offset;
          var tmp;
          if (this.ujc_1) {
            tmp = _IntOffset___get_x__impl__qiqr5o(this_0);
          } else {
            var mainAxisOffset = _IntOffset___get_x__impl__qiqr5o(this_0);
            tmp = (this.yjc_1 - mainAxisOffset | 0) - _get_mainAxisSize__iyci34_1(this, placeable) | 0;
          }
          var tmp0 = tmp;
          var tmp_0;
          if (this.ujc_1) {
            var mainAxisOffset_0 = _IntOffset___get_y__impl__2avpwj(this_0);
            tmp_0 = (this.yjc_1 - mainAxisOffset_0 | 0) - _get_mainAxisSize__iyci34_1(this, placeable) | 0;
          } else {
            tmp_0 = _IntOffset___get_y__impl__2avpwj(this_0);
          }
          // Inline function 'androidx.compose.ui.unit.IntOffset' call
          // Inline function 'androidx.compose.ui.util.packInts' call
          var val2 = tmp_0;
          var tmp$ret$10 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
          offset = _IntOffset___init__impl__rq8h7b(tmp$ret$10);
        }
        offset = IntOffset__plus_impl_nqoa9b(offset, this.ojc_1);
        if (this.ujc_1) {
          scope.ual(placeable, offset);
        } else {
          scope.nal(placeable, offset);
        }
      }
       while (inductionVariable < times);
    return Unit_instance;
  };
  protoOf(MeasuredPage).ajd = function (delta) {
    this.xjc_1 = this.xjc_1 + delta | 0;
    // Inline function 'kotlin.repeat' call
    var times = this.wjc_1.length;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.ujc_1 && (index % 2 | 0) === 1 || (!this.ujc_1 && (index % 2 | 0) === 0)) {
          var _array__4zh2yp = this.wjc_1;
          _array__4zh2yp[index] = _array__4zh2yp[index] + delta | 0;
        }
      }
       while (inductionVariable < times);
  };
  var androidx_compose_foundation_pager_PageSize_Fill$stable;
  var androidx_compose_foundation_pager_PageSize_Fixed$stable;
  function Fill() {
  }
  protoOf(Fill).bjd = function (_this__u8e3s4, availableSpace, pageSpacing) {
    return availableSpace;
  };
  var Fill_instance;
  function Fill_getInstance_0() {
    return Fill_instance;
  }
  var androidx_compose_foundation_pager_PagerDefaults$stable;
  var androidx_compose_foundation_pager_PagerDebugConfig$stable;
  function HorizontalPager(state, modifier, contentPadding, pageSize, beyondViewportPageCount, pageSpacing, verticalAlignment, flingBehavior, userScrollEnabled, reverseLayout, key, pageNestedScrollConnection, snapPosition, overscrollEffect, pageContent, $composer, $changed, $changed1, $default) {
    var modifier_0 = {_v: modifier};
    var contentPadding_0 = {_v: contentPadding};
    var pageSize_0 = {_v: pageSize};
    var beyondViewportPageCount_0 = {_v: beyondViewportPageCount};
    var pageSpacing_0 = {_v: new Dp(pageSpacing)};
    var verticalAlignment_0 = {_v: verticalAlignment};
    var flingBehavior_0 = {_v: flingBehavior};
    var userScrollEnabled_0 = {_v: userScrollEnabled};
    var reverseLayout_0 = {_v: reverseLayout};
    var key_0 = {_v: key};
    var pageNestedScrollConnection_0 = {_v: pageNestedScrollConnection};
    var snapPosition_0 = {_v: snapPosition};
    var overscrollEffect_0 = {_v: overscrollEffect};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1860873769);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(state) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(contentPadding_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(pageSize_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.m31(beyondViewportPageCount_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.n31(_Dp___get_value__impl__geb1vb(pageSpacing_0._v.m5f_1)) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(verticalAlignment_0._v) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | (($default & 128) === 0 && $composer_0.k31(flingBehavior_0._v) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.l31(userScrollEnabled_0._v) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.l31(reverseLayout_0._v) ? 536870912 : 268435456);
    if (!(($default & 1024) === 0))
      $dirty1 = $dirty1 | 6;
    else if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(key_0._v) ? 4 : 2);
    if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | (($default & 2048) === 0 && $composer_0.q31(pageNestedScrollConnection_0._v) ? 32 : 16);
    if (!(($default & 4096) === 0))
      $dirty1 = $dirty1 | 384;
    else if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(snapPosition_0._v) ? 256 : 128);
    if (($changed1 & 3072) === 0)
      $dirty1 = $dirty1 | (($default & 8192) === 0 && $composer_0.k31(overscrollEffect_0._v) ? 2048 : 1024);
    if (($changed1 & 24576) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(pageContent) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 9363) === 9362), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 2) === 0)) {
          modifier_0._v = Companion_instance_0;
        }
        if (!(($default & 4) === 0)) {
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
          contentPadding_0._v = PaddingValues(tmp$ret$0);
        }
        if (!(($default & 8) === 0)) {
          pageSize_0._v = Fill_instance;
        }
        if (!(($default & 16) === 0)) {
          beyondViewportPageCount_0._v = 0;
        }
        if (!(($default & 32) === 0)) {
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$1 = _Dp___init__impl__ms3zkb(0);
          pageSpacing_0._v = new Dp(tmp$ret$1);
        }
        if (!(($default & 64) === 0)) {
          verticalAlignment_0._v = Companion_getInstance_12().u8t_1;
        }
        if (!(($default & 128) === 0)) {
          var tmp = PagerDefaults_instance;
          flingBehavior_0._v = tmp.djd(state, null, null, null, 0.0, $composer_0, 196608 | 14 & $dirty, 30);
          $dirty = $dirty & -29360129;
        }
        if (!(($default & 256) === 0)) {
          userScrollEnabled_0._v = true;
        }
        if (!(($default & 512) === 0)) {
          reverseLayout_0._v = false;
        }
        if (!(($default & 1024) === 0)) {
          key_0._v = null;
        }
        if (!(($default & 2048) === 0)) {
          pageNestedScrollConnection_0._v = PagerDefaults_instance.ejd(state, Orientation_Horizontal_getInstance(), $composer_0, 432 | 14 & $dirty);
          $dirty1 = $dirty1 & -113;
        }
        if (!(($default & 4096) === 0)) {
          snapPosition_0._v = Start_instance;
        }
        if (!(($default & 8192) === 0)) {
          overscrollEffect_0._v = rememberOverscrollEffect($composer_0, 0);
          $dirty1 = $dirty1 & -7169;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 128) === 0))
          $dirty = $dirty & -29360129;
        if (!(($default & 2048) === 0))
          $dirty1 = $dirty1 & -113;
        if (!(($default & 8192) === 0))
          $dirty1 = $dirty1 & -7169;
      }
      $composer_0.r30();
      var tmp0_orientation = Orientation_Horizontal_getInstance();
      var tmp1_horizontalAlignment = Companion_getInstance_12().x8t_1;
      Pager(modifier_0._v, state, contentPadding_0._v, reverseLayout_0._v, tmp0_orientation, flingBehavior_0._v, userScrollEnabled_0._v, overscrollEffect_0._v, beyondViewportPageCount_0._v, pageSpacing_0._v.m5f_1, pageSize_0._v, pageNestedScrollConnection_0._v, key_0._v, tmp1_horizontalAlignment, verticalAlignment_0._v, snapPosition_0._v, pageContent, $composer_0, 24576 | 14 & $dirty >> 3 | 112 & $dirty << 3 | 896 & $dirty | 7168 & $dirty >> 18 | 458752 & $dirty >> 6 | 3670016 & $dirty >> 6 | 29360128 & $dirty1 << 12 | 234881024 & $dirty << 12 | 1879048192 & $dirty << 12, 3072 | 14 & $dirty >> 9 | 112 & $dirty1 | 896 & $dirty1 << 6 | 57344 & $dirty >> 6 | 458752 & $dirty1 << 9 | 3670016 & $dirty1 << 6, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(HorizontalPager$lambda(state, modifier_0, contentPadding_0, pageSize_0, beyondViewportPageCount_0, pageSpacing_0, verticalAlignment_0, flingBehavior_0, userScrollEnabled_0, reverseLayout_0, key_0, pageNestedScrollConnection_0, snapPosition_0, overscrollEffect_0, pageContent, $changed, $changed1, $default));
    }
  }
  function PagerDefaults$flingBehavior$lambda($state, $layoutDirection, $snapPositionalThreshold) {
    return function (flingVelocity, lowerBound, upperBound) {
      return calculateFinalSnappingBound($state, $layoutDirection, $snapPositionalThreshold._v, flingVelocity, lowerBound, upperBound);
    };
  }
  function PagerDefaults() {
    this.cjd_1 = 0;
  }
  protoOf(PagerDefaults).djd = function (state, pagerSnapDistance, decayAnimationSpec, snapAnimationSpec, snapPositionalThreshold, $composer, $changed, $default) {
    var pagerSnapDistance_0 = pagerSnapDistance;
    var decayAnimationSpec_0 = decayAnimationSpec;
    var snapAnimationSpec_0 = snapAnimationSpec;
    var snapPositionalThreshold_0 = {_v: snapPositionalThreshold};
    var $composer_0 = $composer;
    if (!(($default & 2) === 0))
      pagerSnapDistance_0 = Companion_instance_22.fjd(1);
    if (!(($default & 4) === 0))
      decayAnimationSpec_0 = rememberSplineBasedDecay($composer_0, 0);
    if (!(($default & 8) === 0))
      snapAnimationSpec_0 = spring(VOID, 400.0, get_VisibilityThreshold_0(IntCompanionObject_instance));
    if (!(($default & 16) === 0)) {
      snapPositionalThreshold_0._v = 0.5;
    }
    var containsArg = snapPositionalThreshold_0._v;
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(0.0 <= containsArg ? containsArg <= 1.0 : false)) {
      var tmp$ret$1 = 'snapPositionalThreshold should be a number between 0 and 1. ' + ("You've specified " + snapPositionalThreshold_0._v);
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalDensity();
    var $composer_1 = $composer_0;
    var density = $composer_1.u31(this_0);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_1 = get_LocalLayoutDirection();
    var $composer_2 = $composer_0;
    var layoutDirection = $composer_2.u31(this_1);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!(!!(!!((($changed & 14 ^ 6) > 4 && $composer_0.k31(state) || ($changed & 6) === 4) | $composer_0.k31(decayAnimationSpec_0)) | $composer_0.k31(snapAnimationSpec_0)) | (($changed & 112 ^ 48) > 32 && $composer_0.k31(pagerSnapDistance_0) || ($changed & 48) === 32)) | $composer_0.k31(density)) | $composer_0.m31(layoutDirection.a1_1));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var tmp_0 = pagerSnapDistance_0;
      var snapLayoutInfoProvider = SnapLayoutInfoProvider_0(state, tmp_0, PagerDefaults$flingBehavior$lambda(state, layoutDirection, snapPositionalThreshold_0));
      var value = snapFlingBehavior(snapLayoutInfoProvider, decayAnimationSpec_0, snapAnimationSpec_0);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  };
  protoOf(PagerDefaults).ejd = function (state, orientation, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(state) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.m31(orientation.a1_1) || ($changed & 48) === 32));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = new DefaultPagerNestedScrollConnection(state, orientation);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  };
  var PagerDefaults_instance;
  function PagerDefaults_getInstance() {
    return PagerDefaults_instance;
  }
  function toFloat_2($this, $receiver) {
    var tmp;
    if ($this.hjd_1.equals(Orientation_Horizontal_getInstance())) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q($receiver);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      tmp = floatFromBits(bits);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q($receiver);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp = floatFromBits(bits_0);
    }
    return tmp;
  }
  function mainAxis($this, $receiver) {
    var tmp;
    if ($this.hjd_1.equals(Orientation_Horizontal_getInstance())) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q($receiver);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      tmp = floatFromBits(bits);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q($receiver);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp = floatFromBits(bits_0);
    }
    return tmp;
  }
  function DefaultPagerNestedScrollConnection(state, orientation) {
    this.gjd_1 = state;
    this.hjd_1 = orientation;
  }
  protoOf(DefaultPagerNestedScrollConnection).ijd = function (_this__u8e3s4, orientation) {
    var tmp;
    if (orientation.equals(Orientation_Vertical_getInstance())) {
      tmp = Velocity__copy$default_impl_eql69u(_this__u8e3s4, 0.0);
    } else {
      tmp = Velocity__copy$default_impl_eql69u(_this__u8e3s4, VOID, 0.0);
    }
    return tmp;
  };
  protoOf(DefaultPagerNestedScrollConnection).z9u = function (available, source) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (source === Companion_getInstance_20().d9v_1) {
      // Inline function 'kotlin.math.abs' call
      var x = this.gjd_1.mja();
      tmp_1 = Math.abs(x) > 1.0E-6;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = toFloat_2(this, available);
      tmp_0 = Math.abs(this_0) > 0.0;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var layoutInfo = this.gjd_1.thz();
      var currentPageOffset = this.gjd_1.mja() * this.gjd_1.gi2();
      var pageAvailableSpace = layoutInfo.ui1() + layoutInfo.jjd() | 0;
      // Inline function 'kotlin.math.sign' call
      var x_0 = this.gjd_1.mja();
      var nextClosestPageOffset = currentPageOffset + pageAvailableSpace * -sign(x_0);
      var minBound;
      var maxBound;
      if (this.gjd_1.mja() > 0.0) {
        minBound = nextClosestPageOffset;
        maxBound = currentPageOffset;
      } else {
        minBound = currentPageOffset;
        maxBound = nextClosestPageOffset;
      }
      var delta = toFloat_2(this, available);
      var coerced = coerceIn_0(delta, minBound, maxBound);
      var tmp_2;
      if (this.hjd_1.equals(Orientation_Horizontal_getInstance()) && layoutInfo.wi1() && ComposeFoundationFlags_instance.vfg_1) {
        tmp_2 = this.gjd_1.rg7(coerced);
      } else {
        tmp_2 = -this.gjd_1.rg7(-coerced);
      }
      var consumed = tmp_2;
      var tmp_3;
      if (this.hjd_1.equals(Orientation_Horizontal_getInstance())) {
        tmp_3 = consumed;
      } else {
        // Inline function 'androidx.compose.ui.geometry.Offset.x' call
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value = _Offset___get_packedValue__impl__xh2k8q(available);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value, 32));
        tmp_3 = floatFromBits(bits);
      }
      var tmp_4 = tmp_3;
      var tmp_5;
      if (this.hjd_1.equals(Orientation_Vertical_getInstance())) {
        tmp_5 = consumed;
      } else {
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_0 = _Offset___get_packedValue__impl__xh2k8q(available);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        tmp_5 = floatFromBits(bits_0);
      }
      tmp = Offset__copy_impl_9gtypn(available, tmp_4, tmp_5);
    } else {
      tmp = Companion_getInstance_6().g5d_1;
    }
    return tmp;
  };
  protoOf(DefaultPagerNestedScrollConnection).a9v = function (consumed, available, source) {
    if (source === Companion_getInstance_20().e9v_1 && !(mainAxis(this, available) === 0.0)) {
      throw CancellationException_init_$Create$('Scroll cancelled');
    }
    return Companion_getInstance_6().g5d_1;
  };
  protoOf(DefaultPagerNestedScrollConnection).c9v = function (consumed, available, $completion) {
    return new Velocity_0(this.ijd(available, this.hjd_1));
  };
  function pagerSemantics(_this__u8e3s4, state, isVertical, scope, userScrollEnabled) {
    var tmp;
    if (userScrollEnabled) {
      var tmp_0 = Companion_instance_0;
      tmp = _this__u8e3s4.d8v(semantics(tmp_0, VOID, pagerSemantics$lambda(isVertical, state, scope)));
    } else {
      tmp = _this__u8e3s4.d8v(Companion_instance_0);
    }
    return tmp;
  }
  function currentPageOffset(_this__u8e3s4, layoutSize, pageSize, spaceBetweenPages, beforeContentPadding, afterContentPadding, currentPage, currentPageOffsetFraction, pageCount) {
    var snapOffset = _this__u8e3s4.yi6(layoutSize, pageSize, beforeContentPadding, afterContentPadding, currentPage, pageCount);
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = snapOffset - currentPageOffsetFraction * (pageSize + spaceBetweenPages | 0);
    return roundToInt(this_0);
  }
  function HorizontalPager$lambda($state, $modifier, $contentPadding, $pageSize, $beyondViewportPageCount, $pageSpacing, $verticalAlignment, $flingBehavior, $userScrollEnabled, $reverseLayout, $key, $pageNestedScrollConnection, $snapPosition, $overscrollEffect, $pageContent, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      HorizontalPager($state, $modifier._v, $contentPadding._v, $pageSize._v, $beyondViewportPageCount._v, $pageSpacing._v.m5f_1, $verticalAlignment._v, $flingBehavior._v, $userScrollEnabled._v, $reverseLayout._v, $key._v, $pageNestedScrollConnection._v, $snapPosition._v, $overscrollEffect._v, $pageContent, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function pagerSemantics$performForwardPaging$slambda($state, resultContinuation) {
    this.sjd_1 = $state;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(pagerSemantics$performForwardPaging$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(pagerSemantics$performForwardPaging$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(pagerSemantics$performForwardPaging$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = animateToNextPage(this.sjd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(pagerSemantics$performForwardPaging$slambda).q24 = function ($this$launch, completion) {
    var i = new pagerSemantics$performForwardPaging$slambda(this.sjd_1, completion);
    i.tjd_1 = $this$launch;
    return i;
  };
  function pagerSemantics$performForwardPaging$slambda_0($state, resultContinuation) {
    var i = new pagerSemantics$performForwardPaging$slambda($state, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function pagerSemantics$performBackwardPaging$slambda($state, resultContinuation) {
    this.cje_1 = $state;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(pagerSemantics$performBackwardPaging$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(pagerSemantics$performBackwardPaging$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(pagerSemantics$performBackwardPaging$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = animateToPreviousPage(this.cje_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(pagerSemantics$performBackwardPaging$slambda).q24 = function ($this$launch, completion) {
    var i = new pagerSemantics$performBackwardPaging$slambda(this.cje_1, completion);
    i.dje_1 = $this$launch;
    return i;
  };
  function pagerSemantics$performBackwardPaging$slambda_0($state, resultContinuation) {
    var i = new pagerSemantics$performBackwardPaging$slambda($state, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function pagerSemantics$performForwardPaging($state, $scope) {
    var tmp;
    if ($state.mg7()) {
      launch($scope, VOID, VOID, pagerSemantics$performForwardPaging$slambda_0($state, null));
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function pagerSemantics$performBackwardPaging($state, $scope) {
    var tmp;
    if ($state.ng7()) {
      launch($scope, VOID, VOID, pagerSemantics$performBackwardPaging$slambda_0($state, null));
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function pagerSemantics$lambda$lambda($state, $scope) {
    return function () {
      return pagerSemantics$performBackwardPaging($state, $scope);
    };
  }
  function pagerSemantics$lambda$lambda_0($state, $scope) {
    return function () {
      return pagerSemantics$performForwardPaging($state, $scope);
    };
  }
  function pagerSemantics$lambda$lambda_1($state, $scope) {
    return function () {
      return pagerSemantics$performBackwardPaging($state, $scope);
    };
  }
  function pagerSemantics$lambda$lambda_2($state, $scope) {
    return function () {
      return pagerSemantics$performForwardPaging($state, $scope);
    };
  }
  function pagerSemantics$lambda($isVertical, $state, $scope) {
    return function ($this$semantics) {
      var tmp;
      if ($isVertical) {
        pageUp($this$semantics, VOID, pagerSemantics$lambda$lambda($state, $scope));
        pageDown($this$semantics, VOID, pagerSemantics$lambda$lambda_0($state, $scope));
        tmp = Unit_instance;
      } else {
        pageLeft($this$semantics, VOID, pagerSemantics$lambda$lambda_1($state, $scope));
        pageRight($this$semantics, VOID, pagerSemantics$lambda$lambda_2($state, $scope));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  var androidx_compose_foundation_pager_PagerBeyondBoundsState$stable;
  function rememberPagerBeyondBoundsState(state, beyondViewportPageCount, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(state) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.m31(beyondViewportPageCount) || ($changed & 48) === 32));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = new PagerBeyondBoundsState(state, beyondViewportPageCount);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function PagerBeyondBoundsState(state, beyondViewportPageCount) {
    this.eje_1 = state;
    this.fje_1 = beyondViewportPageCount;
  }
  protoOf(PagerBeyondBoundsState).aie = function () {
    return this.eje_1.di2();
  };
  protoOf(PagerBeyondBoundsState).yie = function () {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.eje_1.thz().ci2().r();
  };
  protoOf(PagerBeyondBoundsState).zie = function () {
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = this.eje_1.ii0_1 - this.fje_1 | 0;
    return Math.max(0, b);
  };
  protoOf(PagerBeyondBoundsState).aif = function () {
    var tmp0 = this.aie() - 1 | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = last(this.eje_1.thz().ci2()).bi0() + this.fje_1 | 0;
    return Math.min(tmp0, b);
  };
  protoOf(PagerBeyondBoundsState).bif = function () {
    var visibleItemCount = this.eje_1.thz().ci2().n1();
    if (visibleItemCount === 0)
      return 0;
    var viewportSize = get_mainAxisViewportSize(this.eje_1.thz());
    var averageItemSize = this.eje_1.thz().ui1() + this.eje_1.thz().jjd() | 0;
    if (averageItemSize === 0)
      return 1;
    return coerceAtLeast_0(viewportSize / averageItemSize | 0, 1);
  };
  var androidx_compose_foundation_pager_PagerCacheWindowLogic$stable;
  function PagerCacheWindowLogic(cacheWindow, state, itemCount) {
    CacheWindowLogic.call(this, cacheWindow, false);
    this.vje_1 = cacheWindow;
    this.wje_1 = state;
    this.xje_1 = itemCount;
    this.yje_1 = new PagerCacheWindowScope(this.xje_1);
  }
  protoOf(PagerCacheWindowLogic).zje = function (delta, layoutInfo) {
    // Inline function 'androidx.compose.foundation.pager.PagerCacheWindowLogic.applyWindowScope' call
    this.yje_1.bjf_1 = layoutInfo;
    this.yje_1.cjf_1 = this.wje_1;
    var $this$applyWindowScope = this.yje_1;
    this.tiv($this$applyWindowScope, -delta);
  };
  protoOf(PagerCacheWindowLogic).djf = function (layoutInfo) {
    // Inline function 'androidx.compose.foundation.pager.PagerCacheWindowLogic.applyWindowScope' call
    this.yje_1.bjf_1 = layoutInfo;
    this.yje_1.cjf_1 = this.wje_1;
    var $this$applyWindowScope = this.yje_1;
    this.uiv($this$applyWindowScope);
  };
  function PagerCacheWindowScope$schedulePrefetch$lambda($onItemPrefetched, this$0) {
    return function ($this$schedulePrecompositionAndPremeasure) {
      $onItemPrefetched($this$schedulePrecompositionAndPremeasure.bi0(), this$0.thz().fjf_1);
      return Unit_instance;
    };
  }
  function PagerCacheWindowScope(itemCount) {
    this.ajf_1 = itemCount;
  }
  protoOf(PagerCacheWindowScope).thz = function () {
    var tmp = this.bjf_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('layoutInfo');
    }
  };
  protoOf(PagerCacheWindowScope).ajg = function () {
    var tmp = this.cjf_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('state');
    }
  };
  protoOf(PagerCacheWindowScope).ci0 = function () {
    return this.ajf_1();
  };
  protoOf(PagerCacheWindowScope).yie = function () {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.thz().ejf_1.r();
  };
  protoOf(PagerCacheWindowScope).miv = function () {
    if (this.thz().ejf_1.r())
      return 0;
    var firstVisibleItem = first(this.thz().ejf_1);
    var firstItemOverflowOffset = coerceAtMost(firstVisibleItem.xjc_1 + this.thz().yhz() | 0, 0);
    // Inline function 'kotlin.math.absoluteValue' call
    return abs(firstItemOverflowOffset);
  };
  protoOf(PagerCacheWindowScope).niv = function () {
    if (this.thz().ejf_1.r())
      return 0;
    var lastVisibleItem = last(this.thz().ejf_1);
    var lastItemOverflowOffset = (lastVisibleItem.xjc_1 + this.thz().fjf_1 | 0) + this.thz().gjf_1 | 0;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = lastItemOverflowOffset - this.thz().kjf_1 | 0;
    return abs(this_0);
  };
  protoOf(PagerCacheWindowScope).iiv = function () {
    if (this.thz().ejf_1.r())
      return -1;
    var itemIndex = subtract(fromInt(first(this.thz().ejf_1).ljc_1), fromInt(this.thz().mjf_1));
    return convertToInt(coerceAtLeast_1(itemIndex, new Long(0, 0)));
  };
  protoOf(PagerCacheWindowScope).jiv = function () {
    if (this.thz().ejf_1.r())
      return -1;
    var itemIndex = add(fromInt(last(this.thz().ejf_1).ljc_1), fromInt(this.thz().mjf_1));
    return convertToInt(coerceAtMost_1(itemIndex, subtract(numberToLong(this.ci0()), new Long(1, 0))));
  };
  protoOf(PagerCacheWindowScope).kiv = function () {
    return get_mainAxisViewportSize(this.thz());
  };
  protoOf(PagerCacheWindowScope).u5e = function () {
    return this.thz().yjf_1;
  };
  protoOf(PagerCacheWindowScope).siv = function (lineIndex, onItemPrefetched) {
    var childConstraints = this.thz().zjf_1;
    var tmp = this.ajg();
    return listOf_0(tmp.mij(lineIndex, childConstraints, true, PagerCacheWindowScope$schedulePrefetch$lambda(onItemPrefetched, this)));
  };
  protoOf(PagerCacheWindowScope).viv = function () {
    return (this.thz().vjf_1.n1() + this.thz().ejf_1.n1() | 0) + this.thz().wjf_1.n1() | 0;
  };
  protoOf(PagerCacheWindowScope).yiv = function (indexInVisibleLines) {
    return this.thz().fjf_1;
  };
  protoOf(PagerCacheWindowScope).wiv = function (indexInVisibleLines) {
    var extraPagesBeforeCount = this.thz().vjf_1.n1();
    var visiblePagesCount = this.thz().ejf_1.n1();
    if (indexInVisibleLines < extraPagesBeforeCount) {
      return this.thz().vjf_1.l1(indexInVisibleLines).ljc_1;
    }
    if (indexInVisibleLines >= extraPagesBeforeCount && indexInVisibleLines < (extraPagesBeforeCount + visiblePagesCount | 0)) {
      return this.thz().ejf_1.l1(indexInVisibleLines - extraPagesBeforeCount | 0).ljc_1;
    }
    if (indexInVisibleLines >= (extraPagesBeforeCount + visiblePagesCount | 0)) {
      return this.thz().wjf_1.l1((indexInVisibleLines - extraPagesBeforeCount | 0) - visiblePagesCount | 0).ljc_1;
    }
    return -1;
  };
  protoOf(PagerCacheWindowScope).xiv = function (indexInVisibleLines) {
    var extraPagesBeforeCount = this.thz().vjf_1.n1();
    var visiblePagesCount = this.thz().ejf_1.n1();
    if (indexInVisibleLines < extraPagesBeforeCount) {
      return this.thz().vjf_1.l1(indexInVisibleLines).pjc_1;
    }
    if (indexInVisibleLines >= extraPagesBeforeCount && indexInVisibleLines < (extraPagesBeforeCount + visiblePagesCount | 0)) {
      return this.thz().ejf_1.l1(indexInVisibleLines - extraPagesBeforeCount | 0).pjc_1;
    }
    if (indexInVisibleLines >= (extraPagesBeforeCount + visiblePagesCount | 0)) {
      return this.thz().wjf_1.l1((indexInVisibleLines - extraPagesBeforeCount | 0) - visiblePagesCount | 0).pjc_1;
    }
    return NoKey_instance;
  };
  protoOf(PagerCacheWindowScope).piv = function (lineIndex) {
    return lineIndex;
  };
  protoOf(PagerCacheWindowScope).hiv = function () {
    if (this.thz().ejf_1.r())
      return -1;
    return this.ci0() - 1 | 0;
  };
  function get_mainAxisViewportSize(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.lhy().equals(Orientation_Vertical_getInstance())) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_0 = _this__u8e3s4.khy();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      tmp = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = _this__u8e3s4.khy();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      tmp = convertToInt(shiftRight(value_0, 32));
    }
    return tmp;
  }
  function measurePager(_this__u8e3s4, pageCount, pagerItemProvider, mainAxisAvailableSize, beforeContentPadding, afterContentPadding, spaceBetweenPages, currentPage, currentPageOffset, constraints, orientation, verticalAlignment, horizontalAlignment, reverseLayout, visualPageOffset, pageAvailableSize, beyondViewportPageCount, pinnedPages, snapPosition, placementScopeInvalidator, coroutineScope, density, layout, placeablesCache) {
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(beforeContentPadding >= 0)) {
      var tmp$ret$1 = 'negative beforeContentPadding';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(afterContentPadding >= 0)) {
      var tmp$ret$3 = 'negative afterContentPadding';
      throwIllegalArgumentException(tmp$ret$3);
    }
    var pageSizeWithSpacing = coerceAtLeast_0(pageAvailableSize + spaceBetweenPages | 0, 0);
    var coercedBeyondViewportPageCount = coerceAtMost(beyondViewportPageCount, pageCount);
    // Inline function 'androidx.compose.foundation.pager.debugLog' call
    if (false) {
      var tmp$ret$5 = 'Starting Measure Pass...' + ('\n CurrentPage = ' + currentPage) + ('\n CurrentPageOffset = ' + currentPageOffset) + ('\n SnapPosition = ' + toString(snapPosition));
      println('PagerMeasure: ' + tmp$ret$5);
    }
    var tmp;
    if (orientation.equals(Orientation_Vertical_getInstance())) {
      tmp = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    } else {
      tmp = pageAvailableSize;
    }
    var tmp_0 = tmp;
    var tmp_1;
    if (!orientation.equals(Orientation_Vertical_getInstance())) {
      tmp_1 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    } else {
      tmp_1 = pageAvailableSize;
    }
    var childConstraints = Constraints_0(VOID, tmp_0, VOID, tmp_1);
    var tmp_2;
    if (pageCount <= 0) {
      var tmp0_visiblePagesInfo = emptyList();
      var tmp1_viewportStartOffset = -beforeContentPadding | 0;
      var tmp2_viewportEndOffset = mainAxisAvailableSize + afterContentPadding | 0;
      var tmp_3 = _Constraints___get_minWidth__impl__hi9lfi(constraints);
      var tmp_4 = _Constraints___get_minHeight__impl__ev4bgx(constraints);
      var tmp3_measureResult = layout(tmp_3, tmp_4, measurePager$lambda);
      tmp_2 = new PagerMeasureResult(tmp0_visiblePagesInfo, pageAvailableSize, spaceBetweenPages, afterContentPadding, orientation, tmp1_viewportStartOffset, tmp2_viewportEndOffset, false, coercedBeyondViewportPageCount, null, null, 0.0, 0, false, snapPosition, tmp3_measureResult, false, VOID, VOID, coroutineScope, density, childConstraints);
    } else {
      var firstVisiblePage = currentPage;
      var firstVisiblePageOffset = currentPageOffset;
      while (firstVisiblePage > 0 && firstVisiblePageOffset > 0) {
        firstVisiblePage = firstVisiblePage - 1 | 0;
        firstVisiblePageOffset = firstVisiblePageOffset - pageSizeWithSpacing | 0;
      }
      var firstVisiblePageScrollOffset = imul(firstVisiblePageOffset, -1);
      var currentFirstPage = firstVisiblePage;
      var currentFirstPageScrollOffset = firstVisiblePageScrollOffset;
      if (currentFirstPage >= pageCount) {
        currentFirstPage = pageCount - 1 | 0;
        currentFirstPageScrollOffset = 0;
      }
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$7 = 'Calculated Info:' + ('\n FirstVisiblePage=' + firstVisiblePage) + ('\n firstVisiblePageScrollOffset=' + firstVisiblePageScrollOffset);
        println('PagerMeasure: ' + tmp$ret$7);
      }
      var visiblePages = ArrayDeque_init_$Create$();
      var minOffset = (-beforeContentPadding | 0) + (spaceBetweenPages < 0 ? spaceBetweenPages : 0) | 0;
      var maxOffset = mainAxisAvailableSize;
      currentFirstPageScrollOffset = currentFirstPageScrollOffset + minOffset | 0;
      var maxCrossAxis = 0;
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$9 = 'Composing Backwards';
        println('PagerMeasure: ' + tmp$ret$9);
      }
      while (currentFirstPageScrollOffset < 0 && currentFirstPage > 0) {
        var previous = currentFirstPage - 1 | 0;
        var measuredPage = getAndMeasure(_this__u8e3s4, previous, childConstraints, pagerItemProvider, visualPageOffset, orientation, horizontalAlignment, verticalAlignment, _this__u8e3s4.r6p(), reverseLayout, pageAvailableSize, placeablesCache);
        // Inline function 'androidx.compose.foundation.pager.debugLog' call
        if (false) {
          var tmp$ret$11 = 'Composed Page=' + previous;
          println('PagerMeasure: ' + tmp$ret$11);
        }
        visiblePages.g3(0, measuredPage);
        var tmp0 = maxCrossAxis;
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = measuredPage.vjc_1;
        maxCrossAxis = Math.max(tmp0, b);
        currentFirstPageScrollOffset = currentFirstPageScrollOffset + pageSizeWithSpacing | 0;
        currentFirstPage = previous;
      }
      if (currentFirstPageScrollOffset < minOffset) {
        currentFirstPageScrollOffset = minOffset;
      }
      currentFirstPageScrollOffset = currentFirstPageScrollOffset - minOffset | 0;
      var index = currentFirstPage;
      var maxMainAxis = coerceAtLeast_0(maxOffset + afterContentPadding | 0, 0);
      var currentMainAxisOffset = -currentFirstPageScrollOffset | 0;
      var remeasureNeeded = false;
      var indexInVisibleItems = 0;
      while (indexInVisibleItems < visiblePages.sg_1) {
        if (currentMainAxisOffset >= maxMainAxis) {
          visiblePages.h3(indexInVisibleItems);
          remeasureNeeded = true;
        } else {
          index = index + 1 | 0;
          currentMainAxisOffset = currentMainAxisOffset + pageSizeWithSpacing | 0;
          indexInVisibleItems = indexInVisibleItems + 1 | 0;
        }
      }
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$14 = 'Composing Forward Starting at Index=' + index;
        println('PagerMeasure: ' + tmp$ret$14);
      }
      while (index < pageCount && (currentMainAxisOffset < maxMainAxis || currentMainAxisOffset <= 0 || visiblePages.r())) {
        var measuredPage_0 = getAndMeasure(_this__u8e3s4, index, childConstraints, pagerItemProvider, visualPageOffset, orientation, horizontalAlignment, verticalAlignment, _this__u8e3s4.r6p(), reverseLayout, pageAvailableSize, placeablesCache);
        // Inline function 'androidx.compose.foundation.pager.debugLog' call
        if (false) {
          var tmp$ret$16 = 'Composed Page=' + index + ' at ' + currentFirstPageScrollOffset;
          println('PagerMeasure: ' + tmp$ret$16);
        }
        var tmp_5 = currentMainAxisOffset;
        var tmp_6;
        if (index === (pageCount - 1 | 0)) {
          tmp_6 = pageAvailableSize;
        } else {
          tmp_6 = pageSizeWithSpacing;
        }
        currentMainAxisOffset = tmp_5 + tmp_6 | 0;
        if (currentMainAxisOffset <= minOffset && !(index === (pageCount - 1 | 0))) {
          currentFirstPage = index + 1 | 0;
          currentFirstPageScrollOffset = currentFirstPageScrollOffset - pageSizeWithSpacing | 0;
          remeasureNeeded = true;
        } else {
          var tmp0_0 = maxCrossAxis;
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_0 = measuredPage_0.vjc_1;
          maxCrossAxis = Math.max(tmp0_0, b_0);
          visiblePages.j1(measuredPage_0);
        }
        index = index + 1 | 0;
      }
      if (currentMainAxisOffset < maxOffset) {
        var toScrollBack = maxOffset - currentMainAxisOffset | 0;
        currentFirstPageScrollOffset = currentFirstPageScrollOffset - toScrollBack | 0;
        currentMainAxisOffset = currentMainAxisOffset + toScrollBack | 0;
        while (currentFirstPageScrollOffset < beforeContentPadding && currentFirstPage > 0) {
          var previousIndex = currentFirstPage - 1 | 0;
          var measuredPage_1 = getAndMeasure(_this__u8e3s4, previousIndex, childConstraints, pagerItemProvider, visualPageOffset, orientation, horizontalAlignment, verticalAlignment, _this__u8e3s4.r6p(), reverseLayout, pageAvailableSize, placeablesCache);
          visiblePages.g3(0, measuredPage_1);
          var tmp0_1 = maxCrossAxis;
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_1 = measuredPage_1.vjc_1;
          maxCrossAxis = Math.max(tmp0_1, b_1);
          currentFirstPageScrollOffset = currentFirstPageScrollOffset + pageSizeWithSpacing | 0;
          currentFirstPage = previousIndex;
        }
        if (currentFirstPageScrollOffset < 0) {
          currentMainAxisOffset = currentMainAxisOffset + currentFirstPageScrollOffset | 0;
          currentFirstPageScrollOffset = 0;
        }
      }
      // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
      if (!(currentFirstPageScrollOffset >= 0)) {
        var tmp$ret$20 = 'invalid currentFirstPageScrollOffset';
        throwIllegalArgumentException(tmp$ret$20);
      }
      var visiblePagesScrollOffset = -currentFirstPageScrollOffset | 0;
      var firstPage = visiblePages.vg();
      if (beforeContentPadding > 0 || spaceBetweenPages < 0) {
        var inductionVariable = 0;
        var last = visiblePages.n1() - 1 | 0;
        if (inductionVariable <= last)
          $l$loop: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var size = pageSizeWithSpacing;
            if (!(currentFirstPageScrollOffset === 0) && size <= currentFirstPageScrollOffset && !(i === get_lastIndex(visiblePages))) {
              currentFirstPageScrollOffset = currentFirstPageScrollOffset - size | 0;
              firstPage = visiblePages.l1(i + 1 | 0);
            } else {
              break $l$loop;
            }
          }
           while (inductionVariable <= last);
      }
      var tmp_7 = currentFirstPage;
      var extraPagesBefore = createPagesBeforeList(tmp_7, coercedBeyondViewportPageCount, pinnedPages, measurePager$lambda_0(_this__u8e3s4, childConstraints, pagerItemProvider, visualPageOffset, orientation, horizontalAlignment, verticalAlignment, reverseLayout, pageAvailableSize, placeablesCache));
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_0 = extraPagesBefore.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item = extraPagesBefore.l1(index_0);
          var tmp0_2 = maxCrossAxis;
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_2 = item.vjc_1;
          maxCrossAxis = Math.max(tmp0_2, b_2);
        }
         while (inductionVariable_0 <= last_0);
      var tmp_8 = visiblePages.xg().ljc_1;
      var extraPagesAfter = createPagesAfterList(tmp_8, pageCount, coercedBeyondViewportPageCount, pinnedPages, measurePager$lambda_1(_this__u8e3s4, childConstraints, pagerItemProvider, visualPageOffset, orientation, horizontalAlignment, verticalAlignment, reverseLayout, pageAvailableSize, placeablesCache));
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_1 = 0;
      var last_1 = extraPagesAfter.n1() - 1 | 0;
      if (inductionVariable_1 <= last_1)
        do {
          var index_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var item_0 = extraPagesAfter.l1(index_1);
          var tmp0_3 = maxCrossAxis;
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_3 = item_0.vjc_1;
          maxCrossAxis = Math.max(tmp0_3, b_3);
        }
         while (inductionVariable_1 <= last_1);
      var noExtraPages = equals(firstPage, visiblePages.vg()) && extraPagesBefore.r() && extraPagesAfter.r();
      var layoutWidth = constrainWidth(constraints, orientation.equals(Orientation_Vertical_getInstance()) ? maxCrossAxis : currentMainAxisOffset);
      var layoutHeight = constrainHeight(constraints, orientation.equals(Orientation_Vertical_getInstance()) ? currentMainAxisOffset : maxCrossAxis);
      var positionedPages = calculatePagesOffsets(_this__u8e3s4, visiblePages, extraPagesBefore, extraPagesAfter, layoutWidth, layoutHeight, currentMainAxisOffset, maxOffset, visiblePagesScrollOffset, orientation, reverseLayout, _this__u8e3s4, spaceBetweenPages, pageAvailableSize);
      var tmp_9;
      if (noExtraPages) {
        tmp_9 = positionedPages;
      } else {
        // Inline function 'androidx.compose.ui.util.fastFilter' call
        var target = ArrayList_init_$Create$_0(positionedPages.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_2 = 0;
        var last_2 = positionedPages.n1() - 1 | 0;
        if (inductionVariable_2 <= last_2)
          do {
            var index_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var item_1 = positionedPages.l1(index_2);
            if (item_1.ljc_1 >= visiblePages.vg().ljc_1 && item_1.ljc_1 <= visiblePages.xg().ljc_1) {
              // Inline function 'kotlin.collections.plusAssign' call
              target.j1(item_1);
            }
          }
           while (inductionVariable_2 <= last_2);
        tmp_9 = target;
      }
      var visiblePagesInfo = tmp_9;
      var tmp_10;
      if (extraPagesBefore.r()) {
        tmp_10 = emptyList();
      } else {
        // Inline function 'androidx.compose.ui.util.fastFilter' call
        var target_0 = ArrayList_init_$Create$_0(positionedPages.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_3 = 0;
        var last_3 = positionedPages.n1() - 1 | 0;
        if (inductionVariable_3 <= last_3)
          do {
            var index_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var item_2 = positionedPages.l1(index_3);
            if (item_2.ljc_1 < visiblePages.vg().ljc_1) {
              // Inline function 'kotlin.collections.plusAssign' call
              target_0.j1(item_2);
            }
          }
           while (inductionVariable_3 <= last_3);
        tmp_10 = target_0;
      }
      var positionedPagesBefore = tmp_10;
      var tmp_11;
      if (extraPagesAfter.r()) {
        tmp_11 = emptyList();
      } else {
        // Inline function 'androidx.compose.ui.util.fastFilter' call
        var target_1 = ArrayList_init_$Create$_0(positionedPages.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_4 = 0;
        var last_4 = positionedPages.n1() - 1 | 0;
        if (inductionVariable_4 <= last_4)
          do {
            var index_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            var item_3 = positionedPages.l1(index_4);
            if (item_3.ljc_1 > visiblePages.xg().ljc_1) {
              // Inline function 'kotlin.collections.plusAssign' call
              target_1.j1(item_3);
            }
          }
           while (inductionVariable_4 <= last_4);
        tmp_11 = target_1;
      }
      var positionedPagesAfter = tmp_11;
      var layoutSize = (mainAxisAvailableSize + beforeContentPadding | 0) + afterContentPadding | 0;
      var newCurrentPage = calculateNewCurrentPage(layoutSize, visiblePagesInfo, beforeContentPadding, afterContentPadding, pageAvailableSize, snapPosition, pageCount);
      var tmp5_elvis_lhs = newCurrentPage == null ? null : newCurrentPage.ljc_1;
      var snapOffset = snapPosition.yi6(layoutSize, pageAvailableSize, beforeContentPadding, afterContentPadding, tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs, pageCount);
      var tmp7_elvis_lhs = newCurrentPage == null ? null : newCurrentPage.xjc_1;
      var currentPagePositionOffset = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      var tmp_12;
      if (pageSizeWithSpacing === 0) {
        tmp_12 = 0.0;
      } else {
        tmp_12 = coerceIn_0((snapOffset - currentPagePositionOffset | 0) / pageSizeWithSpacing, -0.5, 0.5);
      }
      var currentPageOffsetFraction = tmp_12;
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$43 = 'Finished Measure Pass' + ('\n Final currentPage=' + (newCurrentPage == null ? null : newCurrentPage.ljc_1) + ' ') + ('\n Final currentPageScrollOffset=' + currentPagePositionOffset) + ('\n Final currentPageScrollOffsetFraction=' + currentPageOffsetFraction);
        println('PagerMeasure: ' + tmp$ret$43);
      }
      var tmp8_firstVisiblePage = firstPage;
      var tmp9_firstVisiblePageScrollOffset = currentFirstPageScrollOffset;
      var tmp10_measureResult = layout(layoutWidth, layoutHeight, measurePager$lambda_2(placementScopeInvalidator, positionedPages));
      var tmp11_viewportStartOffset = -beforeContentPadding | 0;
      var tmp12_viewportEndOffset = maxOffset + afterContentPadding | 0;
      var tmp13_canScrollForward = index < pageCount || currentMainAxisOffset > maxOffset;
      var tmp14_remeasureNeeded = remeasureNeeded;
      return new PagerMeasureResult(visiblePagesInfo, pageAvailableSize, spaceBetweenPages, afterContentPadding, orientation, tmp11_viewportStartOffset, tmp12_viewportEndOffset, reverseLayout, coercedBeyondViewportPageCount, tmp8_firstVisiblePage, newCurrentPage, currentPageOffsetFraction, tmp9_firstVisiblePageScrollOffset, tmp13_canScrollForward, snapPosition, tmp10_measureResult, tmp14_remeasureNeeded, positionedPagesBefore, positionedPagesAfter, coroutineScope, density, childConstraints);
    }
    return tmp_2;
  }
  function getAndMeasure(_this__u8e3s4, index, childConstraints, pagerItemProvider, visualPageOffset, orientation, horizontalAlignment, verticalAlignment, layoutDirection, reverseLayout, pageAvailableSize, placeablesCache) {
    var key = pagerItemProvider.jif(index);
    var cachedPlaceables = placeablesCache.l1(index);
    var tmp;
    if (!(cachedPlaceables == null)) {
      tmp = cachedPlaceables;
    } else {
      var measurables = _this__u8e3s4.nih(index);
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = measurables.n1();
      var list = ArrayList_init_$Create$_0(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4 = measurables.l1(index_0).h8y(childConstraints);
          list.j1(tmp$ret$4);
        }
         while (inductionVariable < size);
      // Inline function 'kotlin.also' call
      placeablesCache.ew(index, list);
      tmp = list;
    }
    var placeable = tmp;
    return new MeasuredPage(index, pageAvailableSize, placeable, visualPageOffset, key, orientation, horizontalAlignment, verticalAlignment, layoutDirection, reverseLayout);
  }
  function createPagesBeforeList(currentFirstPage, beyondViewportPageCount, pinnedPages, getAndMeasure) {
    var list = null;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = currentFirstPage - beyondViewportPageCount | 0;
    var start = Math.max(0, b);
    var inductionVariable = currentFirstPage - 1 | 0;
    if (start <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (list == null) {
          // Inline function 'kotlin.collections.mutableListOf' call
          list = ArrayList_init_$Create$();
        }
        list.j1(getAndMeasure(i));
      }
       while (!(i === start));
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable_0 = 0;
    var last = pinnedPages.n1() - 1 | 0;
    if (inductionVariable_0 <= last)
      do {
        var index = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item = pinnedPages.l1(index);
        if (item < start) {
          if (list == null) {
            // Inline function 'kotlin.collections.mutableListOf' call
            list = ArrayList_init_$Create$();
          }
          var tmp0_safe_receiver = list;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver.j1(getAndMeasure(item));
        }
      }
       while (inductionVariable_0 <= last);
    var tmp0_elvis_lhs = list;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  function createPagesAfterList(currentLastPage, pagesCount, beyondViewportPageCount, pinnedPages, getAndMeasure) {
    var list = null;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = (pagesCount - currentLastPage | 0) - 1 | 0;
    var end = Math.min(beyondViewportPageCount, b) + currentLastPage | 0;
    var inductionVariable = currentLastPage + 1 | 0;
    if (inductionVariable <= end)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (list == null) {
          // Inline function 'kotlin.collections.mutableListOf' call
          list = ArrayList_init_$Create$();
        }
        list.j1(getAndMeasure(i));
      }
       while (!(i === end));
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable_0 = 0;
    var last = pinnedPages.n1() - 1 | 0;
    if (inductionVariable_0 <= last)
      do {
        var index = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item = pinnedPages.l1(index);
        if ((end + 1 | 0) <= item ? item < pagesCount : false) {
          if (list == null) {
            // Inline function 'kotlin.collections.mutableListOf' call
            list = ArrayList_init_$Create$();
          }
          var tmp0_safe_receiver = list;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver.j1(getAndMeasure(item));
        }
      }
       while (inductionVariable_0 <= last);
    var tmp0_elvis_lhs = list;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  function calculatePagesOffsets(_this__u8e3s4, pages, extraPagesBefore, extraPagesAfter, layoutWidth, layoutHeight, finalMainAxisOffset, maxOffset, pagesScrollOffset, orientation, reverseLayout, density, spaceBetweenPages, pageAvailableSize) {
    var pageSizeWithSpacing = pageAvailableSize + spaceBetweenPages | 0;
    var mainAxisLayoutSize = orientation.equals(Orientation_Vertical_getInstance()) ? layoutHeight : layoutWidth;
    // Inline function 'kotlin.comparisons.minOf' call
    var hasSpareSpace = finalMainAxisOffset < Math.min(mainAxisLayoutSize, maxOffset);
    if (hasSpareSpace) {
      // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
      if (!(pagesScrollOffset === 0)) {
        var tmp$ret$2 = 'non-zero pagesScrollOffset=' + pagesScrollOffset;
        throwIllegalStateException(tmp$ret$2);
      }
    }
    var positionedPages = ArrayList_init_$Create$_0((pages.n1() + extraPagesBefore.n1() | 0) + extraPagesAfter.n1() | 0);
    if (hasSpareSpace) {
      // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
      if (!(extraPagesBefore.r() && extraPagesAfter.r())) {
        var tmp$ret$4 = 'No extra pages';
        throwIllegalArgumentException(tmp$ret$4);
      }
      var pagesCount = pages.n1();
      var tmp = 0;
      var tmp_0 = new Int32Array(pagesCount);
      while (tmp < pagesCount) {
        tmp_0[tmp] = pageAvailableSize;
        tmp = tmp + 1 | 0;
      }
      var sizes = tmp_0;
      var offsets = new Int32Array(pagesCount);
      var arrangement = Absolute_getInstance().mdq(_this__u8e3s4.d5f(spaceBetweenPages));
      if (orientation.equals(Orientation_Vertical_getInstance())) {
        // Inline function 'kotlin.with' call
        arrangement.fdq(density, mainAxisLayoutSize, sizes, offsets);
      } else {
        // Inline function 'kotlin.with' call
        arrangement.pdp(density, mainAxisLayoutSize, sizes, LayoutDirection_Ltr_getInstance(), offsets);
      }
      var reverseAwareOffsetIndices = !reverseLayout ? get_indices(offsets) : reversed(get_indices(offsets));
      var inductionVariable = reverseAwareOffsetIndices.x1_1;
      var last = reverseAwareOffsetIndices.y1_1;
      var step = reverseAwareOffsetIndices.z1_1;
      if (step > 0 && inductionVariable <= last || (step < 0 && last <= inductionVariable))
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          var absoluteOffset = offsets[index];
          var page = pages.l1(calculatePagesOffsets$reverseAware(index, reverseLayout, pagesCount));
          var tmp_1;
          if (reverseLayout) {
            tmp_1 = (mainAxisLayoutSize - absoluteOffset | 0) - page.mjc_1 | 0;
          } else {
            tmp_1 = absoluteOffset;
          }
          var relativeOffset = tmp_1;
          page.fig(relativeOffset, layoutWidth, layoutHeight);
          positionedPages.j1(page);
        }
         while (!(index === last));
    } else {
      var currentMainAxis = pagesScrollOffset;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_0 = extraPagesBefore.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item = extraPagesBefore.l1(index_0);
          currentMainAxis = currentMainAxis - pageSizeWithSpacing | 0;
          item.fig(currentMainAxis, layoutWidth, layoutHeight);
          positionedPages.j1(item);
        }
         while (inductionVariable_0 <= last_0);
      currentMainAxis = pagesScrollOffset;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_1 = 0;
      var last_1 = pages.n1() - 1 | 0;
      if (inductionVariable_1 <= last_1)
        do {
          var index_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var item_0 = pages.l1(index_1);
          item_0.fig(currentMainAxis, layoutWidth, layoutHeight);
          positionedPages.j1(item_0);
          currentMainAxis = currentMainAxis + pageSizeWithSpacing | 0;
        }
         while (inductionVariable_1 <= last_1);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_2 = 0;
      var last_2 = extraPagesAfter.n1() - 1 | 0;
      if (inductionVariable_2 <= last_2)
        do {
          var index_2 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var item_1 = extraPagesAfter.l1(index_2);
          item_1.fig(currentMainAxis, layoutWidth, layoutHeight);
          positionedPages.j1(item_1);
          currentMainAxis = currentMainAxis + pageSizeWithSpacing | 0;
        }
         while (inductionVariable_2 <= last_2);
    }
    return positionedPages;
  }
  function calculateNewCurrentPage(viewportSize, visiblePagesInfo, beforeContentPadding, afterContentPadding, itemSize, snapPosition, pageCount) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastMaxBy' call
      if (visiblePagesInfo.r()) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var maxElem = visiblePagesInfo.l1(0);
      var it = maxElem;
      // Inline function 'kotlin.math.abs' call
      var x = calculateDistanceToDesiredSnapPosition(viewportSize, beforeContentPadding, afterContentPadding, itemSize, it.xjc_1, it.ljc_1, snapPosition, pageCount);
      var maxValue = -Math.abs(x);
      var inductionVariable = 1;
      var last = get_lastIndex(visiblePagesInfo);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = visiblePagesInfo.l1(i);
          // Inline function 'kotlin.math.abs' call
          var x_0 = calculateDistanceToDesiredSnapPosition(viewportSize, beforeContentPadding, afterContentPadding, itemSize, e.xjc_1, e.ljc_1, snapPosition, pageCount);
          var v = -Math.abs(x_0);
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (!(i === last));
      tmp$ret$0 = maxElem;
    }
    return tmp$ret$0;
  }
  function measurePager$lambda($this$layout) {
    return Unit_instance;
  }
  function measurePager$lambda_0($this_measurePager, $childConstraints, $pagerItemProvider, $visualPageOffset, $orientation, $horizontalAlignment, $verticalAlignment, $reverseLayout, $pageAvailableSize, $placeablesCache) {
    return function (it) {
      return getAndMeasure($this_measurePager, it, $childConstraints, $pagerItemProvider, $visualPageOffset, $orientation, $horizontalAlignment, $verticalAlignment, $this_measurePager.r6p(), $reverseLayout, $pageAvailableSize, $placeablesCache);
    };
  }
  function measurePager$lambda_1($this_measurePager, $childConstraints, $pagerItemProvider, $visualPageOffset, $orientation, $horizontalAlignment, $verticalAlignment, $reverseLayout, $pageAvailableSize, $placeablesCache) {
    return function (it) {
      return getAndMeasure($this_measurePager, it, $childConstraints, $pagerItemProvider, $visualPageOffset, $orientation, $horizontalAlignment, $verticalAlignment, $this_measurePager.r6p(), $reverseLayout, $pageAvailableSize, $placeablesCache);
    };
  }
  function measurePager$lambda$lambda($positionedPages) {
    return function ($this$withMotionFrameOfReferencePlacement) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = $positionedPages;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item.zjc($this$withMotionFrameOfReferencePlacement);
        }
         while (inductionVariable <= last);
      return Unit_instance;
    };
  }
  function measurePager$lambda_2($placementScopeInvalidator, $positionedPages) {
    return function ($this$layout) {
      $this$layout.xal(measurePager$lambda$lambda($positionedPages));
      ObservableScopeInvalidator__attachToScope_impl_wvvw97($placementScopeInvalidator);
      return Unit_instance;
    };
  }
  function calculatePagesOffsets$reverseAware(_this__u8e3s4, $reverseLayout, pagesCount) {
    return !$reverseLayout ? _this__u8e3s4 : (pagesCount - _this__u8e3s4 | 0) - 1 | 0;
  }
  function rememberPagerMeasurePolicy(itemProviderLambda, state, contentPadding, reverseLayout, orientation, beyondViewportPageCount, pageSpacing, pageSize, horizontalAlignment, verticalAlignment, snapPosition, coroutineScope, pageCount, $composer, $changed, $changed1) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!(!!(!!(!!(!!(!!(!!(!!(!!((($changed & 112 ^ 48) > 32 && $composer_0.k31(state) || ($changed & 48) === 32) | (($changed & 896 ^ 384) > 256 && $composer_0.k31(contentPadding) || ($changed & 384) === 256)) | (($changed & 7168 ^ 3072) > 2048 && $composer_0.l31(reverseLayout) || ($changed & 3072) === 2048)) | (($changed & 57344 ^ 24576) > 16384 && $composer_0.m31(orientation.a1_1) || ($changed & 24576) === 16384)) | (($changed & 234881024 ^ 100663296) > 67108864 && $composer_0.k31(horizontalAlignment) || ($changed & 100663296) === 67108864)) | (($changed & 1879048192 ^ 805306368) > 536870912 && $composer_0.k31(verticalAlignment) || ($changed & 805306368) === 536870912)) | (($changed & 3670016 ^ 1572864) > 1048576 && $composer_0.n31(_Dp___get_value__impl__geb1vb(pageSpacing)) || ($changed & 1572864) === 1048576)) | (($changed & 29360128 ^ 12582912) > 8388608 && $composer_0.k31(pageSize) || ($changed & 12582912) === 8388608)) | (($changed1 & 14 ^ 6) > 4 && $composer_0.k31(snapPosition) || ($changed1 & 6) === 4)) | (($changed1 & 896 ^ 384) > 256 && $composer_0.k31(pageCount) || ($changed1 & 384) === 256)) | (($changed & 458752 ^ 196608) > 131072 && $composer_0.m31(beyondViewportPageCount) || ($changed & 196608) === 131072)) | $composer_0.k31(coroutineScope));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var tmp_0 = rememberPagerMeasurePolicy$lambda(state, orientation, contentPadding, reverseLayout, pageSpacing, pageSize, itemProviderLambda, snapPosition, pageCount, verticalAlignment, horizontalAlignment, beyondViewportPageCount, coroutineScope);
      var value = new sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_1(tmp_0);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function keepAroundItems_1(_this__u8e3s4, cacheWindowLogic, visiblePagesList) {
    // Inline function 'androidx.compose.ui.util.trace' call
    var tmp;
    if (cacheWindowLogic.uib()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !visiblePagesList.r();
    } else {
      tmp = false;
    }
    if (tmp) {
      var firstVisiblePageIndex = first(visiblePagesList).bi0();
      var lastVisiblePageIndex = last(visiblePagesList).bi0();
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$4 = 'Keep Around First Visible Page Index: ' + firstVisiblePageIndex;
        println('Pager Measure Policy: ' + tmp$ret$4);
      }
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$6 = 'Keep Around Last Visible Page Index: ' + firstVisiblePageIndex;
        println('Pager Measure Policy: ' + tmp$ret$6);
      }
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$8 = 'Prefetch Window Start Line: ' + cacheWindowLogic.oib_1;
        println('Pager Measure Policy: ' + tmp$ret$8);
      }
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$10 = 'Prefetch Window End Line: ' + cacheWindowLogic.pib_1;
        println('Pager Measure Policy: ' + tmp$ret$10);
      }
      var inductionVariable = cacheWindowLogic.oib_1;
      if (inductionVariable < firstVisiblePageIndex)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          _this__u8e3s4.nih(item);
        }
         while (inductionVariable < firstVisiblePageIndex);
      var inductionVariable_0 = lastVisiblePageIndex + 1 | 0;
      var last_0 = cacheWindowLogic.pib_1;
      if (inductionVariable_0 <= last_0)
        do {
          var item_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          _this__u8e3s4.nih(item_0);
        }
         while (!(item_0 === last_0));
    }
  }
  function sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_1(function_0) {
    this.bjg_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_1).bid = function (_this__u8e3s4, constraints) {
    return this.bjg_1(_this__u8e3s4, new Constraints(constraints));
  };
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_1).q3 = function () {
    return this.bjg_1;
  };
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, LazyLayoutMeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_lazy_layout_LazyLayoutMeasurePolicy$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function rememberPagerMeasurePolicy$lambda$lambda($this_LazyLayoutMeasurePolicy, $containerConstraints, $totalHorizontalPadding, $totalVerticalPadding) {
    return function (width, height, placement) {
      return $this_LazyLayoutMeasurePolicy.kag(constrainWidth($containerConstraints, width + $totalHorizontalPadding | 0), constrainHeight($containerConstraints, height + $totalVerticalPadding | 0), emptyMap(), placement);
    };
  }
  function rememberPagerMeasurePolicy$lambda($state, $orientation, $contentPadding, $reverseLayout, $pageSpacing, $pageSize, $itemProviderLambda, $snapPosition, $pageCount, $verticalAlignment, $horizontalAlignment, $beyondViewportPageCount, $coroutineScope) {
    return function ($this$LazyLayoutMeasurePolicy, containerConstraints) {
      ObservableScopeInvalidator__attachToScope_impl_wvvw97($state.pi1_1);
      var isVertical = $orientation.equals(Orientation_Vertical_getInstance());
      checkScrollableContainerConstraints(containerConstraints.m5e_1, isVertical ? Orientation_Vertical_getInstance() : Orientation_Horizontal_getInstance());
      var tmp;
      if (isVertical) {
        tmp = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.adw($this$LazyLayoutMeasurePolicy.r6p()));
      } else {
        tmp = $this$LazyLayoutMeasurePolicy.w5e(calculateStartPadding($contentPadding, $this$LazyLayoutMeasurePolicy.r6p()));
      }
      var startPadding = tmp;
      var tmp_0;
      if (isVertical) {
        tmp_0 = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.zdv($this$LazyLayoutMeasurePolicy.r6p()));
      } else {
        tmp_0 = $this$LazyLayoutMeasurePolicy.w5e(calculateEndPadding($contentPadding, $this$LazyLayoutMeasurePolicy.r6p()));
      }
      var endPadding = tmp_0;
      var topPadding = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.fdw());
      var bottomPadding = $this$LazyLayoutMeasurePolicy.w5e($contentPadding.gdw());
      var totalVerticalPadding = topPadding + bottomPadding | 0;
      var totalHorizontalPadding = startPadding + endPadding | 0;
      var totalMainAxisPadding = isVertical ? totalVerticalPadding : totalHorizontalPadding;
      var beforeContentPadding = isVertical && !$reverseLayout ? topPadding : isVertical && $reverseLayout ? bottomPadding : !isVertical && !$reverseLayout ? startPadding : endPadding;
      var afterContentPadding = totalMainAxisPadding - beforeContentPadding | 0;
      var contentConstraints = offset(containerConstraints.m5e_1, -totalHorizontalPadding | 0, -totalVerticalPadding | 0);
      $state.wi0_1 = $this$LazyLayoutMeasurePolicy;
      var spaceBetweenPages = $this$LazyLayoutMeasurePolicy.w5e($pageSpacing);
      var tmp_1;
      if (isVertical) {
        tmp_1 = _Constraints___get_maxHeight__impl__dt3e8z(containerConstraints.m5e_1) - totalVerticalPadding | 0;
      } else {
        tmp_1 = _Constraints___get_maxWidth__impl__uuyqc(containerConstraints.m5e_1) - totalHorizontalPadding | 0;
      }
      var mainAxisAvailableSize = tmp_1;
      var tmp_2;
      if (!$reverseLayout || mainAxisAvailableSize > 0) {
        // Inline function 'androidx.compose.ui.unit.IntOffset' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(startPadding), 32), bitwiseAnd(fromInt(topPadding), new Long(-1, 0)));
        tmp_2 = _IntOffset___init__impl__rq8h7b(tmp$ret$1);
      } else {
        var tmp0 = isVertical ? startPadding : startPadding + mainAxisAvailableSize | 0;
        // Inline function 'androidx.compose.ui.unit.IntOffset' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2 = isVertical ? topPadding + mainAxisAvailableSize | 0 : topPadding;
        var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
        tmp_2 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
      }
      var visualItemOffset = tmp_2;
      // Inline function 'kotlin.with' call
      var $this$with = $pageSize;
      var pageAvailableSize = coerceAtLeast_0($this$with.bjd($this$LazyLayoutMeasurePolicy, mainAxisAvailableSize, spaceBetweenPages), 0);
      var tmp_3 = $state;
      var tmp_4;
      if ($orientation.equals(Orientation_Vertical_getInstance())) {
        tmp_4 = _Constraints___get_maxWidth__impl__uuyqc(contentConstraints);
      } else {
        tmp_4 = pageAvailableSize;
      }
      var tmp_5 = tmp_4;
      var tmp_6;
      if (!$orientation.equals(Orientation_Vertical_getInstance())) {
        tmp_6 = _Constraints___get_maxHeight__impl__dt3e8z(contentConstraints);
      } else {
        tmp_6 = pageAvailableSize;
      }
      tmp_3.li1_1 = Constraints_0(VOID, tmp_5, VOID, tmp_6);
      var itemProvider = $itemProviderLambda();
      var currentPage;
      var currentPageOffset_0;
      var layoutSize = (mainAxisAvailableSize + beforeContentPadding | 0) + afterContentPadding | 0;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance_2.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance_2.q52(previousSnapshot);
        try {
          currentPage = $state.cjg(itemProvider, $state.zj9());
          currentPageOffset_0 = currentPageOffset($snapPosition, layoutSize, pageAvailableSize, spaceBetweenPages, beforeContentPadding, afterContentPadding, $state.zj9(), $state.mja(), $state.di2());
          break $l$block;
        }finally {
          Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
        }
      }
      var pinnedPages = calculateLazyLayoutPinnedIndices(itemProvider, $state.mi1_1, $state.hi1_1);
      var placeablesCache = mutableIntObjectMapOf();
      var tmp0_pageCount = $pageCount();
      var tmp1_placementScopeInvalidator = $state.oi1_1;
      var measureResult = measurePager($this$LazyLayoutMeasurePolicy, tmp0_pageCount, itemProvider, mainAxisAvailableSize, beforeContentPadding, afterContentPadding, spaceBetweenPages, currentPage, currentPageOffset_0, contentConstraints, $orientation, $verticalAlignment, $horizontalAlignment, $reverseLayout, visualItemOffset, pageAvailableSize, $beyondViewportPageCount, pinnedPages, $snapPosition, tmp1_placementScopeInvalidator, $coroutineScope, $this$LazyLayoutMeasurePolicy, rememberPagerMeasurePolicy$lambda$lambda($this$LazyLayoutMeasurePolicy, containerConstraints.m5e_1, totalHorizontalPadding, totalVerticalPadding), placeablesCache);
      $state.djg(measureResult, $this$LazyLayoutMeasurePolicy.jag());
      keepAroundItems_1($this$LazyLayoutMeasurePolicy, $state.gi1_1, measureResult.ejf_1);
      return measureResult;
    };
  }
  var androidx_compose_foundation_pager_PagerMeasureResult$stable;
  function PagerMeasureResult(visiblePagesInfo, pageSize, pageSpacing, afterContentPadding, orientation, viewportStartOffset, viewportEndOffset, reverseLayout, beyondViewportPageCount, firstVisiblePage, currentPage, currentPageOffsetFraction, firstVisiblePageScrollOffset, canScrollForward, snapPosition, measureResult, remeasureNeeded, extraPagesBefore, extraPagesAfter, coroutineScope, density, childConstraints) {
    extraPagesBefore = extraPagesBefore === VOID ? emptyList() : extraPagesBefore;
    extraPagesAfter = extraPagesAfter === VOID ? emptyList() : extraPagesAfter;
    this.ejf_1 = visiblePagesInfo;
    this.fjf_1 = pageSize;
    this.gjf_1 = pageSpacing;
    this.hjf_1 = afterContentPadding;
    this.ijf_1 = orientation;
    this.jjf_1 = viewportStartOffset;
    this.kjf_1 = viewportEndOffset;
    this.ljf_1 = reverseLayout;
    this.mjf_1 = beyondViewportPageCount;
    this.njf_1 = firstVisiblePage;
    this.ojf_1 = currentPage;
    this.pjf_1 = currentPageOffsetFraction;
    this.qjf_1 = firstVisiblePageScrollOffset;
    this.rjf_1 = canScrollForward;
    this.sjf_1 = snapPosition;
    this.tjf_1 = measureResult;
    this.ujf_1 = remeasureNeeded;
    this.vjf_1 = extraPagesBefore;
    this.wjf_1 = extraPagesAfter;
    this.xjf_1 = coroutineScope;
    this.yjf_1 = density;
    this.zjf_1 = childConstraints;
  }
  protoOf(PagerMeasureResult).ci2 = function () {
    return this.ejf_1;
  };
  protoOf(PagerMeasureResult).ui1 = function () {
    return this.fjf_1;
  };
  protoOf(PagerMeasureResult).jjd = function () {
    return this.gjf_1;
  };
  protoOf(PagerMeasureResult).zhz = function () {
    return this.hjf_1;
  };
  protoOf(PagerMeasureResult).lhy = function () {
    return this.ijf_1;
  };
  protoOf(PagerMeasureResult).zif = function () {
    return this.jjf_1;
  };
  protoOf(PagerMeasureResult).aig = function () {
    return this.kjf_1;
  };
  protoOf(PagerMeasureResult).wi1 = function () {
    return this.ljf_1;
  };
  protoOf(PagerMeasureResult).ejg = function () {
    return this.mjf_1;
  };
  protoOf(PagerMeasureResult).fi2 = function () {
    return this.sjf_1;
  };
  protoOf(PagerMeasureResult).khy = function () {
    var tmp0 = this.h5e();
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = this.i5e();
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntSize___init__impl__emcjft(tmp$ret$1);
  };
  protoOf(PagerMeasureResult).yhz = function () {
    return -this.jjf_1 | 0;
  };
  protoOf(PagerMeasureResult).ng7 = function () {
    var tmp;
    var tmp0_safe_receiver = this.njf_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ljc_1;
    if (!((tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) === 0)) {
      tmp = true;
    } else {
      tmp = !(this.qjf_1 === 0);
    }
    return tmp;
  };
  protoOf(PagerMeasureResult).fjg = function (delta) {
    var pageSizeWithSpacing = this.fjf_1 + this.gjf_1 | 0;
    var tmp;
    if (this.ujf_1 || this.ejf_1.r() || this.njf_1 == null) {
      tmp = true;
    } else {
      var containsArg = this.qjf_1 - delta | 0;
      tmp = !(0 <= containsArg ? containsArg < pageSizeWithSpacing : false);
    }
    if (tmp) {
      return null;
    }
    var tmp_0;
    if (!(pageSizeWithSpacing === 0)) {
      tmp_0 = delta / pageSizeWithSpacing;
    } else {
      tmp_0 = 0.0;
    }
    var deltaFraction = tmp_0;
    var newCurrentPageOffsetFraction = this.pjf_1 - deltaFraction;
    if (this.ojf_1 == null || newCurrentPageOffsetFraction >= 0.5 || newCurrentPageOffsetFraction <= -0.5) {
      return null;
    }
    var first_0 = first(this.ejf_1);
    var last_0 = last(this.ejf_1);
    var tmp_1;
    if (delta < 0) {
      var deltaToFirstItemChange = (first_0.xjc_1 + pageSizeWithSpacing | 0) - this.jjf_1 | 0;
      var deltaToLastItemChange = (last_0.xjc_1 + pageSizeWithSpacing | 0) - this.kjf_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      tmp_1 = Math.min(deltaToFirstItemChange, deltaToLastItemChange) > (-delta | 0);
    } else {
      var deltaToFirstItemChange_0 = this.jjf_1 - first_0.xjc_1 | 0;
      var deltaToLastItemChange_0 = this.kjf_1 - last_0.xjc_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      tmp_1 = Math.min(deltaToFirstItemChange_0, deltaToLastItemChange_0) > delta;
    }
    var canApply = tmp_1;
    var tmp_2;
    if (canApply) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = this.ejf_1;
      var inductionVariable = 0;
      var last_1 = this_0.n1() - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item.ajd(delta);
        }
         while (inductionVariable <= last_1);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_1 = this.vjf_1;
      var inductionVariable_0 = 0;
      var last_2 = this_1.n1() - 1 | 0;
      if (inductionVariable_0 <= last_2)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = this_1.l1(index_0);
          item_0.ajd(delta);
        }
         while (inductionVariable_0 <= last_2);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_2 = this.wjf_1;
      var inductionVariable_1 = 0;
      var last_3 = this_2.n1() - 1 | 0;
      if (inductionVariable_1 <= last_3)
        do {
          var index_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var item_1 = this_2.l1(index_1);
          item_1.ajd(delta);
        }
         while (inductionVariable_1 <= last_3);
      tmp_2 = new PagerMeasureResult(this.ejf_1, this.fjf_1, this.gjf_1, this.hjf_1, this.ijf_1, this.jjf_1, this.kjf_1, this.ljf_1, this.mjf_1, this.njf_1, this.ojf_1, this.pjf_1 - deltaFraction, this.qjf_1 - delta | 0, this.rjf_1 || delta > 0, this.sjf_1, this.tjf_1, this.ujf_1, this.vjf_1, this.wjf_1, this.xjf_1, this.yjf_1, this.zjf_1);
    } else {
      tmp_2 = null;
    }
    return tmp_2;
  };
  protoOf(PagerMeasureResult).uad = function () {
    this.tjf_1.uad();
  };
  protoOf(PagerMeasureResult).h5e = function () {
    return this.tjf_1.h5e();
  };
  protoOf(PagerMeasureResult).i5e = function () {
    return this.tjf_1.i5e();
  };
  protoOf(PagerMeasureResult).sad = function () {
    return this.tjf_1.sad();
  };
  protoOf(PagerMeasureResult).tad = function () {
    return this.tjf_1.tad();
  };
  var androidx_compose_foundation_pager_PagerScopeImpl$stable;
  function PagerScopeImpl() {
  }
  var PagerScopeImpl_instance;
  function PagerScopeImpl_getInstance() {
    return PagerScopeImpl_instance;
  }
  var androidx_compose_foundation_pager_PagerScrollPosition$stable;
  function _set_currentPage__l4fckd($this, _set____db54di) {
    var tmp0 = $this.hjg_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerScrollPosition$_get_currentPage_$ref_uvd30t();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('currentPage', 1, tmp, tmp_0, PagerScrollPosition$_set_currentPage_$ref_krmvi9());
    tmp0.a49(_set____db54di);
    return Unit_instance;
  }
  function _set_currentPageOffsetFraction__6d0sns($this, _set____db54di) {
    var tmp0 = $this.ijg_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerScrollPosition$_get_currentPageOffsetFraction_$ref_qk55ug();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('currentPageOffsetFraction', 1, tmp, tmp_0, PagerScrollPosition$_set_currentPageOffsetFraction_$ref_gzf87g());
    tmp0.i45(_set____db54di);
    return Unit_instance;
  }
  function update_2($this, page, offsetFraction) {
    _set_currentPage__l4fckd($this, page);
    $this.ljg_1.pii(page);
    _set_currentPageOffsetFraction__6d0sns($this, offsetFraction);
  }
  function PagerScrollPosition$_get_currentPage_$ref_uvd30t() {
    return constructCallableReference(function (p0) {
      return p0.zj9();
    }, 1, 0, 289);
  }
  function PagerScrollPosition$_set_currentPage_$ref_krmvi9() {
    return constructCallableReference(function (p0, p1) {
      _set_currentPage__l4fckd(p0, p1);
      return Unit_instance;
    }, 2, 0, 290);
  }
  function PagerScrollPosition$_get_currentPageOffsetFraction_$ref_qk55ug() {
    return constructCallableReference(function (p0) {
      return p0.mja();
    }, 1, 0, 291);
  }
  function PagerScrollPosition$_set_currentPageOffsetFraction_$ref_gzf87g() {
    return constructCallableReference(function (p0, p1) {
      _set_currentPageOffsetFraction__6d0sns(p0, p1);
      return Unit_instance;
    }, 2, 0, 292);
  }
  function PagerScrollPosition(currentPage, currentPageOffsetFraction, state) {
    currentPage = currentPage === VOID ? 0 : currentPage;
    currentPageOffsetFraction = currentPageOffsetFraction === VOID ? 0.0 : currentPageOffsetFraction;
    this.gjg_1 = state;
    this.hjg_1 = mutableIntStateOf(currentPage);
    this.ijg_1 = mutableFloatStateOf(currentPageOffsetFraction);
    this.jjg_1 = false;
    this.kjg_1 = null;
    this.ljg_1 = new LazyLayoutNearestRangeState(currentPage, 30, 100);
  }
  protoOf(PagerScrollPosition).zj9 = function () {
    var tmp0 = this.hjg_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerScrollPosition$_get_currentPage_$ref_uvd30t();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('currentPage', 1, tmp, tmp_0, PagerScrollPosition$_set_currentPage_$ref_krmvi9());
    return tmp0.b49();
  };
  protoOf(PagerScrollPosition).mja = function () {
    var tmp0 = this.ijg_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerScrollPosition$_get_currentPageOffsetFraction_$ref_qk55ug();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('currentPageOffsetFraction', 1, tmp, tmp_0, PagerScrollPosition$_set_currentPageOffsetFraction_$ref_gzf87g());
    return tmp0.j45();
  };
  protoOf(PagerScrollPosition).mjg = function (measureResult) {
    var tmp = this;
    var tmp0_safe_receiver = measureResult.ojf_1;
    tmp.kjg_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pjc_1;
    var tmp_0;
    if (this.jjg_1) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !measureResult.ejf_1.r();
    }
    if (tmp_0) {
      this.jjg_1 = true;
      var tmp1_safe_receiver = measureResult.ojf_1;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ljc_1;
      update_2(this, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs, measureResult.pjf_1);
    }
  };
  protoOf(PagerScrollPosition).njg = function (index, offsetFraction) {
    update_2(this, index, offsetFraction);
    this.kjg_1 = null;
  };
  protoOf(PagerScrollPosition).ojg = function (itemProvider, index) {
    var newIndex = findIndexByKey(itemProvider, this.kjg_1, index);
    if (!(index === newIndex)) {
      _set_currentPage__l4fckd(this, newIndex);
      this.ljg_1.pii(index);
    }
    return newIndex;
  };
  protoOf(PagerScrollPosition).pjg = function (offsetFraction) {
    _set_currentPageOffsetFraction__6d0sns(this, offsetFraction);
  };
  protoOf(PagerScrollPosition).ajd = function (delta) {
    // Inline function 'androidx.compose.foundation.pager.debugLog' call
    if (false) {
      var tmp$ret$1 = 'Applying Delta=' + delta;
      println('PagerScrollPosition: ' + tmp$ret$1);
    }
    var tmp;
    if (this.gjg_1.yj9() === 0) {
      tmp = 0.0;
    } else {
      tmp = delta / this.gjg_1.yj9();
    }
    var fractionUpdate = tmp;
    _set_currentPageOffsetFraction__6d0sns(this, this.mja() + fractionUpdate);
  };
  function currentAbsoluteScrollOffset(_this__u8e3s4) {
    var tmp0 = fromInt(_this__u8e3s4.zj9());
    // Inline function 'kotlin.Long.times' call
    var other = _this__u8e3s4.yj9();
    var currentPageOffset = multiply(tmp0, fromInt(other));
    // Inline function 'kotlin.math.roundToLong' call
    var this_0 = _this__u8e3s4.mja() * _this__u8e3s4.yj9();
    var offsetFraction = roundToLong(this_0);
    return add(currentPageOffset, offsetFraction);
  }
  function LazyLayoutScrollScope_1(state, scrollScope) {
    return new LazyLayoutScrollScope$1_0(scrollScope, state);
  }
  function LazyLayoutScrollScope$1_0($scrollScope, $state) {
    this.rjg_1 = $state;
    this.qjg_1 = $scrollScope;
  }
  protoOf(LazyLayoutScrollScope$1_0).lia = function () {
    return this.rjg_1.ii0_1;
  };
  protoOf(LazyLayoutScrollScope$1_0).mia = function () {
    return this.rjg_1.ji0_1;
  };
  protoOf(LazyLayoutScrollScope$1_0).wii = function () {
    return last(this.rjg_1.thz().ci2()).bi0();
  };
  protoOf(LazyLayoutScrollScope$1_0).aie = function () {
    return this.rjg_1.di2();
  };
  protoOf(LazyLayoutScrollScope$1_0).xii = function (index, offset) {
    var pageSizeWithSpacing = this.rjg_1.yj9();
    var tmp;
    if (pageSizeWithSpacing === 0.0) {
      tmp = 0.0;
    } else {
      tmp = offset / pageSizeWithSpacing;
    }
    var offsetFraction = tmp;
    this.rjg_1.sjg(index, offsetFraction, true);
  };
  protoOf(LazyLayoutScrollScope$1_0).zii = function (targetIndex, targetOffset) {
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = imul(targetIndex - this.rjg_1.zj9() | 0, this.rjg_1.yj9()) - this.rjg_1.mja() * this.rjg_1.yj9() + targetOffset;
    var displacement = roundToInt(this_0);
    // Inline function 'kotlin.Long.plus' call
    var this_1 = currentAbsoluteScrollOffset(this.rjg_1);
    var tmp$ret$1 = add(this_1, fromInt(displacement));
    var currentScrollWithDisplacementApplied = coerceIn_2(tmp$ret$1, this.rjg_1.li0_1, this.rjg_1.ki0_1);
    return convertToInt(subtract(currentScrollWithDisplacementApplied, currentAbsoluteScrollOffset(this.rjg_1)));
  };
  protoOf(LazyLayoutScrollScope$1_0).bh7 = function (pixels) {
    return this.qjg_1.bh7(pixels);
  };
  function rememberPagerSemanticState(state, isVertical, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(state) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.l31(isVertical) || ($changed & 48) === 32));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = LazyLayoutSemanticState_0(state, isVertical);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  var androidx_compose_foundation_pager_PagerSnapDistanceMaxPages$stable;
  function Companion_12() {
  }
  protoOf(Companion_12).fjd = function (pages) {
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(pages >= 0)) {
      var tmp$ret$1 = 'pages should be greater than or equal to 0. You have used ' + pages + '.';
      throwIllegalArgumentException(tmp$ret$1);
    }
    return new PagerSnapDistanceMaxPages(pages);
  };
  var Companion_instance_22;
  function Companion_getInstance_71() {
    return Companion_instance_22;
  }
  function PagerSnapDistanceMaxPages(pagesLimit) {
    this.tjg_1 = pagesLimit;
  }
  protoOf(PagerSnapDistanceMaxPages).ii2 = function (startPage, suggestedTargetPage, velocity, pageSize, pageSpacing) {
    // Inline function 'androidx.compose.foundation.pager.debugLog' call
    if (false) {
      var tmp$ret$1 = 'PagerSnapDistanceMaxPages: startPage=' + startPage + ' ' + ('suggestedTargetPage=' + suggestedTargetPage + ' ') + ('velocity=' + velocity + ' ') + ('pageSize=' + pageSize + ' ') + ('pageSpacing' + pageSpacing);
      println('PagerSnapDistance: ' + tmp$ret$1);
    }
    var startPageLong = fromInt(startPage);
    // Inline function 'kotlin.Long.minus' call
    var other = this.tjg_1;
    var tmp$ret$2 = subtract(startPageLong, fromInt(other));
    var minRange = convertToInt(coerceAtLeast_1(tmp$ret$2, new Long(0, 0)));
    // Inline function 'kotlin.Long.plus' call
    var other_0 = this.tjg_1;
    var tmp$ret$3 = add(startPageLong, fromInt(other_0));
    var maxRange = convertToInt(coerceAtMost_1(tmp$ret$3, new Long(2147483647, 0)));
    return coerceIn_1(suggestedTargetPage, minRange, maxRange);
  };
  protoOf(PagerSnapDistanceMaxPages).equals = function (other) {
    var tmp;
    if (other instanceof PagerSnapDistanceMaxPages) {
      tmp = this.tjg_1 === other.tjg_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(PagerSnapDistanceMaxPages).hashCode = function () {
    return this.tjg_1;
  };
  function get_DefaultPositionThreshold() {
    _init_properties_PagerState_kt__9pfij6();
    return DefaultPositionThreshold;
  }
  var DefaultPositionThreshold;
  function get_UnitDensity() {
    _init_properties_PagerState_kt__9pfij6();
    return UnitDensity;
  }
  var UnitDensity;
  function get_EmptyLayoutInfo() {
    _init_properties_PagerState_kt__9pfij6();
    return EmptyLayoutInfo;
  }
  var EmptyLayoutInfo;
  var androidx_compose_foundation_pager_PagerState$stable;
  function PagerState$animateScrollToPage$slambda$lambda(this$0) {
    return function ($this$animateScrollToPage, it) {
      this$0.aja($this$animateScrollToPage, it);
      return Unit_instance;
    };
  }
  function PagerState_init_$Init$(currentPage, currentPageOffsetFraction, $this) {
    currentPage = currentPage === VOID ? 0 : currentPage;
    currentPageOffsetFraction = currentPageOffsetFraction === VOID ? 0.0 : currentPageOffsetFraction;
    PagerState.call($this, currentPage, currentPageOffsetFraction, null);
    return $this;
  }
  function performScroll_0($this, delta) {
    var currentScrollPosition = currentAbsoluteScrollOffset($this);
    // Inline function 'androidx.compose.foundation.pager.debugLog' call
    if (false) {
      var tmp$ret$1 = '\nDelta=' + delta + ' ' + ('\ncurrentScrollPosition=' + currentScrollPosition.toString() + ' ') + ('\naccumulator=' + $this.mi0_1) + ('\nmaxScrollOffset=' + $this.ki0_1.toString());
      println('PagerState: ' + tmp$ret$1);
    }
    var decimalAccumulation = delta + $this.mi0_1;
    // Inline function 'kotlin.math.roundToLong' call
    var decimalAccumulationInt = roundToLong(decimalAccumulation);
    $this.mi0_1 = decimalAccumulation - toNumber(decimalAccumulationInt);
    // Inline function 'kotlin.math.absoluteValue' call
    if (Math.abs(delta) < 1.0E-4)
      return delta;
    var updatedScrollPosition = add(currentScrollPosition, decimalAccumulationInt);
    var coercedScrollPosition = coerceIn_2(updatedScrollPosition, $this.li0_1, $this.ki0_1);
    var changed = !equalsLong(updatedScrollPosition, coercedScrollPosition);
    var scrollDelta = subtract(coercedScrollPosition, currentScrollPosition);
    $this.ni0_1 = toNumber(scrollDelta);
    // Inline function 'kotlin.math.absoluteValue' call
    var tmp$ret$4 = abs_0(scrollDelta);
    if (!equalsLong(tmp$ret$4, new Long(0, 0))) {
      $this.si1_1.s21(toNumber(scrollDelta) > 0.0);
      $this.ti1_1.s21(toNumber(scrollDelta) < 0.0);
    }
    var scrolledLayoutInfo = $this.vi0_1.u1().fjg(-convertToInt(scrollDelta) | 0);
    if (!(scrolledLayoutInfo == null) && !($this.fi0_1 == null)) {
      var tmp0_safe_receiver = $this.fi0_1;
      var scrolledApproachLayoutInfo = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fjg(-convertToInt(scrollDelta) | 0);
      if (!(scrolledApproachLayoutInfo == null)) {
        $this.fi0_1 = scrolledApproachLayoutInfo;
      } else {
        scrolledLayoutInfo = null;
      }
    }
    if (!(scrolledLayoutInfo == null)) {
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$6 = 'Will Apply Without Remeasure';
        println('PagerState: ' + tmp$ret$6);
      }
      $this.vjg(scrolledLayoutInfo, $this.ei0_1, true);
      ObservableScopeInvalidator__invalidateScope_impl_b202xc($this.oi1_1);
      $this.qi0_1 = $this.qi0_1 + 1 | 0;
    } else {
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$8 = 'Will Apply With Remeasure';
        println('PagerState: ' + tmp$ret$8);
      }
      $this.hi0_1.ajd(convertToInt(scrollDelta));
      var tmp1_safe_receiver = $this.ujg();
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.ob8();
      }
      $this.pi0_1 = $this.pi0_1 + 1 | 0;
    }
    return numberToDouble(changed ? scrollDelta : delta);
  }
  function _set_programmaticScrollTargetPage__yju1cc($this, _set____db54di) {
    var tmp0 = $this.zi0_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_programmaticScrollTargetPage_$ref_2b1kfn();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('programmaticScrollTargetPage', 1, tmp, tmp_0, PagerState$_set_programmaticScrollTargetPage_$ref_7w5bqf());
    tmp0.a49(_set____db54di);
    return Unit_instance;
  }
  function _get_programmaticScrollTargetPage__rd92e0($this) {
    var tmp0 = $this.zi0_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_programmaticScrollTargetPage_$ref_2b1kfn();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('programmaticScrollTargetPage', 1, tmp, tmp_0, PagerState$_set_programmaticScrollTargetPage_$ref_7w5bqf());
    return tmp0.b49();
  }
  function _set_settledPageState__dstani($this, _set____db54di) {
    var tmp0 = $this.ai1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_settledPageState_$ref_o0ew1z();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('settledPageState', 1, tmp, tmp_0, PagerState$_set_settledPageState_$ref_x2mhwt());
    tmp0.a49(_set____db54di);
    return Unit_instance;
  }
  function _get_settledPageState__s56i8u($this) {
    var tmp0 = $this.ai1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_settledPageState_$ref_o0ew1z();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('settledPageState', 1, tmp, tmp_0, PagerState$_set_settledPageState_$ref_x2mhwt());
    return tmp0.b49();
  }
  function _set_remeasurement__4pn4n8($this, _set____db54di) {
    var tmp0 = $this.ji1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_remeasurement_$ref_eqvzjz();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('remeasurement', 1, tmp, tmp_0, PagerState$_set_remeasurement_$ref_6ywwqd());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function awaitScrollDependencies($this, $completion) {
    var tmp = new $awaitScrollDependenciesCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function _set_canScrollForward__ffth81_1($this, _set____db54di) {
    var tmp0 = $this.qi1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_canScrollForward_$ref_53ir88();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('canScrollForward', 1, tmp, tmp_0, PagerState$_set_canScrollForward_$ref_8ujws4());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _set_canScrollBackward__6c7ll1_1($this, _set____db54di) {
    var tmp0 = $this.ri1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_canScrollBackward_$ref_vrnax6();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('canScrollBackward', 1, tmp, tmp_0, PagerState$_set_canScrollBackward_$ref_x3uema());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function tryRunPrefetch($this, result) {
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
      var previousSnapshot = Companion_instance_2.p52();
      var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
      var newSnapshot = Companion_instance_2.q52(previousSnapshot);
      try {
        if (!$this.ri0_1)
          return Unit_instance;
        if (result.mjf_1 >= $this.di2())
          return Unit_instance;
        // Inline function 'kotlin.math.abs' call
        var x = $this.ni0_1;
        if (Math.abs(x) <= 0.5)
          return Unit_instance;
        if (!isGestureActionMatchesScroll($this, $this.ni0_1))
          return Unit_instance;
        if (ComposeFoundationFlags_instance.lfg_1) {
          $this.gi1_1.zje($this.ni0_1, result);
        } else {
          notifyPrefetch($this, $this.ni0_1, result);
        }
        break $l$block;
      }finally {
        Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
      }
    }
    return Unit_instance;
  }
  function coerceInPageRange($this, $receiver) {
    var tmp;
    if ($this.di2() > 0) {
      tmp = coerceIn_1($receiver, 0, $this.di2() - 1 | 0);
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function isGestureActionMatchesScroll($this, scrollDelta) {
    var tmp;
    var tmp_0;
    if ($this.thz().lhy().equals(Orientation_Vertical_getInstance())) {
      // Inline function 'kotlin.math.sign' call
      var tmp_1 = sign(scrollDelta);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_0 = $this.yi1();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
      // Inline function 'kotlin.math.sign' call
      var x = -floatFromBits(bits);
      tmp_0 = tmp_1 === sign(x);
    } else {
      // Inline function 'kotlin.math.sign' call
      var tmp_2 = sign(scrollDelta);
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_1 = $this.yi1();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(shiftRight(value_0, 32));
      // Inline function 'kotlin.math.sign' call
      var x_0 = -floatFromBits(bits_0);
      tmp_0 = tmp_2 === sign(x_0);
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = $this.xi1();
    }
    return tmp;
  }
  function notifyPrefetch($this, delta, info) {
    if (!$this.ri0_1) {
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!info.ci2().r()) {
      var isPrefetchingForward = delta > 0;
      var indexToPrefetch = calculatePrefetchIndex($this, isPrefetchingForward, info);
      if (0 <= indexToPrefetch ? indexToPrefetch < $this.di2() : false) {
        if (!(indexToPrefetch === $this.si0_1)) {
          if (!($this.ui0_1 === isPrefetchingForward)) {
            var tmp0_safe_receiver = $this.ti0_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.e2z();
            }
          }
          $this.ui0_1 = isPrefetchingForward;
          $this.si0_1 = indexToPrefetch;
          $this.ti0_1 = $this.di1_1.sj4(indexToPrefetch, $this.li1_1);
        }
        if (isPrefetchingForward) {
          var lastItem = last(info.ci2());
          var pageSize = info.ui1() + info.jjd() | 0;
          var distanceToReachNextItem = (lastItem.ai0() + pageSize | 0) - info.aig() | 0;
          if (distanceToReachNextItem < delta) {
            var tmp1_safe_receiver = $this.ti0_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.cii();
            }
          }
        } else {
          var firstItem = first(info.ci2());
          var distanceToReachNextItem_0 = info.zif() - firstItem.ai0() | 0;
          if (distanceToReachNextItem_0 < -delta) {
            var tmp2_safe_receiver = $this.ti0_1;
            if (tmp2_safe_receiver == null)
              null;
            else {
              tmp2_safe_receiver.cii();
            }
          }
        }
      }
    }
  }
  function cancelPrefetchIfVisibleItemsChanged($this, info) {
    var tmp;
    if (!($this.si0_1 === -1)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !info.ci2().r();
    } else {
      tmp = false;
    }
    if (tmp) {
      var expectedPrefetchIndex = calculatePrefetchIndex($this, $this.ui0_1, info);
      if (!($this.si0_1 === expectedPrefetchIndex)) {
        $this.si0_1 = -1;
        var tmp0_safe_receiver = $this.ti0_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.e2z();
        }
        $this.ti0_1 = null;
      }
    }
  }
  function calculatePrefetchIndex($this, forward, info) {
    var tmp;
    if (forward) {
      var offset = info.ejg() + 1 | 0;
      var tmp_0;
      if (offset < 0) {
        tmp_0 = 2147483647;
      } else {
        tmp_0 = last(info.ci2()).bi0() + offset | 0;
      }
      tmp = tmp_0;
    } else {
      tmp = (first(info.ci2()).bi0() - info.ejg() | 0) - 1 | 0;
    }
    return tmp;
  }
  function PagerState$_get_upDownDifference_$ref_z315bq() {
    return constructCallableReference(function (p0) {
      return new Offset(p0.yi1());
    }, 1, 0, 293);
  }
  function PagerState$_set_upDownDifference_$ref_m008n2() {
    return constructCallableReference(function (p0, p1) {
      p0.mjb(p1.e5d_1);
      return Unit_instance;
    }, 2, 0, 294);
  }
  function PagerState$scrollableState$lambda(this$0) {
    return function (it) {
      return performScroll_0(this$0, it);
    };
  }
  function PagerState$_get_programmaticScrollTargetPage_$ref_2b1kfn() {
    return constructCallableReference(function (p0) {
      return _get_programmaticScrollTargetPage__rd92e0(p0);
    }, 1, 0, 295);
  }
  function PagerState$_set_programmaticScrollTargetPage_$ref_7w5bqf() {
    return constructCallableReference(function (p0, p1) {
      _set_programmaticScrollTargetPage__yju1cc(p0, p1);
      return Unit_instance;
    }, 2, 0, 296);
  }
  function PagerState$_get_settledPageState_$ref_o0ew1z() {
    return constructCallableReference(function (p0) {
      return _get_settledPageState__s56i8u(p0);
    }, 1, 0, 297);
  }
  function PagerState$_set_settledPageState_$ref_x2mhwt() {
    return constructCallableReference(function (p0, p1) {
      _set_settledPageState__dstani(p0, p1);
      return Unit_instance;
    }, 2, 0, 298);
  }
  function PagerState$settledPage$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.sg7()) {
        tmp = _get_settledPageState__s56i8u(this$0);
      } else {
        tmp = this$0.zj9();
      }
      return tmp;
    };
  }
  function PagerState$targetPage$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (!this$0.sg7()) {
        tmp = this$0.zj9();
      } else if (!(_get_programmaticScrollTargetPage__rd92e0(this$0) === -1)) {
        tmp = _get_programmaticScrollTargetPage__rd92e0(this$0);
      } else {
        var tmp_0;
        // Inline function 'kotlin.math.abs' call
        var x = this$0.mja();
        var tmp_1 = Math.abs(x);
        // Inline function 'kotlin.math.abs' call
        var x_0 = this$0.vi1();
        if (tmp_1 >= Math.abs(x_0)) {
          var tmp_2;
          if (this$0.sja()) {
            tmp_2 = this$0.ii0_1 + 1 | 0;
          } else {
            tmp_2 = this$0.ii0_1;
          }
          tmp_0 = tmp_2;
        } else {
          tmp_0 = this$0.zj9();
        }
        tmp = tmp_0;
      }
      var finalPage = tmp;
      return coerceInPageRange(this$0, finalPage);
    };
  }
  function PagerState$prefetchState$lambda(this$0) {
    return function ($this$LazyLayoutPrefetchState) {
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance_2.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance_2.q52(previousSnapshot);
        try {
          $this$LazyLayoutPrefetchState.eii(this$0.ii0_1);
          break $l$block;
        }finally {
          Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
        }
      }
      return Unit_instance;
    };
  }
  function PagerState$pagerCacheWindow$1(this$0) {
    this.fjh_1 = this$0;
  }
  protoOf(PagerState$pagerCacheWindow$1).oiv = function (_this__u8e3s4, viewport) {
    return this.fjh_1.xi0_1;
  };
  protoOf(PagerState$pagerCacheWindow$1).liv = function (_this__u8e3s4, viewport) {
    return 0;
  };
  function PagerState$_scrollIndicatorState$1(this$0) {
    this.gjh_1 = this$0;
  }
  function PagerState$cacheWindowLogic$lambda(this$0) {
    return function () {
      return this$0.di2();
    };
  }
  function PagerState$_get_remeasurement_$ref_eqvzjz() {
    return constructCallableReference(function (p0) {
      return p0.ujg();
    }, 1, 0, 299);
  }
  function PagerState$_set_remeasurement_$ref_6ywwqd() {
    return constructCallableReference(function (p0, p1) {
      _set_remeasurement__4pn4n8(p0, p1);
      return Unit_instance;
    }, 2, 0, 300);
  }
  function PagerState$remeasurementModifier$1(this$0) {
    this.hjh_1 = this$0;
  }
  protoOf(PagerState$remeasurementModifier$1).xap = function (remeasurement) {
    _set_remeasurement__4pn4n8(this.hjh_1, remeasurement);
  };
  function PagerState$_get_nearestRange_$ref_twpupb() {
    return constructCallableReference(function (p0) {
      return p0.yif();
    }, 1, 0, 301);
  }
  function PagerState$scrollToPage$slambda(this$0, $page, $pageOffsetFraction, resultContinuation) {
    this.qjh_1 = this$0;
    this.rjh_1 = $page;
    this.sjh_1 = $pageOffsetFraction;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PagerState$scrollToPage$slambda).zh6 = function ($this$scroll, $completion) {
    var tmp = this.ah7($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(PagerState$scrollToPage$slambda).ja = function (p1, $completion) {
    return this.zh6((!(p1 == null) ? isInterface(p1, ScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PagerState$scrollToPage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            if (false) {
              println('PagerState: ' + ('Scroll from page=' + this.qjh_1.zj9() + ' to page=' + this.rjh_1));
            }

            this.n9_1 = 1;
            suspendResult = awaitScrollDependencies(this.qjh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var containsLower = -0.5;
            var containsArg = this.sjh_1;
            if (!(containsLower <= containsArg ? containsArg <= 0.5 : false)) {
              throwIllegalArgumentException('pageOffsetFraction ' + this.sjh_1 + ' is not within the range -0.5 to 0.5');
            }

            var targetPage = coerceInPageRange(this.qjh_1, this.rjh_1);
            this.qjh_1.sjg(targetPage, this.sjh_1, true);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(PagerState$scrollToPage$slambda).ah7 = function ($this$scroll, completion) {
    var i = new PagerState$scrollToPage$slambda(this.qjh_1, this.rjh_1, this.sjh_1, completion);
    i.tjh_1 = $this$scroll;
    return i;
  };
  function PagerState$scrollToPage$slambda_0(this$0, $page, $pageOffsetFraction, resultContinuation) {
    var i = new PagerState$scrollToPage$slambda(this$0, $page, $pageOffsetFraction, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.zh6($this$scroll, $completion);
    }, 1);
  }
  function PagerState$requestScrollToPage$slambda(this$0, resultContinuation) {
    this.cji_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PagerState$requestScrollToPage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(PagerState$requestScrollToPage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PagerState$requestScrollToPage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = stopScroll(this.cji_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(PagerState$requestScrollToPage$slambda).q24 = function ($this$launch, completion) {
    var i = new PagerState$requestScrollToPage$slambda(this.cji_1, completion);
    i.dji_1 = $this$launch;
    return i;
  };
  function PagerState$requestScrollToPage$slambda_0(this$0, resultContinuation) {
    var i = new PagerState$requestScrollToPage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function PagerState$animateScrollToPage$slambda(this$0, $targetPage, $targetPageOffsetToSnappedPosition, $animationSpec, resultContinuation) {
    this.mji_1 = this$0;
    this.nji_1 = $targetPage;
    this.oji_1 = $targetPageOffsetToSnappedPosition;
    this.pji_1 = $animationSpec;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PagerState$animateScrollToPage$slambda).zh6 = function ($this$scroll, $completion) {
    var tmp = this.ah7($this$scroll, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(PagerState$animateScrollToPage$slambda).ja = function (p1, $completion) {
    return this.zh6((!(p1 == null) ? isInterface(p1, ScrollScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PagerState$animateScrollToPage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = LazyLayoutScrollScope_1(this.mji_1, this.qji_1);
            suspendResult = animateScrollToPage(tmp_0, this.nji_1, this.oji_1, this.pji_1, PagerState$animateScrollToPage$slambda$lambda(this.mji_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(PagerState$animateScrollToPage$slambda).ah7 = function ($this$scroll, completion) {
    var i = new PagerState$animateScrollToPage$slambda(this.mji_1, this.nji_1, this.oji_1, this.pji_1, completion);
    i.qji_1 = $this$scroll;
    return i;
  };
  function PagerState$animateScrollToPage$slambda_0(this$0, $targetPage, $targetPageOffsetToSnappedPosition, $animationSpec, resultContinuation) {
    var i = new PagerState$animateScrollToPage$slambda(this$0, $targetPage, $targetPageOffsetToSnappedPosition, $animationSpec, resultContinuation);
    return constructCallableReference(function ($this$scroll, $completion) {
      return i.zh6($this$scroll, $completion);
    }, 1);
  }
  function PagerState$_get_canScrollForward_$ref_53ir88() {
    return constructCallableReference(function (p0) {
      return p0.mg7();
    }, 1, 0, 302);
  }
  function PagerState$_set_canScrollForward_$ref_8ujws4() {
    return constructCallableReference(function (p0, p1) {
      _set_canScrollForward__ffth81_1(p0, p1);
      return Unit_instance;
    }, 2, 0, 303);
  }
  function PagerState$_get_canScrollBackward_$ref_vrnax6() {
    return constructCallableReference(function (p0) {
      return p0.ng7();
    }, 1, 0, 304);
  }
  function PagerState$_set_canScrollBackward_$ref_x3uema() {
    return constructCallableReference(function (p0, p1) {
      _set_canScrollBackward__6c7ll1_1(p0, p1);
      return Unit_instance;
    }, 2, 0, 305);
  }
  function $animateScrollToPageCOROUTINE$(_this__u8e3s4, page, pageOffsetFraction, animationSpec, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zji_1 = _this__u8e3s4;
    this.ajj_1 = page;
    this.bjj_1 = pageOffsetFraction;
    this.cjj_1 = animationSpec;
  }
  protoOf($animateScrollToPageCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.ajj_1 === this.zji_1.zj9() && this.zji_1.mja() === this.bjj_1 || this.zji_1.di2() === 0)
              return Unit_instance;
            this.n9_1 = 1;
            suspendResult = awaitScrollDependencies(this.zji_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var containsLower = -0.5;
            var containsArg = this.bjj_1;
            if (!(containsLower <= containsArg ? containsArg <= 0.5 : false)) {
              throwIllegalArgumentException('pageOffsetFraction ' + this.bjj_1 + ' is not within the range -0.5 to 0.5');
            }

            var targetPage = coerceInPageRange(this.zji_1, this.ajj_1);
            var targetPageOffsetToSnappedPosition = this.bjj_1 * this.zji_1.yj9();
            this.n9_1 = 2;
            suspendResult = this.zji_1.qg7(VOID, PagerState$animateScrollToPage$slambda_0(this.zji_1, targetPage, targetPageOffsetToSnappedPosition, this.cjj_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $awaitScrollDependenciesCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ejh_1 = _this__u8e3s4;
  }
  protoOf($awaitScrollDependenciesCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.ejh_1.vi0_1.u1() === get_EmptyLayoutInfo()) {
              this.n9_1 = 1;
              suspendResult = this.ejh_1.ii1_1.ail(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $scrollCOROUTINE$_1(_this__u8e3s4, scrollPriority, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ljj_1 = _this__u8e3s4;
    this.mjj_1 = scrollPriority;
    this.njj_1 = block;
  }
  protoOf($scrollCOROUTINE$_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = awaitScrollDependencies(this.ljj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (!this.ljj_1.sg7()) {
              _set_settledPageState__dstani(this.ljj_1, this.ljj_1.zj9());
            }

            this.n9_1 = 2;
            suspendResult = this.ljj_1.oi0_1.pg7(this.mjj_1, this.njj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            _set_programmaticScrollTargetPage__yju1cc(this.ljj_1, -1);
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function PagerState(currentPage, currentPageOffsetFraction, prefetchScheduler) {
    currentPage = currentPage === VOID ? 0 : currentPage;
    currentPageOffsetFraction = currentPageOffsetFraction === VOID ? 0.0 : currentPageOffsetFraction;
    prefetchScheduler = prefetchScheduler === VOID ? null : prefetchScheduler;
    this.ei0_1 = false;
    this.fi0_1 = null;
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(-0.5 <= currentPageOffsetFraction ? currentPageOffsetFraction <= 0.5 : false)) {
      var tmp$ret$1 = 'currentPageOffsetFraction ' + currentPageOffsetFraction + ' is ' + 'not within the range -0.5 to 0.5';
      throwIllegalArgumentException(tmp$ret$1);
    }
    this.gi0_1 = mutableStateOf(new Offset(Companion_getInstance_6().g5d_1));
    this.hi0_1 = new PagerScrollPosition(currentPage, currentPageOffsetFraction, this);
    this.ii0_1 = currentPage;
    this.ji0_1 = 0;
    this.ki0_1 = new Long(-1, 2147483647);
    this.li0_1 = new Long(0, 0);
    this.mi0_1 = 0.0;
    this.ni0_1 = 0.0;
    var tmp = this;
    tmp.oi0_1 = ScrollableState_0(PagerState$scrollableState$lambda(this));
    this.pi0_1 = 0;
    this.qi0_1 = 0;
    this.ri0_1 = true;
    this.si0_1 = -1;
    this.ti0_1 = null;
    this.ui0_1 = false;
    this.vi0_1 = mutableStateOf(get_EmptyLayoutInfo(), neverEqualPolicy());
    this.wi0_1 = get_UnitDensity();
    this.xi0_1 = 0;
    this.yi0_1 = funMutableInteractionSource();
    this.zi0_1 = mutableIntStateOf(-1);
    this.ai1_1 = mutableIntStateOf(currentPage);
    var tmp_0 = this;
    var tmp_1 = structuralEqualityPolicy();
    tmp_0.bi1_1 = derivedStateOf_0(tmp_1, PagerState$settledPage$delegate$lambda(this));
    var tmp_2 = this;
    var tmp_3 = structuralEqualityPolicy();
    tmp_2.ci1_1 = derivedStateOf_0(tmp_3, PagerState$targetPage$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.di1_1 = LazyLayoutPrefetchState_init_$Create$(prefetchScheduler, PagerState$prefetchState$lambda(this));
    var tmp_5 = this;
    tmp_5.ei1_1 = new PagerState$pagerCacheWindow$1(this);
    var tmp_6 = this;
    tmp_6.fi1_1 = new PagerState$_scrollIndicatorState$1(this);
    var tmp_7 = this;
    tmp_7.gi1_1 = new PagerCacheWindowLogic(this.ei1_1, this.di1_1, PagerState$cacheWindowLogic$lambda(this));
    this.hi1_1 = new LazyLayoutBeyondBoundsInfo();
    this.ii1_1 = new AwaitFirstLayoutModifier();
    this.ji1_1 = mutableStateOf(null);
    var tmp_8 = this;
    tmp_8.ki1_1 = new PagerState$remeasurementModifier$1(this);
    this.li1_1 = Constraints_0();
    this.mi1_1 = LazyLayoutPinnedItemList_init_$Create$();
    this.ni1_1 = this.hi0_1.ljg_1;
    this.oi1_1 = _ObservableScopeInvalidator___init__impl__ism0sl();
    this.pi1_1 = _ObservableScopeInvalidator___init__impl__ism0sl();
    this.qi1_1 = mutableStateOf(false);
    this.ri1_1 = mutableStateOf(false);
    this.si1_1 = mutableStateOf(false);
    this.ti1_1 = mutableStateOf(false);
  }
  protoOf(PagerState).mjb = function (_set____db54di) {
    var tmp0 = this.gi0_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_upDownDifference_$ref_z315bq();
    getPropertyCallableRef('upDownDifference', 1, tmp, tmp_0, PagerState$_set_upDownDifference_$ref_m008n2());
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new Offset(_set____db54di);
    tmp0.s21(value);
    return Unit_instance;
  };
  protoOf(PagerState).yi1 = function () {
    var tmp0 = this.gi0_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_upDownDifference_$ref_z315bq();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('upDownDifference', 1, tmp, tmp_0, PagerState$_set_upDownDifference_$ref_m008n2());
    return tmp0.u1().e5d_1;
  };
  protoOf(PagerState).thz = function () {
    return this.vi0_1.u1();
  };
  protoOf(PagerState).hi2 = function () {
    return this.vi0_1.u1().gjf_1;
  };
  protoOf(PagerState).gi2 = function () {
    return this.vi0_1.u1().fjf_1;
  };
  protoOf(PagerState).yj9 = function () {
    return this.gi2() + this.hi2() | 0;
  };
  protoOf(PagerState).vi1 = function () {
    // Inline function 'kotlin.with' call
    var tmp0 = this.wi0_1.v5e(get_DefaultPositionThreshold());
    // Inline function 'kotlin.comparisons.minOf' call
    var b = this.gi2() / 2.0;
    var minThreshold = Math.min(tmp0, b);
    return minThreshold / this.gi2();
  };
  protoOf(PagerState).zj9 = function () {
    return this.hi0_1.zj9();
  };
  protoOf(PagerState).mja = function () {
    return this.hi0_1.mja();
  };
  protoOf(PagerState).ujg = function () {
    var tmp0 = this.ji1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_remeasurement_$ref_eqvzjz();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('remeasurement', 1, tmp, tmp_0, PagerState$_set_remeasurement_$ref_6ywwqd());
    return tmp0.u1();
  };
  protoOf(PagerState).yif = function () {
    var tmp0 = this.ni1_1;
    var tmp = KProperty1;
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('nearestRange', 1, tmp, PagerState$_get_nearestRange_$ref_twpupb(), null);
    return tmp0.u1();
  };
  protoOf(PagerState).ojj = function (page, pageOffsetFraction, $completion) {
    return this.qg7(VOID, PagerState$scrollToPage$slambda_0(this, page, pageOffsetFraction, null), $completion);
  };
  protoOf(PagerState).kjc = function (page, pageOffsetFraction, $completion, $super) {
    pageOffsetFraction = pageOffsetFraction === VOID ? 0.0 : pageOffsetFraction;
    return $super === VOID ? this.ojj(page, pageOffsetFraction, $completion) : $super.ojj.call(this, page, pageOffsetFraction, $completion);
  };
  protoOf(PagerState).aja = function (_this__u8e3s4, targetPage) {
    _set_programmaticScrollTargetPage__yju1cc(this, coerceInPageRange(this, targetPage));
  };
  protoOf(PagerState).sjg = function (page, offsetFraction, forceRemeasure) {
    var positionChanged = !(this.hi0_1.zj9() === page) || !(this.hi0_1.mja() === offsetFraction);
    if (positionChanged) {
      this.gi1_1.nil();
    }
    this.hi0_1.njg(page, offsetFraction);
    if (forceRemeasure) {
      var tmp0_safe_receiver = this.ujg();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.ob8();
      }
    } else {
      ObservableScopeInvalidator__invalidateScope_impl_b202xc(this.pi1_1);
    }
  };
  protoOf(PagerState).pjj = function (page, pageOffsetFraction) {
    if (this.sg7()) {
      var tmp = this.vi0_1.u1().xjf_1;
      launch(tmp, VOID, VOID, PagerState$requestScrollToPage$slambda_0(this, null));
    }
    this.sjg(page, pageOffsetFraction, false);
  };
  protoOf(PagerState).nja = function (page, pageOffsetFraction, $super) {
    pageOffsetFraction = pageOffsetFraction === VOID ? 0.0 : pageOffsetFraction;
    var tmp;
    if ($super === VOID) {
      this.pjj(page, pageOffsetFraction);
      tmp = Unit_instance;
    } else {
      tmp = $super.pjj.call(this, page, pageOffsetFraction);
    }
    return tmp;
  };
  protoOf(PagerState).qjj = function (page, pageOffsetFraction, animationSpec, $completion) {
    var tmp = new $animateScrollToPageCOROUTINE$(this, page, pageOffsetFraction, animationSpec, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(PagerState).rjj = function (page, pageOffsetFraction, animationSpec, $completion, $super) {
    pageOffsetFraction = pageOffsetFraction === VOID ? 0.0 : pageOffsetFraction;
    animationSpec = animationSpec === VOID ? spring() : animationSpec;
    return $super === VOID ? this.qjj(page, pageOffsetFraction, animationSpec, $completion) : $super.qjj.call(this, page, pageOffsetFraction, animationSpec, $completion);
  };
  protoOf(PagerState).pg7 = function (scrollPriority, block, $completion) {
    var tmp = new $scrollCOROUTINE$_1(this, scrollPriority, block, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(PagerState).rg7 = function (delta) {
    return this.oi0_1.rg7(delta);
  };
  protoOf(PagerState).sg7 = function () {
    return this.oi0_1.sg7();
  };
  protoOf(PagerState).mg7 = function () {
    var tmp0 = this.qi1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_canScrollForward_$ref_53ir88();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('canScrollForward', 1, tmp, tmp_0, PagerState$_set_canScrollForward_$ref_8ujws4());
    return tmp0.u1();
  };
  protoOf(PagerState).ng7 = function () {
    var tmp0 = this.ri1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = PagerState$_get_canScrollBackward_$ref_vrnax6();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('canScrollBackward', 1, tmp, tmp_0, PagerState$_set_canScrollBackward_$ref_x3uema());
    return tmp0.u1();
  };
  protoOf(PagerState).sja = function () {
    return this.si1_1.u1();
  };
  protoOf(PagerState).vjg = function (result, isLookingAhead, visibleItemsStayedTheSame) {
    this.di1_1.kij_1 = result.ejf_1.n1();
    this.xi0_1 = result.fjf_1 + result.gjf_1 | 0;
    if (!isLookingAhead && this.ei0_1) {
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$1 = 'Applying Approach Measure Result';
        println('PagerState: ' + tmp$ret$1);
      }
      this.fi0_1 = result;
    } else {
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$3 = 'Applying Measure Result';
        println('PagerState: ' + tmp$ret$3);
      }
      if (isLookingAhead) {
        this.ei0_1 = true;
      }
      if (visibleItemsStayedTheSame) {
        this.hi0_1.pjg(result.pjf_1);
      } else {
        this.hi0_1.mjg(result);
        if (ComposeFoundationFlags_instance.lfg_1) {
          if (this.ri0_1) {
            this.gi1_1.djf(result);
          }
        } else {
          cancelPrefetchIfVisibleItemsChanged(this, result);
        }
      }
      this.vi0_1.s21(result);
      _set_canScrollForward__ffth81_1(this, result.rjf_1);
      _set_canScrollBackward__6c7ll1_1(this, result.ng7());
      var tmp0_safe_receiver = result.njf_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.ii0_1 = tmp0_safe_receiver.ljc_1;
      }
      this.ji0_1 = result.qjf_1;
      tryRunPrefetch(this, result);
      this.ki0_1 = calculateNewMaxScrollOffset(result, this.di2());
      this.li0_1 = coerceAtMost_1(calculateNewMinScrollOffset(result, this.di2()), this.ki0_1);
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$7 = 'Finished Applying Measure Result\nNew maxScrollOffset=' + this.ki0_1.toString();
        println('PagerState: ' + tmp$ret$7);
      }
    }
  };
  protoOf(PagerState).djg = function (result, isLookingAhead, visibleItemsStayedTheSame, $super) {
    visibleItemsStayedTheSame = visibleItemsStayedTheSame === VOID ? false : visibleItemsStayedTheSame;
    var tmp;
    if ($super === VOID) {
      this.vjg(result, isLookingAhead, visibleItemsStayedTheSame);
      tmp = Unit_instance;
    } else {
      tmp = $super.vjg.call(this, result, isLookingAhead, visibleItemsStayedTheSame);
    }
    return tmp;
  };
  protoOf(PagerState).xi1 = function () {
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    var this_0 = this.yi1();
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp$ret$0 = floatFromBits(bits);
    if (numberToInt(tmp$ret$0) === 0) {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_1 = this.yi1();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp$ret$4 = floatFromBits(bits_0);
      tmp = numberToInt(tmp$ret$4) === 0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(PagerState).cjg = function (itemProvider, currentPage) {
    return this.hi0_1.ojg(itemProvider, currentPage);
  };
  function rememberPagerState(initialPage, initialPageOffsetFraction, pageCount, $composer, $changed, $default) {
    _init_properties_PagerState_kt__9pfij6();
    var initialPage_0 = {_v: initialPage};
    var initialPageOffsetFraction_0 = {_v: initialPageOffsetFraction};
    var $composer_0 = $composer;
    if (!(($default & 1) === 0)) {
      initialPage_0._v = 0;
    }
    if (!(($default & 2) === 0)) {
      initialPageOffsetFraction_0._v = 0.0;
    }
    var tmp = Companion_getInstance_72().sjj_1;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!((($changed & 14 ^ 6) > 4 && $composer_0.m31(initialPage_0._v) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.n31(initialPageOffsetFraction_0._v) || ($changed & 48) === 32)) | (($changed & 896 ^ 384) > 256 && $composer_0.k31(pageCount) || ($changed & 384) === 256));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp_0;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = rememberPagerState$lambda(initialPage_0, initialPageOffsetFraction_0, pageCount);
      $composer_0.j31(value);
      tmp_0 = value;
    } else {
      tmp_0 = it;
    }
    var tmp$ret$0 = tmp_0;
    // Inline function 'kotlin.apply' call
    var this_0 = rememberSaveable([], tmp, tmp$ret$0, $composer_0, 0);
    this_0.jjl_1.s21(pageCount);
    return this_0;
  }
  function animateScrollToPage(_this__u8e3s4, targetPage, targetPageOffsetToSnappedPosition, animationSpec, updateTargetPage, $completion) {
    updateTargetPage(_this__u8e3s4, targetPage);
    var forward = targetPage > _this__u8e3s4.lia();
    var visiblePages = (_this__u8e3s4.wii() - _this__u8e3s4.lia() | 0) + 1 | 0;
    if ((forward && targetPage > _this__u8e3s4.wii() || (!forward && targetPage < _this__u8e3s4.lia())) && abs(targetPage - _this__u8e3s4.lia() | 0) >= 3) {
      var tmp;
      if (forward) {
        tmp = coerceAtLeast_0(targetPage - visiblePages | 0, _this__u8e3s4.lia());
      } else {
        tmp = coerceAtMost(targetPage + visiblePages | 0, _this__u8e3s4.lia());
      }
      var preJumpPosition = tmp;
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$1 = 'animateScrollToPage with pre-jump to position=' + preJumpPosition;
        println('PagerState: ' + tmp$ret$1);
      }
      _this__u8e3s4.xii(preJumpPosition, 0);
    }
    var displacement = _this__u8e3s4.aij(targetPage) + targetPageOffsetToSnappedPosition;
    // Inline function 'androidx.compose.foundation.pager.debugLog' call
    if (false) {
      var tmp$ret$3 = 'animateScrollToPage ' + displacement + ' pixels';
      println('PagerState: ' + tmp$ret$3);
    }
    var previousValue = {_v: 0.0};
    return animate(0.0, displacement, VOID, animationSpec, animateScrollToPage$lambda(previousValue, _this__u8e3s4), $completion);
  }
  function calculateNewMaxScrollOffset(_this__u8e3s4, pageCount) {
    _init_properties_PagerState_kt__9pfij6();
    var pageSizeWithSpacing = _this__u8e3s4.jjd() + _this__u8e3s4.ui1() | 0;
    // Inline function 'kotlin.Long.times' call
    var this_0 = fromInt(pageCount);
    var tmp0 = multiply(this_0, fromInt(pageSizeWithSpacing));
    // Inline function 'kotlin.Long.plus' call
    var other = _this__u8e3s4.yhz();
    var tmp0_0 = add(tmp0, fromInt(other));
    // Inline function 'kotlin.Long.plus' call
    var other_0 = _this__u8e3s4.zhz();
    var tmp0_1 = add(tmp0_0, fromInt(other_0));
    // Inline function 'kotlin.Long.minus' call
    var other_1 = _this__u8e3s4.jjd();
    var maxScrollPossible = subtract(tmp0_1, fromInt(other_1));
    var tmp;
    if (_this__u8e3s4.lhy().equals(Orientation_Horizontal_getInstance())) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = _this__u8e3s4.khy();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_1);
      tmp = convertToInt(shiftRight(value, 32));
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_2 = _this__u8e3s4.khy();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_2);
      tmp = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    }
    var layoutSize = tmp;
    var tmp0_$this = _this__u8e3s4.fi2();
    var tmp1_itemSize = _this__u8e3s4.ui1();
    var tmp2_itemIndex = pageCount - 1 | 0;
    var tmp3_beforeContentPadding = _this__u8e3s4.yhz();
    var tmp4_afterContentPadding = _this__u8e3s4.zhz();
    var snapPositionDiscount = layoutSize - coerceIn_1(tmp0_$this.yi6(layoutSize, tmp1_itemSize, tmp3_beforeContentPadding, tmp4_afterContentPadding, tmp2_itemIndex, pageCount), 0, layoutSize) | 0;
    // Inline function 'androidx.compose.foundation.pager.debugLog' call
    if (false) {
      var tmp$ret$9 = 'maxScrollPossible=' + maxScrollPossible.toString() + ('\nsnapPositionDiscount=' + snapPositionDiscount) + ('\nlayoutSize=' + layoutSize);
      println('PagerState: ' + tmp$ret$9);
    }
    // Inline function 'kotlin.Long.minus' call
    var tmp$ret$10 = subtract(maxScrollPossible, fromInt(snapPositionDiscount));
    return coerceAtLeast_1(tmp$ret$10, new Long(0, 0));
  }
  function calculateNewMinScrollOffset(_this__u8e3s4, pageCount) {
    _init_properties_PagerState_kt__9pfij6();
    var tmp;
    if (_this__u8e3s4.ijf_1.equals(Orientation_Horizontal_getInstance())) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = _this__u8e3s4.khy();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      tmp = convertToInt(shiftRight(value, 32));
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_1 = _this__u8e3s4.khy();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      tmp = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    }
    var layoutSize = tmp;
    var tmp0_$this = _this__u8e3s4.sjf_1;
    var tmp1_itemSize = _this__u8e3s4.fjf_1;
    var tmp2_beforeContentPadding = _this__u8e3s4.yhz();
    var tmp3_afterContentPadding = _this__u8e3s4.hjf_1;
    return fromInt(coerceIn_1(tmp0_$this.yi6(layoutSize, tmp1_itemSize, tmp2_beforeContentPadding, tmp3_afterContentPadding, 0, pageCount), 0, layoutSize));
  }
  function DefaultPagerState$Companion$Saver$lambda($this$listSaver, it) {
    return listOf([it.zj9(), coerceIn_0(it.mja(), -0.5, 0.5), it.di2()]);
  }
  function DefaultPagerState$Companion$Saver$lambda_0(it) {
    var tmp = it.l1(0);
    var tmp_0 = typeof tmp === 'number' ? tmp : THROW_CCE();
    var tmp_1 = it.l1(1);
    var tmp_2 = typeof tmp_1 === 'number' ? tmp_1 : THROW_CCE();
    return new DefaultPagerState(tmp_0, tmp_2, DefaultPagerState$Companion$Saver$lambda$lambda(it));
  }
  function DefaultPagerState$Companion$Saver$lambda$lambda($it) {
    return function () {
      var tmp = $it.l1(2);
      return typeof tmp === 'number' ? tmp : THROW_CCE();
    };
  }
  function Companion_13() {
    Companion_instance_23 = this;
    var tmp = this;
    var tmp_0 = DefaultPagerState$Companion$Saver$lambda;
    tmp.sjj_1 = listSaver(tmp_0, DefaultPagerState$Companion$Saver$lambda_0);
  }
  var Companion_instance_23;
  function Companion_getInstance_72() {
    if (Companion_instance_23 == null)
      new Companion_13();
    return Companion_instance_23;
  }
  function DefaultPagerState(currentPage, currentPageOffsetFraction, updatedPageCount) {
    Companion_getInstance_72();
    PagerState_init_$Init$(currentPage, currentPageOffsetFraction, this);
    this.jjl_1 = mutableStateOf(updatedPageCount);
  }
  protoOf(DefaultPagerState).di2 = function () {
    return this.jjl_1.u1()();
  };
  function animateToNextPage(_this__u8e3s4, $completion) {
    var tmp = new $animateToNextPageCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function animateToPreviousPage(_this__u8e3s4, $completion) {
    var tmp = new $animateToPreviousPageCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function UnitDensity$1() {
    this.cjm_1 = 1.0;
    this.djm_1 = 1.0;
  }
  protoOf(UnitDensity$1).u5e = function () {
    return this.cjm_1;
  };
  protoOf(UnitDensity$1).j5f = function () {
    return this.djm_1;
  };
  function EmptyLayoutInfo$1() {
    this.ejm_1 = 0;
    this.fjm_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.mapOf' call
    tmp.gjm_1 = emptyMap();
  }
  protoOf(EmptyLayoutInfo$1).h5e = function () {
    return this.ejm_1;
  };
  protoOf(EmptyLayoutInfo$1).i5e = function () {
    return this.fjm_1;
  };
  protoOf(EmptyLayoutInfo$1).sad = function () {
    return this.gjm_1;
  };
  protoOf(EmptyLayoutInfo$1).uad = function () {
  };
  function rememberPagerState$lambda($initialPage, $initialPageOffsetFraction, $pageCount) {
    return function () {
      return new DefaultPagerState($initialPage._v, $initialPageOffsetFraction._v, $pageCount);
    };
  }
  function animateScrollToPage$lambda($previousValue, $this_animateScrollToPage) {
    return function (currentValue, _unused_var__etf5q3) {
      var delta = currentValue - $previousValue._v;
      var consumed = $this_animateScrollToPage.bh7(delta);
      // Inline function 'androidx.compose.foundation.pager.debugLog' call
      if (false) {
        var tmp$ret$1 = 'Dispatched Delta=' + delta + ' Consumed=' + consumed;
        println('PagerState: ' + tmp$ret$1);
      }
      $previousValue._v = $previousValue._v + consumed;
      return Unit_instance;
    };
  }
  function $animateToNextPageCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.sjl_1 = _this__u8e3s4;
  }
  protoOf($animateToNextPageCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if ((this.sjl_1.zj9() + 1 | 0) < this.sjl_1.di2()) {
              this.n9_1 = 1;
              suspendResult = this.sjl_1.rjj(this.sjl_1.zj9() + 1 | 0, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $animateToPreviousPageCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bjm_1 = _this__u8e3s4;
  }
  protoOf($animateToPreviousPageCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if ((this.bjm_1.zj9() - 1 | 0) >= 0) {
              this.n9_1 = 1;
              suspendResult = this.bjm_1.rjj(this.bjm_1.zj9() - 1 | 0, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_PagerState_kt_v93qz4;
  function _init_properties_PagerState_kt__9pfij6() {
    if (!properties_initialized_PagerState_kt_v93qz4) {
      properties_initialized_PagerState_kt_v93qz4 = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      DefaultPositionThreshold = _Dp___init__impl__ms3zkb(56);
      UnitDensity = new UnitDensity$1();
      var tmp0_visiblePagesInfo = emptyList();
      var tmp1_orientation = Orientation_Horizontal_getInstance();
      var tmp3_measureResult = new EmptyLayoutInfo$1();
      var tmp4_coroutineScope = CoroutineScope_0(EmptyCoroutineContext_getInstance());
      var tmp5_density = get_UnitDensity();
      var tmp6_childConstraints = Constraints_0();
      EmptyLayoutInfo = new PagerMeasureResult(tmp0_visiblePagesInfo, 0, 0, 0, tmp1_orientation, 0, 0, false, 0, null, null, 0.0, 0, false, Start_instance, tmp3_measureResult, false, VOID, VOID, tmp4_coroutineScope, tmp5_density, tmp6_childConstraints);
      androidx_compose_foundation_pager_PagerState$stable = 0;
    }
  }
  var androidx_compose_foundation_relocation_BringIntoViewRequesterNode$stable;
  function funBringIntoViewRequester() {
    return new BringIntoViewRequesterImpl();
  }
  function bringIntoViewRequester(_this__u8e3s4, bringIntoViewRequester) {
    return _this__u8e3s4.d8v(new BringIntoViewRequesterElement(bringIntoViewRequester));
  }
  function disposeRequester($this) {
    var tmp = $this.vjm_1;
    if (tmp instanceof BringIntoViewRequesterImpl) {
      var tmp_0 = $this.vjm_1;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.minusAssign' call
      (tmp_0 instanceof BringIntoViewRequesterImpl ? tmp_0 : THROW_CCE()).xjm_1.g10($this);
    }
  }
  function BringIntoViewRequesterNode(requester) {
    Node.call(this);
    this.vjm_1 = requester;
    this.wjm_1 = false;
  }
  protoOf(BringIntoViewRequesterNode).b8w = function () {
    return this.wjm_1;
  };
  protoOf(BringIntoViewRequesterNode).f8w = function () {
    this.yjm(this.vjm_1);
  };
  protoOf(BringIntoViewRequesterNode).yjm = function (requester) {
    disposeRequester(this);
    if (requester instanceof BringIntoViewRequesterImpl) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
      requester.xjm_1.zz(this);
    }
    this.vjm_1 = requester;
  };
  protoOf(BringIntoViewRequesterNode).h8w = function () {
    disposeRequester(this);
  };
  function BringIntoViewRequesterImpl$bringIntoView$lambda($rect) {
    return function () {
      return $rect;
    };
  }
  function $bringIntoViewCOROUTINE$(_this__u8e3s4, rect, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hjn_1 = _this__u8e3s4;
    this.ijn_1 = rect;
  }
  protoOf($bringIntoViewCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var this_0 = this.hjn_1.xjm_1;
            this.jjn_1 = 0;
            var tmp_0 = this;
            var tmp_1 = this_0.b3e_1;
            tmp_0.kjn_1 = isArray(tmp_1) ? tmp_1 : THROW_CCE();
            this.ljn_1 = this_0.d3e_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.jjn_1 < this.ljn_1)) {
              this.n9_1 = 3;
              continue $sm;
            }

            var it = this.kjn_1[this.jjn_1];
            this.n9_1 = 2;
            suspendResult = bringIntoView(it, BringIntoViewRequesterImpl$bringIntoView$lambda(this.ijn_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.jjn_1 = this.jjn_1 + 1 | 0;
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function BringIntoViewRequesterImpl() {
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.xjm_1 = new MutableVector(tmp$ret$2, 0);
  }
  protoOf(BringIntoViewRequesterImpl).mjn = function (rect, $completion) {
    var tmp = new $bringIntoViewCOROUTINE$(this, rect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function BringIntoViewRequesterElement(requester) {
    ModifierNodeElement.call(this);
    this.ojn_1 = requester;
  }
  protoOf(BringIntoViewRequesterElement).r3d = function () {
    return new BringIntoViewRequesterNode(this.ojn_1);
  };
  protoOf(BringIntoViewRequesterElement).pjn = function (node) {
    node.yjm(this.ojn_1);
  };
  protoOf(BringIntoViewRequesterElement).d8y = function (node) {
    return this.pjn(node instanceof BringIntoViewRequesterNode ? node : THROW_CCE());
  };
  protoOf(BringIntoViewRequesterElement).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof BringIntoViewRequesterElement) {
        tmp_0 = equals(this.ojn_1, other.ojn_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(BringIntoViewRequesterElement).hashCode = function () {
    return hashCode(this.ojn_1);
  };
  var androidx_compose_foundation_relocation_BringIntoViewResponderNode$stable;
  function BringIntoViewResponderNode$bringIntoView$localRect$ref(this$0, $childCoordinates, $boundsProvider) {
    return constructCallableReference(function () {
      return bringIntoView$localRect(this$0, $childCoordinates, $boundsProvider);
    }, 0, 0, 306, 'localRect', [this$0, $childCoordinates, $boundsProvider]);
  }
  function BringIntoViewResponderNode$bringIntoView$slambda$slambda(this$0, $childCoordinates, $boundsProvider, resultContinuation) {
    this.yjn_1 = this$0;
    this.zjn_1 = $childCoordinates;
    this.ajo_1 = $boundsProvider;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.yjn_1.qjo_1;
            suspendResult = tmp_0.bgi(BringIntoViewResponderNode$bringIntoView$localRect$ref(this.yjn_1, this.zjn_1, this.ajo_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new BringIntoViewResponderNode$bringIntoView$slambda$slambda(this.yjn_1, this.zjn_1, this.ajo_1, completion);
    i.bjo_1 = $this$launch;
    return i;
  };
  function BringIntoViewResponderNode$bringIntoView$slambda$slambda_0(this$0, $childCoordinates, $boundsProvider, resultContinuation) {
    var i = new BringIntoViewResponderNode$bringIntoView$slambda$slambda(this$0, $childCoordinates, $boundsProvider, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function BringIntoViewResponderNode$bringIntoView$slambda$slambda_1(this$0, $parentRect, resultContinuation) {
    this.bjp_1 = this$0;
    this.cjp_1 = $parentRect;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = bringIntoView(this.bjp_1, this.cjp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda$slambda_1).q24 = function ($this$launch, completion) {
    var i = new BringIntoViewResponderNode$bringIntoView$slambda$slambda_1(this.bjp_1, this.cjp_1, completion);
    i.djp_1 = $this$launch;
    return i;
  };
  function BringIntoViewResponderNode$bringIntoView$slambda$slambda_2(this$0, $parentRect, resultContinuation) {
    var i = new BringIntoViewResponderNode$bringIntoView$slambda$slambda_1(this$0, $parentRect, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function bringIntoView$localRect(this$0, $childCoordinates, $boundsProvider) {
    if (!this$0.z8v_1)
      return null;
    if (!this$0.sjo_1)
      return null;
    var layoutCoordinates = requireLayoutCoordinates(this$0);
    // Inline function 'kotlin.takeIf' call
    var tmp;
    if ($childCoordinates.y91()) {
      tmp = $childCoordinates;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var childCoordinates = tmp_0;
    var tmp1_elvis_lhs = $boundsProvider();
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var rect = tmp_1;
    return localRectOf(layoutCoordinates, childCoordinates, rect);
  }
  function BringIntoViewResponderNode$bringIntoView$lambda(this$0, $childCoordinates, $boundsProvider) {
    return function () {
      var tmp0_safe_receiver = bringIntoView$localRect(this$0, $childCoordinates, $boundsProvider);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = this$0.qjo_1.agi(tmp0_safe_receiver);
      }
      return tmp;
    };
  }
  function BringIntoViewResponderNode$bringIntoView$slambda(this$0, $childCoordinates, $boundsProvider, $parentRect, resultContinuation) {
    this.mjp_1 = this$0;
    this.njp_1 = $childCoordinates;
    this.ojp_1 = $boundsProvider;
    this.pjp_1 = $parentRect;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda).rjp = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda).ja = function (p1, $completion) {
    return this.rjp((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          launch(this.qjp_1, VOID, VOID, BringIntoViewResponderNode$bringIntoView$slambda$slambda_0(this.mjp_1, this.njp_1, this.ojp_1, null));
          return launch(this.qjp_1, VOID, VOID, BringIntoViewResponderNode$bringIntoView$slambda$slambda_2(this.mjp_1, this.pjp_1, null));
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(BringIntoViewResponderNode$bringIntoView$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new BringIntoViewResponderNode$bringIntoView$slambda(this.mjp_1, this.njp_1, this.ojp_1, this.pjp_1, completion);
    i.qjp_1 = $this$coroutineScope;
    return i;
  };
  function BringIntoViewResponderNode$bringIntoView$slambda_0(this$0, $childCoordinates, $boundsProvider, $parentRect, resultContinuation) {
    var i = new BringIntoViewResponderNode$bringIntoView$slambda(this$0, $childCoordinates, $boundsProvider, $parentRect, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.rjp($this$coroutineScope, $completion);
    }, 1);
  }
  function $bringIntoViewCOROUTINE$_0(_this__u8e3s4, childCoordinates, boundsProvider, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ajq_1 = _this__u8e3s4;
    this.bjq_1 = childCoordinates;
    this.cjq_1 = boundsProvider;
  }
  protoOf($bringIntoViewCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var parentRect = BringIntoViewResponderNode$bringIntoView$lambda(this.ajq_1, this.bjq_1, this.cjq_1);
            this.n9_1 = 1;
            suspendResult = coroutineScope(BringIntoViewResponderNode$bringIntoView$slambda_0(this.ajq_1, this.bjq_1, this.cjq_1, parentRect, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function BringIntoViewResponderNode(responder) {
    Node.call(this);
    this.qjo_1 = responder;
    this.rjo_1 = false;
    this.sjo_1 = false;
  }
  protoOf(BringIntoViewResponderNode).b8w = function () {
    return this.rjo_1;
  };
  protoOf(BringIntoViewResponderNode).x91 = function (coordinates) {
    this.sjo_1 = true;
  };
  protoOf(BringIntoViewResponderNode).jbr = function (childCoordinates, boundsProvider, $completion) {
    var tmp = new $bringIntoViewCOROUTINE$_0(this, childCoordinates, boundsProvider, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function localRectOf(_this__u8e3s4, sourceCoordinates, rect) {
    var localRect = _this__u8e3s4.x9h(sourceCoordinates, false);
    return rect.p5d(localRect.s5d());
  }
  function selectable(_this__u8e3s4, selected, interactionSource, indication_0, enabled, role, onClick) {
    enabled = enabled === VOID ? true : enabled;
    role = role === VOID ? null : role;
    // Inline function 'androidx.compose.foundation.clickableWithIndicationIfNeeded' call
    var tmp;
    if (!(indication_0 == null) ? isInterface(indication_0, IndicationNodeFactory) : false) {
      tmp = new SelectableElement(selected, interactionSource, indication_0, false, enabled, role, onClick);
    } else {
      if (indication_0 == null) {
        tmp = new SelectableElement(selected, interactionSource, null, false, enabled, role, onClick);
      } else {
        if (!(interactionSource == null)) {
          var tmp_0 = indication(Companion_instance_0, interactionSource, indication_0);
          var tmp$ret$3 = new SelectableElement(selected, interactionSource, null, false, enabled, role, onClick);
          tmp = tmp_0.d8v(tmp$ret$3);
        } else {
          var tmp_1 = Companion_instance_0;
          tmp = composed(tmp_1, VOID, selectable$lambda(indication_0, selected, enabled, role, onClick));
        }
      }
    }
    return _this__u8e3s4.d8v(tmp);
  }
  function SelectableElement(selected, interactionSource, indicationNodeFactory, useLocalIndication, enabled, role, onClick) {
    ModifierNodeElement.call(this);
    this.ejq_1 = selected;
    this.fjq_1 = interactionSource;
    this.gjq_1 = indicationNodeFactory;
    this.hjq_1 = useLocalIndication;
    this.ijq_1 = enabled;
    this.jjq_1 = role;
    this.kjq_1 = onClick;
  }
  protoOf(SelectableElement).r3d = function () {
    return new SelectableNode(this.ejq_1, this.fjq_1, this.gjq_1, this.hjq_1, this.ijq_1, this.jjq_1, this.kjq_1);
  };
  protoOf(SelectableElement).ljq = function (node) {
    node.cjs(this.ejq_1, this.fjq_1, this.gjq_1, this.hjq_1, this.ijq_1, this.jjq_1, this.kjq_1);
  };
  protoOf(SelectableElement).d8y = function (node) {
    return this.ljq(node instanceof SelectableNode ? node : THROW_CCE());
  };
  protoOf(SelectableElement).equals = function (other) {
    if (this === other)
      return true;
    if (other === null)
      return false;
    if (!getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof SelectableElement))
      THROW_CCE();
    if (!(this.ejq_1 === other.ejq_1))
      return false;
    if (!equals(this.fjq_1, other.fjq_1))
      return false;
    if (!equals(this.gjq_1, other.gjq_1))
      return false;
    if (!(this.hjq_1 === other.hjq_1))
      return false;
    if (!(this.ijq_1 === other.ijq_1))
      return false;
    var tmp = this.jjq_1;
    var tmp_0 = tmp == null ? null : new Role(tmp);
    var tmp_1 = other.jjq_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new Role(tmp_1)))
      return false;
    if (!(this.kjq_1 === other.kjq_1))
      return false;
    return true;
  };
  protoOf(SelectableElement).hashCode = function () {
    var result = getBooleanHashCode(this.ejq_1);
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.fjq_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.gjq_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    result = imul(31, result) + getBooleanHashCode(this.hjq_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.ijq_1) | 0;
    var tmp_1 = imul(31, result);
    var tmp4_safe_receiver = this.jjq_1;
    var tmp_2;
    var tmp_3 = tmp4_safe_receiver;
    if ((tmp_3 == null ? null : new Role(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      tmp_2 = Role__hashCode_impl_ucjza4(tmp4_safe_receiver);
    }
    var tmp5_elvis_lhs = tmp_2;
    result = tmp_1 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    result = imul(31, result) + hashCode(this.kjq_1) | 0;
    return result;
  };
  function SelectableNode(selected, interactionSource, indicationNodeFactory, useLocalIndication, enabled, role, onClick) {
    ClickableNode.call(this, interactionSource, indicationNodeFactory, useLocalIndication, enabled, null, role, onClick);
    this.bjs_1 = selected;
  }
  protoOf(SelectableNode).cjs = function (selected, interactionSource, indicationNodeFactory, useLocalIndication, enabled, role, onClick) {
    if (!(this.bjs_1 === selected)) {
      this.bjs_1 = selected;
      invalidateSemantics(this);
    }
    protoOf(ClickableNode).rfe.call(this, interactionSource, indicationNodeFactory, useLocalIndication, enabled, null, role, onClick);
  };
  protoOf(SelectableNode).efh = function (_this__u8e3s4) {
    set_selected(_this__u8e3s4, this.bjs_1);
  };
  function selectable$lambda($indication, $selected, $enabled, $role, $onClick) {
    return function ($this$composed, $composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(-1525724089);
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = funMutableInteractionSource();
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var newInteractionSource = tmp;
      var tmp_0 = indication(Companion_instance_0, newInteractionSource, $indication);
      var tmp$ret$4 = new SelectableElement($selected, newInteractionSource, null, false, $enabled, $role, $onClick);
      var tmp0 = tmp_0.d8v(tmp$ret$4);
      $composer_0.n30();
      return tmp0;
    };
  }
  function selectableGroup_0(_this__u8e3s4) {
    return semantics(_this__u8e3s4, VOID, selectableGroup$lambda);
  }
  function selectableGroup$lambda($this$semantics) {
    selectableGroup($this$semantics);
    return Unit_instance;
  }
  function triStateToggleable(_this__u8e3s4, state, interactionSource, indication_0, enabled, role, onClick) {
    enabled = enabled === VOID ? true : enabled;
    role = role === VOID ? null : role;
    // Inline function 'androidx.compose.foundation.clickableWithIndicationIfNeeded' call
    var tmp;
    if (!(indication_0 == null) ? isInterface(indication_0, IndicationNodeFactory) : false) {
      tmp = new TriStateToggleableElement(state, interactionSource, indication_0, false, enabled, role, onClick);
    } else {
      if (indication_0 == null) {
        tmp = new TriStateToggleableElement(state, interactionSource, null, false, enabled, role, onClick);
      } else {
        if (!(interactionSource == null)) {
          var tmp_0 = indication(Companion_instance_0, interactionSource, indication_0);
          var tmp$ret$3 = new TriStateToggleableElement(state, interactionSource, null, false, enabled, role, onClick);
          tmp = tmp_0.d8v(tmp$ret$3);
        } else {
          var tmp_1 = Companion_instance_0;
          tmp = composed(tmp_1, VOID, triStateToggleable$lambda(indication_0, state, enabled, role, onClick));
        }
      }
    }
    return _this__u8e3s4.d8v(tmp);
  }
  function TriStateToggleableElement(state, interactionSource, indicationNodeFactory, useLocalIndication, enabled, role, onClick) {
    ModifierNodeElement.call(this);
    this.ejs_1 = state;
    this.fjs_1 = interactionSource;
    this.gjs_1 = indicationNodeFactory;
    this.hjs_1 = useLocalIndication;
    this.ijs_1 = enabled;
    this.jjs_1 = role;
    this.kjs_1 = onClick;
  }
  protoOf(TriStateToggleableElement).r3d = function () {
    return new TriStateToggleableNode(this.ejs_1, this.fjs_1, this.gjs_1, this.hjs_1, this.ijs_1, this.jjs_1, this.kjs_1);
  };
  protoOf(TriStateToggleableElement).ljs = function (node) {
    node.cju(this.ejs_1, this.fjs_1, this.gjs_1, this.hjs_1, this.ijs_1, this.jjs_1, this.kjs_1);
  };
  protoOf(TriStateToggleableElement).d8y = function (node) {
    return this.ljs(node instanceof TriStateToggleableNode ? node : THROW_CCE());
  };
  protoOf(TriStateToggleableElement).equals = function (other) {
    if (this === other)
      return true;
    if (other === null)
      return false;
    if (!getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof TriStateToggleableElement))
      THROW_CCE();
    if (!this.ejs_1.equals(other.ejs_1))
      return false;
    if (!equals(this.fjs_1, other.fjs_1))
      return false;
    if (!equals(this.gjs_1, other.gjs_1))
      return false;
    if (!(this.hjs_1 === other.hjs_1))
      return false;
    if (!(this.ijs_1 === other.ijs_1))
      return false;
    var tmp = this.jjs_1;
    var tmp_0 = tmp == null ? null : new Role(tmp);
    var tmp_1 = other.jjs_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new Role(tmp_1)))
      return false;
    if (!(this.kjs_1 === other.kjs_1))
      return false;
    return true;
  };
  protoOf(TriStateToggleableElement).hashCode = function () {
    var result = this.ejs_1.hashCode();
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.fjs_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.gjs_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    result = imul(31, result) + getBooleanHashCode(this.hjs_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.ijs_1) | 0;
    var tmp_1 = imul(31, result);
    var tmp4_safe_receiver = this.jjs_1;
    var tmp_2;
    var tmp_3 = tmp4_safe_receiver;
    if ((tmp_3 == null ? null : new Role(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      tmp_2 = Role__hashCode_impl_ucjza4(tmp4_safe_receiver);
    }
    var tmp5_elvis_lhs = tmp_2;
    result = tmp_1 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    result = imul(31, result) + hashCode(this.kjs_1) | 0;
    return result;
  };
  function TriStateToggleableNode$applyAdditionalSemantics$lambda($this_applyAdditionalSemantics) {
    return function (fillableData) {
      var tmp0_safe_receiver = fillableData.u8y();
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        set_toggleableState($this_applyAdditionalSemantics, ToggleableState(tmp0_safe_receiver));
        tmp = true;
      }
      var tmp1_elvis_lhs = tmp;
      return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    };
  }
  function TriStateToggleableNode(state, interactionSource, indicationNodeFactory, useLocalIndication, enabled, role, onClick) {
    ClickableNode.call(this, interactionSource, indicationNodeFactory, useLocalIndication, enabled, null, role, onClick);
    this.bju_1 = state;
  }
  protoOf(TriStateToggleableNode).cju = function (state, interactionSource, indicationNodeFactory, useLocalIndication, enabled, role, onClick) {
    if (!this.bju_1.equals(state)) {
      this.bju_1 = state;
      invalidateSemantics(this);
    }
    protoOf(ClickableNode).rfe.call(this, interactionSource, indicationNodeFactory, useLocalIndication, enabled, null, role, onClick);
  };
  protoOf(TriStateToggleableNode).efh = function (_this__u8e3s4) {
    set_toggleableState(_this__u8e3s4, this.bju_1);
    set_contentDataType(_this__u8e3s4, Companion_getInstance_27().yc2_1);
    var tmp0_safe_receiver = createFromBoolean(Companion_instance_5, !this.bju_1.equals(ToggleableState_Indeterminate_getInstance()));
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      set_fillableData(_this__u8e3s4, tmp0_safe_receiver);
    }
    onFillData(_this__u8e3s4, VOID, TriStateToggleableNode$applyAdditionalSemantics$lambda(_this__u8e3s4));
  };
  function triStateToggleable$lambda($indication, $state, $enabled, $role, $onClick) {
    return function ($this$composed, $composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(-1525724089);
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = funMutableInteractionSource();
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var newInteractionSource = tmp;
      var tmp_0 = indication(Companion_instance_0, newInteractionSource, $indication);
      var tmp$ret$4 = new TriStateToggleableElement($state, newInteractionSource, null, false, $enabled, $role, $onClick);
      var tmp0 = tmp_0.d8v(tmp$ret$4);
      $composer_0.n30();
      return tmp0;
    };
  }
  var androidx_compose_foundation_shape_AbsoluteCutCornerShape$stable;
  var androidx_compose_foundation_shape_AbsoluteRoundedCornerShape$stable;
  var androidx_compose_foundation_shape_CornerBasedShape$stable;
  function CornerBasedShape(topStart, topEnd, bottomEnd, bottomStart) {
    this.dju_1 = topStart;
    this.eju_1 = topEnd;
    this.fju_1 = bottomEnd;
    this.gju_1 = bottomStart;
  }
  protoOf(CornerBasedShape).l6j = function (size, layoutDirection, density) {
    var topStart = this.dju_1.hju(size, density);
    var topEnd = this.eju_1.hju(size, density);
    var bottomEnd = this.fju_1.hju(size, density);
    var bottomStart = this.gju_1.hju(size, density);
    var minDimension = _Size___get_minDimension__impl__4iso0r(size);
    if (topStart + bottomStart > minDimension) {
      var scale = minDimension / (topStart + bottomStart);
      topStart = topStart * scale;
      bottomStart = bottomStart * scale;
    }
    if (topEnd + bottomEnd > minDimension) {
      var scale_0 = minDimension / (topEnd + bottomEnd);
      topEnd = topEnd * scale_0;
      bottomEnd = bottomEnd * scale_0;
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(topStart >= 0.0 && topEnd >= 0.0 && bottomEnd >= 0.0 && bottomStart >= 0.0)) {
      var tmp$ret$1 = "Corner size in Px can't be negative(topStart = " + topStart + ', topEnd = ' + topEnd + ', ' + ('bottomEnd = ' + bottomEnd + ', bottomStart = ' + bottomStart + ')!');
      throwIllegalArgumentException(tmp$ret$1);
    }
    return this.iju(size, topStart, topEnd, bottomEnd, bottomStart, layoutDirection);
  };
  protoOf(CornerBasedShape).kju = function (topStart, topEnd, bottomEnd, bottomStart, $super) {
    topStart = topStart === VOID ? this.dju_1 : topStart;
    topEnd = topEnd === VOID ? this.eju_1 : topEnd;
    bottomEnd = bottomEnd === VOID ? this.fju_1 : bottomEnd;
    bottomStart = bottomStart === VOID ? this.gju_1 : bottomStart;
    return $super === VOID ? this.jju(topStart, topEnd, bottomEnd, bottomStart) : $super.jju.call(this, topStart, topEnd, bottomEnd, bottomStart);
  };
  protoOf(CornerBasedShape).h6b = function (other, t) {
    return null;
  };
  var ZeroCornerSize;
  function CornerSize(percent) {
    _init_properties_CornerSize_kt__adzyne();
    return new PercentCornerSize(percent);
  }
  function CornerSize_0(size) {
    _init_properties_CornerSize_kt__adzyne();
    return new DpCornerSize(size);
  }
  function PercentCornerSize(percent) {
    this.lju_1 = percent;
    if (this.lju_1 < 0 || this.lju_1 > 100) {
      throwIllegalArgumentException('The percent should be in the range of [0, 100]');
    }
  }
  protoOf(PercentCornerSize).hju = function (shapeSize, density) {
    return _Size___get_minDimension__impl__4iso0r(shapeSize) * (this.lju_1 / 100.0);
  };
  protoOf(PercentCornerSize).toString = function () {
    return 'CornerSize(size = ' + this.lju_1 + '%)';
  };
  protoOf(PercentCornerSize).hashCode = function () {
    return getNumberHashCode(this.lju_1);
  };
  protoOf(PercentCornerSize).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PercentCornerSize))
      return false;
    if (!equals(this.lju_1, other.lju_1))
      return false;
    return true;
  };
  function DpCornerSize(size) {
    this.mju_1 = size;
  }
  protoOf(DpCornerSize).hju = function (shapeSize, density) {
    // Inline function 'kotlin.with' call
    return density.v5e(this.mju_1);
  };
  protoOf(DpCornerSize).toString = function () {
    return 'CornerSize(size = ' + _Dp___get_value__impl__geb1vb(this.mju_1) + '.dp)';
  };
  protoOf(DpCornerSize).hashCode = function () {
    return Dp__hashCode_impl_sxkrra(this.mju_1);
  };
  protoOf(DpCornerSize).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DpCornerSize))
      return false;
    if (!equals(this.mju_1, other.mju_1))
      return false;
    return true;
  };
  function CornerSize_1(size) {
    _init_properties_CornerSize_kt__adzyne();
    return new PxCornerSize(size);
  }
  function PxCornerSize(size) {
    this.nju_1 = size;
  }
  protoOf(PxCornerSize).hju = function (shapeSize, density) {
    return this.nju_1;
  };
  protoOf(PxCornerSize).toString = function () {
    return 'CornerSize(size = ' + this.nju_1 + '.px)';
  };
  protoOf(PxCornerSize).hashCode = function () {
    return getNumberHashCode(this.nju_1);
  };
  protoOf(PxCornerSize).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PxCornerSize))
      return false;
    if (!equals(this.nju_1, other.nju_1))
      return false;
    return true;
  };
  function ZeroCornerSize$1() {
  }
  protoOf(ZeroCornerSize$1).hju = function (shapeSize, density) {
    return 0.0;
  };
  protoOf(ZeroCornerSize$1).toString = function () {
    return 'ZeroCornerSize';
  };
  var properties_initialized_CornerSize_kt_9yvmfc;
  function _init_properties_CornerSize_kt__adzyne() {
    if (!properties_initialized_CornerSize_kt_9yvmfc) {
      properties_initialized_CornerSize_kt_9yvmfc = true;
      ZeroCornerSize = new ZeroCornerSize$1();
    }
  }
  var androidx_compose_foundation_shape_CutCornerShape$stable;
  var androidx_compose_foundation_shape_GenericShape$stable;
  function get_CircleShape() {
    _init_properties_RoundedCornerShape_kt__vzposf();
    return CircleShape;
  }
  var CircleShape;
  var androidx_compose_foundation_shape_RoundedCornerShape$stable;
  function RoundedCornerShape(topStart, topEnd, bottomEnd, bottomStart) {
    CornerBasedShape.call(this, topStart, topEnd, bottomEnd, bottomStart);
  }
  protoOf(RoundedCornerShape).iju = function (size, topStart, topEnd, bottomEnd, bottomStart, layoutDirection) {
    var tmp;
    if (topStart + topEnd + bottomEnd + bottomStart === 0.0) {
      tmp = new Rectangle(toRect(size));
    } else {
      var tmp_0 = toRect(size);
      // Inline function 'androidx.compose.ui.geometry.CornerRadius' call
      var x = layoutDirection.equals(LayoutDirection_Ltr_getInstance()) ? topStart : topEnd;
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1 = fromInt(toRawBits(x));
      var v2 = fromInt(toRawBits(x));
      var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var tmp_1 = _CornerRadius___init__impl__ojmabe(tmp$ret$1);
      // Inline function 'androidx.compose.ui.geometry.CornerRadius' call
      var x_0 = layoutDirection.equals(LayoutDirection_Ltr_getInstance()) ? topEnd : topStart;
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1_0 = fromInt(toRawBits(x_0));
      var v2_0 = fromInt(toRawBits(x_0));
      var tmp$ret$3 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
      var tmp_2 = _CornerRadius___init__impl__ojmabe(tmp$ret$3);
      // Inline function 'androidx.compose.ui.geometry.CornerRadius' call
      var x_1 = layoutDirection.equals(LayoutDirection_Ltr_getInstance()) ? bottomEnd : bottomStart;
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1_1 = fromInt(toRawBits(x_1));
      var v2_1 = fromInt(toRawBits(x_1));
      var tmp$ret$5 = bitwiseOr(shiftLeft(v1_1, 32), bitwiseAnd(v2_1, new Long(-1, 0)));
      var tmp_3 = _CornerRadius___init__impl__ojmabe(tmp$ret$5);
      // Inline function 'androidx.compose.ui.geometry.CornerRadius' call
      var x_2 = layoutDirection.equals(LayoutDirection_Ltr_getInstance()) ? bottomStart : bottomEnd;
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1_2 = fromInt(toRawBits(x_2));
      var v2_2 = fromInt(toRawBits(x_2));
      var tmp$ret$7 = bitwiseOr(shiftLeft(v1_2, 32), bitwiseAnd(v2_2, new Long(-1, 0)));
      var tmp$ret$6 = _CornerRadius___init__impl__ojmabe(tmp$ret$7);
      tmp = new Rounded(RoundRect_0(tmp_0, tmp_1, tmp_2, tmp_3, tmp$ret$6));
    }
    return tmp;
  };
  protoOf(RoundedCornerShape).jju = function (topStart, topEnd, bottomEnd, bottomStart) {
    return new RoundedCornerShape(topStart, topEnd, bottomEnd, bottomStart);
  };
  protoOf(RoundedCornerShape).toString = function () {
    return 'RoundedCornerShape(topStart = ' + toString(this.dju_1) + ', topEnd = ' + toString(this.eju_1) + ', bottomEnd = ' + (toString(this.fju_1) + ', bottomStart = ' + toString(this.gju_1) + ')');
  };
  protoOf(RoundedCornerShape).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoundedCornerShape))
      return false;
    if (!equals(this.dju_1, other.dju_1))
      return false;
    if (!equals(this.eju_1, other.eju_1))
      return false;
    if (!equals(this.fju_1, other.fju_1))
      return false;
    if (!equals(this.gju_1, other.gju_1))
      return false;
    return true;
  };
  protoOf(RoundedCornerShape).hashCode = function () {
    var result = hashCode(this.dju_1);
    result = imul(31, result) + hashCode(this.eju_1) | 0;
    result = imul(31, result) + hashCode(this.fju_1) | 0;
    result = imul(31, result) + hashCode(this.gju_1) | 0;
    return result;
  };
  protoOf(RoundedCornerShape).h6b = function (other, t) {
    var other_0 = other;
    if (equals(other_0, get_RectangleShape()) || other_0 == null) {
      other_0 = RoundedCornerShape_3(0.0);
    }
    if (other_0 instanceof RoundedCornerShape) {
      return lerp_4(this, other_0, t);
    }
    return null;
  };
  function RoundedCornerShape_0(size) {
    _init_properties_RoundedCornerShape_kt__vzposf();
    return RoundedCornerShape_4(CornerSize_0(size));
  }
  function RoundedCornerShape_1(topStart, topEnd, bottomEnd, bottomStart) {
    var tmp;
    if (topStart === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp = topStart;
    }
    topStart = tmp;
    var tmp_0;
    if (topEnd === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_0 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_0 = topEnd;
    }
    topEnd = tmp_0;
    var tmp_1;
    if (bottomEnd === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_1 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_1 = bottomEnd;
    }
    bottomEnd = tmp_1;
    var tmp_2;
    if (bottomStart === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_2 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_2 = bottomStart;
    }
    bottomStart = tmp_2;
    _init_properties_RoundedCornerShape_kt__vzposf();
    return new RoundedCornerShape(CornerSize_0(topStart), CornerSize_0(topEnd), CornerSize_0(bottomEnd), CornerSize_0(bottomStart));
  }
  function RoundedCornerShape_2(percent) {
    _init_properties_RoundedCornerShape_kt__vzposf();
    return RoundedCornerShape_4(CornerSize(percent));
  }
  function RoundedCornerShape_3(size) {
    _init_properties_RoundedCornerShape_kt__vzposf();
    return RoundedCornerShape_4(CornerSize_1(size));
  }
  function lerp_4(a, b, t) {
    _init_properties_RoundedCornerShape_kt__vzposf();
    return new RoundedCornerShape(lerp_5(a.dju_1, b.dju_1, t), lerp_5(a.eju_1, b.eju_1, t), lerp_5(a.fju_1, b.fju_1, t), lerp_5(a.gju_1, b.gju_1, t));
  }
  function RoundedCornerShape_4(corner) {
    _init_properties_RoundedCornerShape_kt__vzposf();
    return new RoundedCornerShape(corner, corner, corner, corner);
  }
  function lerp_5(a, b, t) {
    _init_properties_RoundedCornerShape_kt__vzposf();
    return new lerp$1(a, b, t);
  }
  function lerp$1($a, $b, $t) {
    this.sju_1 = $a;
    this.tju_1 = $b;
    this.uju_1 = $t;
  }
  protoOf(lerp$1).hju = function (shapeSize, density) {
    return lerp(this.sju_1.hju(shapeSize, density), this.tju_1.hju(shapeSize, density), this.uju_1);
  };
  var properties_initialized_RoundedCornerShape_kt_5mose9;
  function _init_properties_RoundedCornerShape_kt__vzposf() {
    if (!properties_initialized_RoundedCornerShape_kt_5mose9) {
      properties_initialized_RoundedCornerShape_kt_5mose9 = true;
      CircleShape = RoundedCornerShape_2(50);
      androidx_compose_foundation_shape_RoundedCornerShape$stable = 0;
    }
  }
  var DefaultSpringSpec;
  function get_EmptyResolvedStyle() {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    return EmptyResolvedStyle;
  }
  var EmptyResolvedStyle;
  var TextDefaultsResolvedStyle;
  var androidx_compose_foundation_style_ResolvedStyle$stable;
  function ResolvedStyle() {
    this.vju_1 = 0;
    this.wju_1 = 0;
    this.xju_1 = null;
    this.yju_1 = 0;
    this.zju_1 = 1.0;
    this.ajv_1 = 1.0;
    this.bjv_1 = false;
    this.cjv_1 = null;
    this.djv_1 = 0.0;
    this.ejv_1 = 0.0;
    this.fjv_1 = 0.0;
    this.gjv_1 = 0.0;
    this.hjv_1 = 0.0;
    this.ijv_1 = 0.0;
    this.jjv_1 = 0.0;
    this.kjv_1 = 0.0;
    this.ljv_1 = 0.0;
    this.mjv_1 = NaN;
    this.njv_1 = NaN;
    this.ojv_1 = NaN;
    this.pjv_1 = NaN;
    this.qjv_1 = NaN;
    this.rjv_1 = NaN;
    this.sjv_1 = NaN;
    this.tjv_1 = NaN;
    this.ujv_1 = NaN;
    this.vjv_1 = NaN;
    this.wjv_1 = NaN;
    this.xjv_1 = NaN;
    this.yjv_1 = Companion_getInstance().i6b_1;
    this.zjv_1 = null;
    this.ajw_1 = Companion_getInstance().t6b_1;
    this.bjw_1 = null;
    this.cjw_1 = Companion_getInstance().u6b_1;
    this.djw_1 = null;
    this.ejw_1 = false;
    this.fjw_1 = get_RectangleShape();
    this.gjw_1 = 1.0;
    this.hjw_1 = 1.0;
    this.ijw_1 = 1.0;
    this.jjw_1 = 0.0;
    this.kjw_1 = 0.0;
    this.ljw_1 = 0.0;
    this.mjw_1 = 0.0;
    this.njw_1 = 0.0;
    this.ojw_1 = Companion_getInstance_28().f9i_1;
    this.pjw_1 = 1.0;
    this.qjw_1 = 0.0;
    this.rjw_1 = Companion_getInstance().u6b_1;
    this.sjw_1 = null;
    this.tjw_1 = null;
    this.ujw_1 = null;
    this.vjw_1 = Companion_getInstance_29().q5g_1;
    this.wjw_1 = Companion_getInstance_29().q5g_1;
    this.xjw_1 = Companion_getInstance_29().q5g_1;
    this.yjw_1 = Companion_getInstance_30().y7z_1;
    this.zjw_1 = Companion_getInstance_31().l7v_1;
    this.ajx_1 = 0;
    this.bjx_1 = null;
    this.cjx_1 = null;
  }
  protoOf(ResolvedStyle).djx = function (other, filterFlags) {
    var change = this.yju_1 ^ other.yju_1;
    var checkFor = this.yju_1 & other.yju_1 & filterFlags;
    if (!((checkFor & 1) === 0)) {
      if (!(this.djv_1 === other.djv_1) || !(this.ejv_1 === other.ejv_1) || !(this.fjv_1 === other.fjv_1) || !(this.gjv_1 === other.gjv_1) || !(this.ljv_1 === other.ljv_1)) {
        change = change | 1;
      }
    }
    if (!((checkFor & 8) === 0)) {
      if (!(this.mjv_1 === other.mjv_1) || !(this.njv_1 === other.njv_1) || !(this.ojv_1 === other.ojv_1) || !(this.pjv_1 === other.pjv_1) || !(this.hjv_1 === other.hjv_1) || !(this.ijv_1 === other.ijv_1) || !(this.jjv_1 === other.jjv_1) || !(this.kjv_1 === other.kjv_1) || !(toRawBits(this.qjv_1) === toRawBits(other.qjv_1)) || !(toRawBits(this.rjv_1) === toRawBits(other.rjv_1)) || !(toRawBits(this.sjv_1) === toRawBits(other.sjv_1)) || !(toRawBits(this.tjv_1) === toRawBits(other.tjv_1)) || !(toRawBits(this.wjv_1) === toRawBits(other.wjv_1)) || !(toRawBits(this.xjv_1) === toRawBits(other.xjv_1)) || !(toRawBits(this.ujv_1) === toRawBits(other.ujv_1)) || !(toRawBits(this.vjv_1) === toRawBits(other.vjv_1))) {
        change = change | 8;
      }
    }
    if (!((checkFor & 2) === 0)) {
      if (!(this.ljv_1 === other.ljv_1) || !equals(this.yjv_1, other.yjv_1) || !equals(this.zjv_1, other.zjv_1) || !equals(this.ajw_1, other.ajw_1) || !equals(this.bjw_1, other.bjw_1) || !equals(this.djw_1, other.djw_1) || !equals(this.cjx_1, other.cjx_1) || !equals(this.bjx_1, other.bjx_1) || !equals(this.fjw_1, other.fjw_1)) {
        change = change | 2;
      }
    }
    if (!((checkFor & 4) === 0)) {
      if (!(this.gjw_1 === other.gjw_1) || !(this.hjw_1 === other.hjw_1) || !(this.ijw_1 === other.ijw_1) || !(this.jjw_1 === other.jjw_1) || !(this.kjw_1 === other.kjw_1) || !(this.ljw_1 === other.ljw_1) || !(this.mjw_1 === other.mjw_1) || !(this.njw_1 === other.njw_1) || !equals(this.ojw_1, other.ojw_1) || !(this.ejw_1 === other.ejw_1)) {
        change = change | 4;
      }
    }
    if (!equals(this.fjw_1, other.fjw_1)) {
      change = change | 4 | 2;
    }
    if (!((checkFor & 64) === 0)) {
      if (!equals(this.rjw_1, other.rjw_1) || !equals(this.sjw_1, other.sjw_1)) {
        change = change | 64;
      }
    }
    if (!((checkFor & 32) === 0)) {
      if (!equals(this.tjw_1, other.tjw_1) || !equals(this.ujw_1, other.ujw_1) || !equals(this.vjw_1, other.vjw_1) || !equals(this.wjw_1, other.wjw_1) || !equals(this.xjw_1, other.xjw_1) || !equals(this.yjw_1, other.yjw_1) || !(this.zjw_1 === other.zjw_1) || !(this.ajx_1 === other.ajx_1)) {
        change = change | 32 | 64;
      }
    }
    return change;
  };
  protoOf(ResolvedStyle).ejx = function (target) {
    target.rjw_1 = this.rjw_1;
    target.sjw_1 = this.sjw_1;
    target.tjw_1 = this.tjw_1;
    target.ujw_1 = this.ujw_1;
    target.vjw_1 = this.vjw_1;
    target.wjw_1 = this.wjw_1;
    target.xjw_1 = this.xjw_1;
    target.yjw_1 = this.yjw_1;
    target.zjw_1 = this.zjw_1;
    target.ajx_1 = this.ajx_1;
  };
  protoOf(ResolvedStyle).fjx = function (target) {
    target.yju_1 = this.yju_1;
    target.qjv_1 = this.qjv_1;
    target.rjv_1 = this.rjv_1;
    target.sjv_1 = this.sjv_1;
    target.tjv_1 = this.tjv_1;
    target.ujv_1 = this.ujv_1;
    target.vjv_1 = this.vjv_1;
    target.wjv_1 = this.wjv_1;
    target.xjv_1 = this.xjv_1;
    target.djv_1 = this.djv_1;
    target.ejv_1 = this.ejv_1;
    target.fjv_1 = this.fjv_1;
    target.gjv_1 = this.gjv_1;
    target.hjv_1 = this.hjv_1;
    target.ijv_1 = this.ijv_1;
    target.jjv_1 = this.jjv_1;
    target.kjv_1 = this.kjv_1;
    target.ljv_1 = this.ljv_1;
    target.fjw_1 = this.fjw_1;
    target.gjw_1 = this.gjw_1;
    target.hjw_1 = this.hjw_1;
    target.ijw_1 = this.ijw_1;
    target.jjw_1 = this.jjw_1;
    target.kjw_1 = this.kjw_1;
    target.ljw_1 = this.ljw_1;
    target.mjw_1 = this.mjw_1;
    target.njw_1 = this.njw_1;
    target.ojw_1 = this.ojw_1;
    target.qjw_1 = this.qjw_1;
    target.pjw_1 = this.pjw_1;
    target.yjv_1 = this.yjv_1;
    target.zjv_1 = this.zjv_1;
    target.ajw_1 = this.ajw_1;
    target.bjw_1 = this.bjw_1;
    target.djw_1 = this.djw_1;
    target.bjx_1 = this.bjx_1;
    target.cjx_1 = this.cjx_1;
    target.ejw_1 = this.ejw_1;
    target.mjv_1 = this.mjv_1;
    target.njv_1 = this.njv_1;
    target.ojv_1 = this.ojv_1;
    target.pjv_1 = this.pjv_1;
    this.ejx(target);
  };
  protoOf(ResolvedStyle).gjx = function (style, node, density, animating) {
    this.hjx(node, density, animating);
    // Inline function 'kotlin.with' call
    style.ijx(this);
    this.jjx();
  };
  protoOf(ResolvedStyle).kjx = function (source) {
    var sourceTextFlags = source.yju_1 & 96;
    if (sourceTextFlags === 0)
      return Unit_instance;
    this.yju_1 = this.yju_1 | sourceTextFlags;
    var tmp = this;
    var tmp0 = source.rjw_1;
    // Inline function 'androidx.compose.foundation.style.takeOrElse' call
    var other = this.rjw_1;
    var tmp_0;
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    if (!equals(_Color___get_value__impl__1pls5m(tmp0), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      tmp_0 = tmp0;
    } else {
      tmp_0 = other;
    }
    tmp.rjw_1 = tmp_0;
    var tmp_1 = this;
    var tmp0_elvis_lhs = source.sjw_1;
    tmp_1.sjw_1 = tmp0_elvis_lhs == null ? this.sjw_1 : tmp0_elvis_lhs;
    var tmp_2 = this;
    var tmp1_elvis_lhs = source.tjw_1;
    tmp_2.tjw_1 = tmp1_elvis_lhs == null ? this.tjw_1 : tmp1_elvis_lhs;
    var tmp_3 = this;
    var tmp2_elvis_lhs = source.ujw_1;
    tmp_3.ujw_1 = tmp2_elvis_lhs == null ? this.ujw_1 : tmp2_elvis_lhs;
    var tmp_4 = this;
    var tmp0_0 = source.vjw_1;
    // Inline function 'androidx.compose.foundation.style.takeOrElse' call
    var other_0 = this.vjw_1;
    var tmp_5;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(tmp0_0), new Long(0, 0))) {
      tmp_5 = tmp0_0;
    } else {
      tmp_5 = other_0;
    }
    tmp_4.vjw_1 = tmp_5;
    var tmp_6 = this;
    var tmp0_1 = source.wjw_1;
    // Inline function 'androidx.compose.foundation.style.takeOrElse' call
    var other_1 = this.wjw_1;
    var tmp_7;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(tmp0_1), new Long(0, 0))) {
      tmp_7 = tmp0_1;
    } else {
      tmp_7 = other_1;
    }
    tmp_6.wjw_1 = tmp_7;
    var tmp_8 = this;
    var tmp0_2 = source.xjw_1;
    // Inline function 'androidx.compose.foundation.style.takeOrElse' call
    var other_2 = this.xjw_1;
    var tmp_9;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(tmp0_2), new Long(0, 0))) {
      tmp_9 = tmp0_2;
    } else {
      tmp_9 = other_2;
    }
    tmp_8.xjw_1 = tmp_9;
    var tmp_10 = this;
    var tmp0_3 = source.yjw_1;
    // Inline function 'androidx.compose.foundation.style.takeOrElse' call
    var other_3 = this.yjw_1;
    tmp_10.yjw_1 = equals(tmp0_3, Companion_getInstance_30().y7z_1) ? tmp0_3 : other_3;
    var tmp_11 = this;
    var tmp0_4 = source.zjw_1;
    // Inline function 'androidx.compose.foundation.style.takeOrElse' call
    var other_4 = this.zjw_1;
    var tmp_12;
    // Inline function 'androidx.compose.ui.text.style.isSpecified' call
    if (!(tmp0_4 === Companion_getInstance_31().l7v_1)) {
      tmp_12 = tmp0_4;
    } else {
      tmp_12 = other_4;
    }
    tmp_11.zjw_1 = tmp_12;
    var tmp_13 = this;
    var tmp0_5 = this.ajx_1;
    // Inline function 'androidx.compose.foundation.style.applyTextEnum' call
    var right = source.ajx_1;
    var left = tmp0_5;
    // Inline function 'androidx.compose.foundation.style.setBitsIfNonZero' call
    var left_0 = left;
    var rightBits = right & 3;
    left = left_0 & ~3 | (!(rightBits === 0) ? rightBits : left_0);
    // Inline function 'androidx.compose.foundation.style.setBitsIfNonZero' call
    var left_1 = left;
    var rightBits_0 = right & 28;
    left = left_1 & ~28 | (!(rightBits_0 === 0) ? rightBits_0 : left_1);
    // Inline function 'androidx.compose.foundation.style.setBitsIfNonZero' call
    var left_2 = left;
    var rightBits_1 = right & 112;
    left = left_2 & ~112 | (!(rightBits_1 === 0) ? rightBits_1 : left_2);
    // Inline function 'androidx.compose.foundation.style.setBitsIfNonZero' call
    var left_3 = left;
    var rightBits_2 = right & 768;
    left = left_3 & ~768 | (!(rightBits_2 === 0) ? rightBits_2 : left_3);
    // Inline function 'androidx.compose.foundation.style.setBitsIfNonZero' call
    var left_4 = left;
    var rightBits_3 = right & 15360;
    left = left_4 & ~15360 | (!(rightBits_3 === 0) ? rightBits_3 : left_4);
    // Inline function 'androidx.compose.foundation.style.setBitsIfNonZero' call
    var left_5 = left;
    var rightBits_4 = right & 134086656;
    left = left_5 & ~134086656 | (!(rightBits_4 === 0) ? rightBits_4 : left_5);
    tmp_13.ajx_1 = left;
  };
  protoOf(ResolvedStyle).ljx = function (fallback) {
    var default_0 = get_EmptyResolvedStyle();
    // Inline function 'androidx.compose.ui.graphics.takeOrElse' call
    var this_0 = this.rjw_1;
    var tmp;
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    if (!equals(_Color___get_value__impl__1pls5m(this_0), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      tmp = this_0;
    } else {
      tmp = fallback.s6c();
    }
    var tmp_0 = tmp;
    var tmp0 = this.vjw_1;
    // Inline function 'androidx.compose.foundation.style.takeOrElse' call
    var other = fallback.e82();
    var tmp_1;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(tmp0), new Long(0, 0))) {
      tmp_1 = tmp0;
    } else {
      tmp_1 = other;
    }
    var tmp_2 = tmp_1;
    var tmp_3 = this.njx() ? this.mjx() : fallback.f82();
    var tmp_4 = !(this.ojx() === default_0.ojx()) ? this.ojx() : fallback.g82();
    var tmp_5 = !(this.pjx() === default_0.pjx()) ? this.pjx() : fallback.h82();
    var tmp0_elvis_lhs = this.tjw_1;
    var tmp_6 = tmp0_elvis_lhs == null ? fallback.i82() : tmp0_elvis_lhs;
    var tmp_7 = fallback.j82();
    var tmp0_0 = this.xjw_1;
    // Inline function 'androidx.compose.foundation.style.takeOrElse' call
    var other_0 = fallback.k82();
    var tmp_8;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(tmp0_0), new Long(0, 0))) {
      tmp_8 = tmp0_0;
    } else {
      tmp_8 = other_0;
    }
    var tmp_9 = tmp_8;
    var tmp_10;
    // Inline function 'androidx.compose.ui.text.style.isSpecified' call
    var this_1 = this.yjw_1;
    if (!isNaN_0(_BaselineShift___get_multiplier__impl__qhmjek(this_1))) {
      tmp_10 = this.yjw_1;
    } else {
      tmp_10 = fallback.l82();
    }
    var tmp_11 = tmp_10;
    var tmp_12 = fallback.m82();
    var tmp_13 = fallback.n82();
    var tmp_14 = fallback.o82();
    var tmp_15 = !this.qjx().equals(default_0.qjx()) ? this.qjx() : fallback.r81();
    var tmp_16 = fallback.q81();
    var tmp_17 = fallback.s81();
    var tmp_18 = !(this.rjx() === default_0.rjx()) ? this.rjx() : fallback.p82();
    var tmp_19 = !(this.sjx() === default_0.sjx()) ? this.sjx() : fallback.q82();
    var tmp0_1 = this.wjw_1;
    // Inline function 'androidx.compose.foundation.style.takeOrElse' call
    var other_1 = fallback.r82();
    var tmp_20;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(tmp0_1), new Long(0, 0))) {
      tmp_20 = tmp0_1;
    } else {
      tmp_20 = other_1;
    }
    var tmp_21 = tmp_20;
    var tmp1_elvis_lhs = this.ujw_1;
    var tmp_22 = tmp1_elvis_lhs == null ? fallback.s82() : tmp1_elvis_lhs;
    var tmp_23 = fallback.t82();
    var tmp0_2 = this.zjw_1;
    // Inline function 'androidx.compose.foundation.style.takeOrElse' call
    var other_2 = fallback.v82();
    var tmp_24;
    // Inline function 'androidx.compose.ui.text.style.isSpecified' call
    if (!(tmp0_2 === Companion_getInstance_31().l7v_1)) {
      tmp_24 = tmp0_2;
    } else {
      tmp_24 = other_2;
    }
    var tmp$ret$13 = tmp_24;
    // Inline function 'kotlin.let' call
    var it = TextStyle_init_$Create$(tmp_0, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_9, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_21, tmp_22, fallback.x7u_1, tmp_23, tmp$ret$13, !(this.tjx() === default_0.tjx()) ? this.tjx() : fallback.u82(), fallback.w82());
    return !(this.sjw_1 == null) ? it.d82(this.sjw_1) : it;
  };
  protoOf(ResolvedStyle).u5e = function () {
    return this.zju_1;
  };
  protoOf(ResolvedStyle).j5f = function () {
    return this.ajv_1;
  };
  protoOf(ResolvedStyle).z3c = function (_this__u8e3s4) {
    return currentValueOf(ensureNotNull(this.cjv_1), _this__u8e3s4);
  };
  protoOf(ResolvedStyle).ojx = function () {
    // Inline function 'androidx.compose.foundation.style.getBits' call
    return ((this.ajx_1 & 3) >> 0 & 1) === 1 ? Companion_getInstance_32().l7z_1 : Companion_getInstance_32().k7z_1;
  };
  protoOf(ResolvedStyle).rjx = function () {
    var tmp = Companion_getInstance_18();
    // Inline function 'androidx.compose.foundation.style.getBits' call
    var tmp$ret$0 = (this.ajx_1 & 28) >> 2;
    return tmp.j8e(tmp$ret$0);
  };
  protoOf(ResolvedStyle).sjx = function () {
    var tmp = Companion_getInstance_33();
    // Inline function 'androidx.compose.foundation.style.getBits' call
    var tmp$ret$0 = (this.ajx_1 & 112) >> 4;
    return tmp.m8e(tmp$ret$0);
  };
  protoOf(ResolvedStyle).tjx = function () {
    var tmp = Companion_getInstance_34();
    // Inline function 'androidx.compose.foundation.style.getBits' call
    var tmp$ret$0 = (this.ajx_1 & 768) >> 8;
    return tmp.u8d(tmp$ret$0);
  };
  protoOf(ResolvedStyle).mjx = function () {
    // Inline function 'androidx.compose.foundation.style.getBits' call
    var tmp$ret$0 = (this.ajx_1 & 134086656) >> 17;
    return new FontWeight(tmp$ret$0);
  };
  protoOf(ResolvedStyle).njx = function () {
    // Inline function 'androidx.compose.foundation.style.getBits' call
    return !((this.ajx_1 & 134086656) >> 17 === 0);
  };
  protoOf(ResolvedStyle).pjx = function () {
    var tmp = Companion_getInstance_35();
    // Inline function 'androidx.compose.foundation.style.getBits' call
    var tmp$ret$0 = (this.ajx_1 & 15360) >> 10;
    return tmp.j88(tmp$ret$0 & 7);
  };
  protoOf(ResolvedStyle).qjx = function () {
    var tmp = Companion_getInstance_36();
    // Inline function 'androidx.compose.foundation.style.getBits' call
    var tmp$ret$0 = (this.ajx_1 & 114688) >> 14;
    return tmp.k8e(tmp$ret$0 & 3);
  };
  protoOf(ResolvedStyle).ujx = function (value) {
    this.yju_1 = this.yju_1 | 64;
    this.rjw_1 = value;
    this.sjw_1 = null;
  };
  protoOf(ResolvedStyle).vjx = function (value) {
    this.yju_1 = this.yju_1 | 64;
    var bits = 4 | value.k7x_1;
    this.ajx_1 = this.ajx_1 | bits << 14;
  };
  protoOf(ResolvedStyle).wjx = function (value) {
    this.yju_1 = this.yju_1 | 32;
    this.tjw_1 = value;
  };
  protoOf(ResolvedStyle).xjx = function (value) {
    this.yju_1 = this.yju_1 | 32;
    this.vjw_1 = value;
  };
  protoOf(ResolvedStyle).yjx = function (value) {
    this.yju_1 = this.yju_1 | 32;
    this.xjw_1 = value;
  };
  protoOf(ResolvedStyle).zjx = function (value) {
    this.yju_1 = this.yju_1 | 32;
    this.yjw_1 = value;
  };
  protoOf(ResolvedStyle).ajy = function (value) {
    this.yju_1 = this.yju_1 | 32;
    var tmp = this;
    // Inline function 'androidx.compose.foundation.style.setBits' call
    tmp.ajx_1 = this.ajx_1 & ~3 | (2 | _FontStyle___get_value__impl__gx8aaz(value)) << 0 & 3;
  };
  protoOf(ResolvedStyle).bjy = function (value) {
    this.yju_1 = this.yju_1 | 32;
    var tmp = this;
    // Inline function 'androidx.compose.foundation.style.setBits' call
    tmp.ajx_1 = this.ajx_1 & ~134086656 | value.p7x_1 << 17 & 134086656;
  };
  protoOf(ResolvedStyle).cjy = function (value) {
    this.yju_1 = this.yju_1 | 32;
    var bits = 8 | _FontSynthesis___get_value__impl__xrueqg(value) & 7;
    this.ajx_1 = this.ajx_1 | bits << 10;
  };
  protoOf(ResolvedStyle).hjx = function (node, density, animating) {
    this.wju_1 = 0;
    this.vju_1 = 0;
    this.cjv_1 = node;
    this.zju_1 = density.u5e();
    this.bjv_1 = animating;
  };
  protoOf(ResolvedStyle).jjx = function () {
    this.cjv_1 = null;
    this.bjv_1 = false;
  };
  function lerp_6(a, b, t, flags, result) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    var resultFlags = a.yju_1 | b.yju_1;
    result.yju_1 = resultFlags;
    var flagsToRun = resultFlags & flags;
    if (!((flagsToRun & 8) === 0)) {
      lerpOuterLayout(a, b, t, result);
    }
    if (!((flagsToRun & 1) === 0)) {
      lerpInnerLayout(a, b, t, result);
    }
    if (!((flagsToRun & 2) === 0)) {
      lerpDraw(a, b, t, result);
    }
    if (!((flagsToRun & 4) === 0)) {
      lerpLayer(a, b, t, result);
    }
    if (!((flagsToRun & 64) === 0)) {
      lerpTextDraw(a, b, t, result);
    }
    if (!((flagsToRun & 32) === 0)) {
      lerpTextLayout(a, b, t, result);
    }
  }
  function lerpOuterLayout(a, b, t, result) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    // Inline function 'kotlin.with' call
    var tmp = result;
    var tmp0 = a.hjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_0 = b.hjv_1;
    var aNan = isNaN_0(tmp0);
    var bNan = isNaN_0(b_0);
    var next = (1 - t) * tmp0 + t * b_0;
    tmp.hjv_1 = aNan ? b_0 : bNan ? tmp0 : next;
    var tmp_0 = result;
    var tmp0_0 = a.ijv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_1 = b.ijv_1;
    var aNan_0 = isNaN_0(tmp0_0);
    var bNan_0 = isNaN_0(b_1);
    var next_0 = (1 - t) * tmp0_0 + t * b_1;
    tmp_0.ijv_1 = aNan_0 ? b_1 : bNan_0 ? tmp0_0 : next_0;
    var tmp_1 = result;
    var tmp0_1 = a.jjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_2 = b.jjv_1;
    var aNan_1 = isNaN_0(tmp0_1);
    var bNan_1 = isNaN_0(b_2);
    var next_1 = (1 - t) * tmp0_1 + t * b_2;
    tmp_1.jjv_1 = aNan_1 ? b_2 : bNan_1 ? tmp0_1 : next_1;
    var tmp_2 = result;
    var tmp0_2 = a.kjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_3 = b.kjv_1;
    var aNan_2 = isNaN_0(tmp0_2);
    var bNan_2 = isNaN_0(b_3);
    var next_2 = (1 - t) * tmp0_2 + t * b_3;
    tmp_2.kjv_1 = aNan_2 ? b_3 : bNan_2 ? tmp0_2 : next_2;
    var tmp_3 = result;
    var tmp0_3 = a.qjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_4 = b.qjv_1;
    var aNan_3 = isNaN_0(tmp0_3);
    var bNan_3 = isNaN_0(b_4);
    var next_3 = (1 - t) * tmp0_3 + t * b_4;
    tmp_3.qjv_1 = aNan_3 ? b_4 : bNan_3 ? tmp0_3 : next_3;
    var tmp_4 = result;
    var tmp0_4 = a.rjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_5 = b.rjv_1;
    var aNan_4 = isNaN_0(tmp0_4);
    var bNan_4 = isNaN_0(b_5);
    var next_4 = (1 - t) * tmp0_4 + t * b_5;
    tmp_4.rjv_1 = aNan_4 ? b_5 : bNan_4 ? tmp0_4 : next_4;
    var tmp_5 = result;
    var tmp0_5 = a.sjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_6 = b.sjv_1;
    var aNan_5 = isNaN_0(tmp0_5);
    var bNan_5 = isNaN_0(b_6);
    var next_5 = (1 - t) * tmp0_5 + t * b_6;
    tmp_5.sjv_1 = aNan_5 ? b_6 : bNan_5 ? tmp0_5 : next_5;
    var tmp_6 = result;
    var tmp0_6 = a.tjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_7 = b.tjv_1;
    var aNan_6 = isNaN_0(tmp0_6);
    var bNan_6 = isNaN_0(b_7);
    var next_6 = (1 - t) * tmp0_6 + t * b_7;
    tmp_6.tjv_1 = aNan_6 ? b_7 : bNan_6 ? tmp0_6 : next_6;
    var tmp_7 = result;
    var tmp0_7 = a.mjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_8 = b.mjv_1;
    var aNan_7 = isNaN_0(tmp0_7);
    var bNan_7 = isNaN_0(b_8);
    var next_7 = (1 - t) * tmp0_7 + t * b_8;
    tmp_7.mjv_1 = aNan_7 ? b_8 : bNan_7 ? tmp0_7 : next_7;
    var tmp_8 = result;
    var tmp0_8 = a.njv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_9 = b.njv_1;
    var aNan_8 = isNaN_0(tmp0_8);
    var bNan_8 = isNaN_0(b_9);
    var next_8 = (1 - t) * tmp0_8 + t * b_9;
    tmp_8.njv_1 = aNan_8 ? b_9 : bNan_8 ? tmp0_8 : next_8;
    var tmp_9 = result;
    var tmp0_9 = a.ojv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_10 = b.ojv_1;
    var aNan_9 = isNaN_0(tmp0_9);
    var bNan_9 = isNaN_0(b_10);
    var next_9 = (1 - t) * tmp0_9 + t * b_10;
    tmp_9.ojv_1 = aNan_9 ? b_10 : bNan_9 ? tmp0_9 : next_9;
    var tmp_10 = result;
    var tmp0_10 = a.pjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_11 = b.pjv_1;
    var aNan_10 = isNaN_0(tmp0_10);
    var bNan_10 = isNaN_0(b_11);
    var next_10 = (1 - t) * tmp0_10 + t * b_11;
    tmp_10.pjv_1 = aNan_10 ? b_11 : bNan_10 ? tmp0_10 : next_10;
    var tmp_11 = result;
    var tmp0_11 = a.wjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_12 = b.wjv_1;
    var aNan_11 = isNaN_0(tmp0_11);
    var bNan_11 = isNaN_0(b_12);
    var next_11 = (1 - t) * tmp0_11 + t * b_12;
    tmp_11.wjv_1 = aNan_11 ? b_12 : bNan_11 ? tmp0_11 : next_11;
    var tmp_12 = result;
    var tmp0_12 = a.xjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_13 = b.xjv_1;
    var aNan_12 = isNaN_0(tmp0_12);
    var bNan_12 = isNaN_0(b_13);
    var next_12 = (1 - t) * tmp0_12 + t * b_13;
    tmp_12.xjv_1 = aNan_12 ? b_13 : bNan_12 ? tmp0_12 : next_12;
    var tmp_13 = result;
    var tmp0_13 = a.ujv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_14 = b.ujv_1;
    var aNan_13 = isNaN_0(tmp0_13);
    var bNan_13 = isNaN_0(b_14);
    var next_13 = (1 - t) * tmp0_13 + t * b_14;
    tmp_13.ujv_1 = aNan_13 ? b_14 : bNan_13 ? tmp0_13 : next_13;
    var tmp_14 = result;
    var tmp0_14 = a.vjv_1;
    // Inline function 'androidx.compose.foundation.style.lerpMaybeNan' call
    var b_15 = b.vjv_1;
    var aNan_14 = isNaN_0(tmp0_14);
    var bNan_14 = isNaN_0(b_15);
    var next_14 = (1 - t) * tmp0_14 + t * b_15;
    tmp_14.vjv_1 = aNan_14 ? b_15 : bNan_14 ? tmp0_14 : next_14;
  }
  function lerpInnerLayout(a, b, t, result) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    // Inline function 'kotlin.with' call
    result.djv_1 = lerp(a.djv_1, b.djv_1, t);
    result.ejv_1 = lerp(a.ejv_1, b.ejv_1, t);
    result.fjv_1 = lerp(a.fjv_1, b.fjv_1, t);
    result.gjv_1 = lerp(a.gjv_1, b.gjv_1, t);
  }
  function lerpDraw(a, b, t, result) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    // Inline function 'kotlin.with' call
    result.ljv_1 = lerp(a.ljv_1, b.ljv_1, t);
    result.yjv_1 = lerp_0(a.yjv_1, b.yjv_1, t);
    result.zjv_1 = lerp_7(a.zjv_1, a.yjv_1, b.zjv_1, b.yjv_1, t);
    result.ajw_1 = lerp_0(a.ajw_1, b.ajw_1, t);
    result.bjw_1 = lerp_7(a.bjw_1, a.ajw_1, b.bjw_1, b.ajw_1, t);
    result.djw_1 = lerp_7(a.djw_1, Companion_getInstance().u6b_1, b.djw_1, Companion_getInstance().u6b_1, t);
    result.cjx_1 = lerpShadows(a.cjx_1, b.cjx_1, t);
    result.bjx_1 = lerpShadows(a.bjx_1, b.bjx_1, t);
  }
  function lerpLayer(a, b, t, result) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    // Inline function 'kotlin.with' call
    result.gjw_1 = lerp(a.gjw_1, b.gjw_1, t);
    result.hjw_1 = lerp(a.hjw_1, b.hjw_1, t);
    result.ijw_1 = lerp(a.ijw_1, b.ijw_1, t);
    result.jjw_1 = lerp(a.jjw_1, b.jjw_1, t);
    result.kjw_1 = lerp(a.kjw_1, b.kjw_1, t);
    result.ljw_1 = lerp(a.ljw_1, b.ljw_1, t);
    result.mjw_1 = lerp(a.mjw_1, b.mjw_1, t);
    result.njw_1 = lerp(a.njw_1, b.njw_1, t);
    result.ojw_1 = TransformOrigin(lerp(_TransformOrigin___get_pivotFractionX__impl__a9pmci(a.ojw_1), _TransformOrigin___get_pivotFractionX__impl__a9pmci(b.ojw_1), t), lerp(_TransformOrigin___get_pivotFractionY__impl__ijwupp(a.ojw_1), _TransformOrigin___get_pivotFractionY__impl__ijwupp(b.ojw_1), t));
    result.qjw_1 = lerp(a.qjw_1, b.qjw_1, t);
    result.fjw_1 = lerp_8(a.fjw_1, b.fjw_1, t);
    result.ejw_1 = t < 0.5 ? a.ejw_1 : b.ejw_1;
  }
  function lerpTextDraw(a, b, t, result) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    // Inline function 'kotlin.with' call
    result.rjw_1 = lerp_0(a.rjw_1, b.rjw_1, t);
    result.sjw_1 = lerp_7(a.sjw_1, a.rjw_1, b.sjw_1, b.rjw_1, t);
  }
  function lerpTextLayout(a, b, t, result) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    // Inline function 'kotlin.with' call
    var tmp;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    var this_0 = a.vjw_1;
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_0), new Long(0, 0))) {
      // Inline function 'androidx.compose.ui.unit.isSpecified' call
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      var this_1 = b.vjw_1;
      tmp = !equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_1), new Long(0, 0));
    } else {
      tmp = false;
    }
    if (tmp) {
      result.vjw_1 = lerp_1(a.vjw_1, b.vjw_1, t);
    }
    var tmp_0;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    var this_2 = a.wjw_1;
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_2), new Long(0, 0))) {
      // Inline function 'androidx.compose.ui.unit.isSpecified' call
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      var this_3 = b.wjw_1;
      tmp_0 = !equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_3), new Long(0, 0));
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      result.wjw_1 = lerp_1(a.wjw_1, b.wjw_1, t);
    }
    var tmp_1;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    var this_4 = a.xjw_1;
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_4), new Long(0, 0))) {
      // Inline function 'androidx.compose.ui.unit.isSpecified' call
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      var this_5 = b.xjw_1;
      tmp_1 = !equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_5), new Long(0, 0));
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      result.xjw_1 = lerp_1(a.xjw_1, b.xjw_1, t);
    }
    result.tjw_1 = t < 0.5 ? a.tjw_1 : b.tjw_1;
    result.ujw_1 = t < 0.5 ? a.ujw_1 : b.ujw_1;
    result.yjw_1 = t < 0.5 ? a.yjw_1 : b.yjw_1;
    result.zjw_1 = t < 0.5 ? a.zjw_1 : b.zjw_1;
    result.ajx_1 = t < 0.5 ? a.ajx_1 : b.ajx_1;
    // Inline function 'androidx.compose.foundation.style.getBits' call
    var aWeight = (a.ajx_1 & 134086656) >> 17;
    // Inline function 'androidx.compose.foundation.style.getBits' call
    var bWeight = (b.ajx_1 & 134086656) >> 17;
    if (aWeight > 0 && bWeight > 0) {
      // Inline function 'androidx.compose.foundation.style.floorToNearest100' call
      var this_6 = lerp_2(aWeight, bWeight, t);
      var weight = imul(this_6 / 100 | 0, 100);
      var tmp_2 = result;
      // Inline function 'androidx.compose.foundation.style.setBits' call
      tmp_2.ajx_1 = result.ajx_1 & ~134086656 | weight << 17 & 134086656;
    }
  }
  function lerp_7(leftBrush, leftColor, rightBrush, rightColor, t) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    var a = leftBrush;
    var b = rightBrush;
    if (leftBrush == null && rightBrush == null) {
      return null;
    } else if (leftBrush == null) {
      a = new SolidColor(leftColor);
    } else if (rightBrush == null) {
      b = new SolidColor(rightColor);
    }
    var tmp = Companion_instance_6.d6h(a, b, t);
    return tmp instanceof Brush ? tmp : null;
  }
  function lerpShadows(a, b, t) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    if (a == null && b == null) {
      return null;
    }
    var aIsArray = !(a == null) ? isArray(a) : false;
    var bIsArray = !(b == null) ? isArray(b) : false;
    if (!aIsArray && !bIsArray) {
      var tmp = a instanceof Shadow ? a : null;
      return lerp_3(tmp, b instanceof Shadow ? b : null, t);
    }
    var tmp_0;
    if (aIsArray) {
      tmp_0 = isArray(a) ? a : THROW_CCE();
    } else {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = [a instanceof Shadow ? a : THROW_CCE()];
    }
    var tmp_1 = tmp_0;
    var tmp_2;
    if (bIsArray) {
      tmp_2 = isArray(b) ? b : THROW_CCE();
    } else {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_2 = [b instanceof Shadow ? b : THROW_CCE()];
    }
    return lerpArrayShadows(tmp_1, tmp_2, t);
  }
  function lerp_8(a, b, t) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    var tmp = Companion_instance_6.d6h(a, b, t);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Shape) : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? get_RectangleShape() : tmp0_elvis_lhs;
  }
  function lerpArrayShadows(a, b, t) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    var tmp0 = a.length;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_0 = b.length;
    var maxSize = Math.max(tmp0, b_0);
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(maxSize);
    while (tmp < maxSize) {
      tmp_0[tmp] = null;
      tmp = tmp + 1 | 0;
    }
    var result = tmp_0;
    var inductionVariable = 0;
    if (inductionVariable < maxSize)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var left = getOrNull(a, i);
        var right = getOrNull(b, i);
        result[i] = lerp_3(left, right, t);
      }
       while (inductionVariable < maxSize);
    return result;
  }
  function sam$androidx_compose_foundation_style_Style$0(function_0) {
    this.djy_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_style_Style$0).ijx = function (_this__u8e3s4) {
    return this.djy_1(_this__u8e3s4);
  };
  protoOf(sam$androidx_compose_foundation_style_Style$0).q3 = function () {
    return this.djy_1;
  };
  protoOf(sam$androidx_compose_foundation_style_Style$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Style) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_style_Style$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function TextDefaultsResolvedStyle$lambda($this$apply) {
    _init_properties_ResolvedStyle_kt__ltzlbb();
    $this$apply.xjx(get_sp(14));
    $this$apply.yjx(get_sp(0));
    $this$apply.ujx(Companion_getInstance().i6b_1);
    $this$apply.bjy(Companion_getInstance_19().b7z_1);
    $this$apply.ajy(Companion_getInstance_32().k7z_1);
    $this$apply.cjy(Companion_getInstance_35().p7z_1);
    $this$apply.wjx(Companion_getInstance_37().q7z_1);
    $this$apply.zjx(Companion_getInstance_30().x7z_1);
    $this$apply.vjx(Companion_getInstance_36().a80_1);
    return Unit_instance;
  }
  var properties_initialized_ResolvedStyle_kt_9mq9w7;
  function _init_properties_ResolvedStyle_kt__ltzlbb() {
    if (!properties_initialized_ResolvedStyle_kt_9mq9w7) {
      properties_initialized_ResolvedStyle_kt_9mq9w7 = true;
      DefaultSpringSpec = spring();
      EmptyResolvedStyle = new ResolvedStyle();
      var tmp = new ResolvedStyle();
      var tmp_0 = TextDefaultsResolvedStyle$lambda;
      apply(tmp, new sam$androidx_compose_foundation_style_Style$0(tmp_0));
      TextDefaultsResolvedStyle = Unit_instance;
      androidx_compose_foundation_style_ResolvedStyle$stable = 0;
    }
  }
  var androidx_compose_foundation_style_CombinedStyle$stable;
  function Style() {
  }
  var androidx_compose_foundation_style_StyleAnimations$stable;
  var androidx_compose_foundation_style_StyleElement$stable;
  var androidx_compose_foundation_style_StyleInnerElement$stable;
  var androidx_compose_foundation_style_StyleOuterNode$stable;
  var androidx_compose_foundation_style_StyleInnerNode$stable;
  function StyleOuterNode$resolveInheritedStyle$lambda($nodes, this$0) {
    return function (node) {
      var tmp;
      if (!(node instanceof StyleOuterNode)) {
        return true;
      }
      var tmp_0;
      var tmp_1;
      if (!((node.ujy_1.yju_1 & 96) === 0)) {
        tmp_1 = true;
      } else {
        var tmp1_safe_receiver = node.vjy_1;
        tmp_1 = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.fv()) === true;
      }
      if (tmp_1) {
        var tmp0_elvis_lhs = $nodes._v;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'androidx.collection.mutableObjectListOf' call
          // Inline function 'kotlin.also' call
          var this_0 = new MutableObjectList();
          $nodes._v = this_0;
          this$0.wjy_1 = this_0;
          tmp_2 = this_0;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        tmp_2.j1(node);
        tmp_0 = Unit_instance;
      }
      return true;
    };
  }
  function StyleOuterNode() {
  }
  protoOf(StyleOuterNode).ejz = function (phase, fallback) {
    var tmp0_safe_receiver = this.fjz(toFlags(phase));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ljx(fallback);
    return tmp1_elvis_lhs == null ? fallback : tmp1_elvis_lhs;
  };
  protoOf(StyleOuterNode).fjz = function (flags) {
    var nodes = {_v: this.wjy_1};
    var tmp;
    if (!((this.ujy_1.yju_1 & 96) === 0)) {
      tmp = true;
    } else {
      var tmp1_safe_receiver = this.vjy_1;
      tmp = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.fv()) === true;
    }
    if (tmp) {
      var tmp0_elvis_lhs = nodes._v;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'androidx.collection.mutableObjectListOf' call
        // Inline function 'kotlin.also' call
        var this_0 = new MutableObjectList();
        nodes._v = this_0;
        this.wjy_1 = this_0;
        tmp_0 = this_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp_0.j1(this);
    }
    traverseAncestors(this, 'StyleOuterNode', StyleOuterNode$resolveInheritedStyle$lambda(nodes, this));
    var startStyle = this.gjz();
    var startIndex = !(startStyle == null) ? -1 : -2;
    var tmp2_safe_receiver = this.vjy_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.fv();
    var hasAnimations = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
    var hasInheritedStyles = this.ujy_1.yju_1 & 96;
    var tmp4_safe_receiver = nodes._v;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.collection.ObjectList.forEachIndexed' call
      // Inline function 'kotlin.contracts.contract' call
      var content = tmp4_safe_receiver.sz_1;
      var inductionVariable = 0;
      var last = tmp4_safe_receiver.tz_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var node = content[i];
          var cached = node.gjz();
          var tmp_1;
          if (hasAnimations) {
            tmp_1 = true;
          } else {
            var tmp0_safe_receiver = node.vjy_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fv();
            tmp_1 = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
          }
          hasAnimations = tmp_1;
          hasInheritedStyles = hasInheritedStyles | node.ujy_1.yju_1 & 96;
          if (cached == null) {
            startStyle = null;
            startIndex = -2;
          } else if (startStyle == null) {
            startStyle = cached;
            startIndex = i;
          }
        }
         while (inductionVariable < last);
    }
    if (hasInheritedStyles === 0)
      return null;
    if (!(startStyle == null) && startIndex < 0 && !hasAnimations) {
      return startStyle;
    }
    var ancestorStyle = startStyle;
    startIndex = !(nodes._v == null) && startIndex < -1 ? nodes._v.n1() - 1 | 0 : startIndex;
    var inductionVariable_0 = startIndex;
    if (-1 <= inductionVariable_0)
      $l$loop: do {
        var index = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + -1 | 0;
        var tmp_2;
        if (index < 0) {
          tmp_2 = this;
        } else {
          var tmp5_elvis_lhs = nodes._v;
          var tmp_3;
          if (tmp5_elvis_lhs == null) {
            continue $l$loop;
          } else {
            tmp_3 = tmp5_elvis_lhs;
          }
          tmp_2 = tmp_3.l1(index);
        }
        var node_0 = tmp_2;
        var tmp6_elvis_lhs = node_0.xjy_1;
        var cachedStyle = tmp6_elvis_lhs == null ? new ResolvedStyle() : tmp6_elvis_lhs;
        var tmp7_safe_receiver = ancestorStyle;
        if (tmp7_safe_receiver == null)
          null;
        else {
          tmp7_safe_receiver.ejx(cachedStyle);
        }
        cachedStyle.kjx(node_0.ujy_1);
        ancestorStyle = cachedStyle;
        node_0.hjz(cachedStyle);
      }
       while (-1 <= inductionVariable_0);
    if (hasAnimations) {
      var animatingStyle = new ResolvedStyle();
      var tmp8_safe_receiver = ancestorStyle;
      if (tmp8_safe_receiver == null)
        null;
      else {
        tmp8_safe_receiver.ejx(animatingStyle);
      }
      var tmp9_safe_receiver = nodes._v;
      var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.n1();
      var size = tmp10_elvis_lhs == null ? 0 : tmp10_elvis_lhs;
      var density = requireDensity(this);
      var inductionVariable_1 = size - 1 | 0;
      if (-1 <= inductionVariable_1)
        $l$loop_0: do {
          var index_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + -1 | 0;
          var tmp_4;
          if (index_0 < 0) {
            tmp_4 = this;
          } else {
            var tmp11_elvis_lhs = nodes._v;
            var tmp_5;
            if (tmp11_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp_5 = tmp11_elvis_lhs;
            }
            tmp_4 = tmp_5.l1(index_0);
          }
          var node_1 = tmp_4;
          var tmp12_safe_receiver = node_1.vjy_1;
          if (tmp12_safe_receiver == null)
            null;
          else {
            tmp12_safe_receiver.ijz(animatingStyle, density, node_1, flags);
          }
        }
         while (-1 <= inductionVariable_1);
      ancestorStyle = animatingStyle;
    }
    return ancestorStyle;
  };
  protoOf(StyleOuterNode).gjz = function () {
    return this.yjy_1 ? null : this.xjy_1;
  };
  protoOf(StyleOuterNode).hjz = function (style) {
    this.yjy_1 = false;
    this.xjy_1 = style;
  };
  function toFlags(_this__u8e3s4) {
    return _this__u8e3s4 === Companion_getInstance_86().jjz_1 ? 32 : _this__u8e3s4 === Companion_getInstance_86().kjz_1 ? 64 : 96;
  }
  function apply(_this__u8e3s4, style) {
    // Inline function 'kotlin.with' call
    style.ijx(_this__u8e3s4);
  }
  var androidx_compose_foundation_style_StyleStateKey$stable;
  var androidx_compose_foundation_style_BooleanPredefinedKey$stable;
  var androidx_compose_foundation_style_PredefinedToggleStateKey$stable;
  var androidx_compose_foundation_style_StyleState$stable;
  var androidx_compose_foundation_style_MutableStyleState$stable;
  function get_EmptyInlineContent() {
    _init_properties_AnnotatedStringResolveInlineContent_kt__h20qbv();
    return EmptyInlineContent;
  }
  var EmptyInlineContent;
  function hasInlineContent(_this__u8e3s4) {
    _init_properties_AnnotatedStringResolveInlineContent_kt__h20qbv();
    return _this__u8e3s4.x7q('androidx.compose.foundation.text.inlineContent', 0, _this__u8e3s4.h7q_1.length);
  }
  function resolveInlineContent(_this__u8e3s4, inlineContent) {
    _init_properties_AnnotatedStringResolveInlineContent_kt__h20qbv();
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (inlineContent == null || inlineContent.r()) {
      return get_EmptyInlineContent();
    }
    var inlineContentAnnotations = _this__u8e3s4.w7q('androidx.compose.foundation.text.inlineContent', 0, _this__u8e3s4.h7q_1.length);
    // Inline function 'kotlin.collections.mutableListOf' call
    var placeholders = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.mutableListOf' call
    var inlineComposables = ArrayList_init_$Create$();
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = inlineContentAnnotations.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = inlineContentAnnotations.l1(index);
        var tmp0_safe_receiver = inlineContent.w2(item.m7p_1);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          placeholders.j1(Range_init_$Create$(tmp0_safe_receiver.mjz_1, item.n7p_1, item.o7p_1));
          inlineComposables.j1(Range_init_$Create$(tmp0_safe_receiver.njz_1, item.n7p_1, item.o7p_1));
        }
      }
       while (inductionVariable <= last);
    return new Pair(placeholders, inlineComposables);
  }
  function InlineChildren(text, inlineContents, $composer, $changed) {
    _init_properties_AnnotatedStringResolveInlineContent_kt__h20qbv();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1794596951);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(text) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(inlineContents) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = inlineContents.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = inlineContents.l1(index);
          var content = item.zh();
          var start = item.ai();
          var end = item.hr();
          // Inline function 'androidx.compose.runtime.cache' call
          var this_0 = $composer_0;
          // Inline function 'kotlin.let' call
          var it = this_0.i31();
          var tmp;
          if (false || it === Companion_getInstance_11().f30_1) {
            var tmp_0 = InlineChildren$lambda;
            var value = new sam$androidx_compose_ui_layout_MeasurePolicy$0_0(tmp_0);
            this_0.j31(value);
            tmp = value;
          } else {
            tmp = it;
          }
          var tmp2 = tmp;
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier = null;
          var $composer_1 = $composer_0;
          if (!((2 & 2) === 0))
            modifier = Companion_instance_0;
          var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
          var localMap = $composer_1.t31();
          var materialized = materialize($composer_1, modifier);
          var tmp0 = Companion_getInstance_14().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_2 = $composer_1;
          var tmp_1 = $composer_2.g30();
          if (!isInterface(tmp_1, Applier)) {
            invalidApplier();
          }
          $composer_2.b31();
          if ($composer_2.h30()) {
            $composer_2.c31(tmp0);
          } else {
            $composer_2.d31();
          }
          var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp2, Companion_getInstance_14().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
          var $composer_3 = $composer_2;
          content(text.c(start, end).h7q_1, $composer_3, 0);
          $composer_2.e31();
        }
         while (inductionVariable <= last);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(InlineChildren$lambda_0(text, inlineContents, $changed));
    }
  }
  function sam$androidx_compose_ui_layout_MeasurePolicy$0_0(function_0) {
    this.ojz_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).mak = function (_this__u8e3s4, measurables, constraints) {
    return this.ojz_1(_this__u8e3s4, measurables, new Constraints(constraints));
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).q3 = function () {
    return this.ojz_1;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function InlineChildren$lambda($this$Layout, children, constrains) {
    _init_properties_AnnotatedStringResolveInlineContent_kt__h20qbv();
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(children.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = children.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = children.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = item.h8y(constrains.m5e_1);
        target.j1(element);
      }
       while (inductionVariable <= last);
    var placeables = target;
    var tmp = _Constraints___get_maxWidth__impl__uuyqc(constrains.m5e_1);
    var tmp_0 = _Constraints___get_maxHeight__impl__dt3e8z(constrains.m5e_1);
    return $this$Layout.n8y(tmp, tmp_0, VOID, InlineChildren$lambda$lambda(placeables));
  }
  function InlineChildren$lambda$lambda($placeables) {
    return function ($this$layout) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = $placeables;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          $this$layout.a98(item, 0, 0);
        }
         while (inductionVariable <= last);
      return Unit_instance;
    };
  }
  function InlineChildren$lambda_0($text, $inlineContents, $$changed) {
    return function ($composer, $force) {
      InlineChildren($text, $inlineContents, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var properties_initialized_AnnotatedStringResolveInlineContent_kt_ljtk0d;
  function _init_properties_AnnotatedStringResolveInlineContent_kt__h20qbv() {
    if (!properties_initialized_AnnotatedStringResolveInlineContent_kt_ljtk0d) {
      properties_initialized_AnnotatedStringResolveInlineContent_kt_ljtk0d = true;
      EmptyInlineContent = new Pair(emptyList(), emptyList());
    }
  }
  function get_LocalAutofillHighlightBrush() {
    _init_properties_AutofillHighlight_kt__ivqg9c();
    return LocalAutofillHighlightBrush;
  }
  var LocalAutofillHighlightBrush;
  function get_LocalAutofillHighlightColor() {
    _init_properties_AutofillHighlight_kt__ivqg9c();
    return LocalAutofillHighlightColor;
  }
  var LocalAutofillHighlightColor;
  function resolveAutofillHighlight(brush, color, defaultColor) {
    _init_properties_AutofillHighlight_kt__ivqg9c();
    var isColorOverridden = !equals(color, defaultColor);
    var tmp;
    if (isColorOverridden) {
      tmp = new SolidColor(color);
    } else {
      tmp = brush;
    }
    return tmp;
  }
  function LocalAutofillHighlightBrush$lambda() {
    _init_properties_AutofillHighlight_kt__ivqg9c();
    return new SolidColor(autofillHighlightColor());
  }
  function LocalAutofillHighlightColor$lambda() {
    _init_properties_AutofillHighlight_kt__ivqg9c();
    return new Color(autofillHighlightColor());
  }
  var properties_initialized_AutofillHighlight_kt_22wcuq;
  function _init_properties_AutofillHighlight_kt__ivqg9c() {
    if (!properties_initialized_AutofillHighlight_kt_22wcuq) {
      properties_initialized_AutofillHighlight_kt_22wcuq = true;
      LocalAutofillHighlightBrush = compositionLocalOf(VOID, LocalAutofillHighlightBrush$lambda);
      LocalAutofillHighlightColor = compositionLocalOf(VOID, LocalAutofillHighlightColor$lambda);
    }
  }
  var androidx_compose_foundation_text_SecureTextFieldController$stable;
  var androidx_compose_foundation_text_PasswordInputTransformation$stable;
  function BasicText(text, modifier, style, onTextLayout, overflow, softWrap, maxLines, minLines, color, autoSize, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var style_0 = {_v: style};
    var onTextLayout_0 = {_v: onTextLayout};
    var overflow_0 = {_v: new TextOverflow(overflow)};
    var softWrap_0 = {_v: softWrap};
    var maxLines_0 = {_v: maxLines};
    var minLines_0 = {_v: minLines};
    var color_0 = {_v: color};
    var autoSize_0 = {_v: autoSize};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1040751001);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(text) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(style_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onTextLayout_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.m31(_TextOverflow___get_value__impl__vugm5i(overflow_0._v.q8e_1)) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.l31(softWrap_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.m31(maxLines_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.m31(minLines_0._v) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.q31(color_0._v) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ((($changed & 1073741824) === 0 ? $composer_0.k31(autoSize_0._v) : $composer_0.q31(autoSize_0._v)) ? 536870912 : 268435456);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      if (!(($default & 4) === 0)) {
        style_0._v = Companion_getInstance_38().n81_1;
      }
      if (!(($default & 8) === 0)) {
        onTextLayout_0._v = null;
      }
      if (!(($default & 16) === 0)) {
        overflow_0._v = new TextOverflow(Companion_getInstance_39().w7s_1);
      }
      if (!(($default & 32) === 0)) {
        softWrap_0._v = true;
      }
      if (!(($default & 64) === 0)) {
        maxLines_0._v = 2147483647;
      }
      if (!(($default & 128) === 0)) {
        minLines_0._v = 1;
      }
      if (!(($default & 256) === 0)) {
        color_0._v = null;
      }
      if (!(($default & 512) === 0)) {
        autoSize_0._v = null;
      }
      validateMinMaxLines(minLines_0._v, maxLines_0._v);
      var tmp0 = get_LocalSelectionRegistrar();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var selectionRegistrar = $composer_1.u31(tmp0);
      var tmp;
      if (!(selectionRegistrar == null)) {
        $composer_0.m30(356423075);
        var tmp0_0 = get_LocalTextSelectionColors();
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var $composer_2 = $composer_0;
        var backgroundSelectionColor = $composer_2.u31(tmp0_0).qjz_1;
        var tmp_0 = selectionIdSaver(selectionRegistrar);
        var tmp0_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31(selectionRegistrar);
        // Inline function 'kotlin.let' call
        var it = tmp0_1.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance_11().f30_1) {
          var value = BasicText$lambda(selectionRegistrar);
          tmp0_1.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$2 = tmp_1;
        var selectableId = rememberSaveable([selectionRegistrar], tmp_0, tmp$ret$2, $composer_0, 0);
        var tmp0_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!(!!($composer_0.o31(selectableId) | $composer_0.k31(selectionRegistrar)) | $composer_0.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(backgroundSelectionColor))));
        // Inline function 'kotlin.let' call
        var it_0 = tmp0_2.i31();
        var tmp_2;
        if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
          var value_0 = new SelectionController(selectableId, selectionRegistrar, backgroundSelectionColor);
          tmp0_2.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_0;
        }
        var tmp1_group = tmp_2;
        $composer_0.n30();
        tmp = tmp1_group;
      } else {
        $composer_0.m30(356914239);
        $composer_0.n30();
        tmp = null;
      }
      var selectionController = tmp;
      var tmp0_3 = get_LocalFontFamilyResolver();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_3 = $composer_0;
      var fontFamilyResolver = $composer_3.u31(tmp0_3);
      BackgroundTextMeasurement(text, style_0._v, fontFamilyResolver, $composer_0, 14 & $dirty | 112 & $dirty >> 3);
      var tmp_3;
      if (!(selectionController == null) || !(onTextLayout_0._v == null) || !(autoSize_0._v == null)) {
        $composer_0.m30(357232113);
        var tmp_4 = modifier_0._v;
        var tmp_5 = AnnotatedString_init_$Create$(text);
        var tmp_6 = style_0._v;
        var tmp_7 = onTextLayout_0._v;
        var tmp_8 = overflow_0._v;
        var tmp_9 = softWrap_0._v;
        var tmp_10 = maxLines_0._v;
        var tmp_11 = minLines_0._v;
        var tmp0_4 = get_LocalFontFamilyResolver();
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var $composer_4 = $composer_0;
        var tmp$ret$11 = $composer_4.u31(tmp0_4);
        var tmp2_group = textModifier(tmp_4, tmp_5, tmp_6, tmp_7, tmp_8.q8e_1, tmp_9, tmp_10, tmp_11, tmp$ret$11, null, null, selectionController, color_0._v, null, autoSize_0._v);
        $composer_0.n30();
        tmp_3 = tmp2_group;
      } else {
        $composer_0.m30(357875859);
        $composer_0.n30();
        tmp_3 = modifier_0._v.d8v(new TextStringSimpleElement(text, style_0._v, fontFamilyResolver, overflow_0._v.q8e_1, softWrap_0._v, maxLines_0._v, minLines_0._v, color_0._v));
      }
      var finalModifier = tmp_3;
      var tmp2 = EmptyMeasurePolicy_getInstance();
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_1 = finalModifier;
      var $composer_5 = $composer_0;
      if (!((0 & 1) === 0))
        modifier_1 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_5, 0).hashCode();
      var materialized = materialize($composer_5, modifier_1);
      var localMap = $composer_5.t31();
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var factory = Companion_getInstance_14().oah_1;
      var $composer_6 = $composer_5;
      var tmp_12 = $composer_6.g30();
      if (!isInterface(tmp_12, Applier)) {
        invalidApplier();
      }
      $composer_6.b31();
      if ($composer_6.h30()) {
        $composer_6.c31(factory);
      } else {
        $composer_6.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_6);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp2, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      $composer_6.e31();
    } else {
      $composer_0.z30();
    }
    var tmp3_safe_receiver = $composer_0.t30();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.p3c(BasicText$lambda_0(text, modifier_0, style_0, onTextLayout_0, overflow_0, softWrap_0, maxLines_0, minLines_0, color_0, autoSize_0, $changed, $default));
    }
  }
  function selectionIdSaver(selectionRegistrar) {
    var tmp = selectionIdSaver$lambda(selectionRegistrar);
    return Saver(tmp, selectionIdSaver$lambda_0);
  }
  function textModifier(_this__u8e3s4, text, style, onTextLayout, overflow, softWrap, maxLines, minLines, fontFamilyResolver, placeholders, onPlaceholderLayout, selectionController, color, onShowTranslation, autoSize) {
    if (selectionController == null) {
      var staticTextModifier = new TextAnnotatedStringElement(text, style, fontFamilyResolver, onTextLayout, overflow, softWrap, maxLines, minLines, placeholders, onPlaceholderLayout, null, color, autoSize, onShowTranslation);
      return _this__u8e3s4.d8v(Companion_instance_0).d8v(staticTextModifier);
    } else {
      var selectableTextModifier = new SelectableTextAnnotatedStringElement(text, style, fontFamilyResolver, onTextLayout, overflow, softWrap, maxLines, minLines, placeholders, onPlaceholderLayout, selectionController, color, autoSize);
      return _this__u8e3s4.d8v(selectionController.wjz_1).d8v(selectableTextModifier);
    }
  }
  function EmptyMeasurePolicy$placementBlock$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function EmptyMeasurePolicy() {
    EmptyMeasurePolicy_instance = this;
    var tmp = this;
    tmp.xjz_1 = EmptyMeasurePolicy$placementBlock$lambda;
  }
  protoOf(EmptyMeasurePolicy).mak = function (_this__u8e3s4, measurables, constraints) {
    return _this__u8e3s4.n8y(_Constraints___get_maxWidth__impl__uuyqc(constraints), _Constraints___get_maxHeight__impl__dt3e8z(constraints), VOID, this.xjz_1);
  };
  var EmptyMeasurePolicy_instance;
  function EmptyMeasurePolicy_getInstance() {
    if (EmptyMeasurePolicy_instance == null)
      new EmptyMeasurePolicy();
    return EmptyMeasurePolicy_instance;
  }
  function BasicText_0(text, modifier, style, onTextLayout, overflow, softWrap, maxLines, minLines, inlineContent, color, autoSize, $composer, $changed, $changed1, $default) {
    var modifier_0 = {_v: modifier};
    var style_0 = {_v: style};
    var onTextLayout_0 = {_v: onTextLayout};
    var overflow_0 = {_v: new TextOverflow(overflow)};
    var softWrap_0 = {_v: softWrap};
    var maxLines_0 = {_v: maxLines};
    var minLines_0 = {_v: minLines};
    var inlineContent_0 = {_v: inlineContent};
    var color_0 = {_v: color};
    var autoSize_0 = {_v: autoSize};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1343466571);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(text) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(style_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onTextLayout_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.m31(_TextOverflow___get_value__impl__vugm5i(overflow_0._v.q8e_1)) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.l31(softWrap_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.m31(maxLines_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.m31(minLines_0._v) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.q31(inlineContent_0._v) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.q31(color_0._v) ? 536870912 : 268435456);
    if (!(($default & 1024) === 0))
      $dirty1 = $dirty1 | 6;
    else if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ((($changed1 & 8) === 0 ? $composer_0.k31(autoSize_0._v) : $composer_0.q31(autoSize_0._v)) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 3) === 2), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      if (!(($default & 4) === 0)) {
        style_0._v = Companion_getInstance_38().n81_1;
      }
      if (!(($default & 8) === 0)) {
        onTextLayout_0._v = null;
      }
      if (!(($default & 16) === 0)) {
        overflow_0._v = new TextOverflow(Companion_getInstance_39().w7s_1);
      }
      if (!(($default & 32) === 0)) {
        softWrap_0._v = true;
      }
      if (!(($default & 64) === 0)) {
        maxLines_0._v = 2147483647;
      }
      if (!(($default & 128) === 0)) {
        minLines_0._v = 1;
      }
      if (!(($default & 256) === 0)) {
        // Inline function 'kotlin.collections.mapOf' call
        inlineContent_0._v = emptyMap();
      }
      if (!(($default & 512) === 0)) {
        color_0._v = null;
      }
      if (!(($default & 1024) === 0)) {
        autoSize_0._v = null;
      }
      validateMinMaxLines(minLines_0._v, maxLines_0._v);
      var tmp0 = get_LocalSelectionRegistrar();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var selectionRegistrar = $composer_1.u31(tmp0);
      var tmp;
      if (!(selectionRegistrar == null)) {
        $composer_0.m30(1588268245);
        var tmp0_0 = get_LocalTextSelectionColors();
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var $composer_2 = $composer_0;
        var backgroundSelectionColor = $composer_2.u31(tmp0_0).qjz_1;
        var tmp_0 = selectionIdSaver(selectionRegistrar);
        var tmp0_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31(selectionRegistrar);
        // Inline function 'kotlin.let' call
        var it = tmp0_1.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance_11().f30_1) {
          var value = BasicText$lambda_1(selectionRegistrar);
          tmp0_1.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$3 = tmp_1;
        var selectableId = rememberSaveable([selectionRegistrar], tmp_0, tmp$ret$3, $composer_0, 0);
        var tmp0_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!(!!($composer_0.o31(selectableId) | $composer_0.k31(selectionRegistrar)) | $composer_0.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(backgroundSelectionColor))));
        // Inline function 'kotlin.let' call
        var it_0 = tmp0_2.i31();
        var tmp_2;
        if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
          var value_0 = new SelectionController(selectableId, selectionRegistrar, backgroundSelectionColor);
          tmp0_2.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_0;
        }
        var tmp1_group = tmp_2;
        $composer_0.n30();
        tmp = tmp1_group;
      } else {
        $composer_0.m30(1588759409);
        $composer_0.n30();
        tmp = null;
      }
      var selectionController = tmp;
      var hasInlineContent_0 = hasInlineContent(text);
      var hasLinks_0 = hasLinks(text);
      var tmp0_3 = get_LocalFontFamilyResolver();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_3 = $composer_0;
      var fontFamilyResolver = $composer_3.u31(tmp0_3);
      if (!hasInlineContent_0 && !hasLinks_0) {
        $composer_0.m30(1589006262);
        BackgroundTextMeasurement_0(text, style_0._v, fontFamilyResolver, null, $composer_0, 3072 | 14 & $dirty | 112 & $dirty >> 3);
        var tmp0_4 = textModifier(modifier_0._v, text, style_0._v, onTextLayout_0._v, overflow_0._v.q8e_1, softWrap_0._v, maxLines_0._v, minLines_0._v, fontFamilyResolver, null, null, selectionController, color_0._v, null, autoSize_0._v);
        var tmp2 = EmptyMeasurePolicy_getInstance();
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_1 = tmp0_4;
        var $composer_4 = $composer_0;
        if (!((0 & 1) === 0))
          modifier_1 = Companion_instance_0;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_4, 0).hashCode();
        var materialized = materialize($composer_4, modifier_1);
        var localMap = $composer_4.t31();
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var factory = Companion_getInstance_14().oah_1;
        var $composer_5 = $composer_4;
        var tmp_3 = $composer_5.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_5.b31();
        if ($composer_5.h30()) {
          $composer_5.c31(factory);
        } else {
          $composer_5.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_5);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp2, Companion_getInstance_14().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
        $composer_5.e31();
        $composer_0.n30();
      } else {
        $composer_0.m30(1590022070);
        var tmp0_5 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = ($dirty & 14) === 4;
        // Inline function 'kotlin.let' call
        var it_1 = tmp0_5.i31();
        var tmp_4;
        if (invalid_1 || it_1 === Companion_getInstance_11().f30_1) {
          var value_1 = mutableStateOf(text);
          tmp0_5.j31(value_1);
          tmp_4 = value_1;
        } else {
          tmp_4 = it_1;
        }
        var displayedText$delegate = tmp_4;
        var tmp_5 = modifier_0._v;
        var tmp_6 = BasicText$lambda_2(displayedText$delegate);
        var tmp_7 = onTextLayout_0._v;
        var tmp_8 = inlineContent_0._v;
        var tmp_9 = style_0._v;
        var tmp_10 = overflow_0._v;
        var tmp_11 = softWrap_0._v;
        var tmp_12 = maxLines_0._v;
        var tmp_13 = minLines_0._v;
        var tmp_14 = color_0._v;
        var tmp0_6 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_0.k31(displayedText$delegate);
        // Inline function 'kotlin.let' call
        var it_2 = tmp0_6.i31();
        var tmp_15;
        if (invalid_2 || it_2 === Companion_getInstance_11().f30_1) {
          var value_2 = BasicText$lambda_4(displayedText$delegate);
          tmp0_6.j31(value_2);
          tmp_15 = value_2;
        } else {
          tmp_15 = it_2;
        }
        var tmp$ret$19 = tmp_15;
        LayoutWithLinksAndInlineContent(tmp_5, tmp_6, tmp_7, hasInlineContent_0, tmp_8, tmp_9, tmp_10.q8e_1, tmp_11, tmp_12, tmp_13, fontFamilyResolver, selectionController, tmp_14, tmp$ret$19, autoSize_0._v, $composer_0, 14 & $dirty >> 3 | 896 & $dirty >> 3 | 57344 & $dirty >> 12 | 458752 & $dirty << 9 | 3670016 & $dirty << 6 | 29360128 & $dirty << 6 | 234881024 & $dirty << 6 | 1879048192 & $dirty << 6, 896 & $dirty >> 21 | 57344 & $dirty1 << 12, 0);
        $composer_0.n30();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(BasicText$lambda_5(text, modifier_0, style_0, onTextLayout_0, overflow_0, softWrap_0, maxLines_0, minLines_0, inlineContent_0, color_0, autoSize_0, $changed, $changed1, $default));
    }
  }
  function LayoutWithLinksAndInlineContent(modifier, text, onTextLayout, hasInlineContent, inlineContent, style, overflow, softWrap, maxLines, minLines, fontFamilyResolver, selectionController, color, onShowTranslation, autoSize, $composer, $changed, $changed1, $default) {
    var inlineContent_0 = {_v: inlineContent};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-2118572703);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(text) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onTextLayout) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(hasInlineContent) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(inlineContent_0._v) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.k31(style) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.m31(_TextOverflow___get_value__impl__vugm5i(overflow)) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.l31(softWrap) ? 8388608 : 4194304);
    if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.m31(maxLines) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.m31(minLines) ? 536870912 : 268435456);
    if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(fontFamilyResolver) ? 4 : 2);
    if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(selectionController) ? 32 : 16);
    if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(color) ? 256 : 128);
    if (($changed1 & 3072) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(onShowTranslation) ? 2048 : 1024);
    if (($changed1 & 24576) === 0)
      $dirty1 = $dirty1 | ((($changed1 & 32768) === 0 ? $composer_0.k31(autoSize) : $composer_0.q31(autoSize)) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 16) === 0)) {
        // Inline function 'kotlin.collections.mapOf' call
        inlineContent_0._v = emptyMap();
      }
      var tmp;
      if (hasLinks(text)) {
        $composer_0.m30(145641571);
        var tmp0 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it = tmp0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance_11().f30_1) {
          var value = new TextLinkScope(text);
          tmp0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        $composer_0.n30();
        tmp = tmp0_group;
      } else {
        $composer_0.m30(145707228);
        $composer_0.n30();
        tmp = null;
      }
      var textScope = tmp;
      var tmp_1;
      if (hasLinks(text)) {
        $composer_0.m30(145905443);
        var tmp0_0 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!(($dirty & 112) === 32 | $composer_0.k31(textScope));
        // Inline function 'kotlin.let' call
        var it_0 = tmp0_0.i31();
        var tmp_2;
        if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
          var value_0 = LayoutWithLinksAndInlineContent$lambda(textScope, text);
          tmp0_0.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_0;
        }
        var tmp1_group = tmp_2;
        $composer_0.n30();
        tmp_1 = tmp1_group;
      } else {
        $composer_0.m30(146002721);
        var tmp0_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it_1 = tmp0_1.i31();
        var tmp_3;
        if (invalid_1 || it_1 === Companion_getInstance_11().f30_1) {
          var value_1 = LayoutWithLinksAndInlineContent$lambda_0(text);
          tmp0_1.j31(value_1);
          tmp_3 = value_1;
        } else {
          tmp_3 = it_1;
        }
        var tmp2_group = tmp_3;
        $composer_0.n30();
        tmp_1 = tmp2_group;
      }
      var styledText = tmp_1;
      var tmp_4;
      if (hasInlineContent) {
        tmp_4 = resolveInlineContent(text, inlineContent_0._v);
      } else {
        tmp_4 = new Pair(null, null);
      }
      var _destruct__k2r9zo = tmp_4;
      var placeholders = _destruct__k2r9zo.zh();
      var inlineComposables = _destruct__k2r9zo.ai();
      var tmp_5;
      if (hasInlineContent) {
        $composer_0.m30(146318828);
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_2 = this_0.i31();
        var tmp_6;
        if (false || it_2 === Companion_getInstance_11().f30_1) {
          var value_2 = mutableStateOf(null);
          this_0.j31(value_2);
          tmp_6 = value_2;
        } else {
          tmp_6 = it_2;
        }
        var tmp3_group = tmp_6;
        $composer_0.n30();
        tmp_5 = tmp3_group;
      } else {
        $composer_0.m30(146406588);
        $composer_0.n30();
        tmp_5 = null;
      }
      var measuredPlaceholderPositions = tmp_5;
      var tmp_7;
      if (hasInlineContent) {
        $composer_0.m30(146499837);
        var tmp0_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_0.k31(measuredPlaceholderPositions);
        // Inline function 'kotlin.let' call
        var it_3 = tmp0_2.i31();
        var tmp_8;
        if (invalid_2 || it_3 === Companion_getInstance_11().f30_1) {
          var value_3 = LayoutWithLinksAndInlineContent$lambda_1(measuredPlaceholderPositions);
          tmp0_2.j31(value_3);
          tmp_8 = value_3;
        } else {
          tmp_8 = it_3;
        }
        var tmp4_group = tmp_8;
        $composer_0.n30();
        tmp_7 = tmp4_group;
      } else {
        $composer_0.m30(146571260);
        $composer_0.n30();
        tmp_7 = null;
      }
      var onPlaceholderLayout = tmp_7;
      BackgroundTextMeasurement_0(text, style, fontFamilyResolver, placeholders, $composer_0, 14 & $dirty >> 3 | 112 & $dirty >> 12 | 896 & $dirty1 << 6);
      var tmp_9 = styledText();
      var tmp0_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = !!($composer_0.q31(textScope) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_4 = tmp0_3.i31();
      var tmp_10;
      if (invalid_3 || it_4 === Companion_getInstance_11().f30_1) {
        var value_4 = LayoutWithLinksAndInlineContent$lambda_2(textScope, onTextLayout);
        tmp0_3.j31(value_4);
        tmp_10 = value_4;
      } else {
        tmp_10 = it_4;
      }
      var tmp$ret$21 = tmp_10;
      var tmp0_4 = textModifier(modifier, tmp_9, style, tmp$ret$21, overflow, softWrap, maxLines, minLines, fontFamilyResolver, placeholders, onPlaceholderLayout, selectionController, color, onShowTranslation, autoSize);
      var tmp_11;
      if (!hasInlineContent) {
        $composer_0.m30(147750935);
        var tmp0_5 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_0.q31(textScope);
        // Inline function 'kotlin.let' call
        var it_5 = tmp0_5.i31();
        var tmp_12;
        if (invalid_4 || it_5 === Companion_getInstance_11().f30_1) {
          var value_5 = LayoutWithLinksAndInlineContent$lambda_3(textScope);
          tmp0_5.j31(value_5);
          tmp_12 = value_5;
        } else {
          tmp_12 = it_5;
        }
        var tmp$ret$25 = tmp_12;
        var tmp5_group = new LinksTextMeasurePolicy(tmp$ret$25);
        $composer_0.n30();
        tmp_11 = tmp5_group;
      } else {
        $composer_0.m30(147927697);
        var tmp0_6 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = $composer_0.q31(textScope);
        // Inline function 'kotlin.let' call
        var it_6 = tmp0_6.i31();
        var tmp_13;
        if (invalid_5 || it_6 === Companion_getInstance_11().f30_1) {
          var value_6 = LayoutWithLinksAndInlineContent$lambda_4(textScope);
          tmp0_6.j31(value_6);
          tmp_13 = value_6;
        } else {
          tmp_13 = it_6;
        }
        var tmp_14 = tmp_13;
        var tmp0_7 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_6 = $composer_0.k31(measuredPlaceholderPositions);
        // Inline function 'kotlin.let' call
        var it_7 = tmp0_7.i31();
        var tmp_15;
        if (invalid_6 || it_7 === Companion_getInstance_11().f30_1) {
          var value_7 = LayoutWithLinksAndInlineContent$lambda_5(measuredPlaceholderPositions);
          tmp0_7.j31(value_7);
          tmp_15 = value_7;
        } else {
          tmp_15 = it_7;
        }
        var tmp$ret$33 = tmp_15;
        var tmp6_group = new TextMeasurePolicy(tmp_14, tmp$ret$33);
        $composer_0.n30();
        tmp_11 = tmp6_group;
      }
      var tmp2 = tmp_11;
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = tmp0_4;
      var $composer_1 = $composer_0;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
      var localMap = $composer_1.t31();
      var materialized = materialize($composer_1, modifier_0);
      var tmp0_8 = Companion_getInstance_14().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_2 = $composer_1;
      var tmp_16 = $composer_2.g30();
      if (!isInterface(tmp_16, Applier)) {
        invalidApplier();
      }
      $composer_2.b31();
      if ($composer_2.h30()) {
        $composer_2.c31(tmp0_8);
      } else {
        $composer_2.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp2, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      var $composer_3 = $composer_2;
      if (textScope == null) {
        $composer_3.m30(-433557001);
        $composer_3.n30();
      } else {
        $composer_3.m30(-291080374);
        textScope.ck0($composer_3, 0);
        $composer_3.n30();
      }
      if (inlineComposables == null) {
        $composer_3.m30(-433506223);
        $composer_3.n30();
      } else {
        $composer_3.m30(-433506222);
        // Inline function 'kotlin.let' call
        InlineChildren(text, inlineComposables, $composer_3, 14 & $dirty >> 3);
        $composer_3.n30();
      }
      $composer_2.e31();
    } else {
      $composer_0.z30();
    }
    var tmp7_safe_receiver = $composer_0.t30();
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.p3c(LayoutWithLinksAndInlineContent$lambda_6(modifier, text, onTextLayout, hasInlineContent, inlineContent_0, style, overflow, softWrap, maxLines, minLines, fontFamilyResolver, selectionController, color, onShowTranslation, autoSize, $changed, $changed1, $default));
    }
  }
  function LinksTextMeasurePolicy$measure$lambda($measurables, this$0) {
    return function ($this$layout) {
      var linksToPlace = measureWithTextRangeMeasureConstraints($measurables, this$0.dk0_1);
      if (linksToPlace == null)
        null;
      else {
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = linksToPlace.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = linksToPlace.l1(index);
            var placeable = item.zh();
            var measureResult = item.ai();
            var tmp;
            if (measureResult == null) {
              tmp = null;
            } else {
              var tmp_0 = measureResult();
              tmp = tmp_0 == null ? null : tmp_0.a5g_1;
            }
            var tmp1_elvis_lhs = tmp;
            var tmp_1;
            var tmp_2 = tmp1_elvis_lhs;
            if ((tmp_2 == null ? null : new IntOffset(tmp_2)) == null) {
              tmp_1 = Companion_getInstance_21().c5g_1;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }
            $this$layout.lal(placeable, tmp_1);
          }
           while (inductionVariable <= last);
      }
      return Unit_instance;
    };
  }
  function LinksTextMeasurePolicy(shouldMeasureLinks) {
    this.dk0_1 = shouldMeasureLinks;
  }
  protoOf(LinksTextMeasurePolicy).mak = function (_this__u8e3s4, measurables, constraints) {
    var tmp = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    var tmp_0 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    return _this__u8e3s4.n8y(tmp, tmp_0, VOID, LinksTextMeasurePolicy$measure$lambda(measurables, this));
  };
  function TextMeasurePolicy$measure$lambda($inlineContentToPlace, $linksToPlace) {
    return function ($this$layout) {
      var tmp0_safe_receiver = $inlineContentToPlace;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = tmp0_safe_receiver.l1(index);
            var placeable = item.zh();
            var position = item.ai().a5g_1;
            $this$layout.lal(placeable, position);
          }
           while (inductionVariable <= last);
      }
      var tmp1_safe_receiver = $linksToPlace;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp1_safe_receiver.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = tmp1_safe_receiver.l1(index_0);
            var placeable_0 = item_0.zh();
            var measureResult = item_0.ai();
            var tmp;
            if (measureResult == null) {
              tmp = null;
            } else {
              var tmp_0 = measureResult();
              tmp = tmp_0 == null ? null : tmp_0.a5g_1;
            }
            var tmp1_elvis_lhs = tmp;
            var tmp_1;
            var tmp_2 = tmp1_elvis_lhs;
            if ((tmp_2 == null ? null : new IntOffset(tmp_2)) == null) {
              tmp_1 = Companion_getInstance_21().c5g_1;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }
            $this$layout.lal(placeable_0, tmp_1);
          }
           while (inductionVariable_0 <= last_0);
      }
      return Unit_instance;
    };
  }
  function TextMeasurePolicy(shouldMeasureLinks, placements) {
    this.ek0_1 = shouldMeasureLinks;
    this.fk0_1 = placements;
  }
  protoOf(TextMeasurePolicy).mak = function (_this__u8e3s4, measurables, constraints) {
    // Inline function 'androidx.compose.ui.util.fastFilter' call
    var target = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        var tmp = item.xag();
        if (!(tmp instanceof TextRangeLayoutModifier)) {
          // Inline function 'kotlin.collections.plusAssign' call
          target.j1(item);
        }
      }
       while (inductionVariable <= last);
    var inlineContentMeasurables = target;
    var tmp0_safe_receiver = this.fk0_1();
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'androidx.compose.ui.util.fastMapIndexedNotNull' call
      var target_0 = ArrayList_init_$Create$_0(tmp0_safe_receiver.n1());
      // Inline function 'androidx.compose.ui.util.fastForEachIndexed' call
      var inductionVariable_0 = 0;
      var last_0 = tmp0_safe_receiver.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = tmp0_safe_receiver.l1(index_0);
          var tmp_1;
          if (item_0 == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_2 = inlineContentMeasurables.l1(index_0);
            // Inline function 'androidx.compose.ui.geometry.Rect.width' call
            // Inline function 'kotlin.math.floor' call
            var x = item_0.m5d_1 - item_0.k5d_1;
            var tmp$ret$12 = Math.floor(x);
            var tmp_3 = numberToInt(tmp$ret$12);
            // Inline function 'androidx.compose.ui.geometry.Rect.height' call
            // Inline function 'kotlin.math.floor' call
            var x_0 = item_0.n5d_1 - item_0.l5d_1;
            var tmp$ret$14 = Math.floor(x_0);
            var tmp_4 = tmp_2.h8y(Constraints_0(VOID, tmp_3, VOID, numberToInt(tmp$ret$14)));
            // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
            var this_0 = item_0.k5d_1;
            var tmp_5;
            if (isNaN_0(this_0)) {
              tmp_5 = 0;
            } else {
              // Inline function 'kotlin.math.roundToInt' call
              tmp_5 = roundToInt(this_0);
            }
            var tmp0 = tmp_5;
            // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
            var this_1 = item_0.l5d_1;
            var tmp_6;
            if (isNaN_0(this_1)) {
              tmp_6 = 0;
            } else {
              // Inline function 'kotlin.math.roundToInt' call
              tmp_6 = roundToInt(this_1);
            }
            // Inline function 'androidx.compose.ui.unit.IntOffset' call
            // Inline function 'androidx.compose.ui.util.packInts' call
            var val2 = tmp_6;
            var tmp$ret$20 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
            var tmp$ret$19 = _IntOffset___init__impl__rq8h7b(tmp$ret$20);
            tmp_1 = new Pair(tmp_4, new IntOffset(tmp$ret$19));
          }
          var tmp0_safe_receiver_0 = tmp_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.plusAssign' call
            target_0.j1(tmp0_safe_receiver_0);
          }
        }
         while (inductionVariable_0 <= last_0);
      tmp_0 = target_0;
    }
    var inlineContentToPlace = tmp_0;
    // Inline function 'androidx.compose.ui.util.fastFilter' call
    var target_1 = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable_1 = 0;
    var last_1 = measurables.n1() - 1 | 0;
    if (inductionVariable_1 <= last_1)
      do {
        var index_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var item_1 = measurables.l1(index_1);
        var tmp_7 = item_1.xag();
        if (tmp_7 instanceof TextRangeLayoutModifier) {
          // Inline function 'kotlin.collections.plusAssign' call
          target_1.j1(item_1);
        }
      }
       while (inductionVariable_1 <= last_1);
    var linksMeasurables = target_1;
    var linksToPlace = measureWithTextRangeMeasureConstraints(linksMeasurables, this.ek0_1);
    var tmp_8 = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    var tmp_9 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    return _this__u8e3s4.n8y(tmp_8, tmp_9, VOID, TextMeasurePolicy$measure$lambda(inlineContentToPlace, linksToPlace));
  };
  function measureWithTextRangeMeasureConstraints(measurables, shouldMeasureLinks) {
    var tmp;
    if (shouldMeasureLinks()) {
      var textRangeLayoutMeasureScope = new TextRangeLayoutMeasureScope();
      // Inline function 'androidx.compose.ui.util.fastMapIndexedNotNull' call
      var target = ArrayList_init_$Create$_0(measurables.n1());
      // Inline function 'androidx.compose.ui.util.fastForEachIndexed' call
      var inductionVariable = 0;
      var last = measurables.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = measurables.l1(index);
          var tmp_0 = item.xag();
          var rangeMeasurePolicy = (tmp_0 instanceof TextRangeLayoutModifier ? tmp_0 : THROW_CCE()).gk0_1;
          // Inline function 'kotlin.with' call
          var rangeMeasureResult = rangeMeasurePolicy.hk0(textRangeLayoutMeasureScope);
          var placeable = item.h8y(Companion_instance_4.s5e(rangeMeasureResult.ik0_1, rangeMeasureResult.ik0_1, rangeMeasureResult.jk0_1, rangeMeasureResult.jk0_1));
          var tmp0_safe_receiver = new Pair(placeable, rangeMeasureResult.kk0_1);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.plusAssign' call
            target.j1(tmp0_safe_receiver);
          }
        }
         while (inductionVariable <= last);
      tmp = target;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function BasicText$lambda($selectionRegistrar) {
    return function () {
      return $selectionRegistrar.lk0();
    };
  }
  function BasicText$lambda_0($text, $modifier, $style, $onTextLayout, $overflow, $softWrap, $maxLines, $minLines, $color, $autoSize, $$changed, $$default) {
    return function ($composer, $force) {
      BasicText($text, $modifier._v, $style._v, $onTextLayout._v, $overflow._v.q8e_1, $softWrap._v, $maxLines._v, $minLines._v, $color._v, $autoSize._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function selectionIdSaver$lambda($selectionRegistrar) {
    return function ($this$Saver, it) {
      return hasSelection($selectionRegistrar, it) ? it : null;
    };
  }
  function selectionIdSaver$lambda_0(it) {
    return it;
  }
  function BasicText$lambda_1($selectionRegistrar) {
    return function () {
      return $selectionRegistrar.lk0();
    };
  }
  function BasicText$lambda_2($displayedText$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('displayedText', KMutableProperty0, true);
    return $displayedText$delegate.u1();
  }
  function BasicText$lambda_3($displayedText$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('displayedText', KMutableProperty0, true);
    $displayedText$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BasicText$lambda_4($displayedText$delegate) {
    return function (substitutionValue) {
      var tmp;
      if (substitutionValue.ok0_1) {
        tmp = substitutionValue.nk0_1;
      } else {
        tmp = substitutionValue.mk0_1;
      }
      BasicText$lambda_3($displayedText$delegate, tmp);
      return Unit_instance;
    };
  }
  function BasicText$lambda_5($text, $modifier, $style, $onTextLayout, $overflow, $softWrap, $maxLines, $minLines, $inlineContent, $color, $autoSize, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      BasicText_0($text, $modifier._v, $style._v, $onTextLayout._v, $overflow._v.q8e_1, $softWrap._v, $maxLines._v, $minLines._v, $inlineContent._v, $color._v, $autoSize._v, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function LayoutWithLinksAndInlineContent$lambda($textScope, $text) {
    return function () {
      var tmp0_safe_receiver = $textScope;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qk0();
      return tmp1_elvis_lhs == null ? $text : tmp1_elvis_lhs;
    };
  }
  function LayoutWithLinksAndInlineContent$lambda_0($text) {
    return function () {
      return $text;
    };
  }
  function LayoutWithLinksAndInlineContent$lambda_1($measuredPlaceholderPositions) {
    return function (it) {
      var tmp0_safe_receiver = $measuredPlaceholderPositions;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.s21(it);
      }
      return Unit_instance;
    };
  }
  function LayoutWithLinksAndInlineContent$lambda_2($textScope, $onTextLayout) {
    return function (it) {
      var tmp0_safe_receiver = $textScope;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.rk0(it);
      }
      var tmp1_safe_receiver = $onTextLayout;
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver(it);
      return Unit_instance;
    };
  }
  function LayoutWithLinksAndInlineContent$lambda_3($textScope) {
    return function () {
      var tmp0_safe_receiver = $textScope;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = tmp0_safe_receiver.sk0()();
      }
      var tmp1_elvis_lhs = tmp;
      return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    };
  }
  function LayoutWithLinksAndInlineContent$lambda_4($textScope) {
    return function () {
      var tmp0_safe_receiver = $textScope;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = tmp0_safe_receiver.sk0()();
      }
      var tmp1_elvis_lhs = tmp;
      return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    };
  }
  function LayoutWithLinksAndInlineContent$lambda_5($measuredPlaceholderPositions) {
    return function () {
      var tmp0_safe_receiver = $measuredPlaceholderPositions;
      return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u1();
    };
  }
  function LayoutWithLinksAndInlineContent$lambda_6($modifier, $text, $onTextLayout, $hasInlineContent, $inlineContent, $style, $overflow, $softWrap, $maxLines, $minLines, $fontFamilyResolver, $selectionController, $color, $onShowTranslation, $autoSize, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      LayoutWithLinksAndInlineContent($modifier, $text, $onTextLayout, $hasInlineContent, $inlineContent._v, $style, $overflow, $softWrap, $maxLines, $minLines, $fontFamilyResolver, $selectionController, $color, $onShowTranslation, $autoSize, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  var DefaultTextFieldDecorator;
  var MinTouchTargetSizeForHandles;
  function BasicTextField(value, onValueChange, modifier, enabled, readOnly, textStyle, keyboardOptions, keyboardActions, singleLine, maxLines, minLines, visualTransformation, onTextLayout, interactionSource, cursorBrush, decorationBox, $composer, $changed, $changed1, $default) {
    _init_properties_BasicTextField_kt__a2sezl();
    var modifier_0 = {_v: modifier};
    var enabled_0 = {_v: enabled};
    var readOnly_0 = {_v: readOnly};
    var textStyle_0 = {_v: textStyle};
    var keyboardOptions_0 = {_v: keyboardOptions};
    var keyboardActions_0 = {_v: keyboardActions};
    var singleLine_0 = {_v: singleLine};
    var maxLines_0 = {_v: maxLines};
    var minLines_0 = {_v: minLines};
    var visualTransformation_0 = {_v: visualTransformation};
    var onTextLayout_0 = {_v: onTextLayout};
    var interactionSource_0 = {_v: interactionSource};
    var cursorBrush_0 = {_v: cursorBrush};
    var decorationBox_0 = {_v: decorationBox};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(2026950908);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(value) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onValueChange) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(readOnly_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.k31(textStyle_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(keyboardOptions_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.k31(keyboardActions_0._v) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.l31(singleLine_0._v) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | (($default & 512) === 0 && $composer_0.m31(maxLines_0._v) ? 536870912 : 268435456);
    if (!(($default & 1024) === 0))
      $dirty1 = $dirty1 | 6;
    else if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.m31(minLines_0._v) ? 4 : 2);
    if (!(($default & 2048) === 0))
      $dirty1 = $dirty1 | 48;
    else if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(visualTransformation_0._v) ? 32 : 16);
    if (!(($default & 4096) === 0))
      $dirty1 = $dirty1 | 384;
    else if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(onTextLayout_0._v) ? 256 : 128);
    if (!(($default & 8192) === 0))
      $dirty1 = $dirty1 | 3072;
    else if (($changed1 & 3072) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(interactionSource_0._v) ? 2048 : 1024);
    if (!(($default & 16384) === 0))
      $dirty1 = $dirty1 | 24576;
    else if (($changed1 & 24576) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(cursorBrush_0._v) ? 16384 : 8192);
    if (!(($default & 32768) === 0))
      $dirty1 = $dirty1 | 196608;
    else if (($changed1 & 196608) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(decorationBox_0._v) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 74899) === 74898), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 4) === 0)) {
          modifier_0._v = Companion_instance_0;
        }
        if (!(($default & 8) === 0)) {
          enabled_0._v = true;
        }
        if (!(($default & 16) === 0)) {
          readOnly_0._v = false;
        }
        if (!(($default & 32) === 0)) {
          textStyle_0._v = Companion_getInstance_38().n81_1;
        }
        if (!(($default & 64) === 0)) {
          keyboardOptions_0._v = Companion_getInstance_76().tk0_1;
        }
        if (!(($default & 128) === 0)) {
          keyboardActions_0._v = Companion_getInstance_75().vk0_1;
        }
        if (!(($default & 256) === 0)) {
          singleLine_0._v = false;
        }
        if (!(($default & 512) === 0)) {
          maxLines_0._v = singleLine_0._v ? 1 : 2147483647;
          $dirty = $dirty & -1879048193;
        }
        if (!(($default & 1024) === 0)) {
          minLines_0._v = 1;
        }
        if (!(($default & 2048) === 0)) {
          visualTransformation_0._v = Companion_getInstance_40().o8d_1;
        }
        if (!(($default & 4096) === 0)) {
          // Inline function 'androidx.compose.runtime.cache' call
          var this_0 = $composer_0;
          // Inline function 'kotlin.let' call
          var it = this_0.i31();
          var tmp;
          if (false || it === Companion_getInstance_11().f30_1) {
            var value_0 = BasicTextField$lambda;
            this_0.j31(value_0);
            tmp = value_0;
          } else {
            tmp = it;
          }
          onTextLayout_0._v = tmp;
        }
        if (!(($default & 8192) === 0)) {
          interactionSource_0._v = null;
        }
        if (!(($default & 16384) === 0)) {
          cursorBrush_0._v = new SolidColor(Companion_getInstance().i6b_1);
        }
        if (!(($default & 32768) === 0)) {
          decorationBox_0._v = ComposableSingletons$BasicTextFieldKt_getInstance().xk0_1;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 512) === 0))
          $dirty = $dirty & -1879048193;
      }
      $composer_0.r30();
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var value_1 = mutableStateOf(TextFieldValue_init_$Create$(value));
        this_1.j31(value_1);
        tmp_0 = value_1;
      } else {
        tmp_0 = it_0;
      }
      var textFieldValueState$delegate = tmp_0;
      var textFieldValue = BasicTextField$lambda_0(textFieldValueState$delegate).u8c(value);
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.k31(textFieldValue);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0.i31();
      var tmp_1;
      if (invalid || it_1 === Companion_getInstance_11().f30_1) {
        var value_2 = BasicTextField$lambda_2(textFieldValue, textFieldValueState$delegate);
        tmp0.j31(value_2);
        tmp_1 = value_2;
      } else {
        tmp_1 = it_1;
      }
      var tmp$ret$8 = tmp_1;
      SideEffect(tmp$ret$8, $composer_0, 0);
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = ($dirty & 14) === 4;
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_0.i31();
      var tmp_2;
      if (invalid_0 || it_2 === Companion_getInstance_11().f30_1) {
        var value_3 = mutableStateOf(value);
        tmp0_0.j31(value_3);
        tmp_2 = value_3;
      } else {
        tmp_2 = it_2;
      }
      var lastTextValue$delegate = tmp_2;
      var tmp0_imeOptions = keyboardOptions_0._v.ik1(singleLine_0._v);
      var tmp1_softWrap = !singleLine_0._v;
      var tmp2_minLines = singleLine_0._v ? 1 : minLines_0._v;
      var tmp3_maxLines = singleLine_0._v ? 1 : maxLines_0._v;
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!($composer_0.k31(lastTextValue$delegate) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_1.i31();
      var tmp_3;
      if (invalid_1 || it_3 === Companion_getInstance_11().f30_1) {
        var value_4 = BasicTextField$lambda_5(onValueChange, textFieldValueState$delegate, lastTextValue$delegate);
        tmp0_1.j31(value_4);
        tmp_3 = value_4;
      } else {
        tmp_3 = it_3;
      }
      var tmp_4 = tmp_3;
      var tmp_5 = modifier_0._v;
      var tmp_6 = textStyle_0._v;
      var tmp_7 = visualTransformation_0._v;
      var tmp_8 = onTextLayout_0._v;
      var tmp_9 = interactionSource_0._v;
      var tmp_10 = cursorBrush_0._v;
      var tmp_11 = keyboardActions_0._v;
      var tmp_12 = enabled_0._v;
      var tmp_13 = readOnly_0._v;
      var tmp_14 = decorationBox_0._v;
      CoreTextField(textFieldValue, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp1_softWrap, tmp3_maxLines, tmp2_minLines, tmp0_imeOptions, tmp_11, tmp_12, tmp_13, tmp_14, null, $composer_0, 896 & $dirty | 7168 & $dirty >> 6 | 57344 & $dirty1 << 9 | 458752 & $dirty1 << 9 | 3670016 & $dirty1 << 9 | 29360128 & $dirty1 << 9, 896 & $dirty >> 15 | 7168 & $dirty | 57344 & $dirty | 458752 & $dirty1, 65536);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(BasicTextField$lambda_6(value, onValueChange, modifier_0, enabled_0, readOnly_0, textStyle_0, keyboardOptions_0, keyboardActions_0, singleLine_0, maxLines_0, minLines_0, visualTransformation_0, onTextLayout_0, interactionSource_0, cursorBrush_0, decorationBox_0, $changed, $changed1, $default));
    }
  }
  function ComposableLambda$invoke$ref_6(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function ComposableSingletons$BasicTextFieldKt$lambda$_1706861840$lambda_9jo0kh(it, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(it) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      it($composer_0, 14 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BasicTextFieldKt$lambda$759698998$lambda(innerTextField, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(innerTextField) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      innerTextField($composer_0, 14 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BasicTextFieldKt$lambda$486633673$lambda(innerTextField, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(innerTextField) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      innerTextField($composer_0, 14 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BasicTextFieldKt$lambda$444370233$lambda(innerTextField, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(innerTextField) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      innerTextField($composer_0, 14 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BasicTextFieldKt$lambda$_665310900$lambda_ti0b2k(innerTextField, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(innerTextField) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      innerTextField($composer_0, 14 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BasicTextFieldKt() {
    ComposableSingletons$BasicTextFieldKt_instance = this;
    var tmp = this;
    tmp.wk0_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(-1706861840, false, ComposableSingletons$BasicTextFieldKt$lambda$_1706861840$lambda_9jo0kh));
    var tmp_0 = this;
    tmp_0.xk0_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(759698998, false, ComposableSingletons$BasicTextFieldKt$lambda$759698998$lambda));
    var tmp_1 = this;
    tmp_1.yk0_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(486633673, false, ComposableSingletons$BasicTextFieldKt$lambda$486633673$lambda));
    var tmp_2 = this;
    tmp_2.zk0_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(444370233, false, ComposableSingletons$BasicTextFieldKt$lambda$444370233$lambda));
    var tmp_3 = this;
    tmp_3.ak1_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(-665310900, false, ComposableSingletons$BasicTextFieldKt$lambda$_665310900$lambda_ti0b2k));
  }
  var ComposableSingletons$BasicTextFieldKt_instance;
  function ComposableSingletons$BasicTextFieldKt_getInstance() {
    if (ComposableSingletons$BasicTextFieldKt_instance == null)
      new ComposableSingletons$BasicTextFieldKt();
    return ComposableSingletons$BasicTextFieldKt_instance;
  }
  function BasicTextField_0(value, onValueChange, modifier, enabled, readOnly, textStyle, keyboardOptions, keyboardActions, singleLine, maxLines, minLines, visualTransformation, onTextLayout, interactionSource, cursorBrush, decorationBox, $composer, $changed, $changed1, $default) {
    _init_properties_BasicTextField_kt__a2sezl();
    var modifier_0 = {_v: modifier};
    var enabled_0 = {_v: enabled};
    var readOnly_0 = {_v: readOnly};
    var textStyle_0 = {_v: textStyle};
    var keyboardOptions_0 = {_v: keyboardOptions};
    var keyboardActions_0 = {_v: keyboardActions};
    var singleLine_0 = {_v: singleLine};
    var maxLines_0 = {_v: maxLines};
    var minLines_0 = {_v: minLines};
    var visualTransformation_0 = {_v: visualTransformation};
    var onTextLayout_0 = {_v: onTextLayout};
    var interactionSource_0 = {_v: interactionSource};
    var cursorBrush_0 = {_v: cursorBrush};
    var decorationBox_0 = {_v: decorationBox};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-971111025);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(value) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onValueChange) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(readOnly_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.k31(textStyle_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(keyboardOptions_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.k31(keyboardActions_0._v) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.l31(singleLine_0._v) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | (($default & 512) === 0 && $composer_0.m31(maxLines_0._v) ? 536870912 : 268435456);
    if (!(($default & 1024) === 0))
      $dirty1 = $dirty1 | 6;
    else if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.m31(minLines_0._v) ? 4 : 2);
    if (!(($default & 2048) === 0))
      $dirty1 = $dirty1 | 48;
    else if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(visualTransformation_0._v) ? 32 : 16);
    if (!(($default & 4096) === 0))
      $dirty1 = $dirty1 | 384;
    else if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(onTextLayout_0._v) ? 256 : 128);
    if (!(($default & 8192) === 0))
      $dirty1 = $dirty1 | 3072;
    else if (($changed1 & 3072) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(interactionSource_0._v) ? 2048 : 1024);
    if (!(($default & 16384) === 0))
      $dirty1 = $dirty1 | 24576;
    else if (($changed1 & 24576) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(cursorBrush_0._v) ? 16384 : 8192);
    if (!(($default & 32768) === 0))
      $dirty1 = $dirty1 | 196608;
    else if (($changed1 & 196608) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(decorationBox_0._v) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 74899) === 74898), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 4) === 0)) {
          modifier_0._v = Companion_instance_0;
        }
        if (!(($default & 8) === 0)) {
          enabled_0._v = true;
        }
        if (!(($default & 16) === 0)) {
          readOnly_0._v = false;
        }
        if (!(($default & 32) === 0)) {
          textStyle_0._v = Companion_getInstance_38().n81_1;
        }
        if (!(($default & 64) === 0)) {
          keyboardOptions_0._v = Companion_getInstance_76().tk0_1;
        }
        if (!(($default & 128) === 0)) {
          keyboardActions_0._v = Companion_getInstance_75().vk0_1;
        }
        if (!(($default & 256) === 0)) {
          singleLine_0._v = false;
        }
        if (!(($default & 512) === 0)) {
          maxLines_0._v = singleLine_0._v ? 1 : 2147483647;
          $dirty = $dirty & -1879048193;
        }
        if (!(($default & 1024) === 0)) {
          minLines_0._v = 1;
        }
        if (!(($default & 2048) === 0)) {
          visualTransformation_0._v = Companion_getInstance_40().o8d_1;
        }
        if (!(($default & 4096) === 0)) {
          // Inline function 'androidx.compose.runtime.cache' call
          var this_0 = $composer_0;
          // Inline function 'kotlin.let' call
          var it = this_0.i31();
          var tmp;
          if (false || it === Companion_getInstance_11().f30_1) {
            var value_0 = BasicTextField$lambda_7;
            this_0.j31(value_0);
            tmp = value_0;
          } else {
            tmp = it;
          }
          onTextLayout_0._v = tmp;
        }
        if (!(($default & 8192) === 0)) {
          interactionSource_0._v = null;
        }
        if (!(($default & 16384) === 0)) {
          cursorBrush_0._v = new SolidColor(Companion_getInstance().i6b_1);
        }
        if (!(($default & 32768) === 0)) {
          decorationBox_0._v = ComposableSingletons$BasicTextFieldKt_getInstance().yk0_1;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 512) === 0))
          $dirty = $dirty & -1879048193;
      }
      $composer_0.r30();
      var tmp0_imeOptions = keyboardOptions_0._v.ik1(singleLine_0._v);
      var tmp1_softWrap = !singleLine_0._v;
      var tmp2_minLines = singleLine_0._v ? 1 : minLines_0._v;
      var tmp3_maxLines = singleLine_0._v ? 1 : maxLines_0._v;
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 14) === 4 | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0.i31();
      var tmp_0;
      if (invalid || it_0 === Companion_getInstance_11().f30_1) {
        var value_1 = BasicTextField$lambda_8(value, onValueChange);
        tmp0.j31(value_1);
        tmp_0 = value_1;
      } else {
        tmp_0 = it_0;
      }
      var tmp_1 = tmp_0;
      var tmp_2 = modifier_0._v;
      var tmp_3 = textStyle_0._v;
      var tmp_4 = visualTransformation_0._v;
      var tmp_5 = onTextLayout_0._v;
      var tmp_6 = interactionSource_0._v;
      var tmp_7 = cursorBrush_0._v;
      var tmp_8 = keyboardActions_0._v;
      var tmp_9 = enabled_0._v;
      var tmp_10 = readOnly_0._v;
      var tmp_11 = decorationBox_0._v;
      CoreTextField(value, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp1_softWrap, tmp3_maxLines, tmp2_minLines, tmp0_imeOptions, tmp_8, tmp_9, tmp_10, tmp_11, null, $composer_0, 14 & $dirty | 896 & $dirty | 7168 & $dirty >> 6 | 57344 & $dirty1 << 9 | 458752 & $dirty1 << 9 | 3670016 & $dirty1 << 9 | 29360128 & $dirty1 << 9, 896 & $dirty >> 15 | 7168 & $dirty | 57344 & $dirty | 458752 & $dirty1, 65536);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(BasicTextField$lambda_9(value, onValueChange, modifier_0, enabled_0, readOnly_0, textStyle_0, keyboardOptions_0, keyboardActions_0, singleLine_0, maxLines_0, minLines_0, visualTransformation_0, onTextLayout_0, interactionSource_0, cursorBrush_0, decorationBox_0, $changed, $changed1, $default));
    }
  }
  function sam$androidx_compose_foundation_text_input_TextFieldDecorator$0(function_0) {
    this.jk1_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_text_input_TextFieldDecorator$0).q3 = function () {
    return this.jk1_1;
  };
  protoOf(sam$androidx_compose_foundation_text_input_TextFieldDecorator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, TextFieldDecorator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_text_input_TextFieldDecorator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function BasicTextField$lambda(it) {
    _init_properties_BasicTextField_kt__a2sezl();
    return Unit_instance;
  }
  function BasicTextField$lambda_0($textFieldValueState$delegate) {
    _init_properties_BasicTextField_kt__a2sezl();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('textFieldValueState', KMutableProperty0, true);
    return $textFieldValueState$delegate.u1();
  }
  function BasicTextField$lambda_1($textFieldValueState$delegate, _set____db54di) {
    _init_properties_BasicTextField_kt__a2sezl();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('textFieldValueState', KMutableProperty0, true);
    $textFieldValueState$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BasicTextField$lambda_2($textFieldValue, $textFieldValueState$delegate) {
    return function () {
      var tmp;
      var tmp_0;
      if (!equals($textFieldValue.g8a_1, BasicTextField$lambda_0($textFieldValueState$delegate).g8a_1)) {
        tmp_0 = true;
      } else {
        var tmp_1 = $textFieldValue.h8a_1;
        var tmp_2 = tmp_1 == null ? null : new TextRange(tmp_1);
        var tmp_3 = BasicTextField$lambda_0($textFieldValueState$delegate).h8a_1;
        tmp_0 = !equals(tmp_2, tmp_3 == null ? null : new TextRange(tmp_3));
      }
      if (tmp_0) {
        BasicTextField$lambda_1($textFieldValueState$delegate, $textFieldValue);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BasicTextField$lambda_3($lastTextValue$delegate) {
    _init_properties_BasicTextField_kt__a2sezl();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('lastTextValue', KMutableProperty0, true);
    return $lastTextValue$delegate.u1();
  }
  function BasicTextField$lambda_4($lastTextValue$delegate, _set____db54di) {
    _init_properties_BasicTextField_kt__a2sezl();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('lastTextValue', KMutableProperty0, true);
    $lastTextValue$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BasicTextField$lambda_5($onValueChange, $textFieldValueState$delegate, $lastTextValue$delegate) {
    return function (newTextFieldValueState) {
      BasicTextField$lambda_1($textFieldValueState$delegate, newTextFieldValueState);
      var stringChangedSinceLastInvocation = !(BasicTextField$lambda_3($lastTextValue$delegate) === newTextFieldValueState.h89());
      BasicTextField$lambda_4($lastTextValue$delegate, newTextFieldValueState.h89());
      var tmp;
      if (stringChangedSinceLastInvocation) {
        tmp = $onValueChange(newTextFieldValueState.h89());
      }
      return Unit_instance;
    };
  }
  function BasicTextField$lambda_6($value, $onValueChange, $modifier, $enabled, $readOnly, $textStyle, $keyboardOptions, $keyboardActions, $singleLine, $maxLines, $minLines, $visualTransformation, $onTextLayout, $interactionSource, $cursorBrush, $decorationBox, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      BasicTextField($value, $onValueChange, $modifier._v, $enabled._v, $readOnly._v, $textStyle._v, $keyboardOptions._v, $keyboardActions._v, $singleLine._v, $maxLines._v, $minLines._v, $visualTransformation._v, $onTextLayout._v, $interactionSource._v, $cursorBrush._v, $decorationBox._v, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function BasicTextField$lambda_7(it) {
    _init_properties_BasicTextField_kt__a2sezl();
    return Unit_instance;
  }
  function BasicTextField$lambda_8($value, $onValueChange) {
    return function (it) {
      var tmp;
      if (!$value.equals(it)) {
        tmp = $onValueChange(it);
      }
      return Unit_instance;
    };
  }
  function BasicTextField$lambda_9($value, $onValueChange, $modifier, $enabled, $readOnly, $textStyle, $keyboardOptions, $keyboardActions, $singleLine, $maxLines, $minLines, $visualTransformation, $onTextLayout, $interactionSource, $cursorBrush, $decorationBox, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      BasicTextField_0($value, $onValueChange, $modifier._v, $enabled._v, $readOnly._v, $textStyle._v, $keyboardOptions._v, $keyboardActions._v, $singleLine._v, $maxLines._v, $minLines._v, $visualTransformation._v, $onTextLayout._v, $interactionSource._v, $cursorBrush._v, $decorationBox._v, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  var properties_initialized_BasicTextField_kt_8bw99b;
  function _init_properties_BasicTextField_kt__a2sezl() {
    if (!properties_initialized_BasicTextField_kt_8bw99b) {
      properties_initialized_BasicTextField_kt_8bw99b = true;
      var tmp = ComposableSingletons$BasicTextFieldKt_getInstance().wk0_1;
      DefaultTextFieldDecorator = new sam$androidx_compose_foundation_text_input_TextFieldDecorator$0(tmp);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_0 = _Dp___init__impl__ms3zkb(40);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(40);
      MinTouchTargetSizeForHandles = DpSize_0(tmp_0, tmp$ret$1);
    }
  }
  function CommonContextMenuArea(manager, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1533506138);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(manager) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (ComposeFoundationFlags_instance.hfg_1) {
        $composer_0.m30(-885604480);
        ProvideDefaultPlatformTextContextMenuProviders(manager.vk2(), content, $composer_0, 112 & $dirty, 0);
        $composer_0.n30();
      } else {
        $composer_0.m30(-885475365);
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance_11().f30_1) {
          var value = new ContextMenuState();
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var state = tmp;
        // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
        var getContext = null;
        var $composer_1 = $composer_0;
        if (!((1 & 1) === 0)) {
          getContext = CommonContextMenuArea$lambda;
        }
        var composer = $composer_1;
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_0;
        if (false || it_0 === Companion_getInstance_11().f30_1) {
          var value_0 = createCompositionCoroutineScope(getContext(), composer);
          $composer_1.j31(value_0);
          tmp_0 = value_0;
        } else {
          tmp_0 = it_0;
        }
        var coroutineScope = tmp_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var this_1 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_1 = this_1.i31();
        var tmp_1;
        if (false || it_1 === Companion_getInstance_11().f30_1) {
          var value_1 = mutableStateOf(new MenuItemsAvailability(Companion_getInstance_73().qk1_1));
          this_1.j31(value_1);
          tmp_1 = value_1;
        } else {
          tmp_1 = it_1;
        }
        var menuItemsAvailability = tmp_1;
        // Inline function 'androidx.compose.runtime.cache' call
        var this_2 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_2 = this_2.i31();
        var tmp_2;
        if (false || it_2 === Companion_getInstance_11().f30_1) {
          var value_2 = CommonContextMenuArea$lambda_0(state);
          this_2.j31(value_2);
          tmp_2 = value_2;
        } else {
          tmp_2 = it_2;
        }
        var tmp_3 = tmp_2;
        var tmp_4 = contextMenuBuilder(manager, state, menuItemsAvailability);
        var tmp_5 = manager.uk2();
        var tmp0 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.q31(coroutineScope) | $composer_0.q31(manager));
        // Inline function 'kotlin.let' call
        var it_3 = tmp0.i31();
        var tmp_6;
        if (invalid || it_3 === Companion_getInstance_11().f30_1) {
          var value_3 = CommonContextMenuArea$lambda_1(coroutineScope, menuItemsAvailability, manager);
          tmp0.j31(value_3);
          tmp_6 = value_3;
        } else {
          tmp_6 = it_3;
        }
        var tmp$ret$17 = tmp_6;
        ContextMenuArea(state, tmp_3, tmp_4, null, tmp_5, tmp$ret$17, content, $composer_0, 54 | 3670016 & $dirty << 15, 8);
        $composer_0.n30();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CommonContextMenuArea$lambda_2(manager, content, $changed));
    }
  }
  var TextContextMenuItems_Cut_instance;
  var TextContextMenuItems_Copy_instance;
  var TextContextMenuItems_Paste_instance;
  var TextContextMenuItems_SelectAll_instance;
  var TextContextMenuItems_Autofill_instance;
  var TextContextMenuItems_entriesInitialized;
  function TextContextMenuItems_initEntries() {
    if (TextContextMenuItems_entriesInitialized)
      return Unit_instance;
    TextContextMenuItems_entriesInitialized = true;
    TextContextMenuItems_Cut_instance = new TextContextMenuItems('Cut', 0, TextContextMenuKeys_getInstance().wk2_1, Companion_getInstance_91().bk3_1, Companion_getInstance_90().gk3_1);
    TextContextMenuItems_Copy_instance = new TextContextMenuItems('Copy', 1, TextContextMenuKeys_getInstance().xk2_1, Companion_getInstance_91().ck3_1, Companion_getInstance_90().hk3_1);
    TextContextMenuItems_Paste_instance = new TextContextMenuItems('Paste', 2, TextContextMenuKeys_getInstance().yk2_1, Companion_getInstance_91().dk3_1, Companion_getInstance_90().ik3_1);
    TextContextMenuItems_SelectAll_instance = new TextContextMenuItems('SelectAll', 3, TextContextMenuKeys_getInstance().zk2_1, Companion_getInstance_91().ek3_1, Companion_getInstance_90().jk3_1);
    TextContextMenuItems_Autofill_instance = new TextContextMenuItems('Autofill', 4, TextContextMenuKeys_getInstance().ak3_1, Companion_getInstance_91().fk3_1, Companion_getInstance_90().kk3_1);
  }
  function TextContextMenuItems(name, ordinal, key, stringId, drawableId) {
    Enum.call(this, name, ordinal);
    this.nk3_1 = key;
    this.ok3_1 = stringId;
    this.pk3_1 = drawableId;
  }
  protoOf(TextContextMenuItems).qk3 = function ($composer, $changed) {
    var $composer_0 = $composer;
    return getString(this.ok3_1, $composer_0, 0);
  };
  function _MenuItemsAvailability___init__impl__ezhwgz(value) {
    return value;
  }
  function _MenuItemsAvailability___get_value__impl__f2sj5($this) {
    return $this;
  }
  function _MenuItemsAvailability___init__impl__ezhwgz_0(canCopy, canPaste, canCut, canSelectAll, canAutofill) {
    return _MenuItemsAvailability___init__impl__ezhwgz((canCopy ? 1 : 0) | (canPaste ? 2 : 0) | (canCut ? 4 : 0) | (canSelectAll ? 8 : 0) | (canAutofill ? 16 : 0));
  }
  function Companion_14() {
    Companion_instance_24 = this;
    this.kk1_1 = 1;
    this.lk1_1 = 2;
    this.mk1_1 = 4;
    this.nk1_1 = 8;
    this.ok1_1 = 16;
    this.pk1_1 = 0;
    this.qk1_1 = _MenuItemsAvailability___init__impl__ezhwgz(0);
  }
  var Companion_instance_24;
  function Companion_getInstance_73() {
    if (Companion_instance_24 == null)
      new Companion_14();
    return Companion_instance_24;
  }
  function _MenuItemsAvailability___get_canCopy__impl__6h1bgj($this) {
    return (_MenuItemsAvailability___get_value__impl__f2sj5($this) & 1) === 1;
  }
  function _MenuItemsAvailability___get_canPaste__impl__n8yo1l($this) {
    return (_MenuItemsAvailability___get_value__impl__f2sj5($this) & 2) === 2;
  }
  function _MenuItemsAvailability___get_canCut__impl__fszy0a($this) {
    return (_MenuItemsAvailability___get_value__impl__f2sj5($this) & 4) === 4;
  }
  function _MenuItemsAvailability___get_canSelectAll__impl__u4suex($this) {
    return (_MenuItemsAvailability___get_value__impl__f2sj5($this) & 8) === 8;
  }
  function _MenuItemsAvailability___get_canAutofill__impl__anvhpc($this) {
    return (_MenuItemsAvailability___get_value__impl__f2sj5($this) & 16) === 16;
  }
  function MenuItemsAvailability__toString_impl_fwtkaj($this) {
    return 'MenuItemsAvailability(value=' + $this + ')';
  }
  function MenuItemsAvailability__hashCode_impl_xd4kvq($this) {
    return $this;
  }
  function MenuItemsAvailability__equals_impl_7s8h2m($this, other) {
    if (!(other instanceof MenuItemsAvailability))
      return false;
    if (!($this === other.rk3_1))
      return false;
    return true;
  }
  function MenuItemsAvailability(value) {
    Companion_getInstance_73();
    this.rk3_1 = value;
  }
  protoOf(MenuItemsAvailability).toString = function () {
    return MenuItemsAvailability__toString_impl_fwtkaj(this.rk3_1);
  };
  protoOf(MenuItemsAvailability).hashCode = function () {
    return MenuItemsAvailability__hashCode_impl_xd4kvq(this.rk3_1);
  };
  protoOf(MenuItemsAvailability).equals = function (other) {
    return MenuItemsAvailability__equals_impl_7s8h2m(this.rk3_1, other);
  };
  function getContextMenuItemsAvailability(_this__u8e3s4, $completion) {
    var tmp = new $getContextMenuItemsAvailabilityCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    var tmp_0 = tmp.v9();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  }
  function CommonContextMenuArea$lambda() {
    return EmptyCoroutineContext_getInstance();
  }
  function CommonContextMenuArea$lambda_0($state) {
    return function () {
      close($state);
      return Unit_instance;
    };
  }
  function CommonContextMenuArea$lambda$slambda($menuItemsAvailability, $manager, resultContinuation) {
    this.jk4_1 = $menuItemsAvailability;
    this.kk4_1 = $manager;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CommonContextMenuArea$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CommonContextMenuArea$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CommonContextMenuArea$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = getContextMenuItemsAvailability(this.kk4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.n9_1 = 2;
            continue $sm;
          case 1:
            var unboxed = suspendResult.rk3_1;
            suspendResult = new MenuItemsAvailability(unboxed);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult.rk3_1;
            this.jk4_1.s21(new MenuItemsAvailability(ARGUMENT));
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CommonContextMenuArea$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new CommonContextMenuArea$lambda$slambda(this.jk4_1, this.kk4_1, completion);
    i.lk4_1 = $this$launch;
    return i;
  };
  function CommonContextMenuArea$lambda$slambda_0($menuItemsAvailability, $manager, resultContinuation) {
    var i = new CommonContextMenuArea$lambda$slambda($menuItemsAvailability, $manager, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CommonContextMenuArea$lambda_1($coroutineScope, $menuItemsAvailability, $manager) {
    return function () {
      var tmp = CoroutineStart_UNDISPATCHED_getInstance();
      launch($coroutineScope, VOID, tmp, CommonContextMenuArea$lambda$slambda_0($menuItemsAvailability, $manager, null));
      return Unit_instance;
    };
  }
  function CommonContextMenuArea$lambda_2($manager, $content, $$changed) {
    return function ($composer, $force) {
      CommonContextMenuArea($manager, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function TextContextMenuItems_Cut_getInstance() {
    TextContextMenuItems_initEntries();
    return TextContextMenuItems_Cut_instance;
  }
  function TextContextMenuItems_Copy_getInstance() {
    TextContextMenuItems_initEntries();
    return TextContextMenuItems_Copy_instance;
  }
  function TextContextMenuItems_Paste_getInstance() {
    TextContextMenuItems_initEntries();
    return TextContextMenuItems_Paste_instance;
  }
  function TextContextMenuItems_SelectAll_getInstance() {
    TextContextMenuItems_initEntries();
    return TextContextMenuItems_SelectAll_instance;
  }
  function TextContextMenuItems_Autofill_getInstance() {
    TextContextMenuItems_initEntries();
    return TextContextMenuItems_Autofill_instance;
  }
  function $getContextMenuItemsAvailabilityCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ak4_1 = _this__u8e3s4;
  }
  protoOf($getContextMenuItemsAvailabilityCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.ak4_1.mk4(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return new MenuItemsAvailability(_MenuItemsAvailability___init__impl__ezhwgz_0(this.ak4_1.nk4(), this.ak4_1.ok4(), this.ak4_1.pk4(), this.ak4_1.qk4(), this.ak4_1.rk4()));
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var androidx_compose_foundation_text_LegacyTextFieldState$stable;
  function CoreTextField(value, onValueChange, modifier, textStyle, visualTransformation, onTextLayout, interactionSource, cursorBrush, softWrap, maxLines, minLines, imeOptions, keyboardActions, enabled, readOnly, decorationBox, textScrollerPosition, $composer, $changed, $changed1, $default) {
    var modifier_0 = {_v: modifier};
    var textStyle_0 = {_v: textStyle};
    var visualTransformation_0 = {_v: visualTransformation};
    var onTextLayout_0 = {_v: onTextLayout};
    var interactionSource_0 = {_v: interactionSource};
    var cursorBrush_0 = {_v: cursorBrush};
    var softWrap_0 = {_v: softWrap};
    var maxLines_0 = {_v: maxLines};
    var minLines_0 = {_v: minLines};
    var imeOptions_0 = {_v: imeOptions};
    var keyboardActions_0 = {_v: keyboardActions};
    var enabled_0 = {_v: enabled};
    var readOnly_0 = {_v: readOnly};
    var decorationBox_0 = {_v: decorationBox};
    var textScrollerPosition_0 = {_v: textScrollerPosition};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(31062401);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(value) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onValueChange) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(textStyle_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(visualTransformation_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onTextLayout_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(interactionSource_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.k31(cursorBrush_0._v) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.l31(softWrap_0._v) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.m31(maxLines_0._v) ? 536870912 : 268435456);
    if (!(($default & 1024) === 0))
      $dirty1 = $dirty1 | 6;
    else if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.m31(minLines_0._v) ? 4 : 2);
    if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | (($default & 2048) === 0 && $composer_0.k31(imeOptions_0._v) ? 32 : 16);
    if (!(($default & 4096) === 0))
      $dirty1 = $dirty1 | 384;
    else if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(keyboardActions_0._v) ? 256 : 128);
    if (!(($default & 8192) === 0))
      $dirty1 = $dirty1 | 3072;
    else if (($changed1 & 3072) === 0)
      $dirty1 = $dirty1 | ($composer_0.l31(enabled_0._v) ? 2048 : 1024);
    if (!(($default & 16384) === 0))
      $dirty1 = $dirty1 | 24576;
    else if (($changed1 & 24576) === 0)
      $dirty1 = $dirty1 | ($composer_0.l31(readOnly_0._v) ? 16384 : 8192);
    if (!(($default & 32768) === 0))
      $dirty1 = $dirty1 | 196608;
    else if (($changed1 & 196608) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(decorationBox_0._v) ? 131072 : 65536);
    if (!(($default & 65536) === 0))
      $dirty1 = $dirty1 | 1572864;
    else if (($changed1 & 1572864) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(textScrollerPosition_0._v) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 599187) === 599186), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 4) === 0)) {
          modifier_0._v = Companion_instance_0;
        }
        if (!(($default & 8) === 0)) {
          textStyle_0._v = Companion_getInstance_38().n81_1;
        }
        if (!(($default & 16) === 0)) {
          visualTransformation_0._v = Companion_getInstance_40().o8d_1;
        }
        if (!(($default & 32) === 0)) {
          // Inline function 'androidx.compose.runtime.cache' call
          var this_0 = $composer_0;
          // Inline function 'kotlin.let' call
          var it = this_0.i31();
          var tmp;
          if (false || it === Companion_getInstance_11().f30_1) {
            var value_0 = CoreTextField$lambda;
            this_0.j31(value_0);
            tmp = value_0;
          } else {
            tmp = it;
          }
          onTextLayout_0._v = tmp;
        }
        if (!(($default & 64) === 0)) {
          interactionSource_0._v = null;
        }
        if (!(($default & 128) === 0)) {
          cursorBrush_0._v = new SolidColor(Companion_getInstance().u6b_1);
        }
        if (!(($default & 256) === 0)) {
          softWrap_0._v = true;
        }
        if (!(($default & 512) === 0)) {
          maxLines_0._v = 2147483647;
        }
        if (!(($default & 1024) === 0)) {
          minLines_0._v = 1;
        }
        if (!(($default & 2048) === 0)) {
          imeOptions_0._v = Companion_getInstance_41().p8b_1;
          $dirty1 = $dirty1 & -113;
        }
        if (!(($default & 4096) === 0)) {
          keyboardActions_0._v = Companion_getInstance_75().vk0_1;
        }
        if (!(($default & 8192) === 0)) {
          enabled_0._v = true;
        }
        if (!(($default & 16384) === 0)) {
          readOnly_0._v = false;
        }
        if (!(($default & 32768) === 0)) {
          decorationBox_0._v = ComposableSingletons$CoreTextFieldKt_getInstance().sk4_1;
        }
        if (!(($default & 65536) === 0)) {
          textScrollerPosition_0._v = null;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 2048) === 0))
          $dirty1 = $dirty1 & -113;
      }
      $composer_0.r30();
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var value_1 = new FocusRequester();
        this_1.j31(value_1);
        tmp_0 = value_1;
      } else {
        tmp_0 = it_0;
      }
      var focusRequester = tmp_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_2.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance_11().f30_1) {
        var value_2 = createLegacyPlatformTextInputServiceAdapter();
        this_2.j31(value_2);
        tmp_1 = value_2;
      } else {
        tmp_1 = it_1;
      }
      var legacyTextInputServiceAdapter = tmp_1;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_2 = this_3.i31();
      var tmp_2;
      if (false || it_2 === Companion_getInstance_11().f30_1) {
        var value_3 = new TextInputService(legacyTextInputServiceAdapter);
        this_3.j31(value_3);
        tmp_2 = value_3;
      } else {
        tmp_2 = it_2;
      }
      var textInputService = tmp_2;
      var tmp0 = get_LocalDensity();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var density = $composer_1.u31(tmp0);
      var tmp0_0 = get_LocalFontFamilyResolver();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_2 = $composer_0;
      var fontFamilyResolver = $composer_2.u31(tmp0_0);
      var tmp0_1 = get_LocalTextSelectionColors();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_3 = $composer_0;
      var selectionBackgroundColor = $composer_3.u31(tmp0_1).qjz_1;
      var tmp0_2 = get_LocalFocusManager();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_4 = $composer_0;
      var focusManager = $composer_4.u31(tmp0_2);
      var tmp0_3 = get_LocalWindowInfo();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_5 = $composer_0;
      var windowInfo = $composer_5.u31(tmp0_3);
      var tmp0_4 = get_LocalSoftwareKeyboardController();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_6 = $composer_0;
      var keyboardController = $composer_6.u31(tmp0_4);
      var singleLine = maxLines_0._v === 1 && !softWrap_0._v && imeOptions_0._v.f8c_1;
      var orientation = singleLine ? Orientation_Horizontal_getInstance() : Orientation_Vertical_getInstance();
      var tmp0_elvis_lhs = textScrollerPosition_0._v;
      var tmp_3;
      if (tmp0_elvis_lhs == null) {
        $composer_0.m30(-213744626);
        var tmp_4 = Companion_getInstance_79().tk4_1;
        var tmp0_5 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.m31(orientation.a1_1);
        // Inline function 'kotlin.let' call
        var it_3 = tmp0_5.i31();
        var tmp_5;
        if (invalid || it_3 === Companion_getInstance_11().f30_1) {
          var value_4 = CoreTextField$lambda_0(orientation);
          tmp0_5.j31(value_4);
          tmp_5 = value_4;
        } else {
          tmp_5 = it_3;
        }
        var tmp$ret$22 = tmp_5;
        var tmp0_group = rememberSaveable([orientation], tmp_4, tmp$ret$22, $composer_0, 0);
        $composer_0.n30();
        tmp_3 = tmp0_group;
      } else {
        $composer_0.m30(-213745742);
        $composer_0.n30();
        tmp_3 = tmp0_elvis_lhs;
      }
      var scrollerPosition = tmp_3;
      if (!scrollerPosition.lhy().equals(orientation)) {
        throw IllegalArgumentException_init_$Create$('Mismatching scroller orientation; ' + (orientation.equals(Orientation_Vertical_getInstance()) ? 'only single-line, non-wrap text fields can scroll horizontally' : 'single-line, non-wrap text fields can only scroll horizontally'));
      }
      var tmp0_6 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(($dirty & 14) === 4 | ($dirty & 57344) === 16384);
      // Inline function 'kotlin.let' call
      var it_4 = tmp0_6.i31();
      var tmp_6;
      if (invalid_0 || it_4 === Companion_getInstance_11().f30_1) {
        var transformed = filterWithValidation(visualTransformation_0._v, value.f8a_1);
        var tmp0_safe_receiver = value.h8a_1;
        var tmp_7;
        var tmp_8 = tmp0_safe_receiver;
        if ((tmp_8 == null ? null : new TextRange(tmp_8)) == null) {
          tmp_7 = null;
        } else {
          var tmp_9 = tmp0_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_5 = (tmp_9 == null ? null : new TextRange(tmp_9)).b7u_1;
          tmp_7 = Companion_instance_29.ak5(it_5, transformed);
        }
        var tmp1_elvis_lhs = tmp_7;
        var value_5 = tmp1_elvis_lhs == null ? transformed : tmp1_elvis_lhs;
        tmp0_6.j31(value_5);
        tmp_6 = value_5;
      } else {
        tmp_6 = it_4;
      }
      var transformedText = tmp_6;
      var visualText = transformedText.p8d_1;
      var offsetMapping = transformedText.q8d_1;
      var scope = get_currentRecomposeScope($composer_0, 0);
      var tmp0_7 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_0.k31(keyboardController);
      // Inline function 'kotlin.let' call
      var it_6 = tmp0_7.i31();
      var tmp_10;
      if (invalid_1 || it_6 === Companion_getInstance_11().f30_1) {
        var value_6 = new LegacyTextFieldState(new TextDelegate(visualText, textStyle_0._v, VOID, VOID, softWrap_0._v, VOID, density, fontFamilyResolver), scope, keyboardController);
        tmp0_7.j31(value_6);
        tmp_10 = value_6;
      } else {
        tmp_10 = it_6;
      }
      var state = tmp_10;
      state.dk6(value.f8a_1, visualText, textStyle_0._v, softWrap_0._v, density, fontFamilyResolver, onValueChange, keyboardActions_0._v, focusManager, selectionBackgroundColor);
      state.ek5_1.i8a(value, state.fk5_1);
      // Inline function 'androidx.compose.runtime.cache' call
      var this_4 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_7 = this_4.i31();
      var tmp_11;
      if (false || it_7 === Companion_getInstance_11().f30_1) {
        var value_7 = new UndoManager();
        this_4.j31(value_7);
        tmp_11 = value_7;
      } else {
        tmp_11 = it_7;
      }
      var undoManager = tmp_11;
      undoManager.kk6(value);
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_7 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = CoreTextField$lambda_1;
      }
      var composer = $composer_7;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_8 = $composer_7.i31();
      var tmp_12;
      if (false || it_8 === Companion_getInstance_11().f30_1) {
        var value_8 = createCompositionCoroutineScope(getContext(), composer);
        $composer_7.j31(value_8);
        tmp_12 = value_8;
      } else {
        tmp_12 = it_8;
      }
      var coroutineScope = tmp_12;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_5 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_9 = this_5.i31();
      var tmp_13;
      if (false || it_9 === Companion_getInstance_11().f30_1) {
        var value_9 = funBringIntoViewRequester();
        this_5.j31(value_9);
        tmp_13 = value_9;
      } else {
        tmp_13 = it_9;
      }
      var bringIntoViewRequester = tmp_13;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_6 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_10 = this_6.i31();
      var tmp_14;
      if (false || it_10 === Companion_getInstance_11().f30_1) {
        var value_10 = new TextFieldSelectionManager(undoManager);
        this_6.j31(value_10);
        tmp_14 = value_10;
      } else {
        tmp_14 = it_10;
      }
      var manager = tmp_14;
      manager.sk1_1 = offsetMapping;
      manager.wk1_1 = visualTransformation_0._v;
      manager.tk1_1 = state.wk5_1;
      manager.uk1_1 = state;
      manager.lk6(value);
      var tmp_15 = manager;
      var tmp0_8 = get_LocalClipboard();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_8 = $composer_0;
      tmp_15.yk1_1 = $composer_8.u31(tmp0_8);
      manager.zk1_1 = coroutineScope;
      var tmp_16 = manager;
      var tmp0_9 = get_LocalTextToolbar();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_9 = $composer_0;
      tmp_16.bk2_1 = $composer_9.u31(tmp0_9);
      var tmp_17 = manager;
      var tmp0_10 = get_LocalHapticFeedback();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_10 = $composer_0;
      tmp_17.ck2_1 = $composer_10.u31(tmp0_10);
      manager.dk2_1 = focusRequester;
      manager.mk6(!readOnly_0._v);
      manager.nk6(enabled_0._v);
      if (ComposeFoundationFlags_instance.ifg_1) {
        $composer_0.m30(1966756105);
        manager.ak2_1 = rememberPlatformSelectionBehaviors(SelectedTextType_EditableText_getInstance(), textStyle_0._v.n82(), $composer_0, 6);
        $composer_0.n30();
      } else {
        $composer_0.m30(1966902177);
        $composer_0.n30();
      }
      var tmp1_isEnabled = state.r9h();
      var tmp0_11 = CoreTextField$lambda_2(manager);
      var tmp2 = CoreTextField$lambda_3(manager);
      var tmp4 = CoreTextField$lambda_4(manager);
      // Inline function 'androidx.compose.foundation.text.rememberClipboardEventsHandler' call
      var $composer_11 = $composer_0;
      var onPaste = {_v: tmp0_11};
      var onCopy = {_v: tmp2};
      var onCut = {_v: tmp4};
      var $composer_12 = $composer_11;
      if (!((0 & 1) === 0)) {
        onPaste._v = CoreTextField$lambda_5;
      }
      if (!((0 & 2) === 0)) {
        onCopy._v = CoreTextField$lambda_6;
      }
      if (!((0 & 4) === 0)) {
        onCut._v = CoreTextField$lambda_7;
      }
      if (tmp1_isEnabled) {
        $composer_12.m30(483496527);
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var this_7 = get_LocalActiveClipEventsTarget();
        var $composer_13 = $composer_12;
        var clipEventsTargetProvider = $composer_13.u31(this_7);
        DisposableEffect_0(Unit_instance, CoreTextField$lambda_8(clipEventsTargetProvider, onCopy, onPaste, onCut), $composer_12, 6);
        $composer_12.n30();
      } else {
        $composer_12.m30(485027400);
        $composer_12.n30();
      }
      var tmp_18 = Companion_instance_0;
      var tmp_19 = enabled_0._v;
      var tmp_20 = interactionSource_0._v;
      var tmp0_12 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = !!(!!(!!(!!(!!(!!(!!(!!(!!($composer_0.q31(state) | ($dirty1 & 7168) === 2048) | ($dirty1 & 57344) === 16384) | $composer_0.q31(textInputService)) | ($dirty & 14) === 4) | (($dirty1 & 112 ^ 48) > 32 && $composer_0.k31(imeOptions_0._v) || ($dirty1 & 48) === 32)) | $composer_0.q31(offsetMapping)) | $composer_0.q31(coroutineScope)) | $composer_0.q31(bringIntoViewRequester)) | $composer_0.q31(manager));
      // Inline function 'kotlin.let' call
      var it_11 = tmp0_12.i31();
      var tmp_21;
      if (invalid_2 || it_11 === Companion_getInstance_11().f30_1) {
        var value_11 = CoreTextField$lambda_9(state, enabled_0, readOnly_0, textInputService, value, imeOptions_0, offsetMapping, coroutineScope, manager, bringIntoViewRequester);
        tmp0_12.j31(value_11);
        tmp_21 = value_11;
      } else {
        tmp_21 = it_11;
      }
      var tmp$ret$58 = tmp_21;
      var focusModifier = textFieldFocusModifier(tmp_18, tmp_19, focusRequester, tmp_20, tmp$ret$58);
      var writeable$delegate = rememberUpdatedState(enabled_0._v && !readOnly_0._v, $composer_0, 0);
      var tmp0_13 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = !!(!!(!!(!!($composer_0.k31(writeable$delegate) | $composer_0.q31(state)) | $composer_0.q31(textInputService)) | $composer_0.q31(manager)) | (($dirty1 & 112 ^ 48) > 32 && $composer_0.k31(imeOptions_0._v) || ($dirty1 & 48) === 32));
      // Inline function 'kotlin.let' call
      var it_12 = tmp0_13.i31();
      var tmp_22;
      if (invalid_3 || it_12 === Companion_getInstance_11().f30_1) {
        var value_12 = CoreTextField$slambda_0(state, writeable$delegate, textInputService, manager, imeOptions_0, null);
        tmp0_13.j31(value_12);
        tmp_22 = value_12;
      } else {
        tmp_22 = it_12;
      }
      var tmp$ret$62 = tmp_22;
      LaunchedEffect(Unit_instance, tmp$ret$62, $composer_0, 6);
      var pointerModifier = textFieldPointer(Companion_instance_0, manager, enabled_0._v, interactionSource_0._v, state, focusRequester, readOnly_0._v, offsetMapping, $composer_0, 196614 | 896 & $dirty1 >> 3 | 7168 & $dirty >> 9 | 3670016 & $dirty1 << 6);
      var drawModifier = textFieldDraw(Companion_instance_0, state, value, offsetMapping);
      var tmp_23 = Companion_instance_0;
      var tmp0_14 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_4 = !!(!!(!!(!!(!!($composer_0.q31(state) | ($dirty1 & 7168) === 2048) | $composer_0.k31(windowInfo)) | $composer_0.q31(manager)) | ($dirty & 14) === 4) | $composer_0.q31(offsetMapping));
      // Inline function 'kotlin.let' call
      var it_13 = tmp0_14.i31();
      var tmp_24;
      if (invalid_4 || it_13 === Companion_getInstance_11().f30_1) {
        var value_13 = CoreTextField$lambda_11(state, enabled_0, windowInfo, manager, value, offsetMapping);
        tmp0_14.j31(value_13);
        tmp_24 = value_13;
      } else {
        tmp_24 = it_13;
      }
      var tmp$ret$66 = tmp_24;
      var onPositionedModifier = onGloballyPositioned(tmp_23, tmp$ret$66);
      var tmp_25 = visualTransformation_0._v;
      var isPassword = tmp_25 instanceof PasswordVisualTransformation;
      var semanticsModifier = new CoreTextFieldSemanticsModifier(transformedText, value, state, readOnly_0._v, enabled_0._v, isPassword, offsetMapping, manager, imeOptions_0._v, focusRequester);
      var showCursor = enabled_0._v && !readOnly_0._v && windowInfo.abr() && !state.ok6();
      var cursorModifier = textFieldCursor(Companion_instance_0, state, value, offsetMapping, cursorBrush_0._v, showCursor);
      var tmp0_15 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_5 = $composer_0.q31(manager);
      // Inline function 'kotlin.let' call
      var it_14 = tmp0_15.i31();
      var tmp_26;
      if (invalid_5 || it_14 === Companion_getInstance_11().f30_1) {
        var value_14 = CoreTextField$lambda_12(manager);
        tmp0_15.j31(value_14);
        tmp_26 = value_14;
      } else {
        tmp_26 = it_14;
      }
      var tmp$ret$70 = tmp_26;
      DisposableEffect_0(manager, tmp$ret$70, $composer_0, 0);
      var tmp_27 = imeOptions_0._v;
      var tmp0_16 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_6 = !!(!!(!!($composer_0.q31(state) | $composer_0.q31(textInputService)) | ($dirty & 14) === 4) | (($dirty1 & 112 ^ 48) > 32 && $composer_0.k31(imeOptions_0._v) || ($dirty1 & 48) === 32));
      // Inline function 'kotlin.let' call
      var it_15 = tmp0_16.i31();
      var tmp_28;
      if (invalid_6 || it_15 === Companion_getInstance_11().f30_1) {
        var value_15 = CoreTextField$lambda_13(state, textInputService, value, imeOptions_0);
        tmp0_16.j31(value_15);
        tmp_28 = value_15;
      } else {
        tmp_28 = it_15;
      }
      var tmp$ret$74 = tmp_28;
      DisposableEffect_0(tmp_27, tmp$ret$74, $composer_0, 14 & $dirty1 >> 3);
      var textKeyInputModifier = textFieldKeyInput(Companion_instance_0, state, manager, value, state.wk5_1, !readOnly_0._v, maxLines_0._v === 1, offsetMapping, undoManager, imeOptions_0._v.j8c_1);
      var handwritingEnabled = !(imeOptions_0._v.i8c_1 === Companion_getInstance_42().c8c_1) && !(imeOptions_0._v.i8c_1 === Companion_getInstance_42().d8c_1);
      var tmp_29 = Companion_instance_0;
      var tmp_30 = CoreTextField$lambda_10(writeable$delegate);
      var tmp0_17 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_7 = !!($composer_0.l31(handwritingEnabled) | $composer_0.q31(legacyTextInputServiceAdapter));
      // Inline function 'kotlin.let' call
      var it_16 = tmp0_17.i31();
      var tmp_31;
      if (invalid_7 || it_16 === Companion_getInstance_11().f30_1) {
        var value_16 = CoreTextField$lambda_14(handwritingEnabled, legacyTextInputServiceAdapter);
        tmp0_17.j31(value_16);
        tmp_31 = value_16;
      } else {
        tmp_31 = it_16;
      }
      var tmp$ret$78 = tmp_31;
      var stylusHandwritingModifier = stylusHandwriting(tmp_29, tmp_30, handwritingEnabled, tmp$ret$78);
      var tmp0_18 = get_LocalAutofillHighlightBrush();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_14 = $composer_0;
      var tmp_32 = $composer_14.u31(tmp0_18);
      var tmp0_19 = get_LocalAutofillHighlightColor();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_15 = $composer_0;
      var tmp$ret$83 = $composer_15.u31(tmp0_19).c6d_1;
      var autofillHighlightBrush = resolveAutofillHighlight(tmp_32, tmp$ret$83, autofillHighlightColor());
      var tmp_33 = Companion_instance_0;
      var tmp0_20 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_8 = !!($composer_0.q31(state) | $composer_0.k31(autofillHighlightBrush));
      // Inline function 'kotlin.let' call
      var it_17 = tmp0_20.i31();
      var tmp_34;
      if (invalid_8 || it_17 === Companion_getInstance_11().f30_1) {
        var value_17 = CoreTextField$lambda_15(state, autofillHighlightBrush);
        tmp0_20.j31(value_17);
        tmp_34 = value_17;
      } else {
        tmp_34 = it_17;
      }
      var tmp$ret$84 = tmp_34;
      var drawDecorationModifier = drawWithContent(tmp_33, tmp$ret$84);
      var overscrollEffect = rememberTextFieldOverscrollEffect($composer_0, 0);
      var tmp_35 = textFieldScrollable(previewKeyEventToDeselectOnBack(interceptDPadAndMoveFocus(legacyTextInputAdapter(modifier_0._v.d8v(drawDecorationModifier), legacyTextInputServiceAdapter, state, manager).d8v(stylusHandwritingModifier).d8v(focusModifier), state, focusManager), state, manager).d8v(textKeyInputModifier), scrollerPosition, interactionSource_0._v, enabled_0._v, overscrollEffect).d8v(pointerModifier).d8v(semanticsModifier);
      var decorationBoxModifier = addContextMenuComponents(onGloballyPositioned(tmp_35, CoreTextField$lambda_16(state)), manager, coroutineScope);
      var showHandleAndMagnifier = enabled_0._v && state.r9h() && state.pk6() && windowInfo.abr();
      var tmp_36;
      if (showHandleAndMagnifier) {
        tmp_36 = textFieldMagnifier(Companion_instance_0, manager);
      } else {
        tmp_36 = Companion_instance_0;
      }
      var magnifierModifier = tmp_36;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-814563849, true, CoreTextField$lambda_17(decorationBox_0, state, textStyle_0, minLines_0, maxLines_0, scrollerPosition, value, visualTransformation_0, overscrollEffect, cursorModifier, drawModifier, onPositionedModifier, magnifierModifier, bringIntoViewRequester, manager, showHandleAndMagnifier, readOnly_0, onTextLayout_0, offsetMapping, density), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_16 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_9 = $composer_16.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_18 = $composer_16.i31();
      var tmp_37;
      if (invalid_9 || it_18 === Companion_getInstance_11().f30_1) {
        var value_18 = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_16.j31(value_18);
        tmp_37 = value_18;
      } else {
        tmp_37 = it_18;
      }
      var tmp$ret$88 = tmp_37;
      CoreTextFieldRootBox(decorationBoxModifier, manager, tmp$ret$88, $composer_0, 384);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(CoreTextField$lambda_18(value, onValueChange, modifier_0, textStyle_0, visualTransformation_0, onTextLayout_0, interactionSource_0, cursorBrush_0, softWrap_0, maxLines_0, minLines_0, imeOptions_0, keyboardActions_0, enabled_0, readOnly_0, decorationBox_0, textScrollerPosition_0, $changed, $changed1, $default));
    }
  }
  function ComposableSingletons$CoreTextFieldKt$lambda$559628295$lambda(innerTextField, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(innerTextField) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      innerTextField($composer_0, 14 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CoreTextFieldKt() {
    ComposableSingletons$CoreTextFieldKt_instance = this;
    var tmp = this;
    tmp.sk4_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(559628295, false, ComposableSingletons$CoreTextFieldKt$lambda$559628295$lambda));
  }
  var ComposableSingletons$CoreTextFieldKt_instance;
  function ComposableSingletons$CoreTextFieldKt_getInstance() {
    if (ComposableSingletons$CoreTextFieldKt_instance == null)
      new ComposableSingletons$CoreTextFieldKt();
    return ComposableSingletons$CoreTextFieldKt_instance;
  }
  function LegacyTextFieldState$_get_hasFocus_$ref_5huzrn() {
    return constructCallableReference(function (p0) {
      return p0.r9h();
    }, 1, 0, 307);
  }
  function LegacyTextFieldState$_set_hasFocus_$ref_a1vqsh() {
    return constructCallableReference(function (p0, p1) {
      p0.qk6(p1);
      return Unit_instance;
    }, 2, 0, 308);
  }
  function LegacyTextFieldState$_get_minHeightForSingleLineField_$ref_ylpjlx() {
    return constructCallableReference(function (p0) {
      return new Dp(p0.rk6());
    }, 1, 0, 309);
  }
  function LegacyTextFieldState$_set_minHeightForSingleLineField_$ref_2pddsh() {
    return constructCallableReference(function (p0, p1) {
      p0.sk6(p1.m5f_1);
      return Unit_instance;
    }, 2, 0, 310);
  }
  function LegacyTextFieldState$_get_handleState_$ref_yihszk() {
    return constructCallableReference(function (p0) {
      return p0.tk6();
    }, 1, 0, 311);
  }
  function LegacyTextFieldState$_set_handleState_$ref_qew1h0() {
    return constructCallableReference(function (p0, p1) {
      p0.uk6(p1);
      return Unit_instance;
    }, 2, 0, 312);
  }
  function LegacyTextFieldState$_get_showFloatingToolbar_$ref_ffyfjj() {
    return constructCallableReference(function (p0) {
      return p0.vk6();
    }, 1, 0, 313);
  }
  function LegacyTextFieldState$_set_showFloatingToolbar_$ref_516ypx() {
    return constructCallableReference(function (p0, p1) {
      p0.wk6(p1);
      return Unit_instance;
    }, 2, 0, 314);
  }
  function LegacyTextFieldState$_get_showSelectionHandleStart_$ref_4u2zy2() {
    return constructCallableReference(function (p0) {
      return p0.xk6();
    }, 1, 0, 315);
  }
  function LegacyTextFieldState$_set_showSelectionHandleStart_$ref_c0nywe() {
    return constructCallableReference(function (p0, p1) {
      p0.yk6(p1);
      return Unit_instance;
    }, 2, 0, 316);
  }
  function LegacyTextFieldState$_get_showSelectionHandleEnd_$ref_mbgkgj() {
    return constructCallableReference(function (p0) {
      return p0.zk6();
    }, 1, 0, 317);
  }
  function LegacyTextFieldState$_set_showSelectionHandleEnd_$ref_nqaavb() {
    return constructCallableReference(function (p0, p1) {
      p0.ak7(p1);
      return Unit_instance;
    }, 2, 0, 318);
  }
  function LegacyTextFieldState$_get_showCursorHandle_$ref_g0517a() {
    return constructCallableReference(function (p0) {
      return p0.bk7();
    }, 1, 0, 319);
  }
  function LegacyTextFieldState$_set_showCursorHandle_$ref_ty7p7m() {
    return constructCallableReference(function (p0, p1) {
      p0.ck7(p1);
      return Unit_instance;
    }, 2, 0, 320);
  }
  function LegacyTextFieldState$_get_isInTouchMode_$ref_74gc3a() {
    return constructCallableReference(function (p0) {
      return p0.pk6();
    }, 1, 0, 321);
  }
  function LegacyTextFieldState$_set_isInTouchMode_$ref_su98dm() {
    return constructCallableReference(function (p0, p1) {
      p0.dk7(p1);
      return Unit_instance;
    }, 2, 0, 322);
  }
  function LegacyTextFieldState$_get_autofillHighlightOn_$ref_spj4ns() {
    return constructCallableReference(function (p0) {
      return p0.ek7();
    }, 1, 0, 323);
  }
  function LegacyTextFieldState$_set_autofillHighlightOn_$ref_88dqec() {
    return constructCallableReference(function (p0, p1) {
      p0.fk7(p1);
      return Unit_instance;
    }, 2, 0, 324);
  }
  function LegacyTextFieldState$_get_justAutofilled_$ref_oig6es() {
    return constructCallableReference(function (p0) {
      return p0.gk7();
    }, 1, 0, 325);
  }
  function LegacyTextFieldState$_set_justAutofilled_$ref_ckskg0() {
    return constructCallableReference(function (p0, p1) {
      p0.hk7(p1);
      return Unit_instance;
    }, 2, 0, 326);
  }
  function LegacyTextFieldState$onValueChangeOriginal$lambda(it) {
    return Unit_instance;
  }
  function LegacyTextFieldState$onValueChange$lambda(this$0) {
    return function (it) {
      var tmp;
      var tmp_0 = it.h89();
      var tmp0_safe_receiver = this$0.kk5_1;
      if (!(tmp_0 === (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h7q_1))) {
        this$0.uk6(HandleState_None_getInstance());
        var tmp_1;
        if (this$0.gk7()) {
          this$0.hk7(false);
          tmp_1 = Unit_instance;
        } else {
          this$0.fk7(false);
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      }
      this$0.ik7(Companion_getInstance_43().n7u_1);
      this$0.jk7(Companion_getInstance_43().n7u_1);
      this$0.vk5_1(it);
      this$0.ck5_1.m40();
      return Unit_instance;
    };
  }
  function LegacyTextFieldState$onImeActionPerformed$lambda(this$0) {
    return function (imeAction) {
      this$0.sk5_1.nk7(imeAction.o8b_1);
      return Unit_instance;
    };
  }
  function LegacyTextFieldState$onImeActionPerformedWithResult$lambda(this$0) {
    return function (imeAction) {
      return this$0.sk5_1.nk7(imeAction.o8b_1);
    };
  }
  function LegacyTextFieldState$_get_selectionPreviewHighlightRange_$ref_g2g624() {
    return constructCallableReference(function (p0) {
      return new TextRange(p0.ok7());
    }, 1, 0, 327);
  }
  function LegacyTextFieldState$_set_selectionPreviewHighlightRange_$ref_ozfgi0() {
    return constructCallableReference(function (p0, p1) {
      p0.ik7(p1.b7u_1);
      return Unit_instance;
    }, 2, 0, 328);
  }
  function LegacyTextFieldState$_get_deletionPreviewHighlightRange_$ref_lubh96() {
    return constructCallableReference(function (p0) {
      return new TextRange(p0.pk7());
    }, 1, 0, 329);
  }
  function LegacyTextFieldState$_set_deletionPreviewHighlightRange_$ref_i2s6e2() {
    return constructCallableReference(function (p0, p1) {
      p0.jk7(p1.b7u_1);
      return Unit_instance;
    }, 2, 0, 330);
  }
  function LegacyTextFieldState(textDelegate, recomposeScope, keyboardController) {
    this.bk5_1 = textDelegate;
    this.ck5_1 = recomposeScope;
    this.dk5_1 = keyboardController;
    this.ek5_1 = new EditProcessor();
    this.fk5_1 = null;
    this.gk5_1 = mutableStateOf(false);
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
    tmp.hk5_1 = mutableStateOf(new Dp(tmp$ret$0));
    this.ik5_1 = null;
    this.jk5_1 = mutableStateOf(null);
    this.kk5_1 = null;
    this.lk5_1 = mutableStateOf(HandleState_None_getInstance());
    this.mk5_1 = mutableStateOf(false);
    this.nk5_1 = mutableStateOf(false);
    this.ok5_1 = mutableStateOf(false);
    this.pk5_1 = mutableStateOf(false);
    this.qk5_1 = true;
    this.rk5_1 = mutableStateOf(true);
    this.sk5_1 = new KeyboardActionRunner(this.dk5_1);
    this.tk5_1 = mutableStateOf(false);
    this.uk5_1 = mutableStateOf(false);
    var tmp_0 = this;
    tmp_0.vk5_1 = LegacyTextFieldState$onValueChangeOriginal$lambda;
    var tmp_1 = this;
    tmp_1.wk5_1 = LegacyTextFieldState$onValueChange$lambda(this);
    var tmp_2 = this;
    tmp_2.xk5_1 = LegacyTextFieldState$onImeActionPerformed$lambda(this);
    var tmp_3 = this;
    tmp_3.yk5_1 = LegacyTextFieldState$onImeActionPerformedWithResult$lambda(this);
    this.zk5_1 = Paint();
    this.ak6_1 = Companion_getInstance().u6b_1;
    this.bk6_1 = mutableStateOf(new TextRange(Companion_getInstance_43().n7u_1));
    this.ck6_1 = mutableStateOf(new TextRange(Companion_getInstance_43().n7u_1));
  }
  protoOf(LegacyTextFieldState).qk6 = function (_set____db54di) {
    var tmp0 = this.gk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_hasFocus_$ref_5huzrn();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('hasFocus', 1, tmp, tmp_0, LegacyTextFieldState$_set_hasFocus_$ref_a1vqsh());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).r9h = function () {
    var tmp0 = this.gk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_hasFocus_$ref_5huzrn();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('hasFocus', 1, tmp, tmp_0, LegacyTextFieldState$_set_hasFocus_$ref_a1vqsh());
    return tmp0.u1();
  };
  protoOf(LegacyTextFieldState).sk6 = function (_set____db54di) {
    var tmp0 = this.hk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_minHeightForSingleLineField_$ref_ylpjlx();
    getPropertyCallableRef('minHeightForSingleLineField', 1, tmp, tmp_0, LegacyTextFieldState$_set_minHeightForSingleLineField_$ref_2pddsh());
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new Dp(_set____db54di);
    tmp0.s21(value);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).rk6 = function () {
    var tmp0 = this.hk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_minHeightForSingleLineField_$ref_ylpjlx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('minHeightForSingleLineField', 1, tmp, tmp_0, LegacyTextFieldState$_set_minHeightForSingleLineField_$ref_2pddsh());
    return tmp0.u1().m5f_1;
  };
  protoOf(LegacyTextFieldState).qk7 = function (value) {
    this.ik5_1 = value;
  };
  protoOf(LegacyTextFieldState).rk7 = function () {
    var tmp0_safe_receiver = this.ik5_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (tmp0_safe_receiver.y91()) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(LegacyTextFieldState).sk7 = function (value) {
    this.jk5_1.s21(value);
    this.qk5_1 = false;
  };
  protoOf(LegacyTextFieldState).tk7 = function () {
    return this.jk5_1.u1();
  };
  protoOf(LegacyTextFieldState).uk6 = function (_set____db54di) {
    var tmp0 = this.lk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_handleState_$ref_yihszk();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('handleState', 1, tmp, tmp_0, LegacyTextFieldState$_set_handleState_$ref_qew1h0());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).tk6 = function () {
    var tmp0 = this.lk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_handleState_$ref_yihszk();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('handleState', 1, tmp, tmp_0, LegacyTextFieldState$_set_handleState_$ref_qew1h0());
    return tmp0.u1();
  };
  protoOf(LegacyTextFieldState).wk6 = function (_set____db54di) {
    var tmp0 = this.mk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_showFloatingToolbar_$ref_ffyfjj();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('showFloatingToolbar', 1, tmp, tmp_0, LegacyTextFieldState$_set_showFloatingToolbar_$ref_516ypx());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).vk6 = function () {
    var tmp0 = this.mk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_showFloatingToolbar_$ref_ffyfjj();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('showFloatingToolbar', 1, tmp, tmp_0, LegacyTextFieldState$_set_showFloatingToolbar_$ref_516ypx());
    return tmp0.u1();
  };
  protoOf(LegacyTextFieldState).yk6 = function (_set____db54di) {
    var tmp0 = this.nk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_showSelectionHandleStart_$ref_4u2zy2();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('showSelectionHandleStart', 1, tmp, tmp_0, LegacyTextFieldState$_set_showSelectionHandleStart_$ref_c0nywe());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).xk6 = function () {
    var tmp0 = this.nk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_showSelectionHandleStart_$ref_4u2zy2();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('showSelectionHandleStart', 1, tmp, tmp_0, LegacyTextFieldState$_set_showSelectionHandleStart_$ref_c0nywe());
    return tmp0.u1();
  };
  protoOf(LegacyTextFieldState).ak7 = function (_set____db54di) {
    var tmp0 = this.ok5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_showSelectionHandleEnd_$ref_mbgkgj();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('showSelectionHandleEnd', 1, tmp, tmp_0, LegacyTextFieldState$_set_showSelectionHandleEnd_$ref_nqaavb());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).zk6 = function () {
    var tmp0 = this.ok5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_showSelectionHandleEnd_$ref_mbgkgj();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('showSelectionHandleEnd', 1, tmp, tmp_0, LegacyTextFieldState$_set_showSelectionHandleEnd_$ref_nqaavb());
    return tmp0.u1();
  };
  protoOf(LegacyTextFieldState).ck7 = function (_set____db54di) {
    var tmp0 = this.pk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_showCursorHandle_$ref_g0517a();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('showCursorHandle', 1, tmp, tmp_0, LegacyTextFieldState$_set_showCursorHandle_$ref_ty7p7m());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).bk7 = function () {
    var tmp0 = this.pk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_showCursorHandle_$ref_g0517a();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('showCursorHandle', 1, tmp, tmp_0, LegacyTextFieldState$_set_showCursorHandle_$ref_ty7p7m());
    return tmp0.u1();
  };
  protoOf(LegacyTextFieldState).dk7 = function (_set____db54di) {
    var tmp0 = this.rk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_isInTouchMode_$ref_74gc3a();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isInTouchMode', 1, tmp, tmp_0, LegacyTextFieldState$_set_isInTouchMode_$ref_su98dm());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).pk6 = function () {
    var tmp0 = this.rk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_isInTouchMode_$ref_74gc3a();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isInTouchMode', 1, tmp, tmp_0, LegacyTextFieldState$_set_isInTouchMode_$ref_su98dm());
    return tmp0.u1();
  };
  protoOf(LegacyTextFieldState).fk7 = function (_set____db54di) {
    var tmp0 = this.tk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_autofillHighlightOn_$ref_spj4ns();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('autofillHighlightOn', 1, tmp, tmp_0, LegacyTextFieldState$_set_autofillHighlightOn_$ref_88dqec());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).ek7 = function () {
    var tmp0 = this.tk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_autofillHighlightOn_$ref_spj4ns();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('autofillHighlightOn', 1, tmp, tmp_0, LegacyTextFieldState$_set_autofillHighlightOn_$ref_88dqec());
    return tmp0.u1();
  };
  protoOf(LegacyTextFieldState).hk7 = function (_set____db54di) {
    var tmp0 = this.uk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_justAutofilled_$ref_oig6es();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('justAutofilled', 1, tmp, tmp_0, LegacyTextFieldState$_set_justAutofilled_$ref_ckskg0());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).gk7 = function () {
    var tmp0 = this.uk5_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_justAutofilled_$ref_oig6es();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('justAutofilled', 1, tmp, tmp_0, LegacyTextFieldState$_set_justAutofilled_$ref_ckskg0());
    return tmp0.u1();
  };
  protoOf(LegacyTextFieldState).ik7 = function (_set____db54di) {
    var tmp0 = this.bk6_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_selectionPreviewHighlightRange_$ref_g2g624();
    getPropertyCallableRef('selectionPreviewHighlightRange', 1, tmp, tmp_0, LegacyTextFieldState$_set_selectionPreviewHighlightRange_$ref_ozfgi0());
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new TextRange(_set____db54di);
    tmp0.s21(value);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).ok7 = function () {
    var tmp0 = this.bk6_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_selectionPreviewHighlightRange_$ref_g2g624();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('selectionPreviewHighlightRange', 1, tmp, tmp_0, LegacyTextFieldState$_set_selectionPreviewHighlightRange_$ref_ozfgi0());
    return tmp0.u1().b7u_1;
  };
  protoOf(LegacyTextFieldState).jk7 = function (_set____db54di) {
    var tmp0 = this.ck6_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_deletionPreviewHighlightRange_$ref_lubh96();
    getPropertyCallableRef('deletionPreviewHighlightRange', 1, tmp, tmp_0, LegacyTextFieldState$_set_deletionPreviewHighlightRange_$ref_i2s6e2());
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new TextRange(_set____db54di);
    tmp0.s21(value);
    return Unit_instance;
  };
  protoOf(LegacyTextFieldState).pk7 = function () {
    var tmp0 = this.ck6_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyTextFieldState$_get_deletionPreviewHighlightRange_$ref_lubh96();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('deletionPreviewHighlightRange', 1, tmp, tmp_0, LegacyTextFieldState$_set_deletionPreviewHighlightRange_$ref_i2s6e2());
    return tmp0.u1().b7u_1;
  };
  protoOf(LegacyTextFieldState).ok6 = function () {
    return !_TextRange___get_collapsed__impl__cilesp(this.ok7()) || !_TextRange___get_collapsed__impl__cilesp(this.pk7());
  };
  protoOf(LegacyTextFieldState).dk6 = function (untransformedText, visualText, textStyle, softWrap, density, fontFamilyResolver, onValueChange, keyboardActions, focusManager, selectionBackgroundColor) {
    this.vk5_1 = onValueChange;
    this.ak6_1 = selectionBackgroundColor;
    // Inline function 'kotlin.apply' call
    var this_0 = this.sk5_1;
    this_0.lk7_1 = keyboardActions;
    this_0.mk7_1 = focusManager;
    this.kk5_1 = untransformedText;
    var tmp0_current = this.bk5_1;
    var tmp1_placeholders = emptyList();
    var newTextDelegate = updateTextDelegate(tmp0_current, visualText, textStyle, density, fontFamilyResolver, softWrap, VOID, VOID, VOID, tmp1_placeholders);
    if (!(this.bk5_1 === newTextDelegate))
      this.qk5_1 = true;
    this.bk5_1 = newTextDelegate;
  };
  function startInputSession(textInputService, state, value, imeOptions, offsetMapping) {
    state.fk5_1 = Companion_instance_29.uk7(textInputService, value, state.ek5_1, imeOptions, state.wk5_1, state.xk5_1);
    notifyFocusedRect_0(state, value, offsetMapping);
  }
  function endInputSession(state) {
    var tmp0_safe_receiver = state.fk5_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      Companion_instance_29.vk7(tmp0_safe_receiver, state.ek5_1, state.wk5_1);
    }
    state.fk5_1 = null;
  }
  function bringSelectionEndIntoView(_this__u8e3s4, value, textDelegate, textLayoutResult, offsetMapping, $completion) {
    var selectionEndInTransformed = offsetMapping.o8c(_TextRange___get_max__impl__owm8m(value.g8a_1));
    var tmp;
    if (selectionEndInTransformed < textLayoutResult.e80_1.q80_1.a()) {
      tmp = textLayoutResult.v7t(selectionEndInTransformed);
    } else if (!(selectionEndInTransformed === 0)) {
      tmp = textLayoutResult.v7t(selectionEndInTransformed - 1 | 0);
    } else {
      var defaultSize = computeSizeForDefaultText(textDelegate.xk7_1, textDelegate.ck8_1, textDelegate.dk8_1);
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(defaultSize);
      var tmp$ret$0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp = new Rect(0.0, 0.0, 1.0, tmp$ret$0);
    }
    var selectionEndBounds = tmp;
    return _this__u8e3s4.mjn(selectionEndBounds, $completion);
  }
  var HandleState_None_instance;
  var HandleState_Selection_instance;
  var HandleState_Cursor_instance;
  var HandleState_entriesInitialized;
  function HandleState_initEntries() {
    if (HandleState_entriesInitialized)
      return Unit_instance;
    HandleState_entriesInitialized = true;
    HandleState_None_instance = new HandleState('None', 0);
    HandleState_Selection_instance = new HandleState('Selection', 1);
    HandleState_Cursor_instance = new HandleState('Cursor', 2);
  }
  function HandleState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function notifyFocusedRect_0(state, value, offsetMapping) {
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
      var previousSnapshot = Companion_instance_2.p52();
      var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
      var newSnapshot = Companion_instance_2.q52(previousSnapshot);
      try {
        var tmp0_elvis_lhs = state.tk7();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var layoutResult = tmp;
        var tmp1_elvis_lhs = state.fk5_1;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var inputSession = tmp_0;
        var tmp2_elvis_lhs = state.rk7();
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var layoutCoordinates = tmp_1;
        Companion_instance_29.kk8(value, state.bk5_1, layoutResult.hk8_1, layoutCoordinates, inputSession, state.r9h(), offsetMapping);
        break $l$block;
      }finally {
        Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
      }
    }
  }
  function addContextMenuComponents(_this__u8e3s4, textFieldSelectionManager, coroutineScope) {
    return ComposeFoundationFlags_instance.hfg_1 ? addBasicTextFieldTextContextMenuComponents(_this__u8e3s4, textFieldSelectionManager, coroutineScope) : _this__u8e3s4;
  }
  function previewKeyEventToDeselectOnBack(_this__u8e3s4, state, manager) {
    return onPreviewKeyEvent(_this__u8e3s4, previewKeyEventToDeselectOnBack$lambda(state, manager));
  }
  function CoreTextFieldRootBox(modifier, manager, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(2036174316);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(manager) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_0 = modifier;
      var contentAlignment = null;
      var propagateMinConstraints = true;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier_0 = Companion_instance_0;
      if (!((2 & 2) === 0))
        contentAlignment = Companion_getInstance_12().k8t_1;
      if (!((2 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_1 = modifier_0;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_1 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_1);
      var tmp0 = Companion_getInstance_14().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      ContextMenuArea_0(manager, content, $composer_5, 14 & $dirty >> 3 | 112 & $dirty >> 3);
      $composer_3.e31();
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CoreTextFieldRootBox$lambda(modifier, manager, content, $changed));
    }
  }
  function SelectionToolbarAndHandles(manager, show, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(626339208);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(manager) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(show) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      // Inline function 'kotlin.with' call
      var tmp;
      if (show) {
        $composer_0.m30(1530097388);
        var tmp0_safe_receiver = manager.uk1_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7();
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hk8_1;
        var tmp_0;
        if (tmp2_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_1;
          var tmp0_safe_receiver_0 = manager.uk1_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.qk5_1;
          if (!(tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs)) {
            tmp_1 = tmp2_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp3_safe_receiver = tmp_0;
        var tmp_2;
        if (tmp3_safe_receiver == null) {
          $composer_0.m30(1530097387);
          $composer_0.n30();
          tmp_2 = null;
        } else {
          $composer_0.m30(1530097388);
          // Inline function 'kotlin.let' call
          if (!_TextRange___get_collapsed__impl__cilesp(manager.mk8().g8a_1)) {
            $composer_0.m30(2109807302);
            var startOffset = manager.sk1_1.o8c(_TextRange___get_start__impl__ww4t90(manager.mk8().g8a_1));
            var endOffset = manager.sk1_1.o8c(_TextRange___get_end__impl__gcdxpp(manager.mk8().g8a_1));
            var startDirection = tmp3_safe_receiver.y7t(startOffset);
            // Inline function 'kotlin.math.max' call
            var a = endOffset - 1 | 0;
            var tmp$ret$6 = Math.max(a, 0);
            var endDirection = tmp3_safe_receiver.y7t(tmp$ret$6);
            var tmp0_safe_receiver_1 = manager.uk1_1;
            if ((tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.xk6()) === true) {
              $composer_0.m30(2110225306);
              TextFieldSelectionHandle(true, startDirection, manager, $composer_0, 6 | 896 & $dirty << 6);
              $composer_0.n30();
            } else {
              $composer_0.m30(2110490542);
              $composer_0.n30();
            }
            var tmp1_safe_receiver_0 = manager.uk1_1;
            if ((tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.zk6()) === true) {
              $composer_0.m30(2110574459);
              TextFieldSelectionHandle(false, endDirection, manager, $composer_0, 6 | 896 & $dirty << 6);
              $composer_0.n30();
            } else {
              $composer_0.m30(2110838734);
              $composer_0.n30();
            }
            $composer_0.n30();
          } else {
            $composer_0.m30(2110860558);
            $composer_0.n30();
          }
          var tmp2_safe_receiver_0 = manager.uk1_1;
          var tmp_3;
          if (tmp2_safe_receiver_0 == null) {
            tmp_3 = null;
          } else {
            // Inline function 'kotlin.let' call
            if (manager.nk8()) {
              tmp2_safe_receiver_0.wk6(false);
            }
            if (tmp2_safe_receiver_0.r9h()) {
              if (tmp2_safe_receiver_0.vk6()) {
                manager.ok8();
              } else {
                manager.lk8();
              }
            }
            tmp_3 = Unit_instance;
          }
          var tmp1_group = tmp_3;
          $composer_0.n30();
          tmp_2 = tmp1_group;
        }
        var tmp2_group = tmp_2;
        $composer_0.n30();
        tmp = tmp2_group;
      } else {
        $composer_0.m30(1989076778);
        $composer_0.n30();
        manager.lk8();
        tmp = Unit_instance;
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver_1 = $composer_0.t30();
    if (tmp1_safe_receiver_1 == null)
      null;
    else {
      tmp1_safe_receiver_1.p3c(SelectionToolbarAndHandles$lambda(manager, show, $changed));
    }
  }
  function TextFieldCursorHandle(manager, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1436003720);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(manager) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      var tmp;
      var tmp0_safe_receiver = manager.uk1_1;
      if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bk7()) === true) {
        var tmp1_safe_receiver = manager.pk8();
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.text.isNotEmpty' call
          tmp_0 = charSequenceLength(tmp1_safe_receiver) > 0;
        }
        tmp = tmp_0 === true;
      } else {
        tmp = false;
      }
      if (tmp) {
        $composer_0.m30(-2112351432);
        var tmp0 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31(manager);
        // Inline function 'kotlin.let' call
        var it = tmp0.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance_11().f30_1) {
          var value = manager.qk8();
          tmp0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var observer = tmp_1;
        var tmp0_0 = get_LocalDensity();
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var $composer_1 = $composer_0;
        var tmp$ret$5 = $composer_1.u31(tmp0_0);
        var position = manager.rk8(tmp$ret$5);
        var tmp0_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.o31(_Offset___get_packedValue__impl__xh2k8q(position));
        // Inline function 'kotlin.let' call
        var it_0 = tmp0_1.i31();
        var tmp_2;
        if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
          var tmp_3 = TextFieldCursorHandle$lambda(position);
          var value_0 = new sam$androidx_compose_foundation_text_selection_OffsetProvider$0(tmp_3);
          tmp0_1.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_0;
        }
        var tmp_4 = tmp_2;
        var tmp_5 = Companion_instance_0;
        var tmp0_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = !!($composer_0.q31(observer) | $composer_0.q31(manager));
        // Inline function 'kotlin.let' call
        var it_1 = tmp0_2.i31();
        var tmp_6;
        if (invalid_1 || it_1 === Companion_getInstance_11().f30_1) {
          var tmp_7 = TextFieldCursorHandle$slambda_0(observer, manager, null);
          var value_1 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2(tmp_7);
          tmp0_2.j31(value_1);
          tmp_6 = value_1;
        } else {
          tmp_6 = it_1;
        }
        var tmp$ret$10 = tmp_6;
        var tmp_8 = pointerInput(tmp_5, observer, tmp$ret$10);
        var tmp0_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_0.o31(_Offset___get_packedValue__impl__xh2k8q(position));
        // Inline function 'kotlin.let' call
        var it_2 = tmp0_3.i31();
        var tmp_9;
        if (invalid_2 || it_2 === Companion_getInstance_11().f30_1) {
          var value_2 = TextFieldCursorHandle$lambda_0(position);
          tmp0_3.j31(value_2);
          tmp_9 = value_2;
        } else {
          tmp_9 = it_2;
        }
        var tmp$ret$14 = tmp_9;
        var tmp_10 = semantics(tmp_8, VOID, tmp$ret$14);
        CursorHandle(tmp_4, tmp_10, _DpSize___init__impl__t4mur0(new Long(0, 0)), $composer_0, 0, 4);
        $composer_0.n30();
      } else {
        $composer_0.m30(-2111042550);
        $composer_0.n30();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver_0 = $composer_0.t30();
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      tmp0_safe_receiver_0.p3c(TextFieldCursorHandle$lambda_1(manager, $changed));
    }
  }
  var Handle_Cursor_instance;
  var Handle_SelectionStart_instance;
  var Handle_SelectionEnd_instance;
  var Handle_entriesInitialized;
  function Handle_initEntries() {
    if (Handle_entriesInitialized)
      return Unit_instance;
    Handle_entriesInitialized = true;
    Handle_Cursor_instance = new Handle('Cursor', 0);
    Handle_SelectionStart_instance = new Handle('SelectionStart', 1);
    Handle_SelectionEnd_instance = new Handle('SelectionEnd', 2);
  }
  function Handle(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function requestFocusAndShowKeyboardIfNeeded(state, focusRequester, allowKeyboard) {
    if (!state.r9h()) {
      focusRequester.u9g();
    } else if (allowKeyboard) {
      var tmp0_safe_receiver = state.dk5_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.vbq();
      }
    }
  }
  function defaultTextFieldDraw(_this__u8e3s4, state, value, offsetMapping) {
    return drawBehind(_this__u8e3s4, defaultTextFieldDraw$lambda(state, value, offsetMapping));
  }
  function sam$androidx_compose_foundation_text_selection_OffsetProvider$0(function_0) {
    this.sk8_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_text_selection_OffsetProvider$0).tk8 = function () {
    return this.sk8_1().e5d_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_OffsetProvider$0).q3 = function () {
    return this.sk8_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_OffsetProvider$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, OffsetProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_OffsetProvider$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2(function_0) {
    this.uk8_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2).ka7 = function (_this__u8e3s4, $completion) {
    return this.uk8_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2).q3 = function () {
    return this.uk8_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function CoreTextField$lambda(it) {
    return Unit_instance;
  }
  function CoreTextField$lambda_0($orientation) {
    return function () {
      return new TextFieldScrollerPosition($orientation);
    };
  }
  function CoreTextField$lambda_1() {
    return EmptyCoroutineContext_getInstance();
  }
  function CoreTextField$lambda_2($manager) {
    return function (it) {
      $manager.vk8(it);
      return Unit_instance;
    };
  }
  function CoreTextField$lambda_3($manager) {
    return function () {
      return $manager.wk8();
    };
  }
  function CoreTextField$lambda_4($manager) {
    return function () {
      return $manager.xk8();
    };
  }
  function CoreTextField$lambda_5(it) {
    return Unit_instance;
  }
  function CoreTextField$lambda_6() {
    return null;
  }
  function CoreTextField$lambda_7() {
    return null;
  }
  function CoreTextField$lambda$lambda($onCopy) {
    return function (event) {
      var textToCopy = $onCopy._v();
      var tmp;
      var tmp_0;
      if (!(textToCopy == null)) {
        tmp_0 = event instanceof ClipboardEvent;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp0_safe_receiver = event.clipboardData;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.setData('text/plain', textToCopy.h7q_1);
        }
        event.preventDefault();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CoreTextField$lambda$lambda_0($onPaste) {
    return function (event) {
      var tmp;
      if (event instanceof ClipboardEvent) {
        var tmp0_safe_receiver = event.clipboardData;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getData('text/plain');
        var textToPaste = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        $onPaste._v(AnnotatedString_init_$Create$(textToPaste));
        event.preventDefault();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CoreTextField$lambda$lambda_1($onCut) {
    return function (event) {
      var cutText = $onCut._v();
      var tmp;
      var tmp_0;
      if (!(cutText == null)) {
        tmp_0 = event instanceof ClipboardEvent;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp0_safe_receiver = event.clipboardData;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.setData('text/plain', cutText.h7q_1);
        }
        event.preventDefault();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CoreTextField$$inlined$rememberClipboardEventsHandler$4$4($eventsTarget, $copyListener, $pasteListener, $cutListener) {
    this.yk8_1 = $eventsTarget;
    this.zk8_1 = $copyListener;
    this.ak9_1 = $pasteListener;
    this.bk9_1 = $cutListener;
  }
  protoOf(CoreTextField$$inlined$rememberClipboardEventsHandler$4$4).s1d = function () {
    var tmp0_safe_receiver = this.yk8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.removeEventListener('copy', this.zk8_1);
    }
    var tmp1_safe_receiver = this.yk8_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.removeEventListener('paste', this.ak9_1);
    }
    var tmp2_safe_receiver = this.yk8_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.removeEventListener('cut', this.bk9_1);
    }
  };
  function CoreTextField$lambda_8($clipEventsTargetProvider, $onCopy, $onPaste, $onCut) {
    return function ($this$DisposableEffect) {
      var copyListener = EventListener(CoreTextField$lambda$lambda($onCopy));
      var pasteListener = EventListener(CoreTextField$lambda$lambda_0($onPaste));
      var cutListener = EventListener(CoreTextField$lambda$lambda_1($onCut));
      var eventsTarget = $clipEventsTargetProvider();
      if (eventsTarget == null)
        null;
      else {
        eventsTarget.addEventListener('copy', copyListener);
      }
      if (eventsTarget == null)
        null;
      else {
        eventsTarget.addEventListener('paste', pasteListener);
      }
      if (eventsTarget == null)
        null;
      else {
        eventsTarget.addEventListener('cut', cutListener);
      }
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new CoreTextField$$inlined$rememberClipboardEventsHandler$4$4(eventsTarget, copyListener, pasteListener, cutListener);
    };
  }
  function CoreTextField$lambda$slambda($bringIntoViewRequester, $value, $state, $layoutResult, $offsetMapping, resultContinuation) {
    this.kk9_1 = $bringIntoViewRequester;
    this.lk9_1 = $value;
    this.mk9_1 = $state;
    this.nk9_1 = $layoutResult;
    this.ok9_1 = $offsetMapping;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CoreTextField$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CoreTextField$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CoreTextField$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = bringSelectionEndIntoView(this.kk9_1, this.lk9_1, this.mk9_1.bk5_1, this.nk9_1.hk8_1, this.ok9_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CoreTextField$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new CoreTextField$lambda$slambda(this.kk9_1, this.lk9_1, this.mk9_1, this.nk9_1, this.ok9_1, completion);
    i.pk9_1 = $this$launch;
    return i;
  };
  function CoreTextField$lambda$slambda_0($bringIntoViewRequester, $value, $state, $layoutResult, $offsetMapping, resultContinuation) {
    var i = new CoreTextField$lambda$slambda($bringIntoViewRequester, $value, $state, $layoutResult, $offsetMapping, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CoreTextField$lambda_9($state, $enabled, $readOnly, $textInputService, $value, $imeOptions, $offsetMapping, $coroutineScope, $manager, $bringIntoViewRequester) {
    return function (it) {
      var tmp;
      if ($state.r9h() === it.s9h()) {
        return Unit_instance;
      }
      $state.qk6(it.s9h());
      var tmp_0;
      if ($state.r9h() && $enabled._v && !$readOnly._v) {
        startInputSession($textInputService, $state, $value, $imeOptions._v, $offsetMapping);
        tmp_0 = Unit_instance;
      } else {
        endInputSession($state);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if (it.s9h()) {
        var tmp0_safe_receiver = $state.tk7();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          launch($coroutineScope, VOID, VOID, CoreTextField$lambda$slambda_0($bringIntoViewRequester, $value, $state, tmp0_safe_receiver, $offsetMapping, null));
        }
        tmp_1 = Unit_instance;
      }
      var tmp_2;
      if (!it.s9h()) {
        $manager.qk9();
        tmp_2 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CoreTextField$lambda_10($writeable$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('writeable', KProperty0, false);
    return $writeable$delegate.u1();
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_2(function_0) {
    this.rk9_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).a1v = function (value, $completion) {
    return this.rk9_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).q3 = function () {
    return this.rk9_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function CoreTextField$slambda$lambda($writeable$delegate) {
    return function () {
      return CoreTextField$lambda_10($writeable$delegate);
    };
  }
  function CoreTextField$slambda$slambda($state, $textInputService, $manager, $imeOptions, resultContinuation) {
    this.aka_1 = $state;
    this.bka_1 = $textInputService;
    this.cka_1 = $manager;
    this.dka_1 = $imeOptions;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CoreTextField$slambda$slambda).xf4 = function (writeable, $completion) {
    var tmp = this.yf4(writeable, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CoreTextField$slambda$slambda).ja = function (p1, $completion) {
    return this.xf4((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CoreTextField$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          if (this.eka_1 && this.aka_1.r9h()) {
            startInputSession(this.bka_1, this.aka_1, this.cka_1.mk8(), this.dka_1._v, this.cka_1.sk1_1);
          } else {
            endInputSession(this.aka_1);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CoreTextField$slambda$slambda).yf4 = function (writeable, completion) {
    var i = new CoreTextField$slambda$slambda(this.aka_1, this.bka_1, this.cka_1, this.dka_1, completion);
    i.eka_1 = writeable;
    return i;
  };
  function CoreTextField$slambda$slambda_0($state, $textInputService, $manager, $imeOptions, resultContinuation) {
    var i = new CoreTextField$slambda$slambda($state, $textInputService, $manager, $imeOptions, resultContinuation);
    return constructCallableReference(function (writeable, $completion) {
      return i.xf4(writeable, $completion);
    }, 1);
  }
  function CoreTextField$slambda($state, $writeable$delegate, $textInputService, $manager, $imeOptions, resultContinuation) {
    this.nka_1 = $state;
    this.oka_1 = $writeable$delegate;
    this.pka_1 = $textInputService;
    this.qka_1 = $manager;
    this.rka_1 = $imeOptions;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CoreTextField$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CoreTextField$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CoreTextField$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            var tmp_0 = snapshotFlow(CoreTextField$slambda$lambda(this.oka_1));
            var tmp_1 = CoreTextField$slambda$slambda_0(this.nka_1, this.pka_1, this.qka_1, this.rka_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_2(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            endInputSession(this.nka_1);
            return Unit_instance;
          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            endInputSession(this.nka_1);
            throw t;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CoreTextField$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CoreTextField$slambda(this.nka_1, this.oka_1, this.pka_1, this.qka_1, this.rka_1, completion);
    i.ska_1 = $this$LaunchedEffect;
    return i;
  };
  function CoreTextField$slambda_0($state, $writeable$delegate, $textInputService, $manager, $imeOptions, resultContinuation) {
    var i = new CoreTextField$slambda($state, $writeable$delegate, $textInputService, $manager, $imeOptions, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CoreTextField$lambda_11($state, $enabled, $windowInfo, $manager, $value, $offsetMapping) {
    return function (it) {
      $state.qk7(it);
      var tmp0_safe_receiver = $state.tk7();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.ik8_1 = it;
      }
      var tmp;
      if ($enabled._v) {
        if ($state.tk6().equals(HandleState_Selection_getInstance())) {
          if ($state.vk6() && $windowInfo.abr()) {
            $manager.ok8();
          } else {
            $manager.lk8();
          }
          $state.yk6(isSelectionHandleInVisibleBound($manager, true));
          $state.ak7(isSelectionHandleInVisibleBound($manager, false));
          $state.ck7(_TextRange___get_collapsed__impl__cilesp($value.g8a_1));
        } else if ($state.tk6().equals(HandleState_Cursor_getInstance())) {
          $state.ck7(isSelectionHandleInVisibleBound($manager, true));
        }
        notifyFocusedRect_0($state, $value, $offsetMapping);
        var tmp1_safe_receiver = $state.tk7();
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_0 = $state.fk5_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            if ($state.r9h()) {
              Companion_instance_29.tka(tmp0_safe_receiver_0, $value, $offsetMapping, tmp1_safe_receiver);
            }
          }
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CoreTextField$$inlined$cache$6$1($manager) {
    this.uka_1 = $manager;
  }
  protoOf(CoreTextField$$inlined$cache$6$1).s1d = function () {
    this.uka_1.lk8();
  };
  function CoreTextField$lambda_12($manager) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new CoreTextField$$inlined$cache$6$1($manager);
    };
  }
  function CoreTextField$$inlined$cache$7$1() {
  }
  protoOf(CoreTextField$$inlined$cache$7$1).s1d = function () {
  };
  function CoreTextField$lambda_13($state, $textInputService, $value, $imeOptions) {
    return function ($this$DisposableEffect) {
      var tmp;
      if ($state.r9h()) {
        $state.fk5_1 = Companion_instance_29.vka($textInputService, $value, $state.ek5_1, $imeOptions._v, $state.wk5_1, $state.xk5_1);
        tmp = Unit_instance;
      }
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new CoreTextField$$inlined$cache$7$1();
    };
  }
  function CoreTextField$lambda_14($handwritingEnabled, $legacyTextInputServiceAdapter) {
    return function () {
      var tmp;
      if ($handwritingEnabled) {
        $legacyTextInputServiceAdapter.xka();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CoreTextField$lambda_15($state, $autofillHighlightBrush) {
    return function ($this$drawWithContent) {
      $this$drawWithContent.z91();
      var tmp;
      if ($state.ek7() || $state.gk7()) {
        $this$drawWithContent.a6q($autofillHighlightBrush);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CoreTextField$lambda_16($state) {
    return function (it) {
      var tmp0_safe_receiver = $state.tk7();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.jk8_1 = it;
      }
      return Unit_instance;
    };
  }
  function CoreTextField$o$measure$lambda($this$layout) {
    return Unit_instance;
  }
  function CoreTextField$4($state, $onTextLayout, $value, $offsetMapping, $density, $maxLines) {
    this.yka_1 = $state;
    this.zka_1 = $onTextLayout;
    this.akb_1 = $value;
    this.bkb_1 = $offsetMapping;
    this.ckb_1 = $density;
    this.dkb_1 = $maxLines;
  }
  protoOf(CoreTextField$4).mak = function (_this__u8e3s4, measurables, constraints) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
      var previousSnapshot = Companion_instance_2.p52();
      var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
      var newSnapshot = Companion_instance_2.q52(previousSnapshot);
      try {
        tmp$ret$0 = this.yka_1.tk7();
        break $l$block;
      }finally {
        Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
      }
    }
    var prevProxy = tmp$ret$0;
    var prevResult = prevProxy == null ? null : prevProxy.hk8_1;
    var _destruct__k2r9zo = Companion_instance_29.ekb(this.yka_1.bk5_1, constraints, _this__u8e3s4.r6p(), prevResult);
    var width = _destruct__k2r9zo.zh();
    var height = _destruct__k2r9zo.ai();
    var result = _destruct__k2r9zo.hr();
    if (!equals(prevResult, result)) {
      this.yka_1.sk7(new TextLayoutResultProxy(result, VOID, prevProxy == null ? null : prevProxy.jk8_1));
      this.zka_1._v(result);
      notifyFocusedRect_0(this.yka_1, this.akb_1, this.bkb_1);
    }
    // Inline function 'kotlin.with' call
    var $this$with = this.ckb_1;
    var tmp0_subject = this.dkb_1._v;
    var tmp$ret$2 = $this$with.d5f(tmp0_subject === 1 ? ceilToIntPx(result.i7u(0)) : 0);
    this.yka_1.sk6(tmp$ret$2);
    var tmp = get_FirstBaseline();
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_0 = result.h80_1;
    var tmp_0;
    if (isNaN_0(this_0)) {
      tmp_0 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_0 = roundToInt(this_0);
    }
    var tmp$ret$4 = tmp_0;
    var tmp_1 = to(tmp, tmp$ret$4);
    var tmp_2 = get_LastBaseline();
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_1 = result.i80_1;
    var tmp_3;
    if (isNaN_0(this_1)) {
      tmp_3 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_3 = roundToInt(this_1);
    }
    var tmp$ret$6 = tmp_3;
    var tmp_4 = mapOf([tmp_1, to(tmp_2, tmp$ret$6)]);
    return _this__u8e3s4.kag(width, height, tmp_4, CoreTextField$o$measure$lambda);
  };
  protoOf(CoreTextField$4).pak = function (_this__u8e3s4, measurables, height) {
    this.yka_1.bk5_1.fkb(_this__u8e3s4.r6p());
    return this.yka_1.bk5_1.d62();
  };
  function CoreTextField$lambda$lambda$lambda($state) {
    return function () {
      return $state.tk7();
    };
  }
  function CoreTextField$lambda$lambda$lambda_0($manager, $state, $showHandleAndMagnifier, $readOnly, $onTextLayout, $value, $offsetMapping, $density, $maxLines) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var measurePolicy = new CoreTextField$4($state, $onTextLayout, $value, $offsetMapping, $density, $maxLines);
        var modifier = null;
        var $composer_1 = $composer_0;
        if (!((2 & 2) === 0))
          modifier = Companion_instance_0;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
        var localMap = $composer_1.t31();
        var materialized = materialize($composer_1, modifier);
        var tmp0 = Companion_getInstance_14().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_2 = $composer_1;
        var tmp_0 = $composer_2.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_2.b31();
        if ($composer_2.h30()) {
          $composer_2.c31(tmp0);
        } else {
          $composer_2.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
        var $composer_3 = $composer_2;
        $composer_2.e31();
        SelectionToolbarAndHandles($manager, !$state.tk6().equals(HandleState_None_getInstance()) && !($state.rk7() == null) && ensureNotNull($state.rk7()).y91() && $showHandleAndMagnifier, $composer_0, 0);
        var tmp_1;
        if ($state.tk6().equals(HandleState_Cursor_getInstance()) && !$readOnly._v && $showHandleAndMagnifier) {
          $composer_0.m30(-714666198);
          TextFieldCursorHandle($manager, $composer_0, 0);
          $composer_0.n30();
          tmp_1 = Unit_instance;
        } else {
          $composer_0.m30(-714589318);
          $composer_0.n30();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CoreTextField$lambda$lambda_2($state, $textStyle, $minLines, $maxLines, $scrollerPosition, $value, $visualTransformation, $overscrollEffect, $cursorModifier, $drawModifier, $onPositionedModifier, $magnifierModifier, $bringIntoViewRequester, $manager, $showHandleAndMagnifier, $readOnly, $onTextLayout, $offsetMapping, $density) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var tmp_0 = heightInLines(heightIn(Companion_instance_0, $state.rk6()), $textStyle._v, $minLines._v, $maxLines._v);
        var tmp_1 = $visualTransformation._v;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($state);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_2;
        if (invalid || it === Companion_getInstance_11().f30_1) {
          var value = CoreTextField$lambda$lambda$lambda($state);
          $composer_0.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it;
        }
        var tmp$ret$0 = tmp_2;
        var coreTextFieldModifier = bringIntoViewRequester(textFieldMinSize(textFieldScroll(tmp_0, $scrollerPosition, $value, tmp_1, $overscrollEffect, tmp$ret$0).d8v($cursorModifier).d8v($drawModifier), $textStyle._v).d8v($onPositionedModifier).d8v($magnifierModifier), $bringIntoViewRequester);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1412697320, true, CoreTextField$lambda$lambda$lambda_0($manager, $state, $showHandleAndMagnifier, $readOnly, $onTextLayout, $value, $offsetMapping, $density, $maxLines), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_3;
        if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_3 = value_0;
        } else {
          tmp_3 = it_0;
        }
        var tmp$ret$4 = tmp_3;
        SimpleLayout(coreTextFieldModifier, tmp$ret$4, $composer_0, 48, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CoreTextField$lambda_17($decorationBox, $state, $textStyle, $minLines, $maxLines, $scrollerPosition, $value, $visualTransformation, $overscrollEffect, $cursorModifier, $drawModifier, $onPositionedModifier, $magnifierModifier, $bringIntoViewRequester, $manager, $showHandleAndMagnifier, $readOnly, $onTextLayout, $offsetMapping, $density) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var tmp_0 = $decorationBox._v;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-44346382, true, CoreTextField$lambda$lambda_2($state, $textStyle, $minLines, $maxLines, $scrollerPosition, $value, $visualTransformation, $overscrollEffect, $cursorModifier, $drawModifier, $onPositionedModifier, $magnifierModifier, $bringIntoViewRequester, $manager, $showHandleAndMagnifier, $readOnly, $onTextLayout, $offsetMapping, $density), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance_11().f30_1) {
          var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        tmp = tmp_0(tmp_1, $composer_0, 6);
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CoreTextField$lambda_18($value, $onValueChange, $modifier, $textStyle, $visualTransformation, $onTextLayout, $interactionSource, $cursorBrush, $softWrap, $maxLines, $minLines, $imeOptions, $keyboardActions, $enabled, $readOnly, $decorationBox, $textScrollerPosition, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      CoreTextField($value, $onValueChange, $modifier._v, $textStyle._v, $visualTransformation._v, $onTextLayout._v, $interactionSource._v, $cursorBrush._v, $softWrap._v, $maxLines._v, $minLines._v, $imeOptions._v, $keyboardActions._v, $enabled._v, $readOnly._v, $decorationBox._v, $textScrollerPosition._v, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function previewKeyEventToDeselectOnBack$lambda($state, $manager) {
    return function (keyEvent) {
      var tmp;
      if ($state.tk6().equals(HandleState_Selection_getInstance()) && cancelsTextSelection(keyEvent.e9u_1)) {
        $manager.qk9();
        tmp = true;
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function CoreTextFieldRootBox$lambda($modifier, $manager, $content, $$changed) {
    return function ($composer, $force) {
      CoreTextFieldRootBox($modifier, $manager, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function SelectionToolbarAndHandles$lambda($manager, $show, $$changed) {
    return function ($composer, $force) {
      SelectionToolbarAndHandles($manager, $show, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function TextFieldCursorHandle$lambda($position) {
    return function () {
      return new Offset($position);
    };
  }
  function TextFieldCursorHandle$slambda$slambda$slambda$lambda($manager) {
    return function (it) {
      $manager.ok8();
      return Unit_instance;
    };
  }
  function TextFieldCursorHandle$slambda$slambda$slambda($this_pointerInput, $observer, resultContinuation) {
    this.okb_1 = $this_pointerInput;
    this.pkb_1 = $observer;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldCursorHandle$slambda$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldCursorHandle$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldCursorHandle$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectDownAndDragGesturesWithObserver(this.okb_1, this.pkb_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFieldCursorHandle$slambda$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new TextFieldCursorHandle$slambda$slambda$slambda(this.okb_1, this.pkb_1, completion);
    i.qkb_1 = $this$launch;
    return i;
  };
  function TextFieldCursorHandle$slambda$slambda$slambda_0($this_pointerInput, $observer, resultContinuation) {
    var i = new TextFieldCursorHandle$slambda$slambda$slambda($this_pointerInput, $observer, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TextFieldCursorHandle$slambda$slambda$slambda_1($this_pointerInput, $manager, resultContinuation) {
    this.zkb_1 = $this_pointerInput;
    this.akc_1 = $manager;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldCursorHandle$slambda$slambda$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldCursorHandle$slambda$slambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldCursorHandle$slambda$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectTapGestures(this.zkb_1, VOID, VOID, VOID, TextFieldCursorHandle$slambda$slambda$slambda$lambda(this.akc_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFieldCursorHandle$slambda$slambda$slambda_1).q24 = function ($this$launch, completion) {
    var i = new TextFieldCursorHandle$slambda$slambda$slambda_1(this.zkb_1, this.akc_1, completion);
    i.bkc_1 = $this$launch;
    return i;
  };
  function TextFieldCursorHandle$slambda$slambda$slambda_2($this_pointerInput, $manager, resultContinuation) {
    var i = new TextFieldCursorHandle$slambda$slambda$slambda_1($this_pointerInput, $manager, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TextFieldCursorHandle$slambda$slambda($this_pointerInput, $observer, $manager, resultContinuation) {
    this.kkc_1 = $this_pointerInput;
    this.lkc_1 = $observer;
    this.mkc_1 = $manager;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldCursorHandle$slambda$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldCursorHandle$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldCursorHandle$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
          launch(this.nkc_1, VOID, tmp_0, TextFieldCursorHandle$slambda$slambda$slambda_0(this.kkc_1, this.lkc_1, null));
          var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
          launch(this.nkc_1, VOID, tmp_1, TextFieldCursorHandle$slambda$slambda$slambda_2(this.kkc_1, this.mkc_1, null));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(TextFieldCursorHandle$slambda$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new TextFieldCursorHandle$slambda$slambda(this.kkc_1, this.lkc_1, this.mkc_1, completion);
    i.nkc_1 = $this$coroutineScope;
    return i;
  };
  function TextFieldCursorHandle$slambda$slambda_0($this_pointerInput, $observer, $manager, resultContinuation) {
    var i = new TextFieldCursorHandle$slambda$slambda($this_pointerInput, $observer, $manager, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function TextFieldCursorHandle$slambda($observer, $manager, resultContinuation) {
    this.wkc_1 = $observer;
    this.xkc_1 = $manager;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldCursorHandle$slambda).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldCursorHandle$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldCursorHandle$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = coroutineScope(TextFieldCursorHandle$slambda$slambda_0(this.ykc_1, this.wkc_1, this.xkc_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFieldCursorHandle$slambda).wc6 = function ($this$pointerInput, completion) {
    var i = new TextFieldCursorHandle$slambda(this.wkc_1, this.xkc_1, completion);
    i.ykc_1 = $this$pointerInput;
    return i;
  };
  function TextFieldCursorHandle$slambda_0($observer, $manager, resultContinuation) {
    var i = new TextFieldCursorHandle$slambda($observer, $manager, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function TextFieldCursorHandle$lambda_0($position) {
    return function ($this$semantics) {
      $this$semantics.mbr(get_SelectionHandleInfoKey(), new SelectionHandleInfo(Handle_Cursor_getInstance(), $position, SelectionHandleAnchor_Middle_getInstance(), true));
      return Unit_instance;
    };
  }
  function TextFieldCursorHandle$lambda_1($manager, $$changed) {
    return function ($composer, $force) {
      TextFieldCursorHandle($manager, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function defaultTextFieldDraw$lambda($state, $value, $offsetMapping) {
    return function ($this$drawBehind) {
      var tmp0_safe_receiver = $state.tk7();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'androidx.compose.ui.graphics.drawscope.drawIntoCanvas' call
        var canvas = $this$drawBehind.v6p().x5u();
        Companion_instance_29.zkc(canvas, $value, $state.ok7(), $state.pk7(), $offsetMapping, tmp0_safe_receiver.hk8_1, $state.zk5_1, $state.ak6_1);
      }
      return Unit_instance;
    };
  }
  function HandleState_None_getInstance() {
    HandleState_initEntries();
    return HandleState_None_instance;
  }
  function HandleState_Selection_getInstance() {
    HandleState_initEntries();
    return HandleState_Selection_instance;
  }
  function HandleState_Cursor_getInstance() {
    HandleState_initEntries();
    return HandleState_Cursor_instance;
  }
  function Handle_Cursor_getInstance() {
    Handle_initEntries();
    return Handle_Cursor_instance;
  }
  function Handle_SelectionStart_getInstance() {
    Handle_initEntries();
    return Handle_SelectionStart_instance;
  }
  function Handle_SelectionEnd_getInstance() {
    Handle_initEntries();
    return Handle_SelectionEnd_instance;
  }
  function heightInLines(_this__u8e3s4, textStyle, minLines, maxLines) {
    minLines = minLines === VOID ? 1 : minLines;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    validateMinMaxLines(minLines, maxLines);
    if (minLines === 1 && maxLines === 2147483647)
      return _this__u8e3s4;
    var tmp;
    if (ComposeFoundationFlags_instance.tfg_1) {
      tmp = _this__u8e3s4.d8v(new HeightInLinesElement(textStyle, minLines, maxLines));
    } else {
      tmp = legacyHeightInLines(_this__u8e3s4, textStyle, minLines, maxLines);
    }
    return tmp;
  }
  function validateMinMaxLines(minLines, maxLines) {
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(minLines > 0 && maxLines > 0)) {
      var tmp$ret$1 = 'both minLines ' + minLines + ' and maxLines ' + maxLines + ' must be greater than zero';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(minLines <= maxLines)) {
      var tmp$ret$3 = 'minLines ' + minLines + ' must be less than or equal to maxLines ' + maxLines;
      throwIllegalArgumentException(tmp$ret$3);
    }
  }
  function HeightInLinesElement(textStyle, minLines, maxLines) {
    ModifierNodeElement.call(this);
    this.bkd_1 = textStyle;
    this.ckd_1 = minLines;
    this.dkd_1 = maxLines;
  }
  protoOf(HeightInLinesElement).r3d = function () {
    return new HeightInLinesNode(this.bkd_1, this.ckd_1, this.dkd_1);
  };
  protoOf(HeightInLinesElement).ekd = function (node) {
    node.cke(this.bkd_1, this.ckd_1, this.dkd_1);
  };
  protoOf(HeightInLinesElement).d8y = function (node) {
    return this.ekd(node instanceof HeightInLinesNode ? node : THROW_CCE());
  };
  protoOf(HeightInLinesElement).hashCode = function () {
    var result = this.bkd_1.hashCode();
    result = imul(31, result) + this.ckd_1 | 0;
    result = imul(31, result) + this.dkd_1 | 0;
    return result;
  };
  protoOf(HeightInLinesElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HeightInLinesElement))
      return false;
    if (!this.bkd_1.equals(other.bkd_1))
      return false;
    if (!(this.ckd_1 === other.ckd_1))
      return false;
    if (!(this.dkd_1 === other.dkd_1))
      return false;
    return true;
  };
  function legacyHeightInLines(_this__u8e3s4, textStyle, minLines, maxLines) {
    minLines = minLines === VOID ? 1 : minLines;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = legacyHeightInLines$lambda(minLines, maxLines, textStyle);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp_0 = tmp;
    return composed(_this__u8e3s4, tmp_0, legacyHeightInLines$lambda_0(textStyle, minLines, maxLines));
  }
  function requireResolvedStyle($this) {
    // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
    var value = $this.zkd_1;
    if (value == null) {
      var tmp$ret$1 = 'Resolved style is not set.';
      throwIllegalArgumentExceptionForNullCheck(tmp$ret$1);
    }
    return value;
  }
  function requireFontResolutionState($this) {
    // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
    var value = $this.ake_1;
    if (value == null) {
      var tmp$ret$1 = 'Font resolution state is not set.';
      throwIllegalArgumentExceptionForNullCheck(tmp$ret$1);
    }
    return value;
  }
  function onFontResolutionStateChanged($this) {
    if (!($this.ake_1 == null)) {
      observeReads($this, HeightInLinesNode$onFontResolutionStateChanged$lambda($this));
    }
    $this.wkd_1 = true;
    invalidateMeasurement($this);
  }
  function computeHeights($this, density, resolvedStyle, fontFamilyResolver) {
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_0 = computeSizeForDefaultText(resolvedStyle, density, fontFamilyResolver, get_EmptyTextReplacement(), 1);
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    var firstLineHeight = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_1 = computeSizeForDefaultText(resolvedStyle, density, fontFamilyResolver, get_EmptyTextReplacement() + '\n' + get_EmptyTextReplacement(), 2);
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
    var firstTwoLinesHeight = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var lineHeight = firstTwoLinesHeight - firstLineHeight | 0;
    var tmp = $this;
    var tmp_0;
    if ($this.ukd_1 === 1) {
      tmp_0 = -1;
    } else {
      tmp_0 = firstLineHeight + imul(lineHeight, $this.ukd_1 - 1 | 0) | 0;
    }
    tmp.xkd_1 = tmp_0;
    var tmp_1 = $this;
    var tmp_2;
    if ($this.vkd_1 === 2147483647) {
      tmp_2 = -1;
    } else {
      tmp_2 = firstLineHeight + imul(lineHeight, $this.vkd_1 - 1 | 0) | 0;
    }
    tmp_1.ykd_1 = tmp_2;
  }
  function HeightInLinesNode$onAttach$lambda(this$0) {
    return function () {
      requireFontResolutionState(this$0).u1();
      return Unit_instance;
    };
  }
  function HeightInLinesNode$measure$lambda($measured) {
    return function ($this$layout) {
      $this$layout.a98($measured, 0, 0);
      return Unit_instance;
    };
  }
  function HeightInLinesNode$onFontResolutionStateChanged$lambda(this$0) {
    return function () {
      requireFontResolutionState(this$0).u1();
      return Unit_instance;
    };
  }
  function HeightInLinesNode(textStyle, minLines, maxLines) {
    Node.call(this);
    this.tkd_1 = textStyle;
    this.ukd_1 = minLines;
    this.vkd_1 = maxLines;
    this.wkd_1 = false;
    this.xkd_1 = -1;
    this.ykd_1 = -1;
    this.zkd_1 = null;
    this.ake_1 = null;
    this.bke_1 = false;
  }
  protoOf(HeightInLinesNode).b8w = function () {
    return this.bke_1;
  };
  protoOf(HeightInLinesNode).f8w = function () {
    protoOf(Node).f8w.call(this);
    var fontFamilyResolver = currentValueOf(this, get_LocalFontFamilyResolver());
    this.zkd_1 = resolveDefaults(this.tkd_1, requireLayoutDirection(this));
    var tmp = this;
    var tmp_0 = requireResolvedStyle(this).i82();
    var tmp0_elvis_lhs = requireResolvedStyle(this).f82();
    var tmp_1 = tmp0_elvis_lhs == null ? Companion_getInstance_19().b7z_1 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = requireResolvedStyle(this).g82();
    var tmp_2;
    var tmp_3 = tmp1_elvis_lhs;
    if ((tmp_3 == null ? null : new FontStyle(tmp_3)) == null) {
      tmp_2 = Companion_getInstance_32().k7z_1;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var tmp_4 = tmp_2;
    var tmp2_elvis_lhs = requireResolvedStyle(this).h82();
    var tmp_5;
    var tmp_6 = tmp2_elvis_lhs;
    if ((tmp_6 == null ? null : new FontSynthesis(tmp_6)) == null) {
      tmp_5 = Companion_getInstance_35().p7z_1;
    } else {
      tmp_5 = tmp2_elvis_lhs;
    }
    tmp.ake_1 = fontFamilyResolver.r84(tmp_0, tmp_1, tmp_4, tmp_5);
    observeReads(this, HeightInLinesNode$onAttach$lambda(this));
    this.wkd_1 = true;
  };
  protoOf(HeightInLinesNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    if (this.wkd_1) {
      computeHeights(this, _this__u8e3s4, requireResolvedStyle(this), currentValueOf(this, get_LocalFontFamilyResolver()));
      this.wkd_1 = false;
    }
    var tmp;
    if (!(this.xkd_1 === -1)) {
      tmp = coerceIn_1(this.xkd_1, _Constraints___get_minHeight__impl__ev4bgx(constraints), _Constraints___get_maxHeight__impl__dt3e8z(constraints));
    } else {
      tmp = _Constraints___get_minHeight__impl__ev4bgx(constraints);
    }
    var minHeight = tmp;
    var tmp_0;
    if (!(this.ykd_1 === -1)) {
      tmp_0 = coerceIn_1(this.ykd_1, _Constraints___get_minHeight__impl__ev4bgx(constraints), _Constraints___get_maxHeight__impl__dt3e8z(constraints));
    } else {
      tmp_0 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    }
    var maxHeight = tmp_0;
    var childConstraints = Constraints__copy$default_impl_f452rp(constraints, VOID, VOID, minHeight, maxHeight);
    var measured = measurable.h8y(childConstraints);
    var tmp_1 = measured.i8y_1;
    var tmp_2 = measured.j8y_1;
    return _this__u8e3s4.n8y(tmp_1, tmp_2, VOID, HeightInLinesNode$measure$lambda(measured));
  };
  protoOf(HeightInLinesNode).w95 = function () {
    onFontResolutionStateChanged(this);
  };
  protoOf(HeightInLinesNode).o8w = function () {
    this.zkd_1 = resolveDefaults(this.tkd_1, requireLayoutDirection(this));
    this.wkd_1 = true;
    invalidateMeasurement(this);
  };
  protoOf(HeightInLinesNode).n8w = function () {
    this.wkd_1 = true;
    invalidateMeasurement(this);
  };
  protoOf(HeightInLinesNode).h8w = function () {
    this.zkd_1 = null;
    this.ake_1 = null;
    this.wkd_1 = false;
  };
  protoOf(HeightInLinesNode).cke = function (textStyle, minLines, maxLines) {
    if (!this.tkd_1.equals(textStyle) || !(this.ukd_1 === minLines) || !(this.vkd_1 === maxLines)) {
      this.tkd_1 = textStyle;
      this.ukd_1 = minLines;
      this.vkd_1 = maxLines;
      this.zkd_1 = resolveDefaults(textStyle, requireLayoutDirection(this));
      this.wkd_1 = true;
      invalidateMeasurement(this);
    }
  };
  function legacyHeightInLines$lambda($minLines, $maxLines, $textStyle) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'heightInLines';
      _this__u8e3s4.mdp_1.odp('minLines', $minLines);
      _this__u8e3s4.mdp_1.odp('maxLines', $maxLines);
      _this__u8e3s4.mdp_1.odp('textStyle', $textStyle);
      return Unit_instance;
    };
  }
  function invoke$lambda($typeface$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('typeface', KProperty0, false);
    return $typeface$delegate.u1();
  }
  function legacyHeightInLines$lambda_0($textStyle, $minLines, $maxLines) {
    return function ($this$composed, $composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(595899793);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_0 = get_LocalDensity();
      var $composer_1 = $composer_0;
      var density = $composer_1.u31(this_0);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_1 = get_LocalFontFamilyResolver();
      var $composer_2 = $composer_0;
      var fontFamilyResolver = $composer_2.u31(this_1);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_2 = get_LocalLayoutDirection();
      var $composer_3 = $composer_0;
      var layoutDirection = $composer_3.u31(this_2);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.k31($textStyle) | $composer_0.m31(layoutDirection.a1_1));
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = resolveDefaults($textStyle, layoutDirection);
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var resolvedStyle = tmp;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.k31(fontFamilyResolver) | $composer_0.k31(resolvedStyle));
      // Inline function 'kotlin.let' call
      var it_0 = $composer_0.i31();
      var tmp_0;
      if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
        var tmp_1 = resolvedStyle.i82();
        var tmp0_elvis_lhs = resolvedStyle.f82();
        var tmp_2 = tmp0_elvis_lhs == null ? Companion_getInstance_19().b7z_1 : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = resolvedStyle.g82();
        var tmp_3;
        var tmp_4 = tmp1_elvis_lhs;
        if ((tmp_4 == null ? null : new FontStyle(tmp_4)) == null) {
          tmp_3 = Companion_getInstance_32().k7z_1;
        } else {
          tmp_3 = tmp1_elvis_lhs;
        }
        var tmp_5 = tmp_3;
        var tmp2_elvis_lhs = resolvedStyle.h82();
        var tmp_6;
        var tmp_7 = tmp2_elvis_lhs;
        if ((tmp_7 == null ? null : new FontSynthesis(tmp_7)) == null) {
          tmp_6 = Companion_getInstance_35().p7z_1;
        } else {
          tmp_6 = tmp2_elvis_lhs;
        }
        var value_0 = fontFamilyResolver.r84(tmp_1, tmp_2, tmp_5, tmp_6);
        $composer_0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var typeface$delegate = tmp_0;
      var tmp1_remember$arg$4 = invoke$lambda(typeface$delegate);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(!!(!!(!!($composer_0.k31(density) | $composer_0.k31(fontFamilyResolver)) | $composer_0.k31($textStyle)) | $composer_0.m31(layoutDirection.a1_1)) | $composer_0.k31(tmp1_remember$arg$4));
      // Inline function 'kotlin.let' call
      var it_1 = $composer_0.i31();
      var tmp_8;
      if (invalid_1 || it_1 === Companion_getInstance_11().f30_1) {
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        var this_3 = computeSizeForDefaultText(resolvedStyle, density, fontFamilyResolver, get_EmptyTextReplacement(), 1);
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_1 = _IntSize___get_packedValue__impl__uho7jf(this_3);
        var value_2 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
        $composer_0.j31(value_2);
        tmp_8 = value_2;
      } else {
        tmp_8 = it_1;
      }
      var firstLineHeight = tmp_8;
      var tmp2_remember$arg$4 = invoke$lambda(typeface$delegate);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = !!(!!(!!(!!($composer_0.k31(density) | $composer_0.k31(fontFamilyResolver)) | $composer_0.k31($textStyle)) | $composer_0.m31(layoutDirection.a1_1)) | $composer_0.k31(tmp2_remember$arg$4));
      // Inline function 'kotlin.let' call
      var it_2 = $composer_0.i31();
      var tmp_9;
      if (invalid_2 || it_2 === Companion_getInstance_11().f30_1) {
        var twoLines = get_EmptyTextReplacement() + '\n' + get_EmptyTextReplacement();
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        var this_4 = computeSizeForDefaultText(resolvedStyle, density, fontFamilyResolver, twoLines, 2);
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_3 = _IntSize___get_packedValue__impl__uho7jf(this_4);
        var value_4 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
        $composer_0.j31(value_4);
        tmp_9 = value_4;
      } else {
        tmp_9 = it_2;
      }
      var firstTwoLinesHeight = tmp_9;
      var lineHeight = firstTwoLinesHeight - firstLineHeight | 0;
      var precomputedMinLinesHeight = $minLines === 1 ? null : firstLineHeight + imul(lineHeight, $minLines - 1 | 0) | 0;
      var precomputedMaxLinesHeight = $maxLines === 2147483647 ? null : firstLineHeight + imul(lineHeight, $maxLines - 1 | 0) | 0;
      // Inline function 'kotlin.with' call
      var tmp_10 = Companion_instance_0;
      var tmp1_elvis_lhs_0 = precomputedMinLinesHeight == null ? null : density.d5f(precomputedMinLinesHeight);
      var tmp_11;
      var tmp_12 = tmp1_elvis_lhs_0;
      if ((tmp_12 == null ? null : new Dp(tmp_12)) == null) {
        tmp_11 = Companion_getInstance_4().p5f_1;
      } else {
        tmp_11 = tmp1_elvis_lhs_0;
      }
      var tmp_13 = tmp_11;
      var tmp3_elvis_lhs = precomputedMaxLinesHeight == null ? null : density.d5f(precomputedMaxLinesHeight);
      var tmp_14;
      var tmp_15 = tmp3_elvis_lhs;
      if ((tmp_15 == null ? null : new Dp(tmp_15)) == null) {
        tmp_14 = Companion_getInstance_4().p5f_1;
      } else {
        tmp_14 = tmp3_elvis_lhs;
      }
      var tmp0 = heightIn(tmp_10, tmp_13, tmp_14);
      $composer_0.n30();
      return tmp0;
    };
  }
  var androidx_compose_foundation_text_InlineTextContent$stable;
  var KeyCommand_LEFT_CHAR_instance;
  var KeyCommand_RIGHT_CHAR_instance;
  var KeyCommand_RIGHT_WORD_instance;
  var KeyCommand_LEFT_WORD_instance;
  var KeyCommand_NEXT_PARAGRAPH_instance;
  var KeyCommand_PREV_PARAGRAPH_instance;
  var KeyCommand_LINE_START_instance;
  var KeyCommand_LINE_END_instance;
  var KeyCommand_LINE_LEFT_instance;
  var KeyCommand_LINE_RIGHT_instance;
  var KeyCommand_UP_instance;
  var KeyCommand_DOWN_instance;
  var KeyCommand_CENTER_instance;
  var KeyCommand_PAGE_UP_instance;
  var KeyCommand_PAGE_DOWN_instance;
  var KeyCommand_HOME_instance;
  var KeyCommand_END_instance;
  var KeyCommand_COPY_instance;
  var KeyCommand_PASTE_instance;
  var KeyCommand_CUT_instance;
  var KeyCommand_DELETE_PREV_CHAR_instance;
  var KeyCommand_DELETE_NEXT_CHAR_instance;
  var KeyCommand_DELETE_PREV_WORD_instance;
  var KeyCommand_DELETE_NEXT_WORD_instance;
  var KeyCommand_DELETE_FROM_LINE_START_instance;
  var KeyCommand_DELETE_TO_LINE_END_instance;
  var KeyCommand_SELECT_ALL_instance;
  var KeyCommand_SELECT_LEFT_CHAR_instance;
  var KeyCommand_SELECT_RIGHT_CHAR_instance;
  var KeyCommand_SELECT_UP_instance;
  var KeyCommand_SELECT_DOWN_instance;
  var KeyCommand_SELECT_PAGE_UP_instance;
  var KeyCommand_SELECT_PAGE_DOWN_instance;
  var KeyCommand_SELECT_HOME_instance;
  var KeyCommand_SELECT_END_instance;
  var KeyCommand_SELECT_LEFT_WORD_instance;
  var KeyCommand_SELECT_RIGHT_WORD_instance;
  var KeyCommand_SELECT_NEXT_PARAGRAPH_instance;
  var KeyCommand_SELECT_PREV_PARAGRAPH_instance;
  var KeyCommand_SELECT_LINE_START_instance;
  var KeyCommand_SELECT_LINE_END_instance;
  var KeyCommand_SELECT_LINE_LEFT_instance;
  var KeyCommand_SELECT_LINE_RIGHT_instance;
  var KeyCommand_DESELECT_instance;
  var KeyCommand_NEW_LINE_instance;
  var KeyCommand_TAB_instance;
  var KeyCommand_UNDO_instance;
  var KeyCommand_REDO_instance;
  var KeyCommand_CHARACTER_PALETTE_instance;
  var KeyCommand_entriesInitialized;
  function KeyCommand_initEntries() {
    if (KeyCommand_entriesInitialized)
      return Unit_instance;
    KeyCommand_entriesInitialized = true;
    KeyCommand_LEFT_CHAR_instance = new KeyCommand('LEFT_CHAR', 0, false);
    KeyCommand_RIGHT_CHAR_instance = new KeyCommand('RIGHT_CHAR', 1, false);
    KeyCommand_RIGHT_WORD_instance = new KeyCommand('RIGHT_WORD', 2, false);
    KeyCommand_LEFT_WORD_instance = new KeyCommand('LEFT_WORD', 3, false);
    KeyCommand_NEXT_PARAGRAPH_instance = new KeyCommand('NEXT_PARAGRAPH', 4, false);
    KeyCommand_PREV_PARAGRAPH_instance = new KeyCommand('PREV_PARAGRAPH', 5, false);
    KeyCommand_LINE_START_instance = new KeyCommand('LINE_START', 6, false);
    KeyCommand_LINE_END_instance = new KeyCommand('LINE_END', 7, false);
    KeyCommand_LINE_LEFT_instance = new KeyCommand('LINE_LEFT', 8, false);
    KeyCommand_LINE_RIGHT_instance = new KeyCommand('LINE_RIGHT', 9, false);
    KeyCommand_UP_instance = new KeyCommand('UP', 10, false);
    KeyCommand_DOWN_instance = new KeyCommand('DOWN', 11, false);
    KeyCommand_CENTER_instance = new KeyCommand('CENTER', 12, false);
    KeyCommand_PAGE_UP_instance = new KeyCommand('PAGE_UP', 13, false);
    KeyCommand_PAGE_DOWN_instance = new KeyCommand('PAGE_DOWN', 14, false);
    KeyCommand_HOME_instance = new KeyCommand('HOME', 15, false);
    KeyCommand_END_instance = new KeyCommand('END', 16, false);
    KeyCommand_COPY_instance = new KeyCommand('COPY', 17, false);
    KeyCommand_PASTE_instance = new KeyCommand('PASTE', 18, true);
    KeyCommand_CUT_instance = new KeyCommand('CUT', 19, true);
    KeyCommand_DELETE_PREV_CHAR_instance = new KeyCommand('DELETE_PREV_CHAR', 20, true);
    KeyCommand_DELETE_NEXT_CHAR_instance = new KeyCommand('DELETE_NEXT_CHAR', 21, true);
    KeyCommand_DELETE_PREV_WORD_instance = new KeyCommand('DELETE_PREV_WORD', 22, true);
    KeyCommand_DELETE_NEXT_WORD_instance = new KeyCommand('DELETE_NEXT_WORD', 23, true);
    KeyCommand_DELETE_FROM_LINE_START_instance = new KeyCommand('DELETE_FROM_LINE_START', 24, true);
    KeyCommand_DELETE_TO_LINE_END_instance = new KeyCommand('DELETE_TO_LINE_END', 25, true);
    KeyCommand_SELECT_ALL_instance = new KeyCommand('SELECT_ALL', 26, false);
    KeyCommand_SELECT_LEFT_CHAR_instance = new KeyCommand('SELECT_LEFT_CHAR', 27, false);
    KeyCommand_SELECT_RIGHT_CHAR_instance = new KeyCommand('SELECT_RIGHT_CHAR', 28, false);
    KeyCommand_SELECT_UP_instance = new KeyCommand('SELECT_UP', 29, false);
    KeyCommand_SELECT_DOWN_instance = new KeyCommand('SELECT_DOWN', 30, false);
    KeyCommand_SELECT_PAGE_UP_instance = new KeyCommand('SELECT_PAGE_UP', 31, false);
    KeyCommand_SELECT_PAGE_DOWN_instance = new KeyCommand('SELECT_PAGE_DOWN', 32, false);
    KeyCommand_SELECT_HOME_instance = new KeyCommand('SELECT_HOME', 33, false);
    KeyCommand_SELECT_END_instance = new KeyCommand('SELECT_END', 34, false);
    KeyCommand_SELECT_LEFT_WORD_instance = new KeyCommand('SELECT_LEFT_WORD', 35, false);
    KeyCommand_SELECT_RIGHT_WORD_instance = new KeyCommand('SELECT_RIGHT_WORD', 36, false);
    KeyCommand_SELECT_NEXT_PARAGRAPH_instance = new KeyCommand('SELECT_NEXT_PARAGRAPH', 37, false);
    KeyCommand_SELECT_PREV_PARAGRAPH_instance = new KeyCommand('SELECT_PREV_PARAGRAPH', 38, false);
    KeyCommand_SELECT_LINE_START_instance = new KeyCommand('SELECT_LINE_START', 39, false);
    KeyCommand_SELECT_LINE_END_instance = new KeyCommand('SELECT_LINE_END', 40, false);
    KeyCommand_SELECT_LINE_LEFT_instance = new KeyCommand('SELECT_LINE_LEFT', 41, false);
    KeyCommand_SELECT_LINE_RIGHT_instance = new KeyCommand('SELECT_LINE_RIGHT', 42, false);
    KeyCommand_DESELECT_instance = new KeyCommand('DESELECT', 43, false);
    KeyCommand_NEW_LINE_instance = new KeyCommand('NEW_LINE', 44, true);
    KeyCommand_TAB_instance = new KeyCommand('TAB', 45, true);
    KeyCommand_UNDO_instance = new KeyCommand('UNDO', 46, true);
    KeyCommand_REDO_instance = new KeyCommand('REDO', 47, true);
    KeyCommand_CHARACTER_PALETTE_instance = new KeyCommand('CHARACTER_PALETTE', 48, true);
  }
  function KeyCommand(name, ordinal, editsText) {
    Enum.call(this, name, ordinal);
    this.fke_1 = editsText;
  }
  function KeyCommand_LEFT_CHAR_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_LEFT_CHAR_instance;
  }
  function KeyCommand_RIGHT_CHAR_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_RIGHT_CHAR_instance;
  }
  function KeyCommand_RIGHT_WORD_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_RIGHT_WORD_instance;
  }
  function KeyCommand_LEFT_WORD_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_LEFT_WORD_instance;
  }
  function KeyCommand_NEXT_PARAGRAPH_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_NEXT_PARAGRAPH_instance;
  }
  function KeyCommand_PREV_PARAGRAPH_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_PREV_PARAGRAPH_instance;
  }
  function KeyCommand_LINE_START_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_LINE_START_instance;
  }
  function KeyCommand_LINE_END_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_LINE_END_instance;
  }
  function KeyCommand_LINE_LEFT_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_LINE_LEFT_instance;
  }
  function KeyCommand_LINE_RIGHT_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_LINE_RIGHT_instance;
  }
  function KeyCommand_UP_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_UP_instance;
  }
  function KeyCommand_DOWN_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_DOWN_instance;
  }
  function KeyCommand_CENTER_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_CENTER_instance;
  }
  function KeyCommand_PAGE_UP_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_PAGE_UP_instance;
  }
  function KeyCommand_PAGE_DOWN_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_PAGE_DOWN_instance;
  }
  function KeyCommand_HOME_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_HOME_instance;
  }
  function KeyCommand_END_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_END_instance;
  }
  function KeyCommand_COPY_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_COPY_instance;
  }
  function KeyCommand_PASTE_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_PASTE_instance;
  }
  function KeyCommand_CUT_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_CUT_instance;
  }
  function KeyCommand_DELETE_PREV_CHAR_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_DELETE_PREV_CHAR_instance;
  }
  function KeyCommand_DELETE_NEXT_CHAR_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_DELETE_NEXT_CHAR_instance;
  }
  function KeyCommand_DELETE_PREV_WORD_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_DELETE_PREV_WORD_instance;
  }
  function KeyCommand_DELETE_NEXT_WORD_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_DELETE_NEXT_WORD_instance;
  }
  function KeyCommand_DELETE_FROM_LINE_START_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_DELETE_FROM_LINE_START_instance;
  }
  function KeyCommand_DELETE_TO_LINE_END_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_DELETE_TO_LINE_END_instance;
  }
  function KeyCommand_SELECT_ALL_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_ALL_instance;
  }
  function KeyCommand_SELECT_LEFT_CHAR_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_LEFT_CHAR_instance;
  }
  function KeyCommand_SELECT_RIGHT_CHAR_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_RIGHT_CHAR_instance;
  }
  function KeyCommand_SELECT_UP_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_UP_instance;
  }
  function KeyCommand_SELECT_DOWN_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_DOWN_instance;
  }
  function KeyCommand_SELECT_PAGE_UP_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_PAGE_UP_instance;
  }
  function KeyCommand_SELECT_PAGE_DOWN_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_PAGE_DOWN_instance;
  }
  function KeyCommand_SELECT_HOME_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_HOME_instance;
  }
  function KeyCommand_SELECT_END_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_END_instance;
  }
  function KeyCommand_SELECT_LEFT_WORD_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_LEFT_WORD_instance;
  }
  function KeyCommand_SELECT_RIGHT_WORD_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_RIGHT_WORD_instance;
  }
  function KeyCommand_SELECT_NEXT_PARAGRAPH_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_NEXT_PARAGRAPH_instance;
  }
  function KeyCommand_SELECT_PREV_PARAGRAPH_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_PREV_PARAGRAPH_instance;
  }
  function KeyCommand_SELECT_LINE_START_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_LINE_START_instance;
  }
  function KeyCommand_SELECT_LINE_END_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_LINE_END_instance;
  }
  function KeyCommand_SELECT_LINE_LEFT_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_LINE_LEFT_instance;
  }
  function KeyCommand_SELECT_LINE_RIGHT_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_SELECT_LINE_RIGHT_instance;
  }
  function KeyCommand_DESELECT_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_DESELECT_instance;
  }
  function KeyCommand_NEW_LINE_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_NEW_LINE_instance;
  }
  function KeyCommand_TAB_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_TAB_instance;
  }
  function KeyCommand_UNDO_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_UNDO_instance;
  }
  function KeyCommand_REDO_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_REDO_instance;
  }
  function KeyCommand_CHARACTER_PALETTE_getInstance() {
    KeyCommand_initEntries();
    return KeyCommand_CHARACTER_PALETTE_instance;
  }
  function get_defaultKeyMapping() {
    _init_properties_KeyMapping_kt__n34hqn();
    return defaultKeyMapping;
  }
  var defaultKeyMapping;
  function commonKeyMapping(systemShortcutModifiers) {
    _init_properties_KeyMapping_kt__n34hqn();
    return new commonKeyMapping$1(systemShortcutModifiers);
  }
  function defaultKeyMapping$1($common) {
    this.gke_1 = $common;
  }
  protoOf(defaultKeyMapping$1).hke = function (event) {
    var keyModifiers = get_modifiers(event);
    var tmp0_subject = get_key(event);
    var tmp;
    if (equals(tmp0_subject, Companion_getInstance_10().bcb_1)) {
      tmp = keyModifiers === Companion_getInstance_74().mke_1 || (keyModifiers === Companion_getInstance_74().qke_1 || keyModifiers === Companion_getInstance_74().tke_1) ? KeyCommand_DELETE_PREV_CHAR_getInstance() : keyModifiers === Companion_getInstance_74().oke_1 || keyModifiers === Companion_getInstance_74().ske_1 ? KeyCommand_DELETE_PREV_WORD_getInstance() : null;
    } else if (equals(tmp0_subject, Companion_getInstance_10().acb_1) || equals(tmp0_subject, Companion_getInstance_10().vcc_1)) {
      tmp = keyModifiers === Companion_getInstance_74().mke_1 || keyModifiers === Companion_getInstance_74().qke_1 || (keyModifiers === Companion_getInstance_74().oke_1 || keyModifiers === Companion_getInstance_74().ske_1) ? KeyCommand_NEW_LINE_getInstance() : null;
    } else {
      tmp = null;
    }
    var tmp3_safe_receiver = tmp;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp3_safe_receiver;
    }
    var tmp4_subject = get_modifiers(event);
    var tmp_0;
    if (tmp4_subject === Companion_getInstance_74().ske_1) {
      var tmp5_subject = get_key(event);
      tmp_0 = equals(tmp5_subject, Companion_getInstance_10().ec9_1) || equals(tmp5_subject, Companion_getInstance_10().dck_1) ? KeyCommand_SELECT_LEFT_WORD_getInstance() : equals(tmp5_subject, Companion_getInstance_10().fc9_1) || equals(tmp5_subject, Companion_getInstance_10().eck_1) ? KeyCommand_SELECT_RIGHT_WORD_getInstance() : equals(tmp5_subject, Companion_getInstance_10().cc9_1) || equals(tmp5_subject, Companion_getInstance_10().bck_1) ? KeyCommand_SELECT_PREV_PARAGRAPH_getInstance() : equals(tmp5_subject, Companion_getInstance_10().dc9_1) || equals(tmp5_subject, Companion_getInstance_10().cck_1) ? KeyCommand_SELECT_NEXT_PARAGRAPH_getInstance() : null;
    } else if (tmp4_subject === Companion_getInstance_74().oke_1) {
      var tmp6_subject = get_key(event);
      tmp_0 = equals(tmp6_subject, Companion_getInstance_10().ec9_1) || equals(tmp6_subject, Companion_getInstance_10().dck_1) ? KeyCommand_LEFT_WORD_getInstance() : equals(tmp6_subject, Companion_getInstance_10().fc9_1) || equals(tmp6_subject, Companion_getInstance_10().eck_1) ? KeyCommand_RIGHT_WORD_getInstance() : equals(tmp6_subject, Companion_getInstance_10().cc9_1) || equals(tmp6_subject, Companion_getInstance_10().bck_1) ? KeyCommand_PREV_PARAGRAPH_getInstance() : equals(tmp6_subject, Companion_getInstance_10().dc9_1) || equals(tmp6_subject, Companion_getInstance_10().cck_1) ? KeyCommand_NEXT_PARAGRAPH_getInstance() : equals(tmp6_subject, Companion_getInstance_10().zc9_1) ? KeyCommand_DELETE_PREV_CHAR_getInstance() : equals(tmp6_subject, Companion_getInstance_10().ccb_1) ? KeyCommand_DELETE_NEXT_WORD_getInstance() : equals(tmp6_subject, Companion_getInstance_10().qcb_1) ? KeyCommand_DESELECT_getInstance() : null;
    } else if (tmp4_subject === Companion_getInstance_74().qke_1) {
      var tmp7_subject = get_key(event);
      tmp_0 = equals(tmp7_subject, Companion_getInstance_10().wcc_1) || equals(tmp7_subject, Companion_getInstance_10().fck_1) ? KeyCommand_SELECT_LINE_START_getInstance() : equals(tmp7_subject, Companion_getInstance_10().xcc_1) || equals(tmp7_subject, Companion_getInstance_10().gck_1) ? KeyCommand_SELECT_LINE_END_getInstance() : null;
    } else if (tmp4_subject === Companion_getInstance_74().nke_1) {
      var tmp8_subject = get_key(event);
      tmp_0 = equals(tmp8_subject, Companion_getInstance_10().ccb_1) ? KeyCommand_DELETE_TO_LINE_END_getInstance() : null;
    } else {
      tmp_0 = null;
    }
    var tmp9_elvis_lhs = tmp_0;
    return tmp9_elvis_lhs == null ? this.gke_1.hke(event) : tmp9_elvis_lhs;
  };
  function commonKeyMapping$1($systemShortcutModifiers) {
    this.xke_1 = $systemShortcutModifiers;
  }
  protoOf(commonKeyMapping$1).hke = function (event) {
    var keyModifiers = get_modifiers(event);
    var tmp;
    if (keyModifiers === KeyModifiers__plus_impl_wj4ney(this.xke_1, Companion_getInstance_74().qke_1)) {
      var tmp1_subject = get_key(event);
      tmp = equals(tmp1_subject, Companion_getInstance_10().rca_1) ? KeyCommand_REDO_getInstance() : null;
    } else if (keyModifiers === this.xke_1) {
      var tmp2_subject = get_key(event);
      tmp = equals(tmp2_subject, Companion_getInstance_10().uc9_1) || (equals(tmp2_subject, Companion_getInstance_10().lcb_1) || equals(tmp2_subject, Companion_getInstance_10().jck_1)) ? KeyCommand_COPY_getInstance() : equals(tmp2_subject, Companion_getInstance_10().nca_1) ? KeyCommand_PASTE_getInstance() : equals(tmp2_subject, Companion_getInstance_10().pca_1) ? KeyCommand_CUT_getInstance() : equals(tmp2_subject, Companion_getInstance_10().sc9_1) ? KeyCommand_SELECT_ALL_getInstance() : equals(tmp2_subject, Companion_getInstance_10().qca_1) ? KeyCommand_REDO_getInstance() : equals(tmp2_subject, Companion_getInstance_10().rca_1) ? KeyCommand_UNDO_getInstance() : null;
    } else if (keyModifiers === Companion_getInstance_74().qke_1) {
      var tmp3_subject = get_key(event);
      tmp = equals(tmp3_subject, Companion_getInstance_10().ec9_1) || equals(tmp3_subject, Companion_getInstance_10().dck_1) ? KeyCommand_SELECT_LEFT_CHAR_getInstance() : equals(tmp3_subject, Companion_getInstance_10().fc9_1) || equals(tmp3_subject, Companion_getInstance_10().eck_1) ? KeyCommand_SELECT_RIGHT_CHAR_getInstance() : equals(tmp3_subject, Companion_getInstance_10().cc9_1) || equals(tmp3_subject, Companion_getInstance_10().bck_1) ? KeyCommand_SELECT_UP_getInstance() : equals(tmp3_subject, Companion_getInstance_10().dc9_1) || equals(tmp3_subject, Companion_getInstance_10().cck_1) ? KeyCommand_SELECT_DOWN_getInstance() : equals(tmp3_subject, Companion_getInstance_10().scb_1) || equals(tmp3_subject, Companion_getInstance_10().hck_1) ? KeyCommand_SELECT_PAGE_UP_getInstance() : equals(tmp3_subject, Companion_getInstance_10().tcb_1) || equals(tmp3_subject, Companion_getInstance_10().ick_1) ? KeyCommand_SELECT_PAGE_DOWN_getInstance() : equals(tmp3_subject, Companion_getInstance_10().wcc_1) || equals(tmp3_subject, Companion_getInstance_10().fck_1) ? KeyCommand_SELECT_LINE_START_getInstance() : equals(tmp3_subject, Companion_getInstance_10().xcc_1) || equals(tmp3_subject, Companion_getInstance_10().gck_1) ? KeyCommand_SELECT_LINE_END_getInstance() : equals(tmp3_subject, Companion_getInstance_10().lcb_1) || equals(tmp3_subject, Companion_getInstance_10().jck_1) ? KeyCommand_PASTE_getInstance() : null;
    } else if (keyModifiers === Companion_getInstance_74().mke_1) {
      var tmp4_subject = get_key(event);
      tmp = equals(tmp4_subject, Companion_getInstance_10().ec9_1) || equals(tmp4_subject, Companion_getInstance_10().dck_1) ? KeyCommand_LEFT_CHAR_getInstance() : equals(tmp4_subject, Companion_getInstance_10().fc9_1) || equals(tmp4_subject, Companion_getInstance_10().eck_1) ? KeyCommand_RIGHT_CHAR_getInstance() : equals(tmp4_subject, Companion_getInstance_10().cc9_1) || equals(tmp4_subject, Companion_getInstance_10().bck_1) ? KeyCommand_UP_getInstance() : equals(tmp4_subject, Companion_getInstance_10().dc9_1) || equals(tmp4_subject, Companion_getInstance_10().cck_1) ? KeyCommand_DOWN_getInstance() : equals(tmp4_subject, Companion_getInstance_10().mcd_1) ? KeyCommand_CENTER_getInstance() : equals(tmp4_subject, Companion_getInstance_10().scb_1) || equals(tmp4_subject, Companion_getInstance_10().hck_1) ? KeyCommand_PAGE_UP_getInstance() : equals(tmp4_subject, Companion_getInstance_10().tcb_1) || equals(tmp4_subject, Companion_getInstance_10().ick_1) ? KeyCommand_PAGE_DOWN_getInstance() : equals(tmp4_subject, Companion_getInstance_10().wcc_1) || equals(tmp4_subject, Companion_getInstance_10().fck_1) ? KeyCommand_LINE_START_getInstance() : equals(tmp4_subject, Companion_getInstance_10().xcc_1) || equals(tmp4_subject, Companion_getInstance_10().gck_1) ? KeyCommand_LINE_END_getInstance() : equals(tmp4_subject, Companion_getInstance_10().acb_1) || equals(tmp4_subject, Companion_getInstance_10().vcc_1) ? KeyCommand_NEW_LINE_getInstance() : equals(tmp4_subject, Companion_getInstance_10().bcb_1) ? KeyCommand_DELETE_PREV_CHAR_getInstance() : equals(tmp4_subject, Companion_getInstance_10().ccb_1) ? KeyCommand_DELETE_NEXT_CHAR_getInstance() : equals(tmp4_subject, Companion_getInstance_10().ucj_1) ? KeyCommand_PASTE_getInstance() : equals(tmp4_subject, Companion_getInstance_10().scj_1) ? KeyCommand_CUT_getInstance() : equals(tmp4_subject, Companion_getInstance_10().tcj_1) ? KeyCommand_COPY_getInstance() : equals(tmp4_subject, Companion_getInstance_10().yca_1) ? KeyCommand_TAB_getInstance() : null;
    } else {
      tmp = null;
    }
    return tmp;
  };
  var properties_initialized_KeyMapping_kt_iql13l;
  function _init_properties_KeyMapping_kt__n34hqn() {
    if (!properties_initialized_KeyMapping_kt_iql13l) {
      properties_initialized_KeyMapping_kt_iql13l = true;
      // Inline function 'kotlin.let' call
      var common = commonKeyMapping(Companion_getInstance_74().oke_1);
      defaultKeyMapping = new defaultKeyMapping$1(common);
    }
  }
  function _KeyModifiers___init__impl__eigcpo(flags) {
    return flags;
  }
  function _get_flags__hiz1sm($this) {
    return $this;
  }
  function _KeyModifiers___init__impl__eigcpo_0(isAltPressed, isCtrlPressed, isMetaPressed, isShiftPressed) {
    isAltPressed = isAltPressed === VOID ? false : isAltPressed;
    isCtrlPressed = isCtrlPressed === VOID ? false : isCtrlPressed;
    isMetaPressed = isMetaPressed === VOID ? false : isMetaPressed;
    isShiftPressed = isShiftPressed === VOID ? false : isShiftPressed;
    return _KeyModifiers___init__impl__eigcpo((isAltPressed ? 1 : 0) | (isCtrlPressed ? 2 : 0) | (isMetaPressed ? 4 : 0) | (isShiftPressed ? 8 : 0));
  }
  function KeyModifiers__plus_impl_wj4ney($this, other) {
    return _KeyModifiers___init__impl__eigcpo(_get_flags__hiz1sm($this) | _get_flags__hiz1sm(other));
  }
  function Companion_15() {
    Companion_instance_25 = this;
    this.ike_1 = 1;
    this.jke_1 = 2;
    this.kke_1 = 4;
    this.lke_1 = 8;
    this.mke_1 = _KeyModifiers___init__impl__eigcpo(0);
    this.nke_1 = _KeyModifiers___init__impl__eigcpo(1);
    this.oke_1 = _KeyModifiers___init__impl__eigcpo(2);
    this.pke_1 = _KeyModifiers___init__impl__eigcpo(4);
    this.qke_1 = _KeyModifiers___init__impl__eigcpo(8);
    this.rke_1 = KeyModifiers__plus_impl_wj4ney(this.nke_1, this.qke_1);
    this.ske_1 = KeyModifiers__plus_impl_wj4ney(this.oke_1, this.qke_1);
    this.tke_1 = KeyModifiers__plus_impl_wj4ney(this.pke_1, this.qke_1);
    this.uke_1 = KeyModifiers__plus_impl_wj4ney(this.oke_1, this.nke_1);
    this.vke_1 = KeyModifiers__plus_impl_wj4ney(this.oke_1, this.pke_1);
    this.wke_1 = KeyModifiers__plus_impl_wj4ney(this.pke_1, this.qke_1);
  }
  var Companion_instance_25;
  function Companion_getInstance_74() {
    if (Companion_instance_25 == null)
      new Companion_15();
    return Companion_instance_25;
  }
  function get_modifiers(_this__u8e3s4) {
    return _KeyModifiers___init__impl__eigcpo_0(get_isAltPressed(_this__u8e3s4), get_isCtrlPressed(_this__u8e3s4), get_isMetaPressed(_this__u8e3s4), get_isShiftPressed(_this__u8e3s4));
  }
  var androidx_compose_foundation_text_KeyboardActionRunner$stable;
  function defaultKeyboardActionWithResult($this, imeAction) {
    var tmp;
    if (imeAction === Companion_getInstance_44().m8b_1) {
      $this.sd1().f9d(Companion_getInstance_45().k9b_1);
      tmp = true;
    } else if (imeAction === Companion_getInstance_44().l8b_1) {
      $this.sd1().f9d(Companion_getInstance_45().l9b_1);
      tmp = true;
    } else if (imeAction === Companion_getInstance_44().n8b_1) {
      var tmp_0;
      if (!($this.kk7_1 == null)) {
        $this.kk7_1.wbq();
        tmp_0 = true;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function KeyboardActionRunner(keyboardController) {
    this.kk7_1 = keyboardController;
  }
  protoOf(KeyboardActionRunner).yke = function () {
    var tmp = this.lk7_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('keyboardActions');
    }
  };
  protoOf(KeyboardActionRunner).sd1 = function () {
    var tmp = this.mk7_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('focusManager');
    }
  };
  protoOf(KeyboardActionRunner).nk7 = function (imeAction) {
    var tmp;
    if (imeAction === Companion_getInstance_44().n8b_1) {
      tmp = this.yke().zke_1;
    } else if (imeAction === Companion_getInstance_44().i8b_1) {
      tmp = this.yke().akf_1;
    } else if (imeAction === Companion_getInstance_44().m8b_1) {
      tmp = this.yke().bkf_1;
    } else if (imeAction === Companion_getInstance_44().l8b_1) {
      tmp = this.yke().ckf_1;
    } else if (imeAction === Companion_getInstance_44().j8b_1) {
      tmp = this.yke().dkf_1;
    } else if (imeAction === Companion_getInstance_44().k8b_1) {
      tmp = this.yke().ekf_1;
    } else if (imeAction === Companion_getInstance_44().g8b_1 || imeAction === Companion_getInstance_44().h8b_1) {
      tmp = null;
    } else {
      // Inline function 'kotlin.error' call
      var message = 'invalid ImeAction';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var keyboardAction = tmp;
    if (!(keyboardAction == null)) {
      keyboardAction(this);
      return true;
    } else
      return defaultKeyboardActionWithResult(this, imeAction);
  };
  var androidx_compose_foundation_text_KeyboardActions$stable;
  function Companion_16() {
    Companion_instance_26 = this;
    this.vk0_1 = new KeyboardActions();
  }
  var Companion_instance_26;
  function Companion_getInstance_75() {
    if (Companion_instance_26 == null)
      new Companion_16();
    return Companion_instance_26;
  }
  function KeyboardActions(onDone, onGo, onNext, onPrevious, onSearch, onSend) {
    Companion_getInstance_75();
    onDone = onDone === VOID ? null : onDone;
    onGo = onGo === VOID ? null : onGo;
    onNext = onNext === VOID ? null : onNext;
    onPrevious = onPrevious === VOID ? null : onPrevious;
    onSearch = onSearch === VOID ? null : onSearch;
    onSend = onSend === VOID ? null : onSend;
    this.zke_1 = onDone;
    this.akf_1 = onGo;
    this.bkf_1 = onNext;
    this.ckf_1 = onPrevious;
    this.dkf_1 = onSearch;
    this.ekf_1 = onSend;
  }
  protoOf(KeyboardActions).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyboardActions))
      return false;
    return this.zke_1 === other.zke_1 && this.akf_1 === other.akf_1 && this.bkf_1 === other.bkf_1 && this.ckf_1 === other.ckf_1 && this.dkf_1 === other.dkf_1 && this.ekf_1 === other.ekf_1;
  };
  protoOf(KeyboardActions).hashCode = function () {
    var tmp0_safe_receiver = this.zke_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.akf_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : hashCode(tmp2_safe_receiver);
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp4_safe_receiver = this.bkf_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : hashCode(tmp4_safe_receiver);
    result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    var tmp_1 = imul(31, result);
    var tmp6_safe_receiver = this.ckf_1;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : hashCode(tmp6_safe_receiver);
    result = tmp_1 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0;
    var tmp_2 = imul(31, result);
    var tmp8_safe_receiver = this.dkf_1;
    var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : hashCode(tmp8_safe_receiver);
    result = tmp_2 + (tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs) | 0;
    var tmp_3 = imul(31, result);
    var tmp10_safe_receiver = this.ekf_1;
    var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : hashCode(tmp10_safe_receiver);
    result = tmp_3 + (tmp11_elvis_lhs == null ? 0 : tmp11_elvis_lhs) | 0;
    return result;
  };
  var androidx_compose_foundation_text_KeyboardOptions$stable;
  function Companion_17() {
    Companion_instance_27 = this;
    this.tk0_1 = new KeyboardOptions();
    this.uk0_1 = new KeyboardOptions(VOID, false, Companion_getInstance_42().c8c_1);
  }
  var Companion_instance_27;
  function Companion_getInstance_76() {
    if (Companion_instance_27 == null)
      new Companion_17();
    return Companion_instance_27;
  }
  function _get_autoCorrectOrDefault__mgfs($this) {
    var tmp0_elvis_lhs = $this.ck1_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  function _get_capitalizationOrDefault__p9zc3z($this) {
    // Inline function 'kotlin.takeUnless' call
    var this_0 = new KeyboardCapitalization($this.bk1_1);
    var tmp;
    if (!(this_0.m8c_1 === Companion_getInstance_46().q8b_1)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp_0 = tmp;
    var tmp0_elvis_lhs = tmp_0 == null ? null : tmp_0.m8c_1;
    var tmp_1;
    var tmp_2 = tmp0_elvis_lhs;
    if ((tmp_2 == null ? null : new KeyboardCapitalization(tmp_2)) == null) {
      tmp_1 = Companion_getInstance_46().r8b_1;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    return tmp_1;
  }
  function _get_keyboardTypeOrDefault__arhbcc($this) {
    // Inline function 'kotlin.takeUnless' call
    var this_0 = new KeyboardType($this.dk1_1);
    var tmp;
    if (!(this_0.n8c_1 === Companion_getInstance_42().v8b_1)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp_0 = tmp;
    var tmp0_elvis_lhs = tmp_0 == null ? null : tmp_0.n8c_1;
    var tmp_1;
    var tmp_2 = tmp0_elvis_lhs;
    if ((tmp_2 == null ? null : new KeyboardType(tmp_2)) == null) {
      tmp_1 = Companion_getInstance_42().w8b_1;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    return tmp_1;
  }
  function _get_hintLocalesOrDefault__5ibkpr($this) {
    var tmp0_elvis_lhs = $this.hk1_1;
    return tmp0_elvis_lhs == null ? Companion_getInstance_47().z7z_1 : tmp0_elvis_lhs;
  }
  function KeyboardOptions(capitalization, autoCorrectEnabled, keyboardType, imeAction, platformImeOptions, showKeyboardOnFocus, hintLocales) {
    Companion_getInstance_76();
    capitalization = capitalization === VOID ? Companion_getInstance_46().q8b_1 : capitalization;
    autoCorrectEnabled = autoCorrectEnabled === VOID ? null : autoCorrectEnabled;
    keyboardType = keyboardType === VOID ? Companion_getInstance_42().v8b_1 : keyboardType;
    imeAction = imeAction === VOID ? Companion_getInstance_44().f8b_1 : imeAction;
    platformImeOptions = platformImeOptions === VOID ? null : platformImeOptions;
    showKeyboardOnFocus = showKeyboardOnFocus === VOID ? null : showKeyboardOnFocus;
    hintLocales = hintLocales === VOID ? null : hintLocales;
    this.bk1_1 = capitalization;
    this.ck1_1 = autoCorrectEnabled;
    this.dk1_1 = keyboardType;
    this.ek1_1 = imeAction;
    this.fk1_1 = platformImeOptions;
    this.gk1_1 = showKeyboardOnFocus;
    this.hk1_1 = hintLocales;
  }
  protoOf(KeyboardOptions).fkf = function () {
    // Inline function 'kotlin.takeUnless' call
    var this_0 = new ImeAction(this.ek1_1);
    var tmp;
    if (!(this_0.o8b_1 === Companion_getInstance_44().f8b_1)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp_0 = tmp;
    var tmp0_elvis_lhs = tmp_0 == null ? null : tmp_0.o8b_1;
    var tmp_1;
    var tmp_2 = tmp0_elvis_lhs;
    if ((tmp_2 == null ? null : new ImeAction(tmp_2)) == null) {
      tmp_1 = Companion_getInstance_44().g8b_1;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    return tmp_1;
  };
  protoOf(KeyboardOptions).ik1 = function (singleLine) {
    return new ImeOptions(singleLine, _get_capitalizationOrDefault__p9zc3z(this), _get_autoCorrectOrDefault__mgfs(this), _get_keyboardTypeOrDefault__arhbcc(this), this.fkf(), this.fk1_1, _get_hintLocalesOrDefault__5ibkpr(this));
  };
  protoOf(KeyboardOptions).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyboardOptions))
      return false;
    if (!(this.bk1_1 === other.bk1_1))
      return false;
    if (!(this.ck1_1 == other.ck1_1))
      return false;
    if (!(this.dk1_1 === other.dk1_1))
      return false;
    if (!(this.ek1_1 === other.ek1_1))
      return false;
    if (!equals(this.fk1_1, other.fk1_1))
      return false;
    if (!(this.gk1_1 == other.gk1_1))
      return false;
    if (!equals(this.hk1_1, other.hk1_1))
      return false;
    return true;
  };
  protoOf(KeyboardOptions).hashCode = function () {
    var result = KeyboardCapitalization__hashCode_impl_6ibuz5(this.bk1_1);
    var tmp = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.ck1_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + KeyboardType__hashCode_impl_mw6m33(this.dk1_1) | 0;
    result = imul(31, result) + ImeAction__hashCode_impl_m1mrob(this.ek1_1) | 0;
    var tmp_0 = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.fk1_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    result = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    var tmp_1 = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_1 = this.gk1_1;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
    result = tmp_1 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
    var tmp_2 = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_2 = this.hk1_1;
    var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    result = tmp_2 + (tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2) | 0;
    return result;
  };
  protoOf(KeyboardOptions).toString = function () {
    return 'KeyboardOptions(' + ('capitalization=' + KeyboardCapitalization__toString_impl_f8u1tq(this.bk1_1) + ', ') + ('autoCorrectEnabled=' + this.ck1_1 + ', ') + ('keyboardType=' + KeyboardType__toString_impl_150pa8(this.dk1_1) + ', ') + ('imeAction=' + ImeAction__toString_impl_r8bdhy(this.ek1_1) + ', ') + ('platformImeOptions=' + toString_0(this.fk1_1)) + ('showKeyboardOnFocus=' + this.gk1_1 + ', ') + ('hintLocales=' + toString_0(this.hk1_1)) + ')';
  };
  var androidx_compose_foundation_text_LinkStateInteractionSourceObserver$stable;
  function sam$kotlinx_coroutines_flow_FlowCollector$0_3(function_0) {
    this.gkf_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).a1v = function (value, $completion) {
    return this.gkf_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).q3 = function () {
    return this.gkf_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).hashCode = function () {
    return hashCode(this.q3());
  };
  function LinkStateInteractionSourceObserver$collectInteractionsForLinks$slambda($interactions, this$0, resultContinuation) {
    this.pkf_1 = $interactions;
    this.qkf_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LinkStateInteractionSourceObserver$collectInteractionsForLinks$slambda).zg1 = function (interaction, $completion) {
    var tmp = this.ag2(interaction, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LinkStateInteractionSourceObserver$collectInteractionsForLinks$slambda).ja = function (p1, $completion) {
    return this.zg1((!(p1 == null) ? isInterface(p1, Interaction) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LinkStateInteractionSourceObserver$collectInteractionsForLinks$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var state = 0;
          var tmp0_subject = this.rkf_1;
          var tmp_0;
          if (tmp0_subject instanceof Enter) {
            tmp_0 = true;
          } else {
            var tmp_1;
            if (tmp0_subject instanceof Focus) {
              tmp_1 = true;
            } else {
              tmp_1 = tmp0_subject instanceof Press;
            }
            tmp_0 = tmp_1;
          }
          if (tmp_0) {
            this.pkf_1.j1(this.rkf_1);
          } else {
            if (tmp0_subject instanceof Exit) {
              this.pkf_1.d3(this.rkf_1.zi7_1);
            } else {
              if (tmp0_subject instanceof Unfocus) {
                this.pkf_1.d3(this.rkf_1.bi7_1);
              } else {
                if (tmp0_subject instanceof Release) {
                  this.pkf_1.d3(this.rkf_1.zi8_1);
                } else {
                  if (tmp0_subject instanceof Cancel_0) {
                    this.pkf_1.d3(this.rkf_1.ai9_1);
                  }
                }
              }
            }
          }
          var this_0 = this.pkf_1;
          var content = this_0.sz_1;
          var inductionVariable = 0;
          var last = this_0.tz_1;
          if (inductionVariable < last)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp0_subject_0 = content[i];
              if (tmp0_subject_0 instanceof Enter)
                state = state | this.qkf_1.ukf_1;
              else {
                if (tmp0_subject_0 instanceof Focus)
                  state = state | this.qkf_1.tkf_1;
                else {
                  if (tmp0_subject_0 instanceof Press)
                    state = state | this.qkf_1.vkf_1;
                }
              }
            }
             while (inductionVariable < last);
          this.qkf_1.wkf_1.a49(state);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(LinkStateInteractionSourceObserver$collectInteractionsForLinks$slambda).ag2 = function (interaction, completion) {
    var i = new LinkStateInteractionSourceObserver$collectInteractionsForLinks$slambda(this.pkf_1, this.qkf_1, completion);
    i.rkf_1 = interaction;
    return i;
  };
  function LinkStateInteractionSourceObserver$collectInteractionsForLinks$slambda_0($interactions, this$0, resultContinuation) {
    var i = new LinkStateInteractionSourceObserver$collectInteractionsForLinks$slambda($interactions, this$0, resultContinuation);
    return constructCallableReference(function (interaction, $completion) {
      return i.zg1(interaction, $completion);
    }, 1);
  }
  function LinkStateInteractionSourceObserver(interactionSource) {
    this.skf_1 = interactionSource;
    this.tkf_1 = 1;
    this.ukf_1 = 2;
    this.vkf_1 = 4;
    this.wkf_1 = mutableIntStateOf(0);
  }
  protoOf(LinkStateInteractionSourceObserver).xkf = function ($completion) {
    // Inline function 'androidx.collection.mutableObjectListOf' call
    var interactions = new MutableObjectList();
    var tmp = this.skf_1.eg3();
    var tmp_0 = LinkStateInteractionSourceObserver$collectInteractionsForLinks$slambda_0(interactions, this, null);
    return tmp.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_3(tmp_0), $completion);
  };
  protoOf(LinkStateInteractionSourceObserver).s9h = function () {
    return !((this.wkf_1.b49() & this.tkf_1) === 0);
  };
  protoOf(LinkStateInteractionSourceObserver).ykf = function () {
    return !((this.wkf_1.b49() & this.ukf_1) === 0);
  };
  protoOf(LinkStateInteractionSourceObserver).zkf = function () {
    return !((this.wkf_1.b49() & this.vkf_1) === 0);
  };
  function detectDownAndDragGesturesWithObserver(_this__u8e3s4, observer, $completion) {
    var tmp = new $detectDownAndDragGesturesWithObserverCOROUTINE$(_this__u8e3s4, observer, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function detectPreDragGesturesWithObserver(_this__u8e3s4, observer, $completion) {
    return awaitEachGesture(_this__u8e3s4, detectPreDragGesturesWithObserver$slambda_0(observer, null), $completion);
  }
  function detectDragGesturesWithObserver(_this__u8e3s4, observer, $completion) {
    var tmp = detectDragGesturesWithObserver$lambda(observer);
    var tmp_0 = detectDragGesturesWithObserver$lambda_0(observer);
    var tmp_1 = detectDragGesturesWithObserver$lambda_1(observer);
    return detectDragGestures(_this__u8e3s4, tmp, tmp_0, tmp_1, detectDragGesturesWithObserver$lambda_2(observer), $completion);
  }
  function detectDownAndDragGesturesWithObserver$slambda$slambda($this_detectDownAndDragGesturesWithObserver, $observer, resultContinuation) {
    this.skg_1 = $this_detectDownAndDragGesturesWithObserver;
    this.tkg_1 = $observer;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectDownAndDragGesturesWithObserver$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectDownAndDragGesturesWithObserver$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectDownAndDragGesturesWithObserver$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectPreDragGesturesWithObserver(this.skg_1, this.tkg_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(detectDownAndDragGesturesWithObserver$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new detectDownAndDragGesturesWithObserver$slambda$slambda(this.skg_1, this.tkg_1, completion);
    i.ukg_1 = $this$launch;
    return i;
  };
  function detectDownAndDragGesturesWithObserver$slambda$slambda_0($this_detectDownAndDragGesturesWithObserver, $observer, resultContinuation) {
    var i = new detectDownAndDragGesturesWithObserver$slambda$slambda($this_detectDownAndDragGesturesWithObserver, $observer, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function detectDownAndDragGesturesWithObserver$slambda$slambda_1($this_detectDownAndDragGesturesWithObserver, $observer, resultContinuation) {
    this.dkh_1 = $this_detectDownAndDragGesturesWithObserver;
    this.ekh_1 = $observer;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectDownAndDragGesturesWithObserver$slambda$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectDownAndDragGesturesWithObserver$slambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectDownAndDragGesturesWithObserver$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectDragGesturesWithObserver(this.dkh_1, this.ekh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(detectDownAndDragGesturesWithObserver$slambda$slambda_1).q24 = function ($this$launch, completion) {
    var i = new detectDownAndDragGesturesWithObserver$slambda$slambda_1(this.dkh_1, this.ekh_1, completion);
    i.fkh_1 = $this$launch;
    return i;
  };
  function detectDownAndDragGesturesWithObserver$slambda$slambda_2($this_detectDownAndDragGesturesWithObserver, $observer, resultContinuation) {
    var i = new detectDownAndDragGesturesWithObserver$slambda$slambda_1($this_detectDownAndDragGesturesWithObserver, $observer, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function detectDownAndDragGesturesWithObserver$slambda($this_detectDownAndDragGesturesWithObserver, $observer, resultContinuation) {
    this.okh_1 = $this_detectDownAndDragGesturesWithObserver;
    this.pkh_1 = $observer;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectDownAndDragGesturesWithObserver$slambda).rjp = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectDownAndDragGesturesWithObserver$slambda).ja = function (p1, $completion) {
    return this.rjp((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectDownAndDragGesturesWithObserver$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
          launch(this.qkh_1, VOID, tmp_0, detectDownAndDragGesturesWithObserver$slambda$slambda_0(this.okh_1, this.pkh_1, null));
          var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
          return launch(this.qkh_1, VOID, tmp_1, detectDownAndDragGesturesWithObserver$slambda$slambda_2(this.okh_1, this.pkh_1, null));
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(detectDownAndDragGesturesWithObserver$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new detectDownAndDragGesturesWithObserver$slambda(this.okh_1, this.pkh_1, completion);
    i.qkh_1 = $this$coroutineScope;
    return i;
  };
  function detectDownAndDragGesturesWithObserver$slambda_0($this_detectDownAndDragGesturesWithObserver, $observer, resultContinuation) {
    var i = new detectDownAndDragGesturesWithObserver$slambda($this_detectDownAndDragGesturesWithObserver, $observer, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.rjp($this$coroutineScope, $completion);
    }, 1);
  }
  function detectPreDragGesturesWithObserver$slambda($observer, resultContinuation) {
    this.zkh_1 = $observer;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(detectPreDragGesturesWithObserver$slambda).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(detectPreDragGesturesWithObserver$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(detectPreDragGesturesWithObserver$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            suspendResult = awaitFirstDown(this.aki_1, false, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.bki_1 = suspendResult;
            this.zkh_1.cki(this.bki_1.ka0_1);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.aki_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var event = suspendResult;
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (equals(item.ia0_1, this.bki_1.ia0_1) && item.la0_1) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$0 = false;
            }
             while (false);
            if (tmp$ret$0) {
              this.n9_1 = 2;
              continue $sm;
            }

            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.zkh_1.dki();
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(detectPreDragGesturesWithObserver$slambda).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new detectPreDragGesturesWithObserver$slambda(this.zkh_1, completion);
    i.aki_1 = $this$awaitEachGesture;
    return i;
  };
  function detectPreDragGesturesWithObserver$slambda_0($observer, resultContinuation) {
    var i = new detectPreDragGesturesWithObserver$slambda($observer, resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  function detectDragGesturesWithObserver$lambda($observer) {
    return function (it) {
      $observer.jki(it.e5d_1, Companion_getInstance_87().eki_1);
      return Unit_instance;
    };
  }
  function detectDragGesturesWithObserver$lambda_0($observer) {
    return function () {
      $observer.kki();
      return Unit_instance;
    };
  }
  function detectDragGesturesWithObserver$lambda_1($observer) {
    return function () {
      $observer.sb0();
      return Unit_instance;
    };
  }
  function detectDragGesturesWithObserver$lambda_2($observer) {
    return function (_unused_var__etf5q3, offset) {
      $observer.lki(offset.e5d_1);
      return Unit_instance;
    };
  }
  function $detectDownAndDragGesturesWithObserverCOROUTINE$(_this__u8e3s4, observer, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ikg_1 = _this__u8e3s4;
    this.jkg_1 = observer;
  }
  protoOf($detectDownAndDragGesturesWithObserverCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = coroutineScope(detectDownAndDragGesturesWithObserver$slambda_0(this.ikg_1, this.jkg_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function findParagraphStart(_this__u8e3s4, startIndex) {
    var inductionVariable = startIndex;
    if (1 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (charSequenceGet(_this__u8e3s4, index - 1 | 0) === _Char___init__impl__6a9atx(10)) {
          return index;
        }
      }
       while (1 <= inductionVariable);
    return 0;
  }
  function findParagraphEnd(_this__u8e3s4, startIndex) {
    var inductionVariable = startIndex;
    var last = charSequenceLength(_this__u8e3s4);
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charSequenceGet(_this__u8e3s4, index) === _Char___init__impl__6a9atx(10)) {
          return index;
        }
      }
       while (inductionVariable < last);
    return charSequenceLength(_this__u8e3s4);
  }
  function getParagraphBoundary(_this__u8e3s4, index) {
    return TextRange_0(findParagraphStart(_this__u8e3s4, index), findParagraphEnd(_this__u8e3s4, index));
  }
  var androidx_compose_foundation_text_TextAutoSizeDefaults$stable;
  var androidx_compose_foundation_text_TextDelegate$stable;
  function _get_nonNullIntrinsics__hf0xox($this) {
    var tmp0_elvis_lhs = $this.fk8_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('layoutIntrinsics must be called first');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function layoutText($this, constraints, layoutDirection) {
    $this.fkb(layoutDirection);
    var minWidth = _Constraints___get_minWidth__impl__hi9lfi(constraints);
    var widthMatters = $this.ak8_1 || $this.bk8_1 === Companion_getInstance_39().x7s_1;
    var tmp;
    if (widthMatters && _Constraints___get_hasBoundedWidth__impl__7hd0wr(constraints)) {
      tmp = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    } else {
      tmp = 2147483647;
    }
    var maxWidth = tmp;
    var overwriteMaxLines = !$this.ak8_1 && $this.bk8_1 === Companion_getInstance_39().x7s_1;
    var finalMaxLines = overwriteMaxLines ? 1 : $this.yk7_1;
    var tmp_0;
    if (minWidth === maxWidth) {
      tmp_0 = maxWidth;
    } else {
      tmp_0 = coerceIn_1($this.d62(), minWidth, maxWidth);
    }
    var width = tmp_0;
    return new MultiParagraph(_get_nonNullIntrinsics__hf0xox($this), Companion_instance_4.s5e(0, width, 0, _Constraints___get_maxHeight__impl__dt3e8z(constraints)), finalMaxLines, $this.bk8_1);
  }
  function Companion_18() {
  }
  var Companion_instance_28;
  function Companion_getInstance_77() {
    return Companion_instance_28;
  }
  function TextDelegate(text, style, maxLines, minLines, softWrap, overflow, density, fontFamilyResolver, placeholders) {
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    minLines = minLines === VOID ? 1 : minLines;
    softWrap = softWrap === VOID ? true : softWrap;
    overflow = overflow === VOID ? Companion_getInstance_39().w7s_1 : overflow;
    placeholders = placeholders === VOID ? emptyList() : placeholders;
    this.wk7_1 = text;
    this.xk7_1 = style;
    this.yk7_1 = maxLines;
    this.zk7_1 = minLines;
    this.ak8_1 = softWrap;
    this.bk8_1 = overflow;
    this.ck8_1 = density;
    this.dk8_1 = fontFamilyResolver;
    this.ek8_1 = placeholders;
    this.fk8_1 = null;
    this.gk8_1 = null;
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(this.yk7_1 > 0)) {
      var tmp$ret$1 = 'no maxLines';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(this.zk7_1 > 0)) {
      var tmp$ret$3 = 'no minLines';
      throwIllegalArgumentException(tmp$ret$3);
    }
    // Inline function 'androidx.compose.foundation.internal.requirePrecondition' call
    if (!(this.zk7_1 <= this.yk7_1)) {
      var tmp$ret$5 = 'minLines greater than maxLines';
      throwIllegalArgumentException(tmp$ret$5);
    }
  }
  protoOf(TextDelegate).d62 = function () {
    return ceilToIntPx(_get_nonNullIntrinsics__hf0xox(this).d62());
  };
  protoOf(TextDelegate).fkb = function (layoutDirection) {
    var localIntrinsics = this.fk8_1;
    var tmp;
    if (localIntrinsics == null || !layoutDirection.equals(this.gk8_1) || localIntrinsics.a7v()) {
      this.gk8_1 = layoutDirection;
      var tmp0_annotatedString = this.wk7_1;
      var tmp1_style = resolveDefaults(this.xk7_1, layoutDirection);
      var tmp2_density = this.ck8_1;
      var tmp3_fontFamilyResolver = this.dk8_1;
      var tmp4_placeholders = this.ek8_1;
      tmp = new MultiParagraphIntrinsics(tmp0_annotatedString, tmp1_style, tmp4_placeholders, tmp2_density, tmp3_fontFamilyResolver);
    } else {
      tmp = localIntrinsics;
    }
    var intrinsics = tmp;
    this.fk8_1 = intrinsics;
  };
  protoOf(TextDelegate).mki = function (constraints, layoutDirection, prevResult) {
    if (!(prevResult == null) && canReuse(prevResult, this.wk7_1, this.xk7_1, this.ek8_1, this.yk7_1, this.ak8_1, this.bk8_1, this.ck8_1, layoutDirection, this.dk8_1, constraints)) {
      // Inline function 'kotlin.with' call
      var tmp = TextLayoutInput_init_$Create$(prevResult.e80_1.q80_1, this.xk7_1, prevResult.e80_1.s80_1, prevResult.e80_1.t80_1, prevResult.e80_1.u80_1, prevResult.e80_1.v80_1, prevResult.e80_1.w80_1, prevResult.e80_1.x80_1, prevResult.e80_1.y80_1, constraints);
      var tmp0 = ceilToIntPx(prevResult.f80_1.h7s_1);
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = ceilToIntPx(prevResult.f80_1.i7s_1);
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$2 = _IntSize___init__impl__emcjft(tmp$ret$3);
      return prevResult.o80(tmp, constrain(constraints, tmp$ret$2));
    }
    var multiParagraph = layoutText(this, constraints, layoutDirection);
    var tmp0_0 = ceilToIntPx(multiParagraph.h7s_1);
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2_0 = ceilToIntPx(multiParagraph.i7s_1);
    var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
    var tmp$ret$4 = _IntSize___init__impl__emcjft(tmp$ret$5);
    var size = constrain(constraints, tmp$ret$4);
    return new TextLayoutResult(TextLayoutInput_init_$Create$(this.wk7_1, this.xk7_1, this.ek8_1, this.yk7_1, this.ak8_1, this.bk8_1, this.ck8_1, layoutDirection, this.dk8_1, constraints), multiParagraph, size);
  };
  function ceilToIntPx(_this__u8e3s4) {
    // Inline function 'kotlin.math.ceil' call
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_0 = Math.ceil(_this__u8e3s4);
    var tmp;
    if (isNaN_0(this_0)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(this_0);
    }
    return tmp;
  }
  function updateTextDelegate(current, text, style, density, fontFamilyResolver, softWrap, overflow, maxLines, minLines, placeholders) {
    softWrap = softWrap === VOID ? true : softWrap;
    overflow = overflow === VOID ? Companion_getInstance_39().w7s_1 : overflow;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    minLines = minLines === VOID ? 1 : minLines;
    var tmp;
    if (!current.wk7_1.equals(text) || !current.xk7_1.equals(style) || !(current.ak8_1 === softWrap) || !(current.bk8_1 === overflow) || !(current.yk7_1 === maxLines) || !(current.zk7_1 === minLines) || !equals(current.ck8_1, density) || !equals(current.ek8_1, placeholders) || !(current.dk8_1 === fontFamilyResolver)) {
      tmp = new TextDelegate(text, style, maxLines, minLines, softWrap, overflow, density, fontFamilyResolver, placeholders);
    } else {
      tmp = current;
    }
    return tmp;
  }
  function cursor(_this__u8e3s4, state, value, offsetMapping, cursorBrush, enabled) {
    var tmp;
    if (enabled) {
      tmp = composed(_this__u8e3s4, VOID, cursor$lambda(cursorBrush, state, value, offsetMapping));
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function cursor$lambda$slambda($cursorAnimation, resultContinuation) {
    this.vki_1 = $cursorAnimation;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(cursor$lambda$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(cursor$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(cursor$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.vki_1.akj(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(cursor$lambda$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new cursor$lambda$slambda(this.vki_1, completion);
    i.wki_1 = $this$LaunchedEffect;
    return i;
  };
  function cursor$lambda$slambda_0($cursorAnimation, resultContinuation) {
    var i = new cursor$lambda$slambda($cursorAnimation, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function cursor$lambda$lambda($cursorAnimation, $offsetMapping, $value, $state, $cursorBrush) {
    return function ($this$drawWithContent) {
      $this$drawWithContent.z91();
      var cursorAlphaValue = $cursorAnimation.bkj();
      var tmp;
      if (!(cursorAlphaValue === 0.0)) {
        var transformedOffset = $offsetMapping.o8c(_TextRange___get_start__impl__ww4t90($value.g8a_1));
        var tmp0_safe_receiver = $state.tk7();
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hk8_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c7u(transformedOffset);
        var cursorRect = tmp2_elvis_lhs == null ? new Rect(0.0, 0.0, 0.0, 0.0) : tmp2_elvis_lhs;
        // Inline function 'kotlin.math.floor' call
        var x = $this$drawWithContent.v5e(get_DefaultCursorThickness());
        var tmp$ret$0 = Math.floor(x);
        var cursorWidth = coerceAtLeast(tmp$ret$0, 1.0);
        var tmp_0 = cursorRect.k5d_1 + cursorWidth / 2;
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        var this_0 = $this$drawWithContent.o5d();
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value = _Size___get_packedValue__impl__7rlt1o(this_0);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value, 32));
        var tmp$ret$1 = floatFromBits(bits);
        // Inline function 'kotlin.let' call
        var it = coerceAtLeast(coerceAtMost_0(tmp_0, tmp$ret$1 - cursorWidth / 2), cursorWidth / 2);
        var tmp_1;
        if ((numberToInt(cursorWidth) % 2 | 0) === 1) {
          // Inline function 'kotlin.math.floor' call
          tmp_1 = Math.floor(it) + 0.5;
        } else {
          // Inline function 'kotlin.math.round' call
          tmp_1 = round_0(it);
        }
        var cursorX = tmp_1;
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var val2 = cursorRect.l5d_1;
        var v1 = fromInt(toRawBits(cursorX));
        var v2 = fromInt(toRawBits(val2));
        var tmp$ret$10 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        var tmp3_start = _Offset___init__impl__c168vi(tmp$ret$10);
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var val2_0 = cursorRect.n5d_1;
        var v1_0 = fromInt(toRawBits(cursorX));
        var v2_0 = fromInt(toRawBits(val2_0));
        var tmp$ret$12 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
        var tmp4_end = _Offset___init__impl__c168vi(tmp$ret$12);
        $this$drawWithContent.x6p($cursorBrush, tmp3_start, tmp4_end, cursorWidth, VOID, VOID, cursorAlphaValue);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function cursor$lambda($cursorBrush, $state, $value, $offsetMapping) {
    return function ($this$composed, $composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(-84507373);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_0 = get_LocalCursorBlinkEnabled();
      var $composer_1 = $composer_0;
      var animateCursor = $composer_1.u31(this_0);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.l31(animateCursor);
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = new CursorAnimationState(animateCursor);
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var cursorAnimation = tmp;
      var tmp_0;
      if ($cursorBrush instanceof SolidColor) {
        // Inline function 'androidx.compose.ui.graphics.isUnspecified' call
        var this_1 = $cursorBrush.d6b_1;
        tmp_0 = equals(_Color___get_value__impl__1pls5m(this_1), _ULong___init__impl__c78o9k(new Long(16, 0)));
      } else {
        tmp_0 = false;
      }
      var isBrushSpecified = !tmp_0;
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_2 = get_LocalWindowInfo();
      var $composer_2 = $composer_0;
      var isWindowFocused = $composer_2.u31(this_2).abr();
      var tmp_1;
      if (isWindowFocused && $state.r9h() && _TextRange___get_collapsed__impl__cilesp($value.g8a_1) && isBrushSpecified) {
        $composer_0.m30(-707487962);
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31(cursorAnimation);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_2;
        if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
          var value_0 = cursor$lambda$slambda_0(cursorAnimation, null);
          $composer_0.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_0;
        }
        var tmp$ret$7 = tmp_2;
        LaunchedEffect_0($value.f8a_1, new TextRange($value.g8a_1), tmp$ret$7, $composer_0, 0);
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = !!(!!(!!(!!($composer_0.q31(cursorAnimation) | $composer_0.q31($offsetMapping)) | $composer_0.k31($value)) | $composer_0.q31($state)) | $composer_0.k31($cursorBrush));
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_3;
        if (invalid_1 || it_1 === Companion_getInstance_11().f30_1) {
          var value_1 = cursor$lambda$lambda(cursorAnimation, $offsetMapping, $value, $state, $cursorBrush);
          $composer_0.j31(value_1);
          tmp_3 = value_1;
        } else {
          tmp_3 = it_1;
        }
        var tmp$ret$11 = tmp_3;
        var tmp1_group = drawWithContent($this$composed, tmp$ret$11);
        $composer_0.n30();
        tmp_1 = tmp1_group;
      } else {
        $composer_0.m30(-705473241);
        $composer_0.n30();
        tmp_1 = Companion_instance_0;
      }
      var tmp0 = tmp_1;
      $composer_0.n30();
      return tmp0;
    };
  }
  function get_EmptyTextReplacement() {
    _init_properties_TextFieldDelegate_kt__lo6v7k();
    return EmptyTextReplacement;
  }
  var EmptyTextReplacement;
  var androidx_compose_foundation_text_TextFieldDelegate$stable;
  function drawHighlight($this, canvas, range, offsetMapping, textLayoutResult, paint) {
    var start = offsetMapping.o8c(_TextRange___get_min__impl__uu95c4(range));
    var end = offsetMapping.o8c(_TextRange___get_max__impl__owm8m(range));
    if (!(start === end)) {
      var selectionPath = textLayoutResult.u7s(start, end);
      canvas.m6e(selectionPath, paint);
    }
  }
  function TextFieldDelegate$Companion$notifyFocusedRect$lambda($textDelegate) {
    return function () {
      return new IntSize(computeSizeForDefaultText($textDelegate.xk7_1, $textDelegate.ck8_1, $textDelegate.dk8_1));
    };
  }
  function TextFieldDelegate$Companion$updateTextLayoutResult$lambda($innerTextFieldCoordinates) {
    return function (matrix) {
      var tmp;
      if ($innerTextFieldCoordinates.y91()) {
        findRootCoordinates($innerTextFieldCoordinates).gai($innerTextFieldCoordinates, matrix.e6h_1);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function TextFieldDelegate$Companion$restartInput$lambda($editProcessor, $onValueChange, $session) {
    return function (it) {
      Companion_instance_29.ckj(it, $editProcessor, $onValueChange, $session._v);
      return Unit_instance;
    };
  }
  function Companion_19() {
  }
  protoOf(Companion_19).ekb = function (textDelegate, constraints, layoutDirection, prevResultText) {
    var layoutResult = textDelegate.mki(constraints, layoutDirection, prevResultText);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = layoutResult.g80_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    var tmp = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_1 = layoutResult.g80_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
    var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    return new Triple(tmp, tmp$ret$2, layoutResult);
  };
  protoOf(Companion_19).zkc = function (canvas, value, selectionPreviewHighlightRange, deletionPreviewHighlightRange, offsetMapping, textLayoutResult, highlightPaint, selectionBackgroundColor) {
    if (!_TextRange___get_collapsed__impl__cilesp(selectionPreviewHighlightRange)) {
      highlightPaint.f6b(selectionBackgroundColor);
      drawHighlight(this, canvas, selectionPreviewHighlightRange, offsetMapping, textLayoutResult, highlightPaint);
    } else if (!_TextRange___get_collapsed__impl__cilesp(deletionPreviewHighlightRange)) {
      // Inline function 'kotlin.takeUnless' call
      var this_0 = new Color(textLayoutResult.e80_1.r80_1.s6c());
      var tmp;
      // Inline function 'androidx.compose.ui.graphics.isUnspecified' call
      var this_1 = this_0.c6d_1;
      if (!equals(_Color___get_value__impl__1pls5m(this_1), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
        tmp = this_0;
      } else {
        tmp = null;
      }
      var tmp_0 = tmp;
      var tmp0_elvis_lhs = tmp_0 == null ? null : tmp_0.c6d_1;
      var tmp_1;
      var tmp_2 = tmp0_elvis_lhs;
      if ((tmp_2 == null ? null : new Color(tmp_2)) == null) {
        tmp_1 = Companion_getInstance().i6b_1;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var textColor = tmp_1;
      highlightPaint.f6b(Color__copy$default_impl_ectz3s(textColor, _Color___get_alpha__impl__wcfyv1(textColor) * 0.2));
      drawHighlight(this, canvas, deletionPreviewHighlightRange, offsetMapping, textLayoutResult, highlightPaint);
    } else if (!_TextRange___get_collapsed__impl__cilesp(value.g8a_1)) {
      highlightPaint.f6b(selectionBackgroundColor);
      drawHighlight(this, canvas, value.g8a_1, offsetMapping, textLayoutResult, highlightPaint);
    }
    TextPainter_instance.t81(canvas, textLayoutResult);
  };
  protoOf(Companion_19).kk8 = function (value, textDelegate, textLayoutResult, layoutCoordinates, textInputSession, hasFocus, offsetMapping) {
    if (!hasFocus) {
      return Unit_instance;
    }
    var tmp = offsetMapping.o8c(_TextRange___get_max__impl__owm8m(value.g8a_1));
    textInputSession.h8d(focusedRectInRoot(textLayoutResult, layoutCoordinates, tmp, TextFieldDelegate$Companion$notifyFocusedRect$lambda(textDelegate)));
  };
  protoOf(Companion_19).tka = function (textInputSession, textFieldValue, offsetMapping, textLayoutResult) {
    var tmp0_safe_receiver = textLayoutResult.ik8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (!tmp0_safe_receiver.y91())
        return Unit_instance;
      var tmp0_safe_receiver_0 = textLayoutResult.jk8_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = textInputSession.j8d(textFieldValue, offsetMapping, textLayoutResult.hk8_1, TextFieldDelegate$Companion$updateTextLayoutResult$lambda(tmp0_safe_receiver), visibleBounds(tmp0_safe_receiver), tmp0_safe_receiver.x9h(tmp0_safe_receiver_0, false));
      }
    }
  };
  protoOf(Companion_19).ckj = function (ops, editProcessor, onValueChange, session) {
    var newValue = editProcessor.n8a(ops);
    if (session == null)
      null;
    else
      session.m8a(null, newValue);
    onValueChange(newValue);
  };
  protoOf(Companion_19).dkj = function (position, textLayoutResult, editProcessor, offsetMapping, onValueChange) {
    var offset = offsetMapping.p8c(textLayoutResult.ekj(position));
    onValueChange(editProcessor.p8a().j8a(VOID, TextRange_1(offset)));
  };
  protoOf(Companion_19).vka = function (textInputService, value, editProcessor, imeOptions, onValueChange, onImeActionPerformed) {
    var session = {_v: null};
    session._v = textInputService.z8c(value, imeOptions, TextFieldDelegate$Companion$restartInput$lambda(editProcessor, onValueChange, session), onImeActionPerformed);
    return session._v;
  };
  protoOf(Companion_19).uk7 = function (textInputService, value, editProcessor, imeOptions, onValueChange, onImeActionPerformed) {
    return this.vka(textInputService, value, editProcessor, imeOptions, onValueChange, onImeActionPerformed);
  };
  protoOf(Companion_19).vk7 = function (textInputSession, editProcessor, onValueChange) {
    onValueChange(editProcessor.p8a().j8a(VOID, VOID, null));
    textInputSession.s1d();
  };
  protoOf(Companion_19).ak5 = function (compositionRange, transformed) {
    var startPositionTransformed = transformed.q8d_1.o8c(_TextRange___get_start__impl__ww4t90(compositionRange));
    var endPositionTransformed = transformed.q8d_1.o8c(_TextRange___get_end__impl__gcdxpp(compositionRange));
    // Inline function 'kotlin.math.min' call
    var start = Math.min(startPositionTransformed, endPositionTransformed);
    // Inline function 'kotlin.math.max' call
    var coercedEnd = Math.max(startPositionTransformed, endPositionTransformed);
    // Inline function 'kotlin.apply' call
    var this_0 = Builder_init_$Create$(transformed.p8d_1);
    this_0.k7q(SpanStyle_init_$Create$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_36().b80_1), start, coercedEnd);
    return new TransformedText(this_0.p7q(), transformed.q8d_1);
  };
  var Companion_instance_29;
  function Companion_getInstance_78() {
    return Companion_instance_29;
  }
  function computeSizeForDefaultText(style, density, fontFamilyResolver, text, maxLines) {
    text = text === VOID ? get_EmptyTextReplacement() : text;
    maxLines = maxLines === VOID ? 1 : maxLines;
    _init_properties_TextFieldDelegate_kt__lo6v7k();
    // Inline function 'kotlin.collections.listOf' call
    var tmp0_spanStyles = emptyList();
    var tmp1_overflow = Companion_getInstance_39().w7s_1;
    var tmp2_constraints = Constraints_0();
    var paragraph = Paragraph(text, style, tmp2_constraints, density, fontFamilyResolver, tmp0_spanStyles, VOID, maxLines, tmp1_overflow);
    var tmp0 = ceilToIntPx(paragraph.c62());
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = ceilToIntPx(paragraph.i5e());
    var tmp$ret$2 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntSize___init__impl__emcjft(tmp$ret$2);
  }
  function focusedRectInRoot(layoutResult, layoutCoordinates, focusOffset, sizeForDefaultText) {
    _init_properties_TextFieldDelegate_kt__lo6v7k();
    var tmp;
    if (focusOffset < layoutResult.e80_1.q80_1.a()) {
      tmp = layoutResult.v7t(focusOffset);
    } else if (!(focusOffset === 0)) {
      tmp = layoutResult.v7t(focusOffset - 1 | 0);
    } else {
      var size = sizeForDefaultText().o5g_1;
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(size);
      var tmp$ret$0 = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
      tmp = new Rect(0.0, 0.0, 1.0, tmp$ret$0);
    }
    var bbox = tmp;
    var tmp0 = bbox.k5d_1;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = bbox.l5d_1;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$2 = _Offset___init__impl__c168vi(tmp$ret$3);
    var globalLT = layoutCoordinates.dai(tmp$ret$2);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(globalLT);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value_0, 32));
    var tmp0_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(globalLT);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2_0 = floatFromBits(bits_0);
    var v1_0 = fromInt(toRawBits(tmp0_0));
    var v2_0 = fromInt(toRawBits(val2_0));
    var tmp$ret$13 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
    var tmp_0 = _Offset___init__impl__c168vi(tmp$ret$13);
    // Inline function 'androidx.compose.ui.geometry.Rect.width' call
    var tmp0_1 = bbox.m5d_1 - bbox.k5d_1;
    // Inline function 'androidx.compose.ui.geometry.Rect.height' call
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2_1 = bbox.n5d_1 - bbox.l5d_1;
    var v1_1 = fromInt(toRawBits(tmp0_1));
    var v2_1 = fromInt(toRawBits(val2_1));
    var tmp$ret$17 = bitwiseOr(shiftLeft(v1_1, 32), bitwiseAnd(v2_1, new Long(-1, 0)));
    var tmp$ret$16 = _Size___init__impl__aywn0g(tmp$ret$17);
    return Rect_0(tmp_0, tmp$ret$16);
  }
  var properties_initialized_TextFieldDelegate_kt_1iol9a;
  function _init_properties_TextFieldDelegate_kt__lo6v7k() {
    if (!properties_initialized_TextFieldDelegate_kt_1iol9a) {
      properties_initialized_TextFieldDelegate_kt_1iol9a = true;
      EmptyTextReplacement = repeat('H', 10);
      androidx_compose_foundation_text_TextFieldDelegate$stable = 0;
    }
  }
  function textFieldFocusModifier(_this__u8e3s4, enabled, focusRequester_0, interactionSource, onFocusChanged_0) {
    return focusable(onFocusChanged(focusRequester(_this__u8e3s4, focusRequester_0), onFocusChanged_0), enabled, interactionSource);
  }
  var androidx_compose_foundation_text_TextFieldKeyInput$stable;
  function textFieldKeyInput(_this__u8e3s4, state, manager, value, onValueChange, editable, singleLine, offsetMapping, undoManager, imeAction) {
    var tmp;
    if (onValueChange === VOID) {
      tmp = textFieldKeyInput$lambda;
    } else {
      tmp = onValueChange;
    }
    onValueChange = tmp;
    return composed(_this__u8e3s4, VOID, textFieldKeyInput$lambda_0(state, manager, value, editable, singleLine, offsetMapping, undoManager, onValueChange, imeAction));
  }
  function apply_0($this, $receiver) {
    // Inline function 'kotlin.apply' call
    var this_0 = toMutableList($receiver);
    this_0.g3(0, new FinishComposingTextCommand());
    var newTextFieldValue = $this.fkj_1.ek5_1.n8a(this_0);
    $this.pkj_1(newTextFieldValue);
  }
  function apply_1($this, $receiver) {
    apply_0($this, listOf_0($receiver));
  }
  function typedCommand($this, event) {
    if (!get_isTypedEvent(event)) {
      return null;
    }
    var tmp0_elvis_lhs = $this.nkj_1.rkj(event);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var codePoint = tmp;
    var text = appendCodePointX(StringBuilder_init_$Create$(), codePoint).toString();
    return CommitTextCommand_init_$Create$(text, 1);
  }
  function commandExecutionContext($this, block) {
    var preparedSelection = new TextFieldPreparedSelection($this.hkj_1, $this.lkj_1, $this.fkj_1.tk7(), $this.kkj_1);
    block(preparedSelection);
    if (!equals(preparedSelection.gkk_1, $this.hkj_1.g8a_1) || !preparedSelection.hkk_1.equals($this.hkj_1.f8a_1)) {
      $this.pkj_1(preparedSelection.u1());
    }
  }
  function TextFieldKeyInput$_init_$lambda_5qds7h(it) {
    return Unit_instance;
  }
  function TextFieldKeyInput$process$lambda$lambda($this$collapseLeftOr) {
    $this$collapseLeftOr.ikk();
    return Unit_instance;
  }
  function TextFieldKeyInput$process$lambda$lambda_0($this$collapseRightOr) {
    $this$collapseRightOr.jkk();
    return Unit_instance;
  }
  function TextFieldKeyInput$process$lambda$lambda_1($this$deleteIfSelectedOr) {
    var precedingCodePointIndex = $this$deleteIfSelectedOr.kkk();
    if (precedingCodePointIndex === -1) {
      return null;
    }
    return new DeleteSurroundingTextCommand(_TextRange___get_end__impl__gcdxpp($this$deleteIfSelectedOr.gkk_1) - precedingCodePointIndex | 0, 0);
  }
  function TextFieldKeyInput$process$lambda$lambda_2($this$deleteIfSelectedOr) {
    var nextCharacterIndex = $this$deleteIfSelectedOr.lkk();
    var tmp;
    if (!(nextCharacterIndex === -1)) {
      tmp = new DeleteSurroundingTextCommand(0, nextCharacterIndex - _TextRange___get_end__impl__gcdxpp($this$deleteIfSelectedOr.gkk_1) | 0);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function TextFieldKeyInput$process$lambda$lambda_3($this$deleteIfSelectedOr) {
    var tmp0_safe_receiver = $this$deleteIfSelectedOr.mkk();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new DeleteSurroundingTextCommand(_TextRange___get_end__impl__gcdxpp($this$deleteIfSelectedOr.gkk_1) - tmp0_safe_receiver | 0, 0);
    }
    return tmp;
  }
  function TextFieldKeyInput$process$lambda$lambda_4($this$deleteIfSelectedOr) {
    var tmp0_safe_receiver = $this$deleteIfSelectedOr.nkk();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new DeleteSurroundingTextCommand(0, tmp0_safe_receiver - _TextRange___get_end__impl__gcdxpp($this$deleteIfSelectedOr.gkk_1) | 0);
    }
    return tmp;
  }
  function TextFieldKeyInput$process$lambda$lambda_5($this$deleteIfSelectedOr) {
    var tmp0_safe_receiver = $this$deleteIfSelectedOr.okk();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new DeleteSurroundingTextCommand(_TextRange___get_end__impl__gcdxpp($this$deleteIfSelectedOr.gkk_1) - tmp0_safe_receiver | 0, 0);
    }
    return tmp;
  }
  function TextFieldKeyInput$process$lambda$lambda_6($this$deleteIfSelectedOr) {
    var tmp0_safe_receiver = $this$deleteIfSelectedOr.pkk();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new DeleteSurroundingTextCommand(0, tmp0_safe_receiver - _TextRange___get_end__impl__gcdxpp($this$deleteIfSelectedOr.gkk_1) | 0);
    }
    return tmp;
  }
  function TextFieldKeyInput$process$lambda($command, this$0, $consumed) {
    return function ($this$commandExecutionContext) {
      switch ($command.a1_1) {
        case 17:
          this$0.gkj_1.qkk(false);
          break;
        case 18:
          this$0.gkj_1.rkk();
          break;
        case 19:
          this$0.gkj_1.skk();
          break;
        case 0:
          $this$commandExecutionContext.tkk(TextFieldKeyInput$process$lambda$lambda);
          break;
        case 1:
          $this$commandExecutionContext.ukk(TextFieldKeyInput$process$lambda$lambda_0);
          break;
        case 3:
          $this$commandExecutionContext.vkk();
          break;
        case 2:
          $this$commandExecutionContext.wkk();
          break;
        case 5:
          $this$commandExecutionContext.xkk();
          break;
        case 4:
          $this$commandExecutionContext.ykk();
          break;
        case 10:
          $this$commandExecutionContext.zkk();
          break;
        case 11:
          $this$commandExecutionContext.akl();
          break;
        case 13:
          $this$commandExecutionContext.bkl();
          break;
        case 14:
          $this$commandExecutionContext.ckl();
          break;
        case 6:
          $this$commandExecutionContext.dkl();
          break;
        case 7:
          $this$commandExecutionContext.ekl();
          break;
        case 8:
          $this$commandExecutionContext.fkl();
          break;
        case 9:
          $this$commandExecutionContext.gkl();
          break;
        case 15:
          $this$commandExecutionContext.hkl();
          break;
        case 16:
          $this$commandExecutionContext.ikl();
          break;
        case 20:
          var tmp1_safe_receiver = $this$commandExecutionContext.jkl(TextFieldKeyInput$process$lambda$lambda_1);
          if (tmp1_safe_receiver == null)
            null;
          else {
            apply_0(this$0, tmp1_safe_receiver);
          }

          break;
        case 21:
          var tmp2_safe_receiver = $this$commandExecutionContext.jkl(TextFieldKeyInput$process$lambda$lambda_2);
          if (tmp2_safe_receiver == null)
            null;
          else {
            apply_0(this$0, tmp2_safe_receiver);
          }

          break;
        case 22:
          var tmp3_safe_receiver = $this$commandExecutionContext.jkl(TextFieldKeyInput$process$lambda$lambda_3);
          if (tmp3_safe_receiver == null)
            null;
          else {
            apply_0(this$0, tmp3_safe_receiver);
          }

          break;
        case 23:
          var tmp4_safe_receiver = $this$commandExecutionContext.jkl(TextFieldKeyInput$process$lambda$lambda_4);
          if (tmp4_safe_receiver == null)
            null;
          else {
            apply_0(this$0, tmp4_safe_receiver);
          }

          break;
        case 24:
          var tmp5_safe_receiver = $this$commandExecutionContext.jkl(TextFieldKeyInput$process$lambda$lambda_5);
          if (tmp5_safe_receiver == null)
            null;
          else {
            apply_0(this$0, tmp5_safe_receiver);
          }

          break;
        case 25:
          var tmp6_safe_receiver = $this$commandExecutionContext.jkl(TextFieldKeyInput$process$lambda$lambda_6);
          if (tmp6_safe_receiver == null)
            null;
          else {
            apply_0(this$0, tmp6_safe_receiver);
          }

          break;
        case 44:
          if (!this$0.jkj_1) {
            apply_1(this$0, CommitTextCommand_init_$Create$('\n', 1));
          } else {
            $consumed._v = this$0.fkj_1.yk5_1(new ImeAction(this$0.qkj_1));
          }

          break;
        case 45:
          if (!this$0.jkj_1) {
            apply_1(this$0, CommitTextCommand_init_$Create$('\t', 1));
          } else {
            $consumed._v = false;
          }

          break;
        case 26:
          $this$commandExecutionContext.kkl();
          break;
        case 27:
          $this$commandExecutionContext.ikk().lkl();
          break;
        case 28:
          $this$commandExecutionContext.jkk().lkl();
          break;
        case 35:
          $this$commandExecutionContext.vkk().lkl();
          break;
        case 36:
          $this$commandExecutionContext.wkk().lkl();
          break;
        case 38:
          $this$commandExecutionContext.xkk().lkl();
          break;
        case 37:
          $this$commandExecutionContext.ykk().lkl();
          break;
        case 39:
          $this$commandExecutionContext.dkl().lkl();
          break;
        case 40:
          $this$commandExecutionContext.ekl().lkl();
          break;
        case 41:
          $this$commandExecutionContext.fkl().lkl();
          break;
        case 42:
          $this$commandExecutionContext.gkl().lkl();
          break;
        case 29:
          $this$commandExecutionContext.zkk().lkl();
          break;
        case 30:
          $this$commandExecutionContext.akl().lkl();
          break;
        case 31:
          $this$commandExecutionContext.bkl().lkl();
          break;
        case 32:
          $this$commandExecutionContext.ckl().lkl();
          break;
        case 33:
          $this$commandExecutionContext.hkl().lkl();
          break;
        case 34:
          $this$commandExecutionContext.ikl().lkl();
          break;
        case 43:
          $this$commandExecutionContext.mkl();
          break;
        case 46:
          var tmp7_safe_receiver = this$0.mkj_1;
          if (tmp7_safe_receiver == null)
            null;
          else {
            tmp7_safe_receiver.nkl($this$commandExecutionContext.u1());
          }

          var tmp8_safe_receiver = this$0.mkj_1;
          var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.okl();
          if (tmp9_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            this$0.pkj_1(tmp9_safe_receiver);
          }

          break;
        case 47:
          var tmp10_safe_receiver = this$0.mkj_1;
          var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.pkl();
          if (tmp11_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            this$0.pkj_1(tmp11_safe_receiver);
          }

          break;
        case 48:
          showCharacterPalette();
          break;
        case 12:
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      return Unit_instance;
    };
  }
  function TextFieldKeyInput(state, selectionManager, value, editable, singleLine, preparedSelectionState, offsetMapping, undoManager, keyCombiner, keyMapping, onValueChange, imeAction) {
    value = value === VOID ? TextFieldValue_init_$Create$() : value;
    editable = editable === VOID ? true : editable;
    singleLine = singleLine === VOID ? false : singleLine;
    offsetMapping = offsetMapping === VOID ? Companion_getInstance_48().q8c_1 : offsetMapping;
    undoManager = undoManager === VOID ? null : undoManager;
    keyMapping = keyMapping === VOID ? get_platformDefaultKeyMapping() : keyMapping;
    var tmp;
    if (onValueChange === VOID) {
      tmp = TextFieldKeyInput$_init_$lambda_5qds7h;
    } else {
      tmp = onValueChange;
    }
    onValueChange = tmp;
    this.fkj_1 = state;
    this.gkj_1 = selectionManager;
    this.hkj_1 = value;
    this.ikj_1 = editable;
    this.jkj_1 = singleLine;
    this.kkj_1 = preparedSelectionState;
    this.lkj_1 = offsetMapping;
    this.mkj_1 = undoManager;
    this.nkj_1 = keyCombiner;
    this.okj_1 = keyMapping;
    this.pkj_1 = onValueChange;
    this.qkj_1 = imeAction;
  }
  protoOf(TextFieldKeyInput).qkl = function (event) {
    var tmp0_safe_receiver = typedCommand(this, event);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp;
      if (this.ikj_1) {
        apply_1(this, tmp0_safe_receiver);
        this.kkj_1.skl();
        tmp = true;
      } else {
        tmp = false;
      }
      return tmp;
    }
    if (!(get_type(event) === Companion_getInstance_9().e9e_1)) {
      return false;
    }
    var command = this.okj_1.hke(event);
    if (command == null || (command.fke_1 && !this.ikj_1)) {
      return false;
    }
    var consumed = {_v: true};
    commandExecutionContext(this, TextFieldKeyInput$process$lambda(command, this, consumed));
    var tmp1_safe_receiver = this.mkj_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.tkl();
    }
    return consumed._v;
  };
  function textFieldKeyInput$lambda(it) {
    return Unit_instance;
  }
  function TextFieldKeyInput$process$ref(p0) {
    return constructCallableReference(function (p0_0) {
      return p0.qkl(p0_0.e9u_1);
    }, 1, 0, 331, 'process', [p0]);
  }
  function textFieldKeyInput$lambda_0($state, $manager, $value, $editable, $singleLine, $offsetMapping, $undoManager, $onValueChange, $imeAction) {
    return function ($this$composed, $composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(851809892);
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = new TextPreparedSelectionState();
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var preparedSelectionState = tmp;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_0 = $composer_0.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = new DeadKeyCombiner();
        $composer_0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var keyCombiner = tmp_0;
      var processor = new TextFieldKeyInput($state, $manager, $value, $editable, $singleLine, preparedSelectionState, $offsetMapping, $undoManager, keyCombiner, VOID, $onValueChange, $imeAction);
      var tmp_1 = Companion_instance_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.q31(processor);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_0.i31();
      var tmp_2;
      if (invalid || it_1 === Companion_getInstance_11().f30_1) {
        var value_1 = TextFieldKeyInput$process$ref(processor);
        $composer_0.j31(value_1);
        tmp_2 = value_1;
      } else {
        tmp_2 = it_1;
      }
      var tmp$ret$8 = tmp_2;
      var tmp0 = onKeyEvent(tmp_1, tmp$ret$8);
      $composer_0.n30();
      return tmp0;
    };
  }
  function defaultTextFieldPointer(_this__u8e3s4, manager, enabled, interactionSource, state, focusRequester, readOnly, offsetMapping) {
    var tmp = updateSelectionTouchMode(_this__u8e3s4, defaultTextFieldPointer$lambda(state));
    var tmp_0 = tapPressTextFieldModifier(tmp, interactionSource, enabled, defaultTextFieldPointer$lambda_0(state, focusRequester, readOnly, enabled, offsetMapping, manager));
    var tmp_1 = defaultTextFieldPointer$slambda_0(manager, null);
    return pointerHoverIcon(pointerInput_0(tmp_0, manager.sk2_1, manager.rk2_1, new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3(tmp_1)), Companion_getInstance_49().ca3_1);
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3(function_0) {
    this.ukl_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3).ka7 = function (_this__u8e3s4, $completion) {
    return this.ukl_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3).q3 = function () {
    return this.ukl_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3).hashCode = function () {
    return hashCode(this.q3());
  };
  function defaultTextFieldPointer$lambda($state) {
    return function (it) {
      $state.dk7(it);
      return Unit_instance;
    };
  }
  function defaultTextFieldPointer$lambda_0($state, $focusRequester, $readOnly, $enabled, $offsetMapping, $manager) {
    return function (offset) {
      requestFocusAndShowKeyboardIfNeeded($state, $focusRequester, !$readOnly);
      var tmp;
      if ($state.r9h() && $enabled) {
        if (!$state.tk6().equals(HandleState_Selection_getInstance())) {
          var tmp0_safe_receiver = $state.tk7();
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            Companion_instance_29.dkj(offset.e5d_1, tmp0_safe_receiver, $state.ek5_1, $offsetMapping, $state.wk5_1);
            // Inline function 'kotlin.text.isNotEmpty' call
            var this_0 = $state.bk5_1.wk7_1;
            if (charSequenceLength(this_0) > 0) {
              $state.uk6(HandleState_Cursor_getInstance());
            }
          }
        } else {
          var tmp_0 = offset;
          $manager.vkl(tmp_0 == null ? null : tmp_0.e5d_1);
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function defaultTextFieldPointer$slambda($manager, resultContinuation) {
    this.ekm_1 = $manager;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTextFieldPointer$slambda).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(defaultTextFieldPointer$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(defaultTextFieldPointer$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = awaitSelectionGestures(this.fkm_1, this.ekm_1.sk2_1, this.ekm_1.rk2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTextFieldPointer$slambda).wc6 = function ($this$pointerInput, completion) {
    var i = new defaultTextFieldPointer$slambda(this.ekm_1, completion);
    i.fkm_1 = $this$pointerInput;
    return i;
  };
  function defaultTextFieldPointer$slambda_0($manager, resultContinuation) {
    var i = new defaultTextFieldPointer$slambda($manager, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function tapPressTextFieldModifier(_this__u8e3s4, interactionSource, enabled, onTap) {
    enabled = enabled === VOID ? true : enabled;
    var tmp;
    if (enabled) {
      tmp = composed(_this__u8e3s4, VOID, tapPressTextFieldModifier$lambda(onTap, interactionSource));
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4(function_0) {
    this.gkm_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4).ka7 = function (_this__u8e3s4, $completion) {
    return this.gkm_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4).q3 = function () {
    return this.gkm_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4).hashCode = function () {
    return hashCode(this.q3());
  };
  function tapPressTextFieldModifier$lambda$lambda() {
    return EmptyCoroutineContext_getInstance();
  }
  function tapPressTextFieldModifier$1$$inlined$cache$1$1($pressedInteraction, $interactionSource) {
    this.hkm_1 = $pressedInteraction;
    this.ikm_1 = $interactionSource;
  }
  protoOf(tapPressTextFieldModifier$1$$inlined$cache$1$1).s1d = function () {
    var tmp0_safe_receiver = this.hkm_1.u1();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var interaction = new Cancel_0(tmp0_safe_receiver);
      var tmp0_safe_receiver_0 = this.ikm_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else
        tmp0_safe_receiver_0.efo(interaction);
      this.hkm_1.s21(null);
    }
  };
  function tapPressTextFieldModifier$lambda$lambda_0($pressedInteraction, $interactionSource) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new tapPressTextFieldModifier$1$$inlined$cache$1$1($pressedInteraction, $interactionSource);
    };
  }
  function tapPressTextFieldModifier$lambda$slambda$slambda$slambda($pressedInteraction, $interactionSource, $it, resultContinuation) {
    this.rkm_1 = $pressedInteraction;
    this.skm_1 = $interactionSource;
    this.tkm_1 = $it;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            var tmp0_safe_receiver = this.rkm_1.u1();
            if (tmp0_safe_receiver == null) {
              this.xkm_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              var interaction = new Cancel_0(tmp0_safe_receiver);
              var tmp0_safe_receiver_0 = this.skm_1;
              if (tmp0_safe_receiver_0 == null) {
                this.ykm_1 = null;
                this.n9_1 = 2;
                continue $sm;
              } else {
                this.n9_1 = 1;
                suspendResult = tmp0_safe_receiver_0.vfh(interaction, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 1:
            var tmp_0 = this;
            tmp_0.ykm_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.rkm_1.s21(null);
            var tmp_1 = this;
            tmp_1.xkm_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.vkm_1 = new Press(this.tkm_1);
            var tmp1_safe_receiver = this.skm_1;
            if (tmp1_safe_receiver == null) {
              this.wkm_1 = null;
              this.n9_1 = 5;
              continue $sm;
            } else {
              this.n9_1 = 4;
              suspendResult = tmp1_safe_receiver.vfh(this.vkm_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 4:
            var tmp_2 = this;
            tmp_2.wkm_1 = Unit_instance;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.rkm_1.s21(this.vkm_1);
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new tapPressTextFieldModifier$lambda$slambda$slambda$slambda(this.rkm_1, this.skm_1, this.tkm_1, completion);
    i.ukm_1 = $this$launch;
    return i;
  };
  function tapPressTextFieldModifier$lambda$slambda$slambda$slambda_0($pressedInteraction, $interactionSource, $it, resultContinuation) {
    var i = new tapPressTextFieldModifier$lambda$slambda$slambda$slambda($pressedInteraction, $interactionSource, $it, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function tapPressTextFieldModifier$lambda$slambda$slambda$slambda_1($pressedInteraction, $success, $interactionSource, resultContinuation) {
    this.hkn_1 = $pressedInteraction;
    this.ikn_1 = $success;
    this.jkn_1 = $interactionSource;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0_safe_receiver = this.hkn_1.u1();
            if (tmp0_safe_receiver == null) {
              this.lkn_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              var tmp_0;
              if (this.ikn_1) {
                tmp_0 = new Release(tmp0_safe_receiver);
              } else {
                tmp_0 = new Cancel_0(tmp0_safe_receiver);
              }
              var interaction = tmp_0;
              var tmp0_safe_receiver_0 = this.jkn_1;
              if (tmp0_safe_receiver_0 == null) {
                this.mkn_1 = null;
                this.n9_1 = 2;
                continue $sm;
              } else {
                this.n9_1 = 1;
                suspendResult = tmp0_safe_receiver_0.vfh(interaction, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 1:
            var tmp_1 = this;
            tmp_1.mkn_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.hkn_1.s21(null);
            var tmp_2 = this;
            tmp_2.lkn_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda$slambda_1).q24 = function ($this$launch, completion) {
    var i = new tapPressTextFieldModifier$lambda$slambda$slambda$slambda_1(this.hkn_1, this.ikn_1, this.jkn_1, completion);
    i.kkn_1 = $this$launch;
    return i;
  };
  function tapPressTextFieldModifier$lambda$slambda$slambda$slambda_2($pressedInteraction, $success, $interactionSource, resultContinuation) {
    var i = new tapPressTextFieldModifier$lambda$slambda$slambda$slambda_1($pressedInteraction, $success, $interactionSource, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function tapPressTextFieldModifier$lambda$slambda$slambda($scope, $pressedInteraction, $interactionSource, resultContinuation) {
    this.vkn_1 = $scope;
    this.wkn_1 = $pressedInteraction;
    this.xkn_1 = $interactionSource;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda).bfu = function ($this$detectTapAndPress, it, $completion) {
    var tmp = this.cfu($this$detectTapAndPress, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, PressGestureScope) : false) ? p1 : THROW_CCE();
    return this.bfu(tmp, p2 instanceof Offset ? p2.e5d_1 : THROW_CCE(), $completion);
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            launch(this.vkn_1, VOID, VOID, tapPressTextFieldModifier$lambda$slambda$slambda$slambda_0(this.wkn_1, this.xkn_1, this.zkn_1, null));
            this.n9_1 = 1;
            suspendResult = this.ykn_1.jfp(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var success = suspendResult;
            launch(this.vkn_1, VOID, VOID, tapPressTextFieldModifier$lambda$slambda$slambda$slambda_2(this.wkn_1, success, this.xkn_1, null));
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda$slambda).cfu = function ($this$detectTapAndPress, it, completion) {
    var i = new tapPressTextFieldModifier$lambda$slambda$slambda(this.vkn_1, this.wkn_1, this.xkn_1, completion);
    i.ykn_1 = $this$detectTapAndPress;
    i.zkn_1 = it;
    return i;
  };
  function tapPressTextFieldModifier$lambda$slambda$slambda_0($scope, $pressedInteraction, $interactionSource, resultContinuation) {
    var i = new tapPressTextFieldModifier$lambda$slambda$slambda($scope, $pressedInteraction, $interactionSource, resultContinuation);
    return constructCallableReference(function ($this$detectTapAndPress, it, $completion) {
      return i.bfu($this$detectTapAndPress, it.e5d_1, $completion);
    }, 2);
  }
  function tapPressTextFieldModifier$lambda$slambda$lambda($onTapState) {
    return function (it) {
      $onTapState.u1()(it);
      return Unit_instance;
    };
  }
  function tapPressTextFieldModifier$lambda$slambda($scope, $pressedInteraction, $interactionSource, $onTapState, resultContinuation) {
    this.iko_1 = $scope;
    this.jko_1 = $pressedInteraction;
    this.kko_1 = $interactionSource;
    this.lko_1 = $onTapState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(tapPressTextFieldModifier$lambda$slambda).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = tapPressTextFieldModifier$lambda$slambda$slambda_0(this.iko_1, this.jko_1, this.kko_1, null);
            suspendResult = detectTapAndPress(this.mko_1, tmp_0, tapPressTextFieldModifier$lambda$slambda$lambda(this.lko_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(tapPressTextFieldModifier$lambda$slambda).wc6 = function ($this$pointerInput, completion) {
    var i = new tapPressTextFieldModifier$lambda$slambda(this.iko_1, this.jko_1, this.kko_1, this.lko_1, completion);
    i.mko_1 = $this$pointerInput;
    return i;
  };
  function tapPressTextFieldModifier$lambda$slambda_0($scope, $pressedInteraction, $interactionSource, $onTapState, resultContinuation) {
    var i = new tapPressTextFieldModifier$lambda$slambda($scope, $pressedInteraction, $interactionSource, $onTapState, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function tapPressTextFieldModifier$lambda($onTap, $interactionSource) {
    return function ($this$composed, $composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(-102778667);
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_1 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = tapPressTextFieldModifier$lambda$lambda;
      }
      var composer = $composer_1;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = createCompositionCoroutineScope(getContext(), composer);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var scope = tmp;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_0 = $composer_0.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = mutableStateOf(null);
        $composer_0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var pressedInteraction = tmp_0;
      var onTapState = rememberUpdatedState($onTap, $composer_0, 0);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.k31($interactionSource);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_0.i31();
      var tmp_1;
      if (invalid || it_1 === Companion_getInstance_11().f30_1) {
        var value_1 = tapPressTextFieldModifier$lambda$lambda_0(pressedInteraction, $interactionSource);
        $composer_0.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp$ret$9 = tmp_1;
      DisposableEffect_0($interactionSource, tmp$ret$9, $composer_0, 0);
      var tmp_2 = Companion_instance_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!($composer_0.q31(scope) | $composer_0.k31($interactionSource)) | $composer_0.k31(onTapState));
      // Inline function 'kotlin.let' call
      var it_2 = $composer_0.i31();
      var tmp_3;
      if (invalid_0 || it_2 === Companion_getInstance_11().f30_1) {
        var tmp_4 = tapPressTextFieldModifier$lambda$slambda_0(scope, pressedInteraction, $interactionSource, onTapState, null);
        var value_2 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4(tmp_4);
        $composer_0.j31(value_2);
        tmp_3 = value_2;
      } else {
        tmp_3 = it_2;
      }
      var tmp$ret$13 = tmp_3;
      var tmp0 = pointerInput(tmp_2, $interactionSource, tmp$ret$13);
      $composer_0.n30();
      return tmp0;
    };
  }
  var androidx_compose_foundation_text_TextFieldScrollerPosition$stable;
  function TextFieldScrollerPosition$Companion$Saver$lambda($this$listSaver, it) {
    return listOf([it.ai0(), it.lhy().equals(Orientation_Vertical_getInstance())]);
  }
  function TextFieldScrollerPosition$Companion$Saver$lambda_0(restored) {
    var tmp;
    var tmp_0 = restored.l1(1);
    if (typeof tmp_0 === 'boolean' ? tmp_0 : THROW_CCE()) {
      tmp = Orientation_Vertical_getInstance();
    } else {
      tmp = Orientation_Horizontal_getInstance();
    }
    var tmp_1 = tmp;
    var tmp_2 = restored.l1(0);
    return new TextFieldScrollerPosition(tmp_1, typeof tmp_2 === 'number' ? tmp_2 : THROW_CCE());
  }
  function TextFieldScrollerPosition_init_$Init$($this) {
    TextFieldScrollerPosition.call($this, Orientation_Vertical_getInstance());
    return $this;
  }
  function TextFieldScrollerPosition_init_$Create$() {
    return TextFieldScrollerPosition_init_$Init$(objectCreate(protoOf(TextFieldScrollerPosition)));
  }
  function _set_maximum__3cr7h7($this, _set____db54di) {
    var tmp0 = $this.vk4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldScrollerPosition$_get_maximum_$ref_xvovf0();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('maximum', 1, tmp, tmp_0, TextFieldScrollerPosition$_set_maximum_$ref_3lap34());
    tmp0.i45(_set____db54di);
    return Unit_instance;
  }
  function _set_viewportSize__qbtfu8($this, _set____db54di) {
    var tmp0 = $this.wk4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldScrollerPosition$_get_viewportSize_$ref_si3mef();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('viewportSize', 1, tmp, tmp_0, TextFieldScrollerPosition$_set_viewportSize_$ref_l0mod());
    tmp0.a49(_set____db54di);
    return Unit_instance;
  }
  function Companion_20() {
    Companion_instance_30 = this;
    var tmp = this;
    var tmp_0 = TextFieldScrollerPosition$Companion$Saver$lambda;
    tmp.tk4_1 = listSaver(tmp_0, TextFieldScrollerPosition$Companion$Saver$lambda_0);
  }
  var Companion_instance_30;
  function Companion_getInstance_79() {
    if (Companion_instance_30 == null)
      new Companion_20();
    return Companion_instance_30;
  }
  function TextFieldScrollerPosition$_get_offset_$ref_fdk0h1() {
    return constructCallableReference(function (p0) {
      return p0.ai0();
    }, 1, 0, 332);
  }
  function TextFieldScrollerPosition$_set_offset_$ref_bbfbt() {
    return constructCallableReference(function (p0, p1) {
      p0.nko(p1);
      return Unit_instance;
    }, 2, 0, 333);
  }
  function TextFieldScrollerPosition$_get_maximum_$ref_xvovf0() {
    return constructCallableReference(function (p0) {
      return p0.jay();
    }, 1, 0, 334);
  }
  function TextFieldScrollerPosition$_set_maximum_$ref_3lap34() {
    return constructCallableReference(function (p0, p1) {
      _set_maximum__3cr7h7(p0, p1);
      return Unit_instance;
    }, 2, 0, 335);
  }
  function TextFieldScrollerPosition$_get_viewportSize_$ref_si3mef() {
    return constructCallableReference(function (p0) {
      return p0.gg7();
    }, 1, 0, 336);
  }
  function TextFieldScrollerPosition$_set_viewportSize_$ref_l0mod() {
    return constructCallableReference(function (p0, p1) {
      _set_viewportSize__qbtfu8(p0, p1);
      return Unit_instance;
    }, 2, 0, 337);
  }
  function TextFieldScrollerPosition$_get_orientation_$ref_jfh524() {
    return constructCallableReference(function (p0) {
      return p0.lhy();
    }, 1, 0, 338);
  }
  function TextFieldScrollerPosition$_set_orientation_$ref_9bqxjk() {
    return constructCallableReference(function (p0, p1) {
      p0.oko(p1);
      return Unit_instance;
    }, 2, 0, 339);
  }
  function TextFieldScrollerPosition(initialOrientation, initial) {
    Companion_getInstance_79();
    initial = initial === VOID ? 0.0 : initial;
    this.uk4_1 = mutableFloatStateOf(initial);
    this.vk4_1 = mutableFloatStateOf(0.0);
    this.wk4_1 = mutableIntStateOf(0);
    this.xk4_1 = Companion_getInstance_50().j5d_1;
    this.yk4_1 = Companion_getInstance_43().n7u_1;
    this.zk4_1 = mutableStateOf(initialOrientation, structuralEqualityPolicy());
  }
  protoOf(TextFieldScrollerPosition).nko = function (_set____db54di) {
    var tmp0 = this.uk4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldScrollerPosition$_get_offset_$ref_fdk0h1();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('offset', 1, tmp, tmp_0, TextFieldScrollerPosition$_set_offset_$ref_bbfbt());
    tmp0.i45(_set____db54di);
    return Unit_instance;
  };
  protoOf(TextFieldScrollerPosition).ai0 = function () {
    var tmp0 = this.uk4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldScrollerPosition$_get_offset_$ref_fdk0h1();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('offset', 1, tmp, tmp_0, TextFieldScrollerPosition$_set_offset_$ref_bbfbt());
    return tmp0.j45();
  };
  protoOf(TextFieldScrollerPosition).jay = function () {
    var tmp0 = this.vk4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldScrollerPosition$_get_maximum_$ref_xvovf0();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('maximum', 1, tmp, tmp_0, TextFieldScrollerPosition$_set_maximum_$ref_3lap34());
    return tmp0.j45();
  };
  protoOf(TextFieldScrollerPosition).gg7 = function () {
    var tmp0 = this.wk4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldScrollerPosition$_get_viewportSize_$ref_si3mef();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('viewportSize', 1, tmp, tmp_0, TextFieldScrollerPosition$_set_viewportSize_$ref_l0mod());
    return tmp0.b49();
  };
  protoOf(TextFieldScrollerPosition).oko = function (_set____db54di) {
    var tmp0 = this.zk4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldScrollerPosition$_get_orientation_$ref_jfh524();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('orientation', 1, tmp, tmp_0, TextFieldScrollerPosition$_set_orientation_$ref_9bqxjk());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(TextFieldScrollerPosition).lhy = function () {
    var tmp0 = this.zk4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldScrollerPosition$_get_orientation_$ref_jfh524();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('orientation', 1, tmp, tmp_0, TextFieldScrollerPosition$_set_orientation_$ref_9bqxjk());
    return tmp0.u1();
  };
  protoOf(TextFieldScrollerPosition).pko = function (orientation, cursorRect, containerSize, textFieldSize) {
    var difference = textFieldSize - containerSize | 0;
    _set_maximum__3cr7h7(this, difference);
    if (!(cursorRect.k5d_1 === this.xk4_1.k5d_1) || !(cursorRect.l5d_1 === this.xk4_1.l5d_1)) {
      var vertical = orientation.equals(Orientation_Vertical_getInstance());
      var cursorStart = vertical ? cursorRect.l5d_1 : cursorRect.k5d_1;
      var cursorEnd = vertical ? cursorRect.n5d_1 : cursorRect.m5d_1;
      this.qko(cursorStart, cursorEnd, containerSize);
      this.xk4_1 = cursorRect;
    }
    this.nko(coerceIn_0(this.ai0(), 0.0, difference));
    _set_viewportSize__qbtfu8(this, containerSize);
  };
  protoOf(TextFieldScrollerPosition).qko = function (cursorStart, cursorEnd, containerSize) {
    var startVisibleBound = this.ai0();
    var endVisibleBound = startVisibleBound + containerSize;
    var offsetDifference = cursorEnd > endVisibleBound ? cursorEnd - endVisibleBound : cursorStart < startVisibleBound && cursorEnd - cursorStart > containerSize ? cursorEnd - endVisibleBound : cursorStart < startVisibleBound && cursorEnd - cursorStart <= containerSize ? cursorStart - startVisibleBound : 0.0;
    this.nko(this.ai0() + offsetDifference);
  };
  protoOf(TextFieldScrollerPosition).rko = function (selection) {
    return !(_TextRange___get_start__impl__ww4t90(selection) === _TextRange___get_start__impl__ww4t90(this.yk4_1)) ? _TextRange___get_start__impl__ww4t90(selection) : !(_TextRange___get_end__impl__gcdxpp(selection) === _TextRange___get_end__impl__gcdxpp(this.yk4_1)) ? _TextRange___get_end__impl__gcdxpp(selection) : _TextRange___get_min__impl__uu95c4(selection);
  };
  function textFieldScrollable(_this__u8e3s4, scrollerPosition, interactionSource, enabled, overscrollEffect) {
    interactionSource = interactionSource === VOID ? null : interactionSource;
    enabled = enabled === VOID ? true : enabled;
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = textFieldScrollable$lambda(scrollerPosition, interactionSource, enabled);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp_0 = tmp;
    return composed(_this__u8e3s4, tmp_0, textFieldScrollable$lambda_0(scrollerPosition, enabled, overscrollEffect, interactionSource));
  }
  function defaultTextFieldScroll(_this__u8e3s4, scrollerPosition, textFieldValue, visualTransformation, overscrollEffect, textLayoutResultProvider) {
    var orientation = scrollerPosition.lhy();
    var cursorOffset = scrollerPosition.rko(textFieldValue.g8a_1);
    scrollerPosition.yk4_1 = textFieldValue.g8a_1;
    var transformedText = filterWithValidation(visualTransformation, textFieldValue.f8a_1);
    var tmp;
    switch (orientation.a1_1) {
      case 0:
        tmp = new VerticalScrollLayoutModifier(scrollerPosition, cursorOffset, transformedText, textLayoutResultProvider);
        break;
      case 1:
        tmp = new HorizontalScrollLayoutModifier(scrollerPosition, cursorOffset, transformedText, textLayoutResultProvider);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var layout = tmp;
    return clipToBounds(overscroll(_this__u8e3s4, overscrollEffect)).d8v(layout);
  }
  function VerticalScrollLayoutModifier$measure$lambda(this$0, $placeable, $height) {
    return function ($this$layout) {
      var tmp0_safe_receiver = this$0.vko_1();
      var cursorRect = getCursorRectInScroller($this$layout, this$0.tko_1, this$0.uko_1, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hk8_1, false, $placeable.i8y_1);
      this$0.sko_1.pko(Orientation_Vertical_getInstance(), cursorRect, $height, $placeable.j8y_1);
      var offset = -this$0.sko_1.ai0();
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var tmp;
      if (isNaN_0(offset)) {
        tmp = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp = roundToInt(offset);
      }
      var tmp$ret$0 = tmp;
      $this$layout.a98($placeable, 0, tmp$ret$0);
      return Unit_instance;
    };
  }
  function VerticalScrollLayoutModifier(scrollerPosition, cursorOffset, transformedText, textLayoutResultProvider) {
    this.sko_1 = scrollerPosition;
    this.tko_1 = cursorOffset;
    this.uko_1 = transformedText;
    this.vko_1 = textLayoutResultProvider;
  }
  protoOf(VerticalScrollLayoutModifier).g8y = function (_this__u8e3s4, measurable, constraints) {
    var childConstraints = Constraints__copy$default_impl_f452rp(constraints, VOID, VOID, VOID, 2147483647);
    var placeable = measurable.h8y(childConstraints);
    var tmp0 = placeable.j8y_1;
    // Inline function 'kotlin.math.min' call
    var b = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    var height = Math.min(tmp0, b);
    var tmp = placeable.i8y_1;
    return _this__u8e3s4.n8y(tmp, height, VOID, VerticalScrollLayoutModifier$measure$lambda(this, placeable, height));
  };
  protoOf(VerticalScrollLayoutModifier).toString = function () {
    return 'VerticalScrollLayoutModifier(scrollerPosition=' + toString(this.sko_1) + ', cursorOffset=' + this.tko_1 + ', transformedText=' + this.uko_1.toString() + ', textLayoutResultProvider=' + toString(this.vko_1) + ')';
  };
  protoOf(VerticalScrollLayoutModifier).hashCode = function () {
    var result = hashCode(this.sko_1);
    result = imul(result, 31) + this.tko_1 | 0;
    result = imul(result, 31) + this.uko_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.vko_1) | 0;
    return result;
  };
  protoOf(VerticalScrollLayoutModifier).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VerticalScrollLayoutModifier))
      return false;
    if (!equals(this.sko_1, other.sko_1))
      return false;
    if (!(this.tko_1 === other.tko_1))
      return false;
    if (!this.uko_1.equals(other.uko_1))
      return false;
    if (!equals(this.vko_1, other.vko_1))
      return false;
    return true;
  };
  function HorizontalScrollLayoutModifier$measure$lambda(this$0, $this_measure, $placeable, $width) {
    return function ($this$layout) {
      var tmp0_safe_receiver = this$0.zko_1();
      var cursorRect = getCursorRectInScroller($this$layout, this$0.xko_1, this$0.yko_1, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hk8_1, $this_measure.r6p().equals(LayoutDirection_Rtl_getInstance()), $placeable.i8y_1);
      this$0.wko_1.pko(Orientation_Horizontal_getInstance(), cursorRect, $width, $placeable.i8y_1);
      var offset = -this$0.wko_1.ai0();
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var tmp;
      if (isNaN_0(offset)) {
        tmp = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp = roundToInt(offset);
      }
      var tmp$ret$0 = tmp;
      $this$layout.a98($placeable, tmp$ret$0, 0);
      return Unit_instance;
    };
  }
  function HorizontalScrollLayoutModifier(scrollerPosition, cursorOffset, transformedText, textLayoutResultProvider) {
    this.wko_1 = scrollerPosition;
    this.xko_1 = cursorOffset;
    this.yko_1 = transformedText;
    this.zko_1 = textLayoutResultProvider;
  }
  protoOf(HorizontalScrollLayoutModifier).g8y = function (_this__u8e3s4, measurable, constraints) {
    var maxIntrinsicWidth = measurable.c98(_Constraints___get_maxHeight__impl__dt3e8z(constraints));
    var tmp;
    if (maxIntrinsicWidth < _Constraints___get_maxWidth__impl__uuyqc(constraints)) {
      tmp = constraints;
    } else {
      tmp = Constraints__copy$default_impl_f452rp(constraints, VOID, 2147483647);
    }
    var childConstraints = tmp;
    var placeable = measurable.h8y(childConstraints);
    var tmp0 = placeable.i8y_1;
    // Inline function 'kotlin.math.min' call
    var b = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    var width = Math.min(tmp0, b);
    var tmp_0 = placeable.j8y_1;
    return _this__u8e3s4.n8y(width, tmp_0, VOID, HorizontalScrollLayoutModifier$measure$lambda(this, _this__u8e3s4, placeable, width));
  };
  protoOf(HorizontalScrollLayoutModifier).toString = function () {
    return 'HorizontalScrollLayoutModifier(scrollerPosition=' + toString(this.wko_1) + ', cursorOffset=' + this.xko_1 + ', transformedText=' + this.yko_1.toString() + ', textLayoutResultProvider=' + toString(this.zko_1) + ')';
  };
  protoOf(HorizontalScrollLayoutModifier).hashCode = function () {
    var result = hashCode(this.wko_1);
    result = imul(result, 31) + this.xko_1 | 0;
    result = imul(result, 31) + this.yko_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.zko_1) | 0;
    return result;
  };
  protoOf(HorizontalScrollLayoutModifier).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HorizontalScrollLayoutModifier))
      return false;
    if (!equals(this.wko_1, other.wko_1))
      return false;
    if (!(this.xko_1 === other.xko_1))
      return false;
    if (!this.yko_1.equals(other.yko_1))
      return false;
    if (!equals(this.zko_1, other.zko_1))
      return false;
    return true;
  };
  function getCursorRectInScroller(_this__u8e3s4, cursorOffset, transformedText, textLayoutResult, rtl, textFieldWidth) {
    var tmp1_elvis_lhs = textLayoutResult == null ? null : textLayoutResult.c7u(transformedText.q8d_1.o8c(cursorOffset));
    var cursorRect = tmp1_elvis_lhs == null ? Companion_getInstance_50().j5d_1 : tmp1_elvis_lhs;
    var thickness = _this__u8e3s4.w5e(get_DefaultCursorThickness());
    var tmp;
    if (rtl) {
      tmp = textFieldWidth - cursorRect.k5d_1 - thickness;
    } else {
      tmp = cursorRect.k5d_1;
    }
    var cursorLeft = tmp;
    var tmp_0;
    if (rtl) {
      tmp_0 = textFieldWidth - cursorRect.k5d_1;
    } else {
      tmp_0 = cursorRect.k5d_1 + thickness;
    }
    var cursorRight = tmp_0;
    return cursorRect.w5d(cursorLeft, VOID, cursorRight);
  }
  function textFieldScrollable$lambda($scrollerPosition, $interactionSource, $enabled) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'textFieldScrollable';
      _this__u8e3s4.mdp_1.odp('scrollerPosition', $scrollerPosition);
      _this__u8e3s4.mdp_1.odp('interactionSource', $interactionSource);
      _this__u8e3s4.mdp_1.odp('enabled', $enabled);
      return Unit_instance;
    };
  }
  function textFieldScrollable$lambda$lambda($scrollerPosition) {
    return function (delta) {
      var newOffset = $scrollerPosition.ai0() + delta;
      var consumedDelta = newOffset > $scrollerPosition.jay() ? $scrollerPosition.jay() - $scrollerPosition.ai0() : newOffset < 0.0 ? -$scrollerPosition.ai0() : delta;
      var _receiver__tnumb7 = $scrollerPosition;
      _receiver__tnumb7.nko(_receiver__tnumb7.ai0() + consumedDelta);
      return consumedDelta;
    };
  }
  function textFieldScrollable$lambda$o$canScrollForward$delegate$lambda($scrollerPosition) {
    return function () {
      return $scrollerPosition.ai0() < $scrollerPosition.jay();
    };
  }
  function textFieldScrollable$lambda$o$_get_canScrollForward_$ref_8fwm6k() {
    return constructCallableReference(function (p0) {
      return p0.mg7();
    }, 1, 0, 340);
  }
  function textFieldScrollable$lambda$o$canScrollBackward$delegate$lambda($scrollerPosition) {
    return function () {
      return $scrollerPosition.ai0() > 0.0;
    };
  }
  function textFieldScrollable$lambda$o$_get_canScrollBackward_$ref_v6ao2() {
    return constructCallableReference(function (p0) {
      return p0.ng7();
    }, 1, 0, 341);
  }
  function textFieldScrollable$1$wrappedScrollableState$1($scrollableState, $scrollerPosition) {
    this.akp_1 = $scrollableState;
    var tmp = this;
    tmp.bkp_1 = derivedStateOf(textFieldScrollable$lambda$o$canScrollForward$delegate$lambda($scrollerPosition));
    var tmp_0 = this;
    tmp_0.ckp_1 = derivedStateOf(textFieldScrollable$lambda$o$canScrollBackward$delegate$lambda($scrollerPosition));
  }
  protoOf(textFieldScrollable$1$wrappedScrollableState$1).mg7 = function () {
    var tmp0 = this.bkp_1;
    var tmp = KProperty1;
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('canScrollForward', 1, tmp, textFieldScrollable$lambda$o$_get_canScrollForward_$ref_8fwm6k(), null);
    return tmp0.u1();
  };
  protoOf(textFieldScrollable$1$wrappedScrollableState$1).ng7 = function () {
    var tmp0 = this.ckp_1;
    var tmp = KProperty1;
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('canScrollBackward', 1, tmp, textFieldScrollable$lambda$o$_get_canScrollBackward_$ref_v6ao2(), null);
    return tmp0.u1();
  };
  protoOf(textFieldScrollable$1$wrappedScrollableState$1).pg7 = function (scrollPriority, block, $completion) {
    return this.akp_1.pg7(scrollPriority, block, $completion);
  };
  protoOf(textFieldScrollable$1$wrappedScrollableState$1).rg7 = function (delta) {
    return this.akp_1.rg7(delta);
  };
  protoOf(textFieldScrollable$1$wrappedScrollableState$1).sg7 = function () {
    return this.akp_1.sg7();
  };
  function textFieldScrollable$lambda_0($scrollerPosition, $enabled, $overscrollEffect, $interactionSource) {
    return function ($this$composed, $composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(-2137546592);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_0 = get_LocalLayoutDirection();
      var $composer_1 = $composer_0;
      var rtl = $composer_1.u31(this_0).equals(LayoutDirection_Rtl_getInstance());
      var reverseDirection = $scrollerPosition.lhy().equals(Orientation_Vertical_getInstance()) || !rtl;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.k31($scrollerPosition);
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = textFieldScrollable$lambda$lambda($scrollerPosition);
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$1 = tmp;
      var scrollableState = rememberScrollableState(tmp$ret$1, $composer_0, 0);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.k31(scrollableState) | $composer_0.k31($scrollerPosition));
      // Inline function 'kotlin.let' call
      var it_0 = $composer_0.i31();
      var tmp_0;
      if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = new textFieldScrollable$1$wrappedScrollableState$1(scrollableState, $scrollerPosition);
        $composer_0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var wrappedScrollableState = tmp_0;
      var tmp1_orientation = $scrollerPosition.lhy();
      var tmp2_enabled = $enabled && !($scrollerPosition.jay() === 0.0);
      var scroll = scrollable(Companion_instance_0, wrappedScrollableState, tmp1_orientation, $overscrollEffect, tmp2_enabled, reverseDirection, VOID, $interactionSource);
      $composer_0.n30();
      return scroll;
    };
  }
  function textFieldMinSize(_this__u8e3s4, style) {
    var tmp;
    if (ComposeFoundationFlags_instance.tfg_1) {
      tmp = _this__u8e3s4.d8v(new TextFieldSizeElement(style));
    } else {
      tmp = legacyTextFieldMinSize(_this__u8e3s4, style);
    }
    return tmp;
  }
  function TextFieldSizeElement(style) {
    ModifierNodeElement.call(this);
    this.ekp_1 = style;
  }
  protoOf(TextFieldSizeElement).r3d = function () {
    return new TextFieldSizeNode(this.ekp_1);
  };
  protoOf(TextFieldSizeElement).fkp = function (node) {
    node.ykp(this.ekp_1);
  };
  protoOf(TextFieldSizeElement).d8y = function (node) {
    return this.fkp(node instanceof TextFieldSizeNode ? node : THROW_CCE());
  };
  protoOf(TextFieldSizeElement).hashCode = function () {
    return this.ekp_1.hashCode();
  };
  protoOf(TextFieldSizeElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextFieldSizeElement))
      return false;
    return this.ekp_1.equals(other.ekp_1);
  };
  function legacyTextFieldMinSize(_this__u8e3s4, style) {
    return composed(_this__u8e3s4, VOID, legacyTextFieldMinSize$lambda(style));
  }
  function requireFontResolutionState_0($this) {
    // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
    var value = $this.vkp_1;
    if (value == null) {
      var tmp$ret$1 = 'Font resolution state is not set.';
      throwIllegalArgumentExceptionForNullCheck(tmp$ret$1);
    }
    return value;
  }
  function requireMinSizeState($this) {
    // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
    var value = $this.wkp_1;
    if (value == null) {
      var tmp$ret$1 = 'Min size state is not set.';
      throwIllegalArgumentExceptionForNullCheck(tmp$ret$1);
    }
    return value;
  }
  function updateFontResolutionState($this, resolvedStyle, fontFamilyResolver) {
    var tmp = $this;
    var tmp_0 = resolvedStyle.i82();
    var tmp0_elvis_lhs = resolvedStyle.f82();
    var tmp_1 = tmp0_elvis_lhs == null ? Companion_getInstance_19().b7z_1 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = resolvedStyle.g82();
    var tmp_2;
    var tmp_3 = tmp1_elvis_lhs;
    if ((tmp_3 == null ? null : new FontStyle(tmp_3)) == null) {
      tmp_2 = Companion_getInstance_32().k7z_1;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var tmp_4 = tmp_2;
    var tmp2_elvis_lhs = resolvedStyle.h82();
    var tmp_5;
    var tmp_6 = tmp2_elvis_lhs;
    if ((tmp_6 == null ? null : new FontSynthesis(tmp_6)) == null) {
      tmp_5 = Companion_getInstance_35().p7z_1;
    } else {
      tmp_5 = tmp2_elvis_lhs;
    }
    tmp.vkp_1 = fontFamilyResolver.r84(tmp_0, tmp_1, tmp_4, tmp_5);
    invalidateMeasurement($this);
  }
  function TextFieldSizeNode$measure$lambda($measured) {
    return function ($this$layout) {
      $this$layout.a98($measured, 0, 0);
      return Unit_instance;
    };
  }
  function TextFieldSizeNode(style) {
    Node.call(this);
    this.ukp_1 = style;
    this.vkp_1 = null;
    this.wkp_1 = null;
    this.xkp_1 = false;
  }
  protoOf(TextFieldSizeNode).b8w = function () {
    return this.xkp_1;
  };
  protoOf(TextFieldSizeNode).f8w = function () {
    var resolvedStyle = resolveDefaults(this.ukp_1, requireLayoutDirection(this));
    var fontFamilyResolver = currentValueOf(this, get_LocalFontFamilyResolver());
    updateFontResolutionState(this, resolvedStyle, fontFamilyResolver);
    this.wkp_1 = new TextFieldSize(requireLayoutDirection(this), requireDensity(this), fontFamilyResolver, resolvedStyle, requireFontResolutionState_0(this).u1());
  };
  protoOf(TextFieldSizeNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var minSize = requireMinSizeState(this).gkq(requireFontResolutionState_0(this).u1());
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(minSize);
    var tmp = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(minSize);
    var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var childConstraints = Constraints_0(tmp, VOID, tmp$ret$2);
    var measured = measurable.h8y(constrain_0(constraints, childConstraints));
    var tmp_0 = measured.i8y_1;
    var tmp_1 = measured.j8y_1;
    return _this__u8e3s4.n8y(tmp_0, tmp_1, VOID, TextFieldSizeNode$measure$lambda(measured));
  };
  protoOf(TextFieldSizeNode).o8w = function () {
    var tmp0_safe_receiver = this.wkp_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.hkq(requireLayoutDirection(this));
    }
    invalidateMeasurement(this);
  };
  protoOf(TextFieldSizeNode).n8w = function () {
    var tmp0_safe_receiver = this.wkp_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.hkq(VOID, requireDensity(this));
    }
    invalidateMeasurement(this);
  };
  protoOf(TextFieldSizeNode).h8w = function () {
    this.vkp_1 = null;
    this.wkp_1 = null;
  };
  protoOf(TextFieldSizeNode).ykp = function (style) {
    var resolvedStyle = resolveDefaults(style, requireLayoutDirection(this));
    updateFontResolutionState(this, resolvedStyle, currentValueOf(this, get_LocalFontFamilyResolver()));
    requireMinSizeState(this).hkq(VOID, VOID, VOID, resolvedStyle);
    invalidateMeasurement(this);
  };
  function computeMinSize($this) {
    return computeSizeForDefaultText($this.lkq_1, $this.jkq_1, $this.kkq_1);
  }
  function LegacyTextFieldSize(layoutDirection, density, fontFamilyResolver, resolvedStyle, typeface) {
    this.ikq_1 = layoutDirection;
    this.jkq_1 = density;
    this.kkq_1 = fontFamilyResolver;
    this.lkq_1 = resolvedStyle;
    this.mkq_1 = typeface;
    this.nkq_1 = computeMinSize(this);
  }
  protoOf(LegacyTextFieldSize).okq = function (layoutDirection, density, fontFamilyResolver, resolvedStyle, typeface) {
    if (!layoutDirection.equals(this.ikq_1) || !equals(density, this.jkq_1) || !equals(fontFamilyResolver, this.kkq_1) || !resolvedStyle.equals(this.lkq_1) || !equals(typeface, this.mkq_1)) {
      this.ikq_1 = layoutDirection;
      this.jkq_1 = density;
      this.kkq_1 = fontFamilyResolver;
      this.lkq_1 = resolvedStyle;
      this.mkq_1 = typeface;
      this.nkq_1 = computeMinSize(this);
    }
  };
  function _set_dirty__dipwoj($this, _set____db54di) {
    var tmp0 = $this.ekq_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSize$_get_dirty_$ref_r20kew();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('dirty', 1, tmp, tmp_0, TextFieldSize$_set_dirty_$ref_28tvzo());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_dirty__iiejsx($this) {
    var tmp0 = $this.ekq_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSize$_get_dirty_$ref_r20kew();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('dirty', 1, tmp, tmp_0, TextFieldSize$_set_dirty_$ref_28tvzo());
    return tmp0.u1();
  }
  function TextFieldSize$_get_dirty_$ref_r20kew() {
    return constructCallableReference(function (p0) {
      return _get_dirty__iiejsx(p0);
    }, 1, 0, 342);
  }
  function TextFieldSize$_set_dirty_$ref_28tvzo() {
    return constructCallableReference(function (p0, p1) {
      _set_dirty__dipwoj(p0, p1);
      return Unit_instance;
    }, 2, 0, 343);
  }
  function TextFieldSize(layoutDirection, density, fontFamilyResolver, resolvedStyle, typeface) {
    this.zkp_1 = layoutDirection;
    this.akq_1 = density;
    this.bkq_1 = fontFamilyResolver;
    this.ckq_1 = resolvedStyle;
    this.dkq_1 = typeface;
    this.ekq_1 = mutableStateOf(true);
    this.fkq_1 = this.pkq(this.bkq_1);
  }
  protoOf(TextFieldSize).gkq = function (typeface) {
    this.qkq(typeface);
    if (_get_dirty__iiejsx(this)) {
      this.fkq_1 = this.pkq(this.bkq_1);
      _set_dirty__dipwoj(this, false);
    }
    return this.fkq_1;
  };
  protoOf(TextFieldSize).okq = function (layoutDirection, density, fontFamilyResolver, resolvedStyle, typeface) {
    if (!layoutDirection.equals(this.zkp_1) || !equals(density, this.akq_1) || !equals(fontFamilyResolver, this.bkq_1) || !resolvedStyle.equals(this.ckq_1)) {
      this.zkp_1 = layoutDirection;
      this.akq_1 = density;
      this.bkq_1 = fontFamilyResolver;
      this.ckq_1 = resolvedStyle;
      _set_dirty__dipwoj(this, true);
      return Unit_instance;
    }
    this.qkq(typeface);
  };
  protoOf(TextFieldSize).hkq = function (layoutDirection, density, fontFamilyResolver, resolvedStyle, typeface, $super) {
    layoutDirection = layoutDirection === VOID ? this.zkp_1 : layoutDirection;
    density = density === VOID ? this.akq_1 : density;
    fontFamilyResolver = fontFamilyResolver === VOID ? this.bkq_1 : fontFamilyResolver;
    resolvedStyle = resolvedStyle === VOID ? this.ckq_1 : resolvedStyle;
    typeface = typeface === VOID ? this.dkq_1 : typeface;
    var tmp;
    if ($super === VOID) {
      this.okq(layoutDirection, density, fontFamilyResolver, resolvedStyle, typeface);
      tmp = Unit_instance;
    } else {
      tmp = $super.okq.call(this, layoutDirection, density, fontFamilyResolver, resolvedStyle, typeface);
    }
    return tmp;
  };
  protoOf(TextFieldSize).qkq = function (typeface) {
    if (!equals(typeface, this.dkq_1)) {
      this.dkq_1 = typeface;
      _set_dirty__dipwoj(this, true);
    }
  };
  protoOf(TextFieldSize).pkq = function (fontFamilyResolver) {
    return computeSizeForDefaultText(this.ckq_1, this.akq_1, fontFamilyResolver);
  };
  function invoke$lambda_0($typeface$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('typeface', KProperty0, false);
    return $typeface$delegate.u1();
  }
  function legacyTextFieldMinSize$lambda$lambda$lambda($measured) {
    return function ($this$layout) {
      $this$layout.a98($measured, 0, 0);
      return Unit_instance;
    };
  }
  function legacyTextFieldMinSize$lambda$lambda($minSizeState) {
    return function ($this$layout, measurable, constraints) {
      var minSize = $minSizeState.nkq_1;
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(minSize);
      var tmp$ret$0 = convertToInt(shiftRight(value, 32));
      var tmp = coerceIn_1(tmp$ret$0, _Constraints___get_minWidth__impl__hi9lfi(constraints.m5e_1), _Constraints___get_maxWidth__impl__uuyqc(constraints.m5e_1));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(minSize);
      var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var childConstraints = Constraints__copy$default_impl_f452rp(constraints.m5e_1, tmp, VOID, coerceIn_1(tmp$ret$2, _Constraints___get_minHeight__impl__ev4bgx(constraints.m5e_1), _Constraints___get_maxHeight__impl__dt3e8z(constraints.m5e_1)));
      var measured = measurable.h8y(childConstraints);
      var tmp_0 = measured.i8y_1;
      var tmp_1 = measured.j8y_1;
      return $this$layout.n8y(tmp_0, tmp_1, VOID, legacyTextFieldMinSize$lambda$lambda$lambda(measured));
    };
  }
  function legacyTextFieldMinSize$lambda($style) {
    return function ($this$composed, $composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(-390200690);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_0 = get_LocalDensity();
      var $composer_1 = $composer_0;
      var density = $composer_1.u31(this_0);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_1 = get_LocalFontFamilyResolver();
      var $composer_2 = $composer_0;
      var fontFamilyResolver = $composer_2.u31(this_1);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_2 = get_LocalLayoutDirection();
      var $composer_3 = $composer_0;
      var layoutDirection = $composer_3.u31(this_2);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.k31($style) | $composer_0.m31(layoutDirection.a1_1));
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = resolveDefaults($style, layoutDirection);
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var resolvedStyle = tmp;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.k31(fontFamilyResolver) | $composer_0.k31(resolvedStyle));
      // Inline function 'kotlin.let' call
      var it_0 = $composer_0.i31();
      var tmp_0;
      if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
        var tmp_1 = resolvedStyle.i82();
        var tmp0_elvis_lhs = resolvedStyle.f82();
        var tmp_2 = tmp0_elvis_lhs == null ? Companion_getInstance_19().b7z_1 : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = resolvedStyle.g82();
        var tmp_3;
        var tmp_4 = tmp1_elvis_lhs;
        if ((tmp_4 == null ? null : new FontStyle(tmp_4)) == null) {
          tmp_3 = Companion_getInstance_32().k7z_1;
        } else {
          tmp_3 = tmp1_elvis_lhs;
        }
        var tmp_5 = tmp_3;
        var tmp2_elvis_lhs = resolvedStyle.h82();
        var tmp_6;
        var tmp_7 = tmp2_elvis_lhs;
        if ((tmp_7 == null ? null : new FontSynthesis(tmp_7)) == null) {
          tmp_6 = Companion_getInstance_35().p7z_1;
        } else {
          tmp_6 = tmp2_elvis_lhs;
        }
        var value_0 = fontFamilyResolver.r84(tmp_1, tmp_2, tmp_5, tmp_6);
        $composer_0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var typeface$delegate = tmp_0;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_1 = $composer_0.i31();
      var tmp_8;
      if (false || it_1 === Companion_getInstance_11().f30_1) {
        var value_1 = new LegacyTextFieldSize(layoutDirection, density, fontFamilyResolver, $style, invoke$lambda_0(typeface$delegate));
        $composer_0.j31(value_1);
        tmp_8 = value_1;
      } else {
        tmp_8 = it_1;
      }
      var minSizeState = tmp_8;
      minSizeState.okq(layoutDirection, density, fontFamilyResolver, resolvedStyle, invoke$lambda_0(typeface$delegate));
      var tmp_9 = Companion_instance_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_0.q31(minSizeState);
      // Inline function 'kotlin.let' call
      var it_2 = $composer_0.i31();
      var tmp_10;
      if (invalid_1 || it_2 === Companion_getInstance_11().f30_1) {
        var value_2 = legacyTextFieldMinSize$lambda$lambda(minSizeState);
        $composer_0.j31(value_2);
        tmp_10 = value_2;
      } else {
        tmp_10 = it_2;
      }
      var tmp$ret$15 = tmp_10;
      var tmp0 = layout(tmp_9, tmp$ret$15);
      $composer_0.n30();
      return tmp0;
    };
  }
  function canReuse(_this__u8e3s4, text, style, placeholders, maxLines, softWrap, overflow, density, layoutDirection, fontFamilyResolver, constraints) {
    var layoutInput = _this__u8e3s4.e80_1;
    if (_this__u8e3s4.f80_1.e7s_1.a7v()) {
      return false;
    }
    if (!(layoutInput.q80_1.equals(text) && layoutInput.r80_1.p81(style) && equals(layoutInput.s80_1, placeholders) && layoutInput.t80_1 === maxLines && layoutInput.u80_1 === softWrap && layoutInput.v80_1 === overflow && equals(layoutInput.w80_1, density) && layoutInput.x80_1.equals(layoutDirection) && equals(layoutInput.y80_1, fontFamilyResolver))) {
      return false;
    }
    if (!(_Constraints___get_minWidth__impl__hi9lfi(constraints) === _Constraints___get_minWidth__impl__hi9lfi(layoutInput.z80_1)))
      return false;
    if (!(softWrap || overflow === Companion_getInstance_39().x7s_1)) {
      return true;
    }
    return _Constraints___get_maxWidth__impl__uuyqc(constraints) === _Constraints___get_maxWidth__impl__uuyqc(layoutInput.z80_1) && _Constraints___get_maxHeight__impl__dt3e8z(constraints) === _Constraints___get_maxHeight__impl__dt3e8z(layoutInput.z80_1);
  }
  function getLineHeight(_this__u8e3s4, offset) {
    var tmp;
    if (offset < 0) {
      tmp = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = _this__u8e3s4.e80_1.q80_1;
      tmp = charSequenceLength(this_0) === 0;
    }
    if (tmp)
      return 0.0;
    var tmp0 = _this__u8e3s4.f80_1.d7u(offset);
    var tmp2 = _this__u8e3s4.f80_1.f7s_1 - 1 | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var c = _this__u8e3s4.f80_1.j7s_1 - 1 | 0;
    var line = Math.min(tmp0, tmp2, c);
    var lineEnd = _this__u8e3s4.f80_1.m7u(line);
    if (offset > lineEnd)
      return 0.0;
    return _this__u8e3s4.f80_1.j7u(line);
  }
  var androidx_compose_foundation_text_TextLayoutResultProxy$stable;
  function coercedInVisibleBoundsOfInputText($this, $receiver) {
    var tmp0_safe_receiver = $this.ik8_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0;
      if (tmp0_safe_receiver.y91()) {
        var tmp0_safe_receiver_0 = $this.jk8_1;
        tmp_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.fai(tmp0_safe_receiver);
      } else {
        tmp_0 = Companion_getInstance_50().j5d_1;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var visibleInnerTextFieldRect = tmp1_elvis_lhs == null ? Companion_getInstance_50().j5d_1 : tmp1_elvis_lhs;
    return coerceIn_3($receiver, visibleInnerTextFieldRect);
  }
  function TextLayoutResultProxy(value, innerTextFieldCoordinates, decorationBoxCoordinates) {
    innerTextFieldCoordinates = innerTextFieldCoordinates === VOID ? null : innerTextFieldCoordinates;
    decorationBoxCoordinates = decorationBoxCoordinates === VOID ? null : decorationBoxCoordinates;
    this.hk8_1 = value;
    this.ik8_1 = innerTextFieldCoordinates;
    this.jk8_1 = decorationBoxCoordinates;
  }
  protoOf(TextLayoutResultProxy).rkq = function (position, coerceInVisibleBounds) {
    var coercedPosition = coerceInVisibleBounds ? coercedInVisibleBoundsOfInputText(this, position) : position;
    var relativePosition = this.skq(coercedPosition);
    return this.hk8_1.s7t(relativePosition);
  };
  protoOf(TextLayoutResultProxy).ekj = function (position, coerceInVisibleBounds, $super) {
    coerceInVisibleBounds = coerceInVisibleBounds === VOID ? true : coerceInVisibleBounds;
    return $super === VOID ? this.rkq(position, coerceInVisibleBounds) : $super.rkq.call(this, new Offset(position), coerceInVisibleBounds);
  };
  protoOf(TextLayoutResultProxy).tkq = function (offset) {
    var visibleOffset = coercedInVisibleBoundsOfInputText(this, offset);
    var relativeOffset = this.skq(visibleOffset);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value = _Offset___get_packedValue__impl__xh2k8q(relativeOffset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    var tmp$ret$0 = floatFromBits(bits);
    var line = this.hk8_1.p7t(tmp$ret$0);
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(relativeOffset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_0, 32));
    if (floatFromBits(bits_0) >= this.hk8_1.e7u(line)) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_1 = _Offset___get_packedValue__impl__xh2k8q(relativeOffset);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(shiftRight(value_1, 32));
      tmp = floatFromBits(bits_1) <= this.hk8_1.g7u(line);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(TextLayoutResultProxy).skq = function (offset) {
    var tmp0_safe_receiver = this.ik8_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (tmp0_safe_receiver.y91()) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return offset;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var innerCoords = tmp_1;
    var tmp2_safe_receiver = this.jk8_1;
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_3;
      if (tmp2_safe_receiver.y91()) {
        tmp_3 = tmp2_safe_receiver;
      } else {
        tmp_3 = null;
      }
      tmp_2 = tmp_3;
    }
    var tmp3_elvis_lhs = tmp_2;
    var tmp_4;
    if (tmp3_elvis_lhs == null) {
      return offset;
    } else {
      tmp_4 = tmp3_elvis_lhs;
    }
    var decorationCoords = tmp_4;
    return innerCoords.q91(decorationCoords, offset);
  };
  protoOf(TextLayoutResultProxy).ukq = function (offset) {
    var tmp0_safe_receiver = this.ik8_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (tmp0_safe_receiver.y91()) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return offset;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var innerCoords = tmp_1;
    var tmp2_safe_receiver = this.jk8_1;
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_3;
      if (tmp2_safe_receiver.y91()) {
        tmp_3 = tmp2_safe_receiver;
      } else {
        tmp_3 = null;
      }
      tmp_2 = tmp_3;
    }
    var tmp3_elvis_lhs = tmp_2;
    var tmp_4;
    if (tmp3_elvis_lhs == null) {
      return offset;
    } else {
      tmp_4 = tmp3_elvis_lhs;
    }
    var decorationCoords = tmp_4;
    return decorationCoords.q91(innerCoords, offset);
  };
  function coerceIn_3(_this__u8e3s4, rect) {
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    if (floatFromBits(bits) < rect.k5d_1) {
      tmp = rect.k5d_1;
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(shiftRight(value_0, 32));
      if (floatFromBits(bits_0) > rect.m5d_1) {
        tmp = rect.m5d_1;
      } else {
        // Inline function 'androidx.compose.ui.geometry.Offset.x' call
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value_1 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_1 = convertToInt(shiftRight(value_1, 32));
        tmp = floatFromBits(bits_1);
      }
    }
    var xOffset = tmp;
    var tmp_0;
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    if (floatFromBits(bits_2) < rect.l5d_1) {
      tmp_0 = rect.l5d_1;
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_3 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_3 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
      if (floatFromBits(bits_3) > rect.n5d_1) {
        tmp_0 = rect.n5d_1;
      } else {
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_4 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
        tmp_0 = floatFromBits(bits_4);
      }
    }
    var yOffset = tmp_0;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(xOffset));
    var v2 = fromInt(toRawBits(yOffset));
    var tmp$ret$25 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$25);
  }
  var androidx_compose_foundation_text_TextLinkScope$stable;
  var androidx_compose_foundation_text_TextRangeLayoutMeasureResult$stable;
  var androidx_compose_foundation_text_TextRangeLayoutMeasureScope$stable;
  var androidx_compose_foundation_text_TextRangeLayoutModifier$stable;
  function textRange($this, $receiver, link) {
    var tmp = TextLinkScope$textRange$lambda($this, link);
    return $receiver.d8v(new TextRangeLayoutModifier(new sam$androidx_compose_foundation_text_TextRangeScopeMeasurePolicy$0(tmp)));
  }
  function clipLink($this, $receiver, link) {
    return graphicsLayer($receiver, TextLinkScope$clipLink$lambda($this, link));
  }
  function shapeForRange($this, link) {
    var tmp0_safe_receiver = pathForRangeInRangeCoordinates($this, link);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new TextLinkScope$shapeForRange$1(tmp0_safe_receiver);
    }
    return tmp;
  }
  function pathForRangeInRangeCoordinates($this, link) {
    var tmp;
    if (!$this.sk0()()) {
      tmp = null;
    } else {
      var tmp0_safe_receiver = $this.xdd();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp0_elvis_lhs = calculateVisibleLinkRange($this, link, tmp0_safe_receiver);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var range = tmp_1;
        var path = tmp0_safe_receiver.u7s(range.n7p_1, range.o7p_1);
        var firstCharBoundingBox = tmp0_safe_receiver.v7t(range.n7p_1);
        var lastCharBoundingBox = tmp0_safe_receiver.v7t(range.o7p_1 - 1 | 0);
        var rangeStartLine = tmp0_safe_receiver.d7u(range.n7p_1);
        var rangeEndLine = tmp0_safe_receiver.d7u(range.o7p_1 - 1 | 0);
        var tmp_2;
        if (rangeStartLine === rangeEndLine) {
          var tmp0 = lastCharBoundingBox.k5d_1;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = firstCharBoundingBox.k5d_1;
          tmp_2 = Math.min(tmp0, b);
        } else {
          tmp_2 = 0.0;
        }
        var xOffset = tmp_2;
        var yOffset = firstCharBoundingBox.l5d_1;
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var v1 = fromInt(toRawBits(xOffset));
        var v2 = fromInt(toRawBits(yOffset));
        var tmp$ret$4 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        // Inline function 'androidx.compose.ui.geometry.Offset.unaryMinus' call
        var this_0 = _Offset___init__impl__c168vi(tmp$ret$4);
        var tmp$ret$5 = _Offset___init__impl__c168vi(bitwiseXor(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(-2147483648, -2147483648)));
        path.a5d(tmp$ret$5);
        return path;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function calculateVisibleLinkRange($this, link, textLayoutResult) {
    var lastOffset = textLayoutResult.n80(textLayoutResult.e7t() - 1 | 0);
    var tmp;
    if (link.n7p_1 < lastOffset) {
      // Inline function 'kotlin.math.min' call
      var a = link.o7p_1;
      var tmp$ret$0 = Math.min(a, lastOffset);
      tmp = link.e7q(VOID, VOID, tmp$ret$0);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function mergeOrUse($this, $receiver, other) {
    var tmp1_elvis_lhs = $receiver == null ? null : $receiver.g7y(other);
    return tmp1_elvis_lhs == null ? other : tmp1_elvis_lhs;
  }
  function handleLink($this, link, uriHandler) {
    if (link instanceof Url) {
      var tmp1_safe_receiver = link.r7r_1;
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        tmp1_safe_receiver.vkq(link);
        tmp = Unit_instance;
      }
      if (tmp == null)
        try {
          uriHandler.qdd(link.p7r_1);
        } catch ($p) {
          if ($p instanceof IllegalArgumentException) {
            var _unused_var__etf5q3 = $p;
          } else {
            throw $p;
          }
        }
    } else {
      if (link instanceof Clickable) {
        var tmp3_safe_receiver = link.x7r_1;
        if (tmp3_safe_receiver == null)
          null;
        else {
          tmp3_safe_receiver.vkq(link);
        }
      }
    }
  }
  function StyleAnnotation($this, keys, block, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-2083052099);
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(block) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31($this) ? 256 : 128);
    $composer_0.o30(-358306546, keys.length);
    $dirty = $dirty | ($composer_0.m31(keys.length) ? 4 : 0);
    var inductionVariable = 0;
    var last = keys.length;
    while (inductionVariable < last) {
      var value = keys[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      $dirty = $dirty | ($composer_0.q31(value) ? 4 : 0);
    }
    $composer_0.p30();
    if (($dirty & 14) === 0)
      $dirty = $dirty | 2;
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.q31($this) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value_0 = TextLinkScope$StyleAnnotation$lambda($this, block);
        tmp0.j31(value_0);
        tmp = value_0;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      DisposableEffect(arrayConcat([[block], keys]), tmp$ret$0, $composer_0, 0);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(TextLinkScope$StyleAnnotation$lambda_0($this, keys, block, $changed));
    }
  }
  function sam$androidx_compose_foundation_text_TextRangeScopeMeasurePolicy$0(function_0) {
    this.wkq_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_text_TextRangeScopeMeasurePolicy$0).hk0 = function (_this__u8e3s4) {
    return this.wkq_1(_this__u8e3s4);
  };
  protoOf(sam$androidx_compose_foundation_text_TextRangeScopeMeasurePolicy$0).q3 = function () {
    return this.wkq_1;
  };
  protoOf(sam$androidx_compose_foundation_text_TextRangeScopeMeasurePolicy$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, TextRangeScopeMeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_text_TextRangeScopeMeasurePolicy$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function TextLinkScope$_get_textLayoutResult_$ref_70shul() {
    return constructCallableReference(function (p0) {
      return p0.xdd();
    }, 1, 0, 344);
  }
  function TextLinkScope$_set_textLayoutResult_$ref_kyv5ux() {
    return constructCallableReference(function (p0, p1) {
      p0.rk0(p1);
      return Unit_instance;
    }, 2, 0, 345);
  }
  function TextLinkScope$lambda(it) {
    var tmp;
    var tmp_0;
    var tmp_1 = it.m7p_1;
    if (tmp_1 instanceof LinkAnnotation) {
      var tmp_2 = it.m7p_1;
      tmp_0 = !isNullOrEmpty((tmp_2 instanceof LinkAnnotation ? tmp_2 : THROW_CCE()).s7r());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp_3 = it.m7p_1;
      var tmp0_safe_receiver = (tmp_3 instanceof LinkAnnotation ? tmp_3 : THROW_CCE()).s7r();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g7x_1;
      tmp = arrayListOf([it, Range_init_$Create$(tmp1_elvis_lhs == null ? SpanStyle_init_$Create$() : tmp1_elvis_lhs, it.n7p_1, it.o7p_1)]);
    } else {
      tmp = arrayListOf([it]);
    }
    return tmp;
  }
  function TextLinkScope$_get_shouldMeasureLinks_$lambda_gbg9cn(this$0) {
    return function () {
      var tmp = this$0.ak0_1;
      var tmp0_safe_receiver = this$0.xdd();
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e80_1;
      return tmp.equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.q80_1);
    };
  }
  function TextLinkScope$textRange$lambda$lambda() {
    return new IntOffset(Companion_getInstance_21().c5g_1);
  }
  function TextLinkScope$textRange$lambda$lambda_0() {
    return new IntOffset(Companion_getInstance_21().c5g_1);
  }
  function TextLinkScope$textRange$lambda$lambda_1($bounds) {
    return function () {
      return new IntOffset($bounds.k5g());
    };
  }
  function TextLinkScope$textRange$lambda(this$0, $link) {
    return function ($this$TextRangeLayoutModifier) {
      var tmp0_elvis_lhs = this$0.xdd();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return $this$TextRangeLayoutModifier.xkq(0, 0, TextLinkScope$textRange$lambda$lambda);
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var layoutResult = tmp;
      var tmp1_elvis_lhs = calculateVisibleLinkRange(this$0, $link, layoutResult);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return $this$TextRangeLayoutModifier.xkq(0, 0, TextLinkScope$textRange$lambda$lambda_0);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var updatedRange = tmp_0;
      var bounds = roundToIntRect(layoutResult.u7s(updatedRange.n7p_1, updatedRange.o7p_1).a6j());
      var tmp_1 = bounds.h5e();
      var tmp_2 = bounds.i5e();
      return $this$TextRangeLayoutModifier.xkq(tmp_1, tmp_2, TextLinkScope$textRange$lambda$lambda_1(bounds));
    };
  }
  function TextLinkScope$clipLink$lambda(this$0, $link) {
    return function ($this$graphicsLayer) {
      var tmp0_safe_receiver = shapeForRange(this$0, $link);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $this$graphicsLayer.l98(tmp0_safe_receiver);
        $this$graphicsLayer.n67(true);
      }
      return Unit_instance;
    };
  }
  function TextLinkScope$shapeForRange$1($it) {
    this.ykq_1 = $it;
  }
  protoOf(TextLinkScope$shapeForRange$1).l6j = function (size, layoutDirection, density) {
    return new Generic(this.ykq_1);
  };
  function TextLinkScope$LinksComposables$lambda($this$semantics) {
    $this$semantics.mbr(SemanticsProperties_getInstance().tbu_1, Unit_instance);
    return Unit_instance;
  }
  function TextLinkScope$LinksComposables$lambda_0(this$0, $range, $uriHandler) {
    return function () {
      handleLink(this$0, $range.m7p_1, $uriHandler);
      return Unit_instance;
    };
  }
  function TextLinkScope$LinksComposables$slambda($linkStateObserver, resultContinuation) {
    this.hkr_1 = $linkStateObserver;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextLinkScope$LinksComposables$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextLinkScope$LinksComposables$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextLinkScope$LinksComposables$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.hkr_1.xkf(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextLinkScope$LinksComposables$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new TextLinkScope$LinksComposables$slambda(this.hkr_1, completion);
    i.ikr_1 = $this$LaunchedEffect;
    return i;
  };
  function TextLinkScope$LinksComposables$slambda_0($linkStateObserver, resultContinuation) {
    var i = new TextLinkScope$LinksComposables$slambda($linkStateObserver, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function TextLinkScope$LinksComposables$lambda_1(this$0, $range, $linkStateObserver) {
    return function ($this$StyleAnnotation) {
      var tmp0_safe_receiver = $range.m7p_1.s7r();
      var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g7x_1;
      var tmp_0;
      if ($linkStateObserver.s9h()) {
        var tmp1_safe_receiver = $range.m7p_1.s7r();
        tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h7x_1;
      } else {
        tmp_0 = null;
      }
      var tmp_1 = mergeOrUse(this$0, tmp, tmp_0);
      var tmp_2;
      if ($linkStateObserver.ykf()) {
        var tmp2_safe_receiver = $range.m7p_1.s7r();
        tmp_2 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.i7x_1;
      } else {
        tmp_2 = null;
      }
      var tmp_3 = mergeOrUse(this$0, tmp_1, tmp_2);
      var tmp_4;
      if ($linkStateObserver.zkf()) {
        var tmp3_safe_receiver = $range.m7p_1.s7r();
        tmp_4 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.j7x_1;
      } else {
        tmp_4 = null;
      }
      var mergedStyle = mergeOrUse(this$0, tmp_3, tmp_4);
      $this$StyleAnnotation.lkr($range, mergedStyle);
      return Unit_instance;
    };
  }
  function TextLinkScope$LinksComposables$lambda_2($tmp0_rcvr, $$changed) {
    return function ($composer, $force) {
      $tmp0_rcvr.ck0($composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function TextLinkScope$StyleAnnotation$$inlined$cache$1$1(this$0, $block) {
    this.mkr_1 = this$0;
    this.nkr_1 = $block;
  }
  protoOf(TextLinkScope$StyleAnnotation$$inlined$cache$1$1).s1d = function () {
    var tmp0 = this.mkr_1.bk0_1;
    // Inline function 'kotlin.collections.minusAssign' call
    var element = this.nkr_1;
    tmp0.d3(element);
  };
  function TextLinkScope$StyleAnnotation$lambda(this$0, $block) {
    return function ($this$DisposableEffect) {
      var tmp0 = this$0.bk0_1;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = $block;
      tmp0.j1(element);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new TextLinkScope$StyleAnnotation$$inlined$cache$1$1(this$0, $block);
    };
  }
  function TextLinkScope$StyleAnnotation$lambda_0($tmp0_rcvr, $keys, $block, $$changed) {
    return function ($composer, $force) {
      StyleAnnotation($tmp0_rcvr, $keys, $block, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function TextLinkScope(initialText) {
    this.yjz_1 = initialText;
    this.zjz_1 = mutableStateOf(null);
    var tmp = this;
    tmp.ak0_1 = this.yjz_1.c7r(TextLinkScope$lambda);
    this.bk0_1 = mutableStateListOf();
  }
  protoOf(TextLinkScope).rk0 = function (_set____db54di) {
    var tmp0 = this.zjz_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextLinkScope$_get_textLayoutResult_$ref_70shul();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('textLayoutResult', 1, tmp, tmp_0, TextLinkScope$_set_textLayoutResult_$ref_kyv5ux());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(TextLinkScope).xdd = function () {
    var tmp0 = this.zjz_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextLinkScope$_get_textLayoutResult_$ref_70shul();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('textLayoutResult', 1, tmp, tmp_0, TextLinkScope$_set_textLayoutResult_$ref_kyv5ux());
    return tmp0.u1();
  };
  protoOf(TextLinkScope).sk0 = function () {
    return TextLinkScope$_get_shouldMeasureLinks_$lambda_gbg9cn(this);
  };
  protoOf(TextLinkScope).ck0 = function ($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1154651354);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(this) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      var tmp0 = get_LocalUriHandler();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var uriHandler = $composer_1.u31(tmp0);
      var links = this.ak0_1.y7q(0, this.ak0_1.a());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = links.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = links.l1(index);
          if (!(item.n7p_1 === item.o7p_1)) {
            $composer_0.m30(725478935);
            // Inline function 'androidx.compose.runtime.cache' call
            var this_0 = $composer_0;
            // Inline function 'kotlin.let' call
            var it = this_0.i31();
            var tmp;
            if (false || it === Companion_getInstance_11().f30_1) {
              var value = funMutableInteractionSource();
              this_0.j31(value);
              tmp = value;
            } else {
              tmp = it;
            }
            var interactionSource = tmp;
            var tmp_0 = clipLink(this, Companion_instance_0, item);
            // Inline function 'androidx.compose.runtime.cache' call
            var this_1 = $composer_0;
            // Inline function 'kotlin.let' call
            var it_0 = this_1.i31();
            var tmp_1;
            if (false || it_0 === Companion_getInstance_11().f30_1) {
              var value_0 = TextLinkScope$LinksComposables$lambda;
              this_1.j31(value_0);
              tmp_1 = value_0;
            } else {
              tmp_1 = it_0;
            }
            var tmp$ret$7 = tmp_1;
            var tmp_2 = pointerHoverIcon(hoverable(textRange(this, semantics(tmp_0, VOID, tmp$ret$7), item), interactionSource), Companion_getInstance_49().da3_1);
            var tmp0_0 = $composer_0;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid = !!(!!($composer_0.q31(this) | $composer_0.k31(item)) | $composer_0.q31(uriHandler));
            // Inline function 'kotlin.let' call
            var it_1 = tmp0_0.i31();
            var tmp_3;
            if (invalid || it_1 === Companion_getInstance_11().f30_1) {
              var value_1 = TextLinkScope$LinksComposables$lambda_0(this, item, uriHandler);
              tmp0_0.j31(value_1);
              tmp_3 = value_1;
            } else {
              tmp_3 = it_1;
            }
            var tmp$ret$11 = tmp_3;
            Box(combinedClickable(tmp_2, interactionSource, null, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$11), $composer_0, 0);
            if (!isNullOrEmpty(item.m7p_1.s7r())) {
              $composer_0.m30(726303039);
              // Inline function 'androidx.compose.runtime.cache' call
              var this_2 = $composer_0;
              // Inline function 'kotlin.let' call
              var it_2 = this_2.i31();
              var tmp_4;
              if (false || it_2 === Companion_getInstance_11().f30_1) {
                var value_2 = new LinkStateInteractionSourceObserver(interactionSource);
                this_2.j31(value_2);
                tmp_4 = value_2;
              } else {
                tmp_4 = it_2;
              }
              var linkStateObserver = tmp_4;
              // Inline function 'androidx.compose.runtime.cache' call
              var this_3 = $composer_0;
              // Inline function 'kotlin.let' call
              var it_3 = this_3.i31();
              var tmp_5;
              if (false || it_3 === Companion_getInstance_11().f30_1) {
                var value_3 = TextLinkScope$LinksComposables$slambda_0(linkStateObserver, null);
                this_3.j31(value_3);
                tmp_5 = value_3;
              } else {
                tmp_5 = it_3;
              }
              var tmp$ret$19 = tmp_5;
              LaunchedEffect(Unit_instance, tmp$ret$19, $composer_0, 6);
              var tmp_6 = linkStateObserver.ykf();
              var tmp_7 = linkStateObserver.s9h();
              var tmp_8 = linkStateObserver.zkf();
              var tmp0_safe_receiver = item.m7p_1.s7r();
              var tmp_9 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g7x_1;
              var tmp1_safe_receiver = item.m7p_1.s7r();
              var tmp_10 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h7x_1;
              var tmp2_safe_receiver = item.m7p_1.s7r();
              var tmp_11 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.i7x_1;
              var tmp3_safe_receiver = item.m7p_1.s7r();
              var tmp_12 = [tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.j7x_1];
              var tmp0_1 = $composer_0;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_0 = !!($composer_0.q31(this) | $composer_0.k31(item));
              // Inline function 'kotlin.let' call
              var it_4 = tmp0_1.i31();
              var tmp_13;
              if (invalid_0 || it_4 === Companion_getInstance_11().f30_1) {
                var value_4 = TextLinkScope$LinksComposables$lambda_1(this, item, linkStateObserver);
                tmp0_1.j31(value_4);
                tmp_13 = value_4;
              } else {
                tmp_13 = it_4;
              }
              var tmp$ret$23 = tmp_13;
              StyleAnnotation(this, tmp_12, tmp$ret$23, $composer_0, 896 & $dirty << 6);
              $composer_0.n30();
            } else {
              $composer_0.m30(728331710);
              $composer_0.n30();
            }
            $composer_0.n30();
          } else {
            $composer_0.m30(728345598);
            $composer_0.n30();
          }
        }
         while (inductionVariable <= last);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver_0 = $composer_0.t30();
    if (tmp1_safe_receiver_0 == null)
      null;
    else {
      tmp1_safe_receiver_0.p3c(TextLinkScope$LinksComposables$lambda_2(this, $changed));
    }
  };
  protoOf(TextLinkScope).qk0 = function () {
    var tmp;
    if (this.bk0_1.r()) {
      tmp = this.ak0_1;
    } else {
      var scope = new TextAnnotatorScope(this.ak0_1);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = this.bk0_1;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item(scope);
        }
         while (inductionVariable <= last);
      tmp = scope.kkr_1;
    }
    var styledText = tmp;
    this.ak0_1 = styledText;
    return styledText;
  };
  function TextRangeLayoutModifier(measurePolicy) {
    this.gk0_1 = measurePolicy;
  }
  protoOf(TextRangeLayoutModifier).aaj = function (_this__u8e3s4, parentData) {
    return this;
  };
  function TextRangeLayoutMeasureScope() {
  }
  protoOf(TextRangeLayoutMeasureScope).xkq = function (width, height, place) {
    return new TextRangeLayoutMeasureResult(width, height, place);
  };
  function TextRangeScopeMeasurePolicy() {
  }
  function TextRangeLayoutMeasureResult(width, height, place) {
    this.ik0_1 = width;
    this.jk0_1 = height;
    this.kk0_1 = place;
  }
  function isNullOrEmpty(_this__u8e3s4) {
    return _this__u8e3s4 == null || (_this__u8e3s4.g7x_1 == null && _this__u8e3s4.h7x_1 == null && _this__u8e3s4.i7x_1 == null && _this__u8e3s4.j7x_1 == null);
  }
  function TextAnnotatorScope$replaceStyle$lambda($linkFound, $linkRange, $newStyle) {
    return function (it) {
      var tmp;
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if ($linkFound._v) {
        var tmp_3 = it.m7p_1;
        tmp_2 = tmp_3 instanceof SpanStyle;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = it.n7p_1 === $linkRange.n7p_1;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = it.o7p_1 === $linkRange.o7p_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp0_elvis_lhs = $newStyle;
        tmp = Range_init_$Create$(tmp0_elvis_lhs == null ? SpanStyle_init_$Create$() : tmp0_elvis_lhs, it.n7p_1, it.o7p_1);
      } else {
        tmp = it;
      }
      var annotation = tmp;
      $linkFound._v = $linkRange.equals(it);
      return annotation;
    };
  }
  function TextAnnotatorScope(initialText) {
    this.jkr_1 = initialText;
    this.kkr_1 = this.jkr_1;
  }
  protoOf(TextAnnotatorScope).lkr = function (linkRange, newStyle) {
    var linkFound = {_v: false};
    var tmp = this;
    tmp.kkr_1 = this.jkr_1.b7r(TextAnnotatorScope$replaceStyle$lambda(linkFound, linkRange, newStyle));
  };
  var SNAPSHOTS_INTERVAL_MILLIS;
  var androidx_compose_foundation_text_UndoManager$stable;
  function Entry(next, value) {
    next = next === VOID ? null : next;
    this.okr_1 = next;
    this.pkr_1 = value;
  }
  function removeLastUndo($this) {
    var entry = $this.fk6_1;
    var tmp0_safe_receiver = entry;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.okr_1) == null)
      return Unit_instance;
    $l$loop: while (true) {
      var tmp1_safe_receiver = entry;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.okr_1;
      if (!!((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.okr_1) == null)) {
        break $l$loop;
      }
      entry = entry.okr_1;
    }
    var tmp3_safe_receiver = entry;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.okr_1 = null;
    }
  }
  function UndoManager(maxStoredCharacters) {
    maxStoredCharacters = maxStoredCharacters === VOID ? 100000 : maxStoredCharacters;
    this.ek6_1 = maxStoredCharacters;
    this.fk6_1 = null;
    this.gk6_1 = null;
    this.hk6_1 = 0;
    this.ik6_1 = null;
    this.jk6_1 = false;
  }
  protoOf(UndoManager).qkr = function (value, now) {
    var tmp;
    if (this.jk6_1) {
      tmp = true;
    } else {
      var tmp0_elvis_lhs = this.ik6_1;
      var tmp0 = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
      // Inline function 'kotlin.Long.plus' call
      var other = SNAPSHOTS_INTERVAL_MILLIS;
      var tmp$ret$0 = add(tmp0, fromInt(other));
      tmp = compare(now, tmp$ret$0) > 0;
    }
    if (tmp) {
      this.ik6_1 = now;
      this.nkl(value);
    }
  };
  protoOf(UndoManager).kk6 = function (value, now, $super) {
    now = now === VOID ? timeNowMillis() : now;
    var tmp;
    if ($super === VOID) {
      this.qkr(value, now);
      tmp = Unit_instance;
    } else {
      tmp = $super.qkr.call(this, value, now);
    }
    return tmp;
  };
  protoOf(UndoManager).tkl = function () {
    this.jk6_1 = true;
  };
  protoOf(UndoManager).nkl = function (value) {
    this.jk6_1 = false;
    var tmp0_safe_receiver = this.fk6_1;
    if (value.equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pkr_1)) {
      return Unit_instance;
    } else {
      var tmp = value.h89();
      var tmp2_safe_receiver = this.fk6_1;
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.pkr_1;
      if (tmp === (tmp3_safe_receiver == null ? null : tmp3_safe_receiver.h89())) {
        var tmp1_safe_receiver = this.fk6_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.pkr_1 = value;
        }
        return Unit_instance;
      }
    }
    var tmp_0 = this;
    var tmp4_next = this.fk6_1;
    tmp_0.fk6_1 = new Entry(tmp4_next, value);
    this.gk6_1 = null;
    this.hk6_1 = this.hk6_1 + value.h89().length | 0;
    if (this.hk6_1 > this.ek6_1) {
      removeLastUndo(this);
    }
  };
  protoOf(UndoManager).okl = function () {
    var tmp0_safe_receiver = this.fk6_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.okr_1;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        this.fk6_1 = tmp0_safe_receiver_0;
        this.hk6_1 = this.hk6_1 - tmp0_safe_receiver.pkr_1.h89().length | 0;
        var tmp_1 = this;
        var tmp0_value = tmp0_safe_receiver.pkr_1;
        var tmp1_next = this.gk6_1;
        tmp_1.gk6_1 = new Entry(tmp1_next, tmp0_value);
        tmp_0 = tmp0_safe_receiver_0.pkr_1;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(UndoManager).pkl = function () {
    var tmp0_safe_receiver = this.gk6_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      this.gk6_1 = tmp0_safe_receiver.okr_1;
      var tmp_0 = this;
      var tmp0_value = tmp0_safe_receiver.pkr_1;
      var tmp1_next = this.fk6_1;
      tmp_0.fk6_1 = new Entry(tmp1_next, tmp0_value);
      this.hk6_1 = this.hk6_1 + tmp0_safe_receiver.pkr_1.h89().length | 0;
      tmp = tmp0_safe_receiver.pkr_1;
    }
    return tmp;
  };
  function get_ValidatingEmptyOffsetMappingIdentity() {
    _init_properties_ValidatingOffsetMapping_kt__fcd8ty();
    return ValidatingEmptyOffsetMappingIdentity;
  }
  var ValidatingEmptyOffsetMappingIdentity;
  function filterWithValidation(_this__u8e3s4, text) {
    _init_properties_ValidatingOffsetMapping_kt__fcd8ty();
    var delegate = _this__u8e3s4.n8d(text);
    throwIfNotValidTransform(delegate, text.a());
    return new TransformedText(delegate.p8d_1, new ValidatingOffsetMapping(delegate.q8d_1, text.a(), delegate.p8d_1.a()));
  }
  function ValidatingOffsetMapping(delegate, originalLength, transformedLength) {
    this.rkr_1 = delegate;
    this.skr_1 = originalLength;
    this.tkr_1 = transformedLength;
  }
  protoOf(ValidatingOffsetMapping).o8c = function (offset) {
    // Inline function 'kotlin.also' call
    var this_0 = this.rkr_1.o8c(offset);
    if (0 <= offset ? offset <= this.skr_1 : false) {
      validateOriginalToTransformed(this_0, this.tkr_1, offset);
    }
    return this_0;
  };
  protoOf(ValidatingOffsetMapping).p8c = function (offset) {
    // Inline function 'kotlin.also' call
    var this_0 = this.rkr_1.p8c(offset);
    if (0 <= offset ? offset <= this.tkr_1 : false) {
      validateTransformedToOriginal(this_0, this.skr_1, offset);
    }
    return this_0;
  };
  function throwIfNotValidTransform(_this__u8e3s4, originalLength, limit) {
    limit = limit === VOID ? 100 : limit;
    _init_properties_ValidatingOffsetMapping_kt__fcd8ty();
    var transformedLength = _this__u8e3s4.p8d_1.a();
    var inductionVariable = 0;
    // Inline function 'kotlin.math.min' call
    var last = Math.min(originalLength, limit);
    if (inductionVariable < last)
      do {
        var offset = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var transformedOffset = _this__u8e3s4.q8d_1.o8c(offset);
        validateOriginalToTransformed(transformedOffset, transformedLength, offset);
      }
       while (inductionVariable < last);
    var transformedOffset_0 = _this__u8e3s4.q8d_1.o8c(originalLength);
    validateOriginalToTransformed(transformedOffset_0, transformedLength, originalLength);
    var inductionVariable_0 = 0;
    // Inline function 'kotlin.math.min' call
    var last_0 = Math.min(transformedLength, limit);
    if (inductionVariable_0 < last_0)
      do {
        var offset_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var originalOffset = _this__u8e3s4.q8d_1.p8c(offset_0);
        validateTransformedToOriginal(originalOffset, originalLength, offset_0);
      }
       while (inductionVariable_0 < last_0);
    var originalOffset_0 = _this__u8e3s4.q8d_1.p8c(transformedLength);
    validateTransformedToOriginal(originalOffset_0, originalLength, transformedLength);
  }
  function validateOriginalToTransformed(transformedOffset, transformedLength, offset) {
    _init_properties_ValidatingOffsetMapping_kt__fcd8ty();
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(0 <= transformedOffset ? transformedOffset <= transformedLength : false)) {
      var tmp$ret$1 = 'OffsetMapping.originalToTransformed returned invalid mapping: ' + ('' + offset + ' -> ' + transformedOffset + ' is not in range of transformed text ') + ('[0, ' + transformedLength + ']');
      throwIllegalStateException(tmp$ret$1);
    }
  }
  function validateTransformedToOriginal(originalOffset, originalLength, offset) {
    _init_properties_ValidatingOffsetMapping_kt__fcd8ty();
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(0 <= originalOffset ? originalOffset <= originalLength : false)) {
      var tmp$ret$1 = 'OffsetMapping.transformedToOriginal returned invalid mapping: ' + ('' + offset + ' -> ' + originalOffset + ' is not in range of original text ') + ('[0, ' + originalLength + ']');
      throwIllegalStateException(tmp$ret$1);
    }
  }
  var properties_initialized_ValidatingOffsetMapping_kt_rllilk;
  function _init_properties_ValidatingOffsetMapping_kt__fcd8ty() {
    if (!properties_initialized_ValidatingOffsetMapping_kt_rllilk) {
      properties_initialized_ValidatingOffsetMapping_kt_rllilk = true;
      ValidatingEmptyOffsetMappingIdentity = new ValidatingOffsetMapping(Companion_getInstance_48().q8c_1, 0, 0);
    }
  }
  var androidx_compose_foundation_text_contextmenu_builder_TextContextMenuBuilderScope$stable;
  function TextContextMenuBuilderScope() {
    var tmp = this;
    // Inline function 'androidx.collection.mutableObjectListOf' call
    tmp.ukr_1 = new MutableObjectList();
    var tmp_0 = this;
    // Inline function 'androidx.collection.mutableObjectListOf' call
    tmp_0.vkr_1 = new MutableObjectList();
  }
  protoOf(TextContextMenuBuilderScope).wkr = function () {
    // Inline function 'androidx.collection.mutableObjectListOf' call
    var resultList = new MutableObjectList();
    var headIsSeparator = true;
    var previous = null;
    // Inline function 'androidx.collection.ObjectList.forEach' call
    var this_0 = this.ukr_1;
    // Inline function 'kotlin.contracts.contract' call
    var content = this_0.sz_1;
    var inductionVariable = 0;
    var last = this_0.tz_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0 = content[i];
        $l$block_2: {
          if (headIsSeparator && tmp0 === TextContextMenuSeparator_getInstance()) {
            break $l$block_2;
          }
          headIsSeparator = false;
          if (get_isSeparator(tmp0) && get_isSeparator(previous)) {
            break $l$block_2;
          }
          var tmp;
          if (!get_isSeparator(tmp0)) {
            var tmp0_0 = this.vkr_1;
            var tmp$ret$4;
            $l$block_1: {
              // Inline function 'androidx.collection.ObjectList.any' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'androidx.collection.ObjectList.forEach' call
              // Inline function 'kotlin.contracts.contract' call
              var content_0 = tmp0_0.sz_1;
              var inductionVariable_0 = 0;
              var last_0 = tmp0_0.tz_1;
              if (inductionVariable_0 < last_0)
                do {
                  var i_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  if (!content_0[i_0](tmp0)) {
                    tmp$ret$4 = true;
                    break $l$block_1;
                  }
                }
                 while (inductionVariable_0 < last_0);
              tmp$ret$4 = false;
            }
            tmp = tmp$ret$4;
          } else {
            tmp = false;
          }
          if (tmp) {
            break $l$block_2;
          }
          // Inline function 'androidx.collection.MutableObjectList.plusAssign' call
          resultList.j1(tmp0);
          previous = tmp0;
        }
      }
       while (inductionVariable < last);
    // Inline function 'androidx.collection.ObjectList.lastOrNull' call
    var tmp_0;
    if (resultList.r()) {
      tmp_0 = null;
    } else {
      var tmp_1 = resultList.sz_1;
      // Inline function 'androidx.collection.ObjectList.lastIndex' call
      tmp_0 = tmp_1[resultList.tz_1 - 1 | 0];
    }
    var tmp$ret$11 = tmp_0;
    if (get_isSeparator(tmp$ret$11)) {
      // Inline function 'androidx.collection.ObjectList.lastIndex' call
      var tmp$ret$13 = resultList.tz_1 - 1 | 0;
      resultList.h3(tmp$ret$13);
    }
    return new TextContextMenuData(resultList.p10());
  };
  protoOf(TextContextMenuBuilderScope).xkr = function (filter) {
    // Inline function 'androidx.collection.MutableObjectList.plusAssign' call
    this.vkr_1.j1(filter);
  };
  protoOf(TextContextMenuBuilderScope).ykr = function (component) {
    // Inline function 'androidx.collection.MutableObjectList.plusAssign' call
    this.ukr_1.j1(component);
  };
  protoOf(TextContextMenuBuilderScope).zkr = function () {
    var tmp0 = this.ukr_1;
    // Inline function 'androidx.collection.MutableObjectList.plusAssign' call
    var element = TextContextMenuSeparator_getInstance();
    tmp0.j1(element);
  };
  function get_isSeparator(_this__u8e3s4) {
    return _this__u8e3s4 === TextContextMenuSeparator_getInstance();
  }
  function TextContextMenuBuilderScope$addFilter$ref(p0) {
    return constructCallableReference(function (p0_0) {
      p0.xkr(p0_0);
      return Unit_instance;
    }, 1, 0, 346, 'addFilter', [p0]);
  }
  var androidx_compose_foundation_text_contextmenu_data_TextContextMenuData$stable;
  var androidx_compose_foundation_text_contextmenu_data_TextContextMenuComponent$stable;
  var androidx_compose_foundation_text_contextmenu_data_TextContextMenuSeparator$stable;
  var androidx_compose_foundation_text_contextmenu_data_TextContextMenuKeys$stable;
  function Companion_21() {
    Companion_instance_31 = this;
    this.aks_1 = new TextContextMenuData(emptyList());
  }
  var Companion_instance_31;
  function Companion_getInstance_80() {
    if (Companion_instance_31 == null)
      new Companion_21();
    return Companion_instance_31;
  }
  function TextContextMenuData(components) {
    Companion_getInstance_80();
    this.bks_1 = components;
  }
  protoOf(TextContextMenuData).toString = function () {
    var componentsStr = fastJoinToString(this.bks_1, '\n\t', '[\n\t', '\n]');
    return 'TextContextMenuData(components=' + componentsStr + ')';
  };
  function TextContextMenuComponent(key) {
    this.cks_1 = key;
  }
  function TextContextMenuKeys() {
    TextContextMenuKeys_instance = this;
    this.wk2_1 = new Object();
    this.xk2_1 = new Object();
    this.yk2_1 = new Object();
    this.zk2_1 = new Object();
    this.ak3_1 = new Object();
  }
  var TextContextMenuKeys_instance;
  function TextContextMenuKeys_getInstance() {
    if (TextContextMenuKeys_instance == null)
      new TextContextMenuKeys();
    return TextContextMenuKeys_instance;
  }
  function TextContextMenuSeparator() {
    TextContextMenuSeparator_instance = this;
    TextContextMenuComponent.call(this, new Object());
  }
  var TextContextMenuSeparator_instance;
  function TextContextMenuSeparator_getInstance() {
    if (TextContextMenuSeparator_instance == null)
      new TextContextMenuSeparator();
    return TextContextMenuSeparator_instance;
  }
  function TextContextMenuSession$close$ref(p0) {
    return constructCallableReference(function () {
      p0.j4();
      return Unit_instance;
    }, 0, 0, 347, 'close', [p0]);
  }
  function onRightClickDown(_this__u8e3s4, onDown, $completion) {
    return awaitEachGesture(_this__u8e3s4, onRightClickDown$slambda_0(onDown, null), $completion);
  }
  function awaitFirstRightClickDown(_this__u8e3s4, $completion) {
    var tmp = new $awaitFirstRightClickDownCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function onRightClickDown$slambda($onDown, resultContinuation) {
    this.uks_1 = $onDown;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(onRightClickDown$slambda).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(onRightClickDown$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(onRightClickDown$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = awaitFirstRightClickDown(this.vks_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var down = suspendResult;
            down.ra2();
            this.uks_1(new Offset(down.ka0_1));
            this.n9_1 = 2;
            suspendResult = waitForUpOrCancellation(this.vks_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.ra2();
            }

            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(onRightClickDown$slambda).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new onRightClickDown$slambda(this.uks_1, completion);
    i.vks_1 = $this$awaitEachGesture;
    return i;
  };
  function onRightClickDown$slambda_0($onDown, resultContinuation) {
    var i = new onRightClickDown$slambda($onDown, resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  function $awaitFirstRightClickDownCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lks_1 = _this__u8e3s4;
  }
  protoOf($awaitFirstRightClickDownCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = this.lks_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var event = suspendResult;
            var tmp_0;
            if (get_isSecondaryPressed(event.da0_1)) {
              var tmp0 = event.ca0_1;
              var tmp$ret$0;
              l$ret$1: do {
                var inductionVariable = 0;
                var last = tmp0.n1() - 1 | 0;
                if (inductionVariable <= last)
                  do {
                    var index = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    var item = tmp0.l1(index);
                    if (!changedToDown(item)) {
                      tmp$ret$0 = false;
                      break l$ret$1;
                    }
                  }
                   while (inductionVariable <= last);
                tmp$ret$0 = true;
              }
               while (false);
              tmp_0 = tmp$ret$0;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              return event.ca0_1.l1(0);
            }

            this.n9_1 = 1;
            continue $sm;
          case 3:
            throw this.q9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function showTextContextMenuOnSecondaryClick(_this__u8e3s4, onPreShowContextMenu) {
    onPreShowContextMenu = onPreShowContextMenu === VOID ? null : onPreShowContextMenu;
    return _this__u8e3s4.d8v(new TextContextMenuGestureElement(onPreShowContextMenu));
  }
  function TextContextMenuGestureElement(onPreShowContextMenu) {
    ModifierNodeElement.call(this);
    this.xks_1 = onPreShowContextMenu;
  }
  protoOf(TextContextMenuGestureElement).r3d = function () {
    return new TextContextMenuGestureNode(this.xks_1);
  };
  protoOf(TextContextMenuGestureElement).yks = function (node) {
    node.rkt(this.xks_1);
  };
  protoOf(TextContextMenuGestureElement).d8y = function (node) {
    return this.yks(node instanceof TextContextMenuGestureNode ? node : THROW_CCE());
  };
  protoOf(TextContextMenuGestureElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextContextMenuGestureElement))
      return false;
    if (!(this.xks_1 === other.xks_1))
      return false;
    return true;
  };
  protoOf(TextContextMenuGestureElement).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.xks_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  function TextContextMenuGestureNode$tryShowContextMenu$ref(p0) {
    return constructCallableReference(function (p0_0) {
      var tmp0 = p0;
      tryShowContextMenu(tmp0, p0_0.e5d_1);
      return Unit_instance;
    }, 1, 0, 348, 'tryShowContextMenu', [p0]);
  }
  function Companion_22() {
    this.skt_1 = 'Tried to open context menu before the anchor was placed.';
  }
  var Companion_instance_32;
  function Companion_getInstance_81() {
    return Companion_instance_32;
  }
  function _set_localCoordinates__oaim61($this, _set____db54di) {
    var tmp0 = $this.qkt_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextContextMenuGestureNode$_get_localCoordinates_$ref_p943gc();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('localCoordinates', 1, tmp, tmp_0, TextContextMenuGestureNode$_set_localCoordinates_$ref_bb1fg0());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_localCoordinates__4slmwr($this) {
    var tmp0 = $this.qkt_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextContextMenuGestureNode$_get_localCoordinates_$ref_p943gc();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('localCoordinates', 1, tmp, tmp_0, TextContextMenuGestureNode$_set_localCoordinates_$ref_bb1fg0());
    return tmp0.u1();
  }
  function tryShowContextMenu($this, localClickOffset) {
    var tmp0_elvis_lhs = currentValueOf($this, get_LocalTextContextMenuDropdownProvider());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var provider = tmp;
    var dataProvider = new ClickTextContextMenuDataProvider($this, localClickOffset);
    var tmp_0 = $this.a8w();
    launch(tmp_0, VOID, VOID, TextContextMenuGestureNode$tryShowContextMenu$slambda_0($this, localClickOffset, provider, dataProvider, null));
  }
  function ClickTextContextMenuDataProvider($outer, localClickOffset) {
    this.ukt_1 = $outer;
    this.tkt_1 = localClickOffset;
  }
  protoOf(ClickTextContextMenuDataProvider).vkt = function (destinationCoordinates) {
    // Inline function 'androidx.compose.foundation.internal.checkPreconditionNotNull' call
    var value = _get_localCoordinates__4slmwr(this.ukt_1);
    if (value == null) {
      var tmp$ret$1 = 'Tried to open context menu before the anchor was placed.';
      throwIllegalStateExceptionForNullCheck(tmp$ret$1);
    }
    var localCoordinates = value;
    return destinationCoordinates.q91(localCoordinates, this.tkt_1);
  };
  protoOf(ClickTextContextMenuDataProvider).wkt = function () {
    return collectTextContextMenuData(this.ukt_1);
  };
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5(function_0) {
    this.xkt_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5).ka7 = function (_this__u8e3s4, $completion) {
    return this.xkt_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5).q3 = function () {
    return this.xkt_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5).hashCode = function () {
    return hashCode(this.q3());
  };
  function TextContextMenuGestureNode$_get_localCoordinates_$ref_p943gc() {
    return constructCallableReference(function (p0) {
      return _get_localCoordinates__4slmwr(p0);
    }, 1, 0, 349);
  }
  function TextContextMenuGestureNode$_set_localCoordinates_$ref_bb1fg0() {
    return constructCallableReference(function (p0, p1) {
      _set_localCoordinates__oaim61(p0, p1);
      return Unit_instance;
    }, 2, 0, 350);
  }
  function TextContextMenuGestureNode$slambda(this$0, resultContinuation) {
    this.gku_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextContextMenuGestureNode$slambda).vc6 = function ($this$SuspendingPointerInputModifierNode, $completion) {
    var tmp = this.wc6($this$SuspendingPointerInputModifierNode, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextContextMenuGestureNode$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextContextMenuGestureNode$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = onRightClickDown(this.hku_1, TextContextMenuGestureNode$tryShowContextMenu$ref(this.gku_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextContextMenuGestureNode$slambda).wc6 = function ($this$SuspendingPointerInputModifierNode, completion) {
    var i = new TextContextMenuGestureNode$slambda(this.gku_1, completion);
    i.hku_1 = $this$SuspendingPointerInputModifierNode;
    return i;
  };
  function TextContextMenuGestureNode$slambda_0(this$0, resultContinuation) {
    var i = new TextContextMenuGestureNode$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$SuspendingPointerInputModifierNode, $completion) {
      return i.vc6($this$SuspendingPointerInputModifierNode, $completion);
    }, 1);
  }
  function TextContextMenuGestureNode$tryShowContextMenu$slambda(this$0, $localClickOffset, $provider, $dataProvider, resultContinuation) {
    this.qku_1 = this$0;
    this.rku_1 = $localClickOffset;
    this.sku_1 = $provider;
    this.tku_1 = $dataProvider;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextContextMenuGestureNode$tryShowContextMenu$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextContextMenuGestureNode$tryShowContextMenu$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextContextMenuGestureNode$tryShowContextMenu$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0_safe_receiver = this.qku_1.pkt_1;
            if (tmp0_safe_receiver == null) {
              this.vku_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = tmp0_safe_receiver(new Offset(this.rku_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            tmp_0.vku_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.sku_1.wku(this.tku_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextContextMenuGestureNode$tryShowContextMenu$slambda).q24 = function ($this$launch, completion) {
    var i = new TextContextMenuGestureNode$tryShowContextMenu$slambda(this.qku_1, this.rku_1, this.sku_1, this.tku_1, completion);
    i.uku_1 = $this$launch;
    return i;
  };
  function TextContextMenuGestureNode$tryShowContextMenu$slambda_0(this$0, $localClickOffset, $provider, $dataProvider, resultContinuation) {
    var i = new TextContextMenuGestureNode$tryShowContextMenu$slambda(this$0, $localClickOffset, $provider, $dataProvider, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TextContextMenuGestureNode(onPreShowContextMenu) {
    DelegatingNode.call(this);
    this.pkt_1 = onPreShowContextMenu;
    this.qkt_1 = mutableStateOf(null, neverEqualPolicy());
    var tmp = TextContextMenuGestureNode$slambda_0(this, null);
    this.tb1(SuspendingPointerInputModifierNode(new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5(tmp)));
  }
  protoOf(TextContextMenuGestureNode).rkt = function (onPreShowContextMenu) {
    this.pkt_1 = onPreShowContextMenu;
  };
  protoOf(TextContextMenuGestureNode).eam = function (coordinates) {
    _set_localCoordinates__oaim61(this, coordinates);
  };
  var androidx_compose_foundation_text_contextmenu_modifier_AddTextContextMenuDataComponentsNode$stable;
  function collectTextContextMenuData(_this__u8e3s4) {
    // Inline function 'kotlin.apply' call
    var this_0 = new TextContextMenuBuilderScope();
    var tmp = TextContextMenuBuilderScope$addFilter$ref(this_0);
    traverseTextContextMenuDataNodes(_this__u8e3s4, tmp, collectTextContextMenuData$lambda(this_0));
    return this_0.wkr();
  }
  function appendTextContextMenuComponents(_this__u8e3s4, builder) {
    return _this__u8e3s4.d8v(new AddTextContextMenuDataComponentsElement(builder));
  }
  function traverseTextContextMenuDataNodes(_this__u8e3s4, filterBlock, builderBlock) {
    var tmp = TextContextMenuDataTraverseKey_instance;
    traverseAncestors(_this__u8e3s4, tmp, traverseTextContextMenuDataNodes$lambda(builderBlock, filterBlock));
  }
  function AddTextContextMenuDataComponentsElement(builder) {
    ModifierNodeElement.call(this);
    this.yku_1 = builder;
  }
  protoOf(AddTextContextMenuDataComponentsElement).r3d = function () {
    return new AddTextContextMenuDataComponentsNode(this.yku_1);
  };
  protoOf(AddTextContextMenuDataComponentsElement).zku = function (node) {
    node.okv_1 = this.yku_1;
  };
  protoOf(AddTextContextMenuDataComponentsElement).d8y = function (node) {
    return this.zku(node instanceof AddTextContextMenuDataComponentsNode ? node : THROW_CCE());
  };
  protoOf(AddTextContextMenuDataComponentsElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddTextContextMenuDataComponentsElement))
      return false;
    if (!(this.yku_1 === other.yku_1))
      return false;
    return true;
  };
  protoOf(AddTextContextMenuDataComponentsElement).hashCode = function () {
    return hashCode(this.yku_1);
  };
  function TextContextMenuDataTraverseKey() {
  }
  protoOf(TextContextMenuDataTraverseKey).toString = function () {
    return 'TextContextMenuDataTraverseKey';
  };
  protoOf(TextContextMenuDataTraverseKey).hashCode = function () {
    return -858256270;
  };
  protoOf(TextContextMenuDataTraverseKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextContextMenuDataTraverseKey))
      return false;
    return true;
  };
  var TextContextMenuDataTraverseKey_instance;
  function TextContextMenuDataTraverseKey_getInstance() {
    return TextContextMenuDataTraverseKey_instance;
  }
  function AddTextContextMenuDataComponentsNode(builder) {
    Node.call(this);
    this.okv_1 = builder;
  }
  protoOf(AddTextContextMenuDataComponentsNode).t91 = function () {
    return TextContextMenuDataTraverseKey_instance;
  };
  function FilterTextContextMenuDataComponentsNode() {
  }
  function collectTextContextMenuData$lambda($$this$apply) {
    return function (builder) {
      builder($$this$apply);
      return Unit_instance;
    };
  }
  function traverseTextContextMenuDataNodes$lambda($builderBlock, $filterBlock) {
    return function (node) {
      var tmp;
      if (node instanceof AddTextContextMenuDataComponentsNode) {
        tmp = $builderBlock(node.okv_1);
      } else {
        if (node instanceof FilterTextContextMenuDataComponentsNode) {
          tmp = $filterBlock(node.dkw_1);
        } else {
          throw IllegalStateException_init_$Create$('TextContextMenuDataNode.TraverseKey key must only be attached to instances of TextContextMenuDataNode.');
        }
      }
      return true;
    };
  }
  var androidx_compose_foundation_text_contextmenu_modifier_ToolbarRequester$stable;
  var androidx_compose_foundation_text_contextmenu_modifier_ToolbarRequesterImpl$stable;
  var androidx_compose_foundation_text_contextmenu_modifier_TextContextMenuToolbarHandlerNode$stable;
  function ToolbarRequesterImpl() {
    ToolbarRequester.call(this);
  }
  protoOf(ToolbarRequesterImpl).vbq = function () {
    var tmp0_safe_receiver = this.ikw();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.vbq();
    }
  };
  protoOf(ToolbarRequesterImpl).wbq = function () {
    var tmp0_safe_receiver = this.gkw_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.wbq();
    }
  };
  function ToolbarRequester() {
    this.gkw_1 = null;
    this.hkw_1 = ToolbarHandlerState_Uninitialized_getInstance();
  }
  protoOf(ToolbarRequester).ikw = function () {
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!!this.hkw_1.equals(ToolbarHandlerState_Uninitialized_getInstance())) {
      var tmp$ret$1 = 'ToolbarRequester is not initialized.';
      throwIllegalStateException(tmp$ret$1);
    }
    return this.gkw_1;
  };
  function _get_derivedData__bpca2y($this) {
    var tmp0 = $this.ekx_1;
    var tmp = KProperty1;
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('derivedData', 1, tmp, TextContextMenuToolbarHandlerNode$_get_derivedData_$ref_s8s6o7(), null);
    return tmp0.u1();
  }
  function TextContextMenuToolbarHandlerNode$derivedData$delegate$lambda(this$0) {
    return function () {
      return this$0.z8v_1 ? collectTextContextMenuData(this$0) : Companion_getInstance_80().aks_1;
    };
  }
  function TextContextMenuToolbarHandlerNode$_get_derivedData_$ref_s8s6o7() {
    return constructCallableReference(function (p0) {
      return _get_derivedData__bpca2y(p0);
    }, 1, 0, 351);
  }
  function TextContextMenuToolbarHandlerNode$show$slambda(this$0, $provider, resultContinuation) {
    this.okx_1 = this$0;
    this.pkx_1 = $provider;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextContextMenuToolbarHandlerNode$show$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextContextMenuToolbarHandlerNode$show$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextContextMenuToolbarHandlerNode$show$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 11;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 8;
            var tmp0_safe_receiver = this.okx_1.akx_1;
            if (tmp0_safe_receiver == null) {
              this.ukx_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = tmp0_safe_receiver(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var tmp_0 = this;
            tmp_0.ukx_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            suspendResult = this.pkx_1.wku(this.okx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.o9_1 = 11;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 11;
            var tmp1_safe_receiver = this.okx_1.bkx_1;
            if (tmp1_safe_receiver == null) {
              this.tkx_1 = null;
              this.n9_1 = 7;
              continue $sm;
            } else {
              this.n9_1 = 6;
              suspendResult = tmp1_safe_receiver(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 6:
            var tmp_1 = this;
            tmp_1.tkx_1 = Unit_instance;
            this.n9_1 = 7;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            this.o9_1 = 11;
            this.rkx_1 = this.q9_1;
            var tmp1_safe_receiver_0 = this.okx_1.bkx_1;
            if (tmp1_safe_receiver_0 == null) {
              this.skx_1 = null;
              this.n9_1 = 10;
              continue $sm;
            } else {
              this.n9_1 = 9;
              suspendResult = tmp1_safe_receiver_0(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 9:
            var tmp_2 = this;
            tmp_2.skx_1 = Unit_instance;
            this.n9_1 = 10;
            continue $sm;
          case 10:
            throw this.rkx_1;
          case 11:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 11) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextContextMenuToolbarHandlerNode$show$slambda).q24 = function ($this$launch, completion) {
    var i = new TextContextMenuToolbarHandlerNode$show$slambda(this.okx_1, this.pkx_1, completion);
    i.qkx_1 = $this$launch;
    return i;
  };
  function TextContextMenuToolbarHandlerNode$show$slambda_0(this$0, $provider, resultContinuation) {
    var i = new TextContextMenuToolbarHandlerNode$show$slambda(this$0, $provider, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TextContextMenuToolbarHandlerNode(requester, onShow, onHide, computeContentBounds) {
    DelegatingNode.call(this);
    this.zkw_1 = requester;
    this.akx_1 = onShow;
    this.bkx_1 = onHide;
    this.ckx_1 = computeContentBounds;
    this.dkx_1 = null;
    var tmp = this;
    tmp.ekx_1 = derivedStateOf(TextContextMenuToolbarHandlerNode$derivedData$delegate$lambda(this));
    this.fkx_1 = Companion_getInstance_50().j5d_1;
  }
  protoOf(TextContextMenuToolbarHandlerNode).vkx = function (toolbarRequester) {
    this.zkw_1.gkw_1 = null;
    this.zkw_1 = toolbarRequester;
    this.zkw_1.gkw_1 = this;
    var tmp = this.zkw_1;
    var tmp_0;
    if (this.z8v_1) {
      tmp_0 = ToolbarHandlerState_Attached_getInstance();
    } else {
      tmp_0 = ToolbarHandlerState_Detached_getInstance();
    }
    tmp.hkw_1 = tmp_0;
  };
  protoOf(TextContextMenuToolbarHandlerNode).f8w = function () {
    protoOf(DelegatingNode).f8w.call(this);
    this.zkw_1.hkw_1 = ToolbarHandlerState_Attached_getInstance();
    this.zkw_1.gkw_1 = this;
  };
  protoOf(TextContextMenuToolbarHandlerNode).h8w = function () {
    this.zkw_1.hkw_1 = ToolbarHandlerState_Detached_getInstance();
    this.zkw_1.gkw_1 = null;
    protoOf(DelegatingNode).h8w.call(this);
  };
  protoOf(TextContextMenuToolbarHandlerNode).vbq = function () {
    var tmp;
    if (!this.z8v_1) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = this.dkx_1;
      tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r19()) === true;
    }
    if (tmp)
      return Unit_instance;
    var tmp1_elvis_lhs = currentValueOf(this, get_LocalTextContextMenuToolbarProvider());
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var provider = tmp_0;
    var tmp_1 = this;
    var tmp_2 = this.a8w();
    var tmp_3 = CoroutineStart_UNDISPATCHED_getInstance();
    tmp_1.dkx_1 = launch(tmp_2, VOID, tmp_3, TextContextMenuToolbarHandlerNode$show$slambda_0(this, provider, null));
  };
  protoOf(TextContextMenuToolbarHandlerNode).wbq = function () {
    var tmp0_elvis_lhs = this.dkx_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var job = tmp;
    job.b1b();
    this.dkx_1 = null;
  };
  protoOf(TextContextMenuToolbarHandlerNode).vkt = function (destinationCoordinates) {
    return this.wkx(destinationCoordinates).s5d();
  };
  protoOf(TextContextMenuToolbarHandlerNode).wkx = function (destinationCoordinates) {
    if (!this.z8v_1)
      return this.fkx_1;
    var tmp0_elvis_lhs = this.ckx_1(destinationCoordinates);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this.fkx_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var computedContentBounds = tmp;
    this.fkx_1 = computedContentBounds;
    return computedContentBounds;
  };
  protoOf(TextContextMenuToolbarHandlerNode).wkt = function () {
    return _get_derivedData__bpca2y(this);
  };
  var ToolbarHandlerState_Uninitialized_instance;
  var ToolbarHandlerState_Detached_instance;
  var ToolbarHandlerState_Attached_instance;
  var ToolbarHandlerState_entriesInitialized;
  function ToolbarHandlerState_initEntries() {
    if (ToolbarHandlerState_entriesInitialized)
      return Unit_instance;
    ToolbarHandlerState_entriesInitialized = true;
    ToolbarHandlerState_Uninitialized_instance = new ToolbarHandlerState('Uninitialized', 0);
    ToolbarHandlerState_Detached_instance = new ToolbarHandlerState('Detached', 1);
    ToolbarHandlerState_Attached_instance = new ToolbarHandlerState('Attached', 2);
  }
  function ToolbarHandlerState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function translateRootToDestination(rootContentBounds, localCoordinates, destinationCoordinates) {
    if (!localCoordinates.y91() || !destinationCoordinates.y91())
      return Companion_getInstance_50().j5d_1;
    var rootContentPosition = rootContentBounds.s5d();
    var rootCoordinates = findRootCoordinates(localCoordinates);
    var destinationContentPosition = destinationCoordinates.q91(rootCoordinates, rootContentPosition);
    return Rect_0(destinationContentPosition, rootContentBounds.o5d());
  }
  function textContextMenuToolbarHandler(_this__u8e3s4, requester, onShow, onHide, computeContentBounds) {
    onShow = onShow === VOID ? null : onShow;
    onHide = onHide === VOID ? null : onHide;
    return _this__u8e3s4.d8v(new TextContextMenuToolbarHandlerElement(requester, onShow, onHide, computeContentBounds));
  }
  function TextContextMenuToolbarHandlerElement(requester, onShow, onHide, computeContentBounds) {
    ModifierNodeElement.call(this);
    this.ykx_1 = requester;
    this.zkx_1 = onShow;
    this.aky_1 = onHide;
    this.bky_1 = computeContentBounds;
  }
  protoOf(TextContextMenuToolbarHandlerElement).r3d = function () {
    return new TextContextMenuToolbarHandlerNode(this.ykx_1, this.zkx_1, this.aky_1, this.bky_1);
  };
  protoOf(TextContextMenuToolbarHandlerElement).cky = function (node) {
    node.vkx(this.ykx_1);
    node.akx_1 = this.zkx_1;
    node.bkx_1 = this.aky_1;
    node.ckx_1 = this.bky_1;
  };
  protoOf(TextContextMenuToolbarHandlerElement).d8y = function (node) {
    return this.cky(node instanceof TextContextMenuToolbarHandlerNode ? node : THROW_CCE());
  };
  protoOf(TextContextMenuToolbarHandlerElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextContextMenuToolbarHandlerElement))
      return false;
    if (!(this.ykx_1 === other.ykx_1))
      return false;
    if (!(this.zkx_1 === other.zkx_1))
      return false;
    if (!(this.aky_1 === other.aky_1))
      return false;
    if (!(this.bky_1 === other.bky_1))
      return false;
    return true;
  };
  protoOf(TextContextMenuToolbarHandlerElement).hashCode = function () {
    var result = 0;
    result = imul(31, result) + hashCode(this.ykx_1) | 0;
    var tmp = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.zkx_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.aky_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    result = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    result = imul(31, result) + hashCode(this.bky_1) | 0;
    return result;
  };
  function ToolbarHandlerState_Uninitialized_getInstance() {
    ToolbarHandlerState_initEntries();
    return ToolbarHandlerState_Uninitialized_instance;
  }
  function ToolbarHandlerState_Detached_getInstance() {
    ToolbarHandlerState_initEntries();
    return ToolbarHandlerState_Detached_instance;
  }
  function ToolbarHandlerState_Attached_getInstance() {
    ToolbarHandlerState_initEntries();
    return ToolbarHandlerState_Attached_instance;
  }
  var androidx_compose_foundation_text_contextmenu_provider_BasicTextContextMenuProvider$stable;
  function _set_session__czfrfz($this, _set____db54di) {
    var tmp0 = $this.fky_1;
    var tmp = KMutableProperty1;
    var tmp_0 = BasicTextContextMenuProvider$_get_session_$ref_78nq7e();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('session', 1, tmp, tmp_0, BasicTextContextMenuProvider$_set_session_$ref_n1qg4i());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_session__cmsix1($this) {
    var tmp0 = $this.fky_1;
    var tmp = KMutableProperty1;
    var tmp_0 = BasicTextContextMenuProvider$_get_session_$ref_78nq7e();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('session', 1, tmp, tmp_0, BasicTextContextMenuProvider$_set_session_$ref_n1qg4i());
    return tmp0.u1();
  }
  function SessionImpl($outer, dataProvider) {
    this.iky_1 = $outer;
    this.gky_1 = dataProvider;
    this.hky_1 = Channel();
  }
  protoOf(SessionImpl).j4 = function () {
    this.hky_1.s1s(Unit_instance);
  };
  protoOf(SessionImpl).jky = function ($completion) {
    return this.hky_1.u1s($completion);
  };
  function BasicTextContextMenuProvider$_get_session_$ref_78nq7e() {
    return constructCallableReference(function (p0) {
      return _get_session__cmsix1(p0);
    }, 1, 0, 352);
  }
  function BasicTextContextMenuProvider$_set_session_$ref_n1qg4i() {
    return constructCallableReference(function (p0, p1) {
      _set_session__czfrfz(p0, p1);
      return Unit_instance;
    }, 2, 0, 353);
  }
  function BasicTextContextMenuProvider$showTextContextMenu$slambda(this$0, $localSession, resultContinuation) {
    this.sky_1 = this$0;
    this.tky_1 = $localSession;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BasicTextContextMenuProvider$showTextContextMenu$slambda).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BasicTextContextMenuProvider$showTextContextMenu$slambda).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(BasicTextContextMenuProvider$showTextContextMenu$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            _set_session__czfrfz(this.sky_1, this.tky_1);
            this.n9_1 = 2;
            suspendResult = this.tky_1.jky(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            _set_session__czfrfz(this.sky_1, null);
            return Unit_instance;
          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            _set_session__czfrfz(this.sky_1, null);
            throw t;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BasicTextContextMenuProvider$showTextContextMenu$slambda).s2b = function (completion) {
    return new BasicTextContextMenuProvider$showTextContextMenu$slambda(this.sky_1, this.tky_1, completion);
  };
  function BasicTextContextMenuProvider$showTextContextMenu$slambda_0(this$0, $localSession, resultContinuation) {
    var i = new BasicTextContextMenuProvider$showTextContextMenu$slambda(this$0, $localSession, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function BasicTextContextMenuProvider$ContextMenu$lambda($tmp0_rcvr, $anchorLayoutCoordinates, $$changed) {
    return function ($composer, $force) {
      $tmp0_rcvr.uky($anchorLayoutCoordinates, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function BasicTextContextMenuProvider$ContextMenu$lambda_0($tmp2_rcvr, $anchorLayoutCoordinates, $$changed) {
    return function ($composer, $force) {
      $tmp2_rcvr.uky($anchorLayoutCoordinates, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function BasicTextContextMenuProvider(contextMenuBlock) {
    this.dky_1 = contextMenuBlock;
    this.eky_1 = new MutatorMutex();
    this.fky_1 = mutableStateOf(null);
  }
  protoOf(BasicTextContextMenuProvider).wku = function (dataProvider, $completion) {
    var localSession = new SessionImpl(this, dataProvider);
    return this.eky_1.tg5(VOID, BasicTextContextMenuProvider$showTextContextMenu$slambda_0(this, localSession, null), $completion);
  };
  protoOf(BasicTextContextMenuProvider).uky = function (anchorLayoutCoordinates, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(723898654);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(anchorLayoutCoordinates) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(this) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      var tmp0_elvis_lhs = _get_session__cmsix1(this);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var tmp1_safe_receiver = $composer_0.t30();
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.p3c(BasicTextContextMenuProvider$ContextMenu$lambda(this, anchorLayoutCoordinates, $changed));
        }
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var session = tmp;
      this.dky_1(session, session.gky_1, anchorLayoutCoordinates, $composer_0, 896 & $dirty << 6);
    } else {
      $composer_0.z30();
    }
    var tmp3_safe_receiver = $composer_0.t30();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.p3c(BasicTextContextMenuProvider$ContextMenu$lambda_0(this, anchorLayoutCoordinates, $changed));
    }
  };
  protoOf(BasicTextContextMenuProvider).e2z = function () {
    var tmp0_safe_receiver = _get_session__cmsix1(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.j4();
    }
  };
  function basicTextContextMenuProvider(contextMenu, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(contextMenu) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = new BasicTextContextMenuProvider(contextMenu);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var provider = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid_0 = $composer_0.k31(provider);
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
      var value_0 = basicTextContextMenuProvider$lambda(provider);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp$ret$4 = tmp_0;
    DisposableEffect_0(provider, tmp$ret$4, $composer_0, 0);
    return provider;
  }
  function ProvideBasicTextContextMenu(modifier, providableCompositionLocal, contextMenu, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-714464401);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(providableCompositionLocal) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(contextMenu) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = mutableStateOf(null, neverEqualPolicy());
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var layoutCoordinates$delegate = tmp;
      var provider = basicTextContextMenuProvider(contextMenu, $composer_0, 14 & $dirty >> 6);
      var tmp_0 = providableCompositionLocal.h3c(provider);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(274270255, true, ProvideBasicTextContextMenu$lambda_1(modifier, content, provider, layoutCoordinates$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_1.i31();
      var tmp_1;
      if (invalid || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp$ret$4 = tmp_1;
      CompositionLocalProvider(tmp_0, tmp$ret$4, $composer_0, 48 | androidx_compose_runtime_ProvidedValue$stableprop_getter());
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProvideBasicTextContextMenu$lambda_2(modifier, providableCompositionLocal, contextMenu, content, $changed));
    }
  }
  function basicTextContextMenuProvider$$inlined$cache$1$1($provider) {
    this.vky_1 = $provider;
  }
  protoOf(basicTextContextMenuProvider$$inlined$cache$1$1).s1d = function () {
    this.vky_1.e2z();
  };
  function basicTextContextMenuProvider$lambda($provider) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new basicTextContextMenuProvider$$inlined$cache$1$1($provider);
    };
  }
  function ProvideBasicTextContextMenu$lambda($layoutCoordinates$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('layoutCoordinates', KMutableProperty0, true);
    return $layoutCoordinates$delegate.u1();
  }
  function ProvideBasicTextContextMenu$lambda_0($layoutCoordinates$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('layoutCoordinates', KMutableProperty0, true);
    $layoutCoordinates$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProvideBasicTextContextMenu$lambda$lambda($layoutCoordinates$delegate) {
    return function (it) {
      ProvideBasicTextContextMenu$lambda_0($layoutCoordinates$delegate, it);
      return Unit_instance;
    };
  }
  function ProvideBasicTextContextMenu$lambda$lambda_0($layoutCoordinates$delegate) {
    return function () {
      // Inline function 'androidx.compose.foundation.internal.checkPreconditionNotNull' call
      var value = ProvideBasicTextContextMenu$lambda($layoutCoordinates$delegate);
      if (value == null) {
        throwIllegalStateExceptionForNullCheck('Required value was null.');
      }
      return value;
    };
  }
  function ProvideBasicTextContextMenu$lambda_1($modifier, $content, $provider, $layoutCoordinates$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance_11().f30_1) {
          var value = ProvideBasicTextContextMenu$lambda$lambda($layoutCoordinates$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$0 = tmp_0;
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = onGloballyPositioned($modifier, tmp$ret$0);
        var contentAlignment = null;
        var propagateMinConstraints = true;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance_0;
        if (!((2 & 2) === 0))
          contentAlignment = Companion_getInstance_12().k8t_1;
        if (!((2 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance_0;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_14().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        $content($composer_5, 0);
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_5.i31();
        var tmp_2;
        if (false || it_0 === Companion_getInstance_11().f30_1) {
          var value_0 = ProvideBasicTextContextMenu$lambda$lambda_0($layoutCoordinates$delegate);
          $composer_5.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_0;
        }
        var tmp$ret$10 = tmp_2;
        $provider.uky(tmp$ret$10, $composer_5, 6);
        $composer_3.e31();
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProvideBasicTextContextMenu$lambda_2($modifier, $providableCompositionLocal, $contextMenu, $content, $$changed) {
    return function ($composer, $force) {
      ProvideBasicTextContextMenu($modifier, $providableCompositionLocal, $contextMenu, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function get_LocalTextContextMenuDropdownProvider() {
    _init_properties_TextContextMenuProvider_kt__ez40m8();
    return LocalTextContextMenuDropdownProvider;
  }
  var LocalTextContextMenuDropdownProvider;
  function get_LocalTextContextMenuToolbarProvider() {
    _init_properties_TextContextMenuProvider_kt__ez40m8();
    return LocalTextContextMenuToolbarProvider;
  }
  var LocalTextContextMenuToolbarProvider;
  function LocalTextContextMenuDropdownProvider$lambda() {
    _init_properties_TextContextMenuProvider_kt__ez40m8();
    return null;
  }
  function LocalTextContextMenuToolbarProvider$lambda() {
    _init_properties_TextContextMenuProvider_kt__ez40m8();
    return null;
  }
  var properties_initialized_TextContextMenuProvider_kt_bd48aq;
  function _init_properties_TextContextMenuProvider_kt__ez40m8() {
    if (!properties_initialized_TextContextMenuProvider_kt_bd48aq) {
      properties_initialized_TextContextMenuProvider_kt_bd48aq = true;
      LocalTextContextMenuDropdownProvider = compositionLocalOf(VOID, LocalTextContextMenuDropdownProvider$lambda);
      LocalTextContextMenuToolbarProvider = compositionLocalOf(VOID, LocalTextContextMenuToolbarProvider$lambda);
    }
  }
  function TextContextMenuDataProvider$data$ref(p0) {
    return constructCallableReference(function () {
      return p0.wkt();
    }, 0, 0, 354, 'data', [p0]);
  }
  function get_HandwritingBoundsVerticalOffset() {
    _init_properties_StylusHandwriting_kt__6us847();
    return HandwritingBoundsVerticalOffset;
  }
  var HandwritingBoundsVerticalOffset;
  function get_HandwritingBoundsHorizontalOffset() {
    _init_properties_StylusHandwriting_kt__6us847();
    return HandwritingBoundsHorizontalOffset;
  }
  var HandwritingBoundsHorizontalOffset;
  function get_HandwritingBoundsExpansion() {
    _init_properties_StylusHandwriting_kt__6us847();
    return HandwritingBoundsExpansion;
  }
  var HandwritingBoundsExpansion;
  var androidx_compose_foundation_text_handwriting_StylusHandwritingNode$stable;
  function stylusHandwriting(_this__u8e3s4, enabled, showHoverIcon, onHandwritingSlopExceeded) {
    _init_properties_StylusHandwriting_kt__6us847();
    var tmp;
    if (enabled && get_isStylusHandwritingSupported()) {
      var tmp_0;
      if (showHoverIcon) {
        tmp_0 = stylusHoverIcon(_this__u8e3s4, get_handwritingPointerIcon(), false, get_HandwritingBoundsExpansion());
      } else {
        tmp_0 = _this__u8e3s4;
      }
      tmp = tmp_0.d8v(new StylusHandwritingElement(onHandwritingSlopExceeded));
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function StylusHandwritingElement(onHandwritingSlopExceeded) {
    ModifierNodeElement.call(this);
    this.xky_1 = onHandwritingSlopExceeded;
  }
  protoOf(StylusHandwritingElement).r3d = function () {
    return new StylusHandwritingNode(this.xky_1);
  };
  protoOf(StylusHandwritingElement).yky = function (node) {
    node.pkz_1 = this.xky_1;
  };
  protoOf(StylusHandwritingElement).d8y = function (node) {
    return this.yky(node instanceof StylusHandwritingNode ? node : THROW_CCE());
  };
  protoOf(StylusHandwritingElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StylusHandwritingElement))
      return false;
    return this.xky_1 === other.xky_1;
  };
  protoOf(StylusHandwritingElement).hashCode = function () {
    return hashCode(this.xky_1);
  };
  function StylusHandwritingNode$suspendingPointerInputModifierNode$slambda$slambda(this$0, resultContinuation) {
    this.al0_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StylusHandwritingNode$suspendingPointerInputModifierNode$slambda$slambda).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StylusHandwritingNode$suspendingPointerInputModifierNode$slambda$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StylusHandwritingNode$suspendingPointerInputModifierNode$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            this.n9_1 = 1;
            suspendResult = awaitFirstDown(this.bl0_1, true, PointerEventPass_Initial_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.cl0_1 = suspendResult;
            var isStylus = this.cl0_1.qa0_1 === Companion_getInstance_23().oa2_1 || this.cl0_1.qa0_1 === Companion_getInstance_23().pa2_1;
            if (!isStylus) {
              return Unit_instance;
            }

            var tmp_0;
            var tmp_1;
            var tmp_2;
            var this_0 = this.cl0_1.ka0_1;
            var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
            var bits = convertToInt(shiftRight(value, 32));
            if (floatFromBits(bits) >= 0) {
              var this_1 = this.cl0_1.ka0_1;
              var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
              var bits_0 = convertToInt(shiftRight(value_0, 32));
              var tmp_3 = floatFromBits(bits_0);
              var this_2 = this.bl0_1.q95();
              var value_1 = _IntSize___get_packedValue__impl__uho7jf(this_2);
              tmp_2 = tmp_3 < convertToInt(shiftRight(value_1, 32));
            } else {
              tmp_2 = false;
            }

            if (tmp_2) {
              var this_3 = this.cl0_1.ka0_1;
              var value_2 = _Offset___get_packedValue__impl__xh2k8q(this_3);
              var bits_1 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
              tmp_1 = floatFromBits(bits_1) >= 0;
            } else {
              tmp_1 = false;
            }

            if (tmp_1) {
              var this_4 = this.cl0_1.ka0_1;
              var value_3 = _Offset___get_packedValue__impl__xh2k8q(this_4);
              var bits_2 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
              var tmp_4 = floatFromBits(bits_2);
              var this_5 = this.bl0_1.q95();
              var value_4 = _IntSize___get_packedValue__impl__uho7jf(this_5);
              tmp_0 = tmp_4 < convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
            } else {
              tmp_0 = false;
            }

            var isInBounds = tmp_0;
            var tmp_5 = this;
            var tmp_6;
            if (this.al0_1.qkz_1 || isInBounds) {
              tmp_6 = PointerEventPass_Initial_getInstance();
            } else {
              tmp_6 = PointerEventPass_Main_getInstance();
            }

            tmp_5.gl0_1 = tmp_6;
            this.dl0_1 = null;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.n9_1 = 8;
              continue $sm;
            }

            this.n9_1 = 3;
            suspendResult = this.bl0_1.pa7(this.gl0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.fl0_1 = suspendResult;
            var tmp_7 = this;
            var tmp0 = this.fl0_1.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (!item.qa2() && equals(item.ia0_1, this.cl0_1.ia0_1) && item.la0_1) {
                    tmp$ret$0 = item;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$0 = null;
            }
             while (false);
            tmp_7.el0_1 = tmp$ret$0;
            if (this.el0_1 == null) {
              this.n9_1 = 8;
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            var time = subtract(this.el0_1.ja0_1, this.cl0_1.ja0_1);
            if (compare(time, this.bl0_1.la7().rb9()) >= 0) {
              this.n9_1 = 8;
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 5:
            if (get_isDeepPress(this.fl0_1)) {
              this.n9_1 = 8;
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 6:
            var offset = Offset__minus_impl_hoj2c0(this.el0_1.ka0_1, this.cl0_1.ka0_1);
            if (Offset__getDistance_impl_pclvxn(offset) > this.bl0_1.la7().vb9()) {
              this.dl0_1 = this.el0_1;
              this.n9_1 = 8;
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 7:
            this.n9_1 = 2;
            continue $sm;
          case 8:
            if (this.dl0_1 == null) {
              return Unit_instance;
            }

            if (!this.al0_1.qkz_1) {
              requestFocus(this.al0_1);
            }

            this.al0_1.pkz_1();
            this.dl0_1.ra2();
            this.n9_1 = 9;
            continue $sm;
          case 9:
            if (!true) {
              this.n9_1 = 11;
              continue $sm;
            }

            this.n9_1 = 10;
            suspendResult = this.bl0_1.pa7(PointerEventPass_Initial_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            var pointerEvent = suspendResult;
            var tmp0_0 = pointerEvent.ca0_1;
            var tmp$ret$2;
            l$ret$3: do {
              var inductionVariable_0 = 0;
              var last_0 = tmp0_0.n1() - 1 | 0;
              if (inductionVariable_0 <= last_0)
                do {
                  var index_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var item_0 = tmp0_0.l1(index_0);
                  if (!item_0.qa2() && equals(item_0.ia0_1, this.cl0_1.ia0_1) && item_0.la0_1) {
                    tmp$ret$2 = item_0;
                    break l$ret$3;
                  }
                }
                 while (inductionVariable_0 <= last_0);
              tmp$ret$2 = null;
            }
             while (false);
            var tmp0_elvis_lhs = tmp$ret$2;
            var tmp_8;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_8 = tmp0_elvis_lhs;
            }

            var pointerChange = tmp_8;
            pointerChange.ra2();
            this.n9_1 = 9;
            continue $sm;
          case 11:
            return Unit_instance;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 12) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StylusHandwritingNode$suspendingPointerInputModifierNode$slambda$slambda).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new StylusHandwritingNode$suspendingPointerInputModifierNode$slambda$slambda(this.al0_1, completion);
    i.bl0_1 = $this$awaitEachGesture;
    return i;
  };
  function StylusHandwritingNode$suspendingPointerInputModifierNode$slambda$slambda_0(this$0, resultContinuation) {
    var i = new StylusHandwritingNode$suspendingPointerInputModifierNode$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6(function_0) {
    this.hl0_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6).ka7 = function (_this__u8e3s4, $completion) {
    return this.hl0_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6).q3 = function () {
    return this.hl0_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6).hashCode = function () {
    return hashCode(this.q3());
  };
  function StylusHandwritingNode$suspendingPointerInputModifierNode$slambda(this$0, resultContinuation) {
    this.ql0_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StylusHandwritingNode$suspendingPointerInputModifierNode$slambda).vc6 = function ($this$SuspendingPointerInputModifierNode, $completion) {
    var tmp = this.wc6($this$SuspendingPointerInputModifierNode, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StylusHandwritingNode$suspendingPointerInputModifierNode$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StylusHandwritingNode$suspendingPointerInputModifierNode$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = awaitEachGesture(this.rl0_1, StylusHandwritingNode$suspendingPointerInputModifierNode$slambda$slambda_0(this.ql0_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StylusHandwritingNode$suspendingPointerInputModifierNode$slambda).wc6 = function ($this$SuspendingPointerInputModifierNode, completion) {
    var i = new StylusHandwritingNode$suspendingPointerInputModifierNode$slambda(this.ql0_1, completion);
    i.rl0_1 = $this$SuspendingPointerInputModifierNode;
    return i;
  };
  function StylusHandwritingNode$suspendingPointerInputModifierNode$slambda_0(this$0, resultContinuation) {
    var i = new StylusHandwritingNode$suspendingPointerInputModifierNode$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$SuspendingPointerInputModifierNode, $completion) {
      return i.vc6($this$SuspendingPointerInputModifierNode, $completion);
    }, 1);
  }
  function StylusHandwritingNode(onHandwritingSlopExceeded) {
    DelegatingNode.call(this);
    this.pkz_1 = onHandwritingSlopExceeded;
    this.qkz_1 = false;
    var tmp = this;
    var tmp_0 = StylusHandwritingNode$suspendingPointerInputModifierNode$slambda_0(this, null);
    tmp.rkz_1 = this.tb1(SuspendingPointerInputModifierNode(new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6(tmp_0)));
  }
  protoOf(StylusHandwritingNode).m9c = function (focusState) {
    this.qkz_1 = focusState.s9h();
  };
  protoOf(StylusHandwritingNode).ea5 = function () {
    return get_HandwritingBoundsExpansion().ha6(requireDensity(this));
  };
  protoOf(StylusHandwritingNode).aa1 = function (pointerEvent, pass, bounds) {
    this.rkz_1.aa1(pointerEvent, pass, bounds);
  };
  protoOf(StylusHandwritingNode).xa1 = function () {
    this.rkz_1.xa1();
  };
  var properties_initialized_StylusHandwriting_kt_udw4k5;
  function _init_properties_StylusHandwriting_kt__6us847() {
    if (!properties_initialized_StylusHandwriting_kt_udw4k5) {
      properties_initialized_StylusHandwriting_kt_udw4k5 = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      HandwritingBoundsVerticalOffset = _Dp___init__impl__ms3zkb(40);
      // Inline function 'androidx.compose.ui.unit.dp' call
      HandwritingBoundsHorizontalOffset = _Dp___init__impl__ms3zkb(10);
      HandwritingBoundsExpansion = DpTouchBoundsExpansion(get_HandwritingBoundsHorizontalOffset(), get_HandwritingBoundsVerticalOffset(), get_HandwritingBoundsHorizontalOffset(), get_HandwritingBoundsVerticalOffset());
      androidx_compose_foundation_text_handwriting_StylusHandwritingNode$stable = 8;
    }
  }
  var androidx_compose_foundation_text_input_TextFieldBuffer$stable;
  var androidx_compose_foundation_text_input_TextFieldCharSequence$stable;
  function TextFieldDecorator() {
  }
  var androidx_compose_foundation_text_input_TextFieldLineLimits_SingleLine$stable;
  var androidx_compose_foundation_text_input_TextFieldLineLimits_MultiLine$stable;
  var androidx_compose_foundation_text_input_TextFieldState_Saver$stable;
  var androidx_compose_foundation_text_input_TextFieldState$stable;
  var androidx_compose_foundation_text_input_TextUndoManager_Companion_Saver$stable;
  var androidx_compose_foundation_text_input_TextUndoManager$stable;
  var androidx_compose_foundation_text_input_UndoState$stable;
  var androidx_compose_foundation_text_input_internal_ChangeTracker$stable;
  var androidx_compose_foundation_text_input_internal_SingleLineCodepointTransformation$stable;
  var androidx_compose_foundation_text_input_internal_CoreTextFieldSemanticsModifier$stable;
  var androidx_compose_foundation_text_input_internal_CoreTextFieldSemanticsModifierNode$stable;
  function CoreTextFieldSemanticsModifier(transformedText, value, state, readOnly, enabled, isPassword, offsetMapping, manager, imeOptions, focusRequester) {
    ModifierNodeElement.call(this);
    this.tl0_1 = transformedText;
    this.ul0_1 = value;
    this.vl0_1 = state;
    this.wl0_1 = readOnly;
    this.xl0_1 = enabled;
    this.yl0_1 = isPassword;
    this.zl0_1 = offsetMapping;
    this.al1_1 = manager;
    this.bl1_1 = imeOptions;
    this.cl1_1 = focusRequester;
  }
  protoOf(CoreTextFieldSemanticsModifier).r3d = function () {
    return new CoreTextFieldSemanticsModifierNode(this.tl0_1, this.ul0_1, this.vl0_1, this.wl0_1, this.xl0_1, this.yl0_1, this.zl0_1, this.al1_1, this.bl1_1, this.cl1_1);
  };
  protoOf(CoreTextFieldSemanticsModifier).dl1 = function (node) {
    node.el2(this.tl0_1, this.ul0_1, this.vl0_1, this.wl0_1, this.xl0_1, this.yl0_1, this.zl0_1, this.al1_1, this.bl1_1, this.cl1_1);
  };
  protoOf(CoreTextFieldSemanticsModifier).d8y = function (node) {
    return this.dl1(node instanceof CoreTextFieldSemanticsModifierNode ? node : THROW_CCE());
  };
  protoOf(CoreTextFieldSemanticsModifier).toString = function () {
    return 'CoreTextFieldSemanticsModifier(transformedText=' + this.tl0_1.toString() + ', value=' + this.ul0_1.toString() + ', state=' + toString(this.vl0_1) + ', readOnly=' + this.wl0_1 + ', enabled=' + this.xl0_1 + ', isPassword=' + this.yl0_1 + ', offsetMapping=' + toString(this.zl0_1) + ', manager=' + toString(this.al1_1) + ', imeOptions=' + this.bl1_1.toString() + ', focusRequester=' + toString(this.cl1_1) + ')';
  };
  protoOf(CoreTextFieldSemanticsModifier).hashCode = function () {
    var result = this.tl0_1.hashCode();
    result = imul(result, 31) + this.ul0_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.vl0_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.wl0_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xl0_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.yl0_1) | 0;
    result = imul(result, 31) + hashCode(this.zl0_1) | 0;
    result = imul(result, 31) + hashCode(this.al1_1) | 0;
    result = imul(result, 31) + this.bl1_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.cl1_1) | 0;
    return result;
  };
  protoOf(CoreTextFieldSemanticsModifier).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CoreTextFieldSemanticsModifier))
      return false;
    if (!this.tl0_1.equals(other.tl0_1))
      return false;
    if (!this.ul0_1.equals(other.ul0_1))
      return false;
    if (!equals(this.vl0_1, other.vl0_1))
      return false;
    if (!(this.wl0_1 === other.wl0_1))
      return false;
    if (!(this.xl0_1 === other.xl0_1))
      return false;
    if (!(this.yl0_1 === other.yl0_1))
      return false;
    if (!equals(this.zl0_1, other.zl0_1))
      return false;
    if (!equals(this.al1_1, other.al1_1))
      return false;
    if (!this.bl1_1.equals(other.bl1_1))
      return false;
    if (!equals(this.cl1_1, other.cl1_1))
      return false;
    return true;
  };
  function handleTextUpdateFromSemantics($this, state, text, readOnly, enabled) {
    if (readOnly || !enabled)
      return Unit_instance;
    var tmp0_safe_receiver = state.fk5_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      Companion_instance_29.ckj(listOf([new DeleteAllCommand(), CommitTextCommand_init_$Create$(text, 1)]), state.ek5_1, state.wk5_1, tmp0_safe_receiver);
      tmp = Unit_instance;
    }
    if (tmp == null) {
      // Inline function 'kotlin.run' call
      state.wk5_1(TextFieldValue_init_$Create$(text, TextRange_1(text.length)));
    }
  }
  function CoreTextFieldSemanticsModifierNode$lambda(this$0) {
    return function () {
      requestAutofill(this$0);
      return Unit_instance;
    };
  }
  function CoreTextFieldSemanticsModifierNode$applySemantics$lambda(this$0) {
    return function (fillableData) {
      this$0.wl1_1.hk7(true);
      this$0.wl1_1.fk7(true);
      var tmp = this$0.wl1_1;
      var tmp_0 = fillableData.t8y();
      handleTextUpdateFromSemantics(this$0, tmp, (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE(), this$0.xl1_1, this$0.yl1_1);
      return true;
    };
  }
  function CoreTextFieldSemanticsModifierNode$applySemantics$lambda_0(this$0) {
    return function (it) {
      var tmp;
      if (!(this$0.wl1_1.tk7() == null)) {
        it.j1(ensureNotNull(this$0.wl1_1.tk7()).hk8_1);
        tmp = true;
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function CoreTextFieldSemanticsModifierNode$applySemantics$lambda_1(this$0) {
    return function (text) {
      handleTextUpdateFromSemantics(this$0, this$0.wl1_1, text.h7q_1, this$0.xl1_1, this$0.yl1_1);
      return true;
    };
  }
  function CoreTextFieldSemanticsModifierNode$applySemantics$lambda_2(this$0, $this_applySemantics) {
    return function (text) {
      var tmp;
      if (this$0.xl1_1 || !this$0.yl1_1) {
        return false;
      }
      var tmp0_safe_receiver = this$0.wl1_1.fk5_1;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        Companion_instance_29.ckj(listOf([new FinishComposingTextCommand(), new CommitTextCommand(text, 1)]), this$0.wl1_1.ek5_1, this$0.wl1_1.wk5_1, tmp0_safe_receiver);
        tmp_0 = Unit_instance;
      }
      var tmp1_elvis_lhs = tmp_0;
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.run' call
        var tmp0 = this$0.vl1_1.h89();
        var tmp2 = _TextRange___get_start__impl__ww4t90(this$0.vl1_1.g8a_1);
        // Inline function 'kotlin.text.replaceRange' call
        var endIndex = _TextRange___get_end__impl__gcdxpp(this$0.vl1_1.g8a_1);
        var newText = toString(replaceRange(isCharSequence(tmp0) ? tmp0 : THROW_CCE(), tmp2, endIndex, text));
        var newCursor = TextRange_1(_TextRange___get_start__impl__ww4t90(this$0.vl1_1.g8a_1) + text.a() | 0);
        this$0.wl1_1.wk5_1(TextFieldValue_init_$Create$(newText, newCursor));
        tmp_1 = Unit_instance;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      return true;
    };
  }
  function CoreTextFieldSemanticsModifierNode$applySemantics$lambda_3(this$0) {
    return function (selectionStart, selectionEnd, relativeToOriginalText) {
      var tmp;
      if (relativeToOriginalText) {
        tmp = selectionStart;
      } else {
        tmp = this$0.al2_1.p8c(selectionStart);
      }
      var start = tmp;
      var tmp_0;
      if (relativeToOriginalText) {
        tmp_0 = selectionEnd;
      } else {
        tmp_0 = this$0.al2_1.p8c(selectionEnd);
      }
      var end = tmp_0;
      var tmp_1;
      if (!this$0.yl1_1) {
        tmp_1 = false;
      } else {
        if (start === _TextRange___get_start__impl__ww4t90(this$0.vl1_1.g8a_1) && end === _TextRange___get_end__impl__gcdxpp(this$0.vl1_1.g8a_1)) {
          tmp_1 = false;
        } else {
          var tmp_2;
          // Inline function 'kotlin.comparisons.minOf' call
          if (Math.min(start, end) >= 0) {
            // Inline function 'kotlin.comparisons.maxOf' call
            tmp_2 = Math.max(start, end) <= this$0.vl1_1.f8a_1.a();
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            if (relativeToOriginalText || start === end) {
              this$0.bl2_1.fl2();
            } else {
              this$0.bl2_1.gl2();
            }
            this$0.wl1_1.wk5_1(new TextFieldValue(this$0.vl1_1.f8a_1, TextRange_0(start, end)));
            tmp_1 = true;
          } else {
            this$0.bl2_1.fl2();
            tmp_1 = false;
          }
        }
      }
      return tmp_1;
    };
  }
  function CoreTextFieldSemanticsModifierNode$applySemantics$lambda_4(this$0) {
    return function () {
      this$0.wl1_1.xk5_1(new ImeAction(this$0.cl2_1.j8c_1));
      return true;
    };
  }
  function CoreTextFieldSemanticsModifierNode$applySemantics$lambda_5(this$0) {
    return function () {
      requestFocusAndShowKeyboardIfNeeded(this$0.wl1_1, this$0.dl2_1, !this$0.xl1_1);
      return true;
    };
  }
  function CoreTextFieldSemanticsModifierNode$applySemantics$lambda_6(this$0) {
    return function () {
      this$0.bl2_1.gl2();
      return true;
    };
  }
  function CoreTextFieldSemanticsModifierNode$applySemantics$lambda_7(this$0) {
    return function () {
      this$0.bl2_1.hl2();
      return true;
    };
  }
  function CoreTextFieldSemanticsModifierNode$applySemantics$lambda_8(this$0) {
    return function () {
      this$0.bl2_1.skk();
      return true;
    };
  }
  function CoreTextFieldSemanticsModifierNode$applySemantics$lambda_9(this$0) {
    return function () {
      this$0.bl2_1.rkk();
      return true;
    };
  }
  function CoreTextFieldSemanticsModifierNode$updateNodeSemantics$lambda(this$0) {
    return function () {
      requestAutofill(this$0);
      return Unit_instance;
    };
  }
  function CoreTextFieldSemanticsModifierNode(transformedText, value, state, readOnly, enabled, isPassword, offsetMapping, manager, imeOptions, focusRequester) {
    DelegatingNode.call(this);
    this.ul1_1 = transformedText;
    this.vl1_1 = value;
    this.wl1_1 = state;
    this.xl1_1 = readOnly;
    this.yl1_1 = enabled;
    this.zl1_1 = isPassword;
    this.al2_1 = offsetMapping;
    this.bl2_1 = manager;
    this.cl2_1 = imeOptions;
    this.dl2_1 = focusRequester;
    var tmp = this.bl2_1;
    tmp.xk1_1 = CoreTextFieldSemanticsModifierNode$lambda(this);
  }
  protoOf(CoreTextFieldSemanticsModifierNode).l9j = function () {
    return true;
  };
  protoOf(CoreTextFieldSemanticsModifierNode).l9i = function (_this__u8e3s4) {
    set_inputText(_this__u8e3s4, this.vl1_1.f8a_1);
    set_editableText(_this__u8e3s4, this.ul1_1.p8d_1);
    set_textSelectionRange(_this__u8e3s4, this.vl1_1.g8a_1);
    set_contentDataType(_this__u8e3s4, Companion_getInstance_27().vc2_1);
    var tmp0_safe_receiver = createFromText(Companion_instance_5, this.vl1_1.f8a_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      set_fillableData(_this__u8e3s4, tmp0_safe_receiver);
    }
    onFillData(_this__u8e3s4, VOID, CoreTextFieldSemanticsModifierNode$applySemantics$lambda(this));
    var tmp1_subject = this.cl2_1.i8c_1;
    if (tmp1_subject === Companion_getInstance_42().b8c_1) {
      set_contentType(_this__u8e3s4, Companion_getInstance_51().cc3_1);
    } else if (tmp1_subject === Companion_getInstance_42().c8c_1 || tmp1_subject === Companion_getInstance_42().d8c_1) {
      set_contentType(_this__u8e3s4, Companion_getInstance_51().bc3_1);
    } else if (tmp1_subject === Companion_getInstance_42().z8b_1) {
      set_contentType(_this__u8e3s4, Companion_getInstance_51().ac4_1);
    }
    if (!this.yl1_1) {
      disabled(_this__u8e3s4);
    }
    if (this.zl1_1) {
      password(_this__u8e3s4);
    }
    var editable = this.yl1_1 && !this.xl1_1;
    set_isEditable(_this__u8e3s4, editable);
    getTextLayoutResult(_this__u8e3s4, VOID, CoreTextFieldSemanticsModifierNode$applySemantics$lambda_0(this));
    if (editable) {
      setText(_this__u8e3s4, VOID, CoreTextFieldSemanticsModifierNode$applySemantics$lambda_1(this));
      insertTextAtCursor(_this__u8e3s4, VOID, CoreTextFieldSemanticsModifierNode$applySemantics$lambda_2(this, _this__u8e3s4));
    }
    setSelection(_this__u8e3s4, VOID, CoreTextFieldSemanticsModifierNode$applySemantics$lambda_3(this));
    var tmp = this.cl2_1.j8c_1;
    onImeAction(_this__u8e3s4, tmp, VOID, CoreTextFieldSemanticsModifierNode$applySemantics$lambda_4(this));
    onClick(_this__u8e3s4, VOID, CoreTextFieldSemanticsModifierNode$applySemantics$lambda_5(this));
    onLongClick(_this__u8e3s4, VOID, CoreTextFieldSemanticsModifierNode$applySemantics$lambda_6(this));
    if (!_TextRange___get_collapsed__impl__cilesp(this.vl1_1.g8a_1) && !this.zl1_1) {
      copyText(_this__u8e3s4, VOID, CoreTextFieldSemanticsModifierNode$applySemantics$lambda_7(this));
      if (this.yl1_1 && !this.xl1_1) {
        cutText(_this__u8e3s4, VOID, CoreTextFieldSemanticsModifierNode$applySemantics$lambda_8(this));
      }
    }
    if (this.yl1_1 && !this.xl1_1) {
      pasteText(_this__u8e3s4, VOID, CoreTextFieldSemanticsModifierNode$applySemantics$lambda_9(this));
    }
  };
  protoOf(CoreTextFieldSemanticsModifierNode).el2 = function (transformedText, value, state, readOnly, enabled, isPassword, offsetMapping, manager, imeOptions, focusRequester) {
    var previousEditable = this.yl1_1 && !this.xl1_1;
    var previousEnabled = this.yl1_1;
    var previousIsPassword = this.zl1_1;
    var previousImeOptions = this.cl2_1;
    var previousManager = this.bl2_1;
    var editable = enabled && !readOnly;
    this.ul1_1 = transformedText;
    this.vl1_1 = value;
    this.wl1_1 = state;
    this.xl1_1 = readOnly;
    this.yl1_1 = enabled;
    this.al2_1 = offsetMapping;
    this.bl2_1 = manager;
    this.cl2_1 = imeOptions;
    this.dl2_1 = focusRequester;
    if (!(enabled === previousEnabled) || !(editable === previousEditable) || !imeOptions.equals(previousImeOptions) || !(isPassword === previousIsPassword) || !_TextRange___get_collapsed__impl__cilesp(value.g8a_1)) {
      invalidateSemantics(this);
    }
    if (!equals(manager, previousManager)) {
      var tmp = manager;
      tmp.xk1_1 = CoreTextFieldSemanticsModifierNode$updateNodeSemantics$lambda(this);
    }
  };
  var androidx_compose_foundation_text_input_internal_CursorAnimationState$stable;
  function CursorAnimationState$snapToVisibleAndAnimate$slambda$slambda($oldJob, this$0, resultContinuation) {
    this.ql2_1 = $oldJob;
    this.rl2_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CursorAnimationState$snapToVisibleAndAnimate$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CursorAnimationState$snapToVisibleAndAnimate$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CursorAnimationState$snapToVisibleAndAnimate$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            var tmp0_safe_receiver = this.ql2_1;
            if (tmp0_safe_receiver == null) {
              this.tl2_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = cancelAndJoin(tmp0_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            tmp_0.tl2_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 11;
            _set_cursorAlpha__uc23bx(this.rl2_1, 1.0);
            if (!this.rl2_1.xki_1) {
              this.n9_1 = 10;
              suspendResult = awaitCancellation(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            if (!true) {
              this.n9_1 = 8;
              continue $sm;
            }

            this.n9_1 = 6;
            suspendResult = delay(new Long(500, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            _set_cursorAlpha__uc23bx(this.rl2_1, 0.0);
            this.n9_1 = 7;
            suspendResult = delay(new Long(500, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            _set_cursorAlpha__uc23bx(this.rl2_1, 1.0);
            this.n9_1 = 5;
            continue $sm;
          case 8:
            this.o9_1 = 12;
            this.n9_1 = 9;
            continue $sm;
          case 9:
            this.o9_1 = 12;
            _set_cursorAlpha__uc23bx(this.rl2_1, 0.0);
            return Unit_instance;
          case 10:
            throwKotlinNothingValueException();
            break;
          case 11:
            this.o9_1 = 12;
            var t = this.q9_1;
            _set_cursorAlpha__uc23bx(this.rl2_1, 0.0);
            throw t;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 12) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CursorAnimationState$snapToVisibleAndAnimate$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new CursorAnimationState$snapToVisibleAndAnimate$slambda$slambda(this.ql2_1, this.rl2_1, completion);
    i.sl2_1 = $this$launch;
    return i;
  };
  function CursorAnimationState$snapToVisibleAndAnimate$slambda$slambda_0($oldJob, this$0, resultContinuation) {
    var i = new CursorAnimationState$snapToVisibleAndAnimate$slambda$slambda($oldJob, this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function _set_cursorAlpha__uc23bx($this, _set____db54di) {
    var tmp0 = $this.zki_1;
    var tmp = KMutableProperty1;
    var tmp_0 = CursorAnimationState$_get_cursorAlpha_$ref_rf92q1();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('cursorAlpha', 1, tmp, tmp_0, CursorAnimationState$_set_cursorAlpha_$ref_xi4rqj());
    tmp0.i45(_set____db54di);
    return Unit_instance;
  }
  function CursorAnimationState$_get_cursorAlpha_$ref_rf92q1() {
    return constructCallableReference(function (p0) {
      return p0.bkj();
    }, 1, 0, 355);
  }
  function CursorAnimationState$_set_cursorAlpha_$ref_xi4rqj() {
    return constructCallableReference(function (p0, p1) {
      _set_cursorAlpha__uc23bx(p0, p1);
      return Unit_instance;
    }, 2, 0, 356);
  }
  function CursorAnimationState$snapToVisibleAndAnimate$slambda(this$0, resultContinuation) {
    this.cl3_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CursorAnimationState$snapToVisibleAndAnimate$slambda).el3 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CursorAnimationState$snapToVisibleAndAnimate$slambda).ja = function (p1, $completion) {
    return this.el3((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CursorAnimationState$snapToVisibleAndAnimate$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var oldJob = this.cl3_1.yki_1.x21(null);
          var tmp_0 = this.cl3_1.yki_1;
          return tmp_0.w21(null, launch(this.dl3_1, VOID, VOID, CursorAnimationState$snapToVisibleAndAnimate$slambda$slambda_0(oldJob, this.cl3_1, null)));
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CursorAnimationState$snapToVisibleAndAnimate$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new CursorAnimationState$snapToVisibleAndAnimate$slambda(this.cl3_1, completion);
    i.dl3_1 = $this$coroutineScope;
    return i;
  };
  function CursorAnimationState$snapToVisibleAndAnimate$slambda_0(this$0, resultContinuation) {
    var i = new CursorAnimationState$snapToVisibleAndAnimate$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.el3($this$coroutineScope, $completion);
    }, 1);
  }
  function $snapToVisibleAndAnimateCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nl3_1 = _this__u8e3s4;
  }
  protoOf($snapToVisibleAndAnimateCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = coroutineScope(CursorAnimationState$snapToVisibleAndAnimate$slambda_0(this.nl3_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function CursorAnimationState(animate) {
    this.xki_1 = animate;
    this.yki_1 = new AtomicReference(null);
    this.zki_1 = mutableFloatStateOf(0.0);
  }
  protoOf(CursorAnimationState).bkj = function () {
    var tmp0 = this.zki_1;
    var tmp = KMutableProperty1;
    var tmp_0 = CursorAnimationState$_get_cursorAlpha_$ref_rf92q1();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('cursorAlpha', 1, tmp, tmp_0, CursorAnimationState$_set_cursorAlpha_$ref_xi4rqj());
    return tmp0.j45();
  };
  protoOf(CursorAnimationState).akj = function ($completion) {
    var tmp = new $snapToVisibleAndAnimateCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var androidx_compose_foundation_text_input_internal_DragAndDropHoverInteraction_Enter$stable;
  var androidx_compose_foundation_text_input_internal_DragAndDropHoverInteraction_Exit$stable;
  var androidx_compose_foundation_text_input_internal_PartialGapBuffer$stable;
  var androidx_compose_foundation_text_input_internal_IntIntervalTree$stable;
  var androidx_compose_foundation_text_input_internal_LegacyAdaptingPlatformTextInputModifierNode$stable;
  function legacyTextInputAdapter(_this__u8e3s4, serviceAdapter, legacyTextFieldState, textFieldSelectionManager) {
    return _this__u8e3s4.d8v(new LegacyAdaptingPlatformTextInputModifier(serviceAdapter, legacyTextFieldState, textFieldSelectionManager));
  }
  function LegacyAdaptingPlatformTextInputModifier(serviceAdapter, legacyTextFieldState, textFieldSelectionManager) {
    ModifierNodeElement.call(this);
    this.pl3_1 = serviceAdapter;
    this.ql3_1 = legacyTextFieldState;
    this.rl3_1 = textFieldSelectionManager;
  }
  protoOf(LegacyAdaptingPlatformTextInputModifier).r3d = function () {
    return new LegacyAdaptingPlatformTextInputModifierNode(this.pl3_1, this.ql3_1, this.rl3_1);
  };
  protoOf(LegacyAdaptingPlatformTextInputModifier).sl3 = function (node) {
    node.ll4(this.pl3_1);
    node.il4_1 = this.ql3_1;
    node.jl4_1 = this.rl3_1;
  };
  protoOf(LegacyAdaptingPlatformTextInputModifier).d8y = function (node) {
    return this.sl3(node instanceof LegacyAdaptingPlatformTextInputModifierNode ? node : THROW_CCE());
  };
  protoOf(LegacyAdaptingPlatformTextInputModifier).toString = function () {
    return 'LegacyAdaptingPlatformTextInputModifier(serviceAdapter=' + toString(this.pl3_1) + ', legacyTextFieldState=' + toString(this.ql3_1) + ', textFieldSelectionManager=' + toString(this.rl3_1) + ')';
  };
  protoOf(LegacyAdaptingPlatformTextInputModifier).hashCode = function () {
    var result = hashCode(this.pl3_1);
    result = imul(result, 31) + hashCode(this.ql3_1) | 0;
    result = imul(result, 31) + hashCode(this.rl3_1) | 0;
    return result;
  };
  protoOf(LegacyAdaptingPlatformTextInputModifier).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LegacyAdaptingPlatformTextInputModifier))
      return false;
    if (!equals(this.pl3_1, other.pl3_1))
      return false;
    if (!equals(this.ql3_1, other.ql3_1))
      return false;
    if (!equals(this.rl3_1, other.rl3_1))
      return false;
    return true;
  };
  function _set_layoutCoordinates__ckqjyk($this, _set____db54di) {
    var tmp0 = $this.kl4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyAdaptingPlatformTextInputModifierNode$_get_layoutCoordinates_$ref_mrh29n();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('layoutCoordinates', 1, tmp, tmp_0, LegacyAdaptingPlatformTextInputModifierNode$_set_layoutCoordinates_$ref_gluptz());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function LegacyAdaptingPlatformTextInputModifierNode$_get_layoutCoordinates_$ref_mrh29n() {
    return constructCallableReference(function (p0) {
      return p0.rk7();
    }, 1, 0, 357);
  }
  function LegacyAdaptingPlatformTextInputModifierNode$_set_layoutCoordinates_$ref_gluptz() {
    return constructCallableReference(function (p0, p1) {
      _set_layoutCoordinates__ckqjyk(p0, p1);
      return Unit_instance;
    }, 2, 0, 358);
  }
  function LegacyAdaptingPlatformTextInputModifierNode$launchTextInputSession$slambda(this$0, $block, resultContinuation) {
    this.ul4_1 = this$0;
    this.vl4_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LegacyAdaptingPlatformTextInputModifierNode$launchTextInputSession$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(LegacyAdaptingPlatformTextInputModifierNode$launchTextInputSession$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LegacyAdaptingPlatformTextInputModifierNode$launchTextInputSession$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = establishTextInputSession(this.ul4_1, this.vl4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LegacyAdaptingPlatformTextInputModifierNode$launchTextInputSession$slambda).q24 = function ($this$launch, completion) {
    var i = new LegacyAdaptingPlatformTextInputModifierNode$launchTextInputSession$slambda(this.ul4_1, this.vl4_1, completion);
    i.wl4_1 = $this$launch;
    return i;
  };
  function LegacyAdaptingPlatformTextInputModifierNode$launchTextInputSession$slambda_0(this$0, $block, resultContinuation) {
    var i = new LegacyAdaptingPlatformTextInputModifierNode$launchTextInputSession$slambda(this$0, $block, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function LegacyAdaptingPlatformTextInputModifierNode(serviceAdapter, legacyTextFieldState, textFieldSelectionManager) {
    Node.call(this);
    this.hl4_1 = serviceAdapter;
    this.il4_1 = legacyTextFieldState;
    this.jl4_1 = textFieldSelectionManager;
    this.kl4_1 = mutableStateOf(null);
  }
  protoOf(LegacyAdaptingPlatformTextInputModifierNode).rk7 = function () {
    var tmp0 = this.kl4_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LegacyAdaptingPlatformTextInputModifierNode$_get_layoutCoordinates_$ref_mrh29n();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('layoutCoordinates', 1, tmp, tmp_0, LegacyAdaptingPlatformTextInputModifierNode$_set_layoutCoordinates_$ref_gluptz());
    return tmp0.u1();
  };
  protoOf(LegacyAdaptingPlatformTextInputModifierNode).gbm = function () {
    return currentValueOf(this, get_LocalSoftwareKeyboardController());
  };
  protoOf(LegacyAdaptingPlatformTextInputModifierNode).ll4 = function (serviceAdapter) {
    if (this.z8v_1) {
      this.hl4_1.d8d();
      this.hl4_1.xl4(this);
    }
    this.hl4_1 = serviceAdapter;
    if (this.z8v_1) {
      this.hl4_1.yl4(this);
    }
  };
  protoOf(LegacyAdaptingPlatformTextInputModifierNode).f8w = function () {
    this.hl4_1.yl4(this);
  };
  protoOf(LegacyAdaptingPlatformTextInputModifierNode).h8w = function () {
    this.hl4_1.xl4(this);
  };
  protoOf(LegacyAdaptingPlatformTextInputModifierNode).eam = function (coordinates) {
    _set_layoutCoordinates__ckqjyk(this, coordinates);
  };
  protoOf(LegacyAdaptingPlatformTextInputModifierNode).zl4 = function (block) {
    if (!this.z8v_1)
      return null;
    var tmp = this.a8w();
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    return launch(tmp, VOID, tmp_0, LegacyAdaptingPlatformTextInputModifierNode$launchTextInputSession$slambda_0(this, block, null));
  };
  var androidx_compose_foundation_text_input_internal_LegacyPlatformTextInputServiceAdapter$stable;
  function LegacyPlatformTextInputServiceAdapter() {
    this.wka_1 = null;
  }
  protoOf(LegacyPlatformTextInputServiceAdapter).yl4 = function (node) {
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(this.wka_1 == null)) {
      var tmp$ret$1 = 'Expected textInputModifierNode to be null';
      throwIllegalStateException(tmp$ret$1);
    }
    this.wka_1 = node;
  };
  protoOf(LegacyPlatformTextInputServiceAdapter).xl4 = function (node) {
    // Inline function 'androidx.compose.foundation.internal.checkPrecondition' call
    if (!(this.wka_1 === node)) {
      var tmp$ret$1 = 'Expected textInputModifierNode to be ' + toString(node) + ' but was ' + toString_0(this.wka_1);
      throwIllegalStateException(tmp$ret$1);
    }
    this.wka_1 = null;
  };
  protoOf(LegacyPlatformTextInputServiceAdapter).e8d = function () {
    var tmp0_safe_receiver = this.wka_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gbm();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.vbq();
    }
  };
  protoOf(LegacyPlatformTextInputServiceAdapter).f8d = function () {
    var tmp0_safe_receiver = this.wka_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gbm();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.wbq();
    }
  };
  var androidx_compose_foundation_text_input_internal_OffsetMappingCalculator$stable;
  var androidx_compose_foundation_text_input_internal_TextFieldKeyEventHandler$stable;
  var androidx_compose_foundation_text_input_internal_TextFieldLayoutStateCache$stable;
  var androidx_compose_foundation_text_input_internal_TextFieldTextLayoutModifier$stable;
  var androidx_compose_foundation_text_input_internal_TextFieldTextLayoutModifierNode$stable;
  var androidx_compose_foundation_text_input_internal_TextLayoutState$stable;
  var androidx_compose_foundation_text_input_internal_TextStyleBuffer$stable;
  var androidx_compose_foundation_text_input_internal_TransformedTextFieldState$stable;
  var androidx_compose_foundation_text_input_internal_SelectionWedgeAffinity$stable;
  var androidx_compose_foundation_text_input_internal_selection_TextFieldHandleState$stable;
  var androidx_compose_foundation_text_input_internal_selection_TextFieldMagnifierNode$stable;
  var androidx_compose_foundation_text_input_internal_selection_TextFieldSelectionState$stable;
  var androidx_compose_foundation_text_input_internal_selection_TextFieldPreparedSelectionState$stable;
  var androidx_compose_foundation_text_input_internal_selection_SelectionMovementDeletionContext$stable;
  var androidx_compose_foundation_text_input_internal_undo_TextUndoOperation$stable;
  var androidx_compose_foundation_text_input_internal_undo_UndoManager$stable;
  function _InlineDensity___init__impl__1m7u8m(packedValue) {
    return packedValue;
  }
  function _get_packedValue__aj623s_0($this) {
    return $this;
  }
  function _InlineDensity___init__impl__1m7u8m_0(density, fontScale) {
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(density));
    var v2 = fromInt(toRawBits(fontScale));
    var tmp$ret$0 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _InlineDensity___init__impl__1m7u8m(tmp$ret$0);
  }
  function _InlineDensity___init__impl__1m7u8m_1(density) {
    return _InlineDensity___init__impl__1m7u8m_0(density.u5e(), density.j5f());
  }
  function _InlineDensity___get_density__impl__uz12rr($this) {
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _get_packedValue__aj623s_0($this);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    return floatFromBits(bits);
  }
  function _InlineDensity___get_fontScale__impl__ao594c($this) {
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value = _get_packedValue__aj623s_0($this);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    return floatFromBits(bits);
  }
  function InlineDensity__toString_impl_9jhvwu($this) {
    return 'InlineDensity(density=' + _InlineDensity___get_density__impl__uz12rr($this) + ', fontScale=' + _InlineDensity___get_fontScale__impl__ao594c($this) + ')';
  }
  function Companion_23() {
    Companion_instance_33 = this;
    this.al5_1 = _InlineDensity___init__impl__1m7u8m_0(NaN, NaN);
  }
  var Companion_instance_33;
  function Companion_getInstance_82() {
    if (Companion_instance_33 == null)
      new Companion_23();
    return Companion_instance_33;
  }
  function InlineDensity__hashCode_impl_vanspp($this) {
    return $this.hashCode();
  }
  function InlineDensity__equals_impl_ppdv5r($this, other) {
    if (!(other instanceof InlineDensity))
      return false;
    var tmp0_other_with_cast = other.bl5_1;
    if (!equalsLong($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function InlineDensity(packedValue) {
    Companion_getInstance_82();
    this.bl5_1 = packedValue;
  }
  protoOf(InlineDensity).toString = function () {
    return InlineDensity__toString_impl_9jhvwu(this.bl5_1);
  };
  protoOf(InlineDensity).hashCode = function () {
    return InlineDensity__hashCode_impl_vanspp(this.bl5_1);
  };
  protoOf(InlineDensity).equals = function (other) {
    return InlineDensity__equals_impl_ppdv5r(this.bl5_1, other);
  };
  function finalConstraints(constraints, softWrap, overflow, maxIntrinsicWidth) {
    return Companion_instance_4.s5e(0, finalMaxWidth(constraints, softWrap, overflow, maxIntrinsicWidth), 0, _Constraints___get_maxHeight__impl__dt3e8z(constraints));
  }
  function finalMaxLines(softWrap, overflow, maxLinesIn) {
    var overwriteMaxLines = !softWrap && get_isEllipsis(overflow);
    return overwriteMaxLines ? 1 : coerceAtLeast_0(maxLinesIn, 1);
  }
  function finalMaxWidth(constraints, softWrap, overflow, maxIntrinsicWidth) {
    var widthMatters = softWrap || get_isEllipsis(overflow);
    var tmp;
    if (widthMatters && _Constraints___get_hasBoundedWidth__impl__7hd0wr(constraints)) {
      tmp = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    } else {
      tmp = 2147483647;
    }
    var maxWidth = tmp;
    var tmp_0;
    if (_Constraints___get_minWidth__impl__hi9lfi(constraints) === maxWidth) {
      tmp_0 = maxWidth;
    } else {
      tmp_0 = coerceIn_1(ceilToIntPx(maxIntrinsicWidth), _Constraints___get_minWidth__impl__hi9lfi(constraints), maxWidth);
    }
    return tmp_0;
  }
  function get_isEllipsis(_this__u8e3s4) {
    return _this__u8e3s4 === Companion_getInstance_39().x7s_1 || _this__u8e3s4 === Companion_getInstance_39().z7s_1 || _this__u8e3s4 === Companion_getInstance_39().a7t_1;
  }
  function get_EmptyTextReplacement_0() {
    _init_properties_MinLinesConstrainer_kt__odtdjv();
    return EmptyTextReplacement_0;
  }
  var EmptyTextReplacement_0;
  function get_TwoLineTextReplacement() {
    _init_properties_MinLinesConstrainer_kt__odtdjv();
    return TwoLineTextReplacement;
  }
  var TwoLineTextReplacement;
  var androidx_compose_foundation_text_modifiers_MinLinesConstrainer$stable;
  function Companion_24() {
    this.cl5_1 = null;
  }
  protoOf(Companion_24).dl5 = function (minMaxUtil, layoutDirection, paramStyle, density, fontFamilyResolver) {
    if (minMaxUtil == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (layoutDirection.equals(minMaxUtil.el5_1) && resolveDefaults(paramStyle, layoutDirection).equals(minMaxUtil.fl5_1) && density.u5e() === minMaxUtil.gl5_1.u5e() && fontFamilyResolver === minMaxUtil.hl5_1) {
        return minMaxUtil;
      }
    }
    var tmp1_safe_receiver = this.cl5_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (layoutDirection.equals(tmp1_safe_receiver.el5_1) && resolveDefaults(paramStyle, layoutDirection).equals(tmp1_safe_receiver.fl5_1) && density.u5e() === tmp1_safe_receiver.gl5_1.u5e() && fontFamilyResolver === tmp1_safe_receiver.hl5_1) {
        return tmp1_safe_receiver;
      }
    }
    // Inline function 'kotlin.also' call
    var this_0 = new MinLinesConstrainer(layoutDirection, resolveDefaults(paramStyle, layoutDirection), Density_0(density.u5e(), density.j5f()), fontFamilyResolver);
    Companion_instance_34.cl5_1 = this_0;
    return this_0;
  };
  var Companion_instance_34;
  function Companion_getInstance_83() {
    return Companion_instance_34;
  }
  function MinLinesConstrainer(layoutDirection, inputTextStyle, density, fontFamilyResolver) {
    this.el5_1 = layoutDirection;
    this.fl5_1 = inputTextStyle;
    this.gl5_1 = density;
    this.hl5_1 = fontFamilyResolver;
    this.il5_1 = resolveDefaults(this.fl5_1, this.el5_1);
    this.jl5_1 = NaN;
    this.kl5_1 = NaN;
  }
  protoOf(MinLinesConstrainer).ll5 = function (inConstraints, minLines) {
    var oneLineHeight = this.kl5_1;
    var lineHeight = this.jl5_1;
    if (isNaN_0(oneLineHeight) || isNaN_0(lineHeight)) {
      oneLineHeight = Paragraph(get_EmptyTextReplacement_0(), this.il5_1, Constraints_0(), this.gl5_1, this.hl5_1, VOID, VOID, 1, Companion_getInstance_39().w7s_1).i5e();
      var twoLineHeight = Paragraph(get_TwoLineTextReplacement(), this.il5_1, Constraints_0(), this.gl5_1, this.hl5_1, VOID, VOID, 2, Companion_getInstance_39().w7s_1).i5e();
      lineHeight = twoLineHeight - oneLineHeight;
      this.kl5_1 = oneLineHeight;
      this.jl5_1 = lineHeight;
    }
    var tmp;
    if (!(minLines === 1)) {
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = oneLineHeight + lineHeight * (minLines - 1 | 0);
      var tmp_0;
      if (isNaN_0(this_0)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_0);
      }
      var tmp$ret$0 = tmp_0;
      tmp = coerceAtMost(coerceAtLeast_0(tmp$ret$0, 0), _Constraints___get_maxHeight__impl__dt3e8z(inConstraints));
    } else {
      tmp = _Constraints___get_minHeight__impl__ev4bgx(inConstraints);
    }
    var minHeight = tmp;
    var tmp0_maxHeight = _Constraints___get_maxHeight__impl__dt3e8z(inConstraints);
    var tmp1_minWidth = _Constraints___get_minWidth__impl__hi9lfi(inConstraints);
    var tmp2_maxWidth = _Constraints___get_maxWidth__impl__uuyqc(inConstraints);
    return Constraints_0(tmp1_minWidth, tmp2_maxWidth, minHeight, tmp0_maxHeight);
  };
  var properties_initialized_MinLinesConstrainer_kt_uvu6cn;
  function _init_properties_MinLinesConstrainer_kt__odtdjv() {
    if (!properties_initialized_MinLinesConstrainer_kt_uvu6cn) {
      properties_initialized_MinLinesConstrainer_kt_uvu6cn = true;
      EmptyTextReplacement_0 = repeat('H', 10);
      TwoLineTextReplacement = get_EmptyTextReplacement_0() + '\n' + get_EmptyTextReplacement_0();
      androidx_compose_foundation_text_modifiers_MinLinesConstrainer$stable = 8;
    }
  }
  function get_DefaultFontSize() {
    _init_properties_MultiParagraphLayoutCache_kt__55bq8h();
    return DefaultFontSize;
  }
  var DefaultFontSize;
  var androidx_compose_foundation_text_modifiers_MultiParagraphLayoutCache$stable;
  function _set_style__ksk9mc($this, value) {
    var newStyleHasSameLayoutAffectingAttrs = value.p81($this.xl5_1);
    $this.xl5_1 = value;
    if (!newStyleHasSameLayoutAffectingAttrs) {
      markStyleAffectedDirty($this);
    }
  }
  function _get_fontSizeSearchScope__6avset($this) {
    if ($this.dl6_1 == null)
      $this.dl6_1 = new TextAutoSizeLayoutScopeImpl($this);
    return ensureNotNull($this.dl6_1);
  }
  function recordHistory($this, op) {
    $this.el6_1 = bitwiseOr(shiftLeft($this.el6_1, 2), _LayoutCacheOperation___get_flag__impl__t7gghn(op));
  }
  function useMinLinesConstrainer($this, constraints, layoutDirection) {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_instance_34.dl5($this.ul5_1, layoutDirection, $this.xl5_1, ensureNotNull($this.wl5_1), $this.nl5_1);
    $this.ul5_1 = this_0;
    var localMin = this_0;
    return localMin.ll5(constraints, $this.rl5_1);
  }
  function textLayoutResult($this, layoutDirection, finalConstraints, multiParagraph) {
    var tmp0 = multiParagraph.e7s_1.d62();
    // Inline function 'kotlin.math.min' call
    var b = multiParagraph.h7s_1;
    var layoutWidth = Math.min(tmp0, b);
    var tmp = $this.ml5_1;
    var tmp_0 = $this.xl5_1;
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = $this.sl5_1;
    var tmp$ret$1 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp_1 = TextLayoutInput_init_$Create$(tmp, tmp_0, tmp$ret$1, $this.ql5_1, $this.pl5_1, $this.ol5_1, ensureNotNull($this.wl5_1), layoutDirection, $this.nl5_1, finalConstraints);
    var tmp0_0 = ceilToIntPx(layoutWidth);
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = ceilToIntPx(multiParagraph.i7s_1);
    var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    var tmp$ret$2 = _IntSize___init__impl__emcjft(tmp$ret$3);
    return new TextLayoutResult(tmp_1, multiParagraph, constrain(finalConstraints, tmp$ret$2));
  }
  function setLayoutDirection($this, layoutDirection) {
    var localIntrinsics = $this.yl5_1;
    var tmp;
    if (localIntrinsics == null || !layoutDirection.equals($this.zl5_1) || localIntrinsics.a7v()) {
      $this.zl5_1 = layoutDirection;
      var tmp0_annotatedString = $this.ml5_1;
      var tmp1_style = resolveDefaults($this.xl5_1, layoutDirection);
      var tmp2_density = ensureNotNull($this.wl5_1);
      var tmp3_fontFamilyResolver = $this.nl5_1;
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = $this.sl5_1;
      var tmp4_placeholders = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      tmp = new MultiParagraphIntrinsics(tmp0_annotatedString, tmp1_style, tmp4_placeholders, tmp2_density, tmp3_fontFamilyResolver);
    } else {
      tmp = localIntrinsics;
    }
    var intrinsics = tmp;
    $this.yl5_1 = intrinsics;
    return intrinsics;
  }
  function layoutText_0($this, constraints, layoutDirection) {
    var localParagraphIntrinsics = setLayoutDirection($this, layoutDirection);
    return new MultiParagraph(localParagraphIntrinsics, finalConstraints(constraints, $this.pl5_1, $this.ol5_1, localParagraphIntrinsics.d62()), finalMaxLines($this.pl5_1, $this.ol5_1, $this.ql5_1), $this.ol5_1);
  }
  function newLayoutWillBeDifferent($this, $receiver, constraints, layoutDirection) {
    if ($receiver == null)
      return true;
    if ($receiver.f80_1.e7s_1.a7v())
      return true;
    if (!layoutDirection.equals($receiver.e80_1.x80_1))
      return true;
    if (equals(constraints, $receiver.e80_1.z80_1))
      return false;
    if (!(_Constraints___get_maxWidth__impl__uuyqc(constraints) === _Constraints___get_maxWidth__impl__uuyqc($receiver.e80_1.z80_1)))
      return true;
    if (!(_Constraints___get_minWidth__impl__hi9lfi(constraints) === _Constraints___get_minWidth__impl__hi9lfi($receiver.e80_1.z80_1)))
      return true;
    if (_Constraints___get_maxHeight__impl__dt3e8z(constraints) < $receiver.f80_1.i7s_1 || $receiver.f80_1.g7s_1) {
      return true;
    }
    return false;
  }
  function markDirty($this) {
    $this.yl5_1 = null;
    $this.al6_1 = null;
    $this.cl6_1 = -1;
    $this.bl6_1 = -1;
    $this.dl6_1 = null;
  }
  function markStyleAffectedDirty($this) {
    recordHistory($this, Companion_getInstance_84().fl6_1);
    $this.yl5_1 = null;
    $this.al6_1 = null;
    $this.cl6_1 = -1;
    $this.bl6_1 = -1;
  }
  function TextAutoSizeLayoutScopeImpl($outer) {
    this.kl6_1 = $outer;
    this.jl6_1 = null;
  }
  protoOf(TextAutoSizeLayoutScopeImpl).u5e = function () {
    return ensureNotNull(this.kl6_1.wl5_1).u5e();
  };
  protoOf(TextAutoSizeLayoutScopeImpl).j5f = function () {
    return ensureNotNull(this.kl6_1.wl5_1).j5f();
  };
  protoOf(TextAutoSizeLayoutScopeImpl).x5e = function (_this__u8e3s4) {
    if (_TextUnit___get_isEm__impl__esrmtl(_this__u8e3s4)) {
      // Inline function 'kotlin.check' call
      if (!!_TextUnit___get_isEm__impl__esrmtl(this.kl6_1.xl5_1.e82())) {
        var message = "InternalAutoSize -> toPx(): Cannot convert Em to Px when style.fontSize is Em\nDeclare the composable's style.fontSize with Sp units instead.";
        throw IllegalStateException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.check' call
      if (!!equals(this.kl6_1.xl5_1.e82(), Companion_getInstance_29().q5g_1)) {
        var message_0 = 'InternalAutoSize -> toPx(): Cannot convert Em to Px when style.fontSize is not set. Please specify a font size.';
        throw IllegalStateException_init_$Create$(toString(message_0));
      }
      return this.x5e(this.kl6_1.xl5_1.e82()) * _TextUnit___get_value__impl__hpbx0k(_this__u8e3s4);
    }
    return this.v5e(this.b5f(_this__u8e3s4));
  };
  function MultiParagraphLayoutCache(text, style, fontFamilyResolver, overflow, softWrap, maxLines, minLines, placeholders, autoSize) {
    overflow = overflow === VOID ? Companion_getInstance_39().w7s_1 : overflow;
    softWrap = softWrap === VOID ? true : softWrap;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    minLines = minLines === VOID ? 1 : minLines;
    placeholders = placeholders === VOID ? null : placeholders;
    autoSize = autoSize === VOID ? null : autoSize;
    this.ml5_1 = text;
    this.nl5_1 = fontFamilyResolver;
    this.ol5_1 = overflow;
    this.pl5_1 = softWrap;
    this.ql5_1 = maxLines;
    this.rl5_1 = minLines;
    this.sl5_1 = placeholders;
    this.tl5_1 = autoSize;
    this.ul5_1 = null;
    this.vl5_1 = Companion_getInstance_82().al5_1;
    this.wl5_1 = null;
    this.xl5_1 = style;
    this.yl5_1 = null;
    this.zl5_1 = null;
    this.al6_1 = null;
    this.bl6_1 = -1;
    this.cl6_1 = -1;
    this.dl6_1 = null;
    this.el6_1 = new Long(0, 0);
  }
  protoOf(MultiParagraphLayoutCache).ll6 = function (value) {
    var localField = this.wl5_1;
    var tmp;
    if (value == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = _InlineDensity___init__impl__1m7u8m_1(value);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp1_elvis_lhs;
    if ((tmp_1 == null ? null : new InlineDensity(tmp_1)) == null) {
      tmp_0 = Companion_getInstance_82().al5_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var newDensity = tmp_0;
    if (localField == null) {
      this.wl5_1 = value;
      this.vl5_1 = newDensity;
      return Unit_instance;
    }
    if (value == null || !equals(this.vl5_1, newDensity)) {
      this.wl5_1 = value;
      this.vl5_1 = newDensity;
      recordHistory(this, Companion_getInstance_84().gl6_1);
      markDirty(this);
    }
  };
  protoOf(MultiParagraphLayoutCache).xdd = function () {
    var tmp0_elvis_lhs = this.al6_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('Internal Error: MultiParagraphLayoutCache could not provide TextLayoutResult during the draw phase. Please report this bug on the official Issue Tracker with the following diagnostic information: ' + this.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(MultiParagraphLayoutCache).ml6 = function () {
    return this.al6_1;
  };
  protoOf(MultiParagraphLayoutCache).nl6 = function (constraints, layoutDirection) {
    recordHistory(this, Companion_getInstance_84().il6_1);
    var tmp;
    if (this.rl5_1 > 1) {
      tmp = useMinLinesConstrainer(this, constraints, layoutDirection);
    } else {
      tmp = constraints;
    }
    var finalConstraints = tmp;
    if (!newLayoutWillBeDifferent(this, this.al6_1, finalConstraints, layoutDirection)) {
      if (equals(finalConstraints, ensureNotNull(this.al6_1).e80_1.z80_1))
        return false;
      this.al6_1 = textLayoutResult(this, layoutDirection, finalConstraints, ensureNotNull(this.al6_1).f80_1);
      return true;
    }
    if (!(this.tl5_1 == null)) {
      this.zl5_1 = layoutDirection;
      var fontSizeBeforeLayout = this.xl5_1.e82();
      // Inline function 'kotlin.with' call
      var $this$with = ensureNotNull(this.tl5_1);
      // Inline function 'kotlin.with' call
      var $this$with_0 = _get_fontSizeSearchScope__6avset(this);
      var autoSizeFontSize = $this$with.ol6($this$with_0, constraints, this.ml5_1);
      if (_TextUnit___get_isEm__impl__esrmtl(autoSizeFontSize)) {
        autoSizeFontSize = times(fontSizeBeforeLayout, autoSizeFontSize);
      }
      var optimalFontSize = autoSizeFontSize;
      var autoSizeLayoutCache = _get_fontSizeSearchScope__6avset(this).jl6_1;
      if (!(autoSizeLayoutCache == null) && equals(optimalFontSize, autoSizeLayoutCache.e80_1.r80_1.e82()) && autoSizeLayoutCache.e80_1.v80_1 === this.ol5_1) {
        this.al6_1 = autoSizeLayoutCache;
        return true;
      }
      _set_style__ksk9mc(this, this.xl5_1.b82(VOID, optimalFontSize));
    }
    var multiParagraph = layoutText_0(this, finalConstraints, layoutDirection);
    this.al6_1 = textLayoutResult(this, layoutDirection, finalConstraints, multiParagraph);
    return true;
  };
  protoOf(MultiParagraphLayoutCache).pl6 = function (width, layoutDirection) {
    var localWidth = this.bl6_1;
    var localHeght = this.cl6_1;
    if (width === localWidth && !(localWidth === -1))
      return localHeght;
    var constraints = Constraints_0(0, width, 0, 2147483647);
    var tmp;
    if (this.rl5_1 > 1) {
      tmp = useMinLinesConstrainer(this, constraints, layoutDirection);
    } else {
      tmp = constraints;
    }
    var finalConstraints = tmp;
    var result = coerceAtLeast_0(ceilToIntPx(layoutText_0(this, finalConstraints, layoutDirection).i7s_1), _Constraints___get_minHeight__impl__ev4bgx(finalConstraints));
    this.bl6_1 = width;
    this.cl6_1 = result;
    return result;
  };
  protoOf(MultiParagraphLayoutCache).ql6 = function (text, style, fontFamilyResolver, overflow, softWrap, maxLines, minLines, placeholders, autoSize) {
    this.ml5_1 = text;
    _set_style__ksk9mc(this, style);
    this.nl5_1 = fontFamilyResolver;
    this.ol5_1 = overflow;
    this.pl5_1 = softWrap;
    this.ql5_1 = maxLines;
    this.rl5_1 = minLines;
    this.sl5_1 = placeholders;
    this.tl5_1 = autoSize;
    recordHistory(this, Companion_getInstance_84().hl6_1);
    markDirty(this);
  };
  protoOf(MultiParagraphLayoutCache).rl6 = function (layoutDirection) {
    return ceilToIntPx(setLayoutDirection(this, layoutDirection).d62());
  };
  protoOf(MultiParagraphLayoutCache).sl6 = function (layoutDirection) {
    return ceilToIntPx(setLayoutDirection(this, layoutDirection).c62());
  };
  protoOf(MultiParagraphLayoutCache).toString = function () {
    var tmp = 'MultiParagraphLayoutCache(textLayoutResult=' + (!(this.al6_1 == null) ? '<TextLayoutResult>' : 'null') + ', ';
    var tmp_0 = InlineDensity__toString_impl_9jhvwu(this.vl5_1);
    var tmp_1 = this.el6_1.toString();
    var tmp0_safe_receiver = this.al6_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e80_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.z80_1;
    var tmp_2;
    var tmp_3 = tmp2_elvis_lhs;
    if ((tmp_3 == null ? null : new Constraints(tmp_3)) == null) {
      tmp_2 = 'null';
    } else {
      tmp_2 = new Constraints(tmp2_elvis_lhs);
    }
    return tmp + ('lastDensity=' + tmp_0 + ', history=' + tmp_1 + ', constraints=' + toString(tmp_2) + ')');
  };
  function times(_this__u8e3s4, other) {
    _init_properties_MultiParagraphLayoutCache_kt__55bq8h();
    if (_TextUnit___get_isEm__impl__esrmtl(other)) {
      if (_TextUnit___get_isEm__impl__esrmtl(_this__u8e3s4)) {
        throw IllegalStateException_init_$Create$('Cannot convert Em to Px when style.fontSize is' + (' Em (' + TextUnit__toString_impl_51ghw0(other) + '). Please declare the style.fontSize') + ' with Sp units instead.');
      }
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      if (equalsLong(_TextUnit___get_rawType__impl__tu8yq5(_this__u8e3s4), new Long(0, 0))) {
        var tmp0 = get_DefaultFontSize();
        // Inline function 'androidx.compose.ui.unit.TextUnit.times' call
        var other_0 = _TextUnit___get_value__impl__hpbx0k(other);
        checkArithmetic(tmp0);
        return pack(_TextUnit___get_rawType__impl__tu8yq5(tmp0), _TextUnit___get_value__impl__hpbx0k(tmp0) * other_0);
      }
      // Inline function 'androidx.compose.ui.unit.TextUnit.times' call
      var other_1 = _TextUnit___get_value__impl__hpbx0k(other);
      checkArithmetic(_this__u8e3s4);
      return pack(_TextUnit___get_rawType__impl__tu8yq5(_this__u8e3s4), _TextUnit___get_value__impl__hpbx0k(_this__u8e3s4) * other_1);
    } else {
      throw IllegalArgumentException_init_$Create$('The multiplier must be in em, but was ' + TextUnit__toString_impl_51ghw0(other) + '.');
    }
  }
  var properties_initialized_MultiParagraphLayoutCache_kt_kae00j;
  function _init_properties_MultiParagraphLayoutCache_kt__55bq8h() {
    if (!properties_initialized_MultiParagraphLayoutCache_kt_kae00j) {
      properties_initialized_MultiParagraphLayoutCache_kt_kae00j = true;
      DefaultFontSize = get_sp(14);
      androidx_compose_foundation_text_modifiers_MultiParagraphLayoutCache$stable = 8;
    }
  }
  var androidx_compose_foundation_text_modifiers_ParagraphLayoutCache$stable;
  function recordHistory_0($this, op) {
    $this.ll7_1 = bitwiseOr(shiftLeft($this.ll7_1, 2), _LayoutCacheOperation___get_flag__impl__t7gghn(op));
  }
  function useMinLinesConstrainer_0($this, constraints, layoutDirection, style) {
    style = style === VOID ? $this.ul6_1 : style;
    // Inline function 'kotlin.also' call
    var this_0 = Companion_instance_34.dl5($this.fl7_1, layoutDirection, style, ensureNotNull($this.bl7_1), $this.vl6_1);
    $this.fl7_1 = this_0;
    var localMin = this_0;
    return localMin.ll5(constraints, $this.zl6_1);
  }
  function setLayoutDirection_0($this, layoutDirection) {
    var localIntrinsics = $this.gl7_1;
    var tmp;
    if (localIntrinsics == null || !layoutDirection.equals($this.hl7_1) || localIntrinsics.a7v()) {
      $this.hl7_1 = layoutDirection;
      var tmp_0 = $this.tl6_1;
      var tmp_1 = resolveDefaults($this.ul6_1, layoutDirection);
      // Inline function 'kotlin.collections.listOf' call
      var tmp_2 = emptyList();
      var tmp_3 = ensureNotNull($this.bl7_1);
      var tmp_4 = $this.vl6_1;
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$1 = emptyList();
      tmp = ParagraphIntrinsics(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp$ret$1);
    } else {
      tmp = localIntrinsics;
    }
    var intrinsics = tmp;
    $this.gl7_1 = intrinsics;
    return intrinsics;
  }
  function newLayoutWillBeDifferent_0($this, constraints, layoutDirection) {
    var tmp0_elvis_lhs = $this.cl7_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return true;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var localParagraph = tmp;
    var tmp1_elvis_lhs = $this.gl7_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return true;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var localParagraphIntrinsics = tmp_0;
    if (localParagraphIntrinsics.a7v())
      return true;
    if (!layoutDirection.equals($this.hl7_1))
      return true;
    if (equals(constraints, $this.il7_1))
      return false;
    if (!(_Constraints___get_maxWidth__impl__uuyqc(constraints) === _Constraints___get_maxWidth__impl__uuyqc($this.il7_1)))
      return true;
    if (!(_Constraints___get_minWidth__impl__hi9lfi(constraints) === _Constraints___get_minWidth__impl__hi9lfi($this.il7_1)))
      return true;
    if (_Constraints___get_maxHeight__impl__dt3e8z(constraints) < localParagraph.i5e() || localParagraph.f7t()) {
      return true;
    }
    return false;
  }
  function markDirty_0($this) {
    $this.cl7_1 = null;
    $this.gl7_1 = null;
    $this.hl7_1 = null;
    $this.jl7_1 = -1;
    $this.kl7_1 = -1;
    $this.il7_1 = Companion_instance_4.p5e(0, 0);
    var tmp = $this;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
    tmp.el7_1 = _IntSize___init__impl__emcjft(tmp$ret$1);
    $this.dl7_1 = false;
  }
  function ParagraphLayoutCache(text, style, fontFamilyResolver, overflow, softWrap, maxLines, minLines) {
    overflow = overflow === VOID ? Companion_getInstance_39().w7s_1 : overflow;
    softWrap = softWrap === VOID ? true : softWrap;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    minLines = minLines === VOID ? 1 : minLines;
    this.tl6_1 = text;
    this.ul6_1 = style;
    this.vl6_1 = fontFamilyResolver;
    this.wl6_1 = overflow;
    this.xl6_1 = softWrap;
    this.yl6_1 = maxLines;
    this.zl6_1 = minLines;
    this.al7_1 = Companion_getInstance_82().al5_1;
    this.bl7_1 = null;
    this.cl7_1 = null;
    this.dl7_1 = false;
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
    tmp.el7_1 = _IntSize___init__impl__emcjft(tmp$ret$1);
    this.fl7_1 = null;
    this.gl7_1 = null;
    this.hl7_1 = null;
    this.il7_1 = Companion_instance_4.p5e(0, 0);
    this.jl7_1 = -1;
    this.kl7_1 = -1;
    this.ll7_1 = new Long(0, 0);
  }
  protoOf(ParagraphLayoutCache).ll6 = function (value) {
    var localField = this.bl7_1;
    var tmp;
    if (value == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = _InlineDensity___init__impl__1m7u8m_1(value);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp1_elvis_lhs;
    if ((tmp_1 == null ? null : new InlineDensity(tmp_1)) == null) {
      tmp_0 = Companion_getInstance_82().al5_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var newDensity = tmp_0;
    if (localField == null) {
      this.bl7_1 = value;
      this.al7_1 = newDensity;
      return Unit_instance;
    }
    if (value == null || !equals(this.al7_1, newDensity)) {
      this.bl7_1 = value;
      this.al7_1 = newDensity;
      recordHistory_0(this, Companion_getInstance_84().gl6_1);
      markDirty_0(this);
    }
  };
  protoOf(ParagraphLayoutCache).ml7 = function () {
    var tmp0_safe_receiver = this.gl7_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.a7v();
  };
  protoOf(ParagraphLayoutCache).nl6 = function (constraints, layoutDirection) {
    recordHistory_0(this, Companion_getInstance_84().il6_1);
    var tmp;
    if (this.zl6_1 > 1) {
      tmp = useMinLinesConstrainer_0(this, constraints, layoutDirection);
    } else {
      tmp = constraints;
    }
    var finalConstraints = tmp;
    if (!newLayoutWillBeDifferent_0(this, finalConstraints, layoutDirection)) {
      if (!equals(finalConstraints, this.il7_1)) {
        var localParagraph = ensureNotNull(this.cl7_1);
        var tmp0 = localParagraph.d62();
        // Inline function 'kotlin.math.min' call
        var b = localParagraph.h5e();
        var layoutWidth = Math.min(tmp0, b);
        var tmp0_0 = ceilToIntPx(layoutWidth);
        // Inline function 'androidx.compose.ui.unit.IntSize' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2 = ceilToIntPx(localParagraph.i5e());
        var tmp$ret$2 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
        var tmp$ret$1 = _IntSize___init__impl__emcjft(tmp$ret$2);
        var localSize = constrain(finalConstraints, tmp$ret$1);
        this.el7_1 = localSize;
        var tmp_0 = this;
        var tmp_1;
        if (!(this.wl6_1 === Companion_getInstance_39().y7s_1)) {
          var tmp_2;
          // Inline function 'androidx.compose.ui.unit.IntSize.width' call
          // Inline function 'androidx.compose.ui.util.unpackInt1' call
          var value = _IntSize___get_packedValue__impl__uho7jf(localSize);
          if (convertToInt(shiftRight(value, 32)) < localParagraph.h5e()) {
            tmp_2 = true;
          } else {
            // Inline function 'androidx.compose.ui.unit.IntSize.height' call
            // Inline function 'androidx.compose.ui.util.unpackInt2' call
            var value_0 = _IntSize___get_packedValue__impl__uho7jf(localSize);
            tmp_2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0))) < localParagraph.i5e();
          }
          tmp_1 = tmp_2;
        } else {
          tmp_1 = false;
        }
        tmp_0.dl7_1 = tmp_1;
        this.il7_1 = finalConstraints;
      }
      return false;
    }
    var tmp_3 = this;
    // Inline function 'kotlin.also' call
    var this_0 = this.nl7(finalConstraints, layoutDirection);
    this.il7_1 = finalConstraints;
    var tmp0_1 = ceilToIntPx(this_0.h5e());
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2_0 = ceilToIntPx(this_0.i5e());
    var tmp$ret$10 = bitwiseOr(shiftLeft(fromInt(tmp0_1), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
    var tmp$ret$9 = _IntSize___init__impl__emcjft(tmp$ret$10);
    var localSize_0 = constrain(finalConstraints, tmp$ret$9);
    this.el7_1 = localSize_0;
    var tmp_4 = this;
    var tmp_5;
    if (!(this.wl6_1 === Companion_getInstance_39().y7s_1)) {
      var tmp_6;
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_1 = _IntSize___get_packedValue__impl__uho7jf(localSize_0);
      if (convertToInt(shiftRight(value_1, 32)) < this_0.h5e()) {
        tmp_6 = true;
      } else {
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_2 = _IntSize___get_packedValue__impl__uho7jf(localSize_0);
        tmp_6 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0))) < this_0.i5e();
      }
      tmp_5 = tmp_6;
    } else {
      tmp_5 = false;
    }
    tmp_4.dl7_1 = tmp_5;
    tmp_3.cl7_1 = this_0;
    return true;
  };
  protoOf(ParagraphLayoutCache).pl6 = function (width, layoutDirection) {
    var localWidth = this.jl7_1;
    var localHeght = this.kl7_1;
    if (width === localWidth && !(localWidth === -1))
      return localHeght;
    var constraints = Constraints_0(0, width, 0, 2147483647);
    var tmp;
    if (this.zl6_1 > 1) {
      tmp = useMinLinesConstrainer_0(this, constraints, layoutDirection);
    } else {
      tmp = constraints;
    }
    var finalConstraints = tmp;
    var result = coerceAtLeast_0(ceilToIntPx(this.nl7(finalConstraints, layoutDirection).i5e()), _Constraints___get_minHeight__impl__ev4bgx(finalConstraints));
    this.jl7_1 = width;
    this.kl7_1 = result;
    return result;
  };
  protoOf(ParagraphLayoutCache).ol7 = function (text, style, fontFamilyResolver, overflow, softWrap, maxLines, minLines) {
    this.tl6_1 = text;
    this.ul6_1 = style;
    this.vl6_1 = fontFamilyResolver;
    this.wl6_1 = overflow;
    this.xl6_1 = softWrap;
    this.yl6_1 = maxLines;
    this.zl6_1 = minLines;
    recordHistory_0(this, Companion_getInstance_84().hl6_1);
    markDirty_0(this);
  };
  protoOf(ParagraphLayoutCache).nl7 = function (constraints, layoutDirection) {
    var localParagraphIntrinsics = setLayoutDirection_0(this, layoutDirection);
    return Paragraph_0(localParagraphIntrinsics, finalConstraints(constraints, this.xl6_1, this.wl6_1, localParagraphIntrinsics.d62()), finalMaxLines(this.xl6_1, this.wl6_1, this.yl6_1), this.wl6_1);
  };
  protoOf(ParagraphLayoutCache).pl7 = function (style) {
    var tmp0_elvis_lhs = this.hl7_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var localLayoutDirection = tmp;
    var tmp1_elvis_lhs = this.bl7_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var localDensity = tmp_0;
    var annotatedString = AnnotatedString_init_$Create$(this.tl6_1);
    if (this.cl7_1 == null)
      return null;
    if (this.gl7_1 == null)
      return null;
    // Inline function 'androidx.compose.ui.unit.Constraints.copyMaxDimensions' call
    var this_0 = this.il7_1;
    var finalConstraints = _Constraints___init__impl__v8ud31(bitwiseAnd(_Constraints___get_value__impl__3ah2ax(this_0), new Long(3, -2)));
    return new TextLayoutResult(TextLayoutInput_init_$Create$(annotatedString, style, emptyList(), this.yl6_1, this.xl6_1, this.wl6_1, localDensity, localLayoutDirection, this.vl6_1, finalConstraints), new MultiParagraph(new MultiParagraphIntrinsics(annotatedString, style, emptyList(), localDensity, this.vl6_1), finalConstraints, this.yl6_1, this.wl6_1), this.el7_1);
  };
  protoOf(ParagraphLayoutCache).sl6 = function (layoutDirection) {
    return ceilToIntPx(setLayoutDirection_0(this, layoutDirection).c62());
  };
  protoOf(ParagraphLayoutCache).rl6 = function (layoutDirection) {
    return ceilToIntPx(setLayoutDirection_0(this, layoutDirection).d62());
  };
  protoOf(ParagraphLayoutCache).toString = function () {
    return 'ParagraphLayoutCache(paragraph=' + (!(this.cl7_1 == null) ? '<paragraph>' : 'null') + ', ' + ('lastDensity=' + InlineDensity__toString_impl_9jhvwu(this.al7_1) + ', history=' + this.ll7_1.toString() + ', constraints=$)');
  };
  function _LayoutCacheOperation___init__impl__wyxjqq(flag) {
    return flag;
  }
  function _LayoutCacheOperation___get_flag__impl__t7gghn($this) {
    return $this;
  }
  function Companion_25() {
    Companion_instance_35 = this;
    this.fl6_1 = _LayoutCacheOperation___init__impl__wyxjqq(new Long(0, 0));
    this.gl6_1 = _LayoutCacheOperation___init__impl__wyxjqq(new Long(1, 0));
    this.hl6_1 = _LayoutCacheOperation___init__impl__wyxjqq(new Long(2, 0));
    this.il6_1 = _LayoutCacheOperation___init__impl__wyxjqq(new Long(3, 0));
  }
  var Companion_instance_35;
  function Companion_getInstance_84() {
    if (Companion_instance_35 == null)
      new Companion_25();
    return Companion_instance_35;
  }
  var androidx_compose_foundation_text_modifiers_SelectableTextAnnotatedStringElement$stable;
  function SelectableTextAnnotatedStringElement(text, style, fontFamilyResolver, onTextLayout, overflow, softWrap, maxLines, minLines, placeholders, onPlaceholderLayout, selectionController, color, autoSize) {
    onTextLayout = onTextLayout === VOID ? null : onTextLayout;
    overflow = overflow === VOID ? Companion_getInstance_39().w7s_1 : overflow;
    softWrap = softWrap === VOID ? true : softWrap;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    minLines = minLines === VOID ? 1 : minLines;
    placeholders = placeholders === VOID ? null : placeholders;
    onPlaceholderLayout = onPlaceholderLayout === VOID ? null : onPlaceholderLayout;
    selectionController = selectionController === VOID ? null : selectionController;
    color = color === VOID ? null : color;
    autoSize = autoSize === VOID ? null : autoSize;
    ModifierNodeElement.call(this);
    this.rl7_1 = text;
    this.sl7_1 = style;
    this.tl7_1 = fontFamilyResolver;
    this.ul7_1 = onTextLayout;
    this.vl7_1 = overflow;
    this.wl7_1 = softWrap;
    this.xl7_1 = maxLines;
    this.yl7_1 = minLines;
    this.zl7_1 = placeholders;
    this.al8_1 = onPlaceholderLayout;
    this.bl8_1 = selectionController;
    this.cl8_1 = color;
    this.dl8_1 = autoSize;
  }
  protoOf(SelectableTextAnnotatedStringElement).r3d = function () {
    return new SelectableTextAnnotatedStringNode(this.rl7_1, this.sl7_1, this.tl7_1, this.ul7_1, this.vl7_1, this.wl7_1, this.xl7_1, this.yl7_1, this.zl7_1, this.al8_1, this.bl8_1, this.cl8_1, this.dl8_1);
  };
  protoOf(SelectableTextAnnotatedStringElement).el8 = function (node) {
    node.yl8(this.rl7_1, this.sl7_1, this.zl7_1, this.yl7_1, this.xl7_1, this.wl7_1, this.tl7_1, this.vl7_1, this.ul7_1, this.al8_1, this.bl8_1, this.cl8_1, this.dl8_1);
  };
  protoOf(SelectableTextAnnotatedStringElement).d8y = function (node) {
    return this.el8(node instanceof SelectableTextAnnotatedStringNode ? node : THROW_CCE());
  };
  protoOf(SelectableTextAnnotatedStringElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SelectableTextAnnotatedStringElement))
      return false;
    if (!equals(this.cl8_1, other.cl8_1))
      return false;
    if (!this.rl7_1.equals(other.rl7_1))
      return false;
    if (!this.sl7_1.equals(other.sl7_1))
      return false;
    if (!equals(this.zl7_1, other.zl7_1))
      return false;
    if (!equals(this.tl7_1, other.tl7_1))
      return false;
    if (!equals(this.dl8_1, other.dl8_1))
      return false;
    if (!(this.ul7_1 === other.ul7_1))
      return false;
    if (!(this.vl7_1 === other.vl7_1))
      return false;
    if (!(this.wl7_1 === other.wl7_1))
      return false;
    if (!(this.xl7_1 === other.xl7_1))
      return false;
    if (!(this.yl7_1 === other.yl7_1))
      return false;
    if (!(this.al8_1 === other.al8_1))
      return false;
    if (!equals(this.bl8_1, other.bl8_1))
      return false;
    return true;
  };
  protoOf(SelectableTextAnnotatedStringElement).hashCode = function () {
    var result = this.rl7_1.hashCode();
    result = imul(31, result) + this.sl7_1.hashCode() | 0;
    result = imul(31, result) + hashCode(this.tl7_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.ul7_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + TextOverflow__hashCode_impl_kqdwgt(this.vl7_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.wl7_1) | 0;
    result = imul(31, result) + this.xl7_1 | 0;
    result = imul(31, result) + this.yl7_1 | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.zl7_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : hashCode(tmp2_safe_receiver);
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_1 = imul(31, result);
    var tmp4_safe_receiver = this.al8_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : hashCode(tmp4_safe_receiver);
    result = tmp_1 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    var tmp_2 = imul(31, result);
    var tmp6_safe_receiver = this.bl8_1;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : hashCode(tmp6_safe_receiver);
    result = tmp_2 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0;
    var tmp_3 = imul(31, result);
    var tmp8_safe_receiver = this.dl8_1;
    var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.hashCode();
    result = tmp_3 + (tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs) | 0;
    var tmp_4 = imul(31, result);
    var tmp10_safe_receiver = this.cl8_1;
    var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : hashCode(tmp10_safe_receiver);
    result = tmp_4 + (tmp11_elvis_lhs == null ? 0 : tmp11_elvis_lhs) | 0;
    return result;
  };
  var androidx_compose_foundation_text_modifiers_SelectableTextAnnotatedStringNode$stable;
  function SelectableTextAnnotatedStringNode(text, style, fontFamilyResolver, onTextLayout, overflow, softWrap, maxLines, minLines, placeholders, onPlaceholderLayout, selectionController, overrideColor, autoSize, onShowTranslation) {
    onTextLayout = onTextLayout === VOID ? null : onTextLayout;
    overflow = overflow === VOID ? Companion_getInstance_39().w7s_1 : overflow;
    softWrap = softWrap === VOID ? true : softWrap;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    minLines = minLines === VOID ? 1 : minLines;
    placeholders = placeholders === VOID ? null : placeholders;
    onPlaceholderLayout = onPlaceholderLayout === VOID ? null : onPlaceholderLayout;
    selectionController = selectionController === VOID ? null : selectionController;
    overrideColor = overrideColor === VOID ? null : overrideColor;
    autoSize = autoSize === VOID ? null : autoSize;
    onShowTranslation = onShowTranslation === VOID ? null : onShowTranslation;
    DelegatingNode.call(this);
    this.vl8_1 = selectionController;
    this.wl8_1 = onShowTranslation;
    this.xl8_1 = this.tb1(new TextAnnotatedStringNode(text, style, fontFamilyResolver, onTextLayout, overflow, softWrap, maxLines, minLines, placeholders, onPlaceholderLayout, this.vl8_1, overrideColor, autoSize, this.wl8_1));
    // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
    if (this.vl8_1 == null) {
      var tmp$ret$1 = 'Do not use SelectionCapableStaticTextModifier unless selectionController != null';
      throwIllegalArgumentExceptionForNullCheck(tmp$ret$1);
    }
  }
  protoOf(SelectableTextAnnotatedStringNode).b8w = function () {
    return false;
  };
  protoOf(SelectableTextAnnotatedStringNode).eam = function (coordinates) {
    var tmp0_safe_receiver = this.vl8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zl8(coordinates);
    }
  };
  protoOf(SelectableTextAnnotatedStringNode).h92 = function (_this__u8e3s4) {
    return this.xl8_1.gla(_this__u8e3s4);
  };
  protoOf(SelectableTextAnnotatedStringNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    return this.xl8_1.hla(_this__u8e3s4, measurable, constraints);
  };
  protoOf(SelectableTextAnnotatedStringNode).o8y = function (_this__u8e3s4, measurable, height) {
    return this.xl8_1.ila(_this__u8e3s4, measurable, height);
  };
  protoOf(SelectableTextAnnotatedStringNode).p8y = function (_this__u8e3s4, measurable, width) {
    return this.xl8_1.jla(_this__u8e3s4, measurable, width);
  };
  protoOf(SelectableTextAnnotatedStringNode).q8y = function (_this__u8e3s4, measurable, height) {
    return this.xl8_1.kla(_this__u8e3s4, measurable, height);
  };
  protoOf(SelectableTextAnnotatedStringNode).r8y = function (_this__u8e3s4, measurable, width) {
    return this.xl8_1.lla(_this__u8e3s4, measurable, width);
  };
  protoOf(SelectableTextAnnotatedStringNode).yl8 = function (text, style, placeholders, minLines, maxLines, softWrap, fontFamilyResolver, overflow, onTextLayout, onPlaceholderLayout, selectionController, color, autoSize) {
    this.xl8_1.qla(this.xl8_1.mla(color, style), this.xl8_1.nla(text), this.xl8_1.ola(style, placeholders, minLines, maxLines, softWrap, fontFamilyResolver, overflow, autoSize), this.xl8_1.pla(onTextLayout, onPlaceholderLayout, selectionController, this.wl8_1));
    this.vl8_1 = selectionController;
    invalidateMeasurement(this);
  };
  var androidx_compose_foundation_text_modifiers_StaticTextSelectionParams$stable;
  var androidx_compose_foundation_text_modifiers_SelectionController$stable;
  function SelectionController$modifier$lambda(this$0) {
    return function () {
      return this$0.ujz_1.rla_1;
    };
  }
  function SelectionController$onRemembered$lambda(this$0) {
    return function () {
      return this$0.ujz_1.rla_1;
    };
  }
  function SelectionController$onRemembered$lambda_0(this$0) {
    return function () {
      return this$0.ujz_1.sla_1;
    };
  }
  function SelectionController(selectableId, selectionRegistrar, backgroundSelectionColor, params) {
    params = params === VOID ? Companion_getInstance_85().tla_1 : params;
    this.rjz_1 = selectableId;
    this.sjz_1 = selectionRegistrar;
    this.tjz_1 = backgroundSelectionColor;
    this.ujz_1 = params;
    this.vjz_1 = null;
    var tmp = this;
    tmp.wjz_1 = pointerHoverIcon(makeSelectionModifier(this.sjz_1, this.rjz_1, SelectionController$modifier$lambda(this)), Companion_getInstance_49().ca3_1);
  }
  protoOf(SelectionController).g3f = function () {
    var tmp = this;
    var tmp_0 = SelectionController$onRemembered$lambda(this);
    tmp.vjz_1 = this.sjz_1.ula(new MultiWidgetSelectionDelegate(this.rjz_1, tmp_0, SelectionController$onRemembered$lambda_0(this)));
  };
  protoOf(SelectionController).h3f = function () {
    var localSelectable = this.vjz_1;
    if (!(localSelectable == null)) {
      this.sjz_1.vla(localSelectable);
      this.vjz_1 = null;
    }
  };
  protoOf(SelectionController).i3f = function () {
    var localSelectable = this.vjz_1;
    if (!(localSelectable == null)) {
      this.sjz_1.vla(localSelectable);
      this.vjz_1 = null;
    }
  };
  protoOf(SelectionController).wla = function (textLayoutResult) {
    var prevTextLayoutResult = this.ujz_1.sla_1;
    if (!(prevTextLayoutResult == null) && !prevTextLayoutResult.e80_1.q80_1.equals(textLayoutResult.e80_1.q80_1)) {
      this.sjz_1.xla(this.rjz_1);
    }
    this.ujz_1 = this.ujz_1.yla(VOID, textLayoutResult);
  };
  protoOf(SelectionController).zl8 = function (coordinates) {
    this.ujz_1 = this.ujz_1.yla(coordinates);
    this.sjz_1.zla(this.rjz_1);
  };
  protoOf(SelectionController).alb = function (drawScope) {
    var tmp0_elvis_lhs = this.sjz_1.blb().lx(this.rjz_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var selection = tmp;
    var tmp_0;
    if (!selection.hlb_1) {
      tmp_0 = selection.flb_1.dlb_1;
    } else {
      tmp_0 = selection.glb_1.dlb_1;
    }
    var start = tmp_0;
    var tmp_1;
    if (!selection.hlb_1) {
      tmp_1 = selection.glb_1.dlb_1;
    } else {
      tmp_1 = selection.flb_1.dlb_1;
    }
    var end = tmp_1;
    if (start === end)
      return Unit_instance;
    var tmp1_safe_receiver = this.vjz_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ilb();
    var lastOffset = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
    var clippedStart = coerceAtMost(start, lastOffset);
    var clippedEnd = coerceAtMost(end, lastOffset);
    var tmp3_elvis_lhs = this.ujz_1.u7s(clippedStart, clippedEnd);
    var tmp_2;
    if (tmp3_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    var selectionPath = tmp_2;
    // Inline function 'kotlin.with' call
    if (this.ujz_1.jlb()) {
      // Inline function 'androidx.compose.ui.graphics.drawscope.clipRect' call
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_0 = drawScope.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var right = floatFromBits(bits);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_1 = drawScope.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var bottom = floatFromBits(bits_0);
      var clipOp = Companion_getInstance_5().d6e_1;
      // Inline function 'androidx.compose.ui.graphics.drawscope.withTransform' call
      // Inline function 'kotlin.with' call
      var $this$with = drawScope.v6p();
      var previousSize = $this$with.o5d();
      $this$with.x5u().t6d();
      try {
        $this$with.p6p().a6e(0.0, 0.0, right, bottom, clipOp);
        drawScope.k6q(selectionPath, this.tjz_1);
      }finally {
        $this$with.x5u().u6d();
        $this$with.o6p(previousSize);
      }
    } else {
      drawScope.k6q(selectionPath, this.tjz_1);
    }
  };
  function Companion_26() {
    Companion_instance_36 = this;
    this.tla_1 = new StaticTextSelectionParams(null, null);
  }
  var Companion_instance_36;
  function Companion_getInstance_85() {
    if (Companion_instance_36 == null)
      new Companion_26();
    return Companion_instance_36;
  }
  function StaticTextSelectionParams(layoutCoordinates, textLayoutResult) {
    Companion_getInstance_85();
    this.rla_1 = layoutCoordinates;
    this.sla_1 = textLayoutResult;
  }
  protoOf(StaticTextSelectionParams).u7s = function (start, end) {
    var tmp0_safe_receiver = this.sla_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u7s(start, end);
  };
  protoOf(StaticTextSelectionParams).jlb = function () {
    var tmp0_safe_receiver = this.sla_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = (!(tmp0_safe_receiver.e80_1.v80_1 === Companion_getInstance_39().y7s_1) && tmp0_safe_receiver.m80());
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(StaticTextSelectionParams).klb = function (layoutCoordinates, textLayoutResult) {
    return new StaticTextSelectionParams(layoutCoordinates, textLayoutResult);
  };
  protoOf(StaticTextSelectionParams).yla = function (layoutCoordinates, textLayoutResult, $super) {
    layoutCoordinates = layoutCoordinates === VOID ? this.rla_1 : layoutCoordinates;
    textLayoutResult = textLayoutResult === VOID ? this.sla_1 : textLayoutResult;
    return $super === VOID ? this.klb(layoutCoordinates, textLayoutResult) : $super.klb.call(this, layoutCoordinates, textLayoutResult);
  };
  var androidx_compose_foundation_text_modifiers_TextAnnotatedStringElement$stable;
  function TextAnnotatedStringElement(text, style, fontFamilyResolver, onTextLayout, overflow, softWrap, maxLines, minLines, placeholders, onPlaceholderLayout, selectionController, color, autoSize, onShowTranslation) {
    onTextLayout = onTextLayout === VOID ? null : onTextLayout;
    overflow = overflow === VOID ? Companion_getInstance_39().w7s_1 : overflow;
    softWrap = softWrap === VOID ? true : softWrap;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    minLines = minLines === VOID ? 1 : minLines;
    placeholders = placeholders === VOID ? null : placeholders;
    onPlaceholderLayout = onPlaceholderLayout === VOID ? null : onPlaceholderLayout;
    selectionController = selectionController === VOID ? null : selectionController;
    color = color === VOID ? null : color;
    autoSize = autoSize === VOID ? null : autoSize;
    onShowTranslation = onShowTranslation === VOID ? null : onShowTranslation;
    ModifierNodeElement.call(this);
    this.mlb_1 = text;
    this.nlb_1 = style;
    this.olb_1 = fontFamilyResolver;
    this.plb_1 = onTextLayout;
    this.qlb_1 = overflow;
    this.rlb_1 = softWrap;
    this.slb_1 = maxLines;
    this.tlb_1 = minLines;
    this.ulb_1 = placeholders;
    this.vlb_1 = onPlaceholderLayout;
    this.wlb_1 = selectionController;
    this.xlb_1 = color;
    this.ylb_1 = autoSize;
    this.zlb_1 = onShowTranslation;
  }
  protoOf(TextAnnotatedStringElement).r3d = function () {
    return new TextAnnotatedStringNode(this.mlb_1, this.nlb_1, this.olb_1, this.plb_1, this.qlb_1, this.rlb_1, this.slb_1, this.tlb_1, this.ulb_1, this.vlb_1, this.wlb_1, this.xlb_1, this.ylb_1, this.zlb_1);
  };
  protoOf(TextAnnotatedStringElement).alc = function (node) {
    node.qla(node.mla(this.xlb_1, this.nlb_1), node.nla(this.mlb_1), node.ola(this.nlb_1, this.ulb_1, this.tlb_1, this.slb_1, this.rlb_1, this.olb_1, this.qlb_1, this.ylb_1), node.pla(this.plb_1, this.vlb_1, this.wlb_1, this.zlb_1));
  };
  protoOf(TextAnnotatedStringElement).d8y = function (node) {
    return this.alc(node instanceof TextAnnotatedStringNode ? node : THROW_CCE());
  };
  protoOf(TextAnnotatedStringElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAnnotatedStringElement))
      return false;
    if (!equals(this.xlb_1, other.xlb_1))
      return false;
    if (!this.mlb_1.equals(other.mlb_1))
      return false;
    if (!this.nlb_1.equals(other.nlb_1))
      return false;
    if (!equals(this.ulb_1, other.ulb_1))
      return false;
    if (!equals(this.olb_1, other.olb_1))
      return false;
    if (!(this.plb_1 === other.plb_1))
      return false;
    if (!(this.zlb_1 === other.zlb_1))
      return false;
    if (!(this.qlb_1 === other.qlb_1))
      return false;
    if (!(this.rlb_1 === other.rlb_1))
      return false;
    if (!(this.slb_1 === other.slb_1))
      return false;
    if (!(this.tlb_1 === other.tlb_1))
      return false;
    if (!(this.vlb_1 === other.vlb_1))
      return false;
    if (!equals(this.wlb_1, other.wlb_1))
      return false;
    return true;
  };
  protoOf(TextAnnotatedStringElement).hashCode = function () {
    var result = this.mlb_1.hashCode();
    result = imul(31, result) + this.nlb_1.hashCode() | 0;
    result = imul(31, result) + hashCode(this.olb_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.plb_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + TextOverflow__hashCode_impl_kqdwgt(this.qlb_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.rlb_1) | 0;
    result = imul(31, result) + this.slb_1 | 0;
    result = imul(31, result) + this.tlb_1 | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.ulb_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : hashCode(tmp2_safe_receiver);
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_1 = imul(31, result);
    var tmp4_safe_receiver = this.vlb_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : hashCode(tmp4_safe_receiver);
    result = tmp_1 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    var tmp_2 = imul(31, result);
    var tmp6_safe_receiver = this.wlb_1;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : hashCode(tmp6_safe_receiver);
    result = tmp_2 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0;
    var tmp_3 = imul(31, result);
    var tmp8_safe_receiver = this.xlb_1;
    var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : hashCode(tmp8_safe_receiver);
    result = tmp_3 + (tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs) | 0;
    var tmp_4 = imul(31, result);
    var tmp10_safe_receiver = this.zlb_1;
    var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : hashCode(tmp10_safe_receiver);
    result = tmp_4 + (tmp11_elvis_lhs == null ? 0 : tmp11_elvis_lhs) | 0;
    return result;
  };
  var androidx_compose_foundation_text_modifiers_TextAnnotatedStringNode_TextSubstitutionValue$stable;
  var androidx_compose_foundation_text_modifiers_TextAnnotatedStringNode$stable;
  function _get_layoutCache__kch9ev($this) {
    if ($this.dla_1 == null) {
      $this.dla_1 = new MultiParagraphLayoutCache($this.ol9_1, $this.pl9_1, $this.ql9_1, $this.sl9_1, $this.tl9_1, $this.ul9_1, $this.vl9_1, $this.wl9_1, $this.ala_1);
    }
    return ensureNotNull($this.dla_1);
  }
  function getLayoutCache($this, density) {
    var tmp0_safe_receiver = $this.fla_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (tmp0_safe_receiver.ok0_1) {
        var tmp0_safe_receiver_0 = tmp0_safe_receiver.pk0_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.also' call
          tmp0_safe_receiver_0.ll6(density);
          return tmp0_safe_receiver_0;
        }
      }
    }
    // Inline function 'kotlin.also' call
    var this_0 = _get_layoutCache__kch9ev($this);
    this_0.ll6(density);
    return this_0;
  }
  function TextSubstitutionValue(original, substitution, isShowingSubstitution, layoutCache) {
    isShowingSubstitution = isShowingSubstitution === VOID ? false : isShowingSubstitution;
    layoutCache = layoutCache === VOID ? null : layoutCache;
    this.mk0_1 = original;
    this.nk0_1 = substitution;
    this.ok0_1 = isShowingSubstitution;
    this.pk0_1 = layoutCache;
  }
  protoOf(TextSubstitutionValue).toString = function () {
    return 'TextSubstitutionValue(original=' + this.mk0_1.toString() + ', substitution=' + this.nk0_1.toString() + ', isShowingSubstitution=' + this.ok0_1 + ', layoutCache=' + toString_0(this.pk0_1) + ')';
  };
  protoOf(TextSubstitutionValue).hashCode = function () {
    var result = this.mk0_1.hashCode();
    result = imul(result, 31) + this.nk0_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ok0_1) | 0;
    result = imul(result, 31) + (this.pk0_1 == null ? 0 : hashCode(this.pk0_1)) | 0;
    return result;
  };
  protoOf(TextSubstitutionValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextSubstitutionValue))
      return false;
    if (!this.mk0_1.equals(other.mk0_1))
      return false;
    if (!this.nk0_1.equals(other.nk0_1))
      return false;
    if (!(this.ok0_1 === other.ok0_1))
      return false;
    if (!equals(this.pk0_1, other.pk0_1))
      return false;
    return true;
  };
  function setSubstitution($this, updatedText) {
    var currentTextSubstitution = $this.fla_1;
    if (!(currentTextSubstitution == null)) {
      if (updatedText.equals(currentTextSubstitution.nk0_1)) {
        return false;
      }
      currentTextSubstitution.nk0_1 = updatedText;
      var tmp0_safe_receiver = currentTextSubstitution.pk0_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver.ql6(updatedText, $this.pl9_1, $this.ql9_1, $this.sl9_1, $this.tl9_1, $this.ul9_1, $this.vl9_1, emptyList(), $this.ala_1);
        tmp = Unit_instance;
      }
      if (tmp == null)
        return false;
    } else {
      var newTextSubstitution = new TextSubstitutionValue($this.ol9_1, updatedText);
      var substitutionLayoutCache = new MultiParagraphLayoutCache(updatedText, $this.pl9_1, $this.ql9_1, $this.sl9_1, $this.tl9_1, $this.ul9_1, $this.vl9_1, emptyList(), $this.ala_1);
      substitutionLayoutCache.ll6(_get_layoutCache__kch9ev($this).wl5_1);
      newTextSubstitution.pk0_1 = substitutionLayoutCache;
      $this.fla_1 = newTextSubstitution;
    }
    return true;
  }
  function invalidateForTranslate($this) {
    invalidateSemantics($this);
    invalidateMeasurement($this);
    invalidateDraw($this);
  }
  function TextAnnotatedStringNode$applySemantics$lambda(this$0) {
    return function (textLayoutResult) {
      var inputLayout = _get_layoutCache__kch9ev(this$0).ml6();
      var tmp;
      if (inputLayout == null) {
        tmp = null;
      } else {
        var tmp_0 = this$0.pl9_1;
        var tmp1_safe_receiver = this$0.zl9_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c6g();
        var tmp_1;
        var tmp_2 = tmp2_elvis_lhs;
        if ((tmp_2 == null ? null : new Color(tmp_2)) == null) {
          tmp_1 = Companion_getInstance().u6b_1;
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        tmp = inputLayout.p80(TextLayoutInput_init_$Create$(inputLayout.e80_1.q80_1, tmp_0.z81(tmp_1), inputLayout.e80_1.s80_1, inputLayout.e80_1.t80_1, inputLayout.e80_1.u80_1, inputLayout.e80_1.v80_1, inputLayout.e80_1.w80_1, inputLayout.e80_1.x80_1, inputLayout.e80_1.y80_1, inputLayout.e80_1.z80_1));
      }
      var tmp3_safe_receiver = tmp;
      var tmp_3;
      if (tmp3_safe_receiver == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.also' call
        textLayoutResult.j1(tmp3_safe_receiver);
        tmp_3 = tmp3_safe_receiver;
      }
      var layout = tmp_3;
      return !(layout == null);
    };
  }
  function TextAnnotatedStringNode$applySemantics$lambda_0(this$0) {
    return function (updatedText) {
      setSubstitution(this$0, updatedText);
      invalidateForTranslate(this$0);
      return true;
    };
  }
  function TextAnnotatedStringNode$applySemantics$lambda_1(this$0) {
    return function (it) {
      var tmp;
      if (this$0.fla_1 == null) {
        return false;
      }
      var tmp0_safe_receiver = this$0.bla_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(ensureNotNull(this$0.fla_1));
      var tmp1_safe_receiver = this$0.fla_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.ok0_1 = it;
      }
      invalidateForTranslate(this$0);
      return true;
    };
  }
  function TextAnnotatedStringNode$applySemantics$lambda_2(this$0) {
    return function () {
      this$0.blc();
      invalidateForTranslate(this$0);
      return true;
    };
  }
  function TextAnnotatedStringNode$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.jal($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function TextAnnotatedStringNode(text, style, fontFamilyResolver, onTextLayout, overflow, softWrap, maxLines, minLines, placeholders, onPlaceholderLayout, selectionController, overrideColor, autoSize, onShowTranslation) {
    onTextLayout = onTextLayout === VOID ? null : onTextLayout;
    overflow = overflow === VOID ? Companion_getInstance_39().w7s_1 : overflow;
    softWrap = softWrap === VOID ? true : softWrap;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    minLines = minLines === VOID ? 1 : minLines;
    placeholders = placeholders === VOID ? null : placeholders;
    onPlaceholderLayout = onPlaceholderLayout === VOID ? null : onPlaceholderLayout;
    selectionController = selectionController === VOID ? null : selectionController;
    overrideColor = overrideColor === VOID ? null : overrideColor;
    autoSize = autoSize === VOID ? null : autoSize;
    onShowTranslation = onShowTranslation === VOID ? null : onShowTranslation;
    Node.call(this);
    this.ol9_1 = text;
    this.pl9_1 = style;
    this.ql9_1 = fontFamilyResolver;
    this.rl9_1 = onTextLayout;
    this.sl9_1 = overflow;
    this.tl9_1 = softWrap;
    this.ul9_1 = maxLines;
    this.vl9_1 = minLines;
    this.wl9_1 = placeholders;
    this.xl9_1 = onPlaceholderLayout;
    this.yl9_1 = selectionController;
    this.zl9_1 = overrideColor;
    this.ala_1 = autoSize;
    this.bla_1 = onShowTranslation;
    this.cla_1 = null;
    this.dla_1 = null;
    this.ela_1 = null;
    this.fla_1 = null;
  }
  protoOf(TextAnnotatedStringNode).b8w = function () {
    return false;
  };
  protoOf(TextAnnotatedStringNode).mla = function (color, style) {
    var changed = false;
    if (!equals(color, this.zl9_1)) {
      changed = true;
    }
    this.zl9_1 = color;
    changed = changed || !style.x82(this.pl9_1);
    return changed;
  };
  protoOf(TextAnnotatedStringNode).nla = function (text) {
    var charDiff = !(this.ol9_1.h7q_1 === text.h7q_1);
    var annotationDiff = !this.ol9_1.a7r(text);
    var anyDiff = charDiff || annotationDiff;
    if (anyDiff) {
      this.ol9_1 = text;
    }
    if (charDiff) {
      this.blc();
    }
    return anyDiff;
  };
  protoOf(TextAnnotatedStringNode).ola = function (style, placeholders, minLines, maxLines, softWrap, fontFamilyResolver, overflow, autoSize) {
    var changed;
    changed = !this.pl9_1.p81(style);
    this.pl9_1 = style;
    if (!equals(this.wl9_1, placeholders)) {
      this.wl9_1 = placeholders;
      changed = true;
    }
    if (!(this.vl9_1 === minLines)) {
      this.vl9_1 = minLines;
      changed = true;
    }
    if (!(this.ul9_1 === maxLines)) {
      this.ul9_1 = maxLines;
      changed = true;
    }
    if (!(this.tl9_1 === softWrap)) {
      this.tl9_1 = softWrap;
      changed = true;
    }
    if (!equals(this.ql9_1, fontFamilyResolver)) {
      this.ql9_1 = fontFamilyResolver;
      changed = true;
    }
    if (!(this.sl9_1 === overflow)) {
      this.sl9_1 = overflow;
      changed = true;
    }
    if (!equals(this.ala_1, autoSize)) {
      this.ala_1 = autoSize;
      changed = true;
    }
    return changed;
  };
  protoOf(TextAnnotatedStringNode).pla = function (onTextLayout, onPlaceholderLayout, selectionController, onShowTranslation) {
    var changed = false;
    if (!(this.rl9_1 === onTextLayout)) {
      this.rl9_1 = onTextLayout;
      changed = true;
    }
    if (!(this.xl9_1 === onPlaceholderLayout)) {
      this.xl9_1 = onPlaceholderLayout;
      changed = true;
    }
    if (!equals(this.yl9_1, selectionController)) {
      this.yl9_1 = selectionController;
      changed = true;
    }
    if (!(this.bla_1 === onShowTranslation)) {
      this.bla_1 = onShowTranslation;
      changed = true;
    }
    return changed;
  };
  protoOf(TextAnnotatedStringNode).qla = function (drawChanged, textChanged, layoutChanged, callbacksChanged) {
    if (textChanged || layoutChanged || callbacksChanged) {
      _get_layoutCache__kch9ev(this).ql6(this.ol9_1, this.pl9_1, this.ql9_1, this.sl9_1, this.tl9_1, this.ul9_1, this.vl9_1, this.wl9_1, this.ala_1);
    }
    if (!this.z8v_1) {
      return Unit_instance;
    }
    if (textChanged || (drawChanged && !(this.ela_1 == null))) {
      invalidateSemantics(this);
    }
    if (textChanged || layoutChanged || callbacksChanged) {
      invalidateMeasurement(this);
      invalidateDraw(this);
    }
    if (drawChanged) {
      invalidateDraw(this);
    }
  };
  protoOf(TextAnnotatedStringNode).blc = function () {
    this.fla_1 = null;
  };
  protoOf(TextAnnotatedStringNode).l9i = function (_this__u8e3s4) {
    var localSemanticsTextLayoutResult = this.ela_1;
    if (localSemanticsTextLayoutResult == null) {
      localSemanticsTextLayoutResult = TextAnnotatedStringNode$applySemantics$lambda(this);
      this.ela_1 = localSemanticsTextLayoutResult;
    }
    set_text(_this__u8e3s4, this.ol9_1);
    var currentTextSubstitution = this.fla_1;
    if (!(currentTextSubstitution == null)) {
      set_textSubstitution(_this__u8e3s4, currentTextSubstitution.nk0_1);
      set_isShowingTextSubstitution(_this__u8e3s4, currentTextSubstitution.ok0_1);
    }
    setTextSubstitution(_this__u8e3s4, VOID, TextAnnotatedStringNode$applySemantics$lambda_0(this));
    showTextSubstitution(_this__u8e3s4, VOID, TextAnnotatedStringNode$applySemantics$lambda_1(this));
    clearTextSubstitution(_this__u8e3s4, VOID, TextAnnotatedStringNode$applySemantics$lambda_2(this));
    getTextLayoutResult(_this__u8e3s4, VOID, localSemanticsTextLayoutResult);
  };
  protoOf(TextAnnotatedStringNode).hla = function (measureScope, measurable, constraints) {
    return this.g8y(measureScope, measurable, constraints);
  };
  protoOf(TextAnnotatedStringNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    // Inline function 'androidx.compose.ui.util.trace' call
    var layoutCache = getLayoutCache(this, _this__u8e3s4);
    var didChangeLayout = layoutCache.nl6(constraints, _this__u8e3s4.r6p());
    var textLayoutResult = layoutCache.xdd();
    textLayoutResult.f80_1.e7s_1.a7v();
    if (didChangeLayout) {
      invalidateLayer(this);
      var tmp0_safe_receiver = this.rl9_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(textLayoutResult);
      var tmp1_safe_receiver = this.yl9_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.wla(textLayoutResult);
      }
      var tmp2_elvis_lhs = this.cla_1;
      var cache = tmp2_elvis_lhs == null ? LinkedHashMap_init_$Create$(2) : tmp2_elvis_lhs;
      var tmp2 = get_FirstBaseline();
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = textLayoutResult.h80_1;
      var tmp;
      if (isNaN_0(this_0)) {
        tmp = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp = roundToInt(this_0);
      }
      // Inline function 'kotlin.collections.set' call
      var value = tmp;
      cache.z2(tmp2, value);
      var tmp2_0 = get_LastBaseline();
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_1 = textLayoutResult.i80_1;
      var tmp_0;
      if (isNaN_0(this_1)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_1);
      }
      // Inline function 'kotlin.collections.set' call
      var value_0 = tmp_0;
      cache.z2(tmp2_0, value_0);
      this.cla_1 = cache;
    }
    var tmp3_safe_receiver = this.xl9_1;
    if (tmp3_safe_receiver == null)
      null;
    else
      tmp3_safe_receiver(textLayoutResult.j80_1);
    var tmp_1 = Companion_instance_4;
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_2 = textLayoutResult.g80_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_1 = _IntSize___get_packedValue__impl__uho7jf(this_2);
    var tmp_2 = convertToInt(shiftRight(value_1, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_3 = textLayoutResult.g80_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(this_3);
    var tmp_3 = convertToInt(shiftRight(value_2, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_4 = textLayoutResult.g80_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_3 = _IntSize___get_packedValue__impl__uho7jf(this_4);
    var tmp_4 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_5 = textLayoutResult.g80_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_4 = _IntSize___get_packedValue__impl__uho7jf(this_5);
    var tmp$ret$14 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
    var placeable = measurable.h8y(tmp_1.s5e(tmp_2, tmp_3, tmp_4, tmp$ret$14));
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_6 = textLayoutResult.g80_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_5 = _IntSize___get_packedValue__impl__uho7jf(this_6);
    var tmp_5 = convertToInt(shiftRight(value_5, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_7 = textLayoutResult.g80_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_6 = _IntSize___get_packedValue__impl__uho7jf(this_7);
    var tmp_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
    var tmp_7 = ensureNotNull(this.cla_1);
    return _this__u8e3s4.kag(tmp_5, tmp_6, tmp_7, TextAnnotatedStringNode$measure$lambda(placeable));
  };
  protoOf(TextAnnotatedStringNode).ila = function (intrinsicMeasureScope, measurable, height) {
    return this.o8y(intrinsicMeasureScope, measurable, height);
  };
  protoOf(TextAnnotatedStringNode).o8y = function (_this__u8e3s4, measurable, height) {
    return getLayoutCache(this, _this__u8e3s4).sl6(_this__u8e3s4.r6p());
  };
  protoOf(TextAnnotatedStringNode).jla = function (intrinsicMeasureScope, measurable, width) {
    return this.p8y(intrinsicMeasureScope, measurable, width);
  };
  protoOf(TextAnnotatedStringNode).p8y = function (_this__u8e3s4, measurable, width) {
    return getLayoutCache(this, _this__u8e3s4).pl6(width, _this__u8e3s4.r6p());
  };
  protoOf(TextAnnotatedStringNode).kla = function (intrinsicMeasureScope, measurable, height) {
    return this.q8y(intrinsicMeasureScope, measurable, height);
  };
  protoOf(TextAnnotatedStringNode).q8y = function (_this__u8e3s4, measurable, height) {
    return getLayoutCache(this, _this__u8e3s4).rl6(_this__u8e3s4.r6p());
  };
  protoOf(TextAnnotatedStringNode).lla = function (intrinsicMeasureScope, measurable, width) {
    return this.r8y(intrinsicMeasureScope, measurable, width);
  };
  protoOf(TextAnnotatedStringNode).r8y = function (_this__u8e3s4, measurable, width) {
    return getLayoutCache(this, _this__u8e3s4).pl6(width, _this__u8e3s4.r6p());
  };
  protoOf(TextAnnotatedStringNode).gla = function (contentDrawScope) {
    return this.h92(contentDrawScope);
  };
  protoOf(TextAnnotatedStringNode).h92 = function (_this__u8e3s4) {
    if (!this.z8v_1) {
      return Unit_instance;
    }
    var tmp0_safe_receiver = this.yl9_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.alb(_this__u8e3s4);
    }
    // Inline function 'androidx.compose.ui.graphics.drawscope.drawIntoCanvas' call
    var canvas = _this__u8e3s4.v6p().x5u();
    var layoutCache = getLayoutCache(this, _this__u8e3s4);
    var textLayoutResult = layoutCache.xdd();
    var localParagraph = textLayoutResult.f80_1;
    var willClip = textLayoutResult.m80() && !(this.sl9_1 === Companion_getInstance_39().y7s_1);
    if (willClip) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = textLayoutResult.g80_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var width = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_1 = textLayoutResult.g80_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      var height = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp = Companion_getInstance_6().g5d_1;
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1 = fromInt(toRawBits(width));
      var v2 = fromInt(toRawBits(height));
      var tmp$ret$7 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var tmp$ret$6 = _Size___init__impl__aywn0g(tmp$ret$7);
      var bounds = Rect_0(tmp, tmp$ret$6);
      canvas.t6d();
      canvas.b6e(bounds);
    }
    try {
      var tmp0_elvis_lhs = this.pl9_1.r81();
      var textDecoration = tmp0_elvis_lhs == null ? Companion_getInstance_36().a80_1 : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = this.pl9_1.q81();
      var shadow = tmp1_elvis_lhs == null ? Companion_getInstance_52().m6j_1 : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = this.pl9_1.s81();
      var drawStyle = tmp2_elvis_lhs == null ? Fill_getInstance() : tmp2_elvis_lhs;
      var brush = this.pl9_1.f7y();
      if (!(brush == null)) {
        var alpha = this.pl9_1.j68();
        localParagraph.o7t(canvas, brush, alpha, shadow, textDecoration, drawStyle);
      } else {
        var tmp4_safe_receiver = this.zl9_1;
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.c6g();
        var tmp_0;
        var tmp_1 = tmp5_elvis_lhs;
        if ((tmp_1 == null ? null : new Color(tmp_1)) == null) {
          tmp_0 = Companion_getInstance().u6b_1;
        } else {
          tmp_0 = tmp5_elvis_lhs;
        }
        var overrideColorVal = tmp_0;
        var tmp_2;
        // Inline function 'androidx.compose.ui.graphics.isSpecified' call
        if (!equals(_Color___get_value__impl__1pls5m(overrideColorVal), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
          tmp_2 = overrideColorVal;
        } else {
          // Inline function 'androidx.compose.ui.graphics.isSpecified' call
          var this_2 = this.pl9_1.s6c();
          if (!equals(_Color___get_value__impl__1pls5m(this_2), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
            tmp_2 = this.pl9_1.s6c();
          } else {
            tmp_2 = Companion_getInstance().i6b_1;
          }
        }
        var color = tmp_2;
        localParagraph.m7t(canvas, color, shadow, textDecoration, drawStyle);
      }
    }finally {
      if (willClip) {
        canvas.u6d();
      }
    }
    var tmp_3;
    var tmp6_safe_receiver = this.fla_1;
    if ((tmp6_safe_receiver == null ? null : tmp6_safe_receiver.ok0_1) === true) {
      tmp_3 = false;
    } else {
      tmp_3 = hasLinks(this.ol9_1);
    }
    var hasLinks_0 = tmp_3;
    var tmp_4;
    if (hasLinks_0) {
      tmp_4 = true;
    } else {
      // Inline function 'kotlin.collections.isNullOrEmpty' call
      var this_3 = this.wl9_1;
      tmp_4 = !(this_3 == null || this_3.r());
    }
    if (tmp_4) {
      _this__u8e3s4.z91();
    }
  };
  function hasLinks(_this__u8e3s4) {
    return _this__u8e3s4.z7q(0, _this__u8e3s4.a());
  }
  var androidx_compose_foundation_text_modifiers_SimpleTextAutoSizeLayoutScope$stable;
  var androidx_compose_foundation_text_modifiers_TextStringSimpleElement$stable;
  function TextStringSimpleElement(text, style, fontFamilyResolver, overflow, softWrap, maxLines, minLines, color) {
    overflow = overflow === VOID ? Companion_getInstance_39().w7s_1 : overflow;
    softWrap = softWrap === VOID ? true : softWrap;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    minLines = minLines === VOID ? 1 : minLines;
    color = color === VOID ? null : color;
    ModifierNodeElement.call(this);
    this.dlc_1 = text;
    this.elc_1 = style;
    this.flc_1 = fontFamilyResolver;
    this.glc_1 = overflow;
    this.hlc_1 = softWrap;
    this.ilc_1 = maxLines;
    this.jlc_1 = minLines;
    this.klc_1 = color;
  }
  protoOf(TextStringSimpleElement).r3d = function () {
    return new TextStringSimpleNode(this.dlc_1, this.elc_1, this.flc_1, this.glc_1, this.hlc_1, this.ilc_1, this.jlc_1, this.klc_1);
  };
  protoOf(TextStringSimpleElement).llc = function (node) {
    node.pld(node.mla(this.klc_1, this.elc_1), node.nld(this.dlc_1), node.old(this.elc_1, this.jlc_1, this.ilc_1, this.hlc_1, this.flc_1, this.glc_1));
  };
  protoOf(TextStringSimpleElement).d8y = function (node) {
    return this.llc(node instanceof TextStringSimpleNode ? node : THROW_CCE());
  };
  protoOf(TextStringSimpleElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextStringSimpleElement))
      return false;
    if (!equals(this.klc_1, other.klc_1))
      return false;
    if (!(this.dlc_1 === other.dlc_1))
      return false;
    if (!this.elc_1.equals(other.elc_1))
      return false;
    if (!equals(this.flc_1, other.flc_1))
      return false;
    if (!(this.glc_1 === other.glc_1))
      return false;
    if (!(this.hlc_1 === other.hlc_1))
      return false;
    if (!(this.ilc_1 === other.ilc_1))
      return false;
    if (!(this.jlc_1 === other.jlc_1))
      return false;
    return true;
  };
  protoOf(TextStringSimpleElement).hashCode = function () {
    var result = getStringHashCode(this.dlc_1);
    result = imul(31, result) + this.elc_1.hashCode() | 0;
    result = imul(31, result) + hashCode(this.flc_1) | 0;
    result = imul(31, result) + TextOverflow__hashCode_impl_kqdwgt(this.glc_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.hlc_1) | 0;
    result = imul(31, result) + this.ilc_1 | 0;
    result = imul(31, result) + this.jlc_1 | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.klc_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    return result;
  };
  var androidx_compose_foundation_text_modifiers_TextStringSimpleNode_TextSubstitutionValue$stable;
  var androidx_compose_foundation_text_modifiers_TextStringSimpleNode$stable;
  function _get_layoutCache__kch9ev_0($this) {
    var tmp;
    if (ComposeFoundationFlags_instance.jfg_1) {
      var tmp0_elvis_lhs = $this.kld_1;
      tmp = tmp0_elvis_lhs == null ? $this.bld_1 : tmp0_elvis_lhs;
    } else {
      tmp = $this.bld_1;
    }
    var style = tmp;
    if ($this.jld_1 == null) {
      $this.jld_1 = new ParagraphLayoutCache($this.ald_1, style, $this.cld_1, $this.dld_1, $this.eld_1, $this.fld_1, $this.gld_1);
    }
    return ensureNotNull($this.jld_1);
  }
  function getLayoutCacheForMeasure($this, $receiver) {
    if (ComposeFoundationFlags_instance.jfg_1) {
      if (resolveInheritedStyle($this, Companion_getInstance_86().jjz_1)) {
        var tmp0_elvis_lhs = $this.kld_1;
        var style = tmp0_elvis_lhs == null ? $this.bld_1 : tmp0_elvis_lhs;
        _get_layoutCache__kch9ev_0($this).ol7($this.ald_1, style, $this.cld_1, $this.dld_1, $this.eld_1, $this.fld_1, $this.gld_1);
      }
    }
    var activeCache = getLayoutCache_0($this);
    activeCache.ll6($receiver);
    return activeCache;
  }
  function resolveInheritedStyle($this, phase) {
    var previousStyle = $this.kld_1;
    var newInheritedStyle = inheritedTextStyle($this, phase, $this.bld_1);
    $this.kld_1 = newInheritedStyle;
    if (previousStyle == null)
      return false;
    return !equals(previousStyle, newInheritedStyle);
  }
  function getLayoutCache_0($this) {
    var tmp0_safe_receiver = $this.mld_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (tmp0_safe_receiver.sld_1) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.tld_1;
    return tmp2_elvis_lhs == null ? _get_layoutCache__kch9ev_0($this) : tmp2_elvis_lhs;
  }
  function TextSubstitutionValue_0(original, substitution, isShowingSubstitution, layoutCache) {
    isShowingSubstitution = isShowingSubstitution === VOID ? false : isShowingSubstitution;
    layoutCache = layoutCache === VOID ? null : layoutCache;
    this.qld_1 = original;
    this.rld_1 = substitution;
    this.sld_1 = isShowingSubstitution;
    this.tld_1 = layoutCache;
  }
  protoOf(TextSubstitutionValue_0).toString = function () {
    return 'TextSubstitution(' + ('layoutCache=' + toString_0(this.tld_1) + ', isShowingSubstitution=' + this.sld_1) + ')';
  };
  protoOf(TextSubstitutionValue_0).hashCode = function () {
    var result = getStringHashCode(this.qld_1);
    result = imul(result, 31) + getStringHashCode(this.rld_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.sld_1) | 0;
    result = imul(result, 31) + (this.tld_1 == null ? 0 : hashCode(this.tld_1)) | 0;
    return result;
  };
  protoOf(TextSubstitutionValue_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextSubstitutionValue_0))
      return false;
    if (!(this.qld_1 === other.qld_1))
      return false;
    if (!(this.rld_1 === other.rld_1))
      return false;
    if (!(this.sld_1 === other.sld_1))
      return false;
    if (!equals(this.tld_1, other.tld_1))
      return false;
    return true;
  };
  function setSubstitution_0($this, updatedText) {
    var currentTextSubstitution = $this.mld_1;
    if (!(currentTextSubstitution == null)) {
      if (updatedText === currentTextSubstitution.rld_1) {
        return false;
      }
      currentTextSubstitution.rld_1 = updatedText;
      var tmp0_safe_receiver = currentTextSubstitution.tld_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver.ol7(updatedText, $this.bld_1, $this.cld_1, $this.dld_1, $this.eld_1, $this.fld_1, $this.gld_1);
        tmp = Unit_instance;
      }
      if (tmp == null)
        return false;
    } else {
      var newTextSubstitution = new TextSubstitutionValue_0($this.ald_1, updatedText);
      var substitutionLayoutCache = new ParagraphLayoutCache(updatedText, $this.bld_1, $this.cld_1, $this.dld_1, $this.eld_1, $this.fld_1, $this.gld_1);
      substitutionLayoutCache.ll6(_get_layoutCache__kch9ev_0($this).bl7_1);
      newTextSubstitution.tld_1 = substitutionLayoutCache;
      $this.mld_1 = newTextSubstitution;
    }
    return true;
  }
  function clearSubstitution($this) {
    $this.mld_1 = null;
  }
  function invalidateForTranslate_0($this) {
    invalidateSemantics($this);
    invalidateMeasurement($this);
    invalidateDraw($this);
  }
  function TextStringSimpleNode$applySemantics$lambda(this$0) {
    return function (textLayoutResult) {
      var tmp = _get_layoutCache__kch9ev_0(this$0);
      var tmp_0 = this$0.bld_1;
      var tmp0_safe_receiver = this$0.hld_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c6g();
      var tmp_1;
      var tmp_2 = tmp1_elvis_lhs;
      if ((tmp_2 == null ? null : new Color(tmp_2)) == null) {
        tmp_1 = Companion_getInstance().u6b_1;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var tmp2_safe_receiver = tmp.pl7(tmp_0.z81(tmp_1));
      var tmp_3;
      if (tmp2_safe_receiver == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.also' call
        textLayoutResult.j1(tmp2_safe_receiver);
        tmp_3 = tmp2_safe_receiver;
      }
      var layout = tmp_3;
      return !(layout == null);
    };
  }
  function TextStringSimpleNode$applySemantics$lambda_0(this$0) {
    return function (updatedText) {
      setSubstitution_0(this$0, updatedText.h7q_1);
      invalidateForTranslate_0(this$0);
      return true;
    };
  }
  function TextStringSimpleNode$applySemantics$lambda_1(this$0) {
    return function (it) {
      var tmp;
      if (this$0.mld_1 == null) {
        return false;
      }
      var tmp0_safe_receiver = this$0.mld_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.sld_1 = it;
      }
      invalidateForTranslate_0(this$0);
      return true;
    };
  }
  function TextStringSimpleNode$applySemantics$lambda_2(this$0) {
    return function () {
      clearSubstitution(this$0);
      invalidateForTranslate_0(this$0);
      return true;
    };
  }
  function TextStringSimpleNode$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.jal($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function TextStringSimpleNode(text, style, fontFamilyResolver, overflow, softWrap, maxLines, minLines, overrideColor) {
    overflow = overflow === VOID ? Companion_getInstance_39().w7s_1 : overflow;
    softWrap = softWrap === VOID ? true : softWrap;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    minLines = minLines === VOID ? 1 : minLines;
    overrideColor = overrideColor === VOID ? null : overrideColor;
    Node.call(this);
    this.ald_1 = text;
    this.bld_1 = style;
    this.cld_1 = fontFamilyResolver;
    this.dld_1 = overflow;
    this.eld_1 = softWrap;
    this.fld_1 = maxLines;
    this.gld_1 = minLines;
    this.hld_1 = overrideColor;
    this.ild_1 = null;
    this.jld_1 = null;
    this.kld_1 = null;
    this.lld_1 = null;
    this.mld_1 = null;
  }
  protoOf(TextStringSimpleNode).b8w = function () {
    return false;
  };
  protoOf(TextStringSimpleNode).mla = function (color, style) {
    var changed = false;
    if (!equals(color, this.hld_1)) {
      changed = true;
    }
    this.hld_1 = color;
    changed = changed || !style.x82(this.bld_1);
    return changed;
  };
  protoOf(TextStringSimpleNode).nld = function (text) {
    if (this.ald_1 === text)
      return false;
    this.ald_1 = text;
    clearSubstitution(this);
    return true;
  };
  protoOf(TextStringSimpleNode).old = function (style, minLines, maxLines, softWrap, fontFamilyResolver, overflow) {
    var changed;
    changed = !this.bld_1.p81(style);
    this.bld_1 = style;
    if (!(this.gld_1 === minLines)) {
      this.gld_1 = minLines;
      changed = true;
    }
    if (!(this.fld_1 === maxLines)) {
      this.fld_1 = maxLines;
      changed = true;
    }
    if (!(this.eld_1 === softWrap)) {
      this.eld_1 = softWrap;
      changed = true;
    }
    if (!equals(this.cld_1, fontFamilyResolver)) {
      this.cld_1 = fontFamilyResolver;
      changed = true;
    }
    if (!(this.dld_1 === overflow)) {
      this.dld_1 = overflow;
      changed = true;
    }
    return changed;
  };
  protoOf(TextStringSimpleNode).pld = function (drawChanged, textChanged, layoutChanged) {
    if (drawChanged || textChanged || layoutChanged) {
      this.kld_1 = null;
    }
    if (textChanged || layoutChanged) {
      _get_layoutCache__kch9ev_0(this).ol7(this.ald_1, this.bld_1, this.cld_1, this.dld_1, this.eld_1, this.fld_1, this.gld_1);
    }
    if (!this.z8v_1) {
      return Unit_instance;
    }
    if (textChanged || (drawChanged && !(this.lld_1 == null))) {
      invalidateSemantics(this);
    }
    if (textChanged || layoutChanged) {
      invalidateMeasurement(this);
      invalidateDraw(this);
    }
    if (drawChanged) {
      invalidateDraw(this);
    }
  };
  protoOf(TextStringSimpleNode).l9i = function (_this__u8e3s4) {
    var localSemanticsTextLayoutResult = this.lld_1;
    if (localSemanticsTextLayoutResult == null) {
      localSemanticsTextLayoutResult = TextStringSimpleNode$applySemantics$lambda(this);
      this.lld_1 = localSemanticsTextLayoutResult;
    }
    set_text(_this__u8e3s4, AnnotatedString_init_$Create$(this.ald_1));
    var currentTextSubstitution = this.mld_1;
    if (!(currentTextSubstitution == null)) {
      set_isShowingTextSubstitution(_this__u8e3s4, currentTextSubstitution.sld_1);
      set_textSubstitution(_this__u8e3s4, AnnotatedString_init_$Create$(currentTextSubstitution.rld_1));
    }
    setTextSubstitution(_this__u8e3s4, VOID, TextStringSimpleNode$applySemantics$lambda_0(this));
    showTextSubstitution(_this__u8e3s4, VOID, TextStringSimpleNode$applySemantics$lambda_1(this));
    clearTextSubstitution(_this__u8e3s4, VOID, TextStringSimpleNode$applySemantics$lambda_2(this));
    getTextLayoutResult(_this__u8e3s4, VOID, localSemanticsTextLayoutResult);
  };
  protoOf(TextStringSimpleNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    // Inline function 'androidx.compose.ui.util.trace' call
    var layoutCache = getLayoutCacheForMeasure(this, _this__u8e3s4);
    var didChangeLayout = layoutCache.nl6(constraints, _this__u8e3s4.r6p());
    layoutCache.ml7();
    var paragraph = ensureNotNull(layoutCache.cl7_1);
    var layoutSize = layoutCache.el7_1;
    if (didChangeLayout) {
      invalidateLayer(this);
      var cache = this.ild_1;
      if (cache == null) {
        cache = HashMap_init_$Create$(2);
        this.ild_1 = cache;
      }
      var tmp0 = cache;
      var tmp2 = get_FirstBaseline();
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = paragraph.i7t();
      var tmp;
      if (isNaN_0(this_0)) {
        tmp = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp = roundToInt(this_0);
      }
      // Inline function 'kotlin.collections.set' call
      var value = tmp;
      tmp0.z2(tmp2, value);
      var tmp0_0 = cache;
      var tmp2_0 = get_LastBaseline();
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_1 = paragraph.j7t();
      var tmp_0;
      if (isNaN_0(this_1)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_1);
      }
      // Inline function 'kotlin.collections.set' call
      var value_0 = tmp_0;
      tmp0_0.z2(tmp2_0, value_0);
    }
    var tmp_1 = Companion_instance_4;
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_1 = _IntSize___get_packedValue__impl__uho7jf(layoutSize);
    var tmp_2 = convertToInt(shiftRight(value_1, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(layoutSize);
    var tmp_3 = convertToInt(shiftRight(value_2, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_3 = _IntSize___get_packedValue__impl__uho7jf(layoutSize);
    var tmp_4 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_4 = _IntSize___get_packedValue__impl__uho7jf(layoutSize);
    var tmp$ret$14 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
    var placeable = measurable.h8y(tmp_1.s5e(tmp_2, tmp_3, tmp_4, tmp$ret$14));
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_5 = _IntSize___get_packedValue__impl__uho7jf(layoutSize);
    var tmp_5 = convertToInt(shiftRight(value_5, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_6 = _IntSize___get_packedValue__impl__uho7jf(layoutSize);
    var tmp_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
    var tmp_7 = ensureNotNull(this.ild_1);
    return _this__u8e3s4.kag(tmp_5, tmp_6, tmp_7, TextStringSimpleNode$measure$lambda(placeable));
  };
  protoOf(TextStringSimpleNode).o8y = function (_this__u8e3s4, measurable, height) {
    return getLayoutCacheForMeasure(this, _this__u8e3s4).sl6(_this__u8e3s4.r6p());
  };
  protoOf(TextStringSimpleNode).p8y = function (_this__u8e3s4, measurable, width) {
    return getLayoutCacheForMeasure(this, _this__u8e3s4).pl6(width, _this__u8e3s4.r6p());
  };
  protoOf(TextStringSimpleNode).q8y = function (_this__u8e3s4, measurable, height) {
    return getLayoutCacheForMeasure(this, _this__u8e3s4).rl6(_this__u8e3s4.r6p());
  };
  protoOf(TextStringSimpleNode).r8y = function (_this__u8e3s4, measurable, width) {
    return getLayoutCacheForMeasure(this, _this__u8e3s4).pl6(width, _this__u8e3s4.r6p());
  };
  protoOf(TextStringSimpleNode).h92 = function (_this__u8e3s4) {
    if (!this.z8v_1) {
      return Unit_instance;
    }
    var layoutCache = getLayoutCache_0(this);
    // Inline function 'androidx.compose.foundation.internal.requirePreconditionNotNull' call
    var value = layoutCache.cl7_1;
    if (value == null) {
      var tmp$ret$1 = 'Internal Error: ParagraphLayoutCache could not provide a Paragraph during the draw phase. Please report this bug on the official Issue Tracker with the following diagnostic information: (layoutCache=' + toString_0(this.jld_1) + ', textSubstitution=' + toString_0(this.mld_1) + ')';
      throwIllegalArgumentExceptionForNullCheck(tmp$ret$1);
    }
    var localParagraph = value;
    // Inline function 'androidx.compose.ui.graphics.drawscope.drawIntoCanvas' call
    var canvas = _this__u8e3s4.v6p().x5u();
    var willClip = layoutCache.dl7_1;
    if (willClip) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = layoutCache.el7_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var width = convertToInt(shiftRight(value_0, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_1 = layoutCache.el7_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_1 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      var height = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
      canvas.t6d();
      canvas.e6e(0.0, 0.0, width, height);
    }
    try {
      var tmp;
      if (ComposeFoundationFlags_instance.jfg_1) {
        resolveInheritedStyle(this, Companion_getInstance_86().kjz_1);
        var tmp0_elvis_lhs = this.kld_1;
        tmp = tmp0_elvis_lhs == null ? this.bld_1 : tmp0_elvis_lhs;
      } else {
        tmp = this.bld_1;
      }
      var style = tmp;
      var tmp1_elvis_lhs = style.r81();
      var textDecoration = tmp1_elvis_lhs == null ? Companion_getInstance_36().a80_1 : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = style.q81();
      var shadow = tmp2_elvis_lhs == null ? Companion_getInstance_52().m6j_1 : tmp2_elvis_lhs;
      var tmp3_elvis_lhs = style.s81();
      var drawStyle = tmp3_elvis_lhs == null ? Fill_getInstance() : tmp3_elvis_lhs;
      var brush = style.f7y();
      if (!(brush == null)) {
        var alpha = style.j68();
        localParagraph.f8g(canvas, brush, alpha, shadow, textDecoration, drawStyle);
      } else {
        var tmp5_safe_receiver = this.hld_1;
        var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.c6g();
        var tmp_0;
        var tmp_1 = tmp6_elvis_lhs;
        if ((tmp_1 == null ? null : new Color(tmp_1)) == null) {
          tmp_0 = Companion_getInstance().u6b_1;
        } else {
          tmp_0 = tmp6_elvis_lhs;
        }
        var overrideColorVal = tmp_0;
        var tmp_2;
        // Inline function 'androidx.compose.ui.graphics.isSpecified' call
        if (!equals(_Color___get_value__impl__1pls5m(overrideColorVal), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
          tmp_2 = overrideColorVal;
        } else {
          // Inline function 'androidx.compose.ui.graphics.isSpecified' call
          var this_2 = style.s6c();
          if (!equals(_Color___get_value__impl__1pls5m(this_2), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
            tmp_2 = style.s6c();
          } else {
            tmp_2 = Companion_getInstance().i6b_1;
          }
        }
        var color = tmp_2;
        localParagraph.e8g(canvas, color, shadow, textDecoration, drawStyle);
      }
    }finally {
      if (willClip) {
        canvas.u6d();
      }
    }
  };
  function _StylePhase___init__impl__hlbmkp(value) {
    return value;
  }
  function Companion_27() {
    Companion_instance_37 = this;
    this.jjz_1 = _StylePhase___init__impl__hlbmkp(1);
    this.kjz_1 = _StylePhase___init__impl__hlbmkp(2);
    this.ljz_1 = _StylePhase___init__impl__hlbmkp(-1);
  }
  var Companion_instance_37;
  function Companion_getInstance_86() {
    if (Companion_instance_37 == null)
      new Companion_27();
    return Companion_instance_37;
  }
  function inheritedTextStyle(_this__u8e3s4, phase, fallback) {
    var result = {_v: fallback};
    traverseAncestors(_this__u8e3s4, 'StyleOuterNode', inheritedTextStyle$lambda(result, phase, fallback));
    return result._v;
  }
  function inheritedTextStyle$lambda($result, $phase, $fallback) {
    return function (it) {
      var tmp;
      if (it instanceof StyleOuterNode) {
        $result._v = it.ejz($phase, $fallback);
        tmp = false;
      } else {
        tmp = true;
      }
      return tmp;
    };
  }
  var androidx_compose_foundation_text_selection_MultiWidgetSelectionDelegate$stable;
  function _get_lastVisibleOffset__v7xite($this, $receiver) {
    // Inline function 'androidx.compose.foundation.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    $this.xld_1;
    if (!($this.yld_1 === $receiver)) {
      var tmp;
      if (!$receiver.k80() || $receiver.f80_1.g7s_1) {
        tmp = $receiver.e7t() - 1 | 0;
      } else {
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        var this_0 = $receiver.g80_1;
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
        var tmp$ret$3 = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
        var finalVisibleLine = coerceAtMost($receiver.p7t(tmp$ret$3), $receiver.e7t() - 1 | 0);
        $l$loop: while (true) {
          var tmp_0;
          if (finalVisibleLine >= 0) {
            var tmp_1 = $receiver.h7u(finalVisibleLine);
            // Inline function 'androidx.compose.ui.unit.IntSize.height' call
            var this_1 = $receiver.g80_1;
            // Inline function 'androidx.compose.ui.util.unpackInt2' call
            var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
            tmp_0 = tmp_1 >= convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
          } else {
            tmp_0 = false;
          }
          if (!tmp_0) {
            break $l$loop;
          }
          finalVisibleLine = finalVisibleLine - 1 | 0;
        }
        tmp = coerceAtLeast_0(finalVisibleLine, 0);
      }
      var lastVisibleLine = tmp;
      $this.zld_1 = $receiver.l7u(lastVisibleLine, true);
      $this.yld_1 = $receiver;
    }
    return $this.zld_1;
  }
  function MultiWidgetSelectionDelegate(selectableId, coordinatesCallback, layoutResultCallback) {
    this.uld_1 = selectableId;
    this.vld_1 = coordinatesCallback;
    this.wld_1 = layoutResultCallback;
    var tmp = this;
    // Inline function 'androidx.compose.foundation.platform.makeSynchronizedObject' call
    tmp.xld_1 = new SynchronizedObject();
    this.yld_1 = null;
    this.zld_1 = -1;
  }
  protoOf(MultiWidgetSelectionDelegate).ilb = function () {
    var tmp0_elvis_lhs = this.wld_1();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return 0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var textLayoutResult = tmp;
    return _get_lastVisibleOffset__v7xite(this, textLayoutResult);
  };
  var SelectedTextType_EditableText_instance;
  var SelectedTextType_StaticText_instance;
  var SelectedTextType_entriesInitialized;
  function SelectedTextType_initEntries() {
    if (SelectedTextType_entriesInitialized)
      return Unit_instance;
    SelectedTextType_entriesInitialized = true;
    SelectedTextType_EditableText_instance = new SelectedTextType('EditableText', 0);
    SelectedTextType_StaticText_instance = new SelectedTextType('StaticText', 1);
  }
  function SelectedTextType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SelectedTextType_EditableText_getInstance() {
    SelectedTextType_initEntries();
    return SelectedTextType_EditableText_instance;
  }
  var androidx_compose_foundation_text_selection_Selection_AnchorInfo$stable;
  var androidx_compose_foundation_text_selection_Selection$stable;
  function AnchorInfo(direction, offset, selectableId) {
    this.clb_1 = direction;
    this.dlb_1 = offset;
    this.elb_1 = selectableId;
  }
  protoOf(AnchorInfo).ale = function (direction, offset, selectableId) {
    return new AnchorInfo(direction, offset, selectableId);
  };
  protoOf(AnchorInfo).ble = function (direction, offset, selectableId, $super) {
    direction = direction === VOID ? this.clb_1 : direction;
    offset = offset === VOID ? this.dlb_1 : offset;
    selectableId = selectableId === VOID ? this.elb_1 : selectableId;
    return $super === VOID ? this.ale(direction, offset, selectableId) : $super.ale.call(this, direction, offset, selectableId);
  };
  protoOf(AnchorInfo).toString = function () {
    return 'AnchorInfo(direction=' + this.clb_1.toString() + ', offset=' + this.dlb_1 + ', selectableId=' + this.elb_1.toString() + ')';
  };
  protoOf(AnchorInfo).hashCode = function () {
    var result = this.clb_1.hashCode();
    result = imul(result, 31) + this.dlb_1 | 0;
    result = imul(result, 31) + this.elb_1.hashCode() | 0;
    return result;
  };
  protoOf(AnchorInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnchorInfo))
      return false;
    if (!this.clb_1.equals(other.clb_1))
      return false;
    if (!(this.dlb_1 === other.dlb_1))
      return false;
    if (!equalsLong(this.elb_1, other.elb_1))
      return false;
    return true;
  };
  function Selection(start, end, handlesCrossed) {
    handlesCrossed = handlesCrossed === VOID ? false : handlesCrossed;
    this.flb_1 = start;
    this.glb_1 = end;
    this.hlb_1 = handlesCrossed;
  }
  protoOf(Selection).cle = function (start, end, handlesCrossed) {
    return new Selection(start, end, handlesCrossed);
  };
  protoOf(Selection).dle = function (start, end, handlesCrossed, $super) {
    start = start === VOID ? this.flb_1 : start;
    end = end === VOID ? this.glb_1 : end;
    handlesCrossed = handlesCrossed === VOID ? this.hlb_1 : handlesCrossed;
    return $super === VOID ? this.cle(start, end, handlesCrossed) : $super.cle.call(this, start, end, handlesCrossed);
  };
  protoOf(Selection).toString = function () {
    return 'Selection(start=' + this.flb_1.toString() + ', end=' + this.glb_1.toString() + ', handlesCrossed=' + this.hlb_1 + ')';
  };
  protoOf(Selection).hashCode = function () {
    var result = this.flb_1.hashCode();
    result = imul(result, 31) + this.glb_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.hlb_1) | 0;
    return result;
  };
  protoOf(Selection).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Selection))
      return false;
    if (!this.flb_1.equals(other.flb_1))
      return false;
    if (!this.glb_1.equals(other.glb_1))
      return false;
    if (!(this.hlb_1 === other.hlb_1))
      return false;
    return true;
  };
  function sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0(function_0) {
    this.ele_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0).fle = function (layout) {
    return this.ele_1(layout);
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0).q3 = function () {
    return this.ele_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, SelectionAdjustment) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_0(function_0) {
    this.gle_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_0).fle = function (layout) {
    return this.gle_1(layout);
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_0).q3 = function () {
    return this.gle_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, SelectionAdjustment) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_foundation_text_selection_BoundaryFunction$0(function_0) {
    this.hle_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_text_selection_BoundaryFunction$0).ile = function (_this__u8e3s4, offset) {
    return this.hle_1(_this__u8e3s4, offset).b7u_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_BoundaryFunction$0).q3 = function () {
    return this.hle_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_BoundaryFunction$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, BoundaryFunction) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_BoundaryFunction$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_1(function_0) {
    this.jle_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_1).fle = function (layout) {
    return this.jle_1(layout);
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_1).q3 = function () {
    return this.jle_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, SelectionAdjustment) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_foundation_text_selection_BoundaryFunction$0_0(function_0) {
    this.kle_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_text_selection_BoundaryFunction$0_0).ile = function (_this__u8e3s4, offset) {
    return this.kle_1(_this__u8e3s4, offset).b7u_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_BoundaryFunction$0_0).q3 = function () {
    return this.kle_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_BoundaryFunction$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, BoundaryFunction) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_BoundaryFunction$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_2(function_0) {
    this.lle_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_2).fle = function (layout) {
    return this.lle_1(layout);
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_2).q3 = function () {
    return this.lle_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, SelectionAdjustment) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_3(function_0) {
    this.mle_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_3).fle = function (layout) {
    return this.mle_1(layout);
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_3).q3 = function () {
    return this.mle_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, SelectionAdjustment) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_3).hashCode = function () {
    return hashCode(this.q3());
  };
  function SelectionAdjustment$Companion$None$lambda(layout) {
    return new Selection(layout.nle().ule(layout.nle().qle_1), layout.vle().ule(layout.vle().rle_1), layout.wle().equals(CrossStatus_CROSSED_getInstance()));
  }
  function SelectionAdjustment$Companion$Character$lambda(layout) {
    return ensureAtLeastOneChar(Companion_getInstance_87().eki_1.fle(layout), layout);
  }
  function SelectionAdjustment$Companion$Word$lambda(layout) {
    var tmp = SelectionAdjustment$Companion$Word$lambda$lambda;
    return adjustToBoundaries(layout, new sam$androidx_compose_foundation_text_selection_BoundaryFunction$0(tmp));
  }
  function SelectionAdjustment$Companion$Word$lambda$lambda($this$adjustToBoundaries, it) {
    return new TextRange($this$adjustToBoundaries.tle_1.z7t(it));
  }
  function SelectionAdjustment$Companion$Paragraph$lambda(layout) {
    var tmp = SelectionAdjustment$Companion$Paragraph$lambda$lambda;
    return adjustToBoundaries(layout, new sam$androidx_compose_foundation_text_selection_BoundaryFunction$0_0(tmp));
  }
  function SelectionAdjustment$Companion$Paragraph$lambda$lambda($this$adjustToBoundaries, it) {
    return new TextRange(getParagraphBoundary($this$adjustToBoundaries.xle(), it));
  }
  function SelectionAdjustment$Companion$CharacterWithWordAccelerate$lambda(layout) {
    var tmp0_elvis_lhs = layout.yle();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_87().gki_1.fle(layout);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var previousSelection = tmp;
    var previousAnchor;
    var newAnchor;
    var startAnchor;
    var endAnchor;
    if (layout.zle()) {
      previousAnchor = previousSelection.flb_1;
      newAnchor = updateSelectionBoundary(layout, layout.nle(), previousAnchor);
      startAnchor = newAnchor;
      endAnchor = previousSelection.glb_1;
    } else {
      previousAnchor = previousSelection.glb_1;
      newAnchor = updateSelectionBoundary(layout, layout.vle(), previousAnchor);
      startAnchor = previousSelection.flb_1;
      endAnchor = newAnchor;
    }
    var tmp_0;
    if (newAnchor.equals(previousAnchor)) {
      tmp_0 = previousSelection;
    } else {
      var crossed = layout.wle().equals(CrossStatus_CROSSED_getInstance()) || (layout.wle().equals(CrossStatus_COLLAPSED_getInstance()) && startAnchor.dlb_1 > endAnchor.dlb_1);
      tmp_0 = ensureAtLeastOneChar(new Selection(startAnchor, endAnchor, crossed), layout);
    }
    return tmp_0;
  }
  function Companion_28() {
    Companion_instance_38 = this;
    var tmp = this;
    var tmp_0 = SelectionAdjustment$Companion$None$lambda;
    tmp.eki_1 = new sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0(tmp_0);
    var tmp_1 = this;
    var tmp_2 = SelectionAdjustment$Companion$Character$lambda;
    tmp_1.fki_1 = new sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_0(tmp_2);
    var tmp_3 = this;
    var tmp_4 = SelectionAdjustment$Companion$Word$lambda;
    tmp_3.gki_1 = new sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_1(tmp_4);
    var tmp_5 = this;
    var tmp_6 = SelectionAdjustment$Companion$Paragraph$lambda;
    tmp_5.hki_1 = new sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_2(tmp_6);
    var tmp_7 = this;
    var tmp_8 = SelectionAdjustment$Companion$CharacterWithWordAccelerate$lambda;
    tmp_7.iki_1 = new sam$androidx_compose_foundation_text_selection_SelectionAdjustment$0_3(tmp_8);
  }
  var Companion_instance_38;
  function Companion_getInstance_87() {
    if (Companion_instance_38 == null)
      new Companion_28();
    return Companion_instance_38;
  }
  function SelectionAdjustment() {
  }
  function ensureAtLeastOneChar(_this__u8e3s4, layout) {
    if (!isCollapsed(_this__u8e3s4, layout)) {
      return _this__u8e3s4;
    }
    var text = layout.alf().xle();
    var tmp;
    if (layout.n1() > 1 || layout.yle() == null) {
      tmp = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      tmp = charSequenceLength(text) === 0;
    }
    if (tmp) {
      return _this__u8e3s4;
    }
    return expandOneChar(_this__u8e3s4, layout);
  }
  function adjustToBoundaries(layout, boundaryFunction) {
    var crossed = layout.wle().equals(CrossStatus_CROSSED_getInstance());
    return new Selection(anchorOnBoundary(layout.nle(), crossed, true, layout.blf(), boundaryFunction), anchorOnBoundary(layout.vle(), crossed, false, layout.clf(), boundaryFunction), crossed);
  }
  function BoundaryFunction() {
  }
  function updateSelectionBoundary(_this__u8e3s4, info, previousSelectionAnchor) {
    var currentRawOffset = _this__u8e3s4.zle() ? info.qle_1 : info.rle_1;
    var currentSlot = _this__u8e3s4.zle() ? _this__u8e3s4.blf() : _this__u8e3s4.clf();
    if (!(currentSlot === info.ple_1)) {
      return info.ule(currentRawOffset);
    }
    var tmp = LazyThreadSafetyMode_NONE_getInstance();
    var currentRawLine$delegate = lazy(tmp, updateSelectionBoundary$lambda_0(info, currentRawOffset));
    var otherRawOffset = _this__u8e3s4.zle() ? info.rle_1 : info.qle_1;
    var tmp_0 = LazyThreadSafetyMode_NONE_getInstance();
    var anchorSnappedToWordBoundary$delegate = lazy(tmp_0, updateSelectionBoundary$lambda_2(info, currentRawOffset, otherRawOffset, _this__u8e3s4, currentRawLine$delegate));
    if (!equalsLong(info.ole_1, previousSelectionAnchor.elb_1)) {
      return updateSelectionBoundary$lambda_1(anchorSnappedToWordBoundary$delegate);
    }
    var rawPreviousHandleOffset = info.sle_1;
    if (currentRawOffset === rawPreviousHandleOffset) {
      return previousSelectionAnchor;
    }
    var previousRawLine = info.tle_1.d7u(rawPreviousHandleOffset);
    if (!(updateSelectionBoundary$lambda(currentRawLine$delegate) === previousRawLine)) {
      return updateSelectionBoundary$lambda_1(anchorSnappedToWordBoundary$delegate);
    }
    var previousSelectionOffset = previousSelectionAnchor.dlb_1;
    var previousSelectionWordBoundary = info.tle_1.z7t(previousSelectionOffset);
    if (!isExpanding(info, currentRawOffset, _this__u8e3s4.zle())) {
      return info.ule(currentRawOffset);
    }
    if (previousSelectionOffset === _TextRange___get_start__impl__ww4t90(previousSelectionWordBoundary) || previousSelectionOffset === _TextRange___get_end__impl__gcdxpp(previousSelectionWordBoundary)) {
      return updateSelectionBoundary$lambda_1(anchorSnappedToWordBoundary$delegate);
    }
    return info.ule(currentRawOffset);
  }
  function expandOneChar(_this__u8e3s4, layout) {
    var info = layout.alf();
    var text = info.xle();
    var offset = info.qle_1;
    var lastOffset = text.length;
    var tmp;
    if (offset === 0) {
      var followingBreak = findFollowingBreak(text, 0);
      var tmp_0;
      if (layout.zle()) {
        tmp_0 = _this__u8e3s4.dle(changeOffset(_this__u8e3s4.flb_1, info, followingBreak), VOID, true);
      } else {
        tmp_0 = _this__u8e3s4.dle(VOID, changeOffset(_this__u8e3s4.glb_1, info, followingBreak), false);
      }
      tmp = tmp_0;
    } else if (offset === lastOffset) {
      var precedingBreak = findPrecedingBreak(text, lastOffset);
      var tmp_1;
      if (layout.zle()) {
        tmp_1 = _this__u8e3s4.dle(changeOffset(_this__u8e3s4.flb_1, info, precedingBreak), VOID, false);
      } else {
        tmp_1 = _this__u8e3s4.dle(VOID, changeOffset(_this__u8e3s4.glb_1, info, precedingBreak), true);
      }
      tmp = tmp_1;
    } else {
      var tmp1_safe_receiver = layout.yle();
      var crossed = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hlb_1) === true;
      var tmp_2;
      if (!!(layout.zle() ^ crossed)) {
        tmp_2 = findPrecedingBreak(text, offset);
      } else {
        tmp_2 = findFollowingBreak(text, offset);
      }
      var newOffset = tmp_2;
      var tmp_3;
      if (layout.zle()) {
        tmp_3 = _this__u8e3s4.dle(changeOffset(_this__u8e3s4.flb_1, info, newOffset), VOID, crossed);
      } else {
        tmp_3 = _this__u8e3s4.dle(VOID, changeOffset(_this__u8e3s4.glb_1, info, newOffset), crossed);
      }
      tmp = tmp_3;
    }
    return tmp;
  }
  function anchorOnBoundary(_this__u8e3s4, crossed, isStart, slot, boundaryFunction) {
    var offset = isStart ? _this__u8e3s4.qle_1 : _this__u8e3s4.rle_1;
    if (!(slot === _this__u8e3s4.ple_1)) {
      return _this__u8e3s4.ule(offset);
    }
    // Inline function 'kotlin.with' call
    var range = boundaryFunction.ile(_this__u8e3s4, offset);
    return _this__u8e3s4.ule(!!(isStart ^ crossed) ? _TextRange___get_start__impl__ww4t90(range) : _TextRange___get_end__impl__gcdxpp(range));
  }
  function snapToWordBoundary(_this__u8e3s4, currentLine, currentOffset, otherOffset, isStart, crossed) {
    var wordBoundary = _this__u8e3s4.tle_1.z7t(currentOffset);
    var wordStartLine = _this__u8e3s4.tle_1.d7u(_TextRange___get_start__impl__ww4t90(wordBoundary));
    var tmp;
    if (wordStartLine === currentLine) {
      tmp = _TextRange___get_start__impl__ww4t90(wordBoundary);
    } else if (currentLine >= _this__u8e3s4.tle_1.e7t()) {
      tmp = _this__u8e3s4.tle_1.k7u(_this__u8e3s4.tle_1.e7t() - 1 | 0);
    } else {
      tmp = _this__u8e3s4.tle_1.k7u(currentLine);
    }
    var start = tmp;
    var wordEndLine = _this__u8e3s4.tle_1.d7u(_TextRange___get_end__impl__gcdxpp(wordBoundary));
    var tmp_0;
    if (wordEndLine === currentLine) {
      tmp_0 = _TextRange___get_end__impl__gcdxpp(wordBoundary);
    } else if (currentLine >= _this__u8e3s4.tle_1.e7t()) {
      tmp_0 = _this__u8e3s4.tle_1.n80(_this__u8e3s4.tle_1.e7t() - 1 | 0);
    } else {
      tmp_0 = _this__u8e3s4.tle_1.n80(currentLine);
    }
    var end = tmp_0;
    if (start === otherOffset) {
      return _this__u8e3s4.ule(end);
    }
    if (end === otherOffset) {
      return _this__u8e3s4.ule(start);
    }
    var tmp_1;
    if (!!(isStart ^ crossed)) {
      tmp_1 = currentOffset <= end ? start : end;
    } else {
      tmp_1 = currentOffset >= start ? end : start;
    }
    var resultOffset = tmp_1;
    return _this__u8e3s4.ule(resultOffset);
  }
  function isExpanding(_this__u8e3s4, currentRawOffset, isStart) {
    if (_this__u8e3s4.sle_1 === -1) {
      return true;
    }
    if (currentRawOffset === _this__u8e3s4.sle_1) {
      return false;
    }
    var crossed = _this__u8e3s4.dlf().equals(CrossStatus_CROSSED_getInstance());
    var tmp;
    if (!!(isStart ^ crossed)) {
      tmp = currentRawOffset < _this__u8e3s4.sle_1;
    } else {
      tmp = currentRawOffset > _this__u8e3s4.sle_1;
    }
    return tmp;
  }
  function changeOffset(_this__u8e3s4, info, newOffset) {
    var tmp0_direction = info.tle_1.y7t(newOffset);
    return _this__u8e3s4.ble(tmp0_direction, newOffset);
  }
  function updateSelectionBoundary$lambda($currentRawLine$delegate) {
    // Inline function 'kotlin.getValue' call
    getLocalDelegateReference('currentRawLine', KProperty0, false);
    return $currentRawLine$delegate.u1();
  }
  function updateSelectionBoundary$lambda_0($info, $currentRawOffset) {
    return function () {
      return $info.tle_1.d7u($currentRawOffset);
    };
  }
  function updateSelectionBoundary$lambda_1($anchorSnappedToWordBoundary$delegate) {
    // Inline function 'kotlin.getValue' call
    getLocalDelegateReference('anchorSnappedToWordBoundary', KProperty0, false);
    return $anchorSnappedToWordBoundary$delegate.u1();
  }
  function updateSelectionBoundary$lambda_2($info, $currentRawOffset, $otherRawOffset, $this_updateSelectionBoundary, $currentRawLine$delegate) {
    return function () {
      return snapToWordBoundary($info, updateSelectionBoundary$lambda($currentRawLine$delegate), $currentRawOffset, $otherRawOffset, $this_updateSelectionBoundary.zle(), $this_updateSelectionBoundary.wle().equals(CrossStatus_CROSSED_getInstance()));
    };
  }
  var androidx_compose_foundation_text_selection_ClicksCounter$stable;
  function awaitSelectionGestures(_this__u8e3s4, mouseSelectionObserver, textDragObserver, $completion) {
    var clicksCounter = new ClicksCounter(_this__u8e3s4.la7());
    return awaitEachGesture(_this__u8e3s4, awaitSelectionGestures$slambda_0(clicksCounter, mouseSelectionObserver, textDragObserver, null), $completion);
  }
  function updateSelectionTouchMode(_this__u8e3s4, updateTouchMode) {
    var tmp = updateSelectionTouchMode$slambda_0(updateTouchMode, null);
    return pointerInput(_this__u8e3s4, 8675309, new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_7(tmp));
  }
  function ClicksCounter(viewConfiguration) {
    this.elf_1 = viewConfiguration;
    this.flf_1 = 0;
    this.glf_1 = null;
  }
  protoOf(ClicksCounter).hlf = function (event) {
    var currentPrevEvent = this.glf_1;
    if (!(currentPrevEvent == null) && this.ilf(currentPrevEvent, event) && this.jlf(currentPrevEvent, event)) {
      this.flf_1 = this.flf_1 + 1 | 0;
    } else {
      this.flf_1 = 1;
    }
    this.glf_1 = event;
  };
  protoOf(ClicksCounter).ilf = function (prevClick, newClick) {
    return compare(subtract(newClick.ja0_1, prevClick.ja0_1), this.elf_1.sb9()) < 0;
  };
  protoOf(ClicksCounter).jlf = function (prevClick, newClick) {
    return distanceIsTolerable(this.elf_1, prevClick, newClick);
  };
  function awaitDown(_this__u8e3s4, $completion) {
    var tmp = new $awaitDownCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function mouseSelection(_this__u8e3s4, observer, clicksCounter, down, $completion) {
    var tmp = new $mouseSelectionCOROUTINE$(_this__u8e3s4, observer, clicksCounter, down, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function touchSelectionFirstPress(_this__u8e3s4, observer, downEvent, $completion) {
    var tmp = new $touchSelectionFirstPressCOROUTINE$(_this__u8e3s4, observer, downEvent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function touchSelectionSubsequentPress(_this__u8e3s4, observer, downEvent, clicks, $completion) {
    var tmp = new $touchSelectionSubsequentPressCOROUTINE$(_this__u8e3s4, observer, downEvent, clicks, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function distanceIsTolerable(viewConfiguration, change1, change2) {
    var slop = pointerSlop(viewConfiguration, change1.qa0_1);
    return Offset__getDistance_impl_pclvxn(Offset__minus_impl_hoj2c0(change1.ka0_1, change2.ka0_1)) < slop;
  }
  var DownResolution_Up_instance;
  var DownResolution_Drag_instance;
  var DownResolution_Timeout_instance;
  var DownResolution_Cancel_instance;
  var DownResolution_entriesInitialized;
  function DownResolution_initEntries() {
    if (DownResolution_entriesInitialized)
      return Unit_instance;
    DownResolution_entriesInitialized = true;
    DownResolution_Up_instance = new DownResolution('Up', 0);
    DownResolution_Drag_instance = new DownResolution('Drag', 1);
    DownResolution_Timeout_instance = new DownResolution('Timeout', 2);
    DownResolution_Cancel_instance = new DownResolution('Cancel', 3);
  }
  function DownResolution(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_7(function_0) {
    this.jlh_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_7).ka7 = function (_this__u8e3s4, $completion) {
    return this.jlh_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_7).q3 = function () {
    return this.jlh_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_7).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_7).hashCode = function () {
    return hashCode(this.q3());
  };
  function awaitSelectionGestures$slambda($clicksCounter, $mouseSelectionObserver, $textDragObserver, resultContinuation) {
    this.slh_1 = $clicksCounter;
    this.tlh_1 = $mouseSelectionObserver;
    this.ulh_1 = $textDragObserver;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(awaitSelectionGestures$slambda).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(awaitSelectionGestures$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(awaitSelectionGestures$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            this.n9_1 = 1;
            suspendResult = awaitDown(this.vlh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var downEvent = suspendResult;
            this.slh_1.hlf(downEvent.ca0_1.l1(0));
            var isPrecise = isMouseOrTouchPad(downEvent);
            var tmp_0;
            if (isPrecise && get_isPrimaryPressed(downEvent.da0_1)) {
              var tmp0 = downEvent.ca0_1;
              var tmp$ret$0;
              l$ret$1: do {
                var inductionVariable = 0;
                var last = tmp0.n1() - 1 | 0;
                if (inductionVariable <= last)
                  do {
                    var index = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    var item = tmp0.l1(index);
                    if (!!item.qa2()) {
                      tmp$ret$0 = false;
                      break l$ret$1;
                    }
                  }
                   while (inductionVariable <= last);
                tmp$ret$0 = true;
              }
               while (false);
              tmp_0 = tmp$ret$0;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this.n9_1 = 5;
              suspendResult = mouseSelection(this.vlh_1, this.tlh_1, this.slh_1, downEvent, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!isPrecise) {
                if (this.slh_1.flf_1 === 1) {
                  this.n9_1 = 3;
                  suspendResult = touchSelectionFirstPress(this.vlh_1, this.ulh_1, downEvent, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.n9_1 = 2;
                  suspendResult = touchSelectionSubsequentPress(this.vlh_1, this.ulh_1, downEvent, this.slh_1.flf_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                this.n9_1 = 6;
                continue $sm;
              }
            }

          case 2:
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 6;
            continue $sm;
          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(awaitSelectionGestures$slambda).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new awaitSelectionGestures$slambda(this.slh_1, this.tlh_1, this.ulh_1, completion);
    i.vlh_1 = $this$awaitEachGesture;
    return i;
  };
  function awaitSelectionGestures$slambda_0($clicksCounter, $mouseSelectionObserver, $textDragObserver, resultContinuation) {
    var i = new awaitSelectionGestures$slambda($clicksCounter, $mouseSelectionObserver, $textDragObserver, resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  function updateSelectionTouchMode$slambda$slambda($updateTouchMode, resultContinuation) {
    this.eli_1 = $updateTouchMode;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(updateSelectionTouchMode$slambda$slambda).ic6 = function ($this$awaitPointerEventScope, $completion) {
    var tmp = this.jc6($this$awaitPointerEventScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(updateSelectionTouchMode$slambda$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(updateSelectionTouchMode$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = this.fli_1.pa7(PointerEventPass_Initial_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var event = suspendResult;
            this.eli_1(!isMouseOrTouchPad(event));
            this.n9_1 = 1;
            continue $sm;
          case 3:
            throw this.q9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(updateSelectionTouchMode$slambda$slambda).jc6 = function ($this$awaitPointerEventScope, completion) {
    var i = new updateSelectionTouchMode$slambda$slambda(this.eli_1, completion);
    i.fli_1 = $this$awaitPointerEventScope;
    return i;
  };
  function updateSelectionTouchMode$slambda$slambda_0($updateTouchMode, resultContinuation) {
    var i = new updateSelectionTouchMode$slambda$slambda($updateTouchMode, resultContinuation);
    return constructCallableReference(function ($this$awaitPointerEventScope, $completion) {
      return i.ic6($this$awaitPointerEventScope, $completion);
    }, 1);
  }
  function updateSelectionTouchMode$slambda($updateTouchMode, resultContinuation) {
    this.oli_1 = $updateTouchMode;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(updateSelectionTouchMode$slambda).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(updateSelectionTouchMode$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(updateSelectionTouchMode$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.pli_1.ma7(updateSelectionTouchMode$slambda$slambda_0(this.oli_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(updateSelectionTouchMode$slambda).wc6 = function ($this$pointerInput, completion) {
    var i = new updateSelectionTouchMode$slambda(this.oli_1, completion);
    i.pli_1 = $this$pointerInput;
    return i;
  };
  function updateSelectionTouchMode$slambda_0($updateTouchMode, resultContinuation) {
    var i = new updateSelectionTouchMode$slambda($updateTouchMode, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function mouseSelection$lambda($observer) {
    return function (it) {
      var tmp;
      if ($observer.qli(it.ka0_1)) {
        it.ra2();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function mouseSelection$lambda_0($observer, $selectionAdjustment, $dragConsumed) {
    return function (it) {
      var tmp;
      if ($observer.rli(it.ka0_1, $selectionAdjustment)) {
        it.ra2();
        $dragConsumed._v = true;
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function touchSelectionFirstPress$lambda($observer) {
    return function (it) {
      $observer.lki(positionChange(it));
      it.ra2();
      return Unit_instance;
    };
  }
  function touchSelectionSubsequentPress$slambda$lambda($overSlop) {
    return function (change, slop) {
      change.ra2();
      $overSlop._v = slop;
      return Unit_instance;
    };
  }
  function touchSelectionSubsequentPress$slambda($pointerId, $overSlop, resultContinuation) {
    this.alj_1 = $pointerId;
    this.blj_1 = $overSlop;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(touchSelectionSubsequentPress$slambda).dlj = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.jc6($this$withTimeoutOrNull, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(touchSelectionSubsequentPress$slambda).ja = function (p1, $completion) {
    return this.dlj((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(touchSelectionSubsequentPress$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = awaitTouchSlopOrCancellation(this.clj_1, this.alj_1, touchSelectionSubsequentPress$slambda$lambda(this.blj_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var firstDragPastSlop = suspendResult;
            var tmp_0;
            if (!(firstDragPastSlop == null)) {
              var this_0 = this.blj_1._v.e5d_1;
              tmp_0 = !equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344));
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              return DownResolution_Drag_getInstance();
            }

            var currentChange = first(this.clj_1.oa7().ca0_1);
            var tmp_1;
            if (changedToUpIgnoreConsumed(currentChange)) {
              currentChange.ra2();
              tmp_1 = DownResolution_Up_getInstance();
            } else {
              tmp_1 = DownResolution_Cancel_getInstance();
            }

            return tmp_1;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(touchSelectionSubsequentPress$slambda).jc6 = function ($this$withTimeoutOrNull, completion) {
    var i = new touchSelectionSubsequentPress$slambda(this.alj_1, this.blj_1, completion);
    i.clj_1 = $this$withTimeoutOrNull;
    return i;
  };
  function touchSelectionSubsequentPress$slambda_0($pointerId, $overSlop, resultContinuation) {
    var i = new touchSelectionSubsequentPress$slambda($pointerId, $overSlop, resultContinuation);
    return constructCallableReference(function ($this$withTimeoutOrNull, $completion) {
      return i.dlj($this$withTimeoutOrNull, $completion);
    }, 1);
  }
  function touchSelectionSubsequentPress$lambda($observer) {
    return function (it) {
      $observer.lki(positionChange(it));
      it.ra2();
      return Unit_instance;
    };
  }
  function DownResolution_Up_getInstance() {
    DownResolution_initEntries();
    return DownResolution_Up_instance;
  }
  function DownResolution_Drag_getInstance() {
    DownResolution_initEntries();
    return DownResolution_Drag_instance;
  }
  function DownResolution_Timeout_getInstance() {
    DownResolution_initEntries();
    return DownResolution_Timeout_instance;
  }
  function DownResolution_Cancel_getInstance() {
    DownResolution_initEntries();
    return DownResolution_Cancel_instance;
  }
  function $awaitDownCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.slf_1 = _this__u8e3s4;
  }
  protoOf($awaitDownCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.slf_1.pa7(PointerEventPass_Main_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.tlf_1 = suspendResult;
            var tmp0 = this.tlf_1.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var inductionVariable = 0;
              var last = tmp0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = tmp0.l1(index);
                  if (!changedToDown(item)) {
                    tmp$ret$0 = false;
                    break l$ret$1;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$0 = true;
            }
             while (false);
            if (!tmp$ret$0) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 3;
            continue $sm;
          case 3:
            return this.tlf_1;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $mouseSelectionCOROUTINE$(_this__u8e3s4, observer, clicksCounter, down, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.clg_1 = _this__u8e3s4;
    this.dlg_1 = observer;
    this.elg_1 = clicksCounter;
    this.flg_1 = down;
  }
  protoOf($mouseSelectionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            this.glg_1 = this.flg_1.ca0_1.l1(0);
            if (get_isShiftPressed_0(this.flg_1.ea0_1)) {
              var started = this.dlg_1.flj(this.glg_1.ka0_1);
              if (started) {
                this.n9_1 = 6;
                continue $sm;
              } else {
                this.n9_1 = 9;
                continue $sm;
              }
            } else {
              var tmp_0 = this;
              switch (this.elg_1.flf_1) {
                case 1:
                  tmp_0.ilg_1 = Companion_getInstance_87().eki_1;
                  break;
                case 2:
                  tmp_0.ilg_1 = Companion_getInstance_87().gki_1;
                  break;
                default:
                  tmp_0.ilg_1 = Companion_getInstance_87().hki_1;
                  break;
              }
              var started_0 = this.dlg_1.elj(this.glg_1.ka0_1, this.ilg_1, this.elg_1.flf_1);
              if (started_0) {
                this.n9_1 = 1;
                continue $sm;
              } else {
                this.n9_1 = 4;
                continue $sm;
              }
            }

          case 1:
            this.o9_1 = 5;
            this.hlg_1 = {_v: !equals(this.ilg_1, Companion_getInstance_87().eki_1)};
            this.n9_1 = 2;
            suspendResult = drag(this.clg_1, this.glg_1.ia0_1, mouseSelection$lambda_0(this.dlg_1, this.ilg_1, this.hlg_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var shouldConsumeUp = suspendResult;
            var tmp_1;
            if (shouldConsumeUp && this.hlg_1._v) {
              var this_0 = this.clg_1.oa7().ca0_1;
              var inductionVariable = 0;
              var last = this_0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = this_0.l1(index);
                  if (changedToUp(item)) {
                    item.ra2();
                  }
                }
                 while (inductionVariable <= last);
              tmp_1 = Unit_instance;
            }

            this.o9_1 = 12;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 12;
            this.dlg_1.glj();
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 10;
            continue $sm;
          case 5:
            this.o9_1 = 12;
            var t = this.q9_1;
            this.dlg_1.glj();
            throw t;
          case 6:
            this.o9_1 = 11;
            this.glg_1.ra2();
            this.n9_1 = 7;
            suspendResult = drag(this.clg_1, this.glg_1.ia0_1, mouseSelection$lambda(this.dlg_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var shouldConsumeUp_0 = suspendResult;
            var tmp_2;
            if (shouldConsumeUp_0) {
              var this_1 = this.clg_1.oa7().ca0_1;
              var inductionVariable_0 = 0;
              var last_0 = this_1.n1() - 1 | 0;
              if (inductionVariable_0 <= last_0)
                do {
                  var index_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var item_0 = this_1.l1(index_0);
                  if (changedToUp(item_0)) {
                    item_0.ra2();
                  }
                }
                 while (inductionVariable_0 <= last_0);
              tmp_2 = Unit_instance;
            }

            this.o9_1 = 12;
            this.n9_1 = 8;
            continue $sm;
          case 8:
            this.o9_1 = 12;
            this.dlg_1.glj();
            this.n9_1 = 9;
            continue $sm;
          case 9:
            this.n9_1 = 10;
            continue $sm;
          case 10:
            return Unit_instance;
          case 11:
            this.o9_1 = 12;
            var t_0 = this.q9_1;
            this.dlg_1.glj();
            throw t_0;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 12) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $touchSelectionFirstPressCOROUTINE$(_this__u8e3s4, observer, downEvent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rlg_1 = _this__u8e3s4;
    this.slg_1 = observer;
    this.tlg_1 = downEvent;
  }
  protoOf($touchSelectionFirstPressCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 5;
            this.ulg_1 = first(this.tlg_1.ca0_1);
            this.n9_1 = 1;
            suspendResult = awaitLongPressOrCancellation(this.rlg_1, this.ulg_1.ia0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var longPress = suspendResult;
            if (!(longPress == null) && distanceIsTolerable(this.rlg_1.la7(), this.ulg_1, longPress)) {
              this.slg_1.jki(longPress.ka0_1, get_FirstLongPressSelectionAdjustment());
              this.n9_1 = 2;
              suspendResult = drag(this.rlg_1, longPress.ia0_1, touchSelectionFirstPress$lambda(this.slg_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            var dragCompletedWithUp = suspendResult;
            if (dragCompletedWithUp) {
              var this_0 = this.rlg_1.oa7().ca0_1;
              var inductionVariable = 0;
              var last = this_0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = this_0.l1(index);
                  if (changedToUp(item)) {
                    item.ra2();
                  }
                }
                 while (inductionVariable <= last);
              this.slg_1.kki();
            } else {
              this.slg_1.sb0();
            }

            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.o9_1 = 6;
            return Unit_instance;
          case 5:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof CancellationException) {
              var c = this.q9_1;
              this.slg_1.sb0();
              throw c;
            } else {
              throw this.q9_1;
            }

          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $touchSelectionSubsequentPressCOROUTINE$(_this__u8e3s4, observer, downEvent, clicks, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dlh_1 = _this__u8e3s4;
    this.elh_1 = observer;
    this.flh_1 = downEvent;
    this.glh_1 = clicks;
  }
  protoOf($touchSelectionSubsequentPressCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.o9_1 = 4;
            var firstDown = first(this.flh_1.ca0_1);
            this.hlh_1 = firstDown.ia0_1;
            this.elh_1.jki(firstDown.ka0_1, this.glh_1 > 2 ? Companion_getInstance_87().hki_1 : Companion_getInstance_87().gki_1);
            this.ilh_1 = {_v: new Offset(Companion_getInstance_6().i5d_1)};
            this.n9_1 = 1;
            var tmp_0 = this.dlh_1.la7().rb9();
            suspendResult = this.dlh_1.ra7(tmp_0, touchSelectionSubsequentPress$slambda_0(this.hlh_1, this.ilh_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var downResolution = tmp0_elvis_lhs == null ? DownResolution_Timeout_getInstance() : tmp0_elvis_lhs;
            if (downResolution.equals(DownResolution_Cancel_getInstance())) {
              this.elh_1.sb0();
              return Unit_instance;
            }

            if (downResolution.equals(DownResolution_Up_getInstance())) {
              this.elh_1.kki();
              return Unit_instance;
            } else if (downResolution.equals(DownResolution_Drag_getInstance())) {
              this.elh_1.lki(this.ilh_1._v.e5d_1);
            }

            this.n9_1 = 2;
            suspendResult = drag(this.dlh_1, this.hlh_1, touchSelectionSubsequentPress$lambda(this.elh_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var dragCompletedWithUp = suspendResult;
            if (dragCompletedWithUp) {
              var this_0 = this.dlh_1.oa7().ca0_1;
              var inductionVariable = 0;
              var last = this_0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = this_0.l1(index);
                  if (changedToUp(item)) {
                    item.ra2();
                  }
                }
                 while (inductionVariable <= last);
              this.elh_1.kki();
            } else {
              this.elh_1.sb0();
            }

            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            return Unit_instance;
          case 4:
            this.o9_1 = 5;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof CancellationException) {
              var c = this.q9_1;
              this.elh_1.sb0();
              throw c;
            } else {
              throw this.q9_1;
            }

          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var HandleWidth;
  var HandleHeight;
  function get_SelectionHandleInfoKey() {
    _init_properties_SelectionHandles_kt__nhzem7();
    return SelectionHandleInfoKey;
  }
  var SelectionHandleInfoKey;
  var androidx_compose_foundation_text_selection_SelectionHandleInfo$stable;
  var androidx_compose_foundation_text_selection_HandlePositionProvider$stable;
  function OffsetProvider() {
  }
  function SelectionHandleInfo(handle, position, anchor, visible) {
    this.hlj_1 = handle;
    this.ilj_1 = position;
    this.jlj_1 = anchor;
    this.klj_1 = visible;
  }
  protoOf(SelectionHandleInfo).toString = function () {
    return 'SelectionHandleInfo(handle=' + this.hlj_1.toString() + ', position=' + Offset__toString_impl_4ffbou(this.ilj_1) + ', anchor=' + this.jlj_1.toString() + ', visible=' + this.klj_1 + ')';
  };
  protoOf(SelectionHandleInfo).hashCode = function () {
    var result = this.hlj_1.hashCode();
    result = imul(result, 31) + Offset__hashCode_impl_hbql41(this.ilj_1) | 0;
    result = imul(result, 31) + this.jlj_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.klj_1) | 0;
    return result;
  };
  protoOf(SelectionHandleInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SelectionHandleInfo))
      return false;
    if (!this.hlj_1.equals(other.hlj_1))
      return false;
    if (!equals(this.ilj_1, other.ilj_1))
      return false;
    if (!this.jlj_1.equals(other.jlj_1))
      return false;
    if (!(this.klj_1 === other.klj_1))
      return false;
    return true;
  };
  var SelectionHandleAnchor_Left_instance;
  var SelectionHandleAnchor_Middle_instance;
  var SelectionHandleAnchor_Right_instance;
  var SelectionHandleAnchor_entriesInitialized;
  function SelectionHandleAnchor_initEntries() {
    if (SelectionHandleAnchor_entriesInitialized)
      return Unit_instance;
    SelectionHandleAnchor_entriesInitialized = true;
    SelectionHandleAnchor_Left_instance = new SelectionHandleAnchor('Left', 0);
    SelectionHandleAnchor_Middle_instance = new SelectionHandleAnchor('Middle', 1);
    SelectionHandleAnchor_Right_instance = new SelectionHandleAnchor('Right', 2);
  }
  function SelectionHandleAnchor(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function getAdjustedCoordinates(position) {
    _init_properties_SelectionHandles_kt__nhzem7();
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = floatFromBits(bits_0) - 1.0;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$9 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$9);
  }
  function isLeftSelectionHandle(isStartHandle, direction, handlesCrossed) {
    _init_properties_SelectionHandles_kt__nhzem7();
    var tmp;
    if (isStartHandle) {
      tmp = isHandleLtrDirection(direction, handlesCrossed);
    } else {
      tmp = !isHandleLtrDirection(direction, handlesCrossed);
    }
    return tmp;
  }
  function HandlePositionProvider(handleReferencePoint, positionProvider) {
    this.llj_1 = handleReferencePoint;
    this.mlj_1 = positionProvider;
    this.nlj_1 = Companion_getInstance_6().g5d_1;
  }
  protoOf(HandlePositionProvider).ldb = function (anchorBounds, windowSize, layoutDirection, popupContentSize) {
    // Inline function 'androidx.compose.ui.geometry.takeOrElse' call
    var this_0 = this.mlj_1.tk8();
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.isSpecified' call
    if (!equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
      tmp = this_0;
    } else {
      tmp = this.nlj_1;
    }
    var position = tmp;
    this.nlj_1 = position;
    var adjustment = this.llj_1.f8u(popupContentSize, Companion_getInstance_22().n5g_1, layoutDirection);
    return IntOffset__plus_impl_nqoa9b(IntOffset__plus_impl_nqoa9b(anchorBounds.k5g(), round(position)), adjustment);
  };
  function isHandleLtrDirection(direction, areHandlesCrossed) {
    _init_properties_SelectionHandles_kt__nhzem7();
    return direction.equals(ResolvedTextDirection_Ltr_getInstance()) && !areHandlesCrossed || (direction.equals(ResolvedTextDirection_Rtl_getInstance()) && areHandlesCrossed);
  }
  function SelectionHandleAnchor_Left_getInstance() {
    SelectionHandleAnchor_initEntries();
    return SelectionHandleAnchor_Left_instance;
  }
  function SelectionHandleAnchor_Middle_getInstance() {
    SelectionHandleAnchor_initEntries();
    return SelectionHandleAnchor_Middle_instance;
  }
  function SelectionHandleAnchor_Right_getInstance() {
    SelectionHandleAnchor_initEntries();
    return SelectionHandleAnchor_Right_instance;
  }
  var properties_initialized_SelectionHandles_kt_h9mb7j;
  function _init_properties_SelectionHandles_kt__nhzem7() {
    if (!properties_initialized_SelectionHandles_kt_h9mb7j) {
      properties_initialized_SelectionHandles_kt_h9mb7j = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      HandleWidth = _Dp___init__impl__ms3zkb(25);
      // Inline function 'androidx.compose.ui.unit.dp' call
      HandleHeight = _Dp___init__impl__ms3zkb(25);
      SelectionHandleInfoKey = new SemanticsPropertyKey('SelectionHandleInfo');
      androidx_compose_foundation_text_selection_SelectionHandleInfo$stable = 0;
      androidx_compose_foundation_text_selection_HandlePositionProvider$stable = 0;
    }
  }
  function getTextDirectionForOffset(_this__u8e3s4, offset) {
    return isOffsetAnEmptyLine(_this__u8e3s4, offset) ? _this__u8e3s4.x7t(offset) : _this__u8e3s4.y7t(offset);
  }
  function isOffsetAnEmptyLine(_this__u8e3s4, offset) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = _this__u8e3s4.e80_1.q80_1;
    if (charSequenceLength(this_0) === 0) {
      tmp = true;
    } else {
      // Inline function 'kotlin.let' call
      var currentLine = _this__u8e3s4.d7u(offset);
      tmp = ((offset === 0 || !(currentLine === _this__u8e3s4.d7u(offset - 1 | 0))) && (offset === _this__u8e3s4.e80_1.q80_1.a() || !(currentLine === _this__u8e3s4.d7u(offset + 1 | 0))));
    }
    return tmp;
  }
  var androidx_compose_foundation_text_selection_SelectionLayoutBuilder$stable;
  var androidx_compose_foundation_text_selection_SelectableInfo$stable;
  function getTextFieldSelectionLayout(layoutResult, rawStartHandleOffset, rawEndHandleOffset, rawPreviousHandleOffset, previousSelectionRange, isStartOfSelection, isStartHandle) {
    _init_properties_SelectionLayout_kt__hbukbg();
    var tmp = isStartOfSelection ? null : new Selection(new AnchorInfo(getTextDirectionForOffset(layoutResult, _TextRange___get_start__impl__ww4t90(previousSelectionRange)), _TextRange___get_start__impl__ww4t90(previousSelectionRange), new Long(1, 0)), new AnchorInfo(getTextDirectionForOffset(layoutResult, _TextRange___get_end__impl__gcdxpp(previousSelectionRange)), _TextRange___get_end__impl__gcdxpp(previousSelectionRange), new Long(1, 0)), _TextRange___get_reversed__impl__emhnbm(previousSelectionRange));
    var tmp0_selectableId = new Long(1, 0);
    return new SingleSelectionLayout(isStartHandle, 1, 1, tmp, new SelectableInfo(tmp0_selectableId, 1, rawStartHandleOffset, rawEndHandleOffset, rawPreviousHandleOffset, layoutResult));
  }
  function _get_startRunDirection__mafu79($this) {
    return getTextDirectionForOffset($this.tle_1, $this.qle_1);
  }
  function _get_endRunDirection__fgzj5q($this) {
    return getTextDirectionForOffset($this.tle_1, $this.rle_1);
  }
  function SelectableInfo(selectableId, slot, rawStartHandleOffset, rawEndHandleOffset, rawPreviousHandleOffset, textLayoutResult) {
    this.ole_1 = selectableId;
    this.ple_1 = slot;
    this.qle_1 = rawStartHandleOffset;
    this.rle_1 = rawEndHandleOffset;
    this.sle_1 = rawPreviousHandleOffset;
    this.tle_1 = textLayoutResult;
  }
  protoOf(SelectableInfo).xle = function () {
    return this.tle_1.e80_1.q80_1.h7q_1;
  };
  protoOf(SelectableInfo).olj = function () {
    return this.xle().length;
  };
  protoOf(SelectableInfo).dlf = function () {
    return this.qle_1 < this.rle_1 ? CrossStatus_NOT_CROSSED_getInstance() : this.qle_1 > this.rle_1 ? CrossStatus_CROSSED_getInstance() : CrossStatus_COLLAPSED_getInstance();
  };
  protoOf(SelectableInfo).plj = function (other) {
    return !equalsLong(this.ole_1, other.ole_1) || !(this.qle_1 === other.qle_1) || !(this.rle_1 === other.rle_1);
  };
  protoOf(SelectableInfo).ule = function (offset) {
    return new AnchorInfo(getTextDirectionForOffset(this.tle_1, offset), offset, this.ole_1);
  };
  protoOf(SelectableInfo).toString = function () {
    return 'SelectionInfo(id=' + this.ole_1.toString() + ', ' + ('range=(' + this.qle_1 + '-' + _get_startRunDirection__mafu79(this).toString() + ',' + this.rle_1 + '-' + _get_endRunDirection__fgzj5q(this).toString() + '), ') + ('prevOffset=' + this.sle_1 + ')');
  };
  var CrossStatus_CROSSED_instance;
  var CrossStatus_NOT_CROSSED_instance;
  var CrossStatus_COLLAPSED_instance;
  var CrossStatus_entriesInitialized;
  function CrossStatus_initEntries() {
    if (CrossStatus_entriesInitialized)
      return Unit_instance;
    CrossStatus_entriesInitialized = true;
    CrossStatus_CROSSED_instance = new CrossStatus('CROSSED', 0);
    CrossStatus_NOT_CROSSED_instance = new CrossStatus('NOT_CROSSED', 1);
    CrossStatus_COLLAPSED_instance = new CrossStatus('COLLAPSED', 2);
  }
  function CrossStatus(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function isCollapsed(_this__u8e3s4, layout) {
    _init_properties_SelectionLayout_kt__hbukbg();
    if (_this__u8e3s4 == null)
      return true;
    if (layout == null)
      return true;
    if (equalsLong(_this__u8e3s4.flb_1.elb_1, _this__u8e3s4.glb_1.elb_1)) {
      return _this__u8e3s4.flb_1.dlb_1 === _this__u8e3s4.glb_1.dlb_1;
    }
    var maxAnchor = _this__u8e3s4.hlb_1 ? _this__u8e3s4.flb_1 : _this__u8e3s4.glb_1;
    if (!(maxAnchor.dlb_1 === 0)) {
      return false;
    }
    var minAnchor = _this__u8e3s4.hlb_1 ? _this__u8e3s4.glb_1 : _this__u8e3s4.flb_1;
    if (!(layout.qlj().olj() === minAnchor.dlb_1)) {
      return false;
    }
    var allTextsEmpty = {_v: true};
    layout.rlj(isCollapsed$lambda(allTextsEmpty));
    return allTextsEmpty._v;
  }
  function Companion_29() {
    Companion_instance_39 = this;
    this.slj_1 = 1;
    this.tlj_1 = new Long(1, 0);
  }
  var Companion_instance_39;
  function Companion_getInstance_88() {
    if (Companion_instance_39 == null)
      new Companion_29();
    return Companion_instance_39;
  }
  function SingleSelectionLayout(isStartHandle, startSlot, endSlot, previousSelection, info) {
    Companion_getInstance_88();
    this.ulj_1 = isStartHandle;
    this.vlj_1 = startSlot;
    this.wlj_1 = endSlot;
    this.xlj_1 = previousSelection;
    this.ylj_1 = info;
  }
  protoOf(SingleSelectionLayout).zle = function () {
    return this.ulj_1;
  };
  protoOf(SingleSelectionLayout).blf = function () {
    return this.vlj_1;
  };
  protoOf(SingleSelectionLayout).clf = function () {
    return this.wlj_1;
  };
  protoOf(SingleSelectionLayout).yle = function () {
    return this.xlj_1;
  };
  protoOf(SingleSelectionLayout).n1 = function () {
    return 1;
  };
  protoOf(SingleSelectionLayout).wle = function () {
    return this.vlj_1 < this.wlj_1 ? CrossStatus_NOT_CROSSED_getInstance() : this.vlj_1 > this.wlj_1 ? CrossStatus_CROSSED_getInstance() : this.ylj_1.dlf();
  };
  protoOf(SingleSelectionLayout).nle = function () {
    return this.ylj_1;
  };
  protoOf(SingleSelectionLayout).vle = function () {
    return this.ylj_1;
  };
  protoOf(SingleSelectionLayout).alf = function () {
    return this.ylj_1;
  };
  protoOf(SingleSelectionLayout).qlj = function () {
    return this.ylj_1;
  };
  protoOf(SingleSelectionLayout).rlj = function (block) {
  };
  protoOf(SingleSelectionLayout).zlj = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    if (this.xlj_1 == null || other == null) {
      tmp_3 = true;
    } else {
      tmp_3 = !(other instanceof SingleSelectionLayout);
    }
    if (tmp_3) {
      tmp_2 = true;
    } else {
      tmp_2 = !(this.vlj_1 === other.vlj_1);
    }
    if (tmp_2) {
      tmp_1 = true;
    } else {
      tmp_1 = !(this.wlj_1 === other.wlj_1);
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = !(this.ulj_1 === other.ulj_1);
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = this.ylj_1.plj(other.ylj_1);
    }
    return tmp;
  };
  protoOf(SingleSelectionLayout).toString = function () {
    return 'SingleSelectionLayout(isStartHandle=' + this.ulj_1 + ', crossed=' + this.wle().toString() + ', info=\n\t' + this.ylj_1.toString() + ')';
  };
  function isCollapsed$lambda($allTextsEmpty) {
    return function (it) {
      var tmp;
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = it.xle();
      if (charSequenceLength(this_0) > 0) {
        $allTextsEmpty._v = false;
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CrossStatus_CROSSED_getInstance() {
    CrossStatus_initEntries();
    return CrossStatus_CROSSED_instance;
  }
  function CrossStatus_NOT_CROSSED_getInstance() {
    CrossStatus_initEntries();
    return CrossStatus_NOT_CROSSED_instance;
  }
  function CrossStatus_COLLAPSED_getInstance() {
    CrossStatus_initEntries();
    return CrossStatus_COLLAPSED_instance;
  }
  var properties_initialized_SelectionLayout_kt_inhukm;
  function _init_properties_SelectionLayout_kt__hbukbg() {
    if (!properties_initialized_SelectionLayout_kt_inhukm) {
      properties_initialized_SelectionLayout_kt_inhukm = true;
      androidx_compose_foundation_text_selection_SelectionLayoutBuilder$stable = 8;
      androidx_compose_foundation_text_selection_SelectableInfo$stable = androidx_compose_ui_text_TextLayoutResult$stableprop_getter();
    }
  }
  var invertedInfiniteRect;
  var androidx_compose_foundation_text_selection_SelectionManager$stable;
  function visibleBounds(_this__u8e3s4) {
    _init_properties_SelectionManager_kt__u9j33();
    var boundsInWindow_0 = boundsInWindow(_this__u8e3s4);
    return Rect_1(_this__u8e3s4.bai(boundsInWindow_0.s5d()), _this__u8e3s4.bai(boundsInWindow_0.t5d()));
  }
  function containsInclusive(_this__u8e3s4, offset) {
    _init_properties_SelectionManager_kt__u9j33();
    var tmp;
    var containsLower = _this__u8e3s4.k5d_1;
    var containsUpper = _this__u8e3s4.m5d_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(offset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var containsArg = floatFromBits(bits);
    if (containsLower <= containsArg ? containsArg <= containsUpper : false) {
      var containsLower_0 = _this__u8e3s4.l5d_1;
      var containsUpper_0 = _this__u8e3s4.n5d_1;
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(offset);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var containsArg_0 = floatFromBits(bits_0);
      tmp = containsLower_0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false;
    } else {
      tmp = false;
    }
    return tmp;
  }
  var properties_initialized_SelectionManager_kt_pnaxlp;
  function _init_properties_SelectionManager_kt__u9j33() {
    if (!properties_initialized_SelectionManager_kt_pnaxlp) {
      properties_initialized_SelectionManager_kt_pnaxlp = true;
      invertedInfiniteRect = new Rect(Infinity, Infinity, -Infinity, -Infinity);
      androidx_compose_foundation_text_selection_SelectionManager$stable = 8;
    }
  }
  function get_LocalSelectionRegistrar() {
    _init_properties_SelectionRegistrar_kt__oigj6p();
    return LocalSelectionRegistrar;
  }
  var LocalSelectionRegistrar;
  function hasSelection(_this__u8e3s4, selectableId) {
    _init_properties_SelectionRegistrar_kt__oigj6p();
    var tmp1_safe_receiver = _this__u8e3s4 == null ? null : _this__u8e3s4.blb();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mx(selectableId);
    return tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
  }
  function LocalSelectionRegistrar$lambda() {
    _init_properties_SelectionRegistrar_kt__oigj6p();
    return null;
  }
  var properties_initialized_SelectionRegistrar_kt_shxs4d;
  function _init_properties_SelectionRegistrar_kt__oigj6p() {
    if (!properties_initialized_SelectionRegistrar_kt_shxs4d) {
      properties_initialized_SelectionRegistrar_kt_shxs4d = true;
      LocalSelectionRegistrar = compositionLocalOf(VOID, LocalSelectionRegistrar$lambda);
    }
  }
  var androidx_compose_foundation_text_selection_SelectionRegistrarImpl$stable;
  function SimpleLayout(modifier, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1854833411);
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var tmp_0 = SimpleLayout$lambda;
        var value = new sam$androidx_compose_ui_layout_MeasurePolicy$0_1(tmp_0);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_measurePolicy = tmp;
      var tmp2 = modifier_0._v;
      var tmp6 = $composer_0;
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var $changed_0 = 384 | 14 & $dirty >> 3 | 112 & $dirty << 3;
      var modifier_1 = tmp2;
      var $composer_1 = tmp6;
      if (!((0 & 2) === 0))
        modifier_1 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
      var localMap = $composer_1.t31();
      var materialized = materialize($composer_1, modifier_1);
      var tmp0 = Companion_getInstance_14().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $changed_1 = 6 | 896 & $changed_0 << 6;
      var $composer_2 = $composer_1;
      var tmp_1 = $composer_2.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_2.b31();
      if ($composer_2.h30()) {
        $composer_2.c31(tmp0);
      } else {
        $composer_2.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp0_measurePolicy, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      content($composer_2, 14 & $changed_1 >> 6);
      $composer_2.e31();
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(SimpleLayout$lambda_0(modifier_0, content, $changed, $default));
    }
  }
  function sam$androidx_compose_ui_layout_MeasurePolicy$0_1(function_0) {
    this.alk_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).mak = function (_this__u8e3s4, measurables, constraints) {
    return this.alk_1(_this__u8e3s4, measurables, new Constraints(constraints));
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).q3 = function () {
    return this.alk_1;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function SimpleLayout$lambda($this$Layout, measurables, constraints) {
    var width = 0;
    var height = 0;
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        var placeable = item.h8y(constraints.m5e_1);
        var tmp0 = width;
        // Inline function 'kotlin.math.max' call
        var b = placeable.i8y_1;
        width = Math.max(tmp0, b);
        var tmp0_0 = height;
        // Inline function 'kotlin.math.max' call
        var b_0 = placeable.j8y_1;
        height = Math.max(tmp0_0, b_0);
        // Inline function 'kotlin.collections.plusAssign' call
        target.j1(placeable);
      }
       while (inductionVariable <= last);
    var placeables = target;
    var tmp = width;
    var tmp_0 = height;
    return $this$Layout.n8y(tmp, tmp_0, VOID, SimpleLayout$lambda$lambda(placeables));
  }
  function SimpleLayout$lambda$lambda($placeables) {
    return function ($this$layout) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = $placeables;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          $this$layout.jal(item, 0, 0);
        }
         while (inductionVariable <= last);
      return Unit_instance;
    };
  }
  function SimpleLayout$lambda_0($modifier, $content, $$changed, $$default) {
    return function ($composer, $force) {
      SimpleLayout($modifier._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var androidx_compose_foundation_text_selection_TextFieldSelectionManager$stable;
  function onEnd($this) {
    $this.elk_1.flk(null);
    $this.elk_1.glk(null);
    $this.dlk_1 = Companion_getInstance_87().eki_1;
    updateFloatingToolbar($this.elk_1, true);
    var tmp0_safe_receiver = $this.clk_1;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new TextRange(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = _TextRange___get_collapsed__impl__cilesp(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    var collapsed = tmp1_elvis_lhs == null ? _TextRange___get_collapsed__impl__cilesp($this.elk_1.mk8().g8a_1) : tmp1_elvis_lhs;
    setHandleState($this.elk_1, collapsed ? HandleState_Cursor_getInstance() : HandleState_Selection_getInstance());
    var tmp2_safe_receiver = $this.elk_1.uk1_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.yk6(!collapsed && isSelectionHandleInVisibleBound($this.elk_1, true));
    }
    var tmp3_safe_receiver = $this.elk_1.uk1_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.ak7(!collapsed && isSelectionHandleInVisibleBound($this.elk_1, false));
    }
    var tmp4_safe_receiver = $this.elk_1.uk1_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.ck7(collapsed && isSelectionHandleInVisibleBound($this.elk_1, true));
    }
    if ($this.blk_1) {
      maybeSuggestSelection($this.elk_1, $this.elk_1.hk2_1);
    }
    $this.elk_1.hk2_1 = null;
  }
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda(this$0, resultContinuation) {
    this.plk_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.plk_1.hl2();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda(this.plk_1, completion);
    i.qlk_1 = $this$launch;
    return i;
  };
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_0(this$0, resultContinuation) {
    var i = new TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.zk1_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp = CoroutineStart_UNDISPATCHED_getInstance();
        launch(tmp0_safe_receiver, VOID, tmp, TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_0(this$0, null));
      }
      this$0.lk8();
      return Unit_instance;
    };
  }
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_1(this$0, resultContinuation) {
    this.zlk_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.zlk_1.skk();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_1).q24 = function ($this$launch, completion) {
    var i = new TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_1(this.zlk_1, completion);
    i.all_1 = $this$launch;
    return i;
  };
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_2(this$0, resultContinuation) {
    var i = new TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda_0(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.zk1_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp = CoroutineStart_UNDISPATCHED_getInstance();
        launch(tmp0_safe_receiver, VOID, tmp, TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_2(this$0, null));
      }
      this$0.lk8();
      return Unit_instance;
    };
  }
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_3(this$0, resultContinuation) {
    this.jll_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_3).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.jll_1.rkk();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_3).q24 = function ($this$launch, completion) {
    var i = new TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_3(this.jll_1, completion);
    i.kll_1 = $this$launch;
    return i;
  };
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_4(this$0, resultContinuation) {
    var i = new TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_3(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda_1(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.zk1_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp = CoroutineStart_UNDISPATCHED_getInstance();
        launch(tmp0_safe_receiver, VOID, tmp, TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda$slambda_4(this$0, null));
      }
      this$0.lk8();
      return Unit_instance;
    };
  }
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda_2(this$0) {
    return function () {
      this$0.lll();
      return Unit_instance;
    };
  }
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda_3(this$0) {
    return function () {
      this$0.mll();
      return Unit_instance;
    };
  }
  function _set_hasAvailableTextToPaste__dd9i53($this, _set____db54di) {
    var tmp0 = $this.pk2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSelectionManager$_get_hasAvailableTextToPaste_$ref_2rxvke();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('hasAvailableTextToPaste', 1, tmp, tmp_0, TextFieldSelectionManager$_set_hasAvailableTextToPaste_$ref_u1g6te());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_hasAvailableTextToPaste__xuewej($this) {
    var tmp0 = $this.pk2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSelectionManager$_get_hasAvailableTextToPaste_$ref_2rxvke();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('hasAvailableTextToPaste', 1, tmp, tmp_0, TextFieldSelectionManager$_set_hasAvailableTextToPaste_$ref_u1g6te());
    return tmp0.u1();
  }
  function maybeSuggestSelection($this, selection) {
    var tmp = selection;
    if ((tmp == null ? null : new TextRange(tmp)) == null)
      return Unit_instance;
    var tmp0_elvis_lhs = $this.ak2_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var platformSelectionBehaviors = tmp_0;
    var tmp1_safe_receiver = $this.pk8();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h7q_1;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var text = tmp_1;
    var offsetMapping = $this.sk1_1;
    var transformedSelection = TextRange_0(offsetMapping.o8c(_TextRange___get_start__impl__ww4t90(selection)), offsetMapping.o8c(_TextRange___get_end__impl__gcdxpp(selection)));
    var tmp_2;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(text) > 0) {
      tmp_2 = !_TextRange___get_collapsed__impl__cilesp(transformedSelection);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      var tmp3_safe_receiver = $this.zk1_1;
      if (tmp3_safe_receiver == null)
        null;
      else {
        launch(tmp3_safe_receiver, VOID, VOID, TextFieldSelectionManager$maybeSuggestSelection$slambda_0(platformSelectionBehaviors, text, transformedSelection, offsetMapping, selection, $this, null));
      }
    }
  }
  function _get_isPassword__r21sje($this) {
    var tmp = $this.wk1_1;
    return tmp instanceof PasswordVisualTransformation;
  }
  function _get_hasSelection__k9xj7r($this) {
    return !_TextRange___get_collapsed__impl__cilesp($this.mk8().g8a_1);
  }
  function getContextTextAndSelection($this) {
    var tmp0_safe_receiver = $this.pk8();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h7q_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var text = tmp;
    var tmp2_safe_receiver = $this.ok2_1;
    var tmp_0;
    var tmp_1 = tmp2_safe_receiver;
    if ((tmp_1 == null ? null : new TextRange(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      var tmp_2 = tmp2_safe_receiver;
      // Inline function 'kotlin.let' call
      var selection = (tmp_2 == null ? null : new TextRange(tmp_2)).b7u_1;
      tmp_0 = TextRange_0($this.sk1_1.o8c(_TextRange___get_start__impl__ww4t90(selection)), $this.sk1_1.o8c(_TextRange___get_end__impl__gcdxpp(selection)));
    }
    var tmp3_elvis_lhs = tmp_0;
    var tmp_3;
    var tmp_4 = tmp3_elvis_lhs;
    if ((tmp_4 == null ? null : new TextRange(tmp_4)) == null) {
      return null;
    } else {
      tmp_3 = tmp3_elvis_lhs;
    }
    var selection_0 = tmp_3;
    return new Pair(text, new TextRange(selection_0));
  }
  function updateFloatingToolbar($this, show) {
    var tmp0_safe_receiver = $this.uk1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.wk6(show);
    }
    if (show) {
      $this.ok8();
    } else {
      $this.lk8();
    }
  }
  function showSelectionToolbarViaTextToolbar($this) {
    var tmp0_safe_receiver = $this.zk1_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
      tmp = launch(tmp0_safe_receiver, VOID, tmp_0, TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda_0($this, null));
    }
    return tmp;
  }
  function getContentRect($this) {
    var tmp0_safe_receiver = $this.uk1_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (!tmp0_safe_receiver.qk5_1) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var transformedStart = $this.sk1_1.o8c(_TextRange___get_start__impl__ww4t90($this.mk8().g8a_1));
      var transformedEnd = $this.sk1_1.o8c(_TextRange___get_end__impl__gcdxpp($this.mk8().g8a_1));
      var tmp0_safe_receiver_0 = $this.uk1_1;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.rk7();
      var tmp2_elvis_lhs = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.dai($this.nll(true));
      var tmp_1;
      var tmp_2 = tmp2_elvis_lhs;
      if ((tmp_2 == null ? null : new Offset(tmp_2)) == null) {
        tmp_1 = Companion_getInstance_6().g5d_1;
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      var startOffset = tmp_1;
      var tmp3_safe_receiver = $this.uk1_1;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.rk7();
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.dai($this.nll(false));
      var tmp_3;
      var tmp_4 = tmp5_elvis_lhs;
      if ((tmp_4 == null ? null : new Offset(tmp_4)) == null) {
        tmp_3 = Companion_getInstance_6().g5d_1;
      } else {
        tmp_3 = tmp5_elvis_lhs;
      }
      var endOffset = tmp_3;
      var tmp6_safe_receiver = $this.uk1_1;
      var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.rk7();
      var tmp_5;
      if (tmp7_safe_receiver == null) {
        tmp_5 = null;
      } else {
        var tmp8_safe_receiver = tmp1_safe_receiver.tk7();
        var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.hk8_1;
        var tmp10_safe_receiver = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.c7u(transformedStart);
        var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.l5d_1;
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var val2 = tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs;
        var v1 = fromInt(toRawBits(0.0));
        var v2 = fromInt(toRawBits(val2));
        var tmp$ret$5 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        var tmp$ret$4 = _Offset___init__impl__c168vi(tmp$ret$5);
        tmp_5 = tmp7_safe_receiver.dai(tmp$ret$4);
      }
      var tmp12_safe_receiver = tmp_5;
      var tmp_6;
      var tmp_7 = tmp12_safe_receiver;
      if ((tmp_7 == null ? null : new Offset(tmp_7)) == null) {
        tmp_6 = null;
      } else {
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value = _Offset___get_packedValue__impl__xh2k8q(tmp12_safe_receiver);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
        tmp_6 = floatFromBits(bits);
      }
      var tmp13_elvis_lhs = tmp_6;
      var startTop = tmp13_elvis_lhs == null ? 0.0 : tmp13_elvis_lhs;
      var tmp14_safe_receiver = $this.uk1_1;
      var tmp15_safe_receiver = tmp14_safe_receiver == null ? null : tmp14_safe_receiver.rk7();
      var tmp_8;
      if (tmp15_safe_receiver == null) {
        tmp_8 = null;
      } else {
        var tmp16_safe_receiver = tmp1_safe_receiver.tk7();
        var tmp17_safe_receiver = tmp16_safe_receiver == null ? null : tmp16_safe_receiver.hk8_1;
        var tmp18_safe_receiver = tmp17_safe_receiver == null ? null : tmp17_safe_receiver.c7u(transformedEnd);
        var tmp19_elvis_lhs = tmp18_safe_receiver == null ? null : tmp18_safe_receiver.l5d_1;
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var val2_0 = tmp19_elvis_lhs == null ? 0.0 : tmp19_elvis_lhs;
        var v1_0 = fromInt(toRawBits(0.0));
        var v2_0 = fromInt(toRawBits(val2_0));
        var tmp$ret$11 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
        var tmp$ret$10 = _Offset___init__impl__c168vi(tmp$ret$11);
        tmp_8 = tmp15_safe_receiver.dai(tmp$ret$10);
      }
      var tmp20_safe_receiver = tmp_8;
      var tmp_9;
      var tmp_10 = tmp20_safe_receiver;
      if ((tmp_10 == null ? null : new Offset(tmp_10)) == null) {
        tmp_9 = null;
      } else {
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_0 = _Offset___get_packedValue__impl__xh2k8q(tmp20_safe_receiver);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        tmp_9 = floatFromBits(bits_0);
      }
      var tmp21_elvis_lhs = tmp_9;
      var endTop = tmp21_elvis_lhs == null ? 0.0 : tmp21_elvis_lhs;
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_1 = _Offset___get_packedValue__impl__xh2k8q(startOffset);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(shiftRight(value_1, 32));
      var tmp0 = floatFromBits(bits_1);
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_2 = _Offset___get_packedValue__impl__xh2k8q(endOffset);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(shiftRight(value_2, 32));
      // Inline function 'kotlin.math.min' call
      var b = floatFromBits(bits_2);
      var left = Math.min(tmp0, b);
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_3 = _Offset___get_packedValue__impl__xh2k8q(startOffset);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_3 = convertToInt(shiftRight(value_3, 32));
      var tmp0_0 = floatFromBits(bits_3);
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_4 = _Offset___get_packedValue__impl__xh2k8q(endOffset);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_4 = convertToInt(shiftRight(value_4, 32));
      // Inline function 'kotlin.math.max' call
      var b_0 = floatFromBits(bits_4);
      var right = Math.max(tmp0_0, b_0);
      // Inline function 'kotlin.math.min' call
      var top = Math.min(startTop, endTop);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_5 = _Offset___get_packedValue__impl__xh2k8q(startOffset);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_5 = convertToInt(bitwiseAnd(value_5, new Long(-1, 0)));
      var tmp0_1 = floatFromBits(bits_5);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_6 = _Offset___get_packedValue__impl__xh2k8q(endOffset);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
      // Inline function 'kotlin.math.max' call
      var b_1 = floatFromBits(bits_6);
      var tmp_11 = Math.max(tmp0_1, b_1);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$44 = _Dp___init__impl__ms3zkb(25);
      var bottom = tmp_11 + _Dp___get_value__impl__geb1vb(tmp$ret$44) * tmp1_safe_receiver.bk5_1.ck8_1.u5e();
      return new Rect(left, top, right, bottom);
    }
    return Companion_getInstance_50().j5d_1;
  }
  function updateSelection($this, value, currentPosition, isStartOfSelection, isStartHandle, adjustment, isTouchBasedSelection, hapticFeedbackType) {
    var tmp0_safe_receiver = $this.uk1_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Companion_getInstance_43().n7u_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var layoutResult = tmp;
    var previousTransformedSelection = TextRange_0($this.sk1_1.o8c(_TextRange___get_start__impl__ww4t90(value.g8a_1)), $this.sk1_1.o8c(_TextRange___get_end__impl__gcdxpp(value.g8a_1)));
    var currentOffset = layoutResult.rkq(currentPosition, false);
    var rawStartHandleOffset = isStartHandle || isStartOfSelection ? currentOffset : _TextRange___get_start__impl__ww4t90(previousTransformedSelection);
    var rawEndHandleOffset = !isStartHandle || isStartOfSelection ? currentOffset : _TextRange___get_end__impl__gcdxpp(previousTransformedSelection);
    var previousSelectionLayout = $this.nk2_1;
    var tmp_0;
    if (isStartOfSelection || previousSelectionLayout == null || $this.lk2_1 === -1) {
      tmp_0 = -1;
    } else {
      tmp_0 = $this.lk2_1;
    }
    var rawPreviousHandleOffset = tmp_0;
    var selectionLayout = getTextFieldSelectionLayout(layoutResult.hk8_1, rawStartHandleOffset, rawEndHandleOffset, rawPreviousHandleOffset, previousTransformedSelection, isStartOfSelection, isStartHandle);
    if (!selectionLayout.zlj(previousSelectionLayout)) {
      return value.g8a_1;
    }
    $this.nk2_1 = selectionLayout;
    $this.lk2_1 = currentOffset;
    var newTransformedSelection = adjustment.fle(selectionLayout);
    var newSelection = TextRange_0($this.sk1_1.p8c(newTransformedSelection.flb_1.dlb_1), $this.sk1_1.p8c(newTransformedSelection.glb_1.dlb_1));
    if (equals(newSelection, value.g8a_1))
      return value.g8a_1;
    var tmp_1;
    if (!(_TextRange___get_reversed__impl__emhnbm(newSelection) === _TextRange___get_reversed__impl__emhnbm(value.g8a_1))) {
      // Inline function 'kotlin.with' call
      var tmp$ret$0 = TextRange_0(_TextRange___get_end__impl__gcdxpp(newSelection), _TextRange___get_start__impl__ww4t90(newSelection));
      tmp_1 = equals(tmp$ret$0, value.g8a_1);
    } else {
      tmp_1 = false;
    }
    var onlyChangeIsReversed = tmp_1;
    var bothSelectionsCollapsed = _TextRange___get_collapsed__impl__cilesp(newSelection) && _TextRange___get_collapsed__impl__cilesp(value.g8a_1);
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (isTouchBasedSelection) {
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = value.h89();
      tmp_5 = charSequenceLength(this_0) > 0;
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = !onlyChangeIsReversed;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = !bothSelectionsCollapsed;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      var tmp_6 = hapticFeedbackType;
      tmp_2 = !((tmp_6 == null ? null : new HapticFeedbackType(tmp_6)) == null);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      var tmp2_safe_receiver = $this.ck2_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.hcu(hapticFeedbackType);
      }
    }
    var newValue = createTextFieldValue($this, value.f8a_1, newSelection);
    $this.tk1_1(newValue);
    $this.ok2_1 = newSelection;
    if (!isTouchBasedSelection) {
      updateFloatingToolbar($this, !_TextRange___get_collapsed__impl__cilesp(newSelection));
    }
    var tmp3_safe_receiver = $this.uk1_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.dk7(isTouchBasedSelection);
    }
    var tmp4_safe_receiver = $this.uk1_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.yk6(!_TextRange___get_collapsed__impl__cilesp(newSelection) && isSelectionHandleInVisibleBound($this, true));
    }
    var tmp5_safe_receiver = $this.uk1_1;
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.ak7(!_TextRange___get_collapsed__impl__cilesp(newSelection) && isSelectionHandleInVisibleBound($this, false));
    }
    var tmp6_safe_receiver = $this.uk1_1;
    if (tmp6_safe_receiver == null)
      null;
    else {
      tmp6_safe_receiver.ck7(_TextRange___get_collapsed__impl__cilesp(newSelection) && isSelectionHandleInVisibleBound($this, true));
    }
    return newSelection;
  }
  function setHandleState($this, handleState) {
    var tmp0_safe_receiver = $this.uk1_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeUnless' call
      var tmp_0;
      if (!tmp0_safe_receiver.tk6().equals(handleState)) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp1_safe_receiver.uk6(handleState);
    }
  }
  function createTextFieldValue($this, annotatedString, selection) {
    return new TextFieldValue(annotatedString, selection);
  }
  function access$_get_isPassword__3bf5vq($this) {
    return _get_isPassword__r21sje($this);
  }
  function access$_get_hasSelection__odl9on($this) {
    return _get_hasSelection__k9xj7r($this);
  }
  function TextFieldSelectionManager$onValueChange$lambda(it) {
    return Unit_instance;
  }
  function TextFieldSelectionManager$_get_editable_$ref_ttu104() {
    return constructCallableReference(function (p0) {
      return p0.oll();
    }, 1, 0, 359);
  }
  function TextFieldSelectionManager$_set_editable_$ref_pnjaew() {
    return constructCallableReference(function (p0, p1) {
      p0.mk6(p1);
      return Unit_instance;
    }, 2, 0, 360);
  }
  function TextFieldSelectionManager$_get_enabled_$ref_c3f8c7() {
    return constructCallableReference(function (p0) {
      return p0.uk2();
    }, 1, 0, 361);
  }
  function TextFieldSelectionManager$_set_enabled_$ref_snanb1() {
    return constructCallableReference(function (p0, p1) {
      p0.nk6(p1);
      return Unit_instance;
    }, 2, 0, 362);
  }
  function TextFieldSelectionManager$_get_draggingHandle_$ref_j7ws87() {
    return constructCallableReference(function (p0) {
      return p0.pll();
    }, 1, 0, 363);
  }
  function TextFieldSelectionManager$_set_draggingHandle_$ref_epyiw5() {
    return constructCallableReference(function (p0, p1) {
      p0.flk(p1);
      return Unit_instance;
    }, 2, 0, 364);
  }
  function TextFieldSelectionManager$_get_currentDragPosition_$ref_7t2ung() {
    return constructCallableReference(function (p0) {
      var tmp = p0.qll();
      return tmp == null ? null : new Offset(tmp);
    }, 1, 0, 365);
  }
  function TextFieldSelectionManager$_set_currentDragPosition_$ref_co2jm0() {
    return constructCallableReference(function (p0, p1) {
      var tmp = p1;
      p0.glk(tmp == null ? null : tmp.e5d_1);
      return Unit_instance;
    }, 2, 0, 366);
  }
  function TextFieldSelectionManager$_get_hasAvailableTextToPaste_$ref_2rxvke() {
    return constructCallableReference(function (p0) {
      return _get_hasAvailableTextToPaste__xuewej(p0);
    }, 1, 0, 367);
  }
  function TextFieldSelectionManager$_set_hasAvailableTextToPaste_$ref_u1g6te() {
    return constructCallableReference(function (p0, p1) {
      _set_hasAvailableTextToPaste__dd9i53(p0, p1);
      return Unit_instance;
    }, 2, 0, 368);
  }
  function TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin(this$0, resultContinuation) {
    this.zll_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin).dlm = function (clickLocation, $completion) {
    var tmp = this.ahc(clickLocation, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin).ja = function (p1, $completion) {
    return this.dlm(p1 instanceof Offset ? p1.e5d_1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            suspendResult = this.zll_1.mk4(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = getContextTextAndSelection(this.zll_1);
            if (tmp0_safe_receiver == null) {
              this.blm_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              var text = tmp0_safe_receiver.zh();
              var selection = tmp0_safe_receiver.ai().b7u_1;
              var tmp0_safe_receiver_0 = this.zll_1.ak2_1;
              if (tmp0_safe_receiver_0 == null) {
                this.clm_1 = null;
                this.n9_1 = 3;
                continue $sm;
              } else {
                this.n9_1 = 2;
                suspendResult = tmp0_safe_receiver_0.elm(text, selection, this.alm_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 2:
            var tmp_0 = this;
            tmp_0.clm_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp_1 = this;
            tmp_1.blm_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin).ahc = function (clickLocation, completion) {
    var i = new TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin(this.zll_1, completion);
    i.alm_1 = clickLocation;
    return i;
  };
  function TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_0(this$0, resultContinuation) {
    var i = new TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin(this$0, resultContinuation);
    return constructCallableReference(function (clickLocation, $completion) {
      return i.dlm(clickLocation.e5d_1, $completion);
    }, 1);
  }
  function TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_1(this$0, resultContinuation) {
    this.nlm_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_1).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_1).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            suspendResult = this.nlm_1.mk4(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = getContextTextAndSelection(this.nlm_1);
            if (tmp0_safe_receiver == null) {
              this.olm_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              var text = tmp0_safe_receiver.zh();
              var selection = tmp0_safe_receiver.ai().b7u_1;
              var tmp0_safe_receiver_0 = this.nlm_1.ak2_1;
              if (tmp0_safe_receiver_0 == null) {
                this.plm_1 = null;
                this.n9_1 = 3;
                continue $sm;
              } else {
                this.n9_1 = 2;
                suspendResult = tmp0_safe_receiver_0.qlm(text, selection, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 2:
            var tmp_0 = this;
            tmp_0.plm_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.olm_1 = this.plm_1;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.nlm_1.tk2_1 = true;
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_1).s2b = function (completion) {
    return new TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_1(this.nlm_1, completion);
  };
  function TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_2(this$0, resultContinuation) {
    var i = new TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_1(this$0, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_3(this$0, resultContinuation) {
    this.zlm_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_3).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_3).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.zlm_1.tk2_1 = false;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_3).s2b = function (completion) {
    return new TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_3(this.zlm_1, completion);
  };
  function TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_4(this$0, resultContinuation) {
    var i = new TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_3(this$0, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function TextFieldSelectionManager$_get_contextMenuAreaModifier_$lambda_3z0dcy(this$0) {
    return function (destinationCoordinates) {
      var rootBounds = getContentRect(this$0);
      var tmp0_safe_receiver = this$0.uk1_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rk7();
      var tmp;
      if (tmp1_elvis_lhs == null) {
        return null;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var localCoordinates = tmp;
      return translateRootToDestination(rootBounds, localCoordinates, destinationCoordinates);
    };
  }
  function TextFieldSelectionManager$touchSelectionObserver$1(this$0) {
    this.elk_1 = this$0;
    this.blk_1 = true;
    this.clk_1 = null;
    this.dlk_1 = Companion_getInstance_87().eki_1;
  }
  protoOf(TextFieldSelectionManager$touchSelectionObserver$1).cki = function (point) {
  };
  protoOf(TextFieldSelectionManager$touchSelectionObserver$1).dki = function () {
  };
  protoOf(TextFieldSelectionManager$touchSelectionObserver$1).jki = function (startPoint, selectionAdjustment) {
    if (!this.elk_1.uk2() || !(this.elk_1.pll() == null))
      return Unit_instance;
    this.elk_1.flk(Handle_SelectionEnd_getInstance());
    this.elk_1.lk2_1 = -1;
    this.blk_1 = true;
    this.dlk_1 = selectionAdjustment;
    this.elk_1.lk8();
    var tmp2_safe_receiver = this.elk_1.uk1_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.tk7();
    if (!((tmp3_safe_receiver == null ? null : tmp3_safe_receiver.tkq(startPoint)) === true)) {
      var tmp0_safe_receiver = this.elk_1.uk1_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7();
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var transformedOffset = tmp1_safe_receiver.ekj(startPoint);
        var offset = this.elk_1.sk1_1.p8c(transformedOffset);
        var newValue = createTextFieldValue(this.elk_1, this.elk_1.mk8().f8a_1, TextRange_0(offset, offset));
        this.elk_1.aln(false);
        var tmp0_safe_receiver_0 = this.elk_1.ck2_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.hcu(Companion_instance_1.g9t());
        }
        this.elk_1.tk1_1(newValue);
        this.elk_1.ok2_1 = newValue.g8a_1;
      }
      this.blk_1 = false;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = this.elk_1.mk8().h89();
      if (charSequenceLength(this_0) === 0)
        return Unit_instance;
      this.elk_1.aln(false);
      var adjustedStartSelection = updateSelection(this.elk_1, this.elk_1.mk8().j8a(VOID, Companion_getInstance_43().n7u_1), startPoint, true, false, this.dlk_1, true, Companion_instance_1.g9t());
      this.elk_1.hk2_1 = adjustedStartSelection;
      this.clk_1 = adjustedStartSelection;
    }
    setHandleState(this.elk_1, HandleState_None_getInstance());
    this.elk_1.gk2_1 = startPoint;
    this.elk_1.glk(this.elk_1.gk2_1);
    this.elk_1.ik2_1 = Companion_getInstance_6().g5d_1;
  };
  protoOf(TextFieldSelectionManager$touchSelectionObserver$1).lki = function (delta) {
    var tmp;
    if (!this.elk_1.uk2()) {
      tmp = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = this.elk_1.mk8().h89();
      tmp = charSequenceLength(this_0) === 0;
    }
    if (tmp)
      return Unit_instance;
    this.elk_1.ik2_1 = Offset__plus_impl_c78cg0(this.elk_1.ik2_1, delta);
    var tmp0_safe_receiver = this.elk_1.uk1_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.elk_1.glk(Offset__plus_impl_c78cg0(this.elk_1.gk2_1, this.elk_1.ik2_1));
      var tmp_0;
      var tmp_1;
      var tmp_2 = this.elk_1.hk2_1;
      if ((tmp_2 == null ? null : new TextRange(tmp_2)) == null) {
        var tmp_3 = this.elk_1.qll();
        tmp_1 = !tmp1_safe_receiver.tkq(ensureNotNull(tmp_3 == null ? null : new Offset(tmp_3)).e5d_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var startOffset = this.elk_1.sk1_1.p8c(tmp1_safe_receiver.ekj(this.elk_1.gk2_1));
        var tmp_4 = this.elk_1.sk1_1;
        var tmp_5 = this.elk_1.qll();
        var endOffset = tmp_4.p8c(tmp1_safe_receiver.ekj(ensureNotNull(tmp_5 == null ? null : new Offset(tmp_5)).e5d_1));
        var tmp_6;
        if (startOffset === endOffset) {
          tmp_6 = Companion_getInstance_87().eki_1;
        } else {
          tmp_6 = Companion_getInstance_87().gki_1;
        }
        var adjustment = tmp_6;
        var tmp_7 = this.elk_1.mk8();
        var tmp_8 = this.elk_1.qll();
        tmp_0 = updateSelection(this.elk_1, tmp_7, ensureNotNull(tmp_8 == null ? null : new Offset(tmp_8)).e5d_1, false, false, adjustment, true, Companion_instance_1.c9t());
      } else {
        var tmp0_safe_receiver_0 = this.elk_1.hk2_1;
        var tmp_9;
        var tmp_10 = tmp0_safe_receiver_0;
        if ((tmp_10 == null ? null : new TextRange(tmp_10)) == null) {
          tmp_9 = null;
        } else {
          tmp_9 = _TextRange___get_start__impl__ww4t90(tmp0_safe_receiver_0);
        }
        var tmp1_elvis_lhs = tmp_9;
        var startOffset_0 = tmp1_elvis_lhs == null ? tmp1_safe_receiver.rkq(this.elk_1.gk2_1, false) : tmp1_elvis_lhs;
        var tmp_11 = this.elk_1.qll();
        var endOffset_0 = tmp1_safe_receiver.rkq(ensureNotNull(tmp_11 == null ? null : new Offset(tmp_11)).e5d_1, false);
        var tmp_12;
        var tmp_13 = this.elk_1.hk2_1;
        if ((tmp_13 == null ? null : new TextRange(tmp_13)) == null) {
          tmp_12 = startOffset_0 === endOffset_0;
        } else {
          tmp_12 = false;
        }
        if (tmp_12) {
          return Unit_instance;
        }
        var tmp_14 = this.elk_1.mk8();
        var tmp_15 = this.elk_1.qll();
        tmp_0 = updateSelection(this.elk_1, tmp_14, ensureNotNull(tmp_15 == null ? null : new Offset(tmp_15)).e5d_1, false, false, this.dlk_1, true, Companion_instance_1.c9t());
      }
      var newSelection = tmp_0;
      this.clk_1 = newSelection;
      var tmp_16 = this.elk_1.hk2_1;
      if (!equals(new TextRange(newSelection), tmp_16 == null ? null : new TextRange(tmp_16))) {
        this.blk_1 = false;
      }
    }
    updateFloatingToolbar(this.elk_1, false);
  };
  protoOf(TextFieldSelectionManager$touchSelectionObserver$1).kki = function () {
    return onEnd(this);
  };
  protoOf(TextFieldSelectionManager$touchSelectionObserver$1).sb0 = function () {
    return onEnd(this);
  };
  function TextFieldSelectionManager$mouseSelectionObserver$1(this$0) {
    this.dln_1 = this$0;
    this.bln_1 = true;
    this.cln_1 = null;
  }
  protoOf(TextFieldSelectionManager$mouseSelectionObserver$1).flj = function (downPosition) {
    var tmp0_safe_receiver = this.dln_1.uk1_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7()) == null)
      return false;
    if (!this.dln_1.uk2())
      return false;
    this.dln_1.lk2_1 = -1;
    var tmp2_safe_receiver = this.dln_1.dk2_1;
    if (tmp2_safe_receiver == null)
      null;
    else
      tmp2_safe_receiver.u9g();
    this.eln(this.dln_1.mk8(), downPosition, false, Companion_getInstance_87().eki_1);
    return true;
  };
  protoOf(TextFieldSelectionManager$mouseSelectionObserver$1).qli = function (dragPosition) {
    var tmp;
    if (!this.dln_1.uk2()) {
      tmp = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = this.dln_1.mk8().h89();
      tmp = charSequenceLength(this_0) === 0;
    }
    if (tmp)
      return false;
    var tmp0_safe_receiver = this.dln_1.uk1_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7()) == null)
      return false;
    this.eln(this.dln_1.mk8(), dragPosition, false, Companion_getInstance_87().eki_1);
    return true;
  };
  protoOf(TextFieldSelectionManager$mouseSelectionObserver$1).elj = function (downPosition, adjustment, clickCount) {
    var tmp;
    if (!this.dln_1.uk2()) {
      tmp = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = this.dln_1.mk8().h89();
      tmp = charSequenceLength(this_0) === 0;
    }
    if (tmp)
      return false;
    var tmp0_safe_receiver = this.dln_1.uk1_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7()) == null)
      return false;
    var tmp2_safe_receiver = this.dln_1.dk2_1;
    if (tmp2_safe_receiver == null)
      null;
    else
      tmp2_safe_receiver.u9g();
    this.dln_1.gk2_1 = downPosition;
    this.dln_1.lk2_1 = -1;
    this.dln_1.gl2();
    var newSelection = this.eln(this.dln_1.mk8(), this.dln_1.gk2_1, true, adjustment);
    if (clickCount >= 2) {
      this.bln_1 = true;
      this.cln_1 = newSelection;
    }
    return true;
  };
  protoOf(TextFieldSelectionManager$mouseSelectionObserver$1).rli = function (dragPosition, adjustment) {
    var tmp;
    if (!this.dln_1.uk2()) {
      tmp = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = this.dln_1.mk8().h89();
      tmp = charSequenceLength(this_0) === 0;
    }
    if (tmp)
      return false;
    var tmp0_safe_receiver = this.dln_1.uk1_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7()) == null)
      return false;
    this.eln(this.dln_1.mk8(), dragPosition, false, adjustment);
    return true;
  };
  protoOf(TextFieldSelectionManager$mouseSelectionObserver$1).eln = function (value, currentPosition, isStartOfSelection, adjustment) {
    var newSelection = updateSelection(this.dln_1, value, currentPosition, isStartOfSelection, false, adjustment, false, null);
    var tmp = this.cln_1;
    if (!equals(new TextRange(newSelection), tmp == null ? null : new TextRange(tmp))) {
      this.bln_1 = false;
    }
    setHandleState(this.dln_1, _TextRange___get_collapsed__impl__cilesp(newSelection) ? HandleState_Cursor_getInstance() : HandleState_Selection_getInstance());
    return newSelection;
  };
  protoOf(TextFieldSelectionManager$mouseSelectionObserver$1).glj = function () {
    if (this.bln_1) {
      maybeSuggestSelection(this.dln_1, this.cln_1);
    }
  };
  function TextFieldSelectionManager$maybeSuggestSelection$slambda($platformSelectionBehaviors, $text, $transformedSelection, $offsetMapping, $selection, this$0, resultContinuation) {
    this.nln_1 = $platformSelectionBehaviors;
    this.oln_1 = $text;
    this.pln_1 = $transformedSelection;
    this.qln_1 = $offsetMapping;
    this.rln_1 = $selection;
    this.sln_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionManager$maybeSuggestSelection$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager$maybeSuggestSelection$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldSelectionManager$maybeSuggestSelection$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.nln_1.uln(this.oln_1, this.pln_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.n9_1 = 2;
            continue $sm;
          case 1:
            var tmp_0 = suspendResult;
            var unboxed = tmp_0 == null ? null : tmp_0.b7u_1;
            var tmp_1 = unboxed;
            suspendResult = tmp_1 == null ? null : new TextRange(tmp_1);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var tmp_2 = suspendResult;
            var tmp0_safe_receiver = tmp_2 == null ? null : tmp_2.b7u_1;
            var tmp_3;
            var tmp_4 = tmp0_safe_receiver;
            if ((tmp_4 == null ? null : new TextRange(tmp_4)) == null) {
              tmp_3 = null;
            } else {
              var tmp_5 = tmp0_safe_receiver;
              var it = (tmp_5 == null ? null : new TextRange(tmp_5)).b7u_1;
              tmp_3 = TextRange_0(this.qln_1.p8c(_TextRange___get_start__impl__ww4t90(it)), this.qln_1.p8c(_TextRange___get_end__impl__gcdxpp(it)));
            }

            var tmp1_elvis_lhs = tmp_3;
            var tmp_6;
            var tmp_7 = tmp1_elvis_lhs;
            if ((tmp_7 == null ? null : new TextRange(tmp_7)) == null) {
              return Unit_instance;
            } else {
              tmp_6 = tmp1_elvis_lhs;
            }

            var newSelection = tmp_6;
            var tmp_8;
            var tmp_9;
            var tmp_10 = this.rln_1;
            if (!equals(new TextRange(newSelection), tmp_10 == null ? null : new TextRange(tmp_10))) {
              tmp_9 = this.sln_1.mk8().h89() === this.oln_1;
            } else {
              tmp_9 = false;
            }

            if (tmp_9) {
              tmp_8 = this.qln_1 === this.sln_1.sk1_1;
            } else {
              tmp_8 = false;
            }

            if (tmp_8) {
              this.sln_1.tk1_1(createTextFieldValue(this.sln_1, this.sln_1.mk8().f8a_1, newSelection));
              this.sln_1.ok2_1 = newSelection;
            }

            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFieldSelectionManager$maybeSuggestSelection$slambda).q24 = function ($this$launch, completion) {
    var i = new TextFieldSelectionManager$maybeSuggestSelection$slambda(this.nln_1, this.oln_1, this.pln_1, this.qln_1, this.rln_1, this.sln_1, completion);
    i.tln_1 = $this$launch;
    return i;
  };
  function TextFieldSelectionManager$maybeSuggestSelection$slambda_0($platformSelectionBehaviors, $text, $transformedSelection, $offsetMapping, $selection, this$0, resultContinuation) {
    var i = new TextFieldSelectionManager$maybeSuggestSelection$slambda($platformSelectionBehaviors, $text, $transformedSelection, $offsetMapping, $selection, this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TextFieldSelectionManager$handleDragObserver$1(this$0, $isStartHandle) {
    this.vln_1 = this$0;
    this.wln_1 = $isStartHandle;
  }
  protoOf(TextFieldSelectionManager$handleDragObserver$1).cki = function (point) {
    this.vln_1.flk(this.wln_1 ? Handle_SelectionStart_getInstance() : Handle_SelectionEnd_getInstance());
    var handleCoordinates = getAdjustedCoordinates(this.vln_1.nll(this.wln_1));
    var tmp0_safe_receiver = this.vln_1.uk1_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var layoutResult = tmp;
    var translatedPosition = layoutResult.ukq(handleCoordinates);
    this.vln_1.gk2_1 = translatedPosition;
    this.vln_1.glk(translatedPosition);
    this.vln_1.ik2_1 = Companion_getInstance_6().g5d_1;
    this.vln_1.lk2_1 = -1;
    var tmp2_safe_receiver = this.vln_1.uk1_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.dk7(true);
    }
    updateFloatingToolbar(this.vln_1, false);
  };
  protoOf(TextFieldSelectionManager$handleDragObserver$1).dki = function () {
    this.vln_1.flk(null);
    this.vln_1.glk(null);
    updateFloatingToolbar(this.vln_1, true);
  };
  protoOf(TextFieldSelectionManager$handleDragObserver$1).jki = function (startPoint, selectionAdjustment) {
  };
  protoOf(TextFieldSelectionManager$handleDragObserver$1).lki = function (delta) {
    this.vln_1.ik2_1 = Offset__plus_impl_c78cg0(this.vln_1.ik2_1, delta);
    this.vln_1.glk(Offset__plus_impl_c78cg0(this.vln_1.gk2_1, this.vln_1.ik2_1));
    var tmp = this.vln_1.mk8();
    var tmp_0 = this.vln_1.qll();
    updateSelection(this.vln_1, tmp, ensureNotNull(tmp_0 == null ? null : new Offset(tmp_0)).e5d_1, false, this.wln_1, Companion_getInstance_87().iki_1, true, Companion_instance_1.c9t());
    updateFloatingToolbar(this.vln_1, false);
  };
  protoOf(TextFieldSelectionManager$handleDragObserver$1).kki = function () {
    this.vln_1.flk(null);
    this.vln_1.glk(null);
    updateFloatingToolbar(this.vln_1, true);
  };
  protoOf(TextFieldSelectionManager$handleDragObserver$1).sb0 = function () {
  };
  function TextFieldSelectionManager$cursorDragObserver$1(this$0) {
    this.xln_1 = this$0;
  }
  protoOf(TextFieldSelectionManager$cursorDragObserver$1).cki = function (point) {
  };
  protoOf(TextFieldSelectionManager$cursorDragObserver$1).dki = function () {
    this.xln_1.flk(null);
    this.xln_1.glk(null);
  };
  protoOf(TextFieldSelectionManager$cursorDragObserver$1).jki = function (startPoint, selectionAdjustment) {
    var handleCoordinates = getAdjustedCoordinates(this.xln_1.nll(true));
    var tmp0_safe_receiver = this.xln_1.uk1_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var layoutResult = tmp;
    var translatedPosition = layoutResult.ukq(handleCoordinates);
    this.xln_1.gk2_1 = translatedPosition;
    this.xln_1.glk(translatedPosition);
    this.xln_1.ik2_1 = Companion_getInstance_6().g5d_1;
    this.xln_1.flk(Handle_Cursor_getInstance());
    updateFloatingToolbar(this.xln_1, false);
  };
  protoOf(TextFieldSelectionManager$cursorDragObserver$1).lki = function (delta) {
    this.xln_1.ik2_1 = Offset__plus_impl_c78cg0(this.xln_1.ik2_1, delta);
    var tmp0_safe_receiver = this.xln_1.uk1_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.xln_1.glk(Offset__plus_impl_c78cg0(this.xln_1.gk2_1, this.xln_1.ik2_1));
      var tmp = this.xln_1.sk1_1;
      var tmp_0 = this.xln_1.qll();
      var offset = tmp.p8c(tmp1_safe_receiver.ekj(ensureNotNull(tmp_0 == null ? null : new Offset(tmp_0)).e5d_1));
      var newSelection = TextRange_0(offset, offset);
      if (equals(newSelection, this.xln_1.mk8().g8a_1))
        return Unit_instance;
      var tmp1_safe_receiver_0 = this.xln_1.uk1_1;
      if (!((tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.pk6()) === false)) {
        var tmp0_safe_receiver_0 = this.xln_1.ck2_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.hcu(Companion_instance_1.c9t());
        }
      }
      this.xln_1.tk1_1(createTextFieldValue(this.xln_1, this.xln_1.mk8().f8a_1, newSelection));
      this.xln_1.ok2_1 = newSelection;
    }
  };
  protoOf(TextFieldSelectionManager$cursorDragObserver$1).kki = function () {
    this.xln_1.flk(null);
    this.xln_1.glk(null);
  };
  protoOf(TextFieldSelectionManager$cursorDragObserver$1).sb0 = function () {
  };
  function TextFieldSelectionManager$copy$slambda(this$0, $cancelSelection, resultContinuation) {
    this.glo_1 = this$0;
    this.hlo_1 = $cancelSelection;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionManager$copy$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager$copy$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldSelectionManager$copy$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_elvis_lhs = this.glo_1.klo(this.hlo_1);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var valueToCopy = tmp_0;
            var tmp1_safe_receiver = this.glo_1.yk1_1;
            if (tmp1_safe_receiver == null) {
              this.jlo_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = tmp1_safe_receiver.rc1(toClipEntry(valueToCopy), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_1 = this;
            tmp_1.jlo_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFieldSelectionManager$copy$slambda).q24 = function ($this$launch, completion) {
    var i = new TextFieldSelectionManager$copy$slambda(this.glo_1, this.hlo_1, completion);
    i.ilo_1 = $this$launch;
    return i;
  };
  function TextFieldSelectionManager$copy$slambda_0(this$0, $cancelSelection, resultContinuation) {
    var i = new TextFieldSelectionManager$copy$slambda(this$0, $cancelSelection, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TextFieldSelectionManager$paste$slambda(this$0, resultContinuation) {
    this.tlo_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionManager$paste$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager$paste$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldSelectionManager$paste$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0_safe_receiver = this.tlo_1.yk1_1;
            if (tmp0_safe_receiver == null) {
              this.wlo_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = tmp0_safe_receiver.qc1(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.wlo_1 = suspendResult;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var tmp1_safe_receiver = this.wlo_1;
            if (tmp1_safe_receiver == null) {
              this.vlo_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              this.n9_1 = 3;
              suspendResult = readAnnotatedString(tmp1_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.vlo_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            var tmp2_elvis_lhs = this.vlo_1;
            var tmp_0;
            if (tmp2_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp2_elvis_lhs;
            }

            var text = tmp_0;
            this.tlo_1.vk8(text);
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFieldSelectionManager$paste$slambda).q24 = function ($this$launch, completion) {
    var i = new TextFieldSelectionManager$paste$slambda(this.tlo_1, completion);
    i.ulo_1 = $this$launch;
    return i;
  };
  function TextFieldSelectionManager$paste$slambda_0(this$0, resultContinuation) {
    var i = new TextFieldSelectionManager$paste$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TextFieldSelectionManager$cut$slambda(this$0, resultContinuation) {
    this.flp_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionManager$cut$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager$cut$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldSelectionManager$cut$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_elvis_lhs = this.flp_1.xk8();
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var valueToCut = tmp_0;
            var tmp1_safe_receiver = this.flp_1.yk1_1;
            if (tmp1_safe_receiver == null) {
              this.hlp_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = tmp1_safe_receiver.rc1(toClipEntry(valueToCut), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_1 = this;
            tmp_1.hlp_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFieldSelectionManager$cut$slambda).q24 = function ($this$launch, completion) {
    var i = new TextFieldSelectionManager$cut$slambda(this.flp_1, completion);
    i.glp_1 = $this$launch;
    return i;
  };
  function TextFieldSelectionManager$cut$slambda_0(this$0, resultContinuation) {
    var i = new TextFieldSelectionManager$cut$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda(this$0, resultContinuation) {
    this.qlp_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.qlp_1.mk4(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            l$ret$5: do {
              var previousSnapshot = Companion_instance_2.p52();
              var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
              var newSnapshot = Companion_instance_2.q52(previousSnapshot);
              l$ret$3: do {
                l$ret$1: do {
                  try {
                    var tmp_0;
                    if (this.qlp_1.nk4()) {
                      tmp_0 = TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda(this.qlp_1);
                    } else {
                      tmp_0 = null;
                    }
                    var copy = tmp_0;
                    var tmp_1;
                    if (this.qlp_1.pk4()) {
                      tmp_1 = TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda_0(this.qlp_1);
                    } else {
                      tmp_1 = null;
                    }
                    var cut = tmp_1;
                    var tmp_2;
                    if (this.qlp_1.ok4()) {
                      tmp_2 = TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda_1(this.qlp_1);
                    } else {
                      tmp_2 = null;
                    }
                    var paste = tmp_2;
                    var tmp_3;
                    if (this.qlp_1.qk4()) {
                      tmp_3 = TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda_2(this.qlp_1);
                    } else {
                      tmp_3 = null;
                    }
                    var selectAll = tmp_3;
                    var tmp_4;
                    if (this.qlp_1.rk4()) {
                      tmp_4 = TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda$lambda_3(this.qlp_1);
                    } else {
                      tmp_4 = null;
                    }
                    var autofill = tmp_4;
                    var tmp0_safe_receiver = this.qlp_1.bk2_1;
                    if (tmp0_safe_receiver == null)
                      null;
                    else {
                      tmp0_safe_receiver.xbq(getContentRect(this.qlp_1), copy, paste, cut, selectAll, autofill);
                    }
                    break l$ret$1;
                  } catch ($p) {
                    var t = $p;
                    Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
                    throw t;
                  }
                }
                 while (false);
                Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
                break l$ret$5;
              }
               while (false);
              Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
            }
             while (false);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p_0) {
        var e = $p_0;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda).q24 = function ($this$launch, completion) {
    var i = new TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda(this.qlp_1, completion);
    i.rlp_1 = $this$launch;
    return i;
  };
  function TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda_0(this$0, resultContinuation) {
    var i = new TextFieldSelectionManager$showSelectionToolbarViaTextToolbar$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function $updateClipboardEntryCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.alq_1 = _this__u8e3s4;
  }
  protoOf($updateClipboardEntryCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.alq_1.yk1_1;
            if ((tmp0_safe_receiver == null ? null : isReadSupported(tmp0_safe_receiver)) === true) {
              this.n9_1 = 1;
              suspendResult = hasAvailableTextToPaste(this.alq_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            var ARGUMENT = suspendResult;
            _set_hasAvailableTextToPaste__dd9i53(this.alq_1, ARGUMENT);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function TextFieldSelectionManager(undoManager) {
    undoManager = undoManager === VOID ? null : undoManager;
    this.rk1_1 = undoManager;
    this.sk1_1 = get_ValidatingEmptyOffsetMappingIdentity();
    var tmp = this;
    tmp.tk1_1 = TextFieldSelectionManager$onValueChange$lambda;
    this.uk1_1 = null;
    this.vk1_1 = mutableStateOf(TextFieldValue_init_$Create$());
    this.wk1_1 = Companion_getInstance_40().o8d_1;
    this.xk1_1 = null;
    this.yk1_1 = null;
    this.zk1_1 = null;
    this.ak2_1 = null;
    this.bk2_1 = null;
    this.ck2_1 = null;
    this.dk2_1 = null;
    this.ek2_1 = mutableStateOf(true);
    this.fk2_1 = mutableStateOf(true);
    this.gk2_1 = Companion_getInstance_6().g5d_1;
    this.hk2_1 = null;
    this.ik2_1 = Companion_getInstance_6().g5d_1;
    this.jk2_1 = mutableStateOf(null);
    this.kk2_1 = mutableStateOf(null);
    this.lk2_1 = -1;
    this.mk2_1 = TextFieldValue_init_$Create$();
    this.nk2_1 = null;
    this.ok2_1 = null;
    this.pk2_1 = mutableStateOf(false);
    this.qk2_1 = new ToolbarRequesterImpl();
    var tmp_0 = this;
    tmp_0.rk2_1 = new TextFieldSelectionManager$touchSelectionObserver$1(this);
    var tmp_1 = this;
    tmp_1.sk2_1 = new TextFieldSelectionManager$mouseSelectionObserver$1(this);
    this.tk2_1 = false;
  }
  protoOf(TextFieldSelectionManager).lk6 = function (value) {
    this.vk1_1.s21(value);
    this.ok2_1 = value.g8a_1;
  };
  protoOf(TextFieldSelectionManager).mk8 = function () {
    return this.vk1_1.u1();
  };
  protoOf(TextFieldSelectionManager).pk8 = function () {
    var tmp0_safe_receiver = this.uk1_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bk5_1;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.wk7_1;
  };
  protoOf(TextFieldSelectionManager).mk6 = function (_set____db54di) {
    var tmp0 = this.ek2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSelectionManager$_get_editable_$ref_ttu104();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('editable', 1, tmp, tmp_0, TextFieldSelectionManager$_set_editable_$ref_pnjaew());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(TextFieldSelectionManager).oll = function () {
    var tmp0 = this.ek2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSelectionManager$_get_editable_$ref_ttu104();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('editable', 1, tmp, tmp_0, TextFieldSelectionManager$_set_editable_$ref_pnjaew());
    return tmp0.u1();
  };
  protoOf(TextFieldSelectionManager).nk6 = function (_set____db54di) {
    var tmp0 = this.fk2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSelectionManager$_get_enabled_$ref_c3f8c7();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('enabled', 1, tmp, tmp_0, TextFieldSelectionManager$_set_enabled_$ref_snanb1());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(TextFieldSelectionManager).uk2 = function () {
    var tmp0 = this.fk2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSelectionManager$_get_enabled_$ref_c3f8c7();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('enabled', 1, tmp, tmp_0, TextFieldSelectionManager$_set_enabled_$ref_snanb1());
    return tmp0.u1();
  };
  protoOf(TextFieldSelectionManager).flk = function (_set____db54di) {
    var tmp0 = this.jk2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSelectionManager$_get_draggingHandle_$ref_j7ws87();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('draggingHandle', 1, tmp, tmp_0, TextFieldSelectionManager$_set_draggingHandle_$ref_epyiw5());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(TextFieldSelectionManager).pll = function () {
    var tmp0 = this.jk2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSelectionManager$_get_draggingHandle_$ref_j7ws87();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('draggingHandle', 1, tmp, tmp_0, TextFieldSelectionManager$_set_draggingHandle_$ref_epyiw5());
    return tmp0.u1();
  };
  protoOf(TextFieldSelectionManager).glk = function (_set____db54di) {
    var tmp0 = this.kk2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSelectionManager$_get_currentDragPosition_$ref_7t2ung();
    getPropertyCallableRef('currentDragPosition', 1, tmp, tmp_0, TextFieldSelectionManager$_set_currentDragPosition_$ref_co2jm0());
    var tmp_1 = _set____db54di;
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = tmp_1 == null ? null : new Offset(tmp_1);
    tmp0.s21(value);
    return Unit_instance;
  };
  protoOf(TextFieldSelectionManager).qll = function () {
    var tmp0 = this.kk2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TextFieldSelectionManager$_get_currentDragPosition_$ref_7t2ung();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('currentDragPosition', 1, tmp, tmp_0, TextFieldSelectionManager$_set_currentDragPosition_$ref_co2jm0());
    var tmp_1 = tmp0.u1();
    return tmp_1 == null ? null : tmp_1.e5d_1;
  };
  protoOf(TextFieldSelectionManager).vk2 = function () {
    var tmp;
    if (!this.uk2()) {
      tmp = Companion_instance_0;
    } else {
      var tmp_0 = Companion_instance_0;
      var tmp_1 = showTextContextMenuOnSecondaryClick(tmp_0, TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_0(this, null));
      var tmp_2 = this.qk2_1;
      var tmp_3 = TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_2(this, null);
      var tmp_4 = TextFieldSelectionManager$_get_contextMenuAreaModifier_$slambda_htumin_4(this, null);
      tmp = textContextMenuToolbarHandler(tmp_1, tmp_2, tmp_3, tmp_4, TextFieldSelectionManager$_get_contextMenuAreaModifier_$lambda_3z0dcy(this));
    }
    return tmp;
  };
  protoOf(TextFieldSelectionManager).blq = function (isStartHandle) {
    return new TextFieldSelectionManager$handleDragObserver$1(this, isStartHandle);
  };
  protoOf(TextFieldSelectionManager).qk8 = function () {
    return new TextFieldSelectionManager$cursorDragObserver$1(this);
  };
  protoOf(TextFieldSelectionManager).aln = function (showFloatingToolbar) {
    var tmp1_safe_receiver = this.uk1_1;
    if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r9h()) === false) {
      var tmp0_safe_receiver = this.dk2_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.u9g();
    }
    this.mk2_1 = this.mk8();
    updateFloatingToolbar(this, showFloatingToolbar);
    setHandleState(this, HandleState_Selection_getInstance());
  };
  protoOf(TextFieldSelectionManager).gl2 = function (showFloatingToolbar, $super) {
    showFloatingToolbar = showFloatingToolbar === VOID ? true : showFloatingToolbar;
    var tmp;
    if ($super === VOID) {
      this.aln(showFloatingToolbar);
      tmp = Unit_instance;
    } else {
      tmp = $super.aln.call(this, showFloatingToolbar);
    }
    return tmp;
  };
  protoOf(TextFieldSelectionManager).fl2 = function () {
    updateFloatingToolbar(this, false);
    setHandleState(this, HandleState_None_getInstance());
  };
  protoOf(TextFieldSelectionManager).vkl = function (position) {
    if (!_TextRange___get_collapsed__impl__cilesp(this.mk8().g8a_1)) {
      var tmp0_safe_receiver = this.uk1_1;
      var layoutResult = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7();
      var tmp;
      var tmp_0;
      var tmp_1 = position;
      if (!((tmp_1 == null ? null : new Offset(tmp_1)) == null)) {
        tmp_0 = !(layoutResult == null);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = this.sk1_1.p8c(layoutResult.ekj(position));
      } else {
        tmp = _TextRange___get_max__impl__owm8m(this.mk8().g8a_1);
      }
      var newCursorOffset = tmp;
      var newValue = this.mk8().j8a(VOID, TextRange_1(newCursorOffset));
      this.tk1_1(newValue);
      this.ok2_1 = newValue.g8a_1;
    }
    var tmp_2;
    var tmp_3;
    var tmp_4 = position;
    if (!((tmp_4 == null ? null : new Offset(tmp_4)) == null)) {
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = this.mk8().h89();
      tmp_3 = charSequenceLength(this_0) > 0;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = HandleState_Cursor_getInstance();
    } else {
      tmp_2 = HandleState_None_getInstance();
    }
    var selectionMode = tmp_2;
    setHandleState(this, selectionMode);
    updateFloatingToolbar(this, false);
  };
  protoOf(TextFieldSelectionManager).qk9 = function (position, $super) {
    position = position === VOID ? null : position;
    var tmp;
    if ($super === VOID) {
      this.vkl(position);
      tmp = Unit_instance;
    } else {
      var tmp_0 = $super.vkl;
      var tmp_1 = position;
      tmp = tmp_0.call(this, tmp_1 == null ? null : new Offset(tmp_1));
    }
    return tmp;
  };
  protoOf(TextFieldSelectionManager).nk4 = function () {
    var tmp;
    // Inline function 'androidx.compose.foundation.text.selection.TextFieldSelectionManager.isCopyAllowed' call
    if (access$_get_hasSelection__odl9on(this) && !access$_get_isPassword__3bf5vq(this)) {
      var tmp0_safe_receiver = this.yk1_1;
      tmp = (tmp0_safe_receiver == null ? null : isWriteSupported(tmp0_safe_receiver)) === true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(TextFieldSelectionManager).mk4 = function ($completion) {
    var tmp = new $updateClipboardEntryCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionManager).ok4 = function () {
    var tmp;
    var tmp_0;
    // Inline function 'androidx.compose.foundation.text.selection.TextFieldSelectionManager.isPasteAllowed' call
    if (this.oll()) {
      tmp_0 = _get_hasAvailableTextToPaste__xuewej(this);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp0_safe_receiver = this.yk1_1;
      tmp = (tmp0_safe_receiver == null ? null : isReadSupported(tmp0_safe_receiver)) === true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(TextFieldSelectionManager).pk4 = function () {
    var tmp;
    // Inline function 'androidx.compose.foundation.text.selection.TextFieldSelectionManager.isCutAllowed' call
    if (access$_get_hasSelection__odl9on(this) && this.oll() && !access$_get_isPassword__3bf5vq(this)) {
      var tmp0_safe_receiver = this.yk1_1;
      tmp = (tmp0_safe_receiver == null ? null : isWriteSupported(tmp0_safe_receiver)) === true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(TextFieldSelectionManager).qk4 = function () {
    return !(_TextRange___get_length__impl__7qes3a(this.mk8().g8a_1) === this.mk8().h89().length);
  };
  protoOf(TextFieldSelectionManager).rk4 = function () {
    return this.oll() && _TextRange___get_collapsed__impl__cilesp(this.mk8().g8a_1);
  };
  protoOf(TextFieldSelectionManager).qkk = function (cancelSelection) {
    var tmp0_safe_receiver = this.zk1_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
      tmp = launch(tmp0_safe_receiver, VOID, tmp_0, TextFieldSelectionManager$copy$slambda_0(this, cancelSelection, null));
    }
    return tmp;
  };
  protoOf(TextFieldSelectionManager).hl2 = function (cancelSelection, $super) {
    cancelSelection = cancelSelection === VOID ? true : cancelSelection;
    return $super === VOID ? this.qkk(cancelSelection) : $super.qkk.call(this, cancelSelection);
  };
  protoOf(TextFieldSelectionManager).klo = function (cancelSelection) {
    // Inline function 'androidx.compose.foundation.text.selection.TextFieldSelectionManager.isCopyAllowed' call
    if (!(access$_get_hasSelection__odl9on(this) && !access$_get_isPassword__3bf5vq(this)))
      return null;
    var selectedText = getSelectedText(this.mk8());
    if (!cancelSelection)
      return selectedText;
    var newCursorOffset = _TextRange___get_max__impl__owm8m(this.mk8().g8a_1);
    var newValue = createTextFieldValue(this, this.mk8().f8a_1, TextRange_0(newCursorOffset, newCursorOffset));
    this.tk1_1(newValue);
    setHandleState(this, HandleState_None_getInstance());
    return selectedText;
  };
  protoOf(TextFieldSelectionManager).wk8 = function (cancelSelection, $super) {
    cancelSelection = cancelSelection === VOID ? true : cancelSelection;
    return $super === VOID ? this.klo(cancelSelection) : $super.klo.call(this, cancelSelection);
  };
  protoOf(TextFieldSelectionManager).rkk = function () {
    var tmp0_safe_receiver = this.zk1_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
      tmp = launch(tmp0_safe_receiver, VOID, tmp_0, TextFieldSelectionManager$paste$slambda_0(this, null));
    }
    return tmp;
  };
  protoOf(TextFieldSelectionManager).vk8 = function (text) {
    // Inline function 'androidx.compose.foundation.text.selection.TextFieldSelectionManager.isPasteAllowed' call
    if (!this.oll())
      return Unit_instance;
    var newText = getTextBeforeSelection(this.mk8(), this.mk8().h89().length).v7q(text).v7q(getTextAfterSelection(this.mk8(), this.mk8().h89().length));
    var newCursorOffset = _TextRange___get_min__impl__uu95c4(this.mk8().g8a_1) + text.a() | 0;
    var newValue = createTextFieldValue(this, newText, TextRange_0(newCursorOffset, newCursorOffset));
    this.tk1_1(newValue);
    setHandleState(this, HandleState_None_getInstance());
    var tmp0_safe_receiver = this.rk1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.tkl();
    }
  };
  protoOf(TextFieldSelectionManager).skk = function () {
    var tmp0_safe_receiver = this.zk1_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
      tmp = launch(tmp0_safe_receiver, VOID, tmp_0, TextFieldSelectionManager$cut$slambda_0(this, null));
    }
    return tmp;
  };
  protoOf(TextFieldSelectionManager).xk8 = function () {
    // Inline function 'androidx.compose.foundation.text.selection.TextFieldSelectionManager.isCutAllowed' call
    if (!(access$_get_hasSelection__odl9on(this) && this.oll() && !access$_get_isPassword__3bf5vq(this)))
      return null;
    var selectedText = getSelectedText(this.mk8());
    var newText = getTextBeforeSelection(this.mk8(), this.mk8().h89().length).v7q(getTextAfterSelection(this.mk8(), this.mk8().h89().length));
    var newCursorOffset = _TextRange___get_min__impl__uu95c4(this.mk8().g8a_1);
    var newValue = createTextFieldValue(this, newText, TextRange_0(newCursorOffset, newCursorOffset));
    this.tk1_1(newValue);
    setHandleState(this, HandleState_None_getInstance());
    var tmp0_safe_receiver = this.rk1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.tkl();
    }
    return selectedText;
  };
  protoOf(TextFieldSelectionManager).lll = function () {
    var newValue = createTextFieldValue(this, this.mk8().f8a_1, TextRange_0(0, this.mk8().h89().length));
    this.tk1_1(newValue);
    this.ok2_1 = newValue.g8a_1;
    this.mk2_1 = this.mk2_1.j8a(VOID, newValue.g8a_1);
    this.aln(true);
  };
  protoOf(TextFieldSelectionManager).mll = function () {
    var tmp0_safe_receiver = this.xk1_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  };
  protoOf(TextFieldSelectionManager).nll = function (isStartHandle) {
    var tmp0_safe_receiver = this.uk1_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hk8_1;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      return Companion_getInstance_6().i5d_1;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var textLayoutResult = tmp;
    var tmp3_elvis_lhs = this.pk8();
    var tmp_0;
    if (tmp3_elvis_lhs == null) {
      return Companion_getInstance_6().i5d_1;
    } else {
      tmp_0 = tmp3_elvis_lhs;
    }
    var transformedText = tmp_0;
    var layoutInputText = textLayoutResult.e80_1.q80_1.h7q_1;
    if (!(transformedText.h7q_1 === layoutInputText))
      return Companion_getInstance_6().i5d_1;
    var offset = isStartHandle ? _TextRange___get_start__impl__ww4t90(this.mk8().g8a_1) : _TextRange___get_end__impl__gcdxpp(this.mk8().g8a_1);
    return getSelectionHandleCoordinates(textLayoutResult, this.sk1_1.o8c(offset), isStartHandle, _TextRange___get_reversed__impl__emhnbm(this.mk8().g8a_1));
  };
  protoOf(TextFieldSelectionManager).clq = function (isStartHandle) {
    var offset = isStartHandle ? _TextRange___get_start__impl__ww4t90(this.mk8().g8a_1) : _TextRange___get_end__impl__gcdxpp(this.mk8().g8a_1);
    var tmp0_safe_receiver = this.uk1_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hk8_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : getLineHeight(tmp2_safe_receiver, offset);
    var tmp;
    if (tmp3_elvis_lhs == null) {
      return 0.0;
    } else {
      tmp = tmp3_elvis_lhs;
    }
    return tmp;
  };
  protoOf(TextFieldSelectionManager).rk8 = function (density) {
    var offset = this.sk1_1.o8c(_TextRange___get_start__impl__ww4t90(this.mk8().g8a_1));
    var tmp0_safe_receiver = this.uk1_1;
    var layoutResult = ensureNotNull(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tk7()).hk8_1;
    var cursorRect = layoutResult.c7u(coerceIn_1(offset, 0, layoutResult.e80_1.q80_1.a()));
    // Inline function 'kotlin.with' call
    var x = cursorRect.k5d_1 + density.v5e(get_DefaultCursorThickness()) / 2;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = cursorRect.n5d_1;
    var v1 = fromInt(toRawBits(x));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$3);
  };
  protoOf(TextFieldSelectionManager).ok8 = function () {
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
      var previousSnapshot = Companion_instance_2.p52();
      var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
      var newSnapshot = Companion_instance_2.q52(previousSnapshot);
      try {
        var tmp;
        if (!this.uk2()) {
          tmp = true;
        } else {
          var tmp0_safe_receiver = this.uk1_1;
          tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pk6()) === false;
        }
        if (tmp)
          return Unit_instance;
        break $l$block;
      }finally {
        Companion_instance_2.c53(previousSnapshot, newSnapshot, observer);
      }
    }
    if (ComposeFoundationFlags_instance.hfg_1) {
      this.qk2_1.vbq();
    } else {
      showSelectionToolbarViaTextToolbar(this);
    }
  };
  protoOf(TextFieldSelectionManager).lk8 = function () {
    if (ComposeFoundationFlags_instance.hfg_1) {
      this.qk2_1.wbq();
    } else {
      var tmp1_safe_receiver = this.bk2_1;
      if (equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.zbq(), TextToolbarStatus_Shown_getInstance())) {
        var tmp0_safe_receiver = this.bk2_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.wbq();
        }
      }
    }
  };
  protoOf(TextFieldSelectionManager).nk8 = function () {
    return !(this.mk2_1.h89() === this.mk8().h89());
  };
  function TextFieldSelectionHandle(isStartHandle, direction, manager, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1344558920);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.l31(isStartHandle) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.m31(direction.a1_1) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(manager) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 14) === 4 | $composer_0.k31(manager));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = manager.blq(isStartHandle);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var observer = tmp;
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(manager) | ($dirty & 14) === 4);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_0;
      if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
        var tmp_1 = TextFieldSelectionHandle$lambda(manager, isStartHandle);
        var value_0 = new sam$androidx_compose_foundation_text_selection_OffsetProvider$0_0(tmp_1);
        tmp0_0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp_2 = tmp_0;
      var tmp_3 = _TextRange___get_reversed__impl__emhnbm(manager.mk8().g8a_1);
      var tmp_4 = _DpSize___init__impl__t4mur0(new Long(0, 0));
      var tmp_5 = manager.clq(isStartHandle);
      var tmp_6 = Companion_instance_0;
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_0.q31(observer);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_1.i31();
      var tmp_7;
      if (invalid_1 || it_1 === Companion_getInstance_11().f30_1) {
        var tmp_8 = TextFieldSelectionHandle$slambda_0(observer, null);
        var value_1 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_8(tmp_8);
        tmp0_1.j31(value_1);
        tmp_7 = value_1;
      } else {
        tmp_7 = it_1;
      }
      var tmp$ret$8 = tmp_7;
      SelectionHandle(tmp_2, isStartHandle, direction, tmp_3, tmp_4, tmp_5, pointerInput(tmp_6, observer, tmp$ret$8), $composer_0, 112 & $dirty << 3 | 896 & $dirty << 3, 16);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(TextFieldSelectionHandle$lambda_0(isStartHandle, direction, manager, $changed));
    }
  }
  function isSelectionHandleInVisibleBoundDefault(_this__u8e3s4, isStartHandle) {
    var tmp0_safe_receiver = _this__u8e3s4.uk1_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rk7();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : visibleBounds(tmp1_safe_receiver);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : containsInclusive(tmp2_safe_receiver, _this__u8e3s4.nll(isStartHandle));
    return tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
  }
  function contextMenuBuilder(_this__u8e3s4, contextMenuState, itemsAvailability) {
    return contextMenuBuilder$lambda(itemsAvailability, _this__u8e3s4, contextMenuState);
  }
  function sam$androidx_compose_foundation_text_selection_OffsetProvider$0_0(function_0) {
    this.dlq_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_text_selection_OffsetProvider$0_0).tk8 = function () {
    return this.dlq_1().e5d_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_OffsetProvider$0_0).q3 = function () {
    return this.dlq_1;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_OffsetProvider$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, OffsetProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_text_selection_OffsetProvider$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_8(function_0) {
    this.elq_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_8).ka7 = function (_this__u8e3s4, $completion) {
    return this.elq_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_8).q3 = function () {
    return this.elq_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_8).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_8).hashCode = function () {
    return hashCode(this.q3());
  };
  function TextFieldSelectionHandle$lambda($manager, $isStartHandle) {
    return function () {
      return new Offset($manager.nll($isStartHandle));
    };
  }
  function TextFieldSelectionHandle$slambda($observer, resultContinuation) {
    this.nlq_1 = $observer;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFieldSelectionHandle$slambda).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextFieldSelectionHandle$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFieldSelectionHandle$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectDownAndDragGesturesWithObserver(this.olq_1, this.nlq_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFieldSelectionHandle$slambda).wc6 = function ($this$pointerInput, completion) {
    var i = new TextFieldSelectionHandle$slambda(this.nlq_1, completion);
    i.olq_1 = $this$pointerInput;
    return i;
  };
  function TextFieldSelectionHandle$slambda_0($observer, resultContinuation) {
    var i = new TextFieldSelectionHandle$slambda($observer, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function TextFieldSelectionHandle$lambda_0($isStartHandle, $direction, $manager, $$changed) {
    return function ($composer, $force) {
      TextFieldSelectionHandle($isStartHandle, $direction, $manager, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function contextMenuBuilder$lambda$textFieldItem$lambda($label) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(-35972707);
      var tmp0 = $label.qk3($composer_0, 0);
      $composer_0.n30();
      return tmp0;
    };
  }
  function contextMenuBuilder$lambda$textFieldItem$lambda_0($operation, $state) {
    return function () {
      $operation();
      close($state);
      return Unit_instance;
    };
  }
  function invoke$textFieldItem($this, $contextMenuState, label, enabled, operation) {
    // Inline function 'androidx.compose.foundation.text.TextItem' call
    if (enabled) {
      var tmp = contextMenuBuilder$lambda$textFieldItem$lambda(label);
      $this.jgd(tmp, VOID, VOID, VOID, contextMenuBuilder$lambda$textFieldItem$lambda_0(operation, $contextMenuState));
    }
  }
  function contextMenuBuilder$lambda$lambda($this_contextMenuBuilder) {
    return function () {
      $this_contextMenuBuilder.skk();
      return Unit_instance;
    };
  }
  function contextMenuBuilder$lambda$lambda_0($this_contextMenuBuilder) {
    return function () {
      $this_contextMenuBuilder.qkk(false);
      return Unit_instance;
    };
  }
  function contextMenuBuilder$lambda$lambda_1($this_contextMenuBuilder) {
    return function () {
      $this_contextMenuBuilder.rkk();
      return Unit_instance;
    };
  }
  function contextMenuBuilder$lambda$lambda_2($this_contextMenuBuilder) {
    return function () {
      $this_contextMenuBuilder.lll();
      return Unit_instance;
    };
  }
  function contextMenuBuilder$lambda$lambda_3($this_contextMenuBuilder) {
    return function () {
      $this_contextMenuBuilder.mll();
      return Unit_instance;
    };
  }
  function contextMenuBuilder$lambda($itemsAvailability, $this_contextMenuBuilder, $contextMenuState) {
    return function (_this__u8e3s4) {
      var availability = $itemsAvailability.u1().rk3_1;
      var tmp = TextContextMenuItems_Cut_getInstance();
      var tmp_0 = _MenuItemsAvailability___get_canCut__impl__fszy0a(availability);
      invoke$textFieldItem(_this__u8e3s4, $contextMenuState, tmp, tmp_0, contextMenuBuilder$lambda$lambda($this_contextMenuBuilder));
      var tmp_1 = TextContextMenuItems_Copy_getInstance();
      var tmp_2 = _MenuItemsAvailability___get_canCopy__impl__6h1bgj(availability);
      invoke$textFieldItem(_this__u8e3s4, $contextMenuState, tmp_1, tmp_2, contextMenuBuilder$lambda$lambda_0($this_contextMenuBuilder));
      var tmp_3 = TextContextMenuItems_Paste_getInstance();
      var tmp_4 = _MenuItemsAvailability___get_canPaste__impl__n8yo1l(availability);
      invoke$textFieldItem(_this__u8e3s4, $contextMenuState, tmp_3, tmp_4, contextMenuBuilder$lambda$lambda_1($this_contextMenuBuilder));
      var tmp_5 = TextContextMenuItems_SelectAll_getInstance();
      var tmp_6 = _MenuItemsAvailability___get_canSelectAll__impl__u4suex(availability);
      invoke$textFieldItem(_this__u8e3s4, $contextMenuState, tmp_5, tmp_6, contextMenuBuilder$lambda$lambda_2($this_contextMenuBuilder));
      var tmp_7;
      if (isAutofillAvailable()) {
        var tmp_8 = TextContextMenuItems_Autofill_getInstance();
        var tmp_9 = _MenuItemsAvailability___get_canAutofill__impl__anvhpc(availability);
        invoke$textFieldItem(_this__u8e3s4, $contextMenuState, tmp_8, tmp_9, contextMenuBuilder$lambda$lambda_3($this_contextMenuBuilder));
        tmp_7 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  var androidx_compose_foundation_text_selection_TextPreparedSelectionState$stable;
  var androidx_compose_foundation_text_selection_BaseTextPreparedSelection$stable;
  var androidx_compose_foundation_text_selection_TextPreparedSelection$stable;
  var androidx_compose_foundation_text_selection_TextFieldPreparedSelection$stable;
  function TextPreparedSelectionState() {
    this.rkl_1 = null;
  }
  protoOf(TextPreparedSelectionState).skl = function () {
    this.rkl_1 = null;
  };
  function jumpByPagesOffset($this, $receiver, pagesAmount) {
    var tmp0_safe_receiver = $receiver.ik8_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = $receiver.jk8_1;
      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.fai(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    var visibleInnerTextFieldRect = tmp1_elvis_lhs == null ? Companion_getInstance_50().j5d_1 : tmp1_elvis_lhs;
    var currentOffset = $this.ekk_1.o8c(_TextRange___get_end__impl__gcdxpp($this.zkj_1.g8a_1));
    var currentPos = $receiver.hk8_1.c7u(currentOffset);
    var x = currentPos.k5d_1;
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    var this_0 = visibleInnerTextFieldRect.o5d();
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value = _Size___get_packedValue__impl__7rlt1o(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    var tmp$ret$2 = floatFromBits(bits);
    var y = currentPos.l5d_1 + tmp$ret$2 * pagesAmount;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(x));
    var v2 = fromInt(toRawBits(y));
    var tmp$ret$7 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$6 = _Offset___init__impl__c168vi(tmp$ret$7);
    return $this.ekk_1.p8c($receiver.hk8_1.s7t(tmp$ret$6));
  }
  function TextFieldPreparedSelection(currentValue, offsetMapping, layoutResultProxy, state) {
    offsetMapping = offsetMapping === VOID ? Companion_getInstance_48().q8c_1 : offsetMapping;
    state = state === VOID ? new TextPreparedSelectionState() : state;
    var tmp1_originalText = currentValue.f8a_1;
    var tmp2_originalSelection = currentValue.g8a_1;
    var tmp3_layoutResult = layoutResultProxy == null ? null : layoutResultProxy.hk8_1;
    BaseTextPreparedSelection.call(this, tmp1_originalText, tmp2_originalSelection, tmp3_layoutResult, offsetMapping, state);
    this.zkj_1 = currentValue;
    this.akk_1 = layoutResultProxy;
  }
  protoOf(TextFieldPreparedSelection).u1 = function () {
    return this.zkj_1.j8a(this.hkk_1, this.gkk_1);
  };
  protoOf(TextFieldPreparedSelection).jkl = function (or) {
    var tmp;
    if (_TextRange___get_collapsed__impl__cilesp(this.gkk_1)) {
      var tmp0_safe_receiver = or(this);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = listOf_0(tmp0_safe_receiver);
      }
      tmp = tmp_0;
    } else {
      tmp = listOf([CommitTextCommand_init_$Create$('', 0), new SetSelectionCommand(_TextRange___get_min__impl__uu95c4(this.gkk_1), _TextRange___get_min__impl__uu95c4(this.gkk_1))]);
    }
    return tmp;
  };
  protoOf(TextFieldPreparedSelection).bkl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (false) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      var tmp0_safe_receiver = this.akk_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : jumpByPagesOffset(this, tmp0_safe_receiver, -1);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.qlq(tmp1_safe_receiver);
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(TextFieldPreparedSelection).ckl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (false) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      var tmp0_safe_receiver = this.akk_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : jumpByPagesOffset(this, tmp0_safe_receiver, 1);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.qlq(tmp1_safe_receiver);
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  function moveCursorPrev($this) {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      $this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = $this.plq();
    if (charSequenceLength(this_0) > 0) {
      var prev = $this.slq();
      if (!(prev === -1)) {
        $this.qlq(prev);
      }
    }
    return $this instanceof BaseTextPreparedSelection ? $this : THROW_CCE();
  }
  function moveCursorNext($this) {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      $this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = $this.plq();
    if (charSequenceLength(this_0) > 0) {
      var next = $this.lkk();
      if (!(next === -1)) {
        $this.qlq(next);
      }
    }
    return $this instanceof BaseTextPreparedSelection ? $this : THROW_CCE();
  }
  function moveCursorNextByWord($this) {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      $this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = $this.plq();
    if (charSequenceLength(this_0) > 0) {
      var tmp0_safe_receiver = $this.nkk();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $this.qlq(tmp0_safe_receiver);
      }
    }
    return $this instanceof BaseTextPreparedSelection ? $this : THROW_CCE();
  }
  function moveCursorPrevByWord($this) {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      $this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = $this.plq();
    if (charSequenceLength(this_0) > 0) {
      var tmp0_safe_receiver = $this.mkk();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $this.qlq(tmp0_safe_receiver);
      }
    }
    return $this instanceof BaseTextPreparedSelection ? $this : THROW_CCE();
  }
  function isLtr($this) {
    var tmp0_safe_receiver = $this.dkk_1;
    var direction = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x7t(transformedEndOffset($this));
    return !equals(direction, ResolvedTextDirection_Rtl_getInstance());
  }
  function getNextWordOffsetForLayout($this, $receiver, currentOffset) {
    currentOffset = currentOffset === VOID ? transformedEndOffset($this) : currentOffset;
    var $this_0 = $this;
    var $this_1 = $receiver;
    var currentOffset_0 = currentOffset;
    $l$1: do {
      $l$0: do {
        if (currentOffset_0 >= $this_0.bkk_1.a()) {
          return $this_0.bkk_1.a();
        }
        var currentWord = $this_1.z7t(charOffset($this_0, currentOffset_0));
        var tmp;
        if (_TextRange___get_end__impl__gcdxpp(currentWord) <= currentOffset_0) {
          var tmp0 = $this_0;
          var tmp1 = $this_1;
          var tmp2 = currentOffset_0 + 1 | 0;
          $this_0 = tmp0;
          $this_1 = tmp1;
          currentOffset_0 = tmp2;
          continue $l$0;
        } else {
          tmp = $this_0.ekk_1.p8c(_TextRange___get_end__impl__gcdxpp(currentWord));
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function getPrevWordOffset($this, $receiver, currentOffset) {
    currentOffset = currentOffset === VOID ? transformedEndOffset($this) : currentOffset;
    var $this_0 = $this;
    var $this_1 = $receiver;
    var currentOffset_0 = currentOffset;
    $l$1: do {
      $l$0: do {
        if (currentOffset_0 <= 0) {
          return 0;
        }
        var currentWord = $this_1.z7t(charOffset($this_0, currentOffset_0));
        var tmp;
        if (_TextRange___get_start__impl__ww4t90(currentWord) >= currentOffset_0) {
          var tmp0 = $this_0;
          var tmp1 = $this_1;
          var tmp2 = currentOffset_0 - 1 | 0;
          $this_0 = tmp0;
          $this_1 = tmp1;
          currentOffset_0 = tmp2;
          continue $l$0;
        } else {
          tmp = $this_0.ekk_1.p8c(_TextRange___get_start__impl__ww4t90(currentWord));
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function getLineStartByOffsetForLayout($this, $receiver, currentOffset) {
    currentOffset = currentOffset === VOID ? transformedMinOffset($this) : currentOffset;
    var currentLine = $receiver.d7u(currentOffset);
    return $this.ekk_1.p8c($receiver.k7u(currentLine));
  }
  function getLineEndByOffsetForLayout($this, $receiver, currentOffset) {
    currentOffset = currentOffset === VOID ? transformedMaxOffset($this) : currentOffset;
    var currentLine = $receiver.d7u(currentOffset);
    return $this.ekk_1.p8c($receiver.l7u(currentLine, true));
  }
  function jumpByLinesOffset($this, $receiver, linesAmount) {
    var currentOffset = transformedEndOffset($this);
    if ($this.fkk_1.rkl_1 == null) {
      $this.fkk_1.rkl_1 = $receiver.c7u(currentOffset).k5d_1;
    }
    var targetLine = $receiver.d7u(currentOffset) + linesAmount | 0;
    if (targetLine < 0) {
      return 0;
    } else if (targetLine >= $receiver.e7t()) {
      return $this.plq().length;
    }
    var y = $receiver.i7u(targetLine) - 1;
    // Inline function 'kotlin.also' call
    var this_0 = ensureNotNull($this.fkk_1.rkl_1);
    if (isLtr($this) && this_0 >= $receiver.g7u(targetLine) || (!isLtr($this) && this_0 <= $receiver.e7u(targetLine))) {
      return $receiver.l7u(targetLine, true);
    }
    var x = this_0;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(x));
    var v2 = fromInt(toRawBits(y));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$2 = _Offset___init__impl__c168vi(tmp$ret$3);
    // Inline function 'kotlin.let' call
    var it = $receiver.s7t(tmp$ret$2);
    var newOffset = $this.ekk_1.p8c(it);
    return newOffset;
  }
  function transformedEndOffset($this) {
    return $this.ekk_1.o8c(_TextRange___get_end__impl__gcdxpp($this.gkk_1));
  }
  function transformedMinOffset($this) {
    return $this.ekk_1.o8c(_TextRange___get_min__impl__uu95c4($this.gkk_1));
  }
  function transformedMaxOffset($this) {
    return $this.ekk_1.o8c(_TextRange___get_max__impl__owm8m($this.gkk_1));
  }
  function charOffset($this, offset) {
    return coerceAtMost(offset, $this.plq().length - 1 | 0);
  }
  function Companion_30() {
    this.tlq_1 = -1;
  }
  var Companion_instance_40;
  function Companion_getInstance_89() {
    return Companion_instance_40;
  }
  function BaseTextPreparedSelection(originalText, originalSelection, layoutResult, offsetMapping, state) {
    this.bkk_1 = originalText;
    this.ckk_1 = originalSelection;
    this.dkk_1 = layoutResult;
    this.ekk_1 = offsetMapping;
    this.fkk_1 = state;
    this.gkk_1 = this.ckk_1;
    this.hkk_1 = this.bkk_1;
  }
  protoOf(BaseTextPreparedSelection).plq = function () {
    return this.hkk_1.h7q_1;
  };
  protoOf(BaseTextPreparedSelection).qlq = function (offset) {
    this.rlq(offset, offset);
  };
  protoOf(BaseTextPreparedSelection).rlq = function (start, end) {
    this.gkk_1 = TextRange_0(start, end);
  };
  protoOf(BaseTextPreparedSelection).kkl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      this.rlq(0, this.plq().length);
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).mkl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      this.qlq(_TextRange___get_end__impl__gcdxpp(this.gkk_1));
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).ikk = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      if (isLtr(this)) {
        moveCursorPrev(this);
      } else {
        moveCursorNext(this);
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).jkk = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      if (isLtr(this)) {
        moveCursorNext(this);
      } else {
        moveCursorPrev(this);
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).tkk = function (or) {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      if (_TextRange___get_collapsed__impl__cilesp(this.gkk_1)) {
        or(this instanceof BaseTextPreparedSelection ? this : THROW_CCE());
      } else {
        if (isLtr(this)) {
          this.qlq(_TextRange___get_min__impl__uu95c4(this.gkk_1));
        } else {
          this.qlq(_TextRange___get_max__impl__owm8m(this.gkk_1));
        }
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).ukk = function (or) {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      if (_TextRange___get_collapsed__impl__cilesp(this.gkk_1)) {
        or(this instanceof BaseTextPreparedSelection ? this : THROW_CCE());
      } else {
        if (isLtr(this)) {
          this.qlq(_TextRange___get_max__impl__owm8m(this.gkk_1));
        } else {
          this.qlq(_TextRange___get_min__impl__uu95c4(this.gkk_1));
        }
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).kkk = function () {
    return findCodePointOrEmojiStartBefore(this.hkk_1.h7q_1, _TextRange___get_end__impl__gcdxpp(this.gkk_1), -1);
  };
  protoOf(BaseTextPreparedSelection).slq = function () {
    return findPrecedingBreak(this.hkk_1.h7q_1, _TextRange___get_end__impl__gcdxpp(this.gkk_1));
  };
  protoOf(BaseTextPreparedSelection).lkk = function () {
    return findFollowingBreak(this.hkk_1.h7q_1, _TextRange___get_end__impl__gcdxpp(this.gkk_1));
  };
  protoOf(BaseTextPreparedSelection).hkl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      this.qlq(0);
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).ikl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      this.qlq(this.plq().length);
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).vkk = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      if (isLtr(this)) {
        moveCursorPrevByWord(this);
      } else {
        moveCursorNextByWord(this);
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).wkk = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      if (isLtr(this)) {
        moveCursorNextByWord(this);
      } else {
        moveCursorPrevByWord(this);
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).nkk = function () {
    var tmp0_safe_receiver = this.dkk_1;
    return tmp0_safe_receiver == null ? null : getNextWordOffsetForLayout(this, tmp0_safe_receiver);
  };
  protoOf(BaseTextPreparedSelection).mkk = function () {
    var tmp0_safe_receiver = this.dkk_1;
    return tmp0_safe_receiver == null ? null : getPrevWordOffset(this, tmp0_safe_receiver);
  };
  protoOf(BaseTextPreparedSelection).xkk = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      var paragraphStart = findParagraphStart(this.plq(), _TextRange___get_min__impl__uu95c4(this.gkk_1));
      if (paragraphStart === _TextRange___get_min__impl__uu95c4(this.gkk_1) && !(paragraphStart === 0)) {
        paragraphStart = findParagraphStart(this.plq(), paragraphStart - 1 | 0);
      }
      this.qlq(paragraphStart);
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).ykk = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      var paragraphEnd = findParagraphEnd(this.plq(), _TextRange___get_max__impl__owm8m(this.gkk_1));
      if (paragraphEnd === _TextRange___get_max__impl__owm8m(this.gkk_1) && !(paragraphEnd === this.plq().length)) {
        paragraphEnd = findParagraphEnd(this.plq(), paragraphEnd + 1 | 0);
      }
      this.qlq(paragraphEnd);
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).zkk = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (false) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      var tmp0_safe_receiver = this.dkk_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : jumpByLinesOffset(this, tmp0_safe_receiver, -1);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.qlq(tmp1_safe_receiver);
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).akl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (false) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      var tmp0_safe_receiver = this.dkk_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : jumpByLinesOffset(this, tmp0_safe_receiver, 1);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.qlq(tmp1_safe_receiver);
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).okk = function () {
    var tmp0_safe_receiver = this.dkk_1;
    return tmp0_safe_receiver == null ? null : getLineStartByOffsetForLayout(this, tmp0_safe_receiver);
  };
  protoOf(BaseTextPreparedSelection).dkl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      var tmp0_safe_receiver = this.okk();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.qlq(tmp0_safe_receiver);
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).pkk = function () {
    var tmp0_safe_receiver = this.dkk_1;
    return tmp0_safe_receiver == null ? null : getLineEndByOffsetForLayout(this, tmp0_safe_receiver);
  };
  protoOf(BaseTextPreparedSelection).ekl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      var tmp0_safe_receiver = this.pkk();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.qlq(tmp0_safe_receiver);
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).fkl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      if (isLtr(this)) {
        this.dkl();
      } else {
        this.ekl();
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).gkl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (true) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      if (isLtr(this)) {
        this.ekl();
      } else {
        this.dkl();
      }
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  protoOf(BaseTextPreparedSelection).lkl = function () {
    // Inline function 'androidx.compose.foundation.text.selection.BaseTextPreparedSelection.apply' call
    if (false) {
      this.fkk_1.skl();
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.plq();
    if (charSequenceLength(this_0) > 0) {
      this.gkk_1 = TextRange_0(_TextRange___get_start__impl__ww4t90(this.ckk_1), _TextRange___get_end__impl__gcdxpp(this.gkk_1));
    }
    return this instanceof BaseTextPreparedSelection ? this : THROW_CCE();
  };
  function get_LocalTextSelectionColors() {
    _init_properties_TextSelectionColors_kt__lgomir();
    return LocalTextSelectionColors;
  }
  var LocalTextSelectionColors;
  var androidx_compose_foundation_text_selection_TextSelectionColors$stable;
  function TextSelectionColors(handleColor, backgroundColor) {
    this.pjz_1 = handleColor;
    this.qjz_1 = backgroundColor;
  }
  protoOf(TextSelectionColors).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextSelectionColors))
      return false;
    if (!equals(this.pjz_1, other.pjz_1))
      return false;
    if (!equals(this.qjz_1, other.qjz_1))
      return false;
    return true;
  };
  protoOf(TextSelectionColors).hashCode = function () {
    var result = Color__hashCode_impl_vjyivj(this.pjz_1);
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.qjz_1) | 0;
    return result;
  };
  protoOf(TextSelectionColors).toString = function () {
    return 'SelectionColors(selectionHandleColor=' + Color__toString_impl_hpzmaq(this.pjz_1) + ', ' + ('selectionBackgroundColor=' + Color__toString_impl_hpzmaq(this.qjz_1) + ')');
  };
  function LocalTextSelectionColors$lambda() {
    _init_properties_TextSelectionColors_kt__lgomir();
    return get_DefaultTextSelectionColors();
  }
  var properties_initialized_TextSelectionColors_kt_x2xmyn;
  function _init_properties_TextSelectionColors_kt__lgomir() {
    if (!properties_initialized_TextSelectionColors_kt_x2xmyn) {
      properties_initialized_TextSelectionColors_kt_x2xmyn = true;
      LocalTextSelectionColors = compositionLocalOf(VOID, LocalTextSelectionColors$lambda);
      androidx_compose_foundation_text_selection_TextSelectionColors$stable = 0;
    }
  }
  function getSelectionHandleCoordinates(textLayoutResult, offset, isStart, areHandlesCrossed) {
    var line = textLayoutResult.d7u(offset);
    if (line >= textLayoutResult.e7t())
      return Companion_getInstance_6().i5d_1;
    var tmp = getHorizontalPosition(textLayoutResult, offset, isStart, areHandlesCrossed);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = textLayoutResult.g80_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    var tmp$ret$0 = convertToInt(shiftRight(value, 32));
    var x = coerceIn_0(tmp, 0.0, tmp$ret$0);
    var tmp_0 = textLayoutResult.i7u(line);
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_1 = textLayoutResult.g80_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
    var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var y = coerceIn_0(tmp_0, 0.0, tmp$ret$2);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(x));
    var v2 = fromInt(toRawBits(y));
    var tmp$ret$5 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$5);
  }
  function getHorizontalPosition(_this__u8e3s4, offset, isStart, areHandlesCrossed) {
    var tmp;
    if (isStart && !areHandlesCrossed || (!isStart && areHandlesCrossed)) {
      tmp = offset;
    } else {
      // Inline function 'kotlin.math.max' call
      var a = offset - 1 | 0;
      tmp = Math.max(a, 0);
    }
    var offsetToCheck = tmp;
    var bidiRunDirection = _this__u8e3s4.y7t(offsetToCheck);
    var paragraphDirection = _this__u8e3s4.x7t(offset);
    return _this__u8e3s4.w7t(offset, bidiRunDirection.equals(paragraphDirection));
  }
  function isWriteSupported(_this__u8e3s4) {
    return Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText));
  }
  function toClipEntry(_this__u8e3s4) {
    if (_this__u8e3s4 == null)
      return null;
    return Companion_instance_7.qc0(_this__u8e3s4.h7q_1);
  }
  function isReadSupported(_this__u8e3s4) {
    return Boolean(window.navigator.clipboard && window.navigator.clipboard.read);
  }
  function readText(_this__u8e3s4, $completion) {
    var tmp = new $readTextCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function readAnnotatedString(_this__u8e3s4, $completion) {
    var tmp = new $readAnnotatedStringCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function hasText(_this__u8e3s4) {
    if (_this__u8e3s4 == null)
      return false;
    if (!(_this__u8e3s4.sc0_1 == null))
      return true;
    // Inline function 'kotlin.collections.isEmpty' call
    if (_this__u8e3s4.rc0_1.length === 0)
      return false;
    return doesJsArrayContainValue(_this__u8e3s4.rc0_1[0].types, 'text/plain');
  }
  function getTextFromBlob(blob) {
    return blob.text();
  }
  function doesJsArrayContainValue(jsArray, value) {
    return jsArray.includes(value);
  }
  function $readTextCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.clr_1 = _this__u8e3s4;
  }
  protoOf($readTextCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (!hasText(this.clr_1))
              return null;
            if (!(this.clr_1.sc0_1 == null))
              return this.clr_1.sc0_1;
            if (this.clr_1.rc0_1.length === 0)
              return null;
            this.n9_1 = 1;
            suspendResult = await_0(this.clr_1.rc0_1[0].getType('text/plain'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var blob = suspendResult;
            this.n9_1 = 2;
            suspendResult = await_0(getTextFromBlob(blob), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return toString(ARGUMENT);
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $readAnnotatedStringCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.llr_1 = _this__u8e3s4;
  }
  protoOf($readAnnotatedStringCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = readText(this.llr_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var text = tmp_0;
            return AnnotatedString_init_$Create$(text);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var androidx_compose_foundation_text_input_internal_selection_ClipboardPasteState$stable;
  var androidx_compose_foundation_AtomicReference$stable;
  var androidx_compose_foundation_AtomicLong$stable;
  function AtomicReference(value) {
    this.ig4_1 = atomic$ref$1(value);
  }
  protoOf(AtomicReference).f1i = function () {
    return this.ig4_1.kotlinx$atomicfu$value;
  };
  protoOf(AtomicReference).x21 = function (value) {
    return this.ig4_1.atomicfu$getAndSet(value);
  };
  protoOf(AtomicReference).w21 = function (expect, newValue) {
    return this.ig4_1.atomicfu$compareAndSet(expect, newValue);
  };
  var androidx_compose_foundation_internal_PlatformOptimizedCancellationException$stable;
  function PlatformOptimizedCancellationException(message) {
    message = message === VOID ? null : message;
    CancellationException_init_$Init$_0(message, this);
    captureStack(this, PlatformOptimizedCancellationException);
  }
  function appendCodePointX(_this__u8e3s4, codePoint) {
    appendCodePoint(_this__u8e3s4, codePoint);
    return _this__u8e3s4;
  }
  function get_DefaultContextMenuColors_0() {
    _init_properties_BasicContextMenuRepresentation_skiko_kt__lxw3ik();
    return DefaultContextMenuColors_0;
  }
  var DefaultContextMenuColors_0;
  var androidx_compose_foundation_ContextMenuColors$stable;
  function ContextMenuColors_0(backgroundColor, textColor, iconColor, disabledTextColor, disabledIconColor, hoverColor) {
    this.mlr_1 = backgroundColor;
    this.nlr_1 = textColor;
    this.olr_1 = iconColor;
    this.plr_1 = disabledTextColor;
    this.qlr_1 = disabledIconColor;
    this.rlr_1 = hoverColor;
  }
  protoOf(ContextMenuColors_0).slr = function (enabled) {
    return enabled ? this.nlr_1 : this.plr_1;
  };
  protoOf(ContextMenuColors_0).tlr = function (enabled) {
    return enabled ? this.olr_1 : this.qlr_1;
  };
  protoOf(ContextMenuColors_0).equals = function (other) {
    if (this === other)
      return true;
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(other instanceof ContextMenuColors_0);
    }
    if (tmp)
      return false;
    if (!equals(this.mlr_1, other.mlr_1))
      return false;
    if (!equals(this.nlr_1, other.nlr_1))
      return false;
    if (!equals(this.olr_1, other.olr_1))
      return false;
    if (!equals(this.plr_1, other.plr_1))
      return false;
    if (!equals(this.qlr_1, other.qlr_1))
      return false;
    if (!equals(this.rlr_1, other.rlr_1))
      return false;
    return true;
  };
  protoOf(ContextMenuColors_0).hashCode = function () {
    var result = Color__hashCode_impl_vjyivj(this.mlr_1);
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.nlr_1) | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.olr_1) | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.plr_1) | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.qlr_1) | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.rlr_1) | 0;
    return result;
  };
  protoOf(ContextMenuColors_0).toString = function () {
    return 'ContextMenuColors(' + ('backgroundColor=' + Color__toString_impl_hpzmaq(this.mlr_1) + ', ') + ('textColor=' + Color__toString_impl_hpzmaq(this.nlr_1) + ', ') + ('iconColor=' + Color__toString_impl_hpzmaq(this.olr_1) + ', ') + ('disabledTextColor=' + Color__toString_impl_hpzmaq(this.plr_1) + ', ') + ('disabledIconColor=' + Color__toString_impl_hpzmaq(this.qlr_1) + ', ') + ('hoverColor=' + Color__toString_impl_hpzmaq(this.rlr_1)) + ')';
  };
  function DefaultOpenContextMenu(session, components, popupPositionProvider, colors, $composer, $changed, $default) {
    _init_properties_BasicContextMenuRepresentation_skiko_kt__lxw3ik();
    var colors_0 = {_v: colors};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(780890490);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(session) : $composer_0.q31(session)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(components) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(popupPositionProvider) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(colors_0._v) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        colors_0._v = get_DefaultContextMenuColors_0();
      }
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = mutableStateOf(null);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var focusManager$delegate = tmp;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = mutableStateOf(null);
        this_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var inputModeManager$delegate = tmp_0;
      var tmp0_properties = PopupProperties_init_$Create$(true);
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(session));
      // Inline function 'kotlin.let' call
      var it_1 = tmp0.i31();
      var tmp_1;
      if (invalid || it_1 === Companion_getInstance_11().f30_1) {
        var value_1 = TextContextMenuSession$close$ref(session);
        tmp0.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp1_onDismissRequest = tmp_1;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_2 = this_2.i31();
      var tmp_2;
      if (false || it_2 === Companion_getInstance_11().f30_1) {
        var value_2 = DefaultOpenContextMenu$lambda_3(inputModeManager$delegate, focusManager$delegate);
        this_2.j31(value_2);
        tmp_2 = value_2;
      } else {
        tmp_2 = it_2;
      }
      var tmp_3 = tmp_2;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1690922082, true, DefaultOpenContextMenu$lambda_4(colors_0, components, session, focusManager$delegate, inputModeManager$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_3 = $composer_1.i31();
      var tmp_4;
      if (invalid_0 || it_3 === Companion_getInstance_11().f30_1) {
        var value_3 = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value_3);
        tmp_4 = value_3;
      } else {
        tmp_4 = it_3;
      }
      var tmp$ret$16 = tmp_4;
      Popup_0(popupPositionProvider, tmp1_onDismissRequest, tmp0_properties, null, tmp_3, tmp$ret$16, $composer_0, 221568 | 14 & $dirty >> 6, 8);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(DefaultOpenContextMenu$lambda_5(session, components, popupPositionProvider, colors_0, $changed, $default));
    }
  }
  function MenuSeparator(color, $composer, $changed) {
    _init_properties_BasicContextMenuRepresentation_skiko_kt__lxw3ik();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-517455069);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(color))) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      var tmp = Companion_instance_0;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      var tmp_0 = fillMaxWidth(padding(tmp, VOID, tmp$ret$0));
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(1);
      Box(background(height(tmp_0, tmp$ret$1), color), $composer_0, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(MenuSeparator$lambda(color, $changed));
    }
  }
  function MenuItem(session, colors, component, $composer, $changed) {
    _init_properties_BasicContextMenuRepresentation_skiko_kt__lxw3ik();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1684794331);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(session) : $composer_0.q31(session)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(component) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.q31(component) | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(session))));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = MenuItem$lambda(component, session);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp_0 = tmp;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-163377228, true, MenuItem$lambda_0(component, colors), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_1.i31();
      var tmp_1;
      if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = ComposableLambda$invoke$ref_7(dispatchReceiver);
        $composer_1.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp$ret$4 = tmp_1;
      MenuItemContent(colors, tmp_0, component.wlr_1, tmp$ret$4, $composer_0, 3072 | 14 & $dirty >> 3);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(MenuItem$lambda_1(session, colors, component, $changed));
    }
  }
  function MenuItemContent(colors, onClick, enabled, content, $composer, $changed) {
    _init_properties_BasicContextMenuRepresentation_skiko_kt__lxw3ik();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1350689319);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = funMutableInteractionSource();
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var interactionSource = tmp;
      var tmp_0 = clickable(Companion_instance_0, enabled, VOID, VOID, interactionSource, onClick);
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_1;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = MenuItemContent$lambda;
        this_1.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp$ret$4 = tmp_1;
      var tmp_2 = semantics(tmp_0, true, tmp$ret$4);
      var tmp_3;
      if (enabled) {
        $composer_0.m30(-1162575108);
        var hovered = collectIsHoveredAsState(interactionSource, $composer_0, 6).u1();
        var tmp0_group = background(Companion_instance_0, hovered ? colors.rlr_1 : Companion_getInstance().t6b_1);
        $composer_0.n30();
        tmp_3 = tmp0_group;
      } else {
        $composer_0.m30(-1162353365);
        $composer_0.n30();
        tmp_3 = Companion_instance_0;
      }
      var tmp0_$receiver = fillMaxWidth(tmp_2.d8v(tmp_3));
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp1_minWidth = _Dp___init__impl__ms3zkb(112);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp2_maxWidth = _Dp___init__impl__ms3zkb(280);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp3_minHeight = _Dp___init__impl__ms3zkb(32);
      var tmp_4 = sizeIn(tmp0_$receiver, tmp1_minWidth, tmp3_minHeight, tmp2_maxWidth);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_5 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$12 = _Dp___init__impl__ms3zkb(0);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var $changed_0 = 384 | 7168 & $dirty;
      var modifier = padding_0(tmp_4, PaddingValues_0(tmp_5, tmp$ret$12));
      var horizontalArrangement = null;
      var verticalAlignment = Companion_getInstance_12().u8t_1;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier = Companion_instance_0;
      if (!((2 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((2 & 4) === 0))
        verticalAlignment = Companion_getInstance_12().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & $changed_0 >> 3 | 112 & $changed_0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_14().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_6 = $composer_3.g30();
      if (!isInterface(tmp_6, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      var $composer_4 = $composer_3;
      content(RowScopeInstance_instance, $composer_4, 6 | 112 & $changed_0 >> 6);
      $composer_3.e31();
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(MenuItemContent$lambda_0(colors, onClick, enabled, content, $changed));
    }
  }
  function DefaultOpenContextMenu$lambda($focusManager$delegate) {
    _init_properties_BasicContextMenuRepresentation_skiko_kt__lxw3ik();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('focusManager', KMutableProperty0, true);
    return $focusManager$delegate.u1();
  }
  function DefaultOpenContextMenu$lambda_0($focusManager$delegate, _set____db54di) {
    _init_properties_BasicContextMenuRepresentation_skiko_kt__lxw3ik();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('focusManager', KMutableProperty0, true);
    $focusManager$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function DefaultOpenContextMenu$lambda_1($inputModeManager$delegate) {
    _init_properties_BasicContextMenuRepresentation_skiko_kt__lxw3ik();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('inputModeManager', KMutableProperty0, true);
    return $inputModeManager$delegate.u1();
  }
  function DefaultOpenContextMenu$lambda_2($inputModeManager$delegate, _set____db54di) {
    _init_properties_BasicContextMenuRepresentation_skiko_kt__lxw3ik();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('inputModeManager', KMutableProperty0, true);
    $inputModeManager$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function DefaultOpenContextMenu$lambda_3($inputModeManager$delegate, $focusManager$delegate) {
    return function (it) {
      var tmp;
      if (get_type(it.e9u_1) === Companion_getInstance_9().e9e_1) {
        var tmp0_subject = get_key(it.e9u_1);
        var tmp_0;
        if (equals(tmp0_subject, Companion_getInstance_10().dc9_1) || equals(tmp0_subject, Companion_getInstance_10().bck_1)) {
          var tmp1_safe_receiver = DefaultOpenContextMenu$lambda_1($inputModeManager$delegate);
          if (tmp1_safe_receiver == null)
            null;
          else
            tmp1_safe_receiver.xcp(Companion_getInstance_53().b9u_1);
          var tmp2_safe_receiver = DefaultOpenContextMenu$lambda($focusManager$delegate);
          if (tmp2_safe_receiver == null)
            null;
          else
            tmp2_safe_receiver.f9d(Companion_getInstance_45().k9b_1);
          tmp_0 = true;
        } else if (equals(tmp0_subject, Companion_getInstance_10().cc9_1) || equals(tmp0_subject, Companion_getInstance_10().cck_1)) {
          var tmp3_safe_receiver = DefaultOpenContextMenu$lambda_1($inputModeManager$delegate);
          if (tmp3_safe_receiver == null)
            null;
          else
            tmp3_safe_receiver.xcp(Companion_getInstance_53().b9u_1);
          var tmp4_safe_receiver = DefaultOpenContextMenu$lambda($focusManager$delegate);
          if (tmp4_safe_receiver == null)
            null;
          else
            tmp4_safe_receiver.f9d(Companion_getInstance_45().l9b_1);
          tmp_0 = true;
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function DefaultOpenContextMenu$lambda_4($colors, $components, $session, $focusManager$delegate, $inputModeManager$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var this_0 = get_LocalFocusManager();
        var $composer_1 = $composer_0;
        var tmp$ret$0 = $composer_1.u31(this_0);
        DefaultOpenContextMenu$lambda_0($focusManager$delegate, tmp$ret$0);
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var this_1 = get_LocalInputModeManager();
        var $composer_2 = $composer_0;
        var tmp$ret$1 = $composer_2.u31(this_1);
        DefaultOpenContextMenu$lambda_2($inputModeManager$delegate, tmp$ret$1);
        var tmp_0 = Companion_instance_0;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$2 = _Dp___init__impl__ms3zkb(8);
        var tmp_1 = background(shadow(tmp_0, tmp$ret$2), $colors._v.mlr_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$3 = _Dp___init__impl__ms3zkb(4);
        var tmp_2 = width(padding(tmp_1, VOID, tmp$ret$3), IntrinsicSize_Max_getInstance());
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = verticalScroll(tmp_2, rememberScrollState(0, $composer_0, 0, 1));
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_3 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance_0;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_12().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_3, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_4 = $composer_3;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance_0;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_4, 0).hashCode();
        var localMap = $composer_4.t31();
        var materialized = materialize($composer_4, modifier_0);
        var tmp0 = Companion_getInstance_14().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_5 = $composer_4;
        var tmp_3 = $composer_5.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_5.b31();
        if ($composer_5.h30()) {
          $composer_5.c31(tmp0);
        } else {
          $composer_5.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_5);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
        var $composer_6 = $composer_5;
        var $composer_7 = $composer_6;
        $composer_7.m30(1195397628);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = $components.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (element instanceof TextContextMenuSeparator) {
            $composer_7.m30(417846862);
            MenuSeparator($colors._v.nlr_1, $composer_7, 0);
            $composer_7.n30();
          } else {
            if (element instanceof TextContextMenuItemWithComposableLeadingIcon) {
              $composer_7.m30(417850931);
              MenuItem($session, $colors._v, element, $composer_7, 0);
              $composer_7.n30();
            } else {
              $composer_7.m30(68529427);
              $composer_7.n30();
            }
          }
        }
        $composer_7.n30();
        $composer_5.e31();
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DefaultOpenContextMenu$lambda_5($session, $components, $popupPositionProvider, $colors, $$changed, $$default) {
    return function ($composer, $force) {
      DefaultOpenContextMenu($session, $components, $popupPositionProvider, $colors._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function MenuSeparator$lambda($color, $$changed) {
    return function ($composer, $force) {
      MenuSeparator($color, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function MenuItem$lambda($component, $session) {
    return function () {
      $component.ylr_1($session);
      return Unit_instance;
    };
  }
  function MenuItem$lambda_0($component, $colors) {
    return function ($this$MenuItemContent, $composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        var tmp0_safe_receiver = $component.xlr_1;
        if (tmp0_safe_receiver == null) {
          $composer_0.m30(-973017639);
          $composer_0.n30();
        } else {
          $composer_0.m30(-973017638);
          // Inline function 'kotlin.let' call
          tmp0_safe_receiver(new Color($colors.tlr($component.wlr_1)), $composer_0, 0);
          $composer_0.n30();
        }
        var tmp_0 = TextStyle_init_$Create$($colors.slr($component.wlr_1));
        var tmp_1 = _TextOverflow___init__impl__obguoe(0);
        BasicText($component.vlr_1, null, tmp_0, null, tmp_1, false, 0, 0, null, null, $composer_0, 0, 1018);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_7(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function MenuItem$lambda_1($session, $colors, $component, $$changed) {
    return function ($composer, $force) {
      MenuItem($session, $colors, $component, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function MenuItemContent$lambda($this$semantics) {
    _init_properties_BasicContextMenuRepresentation_skiko_kt__lxw3ik();
    return Unit_instance;
  }
  function MenuItemContent$lambda_0($colors, $onClick, $enabled, $content, $$changed) {
    return function ($composer, $force) {
      MenuItemContent($colors, $onClick, $enabled, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var properties_initialized_BasicContextMenuRepresentation_skiko_kt_t25e7e;
  function _init_properties_BasicContextMenuRepresentation_skiko_kt__lxw3ik() {
    if (!properties_initialized_BasicContextMenuRepresentation_skiko_kt_t25e7e) {
      properties_initialized_BasicContextMenuRepresentation_skiko_kt_t25e7e = true;
      DefaultContextMenuColors_0 = new ContextMenuColors_0(Companion_getInstance().m6b_1, Companion_getInstance().i6b_1, Companion_getInstance().i6b_1, Color__copy$default_impl_ectz3s(Companion_getInstance().i6b_1, 0.38), Color__copy$default_impl_ectz3s(Companion_getInstance().i6b_1, 0.38), Color__copy$default_impl_ectz3s(Companion_getInstance().i6b_1, 0.04));
      androidx_compose_foundation_ContextMenuColors$stable = 0;
    }
  }
  var androidx_compose_foundation_BasicTooltipStrings$stable;
  function isComposeRootInScrollableContainer(_this__u8e3s4) {
    return false;
  }
  function _isSystemInDarkTheme($composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalSystemTheme();
    var $composer_1 = $composer_0;
    return $composer_1.u31(this_0).equals(SystemTheme_Dark_getInstance());
  }
  var androidx_compose_foundation_InputModeFilterIndicationNodeFactory$stable;
  var androidx_compose_foundation_InputModeFilterIndication$stable;
  function platformIndication(indication) {
    return inputModeFilterIndication(indication);
  }
  function inputModeFilterIndication(indication) {
    var tmp;
    if (indication == null) {
      tmp = null;
    } else {
      if (isInterface(indication, IndicationNodeFactory)) {
        tmp = new InputModeFilterIndicationNodeFactory(indication);
      } else {
        tmp = new InputModeFilterIndication(indication);
      }
    }
    return tmp;
  }
  function InputModeFilterIndicationNodeFactory$create$1(this$0, $filteredSource) {
    this.pls_1 = $filteredSource;
    DelegatingNode.call(this);
    this.tb1(this$0.qls_1.ufi($filteredSource));
  }
  protoOf(InputModeFilterIndicationNodeFactory$create$1).f8w = function () {
    this.pls_1.rls_1 = currentValueOf(this, get_LocalInputModeManager());
  };
  protoOf(InputModeFilterIndicationNodeFactory$create$1).h8w = function () {
    this.pls_1.rls_1 = null;
  };
  function InputModeFilterIndicationNodeFactory(original) {
    this.qls_1 = original;
  }
  protoOf(InputModeFilterIndicationNodeFactory).ufi = function (interactionSource) {
    var filteredSource = new InputModeFilterInteractionSource(interactionSource);
    return new InputModeFilterIndicationNodeFactory$create$1(this, filteredSource);
  };
  protoOf(InputModeFilterIndicationNodeFactory).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof InputModeFilterIndicationNodeFactory))
      THROW_CCE();
    return this.qls_1.equals(other.qls_1);
  };
  protoOf(InputModeFilterIndicationNodeFactory).hashCode = function () {
    return this.qls_1.hashCode();
  };
  function InputModeFilterIndication(original) {
    this.tls_1 = original;
  }
  protoOf(InputModeFilterIndication).lg1 = function (interactionSource, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(1127348017);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalInputModeManager();
    var $composer_1 = $composer_0;
    var inputModeManager = $composer_1.u31(this_0);
    var tmp0 = rememberUpdatedInstance.call(this, new InputModeFilterInteractionSource(interactionSource, inputModeManager), $composer_0, 112 & $changed);
    $composer_0.n30();
    return tmp0;
  };
  protoOf(InputModeFilterIndication).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof InputModeFilterIndication))
      THROW_CCE();
    return equals(this.tls_1, other.tls_1);
  };
  protoOf(InputModeFilterIndication).hashCode = function () {
    return hashCode(this.tls_1);
  };
  function InputModeFilterInteractionSource$interactions$slambda$slambda($this_flow, $actualFocusCount, $sentFocusCount, this$0, resultContinuation) {
    this.clt_1 = $this_flow;
    this.dlt_1 = $actualFocusCount;
    this.elt_1 = $sentFocusCount;
    this.flt_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(InputModeFilterInteractionSource$interactions$slambda$slambda).zg1 = function (it, $completion) {
    var tmp = this.ag2(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(InputModeFilterInteractionSource$interactions$slambda$slambda).ja = function (p1, $completion) {
    return this.zg1((!(p1 == null) ? isInterface(p1, Interaction) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(InputModeFilterInteractionSource$interactions$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp_0 = this.glt_1;
            if (!isInterface(tmp_0, FocusInteraction)) {
              this.n9_1 = 3;
              suspendResult = this.clt_1.a1v(this.glt_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (this.dlt_1._v > 0 && this.elt_1._v > 0 || (this.dlt_1._v === 0 && _get_isKeyboardMode__dzti3t(this.flt_1))) {
                var tmp0_subject = this.glt_1;
                if (tmp0_subject instanceof Focus) {
                  var _unary__edvuaz = this.elt_1._v;
                  this.elt_1._v = _unary__edvuaz + 1 | 0;
                } else {
                  if (tmp0_subject instanceof Unfocus) {
                    var _unary__edvuaz_0 = this.elt_1._v;
                    this.elt_1._v = _unary__edvuaz_0 - 1 | 0;
                  }
                }
                this.n9_1 = 1;
                suspendResult = this.clt_1.a1v(this.glt_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 2;
                continue $sm;
              }
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var tmp1_subject = this.glt_1;
            if (tmp1_subject instanceof Focus) {
              var _unary__edvuaz_1 = this.dlt_1._v;
              this.dlt_1._v = _unary__edvuaz_1 + 1 | 0;
            } else {
              if (tmp1_subject instanceof Unfocus) {
                var _unary__edvuaz_2 = this.dlt_1._v;
                this.dlt_1._v = _unary__edvuaz_2 - 1 | 0;
              }
            }

            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(InputModeFilterInteractionSource$interactions$slambda$slambda).ag2 = function (it, completion) {
    var i = new InputModeFilterInteractionSource$interactions$slambda$slambda(this.clt_1, this.dlt_1, this.elt_1, this.flt_1, completion);
    i.glt_1 = it;
    return i;
  };
  function InputModeFilterInteractionSource$interactions$slambda$slambda_0($this_flow, $actualFocusCount, $sentFocusCount, this$0, resultContinuation) {
    var i = new InputModeFilterInteractionSource$interactions$slambda$slambda($this_flow, $actualFocusCount, $sentFocusCount, this$0, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.zg1(it, $completion);
    }, 1);
  }
  function _get_isKeyboardMode__dzti3t($this) {
    var tmp;
    if ($this.rls_1 == null) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = $this.rls_1;
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ncz();
      tmp = equals(tmp_0 == null ? null : new InputMode(tmp_0), new InputMode(Companion_getInstance_53().b9u_1));
    }
    return tmp;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_4(function_0) {
    this.hlt_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).a1v = function (value, $completion) {
    return this.hlt_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).q3 = function () {
    return this.hlt_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).hashCode = function () {
    return hashCode(this.q3());
  };
  function InputModeFilterInteractionSource$interactions$slambda($original, this$0, resultContinuation) {
    this.qlt_1 = $original;
    this.rlt_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(InputModeFilterInteractionSource$interactions$slambda).tlt = function ($this$flow, $completion) {
    var tmp = this.ult($this$flow, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(InputModeFilterInteractionSource$interactions$slambda).ja = function (p1, $completion) {
    return this.tlt((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(InputModeFilterInteractionSource$interactions$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var actualFocusCount = {_v: 0};
            var sentFocusCount = {_v: 0};
            this.n9_1 = 1;
            var tmp_0 = this.qlt_1.eg3();
            var tmp_1 = InputModeFilterInteractionSource$interactions$slambda$slambda_0(this.slt_1, actualFocusCount, sentFocusCount, this.rlt_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_4(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(InputModeFilterInteractionSource$interactions$slambda).ult = function ($this$flow, completion) {
    var i = new InputModeFilterInteractionSource$interactions$slambda(this.qlt_1, this.rlt_1, completion);
    i.slt_1 = $this$flow;
    return i;
  };
  function InputModeFilterInteractionSource$interactions$slambda_0($original, this$0, resultContinuation) {
    var i = new InputModeFilterInteractionSource$interactions$slambda($original, this$0, resultContinuation);
    return constructCallableReference(function ($this$flow, $completion) {
      return i.tlt($this$flow, $completion);
    }, 1);
  }
  function InputModeFilterInteractionSource(original, inputModeManager) {
    inputModeManager = inputModeManager === VOID ? null : inputModeManager;
    this.rls_1 = inputModeManager;
    var tmp = this;
    tmp.sls_1 = flow(InputModeFilterInteractionSource$interactions$slambda_0(original, this, null));
  }
  protoOf(InputModeFilterInteractionSource).eg3 = function () {
    return this.sls_1;
  };
  var androidx_compose_foundation_content_MediaType$stable;
  var androidx_compose_foundation_content_PlatformTransferableContent$stable;
  function computeContextMenuColors($composer, $changed) {
    var $composer_0 = $composer;
    return get_DefaultContextMenuColors();
  }
  var androidx_compose_foundation_draganddrop_DragAndDropSourceDefaults$stable;
  var androidx_compose_foundation_draganddrop_CacheDrawScopeDragShadowCallback$stable;
  function get_LocalBringIntoViewSpec() {
    _init_properties_BringIntoViewSpec_skiko_kt__v57w3d();
    return LocalBringIntoViewSpec;
  }
  var LocalBringIntoViewSpec;
  function LocalBringIntoViewSpec$lambda() {
    _init_properties_BringIntoViewSpec_skiko_kt__v57w3d();
    return Companion_getInstance_59().mge_1;
  }
  var properties_initialized_BringIntoViewSpec_skiko_kt_jq5095;
  function _init_properties_BringIntoViewSpec_skiko_kt__v57w3d() {
    if (!properties_initialized_BringIntoViewSpec_skiko_kt_jq5095) {
      properties_initialized_BringIntoViewSpec_skiko_kt_jq5095 = true;
      LocalBringIntoViewSpec = staticCompositionLocalOf(LocalBringIntoViewSpec$lambda);
    }
  }
  function firstDownRefersToPrimaryMouseButtonOnly() {
    return true;
  }
  function get_isDeepPress(_this__u8e3s4) {
    return false;
  }
  var androidx_compose_foundation_gestures_cupertino_CupertinoFlingBehavior$stable;
  function isAutofillAvailable() {
    return false;
  }
  function rememberDefaultPrefetchScheduler($composer, $changed) {
    var $composer_0 = $composer;
    return new rememberDefaultPrefetchScheduler$1();
  }
  function rememberDefaultPrefetchScheduler$1() {
  }
  protoOf(rememberDefaultPrefetchScheduler$1).rj5 = function (prefetchRequest) {
  };
  var androidx_compose_foundation_platform_SynchronizedObject$stable;
  function SynchronizedObject() {
  }
  function autofillHighlightColor() {
    return Companion_getInstance().u6b_1;
  }
  function BackgroundTextMeasurement(text, style, fontFamilyResolver, $composer, $changed) {
    var $composer_0 = $composer;
  }
  function BackgroundTextMeasurement_0(text, style, fontFamilyResolver, placeholders, $composer, $changed) {
    var $composer_0 = $composer;
  }
  function _ContextMenuIcons___init__impl__765lcb(value) {
    return value;
  }
  function Companion_31() {
    Companion_instance_41 = this;
    this.gk3_1 = _ContextMenuIcons___init__impl__765lcb(0);
    this.hk3_1 = _ContextMenuIcons___init__impl__765lcb(1);
    this.ik3_1 = _ContextMenuIcons___init__impl__765lcb(2);
    this.jk3_1 = _ContextMenuIcons___init__impl__765lcb(3);
    this.kk3_1 = _ContextMenuIcons___init__impl__765lcb(-1);
  }
  var Companion_instance_41;
  function Companion_getInstance_90() {
    if (Companion_instance_41 == null)
      new Companion_31();
    return Companion_instance_41;
  }
  function get_translationByLocaleTag() {
    _init_properties_ContextMenuStrings_skiko_kt__omryhn();
    return translationByLocaleTag;
  }
  var translationByLocaleTag;
  var androidx_compose_foundation_text_Translations$stable;
  function _ContextMenuStrings___init__impl__lshhvx(value) {
    return value;
  }
  function Companion_32() {
    Companion_instance_42 = this;
    this.bk3_1 = _ContextMenuStrings___init__impl__lshhvx(0);
    this.ck3_1 = _ContextMenuStrings___init__impl__lshhvx(1);
    this.dk3_1 = _ContextMenuStrings___init__impl__lshhvx(2);
    this.ek3_1 = _ContextMenuStrings___init__impl__lshhvx(3);
    this.fk3_1 = _ContextMenuStrings___init__impl__lshhvx(4);
  }
  var Companion_instance_42;
  function Companion_getInstance_91() {
    if (Companion_instance_42 == null)
      new Companion_32();
    return Companion_instance_42;
  }
  function ContextMenuStrings__toString_impl_fktwt($this) {
    return 'ContextMenuStrings(value=' + $this + ')';
  }
  function ContextMenuStrings__hashCode_impl_lbl2w2($this) {
    return $this;
  }
  function ContextMenuStrings__equals_impl_hyd5ve($this, other) {
    if (!(other instanceof ContextMenuStrings))
      return false;
    if (!($this === other.vlt_1))
      return false;
    return true;
  }
  function ContextMenuStrings(value) {
    Companion_getInstance_91();
    this.vlt_1 = value;
  }
  protoOf(ContextMenuStrings).toString = function () {
    return ContextMenuStrings__toString_impl_fktwt(this.vlt_1);
  };
  protoOf(ContextMenuStrings).hashCode = function () {
    return ContextMenuStrings__hashCode_impl_lbl2w2(this.vlt_1);
  };
  protoOf(ContextMenuStrings).equals = function (other) {
    return ContextMenuStrings__equals_impl_hyd5ve(this.vlt_1, other);
  };
  function getString(string, $composer, $changed) {
    _init_properties_ContextMenuStrings_skiko_kt__omryhn();
    var $composer_0 = $composer;
    var locale = Companion_instance_8.e2y();
    return getTranslation(string, locale);
  }
  function getLocalizedString(string) {
    _init_properties_ContextMenuStrings_skiko_kt__omryhn();
    var locale = Companion_instance_8.e2y();
    return getTranslation(string, locale);
  }
  function getTranslation(string, locale) {
    _init_properties_ContextMenuStrings_skiko_kt__omryhn();
    var tag = localeTag(locale.n8m(), locale.o8m());
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = get_translationByLocaleTag();
    var value = this_0.w2(tag);
    var tmp;
    if (value == null) {
      var answer = findTranslation(locale);
      this_0.z2(tag, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var translation = tmp;
    var tmp0_elvis_lhs = translation.w2(new ContextMenuStrings(string));
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Missing translation for ' + ContextMenuStrings__toString_impl_fktwt(string);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  function localeTag(language, region) {
    _init_properties_ContextMenuStrings_skiko_kt__omryhn();
    return language === '' ? '' : region === '' ? language : language + '_' + region;
  }
  function findTranslation(locale) {
    _init_properties_ContextMenuStrings_skiko_kt__omryhn();
    // Inline function 'kotlin.sequences.firstNotNullOf' call
    var tmp0 = localeTagChain(locale);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstNotNullOfOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var result = translationFor(element);
        if (!(result == null)) {
          tmp$ret$1 = result;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NoSuchElementException_init_$Create$('No element of the sequence was transformed to a non-null value.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function localeTagChain(locale) {
    _init_properties_ContextMenuStrings_skiko_kt__omryhn();
    return sequence(localeTagChain$slambda_0(locale, null));
  }
  function Translations() {
  }
  var Translations_instance;
  function Translations_getInstance() {
    return Translations_instance;
  }
  function localeTagChain$slambda($locale, resultContinuation) {
    this.elu_1 = $locale;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(localeTagChain$slambda).i3z = function ($this$sequence, $completion) {
    var tmp = this.j3z($this$sequence, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(localeTagChain$slambda).ja = function (p1, $completion) {
    return this.i3z(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(localeTagChain$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            if (!(this.elu_1.o8m() === '')) {
              this.n9_1 = 1;
              suspendResult = this.flu_1.oi(localeTag(this.elu_1.n8m(), this.elu_1.o8m()), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!(this.elu_1.n8m() === '')) {
              this.n9_1 = 3;
              suspendResult = this.flu_1.oi(localeTag(this.elu_1.n8m(), ''), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = this.flu_1.oi(localeTag('', ''), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(localeTagChain$slambda).j3z = function ($this$sequence, completion) {
    var i = new localeTagChain$slambda(this.elu_1, completion);
    i.flu_1 = $this$sequence;
    return i;
  };
  function localeTagChain$slambda_0($locale, resultContinuation) {
    var i = new localeTagChain$slambda($locale, resultContinuation);
    return constructCallableReference(function ($this$sequence, $completion) {
      return i.i3z($this$sequence, $completion);
    }, 1);
  }
  var properties_initialized_ContextMenuStrings_skiko_kt_tx6tk3;
  function _init_properties_ContextMenuStrings_skiko_kt__omryhn() {
    if (!properties_initialized_ContextMenuStrings_skiko_kt_tx6tk3) {
      properties_initialized_ContextMenuStrings_skiko_kt_tx6tk3 = true;
      // Inline function 'kotlin.collections.mutableMapOf' call
      translationByLocaleTag = LinkedHashMap_init_$Create$_0();
      androidx_compose_foundation_text_Translations$stable = 0;
    }
  }
  var androidx_compose_foundation_text_DeadKeyCombiner$stable;
  function DeadKeyCombiner() {
  }
  protoOf(DeadKeyCombiner).rkj = function (event) {
    return get_utf16CodePoint(event);
  };
  var androidx_compose_foundation_text_DefaultSkikoKeyMapping$stable;
  function createMacOsDefaultKeyMapping() {
    var common = commonKeyMapping(Companion_getInstance_74().pke_1);
    return new createMacOsDefaultKeyMapping$1(common);
  }
  function createWindowsDefaultKeyMapping() {
    return new createWindowsDefaultKeyMapping$1();
  }
  function DefaultSkikoKeyMapping() {
  }
  protoOf(DefaultSkikoKeyMapping).hke = function (event) {
    var tmp0_subject = get_key(event);
    var tmp;
    if (equals(tmp0_subject, Companion_getInstance_10().wcc_1) || equals(tmp0_subject, Companion_getInstance_10().fck_1)) {
      var tmp1_subject = get_modifiers(event);
      tmp = tmp1_subject === Companion_getInstance_74().oke_1 ? KeyCommand_HOME_getInstance() : tmp1_subject === Companion_getInstance_74().ske_1 ? KeyCommand_SELECT_HOME_getInstance() : null;
    } else if (equals(tmp0_subject, Companion_getInstance_10().xcc_1) || equals(tmp0_subject, Companion_getInstance_10().gck_1)) {
      var tmp2_subject = get_modifiers(event);
      tmp = tmp2_subject === Companion_getInstance_74().oke_1 ? KeyCommand_END_getInstance() : tmp2_subject === Companion_getInstance_74().ske_1 ? KeyCommand_SELECT_END_getInstance() : null;
    } else {
      tmp = null;
    }
    var tmp3_elvis_lhs = tmp;
    return tmp3_elvis_lhs == null ? get_defaultKeyMapping().hke(event) : tmp3_elvis_lhs;
  };
  var DefaultSkikoKeyMapping_instance;
  function DefaultSkikoKeyMapping_getInstance() {
    return DefaultSkikoKeyMapping_instance;
  }
  function get_CtrlShiftAlt(_this__u8e3s4) {
    return KeyModifiers__plus_impl_wj4ney(KeyModifiers__plus_impl_wj4ney(Companion_getInstance_74().oke_1, Companion_getInstance_74().qke_1), Companion_getInstance_74().nke_1);
  }
  function createMacOsDefaultKeyMapping$1($common) {
    this.glu_1 = $common;
  }
  protoOf(createMacOsDefaultKeyMapping$1).hke = function (event) {
    var keyModifiers = get_modifiers(event);
    var tmp0_subject = get_key(event);
    var tmp;
    if (equals(tmp0_subject, Companion_getInstance_10().ccb_1) || equals(tmp0_subject, Companion_getInstance_10().kck_1)) {
      tmp = keyModifiers === Companion_getInstance_74().mke_1 || keyModifiers === Companion_getInstance_74().qke_1 || (keyModifiers === Companion_getInstance_74().oke_1 || keyModifiers === Companion_getInstance_74().ske_1) ? KeyCommand_DELETE_NEXT_CHAR_getInstance() : keyModifiers === Companion_getInstance_74().nke_1 || keyModifiers === Companion_getInstance_74().rke_1 ? KeyCommand_DELETE_NEXT_WORD_getInstance() : null;
    } else if (equals(tmp0_subject, Companion_getInstance_10().bcb_1)) {
      tmp = keyModifiers === Companion_getInstance_74().mke_1 || keyModifiers === Companion_getInstance_74().qke_1 || (keyModifiers === Companion_getInstance_74().oke_1 || keyModifiers === Companion_getInstance_74().ske_1) ? KeyCommand_DELETE_PREV_CHAR_getInstance() : keyModifiers === Companion_getInstance_74().pke_1 || keyModifiers === Companion_getInstance_74().tke_1 ? KeyCommand_DELETE_FROM_LINE_START_getInstance() : keyModifiers === Companion_getInstance_74().nke_1 || keyModifiers === Companion_getInstance_74().rke_1 ? KeyCommand_DELETE_PREV_WORD_getInstance() : null;
    } else if (equals(tmp0_subject, Companion_getInstance_10().acb_1) || equals(tmp0_subject, Companion_getInstance_10().vcc_1)) {
      tmp = keyModifiers === Companion_getInstance_74().mke_1 || keyModifiers === Companion_getInstance_74().nke_1 || (keyModifiers === Companion_getInstance_74().qke_1 || keyModifiers === Companion_getInstance_74().rke_1) ? KeyCommand_NEW_LINE_getInstance() : null;
    } else if (equals(tmp0_subject, Companion_getInstance_10().wcc_1) || equals(tmp0_subject, Companion_getInstance_10().fck_1)) {
      var tmp4_subject = get_modifiers(event);
      tmp = tmp4_subject === Companion_getInstance_74().pke_1 ? KeyCommand_HOME_getInstance() : tmp4_subject === Companion_getInstance_74().tke_1 ? KeyCommand_SELECT_HOME_getInstance() : null;
    } else if (equals(tmp0_subject, Companion_getInstance_10().xcc_1) || equals(tmp0_subject, Companion_getInstance_10().gck_1)) {
      var tmp5_subject = get_modifiers(event);
      tmp = tmp5_subject === Companion_getInstance_74().pke_1 ? KeyCommand_END_getInstance() : tmp5_subject === Companion_getInstance_74().tke_1 ? KeyCommand_SELECT_END_getInstance() : null;
    } else {
      tmp = null;
    }
    var tmp6_safe_receiver = tmp;
    if (tmp6_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp6_safe_receiver;
    }
    var tmp_0;
    if (keyModifiers === Companion_getInstance_74().vke_1) {
      var tmp8_subject = get_key(event);
      tmp_0 = equals(tmp8_subject, Companion_getInstance_10().zca_1) ? KeyCommand_CHARACTER_PALETTE_getInstance() : null;
    } else if (keyModifiers === Companion_getInstance_74().rke_1) {
      var tmp9_subject = get_key(event);
      tmp_0 = equals(tmp9_subject, Companion_getInstance_10().ec9_1) || equals(tmp9_subject, Companion_getInstance_10().dck_1) ? KeyCommand_SELECT_LEFT_WORD_getInstance() : equals(tmp9_subject, Companion_getInstance_10().fc9_1) || equals(tmp9_subject, Companion_getInstance_10().eck_1) ? KeyCommand_SELECT_RIGHT_WORD_getInstance() : equals(tmp9_subject, Companion_getInstance_10().cc9_1) || equals(tmp9_subject, Companion_getInstance_10().bck_1) ? KeyCommand_SELECT_PREV_PARAGRAPH_getInstance() : equals(tmp9_subject, Companion_getInstance_10().dc9_1) || equals(tmp9_subject, Companion_getInstance_10().cck_1) ? KeyCommand_SELECT_NEXT_PARAGRAPH_getInstance() : null;
    } else if (keyModifiers === Companion_getInstance_74().tke_1) {
      var tmp10_subject = get_key(event);
      tmp_0 = equals(tmp10_subject, Companion_getInstance_10().ec9_1) || equals(tmp10_subject, Companion_getInstance_10().dck_1) ? KeyCommand_SELECT_LINE_LEFT_getInstance() : equals(tmp10_subject, Companion_getInstance_10().fc9_1) || equals(tmp10_subject, Companion_getInstance_10().eck_1) ? KeyCommand_SELECT_LINE_RIGHT_getInstance() : equals(tmp10_subject, Companion_getInstance_10().cc9_1) || equals(tmp10_subject, Companion_getInstance_10().bck_1) ? KeyCommand_SELECT_HOME_getInstance() : equals(tmp10_subject, Companion_getInstance_10().dc9_1) || equals(tmp10_subject, Companion_getInstance_10().cck_1) ? KeyCommand_SELECT_END_getInstance() : null;
    } else if (keyModifiers === Companion_getInstance_74().pke_1) {
      var tmp11_subject = get_key(event);
      tmp_0 = equals(tmp11_subject, Companion_getInstance_10().ec9_1) || equals(tmp11_subject, Companion_getInstance_10().dck_1) ? KeyCommand_LINE_LEFT_getInstance() : equals(tmp11_subject, Companion_getInstance_10().fc9_1) || equals(tmp11_subject, Companion_getInstance_10().eck_1) ? KeyCommand_LINE_RIGHT_getInstance() : equals(tmp11_subject, Companion_getInstance_10().cc9_1) || equals(tmp11_subject, Companion_getInstance_10().bck_1) ? KeyCommand_HOME_getInstance() : equals(tmp11_subject, Companion_getInstance_10().dc9_1) || equals(tmp11_subject, Companion_getInstance_10().cck_1) ? KeyCommand_END_getInstance() : null;
    } else if (keyModifiers === get_CtrlShiftAlt(Companion_getInstance_74())) {
      var tmp12_subject = get_key(event);
      tmp_0 = equals(tmp12_subject, Companion_getInstance_10().xc9_1) ? KeyCommand_SELECT_RIGHT_WORD_getInstance() : equals(tmp12_subject, Companion_getInstance_10().tc9_1) ? KeyCommand_SELECT_LEFT_WORD_getInstance() : null;
    } else if (keyModifiers === Companion_getInstance_74().uke_1) {
      var tmp13_subject = get_key(event);
      tmp_0 = equals(tmp13_subject, Companion_getInstance_10().xc9_1) ? KeyCommand_RIGHT_WORD_getInstance() : equals(tmp13_subject, Companion_getInstance_10().tc9_1) ? KeyCommand_LEFT_WORD_getInstance() : null;
    } else if (keyModifiers === Companion_getInstance_74().ske_1) {
      var tmp14_subject = get_key(event);
      tmp_0 = equals(tmp14_subject, Companion_getInstance_10().xc9_1) ? KeyCommand_SELECT_RIGHT_CHAR_getInstance() : equals(tmp14_subject, Companion_getInstance_10().tc9_1) ? KeyCommand_SELECT_LEFT_CHAR_getInstance() : equals(tmp14_subject, Companion_getInstance_10().hca_1) ? KeyCommand_SELECT_UP_getInstance() : equals(tmp14_subject, Companion_getInstance_10().fca_1) ? KeyCommand_SELECT_DOWN_getInstance() : equals(tmp14_subject, Companion_getInstance_10().sc9_1) ? KeyCommand_SELECT_LINE_START_getInstance() : equals(tmp14_subject, Companion_getInstance_10().wc9_1) ? KeyCommand_SELECT_LINE_END_getInstance() : null;
    } else if (keyModifiers === Companion_getInstance_74().oke_1) {
      var tmp15_subject = get_key(event);
      tmp_0 = equals(tmp15_subject, Companion_getInstance_10().xc9_1) ? KeyCommand_LEFT_CHAR_getInstance() : equals(tmp15_subject, Companion_getInstance_10().tc9_1) ? KeyCommand_RIGHT_CHAR_getInstance() : equals(tmp15_subject, Companion_getInstance_10().hca_1) ? KeyCommand_UP_getInstance() : equals(tmp15_subject, Companion_getInstance_10().fca_1) ? KeyCommand_DOWN_getInstance() : equals(tmp15_subject, Companion_getInstance_10().sc9_1) ? KeyCommand_LINE_START_getInstance() : equals(tmp15_subject, Companion_getInstance_10().wc9_1) ? KeyCommand_LINE_END_getInstance() : equals(tmp15_subject, Companion_getInstance_10().zc9_1) ? KeyCommand_DELETE_PREV_CHAR_getInstance() : equals(tmp15_subject, Companion_getInstance_10().vc9_1) ? KeyCommand_DELETE_NEXT_CHAR_getInstance() : equals(tmp15_subject, Companion_getInstance_10().cca_1) ? KeyCommand_DELETE_TO_LINE_END_getInstance() : equals(tmp15_subject, Companion_getInstance_10().gca_1) ? KeyCommand_NEW_LINE_getInstance() : null;
    } else if (keyModifiers === Companion_getInstance_74().qke_1) {
      var tmp16_subject = get_key(event);
      tmp_0 = equals(tmp16_subject, Companion_getInstance_10().wcc_1) || equals(tmp16_subject, Companion_getInstance_10().fck_1) ? KeyCommand_SELECT_HOME_getInstance() : equals(tmp16_subject, Companion_getInstance_10().xcc_1) || equals(tmp16_subject, Companion_getInstance_10().gck_1) ? KeyCommand_SELECT_END_getInstance() : null;
    } else if (keyModifiers === Companion_getInstance_74().nke_1) {
      var tmp17_subject = get_key(event);
      tmp_0 = equals(tmp17_subject, Companion_getInstance_10().ec9_1) || equals(tmp17_subject, Companion_getInstance_10().dck_1) ? KeyCommand_LEFT_WORD_getInstance() : equals(tmp17_subject, Companion_getInstance_10().fc9_1) || equals(tmp17_subject, Companion_getInstance_10().eck_1) ? KeyCommand_RIGHT_WORD_getInstance() : equals(tmp17_subject, Companion_getInstance_10().cc9_1) || equals(tmp17_subject, Companion_getInstance_10().bck_1) ? KeyCommand_PREV_PARAGRAPH_getInstance() : equals(tmp17_subject, Companion_getInstance_10().dc9_1) || equals(tmp17_subject, Companion_getInstance_10().cck_1) ? KeyCommand_NEXT_PARAGRAPH_getInstance() : null;
    } else {
      tmp_0 = null;
    }
    var tmp18_elvis_lhs = tmp_0;
    return tmp18_elvis_lhs == null ? this.glu_1.hke(event) : tmp18_elvis_lhs;
  };
  function createWindowsDefaultKeyMapping$1() {
  }
  protoOf(createWindowsDefaultKeyMapping$1).hke = function (event) {
    var keyModifiers = get_modifiers(event);
    if (keyModifiers === Companion_getInstance_74().nke_1 && equals(get_key(event), Companion_getInstance_10().bcb_1)) {
      return KeyCommand_UNDO_getInstance();
    }
    return DefaultSkikoKeyMapping_instance.hke(event);
  };
  function findPrecedingBreak(_this__u8e3s4, index) {
    var it = Companion_getInstance_54().l5j();
    it.t5j(_this__u8e3s4);
    return it.r5j(index);
  }
  function findFollowingBreak(_this__u8e3s4, index) {
    var it = Companion_getInstance_54().l5j();
    it.t5j(_this__u8e3s4);
    return it.s5j(index);
  }
  function findCodePointOrEmojiStartBefore(_this__u8e3s4, index, ifNotFound) {
    if (index <= 0)
      return -1;
    var precedingCharBreakIndex = findPrecedingBreak(_this__u8e3s4, index);
    var precedingCodePointIndex = offsetByCodePoints(_this__u8e3s4, index, -1);
    if (precedingCharBreakIndex === precedingCodePointIndex)
      return precedingCodePointIndex;
    var substringFromCharBreak = substring(_this__u8e3s4, precedingCharBreakIndex, index);
    return canBeEmojiOrPictographic(substringFromCharBreak) ? precedingCharBreakIndex : precedingCodePointIndex;
  }
  function appendCodePoint(_this__u8e3s4, codePoint) {
    if (codePoint < 65536) {
      _this__u8e3s4.s(numberToChar(codePoint));
    } else {
      _this__u8e3s4.s(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(55296), (codePoint - 65536 | 0) >> 10));
      _this__u8e3s4.s(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(56320), codePoint & 1023));
    }
  }
  function offsetByCodePoints(_this__u8e3s4, index, offset) {
    var sign = get_sign(offset);
    // Inline function 'kotlin.math.absoluteValue' call
    var distance = abs(offset);
    var currentOffset = index;
    var inductionVariable = 0;
    if (inductionVariable < distance)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        currentOffset = currentOffset + sign | 0;
        if (currentOffset <= 0)
          return 0;
        else if (currentOffset >= charSequenceLength(_this__u8e3s4))
          return charSequenceLength(_this__u8e3s4);
        var lead = charSequenceGet(_this__u8e3s4, currentOffset - 1 | 0);
        var trail = charSequenceGet(_this__u8e3s4, currentOffset);
        if (isSurrogatePair(lead, trail)) {
          currentOffset = currentOffset + sign | 0;
        }
      }
       while (inductionVariable < distance);
    return currentOffset;
  }
  function canBeEmojiOrPictographic(text) {
    var _iterator__ex2g4s = get_codePoints(text).t();
    while (_iterator__ex2g4s.u()) {
      var codePoint = _iterator__ex2g4s.v();
      // Inline function 'kotlin.with' call
      var $this$with = CharProperties_getInstance();
      if ($this$with.q5z(codePoint, 58) || $this$with.q5z(codePoint, 64) || codePoint === 65039) {
        return true;
      }
    }
    return false;
  }
  function isSurrogatePair(high, low) {
    return isHighSurrogate(high) && isLowSurrogate(low);
  }
  function get_codePoints(_this__u8e3s4) {
    return codePointsAt(_this__u8e3s4, 0);
  }
  function codePointsAt(_this__u8e3s4, index) {
    return sequence(codePointsAt$slambda_0(index, _this__u8e3s4, null));
  }
  function codePointAt(_this__u8e3s4, index) {
    var high = charSequenceGet(_this__u8e3s4, index);
    if (isHighSurrogate(high) && (index + 1 | 0) < charSequenceLength(_this__u8e3s4)) {
      var low = charSequenceGet(_this__u8e3s4, index + 1 | 0);
      if (isLowSurrogate(low)) {
        return toCodePoint(Companion_getInstance_55(), high, low);
      }
    }
    // Inline function 'kotlin.code' call
    return Char__toInt_impl_vasixd(high);
  }
  function charCount(_this__u8e3s4) {
    return _this__u8e3s4 >= 65536 ? 2 : 1;
  }
  function toCodePoint(_this__u8e3s4, high, low) {
    return (Char__minus_impl_a2frrh(high, _Char___init__impl__6a9atx(55296)) << 10 | Char__minus_impl_a2frrh(low, _Char___init__impl__6a9atx(56320))) + 65536 | 0;
  }
  function codePointsAt$slambda($index, $this_codePointsAt, resultContinuation) {
    this.plu_1 = $index;
    this.qlu_1 = $this_codePointsAt;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(codePointsAt$slambda).k8f = function ($this$sequence, $completion) {
    var tmp = this.l8f($this$sequence, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(codePointsAt$slambda).ja = function (p1, $completion) {
    return this.k8f(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(codePointsAt$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.slu_1 = this.plu_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.slu_1 < this.qlu_1.length)) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.tlu_1 = codePointAt(this.qlu_1, this.slu_1);
            this.n9_1 = 2;
            suspendResult = this.rlu_1.oi(this.tlu_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.slu_1 = this.slu_1 + charCount(this.tlu_1) | 0;
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(codePointsAt$slambda).l8f = function ($this$sequence, completion) {
    var i = new codePointsAt$slambda(this.plu_1, this.qlu_1, completion);
    i.rlu_1 = $this$sequence;
    return i;
  };
  function codePointsAt$slambda_0($index, $this_codePointsAt, resultContinuation) {
    var i = new codePointsAt$slambda($index, $this_codePointsAt, resultContinuation);
    return constructCallableReference(function ($this$sequence, $completion) {
      return i.k8f($this$sequence, $completion);
    }, 1);
  }
  function interceptDPadAndMoveFocus(_this__u8e3s4, state, focusManager) {
    return _this__u8e3s4;
  }
  var androidx_compose_foundation_text_TextFieldScrollState$stable;
  function get_handwritingPointerIcon() {
    _init_properties_TextPointerIcon_skiko_kt__4sfdky();
    return handwritingPointerIcon;
  }
  var handwritingPointerIcon;
  var properties_initialized_TextPointerIcon_skiko_kt_3qxo0w;
  function _init_properties_TextPointerIcon_skiko_kt__4sfdky() {
    if (!properties_initialized_TextPointerIcon_skiko_kt_3qxo0w) {
      properties_initialized_TextPointerIcon_skiko_kt_3qxo0w = true;
      handwritingPointerIcon = Companion_getInstance_49().da3_1;
    }
  }
  function item_0(_this__u8e3s4, key, label, enabled, leadingIcon, onClick) {
    enabled = enabled === VOID ? true : enabled;
    leadingIcon = leadingIcon === VOID ? null : leadingIcon;
    _this__u8e3s4.ykr(new TextContextMenuItemWithComposableLeadingIcon(key, label, enabled, leadingIcon, onClick));
  }
  var androidx_compose_foundation_text_contextmenu_data_TextContextMenuItemWithComposableLeadingIcon$stable;
  function TextContextMenuItemWithComposableLeadingIcon(key, label, enabled, leadingIcon, onClick) {
    leadingIcon = leadingIcon === VOID ? null : leadingIcon;
    TextContextMenuComponent.call(this, key);
    this.vlr_1 = label;
    this.wlr_1 = enabled;
    this.xlr_1 = leadingIcon;
    this.ylr_1 = onClick;
  }
  protoOf(TextContextMenuItemWithComposableLeadingIcon).toString = function () {
    return 'TextContextMenuItem(key=' + toString(this.cks_1) + ', label="' + this.vlr_1 + '", enabled=' + this.wlr_1 + ')';
  };
  function ProvideDefaultTextContextMenuDropdown(modifier, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1580633563);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      ProvideBasicTextContextMenu(modifier, get_LocalTextContextMenuDropdownProvider(), ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt_getInstance().vlu_1, content, $composer_0, 432 | 14 & $dirty | 7168 & $dirty << 6);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProvideDefaultTextContextMenuDropdown$lambda(modifier, content, $changed));
    }
  }
  function defaultTextContextMenuDropdown($composer, $changed) {
    var $composer_0 = $composer;
    return basicTextContextMenuProvider(ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt_getInstance().wlu_1, $composer_0, 6);
  }
  function ComposableLambda$invoke$ref_8(p0) {
    return constructCallableReference(function (p0_0, p1, p2, p3, p4) {
      p0.w50(p0_0, p1, p2, p3, p4);
      return Unit_instance;
    }, 5, 0, 369, VOID, [p0]);
  }
  function ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt$lambda$1837043723$lambda(session, dataProvider, anchorLayoutCoordinates, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(session) : $composer_0.q31(session)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(dataProvider) : $composer_0.q31(dataProvider)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(anchorLayoutCoordinates) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      OpenContextMenu(session, dataProvider, anchorLayoutCoordinates, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt$lambda$_651812147$lambda_uw895q(session, dataProvider, anchorLayoutCoordinates, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(session) : $composer_0.q31(session)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(dataProvider) : $composer_0.q31(dataProvider)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(anchorLayoutCoordinates) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      OpenContextMenu(session, dataProvider, anchorLayoutCoordinates, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt$lambda$1965104340$lambda(session, dataProvider, anchorLayoutCoordinates, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(session) : $composer_0.q31(session)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(dataProvider) : $composer_0.q31(dataProvider)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(anchorLayoutCoordinates) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      OpenContextMenu(session, dataProvider, anchorLayoutCoordinates, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt() {
    ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt_instance = this;
    var tmp = this;
    tmp.ulu_1 = ComposableLambda$invoke$ref_8(composableLambdaInstance(1837043723, false, ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt$lambda$1837043723$lambda));
    var tmp_0 = this;
    tmp_0.vlu_1 = ComposableLambda$invoke$ref_8(composableLambdaInstance(-651812147, false, ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt$lambda$_651812147$lambda_uw895q));
    var tmp_1 = this;
    tmp_1.wlu_1 = ComposableLambda$invoke$ref_8(composableLambdaInstance(1965104340, false, ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt$lambda$1965104340$lambda));
  }
  var ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt_instance;
  function ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt_getInstance() {
    if (ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt_instance == null)
      new ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt();
    return ComposableSingletons$DefaultTextContextMenuDropdownProvider_skikoKt_instance;
  }
  function OpenContextMenu(session, dataProvider, anchorLayoutCoordinates, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1150686290);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(session) : $composer_0.q31(session)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(dataProvider) : $composer_0.q31(dataProvider)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(anchorLayoutCoordinates) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 112) === 32 || (!(($dirty & 64) === 0) && $composer_0.k31(dataProvider));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = new MaintainWindowPositionPopupPositionProvider(new ContextMenuPopupPositionProvider(OpenContextMenu$lambda(dataProvider, anchorLayoutCoordinates)));
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var popupPositionProvider = tmp;
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = ($dirty & 112) === 32 || (!(($dirty & 64) === 0) && $composer_0.k31(dataProvider));
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_0;
      if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = derivedStateOf(TextContextMenuDataProvider$data$ref(dataProvider));
        tmp0_0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var data$delegate = tmp_0;
      var tmp_1 = OpenContextMenu$lambda_0(data$delegate).bks_1;
      DefaultOpenContextMenu(session, tmp_1, popupPositionProvider, null, $composer_0, 14 & $dirty, 8);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(OpenContextMenu$lambda_1(session, dataProvider, anchorLayoutCoordinates, $changed));
    }
  }
  function MaintainWindowPositionPopupPositionProvider(popupPositionProvider) {
    this.xlu_1 = popupPositionProvider;
    this.ylu_1 = null;
    this.zlu_1 = null;
    this.alv_1 = null;
    this.blv_1 = null;
  }
  protoOf(MaintainWindowPositionPopupPositionProvider).ldb = function (anchorBounds, windowSize, layoutDirection, popupContentSize) {
    var position = this.blv_1;
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2 = position;
    if (!((tmp_2 == null ? null : new IntOffset(tmp_2)) == null)) {
      var tmp_3 = this.ylu_1;
      tmp_1 = equals(tmp_3 == null ? null : new IntSize(tmp_3), new IntSize(windowSize));
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(this.zlu_1, layoutDirection);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp_4 = this.alv_1;
      tmp = equals(tmp_4 == null ? null : new IntSize(tmp_4), new IntSize(popupContentSize));
    } else {
      tmp = false;
    }
    if (tmp) {
      return position;
    }
    var newPosition = this.xlu_1.ldb(anchorBounds, windowSize, layoutDirection, popupContentSize);
    this.ylu_1 = windowSize;
    this.zlu_1 = layoutDirection;
    this.alv_1 = popupContentSize;
    this.blv_1 = newPosition;
    return newPosition;
  };
  function ProvideDefaultTextContextMenuDropdown$lambda($modifier, $content, $$changed) {
    return function ($composer, $force) {
      ProvideDefaultTextContextMenuDropdown($modifier, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function OpenContextMenu$lambda($dataProvider, $anchorLayoutCoordinates) {
    return function () {
      return new IntOffset(round($dataProvider.vkt($anchorLayoutCoordinates())));
    };
  }
  function OpenContextMenu$lambda_0($data$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('data', KProperty0, false);
    return $data$delegate.u1();
  }
  function OpenContextMenu$lambda_1($session, $dataProvider, $anchorLayoutCoordinates, $$changed) {
    return function ($composer, $force) {
      OpenContextMenu($session, $dataProvider, $anchorLayoutCoordinates, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function get_isStylusHandwritingSupported() {
    return false;
  }
  function createLegacyPlatformTextInputServiceAdapter() {
    return new createLegacyPlatformTextInputServiceAdapter$1();
  }
  function TextEditingScope(commands) {
    return new TextEditingScope$1(commands);
  }
  function _set_textFieldValue__2lf7qr($this, _set____db54di) {
    var tmp0 = $this.elv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_textFieldValue_$ref_6w6mc0();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('textFieldValue', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_textFieldValue_$ref_r1oosc());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_textFieldValue__s4ins7($this) {
    var tmp0 = $this.elv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_textFieldValue_$ref_6w6mc0();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('textFieldValue', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_textFieldValue_$ref_r1oosc());
    return tmp0.u1();
  }
  function _set_textLayoutResult__cabbrx($this, _set____db54di) {
    var tmp0 = $this.flv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_textLayoutResult_$ref_4mn80w();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('textLayoutResult', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_textLayoutResult_$ref_9bffzg());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_textLayoutResult__gssxav($this) {
    var tmp0 = $this.flv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_textLayoutResult_$ref_4mn80w();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('textLayoutResult', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_textLayoutResult_$ref_9bffzg());
    return tmp0.u1();
  }
  function _set_focusedRectInRoot__r02n43($this, _set____db54di) {
    var tmp0 = $this.glv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_focusedRectInRoot_$ref_j7v9b0();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('focusedRectInRoot', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_focusedRectInRoot_$ref_d28wvc());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_focusedRectInRoot__5a9qtr($this) {
    var tmp0 = $this.glv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_focusedRectInRoot_$ref_j7v9b0();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('focusedRectInRoot', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_focusedRectInRoot_$ref_d28wvc());
    return tmp0.u1();
  }
  function _set_textFieldRectInRoot__sb9nx($this, _set____db54di) {
    var tmp0 = $this.hlv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_textFieldRectInRoot_$ref_iz8o26();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('textFieldRectInRoot', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_textFieldRectInRoot_$ref_vkpzni());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_textFieldRectInRoot__e31ik9($this) {
    var tmp0 = $this.hlv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_textFieldRectInRoot_$ref_iz8o26();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('textFieldRectInRoot', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_textFieldRectInRoot_$ref_vkpzni());
    return tmp0.u1();
  }
  function _set_textClippingRectInRoot__39a2il($this, _set____db54di) {
    var tmp0 = $this.ilv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_textClippingRectInRoot_$ref_kps796();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('textClippingRectInRoot', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_textClippingRectInRoot_$ref_jaygue());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_textClippingRectInRoot__pidiy9($this) {
    var tmp0 = $this.ilv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_textClippingRectInRoot_$ref_kps796();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('textClippingRectInRoot', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_textClippingRectInRoot_$ref_jaygue());
    return tmp0.u1();
  }
  function _set_unclippedTextOffsetInRoot__82ckt4($this, _set____db54di) {
    var tmp0 = $this.jlv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_unclippedTextOffsetInRoot_$ref_5cdls7();
    getPropertyCallableRef('unclippedTextOffsetInRoot', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_unclippedTextOffsetInRoot_$ref_ex3jf7());
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new Offset(_set____db54di);
    tmp0.s21(value);
    return Unit_instance;
  }
  function _get_unclippedTextOffsetInRoot__5ti1us($this) {
    var tmp0 = $this.jlv_1;
    var tmp = KMutableProperty1;
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$_get_unclippedTextOffsetInRoot_$ref_5cdls7();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('unclippedTextOffsetInRoot', 1, tmp, tmp_0, createLegacyPlatformTextInputServiceAdapter$o$_set_unclippedTextOffsetInRoot_$ref_ex3jf7());
    return tmp0.u1().e5d_1;
  }
  function makeRequest($this, imeOptions, onEditCommand, onImeActionPerformed) {
    var textEditorState = new createLegacyPlatformTextInputServiceAdapter$1$makeRequest$textEditorState$1($this);
    var editBlock = createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda(onEditCommand);
    var tmp = createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_0($this);
    var tmp_0 = createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_1($this);
    var tmp_1 = createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_2($this);
    var tmp_2 = createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_3($this);
    var tmp_3 = createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_4($this);
    return new SkikoPlatformTextInputMethodRequest(tmp, textEditorState, imeOptions, onEditCommand, onImeActionPerformed, tmp_0, tmp_1, tmp_2, tmp_3, createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_5($this), editBlock);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_get_textFieldValue_$ref_6w6mc0() {
    return constructCallableReference(function (p0) {
      return _get_textFieldValue__s4ins7(p0);
    }, 1, 0, 370);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_set_textFieldValue_$ref_r1oosc() {
    return constructCallableReference(function (p0, p1) {
      _set_textFieldValue__2lf7qr(p0, p1);
      return Unit_instance;
    }, 2, 0, 371);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_get_textLayoutResult_$ref_4mn80w() {
    return constructCallableReference(function (p0) {
      return _get_textLayoutResult__gssxav(p0);
    }, 1, 0, 372);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_set_textLayoutResult_$ref_9bffzg() {
    return constructCallableReference(function (p0, p1) {
      _set_textLayoutResult__cabbrx(p0, p1);
      return Unit_instance;
    }, 2, 0, 373);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_get_focusedRectInRoot_$ref_j7v9b0() {
    return constructCallableReference(function (p0) {
      return _get_focusedRectInRoot__5a9qtr(p0);
    }, 1, 0, 374);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_set_focusedRectInRoot_$ref_d28wvc() {
    return constructCallableReference(function (p0, p1) {
      _set_focusedRectInRoot__r02n43(p0, p1);
      return Unit_instance;
    }, 2, 0, 375);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_get_textFieldRectInRoot_$ref_iz8o26() {
    return constructCallableReference(function (p0) {
      return _get_textFieldRectInRoot__e31ik9(p0);
    }, 1, 0, 376);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_set_textFieldRectInRoot_$ref_vkpzni() {
    return constructCallableReference(function (p0, p1) {
      _set_textFieldRectInRoot__sb9nx(p0, p1);
      return Unit_instance;
    }, 2, 0, 377);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_get_textClippingRectInRoot_$ref_kps796() {
    return constructCallableReference(function (p0) {
      return _get_textClippingRectInRoot__pidiy9(p0);
    }, 1, 0, 378);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_set_textClippingRectInRoot_$ref_jaygue() {
    return constructCallableReference(function (p0, p1) {
      _set_textClippingRectInRoot__39a2il(p0, p1);
      return Unit_instance;
    }, 2, 0, 379);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_get_unclippedTextOffsetInRoot_$ref_5cdls7() {
    return constructCallableReference(function (p0) {
      return new Offset(_get_unclippedTextOffsetInRoot__5ti1us(p0));
    }, 1, 0, 380);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$_set_unclippedTextOffsetInRoot_$ref_ex3jf7() {
    return constructCallableReference(function (p0, p1) {
      _set_unclippedTextOffsetInRoot__82ckt4(p0, p1.e5d_1);
      return Unit_instance;
    }, 2, 0, 381);
  }
  function createLegacyPlatformTextInputServiceAdapter$o$startInput$slambda(this$0, $imeOptions, $onEditCommand, $onImeActionPerformed, resultContinuation) {
    this.slv_1 = this$0;
    this.tlv_1 = $imeOptions;
    this.ulv_1 = $onEditCommand;
    this.vlv_1 = $onImeActionPerformed;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createLegacyPlatformTextInputServiceAdapter$o$startInput$slambda).xlv = function ($this$launchTextInputSession, $completion) {
    var tmp = this.ylv($this$launchTextInputSession, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(createLegacyPlatformTextInputServiceAdapter$o$startInput$slambda).ja = function (p1, $completion) {
    return this.xlv((!(p1 == null) ? isInterface(p1, PlatformTextInputSession) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(createLegacyPlatformTextInputServiceAdapter$o$startInput$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.wlv_1.hbp(makeRequest(this.slv_1, this.tlv_1, this.ulv_1, this.vlv_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(createLegacyPlatformTextInputServiceAdapter$o$startInput$slambda).ylv = function ($this$launchTextInputSession, completion) {
    var i = new createLegacyPlatformTextInputServiceAdapter$o$startInput$slambda(this.slv_1, this.tlv_1, this.ulv_1, this.vlv_1, completion);
    i.wlv_1 = $this$launchTextInputSession;
    return i;
  };
  function createLegacyPlatformTextInputServiceAdapter$o$startInput$slambda_0(this$0, $imeOptions, $onEditCommand, $onImeActionPerformed, resultContinuation) {
    var i = new createLegacyPlatformTextInputServiceAdapter$o$startInput$slambda(this$0, $imeOptions, $onEditCommand, $onImeActionPerformed, resultContinuation);
    return constructCallableReference(function ($this$launchTextInputSession, $completion) {
      return i.xlv($this$launchTextInputSession, $completion);
    }, 1);
  }
  function createLegacyPlatformTextInputServiceAdapter$1$makeRequest$textEditorState$1(this$0) {
    this.zlv_1 = this$0;
  }
  protoOf(createLegacyPlatformTextInputServiceAdapter$1$makeRequest$textEditorState$1).a = function () {
    return _get_textFieldValue__s4ins7(this.zlv_1).h89().length;
  };
  protoOf(createLegacyPlatformTextInputServiceAdapter$1$makeRequest$textEditorState$1).b = function (index) {
    return charCodeAt(_get_textFieldValue__s4ins7(this.zlv_1).h89(), index);
  };
  protoOf(createLegacyPlatformTextInputServiceAdapter$1$makeRequest$textEditorState$1).c = function (startIndex, endIndex) {
    return substring(_get_textFieldValue__s4ins7(this.zlv_1).h89(), startIndex, endIndex);
  };
  function createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda($onEditCommand) {
    return function (block) {
      // Inline function 'kotlin.collections.mutableListOf' call
      var commands = ArrayList_init_$Create$();
      // Inline function 'kotlin.with' call
      block(TextEditingScope(commands));
      $onEditCommand(commands);
      return Unit_instance;
    };
  }
  function createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_0(this$0) {
    return function () {
      return _get_textFieldValue__s4ins7(this$0);
    };
  }
  function createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_1(this$0) {
    return function () {
      return _get_textLayoutResult__gssxav(this$0);
    };
  }
  function createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_2(this$0) {
    return function () {
      return _get_focusedRectInRoot__5a9qtr(this$0);
    };
  }
  function createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_3(this$0) {
    return function () {
      return _get_textFieldRectInRoot__e31ik9(this$0);
    };
  }
  function createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_4(this$0) {
    return function () {
      return _get_textClippingRectInRoot__pidiy9(this$0);
    };
  }
  function createLegacyPlatformTextInputServiceAdapter$o$makeRequest$lambda_5(this$0) {
    return function () {
      return new Offset(_get_unclippedTextOffsetInRoot__5ti1us(this$0));
    };
  }
  function createLegacyPlatformTextInputServiceAdapter$1() {
    LegacyPlatformTextInputServiceAdapter.call(this);
    this.dlv_1 = null;
    this.elv_1 = mutableStateOf(TextFieldValue_init_$Create$());
    this.flv_1 = mutableStateOf(null);
    this.glv_1 = mutableStateOf(Companion_getInstance_50().j5d_1);
    this.hlv_1 = mutableStateOf(Companion_getInstance_50().j5d_1);
    this.ilv_1 = mutableStateOf(Companion_getInstance_50().j5d_1);
    this.jlv_1 = mutableStateOf(new Offset(Companion_getInstance_6().g5d_1));
  }
  protoOf(createLegacyPlatformTextInputServiceAdapter$1).a8d = function (value, imeOptions, onEditCommand, onImeActionPerformed) {
    _set_textFieldValue__2lf7qr(this, value);
    var tmp0_elvis_lhs = this.wka_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var node = tmp;
    var tmp_0 = this;
    tmp_0.dlv_1 = node.zl4(createLegacyPlatformTextInputServiceAdapter$o$startInput$slambda_0(this, imeOptions, onEditCommand, onImeActionPerformed, null));
  };
  protoOf(createLegacyPlatformTextInputServiceAdapter$1).d8d = function () {
    var tmp0_safe_receiver = this.dlv_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.b1b();
    }
    this.dlv_1 = null;
    _set_textFieldValue__2lf7qr(this, TextFieldValue_init_$Create$());
  };
  protoOf(createLegacyPlatformTextInputServiceAdapter$1).l8d = function (oldValue, newValue) {
    _set_textFieldValue__2lf7qr(this, newValue);
  };
  protoOf(createLegacyPlatformTextInputServiceAdapter$1).k8d = function (textFieldValue, offsetMapping, textLayoutResult, textFieldToRootTransform, innerTextFieldBounds, decorationBoxBounds) {
    _set_textFieldValue__2lf7qr(this, textFieldValue);
    _set_textLayoutResult__cabbrx(this, textLayoutResult);
    // Inline function 'kotlin.also' call
    var this_0 = new Matrix(_Matrix___init__impl__q3kp4w());
    var it = this_0.e6h_1;
    textFieldToRootTransform(new Matrix(it));
    var matrix = this_0.e6h_1;
    _set_textFieldRectInRoot__sb9nx(this, Matrix__map_impl_7meu7m(matrix, decorationBoxBounds));
    _set_textClippingRectInRoot__39a2il(this, Matrix__map_impl_7meu7m(matrix, innerTextFieldBounds));
    var cursorOffset = offsetMapping.o8c(_TextRange___get_max__impl__owm8m(textFieldValue.g8a_1));
    _set_focusedRectInRoot__r02n43(this, Matrix__map_impl_7meu7m(matrix, textLayoutResult.c7u(cursorOffset)));
    _set_unclippedTextOffsetInRoot__82ckt4(this, Offset__minus_impl_hoj2c0(_get_textClippingRectInRoot__pidiy9(this).s5d(), innerTextFieldBounds.s5d()));
  };
  protoOf(createLegacyPlatformTextInputServiceAdapter$1).xka = function () {
  };
  function TextEditingScope$1($commands) {
    this.alw_1 = $commands;
  }
  var androidx_compose_foundation_text_input_internal_SkikoPlatformTextInputMethodRequest$stable;
  function SkikoPlatformTextInputMethodRequest(value, state, imeOptions, onEditCommand, onImeAction, textLayoutResult, focusedRectInRoot, textFieldRectInRoot, textClippingRectInRoot, unclippedTextOffsetInRoot, editText) {
    this.blw_1 = value;
    this.clw_1 = state;
    this.dlw_1 = imeOptions;
    this.elw_1 = onEditCommand;
    this.flw_1 = onImeAction;
    this.glw_1 = textLayoutResult;
    this.hlw_1 = focusedRectInRoot;
    this.ilw_1 = textFieldRectInRoot;
    this.jlw_1 = textClippingRectInRoot;
    this.klw_1 = unclippedTextOffsetInRoot;
    this.llw_1 = editText;
  }
  protoOf(SkikoPlatformTextInputMethodRequest).u1 = function () {
    return this.blw_1;
  };
  protoOf(SkikoPlatformTextInputMethodRequest).bde = function () {
    return this.dlw_1;
  };
  protoOf(SkikoPlatformTextInputMethodRequest).cdo = function () {
    return this.elw_1;
  };
  protoOf(SkikoPlatformTextInputMethodRequest).xdd = function () {
    return this.glw_1;
  };
  protoOf(SkikoPlatformTextInputMethodRequest).hdm = function () {
    return this.hlw_1;
  };
  protoOf(SkikoPlatformTextInputMethodRequest).toString = function () {
    return 'SkikoPlatformTextInputMethodRequest(value=' + toString(this.blw_1) + ', state=' + toString(this.clw_1) + ', imeOptions=' + this.dlw_1.toString() + ', onEditCommand=' + toString(this.elw_1) + ', onImeAction=' + toString_0(this.flw_1) + ', textLayoutResult=' + toString(this.glw_1) + ', focusedRectInRoot=' + toString(this.hlw_1) + ', textFieldRectInRoot=' + toString(this.ilw_1) + ', textClippingRectInRoot=' + toString(this.jlw_1) + ', unclippedTextOffsetInRoot=' + toString(this.klw_1) + ', editText=' + toString(this.llw_1) + ')';
  };
  protoOf(SkikoPlatformTextInputMethodRequest).hashCode = function () {
    var result = hashCode(this.blw_1);
    result = imul(result, 31) + hashCode(this.clw_1) | 0;
    result = imul(result, 31) + this.dlw_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.elw_1) | 0;
    result = imul(result, 31) + (this.flw_1 == null ? 0 : hashCode(this.flw_1)) | 0;
    result = imul(result, 31) + hashCode(this.glw_1) | 0;
    result = imul(result, 31) + hashCode(this.hlw_1) | 0;
    result = imul(result, 31) + hashCode(this.ilw_1) | 0;
    result = imul(result, 31) + hashCode(this.jlw_1) | 0;
    result = imul(result, 31) + hashCode(this.klw_1) | 0;
    result = imul(result, 31) + hashCode(this.llw_1) | 0;
    return result;
  };
  protoOf(SkikoPlatformTextInputMethodRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SkikoPlatformTextInputMethodRequest))
      return false;
    if (!equals(this.blw_1, other.blw_1))
      return false;
    if (!equals(this.clw_1, other.clw_1))
      return false;
    if (!this.dlw_1.equals(other.dlw_1))
      return false;
    if (!equals(this.elw_1, other.elw_1))
      return false;
    if (!equals(this.flw_1, other.flw_1))
      return false;
    if (!equals(this.glw_1, other.glw_1))
      return false;
    if (!equals(this.hlw_1, other.hlw_1))
      return false;
    if (!equals(this.ilw_1, other.ilw_1))
      return false;
    if (!equals(this.jlw_1, other.jlw_1))
      return false;
    if (!equals(this.klw_1, other.klw_1))
      return false;
    if (!equals(this.llw_1, other.llw_1))
      return false;
    return true;
  };
  function af(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Kies alles'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Sny'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopieer'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Plak'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Outovul')]);
  }
  function am(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u1201\u1209\u1295\u121D \u121D\u1228\u1325'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u1241\u1228\u1325'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u130D\u120B\u1263\u132D'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u1208\u1325\u134D'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u122B\u1235-\u1219\u120B')]);
  }
  function ar(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0643\u0644'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0642\u0635'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0646\u0633\u062E'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0644\u0635\u0642'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0627\u0644\u0645\u0644\u0621 \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A')]);
  }
  function as(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0986\u099F\u09BE\u0987\u09AC\u09CB\u09F0 \u09AC\u09BE\u099B\u09A8\u09BF \u0995\u09F0\u0995'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0995\u09BE\u099F\u0995'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u09AA\u09CD\u09F0\u09A4\u09BF\u09B2\u09BF\u09AA\u09BF \u0995\u09F0\u0995'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u09AA\u09C7\u0987\u09B7\u09CD\u099F \u0995\u09F0\u0995'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u09B8\u09CD\u09AC\u09AF\u09BC\u0982\u09AA\u09C2\u09F0\u09CD\u09A4\u09BF')]);
  }
  function az(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Ham\u0131s\u0131n\u0131 se\xE7'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'K\u0259s'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopyala'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Yerl\u0259\u015Fdir'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Avtodoldurma')]);
  }
  function be(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0412\u044B\u043B\u0443\u0447\u044B\u0446\u044C \u0443\u0441\u0451'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0412\u044B\u0440\u0430\u0437\u0430\u0446\u044C'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u041A\u0430\u043F\u0456\u0440\u0430\u0432\u0430\u0446\u044C'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0423\u0441\u0442\u0430\u0432\u0456\u0446\u044C'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0410\u045E\u0442\u0430\u0437\u0430\u043F\u0430\u045E\u043D\u0435\u043D\u043D\u0435')]);
  }
  function bg(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0418\u0437\u0431\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0432\u0441\u0438\u0447\u043A\u043E'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0418\u0437\u0440\u044F\u0437\u0432\u0430\u043D\u0435'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u0435'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u041F\u043E\u0441\u0442\u0430\u0432\u044F\u043D\u0435'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043F\u043E\u043F\u044A\u043B\u0432\u0430\u043D\u0435')]);
  }
  function bn(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u09B8\u09AC\u0997\u09C1\u09B2\u09BF \u09AC\u09C7\u099B\u09C7 \u09A8\u09BF\u09A8'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0995\u09BE\u099F\u09C1\u09A8'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0995\u09AA\u09BF \u0995\u09B0\u09C1\u09A8'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u09AA\u09C7\u09B8\u09CD\u099F \u0995\u09B0\u09C1\u09A8'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0986\u09AA\u09A8\u09BE\u0986\u09AA\u09A8\u09BF \u09AA\u09C2\u09B0\u09A3 \u09B9\u09A4\u09C7 \u09A6\u09BF\u09A8')]);
  }
  function bs(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Odaberi sve'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Izre\u017Ei'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopiraj'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Zalijepi'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Automatsko popunjavanje')]);
  }
  function ca(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Selecciona-ho tot'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Retalla'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copia'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Enganxa'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Emplenament autom\xE0tic')]);
  }
  function cs(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Vybrat v\u0161e'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Vyjmout'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kop\xEDrovat'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Vlo\u017Eit'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Automatick\xE9 vypl\u0148ov\xE1n\xED')]);
  }
  function da(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Mark\xE9r alt'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Klip'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopi\xE9r'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Inds\xE6t'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autofyld')]);
  }
  function de(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Alles ausw\xE4hlen'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Ausschneiden'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopieren'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Einf\xFCgen'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autofill')]);
  }
  function el(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03CC\u03BB\u03C9\u03BD'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0391\u03C0\u03BF\u03BA\u03BF\u03C0\u03AE'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0395\u03C0\u03B9\u03BA\u03CC\u03BB\u03BB\u03B7\u03C3\u03B7'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0391\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B7 \u03C3\u03C5\u03BC\u03C0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7')]);
  }
  function en(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Select all'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Cut'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copy'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Paste'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autofill')]);
  }
  function enAU(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Select all'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Cut'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copy'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Paste'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Auto-fill')]);
  }
  function enCA(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Select all'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Cut'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copy'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Paste'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autofill')]);
  }
  function enGB(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Select all'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Cut'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copy'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Paste'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Auto-fill')]);
  }
  function enIN(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Select all'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Cut'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copy'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Paste'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Auto-fill')]);
  }
  function es(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Seleccionar todo'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Cortar'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copiar'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Pegar'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autocompletar')]);
  }
  function esUS(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Seleccionar todo'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Cortar'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copiar'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Pegar'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autocompletar')]);
  }
  function et(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Vali k\xF5ik'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'L\xF5ika'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopeeri'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Kleebi'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Automaatne t\xE4itmine')]);
  }
  function eu(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Hautatu dena'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Ebaki'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopiatu'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Itsatsi'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Betetze automatikoa')]);
  }
  function fa(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0627\u0646\u062A\u062E\u0627\u0628 \u0647\u0645\u0647'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0628\u0631\u0634'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u06A9\u067E\u06CC'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u062C\u0627\u06CC\u200C\u06AF\u0630\u0627\u0631\u06CC'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u062A\u06A9\u0645\u06CC\u0644 \u062E\u0648\u062F\u06A9\u0627\u0631')]);
  }
  function fi(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Valitse kaikki'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Leikkaa'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopioi'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Liit\xE4'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Automaattinen t\xE4ytt\xF6')]);
  }
  function fr(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Tout s\xE9lectionner'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Couper'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copier'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Coller'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Saisie automatique')]);
  }
  function frCA(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Tout s\xE9lectionner'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Couper'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copier'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Coller'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Remplissage automatique')]);
  }
  function gl(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Seleccionar todo'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Cortar'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copiar'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Pegar'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autocompletar')]);
  }
  function gu(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0AAC\u0AA7\u0ABE \u0AAA\u0AB8\u0A82\u0AA6 \u0A95\u0AB0\u0ACB'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0A95\u0ABE\u0AAA\u0ACB'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0A95\u0AC9\u0AAA\u0ABF \u0A95\u0AB0\u0ACB'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0AAA\u0AC7\u0AB8\u0ACD\u0A9F \u0A95\u0AB0\u0ACB'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0AB8\u0ACD\u0AB5\u0AA4\u0A83\u0AAD\u0AB0\u0AA3')]);
  }
  function hi(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u092A\u0942\u0930\u093E \u091F\u0947\u0915\u094D\u0938\u094D\u091F \u091A\u0941\u0928\u0947\u0902'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0915\u093E\u091F\u0947\u0902'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0915\u0949\u092A\u0940 \u0915\u0930\u0947\u0902'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u091A\u093F\u092A\u0915\u093E\u090F\u0902'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0911\u091F\u094B\u092E\u0948\u091F\u093F\u0915 \u092D\u0930\u0928\u093E')]);
  }
  function hr(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Odaberi sve'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Izre\u017Ei'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopiraj'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Zalijepi'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Automatsko popunjavanje')]);
  }
  function hu(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\xD6sszes kijel\xF6l\xE9se'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Kiv\xE1g\xE1s'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'M\xE1sol\xE1s'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Beilleszt\xE9s'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Automatikus kit\xF6lt\xE9s')]);
  }
  function hy(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0538\u0576\u057F\u0580\u0565\u056C \u0562\u0578\u056C\u0578\u0580\u0568'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u053F\u057F\u0580\u0565\u056C'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u054A\u0561\u057F\u0573\u0565\u0576\u0565\u056C'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u054F\u0565\u0572\u0561\u0564\u0580\u0565\u056C'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u053B\u0576\u0584\u0576\u0561\u056C\u0580\u0561\u0581\u0578\u0582\u0574')]);
  }
  function in_0(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Pilih semua'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Potong'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Salin'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Tempel'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Isi Otomatis')]);
  }
  function is(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Velja allt'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Klippa'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Afrita'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'L\xEDma'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Sj\xE1lfvirk \xFAtfylling')]);
  }
  function it(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Seleziona tutto'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Taglia'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copia'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Incolla'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Compilazione automatica')]);
  }
  function iw(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u05D1\u05D7\u05D9\u05E8\u05EA \u05D4\u05DB\u05D5\u05DC'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u05D7\u05D9\u05EA\u05D5\u05DA'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u05D4\u05E2\u05EA\u05E7\u05D4'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u05D4\u05D3\u05D1\u05E7\u05D4'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u05DE\u05D9\u05DC\u05D5\u05D9 \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9')]);
  }
  function ja(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u3059\u3079\u3066\u9078\u629E'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u5207\u308A\u53D6\u308A'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u30B3\u30D4\u30FC'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u8CBC\u308A\u4ED8\u3051'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u81EA\u52D5\u5165\u529B')]);
  }
  function ka(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u10D0\u10DB\u10DD\u10ED\u10E0\u10D0'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u10D9\u10DD\u10DE\u10D8\u10E0\u10D4\u10D1\u10D0'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u10E9\u10D0\u10E1\u10DB\u10D0'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10E8\u10D4\u10D5\u10E1\u10D4\u10D1\u10D0')]);
  }
  function kk(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0411\u0430\u0440\u043B\u044B\u0493\u044B\u043D \u0442\u0430\u04A3\u0434\u0430\u0443'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u049A\u0438\u044B\u043F \u0430\u043B\u0443'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u041A\u04E9\u0448\u0456\u0440\u0443'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u049A\u043E\u044E'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'A\u0432\u0442\u043E\u0442\u043E\u043B\u0442\u044B\u0440\u0443')]);
  }
  function km(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u1787\u17D2\u179A\u17BE\u179F\u179A\u17BE\u179F\u200B\u1791\u17B6\u17C6\u1784\u17A2\u179F\u17CB'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u1780\u17B6\u178F\u17CB'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u1785\u1798\u17D2\u179B\u1784'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u178A\u17B6\u1780\u17CB\u1785\u17BC\u179B'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u1794\u17C6\u1796\u17C1\u1789\u200B\u178A\u17C4\u1799\u179F\u17D2\u179C\u17D0\u1799\u200B\u1794\u17D2\u179A\u179C\u178F\u17D2\u178F\u17B7')]);
  }
  function kn(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0C8E\u0CB2\u0CCD\u0CB2\u0CB5\u0CA8\u0CCD\u0CA8\u0CC2 \u0C86\u0CAF\u0CCD\u0C95\u0CC6 \u0CAE\u0CBE\u0CA1\u0CBF'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0C95\u0CA4\u0CCD\u0CA4\u0CB0\u0CBF\u0CB8\u0CC1'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0CA8\u0C95\u0CB2\u0CBF\u0CB8\u0CBF'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0C85\u0C82\u0C9F\u0CBF\u0CB8\u0CBF'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0CB8\u0CCD\u0CB5\u0CAF\u0C82\u0CA4\u0CC1\u0C82\u0CAC\u0CC1\u0CB5\u0CBF\u0C95\u0CC6')]);
  }
  function ko(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\uBAA8\uB450 \uC120\uD0DD'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\uC798\uB77C\uB0B4\uAE30'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\uBCF5\uC0AC'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\uBD99\uC5EC\uB123\uAE30'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\uC790\uB3D9\uC644\uC131')]);
  }
  function ky(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0411\u0430\u0430\u0440\u044B\u043D \u0442\u0430\u043D\u0434\u043E\u043E'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u041A\u0435\u0441\u04AF\u04AF'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u041A\u04E9\u0447\u04AF\u0440\u04AF\u04AF'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0427\u0430\u043F\u0442\u043E\u043E'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0410\u0432\u0442\u043E\u0442\u043E\u043B\u0442\u0443\u0440\u0443\u0443')]);
  }
  function lo(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0EC0\u0EA5\u0EB7\u0EAD\u0E81\u0E97\u0EB1\u0E87\u0EDD\u0EBB\u0E94'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0E95\u0EB1\u0E94'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0EAA\u0EB3\u0EC0\u0E99\u0EBB\u0EB2'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0EA7\u0EB2\u0E87'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0E95\u0EB7\u0EC8\u0EA1\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAD\u0EB1\u0E94\u0E95\u0EB0\u0EC2\u0E99\u0EA1\u0EB1\u0E94')]);
  }
  function lt(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Pasirinkti visus'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'I\u0161kirpti'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopijuoti'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u012Eklijuoti'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Automatinis pildymas')]);
  }
  function lv(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Atlas\u012Bt visu'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Izgriezt'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kop\u0113t'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Iel\u012Bm\u0113t'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autom\u0101tisk\u0101 aizpilde')]);
  }
  function mk(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0418\u0437\u0431\u0435\u0440\u0438 \u0433\u0438 \u0441\u0438\u0442\u0435'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0418\u0441\u0435\u0447\u0438'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u041A\u043E\u043F\u0438\u0440\u0430\u0458'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0417\u0430\u043B\u0435\u043F\u0438'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0441\u043A\u043E \u043F\u043E\u043F\u043E\u043B\u043D\u0443\u0432\u0430\u045A\u0435')]);
  }
  function ml(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0D0E\u0D32\u0D4D\u0D32\u0D3E\u0D02 \u0D24\u0D3F\u0D30\u0D1E\u0D4D\u0D1E\u0D46\u0D1F\u0D41\u0D15\u0D4D\u0D15\u0D41\u0D15'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0D2E\u0D41\u0D31\u0D3F\u0D15\u0D4D\u0D15\u0D41\u0D15'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0D2A\u0D15\u0D30\u0D4D\u200D\u0D24\u0D4D\u0D24\u0D41\u0D15'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0D12\u0D1F\u0D4D\u0D1F\u0D3F\u0D15\u0D4D\u0D15\u0D41\u0D15'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0D38\u0D4D\u0D35\u0D2F\u0D2E\u0D47\u0D35 \u0D2A\u0D42\u0D30\u0D3F\u0D2A\u0D4D\u0D2A\u0D3F\u0D15\u0D4D\u0D15\u0D7D')]);
  }
  function mn(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0411\u04AF\u0433\u0434\u0438\u0439\u0433 \u0441\u043E\u043D\u0433\u043E\u0445'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0422\u0430\u0441\u043B\u0430\u0445'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0425\u0443\u0443\u043B\u0430\u0445'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0411\u0443\u0443\u043B\u0433\u0430\u0445'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0410\u0432\u0442\u043E\u043C\u0430\u0442aa\u0440 \u0431\u04E9\u0433\u043B\u04E9\u0445 \u0445\u044D\u0441\u044D\u0433')]);
  }
  function mr(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0938\u0930\u094D\u0935 \u0928\u093F\u0935\u0921\u093E'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0915\u091F \u0915\u0930\u093E'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0915\u0949\u092A\u0940 \u0915\u0930\u093E'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u092A\u0947\u0938\u094D\u091F \u0915\u0930\u093E'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0938\u094D\u0935\u092F\u0902-\u092D\u0930\u0923')]);
  }
  function ms(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Pilih semua'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Potong'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Salin'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Tampal'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autolengkap')]);
  }
  function my(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u1021\u102C\u1038\u101C\u102F\u1036\u1038\u101B\u103D\u1031\u1038\u101B\u1014\u103A'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u1016\u103C\u1010\u103A\u101B\u1014\u103A'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u1000\u1030\u1038\u101B\u1014\u103A'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u1000\u1030\u1038\u1011\u100A\u1037\u103A\u101B\u1014\u103A'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u1021\u1031\u102C\u103A\u1010\u102D\u102F\u1016\u103C\u100A\u1037\u103A')]);
  }
  function nb(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Merk alt'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Klipp ut'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopi\xE9r'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Lim inn'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autofyll')]);
  }
  function ne(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0938\u092C\u0948\u0932\u093E\u0908 \u091A\u092F\u0928 \u0917\u0930\u094D\u0928\u0941\u0939\u094B\u0938\u094D'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0915\u091F\u094D \u0917\u0930\u094D\u0928\u0941\u0939\u094B\u0938\u094D'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0915\u092A\u0940 \u0917\u0930\u094D\u0928\u0941\u0939\u094B\u0938\u094D'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u091F\u093E\u0901\u0938\u094D\u0928\u0941\u0939\u094B\u0938\u094D'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0905\u091F\u094B\u092B\u093F\u0932')]);
  }
  function nl(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Alles selecteren'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Knippen'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopi\xEBren'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Plakken'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Automatisch invullen')]);
  }
  function or(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0B38\u0B2C\u0B41 \u0B1A\u0B5F\u0B28 \u0B15\u0B30\u0B28\u0B4D\u0B24\u0B41'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0B15\u0B1F\u0B4D\u200C'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0B15\u0B2A\u0B3F \u0B15\u0B30\u0B28\u0B4D\u0B24\u0B41'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0B2A\u0B47\u0B37\u0B4D\u0B1F \u0B15\u0B30\u0B28\u0B4D\u0B24\u0B41'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0B05\u0B1F\u0B4B\u0B2B\u0B3F\u0B32\u0B4D\u200C')]);
  }
  function pa(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0A38\u0A2D \u0A1A\u0A41\u0A23\u0A4B'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0A15\u0A71\u0A1F\u0A4B'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0A15\u0A3E\u0A2A\u0A40 \u0A15\u0A30\u0A4B'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0A2A\u0A47\u0A38\u0A1F \u0A15\u0A30\u0A4B'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0A06\u0A1F\u0A4B\u0A2B\u0A3F\u0A32')]);
  }
  function pl(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Zaznacz wszystko'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Wytnij'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopiuj'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Wklej'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autouzupe\u0142nianie')]);
  }
  function pt(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Selecionar tudo'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Recortar'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copiar'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Colar'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Preenchimento autom\xE1tico')]);
  }
  function ptBR(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Selecionar tudo'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Recortar'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copiar'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Colar'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Preenchimento autom\xE1tico')]);
  }
  function ptPT(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Selecionar tudo'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Cortar'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copiar'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Colar'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Preenchimento autom\xE1tico')]);
  }
  function ro(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Selecteaz\u0103 tot'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Decupeaz\u0103'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Copiaz\u0103'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Insereaz\u0103'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Completare automat\u0103')]);
  }
  function ru(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0412\u044B\u0440\u0435\u0437\u0430\u0442\u044C'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0410\u0432\u0442\u043E\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435')]);
  }
  function si(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0DC3\u0DD2\u0DBA\u0DBD\u0DCA\u0DBD \u0DAD\u0DDD\u0DBB\u0DB1\u0DCA\u0DB1'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0D9A\u0DB4\u0DB1\u0DCA\u0DB1'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0DB4\u0DD2\u0DA7\u0DB4\u0DAD\u0DCA \u0D9A\u0DBB\u0DB1\u0DCA\u0DB1'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0D85\u0DBD\u0DC0\u0DB1\u0DCA\u0DB1'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0DC3\u0DCA\u0DC0\u0DBA\u0D82\u0D9A\u0DCA\u200D\u0DBB\u0DD2\u0DBA \u0DB4\u0DD2\u0DBB\u0DC0\u0DD4\u0DB8')]);
  }
  function sk(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Vybra\u0165 v\u0161etko'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Vystrihn\xFA\u0165'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Skop\xEDrova\u0165'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Prilepi\u0165'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Automatick\xE9 dop\u013A\u0148anie')]);
  }
  function sl(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Izberi vse'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Izre\u017Ei'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopiraj'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Prilepi'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Samodejno izpolnjevanje')]);
  }
  function sq(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'P\xEBrzgjidhi t\xEB gjitha'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Pri'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopjo'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Ngjit'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Plot\xEBsim automatik')]);
  }
  function sr(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0418\u0437\u0430\u0431\u0435\u0440\u0438 \u0441\u0432\u0435'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0418\u0441\u0435\u0446\u0438'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u041A\u043E\u043F\u0438\u0440\u0430\u0458'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u041D\u0430\u043B\u0435\u043F\u0438'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0410\u0443\u0442\u043E\u043C\u0430\u0442\u0441\u043A\u043E \u043F\u043E\u043F\u0443\u045A\u0430\u0432\u0430\u045A\u0435')]);
  }
  function sv(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Markera allt'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Klipp ut'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopiera'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Klistra in'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Autofyll')]);
  }
  function sw(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Chagua zote'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Kata'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Nakili'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Bandika'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Kujaza kiotomatiki')]);
  }
  function ta(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0B85\u0BA9\u0BC8\u0BA4\u0BCD\u0BA4\u0BC8\u0BAF\u0BC1\u0BAE\u0BCD \u0BA4\u0BC7\u0BB0\u0BCD\u0BA8\u0BCD\u0BA4\u0BC6\u0B9F\u0BC1'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0BB5\u0BC6\u0B9F\u0BCD\u0B9F\u0BC1'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0BA8\u0B95\u0BB2\u0BC6\u0B9F\u0BC1'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0B92\u0B9F\u0BCD\u0B9F\u0BC1'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0BA4\u0BA9\u0BCD\u0BA9\u0BBF\u0BB0\u0BAA\u0BCD\u0BAA\u0BBF')]);
  }
  function te(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0C05\u0C28\u0C4D\u0C28\u0C3F\u0C02\u0C1F\u0C3F\u0C28\u0C40 \u0C0E\u0C02\u0C1A\u0C41\u0C15\u0C4B\u0C02\u0C21\u0C3F'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0C15\u0C24\u0C4D\u0C24\u0C3F\u0C30\u0C3F\u0C02\u0C1A\u0C02\u0C21\u0C3F'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0C15\u0C3E\u0C2A\u0C40 \u0C1A\u0C47\u0C2F\u0C02\u0C21\u0C3F'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0C2A\u0C47\u0C38\u0C4D\u0C1F\u0C4D \u0C1A\u0C47\u0C2F\u0C02\u0C21\u0C3F'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0C06\u0C1F\u0C4B\u0C2B\u0C3F\u0C32\u0C4D')]);
  }
  function th(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0E15\u0E31\u0E14'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0E27\u0E32\u0E07'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0E1B\u0E49\u0E2D\u0E19\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34')]);
  }
  function tl(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Piliin lahat'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'I-cut'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopyahin'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'I-paste'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'I-autofill')]);
  }
  function tr(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'T\xFCm\xFCn\xFC se\xE7'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Kes'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopyala'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Yap\u0131\u015Ft\u0131r'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Otomatik Doldur')]);
  }
  function translationFor(localeTag) {
    switch (localeTag) {
      case '':
        return en(Translations_instance);
      case 'en_AU':
        return enAU(Translations_instance);
      case 'en_CA':
        return enCA(Translations_instance);
      case 'en_GB':
        return enGB(Translations_instance);
      case 'en_IN':
        return enIN(Translations_instance);
      case 'af':
        return af(Translations_instance);
      case 'am':
        return am(Translations_instance);
      case 'ar':
        return ar(Translations_instance);
      case 'as':
        return as(Translations_instance);
      case 'az':
        return az(Translations_instance);
      case 'be':
        return be(Translations_instance);
      case 'bg':
        return bg(Translations_instance);
      case 'bn':
        return bn(Translations_instance);
      case 'bs':
        return bs(Translations_instance);
      case 'ca':
        return ca(Translations_instance);
      case 'cs':
        return cs(Translations_instance);
      case 'da':
        return da(Translations_instance);
      case 'de':
        return de(Translations_instance);
      case 'el':
        return el(Translations_instance);
      case 'es':
        return es(Translations_instance);
      case 'es_US':
        return esUS(Translations_instance);
      case 'et':
        return et(Translations_instance);
      case 'eu':
        return eu(Translations_instance);
      case 'fa':
        return fa(Translations_instance);
      case 'fi':
        return fi(Translations_instance);
      case 'fr':
        return fr(Translations_instance);
      case 'fr_CA':
        return frCA(Translations_instance);
      case 'gl':
        return gl(Translations_instance);
      case 'gu':
        return gu(Translations_instance);
      case 'hi':
        return hi(Translations_instance);
      case 'hr':
        return hr(Translations_instance);
      case 'hu':
        return hu(Translations_instance);
      case 'hy':
        return hy(Translations_instance);
      case 'in':
        return in_0(Translations_instance);
      case 'id':
        return in_0(Translations_instance);
      case 'is':
        return is(Translations_instance);
      case 'it':
        return it(Translations_instance);
      case 'iw':
        return iw(Translations_instance);
      case 'he':
        return iw(Translations_instance);
      case 'ja':
        return ja(Translations_instance);
      case 'ka':
        return ka(Translations_instance);
      case 'kk':
        return kk(Translations_instance);
      case 'km':
        return km(Translations_instance);
      case 'kn':
        return kn(Translations_instance);
      case 'ko':
        return ko(Translations_instance);
      case 'ky':
        return ky(Translations_instance);
      case 'lo':
        return lo(Translations_instance);
      case 'lt':
        return lt(Translations_instance);
      case 'lv':
        return lv(Translations_instance);
      case 'mk':
        return mk(Translations_instance);
      case 'ml':
        return ml(Translations_instance);
      case 'mn':
        return mn(Translations_instance);
      case 'mr':
        return mr(Translations_instance);
      case 'ms':
        return ms(Translations_instance);
      case 'my':
        return my(Translations_instance);
      case 'nb':
        return nb(Translations_instance);
      case 'ne':
        return ne(Translations_instance);
      case 'nl':
        return nl(Translations_instance);
      case 'or':
        return or(Translations_instance);
      case 'pa':
        return pa(Translations_instance);
      case 'pl':
        return pl(Translations_instance);
      case 'pt':
        return pt(Translations_instance);
      case 'pt_BR':
        return ptBR(Translations_instance);
      case 'pt_PT':
        return ptPT(Translations_instance);
      case 'ro':
        return ro(Translations_instance);
      case 'ru':
        return ru(Translations_instance);
      case 'si':
        return si(Translations_instance);
      case 'sk':
        return sk(Translations_instance);
      case 'sl':
        return sl(Translations_instance);
      case 'sq':
        return sq(Translations_instance);
      case 'sr':
        return sr(Translations_instance);
      case 'sv':
        return sv(Translations_instance);
      case 'sw':
        return sw(Translations_instance);
      case 'ta':
        return ta(Translations_instance);
      case 'te':
        return te(Translations_instance);
      case 'th':
        return th(Translations_instance);
      case 'tl':
        return tl(Translations_instance);
      case 'tr':
        return tr(Translations_instance);
      case 'uk':
        return uk(Translations_instance);
      case 'ur':
        return ur(Translations_instance);
      case 'uz':
        return uz(Translations_instance);
      case 'vi':
        return vi(Translations_instance);
      case 'zh_CN':
        return zhCN(Translations_instance);
      case 'zh_HK':
        return zhHK(Translations_instance);
      case 'zh_TW':
        return zhTW(Translations_instance);
      case 'zu':
        return zu(Translations_instance);
      default:
        return null;
    }
  }
  function uk(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0435'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u0412\u0438\u0440\u0456\u0437\u0430\u0442\u0438'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0410\u0432\u0442\u043E\u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u043D\u044F')]);
  }
  function ur(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u0633\u0628\u06BE\u06CC \u06A9\u0648 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u06A9\u0627\u0679\u06CC\u06BA'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u06A9\u0627\u067E\u06CC \u06A9\u0631\u06CC\u06BA'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u067E\u06CC\u0633\u0679 \u06A9\u0631\u06CC\u06BA'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u0622\u0679\u0648 \u0641\u0644')]);
  }
  function uz(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Hammasini belgilash'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Kesib olish'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Nusxa olish'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Joylash'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Avtomatik to\u2018ldirish')]);
  }
  function vi(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Ch\u1ECDn t\u1EA5t c\u1EA3'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'C\u1EAFt'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Sao ch\xE9p'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'D\xE1n'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'T\u1EF1 \u0111\u1ED9ng \u0111i\u1EC1n')]);
  }
  function zhCN(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u5168\u9009'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u526A\u5207'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u590D\u5236'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u7C98\u8D34'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u81EA\u52A8\u586B\u5145')]);
  }
  function zhHK(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u5168\u90E8\u9078\u53D6'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u526A\u4E0B'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u8907\u88FD'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u8CBC\u4E0A'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u81EA\u52D5\u586B\u5165')]);
  }
  function zhTW(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), '\u5168\u90E8\u9078\u53D6'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), '\u526A\u4E0B'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), '\u8907\u88FD'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), '\u8CBC\u4E0A'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), '\u81EA\u52D5\u586B\u5165')]);
  }
  function zu(_this__u8e3s4) {
    return mapOf([to(new ContextMenuStrings(Companion_getInstance_91().ek3_1), 'Khetha konke'), to(new ContextMenuStrings(Companion_getInstance_91().bk3_1), 'Nqamula'), to(new ContextMenuStrings(Companion_getInstance_91().ck3_1), 'Kopisha'), to(new ContextMenuStrings(Companion_getInstance_91().dk3_1), 'Namathisela'), to(new ContextMenuStrings(Companion_getInstance_91().fk3_1), 'Ukugcwalisa ngokuzenzakalela')]);
  }
  var androidx_compose_foundation_text_modifiers_SkikoSelectionModifierElement$stable;
  var androidx_compose_foundation_text_modifiers_SkikoSelectionModifierNode$stable;
  function makeSkikoSelectionModifier(_this__u8e3s4, selectableId, layoutCoordinates) {
    return new SkikoSelectionModifierElement(_this__u8e3s4, selectableId, layoutCoordinates);
  }
  function SkikoSelectionModifierElement(selectionRegistrar, selectableId, layoutCoordinates) {
    ModifierNodeElement.call(this);
    this.nlw_1 = selectionRegistrar;
    this.olw_1 = selectableId;
    this.plw_1 = layoutCoordinates;
  }
  protoOf(SkikoSelectionModifierElement).r3d = function () {
    return new SkikoSelectionModifierNode(this.nlw_1, this.olw_1, this.plw_1);
  };
  protoOf(SkikoSelectionModifierElement).qlw = function (node) {
    node.nlx(this.nlw_1, this.olw_1, this.plw_1);
  };
  protoOf(SkikoSelectionModifierElement).d8y = function (node) {
    return this.qlw(node instanceof SkikoSelectionModifierNode ? node : THROW_CCE());
  };
  protoOf(SkikoSelectionModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SkikoSelectionModifierElement))
      return false;
    if (!equals(this.nlw_1, other.nlw_1))
      return false;
    if (!equalsLong(this.olw_1, other.olw_1))
      return false;
    if (!equals(this.plw_1, other.plw_1))
      return false;
    return true;
  };
  protoOf(SkikoSelectionModifierElement).hashCode = function () {
    var result = this.olw_1.hashCode();
    result = imul(31, result) + hashCode(this.nlw_1) | 0;
    result = imul(31, result) + hashCode(this.plw_1) | 0;
    return result;
  };
  function SkikoSelectionModifierNode$bringIntoView$slambda$lambda($offset) {
    return function () {
      return Rect_0($offset, Companion_getInstance_0().j5e_1);
    };
  }
  function createMouseSelectionObserver($this) {
    var tmp = $this.hlx_1;
    var tmp_0 = $this.ilx_1;
    var tmp_1 = $this.jlx_1;
    return skikoMouseSelectionObserver(tmp, tmp_0, tmp_1, SkikoSelectionModifierNode$bringIntoView$ref($this));
  }
  function bringIntoView_0($this, offset) {
    var tmp = $this.a8w();
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    launch(tmp, VOID, tmp_0, SkikoSelectionModifierNode$bringIntoView$slambda_0($this, offset, null));
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_9(function_0) {
    this.olx_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_9).ka7 = function (_this__u8e3s4, $completion) {
    return this.olx_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_9).q3 = function () {
    return this.olx_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_9).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_9).hashCode = function () {
    return hashCode(this.q3());
  };
  function SkikoSelectionModifierNode$pointerInputNode$slambda(this$0, resultContinuation) {
    this.xlx_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SkikoSelectionModifierNode$pointerInputNode$slambda).vc6 = function ($this$SuspendingPointerInputModifierNode, $completion) {
    var tmp = this.wc6($this$SuspendingPointerInputModifierNode, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SkikoSelectionModifierNode$pointerInputNode$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SkikoSelectionModifierNode$pointerInputNode$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = awaitSelectionGestures(this.ylx_1, this.xlx_1.mlx_1, this.xlx_1.llx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SkikoSelectionModifierNode$pointerInputNode$slambda).wc6 = function ($this$SuspendingPointerInputModifierNode, completion) {
    var i = new SkikoSelectionModifierNode$pointerInputNode$slambda(this.xlx_1, completion);
    i.ylx_1 = $this$SuspendingPointerInputModifierNode;
    return i;
  };
  function SkikoSelectionModifierNode$pointerInputNode$slambda_0(this$0, resultContinuation) {
    var i = new SkikoSelectionModifierNode$pointerInputNode$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$SuspendingPointerInputModifierNode, $completion) {
      return i.vc6($this$SuspendingPointerInputModifierNode, $completion);
    }, 1);
  }
  function SkikoSelectionModifierNode$longPressDragObserver$1(this$0) {
    this.cly_1 = this$0;
    this.zlx_1 = Companion_getInstance_6().g5d_1;
    this.aly_1 = Companion_getInstance_6().g5d_1;
    this.bly_1 = Companion_getInstance_87().eki_1;
  }
  protoOf(SkikoSelectionModifierNode$longPressDragObserver$1).cki = function (point) {
  };
  protoOf(SkikoSelectionModifierNode$longPressDragObserver$1).dki = function () {
  };
  protoOf(SkikoSelectionModifierNode$longPressDragObserver$1).jki = function (startPoint, selectionAdjustment) {
    this.bly_1 = selectionAdjustment;
    var tmp0_safe_receiver = this.cly_1.jlx_1();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (!tmp0_safe_receiver.y91())
        return Unit_instance;
      this.cly_1.hlx_1.dly(tmp0_safe_receiver, startPoint, this.bly_1, true);
      this.zlx_1 = startPoint;
    }
    if (!hasSelection(this.cly_1.hlx_1, this.cly_1.ilx_1))
      return Unit_instance;
    this.aly_1 = Companion_getInstance_6().g5d_1;
  };
  protoOf(SkikoSelectionModifierNode$longPressDragObserver$1).lki = function (delta) {
    var tmp0_safe_receiver = this.cly_1.jlx_1();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (!tmp0_safe_receiver.y91())
        return Unit_instance;
      if (!hasSelection(this.cly_1.hlx_1, this.cly_1.ilx_1))
        return Unit_instance;
      this.aly_1 = Offset__plus_impl_c78cg0(this.aly_1, delta);
      var newPosition = Offset__plus_impl_c78cg0(this.zlx_1, this.aly_1);
      var tmp0_$this = this.cly_1.hlx_1;
      var tmp1_previousPosition = this.zlx_1;
      var tmp2_adjustment = this.bly_1;
      var consumed = tmp0_$this.ely(tmp0_safe_receiver, newPosition, tmp1_previousPosition, false, tmp2_adjustment, true);
      if (consumed) {
        this.zlx_1 = newPosition;
        this.aly_1 = Companion_getInstance_6().g5d_1;
      }
    }
  };
  protoOf(SkikoSelectionModifierNode$longPressDragObserver$1).kki = function () {
    if (hasSelection(this.cly_1.hlx_1, this.cly_1.ilx_1)) {
      this.cly_1.hlx_1.fly();
    }
  };
  protoOf(SkikoSelectionModifierNode$longPressDragObserver$1).sb0 = function () {
    if (hasSelection(this.cly_1.hlx_1, this.cly_1.ilx_1)) {
      this.cly_1.hlx_1.fly();
    }
  };
  function SkikoSelectionModifierNode$bringIntoView$ref(p0) {
    return constructCallableReference(function (p0_0) {
      var tmp0 = p0;
      bringIntoView_0(tmp0, p0_0.e5d_1);
      return Unit_instance;
    }, 1, 0, 382, 'bringIntoView', [p0]);
  }
  function SkikoSelectionModifierNode$bringIntoView$slambda(this$0, $offset, resultContinuation) {
    this.oly_1 = this$0;
    this.ply_1 = $offset;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SkikoSelectionModifierNode$bringIntoView$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SkikoSelectionModifierNode$bringIntoView$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SkikoSelectionModifierNode$bringIntoView$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = bringIntoView(this.oly_1, SkikoSelectionModifierNode$bringIntoView$slambda$lambda(this.ply_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SkikoSelectionModifierNode$bringIntoView$slambda).q24 = function ($this$launch, completion) {
    var i = new SkikoSelectionModifierNode$bringIntoView$slambda(this.oly_1, this.ply_1, completion);
    i.qly_1 = $this$launch;
    return i;
  };
  function SkikoSelectionModifierNode$bringIntoView$slambda_0(this$0, $offset, resultContinuation) {
    var i = new SkikoSelectionModifierNode$bringIntoView$slambda(this$0, $offset, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function SkikoSelectionModifierNode(selectionRegistrar, selectableId, layoutCoordinates) {
    DelegatingNode.call(this);
    this.hlx_1 = selectionRegistrar;
    this.ilx_1 = selectableId;
    this.jlx_1 = layoutCoordinates;
    var tmp = this;
    var tmp_0 = SkikoSelectionModifierNode$pointerInputNode$slambda_0(this, null);
    tmp.klx_1 = this.tb1(SuspendingPointerInputModifierNode(new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_9(tmp_0)));
    var tmp_1 = this;
    tmp_1.llx_1 = new SkikoSelectionModifierNode$longPressDragObserver$1(this);
    this.mlx_1 = createMouseSelectionObserver(this);
  }
  protoOf(SkikoSelectionModifierNode).nlx = function (selectionRegistrar, selectableId, layoutCoordinates) {
    this.hlx_1 = selectionRegistrar;
    this.ilx_1 = selectableId;
    this.jlx_1 = layoutCoordinates;
    this.mlx_1 = createMouseSelectionObserver(this);
    this.klx_1.fab();
  };
  function skikoMouseSelectionObserver(_this__u8e3s4, selectableId, layoutCoordinates, bringIntoView) {
    return new skikoMouseSelectionObserver$1(layoutCoordinates, _this__u8e3s4, bringIntoView, selectableId);
  }
  function skikoMouseSelectionObserver$1($layoutCoordinates, $this_skikoMouseSelectionObserver, $bringIntoView, $selectableId) {
    this.sly_1 = $layoutCoordinates;
    this.tly_1 = $this_skikoMouseSelectionObserver;
    this.uly_1 = $bringIntoView;
    this.vly_1 = $selectableId;
    this.rly_1 = Companion_getInstance_6().g5d_1;
  }
  protoOf(skikoMouseSelectionObserver$1).flj = function (downPosition) {
    var tmp0_safe_receiver = this.sly_1();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (!tmp0_safe_receiver.y91())
        return false;
      var consumed = this.tly_1.ely(tmp0_safe_receiver, downPosition, this.rly_1, false, Companion_getInstance_87().eki_1, false);
      if (consumed) {
        this.rly_1 = downPosition;
      }
      this.uly_1(new Offset(downPosition));
      return hasSelection(this.tly_1, this.vly_1);
    }
    return false;
  };
  protoOf(skikoMouseSelectionObserver$1).qli = function (dragPosition) {
    var tmp0_safe_receiver = this.sly_1();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (!tmp0_safe_receiver.y91())
        return false;
      if (!hasSelection(this.tly_1, this.vly_1))
        return false;
      var consumed = this.tly_1.ely(tmp0_safe_receiver, dragPosition, this.rly_1, false, Companion_getInstance_87().eki_1, false);
      if (consumed) {
        this.rly_1 = dragPosition;
      }
      this.uly_1(new Offset(dragPosition));
    }
    return true;
  };
  protoOf(skikoMouseSelectionObserver$1).elj = function (downPosition, adjustment, clickCount) {
    var tmp0_safe_receiver = this.sly_1();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (!tmp0_safe_receiver.y91())
        return false;
      this.tly_1.dly(tmp0_safe_receiver, downPosition, adjustment, false);
      this.rly_1 = downPosition;
      this.uly_1(new Offset(downPosition));
      return hasSelection(this.tly_1, this.vly_1);
    }
    return false;
  };
  protoOf(skikoMouseSelectionObserver$1).rli = function (dragPosition, adjustment) {
    var tmp0_safe_receiver = this.sly_1();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (!tmp0_safe_receiver.y91())
        return false;
      if (!hasSelection(this.tly_1, this.vly_1))
        return false;
      var tmp0_previousPosition = this.rly_1;
      var consumed = this.tly_1.ely(tmp0_safe_receiver, dragPosition, tmp0_previousPosition, false, adjustment, false);
      if (consumed) {
        this.rly_1 = dragPosition;
      }
      this.uly_1(new Offset(dragPosition));
    }
    return true;
  };
  protoOf(skikoMouseSelectionObserver$1).glj = function () {
    this.tly_1.fly();
  };
  function rememberPlatformSelectionBehaviors(selectedTextType, localeList, $composer, $changed) {
    var $composer_0 = $composer;
    return null;
  }
  function isMouseOrTouchPad(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.ca0_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAll' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (!(item.qa0_1 === Companion_getInstance_23().na2_1)) {
            tmp$ret$0 = false;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  function get_PADDING() {
    _init_properties_SelectionHandles_skiko_kt__bk50qu();
    return PADDING;
  }
  var PADDING;
  function get_RADIUS() {
    _init_properties_SelectionHandles_skiko_kt__bk50qu();
    return RADIUS;
  }
  var RADIUS;
  function get_THICKNESS() {
    _init_properties_SelectionHandles_skiko_kt__bk50qu();
    return THICKNESS;
  }
  var THICKNESS;
  function SkikoSelectionHandle(offsetProvider, isStartHandle, direction, handlesCrossed, minTouchTargetSize, lineHeight, modifier, $composer, $changed) {
    _init_properties_SelectionHandles_skiko_kt__bk50qu();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1575917816);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(offsetProvider) : $composer_0.q31(offsetProvider)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isStartHandle) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.m31(direction.a1_1) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(handlesCrossed) ? 2048 : 1024);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.n31(lineHeight) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 590995) === 590994), $dirty & 1)) {
      var isLeft = isLeftSelectionHandle(isStartHandle, direction, handlesCrossed);
      var handleReferencePoint = isLeft ? Companion_getInstance_12().r8t_1 : Companion_getInstance_12().l8t_1;
      var tmp = new SkikoSelectionHandle$1(offsetProvider, isLeft, lineHeight);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(484598449, true, SkikoSelectionHandle$lambda(modifier, offsetProvider, isStartHandle, isLeft, lineHeight), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp$ret$0 = tmp_0;
      HandlePopup(tmp, handleReferencePoint, tmp$ret$0, $composer_0, 384);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(SkikoSelectionHandle$lambda_0(offsetProvider, isStartHandle, direction, handlesCrossed, minTouchTargetSize, lineHeight, modifier, $changed));
    }
  }
  function HandlePopup(positionProvider, handleReferencePoint, content, $composer, $changed) {
    _init_properties_SelectionHandles_skiko_kt__bk50qu();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(23401851);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(positionProvider) : $composer_0.q31(positionProvider)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(handleReferencePoint) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 112) === 32 | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.k31(positionProvider))));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = new HandlePositionProvider(handleReferencePoint, positionProvider);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var popupPositionProvider = tmp;
      Popup(popupPositionProvider, null, PopupProperties_init_$Create$(VOID, VOID, VOID, false), content, $composer_0, 384 | 7168 & $dirty << 3, 2);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(HandlePopup$lambda(positionProvider, handleReferencePoint, content, $changed));
    }
  }
  function SelectionHandleIcon(modifier, iconVisible, lineHeight, isLeft, $composer, $changed) {
    _init_properties_SelectionHandles_skiko_kt__bk50qu();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1724324913);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(iconVisible) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.n31(lineHeight) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(isLeft) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      var tmp0 = get_LocalDensity();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var density = $composer_1.u31(tmp0);
      var tmp0_0 = get_LocalTextSelectionColors();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_2 = $composer_0;
      var handleColor = $composer_2.u31(tmp0_0).pjz_1;
      // Inline function 'kotlin.with' call
      var lineHeightDp = density.e5f(lineHeight);
      var tmp0_1 = get_PADDING();
      // Inline function 'androidx.compose.ui.unit.Dp.plus' call
      var other = get_RADIUS();
      // Inline function 'androidx.compose.ui.unit.Dp.times' call
      var this_0 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(tmp0_1) + _Dp___get_value__impl__geb1vb(other));
      var tmp = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(this_0) * 2);
      // Inline function 'androidx.compose.ui.unit.Dp.times' call
      var this_1 = get_RADIUS();
      var tmp0_2 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(this_1) * 2);
      // Inline function 'androidx.compose.ui.unit.Dp.plus' call
      var other_0 = get_PADDING();
      // Inline function 'androidx.compose.ui.unit.Dp.plus' call
      var this_2 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(tmp0_2) + _Dp___get_value__impl__geb1vb(other_0));
      var tmp$ret$8 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(this_2) + _Dp___get_value__impl__geb1vb(lineHeightDp));
      Spacer(drawSelectionHandle(size(modifier, tmp, tmp$ret$8), iconVisible, lineHeight, isLeft, handleColor, density), $composer_0, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(SelectionHandleIcon$lambda(modifier, iconVisible, lineHeight, isLeft, $changed));
    }
  }
  function drawSelectionHandle(_this__u8e3s4, iconVisible, lineHeight, isLeft, handleColor, density) {
    _init_properties_SelectionHandles_skiko_kt__bk50qu();
    return drawWithCache(_this__u8e3s4, drawSelectionHandle$lambda(density, iconVisible, handleColor, isLeft, lineHeight));
  }
  function SkikoSelectionHandle$1($offsetProvider, $isLeft, $lineHeight) {
    this.wly_1 = $offsetProvider;
    this.xly_1 = $isLeft;
    this.yly_1 = $lineHeight;
  }
  protoOf(SkikoSelectionHandle$1).tk8 = function () {
    var offset = this.wly_1.tk8();
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.isSpecified' call
    var this_0 = offset;
    if (!equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
      tmp = !this.xly_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_0 = offset;
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = -this.yly_1;
      var v1 = fromInt(toRawBits(0.0));
      var v2 = fromInt(toRawBits(val2));
      var tmp$ret$2 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var tmp$ret$1 = _Offset___init__impl__c168vi(tmp$ret$2);
      offset = Offset__plus_impl_c78cg0(tmp_0, tmp$ret$1);
    }
    return offset;
  };
  function SkikoSelectionHandle$lambda$lambda($offsetProvider, $isStartHandle, $isLeft) {
    return function ($this$semantics) {
      var position = $offsetProvider.tk8();
      var tmp = get_SelectionHandleInfoKey();
      var tmp_0 = $isStartHandle ? Handle_SelectionStart_getInstance() : Handle_SelectionEnd_getInstance();
      var tmp_1 = $isLeft ? SelectionHandleAnchor_Left_getInstance() : SelectionHandleAnchor_Right_getInstance();
      // Inline function 'androidx.compose.ui.geometry.isSpecified' call
      var tmp$ret$0 = !equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(position), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344));
      $this$semantics.mbr(tmp, new SelectionHandleInfo(tmp_0, position, tmp_1, tmp$ret$0));
      return Unit_instance;
    };
  }
  function SkikoSelectionHandle$lambda$lambda_0($offsetProvider) {
    return function () {
      // Inline function 'androidx.compose.ui.geometry.isSpecified' call
      var this_0 = $offsetProvider.tk8();
      return !equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344));
    };
  }
  function SkikoSelectionHandle$lambda($modifier, $offsetProvider, $isStartHandle, $isLeft, $lineHeight) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.q31($offsetProvider) | $composer_0.l31($isStartHandle)) | $composer_0.l31($isLeft));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance_11().f30_1) {
          var value = SkikoSelectionHandle$lambda$lambda($offsetProvider, $isStartHandle, $isLeft);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$0 = tmp_0;
        var tmp_1 = semantics($modifier, VOID, tmp$ret$0);
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31($offsetProvider);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_2;
        if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
          var value_0 = SkikoSelectionHandle$lambda$lambda_0($offsetProvider);
          $composer_0.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_0;
        }
        var tmp$ret$4 = tmp_2;
        SelectionHandleIcon(tmp_1, tmp$ret$4, $lineHeight, $isLeft, $composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SkikoSelectionHandle$lambda_0($offsetProvider, $isStartHandle, $direction, $handlesCrossed, $minTouchTargetSize, $lineHeight, $modifier, $$changed) {
    return function ($composer, $force) {
      SkikoSelectionHandle($offsetProvider, $isStartHandle, $direction, $handlesCrossed, $minTouchTargetSize, $lineHeight, $modifier, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function HandlePopup$lambda($positionProvider, $handleReferencePoint, $content, $$changed) {
    return function ($composer, $force) {
      HandlePopup($positionProvider, $handleReferencePoint, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function SelectionHandleIcon$lambda($modifier, $iconVisible, $lineHeight, $isLeft, $$changed) {
    return function ($composer, $force) {
      SelectionHandleIcon($modifier, $iconVisible, $lineHeight, $isLeft, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function drawSelectionHandle$lambda$lambda($iconVisible, $handleColor, $paddingPx, $radiusPx, $thicknessPx, $isLeft, $lineHeight) {
    return function ($this$onDrawWithContent) {
      $this$onDrawWithContent.z91();
      var tmp;
      if (!$iconVisible()) {
        return Unit_instance;
      }
      var tmp0 = $paddingPx + $radiusPx - $thicknessPx / 2;
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = $isLeft ? $paddingPx + $radiusPx : 0.0;
      var v1 = fromInt(toRawBits(tmp0));
      var v2 = fromInt(toRawBits(val2));
      var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var tmp_0 = _Offset___init__impl__c168vi(tmp$ret$1);
      var tmp0_0 = $thicknessPx;
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2_0 = $lineHeight + $radiusPx;
      var v1_0 = fromInt(toRawBits(tmp0_0));
      var v2_0 = fromInt(toRawBits(val2_0));
      var tmp$ret$3 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
      var tmp$ret$2 = _Size___init__impl__aywn0g(tmp$ret$3);
      $this$onDrawWithContent.b6q($handleColor, tmp_0, tmp$ret$2);
      $this$onDrawWithContent.h6q($handleColor, $radiusPx, Offset__copy$default_impl_bmwjg8($this$onDrawWithContent.m6q(), VOID, $isLeft ? $paddingPx + $radiusPx : $lineHeight + $radiusPx));
      return Unit_instance;
    };
  }
  function drawSelectionHandle$lambda($density, $iconVisible, $handleColor, $isLeft, $lineHeight) {
    return function ($this$drawWithCache) {
      // Inline function 'kotlin.with' call
      var paddingPx = $density.v5e(get_PADDING());
      // Inline function 'kotlin.with' call
      var radiusPx = $density.v5e(get_RADIUS());
      // Inline function 'kotlin.with' call
      var thicknessPx = $density.v5e(get_THICKNESS());
      return $this$drawWithCache.f92(drawSelectionHandle$lambda$lambda($iconVisible, $handleColor, paddingPx, radiusPx, thicknessPx, $isLeft, $lineHeight));
    };
  }
  var properties_initialized_SelectionHandles_skiko_kt_p4d7vc;
  function _init_properties_SelectionHandles_skiko_kt__bk50qu() {
    if (!properties_initialized_SelectionHandles_skiko_kt_p4d7vc) {
      properties_initialized_SelectionHandles_skiko_kt_p4d7vc = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      PADDING = _Dp___init__impl__ms3zkb(5);
      // Inline function 'androidx.compose.ui.unit.dp' call
      RADIUS = _Dp___init__impl__ms3zkb(6);
      // Inline function 'androidx.compose.ui.unit.dp' call
      THICKNESS = _Dp___init__impl__ms3zkb(2);
    }
  }
  var androidx_compose_foundation_v2_ScrollableScrollbarAdapter$stable;
  var androidx_compose_foundation_v2_LazyLineContentAdapter_VisibleLine$stable;
  var androidx_compose_foundation_v2_LazyLineContentAdapter$stable;
  var androidx_compose_foundation_v2_LazyListScrollbarAdapter$stable;
  var androidx_compose_foundation_v2_LazyGridScrollbarAdapter$stable;
  var androidx_compose_foundation_v2_TextFieldScrollbarAdapter$stable;
  var androidx_compose_foundation_v2_SliderAdapter$stable;
  function get_TapIndicationDelay() {
    return TapIndicationDelay;
  }
  var TapIndicationDelay;
  function defaultOverscrollFactory(_this__u8e3s4) {
    return null;
  }
  function isRequestFocusOnClickEnabled() {
    return true;
  }
  function platformScrollConfig(_this__u8e3s4) {
    return JsConfig_instance;
  }
  function JsConfig() {
  }
  protoOf(JsConfig).ch1 = function (_this__u8e3s4, event, bounds) {
    var tmp = get_totalScrollDelta(event);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$0 = _Dp___init__impl__ms3zkb(1);
    return Offset__times_impl_jz1mli(tmp, -_this__u8e3s4.v5e(tmp$ret$0));
  };
  var JsConfig_instance;
  function JsConfig_getInstance() {
    return JsConfig_instance;
  }
  function get_totalScrollDelta(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.ca0_1;
    // Inline function 'androidx.compose.ui.util.fastFold' call
    var accumulator = new Offset(Companion_getInstance_6().g5d_1);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = tmp0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = tmp0.l1(index);
        var acc = accumulator.e5d_1;
        accumulator = new Offset(Offset__plus_impl_c78cg0(acc, item.ra0_1));
      }
       while (inductionVariable <= last);
    return accumulator.e5d_1;
  }
  function rememberPlatformDefaultFlingBehavior($composer, $changed) {
    var $composer_0 = $composer;
    var flingSpec = rememberSplineBasedDecay($composer_0, 0);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.k31(flingSpec);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_11().f30_1) {
      var value = new DefaultFlingBehavior(flingSpec);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function platformScrollableDefaultFlingBehavior() {
    return new DefaultFlingBehavior(generateDecayAnimationSpec(new SplineBasedFloatDecayAnimationSpec(get_UnityDensity())));
  }
  function defaultLazyListBeyondBoundsItemCount($composer, $changed) {
    var $composer_0 = $composer;
    return 0;
  }
  function getDefaultLazyLayoutKey(index) {
    return new DefaultLazyKey(index);
  }
  function DefaultLazyKey(index) {
    this.zly_1 = index;
  }
  protoOf(DefaultLazyKey).toString = function () {
    return 'DefaultLazyKey(index=' + this.zly_1 + ')';
  };
  protoOf(DefaultLazyKey).hashCode = function () {
    return this.zly_1;
  };
  protoOf(DefaultLazyKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DefaultLazyKey))
      return false;
    if (!(this.zly_1 === other.zly_1))
      return false;
    return true;
  };
  function ContextMenuArea_0(manager, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(399547873);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(manager) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-310830538, true, ContextMenuArea$lambda_2(manager, content), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      WebTextToolbarArea(null, tmp$ret$0, $composer_0, 48, 1);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ContextMenuArea$lambda_3(manager, content, $changed));
    }
  }
  function ContextMenuArea$lambda_2($manager, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        CommonContextMenuArea($manager, $content, $composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ContextMenuArea$lambda_3($manager, $content, $$changed) {
    return function ($composer, $force) {
      ContextMenuArea_0($manager, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function textFieldDraw(_this__u8e3s4, state, value, offsetMapping) {
    return defaultTextFieldDraw(_this__u8e3s4, state, value, offsetMapping);
  }
  function textFieldCursor(_this__u8e3s4, state, value, offsetMapping, cursorBrush, showCursor) {
    return cursor(_this__u8e3s4, state, value, offsetMapping, cursorBrush, showCursor);
  }
  function cancelsTextSelection(_this__u8e3s4) {
    return false;
  }
  function showCharacterPalette() {
  }
  function get_platformDefaultKeyMapping() {
    _init_properties_KeyMapping_web_kt__x052ob();
    return platformDefaultKeyMapping;
  }
  var platformDefaultKeyMapping;
  function createPlatformDefaultKeyMapping(platform) {
    _init_properties_KeyMapping_web_kt__x052ob();
    var keyMapping;
    switch (platform.a1_1) {
      case 3:
        keyMapping = createMacOsDefaultKeyMapping();
        break;
      case 2:
        keyMapping = createWindowsDefaultKeyMapping();
        break;
      default:
        keyMapping = DefaultSkikoKeyMapping_instance;
        break;
    }
    return new createPlatformDefaultKeyMapping$1(keyMapping);
  }
  function createPlatformDefaultKeyMapping$1($keyMapping) {
    this.alz_1 = $keyMapping;
  }
  protoOf(createPlatformDefaultKeyMapping$1).hke = function (event) {
    var command = this.alz_1.hke(event);
    switch (command == null ? -1 : command.a1_1) {
      case 17:
      case 19:
      case 18:
        return null;
      default:
        return command;
    }
  };
  var properties_initialized_KeyMapping_web_kt_fblptj;
  function _init_properties_KeyMapping_web_kt__x052ob() {
    if (!properties_initialized_KeyMapping_web_kt_fblptj) {
      properties_initialized_KeyMapping_web_kt_fblptj = true;
      platformDefaultKeyMapping = createPlatformDefaultKeyMapping(get_hostOs());
    }
  }
  function CursorHandle(offsetProvider, modifier, minTouchTargetSize, $composer, $changed, $default) {
    var minTouchTargetSize_0 = {_v: new DpSize(minTouchTargetSize)};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-2057689830);
    var $dirty = $changed;
    if ($composer_0.r31(!(($dirty & 1) === 0), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 4) === 0)) {
          minTouchTargetSize_0._v = new DpSize(Companion_getInstance_56().i5f_1);
          $dirty = $dirty & -897;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
      }
      $composer_0.r30();
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CursorHandle$lambda(offsetProvider, modifier, minTouchTargetSize_0, $changed, $default));
    }
  }
  function CursorHandle$lambda($offsetProvider, $modifier, $minTouchTargetSize, $$changed, $$default) {
    return function ($composer, $force) {
      CursorHandle($offsetProvider, $modifier, $minTouchTargetSize._v.r5f_1, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function get_DefaultCursorThickness() {
    _init_properties_TextFieldCursor_web_kt__kcels9();
    return DefaultCursorThickness;
  }
  var DefaultCursorThickness;
  var properties_initialized_TextFieldCursor_web_kt_ahml8n;
  function _init_properties_TextFieldCursor_web_kt__kcels9() {
    if (!properties_initialized_TextFieldCursor_web_kt_ahml8n) {
      properties_initialized_TextFieldCursor_web_kt_ahml8n = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      DefaultCursorThickness = _Dp___init__impl__ms3zkb(1);
    }
  }
  function get_isTypedEvent(_this__u8e3s4) {
    var tmp;
    if (get_type(_this__u8e3s4) === Companion_getInstance_9().e9e_1 && !get_isMetaPressed(_this__u8e3s4) && !get_isCtrlPressed(_this__u8e3s4)) {
      var tmp0_safe_receiver = get_domEventOrNull(_this__u8e3s4);
      tmp = (tmp0_safe_receiver == null ? null : isPrintable(tmp0_safe_receiver)) === true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isPrintable(_this__u8e3s4) {
    var tmp0_safe_receiver = firstOrNull_1(_this__u8e3s4.key);
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = toString_2(tmp0_safe_receiver);
    }
    return tmp === _this__u8e3s4.key;
  }
  function textFieldPointer(_this__u8e3s4, manager, enabled, interactionSource, state, focusRequester, readOnly, offsetMapping, $composer, $changed) {
    var $composer_0 = $composer;
    return defaultTextFieldPointer(_this__u8e3s4, manager, enabled, interactionSource, state, focusRequester, readOnly, offsetMapping);
  }
  function rememberTextFieldOverscrollEffect($composer, $changed) {
    var $composer_0 = $composer;
    return null;
  }
  function textFieldScroll(_this__u8e3s4, scrollerPosition, textFieldValue, visualTransformation, overscrollEffect, textLayoutResultProvider) {
    return defaultTextFieldScroll(_this__u8e3s4, scrollerPosition, textFieldValue, visualTransformation, overscrollEffect, textLayoutResultProvider);
  }
  var isInTouchMode;
  function timeNowMillis() {
    return numberToLong(window.performance.now());
  }
  function get_DefaultPopupToolbarProperties() {
    _init_properties_WebContextMenuToolbarUi_web_kt__kxvk3t();
    return DefaultPopupToolbarProperties;
  }
  var DefaultPopupToolbarProperties;
  var androidx_compose_foundation_text_WebContextMenuToolbarSpec$stable;
  function WebContextMenuToolbarSpec() {
    WebContextMenuToolbarSpec_instance = this;
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp.blz_1 = _Dp___init__impl__ms3zkb(56);
    var tmp_0 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_0.clz_1 = _Dp___init__impl__ms3zkb(6);
    this.dlz_1 = RoundedCornerShape_2(50);
    this.elz_1 = Companion_getInstance_12().u8t_1;
    this.flz_1 = Companion_getInstance_18().d7v_1;
    var tmp_1 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_1.glz_1 = _Dp___init__impl__ms3zkb(8);
    var tmp_2 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_2.hlz_1 = _Dp___init__impl__ms3zkb(8);
    var tmp_3 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_3.ilz_1 = _Dp___init__impl__ms3zkb(24);
    this.jlz_1 = get_sp(16);
    this.klz_1 = Companion_getInstance_19().c7z_1;
    this.llz_1 = get_sp(20);
    this.mlz_1 = get_sp_0(0.1);
  }
  protoOf(WebContextMenuToolbarSpec).cge = function (color) {
    var tmp0_textAlign = this.flz_1;
    var tmp1_fontSize = this.jlz_1;
    var tmp2_fontWeight = this.klz_1;
    var tmp3_lineHeight = this.llz_1;
    var tmp4_letterSpacing = this.mlz_1;
    return TextStyle_init_$Create$(color, tmp1_fontSize, tmp2_fontWeight, VOID, VOID, VOID, VOID, tmp4_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_textAlign, VOID, tmp3_lineHeight);
  };
  var WebContextMenuToolbarSpec_instance;
  function WebContextMenuToolbarSpec_getInstance() {
    if (WebContextMenuToolbarSpec_instance == null)
      new WebContextMenuToolbarSpec();
    return WebContextMenuToolbarSpec_instance;
  }
  function WebContextMenuToolbarPopup(popupPositionProvider, onDismiss, modifier, contextMenuBuilderBlock, $composer, $changed, $default) {
    _init_properties_WebContextMenuToolbarUi_web_kt__kxvk3t();
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1747563413);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(popupPositionProvider) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(contextMenuBuilderBlock) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      WebContextMenuToolbarPopup_0(popupPositionProvider, onDismiss, modifier_0._v, computeContextMenuColors($composer_0, 0), contextMenuBuilderBlock, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty | 57344 & $dirty << 3, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(WebContextMenuToolbarPopup$lambda(popupPositionProvider, onDismiss, modifier_0, contextMenuBuilderBlock, $changed, $default));
    }
  }
  function WebContextMenuToolbarPopup_0(popupPositionProvider, onDismiss, modifier, colors, contextMenuBuilderBlock, $composer, $changed, $default) {
    _init_properties_WebContextMenuToolbarUi_web_kt__kxvk3t();
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1409967737);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(popupPositionProvider) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(contextMenuBuilderBlock) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      var tmp = get_DefaultPopupToolbarProperties();
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-253510491, true, WebContextMenuToolbarPopup$lambda_0(modifier_0, colors, contextMenuBuilderBlock), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp$ret$0 = tmp_0;
      Popup(popupPositionProvider, onDismiss, tmp, tmp$ret$0, $composer_0, 3456 | 14 & $dirty | 112 & $dirty, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(WebContextMenuToolbarPopup$lambda_1(popupPositionProvider, onDismiss, modifier_0, colors, contextMenuBuilderBlock, $changed, $default));
    }
  }
  function WebContextMenuRowBuilder(modifier, colors, contextMenuBuilderBlock, $composer, $changed, $default) {
    _init_properties_WebContextMenuToolbarUi_web_kt__kxvk3t();
    var modifier_0 = {_v: modifier};
    var colors_0 = {_v: colors};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1143533795);
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(colors_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(contextMenuBuilderBlock) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      if (!(($default & 2) === 0)) {
        colors_0._v = get_DefaultContextMenuColors();
      }
      var tmp = colors_0._v;
      var tmp_0 = modifier_0._v;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-573514296, true, WebContextMenuRowBuilder$lambda(contextMenuBuilderBlock, colors_0), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_1;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = ComposableLambda$invoke$ref_7(dispatchReceiver);
        $composer_1.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp$ret$0 = tmp_1;
      WebContextMenuRow(tmp, tmp_0, tmp$ret$0, $composer_0, 384 | 14 & $dirty >> 3 | 112 & $dirty << 3, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(WebContextMenuRowBuilder$lambda_0(modifier_0, colors_0, contextMenuBuilderBlock, $changed, $default));
    }
  }
  function WebContextMenuRow(colors, modifier, content, $composer, $changed, $default) {
    _init_properties_WebContextMenuToolbarUi_web_kt__kxvk3t();
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(582169251);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      var tmp = background(shadow(padding(modifier_0._v, WebContextMenuToolbarSpec_getInstance().hlz_1), WebContextMenuToolbarSpec_getInstance().clz_1, WebContextMenuToolbarSpec_getInstance().dlz_1), colors.zgc_1);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var $changed_0 = 7168 & $dirty << 3;
      var modifier_1 = padding(horizontalScroll(tmp, rememberScrollState(0, $composer_0, 0, 1)), WebContextMenuToolbarSpec_getInstance().hlz_1);
      var horizontalArrangement = null;
      var verticalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance_0;
      if (!((6 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((6 & 4) === 0))
        verticalAlignment = Companion_getInstance_12().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & $changed_0 >> 3 | 112 & $changed_0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0 = Companion_getInstance_14().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      var $composer_4 = $composer_3;
      content(RowScopeInstance_instance, $composer_4, 6 | 112 & $changed_0 >> 6);
      $composer_3.e31();
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(WebContextMenuRow$lambda(colors, modifier_0, content, $changed, $default));
    }
  }
  function ComposableSingletons$WebContextMenuToolbarUi_webKt$lambda$_1900159888$lambda_822qk0(modifier, label, enabled, colors, leadingIcon, onClick, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(leadingIcon) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      WebContextMenuToolbarItem(label, enabled, colors, modifier, leadingIcon, onClick, $composer_0, 14 & $dirty >> 3 | 112 & $dirty >> 3 | 896 & $dirty >> 3 | 7168 & $dirty << 9 | 57344 & $dirty | 458752 & $dirty, 0);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$WebContextMenuToolbarUi_webKt() {
    ComposableSingletons$WebContextMenuToolbarUi_webKt_instance = this;
    var tmp = this;
    tmp.nlz_1 = ComposableLambda$invoke$ref_0(composableLambdaInstance(-1900159888, false, ComposableSingletons$WebContextMenuToolbarUi_webKt$lambda$_1900159888$lambda_822qk0));
  }
  var ComposableSingletons$WebContextMenuToolbarUi_webKt_instance;
  function ComposableSingletons$WebContextMenuToolbarUi_webKt_getInstance() {
    if (ComposableSingletons$WebContextMenuToolbarUi_webKt_instance == null)
      new ComposableSingletons$WebContextMenuToolbarUi_webKt();
    return ComposableSingletons$WebContextMenuToolbarUi_webKt_instance;
  }
  function WebContextMenuToolbarItem(label, enabled, colors, modifier, leadingIcon, onClick, $composer, $changed, $default) {
    _init_properties_WebContextMenuToolbarUi_web_kt__kxvk3t();
    var modifier_0 = {_v: modifier};
    var leadingIcon_0 = {_v: leadingIcon};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1539461334);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(colors) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(leadingIcon_0._v) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74899) === 74898), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      if (!(($default & 16) === 0)) {
        leadingIcon_0._v = null;
      }
      var tmp0_verticalAlignment = WebContextMenuToolbarSpec_getInstance().elz_1;
      var tmp1_horizontalArrangement = Arrangement_getInstance().mdq(WebContextMenuToolbarSpec_getInstance().glz_1);
      var tmp = modifier_0._v;
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 112) === 32 | ($dirty & 458752) === 131072);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = WebContextMenuToolbarItem$lambda(enabled, onClick);
        tmp0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp$ret$0 = tmp_0;
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_1 = padding(sizeIn(clickable(tmp, enabled, label, VOID, VOID, tmp$ret$0), VOID, WebContextMenuToolbarSpec_getInstance().blz_1, VOID, WebContextMenuToolbarSpec_getInstance().blz_1), WebContextMenuToolbarSpec_getInstance().glz_1);
      var horizontalArrangement = tmp1_horizontalArrangement;
      var verticalAlignment = tmp0_verticalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier_1 = Companion_instance_0;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_12().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0_0 = Companion_getInstance_14().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      var tmp0_safe_receiver = leadingIcon_0._v;
      if (tmp0_safe_receiver == null) {
        $composer_5.m30(1230285403);
        $composer_5.n30();
      } else {
        $composer_5.m30(1230285404);
        // Inline function 'kotlin.let' call
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = requiredSizeIn(Companion_instance_0, WebContextMenuToolbarSpec_getInstance().ilz_1, VOID, WebContextMenuToolbarSpec_getInstance().ilz_1, WebContextMenuToolbarSpec_getInstance().ilz_1);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance_0;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_12().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance_0;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_4);
        var tmp0_1 = Companion_getInstance_14().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_2 = $composer_8.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_1);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_14().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_14().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_14().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_14().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_14().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        tmp0_safe_receiver(new Color(enabled ? colors.bgd_1 : colors.dgd_1), $composer_10, 0);
        $composer_8.e31();
        $composer_5.n30();
      }
      var tmp_3 = WebContextMenuToolbarSpec_getInstance().cge(enabled ? colors.agd_1 : colors.cgd_1);
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      BasicText(label, null, tmp_3, null, tmp_4, false, 1, 0, null, null, $composer_5, 1572864 | 14 & $dirty, 954);
      $composer_3.e31();
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver_0 = $composer_0.t30();
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      tmp0_safe_receiver_0.p3c(WebContextMenuToolbarItem$lambda_0(label, enabled, colors, modifier_0, leadingIcon_0, onClick, $changed, $default));
    }
  }
  function WebContextMenuToolbarPopup$lambda($popupPositionProvider, $onDismiss, $modifier, $contextMenuBuilderBlock, $$changed, $$default) {
    return function ($composer, $force) {
      WebContextMenuToolbarPopup($popupPositionProvider, $onDismiss, $modifier._v, $contextMenuBuilderBlock, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function WebContextMenuToolbarPopup$lambda_0($modifier, $colors, $contextMenuBuilderBlock) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        WebContextMenuRowBuilder($modifier._v, $colors, $contextMenuBuilderBlock, $composer_0, 0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function WebContextMenuToolbarPopup$lambda_1($popupPositionProvider, $onDismiss, $modifier, $colors, $contextMenuBuilderBlock, $$changed, $$default) {
    return function ($composer, $force) {
      WebContextMenuToolbarPopup_0($popupPositionProvider, $onDismiss, $modifier._v, $colors, $contextMenuBuilderBlock, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function WebContextMenuRowBuilder$lambda($contextMenuBuilderBlock, $colors) {
    return function ($this$WebContextMenuRow, $composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance_11().f30_1) {
          var value = new ContextMenuScope(ComposableSingletons$WebContextMenuToolbarUi_webKt_getInstance().nlz_1);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var scope = tmp_0;
        // Inline function 'kotlin.with' call
        scope.hgd();
        $contextMenuBuilderBlock(scope);
        scope.ggd($colors._v, $composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function WebContextMenuRowBuilder$lambda_0($modifier, $colors, $contextMenuBuilderBlock, $$changed, $$default) {
    return function ($composer, $force) {
      WebContextMenuRowBuilder($modifier._v, $colors._v, $contextMenuBuilderBlock, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function WebContextMenuRow$lambda($colors, $modifier, $content, $$changed, $$default) {
    return function ($composer, $force) {
      WebContextMenuRow($colors, $modifier._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function WebContextMenuToolbarItem$lambda($enabled, $onClick) {
    return function () {
      if ($enabled)
        $onClick();
      return Unit_instance;
    };
  }
  function WebContextMenuToolbarItem$lambda_0($label, $enabled, $colors, $modifier, $leadingIcon, $onClick, $$changed, $$default) {
    return function ($composer, $force) {
      WebContextMenuToolbarItem($label, $enabled, $colors, $modifier._v, $leadingIcon._v, $onClick, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var properties_initialized_WebContextMenuToolbarUi_web_kt_jboq5x;
  function _init_properties_WebContextMenuToolbarUi_web_kt__kxvk3t() {
    if (!properties_initialized_WebContextMenuToolbarUi_web_kt_jboq5x) {
      properties_initialized_WebContextMenuToolbarUi_web_kt_jboq5x = true;
      DefaultPopupToolbarProperties = PopupProperties_init_$Create$(false);
      androidx_compose_foundation_text_WebContextMenuToolbarSpec$stable = 0;
    }
  }
  function WebTextToolbarArea(modifier, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(2074765461);
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = modifier_0._v;
      var contentAlignment = null;
      var propagateMinConstraints = true;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier_1 = Companion_instance_0;
      if (!((2 & 2) === 0))
        contentAlignment = Companion_getInstance_12().k8t_1;
      if (!((2 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0 = Companion_getInstance_14().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      content($composer_5, 14 & $dirty >> 3);
      WebTextToolbarPopup($composer_5, 0);
      $composer_3.e31();
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(WebTextToolbarArea$lambda(modifier_0, content, $changed, $default));
    }
  }
  function WebTextToolbarPopup($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1742248538);
    if ($composer_0.r31(!($changed === 0), $changed & 1)) {
      var tmp0 = get_LocalTextToolbar();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var tmp = $composer_1.u31(tmp0);
      var tmp0_elvis_lhs = tmp instanceof WebTextToolbar ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp0_safe_receiver = $composer_0.t30();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.p3c(WebTextToolbarPopup$lambda($changed));
        }
        return Unit_instance;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var textToolbar = tmp_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = mutableStateOf(Companion_getInstance_57().e5g_1);
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var layoutParentBoundsInWindow$delegate = tmp_1;
      var tmp_2 = Companion_instance_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_3;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = WebTextToolbarPopup$lambda_2(layoutParentBoundsInWindow$delegate);
        this_1.j31(value_0);
        tmp_3 = value_0;
      } else {
        tmp_3 = it_0;
      }
      var tmp$ret$5 = tmp_3;
      var tmp0_0 = onGloballyPositioned(tmp_2, tmp$ret$5);
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_2.i31();
      var tmp_4;
      if (false || it_1 === Companion_getInstance_11().f30_1) {
        var tmp_5 = WebTextToolbarPopup$lambda_3;
        var value_1 = new sam$androidx_compose_ui_layout_MeasurePolicy$0_2(tmp_5);
        this_2.j31(value_1);
        tmp_4 = value_1;
      } else {
        tmp_4 = it_1;
      }
      var tmp2 = tmp_4;
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier = tmp0_0;
      var $composer_2 = $composer_0;
      if (!((0 & 2) === 0))
        modifier = Companion_instance_0;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier);
      var tmp0_1 = Companion_getInstance_14().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_6 = $composer_3.g30();
      if (!isInterface(tmp_6, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_1);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp2, Companion_getInstance_14().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
      var $composer_4 = $composer_3;
      $composer_3.e31();
      var tmp1_elvis_lhs = textToolbar.lde();
      var tmp_7;
      if (tmp1_elvis_lhs == null) {
        var tmp1_safe_receiver = $composer_0.t30();
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.p3c(WebTextToolbarPopup$lambda_4($changed));
        }
        return Unit_instance;
      } else {
        tmp_7 = tmp1_elvis_lhs;
      }
      var menu = tmp_7;
      var tmp0_2 = get_LocalDensity();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_5 = $composer_0;
      // Inline function 'kotlin.with' call
      var $this$with = $composer_5.u31(tmp0_2);
      var tmp0_3 = WebContextMenuToolbarSpec_getInstance().blz_1;
      // Inline function 'androidx.compose.ui.unit.dp' call
      // Inline function 'androidx.compose.ui.unit.Dp.plus' call
      var other = _Dp___init__impl__ms3zkb(16);
      var tmp$ret$21 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(tmp0_3) + _Dp___get_value__impl__geb1vb(other));
      var toolbarOffset = $this$with.w5e(tmp$ret$21);
      var tmp0_4 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.k31(menu);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_4.i31();
      var tmp_8;
      if (invalid || it_2 === Companion_getInstance_11().f30_1) {
        var tmp0_5 = menu.ede_1.k5d_1;
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var val2 = menu.ede_1.l5d_1 - toolbarOffset;
        var v1 = fromInt(toRawBits(tmp0_5));
        var v2 = fromInt(toRawBits(val2));
        var tmp$ret$27 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        var tmp$ret$26 = _Offset___init__impl__c168vi(tmp$ret$27);
        var value_2 = ContextMenuPopupPositionProvider_init_$Create$(IntOffset__minus_impl_4m69hb(round(tmp$ret$26), WebTextToolbarPopup$lambda_0(layoutParentBoundsInWindow$delegate).k5g()));
        tmp0_4.j31(value_2);
        tmp_8 = value_2;
      } else {
        tmp_8 = it_2;
      }
      var popupPositionProvider = tmp_8;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_3 = this_3.i31();
      var tmp_9;
      if (false || it_3 === Companion_getInstance_11().f30_1) {
        var value_3 = WebTextToolbarPopup$lambda_5;
        this_3.j31(value_3);
        tmp_9 = value_3;
      } else {
        tmp_9 = it_3;
      }
      var tmp_10 = tmp_9;
      var tmp0_6 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_0.q31(menu);
      // Inline function 'kotlin.let' call
      var it_4 = tmp0_6.i31();
      var tmp_11;
      if (invalid_0 || it_4 === Companion_getInstance_11().f30_1) {
        var value_4 = WebTextToolbarPopup$lambda_6(menu);
        tmp0_6.j31(value_4);
        tmp_11 = value_4;
      } else {
        tmp_11 = it_4;
      }
      var tmp$ret$32 = tmp_11;
      WebContextMenuToolbarPopup(popupPositionProvider, tmp_10, null, tmp$ret$32, $composer_0, 48, 4);
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(WebTextToolbarPopup$lambda_7($changed));
    }
  }
  function sam$androidx_compose_ui_layout_MeasurePolicy$0_2(function_0) {
    this.olz_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_2).mak = function (_this__u8e3s4, measurables, constraints) {
    return this.olz_1(_this__u8e3s4, measurables, new Constraints(constraints));
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_2).q3 = function () {
    return this.olz_1;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function WebTextToolbarArea$lambda($modifier, $content, $$changed, $$default) {
    return function ($composer, $force) {
      WebTextToolbarArea($modifier._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function WebTextToolbarPopup$lambda($$changed) {
    return function ($composer, $force) {
      WebTextToolbarPopup($composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function WebTextToolbarPopup$lambda_0($layoutParentBoundsInWindow$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('layoutParentBoundsInWindow', KMutableProperty0, true);
    return $layoutParentBoundsInWindow$delegate.u1();
  }
  function WebTextToolbarPopup$lambda_1($layoutParentBoundsInWindow$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('layoutParentBoundsInWindow', KMutableProperty0, true);
    $layoutParentBoundsInWindow$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function WebTextToolbarPopup$lambda_2($layoutParentBoundsInWindow$delegate) {
    return function (childCoordinates) {
      var tmp0_safe_receiver = childCoordinates.zah();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var layoutPosition = round(positionInWindow(tmp0_safe_receiver));
        var layoutSize = tmp0_safe_receiver.q95();
        WebTextToolbarPopup$lambda_1($layoutParentBoundsInWindow$delegate, IntRect(layoutPosition, layoutSize));
      }
      return Unit_instance;
    };
  }
  function WebTextToolbarPopup$lambda_3($this$Layout, _unused_var__etf5q3, constraints) {
    var tmp = _Constraints___get_minWidth__impl__hi9lfi(constraints.m5e_1);
    var tmp_0 = _Constraints___get_minHeight__impl__ev4bgx(constraints.m5e_1);
    return $this$Layout.n8y(tmp, tmp_0, VOID, WebTextToolbarPopup$lambda$lambda);
  }
  function WebTextToolbarPopup$lambda$lambda($this$layout) {
    return Unit_instance;
  }
  function WebTextToolbarPopup$lambda_4($$changed) {
    return function ($composer, $force) {
      WebTextToolbarPopup($composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function WebTextToolbarPopup$lambda_5() {
    return Unit_instance;
  }
  function WebTextToolbarPopup$lambda$lambda_0($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(919247201);
    var tmp0 = getString(Companion_getInstance_91().ck3_1, $composer_0, 6);
    $composer_0.n30();
    return tmp0;
  }
  function WebTextToolbarPopup$lambda$lambda_1($menu) {
    return function () {
      var tmp0_safe_receiver = $menu.fde_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver();
      return Unit_instance;
    };
  }
  function WebTextToolbarPopup$lambda$lambda_2($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(730743562);
    var tmp0 = getString(Companion_getInstance_91().dk3_1, $composer_0, 6);
    $composer_0.n30();
    return tmp0;
  }
  function WebTextToolbarPopup$lambda$lambda_3($menu) {
    return function () {
      var tmp0_safe_receiver = $menu.gde_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver();
      return Unit_instance;
    };
  }
  function WebTextToolbarPopup$lambda$lambda_4($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(1033630953);
    var tmp0 = getString(Companion_getInstance_91().bk3_1, $composer_0, 6);
    $composer_0.n30();
    return tmp0;
  }
  function WebTextToolbarPopup$lambda$lambda_5($menu) {
    return function () {
      var tmp0_safe_receiver = $menu.hde_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver();
      return Unit_instance;
    };
  }
  function WebTextToolbarPopup$lambda$lambda_6($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(1336518344);
    var tmp0 = getString(Companion_getInstance_91().ek3_1, $composer_0, 6);
    $composer_0.n30();
    return tmp0;
  }
  function WebTextToolbarPopup$lambda$lambda_7($menu) {
    return function () {
      var tmp0_safe_receiver = $menu.ide_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver();
      return Unit_instance;
    };
  }
  function WebTextToolbarPopup$lambda_6($menu) {
    return function ($this$WebContextMenuToolbarPopup) {
      var tmp;
      if (!($menu.fde_1 == null)) {
        var tmp_0 = WebTextToolbarPopup$lambda$lambda_0;
        $this$WebContextMenuToolbarPopup.jgd(tmp_0, VOID, VOID, VOID, WebTextToolbarPopup$lambda$lambda_1($menu));
        tmp = Unit_instance;
      }
      var tmp_1;
      if (!($menu.gde_1 == null)) {
        var tmp_2 = WebTextToolbarPopup$lambda$lambda_2;
        $this$WebContextMenuToolbarPopup.jgd(tmp_2, VOID, VOID, VOID, WebTextToolbarPopup$lambda$lambda_3($menu));
        tmp_1 = Unit_instance;
      }
      var tmp_3;
      if (!($menu.hde_1 == null)) {
        var tmp_4 = WebTextToolbarPopup$lambda$lambda_4;
        $this$WebContextMenuToolbarPopup.jgd(tmp_4, VOID, VOID, VOID, WebTextToolbarPopup$lambda$lambda_5($menu));
        tmp_3 = Unit_instance;
      }
      var tmp_5;
      if (!($menu.ide_1 == null)) {
        var tmp_6 = WebTextToolbarPopup$lambda$lambda_6;
        $this$WebContextMenuToolbarPopup.jgd(tmp_6, VOID, VOID, VOID, WebTextToolbarPopup$lambda$lambda_7($menu));
        tmp_5 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function WebTextToolbarPopup$lambda_7($$changed) {
    return function ($composer, $force) {
      WebTextToolbarPopup($composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function ProvideDefaultPlatformTextContextMenuProviders(modifier, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(2017300822);
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        modifier_0._v = Companion_instance_0;
      }
      var tmp0 = get_LocalTextContextMenuDropdownProvider();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var dropdownDefined = !($composer_1.u31(tmp0) == null);
      var tmp0_0 = get_LocalTextContextMenuToolbarProvider();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_2 = $composer_0;
      var toolbarDefined = !($composer_2.u31(tmp0_0) == null);
      if (dropdownDefined && toolbarDefined) {
        $composer_0.m30(-2068264122);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = modifier_0._v;
        var contentAlignment = null;
        var propagateMinConstraints = true;
        var $composer_3 = $composer_0;
        if (!((2 & 1) === 0))
          modifier_1 = Companion_instance_0;
        if (!((2 & 2) === 0))
          contentAlignment = Companion_getInstance_12().k8t_1;
        if (!((2 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_4 = $composer_3;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance_0;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_4, 0).hashCode();
        var localMap = $composer_4.t31();
        var materialized = materialize($composer_4, modifier_2);
        var tmp0_1 = Companion_getInstance_14().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_5 = $composer_4;
        var tmp = $composer_5.g30();
        if (!isInterface(tmp, Applier)) {
          invalidApplier();
        }
        $composer_5.b31();
        if ($composer_5.h30()) {
          $composer_5.c31(tmp0_1);
        } else {
          $composer_5.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_5);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
        var $composer_6 = $composer_5;
        var $composer_7 = $composer_6;
        content($composer_7, 14 & $dirty >> 3);
        $composer_5.e31();
        $composer_0.n30();
      } else if (dropdownDefined) {
        $composer_0.m30(-2068073937);
        ProvideDefaultTextContextMenuToolbar(modifier_0._v, content, $composer_0, 14 & $dirty | 112 & $dirty);
        $composer_0.n30();
      } else if (toolbarDefined) {
        $composer_0.m30(-2067924114);
        ProvideDefaultTextContextMenuDropdown(modifier_0._v, content, $composer_0, 14 & $dirty | 112 & $dirty);
        $composer_0.n30();
      } else {
        $composer_0.m30(-2067793697);
        ProvideBothDefaultProviders(modifier_0._v, content, $composer_0, 14 & $dirty | 112 & $dirty);
        $composer_0.n30();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProvideDefaultPlatformTextContextMenuProviders$lambda(modifier_0, content, $changed, $default));
    }
  }
  function ProvideBothDefaultProviders(modifier, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1004301763);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = mutableStateOf(null, neverEqualPolicy());
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var layoutCoordinates$delegate = tmp;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = ProvideBothDefaultProviders$lambda_1(layoutCoordinates$delegate);
        this_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var layoutCoordinatesBlock = tmp_0;
      var dropdownProvider = defaultTextContextMenuDropdown($composer_0, 0);
      var toolbarProvider = defaultTextContextMenuToolbar($composer_0, 0);
      var tmp_1 = [get_LocalTextContextMenuToolbarProvider().h3c(toolbarProvider), get_LocalTextContextMenuDropdownProvider().h3c(dropdownProvider)];
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-572280573, true, ProvideBothDefaultProviders$lambda_2(modifier, content, toolbarProvider, layoutCoordinatesBlock, dropdownProvider, layoutCoordinates$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_1.i31();
      var tmp_2;
      if (invalid || it_1 === Companion_getInstance_11().f30_1) {
        var value_1 = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value_1);
        tmp_2 = value_1;
      } else {
        tmp_2 = it_1;
      }
      var tmp$ret$8 = tmp_2;
      CompositionLocalProvider_0(tmp_1, tmp$ret$8, $composer_0, 48 | androidx_compose_runtime_ProvidedValue$stableprop_getter());
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProvideBothDefaultProviders$lambda_3(modifier, content, $changed));
    }
  }
  function ProvideDefaultPlatformTextContextMenuProviders$lambda($modifier, $content, $$changed, $$default) {
    return function ($composer, $force) {
      ProvideDefaultPlatformTextContextMenuProviders($modifier._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ProvideBothDefaultProviders$lambda($layoutCoordinates$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('layoutCoordinates', KMutableProperty0, true);
    return $layoutCoordinates$delegate.u1();
  }
  function ProvideBothDefaultProviders$lambda_0($layoutCoordinates$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('layoutCoordinates', KMutableProperty0, true);
    $layoutCoordinates$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProvideBothDefaultProviders$lambda_1($layoutCoordinates$delegate) {
    return function () {
      // Inline function 'androidx.compose.foundation.internal.checkPreconditionNotNull' call
      var value = ProvideBothDefaultProviders$lambda($layoutCoordinates$delegate);
      if (value == null) {
        throwIllegalStateExceptionForNullCheck('Required value was null.');
      }
      return value;
    };
  }
  function ProvideBothDefaultProviders$lambda$lambda($layoutCoordinates$delegate) {
    return function (it) {
      ProvideBothDefaultProviders$lambda_0($layoutCoordinates$delegate, it);
      return Unit_instance;
    };
  }
  function ProvideBothDefaultProviders$lambda_2($modifier, $content, $toolbarProvider, $layoutCoordinatesBlock, $dropdownProvider, $layoutCoordinates$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance_11().f30_1) {
          var value = ProvideBothDefaultProviders$lambda$lambda($layoutCoordinates$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$0 = tmp_0;
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = onGloballyPositioned($modifier, tmp$ret$0);
        var contentAlignment = null;
        var propagateMinConstraints = true;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance_0;
        if (!((2 & 2) === 0))
          contentAlignment = Companion_getInstance_12().k8t_1;
        if (!((2 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance_0;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_14().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        $content($composer_5, 0);
        $toolbarProvider.uky($layoutCoordinatesBlock, $composer_5, 6);
        $dropdownProvider.uky($layoutCoordinatesBlock, $composer_5, 6);
        $composer_3.e31();
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProvideBothDefaultProviders$lambda_3($modifier, $content, $$changed) {
    return function ($composer, $force) {
      ProvideBothDefaultProviders($modifier, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function ProvideDefaultTextContextMenuToolbar(modifier, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(2018060703);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      ProvidePlatformTextContextMenuToolbar(modifier, get_LocalTextContextMenuToolbarProvider(), ComposableSingletons$WebTextContextMenuToolbarProvider_webKt_getInstance().plz_1, content, $composer_0, 432 | 14 & $dirty | 7168 & $dirty << 6);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProvideDefaultTextContextMenuToolbar$lambda(modifier, content, $changed));
    }
  }
  function defaultTextContextMenuToolbar($composer, $changed) {
    var $composer_0 = $composer;
    return basicTextContextMenuProvider(ComposableSingletons$WebTextContextMenuToolbarProvider_webKt_getInstance().qlz_1, $composer_0, 6);
  }
  function ProvidePlatformTextContextMenuToolbar(modifier, providableCompositionLocal, contextMenu, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1472599976);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(providableCompositionLocal) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(contextMenu) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_11().f30_1) {
        var value = mutableStateOf(null, neverEqualPolicy());
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var layoutCoordinates$delegate = tmp;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = ProvidePlatformTextContextMenuToolbar$lambda_1(layoutCoordinates$delegate);
        this_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var layoutCoordinatesBlock = tmp_0;
      var provider = basicTextContextMenuProvider(contextMenu, $composer_0, 14 & $dirty >> 6);
      var tmp_1 = providableCompositionLocal.h3c(provider);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(107313896, true, ProvidePlatformTextContextMenuToolbar$lambda_2(modifier, content, provider, layoutCoordinatesBlock, layoutCoordinates$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_1.i31();
      var tmp_2;
      if (invalid || it_1 === Companion_getInstance_11().f30_1) {
        var value_1 = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value_1);
        tmp_2 = value_1;
      } else {
        tmp_2 = it_1;
      }
      var tmp$ret$8 = tmp_2;
      CompositionLocalProvider(tmp_1, tmp$ret$8, $composer_0, 48 | androidx_compose_runtime_ProvidedValue$stableprop_getter());
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProvidePlatformTextContextMenuToolbar$lambda_3(modifier, providableCompositionLocal, contextMenu, content, $changed));
    }
  }
  function ComposableSingletons$WebTextContextMenuToolbarProvider_webKt$lambda$_2024605971$lambda_i4cmoj(session, dataProvider, anchorLayoutCoordinates, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(session) : $composer_0.q31(session)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(dataProvider) : $composer_0.q31(dataProvider)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(anchorLayoutCoordinates) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      OpenContextMenuToolbar(session, dataProvider, anchorLayoutCoordinates, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$WebTextContextMenuToolbarProvider_webKt$lambda$_531017990$lambda_fpegs(session, dataProvider, anchorLayoutCoordinates, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(session) : $composer_0.q31(session)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(dataProvider) : $composer_0.q31(dataProvider)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(anchorLayoutCoordinates) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      OpenContextMenuToolbar(session, dataProvider, anchorLayoutCoordinates, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$WebTextContextMenuToolbarProvider_webKt() {
    ComposableSingletons$WebTextContextMenuToolbarProvider_webKt_instance = this;
    var tmp = this;
    tmp.plz_1 = ComposableLambda$invoke$ref_8(composableLambdaInstance(-2024605971, false, ComposableSingletons$WebTextContextMenuToolbarProvider_webKt$lambda$_2024605971$lambda_i4cmoj));
    var tmp_0 = this;
    tmp_0.qlz_1 = ComposableLambda$invoke$ref_8(composableLambdaInstance(-531017990, false, ComposableSingletons$WebTextContextMenuToolbarProvider_webKt$lambda$_531017990$lambda_fpegs));
  }
  var ComposableSingletons$WebTextContextMenuToolbarProvider_webKt_instance;
  function ComposableSingletons$WebTextContextMenuToolbarProvider_webKt_getInstance() {
    if (ComposableSingletons$WebTextContextMenuToolbarProvider_webKt_instance == null)
      new ComposableSingletons$WebTextContextMenuToolbarProvider_webKt();
    return ComposableSingletons$WebTextContextMenuToolbarProvider_webKt_instance;
  }
  function OpenContextMenuToolbar(session, dataProvider, anchorLayoutCoordinates, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1604153151);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(session) : $composer_0.q31(session)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(dataProvider) : $composer_0.q31(dataProvider)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(anchorLayoutCoordinates) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      var tmp0 = get_LocalDensity();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      // Inline function 'kotlin.with' call
      var $this$with = $composer_1.u31(tmp0);
      var tmp0_0 = WebContextMenuToolbarSpec_getInstance().blz_1;
      // Inline function 'androidx.compose.ui.unit.dp' call
      // Inline function 'androidx.compose.ui.unit.Dp.plus' call
      var other = _Dp___init__impl__ms3zkb(16);
      var tmp$ret$4 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(tmp0_0) + _Dp___get_value__impl__geb1vb(other));
      // Inline function 'kotlin.let' call
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = $this$with.w5e(tmp$ret$4);
      var v1 = fromInt(toRawBits(0.0));
      var v2 = fromInt(toRawBits(val2));
      var tmp$ret$8 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var toolbarOffset = _Offset___init__impl__c168vi(tmp$ret$8);
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 112) === 32 || (!(($dirty & 64) === 0) && $composer_0.k31(dataProvider));
      // Inline function 'kotlin.let' call
      var it = tmp0_1.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_11().f30_1) {
        var value = new ContextMenuPopupPositionProvider(OpenContextMenuToolbar$lambda(anchorLayoutCoordinates, dataProvider, toolbarOffset));
        tmp0_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var popupPositionProvider = tmp;
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = ($dirty & 112) === 32 || (!(($dirty & 64) === 0) && $composer_0.k31(dataProvider));
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_2.i31();
      var tmp_0;
      if (invalid_0 || it_0 === Companion_getInstance_11().f30_1) {
        var value_0 = derivedStateOf(TextContextMenuDataProvider$data$ref(dataProvider));
        tmp0_2.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var data$delegate = tmp_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_0.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance_11().f30_1) {
        var value_1 = OpenContextMenuToolbar$lambda_1;
        this_0.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp_2 = tmp_1;
      var tmp_3 = computeContextMenuColors($composer_0, 0);
      var tmp0_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!($composer_0.k31(data$delegate) | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(session))));
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_3.i31();
      var tmp_4;
      if (invalid_1 || it_2 === Companion_getInstance_11().f30_1) {
        var value_2 = OpenContextMenuToolbar$lambda_2(data$delegate, session);
        tmp0_3.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var tmp$ret$21 = tmp_4;
      WebContextMenuToolbarPopup_0(popupPositionProvider, tmp_2, null, tmp_3, tmp$ret$21, $composer_0, 48, 4);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(OpenContextMenuToolbar$lambda_3(session, dataProvider, anchorLayoutCoordinates, $changed));
    }
  }
  function ProvideDefaultTextContextMenuToolbar$lambda($modifier, $content, $$changed) {
    return function ($composer, $force) {
      ProvideDefaultTextContextMenuToolbar($modifier, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function ProvidePlatformTextContextMenuToolbar$lambda($layoutCoordinates$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('layoutCoordinates', KMutableProperty0, true);
    return $layoutCoordinates$delegate.u1();
  }
  function ProvidePlatformTextContextMenuToolbar$lambda_0($layoutCoordinates$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('layoutCoordinates', KMutableProperty0, true);
    $layoutCoordinates$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProvidePlatformTextContextMenuToolbar$lambda_1($layoutCoordinates$delegate) {
    return function () {
      // Inline function 'androidx.compose.foundation.internal.checkPreconditionNotNull' call
      var value = ProvidePlatformTextContextMenuToolbar$lambda($layoutCoordinates$delegate);
      if (value == null) {
        throwIllegalStateExceptionForNullCheck('Required value was null.');
      }
      return value;
    };
  }
  function ProvidePlatformTextContextMenuToolbar$lambda$lambda($layoutCoordinates$delegate) {
    return function (it) {
      ProvidePlatformTextContextMenuToolbar$lambda_0($layoutCoordinates$delegate, it);
      return Unit_instance;
    };
  }
  function ProvidePlatformTextContextMenuToolbar$lambda_2($modifier, $content, $provider, $layoutCoordinatesBlock, $layoutCoordinates$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance_11().f30_1) {
          var value = ProvidePlatformTextContextMenuToolbar$lambda$lambda($layoutCoordinates$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$0 = tmp_0;
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = onGloballyPositioned($modifier, tmp$ret$0);
        var contentAlignment = null;
        var propagateMinConstraints = true;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance_0;
        if (!((2 & 2) === 0))
          contentAlignment = Companion_getInstance_12().k8t_1;
        if (!((2 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance_0;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_14().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_14().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_14().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_14().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_14().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_14().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        $content($composer_5, 0);
        $provider.uky($layoutCoordinatesBlock, $composer_5, 6);
        $composer_3.e31();
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProvidePlatformTextContextMenuToolbar$lambda_3($modifier, $providableCompositionLocal, $contextMenu, $content, $$changed) {
    return function ($composer, $force) {
      ProvidePlatformTextContextMenuToolbar($modifier, $providableCompositionLocal, $contextMenu, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function OpenContextMenuToolbar$lambda($anchorLayoutCoordinates, $dataProvider, $toolbarOffset) {
    return function () {
      var anchorLayoutCoordinates = $anchorLayoutCoordinates();
      var localBoundingBox = $dataProvider.vkt(anchorLayoutCoordinates);
      return new IntOffset(round(Offset__minus_impl_hoj2c0(localBoundingBox, $toolbarOffset)));
    };
  }
  function OpenContextMenuToolbar$lambda_0($data$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('data', KProperty0, false);
    return $data$delegate.u1();
  }
  function OpenContextMenuToolbar$lambda_1() {
    return Unit_instance;
  }
  function OpenContextMenuToolbar$lambda$lambda($component) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      $composer_0.m30(-315907989);
      var tmp0 = $component.vlr_1;
      $composer_0.n30();
      return tmp0;
    };
  }
  function OpenContextMenuToolbar$lambda$lambda_0($component, $session) {
    return function () {
      $component.ylr_1($session);
      return Unit_instance;
    };
  }
  function OpenContextMenuToolbar$lambda_2($data$delegate, $session) {
    return function ($this$WebContextMenuToolbarPopup) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = OpenContextMenuToolbar$lambda_0($data$delegate).bks_1;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          if (item instanceof TextContextMenuItemWithComposableLeadingIcon) {
            var tmp1_enabled = item.wlr_1;
            var tmp2_leadingIcon = item.xlr_1;
            var tmp = OpenContextMenuToolbar$lambda$lambda(item);
            $this$WebContextMenuToolbarPopup.jgd(tmp, VOID, tmp1_enabled, tmp2_leadingIcon, OpenContextMenuToolbar$lambda$lambda_0(item, $session));
          }
        }
         while (inductionVariable <= last);
      return Unit_instance;
    };
  }
  function OpenContextMenuToolbar$lambda_3($session, $dataProvider, $anchorLayoutCoordinates, $$changed) {
    return function ($composer, $force) {
      OpenContextMenuToolbar($session, $dataProvider, $anchorLayoutCoordinates, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function makeSelectionModifier(_this__u8e3s4, selectableId, layoutCoordinates) {
    return makeSkikoSelectionModifier(_this__u8e3s4, selectableId, layoutCoordinates);
  }
  function get_DefaultSelectionColor() {
    _init_properties_DefaultTextSelectionColors_web_kt__kputis();
    return DefaultSelectionColor;
  }
  var DefaultSelectionColor;
  function get_DefaultTextSelectionColors() {
    _init_properties_DefaultTextSelectionColors_web_kt__kputis();
    return DefaultTextSelectionColors;
  }
  var DefaultTextSelectionColors;
  var properties_initialized_DefaultTextSelectionColors_web_kt_2l2esq;
  function _init_properties_DefaultTextSelectionColors_web_kt__kputis() {
    if (!properties_initialized_DefaultTextSelectionColors_web_kt_2l2esq) {
      properties_initialized_DefaultTextSelectionColors_web_kt_2l2esq = true;
      DefaultSelectionColor = Color_0(new Long(-12417292, 0));
      DefaultTextSelectionColors = new TextSelectionColors(get_DefaultSelectionColor(), Color__copy$default_impl_ectz3s(get_DefaultSelectionColor(), 0.4));
    }
  }
  function get_FirstLongPressSelectionAdjustment() {
    return Companion_getInstance_87().gki_1;
  }
  function SelectionHandle(offsetProvider, isStartHandle, direction, handlesCrossed, minTouchTargetSize, lineHeight, modifier, $composer, $changed, $default) {
    var minTouchTargetSize_0 = {_v: new DpSize(minTouchTargetSize)};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1618108002);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(offsetProvider) : $composer_0.q31(offsetProvider)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isStartHandle) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.m31(direction.a1_1) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(handlesCrossed) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | (($default & 16) === 0 && $composer_0.o31(_DpSize___get_packedValue__impl__jx4au8(minTouchTargetSize_0._v.r5f_1)) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.n31(lineHeight) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 16) === 0)) {
          minTouchTargetSize_0._v = new DpSize(Companion_getInstance_56().i5f_1);
          $dirty = $dirty & -57345;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 16) === 0))
          $dirty = $dirty & -57345;
      }
      $composer_0.r30();
      SkikoSelectionHandle(offsetProvider, isStartHandle, direction, handlesCrossed, minTouchTargetSize_0._v.r5f_1, lineHeight, modifier, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty | 7168 & $dirty | 57344 & $dirty | 458752 & $dirty | 3670016 & $dirty);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(SelectionHandle$lambda(offsetProvider, isStartHandle, direction, handlesCrossed, minTouchTargetSize_0, lineHeight, modifier, $changed, $default));
    }
  }
  function SelectionHandle$lambda($offsetProvider, $isStartHandle, $direction, $handlesCrossed, $minTouchTargetSize, $lineHeight, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      SelectionHandle($offsetProvider, $isStartHandle, $direction, $handlesCrossed, $minTouchTargetSize._v.r5f_1, $lineHeight, $modifier, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function isSelectionHandleInVisibleBound(_this__u8e3s4, isStartHandle) {
    return isSelectionHandleInVisibleBoundDefault(_this__u8e3s4, isStartHandle);
  }
  function textFieldMagnifier(_this__u8e3s4, manager) {
    return _this__u8e3s4;
  }
  function addBasicTextFieldTextContextMenuComponents(_this__u8e3s4, manager, coroutineScope) {
    return appendTextContextMenuComponents(_this__u8e3s4, addBasicTextFieldTextContextMenuComponents$lambda(manager, coroutineScope));
  }
  function hasAvailableTextToPaste(_this__u8e3s4, $completion) {
    return true;
  }
  function addBasicTextFieldTextContextMenuComponents$lambda$textFieldItem$lambda($onClick) {
    return function ($this$item) {
      $onClick();
      $this$item.j4();
      return Unit_instance;
    };
  }
  function addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda$slambda($onClick, resultContinuation) {
    this.zlz_1 = $onClick;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.zlz_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda$slambda(this.zlz_1, completion);
    i.am0_1 = $this$launch;
    return i;
  };
  function addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda$slambda_0($onClick, resultContinuation) {
    var i = new addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda$slambda($onClick, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda($coroutineScope, $onClick) {
    return function () {
      var tmp = CoroutineStart_UNDISPATCHED_getInstance();
      launch($coroutineScope, VOID, tmp, addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda$slambda_0($onClick, null));
      return Unit_instance;
    };
  }
  function invoke$textFieldItem_0(_this__u8e3s4, item, enabled, onClick) {
    var tmp = getLocalizedString(item.ok3_1);
    item_0(_this__u8e3s4, item.nk3_1, tmp, enabled, VOID, addBasicTextFieldTextContextMenuComponents$lambda$textFieldItem$lambda(onClick));
  }
  function invoke$textFieldSuspendItem(_this__u8e3s4, $coroutineScope, item, enabled, onClick) {
    invoke$textFieldItem_0(_this__u8e3s4, item, enabled, addBasicTextFieldTextContextMenuComponents$lambda$textFieldSuspendItem$lambda($coroutineScope, onClick));
  }
  function addBasicTextFieldTextContextMenuComponents$lambda$slambda($$this$with, resultContinuation) {
    this.jm0_1 = $$this$with;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.jm0_1.skk();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda).s2b = function (completion) {
    return new addBasicTextFieldTextContextMenuComponents$lambda$slambda(this.jm0_1, completion);
  };
  function addBasicTextFieldTextContextMenuComponents$lambda$slambda_0($$this$with, resultContinuation) {
    var i = new addBasicTextFieldTextContextMenuComponents$lambda$slambda($$this$with, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function addBasicTextFieldTextContextMenuComponents$lambda$slambda_1($$this$with, resultContinuation) {
    this.sm0_1 = $$this$with;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda_1).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda_1).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.sm0_1.qkk(false);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda_1).s2b = function (completion) {
    return new addBasicTextFieldTextContextMenuComponents$lambda$slambda_1(this.sm0_1, completion);
  };
  function addBasicTextFieldTextContextMenuComponents$lambda$slambda_2($$this$with, resultContinuation) {
    var i = new addBasicTextFieldTextContextMenuComponents$lambda$slambda_1($$this$with, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function addBasicTextFieldTextContextMenuComponents$lambda$slambda_3($$this$with, resultContinuation) {
    this.bm1_1 = $$this$with;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda_3).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda_3).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.bm1_1.rkk();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(addBasicTextFieldTextContextMenuComponents$lambda$slambda_3).s2b = function (completion) {
    return new addBasicTextFieldTextContextMenuComponents$lambda$slambda_3(this.bm1_1, completion);
  };
  function addBasicTextFieldTextContextMenuComponents$lambda$slambda_4($$this$with, resultContinuation) {
    var i = new addBasicTextFieldTextContextMenuComponents$lambda$slambda_3($$this$with, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function addBasicTextFieldTextContextMenuComponents$lambda$lambda($$this$with) {
    return function () {
      $$this$with.lll();
      return Unit_instance;
    };
  }
  function addBasicTextFieldTextContextMenuComponents$lambda($manager, $coroutineScope) {
    return function ($this$appendTextContextMenuComponents) {
      // Inline function 'kotlin.with' call
      var $this$with = $manager;
      $this$appendTextContextMenuComponents.zkr();
      var tmp = TextContextMenuItems_Cut_getInstance();
      var tmp_0 = $this$with.pk4();
      invoke$textFieldSuspendItem($this$appendTextContextMenuComponents, $coroutineScope, tmp, tmp_0, addBasicTextFieldTextContextMenuComponents$lambda$slambda_0($this$with, null));
      var tmp_1 = TextContextMenuItems_Copy_getInstance();
      var tmp_2 = $this$with.nk4();
      invoke$textFieldSuspendItem($this$appendTextContextMenuComponents, $coroutineScope, tmp_1, tmp_2, addBasicTextFieldTextContextMenuComponents$lambda$slambda_2($this$with, null));
      var tmp_3 = TextContextMenuItems_Paste_getInstance();
      var tmp_4 = $this$with.ok4();
      invoke$textFieldSuspendItem($this$appendTextContextMenuComponents, $coroutineScope, tmp_3, tmp_4, addBasicTextFieldTextContextMenuComponents$lambda$slambda_4($this$with, null));
      var tmp_5 = TextContextMenuItems_SelectAll_getInstance();
      var tmp_6 = $this$with.qk4();
      invoke$textFieldItem_0($this$appendTextContextMenuComponents, tmp_5, tmp_6, addBasicTextFieldTextContextMenuComponents$lambda$lambda($this$with));
      $this$appendTextContextMenuComponents.zkr();
      return Unit_instance;
    };
  }
  //region block: post-declaration
  protoOf(BackgroundNode).v95 = onMeasureResultChanged;
  protoOf(BackgroundNode).k9j = get_shouldClearDescendantSemantics;
  protoOf(BackgroundNode).l9j = get_shouldMergeDescendantSemantics;
  protoOf(BorderModifierNode).k9j = get_shouldClearDescendantSemantics;
  protoOf(BorderModifierNode).l9j = get_shouldMergeDescendantSemantics;
  protoOf(AbstractClickableNode).n8w = onDensityChange;
  protoOf(AbstractClickableNode).fa5 = interceptOutOfBoundsChildEvents;
  protoOf(AbstractClickableNode).ga5 = sharePointerInputWithSiblings;
  protoOf(AbstractClickableNode).ha5 = onViewConfigurationChange;
  protoOf(AbstractClickableNode).ea5 = get_touchBoundsExpansion;
  protoOf(AbstractClickableNode).k9j = get_shouldClearDescendantSemantics;
  protoOf(AbstractClickableNode).k9i = get_isImportantForBounds;
  protoOf(AbstractClickableNode).hfh = isInterested;
  protoOf(FocusableNode).k9j = get_shouldClearDescendantSemantics;
  protoOf(FocusableNode).l9j = get_shouldMergeDescendantSemantics;
  protoOf(FocusableNode).k9i = get_isImportantForBounds;
  protoOf(HoverableNode).fa5 = interceptOutOfBoundsChildEvents;
  protoOf(HoverableNode).ga5 = sharePointerInputWithSiblings;
  protoOf(HoverableNode).n8w = onDensityChange;
  protoOf(HoverableNode).ha5 = onViewConfigurationChange;
  protoOf(HoverableNode).ea5 = get_touchBoundsExpansion;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).nak = minIntrinsicWidth;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).oak = minIntrinsicHeight;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).pak = maxIntrinsicWidth;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).qak = maxIntrinsicHeight;
  protoOf(DefaultDebugIndicationInstance).v95 = onMeasureResultChanged;
  protoOf(DefaultDebugIndication).lg1 = rememberUpdatedInstance;
  protoOf(IndicationModifier).h8v = foldIn;
  protoOf(IndicationModifier).i8v = all;
  protoOf(IndicationModifier).d8v = then;
  protoOf(ScrollState).qg7 = scroll$default;
  protoOf(ScrollNode).k9j = get_shouldClearDescendantSemantics;
  protoOf(ScrollNode).l9j = get_shouldMergeDescendantSemantics;
  protoOf(ScrollNode).k9i = get_isImportantForBounds;
  protoOf(BringIntoViewSpec$Companion$DefaultBringIntoViewSpec$1).jge = get_scrollAnimationSpec;
  protoOf(BringIntoViewSpec$Companion$DefaultBringIntoViewSpec$1).kge = calculateScrollDistance;
  protoOf(DragGestureNode).n8w = onDensityChange;
  protoOf(DragGestureNode).fa5 = interceptOutOfBoundsChildEvents;
  protoOf(DragGestureNode).ga5 = sharePointerInputWithSiblings;
  protoOf(DragGestureNode).ha5 = onViewConfigurationChange;
  protoOf(DragGestureNode).ea5 = get_touchBoundsExpansion;
  protoOf(ScrollableNode).k9j = get_shouldClearDescendantSemantics;
  protoOf(ScrollableNode).l9j = get_shouldMergeDescendantSemantics;
  protoOf(ScrollableNode).k9i = get_isImportantForBounds;
  protoOf(ScrollableNestedScrollConnection).z9u = onPreScroll;
  protoOf(ScrollableNestedScrollConnection).b9v = onPreFling;
  protoOf(DefaultScrollMotionDurationScale$1).t1 = get_key_0;
  protoOf(DefaultScrollMotionDurationScale$1).aa = get;
  protoOf(DefaultScrollMotionDurationScale$1).wj = fold;
  protoOf(DefaultScrollMotionDurationScale$1).vj = minusKey;
  protoOf(DefaultScrollMotionDurationScale$1).xj = plus;
  protoOf(UnityDensity$1).v5e = toPx;
  protoOf(UnityDensity$1).x5e = toPx_0;
  protoOf(UnityDensity$1).w5e = roundToPx;
  protoOf(UnityDensity$1).c5f = roundToPx_0;
  protoOf(UnityDensity$1).d5f = toDp;
  protoOf(UnityDensity$1).e5f = toDp_0;
  protoOf(UnityDensity$1).b5f = toDp_1;
  protoOf(UnityDensity$1).f5f = toSize_0;
  protoOf(UnityDensity$1).g5f = toDpSize;
  protoOf(DefaultScrollableState).qg7 = scroll$default;
  protoOf(DefaultScrollableState).mg7 = get_canScrollForward;
  protoOf(DefaultScrollableState).ng7 = get_canScrollBackward;
  protoOf(SnapFlingBehavior).whd = performFling;
  protoOf(LazyItemScopeImpl).gi9 = fillParentMaxWidth$default;
  protoOf(ParentSizeNode).o8y = minIntrinsicWidth_0;
  protoOf(ParentSizeNode).p8y = minIntrinsicHeight_0;
  protoOf(ParentSizeNode).q8y = maxIntrinsicWidth_0;
  protoOf(ParentSizeNode).r8y = maxIntrinsicHeight_0;
  protoOf(LazyListIntervalContent).ei9 = items$default;
  protoOf(LazyListIntervalContent).ci9 = item$default;
  protoOf(DefaultLazyListPrefetchStrategy).oih = get_prefetchScheduler;
  protoOf(LazyLayoutScrollScope$1).aij = calculateDistanceTo$default;
  protoOf(LazyListState$remeasurementModifier$1).h8v = foldIn;
  protoOf(LazyListState$remeasurementModifier$1).i8v = all;
  protoOf(LazyListState$remeasurementModifier$1).d8v = then;
  protoOf(LazyListState$prefetchScope$1).tih = schedulePrefetch$default;
  protoOf(LazyListState).qg7 = scroll$default;
  protoOf(EmptyLazyListMeasureResult$1).tad = get_rulers;
  protoOf(LazyGridIntervalContent).eiq = item$default_0;
  protoOf(LazyGridIntervalContent).giq = items$default_0;
  protoOf(DefaultLazyGridPrefetchStrategy).oih = get_prefetchScheduler_0;
  protoOf(LazyGridState$remeasurementModifier$1).h8v = foldIn;
  protoOf(LazyGridState$remeasurementModifier$1).i8v = all;
  protoOf(LazyGridState$remeasurementModifier$1).d8v = then;
  protoOf(LazyGridState).qg7 = scroll$default;
  protoOf(EmptyLazyGridLayoutInfo$1).tad = get_rulers;
  protoOf(LazyLayoutBeyondBoundsProviderModifierNode).o8y = minIntrinsicWidth_0;
  protoOf(LazyLayoutBeyondBoundsProviderModifierNode).p8y = minIntrinsicHeight_0;
  protoOf(LazyLayoutBeyondBoundsProviderModifierNode).q8y = maxIntrinsicWidth_0;
  protoOf(LazyLayoutBeyondBoundsProviderModifierNode).r8y = maxIntrinsicHeight_0;
  protoOf(DisplayingDisappearingItemsNode).v95 = onMeasureResultChanged;
  protoOf(LazyLayoutMeasureScopeImpl).n8y = layout$default;
  protoOf(LazyLayoutMeasureScopeImpl).iag = layout$default_0;
  protoOf(LazyLayoutSemanticsModifierNode).k9j = get_shouldClearDescendantSemantics;
  protoOf(LazyLayoutSemanticsModifierNode).l9j = get_shouldMergeDescendantSemantics;
  protoOf(LazyLayoutSemanticsModifierNode).k9i = get_isImportantForBounds;
  protoOf(PagerLazyLayoutItemProvider).kif = getContentType;
  protoOf(PagerIntervalContent).oif = get_type_0;
  protoOf(PagerBringIntoViewSpec).jge = get_scrollAnimationSpec;
  protoOf(LegacyPagerBringIntoViewSpec).jge = get_scrollAnimationSpec;
  protoOf(DefaultPagerNestedScrollConnection).b9v = onPreFling;
  protoOf(LazyLayoutScrollScope$1_0).aij = calculateDistanceTo$default;
  protoOf(PagerState$remeasurementModifier$1).h8v = foldIn;
  protoOf(PagerState$remeasurementModifier$1).i8v = all;
  protoOf(PagerState$remeasurementModifier$1).d8v = then;
  protoOf(PagerState).qg7 = scroll$default;
  protoOf(UnitDensity$1).v5e = toPx;
  protoOf(UnitDensity$1).x5e = toPx_0;
  protoOf(UnitDensity$1).w5e = roundToPx;
  protoOf(UnitDensity$1).c5f = roundToPx_0;
  protoOf(UnitDensity$1).d5f = toDp;
  protoOf(UnitDensity$1).e5f = toDp_0;
  protoOf(UnitDensity$1).b5f = toDp_1;
  protoOf(UnitDensity$1).f5f = toSize_0;
  protoOf(UnitDensity$1).g5f = toDpSize;
  protoOf(EmptyLayoutInfo$1).tad = get_rulers;
  protoOf(BringIntoViewResponderNode).u91 = onRemeasured;
  protoOf(ResolvedStyle).v5e = toPx;
  protoOf(ResolvedStyle).x5e = toPx_0;
  protoOf(ResolvedStyle).w5e = roundToPx;
  protoOf(ResolvedStyle).c5f = roundToPx_0;
  protoOf(ResolvedStyle).d5f = toDp;
  protoOf(ResolvedStyle).e5f = toDp_0;
  protoOf(ResolvedStyle).b5f = toDp_1;
  protoOf(ResolvedStyle).f5f = toSize_0;
  protoOf(ResolvedStyle).g5f = toDpSize;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).nak = minIntrinsicWidth;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).oak = minIntrinsicHeight;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).pak = maxIntrinsicWidth;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).qak = maxIntrinsicHeight;
  protoOf(EmptyMeasurePolicy).nak = minIntrinsicWidth;
  protoOf(EmptyMeasurePolicy).oak = minIntrinsicHeight;
  protoOf(EmptyMeasurePolicy).pak = maxIntrinsicWidth;
  protoOf(EmptyMeasurePolicy).qak = maxIntrinsicHeight;
  protoOf(LinksTextMeasurePolicy).nak = minIntrinsicWidth;
  protoOf(LinksTextMeasurePolicy).oak = minIntrinsicHeight;
  protoOf(LinksTextMeasurePolicy).pak = maxIntrinsicWidth;
  protoOf(LinksTextMeasurePolicy).qak = maxIntrinsicHeight;
  protoOf(TextMeasurePolicy).nak = minIntrinsicWidth;
  protoOf(TextMeasurePolicy).oak = minIntrinsicHeight;
  protoOf(TextMeasurePolicy).pak = maxIntrinsicWidth;
  protoOf(TextMeasurePolicy).qak = maxIntrinsicHeight;
  protoOf(CoreTextField$4).nak = minIntrinsicWidth;
  protoOf(CoreTextField$4).oak = minIntrinsicHeight;
  protoOf(CoreTextField$4).qak = maxIntrinsicHeight;
  protoOf(HeightInLinesNode).o8y = minIntrinsicWidth_0;
  protoOf(HeightInLinesNode).p8y = minIntrinsicHeight_0;
  protoOf(HeightInLinesNode).q8y = maxIntrinsicWidth_0;
  protoOf(HeightInLinesNode).r8y = maxIntrinsicHeight_0;
  protoOf(VerticalScrollLayoutModifier).o8y = minIntrinsicWidth_1;
  protoOf(VerticalScrollLayoutModifier).p8y = minIntrinsicHeight_1;
  protoOf(VerticalScrollLayoutModifier).q8y = maxIntrinsicWidth_1;
  protoOf(VerticalScrollLayoutModifier).r8y = maxIntrinsicHeight_1;
  protoOf(VerticalScrollLayoutModifier).h8v = foldIn;
  protoOf(VerticalScrollLayoutModifier).i8v = all;
  protoOf(VerticalScrollLayoutModifier).d8v = then;
  protoOf(HorizontalScrollLayoutModifier).o8y = minIntrinsicWidth_1;
  protoOf(HorizontalScrollLayoutModifier).p8y = minIntrinsicHeight_1;
  protoOf(HorizontalScrollLayoutModifier).q8y = maxIntrinsicWidth_1;
  protoOf(HorizontalScrollLayoutModifier).r8y = maxIntrinsicHeight_1;
  protoOf(HorizontalScrollLayoutModifier).h8v = foldIn;
  protoOf(HorizontalScrollLayoutModifier).i8v = all;
  protoOf(HorizontalScrollLayoutModifier).d8v = then;
  protoOf(textFieldScrollable$1$wrappedScrollableState$1).qg7 = scroll$default;
  protoOf(TextFieldSizeNode).o8y = minIntrinsicWidth_0;
  protoOf(TextFieldSizeNode).p8y = minIntrinsicHeight_0;
  protoOf(TextFieldSizeNode).q8y = maxIntrinsicWidth_0;
  protoOf(TextFieldSizeNode).r8y = maxIntrinsicHeight_0;
  protoOf(TextRangeLayoutModifier).h8v = foldIn;
  protoOf(TextRangeLayoutModifier).i8v = all;
  protoOf(TextRangeLayoutModifier).d8v = then;
  protoOf(StylusHandwritingNode).n8w = onDensityChange;
  protoOf(StylusHandwritingNode).fa5 = interceptOutOfBoundsChildEvents;
  protoOf(StylusHandwritingNode).ga5 = sharePointerInputWithSiblings;
  protoOf(StylusHandwritingNode).ha5 = onViewConfigurationChange;
  protoOf(CoreTextFieldSemanticsModifierNode).k9j = get_shouldClearDescendantSemantics;
  protoOf(CoreTextFieldSemanticsModifierNode).k9i = get_isImportantForBounds;
  protoOf(LegacyPlatformTextInputServiceAdapter).b8d = startInput;
  protoOf(LegacyPlatformTextInputServiceAdapter).i8d = notifyFocusedRect;
  protoOf(LegacyPlatformTextInputServiceAdapter).k8d = updateTextLayoutResult;
  protoOf(TextAutoSizeLayoutScopeImpl).v5e = toPx;
  protoOf(TextAutoSizeLayoutScopeImpl).w5e = roundToPx;
  protoOf(TextAutoSizeLayoutScopeImpl).c5f = roundToPx_0;
  protoOf(TextAutoSizeLayoutScopeImpl).d5f = toDp;
  protoOf(TextAutoSizeLayoutScopeImpl).e5f = toDp_0;
  protoOf(TextAutoSizeLayoutScopeImpl).b5f = toDp_1;
  protoOf(TextAutoSizeLayoutScopeImpl).f5f = toSize_0;
  protoOf(TextAutoSizeLayoutScopeImpl).g5f = toDpSize;
  protoOf(SelectableTextAnnotatedStringNode).v95 = onMeasureResultChanged;
  protoOf(TextAnnotatedStringNode).v95 = onMeasureResultChanged;
  protoOf(TextAnnotatedStringNode).k9j = get_shouldClearDescendantSemantics;
  protoOf(TextAnnotatedStringNode).l9j = get_shouldMergeDescendantSemantics;
  protoOf(TextAnnotatedStringNode).k9i = get_isImportantForBounds;
  protoOf(TextStringSimpleNode).v95 = onMeasureResultChanged;
  protoOf(TextStringSimpleNode).k9j = get_shouldClearDescendantSemantics;
  protoOf(TextStringSimpleNode).l9j = get_shouldMergeDescendantSemantics;
  protoOf(TextStringSimpleNode).k9i = get_isImportantForBounds;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).nak = minIntrinsicWidth;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).oak = minIntrinsicHeight;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).pak = maxIntrinsicWidth;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).qak = maxIntrinsicHeight;
  protoOf(InputModeFilterIndicationNodeFactory).lg1 = rememberUpdatedInstance;
  protoOf(JsConfig).dh1 = get_isSmoothScrollingEnabled;
  protoOf(JsConfig).eh1 = isPreciseWheelScroll;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_2).nak = minIntrinsicWidth;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_2).oak = minIntrinsicHeight;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_2).pak = maxIntrinsicWidth;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_2).qak = maxIntrinsicHeight;
  //endregion
  //region block: init
  androidx_compose_foundation_MarqueeDefaults$stable = 0;
  androidx_compose_foundation_BasicTooltipDefaults$stable = 0;
  androidx_compose_foundation_BorderModifierNodeElement$stable = 0;
  androidx_compose_foundation_BorderModifierNode$stable = 8;
  androidx_compose_foundation_BorderStroke$stable = 0;
  androidx_compose_foundation_ClickableNode$stable = 8;
  androidx_compose_foundation_CombinedClickableNode_DoubleKeyClickState$stable = 8;
  androidx_compose_foundation_AbstractClickableNode$stable = 8;
  TraverseKey_instance = new TraverseKey();
  VerticalScrollableClipShape_instance = new VerticalScrollableClipShape();
  HorizontalScrollableClipShape_instance = new HorizontalScrollableClipShape();
  androidx_compose_foundation_ComposeFoundationFlags$stable = 8;
  ComposeFoundationFlags_instance = new ComposeFoundationFlags();
  androidx_compose_foundation_FocusableNode$stable = 8;
  TraverseKey_instance_0 = new TraverseKey_0();
  androidx_compose_foundation_FocusedBoundsObserverNode$stable = 8;
  TraverseKey_instance_1 = new TraverseKey_1();
  TraverseKey_instance_2 = new TraverseKey_2();
  DefaultDebugIndication_instance = new DefaultDebugIndication();
  NoIndicationInstance_instance = new NoIndicationInstance();
  androidx_compose_foundation_MutationInterruptedException$stable = 8;
  androidx_compose_foundation_MutatorMutex$stable = 0;
  androidx_compose_foundation_ScrollState$stable = 0;
  androidx_compose_foundation_ScrollingLayoutElement$stable = 0;
  androidx_compose_foundation_ScrollNode$stable = 8;
  androidx_compose_foundation_border_BorderLogic$stable = 8;
  androidx_compose_foundation_content_ReceiveContentElement$stable = 0;
  androidx_compose_foundation_content_ReceiveContentNode$stable = 8;
  ContextMenuKey_instance = new ContextMenuKey();
  androidx_compose_foundation_contextmenu_ContextMenuPopupPositionProvider$stable = 0;
  androidx_compose_foundation_contextmenu_ContextMenuState_Status_Open$stable = 0;
  androidx_compose_foundation_contextmenu_ContextMenuState_Status_Closed$stable = 0;
  androidx_compose_foundation_contextmenu_ContextMenuState_Status$stable = 0;
  androidx_compose_foundation_contextmenu_ContextMenuState$stable = 0;
  androidx_compose_foundation_draganddrop_DragAndDropSourceNode$stable = 8;
  androidx_compose_foundation_gestures_GestureCancellationException$stable = 8;
  androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector_DragDetectionState_AwaitDown$stable = 8;
  androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector_DragDetectionState_AwaitTouchSlop$stable = 8;
  androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector_DragDetectionState_AwaitGesturePickup$stable = 8;
  androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector_DragDetectionState_Dragging$stable = 8;
  androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector_DragDetectionState$stable = 0;
  androidx_compose_foundation_gestures_IndirectPointerInputDragCycleDetector$stable = 8;
  androidx_compose_foundation_gestures_IndirectPointerInputEventSmoother$stable = 8;
  androidx_compose_foundation_gestures_OffsetSmoother$stable = 8;
  androidx_compose_foundation_gestures_NonTouchScrollingLogic$stable = 8;
  TraverseKey_instance_3 = new TraverseKey_3();
  ScrollableDefaults_instance = new ScrollableDefaults();
  androidx_compose_foundation_gestures_TrackpadScrollingLogic$stable = 8;
  androidx_compose_foundation_gestures_TransformEvent_TransformStarted$stable = 0;
  androidx_compose_foundation_gestures_TransformEvent_TransformStopped$stable = 0;
  androidx_compose_foundation_gestures_TransformEvent_TransformDelta$stable = 0;
  androidx_compose_foundation_gestures_UpdatableAnimationState$stable = 8;
  androidx_compose_foundation_gestures_snapping_SnapPosition_Center$stable = 0;
  androidx_compose_foundation_gestures_snapping_SnapPosition_Start$stable = 0;
  androidx_compose_foundation_gestures_snapping_SnapPosition_End$stable = 0;
  Center_instance = new Center();
  Start_instance = new Start();
  androidx_compose_foundation_interaction_DragInteraction_Start$stable = 0;
  androidx_compose_foundation_interaction_DragInteraction_Stop$stable = 0;
  androidx_compose_foundation_interaction_DragInteraction_Cancel$stable = 0;
  androidx_compose_foundation_interaction_FocusInteraction_Focus$stable = 0;
  androidx_compose_foundation_interaction_FocusInteraction_Unfocus$stable = 0;
  androidx_compose_foundation_interaction_HoverInteraction_Enter$stable = 0;
  androidx_compose_foundation_interaction_HoverInteraction_Exit$stable = 0;
  androidx_compose_foundation_interaction_PressInteraction_Press$stable = 0;
  androidx_compose_foundation_interaction_PressInteraction_Release$stable = 0;
  androidx_compose_foundation_interaction_PressInteraction_Cancel$stable = 0;
  androidx_compose_foundation_lazy_LazyItemScopeImpl$stable = 0;
  androidx_compose_foundation_lazy_LazyListBeyondBoundsState$stable = 0;
  androidx_compose_foundation_lazy_LazyListCacheWindowStrategy$stable = 8;
  androidx_compose_foundation_lazy_LazyListCacheWindowScope$stable = 8;
  androidx_compose_foundation_lazy_LazyListIntervalContent$stable = 8;
  androidx_compose_foundation_lazy_LazyListInterval$stable = 0;
  androidx_compose_foundation_lazy_LazyListMeasureResult$stable = 8;
  androidx_compose_foundation_lazy_LazyListMeasuredItem$stable = 8;
  androidx_compose_foundation_lazy_LazyListMeasuredItemProvider$stable = 8;
  androidx_compose_foundation_lazy_LazyListPrefetchResultScopeImpl$stable = 0;
  androidx_compose_foundation_lazy_LazyListScrollPosition$stable = 8;
  androidx_compose_foundation_lazy_grid_LazyGridSlots$stable = 8;
  androidx_compose_foundation_lazy_grid_LazyGridBeyondBoundsState$stable = 0;
  androidx_compose_foundation_lazy_grid_LazyGridCacheWindowPrefetchStrategy$stable = 8;
  androidx_compose_foundation_lazy_grid_GridCells_Fixed$stable = 0;
  androidx_compose_foundation_lazy_grid_GridCells_Adaptive$stable = 0;
  androidx_compose_foundation_lazy_grid_GridCells_FixedSize$stable = 0;
  androidx_compose_foundation_lazy_grid_LazyGridIntervalContent$stable = 8;
  androidx_compose_foundation_lazy_grid_LazyGridInterval$stable = 0;
  androidx_compose_foundation_lazy_grid_LazyGridItemScopeImpl$stable = 0;
  LazyGridItemScopeImpl_instance = new LazyGridItemScopeImpl();
  androidx_compose_foundation_lazy_grid_LazyGridMeasureResult$stable = 8;
  androidx_compose_foundation_lazy_grid_LazyGridMeasuredItem$stable = 8;
  androidx_compose_foundation_lazy_grid_LazyGridMeasuredItemProvider$stable = 8;
  androidx_compose_foundation_lazy_grid_LazyGridMeasuredLine$stable = 8;
  androidx_compose_foundation_lazy_grid_LazyGridMeasuredLineProvider$stable = 8;
  androidx_compose_foundation_lazy_grid_LazyGridPrefetchResultScopeImpl$stable = 8;
  androidx_compose_foundation_lazy_grid_LazyGridScrollPosition$stable = 8;
  androidx_compose_foundation_lazy_grid_LazyGridSpanLayoutProvider_LineConfiguration$stable = 8;
  androidx_compose_foundation_lazy_grid_LazyGridSpanLayoutProvider$stable = 8;
  LazyGridItemSpanScopeImpl_instance = new LazyGridItemSpanScopeImpl();
  androidx_compose_foundation_lazy_layout_AwaitFirstLayoutModifier$stable = 0;
  androidx_compose_foundation_lazy_layout_CacheWindowLogic$stable = 8;
  androidx_compose_foundation_lazy_layout_CachedItem$stable = 8;
  NoKey_instance = new NoKey();
  androidx_compose_foundation_lazy_layout_IntervalList_Interval$stable = 0;
  androidx_compose_foundation_lazy_layout_MutableIntervalList$stable = 8;
  androidx_compose_foundation_lazy_layout_LazyLayoutBeyondBoundsProviderModifierNode$stable = 8;
  androidx_compose_foundation_lazy_layout_LazyLayoutIntervalContent$stable = 0;
  androidx_compose_foundation_lazy_layout_LazyLayoutItemContentFactory$stable = 8;
  androidx_compose_foundation_lazy_layout_NearestRangeKeyIndexMap$stable = 8;
  androidx_compose_foundation_lazy_layout_LazyLayoutMeasureScopeImpl$stable = 0;
  androidx_compose_foundation_lazy_layout_LazyLayoutNearestRangeState$stable = 0;
  Companion_instance_19 = new Companion_9();
  androidx_compose_foundation_lazy_layout_LazyLayoutPinnedItemList$stable = 8;
  DummyHandle_instance = new DummyHandle();
  Companion_instance_21 = new Companion_11();
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridSlots$stable = 8;
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridBeyondBoundsState$stable = 0;
  androidx_compose_foundation_lazy_staggeredgrid_StaggeredGridCells_Fixed$stable = 0;
  androidx_compose_foundation_lazy_staggeredgrid_StaggeredGridCells_Adaptive$stable = 0;
  androidx_compose_foundation_lazy_staggeredgrid_StaggeredGridCells_FixedSize$stable = 0;
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridIntervalContent$stable = 8;
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridInterval$stable = 0;
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridItemScopeImpl$stable = 0;
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridLaneInfo$stable = 8;
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridMeasureContext$stable = 8;
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridMeasureProvider$stable = 8;
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridMeasuredItem$stable = 8;
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridScrollPosition$stable = 8;
  androidx_compose_foundation_lazy_staggeredgrid_StaggeredGridItemSpan$stable = 0;
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridSpanProvider$stable = 8;
  androidx_compose_foundation_lazy_staggeredgrid_LazyStaggeredGridState$stable = 0;
  androidx_compose_foundation_pager_PagerLazyLayoutItemProvider$stable = 0;
  androidx_compose_foundation_pager_PagerIntervalContent$stable = 0;
  androidx_compose_foundation_pager_MeasuredPage$stable = 8;
  androidx_compose_foundation_pager_PageSize_Fill$stable = 0;
  androidx_compose_foundation_pager_PageSize_Fixed$stable = 0;
  Fill_instance = new Fill();
  androidx_compose_foundation_pager_PagerDefaults$stable = 0;
  androidx_compose_foundation_pager_PagerDebugConfig$stable = 0;
  PagerDefaults_instance = new PagerDefaults();
  androidx_compose_foundation_pager_PagerBeyondBoundsState$stable = 0;
  androidx_compose_foundation_pager_PagerCacheWindowLogic$stable = 8;
  androidx_compose_foundation_pager_PagerMeasureResult$stable = 8;
  androidx_compose_foundation_pager_PagerScopeImpl$stable = 0;
  PagerScopeImpl_instance = new PagerScopeImpl();
  androidx_compose_foundation_pager_PagerScrollPosition$stable = 8;
  androidx_compose_foundation_pager_PagerSnapDistanceMaxPages$stable = 0;
  Companion_instance_22 = new Companion_12();
  androidx_compose_foundation_relocation_BringIntoViewRequesterNode$stable = 8;
  androidx_compose_foundation_relocation_BringIntoViewResponderNode$stable = 8;
  androidx_compose_foundation_shape_AbsoluteCutCornerShape$stable = 0;
  androidx_compose_foundation_shape_AbsoluteRoundedCornerShape$stable = 0;
  androidx_compose_foundation_shape_CornerBasedShape$stable = 0;
  androidx_compose_foundation_shape_CutCornerShape$stable = 0;
  androidx_compose_foundation_shape_GenericShape$stable = 0;
  androidx_compose_foundation_style_CombinedStyle$stable = 8;
  androidx_compose_foundation_style_StyleAnimations$stable = 8;
  androidx_compose_foundation_style_StyleElement$stable = 0;
  androidx_compose_foundation_style_StyleInnerElement$stable = 0;
  androidx_compose_foundation_style_StyleOuterNode$stable = 8;
  androidx_compose_foundation_style_StyleInnerNode$stable = 8;
  androidx_compose_foundation_style_StyleStateKey$stable = 0;
  androidx_compose_foundation_style_BooleanPredefinedKey$stable = 8;
  androidx_compose_foundation_style_PredefinedToggleStateKey$stable = 8;
  androidx_compose_foundation_style_StyleState$stable = 0;
  androidx_compose_foundation_style_MutableStyleState$stable = 8;
  androidx_compose_foundation_text_SecureTextFieldController$stable = 8;
  androidx_compose_foundation_text_PasswordInputTransformation$stable = 0;
  androidx_compose_foundation_text_LegacyTextFieldState$stable = 8;
  androidx_compose_foundation_text_InlineTextContent$stable = 0;
  androidx_compose_foundation_text_KeyboardActionRunner$stable = 8;
  androidx_compose_foundation_text_KeyboardActions$stable = 0;
  androidx_compose_foundation_text_KeyboardOptions$stable = 0;
  androidx_compose_foundation_text_LinkStateInteractionSourceObserver$stable = 0;
  androidx_compose_foundation_text_TextAutoSizeDefaults$stable = 0;
  androidx_compose_foundation_text_TextDelegate$stable = 0;
  Companion_instance_28 = new Companion_18();
  Companion_instance_29 = new Companion_19();
  androidx_compose_foundation_text_TextFieldKeyInput$stable = 8;
  androidx_compose_foundation_text_TextFieldScrollerPosition$stable = 0;
  androidx_compose_foundation_text_TextLayoutResultProxy$stable = 8;
  androidx_compose_foundation_text_TextLinkScope$stable = 8;
  androidx_compose_foundation_text_TextRangeLayoutMeasureResult$stable = 0;
  androidx_compose_foundation_text_TextRangeLayoutMeasureScope$stable = 0;
  androidx_compose_foundation_text_TextRangeLayoutModifier$stable = 0;
  SNAPSHOTS_INTERVAL_MILLIS = 5000;
  androidx_compose_foundation_text_UndoManager$stable = 8;
  androidx_compose_foundation_text_contextmenu_builder_TextContextMenuBuilderScope$stable = 8;
  androidx_compose_foundation_text_contextmenu_data_TextContextMenuData$stable = 8;
  androidx_compose_foundation_text_contextmenu_data_TextContextMenuComponent$stable = 8;
  androidx_compose_foundation_text_contextmenu_data_TextContextMenuSeparator$stable = 8;
  androidx_compose_foundation_text_contextmenu_data_TextContextMenuKeys$stable = 8;
  Companion_instance_32 = new Companion_22();
  androidx_compose_foundation_text_contextmenu_modifier_AddTextContextMenuDataComponentsNode$stable = 8;
  TextContextMenuDataTraverseKey_instance = new TextContextMenuDataTraverseKey();
  androidx_compose_foundation_text_contextmenu_modifier_ToolbarRequester$stable = 8;
  androidx_compose_foundation_text_contextmenu_modifier_ToolbarRequesterImpl$stable = 8;
  androidx_compose_foundation_text_contextmenu_modifier_TextContextMenuToolbarHandlerNode$stable = 8;
  androidx_compose_foundation_text_contextmenu_provider_BasicTextContextMenuProvider$stable = 0;
  androidx_compose_foundation_text_input_TextFieldBuffer$stable = 8;
  androidx_compose_foundation_text_input_TextFieldCharSequence$stable = 8;
  androidx_compose_foundation_text_input_TextFieldLineLimits_SingleLine$stable = 0;
  androidx_compose_foundation_text_input_TextFieldLineLimits_MultiLine$stable = 0;
  androidx_compose_foundation_text_input_TextFieldState_Saver$stable = 0;
  androidx_compose_foundation_text_input_TextFieldState$stable = 0;
  androidx_compose_foundation_text_input_TextUndoManager_Companion_Saver$stable = 8;
  androidx_compose_foundation_text_input_TextUndoManager$stable = 8;
  androidx_compose_foundation_text_input_UndoState$stable = 0;
  androidx_compose_foundation_text_input_internal_ChangeTracker$stable = 8;
  androidx_compose_foundation_text_input_internal_SingleLineCodepointTransformation$stable = 0;
  androidx_compose_foundation_text_input_internal_CoreTextFieldSemanticsModifier$stable = 0;
  androidx_compose_foundation_text_input_internal_CoreTextFieldSemanticsModifierNode$stable = 8;
  androidx_compose_foundation_text_input_internal_CursorAnimationState$stable = 8;
  androidx_compose_foundation_text_input_internal_DragAndDropHoverInteraction_Enter$stable = 0;
  androidx_compose_foundation_text_input_internal_DragAndDropHoverInteraction_Exit$stable = 0;
  androidx_compose_foundation_text_input_internal_PartialGapBuffer$stable = 8;
  androidx_compose_foundation_text_input_internal_IntIntervalTree$stable = 8;
  androidx_compose_foundation_text_input_internal_LegacyAdaptingPlatformTextInputModifierNode$stable = 8;
  androidx_compose_foundation_text_input_internal_LegacyPlatformTextInputServiceAdapter$stable = 8;
  androidx_compose_foundation_text_input_internal_OffsetMappingCalculator$stable = 8;
  androidx_compose_foundation_text_input_internal_TextFieldKeyEventHandler$stable = 8;
  androidx_compose_foundation_text_input_internal_TextFieldLayoutStateCache$stable = 0;
  androidx_compose_foundation_text_input_internal_TextFieldTextLayoutModifier$stable = 0;
  androidx_compose_foundation_text_input_internal_TextFieldTextLayoutModifierNode$stable = 8;
  androidx_compose_foundation_text_input_internal_TextLayoutState$stable = 8;
  androidx_compose_foundation_text_input_internal_TextStyleBuffer$stable = 8;
  androidx_compose_foundation_text_input_internal_TransformedTextFieldState$stable = 0;
  androidx_compose_foundation_text_input_internal_SelectionWedgeAffinity$stable = 0;
  androidx_compose_foundation_text_input_internal_selection_TextFieldHandleState$stable = 0;
  androidx_compose_foundation_text_input_internal_selection_TextFieldMagnifierNode$stable = 0;
  androidx_compose_foundation_text_input_internal_selection_TextFieldSelectionState$stable = 8;
  androidx_compose_foundation_text_input_internal_selection_TextFieldPreparedSelectionState$stable = 8;
  androidx_compose_foundation_text_input_internal_selection_SelectionMovementDeletionContext$stable = 8;
  androidx_compose_foundation_text_input_internal_undo_TextUndoOperation$stable = 0;
  androidx_compose_foundation_text_input_internal_undo_UndoManager$stable = 8;
  Companion_instance_34 = new Companion_24();
  androidx_compose_foundation_text_modifiers_ParagraphLayoutCache$stable = 8;
  androidx_compose_foundation_text_modifiers_SelectableTextAnnotatedStringElement$stable = 0;
  androidx_compose_foundation_text_modifiers_SelectableTextAnnotatedStringNode$stable = 8;
  androidx_compose_foundation_text_modifiers_StaticTextSelectionParams$stable = 8;
  androidx_compose_foundation_text_modifiers_SelectionController$stable = 8;
  androidx_compose_foundation_text_modifiers_TextAnnotatedStringElement$stable = 0;
  androidx_compose_foundation_text_modifiers_TextAnnotatedStringNode_TextSubstitutionValue$stable = 8;
  androidx_compose_foundation_text_modifiers_TextAnnotatedStringNode$stable = 8;
  androidx_compose_foundation_text_modifiers_SimpleTextAutoSizeLayoutScope$stable = 0;
  androidx_compose_foundation_text_modifiers_TextStringSimpleElement$stable = 0;
  androidx_compose_foundation_text_modifiers_TextStringSimpleNode_TextSubstitutionValue$stable = 8;
  androidx_compose_foundation_text_modifiers_TextStringSimpleNode$stable = 8;
  androidx_compose_foundation_text_selection_MultiWidgetSelectionDelegate$stable = 8;
  androidx_compose_foundation_text_selection_Selection_AnchorInfo$stable = 0;
  androidx_compose_foundation_text_selection_Selection$stable = 0;
  androidx_compose_foundation_text_selection_ClicksCounter$stable = 8;
  androidx_compose_foundation_text_selection_SelectionRegistrarImpl$stable = 8;
  androidx_compose_foundation_text_selection_TextFieldSelectionManager$stable = 8;
  androidx_compose_foundation_text_selection_TextPreparedSelectionState$stable = 8;
  androidx_compose_foundation_text_selection_BaseTextPreparedSelection$stable = 8;
  androidx_compose_foundation_text_selection_TextPreparedSelection$stable = 8;
  androidx_compose_foundation_text_selection_TextFieldPreparedSelection$stable = 8;
  Companion_instance_40 = new Companion_30();
  androidx_compose_foundation_text_input_internal_selection_ClipboardPasteState$stable = 8;
  androidx_compose_foundation_AtomicReference$stable = 8;
  androidx_compose_foundation_AtomicLong$stable = 8;
  androidx_compose_foundation_internal_PlatformOptimizedCancellationException$stable = 8;
  androidx_compose_foundation_BasicTooltipStrings$stable = 0;
  androidx_compose_foundation_InputModeFilterIndicationNodeFactory$stable = 0;
  androidx_compose_foundation_InputModeFilterIndication$stable = 0;
  androidx_compose_foundation_content_MediaType$stable = 0;
  androidx_compose_foundation_content_PlatformTransferableContent$stable = 0;
  androidx_compose_foundation_draganddrop_DragAndDropSourceDefaults$stable = 0;
  androidx_compose_foundation_draganddrop_CacheDrawScopeDragShadowCallback$stable = 8;
  androidx_compose_foundation_gestures_cupertino_CupertinoFlingBehavior$stable = 0;
  androidx_compose_foundation_platform_SynchronizedObject$stable = 0;
  Translations_instance = new Translations();
  androidx_compose_foundation_text_DeadKeyCombiner$stable = 0;
  androidx_compose_foundation_text_DefaultSkikoKeyMapping$stable = 0;
  DefaultSkikoKeyMapping_instance = new DefaultSkikoKeyMapping();
  androidx_compose_foundation_text_TextFieldScrollState$stable = 8;
  androidx_compose_foundation_text_contextmenu_data_TextContextMenuItemWithComposableLeadingIcon$stable = 8;
  androidx_compose_foundation_text_input_internal_SkikoPlatformTextInputMethodRequest$stable = 8;
  androidx_compose_foundation_text_modifiers_SkikoSelectionModifierElement$stable = 0;
  androidx_compose_foundation_text_modifiers_SkikoSelectionModifierNode$stable = 8;
  androidx_compose_foundation_v2_ScrollableScrollbarAdapter$stable = 0;
  androidx_compose_foundation_v2_LazyLineContentAdapter_VisibleLine$stable = 0;
  androidx_compose_foundation_v2_LazyLineContentAdapter$stable = 0;
  androidx_compose_foundation_v2_LazyListScrollbarAdapter$stable = 0;
  androidx_compose_foundation_v2_LazyGridScrollbarAdapter$stable = 0;
  androidx_compose_foundation_v2_TextFieldScrollbarAdapter$stable = 8;
  androidx_compose_foundation_v2_SliderAdapter$stable = 8;
  TapIndicationDelay = new Long(150, 0);
  JsConfig_instance = new JsConfig();
  isInTouchMode = false;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = SnapLayoutInfoProvider;
  _.$_$.b = SnapLayoutInfoProvider_1;
  _.$_$.c = snapFlingBehavior;
  _.$_$.d = DragScope;
  _.$_$.e = PressGestureScope;
  _.$_$.f = calculateCentroid;
  _.$_$.g = calculatePan;
  _.$_$.h = calculateZoom;
  _.$_$.i = draggable;
  _.$_$.j = rememberDraggableState;
  _.$_$.k = Cancel;
  _.$_$.l = Start_0;
  _.$_$.m = Stop;
  _.$_$.n = Focus;
  _.$_$.o = Unfocus;
  _.$_$.p = Enter;
  _.$_$.q = Exit;
  _.$_$.r = Interaction;
  _.$_$.s = funMutableInteractionSource;
  _.$_$.t = Cancel_0;
  _.$_$.u = Press;
  _.$_$.v = Release;
  _.$_$.w = PressInteraction;
  _.$_$.x = collectIsFocusedAsState;
  _.$_$.y = Fixed;
  _.$_$.z = GridItemSpan_0;
  _.$_$.a1 = GridItemSpan;
  _.$_$.b1 = LazyVerticalGrid;
  _.$_$.c1 = rememberLazyGridState;
  _.$_$.d1 = LazyColumn;
  _.$_$.e1 = LazyRow;
  _.$_$.f1 = rememberLazyListState;
  _.$_$.g1 = HorizontalPager;
  _.$_$.h1 = rememberPagerState;
  _.$_$.i1 = selectableGroup_0;
  _.$_$.j1 = selectable;
  _.$_$.k1 = triStateToggleable;
  _.$_$.l1 = get_CircleShape;
  _.$_$.m1 = CornerSize_0;
  _.$_$.n1 = CornerSize;
  _.$_$.o1 = RoundedCornerShape_0;
  _.$_$.p1 = RoundedCornerShape_1;
  _.$_$.q1 = get_LocalTextSelectionColors;
  _.$_$.r1 = TextSelectionColors;
  _.$_$.s1 = BasicTextField_0;
  _.$_$.t1 = BasicTextField;
  _.$_$.u1 = BasicText;
  _.$_$.v1 = BasicText_0;
  _.$_$.w1 = KeyboardOptions;
  _.$_$.x1 = BorderStroke_0;
  _.$_$.y1 = Canvas_0;
  _.$_$.z1 = Image_0;
  _.$_$.a2 = Image;
  _.$_$.b2 = rememberUpdatedInstance;
  _.$_$.c2 = IndicationNodeFactory;
  _.$_$.d2 = get_LocalIndication;
  _.$_$.e2 = MutatorMutex;
  _.$_$.f2 = background;
  _.$_$.g2 = background_0;
  _.$_$.h2 = border_1;
  _.$_$.i2 = border;
  _.$_$.j2 = clickable;
  _.$_$.k2 = clickable_0;
  _.$_$.l2 = focusable;
  _.$_$.m2 = horizontalScroll;
  _.$_$.n2 = hoverable;
  _.$_$.o2 = indication;
  _.$_$.p2 = isSystemInDarkTheme;
  _.$_$.q2 = progressSemantics;
  _.$_$.r2 = progressSemantics_0;
  _.$_$.s2 = rememberScrollState;
  _.$_$.t2 = verticalScroll;
  _.$_$.u2 = Companion_getInstance_75;
  _.$_$.v2 = Companion_getInstance_76;
  _.$_$.w2 = Orientation_Horizontal_getInstance;
  _.$_$.x2 = Orientation_Vertical_getInstance;
  _.$_$.y2 = MutatePriority_Default_getInstance;
  _.$_$.z2 = MutatePriority_PreventUserInput_getInstance;
  _.$_$.a3 = MutatePriority_UserInput_getInstance;
  _.$_$.b3 = awaitEachGesture;
  _.$_$.c3 = awaitFirstDown;
  _.$_$.d3 = detectDragGestures;
  _.$_$.e3 = detectTapGestures;
  _.$_$.f3 = detectTransformGestures;
  _.$_$.g3 = waitForUpOrCancellation;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-foundation-foundation.js.map
